! function(e, define) {
    define("kendo.core.min", ["jquery"], e)
}(function() {
    return function(e, t, n) {
        function r() {}

        function o(e, t) {
            if (t) return "'" + e.split("'").join("\\'").split('\\"').join('\\\\\\"').replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t") + "'";
            var n = e.charAt(0),
                r = e.substring(1);
            return "=" === n ? "+(" + r + ")+" : ":" === n ? "+$kendoHtmlEncode(" + r + ")+" : ";" + e + ";$kendoOutput+="
        }

        function i(e, t, n) {
            return e += "", t = t || 2, n = t - e.length, n ? B[t].substring(0, n) + e : e
        }

        function a(e) {
            var t = e.css(be.support.transitions.css + "box-shadow") || e.css("box-shadow"),
                n = t ? t.match(_e) || [0, 0, 0, 0, 0] : [0, 0, 0, 0, 0],
                r = ke.max(+n[3], +(n[4] || 0));
            return {
                left: -n[1] + r,
                right: +n[1] + r,
                bottom: +n[2] + r
            }
        }

        function s(n, r) {
            var o, i, a, s, l, c, d = Oe.browser,
                f = be._outerWidth,
                p = be._outerHeight,
                m = n.parent(),
                h = f(t);
            return m.removeClass("k-animation-container-sm"), m.hasClass("k-animation-container") ? u(n, r) : (i = n[0].style.width, a = n[0].style.height, s = De.test(i), l = De.test(a), c = n.hasClass("k-tooltip") || n.is(".k-menu-horizontal.k-context-menu"), o = s || l, !s && (!r || r && i || c) && (i = r ? f(n) + 1 : f(n)), (!l && (!r || r && a) || n.is(".k-menu-horizontal.k-context-menu")) && (a = p(n)), n.wrap(e("<div/>").addClass("k-animation-container").css({
                width: i,
                height: a
            })), m = n.parent(), o && n.css({
                width: "100%",
                height: "100%",
                boxSizing: "border-box",
                mozBoxSizing: "border-box",
                webkitBoxSizing: "border-box"
            })), h < f(m) && (m.addClass("k-animation-container-sm"), u(n, r)), d.msie && ke.floor(d.version) <= 7 && (n.css({
                zoom: 1
            }), n.children(".k-menu").width(n.width())), m
        }

        function u(e, t) {
            var n, r = be._outerWidth,
                o = be._outerHeight,
                i = e.parent(".k-animation-container"),
                a = i[0].style;
            i.is(":hidden") && i.css({
                display: "",
                position: ""
            }), n = De.test(a.width) || De.test(a.height), n || i.css({
                width: t ? r(e) + 1 : r(e),
                height: o(e),
                boxSizing: "content-box",
                mozBoxSizing: "content-box",
                webkitBoxSizing: "content-box"
            })
        }

        function l(e) {
            var t = 1,
                n = arguments.length;
            for (t = 1; t < n; t++) c(e, arguments[t]);
            return e
        }

        function c(e, n) {
            var r, o, i, a, s, u = be.data.ObservableArray,
                l = be.data.LazyObservableArray,
                d = be.data.DataSource,
                f = be.data.HierarchicalDataSource;
            for (r in n) o = n[r], i = typeof o, a = i === Fe && null !== o ? o.constructor : null, !a || a === Array || a === u || a === l || a === d || a === f || a === RegExp || be.isFunction(t.ArrayBuffer) && a === ArrayBuffer ? i !== Ue && (e[r] = o) : o instanceof Date ? e[r] = new Date(o.getTime()) : N(o.clone) ? e[r] = o.clone() : (s = e[r], e[r] = typeof s === Fe ? s || {} : {}, c(e[r], o));
            return e
        }

        function d(e, t, r) {
            for (var o in t)
                if (t.hasOwnProperty(o) && t[o].test(e)) return o;
            return r !== n ? r : e
        }

        function f(e) {
            return e.replace(/([a-z][A-Z])/g, function(e) {
                return e.charAt(0) + "-" + e.charAt(1).toLowerCase()
            })
        }

        function p(e) {
            return e.replace(/\-(\w)/g, function(e, t) {
                return t.toUpperCase()
            })
        }

        function m(t, n) {
            var r, o = {};
            return document.defaultView && document.defaultView.getComputedStyle ? (r = document.defaultView.getComputedStyle(t, ""), n && e.each(n, function(e, t) {
                o[t] = r.getPropertyValue(t)
            })) : (r = t.currentStyle, n && e.each(n, function(e, t) {
                o[t] = r[p(t)]
            })), be.size(o) || (o = r), o
        }

        function h(e) {
            if (e && e.className && "string" == typeof e.className && e.className.indexOf("k-auto-scrollable") > -1) return !0;
            var t = m(e, ["overflow"]).overflow;
            return "auto" == t || "scroll" == t
        }

        function g(t, r) {
            var o, i = Oe.browser.webkit,
                a = Oe.browser.mozilla,
                s = t instanceof e ? t[0] : t;
            if (t) return o = Oe.isRtl(t), r === n ? o && i ? s.scrollWidth - s.clientWidth - s.scrollLeft : Math.abs(s.scrollLeft) : (s.scrollLeft = o && i ? s.scrollWidth - s.clientWidth - r : o && a ? -r : r, n)
        }

        function y(e) {
            var t, n = 0;
            for (t in e) e.hasOwnProperty(t) && "toJSON" != t && n++;
            return n
        }

        function v(e, n, r) {
            var o, i, a;
            return n || (n = "offset"), o = e[n](), i = {
                top: o.top,
                right: o.right,
                bottom: o.bottom,
                left: o.left
            }, Oe.browser.msie && (Oe.pointers || Oe.msPointers) && !r && (a = Oe.isRtl(e) ? 1 : -1, i.top -= t.pageYOffset - document.documentElement.scrollTop, i.left -= t.pageXOffset + a * document.documentElement.scrollLeft), i
        }

        function b(e) {
            var t = {};
            return Me("string" == typeof e ? e.split(" ") : e, function(e) {
                t[e] = this
            }), t
        }

        function w(e) {
            return new be.effects.Element(e)
        }

        function M(e, t, n, r) {
            return typeof e === He && (N(t) && (r = t, t = 400, n = !1), N(n) && (r = n, n = !1), typeof t === Re && (n = t, t = 400), e = {
                effects: e,
                duration: t,
                reverse: n,
                complete: r
            }), we({
                effects: {},
                duration: 400,
                reverse: !1,
                init: Te,
                teardown: Te,
                hide: !1
            }, e, {
                completeCallback: e.complete,
                complete: Te
            })
        }

        function x(t, n, r, o, i) {
            for (var a, s = 0, u = t.length; s < u; s++) a = e(t[s]), a.queue(function() {
                q.promise(a, M(n, r, o, i))
            });
            return t
        }

        function S(e, t, n, r) {
            return t && (t = t.split(" "), Me(t, function(t, n) {
                e.toggleClass(n, r)
            })), e
        }

        function T(e) {
            return ("" + e).replace(J, "&amp;").replace(V, "&lt;").replace(K, "&gt;").replace(G, "&quot;").replace(Q, "&#39;")
        }

        function k(e) {
            var n;
            try {
                n = t.decodeURIComponent(e)
            } catch (r) {
                n = e.replace(/%u([\dA-F]{4})|%([\dA-F]{2})/gi, function(e, t, n) {
                    return String.fromCharCode(parseInt("0x" + (t || n), 16))
                })
            }
            return n
        }

        function z(e, t) {
            var r;
            return 0 === t.indexOf("data") && (t = t.substring(4), t = t.charAt(0).toLowerCase() + t.substring(1)), t = t.replace(ae, "-$1"), r = e.getAttribute("data-" + be.ns + t), null === r ? r = n : "null" === r ? r = null : "true" === r ? r = !0 : "false" === r ? r = !1 : Ae.test(r) && "mask" != t ? r = parseFloat(r) : oe.test(r) && !ie.test(r) && (r = Function("return (" + r + ")")()), r
        }

        function O(t, r, o) {
            var i, a, s = {},
                u = t.getAttribute("data-" + be.ns + "role");
            for (i in r) a = z(t, i), a !== n && (re.test(i) && "drawer" != u && ("string" == typeof a ? e("#" + a).length ? a = be.template(e("#" + a).html()) : o && (a = be.template(o[a])) : a = t.getAttribute(i)), s[i] = a);
            return s
        }

        function D(t, n) {
            return e.contains(t, n) ? -1 : 1
        }

        function C() {
            var t = e(this);
            return e.inArray(t.attr("data-" + be.ns + "role"), ["slider", "rangeslider", "breadcrumb"]) > -1 || t.is(":visible")
        }

        function _(e, t) {
            var n = e.nodeName.toLowerCase();
            return (/input|select|textarea|button|object/.test(n) ? !e.disabled : "a" === n ? e.href || t : t) && A(e)
        }

        function A(t) {
            return e.expr.pseudos.visible(t) && !e(t).parents().addBack().filter(function() {
                return "hidden" === e.css(this, "visibility")
            }).length
        }

        function E(e, t) {
            return new E.fn.init(e, t)
        }
        var H, N, F, P, R, U, j, I, W, $, L, B, Y, q, J, V, G, Q, K, Z, X, ee, te, ne, re, oe, ie, ae, se, ue, le, ce, de, fe, pe, me, he, ge, ye, ve, be = t.kendo = t.kendo || {
                cultures: {}
            },
            we = e.extend,
            Me = e.each,
            xe = e.isArray,
            Se = e.proxy,
            Te = e.noop,
            ke = Math,
            ze = t.JSON || {},
            Oe = {},
            De = /%/,
            Ce = /\{(\d+)(:[^\}]+)?\}/g,
            _e = /(\d+(?:\.?)\d*)px\s*(\d+(?:\.?)\d*)px\s*(\d+(?:\.?)\d*)px\s*(\d+)?/i,
            Ae = /^(\+|-?)\d+(\.?)\d*$/,
            Ee = "function",
            He = "string",
            Ne = "number",
            Fe = "object",
            Pe = "null",
            Re = "boolean",
            Ue = "undefined",
            je = {},
            Ie = {},
            We = [].slice,
            $e = function() {
                var e, t, r, o, i, a, s = arguments[0] || {},
                    u = 1,
                    l = arguments.length,
                    c = !1;
                for ("boolean" == typeof s && (c = s, s = arguments[u] || {}, u++), "object" == typeof s || jQuery.isFunction(s) || (s = {}), u === l && (s = this, u--); u < l; u++)
                    if (null != (i = arguments[u]))
                        for (o in i) "filters" != o && "concat" != o && ":" != o && (e = s[o], r = i[o], s !== r && (c && r && (jQuery.isPlainObject(r) || (t = jQuery.isArray(r))) ? (t ? (t = !1, a = e && jQuery.isArray(e) ? e : []) : a = e && jQuery.isPlainObject(e) ? e : {}, s[o] = $e(c, a, r)) : r !== n && (s[o] = r)));
                return s
            };
        be.version = "2020.1.114".replace(/^\s+|\s+$/g, ""), r.extend = function(e) {
                var t, n, r = function() {},
                    o = this,
                    i = e && e.init ? e.init : function() {
                        o.apply(this, arguments)
                    };
                r.prototype = o.prototype, n = i.fn = i.prototype = new r;
                for (t in e) n[t] = null != e[t] && e[t].constructor === Object ? we(!0, {}, r.prototype[t], e[t]) : e[t];
                return n.constructor = i, i.extend = o.extend, i
            }, r.prototype._initOptions = function(e) {
                this.options = l({}, this.options, e)
            }, N = be.isFunction = function(e) {
                return "function" == typeof e
            }, F = function() {
                this._defaultPrevented = !0
            }, P = function() {
                return this._defaultPrevented === !0
            }, R = r.extend({
                init: function() {
                    this._events = {}
                },
                bind: function(e, t, r) {
                    var o, i, a, s, u, l = this,
                        c = typeof e === He ? [e] : e,
                        d = typeof t === Ee;
                    if (t === n) {
                        for (o in e) l.bind(o, e[o]);
                        return l
                    }
                    for (o = 0, i = c.length; o < i; o++) e = c[o], s = d ? t : t[e], s && (r && (a = s, s = function() {
                        l.unbind(e, s), a.apply(l, arguments)
                    }, s.original = a), u = l._events[e] = l._events[e] || [], u.push(s));
                    return l
                },
                one: function(e, t) {
                    return this.bind(e, t, !0)
                },
                first: function(e, t) {
                    var n, r, o, i, a = this,
                        s = typeof e === He ? [e] : e,
                        u = typeof t === Ee;
                    for (n = 0, r = s.length; n < r; n++) e = s[n], o = u ? t : t[e], o && (i = a._events[e] = a._events[e] || [], i.unshift(o));
                    return a
                },
                trigger: function(e, t) {
                    var n, r, o = this,
                        i = o._events[e];
                    if (i) {
                        for (t = t || {}, t.sender = o, t._defaultPrevented = !1, t.preventDefault = F, t.isDefaultPrevented = P, i = i.slice(), n = 0, r = i.length; n < r; n++) i[n].call(o, t);
                        return t._defaultPrevented === !0
                    }
                    return !1
                },
                unbind: function(e, t) {
                    var r, o = this,
                        i = o._events[e];
                    if (e === n) o._events = {};
                    else if (i)
                        if (t)
                            for (r = i.length - 1; r >= 0; r--) i[r] !== t && i[r].original !== t || i.splice(r, 1);
                        else o._events[e] = [];
                    return o
                }
            }), U = /^\w+/, j = /\$\{([^}]*)\}/g, I = /\\\}/g, W = /__CURLY__/g, $ = /\\#/g, L = /__SHARP__/g, B = ["", "0", "00", "000", "0000"], H = {
                paramName: "data",
                useWithBlock: !0,
                render: function(e, t) {
                    var n, r, o = "";
                    for (n = 0, r = t.length; n < r; n++) o += e(t[n]);
                    return o
                },
                compile: function(e, t) {
                    var n, r, i, a = we({}, this, t),
                        s = a.paramName,
                        u = s.match(U)[0],
                        l = a.useWithBlock,
                        c = "var $kendoOutput, $kendoHtmlEncode = kendo.htmlEncode;";
                    if (N(e)) return e;
                    for (c += l ? "with(" + s + "){" : "", c += "$kendoOutput=", r = e.replace(I, "__CURLY__").replace(j, "#=$kendoHtmlEncode($1)#").replace(W, "}").replace($, "__SHARP__").split("#"), i = 0; i < r.length; i++) c += o(r[i], i % 2 === 0);
                    c += l ? ";}" : ";", c += "return $kendoOutput;", c = c.replace(L, "#");
                    try {
                        return n = Function(u, c), n._slotCount = Math.floor(r.length / 2), n
                    } catch (d) {
                        throw Error(be.format("Invalid template:'{0}' Generated code:'{1}'", e, c))
                    }
                }
            },
            function() {
                function e(e) {
                    return a.lastIndex = 0, a.test(e) ? '"' + e.replace(a, function(e) {
                        var t = s[e];
                        return typeof t === He ? t : "\\u" + ("0000" + e.charCodeAt(0).toString(16)).slice(-4)
                    }) + '"' : '"' + e + '"'
                }

                function t(i, a) {
                    var s, l, c, d, f, p, m = n,
                        h = a[i];
                    if (h && typeof h === Fe && typeof h.toJSON === Ee && (h = h.toJSON(i)), typeof o === Ee && (h = o.call(a, i, h)), p = typeof h, p === He) return e(h);
                    if (p === Ne) return isFinite(h) ? h + "" : Pe;
                    if (p === Re || p === Pe) return h + "";
                    if (p === Fe) {
                        if (!h) return Pe;
                        if (n += r, f = [], "[object Array]" === u.apply(h)) {
                            for (d = h.length, s = 0; s < d; s++) f[s] = t(s, h) || Pe;
                            return c = 0 === f.length ? "[]" : n ? "[\n" + n + f.join(",\n" + n) + "\n" + m + "]" : "[" + f.join(",") + "]", n = m, c
                        }
                        if (o && typeof o === Fe)
                            for (d = o.length, s = 0; s < d; s++) typeof o[s] === He && (l = o[s], c = t(l, h), c && f.push(e(l) + (n ? ": " : ":") + c));
                        else
                            for (l in h) Object.hasOwnProperty.call(h, l) && (c = t(l, h), c && f.push(e(l) + (n ? ": " : ":") + c));
                        return c = 0 === f.length ? "{}" : n ? "{\n" + n + f.join(",\n" + n) + "\n" + m + "}" : "{" + f.join(",") + "}", n = m, c
                    }
                }
                var n, r, o, a = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g,
                    s = {
                        "\b": "\\b",
                        "\t": "\\t",
                        "\n": "\\n",
                        "\f": "\\f",
                        "\r": "\\r",
                        '"': '\\"',
                        "\\": "\\\\"
                    },
                    u = {}.toString;
                typeof Date.prototype.toJSON !== Ee && (Date.prototype.toJSON = function() {
                    var e = this;
                    return isFinite(e.valueOf()) ? i(e.getUTCFullYear(), 4) + "-" + i(e.getUTCMonth() + 1) + "-" + i(e.getUTCDate()) + "T" + i(e.getUTCHours()) + ":" + i(e.getUTCMinutes()) + ":" + i(e.getUTCSeconds()) + "Z" : null
                }, String.prototype.toJSON = Number.prototype.toJSON = Boolean.prototype.toJSON = function() {
                    return this.valueOf()
                }), typeof ze.stringify !== Ee && (ze.stringify = function(e, i, a) {
                    var s;
                    if (n = "", r = "", typeof a === Ne)
                        for (s = 0; s < a; s += 1) r += " ";
                    else typeof a === He && (r = a);
                    if (o = i, i && typeof i !== Ee && (typeof i !== Fe || typeof i.length !== Ne)) throw Error("JSON.stringify");
                    return t("", {
                        "": e
                    })
                })
            }(),
            function() {
                function t(e) {
                    if (e) {
                        if (e.numberFormat) return e;
                        if (typeof e === He) {
                            var t = be.cultures;
                            return t[e] || t[e.split("-")[0]] || null
                        }
                        return null
                    }
                    return null
                }

                function r(e) {
                    return e && (e = t(e)), e || be.cultures.current
                }

                function o(e, t, o) {
                    o = r(o);
                    var a = o.calendars.standard,
                        s = a.days,
                        u = a.months;
                    return t = a.patterns[t] || t, t.replace(c, function(t) {
                        var r, o, l;
                        return "d" === t ? o = e.getDate() : "dd" === t ? o = i(e.getDate()) : "ddd" === t ? o = s.namesAbbr[e.getDay()] : "dddd" === t ? o = s.names[e.getDay()] : "M" === t ? o = e.getMonth() + 1 : "MM" === t ? o = i(e.getMonth() + 1) : "MMM" === t ? o = u.namesAbbr[e.getMonth()] : "MMMM" === t ? o = u.names[e.getMonth()] : "yy" === t ? o = i(e.getFullYear() % 100) : "yyyy" === t ? o = i(e.getFullYear(), 4) : "h" === t ? o = e.getHours() % 12 || 12 : "hh" === t ? o = i(e.getHours() % 12 || 12) : "H" === t ? o = e.getHours() : "HH" === t ? o = i(e.getHours()) : "m" === t ? o = e.getMinutes() : "mm" === t ? o = i(e.getMinutes()) : "s" === t ? o = e.getSeconds() : "ss" === t ? o = i(e.getSeconds()) : "f" === t ? o = ke.floor(e.getMilliseconds() / 100) : "ff" === t ? (o = e.getMilliseconds(), o > 99 && (o = ke.floor(o / 10)), o = i(o)) : "fff" === t ? o = i(e.getMilliseconds(), 3) : "tt" === t ? o = e.getHours() < 12 ? a.AM[0] : a.PM[0] : "zzz" === t ? (r = e.getTimezoneOffset(), l = r < 0, o = ("" + ke.abs(r / 60)).split(".")[0], r = ke.abs(r) - 60 * o, o = (l ? "+" : "-") + i(o), o += ":" + i(r)) : "zz" !== t && "z" !== t || (o = e.getTimezoneOffset() / 60, l = o < 0, o = ("" + ke.abs(o)).split(".")[0], o = (l ? "+" : "-") + ("zz" === t ? i(o) : o)), o !== n ? o : t.slice(1, t.length - 1)
                    })
                }

                function a(e, t, o) {
                    var i, a, l, c, w, M, x, S, T, k, z, O, D, C, _, A, E, H, N, F, P, R, U, j, I, W, $, L, B, Y, q, J, V, G;
                    if (o = r(o), i = o.numberFormat, a = i[h], l = i.decimals, c = i.pattern[0], w = [], z = e < 0, A = m, E = m, q = -1, e === n) return m;
                    if (!isFinite(e)) return e;
                    if (!t) return o.name.length ? e.toLocaleString() : "" + e;
                    if (k = d.exec(t)) {
                        if (t = k[1].toLowerCase(), x = "c" === t, S = "p" === t, (x || S) && (i = x ? i.currency : i.percent, a = i[h], l = i.decimals, M = i.symbol, c = i.pattern[z ? 0 : 1]), T = k[2], T && (l = +T), "e" === t) return V = T ? e.toExponential(l) : e.toExponential(), V.replace(h, i[h]);
                        if (S && (e *= 100), e = u(e, l), z = e < 0, e = e.split(h), O = e[0], D = e[1], z && (O = O.substring(1)), E = s(O, 0, O.length, i), D && (E += a + D), "n" === t && !z) return E;
                        for (e = m, H = 0, N = c.length; H < N; H++) F = c.charAt(H), e += "n" === F ? E : "$" === F || "%" === F ? M : F;
                        return e
                    }
                    if ((t.indexOf("'") > -1 || t.indexOf('"') > -1 || t.indexOf("\\") > -1) && (t = t.replace(f, function(e) {
                            var t = e.charAt(0).replace("\\", ""),
                                n = e.slice(1).replace(t, "");
                            return w.push(n), b
                        })), t = t.split(";"), z && t[1]) t = t[1], R = !0;
                    else if (0 === e && t[2]) {
                        if (t = t[2], t.indexOf(y) == -1 && t.indexOf(v) == -1) return t
                    } else t = t[0];
                    if (L = t.indexOf("%"), B = t.indexOf("$"), S = L != -1, x = B != -1, S && (e *= 100), x && "\\" === t[B - 1] && (t = t.split("\\").join(""), x = !1), (x || S) && (i = x ? i.currency : i.percent, a = i[h], l = i.decimals, M = i.symbol), P = t.indexOf(g) > -1, P && (t = t.replace(p, m)), U = t.indexOf(h), N = t.length, U != -1)
                        if (D = ("" + e).split("e"), D = D[1] ? u(e, Math.abs(D[1])) : D[0], D = D.split(h)[1] || m, I = t.lastIndexOf(v) - U, j = t.lastIndexOf(y) - U, W = I > -1, $ = j > -1, H = D.length, W || $ || (t = t.substring(0, U) + t.substring(U + 1), N = t.length, U = -1, H = 0), W && I > j) H = I;
                        else if (j > I)
                        if ($ && H > j) {
                            for (G = u(e, j, z); G.charAt(G.length - 1) === v && j > 0 && j > I;) j--, G = u(e, j, z);
                            H = j
                        } else W && H < I && (H = I);
                    if (e = u(e, H, z), j = t.indexOf(y), Y = I = t.indexOf(v), q = j == -1 && I != -1 ? I : j != -1 && I == -1 ? j : j > I ? I : j, j = t.lastIndexOf(y), I = t.lastIndexOf(v), J = j == -1 && I != -1 ? I : j != -1 && I == -1 ? j : j > I ? j : I, q == N && (J = q), q != -1) {
                        for (E = ("" + e).split(h), O = E[0], D = E[1] || m, C = O.length, _ = D.length, z && e * -1 >= 0 && (z = !1), e = t.substring(0, q), z && !R && (e += "-"), H = q; H < N; H++) {
                            if (F = t.charAt(H), U == -1) {
                                if (J - H < C) {
                                    e += O;
                                    break
                                }
                            } else if (I != -1 && I < H && (A = m), U - H <= C && U - H > -1 && (e += O, H = U), U === H) {
                                e += (D ? a : m) + D, H += J - U + 1;
                                continue
                            }
                            F === v ? (e += F, A = F) : F === y && (e += A)
                        }
                        if (P && (e = s(e, q + (z && !R ? 1 : 0), Math.max(J, C + q), i)), J >= q && (e += t.substring(J + 1)), x || S) {
                            for (E = m, H = 0, N = e.length; H < N; H++) F = e.charAt(H), E += "$" === F || "%" === F ? M : F;
                            e = E
                        }
                        if (N = w.length)
                            for (H = 0; H < N; H++) e = e.replace(b, w[H])
                    }
                    return e
                }
                var s, u, l, c = /dddd|ddd|dd|d|MMMM|MMM|MM|M|yyyy|yy|HH|H|hh|h|mm|m|fff|ff|f|tt|ss|s|zzz|zz|z|"[^"]*"|'[^']*'/g,
                    d = /^(n|c|p|e)(\d*)$/i,
                    f = /(\\.)|(['][^']*[']?)|(["][^"]*["]?)/g,
                    p = /\,/g,
                    m = "",
                    h = ".",
                    g = ",",
                    y = "#",
                    v = "0",
                    b = "??",
                    w = "en-US",
                    M = {}.toString;
                be.cultures["en-US"] = {
                    name: w,
                    numberFormat: {
                        pattern: ["-n"],
                        decimals: 2,
                        ",": ",",
                        ".": ".",
                        groupSize: [3],
                        percent: {
                            pattern: ["-n %", "n %"],
                            decimals: 2,
                            ",": ",",
                            ".": ".",
                            groupSize: [3],
                            symbol: "%"
                        },
                        currency: {
                            name: "US Dollar",
                            abbr: "USD",
                            pattern: ["($n)", "$n"],
                            decimals: 2,
                            ",": ",",
                            ".": ".",
                            groupSize: [3],
                            symbol: "$"
                        }
                    },
                    calendars: {
                        standard: {
                            days: {
                                names: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                                namesAbbr: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
                                namesShort: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
                            },
                            months: {
                                names: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                                namesAbbr: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
                            },
                            AM: ["AM", "am", "AM"],
                            PM: ["PM", "pm", "PM"],
                            patterns: {
                                d: "M/d/yyyy",
                                D: "dddd, MMMM dd, yyyy",
                                F: "dddd, MMMM dd, yyyy h:mm:ss tt",
                                g: "M/d/yyyy h:mm tt",
                                G: "M/d/yyyy h:mm:ss tt",
                                m: "MMMM dd",
                                M: "MMMM dd",
                                s: "yyyy'-'MM'-'ddTHH':'mm':'ss",
                                t: "h:mm tt",
                                T: "h:mm:ss tt",
                                u: "yyyy'-'MM'-'dd HH':'mm':'ss'Z'",
                                y: "MMMM, yyyy",
                                Y: "MMMM, yyyy"
                            },
                            "/": "/",
                            ":": ":",
                            firstDay: 0,
                            twoDigitYearMax: 2029
                        }
                    }
                }, be.culture = function(e) {
                    var r, o = be.cultures;
                    return e === n ? o.current : (r = t(e) || o[w], r.calendar = r.calendars.standard, o.current = r, n)
                }, be.findCulture = t, be.getCulture = r, be.culture(w), s = function(e, t, r, o) {
                    var i, a, s, u, l, c, d = e.indexOf(o[h]),
                        f = o.groupSize.slice(),
                        p = f.shift();
                    if (r = d !== -1 ? d : r + 1, i = e.substring(t, r), a = i.length, a >= p) {
                        for (s = a, u = []; s > -1;)
                            if (l = i.substring(s - p, s), l && u.push(l), s -= p, c = f.shift(), p = c !== n ? c : p, 0 === p) {
                                s > 0 && u.push(i.substring(0, s));
                                break
                            }
                        i = u.reverse().join(o[g]), e = e.substring(0, t) + i + e.substring(r)
                    }
                    return e
                }, u = function(e, t, n) {
                    return t = t || 0, e = ("" + e).split("e"), e = Math.round(+(e[0] + "e" + (e[1] ? +e[1] + t : t))), n && (e = -e), e = ("" + e).split("e"), e = +(e[0] + "e" + (e[1] ? +e[1] - t : -t)), e.toFixed(Math.min(t, 20))
                }, l = function(e, t, r) {
                    if (t) {
                        if ("[object Date]" === M.call(e)) return o(e, t, r);
                        if (typeof e === Ne) return a(e, t, r)
                    }
                    return e !== n ? e : ""
                }, be.format = function(e) {
                    var t = arguments;
                    return e.replace(Ce, function(e, n, r) {
                        var o = t[parseInt(n, 10) + 1];
                        return l(o, r ? r.substring(1) : "")
                    })
                }, be._extractFormat = function(e) {
                    return "{0:" === e.slice(0, 3) && (e = e.slice(3, e.length - 1)), e
                }, be._activeElement = function() {
                    try {
                        return document.activeElement
                    } catch (e) {
                        return document.documentElement.activeElement
                    }
                }, be._round = u, be._outerWidth = function(t, n) {
                    return e(t).outerWidth(n || !1) || 0
                }, be._outerHeight = function(t, n) {
                    return e(t).outerHeight(n || !1) || 0
                }, be.toString = l
            }(),
            function() {
                function t(e, t, n) {
                    return !(e >= t && e <= n)
                }

                function r(e) {
                    return e.charAt(0)
                }

                function o(t) {
                    return e.map(t, r)
                }

                function i(e, t) {
                    t || 23 !== e.getHours() || e.setHours(e.getHours() + 2)
                }

                function a(e) {
                    for (var t = 0, n = e.length, r = []; t < n; t++) r[t] = (e[t] + "").toLowerCase();
                    return r
                }

                function s(e) {
                    var t, n = {};
                    for (t in e) n[t] = a(e[t]);
                    return n
                }

                function u(e, r, a, u) {
                    if (!e) return null;
                    var l, c, d, f, p, g, y, v, b, M, x, S, T, k = function(e) {
                            for (var t = 0; r[R] === e;) t++, R++;
                            return t > 0 && (R -= 1), t
                        },
                        z = function(t) {
                            var n = w[t] || RegExp("^\\d{1," + t + "}"),
                                r = e.substr(U, t).match(n);
                            return r ? (r = r[0], U += r.length, parseInt(r, 10)) : null
                        },
                        O = function(t, n) {
                            for (var r, o, i, a = 0, s = t.length, u = 0, l = 0; a < s; a++) r = t[a], o = r.length, i = e.substr(U, o), n && (i = i.toLowerCase()), i == r && o > u && (u = o, l = a);
                            return u ? (U += u, l + 1) : null
                        },
                        D = function() {
                            var t = !1;
                            return e.charAt(U) === r[R] && (U++, t = !0), t
                        },
                        C = a.calendars.standard,
                        _ = null,
                        A = null,
                        E = null,
                        H = null,
                        N = null,
                        F = null,
                        P = null,
                        R = 0,
                        U = 0,
                        j = !1,
                        I = new Date,
                        W = C.twoDigitYearMax || 2029,
                        $ = I.getFullYear();
                    for (r || (r = "d"), f = C.patterns[r], f && (r = f), r = r.split(""), d = r.length; R < d; R++)
                        if (l = r[R], j) "'" === l ? j = !1 : D();
                        else if ("d" === l) {
                        if (c = k("d"), C._lowerDays || (C._lowerDays = s(C.days)), null !== E && c > 2) continue;
                        if (E = c < 3 ? z(2) : O(C._lowerDays[3 == c ? "namesAbbr" : "names"], !0), null === E || t(E, 1, 31)) return null
                    } else if ("M" === l) {
                        if (c = k("M"), C._lowerMonths || (C._lowerMonths = s(C.months)), A = c < 3 ? z(2) : O(C._lowerMonths[3 == c ? "namesAbbr" : "names"], !0), null === A || t(A, 1, 12)) return null;
                        A -= 1
                    } else if ("y" === l) {
                        if (c = k("y"), _ = z(c), null === _) return null;
                        2 == c && ("string" == typeof W && (W = $ + parseInt(W, 10)), _ = $ - $ % 100 + _, _ > W && (_ -= 100))
                    } else if ("h" === l) {
                        if (k("h"), H = z(2), 12 == H && (H = 0), null === H || t(H, 0, 11)) return null
                    } else if ("H" === l) {
                        if (k("H"), H = z(2), null === H || t(H, 0, 23)) return null
                    } else if ("m" === l) {
                        if (k("m"), N = z(2), null === N || t(N, 0, 59)) return null
                    } else if ("s" === l) {
                        if (k("s"), F = z(2), null === F || t(F, 0, 59)) return null
                    } else if ("f" === l) {
                        if (c = k("f"), T = e.substr(U, c).match(w[3]), P = z(c), null !== P && (P = parseFloat("0." + T[0], 10), P = be._round(P, 3), P *= 1e3), null === P || t(P, 0, 999)) return null
                    } else if ("t" === l) {
                        if (c = k("t"), v = C.AM, b = C.PM, 1 === c && (v = o(v), b = o(b)), p = O(b), !p && !O(v)) return null
                    } else if ("z" === l) {
                        if (g = !0, c = k("z"), "Z" === e.substr(U, 1)) {
                            D();
                            continue
                        }
                        if (y = e.substr(U, 6).match(c > 2 ? h : m), !y) return null;
                        if (y = y[0].split(":"), M = y[0], x = y[1], !x && M.length > 3 && (U = M.length - 2, x = M.substring(U), M = M.substring(0, U)), M = parseInt(M, 10), t(M, -12, 13)) return null;
                        if (c > 2 && (x = y[0][0] + x, x = parseInt(x, 10), isNaN(x) || t(x, -59, 59))) return null
                    } else if ("'" === l) j = !0, D();
                    else if (!D()) return null;
                    return u && !/^\s*$/.test(e.substr(U)) ? null : (S = null !== H || null !== N || F || null, null === _ && null === A && null === E && S ? (_ = $, A = I.getMonth(), E = I.getDate()) : (null === _ && (_ = $), null === E && (E = 1)), p && H < 12 && (H += 12), g ? (M && (H += -M), x && (N += -x), e = new Date(Date.UTC(_, A, E, H, N, F, P))) : (e = new Date(_, A, E, H, N, F, P), i(e, H)), _ < 100 && e.setFullYear(_), e.getDate() !== E && g === n ? null : e)
                }

                function l(e) {
                    var t = "-" === e.substr(0, 1) ? -1 : 1;
                    return e = e.substring(1), e = 60 * parseInt(e.substr(0, 2), 10) + parseInt(e.substring(2), 10), t * e
                }

                function c(e) {
                    var t, n, r, o = ke.max(v.length, b.length),
                        i = e.calendar || e.calendars.standard,
                        a = i.patterns,
                        s = [];
                    for (r = 0; r < o; r++) {
                        for (t = v[r], n = 0; n < t.length; n++) s.push(a[t[n]]);
                        s = s.concat(b[r])
                    }
                    return s
                }

                function d(e, t, n, r) {
                    var o, i, a, s;
                    if ("[object Date]" === M.call(e)) return e;
                    if (o = 0, i = null, e && 0 === e.indexOf("/D") && (i = g.exec(e))) return i = i[1], s = y.exec(i.substring(1)), i = new Date(parseInt(i, 10)), s && (s = l(s[0]), i = be.timezone.apply(i, 0), i = be.timezone.convert(i, 0, -1 * s)), i;
                    for (n = be.getCulture(n), t || (t = c(n)), t = xe(t) ? t : [t], a = t.length; o < a; o++)
                        if (i = u(e, t[o], n, r)) return i;
                    return i
                }
                var f = /\u00A0/g,
                    p = /[eE][\-+]?[0-9]+/,
                    m = /[+|\-]\d{1,2}/,
                    h = /[+|\-]\d{1,2}:?\d{2}/,
                    g = /^\/Date\((.*?)\)\/$/,
                    y = /[+-]\d*/,
                    v = [
                        [],
                        ["G", "g", "F"],
                        ["D", "d", "y", "m", "T", "t"]
                    ],
                    b = [
                        ["yyyy-MM-ddTHH:mm:ss.fffffffzzz", "yyyy-MM-ddTHH:mm:ss.fffffff", "yyyy-MM-ddTHH:mm:ss.fffzzz", "yyyy-MM-ddTHH:mm:ss.fff", "ddd MMM dd yyyy HH:mm:ss", "yyyy-MM-ddTHH:mm:sszzz", "yyyy-MM-ddTHH:mmzzz", "yyyy-MM-ddTHH:mmzz", "yyyy-MM-ddTHH:mm:ss", "yyyy-MM-dd HH:mm:ss", "yyyy/MM/dd HH:mm:ss"],
                        ["yyyy-MM-ddTHH:mm", "yyyy-MM-dd HH:mm", "yyyy/MM/dd HH:mm"],
                        ["yyyy/MM/dd", "yyyy-MM-dd", "HH:mm:ss", "HH:mm"]
                    ],
                    w = {
                        2: /^\d{1,2}/,
                        3: /^\d{1,3}/,
                        4: /^\d{4}/
                    },
                    M = {}.toString;
                be.parseDate = function(e, t, n) {
                    return d(e, t, n, !1)
                }, be.parseExactDate = function(e, t, n) {
                    return d(e, t, n, !0)
                }, be.parseInt = function(e, t) {
                    var n = be.parseFloat(e, t);
                    return n && (n = 0 | n), n
                }, be.parseFloat = function(e, t, n) {
                    if (!e && 0 !== e) return null;
                    if (typeof e === Ne) return e;
                    e = "" + e, t = be.getCulture(t);
                    var r, o, i = t.numberFormat,
                        a = i.percent,
                        s = i.currency,
                        u = s.symbol,
                        l = a.symbol,
                        c = e.indexOf("-");
                    return p.test(e) ? (e = parseFloat(e.replace(i["."], ".")), isNaN(e) && (e = null), e) : c > 0 ? null : (c = c > -1, e.indexOf(u) > -1 || n && n.toLowerCase().indexOf("c") > -1 ? (i = s, r = i.pattern[0].replace("$", u).split("n"), e.indexOf(r[0]) > -1 && e.indexOf(r[1]) > -1 && (e = e.replace(r[0], "").replace(r[1], ""), c = !0)) : e.indexOf(l) > -1 && (o = !0, i = a, u = l), e = e.replace("-", "").replace(u, "").replace(f, " ").split(i[","].replace(f, " ")).join("").replace(i["."], "."), e = parseFloat(e), isNaN(e) ? e = null : c && (e *= -1), e && o && (e /= 100), e)
                }
            }(),
            function() {
                var r, o, i, a, s, u, l, c, f, p, m, h;
                Oe._scrollbar = n, Oe.scrollbar = function(e) {
                    if (isNaN(Oe._scrollbar) || e) {
                        var t, n = document.createElement("div");
                        return n.style.cssText = "overflow:scroll;overflow-x:hidden;zoom:1;clear:both;display:block", n.innerHTML = "&nbsp;", document.body.appendChild(n), Oe._scrollbar = t = n.offsetWidth - n.scrollWidth, document.body.removeChild(n), t
                    }
                    return Oe._scrollbar
                }, Oe.isRtl = function(t) {
                    return e(t).closest(".k-rtl").length > 0
                }, r = document.createElement("table");
                try {
                    r.innerHTML = "<tr><td></td></tr>", Oe.tbodyInnerHtml = !0
                } catch (g) {
                    Oe.tbodyInnerHtml = !1
                }
                Oe.touch = "ontouchstart" in t, o = document.documentElement.style, i = Oe.transitions = !1, a = Oe.transforms = !1, s = "HTMLElement" in t ? HTMLElement.prototype : [], Oe.hasHW3D = "WebKitCSSMatrix" in t && "m11" in new t.WebKitCSSMatrix || "MozPerspective" in o || "msPerspective" in o, Oe.cssFlexbox = "flexWrap" in o || "WebkitFlexWrap" in o || "msFlexWrap" in o, Me(["Moz", "webkit", "O", "ms"], function() {
                    var e, t = "" + this,
                        n = typeof r.style[t + "Transition"] === He;
                    if (n || typeof r.style[t + "Transform"] === He) return e = t.toLowerCase(), a = {
                        css: "ms" != e ? "-" + e + "-" : "",
                        prefix: t,
                        event: "o" === e || "webkit" === e ? e : ""
                    }, n && (i = a, i.event = i.event ? i.event + "TransitionEnd" : "transitionend"), !1
                }), r = null, Oe.transforms = a, Oe.transitions = i, Oe.devicePixelRatio = t.devicePixelRatio === n ? 1 : t.devicePixelRatio;
                try {
                    Oe.screenWidth = t.outerWidth || t.screen ? t.screen.availWidth : t.innerWidth, Oe.screenHeight = t.outerHeight || t.screen ? t.screen.availHeight : t.innerHeight
                } catch (g) {
                    Oe.screenWidth = t.screen.availWidth, Oe.screenHeight = t.screen.availHeight
                }
                Oe.detectOS = function(e) {
                        var n, r, o = !1,
                            i = [],
                            a = !/mobile safari/i.test(e),
                            s = {
                                wp: /(Windows Phone(?: OS)?)\s(\d+)\.(\d+(\.\d+)?)/,
                                fire: /(Silk)\/(\d+)\.(\d+(\.\d+)?)/,
                                android: /(Android|Android.*(?:Opera|Firefox).*?\/)\s*(\d+)\.?(\d+(\.\d+)?)?/,
                                iphone: /(iPhone|iPod).*OS\s+(\d+)[\._]([\d\._]+)/,
                                ipad: /(iPad).*OS\s+(\d+)[\._]([\d_]+)/,
                                meego: /(MeeGo).+NokiaBrowser\/(\d+)\.([\d\._]+)/,
                                webos: /(webOS)\/(\d+)\.(\d+(\.\d+)?)/,
                                blackberry: /(BlackBerry|BB10).*?Version\/(\d+)\.(\d+(\.\d+)?)/,
                                playbook: /(PlayBook).*?Tablet\s*OS\s*(\d+)\.(\d+(\.\d+)?)/,
                                windows: /(MSIE)\s+(\d+)\.(\d+(\.\d+)?)/,
                                tizen: /(tizen).*?Version\/(\d+)\.(\d+(\.\d+)?)/i,
                                sailfish: /(sailfish).*rv:(\d+)\.(\d+(\.\d+)?).*firefox/i,
                                ffos: /(Mobile).*rv:(\d+)\.(\d+(\.\d+)?).*Firefox/
                            },
                            u = {
                                ios: /^i(phone|pad|pod)$/i,
                                android: /^android|fire$/i,
                                blackberry: /^blackberry|playbook/i,
                                windows: /windows/,
                                wp: /wp/,
                                flat: /sailfish|ffos|tizen/i,
                                meego: /meego/
                            },
                            l = {
                                tablet: /playbook|ipad|fire/i
                            },
                            c = {
                                omini: /Opera\sMini/i,
                                omobile: /Opera\sMobi/i,
                                firefox: /Firefox|Fennec/i,
                                mobilesafari: /version\/.*safari/i,
                                ie: /MSIE|Windows\sPhone/i,
                                chrome: /chrome|crios/i,
                                webkit: /webkit/i
                            };
                        for (r in s)
                            if (s.hasOwnProperty(r) && (i = e.match(s[r]))) {
                                if ("windows" == r && "plugins" in navigator) return !1;
                                o = {}, o.device = r, o.tablet = d(r, l, !1), o.browser = d(e, c, "default"), o.name = d(r, u), o[o.name] = !0, o.majorVersion = i[2], o.minorVersion = (i[3] || "0").replace("_", "."), n = o.minorVersion.replace(".", "").substr(0, 2), o.flatVersion = o.majorVersion + n + Array(3 - (n.length < 3 ? n.length : 2)).join("0"), o.cordova = typeof t.PhoneGap !== Ue || typeof t.cordova !== Ue, o.appMode = t.navigator.standalone || /file|local|wmapp/.test(t.location.protocol) || o.cordova, o.android && (Oe.devicePixelRatio < 1.5 && o.flatVersion < 400 || a) && (Oe.screenWidth > 800 || Oe.screenHeight > 800) && (o.tablet = r);
                                break
                            }
                        return o
                    }, u = Oe.mobileOS = Oe.detectOS(navigator.userAgent), Oe.wpDevicePixelRatio = u.wp ? screen.width / 320 : 0, Oe.hasNativeScrolling = !1, (u.ios || u.android && u.majorVersion > 2 || u.wp) && (Oe.hasNativeScrolling = u), Oe.delayedClick = function() {
                        if (Oe.touch) {
                            if (u.ios) return !0;
                            if (u.android) return !Oe.browser.chrome || !(Oe.browser.version < 32) && !(e("meta[name=viewport]").attr("content") || "").match(/user-scalable=no/i)
                        }
                        return !1
                    }, Oe.mouseAndTouchPresent = Oe.touch && !(Oe.mobileOS.ios || Oe.mobileOS.android), Oe.detectBrowser = function(e) {
                        var t, n = !1,
                            r = [],
                            o = {
                                edge: /(edge)[ \/]([\w.]+)/i,
                                webkit: /(chrome|crios)[ \/]([\w.]+)/i,
                                safari: /(webkit)[ \/]([\w.]+)/i,
                                opera: /(opera)(?:.*version|)[ \/]([\w.]+)/i,
                                msie: /(msie\s|trident.*? rv:)([\w.]+)/i,
                                mozilla: /(mozilla)(?:.*? rv:([\w.]+)|)/i
                            };
                        for (t in o)
                            if (o.hasOwnProperty(t) && (r = e.match(o[t]))) {
                                n = {}, n[t] = !0, n[r[1].toLowerCase().split(" ")[0].split("/")[0]] = !0, n.version = parseInt(document.documentMode || r[2], 10);
                                break
                            }
                        return n
                    }, Oe.browser = Oe.detectBrowser(navigator.userAgent), Oe.detectClipboardAccess = function() {
                        var e = {
                            copy: !!document.queryCommandSupported && document.queryCommandSupported("copy"),
                            cut: !!document.queryCommandSupported && document.queryCommandSupported("cut"),
                            paste: !!document.queryCommandSupported && document.queryCommandSupported("paste")
                        };
                        return Oe.browser.chrome && (e.paste = !1, Oe.browser.version >= 43 && (e.copy = !0, e.cut = !0)), e
                    }, Oe.clipboard = Oe.detectClipboardAccess(), Oe.zoomLevel = function() {
                        var e, n, r;
                        try {
                            return e = Oe.browser, n = 0, r = document.documentElement, e.msie && 11 == e.version && r.scrollHeight > r.clientHeight && !Oe.touch && (n = Oe.scrollbar()), Oe.touch ? r.clientWidth / t.innerWidth : e.msie && e.version >= 10 ? ((top || t).document.documentElement.offsetWidth + n) / (top || t).innerWidth : 1
                        } catch (o) {
                            return 1
                        }
                    }, Oe.cssBorderSpacing = n !== o.borderSpacing && !(Oe.browser.msie && Oe.browser.version < 8),
                    function(t) {
                        var n = "",
                            r = e(document.documentElement),
                            o = parseInt(t.version, 10);
                        t.msie ? n = "ie" : t.mozilla ? n = "ff" : t.safari ? n = "safari" : t.webkit ? n = "webkit" : t.opera ? n = "opera" : t.edge && (n = "edge"), n && (n = "k-" + n + " k-" + n + o), Oe.mobileOS && (n += " k-mobile"), Oe.cssFlexbox || (n += " k-no-flexbox"), r.addClass(n)
                    }(Oe.browser), Oe.eventCapture = document.documentElement.addEventListener, l = document.createElement("input"), Oe.placeholder = "placeholder" in l, Oe.propertyChangeEvent = "onpropertychange" in l, Oe.input = function() {
                        for (var e, t = ["number", "date", "time", "month", "week", "datetime", "datetime-local"], n = t.length, r = "test", o = {}, i = 0; i < n; i++) e = t[i], l.setAttribute("type", e), l.value = r, o[e.replace("-", "")] = "text" !== l.type && l.value !== r;
                        return o
                    }(), l.style.cssText = "float:left;", Oe.cssFloat = !!l.style.cssFloat, l = null, Oe.stableSort = function() {
                        var e, t = 513,
                            n = [{
                                index: 0,
                                field: "b"
                            }];
                        for (e = 1; e < t; e++) n.push({
                            index: e,
                            field: "a"
                        });
                        return n.sort(function(e, t) {
                            return e.field > t.field ? 1 : e.field < t.field ? -1 : 0
                        }), 1 === n[0].index
                    }(), Oe.matchesSelector = s.webkitMatchesSelector || s.mozMatchesSelector || s.msMatchesSelector || s.oMatchesSelector || s.matchesSelector || s.matches || function(t) {
                        for (var n = document.querySelectorAll ? (this.parentNode || document).querySelectorAll(t) || [] : e(t), r = n.length; r--;)
                            if (n[r] == this) return !0;
                        return !1
                    }, Oe.matchMedia = "matchMedia" in t, Oe.pushState = t.history && t.history.pushState, c = document.documentMode, Oe.hashChange = "onhashchange" in t && !(Oe.browser.msie && (!c || c <= 8)), Oe.customElements = "registerElement" in t.document, f = Oe.browser.chrome, p = Oe.browser.crios, m = Oe.browser.mozilla, h = Oe.browser.safari, Oe.msPointers = !f && t.MSPointerEvent, Oe.pointers = !f && !p && !m && !h && t.PointerEvent, Oe.kineticScrollNeeded = u && (Oe.touch || Oe.msPointers || Oe.pointers)
            }(), Y = {
                left: {
                    reverse: "right"
                },
                right: {
                    reverse: "left"
                },
                down: {
                    reverse: "up"
                },
                up: {
                    reverse: "down"
                },
                top: {
                    reverse: "bottom"
                },
                bottom: {
                    reverse: "top"
                },
                "in": {
                    reverse: "out"
                },
                out: {
                    reverse: "in"
                }
            }, q = {}, e.extend(q, {
                enabled: !0,
                Element: function(t) {
                    this.element = e(t)
                },
                promise: function(e, t) {
                    e.is(":visible") || e.css({
                        display: e.data("olddisplay") || "block"
                    }).css("display"), t.hide && e.data("olddisplay", e.css("display")).hide(), t.init && t.init(), t.completeCallback && t.completeCallback(e), e.dequeue()
                },
                disable: function() {
                    this.enabled = !1, this.promise = this.promiseShim
                },
                enable: function() {
                    this.enabled = !0, this.promise = this.animatedPromise
                }
            }), q.promiseShim = q.promise, "kendoAnimate" in e.fn || we(e.fn, {
                kendoStop: function(e, t) {
                    return this.stop(e, t)
                },
                kendoAnimate: function(e, t, n, r) {
                    return x(this, e, t, n, r)
                },
                kendoAddClass: function(e, t) {
                    return be.toggleClass(this, e, t, !0)
                },
                kendoRemoveClass: function(e, t) {
                    return be.toggleClass(this, e, t, !1)
                },
                kendoToggleClass: function(e, t, n) {
                    return be.toggleClass(this, e, t, n)
                }
            }), J = /&/g, V = /</g, G = /"/g, Q = /'/g, K = />/g, Z = function(e) {
                return e.target
            }, Oe.touch && (Z = function(e) {
                var t = "originalEvent" in e ? e.originalEvent.changedTouches : "changedTouches" in e ? e.changedTouches : null;
                return t ? document.elementFromPoint(t[0].clientX, t[0].clientY) : e.target
            }, Me(["swipe", "swipeLeft", "swipeRight", "swipeUp", "swipeDown", "doubleTap", "tap"], function(t, n) {
                e.fn[n] = function(e) {
                    return this.bind(n, e)
                }
            })), Oe.touch ? Oe.mobileOS ? (Oe.mousedown = "touchstart", Oe.mouseup = "touchend", Oe.mousemove = "touchmove", Oe.mousecancel = "touchcancel", Oe.click = "touchend", Oe.resize = "orientationchange") : (Oe.mousedown = "mousedown touchstart", Oe.mouseup = "mouseup touchend", Oe.mousemove = "mousemove touchmove", Oe.mousecancel = "mouseleave touchcancel", Oe.click = "click", Oe.resize = "resize") : Oe.pointers ? (Oe.mousemove = "pointermove", Oe.mousedown = "pointerdown", Oe.mouseup = "pointerup", Oe.mousecancel = "pointercancel", Oe.click = "pointerup", Oe.resize = "orientationchange resize") : Oe.msPointers ? (Oe.mousemove = "MSPointerMove", Oe.mousedown = "MSPointerDown", Oe.mouseup = "MSPointerUp", Oe.mousecancel = "MSPointerCancel", Oe.click = "MSPointerUp", Oe.resize = "orientationchange resize") : (Oe.mousemove = "mousemove", Oe.mousedown = "mousedown", Oe.mouseup = "mouseup", Oe.mousecancel = "mouseleave", Oe.click = "click", Oe.resize = "resize"), X = function(e, t) {
                var n, r, o, i, a = t || "d",
                    s = 1;
                for (r = 0, o = e.length; r < o; r++) i = e[r], "" !== i && (n = i.indexOf("["), 0 !== n && (n == -1 ? i = "." + i : (s++, i = "." + i.substring(0, n) + " || {})" + i.substring(n))), s++, a += i + (r < o - 1 ? " || {})" : ")"));
                return Array(s).join("(") + a
            }, ee = /^([a-z]+:)?\/\//i, we(be, {
                widgets: [],
                _widgetRegisteredCallbacks: [],
                ui: be.ui || {},
                fx: be.fx || w,
                effects: be.effects || q,
                mobile: be.mobile || {},
                data: be.data || {},
                dataviz: be.dataviz || {},
                drawing: be.drawing || {},
                spreadsheet: {
                    messages: {}
                },
                keys: {
                    INSERT: 45,
                    DELETE: 46,
                    BACKSPACE: 8,
                    TAB: 9,
                    ENTER: 13,
                    ESC: 27,
                    LEFT: 37,
                    UP: 38,
                    RIGHT: 39,
                    DOWN: 40,
                    END: 35,
                    HOME: 36,
                    SPACEBAR: 32,
                    PAGEUP: 33,
                    PAGEDOWN: 34,
                    F2: 113,
                    F10: 121,
                    F12: 123,
                    NUMPAD_PLUS: 107,
                    NUMPAD_MINUS: 109,
                    NUMPAD_DOT: 110
                },
                support: be.support || Oe,
                animate: be.animate || x,
                ns: "",
                attr: function(e) {
                    return "data-" + be.ns + e
                },
                getShadows: a,
                wrap: s,
                deepExtend: l,
                getComputedStyles: m,
                isScrollable: h,
                scrollLeft: g,
                size: y,
                toCamelCase: p,
                toHyphens: f,
                getOffset: be.getOffset || v,
                parseEffects: be.parseEffects || b,
                toggleClass: be.toggleClass || S,
                directions: be.directions || Y,
                Observable: R,
                Class: r,
                Template: H,
                template: Se(H.compile, H),
                render: Se(H.render, H),
                stringify: Se(ze.stringify, ze),
                eventTarget: Z,
                htmlEncode: T,
                unescape: k,
                isLocalUrl: function(e) {
                    return e && !ee.test(e)
                },
                expr: function(e, t, n) {
                    return e = e || "", typeof t == He && (n = t, t = !1), n = n || "d", e && "[" !== e.charAt(0) && (e = "." + e), t ? (e = e.replace(/"([^.]*)\.([^"]*)"/g, '"$1_$DOT$_$2"'), e = e.replace(/'([^.]*)\.([^']*)'/g, "'$1_$DOT$_$2'"), e = X(e.split("."), n), e = e.replace(/_\$DOT\$_/g, ".")) : e = n + e, e
                },
                getter: function(e, t) {
                    var n = e + t;
                    return je[n] = je[n] || Function("d", "return " + be.expr(e, t))
                },
                setter: function(e) {
                    return Ie[e] = Ie[e] || Function("d,value", be.expr(e) + "=value")
                },
                accessor: function(e) {
                    return {
                        get: be.getter(e),
                        set: be.setter(e)
                    }
                },
                guid: function() {
                    var e, t, n = "";
                    for (e = 0; e < 32; e++) t = 16 * ke.random() | 0, 8 != e && 12 != e && 16 != e && 20 != e || (n += "-"), n += (12 == e ? 4 : 16 == e ? 3 & t | 8 : t).toString(16);
                    return n
                },
                roleSelector: function(e) {
                    return e.replace(/(\S+)/g, "[" + be.attr("role") + "=$1],").slice(0, -1)
                },
                directiveSelector: function(e) {
                    var t, n = e.split(" ");
                    if (n)
                        for (t = 0; t < n.length; t++) "view" != n[t] && (n[t] = n[t].replace(/(\w*)(view|bar|strip|over)$/, "$1-$2"));
                    return n.join(" ").replace(/(\S+)/g, "kendo-mobile-$1,").slice(0, -1)
                },
                triggeredByInput: function(e) {
                    return /^(label|input|textarea|select)$/i.test(e.target.tagName)
                },
                onWidgetRegistered: function(e) {
                    for (var t = 0, n = be.widgets.length; t < n; t++) e(be.widgets[t]);
                    be._widgetRegisteredCallbacks.push(e)
                },
                logToConsole: function(e, r) {
                    var o = t.console;
                    !be.suppressLog && n !== o && o.log && o[r || "log"](e)
                }
            }), te = R.extend({
                init: function(e, t) {
                    var n, r = this;
                    r.element = be.jQuery(e).handler(r), r.angular("init", t), R.fn.init.call(r), n = t ? t.dataSource : null, n && (t = we({}, t, {
                        dataSource: {}
                    })), t = r.options = we(!0, {}, r.options, t), n && (t.dataSource = n), r.element.attr(be.attr("role")) || r.element.attr(be.attr("role"), (t.name || "").toLowerCase()), r.element.data("kendo" + t.prefix + t.name, r), r.bind(r.events, t)
                },
                events: [],
                options: {
                    prefix: ""
                },
                _hasBindingTarget: function() {
                    return !!this.element[0].kendoBindingTarget
                },
                _tabindex: function(e) {
                    e = e || this.wrapper;
                    var t = this.element,
                        n = "tabindex",
                        r = e.attr(n) || t.attr(n);
                    t.removeAttr(n), e.attr(n, isNaN(r) ? 0 : r)
                },
                setOptions: function(t) {
                    this._setEvents(t), e.extend(this.options, t)
                },
                _setEvents: function(e) {
                    for (var t, n = this, r = 0, o = n.events.length; r < o; r++) t = n.events[r], n.options[t] && e[t] && (n.unbind(t, n.options[t]), n._events && n._events[t] && delete n._events[t]);
                    n.bind(n.events, e)
                },
                resize: function(e) {
                    var t = this.getSize(),
                        n = this._size;
                    (e || (t.width > 0 || t.height > 0) && (!n || t.width !== n.width || t.height !== n.height)) && (this._size = t, this._resize(t, e), this.trigger("resize", t))
                },
                getSize: function() {
                    return be.dimensions(this.element)
                },
                size: function(e) {
                    return e ? (this.setSize(e), n) : this.getSize()
                },
                setSize: e.noop,
                _resize: e.noop,
                destroy: function() {
                    var e = this;
                    e.element.removeData("kendo" + e.options.prefix + e.options.name), e.element.removeData("handler"), e.unbind()
                },
                _destroy: function() {
                    this.destroy()
                },
                angular: function() {},
                _muteAngularRebind: function(e) {
                    this._muteRebind = !0, e.call(this), this._muteRebind = !1
                }
            }), ne = te.extend({
                dataItems: function() {
                    return this.dataSource.flatView()
                },
                _angularItems: function(t) {
                    var n = this;
                    n.angular(t, function() {
                        return {
                            elements: n.items(),
                            data: e.map(n.dataItems(), function(e) {
                                return {
                                    dataItem: e
                                }
                            })
                        }
                    })
                }
            }), be.dimensions = function(e, t) {
                var n = e[0];
                return t && e.css(t), {
                    width: n.offsetWidth,
                    height: n.offsetHeight
                }
            }, be.notify = Te, re = /template$/i, oe = /^\s*(?:\{(?:.|\r\n|\n)*\}|\[(?:.|\r\n|\n)*\])\s*$/, ie = /^\{(\d+)(:[^\}]+)?\}|^\[[A-Za-z_]+\]$/, ae = /([A-Z])/g, be.initWidget = function(r, o, i) {
                var a, s, u, l, c, d, f, p, m, h, g, y, v;
                if (i ? i.roles && (i = i.roles) : i = be.ui.roles, r = r.nodeType ? r : r[0], d = r.getAttribute("data-" + be.ns + "role")) {
                    m = d.indexOf(".") === -1, u = m ? i[d] : be.getter(d)(t), g = e(r).data(), y = u ? "kendo" + u.fn.options.prefix + u.fn.options.name : "", h = m ? RegExp("^kendo.*" + d + "$", "i") : RegExp("^" + y + "$", "i");
                    for (v in g)
                        if (v.match(h)) {
                            if (v !== y) return g[v];
                            a = g[v]
                        }
                    if (u) {
                        for (p = z(r, "dataSource"), o = e.extend({}, O(r, u.fn.options), o), p && (o.dataSource = typeof p === He ? be.getter(p)(t) : p), l = 0, c = u.fn.events.length; l < c; l++) s = u.fn.events[l], f = z(r, s), f !== n && (o[s] = be.getter(f)(t));
                        return a ? e.isEmptyObject(o) || a.setOptions(o) : a = new u(r, o), a
                    }
                }
            }, be.rolesFromNamespaces = function(e) {
                var t, n, r = [];
                for (e[0] || (e = [be.ui, be.dataviz.ui]), t = 0, n = e.length; t < n; t++) r[t] = e[t].roles;
                return we.apply(null, [{}].concat(r.reverse()))
            }, be.init = function(t) {
                var n = be.rolesFromNamespaces(We.call(arguments, 1));
                e(t).find("[data-" + be.ns + "role]").addBack().each(function() {
                    be.initWidget(this, {}, n)
                })
            }, be.destroy = function(t) {
                e(t).find("[data-" + be.ns + "role]").addBack().each(function() {
                    var t, n = e(this).data();
                    for (t in n) 0 === t.indexOf("kendo") && typeof n[t].destroy === Ee && n[t].destroy()
                })
            }, be.resize = function(t, n) {
                var r, o = e(t).find("[data-" + be.ns + "role]").addBack().filter(C);
                o.length && (r = e.makeArray(o), r.sort(D), e.each(r, function() {
                    var t = be.widgetInstance(e(this));
                    t && t.resize(n)
                }))
            }, be.parseOptions = O, we(be.ui, {
                Widget: te,
                DataBoundWidget: ne,
                roles: {},
                progress: function(t, n, r) {
                    var o, i, a, s, u, l = t.find(".k-loading-mask"),
                        c = be.support,
                        d = c.browser;
                    r = e.extend({}, {
                        width: "100%",
                        height: "100%",
                        top: t.scrollTop(),
                        opacity: !1
                    }, r), u = r.opacity ? "k-loading-mask k-opaque" : "k-loading-mask", n ? l.length || (o = c.isRtl(t), i = o ? "right" : "left", s = t.scrollLeft(), a = d.webkit && o ? t[0].scrollWidth - t.width() - 2 * s : 0, l = e(be.format("<div class='{0}'><span class='k-loading-text'>{1}</span><div class='k-loading-image'/><div class='k-loading-color'/></div>", u, be.ui.progress.messages.loading)).width(r.width).height(r.height).css("top", r.top).css(i, Math.abs(s) + a).prependTo(t)) : l && l.remove()
                },
                plugin: function(t, r, o) {
                    var i, a, s, u, l = t.fn.options.name;
                    for (r = r || be.ui, o = o || "", r[l] = t, r.roles[l.toLowerCase()] = t, i = "getKendo" + o + l, l = "kendo" + o + l, a = {
                            name: l,
                            widget: t,
                            prefix: o || ""
                        }, be.widgets.push(a), s = 0, u = be._widgetRegisteredCallbacks.length; s < u; s++) be._widgetRegisteredCallbacks[s](a);
                    e.fn[l] = function(r) {
                        var o, i = this;
                        return typeof r === He ? (o = We.call(arguments, 1), this.each(function() {
                            var t, a, s = e.data(this, l);
                            if (!s) throw Error(be.format("Cannot call method '{0}' of {1} before it is initialized", r, l));
                            if (t = s[r], typeof t !== Ee) throw Error(be.format("Cannot find method '{0}' of {1}", r, l));
                            if (a = t.apply(s, o), a !== n) return i = a, !1
                        })) : this.each(function() {
                            return new t(this, r)
                        }), i
                    }, e.fn[l].widget = t, e.fn[i] = function() {
                        return this.data(l)
                    }
                }
            }), be.ui.progress.messages = {
                loading: "Loading..."
            }, se = {
                bind: function() {
                    return this
                },
                nullObject: !0,
                options: {}
            }, ue = te.extend({
                init: function(e, t) {
                    te.fn.init.call(this, e, t), this.element.autoApplyNS(), this.wrapper = this.element, this.element.addClass("km-widget")
                },
                destroy: function() {
                    te.fn.destroy.call(this), this.element.kendoDestroy()
                },
                options: {
                    prefix: "Mobile"
                },
                events: [],
                view: function() {
                    var e = this.element.closest(be.roleSelector("view splitview modalview drawer"));
                    return be.widgetInstance(e, be.mobile.ui) || se
                },
                viewHasNativeScrolling: function() {
                    var e = this.view();
                    return e && e.options.useNativeScrolling
                },
                container: function() {
                    var e = this.element.closest(be.roleSelector("view layout modalview drawer splitview"));
                    return be.widgetInstance(e.eq(0), be.mobile.ui) || se
                }
            }), we(be.mobile, {
                init: function(e) {
                    be.init(e, be.mobile.ui, be.ui, be.dataviz.ui)
                },
                appLevelNativeScrolling: function() {
                    return be.mobile.application && be.mobile.application.options && be.mobile.application.options.useNativeScrolling
                },
                roles: {},
                ui: {
                    Widget: ue,
                    DataBoundWidget: ne.extend(ue.prototype),
                    roles: {},
                    plugin: function(e) {
                        be.ui.plugin(e, be.mobile.ui, "Mobile")
                    }
                }
            }), l(be.dataviz, {
                init: function(e) {
                    be.init(e, be.dataviz.ui)
                },
                ui: {
                    roles: {},
                    themes: {},
                    views: [],
                    plugin: function(e) {
                        be.ui.plugin(e, be.dataviz.ui)
                    }
                },
                roles: {}
            }), be.touchScroller = function(t, n) {
                return n || (n = {}), n.useNative = !0, e(t).map(function(t, r) {
                    return r = e(r), !(!Oe.kineticScrollNeeded || !be.mobile.ui.Scroller || r.data("kendoMobileScroller")) && (r.kendoMobileScroller(n), r.data("kendoMobileScroller"))
                })[0]
            }, be.preventDefault = function(e) {
                e.preventDefault()
            }, be.widgetInstance = function(e, n) {
                var r, o, i, a, s, u = e.data(be.ns + "role"),
                    l = [],
                    c = e.data("kendoView");
                if (u) {
                    if ("content" === u && (u = "scroller"), "editortoolbar" === u && (i = e.data("kendoEditorToolbar"))) return i;
                    if ("view" === u && c) return c;
                    if (n)
                        if (n[0])
                            for (r = 0, o = n.length; r < o; r++) l.push(n[r].roles[u]);
                        else l.push(n.roles[u]);
                    else l = [be.ui.roles[u], be.dataviz.ui.roles[u], be.mobile.ui.roles[u]];
                    for (u.indexOf(".") >= 0 && (l = [be.getter(u)(t)]), r = 0, o = l.length; r < o; r++)
                        if (a = l[r], a && (s = e.data("kendo" + a.fn.options.prefix + a.fn.options.name))) return s
                }
            }, be.onResize = function(n) {
                var r = n;
                return Oe.mobileOS.android && (r = function() {
                    setTimeout(n, 600)
                }), e(t).on(Oe.resize, r), r
            }, be.unbindResize = function(n) {
                e(t).off(Oe.resize, n)
            }, be.attrValue = function(e, t) {
                return e.data(be.ns + t)
            }, be.days = {
                Sunday: 0,
                Monday: 1,
                Tuesday: 2,
                Wednesday: 3,
                Thursday: 4,
                Friday: 5,
                Saturday: 6
            }, e.extend(e.expr.pseudos, {
                kendoFocusable: function(t) {
                    var n = e.attr(t, "tabindex");
                    return _(t, !isNaN(n) && n > -1)
                }
            }), le = ["mousedown", "mousemove", "mouseenter", "mouseleave", "mouseover", "mouseout", "mouseup", "click"], ce = "label, input, [data-rel=external]", de = {
                setupMouseMute: function() {
                    var t, n = 0,
                        r = le.length,
                        o = document.documentElement;
                    if (!de.mouseTrap && Oe.eventCapture)
                        for (de.mouseTrap = !0, de.bustClick = !1, de.captureMouse = !1, t = function(t) {
                                de.captureMouse && ("click" === t.type ? de.bustClick && !e(t.target).is(ce) && (t.preventDefault(), t.stopPropagation()) : t.stopPropagation())
                            }; n < r; n++) o.addEventListener(le[n], t, !0)
                },
                muteMouse: function(e) {
                    de.captureMouse = !0, e.data.bustClick && (de.bustClick = !0), clearTimeout(de.mouseTrapTimeoutID)
                },
                unMuteMouse: function() {
                    clearTimeout(de.mouseTrapTimeoutID), de.mouseTrapTimeoutID = setTimeout(function() {
                        de.captureMouse = !1, de.bustClick = !1
                    }, 400)
                }
            }, fe = {
                down: "touchstart mousedown",
                move: "mousemove touchmove",
                up: "mouseup touchend touchcancel",
                cancel: "mouseleave touchcancel"
            }, Oe.touch && (Oe.mobileOS.ios || Oe.mobileOS.android) ? fe = {
                down: "touchstart",
                move: "touchmove",
                up: "touchend touchcancel",
                cancel: "touchcancel"
            } : Oe.pointers ? fe = {
                down: "pointerdown",
                move: "pointermove",
                up: "pointerup",
                cancel: "pointercancel pointerleave"
            } : Oe.msPointers && (fe = {
                down: "MSPointerDown",
                move: "MSPointerMove",
                up: "MSPointerUp",
                cancel: "MSPointerCancel MSPointerLeave"
            }), !Oe.msPointers || "onmspointerenter" in t || e.each({
                MSPointerEnter: "MSPointerOver",
                MSPointerLeave: "MSPointerOut"
            }, function(t, n) {
                e.event.special[t] = {
                    delegateType: n,
                    bindType: n,
                    handle: function(t) {
                        var r, o = this,
                            i = t.relatedTarget,
                            a = t.handleObj;
                        return i && (i === o || e.contains(o, i)) || (t.type = a.origType, r = a.handler.apply(this, arguments), t.type = n), r
                    }
                }
            }), pe = function(e) {
                return fe[e] || e
            }, me = /([^ ]+)/g, be.applyEventMap = function(e, t) {
                return e = e.replace(me, pe), t && (e = e.replace(me, "$1." + t)), e
            }, he = e.fn.on, $e(!0, E, e), E.fn = E.prototype = new e, E.fn.constructor = E, E.fn.init = function(t, n) {
                return n && n instanceof e && !(n instanceof E) && (n = E(n)), e.fn.init.call(this, t, n, ge)
            }, E.fn.init.prototype = E.fn, ge = E(document), we(E.fn, {
                handler: function(e) {
                    return this.data("handler", e), this
                },
                autoApplyNS: function(e) {
                    return this.data("kendoNS", e || be.guid()), this
                },
                on: function() {
                    var e, t, n, r, o, i, a = this,
                        s = a.data("kendoNS");
                    return 1 === arguments.length ? he.call(a, arguments[0]) : (e = a, t = We.call(arguments), typeof t[t.length - 1] === Ue && t.pop(), n = t[t.length - 1], r = be.applyEventMap(t[0], s), Oe.mouseAndTouchPresent && r.search(/mouse|click/) > -1 && this[0] !== document.documentElement && (de.setupMouseMute(), o = 2 === t.length ? null : t[1], i = r.indexOf("click") > -1 && r.indexOf("touchend") > -1, he.call(this, {
                        touchstart: de.muteMouse,
                        touchend: de.unMuteMouse
                    }, o, {
                        bustClick: i
                    })), typeof n === He && (e = a.data("handler"), n = e[n], t[t.length - 1] = function(t) {
                        n.call(e, t)
                    }), t[0] = r, he.apply(a, t), a)
                },
                kendoDestroy: function(e) {
                    return e = e || this.data("kendoNS"), e && this.off("." + e), this
                }
            }), be.jQuery = E, be.eventMap = fe, be.timezone = function() {
                function e(e, t) {
                    var n, r, o, i = t[3],
                        a = t[4],
                        s = t[5],
                        u = t[8];
                    return u || (t[8] = u = {}), u[e] ? u[e] : (isNaN(a) ? 0 === a.indexOf("last") ? (n = new Date(Date.UTC(e, c[i] + 1, 1, s[0] - 24, s[1], s[2], 0)), r = d[a.substr(4, 3)], o = n.getUTCDay(), n.setUTCDate(n.getUTCDate() + r - o - (r > o ? 7 : 0))) : a.indexOf(">=") >= 0 ? (n = new Date(Date.UTC(e, c[i], a.substr(5), s[0], s[1], s[2], 0)), r = d[a.substr(0, 3)], o = n.getUTCDay(), n.setUTCDate(n.getUTCDate() + r - o + (r < o ? 7 : 0))) : a.indexOf("<=") >= 0 && (n = new Date(Date.UTC(e, c[i], a.substr(5), s[0], s[1], s[2], 0)), r = d[a.substr(0, 3)], o = n.getUTCDay(), n.setUTCDate(n.getUTCDate() + r - o - (r > o ? 7 : 0))) : n = new Date(Date.UTC(e, c[i], a, s[0], s[1], s[2], 0)), u[e] = n)
                }

                function t(t, n, r) {
                    var o, i, a, s;
                    return (n = n[r]) ? (a = new Date(t).getUTCFullYear(), n = jQuery.grep(n, function(e) {
                        var t = e[0],
                            n = e[1];
                        return t <= a && (n >= a || t == a && "only" == n || "max" == n)
                    }), n.push(t), n.sort(function(t, n) {
                        return "number" != typeof t && (t = +e(a, t)), "number" != typeof n && (n = +e(a, n)), t - n
                    }), s = n[jQuery.inArray(t, n) - 1] || n[n.length - 1], isNaN(s) ? s : null) : (o = r.split(":"), i = 0, o.length > 1 && (i = 60 * o[0] + +o[1]), [-1e6, "max", "-", "Jan", 1, [0, 0, 0], i, "-"])
                }

                function n(e, t, n) {
                    var r, o, i, a = t[n];
                    if ("string" == typeof a && (a = t[a]), !a) throw Error('Timezone "' + n + '" is either incorrect, or kendo.timezones.min.js is not included.');
                    for (r = a.length - 1; r >= 0 && (o = a[r][3], !(o && e > o)); r--);
                    if (i = a[r + 1], !i) throw Error('Timezone "' + n + '" not found on ' + e + ".");
                    return i
                }

                function r(e, r, o, i) {
                    typeof e != Ne && (e = Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
                    var a = n(e, r, i);
                    return {
                        zone: a,
                        rule: t(e, o, a[1])
                    }
                }

                function o(e, t) {
                    var n, o, i;
                    return "Etc/UTC" == t || "Etc/GMT" == t ? 0 : (n = r(e, this.zones, this.rules, t), o = n.zone, i = n.rule, be.parseFloat(i ? o[0] - i[6] : o[0]))
                }

                function i(e, t) {
                    var n = r(e, this.zones, this.rules, t),
                        o = n.zone,
                        i = n.rule,
                        a = o[2];
                    return a.indexOf("/") >= 0 ? a.split("/")[i && +i[6] ? 1 : 0] : a.indexOf("%s") >= 0 ? a.replace("%s", i && "-" != i[7] ? i[7] : "") : a
                }

                function a(e, t, n) {
                    var r, o, i, a = n;
                    return typeof t == He && (t = this.offset(e, t)), typeof n == He && (n = this.offset(e, n)), o = e.getTimezoneOffset(), e = new Date(e.getTime() + 6e4 * (t - n)), i = e.getTimezoneOffset(), typeof a == He && (a = this.offset(e, a)), r = i - o + (n - a), new Date(e.getTime() + 6e4 * r)
                }

                function s(e, t) {
                    return this.convert(e, e.getTimezoneOffset(), t)
                }

                function u(e, t) {
                    return this.convert(e, t, e.getTimezoneOffset())
                }

                function l(e) {
                    return this.apply(new Date(e), "Etc/UTC")
                }
                var c = {
                        Jan: 0,
                        Feb: 1,
                        Mar: 2,
                        Apr: 3,
                        May: 4,
                        Jun: 5,
                        Jul: 6,
                        Aug: 7,
                        Sep: 8,
                        Oct: 9,
                        Nov: 10,
                        Dec: 11
                    },
                    d = {
                        Sun: 0,
                        Mon: 1,
                        Tue: 2,
                        Wed: 3,
                        Thu: 4,
                        Fri: 5,
                        Sat: 6
                    };
                return {
                    zones: {},
                    rules: {},
                    offset: o,
                    convert: a,
                    apply: s,
                    remove: u,
                    abbr: i,
                    toLocalDate: l
                }
            }(), be.date = function() {
                function e(e, t) {
                    return 0 === t && 23 === e.getHours() && (e.setHours(e.getHours() + 2), !0)
                }

                function t(t, n, r) {
                    var o = t.getHours();
                    r = r || 1, n = (n - t.getDay() + 7 * r) % 7, t.setDate(t.getDate() + n), e(t, o)
                }

                function r(e, n, r) {
                    return e = new Date(e), t(e, n, r), e
                }

                function o(e) {
                    return new Date(e.getFullYear(), e.getMonth(), 1)
                }

                function i(e) {
                    var t = new Date(e.getFullYear(), e.getMonth() + 1, 0),
                        n = o(e),
                        r = Math.abs(t.getTimezoneOffset() - n.getTimezoneOffset());
                    return r && t.setHours(n.getHours() + r / 60), t
                }

                function a(e, t) {
                    return 1 !== t ? m(r(e, t, -1), 4) : m(e, 4 - (e.getDay() || 7))
                }

                function s(e, t) {
                    var n = new Date(e.getFullYear(), 0, 1, (-6)),
                        r = a(e, t),
                        o = r.getTime() - n.getTime(),
                        i = Math.floor(o / M);
                    return 1 + Math.floor(i / 7)
                }

                function u(e, t) {
                    var r, o, i;
                    return t === n && (t = be.culture().calendar.firstDay), r = m(e, -7), o = m(e, 7), i = s(e, t), 0 === i ? s(r, t) + 1 : 53 === i && s(o, t) > 1 ? 1 : i
                }

                function l(t) {
                    return t = new Date(t.getFullYear(), t.getMonth(), t.getDate(), 0, 0, 0), e(t, 0), t
                }

                function c(e) {
                    return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds())
                }

                function d(e) {
                    return b(e).getTime() - l(b(e))
                }

                function f(e, t, n) {
                    var r, o = d(t),
                        i = d(n);
                    return !e || o == i || (t >= n && (n += M), r = d(e), o > r && (r += M), i < o && (i += M), r >= o && r <= i)
                }

                function p(e, t, n) {
                    var r, o = t.getTime(),
                        i = n.getTime();
                    return o >= i && (i += M), r = e.getTime(), r >= o && r <= i
                }

                function m(t, n) {
                    var r = t.getHours();
                    return t = new Date(t), h(t, n * M), e(t, r), t
                }

                function h(e, t, n) {
                    var r, o = e.getTimezoneOffset();
                    e.setTime(e.getTime() + t), n || (r = e.getTimezoneOffset() - o, e.setTime(e.getTime() + r * w))
                }

                function g(t, n) {
                    return t = new Date(t.getFullYear(), t.getMonth(), t.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()), e(t, n.getHours()), t
                }

                function y() {
                    return l(new Date)
                }

                function v(e) {
                    return l(e).getTime() == y().getTime()
                }

                function b(e) {
                    var t = new Date(1980, 1, 1, 0, 0, 0);
                    return e && t.setHours(e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()), t
                }
                var w = 6e4,
                    M = 864e5;
                return {
                    adjustDST: e,
                    dayOfWeek: r,
                    setDayOfWeek: t,
                    getDate: l,
                    isInDateRange: p,
                    isInTimeRange: f,
                    isToday: v,
                    nextDay: function(e) {
                        return m(e, 1)
                    },
                    previousDay: function(e) {
                        return m(e, -1)
                    },
                    toUtcTime: c,
                    MS_PER_DAY: M,
                    MS_PER_HOUR: 60 * w,
                    MS_PER_MINUTE: w,
                    setTime: h,
                    setHours: g,
                    addDays: m,
                    today: y,
                    toInvariantTime: b,
                    firstDayOfMonth: o,
                    lastDayOfMonth: i,
                    weekInYear: u,
                    getMilliseconds: d
                }
            }(), be.stripWhitespace = function(e) {
                var t, n, r;
                if (document.createNodeIterator)
                    for (t = document.createNodeIterator(e, NodeFilter.SHOW_TEXT, function(t) {
                            return t.parentNode == e ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT
                        }, !1); t.nextNode();) t.referenceNode && !t.referenceNode.textContent.trim() && t.referenceNode.parentNode.removeChild(t.referenceNode);
                else
                    for (n = 0; n < e.childNodes.length; n++) r = e.childNodes[n], 3 != r.nodeType || /\S/.test(r.nodeValue) || (e.removeChild(r), n--), 1 == r.nodeType && be.stripWhitespace(r)
            }, ye = t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || t.oRequestAnimationFrame || t.msRequestAnimationFrame || function(e) {
                setTimeout(e, 1e3 / 60)
            }, be.animationFrame = function(e) {
                ye.call(t, e)
            }, ve = [], be.queueAnimation = function(e) {
                ve[ve.length] = e, 1 === ve.length && be.runNextAnimation()
            }, be.runNextAnimation = function() {
                be.animationFrame(function() {
                    ve[0] && (ve.shift()(), ve[0] && be.runNextAnimation())
                })
            }, be.parseQueryStringParams = function(e) {
                for (var t = e.split("?")[1] || "", n = {}, r = t.split(/&|=/), o = r.length, i = 0; i < o; i += 2) "" !== r[i] && (n[decodeURIComponent(r[i])] = decodeURIComponent(r[i + 1]));
                return n
            }, be.elementUnderCursor = function(e) {
                if (n !== e.x.client) return document.elementFromPoint(e.x.client, e.y.client)
            }, be.wheelDeltaY = function(e) {
                var t, r = e.originalEvent,
                    o = r.wheelDeltaY;
                return r.wheelDelta ? (o === n || o) && (t = r.wheelDelta) : r.detail && r.axis === r.VERTICAL_AXIS && (t = 10 * -r.detail), t
            }, be.throttle = function(e, t) {
                var r, o, i = 0;
                return !t || t <= 0 ? e : (o = function() {
                    function o() {
                        e.apply(a, u), i = +new Date
                    }
                    var a = this,
                        s = +new Date - i,
                        u = arguments;
                    return i ? (r && clearTimeout(r), s > t ? o() : r = setTimeout(o, t - s), n) : o()
                }, o.cancel = function() {
                    clearTimeout(r)
                }, o)
            }, be.caret = function(t, r, o) {
                var i, a, s, u, l, c = r !== n;
                if (o === n && (o = r), t[0] && (t = t[0]), !c || !t.disabled) {
                    try {
                        t.selectionStart !== n ? c ? (t.focus(), a = Oe.mobileOS, a.wp || a.android ? setTimeout(function() {
                            t.setSelectionRange(r, o)
                        }, 0) : t.setSelectionRange(r, o)) : r = [t.selectionStart, t.selectionEnd] : document.selection && (e(t).is(":visible") && t.focus(), i = t.createTextRange(), c ? (i.collapse(!0), i.moveStart("character", r), i.moveEnd("character", o - r), i.select()) : (s = i.duplicate(), i.moveToBookmark(document.selection.createRange().getBookmark()), s.setEndPoint("EndToStart", i), u = s.text.length, l = u + i.text.length, r = [u, l]))
                    } catch (d) {
                        r = []
                    }
                    return r
                }
            }, be.compileMobileDirective = function(e, n) {
                var r = t.angular;
                return e.attr("data-" + be.ns + "role", e[0].tagName.toLowerCase().replace("kendo-mobile-", "").replace("-", "")), r.element(e).injector().invoke(["$compile", function(t) {
                    t(e)(n), /^\$(digest|apply)$/.test(n.$$phase) || n.$digest()
                }]), be.widgetInstance(e, be.mobile.ui)
            }, be.antiForgeryTokens = function() {
                var t = {},
                    r = e("meta[name=csrf-token],meta[name=_csrf]").attr("content"),
                    o = e("meta[name=csrf-param],meta[name=_csrf_header]").attr("content");
                return e("input[name^='__RequestVerificationToken']").each(function() {
                    t[this.name] = this.value
                }), o !== n && r !== n && (t[o] = r), t
            }, be.cycleForm = function(e) {
                function t(e) {
                    var t = be.widgetInstance(e);
                    t && t.focus ? t.focus() : e.focus()
                }
                var n = e.find("input, .k-widget").first(),
                    r = e.find("button, .k-button").last();
                r.on("keydown", function(e) {
                    e.keyCode != be.keys.TAB || e.shiftKey || (e.preventDefault(), t(n))
                }), n.on("keydown", function(e) {
                    e.keyCode == be.keys.TAB && e.shiftKey && (e.preventDefault(), t(r))
                })
            }, be.focusElement = function(n) {
                var r = [],
                    o = n.parentsUntil("body").filter(function(e, t) {
                        var n = be.getComputedStyles(t, ["overflow"]);
                        return "visible" !== n.overflow
                    }).add(t);
                o.each(function(t, n) {
                    r[t] = e(n).scrollTop()
                });
                try {
                    n[0].setActive()
                } catch (i) {
                    n[0].focus()
                }
                o.each(function(t, n) {
                    e(n).scrollTop(r[t])
                })
            }, be.matchesMedia = function(e) {
                var n = be._bootstrapToMedia(e) || e;
                return Oe.matchMedia && t.matchMedia(n).matches
            }, be._bootstrapToMedia = function(e) {
                return {
                    xs: "(max-width: 576px)",
                    sm: "(min-width: 576px)",
                    md: "(min-width: 768px)",
                    lg: "(min-width: 992px)",
                    xl: "(min-width: 1200px)"
                }[e]
            }, be.fileGroupMap = {
                audio: [".aif", ".iff", ".m3u", ".m4a", ".mid", ".mp3", ".mpa", ".wav", ".wma", ".ogg", ".wav", ".wma", ".wpl"],
                video: [".3g2", ".3gp", ".avi", ".asf", ".flv", ".m4u", ".rm", ".h264", ".m4v", ".mkv", ".mov", ".mp4", ".mpg", ".rm", ".swf", ".vob", ".wmv"],
                image: [".ai", ".dds", ".heic", ".jpe", "jfif", ".jif", ".jp2", ".jps", ".eps", ".bmp", ".gif", ".jpeg", ".jpg", ".png", ".ps", ".psd", ".svg", ".svgz", ".tif", ".tiff"],
                txt: [".doc", ".docx", ".log", ".pages", ".tex", ".wpd", ".wps", ".odt", ".rtf", ".text", ".txt", ".wks"],
                presentation: [".key", ".odp", ".pps", ".ppt", ".pptx"],
                data: [".xlr", ".xls", ".xlsx"],
                programming: [".tmp", ".bak", ".msi", ".cab", ".cpl", ".cur", ".dll", ".dmp", ".drv", ".icns", ".ico", ".link", ".sys", ".cfg", ".ini", ".asp", ".aspx", ".cer", ".csr", ".css", ".dcr", ".htm", ".html", ".js", ".php", ".rss", ".xhtml"],
                pdf: [".pdf"],
                config: [".apk", ".app", ".bat", ".cgi", ".com", ".exe", ".gadget", ".jar", ".wsf"],
                zip: [".7z", ".cbr", ".gz", ".sitx", ".arj", ".deb", ".pkg", ".rar", ".rpm", ".tar.gz", ".z", ".zip", ".zipx"],
                "disc-image": [".dmg", ".iso", ".toast", ".vcd", ".bin", ".cue", ".mdf"]
            }, be.getFileGroup = function(e, t) {
                var r, o, i = be.fileGroupMap,
                    a = Object.keys(i),
                    s = "file";
                if (e === n) return "";
                if ("" === e) return "folder";
                for (r = 0; r < a.length; r += 1)
                    if (o = i[a[r]], o.indexOf(e.toLowerCase()) > -1) return t ? "file-" + a[r] : a[r];
                return s
            }, be.getFileSizeMessage = function(e) {
                var t, n = ["Bytes", "KB", "MB", "GB", "TB"];
                return 0 === e ? "0 Byte" : (t = parseInt(Math.floor(Math.log(e) / Math.log(1024)), 10), Math.round(e / Math.pow(1024, t), 2) + " " + n[t])
            },
            function() {
                function n(t, n, r, o) {
                    var i, a, s = e("<form>").attr({
                            action: r,
                            method: "POST",
                            target: o
                        }),
                        u = be.antiForgeryTokens();
                    u.fileName = n, i = t.split(";base64,"), u.contentType = i[0].replace("data:", ""), u.base64 = i[1];
                    for (a in u) u.hasOwnProperty(a) && e("<input>").attr({
                        value: u[a],
                        name: a,
                        type: "hidden"
                    }).appendTo(s);
                    s.appendTo("body").submit().remove()
                }

                function r(e, t) {
                    var n, r, o, i, a, s = e;
                    if ("string" == typeof e) {
                        for (n = e.split(";base64,"), r = n[0], o = atob(n[1]), i = new Uint8Array(o.length), a = 0; a < o.length; a++) i[a] = o.charCodeAt(a);
                        s = new Blob([i.buffer], {
                            type: r
                        })
                    }
                    navigator.msSaveBlob(s, t)
                }

                function o(e, n) {
                    t.Blob && e instanceof Blob && (e = URL.createObjectURL(e)), i.download = n, i.href = e;
                    var r = document.createEvent("MouseEvents");
                    r.initMouseEvent("click", !0, !1, t, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), i.dispatchEvent(r), setTimeout(function() {
                        URL.revokeObjectURL(e)
                    })
                }
                var i = document.createElement("a"),
                    a = "download" in i && !be.support.browser.edge;
                be.saveAs = function(e) {
                    var t = n;
                    e.forceProxy || (a ? t = o : navigator.msSaveBlob && (t = r)), t(e.dataURI, e.fileName, e.proxyURL, e.proxyTarget)
                }
            }(), be.proxyModelSetters = function(e) {
                var t = {};
                return Object.keys(e || {}).forEach(function(n) {
                    Object.defineProperty(t, n, {
                        get: function() {
                            return e[n]
                        },
                        set: function(t) {
                            e[n] = t, e.dirty = !0
                        }
                    })
                }), t
            }
    }(jQuery, window), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(e, define) {
    define("kendo.data.min", ["kendo.core.min", "kendo.data.odata.min", "kendo.data.xml.min"], e)
}(function() {
    return function(e, t) {
        function r(e, t, r, i) {
            return function(n) {
                var a, s = {};
                for (a in n) s[a] = n[a];
                s.field = i ? r + "." + n.field : r, t == Ie && e._notifyChange && e._notifyChange(s), e.trigger(t, s)
            }
        }

        function i(t, r) {
            if (t === r) return !0;
            var n, a = e.type(t),
                s = e.type(r);
            if (a !== s) return !1;
            if ("date" === a) return t.getTime() === r.getTime();
            if ("object" !== a && "array" !== a) return !1;
            for (n in t)
                if (!i(t[n], r[n])) return !1;
            return !0
        }

        function n(e, t) {
            var r, i;
            for (i in e) {
                if (r = e[i], ve(r) && r.field && r.field === t) return r;
                if (r === t) return r
            }
            return null
        }

        function a(e) {
            this.data = e || []
        }

        function s(e, r) {
            if (e) {
                var i = typeof e === De ? {
                        field: e,
                        dir: r
                    } : e,
                    n = ye(i) ? i : i !== t ? [i] : [];
                return Se(n, function(e) {
                    return !!e.dir
                })
            }
        }

        function o(e, r) {
            var i, n, a, s = {};
            if (e)
                for (i = typeof e === De ? {
                        field: e,
                        dir: r
                    } : e, n = ye(i) ? i : i !== t ? [i] : [], a = 0; a < n.length; a++) s[n[a].field] = {
                    dir: n[a].dir,
                    index: a + 1
                };
            return s
        }

        function u(e) {
            var t, r, i, n, a = e.filters;
            if (a)
                for (t = 0, r = a.length; t < r; t++) i = a[t], n = i.operator, n && typeof n === De && (i.operator = ie[n.toLowerCase()] || n), u(i)
        }

        function l(e) {
            if (e && !me(e)) return !ye(e) && e.filters || (e = {
                logic: "and",
                filters: ye(e) ? e : [e]
            }), u(e), e
        }

        function h(e, t) {
            return !e.logic && !t.logic && (e.field === t.field && e.value === t.value && e.operator === t.operator)
        }

        function d(e) {
            return e = e || {}, me(e) ? {
                logic: "and",
                filters: []
            } : l(e)
        }

        function f(e, t) {
            return t.logic || e.field > t.field ? 1 : e.field < t.field ? -1 : 0
        }

        function c(e, t) {
            var r, i, n, a, s;
            if (e = d(e), t = d(t), e.logic !== t.logic) return !1;
            if (n = (e.filters || []).slice(), a = (t.filters || []).slice(), n.length !== a.length) return !1;
            for (n = n.sort(f), a = a.sort(f), s = 0; s < n.length; s++)
                if (r = n[s], i = a[s], r.logic && i.logic) {
                    if (!c(r, i)) return !1
                } else if (!h(r, i)) return !1;
            return !0
        }

        function g(e) {
            return ye(e) ? e : [e]
        }

        function p(e, r, i, n) {
            var a = typeof e === De ? {
                    field: e,
                    dir: r,
                    compare: i,
                    skipItemSorting: n
                } : e,
                s = ye(a) ? a : a !== t ? [a] : [];
            return W(s, function(e) {
                return {
                    field: e.field,
                    dir: e.dir || "asc",
                    aggregates: e.aggregates,
                    compare: e.compare,
                    skipItemSorting: e.skipItemSorting
                }
            })
        }

        function _(e, t, r) {
            var i, n = p(e, t, r);
            for (i = 0; i < n.length; i++) delete n[i].compare;
            return n
        }

        function v(e) {
            var t, r = ye(e) ? e : [e];
            for (t = 0; t < r.length; t++)
                if (r[t] && xe(r[t].compare)) return !0;
            return !1
        }

        function m(e, t) {
            return e && e.getTime && t && t.getTime ? e.getTime() === t.getTime() : e === t
        }

        function y(e, t, r, i, n, a) {
            var s, o, u, l, h;
            for (t = t || [], l = t.length, s = 0; s < l; s++) o = t[s], u = o.aggregate, h = o.field, e[h] = e[h] || {}, a[h] = a[h] || {}, a[h][u] = a[h][u] || {}, e[h][u] = ne[u.toLowerCase()](e[h][u], r, Fe.accessor(h), i, n, a[h][u])
        }

        function S(e) {
            return "number" == typeof e && !isNaN(e)
        }

        function b(e) {
            return e && e.getTime
        }

        function w(e) {
            var t, r = e.length,
                i = Array(r);
            for (t = 0; t < r; t++) i[t] = e[t].toJSON();
            return i
        }

        function k(e, t, r, i, n) {
            var a, s, o, u, l, h = {};
            for (u = 0, l = e.length; u < l; u++) {
                a = e[u];
                for (s in t) o = n[s], o && o !== s && (h[o] || (h[o] = Fe.setter(o)), h[o](a, t[s](a)), delete a[s])
            }
        }

        function F(e, t, r, i, n) {
            var a, s, o, u, l;
            for (u = 0, l = e.length; u < l; u++) {
                a = e[u];
                for (s in t) a[s] = r._parse(s, t[s](a)), o = n[s], o && o !== s && delete a[o]
            }
        }

        function x(e, t, r, i, n) {
            var a, s, o, u;
            for (s = 0, u = e.length; s < u; s++) a = e[s], o = i[a.field], o && o != a.field && (a.field = o), a.value = r._parse(a.field, a.value), a.hasSubgroups ? x(a.items, t, r, i, n) : F(a.items, t, r, i, n)
        }

        function R(e, t, r, i, n, a) {
            return function(s) {
                return s = e(s), q(t, r, i, n, a)(s)
            }
        }

        function q(e, t, r, i, n) {
            return function(a) {
                return a && !me(r) && ("[object Array]" === et.call(a) || a instanceof it || (a = [a]), t(a, r, new e, i, n)), a || []
            }
        }

        function D(e, t) {
            var r, i, n;
            if (t.items && t.items.length)
                for (n = 0; n < t.items.length; n++) r = e.items[n], i = t.items[n], r && i ? r.hasSubgroups ? D(r, i) : r.field && r.value == i.value ? r.items.push.apply(r.items, i.items) : e.items.push.apply(e.items, [i]) : i && e.items.push.apply(e.items, [i])
        }

        function z(e, t, r, i) {
            for (var n, a, s, o = 0; t.length && i && (n = t[o], a = n.items, s = a.length, e && e.field === n.field && e.value === n.value ? (e.hasSubgroups && e.items.length ? z(e.items[e.items.length - 1], n.items, r, i) : (a = a.slice(r, r + i), e.items = e.items.concat(a)), t.splice(o--, 1)) : n.hasSubgroups && a.length ? (z(n, a, r, i), n.items.length || t.splice(o--, 1)) : (a = a.slice(r, r + i), n.items = a, n.items.length || t.splice(o--, 1)), 0 === a.length ? r -= s : (r = 0, i -= a.length), !(++o >= t.length)););
            o < t.length && t.splice(o, t.length - o)
        }

        function C(e, t) {
            var r, i, n, a, s = [],
                o = (e || []).length,
                u = xe(t) ? t : function(e, t) {
                    return e[t]
                };
            for (n = 0; n < o; n++)
                if (r = u(e, n), r.hasSubgroups) s = s.concat(C(r.items));
                else
                    for (i = r.items, a = 0; a < i.length; a++) s.push(u(i, a));
            return s
        }

        function O(e) {
            var t, r, i, n, a, s = [];
            for (t = 0, r = e.length; t < r; t++)
                if (a = e.at(t), a.hasSubgroups) s = s.concat(O(a.items));
                else
                    for (i = a.items, n = 0; n < i.length; n++) s.push(i.at(n));
            return s
        }

        function P(e, t) {
            var r, i, n;
            if (t)
                for (r = 0, i = e.length; r < i; r++) n = e.at(r), n.hasSubgroups ? P(n.items, t) : n.items = new $(n.items, t, n.items._events)
        }

        function T(e, t) {
            for (var r = 0; r < e.length; r++)
                if (e[r].hasSubgroups) {
                    if (T(e[r].items, t)) return !0
                } else if (t(e[r].items, e[r])) return !0
        }

        function A(e, t, r, i) {
            for (var n = 0; n < e.length && e[n].data !== t && !I(e[n].data, r, i); n++);
        }

        function I(e, t, r) {
            for (var i = 0, n = e.length; i < n; i++) {
                if (e[i] && e[i].hasSubgroups) return I(e[i].items, t, r);
                if (e[i] === t || e[i] === r) return e[i] = r, !0
            }
        }

        function M(e, r, i, n, a) {
            var s, o, u, l;
            for (s = 0, o = e.length; s < o; s++)
                if (u = e[s], u && !(u instanceof n))
                    if (u.hasSubgroups === t || a) {
                        for (l = 0; l < r.length; l++)
                            if (r[l] === u) {
                                e[s] = r.at(l), A(i, r, u, e[s]);
                                break
                            }
                    } else M(u.items, r, i, n, a)
        }

        function N(e, t) {
            var r, i, n = e.length;
            for (i = 0; i < n; i++)
                if (r = e[i], r.uid && r.uid == t.uid) return e.splice(i, 1), r
        }

        function G(e, t) {
            return t ? j(e, function(e) {
                return e.uid && e.uid == t.uid || e[t.idField] === t.id && t.id !== t._defaultId
            }) : -1
        }

        function L(e, t) {
            return t ? j(e, function(e) {
                return e.uid == t.uid
            }) : -1
        }

        function j(e, t) {
            var r, i;
            for (r = 0, i = e.length; r < i; r++)
                if (t(e[r])) return r;
            return -1
        }

        function E(e, t) {
            var r, i;
            return e && !me(e) ? (r = e[t], i = ve(r) ? r.from || r.field || t : e[t] || t, xe(i) ? t : i) : t
        }

        function B(e, t) {
            var r, i, n, a = {};
            for (n in e) "filters" !== n && (a[n] = e[n]);
            if (e.filters)
                for (a.filters = [], r = 0, i = e.filters.length; r < i; r++) a.filters[r] = B(e.filters[r], t);
            else a.field = E(t.fields, a.field);
            return a
        }

        function H(e, t) {
            var r, i, n, a, s, o = [];
            for (r = 0, i = e.length; r < i; r++) {
                n = {}, a = e[r];
                for (s in a) n[s] = a[s];
                n.field = E(t.fields, n.field), n.aggregates && ye(n.aggregates) && (n.aggregates = H(n.aggregates, t)), o.push(n)
            }
            return o
        }

        function U(t, r) {
            var i, n, a, s, o, u, l, h, d, f;
            for (t = e(t)[0], i = t.options, n = r[0], a = r[1], s = [], o = 0, u = i.length; o < u; o++) d = {}, h = i[o], l = h.parentNode, l === t && (l = null), h.disabled || l && l.disabled || (l && (d.optgroup = l.label), d[n.field] = h.text, f = h.attributes.value, f = f && f.specified ? h.value : h.text, d[a.field] = f, s.push(d));
            return s
        }

        function J(t, r) {
            var i, n, a, s, o, u, l, h = e(t)[0].tBodies[0],
                d = h ? h.rows : [],
                f = r.length,
                c = [];
            for (i = 0, n = d.length; i < n; i++) {
                for (o = {}, l = !0, s = d[i].cells, a = 0; a < f; a++) u = s[a], "th" !== u.nodeName.toLowerCase() && (l = !1, o[r[a].field] = u.innerHTML);
                l || c.push(o)
            }
            return c
        }

        function V(e) {
            return function() {
                var t = this._data,
                    r = le.fn[e].apply(this, Ye.call(arguments));
                return this._data != t && this._attachBubbleHandlers(), r
            }
        }

        function Q(t, r) {
            function i(e, t) {
                return e.filter(t).add(e.find(t))
            }
            var n, a, s, o, u, l, h, d, f = e(t).children(),
                c = [],
                g = r[0].field,
                p = r[1] && r[1].field,
                _ = r[2] && r[2].field,
                v = r[3] && r[3].field;
            for (n = 0, a = f.length; n < a; n++) s = {
                _loaded: !0
            }, o = f.eq(n), l = o[0].firstChild, d = o.children(), t = d.filter("ul"), d = d.filter(":not(ul)"), u = o.attr("data-id"), u && (s.id = u), l && (s[g] = 3 == l.nodeType ? l.nodeValue : d.text()), p && (s[p] = i(d, "a").attr("href")), v && (s[v] = i(d, "img").attr("src")), _ && (h = i(d, ".k-sprite").prop("className"), s[_] = h && e.trim(h.replace("k-sprite", ""))), t.length && (s.items = Q(t.eq(0), r)), "true" == o.attr("data-hasChildren") && (s.hasChildren = !0), c.push(s);
            return c
        }
        var W, $, K, X, Y, Z, ee, te, re, ie, ne, ae, se, oe, ue, le, he, de, fe, ce, ge, pe = e.extend,
            _e = e.proxy,
            ve = e.isPlainObject,
            me = e.isEmptyObject,
            ye = e.isArray,
            Se = e.grep,
            be = e.ajax,
            we = e.each,
            ke = e.noop,
            Fe = window.kendo,
            xe = Fe.isFunction,
            Re = Fe.Observable,
            qe = Fe.Class,
            De = "string",
            ze = "function",
            Ce = "asc",
            Oe = "create",
            Pe = "read",
            Te = "update",
            Ae = "destroy",
            Ie = "change",
            Me = "sync",
            Ne = "get",
            Ge = "error",
            Le = "requestStart",
            je = "progress",
            Ee = "requestEnd",
            Be = [Oe, Pe, Te, Ae],
            He = function(e) {
                return e
            },
            Ue = Fe.getter,
            Je = Fe.stringify,
            Ve = Math,
            Qe = [].push,
            We = [].join,
            $e = [].pop,
            Ke = [].splice,
            Xe = [].shift,
            Ye = [].slice,
            Ze = [].unshift,
            et = {}.toString,
            tt = Fe.support.stableSort,
            rt = /^\/Date\((.*?)\)\/$/,
            it = Re.extend({
                init: function(e, t) {
                    var r = this;
                    r.type = t || K, Re.fn.init.call(r), r.length = e.length, r.wrapAll(e, r)
                },
                at: function(e) {
                    return this[e]
                },
                toJSON: function(e) {
                    var t, r, i = this.length,
                        n = Array(i);
                    for (t = 0; t < i; t++) r = this[t], r instanceof K && (r = r.toJSON(e)), n[t] = r;
                    return n
                },
                parent: ke,
                wrapAll: function(e, t) {
                    var r, i, n = this,
                        a = function() {
                            return n
                        };
                    for (t = t || [], r = 0, i = e.length; r < i; r++) t[r] = n.wrap(e[r], a);
                    return t
                },
                wrap: function(e, t) {
                    var r, i = this;
                    return null !== e && "[object Object]" === et.call(e) && (r = e instanceof i.type || e instanceof Z, r || (e = e instanceof K ? e.toJSON() : e, e = new i.type(e)), e.parent = t, e.bind(Ie, function(e) {
                        i.trigger(Ie, {
                            field: e.field,
                            node: e.node,
                            index: e.index,
                            items: e.items || [this],
                            action: e.node ? e.action || "itemloaded" : "itemchange"
                        })
                    })), e
                },
                push: function() {
                    var e, t = this.length,
                        r = this.wrapAll(arguments);
                    return e = Qe.apply(this, r), this.trigger(Ie, {
                        action: "add",
                        index: t,
                        items: r
                    }), e
                },
                slice: Ye,
                sort: [].sort,
                join: We,
                pop: function() {
                    var e = this.length,
                        t = $e.apply(this);
                    return e && this.trigger(Ie, {
                        action: "remove",
                        index: e - 1,
                        items: [t]
                    }), t
                },
                splice: function(e, t, r) {
                    var i, n, a, s = this.wrapAll(Ye.call(arguments, 2));
                    if (i = Ke.apply(this, [e, t].concat(s)), i.length)
                        for (this.trigger(Ie, {
                                action: "remove",
                                index: e,
                                items: i
                            }), n = 0, a = i.length; n < a; n++) i[n] && i[n].children && i[n].unbind(Ie);
                    return r && this.trigger(Ie, {
                        action: "add",
                        index: e,
                        items: s
                    }), i
                },
                shift: function() {
                    var e = this.length,
                        t = Xe.apply(this);
                    return e && this.trigger(Ie, {
                        action: "remove",
                        index: 0,
                        items: [t]
                    }), t
                },
                unshift: function() {
                    var e, t = this.wrapAll(arguments);
                    return e = Ze.apply(this, t), this.trigger(Ie, {
                        action: "add",
                        index: 0,
                        items: t
                    }), e
                },
                indexOf: function(e) {
                    var t, r, i = this;
                    for (t = 0, r = i.length; t < r; t++)
                        if (i[t] === e) return t;
                    return -1
                },
                forEach: function(e, t) {
                    for (var r = 0, i = this.length, n = t || window; r < i; r++) e.call(n, this[r], r, this)
                },
                map: function(e, t) {
                    for (var r = 0, i = [], n = this.length, a = t || window; r < n; r++) i[r] = e.call(a, this[r], r, this);
                    return i
                },
                reduce: function(e) {
                    var t, r = 0,
                        i = this.length;
                    for (2 == arguments.length ? t = arguments[1] : r < i && (t = this[r++]); r < i; r++) t = e(t, this[r], r, this);
                    return t
                },
                reduceRight: function(e) {
                    var t, r = this.length - 1;
                    for (2 == arguments.length ? t = arguments[1] : r > 0 && (t = this[r--]); r >= 0; r--) t = e(t, this[r], r, this);
                    return t
                },
                filter: function(e, t) {
                    for (var r, i = 0, n = [], a = this.length, s = t || window; i < a; i++) r = this[i], e.call(s, r, i, this) && (n[n.length] = r);
                    return n
                },
                find: function(e, t) {
                    for (var r, i = 0, n = this.length, a = t || window; i < n; i++)
                        if (r = this[i], e.call(a, r, i, this)) return r
                },
                every: function(e, t) {
                    for (var r, i = 0, n = this.length, a = t || window; i < n; i++)
                        if (r = this[i], !e.call(a, r, i, this)) return !1;
                    return !0
                },
                some: function(e, t) {
                    for (var r, i = 0, n = this.length, a = t || window; i < n; i++)
                        if (r = this[i], e.call(a, r, i, this)) return !0;
                    return !1
                },
                remove: function(e) {
                    var t = this.indexOf(e);
                    t !== -1 && this.splice(t, 1)
                },
                empty: function() {
                    this.splice(0, this.length)
                }
            });
        "undefined" != typeof Symbol && Symbol.iterator && !it.prototype[Symbol.iterator] && (it.prototype[Symbol.iterator] = [][Symbol.iterator]), $ = it.extend({
            init: function(e, t, r) {
                Re.fn.init.call(this), this.type = t || K, r && (this._events = r);
                for (var i = 0; i < e.length; i++) this[i] = e[i];
                this.length = i, this._parent = _e(function() {
                    return this
                }, this)
            },
            at: function(e) {
                var t = this[e];
                return t instanceof this.type ? t.parent = this._parent : t = this[e] = this.wrap(t, this._parent), t
            }
        }), K = Re.extend({
            init: function(e) {
                var t, r, i = this,
                    n = function() {
                        return i
                    };
                Re.fn.init.call(this), this._handlers = {};
                for (r in e) t = e[r], "object" == typeof t && t && !t.getTime && "_" != r.charAt(0) && (t = i.wrap(t, r, n)), i[r] = t;
                i.uid = Fe.guid()
            },
            shouldSerialize: function(e, t) {
                return this.hasOwnProperty(e) && "_handlers" !== e && "_events" !== e && (t && t[e] || typeof this[e] !== ze) && "uid" !== e
            },
            forEach: function(e) {
                for (var t in this) this.shouldSerialize(t) && e(this[t], t)
            },
            toJSON: function(e) {
                var t, r, i = {};
                for (r in this) this.shouldSerialize(r, e) && (t = this[r], (t instanceof K || t instanceof it) && (t = t.toJSON(e)), i[r] = t);
                return i
            },
            get: function(e) {
                var t, r = this;
                return r.trigger(Ne, {
                    field: e
                }), t = "this" === e ? r : Fe.getter(e, !0)(r)
            },
            _set: function(e, t) {
                var r, i, n, a = this,
                    s = e.indexOf(".") >= 0;
                if (s)
                    for (r = e.split("."), i = ""; r.length > 1;) {
                        if (i += r.shift(), n = Fe.getter(i, !0)(a), n instanceof K) return n.set(r.join("."), t), s;
                        i += "."
                    }
                return Fe.setter(e)(a, t), s
            },
            set: function(e, t) {
                var r = this,
                    i = !1,
                    n = e.indexOf(".") >= 0,
                    a = Fe.getter(e, !0)(r);
                return a !== t && (a instanceof Re && this._handlers[e] && (this._handlers[e].get && a.unbind(Ne, this._handlers[e].get), a.unbind(Ie, this._handlers[e].change)), i = r.trigger("set", {
                    field: e,
                    value: t
                }), i || (n || (t = r.wrap(t, e, function() {
                    return r
                })), (!r._set(e, t) || e.indexOf("(") >= 0 || e.indexOf("[") >= 0) && r.trigger(Ie, {
                    field: e
                }))), i
            },
            parent: ke,
            wrap: function(e, t, i) {
                var n, a, s, o, u = this,
                    l = et.call(e);
                return null == e || "[object Object]" !== l && "[object Array]" !== l || (s = e instanceof it, o = e instanceof le, "[object Object]" !== l || o || s ? ("[object Array]" === l || s || o) && (s || o || (e = new it(e)), a = r(u, Ie, t, !1), e.bind(Ie, a), u._handlers[t] = {
                    change: a
                }) : (e instanceof K || (e = new K(e)), n = r(u, Ne, t, !0), e.bind(Ne, n), a = r(u, Ie, t, !0), e.bind(Ie, a), u._handlers[t] = {
                    get: n,
                    change: a
                }), e.parent = i), e
            }
        }), X = {
            number: function(e) {
                return typeof e === De && "null" === e.toLowerCase() ? null : Fe.parseFloat(e)
            },
            date: function(e) {
                return typeof e === De && "null" === e.toLowerCase() ? null : Fe.parseDate(e)
            },
            "boolean": function(e) {
                return typeof e === De ? "null" === e.toLowerCase() ? null : "true" === e.toLowerCase() : null != e ? !!e : e
            },
            string: function(e) {
                return typeof e === De && "null" === e.toLowerCase() ? null : null != e ? e + "" : e
            },
            "default": function(e) {
                return e
            }
        }, Y = {
            string: "",
            number: 0,
            date: new Date,
            "boolean": !1,
            "default": ""
        }, Z = K.extend({
            init: function(r) {
                var i, n, a = this;
                if ((!r || e.isEmptyObject(r)) && (r = e.extend({}, a.defaults, r), a._initializers))
                    for (i = 0; i < a._initializers.length; i++) n = a._initializers[i], r[n] = a.defaults[n]();
                K.fn.init.call(a, r), a.dirty = !1, a.dirtyFields = {}, a.idField && (a.id = a.get(a.idField), a.id === t && (a.id = a._defaultId))
            },
            shouldSerialize: function(e) {
                return K.fn.shouldSerialize.call(this, e) && "uid" !== e && !("id" !== this.idField && "id" === e) && "dirty" !== e && "dirtyFields" !== e && "_accessors" !== e
            },
            _parse: function(e, t) {
                var r, i = this,
                    a = e,
                    s = i.fields || {};
                return e = s[e], e || (e = n(s, a)), e && (r = e.parse, !r && e.type && (r = X[e.type.toLowerCase()])), r ? r(t) : t
            },
            _notifyChange: function(e) {
                var t = e.action;
                "add" != t && "remove" != t || (this.dirty = !0, this.dirtyFields[e.field] = !0)
            },
            editable: function(e) {
                return e = (this.fields || {})[e], !e || e.editable !== !1
            },
            set: function(e, t) {
                var r = this,
                    n = r.dirty;
                r.editable(e) && (t = r._parse(e, t), i(t, r.get(e)) ? r.trigger("equalSet", {
                    field: e,
                    value: t
                }) : (r.dirty = !0, r.dirtyFields[e] = !0, K.fn.set.call(r, e, t) && !n && (r.dirty = n, r.dirty || (r.dirtyFields[e] = !1))))
            },
            accept: function(e) {
                var t, r, i = this,
                    n = function() {
                        return i
                    };
                for (t in e) r = e[t], "_" != t.charAt(0) && (r = i.wrap(e[t], t, n)), i._set(t, r);
                i.idField && (i.id = i.get(i.idField)), i.dirty = !1, i.dirtyFields = {}
            },
            isNew: function() {
                return this.id === this._defaultId
            }
        }), Z.define = function(e, r) {
            r === t && (r = e, e = Z);
            var i, n, a, s, o, u, l, h, d = pe({
                    defaults: {}
                }, r),
                f = {},
                c = d.id,
                g = [];
            if (c && (d.idField = c), d.id && delete d.id, c && (d.defaults[c] = d._defaultId = ""), "[object Array]" === et.call(d.fields)) {
                for (u = 0, l = d.fields.length; u < l; u++) a = d.fields[u], typeof a === De ? f[a] = {} : a.field && (f[a.field] = a);
                d.fields = f
            }
            for (n in d.fields) a = d.fields[n], s = a.type || "default", o = null, h = n, n = typeof a.field === De ? a.field : n, a.nullable || (o = d.defaults[h !== n ? h : n] = a.defaultValue !== t ? a.defaultValue : Y[s.toLowerCase()], "function" == typeof o && g.push(n)), r.id === n && (d._defaultId = o), d.defaults[h !== n ? h : n] = o, a.parse = a.parse || X[s];
            return g.length > 0 && (d._initializers = g), i = e.extend(d), i.define = function(e) {
                return Z.define(i, e)
            }, d.fields && (i.fields = d.fields, i.idField = d.idField), i
        }, ee = {
            selector: function(e) {
                return xe(e) ? e : Ue(e)
            },
            compare: function(e) {
                var t = this.selector(e);
                return function(e, r) {
                    return e = t(e), r = t(r), null == e && null == r ? 0 : null == e ? -1 : null == r ? 1 : e.localeCompare ? e.localeCompare(r) : e > r ? 1 : e < r ? -1 : 0
                }
            },
            create: function(e) {
                var t = e.compare || this.compare(e.field);
                return "desc" == e.dir ? function(e, r) {
                    return t(r, e, !0)
                } : t
            },
            combine: function(e) {
                return function(t, r) {
                    var i, n, a = e[0](t, r);
                    for (i = 1, n = e.length; i < n; i++) a = a || e[i](t, r);
                    return a
                }
            }
        }, te = pe({}, ee, {
            asc: function(e) {
                var t = this.selector(e);
                return function(e, r) {
                    var i = t(e),
                        n = t(r);
                    return i && i.getTime && n && n.getTime && (i = i.getTime(), n = n.getTime()), i === n ? e.__position - r.__position : null == i ? -1 : null == n ? 1 : i.localeCompare ? i.localeCompare(n) : i > n ? 1 : -1
                }
            },
            desc: function(e) {
                var t = this.selector(e);
                return function(e, r) {
                    var i = t(e),
                        n = t(r);
                    return i && i.getTime && n && n.getTime && (i = i.getTime(), n = n.getTime()), i === n ? e.__position - r.__position : null == i ? 1 : null == n ? -1 : n.localeCompare ? n.localeCompare(i) : i < n ? 1 : -1
                }
            },
            create: function(e) {
                return this[e.dir](e.field)
            }
        }), W = function(e, t) {
            var r, i = e.length,
                n = Array(i);
            for (r = 0; r < i; r++) n[r] = t(e[r], r, e);
            return n
        }, re = function() {
            function e(e) {
                return "string" == typeof e && (e = e.replace(/[\r\n]+/g, "")), JSON.stringify(e)
            }

            function t(t) {
                return function(r, i, n, a) {
                    return i += "", n && (r = "(" + r + " + '').toString()" + (a ? ".toLocaleLowerCase('" + a + "')" : ".toLowerCase()"), i = a ? i.toLocaleLowerCase(a) : i.toLowerCase()), t(r, e(i), n)
                }
            }

            function r(t, r, i, n, a) {
                if (null != i) {
                    if (typeof i === De) {
                        var s = rt.exec(i);
                        s ? i = new Date((+s[1])) : n ? (i = e(a ? i.toLocaleLowerCase(a) : i.toLowerCase()), r = "((" + r + " || '')+'')" + (a ? ".toLocaleLowerCase('" + a + "')" : ".toLowerCase()")) : i = e(i)
                    }
                    i.getTime && (r = "(" + r + "&&" + r + ".getTime?" + r + ".getTime():" + r + ")", i = i.getTime())
                }
                return r + " " + t + " " + i
            }

            function i(e) {
                var t, r, i, n;
                for (t = "/^", r = !1, i = 0; i < e.length; ++i) {
                    if (n = e.charAt(i), r) t += "\\" + n;
                    else {
                        if ("~" == n) {
                            r = !0;
                            continue
                        }
                        t += "*" == n ? ".*" : "?" == n ? "." : ".+^$()[]{}|\\/\n\r\u2028\u2029 ".indexOf(n) >= 0 ? "\\" + n : n
                    }
                    r = !1
                }
                return t + "$/"
            }
            return {
                quote: function(t) {
                    return t && t.getTime ? "new Date(" + t.getTime() + ")" : e(t)
                },
                eq: function(e, t, i, n) {
                    return r("==", e, t, i, n)
                },
                neq: function(e, t, i, n) {
                    return r("!=", e, t, i, n)
                },
                gt: function(e, t, i) {
                    return r(">", e, t, i)
                },
                gte: function(e, t, i) {
                    return r(">=", e, t, i)
                },
                lt: function(e, t, i) {
                    return r("<", e, t, i)
                },
                lte: function(e, t, i) {
                    return r("<=", e, t, i)
                },
                startswith: t(function(e, t) {
                    return e + ".lastIndexOf(" + t + ", 0) == 0"
                }),
                doesnotstartwith: t(function(e, t) {
                    return e + ".lastIndexOf(" + t + ", 0) == -1"
                }),
                endswith: t(function(e, t) {
                    var r = t ? t.length - 2 : 0;
                    return e + ".indexOf(" + t + ", " + e + ".length - " + r + ") >= 0"
                }),
                doesnotendwith: t(function(e, t) {
                    var r = t ? t.length - 2 : 0;
                    return e + ".indexOf(" + t + ", " + e + ".length - " + r + ") < 0"
                }),
                contains: t(function(e, t) {
                    return e + ".indexOf(" + t + ") >= 0"
                }),
                doesnotcontain: t(function(e, t) {
                    return e + ".indexOf(" + t + ") == -1"
                }),
                matches: t(function(e, t) {
                    return t = t.substring(1, t.length - 1), i(t) + ".test(" + e + ")"
                }),
                doesnotmatch: t(function(e, t) {
                    return t = t.substring(1, t.length - 1), "!" + i(t) + ".test(" + e + ")"
                }),
                isempty: function(e) {
                    return e + " === ''"
                },
                isnotempty: function(e) {
                    return e + " !== ''"
                },
                isnull: function(e) {
                    return "(" + e + " == null)"
                },
                isnotnull: function(e) {
                    return "(" + e + " != null)"
                },
                isnullorempty: function(e) {
                    return "(" + e + " === null) || (" + e + " === '')"
                },
                isnotnullorempty: function(e) {
                    return "(" + e + " !== null) && (" + e + " !== '')"
                }
            }
        }(), a.filterExpr = function(e) {
            var r, i, n, s, o, u, l = [],
                h = {
                    and: " && ",
                    or: " || "
                },
                d = [],
                f = [],
                c = e.filters;
            for (r = 0, i = c.length; r < i; r++) n = c[r], o = n.field, u = n.operator, n.filters ? (s = a.filterExpr(n), n = s.expression.replace(/__o\[(\d+)\]/g, function(e, t) {
                return t = +t, "__o[" + (f.length + t) + "]"
            }).replace(/__f\[(\d+)\]/g, function(e, t) {
                return t = +t, "__f[" + (d.length + t) + "]"
            }), f.push.apply(f, s.operators), d.push.apply(d, s.fields)) : (typeof o === ze ? (s = "__f[" + d.length + "](d)", d.push(o)) : s = Fe.expr(o), typeof u === ze ? (n = "__o[" + f.length + "](" + s + ", " + re.quote(n.value) + ")", f.push(u)) : n = re[(u || "eq").toLowerCase()](s, n.value, n.ignoreCase === t || n.ignoreCase, e.accentFoldingFiltering)), l.push(n);
            return {
                expression: "(" + l.join(h[e.logic]) + ")",
                fields: d,
                operators: f
            }
        }, ie = {
            "==": "eq",
            equals: "eq",
            isequalto: "eq",
            equalto: "eq",
            equal: "eq",
            "!=": "neq",
            ne: "neq",
            notequals: "neq",
            isnotequalto: "neq",
            notequalto: "neq",
            notequal: "neq",
            "<": "lt",
            islessthan: "lt",
            lessthan: "lt",
            less: "lt",
            "<=": "lte",
            le: "lte",
            islessthanorequalto: "lte",
            lessthanequal: "lte",
            ">": "gt",
            isgreaterthan: "gt",
            greaterthan: "gt",
            greater: "gt",
            ">=": "gte",
            isgreaterthanorequalto: "gte",
            greaterthanequal: "gte",
            ge: "gte",
            notsubstringof: "doesnotcontain",
            isnull: "isnull",
            isempty: "isempty",
            isnotempty: "isnotempty"
        }, a.normalizeFilter = l, a.compareFilters = c, a.prototype = {
            toArray: function() {
                return this.data
            },
            range: function(e, t) {
                return new a(this.data.slice(e, e + t))
            },
            skip: function(e) {
                return new a(this.data.slice(e))
            },
            take: function(e) {
                return new a(this.data.slice(0, e))
            },
            select: function(e) {
                return new a(W(this.data, e))
            },
            order: function(e, t, r) {
                var i = {
                    dir: t
                };
                return e && (e.compare ? i.compare = e.compare : i.field = e), new a(r ? this.data.sort(ee.create(i)) : this.data.slice(0).sort(ee.create(i)))
            },
            orderBy: function(e, t) {
                return this.order(e, "asc", t)
            },
            orderByDescending: function(e, t) {
                return this.order(e, "desc", t)
            },
            sort: function(e, t, r, i) {
                var n, a, o = s(e, t),
                    u = [];
                if (r = r || ee, o.length) {
                    for (n = 0, a = o.length; n < a; n++) u.push(r.create(o[n]));
                    return this.orderBy({
                        compare: r.combine(u)
                    }, i)
                }
                return this
            },
            filter: function(e) {
                var t, r, i, n, s, o, u, h, d = this.data,
                    f = [];
                if (e = l(e), !e || 0 === e.filters.length) return this;
                for (n = a.filterExpr(e), o = n.fields, u = n.operators, s = h = Function("d, __f, __o", "return " + n.expression), (o.length || u.length) && (h = function(e) {
                        return s(e, o, u)
                    }), t = 0, i = d.length; t < i; t++) r = d[t], h(r) && f.push(r);
                return new a(f)
            },
            group: function(e, t) {
                e = p(e || []), t = t || this.data;
                var r, i = this,
                    n = new a(i.data);
                return e.length > 0 && (r = e[0], n = n.groupBy(r).select(function(i) {
                    var n = new a(t).filter([{
                        field: i.field,
                        operator: "eq",
                        value: i.value,
                        ignoreCase: !1
                    }]);
                    return {
                        field: i.field,
                        value: i.value,
                        items: e.length > 1 ? new a(i.items).group(e.slice(1), n.toArray()).toArray() : i.items,
                        hasSubgroups: e.length > 1,
                        aggregates: n.aggregate(r.aggregates)
                    }
                })), n
            },
            groupBy: function(e) {
                var t, r, i, n, s, o, u, l, h, d, f = this;
                if (me(e) || !this.data.length) return new a([]);
                for (t = e.field, r = e.skipItemSorting ? this.data : this._sortForGrouping(t, e.dir || "asc"), i = Fe.accessor(t), s = i.get(r[0], t), o = {
                        field: t,
                        value: s,
                        items: []
                    }, d = [o], l = 0, h = r.length; l < h; l++) n = r[l], u = i.get(n, t), m(s, u) || (s = u, o = {
                    field: t,
                    value: s,
                    items: []
                }, d.push(o)), o.items.push(n);
                return d = f._sortGroups(d, e), new a(d)
            },
            _sortForGrouping: function(e, t) {
                var r, i, n = this.data;
                if (!tt) {
                    for (r = 0, i = n.length; r < i; r++) n[r].__position = r;
                    for (n = new a(n).sort(e, t, te).toArray(), r = 0, i = n.length; r < i; r++) delete n[r].__position;
                    return n
                }
                return this.sort(e, t).toArray()
            },
            _sortGroups: function(e, t) {
                var r = e;
                return t && xe(t.compare) && (r = new a(r).order({
                    compare: t.compare
                }, t.dir || Ce).toArray()), r
            },
            aggregate: function(e) {
                var t, r, i = {},
                    n = {};
                if (e && e.length)
                    for (t = 0, r = this.data.length; t < r; t++) y(i, e, this.data[t], t, r, n);
                return i
            }
        }, ne = {
            sum: function(e, t, r) {
                var i = r.get(t);
                return S(e) ? S(i) && (e += i) : e = i, e
            },
            count: function(e) {
                return (e || 0) + 1
            },
            average: function(e, r, i, n, a, s) {
                var o = i.get(r);
                return s.count === t && (s.count = 0), S(e) ? S(o) && (e += o) : e = o, S(o) && s.count++, n == a - 1 && S(e) && (e /= s.count), e
            },
            max: function(e, t, r) {
                var i = r.get(t);
                return S(e) || b(e) || (e = i), e < i && (S(i) || b(i)) && (e = i), e
            },
            min: function(e, t, r) {
                var i = r.get(t);
                return S(e) || b(e) || (e = i), e > i && (S(i) || b(i)) && (e = i), e
            }
        }, a.normalizeGroup = p, a.normalizeSort = s, a.process = function(e, r, i) {
            var n, o, u, l, h, d, f, c, g, m, y, S;
            return r = r || {}, n = r.group, o = v(p(n || [])), u = new a(e), l = _(n || []), h = s(r.sort || []), d = o ? h : l.concat(h), g = r.filterCallback, m = r.filter, y = r.skip, S = r.take, d && i && (u = u.sort(d, t, t, i)), m && (u = u.filter(m), g && (u = g(u)), c = u.toArray().length), d && (i || (u = u.sort(d)), n && (e = u.toArray())), o ? (u = u.group(n, e), y !== t && S !== t && (u = new a(C(u.toArray())).range(y, S), f = W(l, function(e) {
                return pe({}, e, {
                    skipItemSorting: !0
                })
            }), u = u.group(f, e))) : (y !== t && S !== t && (u = u.range(y, S)), n && (u = u.group(n, e))), {
                total: c,
                data: u.toArray()
            }
        }, ae = qe.extend({
            init: function(e) {
                this.data = e.data
            },
            read: function(e) {
                e.success(this.data)
            },
            update: function(e) {
                e.success(e.data)
            },
            create: function(e) {
                e.success(e.data)
            },
            destroy: function(e) {
                e.success(e.data)
            }
        }), se = qe.extend({
            init: function(e) {
                var t, r = this;
                e = r.options = pe({}, r.options, e), we(Be, function(t, r) {
                    typeof e[r] === De && (e[r] = {
                        url: e[r]
                    })
                }), r.cache = e.cache ? oe.create(e.cache) : {
                    find: ke,
                    add: ke
                }, t = e.parameterMap, e.submit && (r.submit = e.submit), xe(e.push) && (r.push = e.push), r.push || (r.push = He), r.parameterMap = xe(t) ? t : function(e) {
                    var r = {};
                    return we(e, function(e, i) {
                        e in t && (e = t[e], ve(e) && (i = e.value(i), e = e.key)), r[e] = i
                    }), r
                }
            },
            options: {
                parameterMap: He
            },
            create: function(e) {
                return be(this.setup(e, Oe))
            },
            read: function(r) {
                var i, n, a, s = this,
                    o = s.cache;
                r = s.setup(r, Pe), i = r.success || ke, n = r.error || ke, a = o.find(r.data), a !== t ? i(a) : (r.success = function(e) {
                    o.add(r.data, e), i(e)
                }, e.ajax(r))
            },
            update: function(e) {
                return be(this.setup(e, Te))
            },
            destroy: function(e) {
                return be(this.setup(e, Ae))
            },
            setup: function(e, t) {
                e = e || {};
                var r, i = this,
                    n = i.options[t],
                    a = xe(n.data) ? n.data(e.data) : n.data;
                return e = pe(!0, {}, n, e), r = pe(!0, {}, a, e.data), e.data = i.parameterMap(r, t), xe(e.url) && (e.url = e.url(r)), e
            }
        }), oe = qe.extend({
            init: function() {
                this._store = {}
            },
            add: function(e, r) {
                e !== t && (this._store[Je(e)] = r)
            },
            find: function(e) {
                return this._store[Je(e)]
            },
            clear: function() {
                this._store = {}
            },
            remove: function(e) {
                delete this._store[Je(e)]
            }
        }), oe.create = function(e) {
            var t = {
                inmemory: function() {
                    return new oe
                }
            };
            return ve(e) && xe(e.find) ? e : e === !0 ? new oe : t[e]()
        }, ue = qe.extend({
            init: function(e) {
                var t, r, i, n, a, s, o, u, l, h, d, f, c, g, p = this;
                e = e || {};
                for (t in e) r = e[t], p[t] = typeof r === De ? Ue(r) : r;
                n = e.modelBase || Z, ve(p.model) && (p.model = i = n.define(p.model)), a = _e(p.data, p), p._dataAccessFunction = a, p.model && (s = _e(p.groups, p), o = _e(p.serialize, p), u = {}, l = {}, h = {}, d = {}, f = !1, i = p.model, i.fields && (we(i.fields, function(e, t) {
                    var r;
                    c = e, ve(t) && t.field ? c = t.field : typeof t === De && (c = t), ve(t) && t.from && (r = t.from), f = f || r && r !== e || c !== e, g = r || c, l[e] = g.indexOf(".") !== -1 ? Ue(g, !0) : Ue(g), h[e] = Ue(e), u[r || c] = e, d[e] = r || c
                }), !e.serialize && f && (p.serialize = R(o, i, k, h, u, d))), p._dataAccessFunction = a, p._wrapDataAccessBase = q(i, F, l, u, d), p.data = R(a, i, F, l, u, d), p.groups = R(s, i, x, l, u, d))
            },
            errors: function(e) {
                return e ? e.errors : null
            },
            parse: He,
            data: He,
            total: function(e) {
                return e.length
            },
            groups: He,
            aggregates: function() {
                return {}
            },
            serialize: function(e) {
                return e
            }
        }), le = Re.extend({
            init: function(e) {
                var r, i, n, a = this;
                e && (i = e.data), e = a.options = pe({}, a.options, e), a._map = {}, a._prefetch = {}, a._data = [], a._pristineData = [], a._ranges = [], a._view = [], a._pristineTotal = 0, a._destroyed = [], a._pageSize = e.pageSize, a._page = e.page || (e.pageSize ? 1 : t), a._sort = s(e.sort), a._filter = l(e.filter), a._group = p(e.group), a._aggregate = e.aggregate, a._total = e.total, a._shouldDetachObservableParents = !0, Re.fn.init.call(a), a.transport = he.create(e, i, a), xe(a.transport.push) && a.transport.push({
                    pushCreate: _e(a._pushCreate, a),
                    pushUpdate: _e(a._pushUpdate, a),
                    pushDestroy: _e(a._pushDestroy, a)
                }), null != e.offlineStorage && ("string" == typeof e.offlineStorage ? (n = e.offlineStorage, a._storage = {
                    getItem: function() {
                        return JSON.parse(localStorage.getItem(n))
                    },
                    setItem: function(e) {
                        localStorage.setItem(n, Je(a.reader.serialize(e)))
                    }
                }) : a._storage = e.offlineStorage), a.reader = new Fe.data.readers[e.schema.type || "json"](e.schema), r = a.reader.model || {}, a._detachObservableParents(), a._data = a._observe(a._data), a._online = !0, a.bind(["push", Ge, Ie, Le, Me, Ee, je], e)
            },
            options: {
                data: null,
                schema: {
                    modelBase: Z
                },
                offlineStorage: null,
                serverSorting: !1,
                serverPaging: !1,
                serverFiltering: !1,
                serverGrouping: !1,
                serverAggregates: !1,
                batch: !1,
                inPlaceSort: !1
            },
            clone: function() {
                return this
            },
            online: function(r) {
                return r !== t ? this._online != r && (this._online = r, r) ? this.sync() : e.Deferred().resolve().promise() : this._online
            },
            offlineData: function(e) {
                return null == this.options.offlineStorage ? null : e !== t ? this._storage.setItem(e) : this._storage.getItem() || []
            },
            _isServerGrouped: function() {
                var e = this.group() || [];
                return this.options.serverGrouping && e.length
            },
            _pushCreate: function(e) {
                this._push(e, "pushCreate")
            },
            _pushUpdate: function(e) {
                this._push(e, "pushUpdate")
            },
            _pushDestroy: function(e) {
                this._push(e, "pushDestroy")
            },
            _push: function(e, t) {
                var r = this._readData(e);
                r || (r = e), this[t](r)
            },
            _flatData: function(e, t) {
                if (e) {
                    if (this._isServerGrouped()) return O(e);
                    if (!t)
                        for (var r = 0; r < e.length; r++) e.at(r)
                }
                return e
            },
            parent: ke,
            get: function(e) {
                var t, r, i = this._flatData(this._data, this.options.useRanges);
                for (t = 0, r = i.length; t < r; t++)
                    if (i[t].id == e) return i[t]
            },
            getByUid: function(e) {
                return this._getByUid(e, this._data)
            },
            _getByUid: function(e, t) {
                var r, i, n = this._flatData(t, this.options.useRanges);
                if (n)
                    for (r = 0, i = n.length; r < i; r++)
                        if (n[r].uid == e) return n[r]
            },
            indexOf: function(e) {
                return L(this._data, e)
            },
            at: function(e) {
                return this._data.at(e)
            },
            data: function(e) {
                var r, i = this;
                if (e === t) {
                    if (i._data)
                        for (r = 0; r < i._data.length; r++) i._data.at(r);
                    return i._data
                }
                i._detachObservableParents(), i._data = this._observe(e), i._pristineData = e.slice(0), i._storeData(), i._ranges = [], i.trigger("reset"), i._addRange(i._data), i._total = i._data.length, i._pristineTotal = i._total, i._process(i._data)
            },
            view: function(e) {
                return e === t ? this._view : (this._view = this._observeView(e), t)
            },
            _observeView: function(e) {
                var t, r = this;
                return M(e, r._data, r._ranges, r.reader.model || K, r._isServerGrouped()), t = new $(e, r.reader.model), t.parent = function() {
                    return r.parent()
                }, t
            },
            flatView: function() {
                var e = this.group() || [];
                return e.length ? O(this._view) : this._view
            },
            add: function(e) {
                return this.insert(this._data.length, e)
            },
            _createNewModel: function(e) {
                return this.reader.model ? new this.reader.model(e) : e instanceof K ? e : new K(e)
            },
            insert: function(e, t) {
                return t || (t = e, e = 0), t instanceof Z || (t = this._createNewModel(t)), this._isServerGrouped() ? this._data.splice(e, 0, this._wrapInEmptyGroup(t)) : this._data.splice(e, 0, t), this._insertModelInRange(e, t), t
            },
            pushInsert: function(t, r) {
                var i, n, a, s, o, u, l = this,
                    h = l._getCurrentRangeSpan();
                r || (r = t, t = 0), ye(r) || (r = [r]), i = [], n = this.options.autoSync, this.options.autoSync = !1;
                try {
                    for (a = 0; a < r.length; a++) s = r[a], o = this.insert(t, s), i.push(o), u = o.toJSON(), this._isServerGrouped() && (u = this._wrapInEmptyGroup(u)), this._pristineData.push(u), h && h.length && e(h).last()[0].pristineData.push(u), t++
                } finally {
                    this.options.autoSync = n
                }
                i.length && this.trigger("push", {
                    type: "create",
                    items: i
                })
            },
            pushCreate: function(e) {
                this.pushInsert(this._data.length, e)
            },
            pushUpdate: function(e) {
                var t, r, i, n, a;
                for (ye(e) || (e = [e]), t = [], r = 0; r < e.length; r++) i = e[r], n = this._createNewModel(i), a = this.get(n.id), a ? (t.push(a), a.accept(i), a.trigger(Ie), this._updatePristineForModel(a, i)) : this.pushCreate(i);
                t.length && this.trigger("push", {
                    type: "update",
                    items: t
                })
            },
            pushDestroy: function(e) {
                var t = this._removeItems(e);
                t.length && this.trigger("push", {
                    type: "destroy",
                    items: t
                })
            },
            _removeItems: function(e, r) {
                var i, n, a, s, o, u, l;
                ye(e) || (e = [e]), i = t === r || r, n = [], a = this.options.autoSync, this.options.autoSync = !1;
                try {
                    for (s = 0; s < e.length; s++) o = e[s], u = this._createNewModel(o), l = !1, this._eachItem(this._data, function(e) {
                        var t, r;
                        for (t = 0; t < e.length; t++)
                            if (r = e.at(t), r.id === u.id) {
                                n.push(r), e.splice(t, 1), l = !0;
                                break
                            }
                    }), l && i && (this._removePristineForModel(u), this._destroyed.pop())
                } finally {
                    this.options.autoSync = a
                }
                return n
            },
            remove: function(e) {
                var t, r = this,
                    i = r._isServerGrouped();
                return this._eachItem(r._data, function(n) {
                    if (t = N(n, e), t && i) return t.isNew && t.isNew() || r._destroyed.push(t), !0
                }), this._removeModelFromRanges(e), e
            },
            destroyed: function() {
                return this._destroyed
            },
            created: function() {
                var e, t, r = [],
                    i = this._flatData(this._data, this.options.useRanges);
                for (e = 0, t = i.length; e < t; e++) i[e].isNew && i[e].isNew() && r.push(i[e]);
                return r
            },
            updated: function() {
                var e, t, r = [],
                    i = this._flatData(this._data, this.options.useRanges);
                for (e = 0, t = i.length; e < t; e++) i[e].isNew && !i[e].isNew() && i[e].dirty && r.push(i[e]);
                return r
            },
            sync: function() {
                var t, r = this,
                    i = [],
                    n = [],
                    a = r._destroyed,
                    s = e.Deferred().resolve().promise();
                if (r.online()) {
                    if (!r.reader.model) return s;
                    i = r.created(), n = r.updated(), t = [], r.options.batch && r.transport.submit ? t = r._sendSubmit(i, n, a) : (t.push.apply(t, r._send("create", i)), t.push.apply(t, r._send("update", n)), t.push.apply(t, r._send("destroy", a))), s = e.when.apply(null, t).then(function() {
                        var e, t;
                        for (e = 0, t = arguments.length; e < t; e++) arguments[e] && r._accept(arguments[e]);
                        r._storeData(!0), r._syncEnd(), r._change({
                            action: "sync"
                        }), r.trigger(Me)
                    })
                } else r._storeData(!0), r._syncEnd(), r._change({
                    action: "sync"
                });
                return s
            },
            _syncEnd: ke,
            cancelChanges: function(e) {
                var t = this;
                e instanceof Fe.data.Model ? t._cancelModel(e) : (t._destroyed = [], t._detachObservableParents(), t._data = t._observe(t._pristineData), t.options.serverPaging && (t._total = t._pristineTotal), t._ranges = [], t._addRange(t._data, 0), t._changesCanceled(), t._change(), t._markOfflineUpdatesAsDirty())
            },
            _changesCanceled: ke,
            _markOfflineUpdatesAsDirty: function() {
                var e = this;
                null != e.options.offlineStorage && e._eachItem(e._data, function(e) {
                    var t, r;
                    for (t = 0; t < e.length; t++) r = e.at(t), "update" != r.__state__ && "create" != r.__state__ || (r.dirty = !0);
                })
            },
            hasChanges: function() {
                var e, t, r = this._flatData(this._data, this.options.useRanges);
                if (this._destroyed.length) return !0;
                for (e = 0, t = r.length; e < t; e++)
                    if (r[e].isNew && r[e].isNew() || r[e].dirty) return !0;
                return !1
            },
            _accept: function(t) {
                var r, i = this,
                    n = t.models,
                    a = t.response,
                    s = 0,
                    o = i._isServerGrouped(),
                    u = i._pristineData,
                    l = t.type;
                if (i.trigger(Ee, {
                        response: a,
                        type: l
                    }), a && !me(a)) {
                    if (a = i.reader.parse(a), i._handleCustomErrors(a)) return;
                    a = i.reader.data(a), ye(a) || (a = [a])
                } else a = e.map(n, function(e) {
                    return e.toJSON()
                });
                for ("destroy" === l && (i._destroyed = []), s = 0, r = n.length; s < r; s++) "destroy" !== l ? (n[s].accept(a[s]), "create" === l ? u.push(o ? i._wrapInEmptyGroup(n[s].toJSON()) : a[s]) : "update" === l && i._updatePristineForModel(n[s], a[s])) : i._removePristineForModel(n[s])
            },
            _updatePristineForModel: function(e, t) {
                this._executeOnPristineForModel(e, function(e, r) {
                    Fe.deepExtend(r[e], t)
                })
            },
            _executeOnPristineForModel: function(e, t) {
                this._eachPristineItem(function(r) {
                    var i = G(r, e);
                    if (i > -1) return t(i, r), !0
                })
            },
            _removePristineForModel: function(e) {
                this._executeOnPristineForModel(e, function(e, t) {
                    t.splice(e, 1)
                })
            },
            _readData: function(e) {
                var t = this._isServerGrouped() ? this.reader.groups : this.reader.data;
                return t.call(this.reader, e)
            },
            _eachPristineItem: function(e) {
                var t = this,
                    r = t.options,
                    i = t._getCurrentRangeSpan();
                t._eachItem(t._pristineData, e), r.serverPaging && r.useRanges && we(i, function(r, i) {
                    t._eachItem(i.pristineData, e)
                })
            },
            _eachItem: function(e, t) {
                e && e.length && (this._isServerGrouped() ? T(e, t) : t(e))
            },
            _pristineForModel: function(e) {
                var t, r, i = function(i) {
                    if (r = G(i, e), r > -1) return t = i[r], !0
                };
                return this._eachPristineItem(i), t
            },
            _cancelModel: function(e) {
                var t = this,
                    r = this._pristineForModel(e);
                this._eachItem(this._data, function(i) {
                    var n = L(i, e);
                    n >= 0 && (!r || e.isNew() && !r.__state__ ? (t._modelCanceled(e), i.splice(n, 1), t._removeModelFromRanges(e)) : (i[n].accept(r), "update" == r.__state__ && (i[n].dirty = !0)))
                })
            },
            _modelCanceled: ke,
            _submit: function(t, r) {
                var i = this;
                i.trigger(Le, {
                    type: "submit"
                }), i.trigger(je), i.transport.submit(pe({
                    success: function(r, i) {
                        var n = e.grep(t, function(e) {
                            return e.type == i
                        })[0];
                        n && n.resolve({
                            response: r,
                            models: n.models,
                            type: i
                        })
                    },
                    error: function(e, r, n) {
                        for (var a = 0; a < t.length; a++) t[a].reject(e);
                        i.error(e, r, n)
                    }
                }, r))
            },
            _sendSubmit: function(t, r, i) {
                var n = this,
                    a = [];
                return n.options.batch && (t.length && a.push(e.Deferred(function(e) {
                    e.type = "create", e.models = t
                })), r.length && a.push(e.Deferred(function(e) {
                    e.type = "update", e.models = r
                })), i.length && a.push(e.Deferred(function(e) {
                    e.type = "destroy", e.models = i
                })), n._submit(a, {
                    data: {
                        created: n.reader.serialize(w(t)),
                        updated: n.reader.serialize(w(r)),
                        destroyed: n.reader.serialize(w(i))
                    }
                })), a
            },
            _promise: function(t, r, i) {
                var n = this;
                return e.Deferred(function(e) {
                    n.trigger(Le, {
                        type: i
                    }), n.trigger(je), n.transport[i].call(n.transport, pe({
                        success: function(t) {
                            e.resolve({
                                response: t,
                                models: r,
                                type: i
                            })
                        },
                        error: function(t, r, i) {
                            e.reject(t), n.error(t, r, i)
                        }
                    }, t))
                }).promise()
            },
            _send: function(e, t) {
                var r, i, n = this,
                    a = [],
                    s = n.reader.serialize(w(t));
                if (n.options.batch) t.length && a.push(n._promise({
                    data: {
                        models: s
                    }
                }, t, e));
                else
                    for (r = 0, i = t.length; r < i; r++) a.push(n._promise({
                        data: s[r]
                    }, [t[r]], e));
                return a
            },
            read: function(t) {
                var r = this,
                    i = r._params(t),
                    n = e.Deferred();
                return r._queueRequest(i, function() {
                    var e = r.trigger(Le, {
                        type: "read"
                    });
                    e ? (r._dequeueRequest(), n.resolve(e)) : (r.trigger(je), r._ranges = [], r.trigger("reset"), r.online() ? r.transport.read({
                        data: i,
                        success: function(e) {
                            r._ranges = [], r.success(e, i), n.resolve()
                        },
                        error: function() {
                            var e = Ye.call(arguments);
                            r.error.apply(r, e), n.reject.apply(n, e)
                        }
                    }) : null != r.options.offlineStorage && (r.success(r.offlineData(), i), n.resolve()))
                }), n.promise()
            },
            _readAggregates: function(e) {
                return this.reader.aggregates(e)
            },
            success: function(e) {
                var r, i, n, a, s, o, u, l, h, d, f, c = this,
                    g = c.options;
                if (c.trigger(Ee, {
                        response: e,
                        type: "read"
                    }), c.online()) {
                    if (e = c.reader.parse(e), c._handleCustomErrors(e)) return c._dequeueRequest(), t;
                    c._total = c.reader.total(e), c._pageSize > c._total && (c._pageSize = c._total, c.options.pageSize && c.options.pageSize > c._pageSize && (c._pageSize = c.options.pageSize)), c._aggregate && g.serverAggregates && (c._aggregateResult = c._readAggregates(e)), e = c._readData(e), c._destroyed = []
                } else {
                    for (e = c._readData(e), r = [], n = {}, a = c.reader.model, s = a ? a.idField : "id", o = 0; o < this._destroyed.length; o++) u = this._destroyed[o][s], n[u] = u;
                    for (o = 0; o < e.length; o++) l = e[o], h = l.__state__, "destroy" == h ? n[l[s]] || this._destroyed.push(this._createNewModel(l)) : r.push(l);
                    e = r, c._total = e.length
                }
                if (c._pristineTotal = c._total, i = c._skip && c._data.length && c._skip < c._data.length, c.options.endless)
                    for (i && c._pristineData.splice(c._skip, c._pristineData.length), r = e.slice(0), d = 0; d < r.length; d++) c._pristineData.push(r[d]);
                else c._pristineData = e.slice(0);
                if (c._detachObservableParents(), c.options.endless) {
                    for (c._data.unbind(Ie, c._changeHandler), c._isServerGrouped() && c._data[c._data.length - 1].value === e[0].value && (D(c._data[c._data.length - 1], e[0]), e.shift()), e = c._observe(e), i && c._data.splice(c._skip, c._data.length), f = 0; f < e.length; f++) c._data.push(e[f]);
                    c._data.bind(Ie, c._changeHandler)
                } else c._data = c._observe(e);
                c._markOfflineUpdatesAsDirty(), c._storeData(), c._addRange(c._data), c._process(c._data), c._dequeueRequest()
            },
            _detachObservableParents: function() {
                if (this._data && this._shouldDetachObservableParents)
                    for (var e = 0; e < this._data.length; e++) this._data[e].parent && (this._data[e].parent = ke)
            },
            _storeData: function(e) {
                function t(e) {
                    var r, i, n, a = [];
                    for (r = 0; r < e.length; r++) i = e.at(r), n = i.toJSON(), s && i.items ? n.items = t(i.items) : (n.uid = i.uid, o && (i.isNew() ? n.__state__ = "create" : i.dirty && (n.__state__ = "update"))), a.push(n);
                    return a
                }
                var r, i, n, a, s = this._isServerGrouped(),
                    o = this.reader.model;
                if (null != this.options.offlineStorage) {
                    for (r = t(this._data), i = [], n = 0; n < this._destroyed.length; n++) a = this._destroyed[n].toJSON(), a.__state__ = "destroy", i.push(a);
                    this.offlineData(r.concat(i)), e && (this._pristineData = this.reader.reader ? this.reader.reader._wrapDataAccessBase(r) : this.reader._wrapDataAccessBase(r))
                }
            },
            _addRange: function(e, r) {
                var i = this,
                    n = t !== r ? r : i._skip || 0,
                    a = n + i._flatData(e, !0).length;
                i._ranges.push({
                    start: n,
                    end: a,
                    data: e,
                    pristineData: e.toJSON(),
                    timestamp: i._timeStamp()
                }), i._sortRanges()
            },
            _sortRanges: function() {
                this._ranges.sort(function(e, t) {
                    return e.start - t.start
                })
            },
            error: function(e, t, r) {
                this._dequeueRequest(), this.trigger(Ee, {}), this.trigger(Ge, {
                    xhr: e,
                    status: t,
                    errorThrown: r
                })
            },
            _params: function(e) {
                var t = this,
                    r = pe({
                        take: t.take(),
                        skip: t.skip(),
                        page: t.page(),
                        pageSize: t.pageSize(),
                        sort: t._sort,
                        filter: t._filter,
                        group: t._group,
                        aggregate: t._aggregate
                    }, e);
                return t.options.serverPaging || (delete r.take, delete r.skip, delete r.page, delete r.pageSize), t.options.serverGrouping ? t.reader.model && r.group && (r.group = H(r.group, t.reader.model)) : delete r.group, t.options.serverFiltering ? t.reader.model && r.filter && (r.filter = B(r.filter, t.reader.model)) : delete r.filter, t.options.serverSorting ? t.reader.model && r.sort && (r.sort = H(r.sort, t.reader.model)) : delete r.sort, t.options.serverAggregates ? t.reader.model && r.aggregate && (r.aggregate = H(r.aggregate, t.reader.model)) : delete r.aggregate, r
            },
            _queueRequest: function(e, r) {
                var i = this;
                i._requestInProgress ? i._pending = {
                    callback: _e(r, i),
                    options: e
                } : (i._requestInProgress = !0, i._pending = t, r())
            },
            _dequeueRequest: function() {
                var e = this;
                e._requestInProgress = !1, e._pending && e._queueRequest(e._pending.options, e._pending.callback)
            },
            _handleCustomErrors: function(e) {
                if (this.reader.errors) {
                    var t = this.reader.errors(e);
                    if (t) return this.trigger(Ge, {
                        xhr: null,
                        status: "customerror",
                        errorThrown: "custom error",
                        errors: t
                    }), !0
                }
                return !1
            },
            _shouldWrap: function(e) {
                var t = this.reader.model;
                return !(!t || !e.length) && !(e[0] instanceof t)
            },
            _observe: function(e) {
                var t, r = this,
                    i = r.reader.model;
                return r._shouldDetachObservableParents = !0, e instanceof it ? (r._shouldDetachObservableParents = !1, r._shouldWrap(e) && (e.type = r.reader.model, e.wrapAll(e, e))) : (t = r.pageSize() && !r.options.serverPaging ? $ : it, e = new t(e, r.reader.model), e.parent = function() {
                    return r.parent()
                }), r._isServerGrouped() && P(e, i), !(r._changeHandler && r._data && r._data instanceof it) || r.options.useRanges && r.options.serverPaging ? r._changeHandler = _e(r._change, r) : r._data.unbind(Ie, r._changeHandler), e.bind(Ie, r._changeHandler)
            },
            _updateTotalForAction: function(e, t) {
                var r = this,
                    i = parseInt(r._total, 10);
                S(r._total) || (i = parseInt(r._pristineTotal, 10)), "add" === e ? i += t.length : "remove" === e ? i -= t.length : "itemchange" === e || "sync" === e || r.options.serverPaging ? "sync" === e && (i = r._pristineTotal = parseInt(r._total, 10)) : i = r._pristineTotal, r._total = i
            },
            _change: function(e) {
                var t, r, i, n = this,
                    a = e ? e.action : "";
                if ("remove" === a)
                    for (t = 0, r = e.items.length; t < r; t++) e.items[t].isNew && e.items[t].isNew() || n._destroyed.push(e.items[t]);
                !n.options.autoSync || "add" !== a && "remove" !== a && "itemchange" !== a ? (n._updateTotalForAction(a, e ? e.items : []), n._process(n._data, e)) : (i = function(t) {
                    "sync" === t.action && (n.unbind("change", i), n._updateTotalForAction(a, e.items))
                }, n.first("change", i), n.sync())
            },
            _calculateAggregates: function(e, t) {
                t = t || {};
                var r = new a(e),
                    i = t.aggregate,
                    n = t.filter;
                return n && (r = r.filter(n)), r.aggregate(i)
            },
            _process: function(e, r) {
                var i, n = this,
                    a = {};
                n.options.serverPaging !== !0 && (a.skip = n._skip, a.take = n._take || n._pageSize, a.skip === t && n._page !== t && n._pageSize !== t && (a.skip = (n._page - 1) * n._pageSize), n.options.useRanges && (a.skip = n.currentRangeStart())), n.options.serverSorting !== !0 && (a.sort = n._sort), n.options.serverFiltering !== !0 && (a.filter = n._filter), n.options.serverGrouping !== !0 && (a.group = n._group), n.options.serverAggregates !== !0 && (a.aggregate = n._aggregate), n.options.serverGrouping && n._clearEmptyGroups(e), i = n._queryProcess(e, a), n.options.serverAggregates !== !0 && (n._aggregateResult = n._calculateAggregates(i.dataToAggregate || e, a)), n.view(i.data), n._setFilterTotal(i.total, !1), r = r || {}, r.items = r.items || n._view, n.trigger(Ie, r)
            },
            _clearEmptyGroups: function(e) {
                var t, r;
                for (t = e.length - 1; t >= 0; t--) r = e[t], r.hasSubgroups ? this._clearEmptyGroups(r.items) : r.items && !r.items.length && Ke.apply(r.parent(), [t, 1])
            },
            _queryProcess: function(e, t) {
                return this.options.inPlaceSort ? a.process(e, t, this.options.inPlaceSort) : a.process(e, t)
            },
            _mergeState: function(r) {
                var i = this;
                return r !== t && (i._pageSize = r.pageSize, i._page = r.page, i._sort = r.sort, i._filter = r.filter, i._group = r.group, i._aggregate = r.aggregate, i._skip = i._currentRangeStart = r.skip, i._take = r.take, i._skip === t && (i._skip = i._currentRangeStart = i.skip(), r.skip = i.skip()), i._take === t && i._pageSize !== t && (i._take = i._pageSize, r.take = i._take), r.sort && (i._sort = r.sort = s(r.sort), i._sortFields = o(r.sort)), r.filter && (i._filter = r.filter = i.options.accentFoldingFiltering && !e.isEmptyObject(r.filter) ? e.extend({}, l(r.filter), {
                    accentFoldingFiltering: i.options.accentFoldingFiltering
                }) : l(r.filter)), r.group && (i._group = r.group = p(r.group)), r.aggregate && (i._aggregate = r.aggregate = g(r.aggregate))), r
            },
            query: function(r) {
                var i, n, a, s = this.options.serverSorting || this.options.serverPaging || this.options.serverFiltering || this.options.serverGrouping || this.options.serverAggregates;
                return s || (this._data === t || 0 === this._data.length) && !this._destroyed.length ? (this.options.endless && (n = r.pageSize - this.pageSize(), n > 0 ? (n = this.pageSize(), r.page = r.pageSize / n, r.pageSize = n) : (r.page = 1, this.options.endless = !1)), this.read(this._mergeState(r))) : (a = this.trigger(Le, {
                    type: "read"
                }), a || (this.trigger(je), i = this._queryProcess(this._data, this._mergeState(r)), this._setFilterTotal(i.total, !0), this._aggregateResult = this._calculateAggregates(i.dataToAggregate || this._data, r), this.view(i.data), this.trigger(Ee, {
                    type: "read"
                }), this.trigger(Ie, {
                    items: i.data
                })), e.Deferred().resolve(a).promise())
            },
            _setFilterTotal: function(e, r) {
                var i = this;
                i.options.serverFiltering || (e !== t ? i._total = e : r && (i._total = i._data.length))
            },
            fetch: function(e) {
                var t = this,
                    r = function(r) {
                        r !== !0 && xe(e) && e.call(t)
                    };
                return this._query().done(r)
            },
            _query: function(e) {
                var t = this;
                return t.query(pe({}, {
                    page: t.page(),
                    pageSize: t.pageSize(),
                    sort: t.sort(),
                    filter: t.filter(),
                    group: t.group(),
                    aggregate: t.aggregate()
                }, e))
            },
            next: function(e) {
                var t = this,
                    r = t.page(),
                    i = t.total();
                if (e = e || {}, r && !(i && r + 1 > t.totalPages())) return t._skip = t._currentRangeStart = r * t.take(), r += 1, e.page = r, t._query(e), r
            },
            prev: function(e) {
                var t = this,
                    r = t.page();
                if (e = e || {}, r && 1 !== r) return t._skip = t._currentRangeStart = t._skip - t.take(), r -= 1, e.page = r, t._query(e), r
            },
            page: function(e) {
                var r, i = this;
                return e !== t ? (e = Ve.max(Ve.min(Ve.max(e, 1), i.totalPages()), 1), i._query(i._pageableQueryOptions({
                    page: e
                })), t) : (r = i.skip(), r !== t ? Ve.round((r || 0) / (i.take() || 1)) + 1 : t)
            },
            pageSize: function(e) {
                var r = this;
                return e !== t ? (r._query(r._pageableQueryOptions({
                    pageSize: e,
                    page: 1
                })), t) : r.take()
            },
            sort: function(e) {
                var r = this;
                return e !== t ? (r.trigger("sort"), r._query({
                    sort: e
                }), t) : r._sort
            },
            filter: function(e) {
                var r = this;
                return e === t ? r._filter : (r.trigger("reset"), r._query({
                    filter: e,
                    page: 1
                }), t)
            },
            group: function(e) {
                var r = this;
                return e !== t ? (r._query({
                    group: e
                }), t) : r._group
            },
            total: function() {
                return parseInt(this._total || 0, 10)
            },
            aggregate: function(e) {
                var r = this;
                return e !== t ? (r._query({
                    aggregate: e
                }), t) : r._aggregate
            },
            aggregates: function() {
                var e = this._aggregateResult;
                return me(e) && (e = this._emptyAggregates(this.aggregate())), e
            },
            _emptyAggregates: function(e) {
                var t, r, i = {};
                if (!me(e))
                    for (t = {}, ye(e) || (e = [e]), r = 0; r < e.length; r++) t[e[r].aggregate] = 0, i[e[r].field] = t;
                return i
            },
            _pageableQueryOptions: function(e) {
                return e
            },
            _wrapInEmptyGroup: function(e) {
                var t, r, i, n, a = this.group();
                for (i = a.length - 1, n = 0; i >= n; i--) r = a[i], t = {
                    value: e.get ? e.get(r.field) : e[r.field],
                    field: r.field,
                    items: t ? [t] : [e],
                    hasSubgroups: !!t,
                    aggregates: this._emptyAggregates(r.aggregates)
                };
                return t
            },
            totalPages: function() {
                var e = this,
                    t = e.pageSize() || e.total();
                return Ve.ceil((e.total() || 0) / t)
            },
            inRange: function(e, t) {
                var r = this,
                    i = Ve.min(e + t, r.total());
                return !r.options.serverPaging && r._data.length > 0 || r._findRange(e, i).length > 0
            },
            lastRange: function() {
                var e = this._ranges;
                return e[e.length - 1] || {
                    start: 0,
                    end: 0,
                    data: []
                }
            },
            firstItemUid: function() {
                var e = this._ranges;
                return e.length && e[0].data.length && e[0].data[0].uid
            },
            enableRequestsInProgress: function() {
                this._skipRequestsInProgress = !1
            },
            _timeStamp: function() {
                return (new Date).getTime()
            },
            range: function(e, r, i) {
                this._currentRequestTimeStamp = this._timeStamp(), this._skipRequestsInProgress = !0, e = Ve.min(e || 0, this.total()), i = xe(i) ? i : ke;
                var n, a = this,
                    s = Ve.max(Ve.floor(e / r), 0) * r,
                    o = Ve.min(s + r, a.total());
                return n = a._findRange(e, Ve.min(e + r, a.total())), n.length || 0 === a.total() ? (a._processRangeData(n, e, r, s, o), i(), t) : (r !== t && (a._rangeExists(s, o) ? s < e && a.prefetch(o, r, function() {
                    a.range(e, r, i)
                }) : a.prefetch(s, r, function() {
                    e > s && o < a.total() && !a._rangeExists(o, Ve.min(o + r, a.total())) ? a.prefetch(o, r, function() {
                        a.range(e, r, i)
                    }) : a.range(e, r, i)
                })), t)
            },
            _findRange: function(e, r) {
                var i, n, a, o, u, l, h, d, f, c, g, p, v = this,
                    m = v._ranges,
                    y = [],
                    S = v.options,
                    b = S.serverSorting || S.serverPaging || S.serverFiltering || S.serverGrouping || S.serverAggregates;
                for (n = 0, g = m.length; n < g; n++)
                    if (i = m[n], e >= i.start && e <= i.end) {
                        for (c = 0, a = n; a < g; a++)
                            if (i = m[a], f = v._flatData(i.data, !0), f.length && e + c >= i.start && (l = i.data, h = i.end, b || (S.inPlaceSort ? d = v._queryProcess(i.data, {
                                    filter: v.filter()
                                }) : (p = _(v.group() || []).concat(s(v.sort() || [])), d = v._queryProcess(i.data, {
                                    sort: p,
                                    filter: v.filter()
                                })), f = l = d.data, d.total !== t && (h = d.total)), o = 0, e + c > i.start && (o = e + c - i.start), u = f.length, h > r && (u -= h - r), c += u - o, y = v._mergeGroups(y, l, o, u), r <= i.end && c == r - e)) return y;
                        break
                    }
                return []
            },
            _mergeGroups: function(e, t, r, i) {
                if (this._isServerGrouped()) {
                    var n, a = t.toJSON();
                    return e.length && (n = e[e.length - 1]), z(n, a, r, i), e.concat(a)
                }
                return e.concat(t.slice(r, i))
            },
            _processRangeData: function(e, r, i, n, a) {
                var s, o, u, l, h = this;
                h._pending = t, h._skip = r > h.skip() ? Ve.min(a, (h.totalPages() - 1) * h.take()) : n, h._currentRangeStart = r, h._take = i, s = h.options.serverPaging, o = h.options.serverSorting, u = h.options.serverFiltering, l = h.options.serverAggregates;
                try {
                    h.options.serverPaging = !0, h._isServerGrouped() || h.group() && h.group().length || (h.options.serverSorting = !0), h.options.serverFiltering = !0, h.options.serverPaging = !0, h.options.serverAggregates = !0, s && (h._detachObservableParents(), h._data = e = h._observe(e)), h._process(e)
                } finally {
                    h.options.serverPaging = s, h.options.serverSorting = o, h.options.serverFiltering = u, h.options.serverAggregates = l
                }
            },
            skip: function() {
                var e = this;
                return e._skip === t ? e._page !== t ? (e._page - 1) * (e.take() || 1) : t : e._skip
            },
            currentRangeStart: function() {
                return this._currentRangeStart || 0
            },
            take: function() {
                return this._take || this._pageSize
            },
            _prefetchSuccessHandler: function(e, t, r, i) {
                var n = this,
                    a = n._timeStamp();
                return function(s) {
                    var o, u, l, h = !1,
                        d = {
                            start: e,
                            end: t,
                            data: [],
                            timestamp: n._timeStamp()
                        };
                    if (n._dequeueRequest(), n.trigger(Ee, {
                            response: s,
                            type: "read"
                        }), s = n.reader.parse(s), l = n._readData(s), l.length) {
                        for (o = 0, u = n._ranges.length; o < u; o++)
                            if (n._ranges[o].start === e) {
                                h = !0, d = n._ranges[o], d.pristineData = l, d.data = n._observe(l), d.end = d.start + n._flatData(d.data, !0).length, n._sortRanges();
                                break
                            }
                        h || n._addRange(n._observe(l), e)
                    }
                    n._total = n.reader.total(s), (i || a >= n._currentRequestTimeStamp || !n._skipRequestsInProgress) && (r && l.length ? r() : n.trigger(Ie, {}))
                }
            },
            prefetch: function(e, t, r) {
                var i = this,
                    n = Ve.min(e + t, i.total()),
                    a = {
                        take: t,
                        skip: e,
                        page: e / t + 1,
                        pageSize: t,
                        sort: i._sort,
                        filter: i._filter,
                        group: i._group,
                        aggregate: i._aggregate
                    };
                i._rangeExists(e, n) ? r && r() : (clearTimeout(i._timeout), i._timeout = setTimeout(function() {
                    i._queueRequest(a, function() {
                        i.trigger(Le, {
                            type: "read"
                        }) ? i._dequeueRequest() : i.transport.read({
                            data: i._params(a),
                            success: i._prefetchSuccessHandler(e, n, r),
                            error: function() {
                                var e = Ye.call(arguments);
                                i.error.apply(i, e)
                            }
                        })
                    })
                }, 100))
            },
            _multiplePrefetch: function(e, t, r) {
                var i = this,
                    n = Ve.min(e + t, i.total()),
                    a = {
                        take: t,
                        skip: e,
                        page: e / t + 1,
                        pageSize: t,
                        sort: i._sort,
                        filter: i._filter,
                        group: i._group,
                        aggregate: i._aggregate
                    };
                i._rangeExists(e, n) ? r && r() : i.trigger(Le, {
                    type: "read"
                }) || i.transport.read({
                    data: i._params(a),
                    success: i._prefetchSuccessHandler(e, n, r, !0)
                })
            },
            _rangeExists: function(e, t) {
                var r, i, n = this,
                    a = n._ranges;
                for (r = 0, i = a.length; r < i; r++)
                    if (a[r].start <= e && a[r].end >= t) return !0;
                return !1
            },
            _getCurrentRangeSpan: function() {
                var e, t, r = this,
                    i = r._ranges,
                    n = r.currentRangeStart(),
                    a = n + (r.take() || 0),
                    s = [],
                    o = i.length;
                for (t = 0; t < o; t++) e = i[t], (e.start <= n && e.end >= n || e.start >= n && e.start <= a) && s.push(e);
                return s
            },
            _removeModelFromRanges: function(e) {
                var t, r, i, n = this;
                for (r = 0, i = this._ranges.length; r < i; r++) t = this._ranges[r], n._removeModelFromRange(t, e);
                n._updateRangesLength()
            },
            _removeModelFromRange: function(e, t) {
                this._eachItem(e.data, function(e) {
                    var r, i;
                    for (r = 0; r < e.length; r++)
                        if (i = e[r], i.uid && i.uid == t.uid) {
                            [].splice.call(e, r, 1);
                            break
                        }
                })
            },
            _insertModelInRange: function(e, t) {
                var r, i, n = this,
                    a = n._ranges || [],
                    s = a.length;
                for (i = 0; i < s; i++)
                    if (r = a[i], r.start <= e && r.end >= e) {
                        n._getByUid(t.uid, r.data) || (n._isServerGrouped() ? r.data.splice(e, 0, n._wrapInEmptyGroup(t)) : r.data.splice(e, 0, t));
                        break
                    }
                n._updateRangesLength()
            },
            _updateRangesLength: function() {
                var e, t, r = this,
                    i = r._ranges || [],
                    n = i.length,
                    a = !1,
                    s = 0,
                    o = 0;
                for (t = 0; t < n; t++) e = i[t], o = r._flatData(e.data, !0).length - Ve.abs(e.end - e.start), a || 0 === o ? a && (e.start += s, e.end += s) : (a = !0, s = o, e.end += s)
            }
        }), he = {}, he.create = function(t, r, i) {
            var n, a = t.transport ? e.extend({}, t.transport) : null;
            return a ? (a.read = typeof a.read === De ? {
                url: a.read
            } : a.read, "jsdo" === t.type && (a.dataSource = i), t.type && (Fe.data.transports = Fe.data.transports || {}, Fe.data.schemas = Fe.data.schemas || {}, Fe.data.transports[t.type] ? ve(Fe.data.transports[t.type]) ? a = pe(!0, {}, Fe.data.transports[t.type], a) : n = new Fe.data.transports[t.type](pe(a, {
                data: r
            })) : Fe.logToConsole("Unknown DataSource transport type '" + t.type + "'.\nVerify that registration scripts for this type are included after Kendo UI on the page.", "warn"), t.schema = pe(!0, {}, Fe.data.schemas[t.type], t.schema)), n || (n = xe(a.read) ? a : new se(a))) : n = new ae({
                data: t.data || []
            }), n
        }, le.create = function(e) {
            (ye(e) || e instanceof it) && (e = {
                data: e
            });
            var r, i, n, a = e || {},
                s = a.data,
                o = a.fields,
                u = a.table,
                l = a.select,
                h = {};
            if (s || !o || a.transport || (u ? s = J(u, o) : l && (s = U(l, o), a.group === t && s[0] && s[0].optgroup !== t && (a.group = "optgroup"))), Fe.data.Model && o && (!a.schema || !a.schema.model)) {
                for (r = 0, i = o.length; r < i; r++) n = o[r], n.type && (h[n.field] = n);
                me(h) || (a.schema = pe(!0, a.schema, {
                    model: {
                        fields: h
                    }
                }))
            }
            return a.data = s, l = null, a.select = null, u = null, a.table = null, a instanceof le ? a : new le(a)
        }, de = Z.define({
            idField: "id",
            init: function(e) {
                var t, r = this,
                    i = r.hasChildren || e && e.hasChildren,
                    n = "items",
                    a = {};
                Fe.data.Model.fn.init.call(r, e), typeof r.children === De && (n = r.children), a = {
                    schema: {
                        data: n,
                        model: {
                            hasChildren: i,
                            id: r.idField,
                            fields: r.fields
                        }
                    }
                }, typeof r.children !== De && pe(a, r.children), a.data = e, i || (i = a.schema.data), typeof i === De && (i = Fe.getter(i)), xe(i) && (t = i.call(r, r), r.hasChildren = (!t || 0 !== t.length) && !!t), r._childrenOptions = a, r.hasChildren && r._initChildren(), r._loaded = !(!e || !e._loaded)
            },
            _initChildren: function() {
                var e, t, r, i = this;
                i.children instanceof fe || (e = i.children = new fe(i._childrenOptions), t = e.transport, r = t.parameterMap, t.parameterMap = function(e, t) {
                    return e[i.idField || "id"] = i.id, r && (e = r(e, t)), e
                }, e.parent = function() {
                    return i
                }, e.bind(Ie, function(e) {
                    e.node = e.node || i, i.trigger(Ie, e)
                }), e.bind(Ge, function(e) {
                    var t = i.parent();
                    t && (e.node = e.node || i, t.trigger(Ge, e))
                }), i._updateChildrenField())
            },
            append: function(e) {
                this._initChildren(), this.loaded(!0), this.children.add(e)
            },
            hasChildren: !1,
            level: function() {
                for (var e = this.parentNode(), t = 0; e && e.parentNode;) t++, e = e.parentNode ? e.parentNode() : null;
                return t
            },
            _updateChildrenField: function() {
                var e = this._childrenOptions.schema.data;
                this[e || "items"] = this.children.data()
            },
            _childrenLoaded: function() {
                this._loaded = !0, this._updateChildrenField()
            },
            load: function() {
                var r, i, n = {},
                    a = "_query";
                return this.hasChildren ? (this._initChildren(), r = this.children, n[this.idField || "id"] = this.id, this._loaded || (r._data = t, a = "read"), r.one(Ie, _e(this._childrenLoaded, this)), this._matchFilter && (n.filter = {
                    field: "_matchFilter",
                    operator: "eq",
                    value: !0
                }), i = r[a](n)) : this.loaded(!0), i || e.Deferred().resolve().promise()
            },
            parentNode: function() {
                var e = this.parent();
                return e.parent()
            },
            loaded: function(e) {
                return e === t ? this._loaded : (this._loaded = e, t)
            },
            shouldSerialize: function(e) {
                return Z.fn.shouldSerialize.call(this, e) && "children" !== e && "_loaded" !== e && "hasChildren" !== e && "_childrenOptions" !== e
            }
        }), fe = le.extend({
            init: function(e) {
                var t = de.define({
                    children: e
                });
                e.filter && !e.serverFiltering && (this._hierarchicalFilter = e.filter, e.filter = null), le.fn.init.call(this, pe(!0, {}, {
                    schema: {
                        modelBase: t,
                        model: t
                    }
                }, e)), this._attachBubbleHandlers()
            },
            _attachBubbleHandlers: function() {
                var e = this;
                e._data.bind(Ge, function(t) {
                    e.trigger(Ge, t)
                })
            },
            read: function(e) {
                var t = le.fn.read.call(this, e);
                return this._hierarchicalFilter && (this._data && this._data.length > 0 ? this.filter(this._hierarchicalFilter) : (this.options.filter = this._hierarchicalFilter, this._filter = l(this.options.filter), this._hierarchicalFilter = null)), t
            },
            remove: function(e) {
                var t, r = e.parentNode(),
                    i = this;
                return r && r._initChildren && (i = r.children), t = le.fn.remove.call(i, e), r && !i.data().length && (r.hasChildren = !1), t
            },
            success: V("success"),
            data: V("data"),
            insert: function(e, t) {
                var r = this.parent();
                return r && r._initChildren && (r.hasChildren = !0, r._initChildren()), le.fn.insert.call(this, e, t)
            },
            filter: function(e) {
                return e === t ? this._filter : (!this.options.serverFiltering && this._markHierarchicalQuery(e) && (e = {
                    logic: "or",
                    filters: [e, {
                        field: "_matchFilter",
                        operator: "equals",
                        value: !0
                    }]
                }), this.trigger("reset"), this._query({
                    filter: e,
                    page: 1
                }), t)
            },
            _markHierarchicalQuery: function(t) {
                var r, i, n, s, o, u = this.options.accentFoldingFiltering;
                return t = u ? e.extend({}, l(t), {
                    accentFoldingFiltering: u
                }) : l(t), t && 0 !== t.filters.length ? (r = a.filterExpr(t), n = r.fields, s = r.operators, i = o = Function("d, __f, __o", "return " + r.expression), (n.length || s.length) && (o = function(e) {
                    return i(e, n, s)
                }), this._updateHierarchicalFilter(o), !0) : (this._updateHierarchicalFilter(function() {
                    return !0
                }), !1)
            },
            _updateHierarchicalFilter: function(e) {
                var t, r, i = this._data,
                    n = !1;
                for (r = 0; r < i.length; r++) t = i[r], t.hasChildren ? (t._matchFilter = t.children._updateHierarchicalFilter(e), t._matchFilter || (t._matchFilter = e(t))) : t._matchFilter = e(t), t._matchFilter && (n = !0);
                return n
            },
            _find: function(e, t) {
                var r, i, n, a, s = this._data;
                if (s) {
                    if (n = le.fn[e].call(this, t)) return n;
                    for (s = this._flatData(this._data), r = 0, i = s.length; r < i; r++)
                        if (a = s[r].children, a instanceof fe && (n = a[e](t))) return n
                }
            },
            get: function(e) {
                return this._find("get", e)
            },
            getByUid: function(e) {
                return this._find("getByUid", e)
            }
        }), fe.create = function(e) {
            e = e && e.push ? {
                data: e
            } : e;
            var t = e || {},
                r = t.data,
                i = t.fields,
                n = t.list;
            return r && r._dataSource ? r._dataSource : (r || !i || t.transport || n && (r = Q(n, i)), t.data = r, t instanceof fe ? t : new fe(t))
        }, ce = Fe.Observable.extend({
            init: function(e, t, r) {
                Fe.Observable.fn.init.call(this), this._prefetching = !1, this.dataSource = e, this.prefetch = !r;
                var i = this;
                e.bind("change", function() {
                    i._change()
                }), e.bind("reset", function() {
                    i._reset()
                }), this._syncWithDataSource(), this.setViewSize(t)
            },
            setViewSize: function(e) {
                this.viewSize = e, this._recalculate()
            },
            at: function(e) {
                var r = this.pageSize,
                    i = !0;
                return e >= this.total() ? (this.trigger("endreached", {
                    index: e
                }), null) : this.useRanges ? this.useRanges ? ((e < this.dataOffset || e >= this.skip + r) && (i = this.range(Math.floor(e / r) * r)), e === this.prefetchThreshold && this._prefetch(), e === this.midPageThreshold ? this.range(this.nextMidRange, !0) : e === this.nextPageThreshold ? this.range(this.nextFullRange) : e === this.pullBackThreshold && this.range(this.offset === this.skip ? this.previousMidRange : this.previousFullRange), i ? this.dataSource.at(e - this.dataOffset) : (this.trigger("endreached", {
                    index: e
                }), null)) : t : this.dataSource.view()[e]
            },
            indexOf: function(e) {
                return this.dataSource.data().indexOf(e) + this.dataOffset
            },
            total: function() {
                return parseInt(this.dataSource.total(), 10)
            },
            next: function() {
                var e = this,
                    t = e.pageSize,
                    r = e.skip - e.viewSize + t,
                    i = Ve.max(Ve.floor(r / t), 0) * t;
                this.offset = r, this.dataSource.prefetch(i, t, function() {
                    e._goToRange(r, !0)
                })
            },
            range: function(e, t) {
                if (this.offset === e) return !0;
                var r = this,
                    i = this.pageSize,
                    n = Ve.max(Ve.floor(e / i), 0) * i,
                    a = this.dataSource;
                return t && (n += i), a.inRange(e, i) ? (this.offset = e, this._recalculate(), this._goToRange(e), !0) : !this.prefetch || (a.prefetch(n, i, function() {
                    r.offset = e, r._recalculate(), r._goToRange(e, !0)
                }), !1)
            },
            syncDataSource: function() {
                var e = this.offset;
                this.offset = null, this.range(e)
            },
            destroy: function() {
                this.unbind()
            },
            _prefetch: function() {
                var e = this,
                    t = this.pageSize,
                    r = this.skip + t,
                    i = this.dataSource;
                i.inRange(r, t) || this._prefetching || !this.prefetch || (this._prefetching = !0, this.trigger("prefetching", {
                    skip: r,
                    take: t
                }), i.prefetch(r, t, function() {
                    e._prefetching = !1, e.trigger("prefetched", {
                        skip: r,
                        take: t
                    })
                }))
            },
            _goToRange: function(e, t) {
                this.offset === e && (this.dataOffset = e, this._expanding = t, this.dataSource.range(e, this.pageSize), this.dataSource.enableRequestsInProgress())
            },
            _reset: function() {
                this._syncPending = !0
            },
            _change: function() {
                var e = this.dataSource;
                this.length = this.useRanges ? e.lastRange().end : e.view().length, this._syncPending && (this._syncWithDataSource(), this._recalculate(), this._syncPending = !1, this.trigger("reset", {
                    offset: this.offset
                })), this.trigger("resize"), this._expanding && this.trigger("expand"), delete this._expanding
            },
            _syncWithDataSource: function() {
                var e = this.dataSource;
                this._firstItemUid = e.firstItemUid(), this.dataOffset = this.offset = e.skip() || 0, this.pageSize = e.pageSize(), this.useRanges = e.options.serverPaging
            },
            _recalculate: function() {
                var e = this.pageSize,
                    t = this.offset,
                    r = this.viewSize,
                    i = Math.ceil(t / e) * e;
                this.skip = i, this.midPageThreshold = i + e - 1, this.nextPageThreshold = i + r - 1, this.prefetchThreshold = i + Math.floor(e / 3 * 2), this.pullBackThreshold = this.offset - 1, this.nextMidRange = i + e - r, this.nextFullRange = i, this.previousMidRange = t - r, this.previousFullRange = i - e
            }
        }), ge = Fe.Observable.extend({
            init: function(e, t) {
                var r = this;
                Fe.Observable.fn.init.call(r), this.dataSource = e, this.batchSize = t, this._total = 0, this.buffer = new ce(e, 3 * t), this.buffer.bind({
                    endreached: function(e) {
                        r.trigger("endreached", {
                            index: e.index
                        })
                    },
                    prefetching: function(e) {
                        r.trigger("prefetching", {
                            skip: e.skip,
                            take: e.take
                        })
                    },
                    prefetched: function(e) {
                        r.trigger("prefetched", {
                            skip: e.skip,
                            take: e.take
                        })
                    },
                    reset: function() {
                        r._total = 0, r.trigger("reset")
                    },
                    resize: function() {
                        r._total = Math.ceil(this.length / r.batchSize), r.trigger("resize", {
                            total: r.total(),
                            offset: this.offset
                        })
                    }
                })
            },
            syncDataSource: function() {
                this.buffer.syncDataSource()
            },
            at: function(e) {
                var t, r, i = this.buffer,
                    n = e * this.batchSize,
                    a = this.batchSize,
                    s = [];
                for (i.offset > n && i.at(i.offset - 1), r = 0; r < a && (t = i.at(n + r), null !== t); r++) s.push(t);
                return s
            },
            total: function() {
                return this._total
            },
            destroy: function() {
                this.buffer.destroy(), this.unbind()
            }
        }), pe(!0, Fe.data, {
            readers: {
                json: ue
            },
            Query: a,
            DataSource: le,
            HierarchicalDataSource: fe,
            Node: de,
            ObservableObject: K,
            ObservableArray: it,
            LazyObservableArray: $,
            LocalTransport: ae,
            RemoteTransport: se,
            Cache: oe,
            DataReader: ue,
            Model: Z,
            Buffer: ce,
            BatchBuffer: ge
        })
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, r) {
    (r || t)()
});;
! function(e, define) {
    define("kendo.binder.min", ["kendo.core.min", "kendo.data.min"], e)
}(function() {
    return function(e, t) {
        function i(t, i, n) {
            return p.extend({
                init: function(e, t, i) {
                    var n = this;
                    p.fn.init.call(n, e.element[0], t, i), n.widget = e, n._dataBinding = M(n.dataBinding, n), n._dataBound = M(n.dataBound, n), n._itemChange = M(n.itemChange, n)
                },
                itemChange: function(e) {
                    r(e.item[0], e.data, this._ns(e.ns), [e.data].concat(this.bindings[t]._parents()))
                },
                dataBinding: function(e) {
                    var t, i, n = this.widget,
                        s = e.removedItems || n.items();
                    for (t = 0, i = s.length; t < i; t++) h(s[t], !1)
                },
                _ns: function(t) {
                    t = t || C.ui;
                    var i = [C.ui, C.dataviz.ui, C.mobile.ui];
                    return i.splice(e.inArray(t, i), 1), i.unshift(t), C.rolesFromNamespaces(i)
                },
                dataBound: function(e) {
                    var n, s, a, d, o = this.widget,
                        h = e.addedItems || o.items(),
                        l = o[i],
                        c = C.data.HierarchicalDataSource;
                    if (!(c && l instanceof c) && h.length)
                        for (a = e.addedDataItems || l.flatView(), d = this.bindings[t]._parents(), n = 0, s = a.length; n < s; n++) h[n] && r(h[n], a[n], this._ns(e.ns), [a[n]].concat(d))
                },
                refresh: function(e) {
                    var s, a, r, d, o = this,
                        h = o.widget;
                    e = e || {}, e.action || (o.destroy(), h.bind("dataBinding", o._dataBinding), h.bind("dataBound", o._dataBound), h.bind("itemChange", o._itemChange), s = o.bindings[t].get(), h[i] instanceof C.data.DataSource && h[i] != s && (s instanceof C.data.DataSource ? h[n](s) : s && s._dataSource ? h[n](s._dataSource) : (a = C.ui.Select && h instanceof C.ui.Select, r = C.ui.MultiSelect && h instanceof C.ui.MultiSelect, d = C.ui.DropDownTree && h instanceof C.ui.DropDownTree, d ? h.treeview[i].data(s) : h[i].data(s), o.bindings.value && (a || r) && h.value(u(o.bindings.value.get(), h.options.dataValueField)))))
                },
                destroy: function() {
                    var e = this.widget;
                    e.unbind("dataBinding", this._dataBinding), e.unbind("dataBound", this._dataBound), e.unbind("itemChange", this._itemChange)
                }
            })
        }

        function n(e, t) {
            var i = C.initWidget(e, {}, t);
            if (i) return new _(i)
        }

        function s(e) {
            var t, i, n, a, r, d, o, h = {};
            for (o = e.match(x), t = 0, i = o.length; t < i; t++) n = o[t], a = n.indexOf(":"), r = n.substring(0, a), d = n.substring(a + 1), "{" == d.charAt(0) && (d = s(d)), h[r] = d;
            return h
        }

        function a(e, t, i) {
            var n, s = {};
            for (n in e) s[n] = new i(t, e[n]);
            return s
        }

        function r(e, t, i, d) {
            var h, l, c, g, u, p, m, y, _;
            if (e && !e.getAttribute("data-" + C.ns + "stop") && (h = e.getAttribute("data-" + C.ns + "role"), c = e.getAttribute("data-" + C.ns + "bind"), g = [], u = !0, m = {}, d = d || [t], (h || c) && o(e, !1), h && (y = n(e, i)), c && (c = s(c.replace(B, "")), y || (m = C.parseOptions(e, {
                    textField: "",
                    valueField: "",
                    template: "",
                    valueUpdate: j,
                    valuePrimitive: !1,
                    autoBind: !0
                }, t), m.roles = i, y = new w(e, m)), y.source = t, p = a(c, d, f), m.template && (p.template = new v(d, "", m.template)), p.click && (c.events = c.events || {}, c.events.click = c.click, p.click.destroy(), delete p.click), p.source && (u = !1), c.attr && (p.attr = a(c.attr, d, f)), c.style && (p.style = a(c.style, d, f)), c.events && (p.events = a(c.events, d, b)), c.css && (p.css = a(c.css, d, f)), y.bind(p)), y && (e.kendoBindingTarget = y), _ = e.children, u && _)) {
                for (l = 0; l < _.length; l++) g[l] = _[l];
                for (l = 0; l < g.length; l++) r(g[l], t, i, d)
            }
        }

        function d(t, i) {
            var n, s, a, d = C.rolesFromNamespaces([].slice.call(arguments, 2));
            for (i = C.observable(i), t = e(t), n = 0, s = t.length; n < s; n++) a = t[n], 1 === a.nodeType && r(a, i, d)
        }

        function o(t, i) {
            var n, s = t.kendoBindingTarget;
            s && (s.destroy(), L ? delete t.kendoBindingTarget : t.removeAttribute ? t.removeAttribute("kendoBindingTarget") : t.kendoBindingTarget = null), i && (n = C.widgetInstance(e(t)), n && typeof n.destroy === P && n.destroy())
        }

        function h(e, t) {
            o(e, t), l(e, t)
        }

        function l(e, t) {
            var i, n, s = e.children;
            if (s)
                for (i = 0, n = s.length; i < n; i++) h(s[i], t)
        }

        function c(t) {
            var i, n;
            for (t = e(t), i = 0, n = t.length; i < n; i++) h(t[i], !1)
        }

        function g(e, t) {
            var i = e.element,
                n = i[0].kendoBindingTarget;
            n && d(i, n.source, t)
        }

        function u(e, t) {
            var i, n, s = [],
                a = 0;
            if (!t) return e;
            if (e instanceof D) {
                for (i = e.length; a < i; a++) n = e[a], s[a] = n.get ? n.get(t) : n[t];
                e = s
            } else e instanceof S && (e = e.get(t));
            return e
        }
        var f, b, v, p, m, y, w, _, x, B, C = window.kendo,
            k = C.Observable,
            S = C.data.ObservableObject,
            D = C.data.ObservableArray,
            F = {}.toString,
            T = {},
            A = C.Class,
            M = e.proxy,
            I = "value",
            V = "source",
            O = "events",
            H = "checked",
            N = "css",
            L = !0,
            P = "function",
            j = "change";
        ! function() {
            var e = document.createElement("a");
            try {
                delete e.test
            } catch (t) {
                L = !1
            }
        }(), f = k.extend({
            init: function(e, t) {
                var i = this;
                k.fn.init.call(i), i.source = e[0], i.parents = e, i.path = t, i.dependencies = {}, i.dependencies[t] = !0, i.observable = i.source instanceof k, i._access = function(e) {
                    i.dependencies[e.field] = !0
                }, i.observable && (i._change = function(e) {
                    i.change(e)
                }, i.source.bind(j, i._change))
            },
            _parents: function() {
                var t, i = this.parents,
                    n = this.get();
                return n && "function" == typeof n.parent && (t = n.parent(), e.inArray(t, i) < 0 && (i = [t].concat(i))), i
            },
            change: function(e) {
                var t, i, n = e.field,
                    s = this;
                if ("this" === s.path) s.trigger(j, e);
                else
                    for (t in s.dependencies)
                        if (0 === t.indexOf(n) && (i = t.charAt(n.length), !i || "." === i || "[" === i)) {
                            s.trigger(j, e);
                            break
                        }
            },
            start: function(e) {
                e.bind("get", this._access)
            },
            stop: function(e) {
                e.unbind("get", this._access)
            },
            get: function() {
                var e = this,
                    i = e.source,
                    n = 0,
                    s = e.path,
                    a = i;
                if (!e.observable) return a;
                for (e.start(e.source), a = i.get(s); a === t && i;) i = e.parents[++n], i instanceof S && (a = i.get(s));
                if (a === t)
                    for (i = e.source; a === t && i;) i = i.parent(), i instanceof S && (a = i.get(s));
                return "function" == typeof a && (n = s.lastIndexOf("."), n > 0 && (i = i.get(s.substring(0, n))), e.start(i), a = i !== e.source ? a.call(i, e.source) : a.call(i), e.stop(i)), i && i !== e.source && (e.currentSource = i, i.unbind(j, e._change).bind(j, e._change)), e.stop(e.source), a
            },
            set: function(e) {
                var t = this.currentSource || this.source,
                    i = C.getter(this.path)(t);
                "function" == typeof i ? t !== this.source ? i.call(t, this.source, e) : i.call(t, e) : t.set(this.path, e)
            },
            destroy: function() {
                this.observable && (this.source.unbind(j, this._change), this.currentSource && this.currentSource.unbind(j, this._change)), this.unbind()
            }
        }), b = f.extend({
            get: function() {
                var e, t = this.source,
                    i = this.path,
                    n = 0;
                for (e = t.get(i); !e && t;) t = this.parents[++n], t instanceof S && (e = t.get(i));
                return M(e, t)
            }
        }), v = f.extend({
            init: function(e, t, i) {
                var n = this;
                f.fn.init.call(n, e, t), n.template = i
            },
            render: function(e) {
                var t;
                return this.start(this.source), t = C.render(this.template, e), this.stop(this.source), t
            }
        }), p = A.extend({
            init: function(e, t, i) {
                this.element = e, this.bindings = t, this.options = i
            },
            bind: function(e, t) {
                var i = this;
                e = t ? e[t] : e, e.bind(j, function(e) {
                    i.refresh(t || e)
                }), i.refresh(t)
            },
            destroy: function() {}
        }), m = p.extend({
            dataType: function() {
                var e = this.element.getAttribute("data-type") || this.element.type || "text";
                return e.toLowerCase()
            },
            parsedValue: function() {
                return this._parseValue(this.element.value, this.dataType())
            },
            _parseValue: function(e, t) {
                return "date" == t ? e = C.parseDate(e, "yyyy-MM-dd") : "datetime-local" == t ? e = C.parseDate(e, ["yyyy-MM-ddTHH:mm:ss", "yyyy-MM-ddTHH:mm"]) : "number" == t ? e = C.parseFloat(e) : "boolean" == t && (e = e.toLowerCase(), e = null !== C.parseFloat(e) ? !!C.parseFloat(e) : "true" === e.toLowerCase()), e
            }
        }), T.attr = p.extend({
            refresh: function(e) {
                this.element.setAttribute(e, this.bindings.attr[e].get())
            }
        }), T.css = p.extend({
            init: function(e, t, i) {
                p.fn.init.call(this, e, t, i), this.classes = {}
            },
            refresh: function(t) {
                var i = e(this.element),
                    n = this.bindings.css[t],
                    s = this.classes[t] = n.get();
                s ? i.addClass(t) : i.removeClass(t)
            }
        }), T.style = p.extend({
            refresh: function(e) {
                this.element.style[e] = this.bindings.style[e].get() || ""
            }
        }), T.enabled = p.extend({
            refresh: function() {
                this.bindings.enabled.get() ? this.element.removeAttribute("disabled") : this.element.setAttribute("disabled", "disabled")
            }
        }), T.readonly = p.extend({
            refresh: function() {
                this.bindings.readonly.get() ? this.element.setAttribute("readonly", "readonly") : this.element.removeAttribute("readonly")
            }
        }), T.disabled = p.extend({
            refresh: function() {
                this.bindings.disabled.get() ? this.element.setAttribute("disabled", "disabled") : this.element.removeAttribute("disabled")
            }
        }), T.events = p.extend({
            init: function(e, t, i) {
                p.fn.init.call(this, e, t, i), this.handlers = {}
            },
            refresh: function(t) {
                var i = e(this.element),
                    n = this.bindings.events[t],
                    s = this.handlers[t];
                s && i.off(t, s), s = this.handlers[t] = n.get(), i.on(t, n.source, s)
            },
            destroy: function() {
                var t, i = e(this.element);
                for (t in this.handlers) i.off(t, this.handlers[t])
            }
        }), T.text = p.extend({
            refresh: function() {
                var t = this.bindings.text.get(),
                    i = this.element.getAttribute("data-format") || "";
                null == t && (t = ""), e(this.element).text(C.toString(t, i))
            }
        }), T.visible = p.extend({
            refresh: function() {
                this.element.style.display = this.bindings.visible.get() ? "" : "none"
            }
        }), T.invisible = p.extend({
            refresh: function() {
                this.element.style.display = this.bindings.invisible.get() ? "none" : ""
            }
        }), T.html = p.extend({
            refresh: function() {
                this.element.innerHTML = this.bindings.html.get()
            }
        }), T.value = m.extend({
            init: function(t, i, n) {
                m.fn.init.call(this, t, i, n), this._change = M(this.change, this), this.eventName = n.valueUpdate || j, e(this.element).on(this.eventName, this._change), this._initChange = !1
            },
            change: function() {
                this._initChange = this.eventName != j, this.bindings[I].set(this.parsedValue()), this._initChange = !1
            },
            refresh: function() {
                var e, t;
                this._initChange || (e = this.bindings[I].get(), null == e && (e = ""), t = this.dataType(), "date" == t ? e = C.toString(e, "yyyy-MM-dd") : "datetime-local" == t && (e = C.toString(e, "yyyy-MM-ddTHH:mm:ss")), this.element.value = e), this._initChange = !1
            },
            destroy: function() {
                e(this.element).off(this.eventName, this._change)
            }
        }), T.source = p.extend({
            init: function(e, t, i) {
                p.fn.init.call(this, e, t, i);
                var n = this.bindings.source.get();
                n instanceof C.data.DataSource && i.autoBind !== !1 && n.fetch()
            },
            refresh: function(e) {
                var t = this,
                    i = t.bindings.source.get();
                i instanceof D || i instanceof C.data.DataSource ? (e = e || {}, "add" == e.action ? t.add(e.index, e.items) : "remove" == e.action ? t.remove(e.index, e.items) : "itemchange" != e.action && t.render()) : t.render()
            },
            container: function() {
                var e = this.element;
                return "table" == e.nodeName.toLowerCase() && (e.tBodies[0] || e.appendChild(document.createElement("tbody")), e = e.tBodies[0]), e
            },
            template: function() {
                var e = this.options,
                    t = e.template,
                    i = this.container().nodeName.toLowerCase();
                return t || (t = "select" == i ? e.valueField || e.textField ? C.format('<option value="#:{0}#">#:{1}#</option>', e.valueField || e.textField, e.textField || e.valueField) : "<option>#:data#</option>" : "tbody" == i ? "<tr><td>#:data#</td></tr>" : "ul" == i || "ol" == i ? "<li>#:data#</li>" : "#:data#", t = C.template(t)), t
            },
            add: function(t, i) {
                var n, s, a, d, o = this.container(),
                    h = o.cloneNode(!1),
                    l = o.children[t];
                if (e(h).html(C.render(this.template(), i)), h.children.length)
                    for (n = this.bindings.source._parents(), s = 0, a = i.length; s < a; s++) d = h.children[0], o.insertBefore(d, l || null), r(d, i[s], this.options.roles, [i[s]].concat(n))
            },
            remove: function(e, t) {
                var i, n, s = this.container();
                for (i = 0; i < t.length; i++) n = s.children[e], h(n, !0), n.parentNode == s && s.removeChild(n)
            },
            render: function() {
                var t, i, n, s = this.bindings.source.get(),
                    a = this.container(),
                    d = this.template();
                if (null != s)
                    if (s instanceof C.data.DataSource && (s = s.view()), s instanceof D || "[object Array]" === F.call(s) || (s = [s]), this.bindings.template) {
                        if (l(a, !0), e(a).html(this.bindings.template.render(s)), a.children.length)
                            for (t = this.bindings.source._parents(), i = 0, n = s.length; i < n; i++) r(a.children[i], s[i], this.options.roles, [s[i]].concat(t))
                    } else e(a).html(C.render(d, s))
            }
        }), T.input = {
            checked: m.extend({
                init: function(t, i, n) {
                    m.fn.init.call(this, t, i, n), this._change = M(this.change, this), e(this.element).change(this._change)
                },
                change: function() {
                    var e, t, i, n = this.element,
                        s = this.value();
                    if ("radio" == n.type) s = this.parsedValue(), this.bindings[H].set(s);
                    else if ("checkbox" == n.type)
                        if (e = this.bindings[H].get(), e instanceof D) {
                            if (s = this.parsedValue(), s instanceof Date) {
                                for (i = 0; i < e.length; i++)
                                    if (e[i] instanceof Date && +e[i] === +s) {
                                        t = i;
                                        break
                                    }
                            } else t = e.indexOf(s);
                            t > -1 ? e.splice(t, 1) : e.push(s)
                        } else this.bindings[H].set(s)
                },
                refresh: function() {
                    var e, i, n = this.bindings[H].get(),
                        s = n,
                        a = this.dataType(),
                        r = this.element;
                    if ("checkbox" == r.type)
                        if (s instanceof D) {
                            if (e = -1, n = this.parsedValue(), n instanceof Date) {
                                for (i = 0; i < s.length; i++)
                                    if (s[i] instanceof Date && +s[i] === +n) {
                                        e = i;
                                        break
                                    }
                            } else e = s.indexOf(n);
                            r.checked = e >= 0
                        } else r.checked = s;
                    else "radio" == r.type && ("date" == a ? n = C.toString(n, "yyyy-MM-dd") : "datetime-local" == a && (n = C.toString(n, "yyyy-MM-ddTHH:mm:ss")), r.checked = null !== n && t !== n && r.value === "" + n)
                },
                value: function() {
                    var e = this.element,
                        t = e.value;
                    return "checkbox" == e.type && (t = e.checked), t
                },
                destroy: function() {
                    e(this.element).off(j, this._change)
                }
            })
        }, T.select = {
            source: T.source.extend({
                refresh: function(i) {
                    var n, s = this,
                        a = s.bindings.source.get();
                    a instanceof D || a instanceof C.data.DataSource ? (i = i || {}, "add" == i.action ? s.add(i.index, i.items) : "remove" == i.action ? s.remove(i.index, i.items) : "itemchange" != i.action && i.action !== t || (s.render(), s.bindings.value && s.bindings.value && (n = u(s.bindings.value.get(), e(s.element).data("valueField")), null === n ? s.element.selectedIndex = -1 : s.element.value = n))) : s.render()
                }
            }),
            value: m.extend({
                init: function(t, i, n) {
                    m.fn.init.call(this, t, i, n), this._change = M(this.change, this), e(this.element).change(this._change)
                },
                parsedValue: function() {
                    var e, t, i, n, s = this.dataType(),
                        a = [];
                    for (i = 0, n = this.element.options.length; i < n; i++) t = this.element.options[i], t.selected && (e = t.attributes.value, e = e && e.specified ? t.value : t.text, a.push(this._parseValue(e, s)));
                    return a
                },
                change: function() {
                    var e, i, n, s, a, r, d, o, h = [],
                        l = this.element,
                        c = this.options.valueField || this.options.textField,
                        g = this.options.valuePrimitive;
                    for (a = 0, r = l.options.length; a < r; a++) i = l.options[a], i.selected && (s = i.attributes.value, s = s && s.specified ? i.value : i.text, h.push(c ? s : this._parseValue(s, this.dataType())));
                    if (c)
                        for (e = this.bindings.source.get(), e instanceof C.data.DataSource && (e = e.view()), n = 0; n < h.length; n++)
                            for (a = 0, r = e.length; a < r; a++)
                                if (d = e[a].get(c), o = d + "" === h[n]) {
                                    h[n] = e[a];
                                    break
                                }
                    s = this.bindings[I].get(), s instanceof D ? s.splice.apply(s, [0, s.length].concat(h)) : this.bindings[I].set(g || !(s instanceof S || null === s || s === t) && c ? h[0].get(c) : h[0])
                },
                refresh: function() {
                    var e, t, i, n = this.element,
                        s = n.options,
                        a = this.bindings[I].get(),
                        r = a,
                        d = this.options.valueField || this.options.textField,
                        o = !1,
                        h = this.dataType();
                    for (r instanceof D || (r = new D([a])), n.selectedIndex = -1, i = 0; i < r.length; i++)
                        for (a = r[i], d && a instanceof S && (a = a.get(d)), "date" == h ? a = C.toString(r[i], "yyyy-MM-dd") : "datetime-local" == h && (a = C.toString(r[i], "yyyy-MM-ddTHH:mm:ss")), e = 0; e < s.length; e++) t = s[e].value, "" === t && "" !== a && (t = s[e].text), null != a && t == "" + a && (s[e].selected = !0, o = !0)
                },
                destroy: function() {
                    e(this.element).off(j, this._change)
                }
            })
        }, T.widget = {
            events: p.extend({
                init: function(e, t, i) {
                    p.fn.init.call(this, e.element[0], t, i), this.widget = e, this.handlers = {}
                },
                refresh: function(e) {
                    var t = this.bindings.events[e],
                        i = this.handlers[e];
                    i && this.widget.unbind(e, i), i = t.get(), this.handlers[e] = function(e) {
                        e.data = t.source, i(e), e.data === t.source && delete e.data
                    }, this.widget.bind(e, this.handlers[e])
                },
                destroy: function() {
                    var e;
                    for (e in this.handlers) this.widget.unbind(e, this.handlers[e])
                }
            }),
            checked: p.extend({
                init: function(e, t, i) {
                    p.fn.init.call(this, e.element[0], t, i), this.widget = e, this._change = M(this.change, this), this.widget.bind(j, this._change)
                },
                change: function() {
                    this.bindings[H].set(this.value())
                },
                refresh: function() {
                    this.widget.check(this.bindings[H].get() === !0)
                },
                value: function() {
                    var e = this.element,
                        t = e.value;
                    return "on" != t && "off" != t && "checkbox" != this.element.type || (t = e.checked), t
                },
                destroy: function() {
                    this.widget.unbind(j, this._change)
                }
            }),
            start: p.extend({
                init: function(e, t, i) {
                    p.fn.init.call(this, e.element[0], t, i), this._change = M(this.change, this), this.widget = e, this.widget.bind(j, this._change)
                },
                change: function() {
                    this.bindings.start.set(this.widget.range().start)
                },
                refresh: function() {
                    var e = this,
                        t = this.bindings.start.get(),
                        i = e.widget._range ? e.widget._range.end : null;
                    this.widget.range({
                        start: t,
                        end: i
                    })
                },
                destroy: function() {
                    this.widget.unbind(j, this._change)
                }
            }),
            end: p.extend({
                init: function(e, t, i) {
                    p.fn.init.call(this, e.element[0], t, i), this._change = M(this.change, this), this.widget = e, this.widget.bind(j, this._change)
                },
                change: function() {
                    this.bindings.end.set(this.widget.range().end)
                },
                refresh: function() {
                    var e = this,
                        t = this.bindings.end.get(),
                        i = e.widget._range ? e.widget._range.start : null;
                    this.widget.range({
                        start: i,
                        end: t
                    })
                },
                destroy: function() {
                    this.widget.unbind(j, this._change)
                }
            }),
            visible: p.extend({
                init: function(e, t, i) {
                    p.fn.init.call(this, e.element[0], t, i), this.widget = e
                },
                refresh: function() {
                    var e = this.bindings.visible.get();
                    this.widget.wrapper[0].style.display = e ? "" : "none"
                }
            }),
            invisible: p.extend({
                init: function(e, t, i) {
                    p.fn.init.call(this, e.element[0], t, i), this.widget = e
                },
                refresh: function() {
                    var e = this.bindings.invisible.get();
                    this.widget.wrapper[0].style.display = e ? "none" : ""
                }
            }),
            enabled: p.extend({
                init: function(e, t, i) {
                    p.fn.init.call(this, e.element[0], t, i), this.widget = e
                },
                refresh: function() {
                    this.widget.enable && this.widget.enable(this.bindings.enabled.get())
                }
            }),
            disabled: p.extend({
                init: function(e, t, i) {
                    p.fn.init.call(this, e.element[0], t, i), this.widget = e
                },
                refresh: function() {
                    this.widget.enable && this.widget.enable(!this.bindings.disabled.get())
                }
            }),
            source: i("source", "dataSource", "setDataSource"),
            value: p.extend({
                init: function(t, i, n) {
                    p.fn.init.call(this, t.element[0], i, n), this.widget = t, this._change = e.proxy(this.change, this), this.widget.first(j, this._change);
                    var s = this.bindings.value.get();
                    this._valueIsObservableObject = !n.valuePrimitive && (null == s || s instanceof S), this._valueIsObservableArray = s instanceof D, this._initChange = !1
                },
                _source: function() {
                    var e;
                    return this.widget.dataItem && (e = this.widget.dataItem(), e && e instanceof S) ? [e] : (this.bindings.source && (e = this.bindings.source.get()), (!e || e instanceof C.data.DataSource) && (e = this.widget.dataSource.flatView()), e)
                },
                change: function() {
                    var e, t, i, n, s, a, r, d = this.widget.value(),
                        o = this.options.dataValueField || this.options.dataTextField,
                        h = "[object Array]" === F.call(d),
                        l = this._valueIsObservableObject,
                        c = [];
                    if (this._initChange = !0, o)
                        if ("" === d && (l || this.options.valuePrimitive)) d = null;
                        else {
                            for (r = this._source(), h && (t = d.length, c = d.slice(0)), s = 0, a = r.length; s < a; s++)
                                if (i = r[s], n = i.get(o), h) {
                                    for (e = 0; e < t; e++)
                                        if (n == c[e]) {
                                            c[e] = i;
                                            break
                                        }
                                } else if (n == d) {
                                d = l ? i : n;
                                break
                            }
                            c[0] && (d = this._valueIsObservableArray ? c : l || !o ? c[0] : c[0].get(o))
                        }
                    this.bindings.value.set(d), this._initChange = !1
                },
                refresh: function() {
                    var e, i, n, s, a, r, d, o, h;
                    if (!this._initChange) {
                        if (e = this.widget, i = e.options, n = i.dataTextField, s = i.dataValueField || n, a = this.bindings.value.get(), r = i.text || "", d = 0, h = [], a === t && (a = null), s)
                            if (a instanceof D) {
                                for (o = a.length; d < o; d++) h[d] = a[d].get(s);
                                a = h
                            } else a instanceof S && (r = a.get(n), a = a.get(s));
                        i.autoBind !== !1 || i.cascadeFrom || !e.listView || e.listView.bound() ? e.value(a) : (n !== s || r || (r = a), r || !a && 0 !== a || !i.valuePrimitive ? e._preselect(a, r) : e.value(a))
                    }
                    this._initChange = !1
                },
                destroy: function() {
                    this.widget.unbind(j, this._change)
                }
            }),
            dropdowntree: {
                value: p.extend({
                    init: function(t, i, n) {
                        p.fn.init.call(this, t.element[0], i, n), this.widget = t, this._change = e.proxy(this.change, this), this.widget.first(j, this._change), this._initChange = !1
                    },
                    change: function() {
                        var e, i, n, s, a, r, d, o, h, l = this,
                            c = l.bindings[I].get(),
                            g = l.options.valuePrimitive,
                            u = l.widget.treeview.select(),
                            f = l.widget._isMultipleSelection() ? l.widget._getAllChecked() : l.widget.treeview.dataItem(u) || l.widget.value(),
                            b = g || l.widget.options.autoBind === !1 ? l.widget.value() : f,
                            v = this.options.dataValueField || this.options.dataTextField;
                        if (b = b.slice ? b.slice(0) : b, l._initChange = !0, c instanceof D) {
                            for (e = [], i = b.length, n = 0, s = 0, a = c[n], r = !1; a !== t;) {
                                for (h = !1, s = 0; s < i; s++)
                                    if (g ? r = b[s] == a : (o = b[s], o = o.get ? o.get(v) : o, r = o == (a.get ? a.get(v) : a)), r) {
                                        b.splice(s, 1), i -= 1, h = !0;
                                        break
                                    }
                                h ? n += 1 : (e.push(a), y(c, n, 1), d = n), a = c[n]
                            }
                            y(c, c.length, 0, b), e.length && c.trigger("change", {
                                action: "remove",
                                items: e,
                                index: d
                            }), b.length && c.trigger("change", {
                                action: "add",
                                items: b,
                                index: c.length - 1
                            })
                        } else l.bindings[I].set(b);
                        l._initChange = !1
                    },
                    refresh: function() {
                        if (!this._initChange) {
                            var e, t, i = this.options,
                                n = this.widget,
                                s = i.dataValueField || i.dataTextField,
                                a = this.bindings.value.get(),
                                r = a,
                                d = 0,
                                o = [];
                            if (s)
                                if (a instanceof D) {
                                    for (e = a.length; d < e; d++) t = a[d], o[d] = t.get ? t.get(s) : t;
                                    a = o
                                } else a instanceof S && (a = a.get(s));
                            i.autoBind === !1 && i.valuePrimitive !== !0 ? n._preselect(r, a) : n.value(a)
                        }
                    },
                    destroy: function() {
                        this.widget.unbind(j, this._change)
                    }
                })
            },
            gantt: {
                dependencies: i("dependencies", "dependencies", "setDependenciesDataSource")
            },
            multiselect: {
                value: p.extend({
                    init: function(t, i, n) {
                        p.fn.init.call(this, t.element[0], i, n), this.widget = t, this._change = e.proxy(this.change, this), this.widget.first(j, this._change), this._initChange = !1
                    },
                    change: function() {
                        var e, i, n, s, a, r, d, o, h, l = this,
                            c = l.bindings[I].get(),
                            g = l.options.valuePrimitive,
                            u = g ? l.widget.value() : l.widget.dataItems(),
                            f = this.options.dataValueField || this.options.dataTextField;
                        if (u = u.slice(0), l._initChange = !0, c instanceof D) {
                            for (e = [], i = u.length, n = 0, s = 0, a = c[n], r = !1; a !== t;) {
                                for (h = !1, s = 0; s < i; s++)
                                    if (g ? r = u[s] == a : (o = u[s], o = o.get ? o.get(f) : o, r = o == (a.get ? a.get(f) : a)), r) {
                                        u.splice(s, 1), i -= 1, h = !0;
                                        break
                                    }
                                h ? n += 1 : (e.push(a), y(c, n, 1), d = n), a = c[n]
                            }
                            y(c, c.length, 0, u), e.length && c.trigger("change", {
                                action: "remove",
                                items: e,
                                index: d
                            }), u.length && c.trigger("change", {
                                action: "add",
                                items: u,
                                index: c.length - 1
                            })
                        } else l.bindings[I].set(u);
                        l._initChange = !1
                    },
                    refresh: function() {
                        if (!this._initChange) {
                            var e, i, n = this.options,
                                s = this.widget,
                                a = n.dataValueField || n.dataTextField,
                                r = this.bindings.value.get(),
                                d = r,
                                o = 0,
                                h = [];
                            if (r === t && (r = null), a)
                                if (r instanceof D) {
                                    for (e = r.length; o < e; o++) i = r[o], h[o] = i.get ? i.get(a) : i;
                                    r = h
                                } else r instanceof S && (r = r.get(a));
                            n.autoBind !== !1 || n.valuePrimitive === !0 || s._isBound() ? s.value(r) : s._preselect(d, r)
                        }
                    },
                    destroy: function() {
                        this.widget.unbind(j, this._change)
                    }
                })
            },
            scheduler: {
                source: i("source", "dataSource", "setDataSource").extend({
                    dataBound: function(e) {
                        var t, i, n, s, a = this.widget,
                            d = e.addedItems || a.items();
                        if (d.length)
                            for (n = e.addedDataItems || a.dataItems(), s = this.bindings.source._parents(), t = 0, i = n.length; t < i; t++) r(d[t], n[t], this._ns(e.ns), [n[t]].concat(s))
                    }
                })
            },
            grid: {
                source: i("source", "dataSource", "setDataSource").extend({
                    dataBound: function(e) {
                        var t, i, n, s, a = this.widget,
                            d = e.addedItems || a.items();
                        if (d.length)
                            for (s = e.addedDataItems || a.dataItems(), n = this.bindings.source._parents(), t = 0, i = s.length; t < i; t++) r(d[t], s[t], this._ns(e.ns), [s[t]].concat(n))
                    }
                })
            }
        }, y = function(e, t, i, n) {
            var s, a, r, d, o;
            if (n = n || [], i = i || 0, s = n.length, a = e.length, r = [].slice.call(e, t + i), d = r.length, s) {
                for (s = t + s, o = 0; t < s; t++) e[t] = n[o], o++;
                e.length = s
            } else if (i)
                for (e.length = t, i += t; t < i;) delete e[--i];
            if (d) {
                for (d = t + d, o = 0; t < d; t++) e[t] = r[o], o++;
                e.length = d
            }
            for (t = e.length; t < a;) delete e[t], t++
        }, w = A.extend({
            init: function(e, t) {
                this.target = e, this.options = t, this.toDestroy = []
            },
            bind: function(e) {
                var t, i, n, s, a, r, d = this instanceof _,
                    o = this.binders();
                for (t in e) t == I ? i = !0 : t == V ? n = !0 : t != O || d ? t == H ? a = !0 : t == N ? r = !0 : this.applyBinding(t, e, o) : s = !0;
                n && this.applyBinding(V, e, o), i && this.applyBinding(I, e, o), a && this.applyBinding(H, e, o), s && !d && this.applyBinding(O, e, o), r && !d && this.applyBinding(N, e, o)
            },
            binders: function() {
                return T[this.target.nodeName.toLowerCase()] || {}
            },
            applyBinding: function(e, t, i) {
                var n, s = i[e] || T[e],
                    a = this.toDestroy,
                    r = t[e];
                if (s)
                    if (s = new s(this.target, t, this.options), a.push(s), r instanceof f) s.bind(r), a.push(r);
                    else
                        for (n in r) s.bind(r, n), a.push(r[n]);
                else if ("template" !== e) throw Error("The " + e + " binding is not supported by the " + this.target.nodeName.toLowerCase() + " element")
            },
            destroy: function() {
                var e, t, i = this.toDestroy;
                for (e = 0, t = i.length; e < t; e++) i[e].destroy()
            }
        }), _ = w.extend({
            binders: function() {
                return T.widget[this.target.options.name.toLowerCase()] || {}
            },
            applyBinding: function(e, t, i) {
                var n, s = i[e] || T.widget[e],
                    a = this.toDestroy,
                    r = t[e];
                if (!s) throw Error("The " + e + " binding is not supported by the " + this.target.options.name + " widget");
                if (s = new s(this.target, t, this.target.options), a.push(s), r instanceof f) s.bind(r), a.push(r);
                else
                    for (n in r) s.bind(r, n), a.push(r[n])
            }
        }), x = /[A-Za-z0-9_\-]+:(\{([^}]*)\}|[^,}]+)/g, B = /\s/g, C.unbind = c, C.bind = d, C.data.binders = T, C.data.Binder = p, C.notify = g, C.observable = function(e) {
            return e instanceof S || (e = new S(e)), e
        }, C.observableHierarchy = function(e) {
            function t(e) {
                var i, n;
                for (i = 0; i < e.length; i++) e[i]._initChildren(), n = e[i].children, n.fetch(), e[i].items = n.data(), t(e[i].items)
            }
            var i = C.data.HierarchicalDataSource.create(e);
            return i.fetch(), t(i.data()), i._data._dataSource = i, i._data
        }
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, i) {
    (i || t)()
});;
! function(e, define) {
    define("kendo.userevents.min", ["kendo.core.min"], e)
}(function() {
    return function(e, t) {
        function n(e, t) {
            var n = e.x.location,
                i = e.y.location,
                o = t.x.location,
                r = t.y.location,
                s = n - o,
                a = i - r;
            return {
                center: {
                    x: (n + o) / 2,
                    y: (i + r) / 2
                },
                distance: Math.sqrt(s * s + a * a)
            }
        }

        function i(e) {
            var t, n, i, o = [],
                r = e.originalEvent,
                a = e.currentTarget,
                c = 0;
            if (e.api) o.push({
                id: 2,
                event: e,
                target: e.target,
                currentTarget: e.target,
                location: e,
                type: "api"
            });
            else if (e.type.match(/touch/))
                for (n = r ? r.changedTouches : [], t = n.length; c < t; c++) i = n[c], o.push({
                    location: i,
                    event: e,
                    target: i.target,
                    currentTarget: a,
                    id: i.identifier,
                    type: "touch"
                });
            else o.push(s.pointers || s.msPointers ? {
                location: r,
                event: e,
                target: e.target,
                currentTarget: a,
                id: r.pointerId,
                type: "pointer"
            } : {
                id: 1,
                event: e,
                target: e.target,
                currentTarget: a,
                location: e,
                type: "mouse"
            });
            return o
        }

        function o(e) {
            for (var t = r.eventMap.up.split(" "), n = 0, i = t.length; n < i; n++) e(t[n])
        }
        var r = window.kendo,
            s = r.support,
            a = r.Class,
            c = r.Observable,
            u = e.now,
            l = e.extend,
            h = s.mobileOS,
            p = h && h.android,
            d = 800,
            f = 300,
            v = s.browser.msie ? 5 : 0,
            g = "press",
            _ = "hold",
            m = "select",
            T = "start",
            y = "move",
            k = "end",
            E = "cancel",
            x = "tap",
            D = "doubleTap",
            M = "release",
            w = "gesturestart",
            b = "gesturechange",
            A = "gestureend",
            C = "gesturetap",
            I = {
                api: 0,
                touch: 0,
                mouse: 9,
                pointer: 9
            },
            S = !s.touch || s.mouseAndTouchPresent,
            P = a.extend({
                init: function(e, t) {
                    var n = this;
                    n.axis = e, n._updateLocationData(t), n.startLocation = n.location, n.velocity = n.delta = 0, n.timeStamp = u()
                },
                move: function(e) {
                    var t = this,
                        n = e["page" + t.axis],
                        i = u(),
                        o = i - t.timeStamp || 1;
                    !n && p || (t.delta = n - t.location, t._updateLocationData(e), t.initialDelta = n - t.startLocation, t.velocity = t.delta / o, t.timeStamp = i)
                },
                _updateLocationData: function(e) {
                    var t = this,
                        n = t.axis;
                    t.location = e["page" + n], t.client = e["client" + n], t.screen = e["screen" + n]
                }
            }),
            L = a.extend({
                init: function(e, t, n) {
                    l(this, {
                        x: new P("X", n.location),
                        y: new P("Y", n.location),
                        type: n.type,
                        useClickAsTap: e.useClickAsTap,
                        threshold: e.threshold || I[n.type],
                        userEvents: e,
                        target: t,
                        currentTarget: n.currentTarget,
                        initialTouch: n.target,
                        id: n.id,
                        pressEvent: n,
                        _clicks: e._clicks,
                        supportDoubleTap: e.supportDoubleTap,
                        _moved: !1,
                        _finished: !1
                    })
                },
                press: function() {
                    this._holdTimeout = setTimeout(e.proxy(this, "_hold"), this.userEvents.minHold), this._trigger(g, this.pressEvent)
                },
                _tap: function(e) {
                    var t = this;
                    t.userEvents._clicks++, 1 == t.userEvents._clicks && (t._clickTimeout = setTimeout(function() {
                        1 == t.userEvents._clicks ? t._trigger(x, e) : t._trigger(D, e), t.userEvents._clicks = 0
                    }, f))
                },
                _hold: function() {
                    this._trigger(_, this.pressEvent)
                },
                move: function(e) {
                    var t = this,
                        n = "api" !== e.type && t.userEvents._shouldNotMove;
                    if (!t._finished && !n) {
                        if (t.x.move(e.location), t.y.move(e.location), !t._moved) {
                            if (t._withinIgnoreThreshold()) return;
                            if (X.current && X.current !== t.userEvents) return t.dispose();
                            t._start(e)
                        }
                        t._finished || t._trigger(y, e)
                    }
                },
                end: function(e) {
                    this.endTime = u(), this._finished || (this._finished = !0, this._trigger(M, e), this._moved ? this._trigger(k, e) : this.useClickAsTap || (this.supportDoubleTap ? this._tap(e) : this._trigger(x, e)), clearTimeout(this._holdTimeout), this.dispose())
                },
                dispose: function() {
                    var t = this.userEvents,
                        n = t.touches;
                    this._finished = !0, this.pressEvent = null, clearTimeout(this._holdTimeout), n.splice(e.inArray(this, n), 1)
                },
                skip: function() {
                    this.dispose()
                },
                cancel: function() {
                    this.dispose()
                },
                isMoved: function() {
                    return this._moved
                },
                _start: function(e) {
                    clearTimeout(this._holdTimeout), this.startTime = u(), this._moved = !0, this._trigger(T, e)
                },
                _trigger: function(e, t) {
                    var n = this,
                        i = t.event,
                        o = {
                            touch: n,
                            x: n.x,
                            y: n.y,
                            target: n.target,
                            event: i
                        };
                    n.userEvents.notify(e, o) && i.preventDefault()
                },
                _withinIgnoreThreshold: function() {
                    var e = this.x.initialDelta,
                        t = this.y.initialDelta;
                    return Math.sqrt(e * e + t * t) <= this.threshold
                }
            }),
            X = c.extend({
                init: function(t, n) {
                    var i, a, u, h, p = this,
                        f = r.guid();
                    n = n || {}, i = p.filter = n.filter, p.threshold = n.threshold || v, p.minHold = n.minHold || d, p.touches = [], p._maxTouches = n.multiTouch ? 2 : 1, p.allowSelection = n.allowSelection, p.captureUpIfMoved = n.captureUpIfMoved, p.useClickAsTap = !n.fastTap && !s.delayedClick(), p.eventNS = f, p._clicks = 0, p.supportDoubleTap = n.supportDoubleTap, t = e(t).handler(p), c.fn.init.call(p), l(p, {
                        element: t,
                        surface: e(n.global && S ? t[0].ownerDocument.documentElement : n.surface || t),
                        stopPropagation: n.stopPropagation,
                        pressed: !1
                    }), p.surface.handler(p).on(r.applyEventMap("move", f), "_move").on(r.applyEventMap("up cancel", f), "_end"), t.on(r.applyEventMap("down", f), i, "_start"), p.useClickAsTap && t.on(r.applyEventMap("click", f), i, "_click"), (s.pointers || s.msPointers) && (s.browser.version < 11 ? (a = "pinch-zoom double-tap-zoom", t.css("-ms-touch-action", n.touchAction && "none" != n.touchAction ? a + " " + n.touchAction : a)) : t.css("touch-action", n.touchAction || "none")), n.preventDragEvent && t.on(r.applyEventMap("dragstart", f), r.preventDefault), t.on(r.applyEventMap("mousedown", f), i, {
                        root: t
                    }, "_select"), p.captureUpIfMoved && s.eventCapture && (u = p.surface[0], h = e.proxy(p.preventIfMoving, p), o(function(e) {
                        u.addEventListener(e, h, !0)
                    })), p.bind([g, _, x, D, T, y, k, M, E, w, b, A, C, m], n)
                },
                preventIfMoving: function(e) {
                    this._isMoved() && e.preventDefault()
                },
                destroy: function() {
                    var e, t = this;
                    t._destroyed || (t._destroyed = !0, t.captureUpIfMoved && s.eventCapture && (e = t.surface[0], o(function(n) {
                        e.removeEventListener(n, t.preventIfMoving)
                    })), t.element.kendoDestroy(t.eventNS), t.surface.kendoDestroy(t.eventNS), t.element.removeData("handler"), t.surface.removeData("handler"), t._disposeAll(), t.unbind(), delete t.surface, delete t.element, delete t.currentTarget)
                },
                capture: function() {
                    X.current = this
                },
                cancel: function() {
                    this._disposeAll(), this.trigger(E)
                },
                notify: function(e, t) {
                    var i = this,
                        o = i.touches;
                    if (this._isMultiTouch()) {
                        switch (e) {
                            case y:
                                e = b;
                                break;
                            case k:
                                e = A;
                                break;
                            case x:
                                e = C
                        }
                        l(t, {
                            touches: o
                        }, n(o[0], o[1]))
                    }
                    return this.trigger(e, l(t, {
                        type: e
                    }))
                },
                press: function(e, t, n) {
                    this._apiCall("_start", e, t, n)
                },
                move: function(e, t) {
                    this._apiCall("_move", e, t)
                },
                end: function(e, t) {
                    this._apiCall("_end", e, t)
                },
                _isMultiTouch: function() {
                    return this.touches.length > 1
                },
                _maxTouchesReached: function() {
                    return this.touches.length >= this._maxTouches
                },
                _disposeAll: function() {
                    for (var e = this.touches; e.length > 0;) e.pop().dispose()
                },
                _isMoved: function() {
                    return e.grep(this.touches, function(e) {
                        return e.isMoved()
                    }).length
                },
                _select: function(e) {
                    this.allowSelection && !this.trigger(m, {
                        event: e
                    }) || e.preventDefault()
                },
                _start: function(t) {
                    var n, o, r = this,
                        s = 0,
                        a = r.filter,
                        c = i(t),
                        u = c.length,
                        l = t.which;
                    if (!(l && l > 1 || r._maxTouchesReached()))
                        for (X.current = null, r.currentTarget = t.currentTarget, r.stopPropagation && t.stopPropagation(); s < u && !r._maxTouchesReached(); s++) o = c[s], n = a ? e(o.currentTarget) : r.element, n.length && (o = new L(r, n, o), r.touches.push(o), o.press(), r._isMultiTouch() && r.notify("gesturestart", {}))
                },
                _move: function(e) {
                    this._eachTouch("move", e)
                },
                _end: function(e) {
                    this._eachTouch("end", e)
                },
                _click: function(t) {
                    var n = {
                        touch: {
                            initialTouch: t.target,
                            target: e(t.currentTarget),
                            endTime: u(),
                            x: {
                                location: t.pageX,
                                client: t.clientX
                            },
                            y: {
                                location: t.pageY,
                                client: t.clientY
                            }
                        },
                        x: t.pageX,
                        y: t.pageY,
                        target: e(t.currentTarget),
                        event: t,
                        type: "tap"
                    };
                    this.trigger("tap", n) && t.preventDefault()
                },
                _eachTouch: function(e, t) {
                    var n, o, r, s, a = this,
                        c = {},
                        u = i(t),
                        l = a.touches;
                    for (n = 0; n < l.length; n++) o = l[n], c[o.id] = o;
                    for (n = 0; n < u.length; n++) r = u[n], s = c[r.id], s && s[e](r)
                },
                _apiCall: function(t, n, i, o) {
                    this[t]({
                        api: !0,
                        pageX: n,
                        pageY: i,
                        clientX: n,
                        clientY: i,
                        target: e(o || this.element)[0],
                        stopPropagation: e.noop,
                        preventDefault: e.noop
                    })
                }
            });
        X.defaultThreshold = function(e) {
            v = e
        }, X.minHold = function(e) {
            d = e
        }, r.getTouches = i, r.touchDelta = n, r.UserEvents = X
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(t, define) {
    define("kendo.draganddrop.min", ["kendo.core.min", "kendo.userevents.min"], t)
}(function() {
    return function(t, e) {
        function n(e, n) {
            try {
                return t.contains(e, n) || e == n
            } catch (r) {
                return !1
            }
        }

        function r(t, e) {
            return parseInt(t.css(e), 10) || 0
        }

        function i(t, e) {
            return Math.min(Math.max(t, e.min), e.max)
        }

        function o(t, e) {
            var n = D(t),
                i = _._outerWidth,
                o = _._outerHeight,
                a = n.left + r(t, "borderLeftWidth") + r(t, "paddingLeft"),
                s = n.top + r(t, "borderTopWidth") + r(t, "paddingTop"),
                l = a + t.width() - i(e, !0),
                c = s + t.height() - o(e, !0);
            return {
                x: {
                    min: a,
                    max: l
                },
                y: {
                    min: s,
                    max: c
                }
            }
        }

        function a(n, r, i) {
            for (var o, a, s = 0, l = r && r.length, c = i && i.length; n && n.parentNode;) {
                for (s = 0; s < l; s++)
                    if (o = r[s], o.element[0] === n) return {
                        target: o,
                        targetElement: n
                    };
                for (s = 0; s < c; s++)
                    if (a = i[s], t.contains(a.element[0], n) && x.matchesSelector.call(n, a.options.filter)) return {
                        target: a,
                        targetElement: n
                    };
                n = n.parentNode
            }
            return e
        }

        function s(t, e) {
            var n, r = e.options.group,
                i = t[r];
            if (T.fn.destroy.call(e), i.length > 1) {
                for (n = 0; n < i.length; n++)
                    if (i[n] == e) {
                        i.splice(n, 1);
                        break
                    }
            } else i.length = 0, delete t[r]
        }

        function l(t) {
            var e, n, r, i = c()[0];
            return t[0] === i ? (n = i.scrollTop, r = i.scrollLeft, {
                top: n,
                left: r,
                bottom: n + b.height(),
                right: r + b.width()
            }) : (e = t.offset(), e.bottom = e.top + t.height(), e.right = e.left + t.width(), e)
        }

        function c() {
            return t(_.support.browser.edge || _.support.browser.safari ? y.body : y.documentElement)
        }

        function u(e) {
            var n, r = c();
            if (!e || e === y.body || e === y.documentElement) return r;
            for (n = t(e)[0]; n && !_.isScrollable(n) && n !== y.body;) n = n.parentNode;
            return n === y.body ? r : t(n)
        }

        function h(t, e, n) {
            var r = {
                    x: 0,
                    y: 0
                },
                i = 50;
            return t - n.left < i ? r.x = -(i - (t - n.left)) : n.right - t < i && (r.x = i - (n.right - t)), e - n.top < i ? r.y = -(i - (e - n.top)) : n.bottom - e < i && (r.y = i - (n.bottom - e)), r
        }
        var d, f, p, g, v, m, _ = window.kendo,
            x = _.support,
            y = window.document,
            b = t(window),
            E = _.Class,
            T = _.ui.Widget,
            S = _.Observable,
            w = _.UserEvents,
            M = t.proxy,
            C = t.extend,
            D = _.getOffset,
            O = {},
            k = {},
            I = {},
            H = _.elementUnderCursor,
            W = "keyup",
            z = "change",
            P = "dragstart",
            U = "hold",
            L = "drag",
            A = "dragend",
            N = "dragcancel",
            V = "hintDestroyed",
            B = "dragenter",
            $ = "dragleave",
            F = "drop",
            j = S.extend({
                init: function(e, n) {
                    var r = this,
                        i = e[0];
                    r.capture = !1, i.addEventListener ? (t.each(_.eventMap.down.split(" "), function() {
                        i.addEventListener(this, M(r._press, r), !0)
                    }), t.each(_.eventMap.up.split(" "), function() {
                        i.addEventListener(this, M(r._release, r), !0)
                    })) : (t.each(_.eventMap.down.split(" "), function() {
                        i.attachEvent(this, M(r._press, r))
                    }), t.each(_.eventMap.up.split(" "), function() {
                        i.attachEvent(this, M(r._release, r))
                    })), S.fn.init.call(r), r.bind(["press", "release"], n || {})
                },
                captureNext: function() {
                    this.capture = !0
                },
                cancelCapture: function() {
                    this.capture = !1
                },
                _press: function(t) {
                    var e = this;
                    e.trigger("press"), e.capture && t.preventDefault()
                },
                _release: function(t) {
                    var e = this;
                    e.trigger("release"), e.capture && (t.preventDefault(), e.cancelCapture())
                }
            }),
            G = S.extend({
                init: function(e) {
                    var n = this;
                    S.fn.init.call(n), n.forcedEnabled = !1, t.extend(n, e), n.scale = 1, n.horizontal ? (n.measure = "offsetWidth", n.scrollSize = "scrollWidth", n.axis = "x") : (n.measure = "offsetHeight", n.scrollSize = "scrollHeight", n.axis = "y")
                },
                makeVirtual: function() {
                    t.extend(this, {
                        virtual: !0,
                        forcedEnabled: !0,
                        _virtualMin: 0,
                        _virtualMax: 0
                    })
                },
                virtualSize: function(t, e) {
                    this._virtualMin === t && this._virtualMax === e || (this._virtualMin = t, this._virtualMax = e, this.update())
                },
                outOfBounds: function(t) {
                    return t > this.max || t < this.min
                },
                forceEnabled: function() {
                    this.forcedEnabled = !0
                },
                getSize: function() {
                    return this.container[0][this.measure]
                },
                getTotal: function() {
                    return this.element[0][this.scrollSize]
                },
                rescale: function(t) {
                    this.scale = t
                },
                update: function(t) {
                    var e = this,
                        n = e.virtual ? e._virtualMax : e.getTotal(),
                        r = n * e.scale,
                        i = e.getSize();
                    (0 !== n || e.forcedEnabled) && (e.max = e.virtual ? -e._virtualMin : 0, e.size = i, e.total = r, e.min = Math.min(e.max, i - r), e.minScale = i / n, e.centerOffset = (r - i) / 2, e.enabled = e.forcedEnabled || r > i, t || e.trigger(z, e))
                }
            }),
            Q = S.extend({
                init: function(t) {
                    var e = this;
                    S.fn.init.call(e), e.x = new G(C({
                        horizontal: !0
                    }, t)), e.y = new G(C({
                        horizontal: !1
                    }, t)), e.container = t.container, e.forcedMinScale = t.minScale, e.maxScale = t.maxScale || 100, e.bind(z, t)
                },
                rescale: function(t) {
                    this.x.rescale(t), this.y.rescale(t), this.refresh()
                },
                centerCoordinates: function() {
                    return {
                        x: Math.min(0, -this.x.centerOffset),
                        y: Math.min(0, -this.y.centerOffset)
                    }
                },
                refresh: function() {
                    var t = this;
                    t.x.update(), t.y.update(), t.enabled = t.x.enabled || t.y.enabled, t.minScale = t.forcedMinScale || Math.min(t.x.minScale, t.y.minScale), t.fitScale = Math.max(t.x.minScale, t.y.minScale), t.trigger(z)
                }
            }),
            q = S.extend({
                init: function(t) {
                    var e = this;
                    C(e, t), S.fn.init.call(e)
                },
                outOfBounds: function() {
                    return this.dimension.outOfBounds(this.movable[this.axis])
                },
                dragMove: function(t) {
                    var e = this,
                        n = e.dimension,
                        r = e.axis,
                        i = e.movable,
                        o = i[r] + t;
                    n.enabled && ((o < n.min && t < 0 || o > n.max && t > 0) && (t *= e.resistance), i.translateAxis(r, t), e.trigger(z, e))
                }
            }),
            J = E.extend({
                init: function(e) {
                    var n, r, i, o, a = this;
                    C(a, {
                        elastic: !0
                    }, e), i = a.elastic ? .5 : 0, o = a.movable, a.x = n = new q({
                        axis: "x",
                        dimension: a.dimensions.x,
                        resistance: i,
                        movable: o
                    }), a.y = r = new q({
                        axis: "y",
                        dimension: a.dimensions.y,
                        resistance: i,
                        movable: o
                    }), a.userEvents.bind(["press", "move", "end", "gesturestart", "gesturechange"], {
                        gesturestart: function(t) {
                            a.gesture = t, a.offset = a.dimensions.container.offset()
                        },
                        press: function(e) {
                            t(e.event.target).closest("a").is("[data-navigate-on-press=true]") && e.sender.cancel()
                        },
                        gesturechange: function(t) {
                            var e, i, s, l = a.gesture,
                                c = l.center,
                                u = t.center,
                                h = t.distance / l.distance,
                                d = a.dimensions.minScale,
                                f = a.dimensions.maxScale;
                            o.scale <= d && h < 1 && (h += .8 * (1 - h)), o.scale * h >= f && (h = f / o.scale), i = o.x + a.offset.left, s = o.y + a.offset.top, e = {
                                x: (i - c.x) * h + u.x - i,
                                y: (s - c.y) * h + u.y - s
                            }, o.scaleWith(h), n.dragMove(e.x), r.dragMove(e.y), a.dimensions.rescale(o.scale), a.gesture = t, t.preventDefault()
                        },
                        move: function(t) {
                            t.event.target.tagName.match(/textarea|input/i) || (n.dimension.enabled || r.dimension.enabled ? (n.dragMove(t.x.delta), r.dragMove(t.y.delta), t.preventDefault()) : t.touch.skip())
                        },
                        end: function(t) {
                            t.preventDefault()
                        }
                    })
                }
            }),
            K = x.transitions.prefix + "Transform";
        f = x.hasHW3D ? function(t, e, n) {
            return "translate3d(" + t + "px," + e + "px,0) scale(" + n + ")"
        } : function(t, e, n) {
            return "translate(" + t + "px," + e + "px) scale(" + n + ")"
        }, p = S.extend({
            init: function(e) {
                var n = this;
                S.fn.init.call(n), n.element = t(e), n.element[0].style.webkitTransformOrigin = "left top", n.x = 0, n.y = 0, n.scale = 1, n._saveCoordinates(f(n.x, n.y, n.scale))
            },
            translateAxis: function(t, e) {
                this[t] += e, this.refresh()
            },
            scaleTo: function(t) {
                this.scale = t, this.refresh()
            },
            scaleWith: function(t) {
                this.scale *= t, this.refresh()
            },
            translate: function(t) {
                this.x += t.x, this.y += t.y, this.refresh()
            },
            moveAxis: function(t, e) {
                this[t] = e, this.refresh()
            },
            moveTo: function(t) {
                C(this, t), this.refresh()
            },
            refresh: function() {
                var t, e = this,
                    n = e.x,
                    r = e.y;
                e.round && (n = Math.round(n), r = Math.round(r)), t = f(n, r, e.scale), t != e.coordinates && (_.support.browser.msie && _.support.browser.version < 10 ? (e.element[0].style.position = "absolute", e.element[0].style.left = e.x + "px", e.element[0].style.top = e.y + "px") : e.element[0].style[K] = t, e._saveCoordinates(t), e.trigger(z))
            },
            _saveCoordinates: function(t) {
                this.coordinates = t
            }
        }), g = T.extend({
            init: function(t, e) {
                var n, r = this;
                T.fn.init.call(r, t, e), n = r.options.group, n in k ? k[n].push(r) : k[n] = [r]
            },
            events: [B, $, F],
            options: {
                name: "DropTarget",
                group: "default"
            },
            destroy: function() {
                s(k, this)
            },
            _trigger: function(t, e) {
                var n = this,
                    r = O[n.options.group];
                if (r) return n.trigger(t, C({}, e.event, {
                    draggable: r,
                    dropTarget: e.dropTarget
                }))
            },
            _over: function(t) {
                this._trigger(B, t)
            },
            _out: function(t) {
                this._trigger($, t)
            },
            _drop: function(t) {
                var e = this,
                    n = O[e.options.group];
                n && (n.dropped = !e._trigger(F, t))
            }
        }), g.destroyGroup = function(t) {
            var e, n = k[t] || I[t];
            if (n) {
                for (e = 0; e < n.length; e++) T.fn.destroy.call(n[e]);
                n.length = 0, delete k[t], delete I[t]
            }
        }, g._cache = k, v = g.extend({
            init: function(t, e) {
                var n, r = this;
                T.fn.init.call(r, t, e), n = r.options.group, n in I ? I[n].push(r) : I[n] = [r]
            },
            destroy: function() {
                s(I, this)
            },
            options: {
                name: "DropTargetArea",
                group: "default",
                filter: null
            }
        }), m = T.extend({
            init: function(t, e) {
                var n = this;
                T.fn.init.call(n, t, e), n._activated = !1, n.userEvents = new w(n.element, {
                    global: !0,
                    allowSelection: !0,
                    filter: n.options.filter,
                    threshold: n.options.distance,
                    start: M(n._start, n),
                    hold: M(n._hold, n),
                    move: M(n._drag, n),
                    end: M(n._end, n),
                    cancel: M(n._cancel, n),
                    select: M(n._select, n)
                }), n._afterEndHandler = M(n._afterEnd, n), n._captureEscape = M(n._captureEscape, n)
            },
            events: [U, P, L, A, N, V],
            options: {
                name: "Draggable",
                distance: _.support.touch ? 0 : 5,
                group: "default",
                cursorOffset: null,
                axis: null,
                container: null,
                filter: null,
                ignore: null,
                holdToDrag: !1,
                autoScroll: !1,
                dropped: !1
            },
            cancelHold: function() {
                this._activated = !1
            },
            _captureEscape: function(t) {
                var e = this;
                t.keyCode === _.keys.ESC && (e._trigger(N, {
                    event: t
                }), e.userEvents.cancel())
            },
            _updateHint: function(e) {
                var n, r = this,
                    o = r.options,
                    a = r.boundaries,
                    s = o.axis,
                    l = r.options.cursorOffset;
                l ? n = {
                    left: e.x.location + l.left,
                    top: e.y.location + l.top
                } : (r.hintOffset.left += e.x.delta, r.hintOffset.top += e.y.delta, n = t.extend({}, r.hintOffset)), a && (n.top = i(n.top, a.y), n.left = i(n.left, a.x)), "x" === s ? delete n.top : "y" === s && delete n.left, r.hint.css(n)
            },
            _shouldIgnoreTarget: function(e) {
                var n = this.options.ignore;
                return n && t(e).is(n)
            },
            _select: function(t) {
                this._shouldIgnoreTarget(t.event.target) || t.preventDefault()
            },
            _start: function(n) {
                var r, i = this,
                    a = i.options,
                    s = a.container ? t(a.container) : null,
                    l = a.hint;
                return this._shouldIgnoreTarget(n.touch.initialTouch) || a.holdToDrag && !i._activated ? (i.userEvents.cancel(), e) : (i.currentTarget = n.target, i.currentTargetOffset = D(i.currentTarget), l && (i.hint && i.hint.stop(!0, !0).remove(), i.hint = _.isFunction(l) ? t(l.call(i, i.currentTarget)) : l, r = D(i.currentTarget), i.hintOffset = r, i.hint.css({
                    position: "absolute",
                    zIndex: 2e4,
                    left: r.left,
                    top: r.top
                }).appendTo(y.body), i.angular("compile", function() {
                    i.hint.removeAttr("ng-repeat");
                    for (var e = t(n.target); !e.data("$$kendoScope") && e.length;) e = e.parent();
                    return {
                        elements: i.hint.get(),
                        scopeFrom: e.data("$$kendoScope")
                    }
                })), O[a.group] = i, i.dropped = !1, s && (i.boundaries = o(s, i.hint)), t(y).on(W, i._captureEscape), i._trigger(P, n) && (i.userEvents.cancel(), i._afterEnd()), i.userEvents.capture(), e)
            },
            _hold: function(t) {
                this.currentTarget = t.target, this._trigger(U, t) ? this.userEvents.cancel() : this._activated = !0
            },
            _drag: function(e) {
                var n, r;
                e.preventDefault(), n = this._elementUnderCursor(e), this.options.autoScroll && this._cursorElement !== n && (this._scrollableParent = u(n), this._cursorElement = n), this._lastEvent = e, this._processMovement(e, n), this.options.autoScroll && this._scrollableParent[0] && (r = h(e.x.location, e.y.location, l(this._scrollableParent)), this._scrollCompenstation = t.extend({}, this.hintOffset), this._scrollVelocity = r, 0 === r.y && 0 === r.x ? (clearInterval(this._scrollInterval), this._scrollInterval = null) : this._scrollInterval || (this._scrollInterval = setInterval(t.proxy(this, "_autoScroll"), 50))), this.hint && this._updateHint(e)
            },
            _processMovement: function(n, r) {
                this._withDropTarget(r, function(r, i) {
                    if (!r) return d && (d._trigger($, C(n, {
                        dropTarget: t(d.targetElement)
                    })), d = null), e;
                    if (d) {
                        if (i === d.targetElement) return;
                        d._trigger($, C(n, {
                            dropTarget: t(d.targetElement)
                        }))
                    }
                    r._trigger(B, C(n, {
                        dropTarget: t(i)
                    })), d = C(r, {
                        targetElement: i
                    })
                }), this._trigger(L, C(n, {
                    dropTarget: d,
                    elementUnderCursor: r
                }))
            },
            _autoScroll: function() {
                var t, e, n, r, i, o, a, s, l = this._scrollableParent[0],
                    u = this._scrollVelocity,
                    h = this._scrollCompenstation;
                l && (t = this._elementUnderCursor(this._lastEvent), this._processMovement(this._lastEvent, t), r = l === c()[0], r ? (e = y.body.scrollHeight > b.height(), n = y.body.scrollWidth > b.width()) : (e = l.offsetHeight <= l.scrollHeight, n = l.offsetWidth <= l.scrollWidth), i = l.scrollTop + u.y, o = e && i > 0 && i < l.scrollHeight, a = l.scrollLeft + u.x, s = n && a > 0 && a < l.scrollWidth, o && (l.scrollTop += u.y), s && (l.scrollLeft += u.x), this.hint && r && (s || o) && (o && (h.top += u.y), s && (h.left += u.x), this.hint.css(h)))
            },
            _end: function(e) {
                this._withDropTarget(this._elementUnderCursor(e), function(n, r) {
                    n && (n._drop(C({}, e, {
                        dropTarget: t(r)
                    })), d = null)
                }), this._cancel(this._trigger(A, e))
            },
            _cancel: function(t) {
                var e = this;
                e._scrollableParent = null, this._cursorElement = null, clearInterval(this._scrollInterval), e._activated = !1, e.hint && !e.dropped ? setTimeout(function() {
                    e.hint.stop(!0, !0), t ? e._afterEndHandler() : e.hint.animate(e.currentTargetOffset, "fast", e._afterEndHandler)
                }, 0) : e._afterEnd()
            },
            _trigger: function(t, e) {
                var n = this;
                return n.trigger(t, C({}, e.event, {
                    x: e.x,
                    y: e.y,
                    currentTarget: n.currentTarget,
                    initialTarget: e.touch ? e.touch.initialTouch : null,
                    dropTarget: e.dropTarget,
                    elementUnderCursor: e.elementUnderCursor
                }))
            },
            _elementUnderCursor: function(t) {
                var e = H(t),
                    r = this.hint;
                return r && n(r[0], e) && (r.hide(), e = H(t), e || (e = H(t)), r.show()), e
            },
            _withDropTarget: function(t, e) {
                var n, r = this.options.group,
                    i = k[r],
                    o = I[r];
                (i && i.length || o && o.length) && (n = a(t, i, o), n ? e(n.target, n.targetElement) : e())
            },
            destroy: function() {
                var t = this;
                T.fn.destroy.call(t), t._afterEnd(), t.userEvents.destroy(), this._scrollableParent = null, this._cursorElement = null, clearInterval(this._scrollInterval), t.currentTarget = null
            },
            _afterEnd: function() {
                var e = this;
                e.hint && e.hint.remove(), delete O[e.options.group], e.trigger("destroy"), e.trigger(V), t(y).off(W, e._captureEscape)
            }
        }), _.ui.plugin(g), _.ui.plugin(v), _.ui.plugin(m), _.TapCapture = j, _.containerBoundaries = o, C(_.ui, {
            Pane: J,
            PaneDimensions: Q,
            Movable: p
        }), _.ui.Draggable.utils = {
            autoScrollVelocity: h,
            scrollableViewPort: l,
            findScrollableParent: u
        }
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, n) {
    (n || e)()
});;
! function(e, define) {
    define("kendo.color.min", ["kendo.core.min"], e)
}(function() {
    function e(e, t, r) {
        void 0 === r && (r = "0");
        for (var n = e.toString(16); t > n.length;) n = r + n;
        return n
    }

    function t(e, t, r) {
        var n = r;
        return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + 6 * (t - e) * n : n < .5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e
    }

    function r(e, t) {
        var n, a, s;
        if (null == e || "none" === e) return null;
        if (e instanceof o) return e;
        if (s = e.toLowerCase(), n = f(s)) return s = "transparent" === n[1] ? new l(1, 1, 1, 0) : r(i[n[1]], t), s.match = [n[1]], s;
        if ((n = /^#?([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})\b/i.exec(s)) ? a = new u(parseInt(n[1], 16), parseInt(n[2], 16), parseInt(n[3], 16), 1) : (n = /^#?([0-9a-f])([0-9a-f])([0-9a-f])\b/i.exec(s)) ? a = new u(parseInt(n[1] + n[1], 16), parseInt(n[2] + n[2], 16), parseInt(n[3] + n[3], 16), 1) : (n = /^rgb\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/.exec(s)) ? a = new u(parseInt(n[1], 10), parseInt(n[2], 10), parseInt(n[3], 10), 1) : (n = /^rgba\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9.]+)\s*\)/.exec(s)) ? a = new u(parseInt(n[1], 10), parseInt(n[2], 10), parseInt(n[3], 10), parseFloat(n[4])) : (n = /^rgb\(\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*\)/.exec(s)) ? a = new l(parseFloat(n[1]) / 100, parseFloat(n[2]) / 100, parseFloat(n[3]) / 100, 1) : (n = /^rgba\(\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9]*\.?[0-9]+)%\s*,\s*([0-9.]+)\s*\)/.exec(s)) && (a = new l(parseFloat(n[1]) / 100, parseFloat(n[2]) / 100, parseFloat(n[3]) / 100, parseFloat(n[4]))), a) a.match = n;
        else if (!t) throw Error("Cannot parse color: " + s);
        return a
    }
    var n, a, i, s, f, o, l, u, h, d, c;
    window.kendo = window.kendo || {}, n = kendo.Class, a = kendo.support, i = {
        aliceblue: "f0f8ff",
        antiquewhite: "faebd7",
        aqua: "00ffff",
        aquamarine: "7fffd4",
        azure: "f0ffff",
        beige: "f5f5dc",
        bisque: "ffe4c4",
        black: "000000",
        blanchedalmond: "ffebcd",
        blue: "0000ff",
        blueviolet: "8a2be2",
        brown: "a52a2a",
        burlywood: "deb887",
        cadetblue: "5f9ea0",
        chartreuse: "7fff00",
        chocolate: "d2691e",
        coral: "ff7f50",
        cornflowerblue: "6495ed",
        cornsilk: "fff8dc",
        crimson: "dc143c",
        cyan: "00ffff",
        darkblue: "00008b",
        darkcyan: "008b8b",
        darkgoldenrod: "b8860b",
        darkgray: "a9a9a9",
        darkgrey: "a9a9a9",
        darkgreen: "006400",
        darkkhaki: "bdb76b",
        darkmagenta: "8b008b",
        darkolivegreen: "556b2f",
        darkorange: "ff8c00",
        darkorchid: "9932cc",
        darkred: "8b0000",
        darksalmon: "e9967a",
        darkseagreen: "8fbc8f",
        darkslateblue: "483d8b",
        darkslategray: "2f4f4f",
        darkslategrey: "2f4f4f",
        darkturquoise: "00ced1",
        darkviolet: "9400d3",
        deeppink: "ff1493",
        deepskyblue: "00bfff",
        dimgray: "696969",
        dimgrey: "696969",
        dodgerblue: "1e90ff",
        firebrick: "b22222",
        floralwhite: "fffaf0",
        forestgreen: "228b22",
        fuchsia: "ff00ff",
        gainsboro: "dcdcdc",
        ghostwhite: "f8f8ff",
        gold: "ffd700",
        goldenrod: "daa520",
        gray: "808080",
        grey: "808080",
        green: "008000",
        greenyellow: "adff2f",
        honeydew: "f0fff0",
        hotpink: "ff69b4",
        indianred: "cd5c5c",
        indigo: "4b0082",
        ivory: "fffff0",
        khaki: "f0e68c",
        lavender: "e6e6fa",
        lavenderblush: "fff0f5",
        lawngreen: "7cfc00",
        lemonchiffon: "fffacd",
        lightblue: "add8e6",
        lightcoral: "f08080",
        lightcyan: "e0ffff",
        lightgoldenrodyellow: "fafad2",
        lightgray: "d3d3d3",
        lightgrey: "d3d3d3",
        lightgreen: "90ee90",
        lightpink: "ffb6c1",
        lightsalmon: "ffa07a",
        lightseagreen: "20b2aa",
        lightskyblue: "87cefa",
        lightslategray: "778899",
        lightslategrey: "778899",
        lightsteelblue: "b0c4de",
        lightyellow: "ffffe0",
        lime: "00ff00",
        limegreen: "32cd32",
        linen: "faf0e6",
        magenta: "ff00ff",
        maroon: "800000",
        mediumaquamarine: "66cdaa",
        mediumblue: "0000cd",
        mediumorchid: "ba55d3",
        mediumpurple: "9370d8",
        mediumseagreen: "3cb371",
        mediumslateblue: "7b68ee",
        mediumspringgreen: "00fa9a",
        mediumturquoise: "48d1cc",
        mediumvioletred: "c71585",
        midnightblue: "191970",
        mintcream: "f5fffa",
        mistyrose: "ffe4e1",
        moccasin: "ffe4b5",
        navajowhite: "ffdead",
        navy: "000080",
        oldlace: "fdf5e6",
        olive: "808000",
        olivedrab: "6b8e23",
        orange: "ffa500",
        orangered: "ff4500",
        orchid: "da70d6",
        palegoldenrod: "eee8aa",
        palegreen: "98fb98",
        paleturquoise: "afeeee",
        palevioletred: "d87093",
        papayawhip: "ffefd5",
        peachpuff: "ffdab9",
        peru: "cd853f",
        pink: "ffc0cb",
        plum: "dda0dd",
        powderblue: "b0e0e6",
        purple: "800080",
        red: "ff0000",
        rosybrown: "bc8f8f",
        royalblue: "4169e1",
        saddlebrown: "8b4513",
        salmon: "fa8072",
        sandybrown: "f4a460",
        seagreen: "2e8b57",
        seashell: "fff5ee",
        sienna: "a0522d",
        silver: "c0c0c0",
        skyblue: "87ceeb",
        slateblue: "6a5acd",
        slategray: "708090",
        slategrey: "708090",
        snow: "fffafa",
        springgreen: "00ff7f",
        steelblue: "4682b4",
        tan: "d2b48c",
        teal: "008080",
        thistle: "d8bfd8",
        tomato: "ff6347",
        turquoise: "40e0d0",
        violet: "ee82ee",
        wheat: "f5deb3",
        white: "ffffff",
        whitesmoke: "f5f5f5",
        yellow: "ffff00",
        yellowgreen: "9acd32"
    }, s = a.browser, f = function(e) {
        var t, r = Object.keys(i);
        return r.push("transparent"), t = RegExp("^(" + r.join("|") + ")(\\W|$)", "i"), f = function(e) {
            return t.exec(e)
        }, t.exec(e)
    }, o = n.extend({
        init: function() {},
        toHSV: function() {
            return this
        },
        toRGB: function() {
            return this
        },
        toHex: function() {
            return this.toBytes().toHex()
        },
        toBytes: function() {
            return this
        },
        toCss: function() {
            return "#" + this.toHex()
        },
        toCssRgba: function() {
            var e = this.toBytes();
            return "rgba(" + e.r + ", " + e.g + ", " + e.b + ", " + parseFloat((+this.a).toFixed(3)) + ")"
        },
        toDisplay: function() {
            return s.msie && s.version < 9 ? this.toCss() : this.toCssRgba()
        },
        equals: function(e) {
            return e === this || null !== e && this.toCssRgba() === r(e).toCssRgba()
        },
        diff: function(e) {
            var t, r;
            return null === e ? NaN : (t = this.toBytes(), r = e.toBytes(), Math.sqrt(Math.pow(.3 * (t.r - r.r), 2) + Math.pow(.59 * (t.g - r.g), 2) + Math.pow(.11 * (t.b - r.b), 2)))
        },
        clone: function() {
            var e = this.toBytes();
            return e === this && (e = new u(e.r, e.g, e.b, e.a)), e
        }
    }), l = o.extend({
        init: function(e, t, r, n) {
            o.fn.init.call(this), this.r = e, this.g = t, this.b = r, this.a = n
        },
        toHSV: function() {
            var e, t, r = this,
                n = r.r,
                a = r.g,
                i = r.b,
                s = Math.min(n, a, i),
                f = Math.max(n, a, i),
                o = f - s,
                l = f;
            return 0 === o ? new h(0, 0, l, this.a) : (0 !== f ? (t = o / f, e = n === f ? (a - i) / o : a === f ? 2 + (i - n) / o : 4 + (n - a) / o, e *= 60, e < 0 && (e += 360)) : (t = 0, e = -1), new h(e, t, l, this.a))
        },
        toHSL: function() {
            var e, t, r, n = this,
                a = n.r,
                i = n.g,
                s = n.b,
                f = Math.max(a, i, s),
                o = Math.min(a, i, s),
                l = (f + o) / 2;
            if (f === o) e = t = 0;
            else switch (r = f - o, t = l > .5 ? r / (2 - f - o) : r / (f + o), f) {
                case a:
                    e = (i - s) / r + (i < s ? 6 : 0);
                    break;
                case i:
                    e = (s - a) / r + 2;
                    break;
                case s:
                    e = (a - i) / r + 4
            }
            return new d(60 * e, 100 * t, 100 * l, this.a)
        },
        toBytes: function() {
            return new u(255 * this.r, 255 * this.g, 255 * this.b, this.a)
        }
    }), u = l.extend({
        init: function(e, t, r, n) {
            l.fn.init.call(this, Math.round(e), Math.round(t), Math.round(r), n)
        },
        toRGB: function() {
            return new l(this.r / 255, this.g / 255, this.b / 255, this.a)
        },
        toHSV: function() {
            return this.toRGB().toHSV()
        },
        toHSL: function() {
            return this.toRGB().toHSL()
        },
        toHex: function() {
            return e(this.r, 2) + e(this.g, 2) + e(this.b, 2)
        },
        toBytes: function() {
            return this
        }
    }), h = o.extend({
        init: function(e, t, r, n) {
            o.fn.init.call(this), this.h = e, this.s = t, this.v = r, this.a = n
        },
        toRGB: function() {
            var e, t, r, n, a, i, s, f, o = this,
                u = o.h,
                h = o.s,
                d = o.v;
            if (0 === h) e = t = r = d;
            else switch (u /= 60, n = Math.floor(u), a = u - n, i = d * (1 - h), s = d * (1 - h * a), f = d * (1 - h * (1 - a)), n) {
                case 0:
                    e = d, t = f, r = i;
                    break;
                case 1:
                    e = s, t = d, r = i;
                    break;
                case 2:
                    e = i, t = d, r = f;
                    break;
                case 3:
                    e = i, t = s, r = d;
                    break;
                case 4:
                    e = f, t = i, r = d;
                    break;
                default:
                    e = d, t = i, r = s
            }
            return new l(e, t, r, this.a)
        },
        toHSL: function() {
            return this.toRGB().toHSL()
        },
        toBytes: function() {
            return this.toRGB().toBytes()
        }
    }), d = o.extend({
        init: function(e, t, r, n) {
            o.fn.init.call(this), this.h = e, this.s = t, this.l = r, this.a = n
        },
        toRGB: function() {
            var e, r, n, a, i, s = this.h / 360,
                f = this.s / 100,
                o = this.l / 100;
            return 0 === f ? e = r = n = o : (a = o < .5 ? o * (1 + f) : o + f - o * f, i = 2 * o - a, e = t(i, a, s + 1 / 3), r = t(i, a, s), n = t(i, a, s - 1 / 3)), new l(e, r, n, this.a)
        },
        toHSV: function() {
            return this.toRGB().toHSV()
        },
        toBytes: function() {
            return this.toRGB().toBytes()
        }
    }), c = n.extend({
        init: function(e) {
            var t, r, n, a, i, s, f, o = this;
            if (1 === arguments.length)
                for (t = c.formats, r = this.resolveColor(e), n = 0; n < t.length; n++) a = t[n].re, i = t[n].process, s = a.exec(r), s && (f = i(s), o.r = f[0], o.g = f[1], o.b = f[2]);
            else this.r = arguments[0], this.g = arguments[1], this.b = arguments[2];
            this.r = this.normalizeByte(this.r), this.g = this.normalizeByte(this.g), this.b = this.normalizeByte(this.b)
        },
        toHex: function() {
            var e = this.padDigit,
                t = this.r.toString(16),
                r = this.g.toString(16),
                n = this.b.toString(16);
            return "#" + e(t) + e(r) + e(n)
        },
        resolveColor: function(e) {
            var t = e || "black";
            return "#" === t.charAt(0) && (t = t.substr(1, 6)), t = t.replace(/ /g, ""), t = t.toLowerCase(), t = c.namedColors[t] || t
        },
        normalizeByte: function(e) {
            return e < 0 || isNaN(e) ? 0 : e > 255 ? 255 : e
        },
        padDigit: function(e) {
            return 1 === e.length ? "0" + e : e
        },
        brightness: function(e) {
            var t = Math.round;
            return this.r = t(this.normalizeByte(this.r * e)), this.g = t(this.normalizeByte(this.g * e)), this.b = t(this.normalizeByte(this.b * e)), this
        },
        percBrightness: function() {
            return Math.sqrt(.241 * this.r * this.r + .691 * this.g * this.g + .068 * this.b * this.b)
        }
    }), c.fromBytes = function(e, t, r, n) {
        return new u(e, t, r, null != n ? n : 1)
    }, c.fromRGB = function(e, t, r, n) {
        return new l(e, t, r, null != n ? n : 1)
    }, c.fromHSV = function(e, t, r, n) {
        return new h(e, t, r, null != n ? n : 1)
    }, c.fromHSL = function(e, t, r, n) {
        return new d(e, t, r, null != n ? n : 1)
    }, c.formats = [{
        re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
        process: function(e) {
            return [parseInt(e[1], 10), parseInt(e[2], 10), parseInt(e[3], 10)]
        }
    }, {
        re: /^(\w{2})(\w{2})(\w{2})$/,
        process: function(e) {
            return [parseInt(e[1], 16), parseInt(e[2], 16), parseInt(e[3], 16)]
        }
    }, {
        re: /^(\w{1})(\w{1})(\w{1})$/,
        process: function(e) {
            return [parseInt(e[1] + e[1], 16), parseInt(e[2] + e[2], 16), parseInt(e[3] + e[3], 16)]
        }
    }], c.namedColors = i, kendo.deepExtend(kendo, {
        parseColor: r,
        Color: c
    })
}, "function" == typeof define && define.amd ? define : function(e, t, r) {
    (r || t)()
});;
! function(e, define) {
    define("kendo.popup.min", ["kendo.core.min"], e)
}(function() {
    return function(e, t) {
        function o(t, o) {
            return !(!t || !o) && (t === o || e.contains(t, o))
        }
        var n, i, s, r, a = window.kendo,
            l = a.ui,
            d = l.Widget,
            p = a.Class,
            c = a.support,
            f = a.getOffset,
            u = a._outerWidth,
            h = a._outerHeight,
            m = "open",
            g = "close",
            w = "deactivate",
            v = "activate",
            _ = "center",
            b = "left",
            y = "right",
            k = "top",
            x = "bottom",
            T = "absolute",
            z = "hidden",
            C = "body",
            P = "location",
            S = "position",
            E = "visible",
            I = "effects",
            R = "k-state-active",
            A = "k-state-border",
            D = /k-state-border-(\w+)/,
            O = ".k-picker-wrap, .k-dropdown-wrap, .k-link",
            F = "down",
            H = e(document.documentElement),
            N = e.proxy,
            W = e(window),
            L = "scroll",
            j = c.transitions.css,
            M = j + "transform",
            K = e.extend,
            U = ".kendoPopup",
            Y = ["font-size", "font-family", "font-stretch", "font-style", "font-weight", "line-height"],
            Q = d.extend({
                init: function(t, o) {
                    var n, i = this;
                    o = o || {}, o.isRtl && (o.origin = o.origin || x + " " + y, o.position = o.position || k + " " + y), d.fn.init.call(i, t, o), t = i.element, o = i.options, i.collisions = o.collision ? o.collision.split(" ") : [], i.downEvent = a.applyEventMap(F, a.guid()), 1 === i.collisions.length && i.collisions.push(i.collisions[0]), n = e(i.options.anchor).closest(".k-popup,.k-group").filter(":not([class^=km-])"), o.appendTo = e(e(o.appendTo)[0] || n[0] || document.body), i.element.hide().addClass("k-popup k-group k-reset").toggleClass("k-rtl", !!o.isRtl).css({
                        position: T
                    }).appendTo(o.appendTo).attr("aria-hidden", !0).on("mouseenter" + U, function() {
                        i._hovered = !0
                    }).on("wheel" + U, function(t) {
                        var o = e(t.target).find(".k-list"),
                            n = o.parent();
                        o.length && o.is(":visible") && (0 === n.scrollTop() && t.originalEvent.deltaY < 0 || n.scrollTop() === n.prop("scrollHeight") - n.prop("offsetHeight") && t.originalEvent.deltaY > 0) && t.preventDefault()
                    }).on("mouseleave" + U, function() {
                        i._hovered = !1
                    }), i.wrapper = e(), o.animation === !1 && (o.animation = {
                        open: {
                            effects: {}
                        },
                        close: {
                            hide: !0,
                            effects: {}
                        }
                    }), K(o.animation.open, {
                        complete: function() {
                            i.wrapper.css({
                                overflow: E
                            }), i._activated = !0, i._trigger(v)
                        }
                    }), K(o.animation.close, {
                        complete: function() {
                            i._animationClose()
                        }
                    }), i._mousedownProxy = function(e) {
                        i._mousedown(e)
                    }, i._resizeProxy = c.mobileOS.android ? function(e) {
                        setTimeout(function() {
                            i._resize(e)
                        }, 600)
                    } : function(e) {
                        i._resize(e)
                    }, o.toggleTarget && e(o.toggleTarget).on(o.toggleEvent + U, e.proxy(i.toggle, i))
                },
                events: [m, v, g, w],
                options: {
                    name: "Popup",
                    toggleEvent: "click",
                    origin: x + " " + b,
                    position: k + " " + b,
                    anchor: C,
                    appendTo: null,
                    collision: "flip fit",
                    viewport: window,
                    copyAnchorStyles: !0,
                    autosize: !1,
                    modal: !1,
                    adjustSize: {
                        width: 0,
                        height: 0
                    },
                    animation: {
                        open: {
                            effects: "slideIn:down",
                            transition: !0,
                            duration: 200
                        },
                        close: {
                            duration: 100,
                            hide: !0
                        }
                    }
                },
                _animationClose: function() {
                    var e = this,
                        t = e.wrapper.data(P);
                    e.wrapper.hide(), t && e.wrapper.css(t), e.options.anchor != C && e._hideDirClass(), e._closing = !1, e._trigger(w)
                },
                destroy: function() {
                    var t, o = this,
                        n = o.options,
                        i = o.element.off(U);
                    d.fn.destroy.call(o), n.toggleTarget && e(n.toggleTarget).off(U), n.modal || (H.off(o.downEvent, o._mousedownProxy), o._toggleResize(!1)), a.destroy(o.element.children()), i.removeData(), n.appendTo[0] === document.body && (t = i.parent(".k-animation-container"), t[0] ? t.remove() : i.remove())
                },
                open: function(t, o) {
                    var n, i, s = this,
                        r = {
                            isFixed: !isNaN(parseInt(o, 10)),
                            x: t,
                            y: o
                        },
                        l = s.element,
                        d = s.options,
                        p = e(d.anchor),
                        f = l[0] && l.hasClass("km-widget");
                    if (!s.visible()) {
                        if (d.copyAnchorStyles && (f && "font-size" == Y[0] && Y.shift(), l.css(a.getComputedStyles(p[0], Y))), l.data("animating") || s._trigger(m)) return;
                        s._activated = !1, d.modal || (H.off(s.downEvent, s._mousedownProxy).on(s.downEvent, s._mousedownProxy), s._toggleResize(!1), s._toggleResize(!0)), s.wrapper = i = a.wrap(l, d.autosize).css({
                            overflow: z,
                            display: "block",
                            position: T
                        }).attr("aria-hidden", !1), c.mobileOS.android && i.css(M, "translatez(0)"), i.css(S), e(d.appendTo)[0] == document.body && i.css(k, "-10000px"), s.flipped = s._position(r), n = s._openAnimation(), d.anchor != C && s._showDirClass(n), l.data(I, n.effects).kendoStop(!0).kendoAnimate(n).attr("aria-hidden", !1)
                    }
                },
                _location: function(t) {
                    var o, n, i = this,
                        s = i.element,
                        r = i.options,
                        l = e(r.anchor),
                        d = s[0] && s.hasClass("km-widget");
                    return r.copyAnchorStyles && (d && "font-size" == Y[0] && Y.shift(), s.css(a.getComputedStyles(l[0], Y))), i.wrapper = o = a.wrap(s, r.autosize).css({
                        overflow: z,
                        display: "block",
                        position: T
                    }), c.mobileOS.android && o.css(M, "translatez(0)"), o.css(S), e(r.appendTo)[0] == document.body && o.css(k, "-10000px"), i._position(t || {}), n = o.offset(), {
                        width: a._outerWidth(o),
                        height: a._outerHeight(o),
                        left: n.left,
                        top: n.top
                    }
                },
                _openAnimation: function() {
                    var e = K(!0, {}, this.options.animation.open);
                    return e.effects = a.parseEffects(e.effects, this.flipped), e
                },
                _hideDirClass: function() {
                    var t = e(this.options.anchor),
                        o = ((t.attr("class") || "").match(D) || ["", "down"])[1],
                        n = A + "-" + o;
                    t.removeClass(n).children(O).removeClass(R).removeClass(n), this.element.removeClass(A + "-" + a.directions[o].reverse)
                },
                _showDirClass: function(t) {
                    var o = t.effects.slideIn ? t.effects.slideIn.direction : "down",
                        n = A + "-" + o;
                    e(this.options.anchor).addClass(n).children(O).addClass(R).addClass(n), this.element.addClass(A + "-" + a.directions[o].reverse)
                },
                position: function() {
                    this.visible() && (this.flipped = this._position())
                },
                toggle: function() {
                    var e = this;
                    e[e.visible() ? g : m]()
                },
                visible: function() {
                    return this.element.is(":" + E)
                },
                close: function(o) {
                    var n, i, s, r, l = this,
                        d = l.options;
                    if (l.visible()) {
                        if (n = l.wrapper[0] ? l.wrapper : a.wrap(l.element).hide(), l._toggleResize(!1), l._closing || l._trigger(g)) return l._toggleResize(!0), t;
                        l.element.find(".k-popup").each(function() {
                            var t = e(this),
                                n = t.data("kendoPopup");
                            n && n.close(o)
                        }), H.off(l.downEvent, l._mousedownProxy), o ? i = {
                            hide: !0,
                            effects: {}
                        } : (i = K(!0, {}, d.animation.close), s = l.element.data(I), r = i.effects, !r && !a.size(r) && s && a.size(s) && (i.effects = s, i.reverse = !0), l._closing = !0), l.element.kendoStop(!0).attr("aria-hidden", !0), n.css({
                            overflow: z
                        }).attr("aria-hidden", !0), l.element.kendoAnimate(i), o && l._animationClose()
                    }
                },
                _trigger: function(e) {
                    return this.trigger(e, {
                        type: e
                    })
                },
                _resize: function(e) {
                    var t = this;
                    c.resize.indexOf(e.type) !== -1 ? (clearTimeout(t._resizeTimeout), t._resizeTimeout = setTimeout(function() {
                        t._position(), t._resizeTimeout = null
                    }, 50)) : (!t._hovered || t._activated && t.element.hasClass("k-list-container")) && t.close()
                },
                _toggleResize: function(e) {
                    var t = e ? "on" : "off",
                        o = c.resize;
                    c.mobileOS.ios || c.mobileOS.android || (o += " " + L), e && !this.scrollableParents && (this.scrollableParents = this._scrollableParents()), this.scrollableParents && this.scrollableParents.length && this.scrollableParents[t](L, this._resizeProxy), W[t](o, this._resizeProxy)
                },
                _mousedown: function(t) {
                    var n = this,
                        i = n.element[0],
                        s = n.options,
                        r = e(s.anchor)[0],
                        l = s.toggleTarget,
                        d = a.eventTarget(t),
                        p = e(d).closest(".k-popup"),
                        c = p.parent().parent(".km-shim").length;
                    p = p[0], !c && p && p !== n.element[0] || "popover" !== e(t.target).closest("a").data("rel") && (o(i, d) || o(r, d) || l && o(e(l)[0], d) || n.close())
                },
                _fit: function(e, t, o) {
                    var n = 0;
                    return e + t > o && (n = o - (e + t)), e < 0 && (n = -e), n
                },
                _flip: function(e, t, o, n, i, s, r) {
                    var a = 0;
                    return r = r || t, s !== i && s !== _ && i !== _ && (e + r > n && (a += -(o + t)), e + a < 0 && (a += o + t)), a
                },
                _scrollableParents: function() {
                    return e(this.options.anchor).parentsUntil("body").filter(function(e, t) {
                        return a.isScrollable(t)
                    })
                },
                _position: function(t) {
                    var o, n, i, s, r, l, d, p, m, g, w, v, _, b, y, k, x, z = this,
                        C = z.element,
                        E = z.wrapper,
                        I = z.options,
                        R = e(I.viewport),
                        A = c.zoomLevel(),
                        D = !!(R[0] == window && window.innerWidth && A <= 1.02),
                        O = e(I.anchor),
                        F = I.origin.toLowerCase().split(" "),
                        H = I.position.toLowerCase().split(" "),
                        N = z.collisions,
                        W = 10002,
                        L = 0,
                        j = document.documentElement;
                    if (r = I.viewport === window ? {
                            top: window.pageYOffset || document.documentElement.scrollTop || 0,
                            left: window.pageXOffset || document.documentElement.scrollLeft || 0
                        } : R.offset(), D ? (l = window.innerWidth, d = window.innerHeight) : (l = R.width(), d = R.height()), D && j.scrollHeight - j.clientHeight > 0 && (p = I.isRtl ? -1 : 1, l -= p * a.support.scrollbar()), o = O.parents().filter(E.siblings()), o[0])
                        if (i = Math.max(+o.css("zIndex"), 0)) W = i + 10;
                        else
                            for (n = O.parentsUntil(o), s = n.length; L < s; L++) i = +e(n[L]).css("zIndex"), i && W < i && (W = i + 10);
                    return E.css("zIndex", W), E.css(t && t.isFixed ? {
                        left: t.x,
                        top: t.y
                    } : z._align(F, H)), m = f(E, S, O[0] === E.offsetParent()[0]), g = f(E), w = O.offsetParent().parent(".k-animation-container,.k-popup,.k-group"), w.length && (m = f(E, S, !0), g = f(E)), g.top -= r.top, g.left -= r.left, z.wrapper.data(P) || E.data(P, K({}, m)), v = K({}, g), _ = K({}, m), b = I.adjustSize, "fit" === N[0] && (_.top += z._fit(v.top, h(E) + b.height, d / A)), "fit" === N[1] && (_.left += z._fit(v.left, u(E) + b.width, l / A)), y = K({}, _), k = h(C), x = h(E), !E.height() && k && (x += k), "flip" === N[0] && (_.top += z._flip(v.top, k, h(O), d / A, F[0], H[0], x)), "flip" === N[1] && (_.left += z._flip(v.left, u(C), u(O), l / A, F[1], H[1], u(E))), C.css(S, T), E.css(_), _.left != y.left || _.top != y.top
                },
                _align: function(t, o) {
                    var n, i = this,
                        s = i.wrapper,
                        r = e(i.options.anchor),
                        a = t[0],
                        l = t[1],
                        d = o[0],
                        p = o[1],
                        c = f(r),
                        m = e(i.options.appendTo),
                        g = u(s),
                        w = h(s) || h(s.children().first()),
                        v = u(r),
                        b = h(r),
                        k = c.top,
                        T = c.left,
                        z = Math.round;
                    return m[0] != document.body && (n = f(m), k -= n.top, T -= n.left), a === x && (k += b), a === _ && (k += z(b / 2)), d === x && (k -= w), d === _ && (k -= z(w / 2)), l === y && (T += v), l === _ && (T += z(v / 2)), p === y && (T -= g), p === _ && (T -= z(g / 2)), {
                        top: k,
                        left: T
                    }
                }
            });
        l.plugin(Q), n = a.support.stableSort, i = "kendoTabKeyTrap", s = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex], *[contenteditable]", r = p.extend({
            init: function(t) {
                this.element = e(t), this.element.autoApplyNS(i)
            },
            trap: function() {
                this.element.on("keydown", N(this._keepInTrap, this))
            },
            removeTrap: function() {
                this.element.kendoDestroy(i)
            },
            destroy: function() {
                this.element.kendoDestroy(i), this.element = t
            },
            shouldTrap: function() {
                return !0
            },
            _keepInTrap: function(e) {
                var t, o, n;
                9 === e.which && this.shouldTrap() && !e.isDefaultPrevented() && (t = this._focusableElements(), o = this._sortFocusableElements(t), n = this._nextFocusable(e, o), this._focus(n), e.preventDefault())
            },
            _focusableElements: function() {
                var t = this.element.find(s).filter(function(t, o) {
                    return o.tabIndex >= 0 && e(o).is(":visible") && !e(o).is("[disabled]")
                });
                return this.element.is("[tabindex]") && t.push(this.element[0]), t
            },
            _sortFocusableElements: function(e) {
                var t, o;
                return n ? t = e.sort(function(e, t) {
                    return e.tabIndex - t.tabIndex
                }) : (o = "__k_index", e.each(function(e, t) {
                    t.setAttribute(o, e)
                }), t = e.sort(function(e, t) {
                    return e.tabIndex === t.tabIndex ? parseInt(e.getAttribute(o), 10) - parseInt(t.getAttribute(o), 10) : e.tabIndex - t.tabIndex
                }), e.removeAttr(o)), t
            },
            _nextFocusable: function(e, t) {
                var o = t.length,
                    n = t.index(e.target);
                return t.get((n + (e.shiftKey ? -1 : 1)) % o)
            },
            _focus: function(e) {
                return "IFRAME" == e.nodeName ? (e.contentWindow.document.body.focus(), t) : (e.focus(), "INPUT" == e.nodeName && e.setSelectionRange && this._haveSelectionRange(e) && e.setSelectionRange(0, e.value.length), t)
            },
            _haveSelectionRange: function(e) {
                var t = e.type.toLowerCase();
                return "text" === t || "search" === t || "url" === t || "tel" === t || "password" === t
            }
        }), l.Popup.TabKeyTrap = r
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, o) {
    (o || t)()
});;
! function(t, define) {
    define("drawing/util.min", ["kendo.core.min"], t)
}(function() {
    return function(t) {
        function e() {
            return t.Deferred()
        }

        function n(e) {
            return t.when.apply(t, e)
        }
        kendo.drawing.util = kendo.drawing.util || {}, kendo.deepExtend(kendo.drawing.util, {
            createPromise: e,
            promiseAll: n
        })
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, n) {
    (n || e)()
}),
function(t, define) {
    define("util/text-metrics.min", ["kendo.core.min"], t)
}(function() {
    ! function(t) {
        function e(t) {
            return (t + "").replace(a, h)
        }

        function n(t) {
            var e, n = [];
            for (e in t) n.push(e + t[e]);
            return n.sort().join("")
        }

        function i(t) {
            var e, n = 2166136261;
            for (e = 0; e < t.length; ++e) n += (n << 1) + (n << 4) + (n << 7) + (n << 8) + (n << 24), n ^= t.charCodeAt(e);
            return n >>> 0
        }

        function r() {
            return {
                width: 0,
                height: 0,
                baseline: 0
            }
        }

        function o(t, e, n) {
            return u.current.measure(t, e, n)
        }
        var s, a, h, l, c, u;
        window.kendo.util = window.kendo.util || {}, s = kendo.Class.extend({
            init: function(t) {
                this._size = t, this._length = 0, this._map = {}
            },
            put: function(t, e) {
                var n = this._map,
                    i = {
                        key: t,
                        value: e
                    };
                n[t] = i, this._head ? (this._tail.newer = i, i.older = this._tail, this._tail = i) : this._head = this._tail = i, this._length >= this._size ? (n[this._head.key] = null, this._head = this._head.newer, this._head.older = null) : this._length++
            },
            get: function(t) {
                var e = this._map[t];
                if (e) return e === this._head && e !== this._tail && (this._head = e.newer, this._head.older = null), e !== this._tail && (e.older && (e.older.newer = e.newer, e.newer.older = e.older), e.older = this._tail, e.newer = null, this._tail.newer = e, this._tail = e), e.value
            }
        }), a = /\r?\n|\r|\t/g, h = " ", l = {
            baselineMarkerSize: 1
        }, "undefined" != typeof document && (c = document.createElement("div"), c.style.cssText = "position: absolute !important; top: -4000px !important; width: auto !important; height: auto !important;padding: 0 !important; margin: 0 !important; border: 0 !important;line-height: normal !important; visibility: hidden !important; white-space: pre!important;"), u = kendo.Class.extend({
            init: function(e) {
                this._cache = new s(1e3), this.options = t.extend({}, l, e)
            },
            measure: function(t, o, s) {
                var a, h, l, u, d, f, p, g, m;
                if (void 0 === s && (s = {}), !t) return r();
                if (a = n(o), h = i(t + a), l = this._cache.get(h)) return l;
                u = r(), d = s.box || c, f = this._baselineMarker().cloneNode(!1);
                for (p in o) g = o[p], void 0 !== g && (d.style[p] = g);
                return m = s.normalizeText !== !1 ? e(t) : t + "", d.textContent = m, d.appendChild(f), document.body.appendChild(d), m.length && (u.width = d.offsetWidth - this.options.baselineMarkerSize, u.height = d.offsetHeight, u.baseline = f.offsetTop + this.options.baselineMarkerSize), u.width > 0 && u.height > 0 && this._cache.put(h, u), d.parentNode.removeChild(d), u
            },
            _baselineMarker: function() {
                var t = document.createElement("div");
                return t.style.cssText = "display: inline-block; vertical-align: baseline;width: " + this.options.baselineMarkerSize + "px; height: " + this.options.baselineMarkerSize + "px;overflow: hidden;", t
            }
        }), u.current = new u, kendo.deepExtend(kendo.util, {
            LRUCache: s,
            TextMetrics: u,
            measureText: o,
            objectKey: n,
            hashKey: i,
            normalizeText: e
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(t, e, n) {
    (n || e)()
}),
function(t, define) {
    define("drawing/kendo-drawing.min", ["drawing/util.min", "kendo.color.min", "util/text-metrics.min"], t)
}(function() {
    ! function(t) {
        function e(t, e) {
            return t.push.apply(t, e), t
        }

        function n(t) {
            for (var e = [1e3, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1], n = ""; t > 0;) t < e[0] ? e.shift() : (n += Qe[e[0]], t -= e[0]);
            return n
        }

        function i(t) {
            return typeof t !== Ze
        }

        function r() {
            return "kdef" + Je++
        }

        function o(t) {
            return t / Ke
        }

        function s(t) {
            var e, n, i = "";
            for (e = 0; e < t.length; e++) n = t.charCodeAt(e), n < 128 ? i += rn(n) : n < 2048 ? (i += rn(192 | n >>> 6), i += rn(128 | 63 & n)) : n < 65536 && (i += rn(224 | n >>> 12), i += rn(128 | n >>> 6 & 63), i += rn(128 | 63 & n));
            return i
        }

        function a(t) {
            for (var e, n, i, r, o, a, h, l = "", c = 0, u = s(t); c < u.length;) e = u.charCodeAt(c++), n = u.charCodeAt(c++), i = u.charCodeAt(c++), r = e >> 2, o = (3 & e) << 4 | n >> 4, a = (15 & n) << 2 | i >> 6, h = 63 & i, isNaN(n) ? a = h = 64 : isNaN(i) && (h = 64), l = l + nn.charAt(r) + nn.charAt(o) + nn.charAt(a) + nn.charAt(h);
            return l
        }

        function h(t) {
            return i((t.x || {}).location) ? {
                x: t.x.location,
                y: t.y.location
            } : {
                x: t.pageX || t.clientX || 0,
                y: t.pageY || t.clientY || 0
            }
        }

        function l(t) {
            return void 0 === t && (t = {}), t.touch ? t.touch.initialTouch : t.target
        }

        function c(t) {
            return "" === t || null === t || "none" === t || "transparent" === t || !i(t)
        }

        function u(t) {
            if (t) return t[t.length - 1]
        }

        function d(t, e, n) {
            return Math.max(Math.min(t, n), e)
        }

        function f(t, e) {
            function n(t, n) {
                for (var i = [], r = 0, o = 0, s = 0; r < t.length && o < n.length;) e(t[r], n[o]) <= 0 ? i[s++] = t[r++] : i[s++] = n[o++];
                return r < t.length && i.push.apply(i, t.slice(r)), o < n.length && i.push.apply(i, n.slice(o)), i
            }
            return t.length < 2 ? t.slice() : function i(t) {
                var e, r, o;
                return t.length <= 1 ? t : (e = Math.floor(t.length / 2), r = t.slice(0, e), o = t.slice(e), r = i(r), o = i(o), n(r, o))
            }(t)
        }

        function p(t) {
            return t * Ke
        }

        function g(t) {
            return t ? Math.pow(10, t) : 1
        }

        function m(t, e) {
            var n = g(e);
            return Math.round(t * n) / n
        }

        function v(t, e) {
            return i(t) ? t : e
        }

        function x(t, e) {
            var n, i, r;
            for (n in e)
                for (i = n.trim().split(" "), r = 0; r < i.length; r++) t.addEventListener(i[r], e[n], !1)
        }

        function y(t) {
            var e = t.getBoundingClientRect(),
                n = document.documentElement;
            return {
                top: e.top + (window.pageYOffset || n.scrollTop) - (n.clientTop || 0),
                left: e.left + (window.pageXOffset || n.scrollLeft) - (n.clientLeft || 0)
            }
        }

        function w(t, e) {
            var n, i, r = {},
                o = window.getComputedStyle(t) || {},
                s = Array.isArray(e) ? e : [e];
            for (n = 0; n < s.length; n++) i = s[n], r[i] = o[i];
            return r
        }

        function _(t) {
            return isNaN(t) ? t : t + "px"
        }

        function b(t, e) {
            var n, r, o;
            return e ? (n = e.width, r = e.height, i(n) && (t.style.width = _(n)), i(r) && (t.style.height = _(r)), void 0) : (o = w(t, ["width", "height"]), {
                width: parseInt(o.width, 10),
                height: parseInt(o.height, 10)
            })
        }

        function C(t, e) {
            var n, i, r;
            void 0 === e && (e = {});
            for (n in e)
                for (i = n.trim().split(" "), r = 0; r < i.length; r++) t.removeEventListener(i[r], e[n], !1)
        }

        function k(t) {
            return function(e) {
                return this[t] !== e && (this[t] = e, this.geometryChange()), this
            }
        }

        function T(t) {
            return function() {
                return this[t]
            }
        }

        function M(t, e) {
            var n, i, r;
            for (n = 0; n < e.length; n++) i = e[n], r = i.charAt(0).toUpperCase() + i.substring(1, i.length), t["set" + r] = k(i), t["get" + r] = T(i)
        }

        function S(t) {
            return t && "function" == typeof t.matrix ? t.matrix() : t
        }

        function E(t) {
            return null === t ? null : t instanceof dn ? t : new dn(t)
        }

        function A(t, e, n, i) {
            var r = 0,
                o = 0;
            return i && (r = Math.atan2(i.c * n, i.a * e), 0 !== i.b && (o = Math.atan2(i.d * n, i.b * e))), {
                x: r,
                y: o
            }
        }

        function P(t) {
            var e = "_" + t;
            return function(t) {
                return i(t) ? (this._observerField(e, t), this.geometryChange(), this) : this[e]
            }
        }

        function O(t, e) {
            for (var n = 0; n < e.length; n++) t[e[n]] = P(e[n])
        }

        function z(t, e, n) {
            return void 0 === n && (n = bn), 0 === m(Math.abs(t - e), n)
        }

        function N(t, e, n) {
            return t < e || z(t, e, n)
        }

        function R(t, e, n, i) {
            var r = e.x - t.x,
                o = i.x - n.x,
                s = e.y - t.y,
                a = i.y - n.y,
                h = t.x - n.x,
                l = t.y - n.y,
                c = r * a - o * s,
                u = (r * l - s * h) / c,
                d = (o * l - a * h) / c;
            if (u >= 0 && u <= 1 && d >= 0 && d <= 1) return new ln(t.x + d * r, t.y + d * s)
        }

        function B(t, e, n, i, r, s) {
            var a = m((r - t) / n, 3),
                h = m((s - e) / i, 3);
            return m(o(Math.atan2(h, a)))
        }

        function L(t) {
            var e, n, i, r, s, a, h, l, c, u, d, f, g, v, x, y, w, _, b, C, k, T, M, S, E, A = t.x1,
                P = t.y1,
                O = t.x2,
                z = t.y2,
                N = t.rx,
                R = t.ry,
                B = t.largeArc,
                L = t.swipe,
                F = t.rotation;
            return void 0 === F && (F = 0), e = p(F), n = Math.cos(e), i = Math.sin(e), r = n * (A - O) / 2 + i * (P - z) / 2, s = -i * (A - O) / 2 + n * (P - z) / 2, a = B !== L ? 1 : -1, h = Math.pow(r, 2), l = Math.pow(s, 2), c = Math.pow(N, 2), u = Math.pow(R, 2), d = h / c + l / u, d > 1 && (d = Math.sqrt(h / c + l / u), N = d * N, c = Math.pow(N, 2), R = d * R, u = Math.pow(R, 2)), f = a * Math.sqrt((c * u - c * l - u * h) / (c * l + u * h)), isNaN(f) && (f = 0), g = f * (N * s) / R, v = -f * (R * r) / N, x = n * g - i * v + (A + O) / 2, y = i * g + n * v + (P + z) / 2, w = (r - g) / N, _ = (s - v) / R, b = -(r + g) / N, C = -(s + v) / R, k = (_ >= 0 ? 1 : -1) * o(Math.acos(w / Math.sqrt(w * w + _ * _))), T = m((w * b + _ * C) / (Math.sqrt(w * w + _ * _) * Math.sqrt(b * b + C * C)), 10), M = (w * C - _ * b >= 0 ? 1 : -1) * o(Math.acos(T)), !L && M > 0 && (M -= 360), L && M < 0 && (M += 360), S = k + M, E = S >= 0 ? 1 : -1, S = Math.abs(S) % 360 * E, {
                center: new ln(x, y),
                startAngle: k,
                endAngle: S,
                radiusX: N,
                radiusY: R,
                xRotation: F
            }
        }

        function F(t, e) {
            for (var n = t; n < e;) n += 90;
            return n
        }

        function I(t) {
            var e = "_" + t;
            return function(t) {
                return i(t) ? (this._observerField(e, ln.create(t)), this.geometryChange(), this) : this[e]
            }
        }

        function D(t, e) {
            for (var n = 0; n < e.length; n++) t[e[n]] = I(e[n])
        }

        function H(t, e, n) {
            var i = o(Math.atan2(e.y - t.y, e.x - t.x)),
                r = n.transformCopy(E().rotate(-i, t));
            return r.x < t.x
        }

        function j(t, e, n) {
            var i = 1 - t;
            return Math.pow(i, 3) * n[0][e] + 3 * Math.pow(i, 2) * t * n[1][e] + 3 * Math.pow(t, 2) * i * n[2][e] + Math.pow(t, 3) * n[3][e]
        }

        function q(t, e) {
            return [-t[0][e] + 3 * t[1][e] - 3 * t[2][e] + t[3][e], 3 * (t[0][e] - 2 * t[1][e] + t[2][e]), 3 * (-t[0][e] + t[1][e]), t[0][e]]
        }

        function G(t) {
            return t < 0 ? -1 : 1
        }

        function $(t, e, n) {
            var i = Math.sqrt(Math.pow(e, 2) - 4 * t * n);
            return [(-e + i) / (2 * t), (-e - i) / (2 * t)]
        }

        function V(t, e, n, i) {
            var r, o, s, a, h, l, c, u, d, f, p, g, v;
            return 0 === t ? $(e, n, i) : (r = (3 * t * n - Math.pow(e, 2)) / (3 * Math.pow(t, 2)), o = (2 * Math.pow(e, 3) - 9 * t * e * n + 27 * Math.pow(t, 2) * i) / (27 * Math.pow(t, 3)), s = Math.pow(r / 3, 3) + Math.pow(o / 2, 2), a = new Rn(0, 1), h = -e / (3 * t), s < 0 ? (l = new Rn(-o / 2, Math.sqrt(-s)).nthRoot(3), c = new Rn(-o / 2, (-Math.sqrt(-s))).nthRoot(3)) : (l = -o / 2 + Math.sqrt(s), l = new Rn(G(l) * Math.pow(Math.abs(l), 1 / 3)), c = -o / 2 - Math.sqrt(s), c = new Rn(G(c) * Math.pow(Math.abs(c), 1 / 3))), u = l.add(c), p = l.add(c).multiplyConstant(-.5), g = l.add(c.negate()).multiplyConstant(Math.sqrt(3) / 2), d = p.add(a.multiply(g)), f = p.add(a.negate().multiply(g)), v = [], u.isReal() && v.push(m(u.real + h, bn)), d.isReal() && v.push(m(d.real + h, bn)), f.isReal() && v.push(m(f.real + h, bn)), v)
        }

        function U(t, e, n, i, r) {
            var o, s, a = q(t, i),
                h = V(a[0], a[1], a[2], a[3] - e[i]);
            for (s = 0; s < h.length; s++)
                if (0 <= h[s] && h[s] <= 1 && (o = j(h[s], n, t), Math.abs(o - e[n]) <= r)) return !0
        }

        function X(t, e, n) {
            var i, r, o, s = q(t, "x"),
                a = V(s[0], s[1], s[2], s[3] - e.x),
                h = 0;
            for (o = 0; o < a.length; o++) i = j(a[o], "y", t), r = z(i, e.y) || i > e.y, r && ((0 === a[o] || 1 === a[o]) && n.bottomRight().x > e.x || 0 < a[o] && a[o] < 1) && h++;
            return h
        }

        function Y(t, e, n) {
            var i, r, o, s, a, h;
            return t.x !== e.x && (r = Math.min(t.x, e.x), o = Math.max(t.x, e.x), s = Math.min(t.y, e.y), a = Math.max(t.y, e.y), h = r <= n.x && n.x < o, i = s === a ? n.y <= s && h : h && (a - s) * ((t.x - e.x) * (t.y - e.y) > 0 ? n.x - r : o - n.x) / (o - r) + s - n.y >= 0), i ? 1 : 0
        }

        function W(t) {
            var e, n = t.length,
                i = tn,
                r = en;
            for (e = 0; e < n; e++) r = Math.max(r, t[e]), i = Math.min(i, t[e]);
            return {
                min: i,
                max: r
            }
        }

        function Q(t, e, n) {
            var i, r, o, s;
            for (r = 0; r < t.length; r++) o = t[r], o.visible() && (s = e ? o.bbox(n) : o.rawBBox(), s && (i = i ? un.union(i, s) : s));
            return i
        }

        function Z(t, e) {
            var n, i, r, o;
            for (i = 0; i < t.length; i++) r = t[i], r.visible() && (o = r.clippedBBox(e), o && (n = n ? un.union(n, o) : o));
            return n
        }

        function J(t, e, n) {
            var i, r = e ? 0 : 1;
            for (i = 0; i < t.length; i += 2) t.splice(i + r, 0, n)
        }

        function K(t, e) {
            if (t && e) return e.scaleCopy(2).translate(-t.x, -t.y)
        }

        function tt(t, e, n) {
            var i = e.clone().scale(2 / 3);
            return {
                controlOut: i.clone().translateWith(t.scaleCopy(In)),
                controlIn: i.translateWith(n.scaleCopy(In))
            }
        }

        function et(t) {
            var e = [];
            return t.replace(Hn, function(t, n) {
                e.push(parseFloat(n))
            }), e
        }

        function nt(t, e, n) {
            var i = n.transform() || E(),
                r = i.matrix();
            r.e += t.x - e.origin.x, r.f += t.y - e.origin.y, i.matrix(r), n.transform(i)
        }

        function it(t, e, n, i, r) {
            var o;
            return o = "start" === n ? e.origin[i] : "end" === n ? e.origin[i] + e.size[r] - t : e.origin[i] + (e.size[r] - t) / 2
        }

        function rt(t, e, n, i, r) {
            var o;
            return o = "start" === n ? e.origin[i] + e.size[r] - t : "end" === n ? e.origin[i] : e.origin[i] + (e.size[r] - t) / 2
        }

        function ot(t, e, n, i, r) {
            var o, s, a;
            for (o = 0; o < t.length; o++) s = t[o].clippedBBox(), s && (a = s.origin.clone(), a[i] = it(s.size[r], e, n || "start", i, r), nt(a, s, t[o]))
        }

        function st(t, e, n) {
            ot(t, e, n, "x", "width")
        }

        function at(t, e, n) {
            ot(t, e, n, "y", "height")
        }

        function ht(t, e, n, i) {
            var r, o, s, a, h;
            if (t.length > 1)
                for (r = new ln, o = t[0].bbox, s = 1; s < t.length; s++) a = t[s].element, h = t[s].bbox, r[e] = o.origin[e] + o.size[i], r[n] = h.origin[n], nt(r, h, a), h.origin[e] = r[e], o = h
        }

        function lt(t) {
            var e, n, i, r = [];
            for (e = 0; e < t.length; e++) n = t[e], i = n.clippedBBox(), i && r.push({
                element: n,
                bbox: i
            });
            return r
        }

        function ct(t) {
            ht(lt(t), "x", "y", "width")
        }

        function ut(t) {
            ht(lt(t), "y", "x", "height")
        }

        function dt(t, e, n) {
            var i, r, o, s, a = e.size[n],
                h = [],
                l = [],
                c = 0,
                u = function() {
                    l.push({
                        element: i,
                        bbox: r
                    })
                };
            for (o = 0; o < t.length; o++) i = t[o], r = i.clippedBBox(), r && (s = r.size[n], c + s > a ? l.length ? (h.push(l), l = [], u(), c = s) : (u(), h.push(l), l = [], c = 0) : (u(), c += s));
            return l.length && h.push(l), h
        }

        function ft(t, e, n, i, r) {
            var o, s, a, h, l = dt(t, e, r),
                c = e.origin.clone(),
                u = [];
            for (o = 0; o < l.length; o++)
                for (s = l[o], a = s[0], c[i] = a.bbox.origin[i], nt(c, a.bbox, a.element), a.bbox.origin[n] = c[n], ht(s, n, i, r), u.push([]), h = 0; h < s.length; h++) u[o].push(s[h].element);
            return u
        }

        function pt(t, e) {
            return ft(t, e, "x", "y", "width")
        }

        function gt(t, e) {
            return ft(t, e, "y", "x", "height")
        }

        function mt(t, e) {
            var n, i, r, o, s = t.clippedBBox();
            s && (n = s.size, i = e.size, (i.width < n.width || i.height < n.height) && (r = Math.min(i.width / n.width, i.height / n.height), o = t.transform() || E(), o.scale(r, r), t.transform(o)))
        }

        function vt(t) {
            return function(e) {
                return i(e) ? (this.options.set(t, e), this) : this.options.get(t)
            }
        }

        function xt(t, e) {
            for (var n = 0; n < e.length; n++) t[e[n]] = vt(e[n])
        }

        function yt(t) {
            return .5 - Math.cos(t * Math.PI) / 2
        }

        function wt(t) {
            return t
        }

        function _t(t, e, n, i) {
            var r = 1.70158,
                o = 0,
                s = i;
            return 0 === t ? n : 1 === t ? n + i : (o || (o = .5), s < Math.abs(i) ? (s = i, r = o / 4) : r = o / (2 * Math.PI) * Math.asin(i / s), s * Math.pow(2, -10 * t) * Math.sin((+t - r) * (1.1 * Math.PI) / o) + i + n)
        }

        function bt(t, e) {
            return i(e) && null !== e ? " " + t + '="' + e + '" ' : ""
        }

        function Ct(t) {
            var e, n = "";
            for (e = 0; e < t.length; e++) n += bt(t[e][0], t[e][1]);
            return n
        }

        function kt(t) {
            var e, n, r = "";
            for (e = 0; e < t.length; e++) n = t[e][1], i(n) && (r += t[e][0] + ":" + n + ";");
            if ("" !== r) return r
        }

        function Tt(t, e) {
            return "clip" === t || "fill" === t && (!e || "Gradient" === e.nodeType)
        }

        function Mt() {
            var t, e = document.getElementsByTagName("base")[0],
                n = document.location.href,
                i = "";
            return e && !Ue.msie && (t = n.indexOf("#"), t !== -1 && (n = n.substring(0, t)), i = n), i
        }

        function St(t) {
            var e, n, i, r;
            try {
                e = t.getScreenCTM ? t.getScreenCTM() : null
            } catch (o) {}
            e && (n = -e.e % 1, i = -e.f % 1, r = t.style, 0 === n && 0 === i || (r.left = n + "px", r.top = i + "px"))
        }

        function Et(t) {
            if (!t || "string" != typeof t || !Yi.test(t)) return t;
            var e = Et._element;
            return Yi.lastIndex = 0, t.replace(Yi, function(t) {
                return e.innerHTML = t, e.textContent || e.innerText
            })
        }

        function At(t) {
            var e, n, i, r = new Ri({
                    skipBaseHref: !0
                }),
                o = t.clippedBBox(),
                s = t;
            return o && (e = o.getOrigin(), n = new Jn, n.transform(E().translate(-e.x, -e.y)), n.children.push(t), s = n), r.load([s]), i = "<?xml version='1.0' ?><svg xmlns='" + xi + "' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'>" + r.render() + "</svg>", r.destroy(), i
        }

        function Pt(t, e) {
            var n, i, r, o, s, a, h = e.segments;
            if (0 !== h.length) {
                for (n = h[0], i = n.anchor(), t.moveTo(i.x, i.y), r = 1; r < h.length; r++) n = h[r], i = n.anchor(), o = h[r - 1], s = o.controlOut(), a = n.controlIn(), s && a ? t.bezierCurveTo(s.x, s.y, a.x, a.y, i.x, i.y) : t.lineTo(i.x, i.y);
                e.options.closed && t.closePath()
            }
        }

        function Ot(t, e) {
            return t._zIndex < e._zIndex ? 1 : t._zIndex > e._zIndex ? -1 : 0
        }

        function zt(t, e) {
            var n, i, r;
            for (n = 0; n < e.length; n++) i = e[n], r = kendo.parseColor(i.color()), r.a *= i.opacity(), t.addColorStop(i.offset(), r.toCssRgba())
        }

        function Nt(e, n) {
            var i, r, o, s, a, h, l, c, u = {
                    width: "800px",
                    height: "600px",
                    cors: "Anonymous"
                },
                d = e,
                f = e.clippedBBox();
            return f && (i = f.getOrigin(), d = new Jn, d.transform(E().translate(-i.x, -i.y)), d.children.push(e), r = f.getSize(), u.width = r.width + "px", u.height = r.height + "px"), o = t.extend(u, n), s = document.createElement("div"), a = s.style, a.display = "none", a.width = o.width, a.height = o.height, document.body.appendChild(s), h = new ur(s, o), h.suspendTracking(), h.draw(d), l = h.image(), c = function() {
                h.destroy(), document.body.removeChild(s)
            }, l.then(c, c), l
        }

        function Rt(t, e) {
            var n = At(t);
            return e && e.raw || (n = "data:image/svg+xml;base64," + a(n)), Xe().resolve(n)
        }

        function Bt(t) {
            return Array.prototype.slice.call(t)
        }

        function Lt(t, e) {
            t.classList ? t.classList.add(e) : t.className += " " + e
        }

        function Ft(t, e) {
            t.classList ? t.classList.remove(e) : t.className = t.className.split(/\s+/).reduce(function(t, n) {
                return n != e && t.push(n), t
            }, []).join(" ")
        }

        function It(t, e) {
            Object.keys(e).forEach(function(n) {
                t.style[n] = e[n]
            })
        }

        function Dt(t, e) {
            if (t.closest) return t.closest(e);
            for (; t && !/^\[object (?:HTML)?Document\]$/.test(t + "");) {
                if (1 == t.nodeType && Sr(t, e)) return t;
                t = t.parentNode
            }
        }

        function Ht(t) {
            return "number" == typeof t ? {
                x: t,
                y: t
            } : Array.isArray(t) ? {
                x: t[0],
                y: t[1]
            } : {
                x: t.x,
                y: t.y
            }
        }

        function jt(t, e) {
            function n(t) {
                var n = new Jn,
                    i = t.getBoundingClientRect();
                return me(n, [s.x, 0, 0, s.y, -i.left * s.x, -i.top * s.y]), Cr._clipbox = !1, Cr._matrix = hn.unit(), Cr._stackingContext = {
                    element: t,
                    group: n
                }, Cr._avoidLinks = e.avoidLinks === !0 ? "a" : e.avoidLinks, Lt(t, "k-pdf-export"), De(t, n), Ft(t, "k-pdf-export"), n
            }

            function i(t) {
                if (null != t) return "string" == typeof t && (t = kendo.template(t.replace(/^\s+|\s+$/g, ""))), "function" == typeof t ? function(e) {
                    var n, i = t(e);
                    return i && "string" == typeof i && (n = document.createElement("div"), n.innerHTML = i, i = n.firstElementChild), i
                } : function() {
                    return t.cloneNode(!0)
                }
            }

            function r(t, e, n, r, o, s, a) {
                function h() {
                    ("-" != n || o) && c(w);
                    var e = f();
                    w.parentNode.insertBefore(e, w), e.appendChild(w), v && y.forEach(function(t, e) {
                        var n = v({
                            element: t,
                            pageNum: e + 1,
                            totalPages: y.length
                        });
                        n && t.appendChild(n)
                    }), Jt(y, function() {
                        Zt(y, function() {
                            t({
                                pages: y,
                                container: _
                            })
                        })
                    })
                }

                function l(t) {
                    if (a.keepTogether && Sr(t, a.keepTogether) && t.offsetHeight <= o - b) return !0;
                    var e = t.tagName;
                    return !(/^h[1-6]$/i.test(e) && t.offsetHeight >= o - b) && (t.getAttribute("data-kendo-chart") || /^(?:img|tr|thead|th|tfoot|iframe|svg|object|canvas|input|textarea|select|video|h[1-6])/i.test(t.tagName))
                }

                function c(t) {
                    var e, i, r, s, a, h, u;
                    if ("TABLE" == t.tagName && It(t, {
                            tableLayout: "fixed"
                        }), !l(t)) {
                        for (e = oe(t), i = parseFloat(se(e, "padding-bottom")), r = parseFloat(se(e, "border-bottom-width")), s = b, b += i + r, a = !0, h = t.firstChild; h; h = h.nextSibling)
                            if (1 == h.nodeType) {
                                if (a = !1, Sr(h, n)) {
                                    d(h);
                                    continue
                                }
                                if (!o) {
                                    c(h);
                                    continue
                                }
                                if (!/^(?:static|relative)$/.test(se(oe(h), "position"))) continue;
                                u = p(h), 1 == u ? d(h) : u && l(h) ? d(h) : c(h)
                            } else 3 == h.nodeType && o && (g(h, a), a = !1);
                        b = s
                    }
                }

                function u(t) {
                    var e = t.parentNode,
                        n = e.firstChild;
                    if (t === n) return !0;
                    if (t === e.children[0]) {
                        if (7 == n.nodeType || 8 == n.nodeType) return !0;
                        if (3 == n.nodeType) return !/\S/.test(n.data)
                    }
                    return !1
                }

                function d(t) {
                    var e, n, i, r, o, s, h;
                    return 1 == t.nodeType && t !== w && u(t) ? d(t.parentNode) : (e = Dt(t, "table"), n = e && e.querySelector("colgroup"), a.repeatHeaders && (i = e && e.querySelector("thead"), r = Dt(t, ".k-grid.k-widget"), r && r.querySelector(".k-auto-scrollable") && (o = r.querySelector(".k-grid-header"))), s = f(), h = x.createRange(), h.setStartBefore(w), h.setEndBefore(t), s.appendChild(h.extractContents()), w.parentNode.insertBefore(s, w), m(t.parentNode), e && (e = Dt(t, "table"), a.repeatHeaders && i && e.insertBefore(i.cloneNode(!0), e.firstChild), n && e.insertBefore(n.cloneNode(!0), e.firstChild)), void(a.repeatHeaders && o && (r = Dt(t, ".k-grid.k-widget"), r.insertBefore(o.cloneNode(!0), r.firstChild))))
                }

                function f() {
                    var t = x.createElement("KENDO-PDF-PAGE");
                    return It(t, {
                        display: "block",
                        boxSizing: "content-box",
                        width: r ? r + "px" : "auto",
                        padding: s.top + "px " + s.right + "px " + s.bottom + "px " + s.left + "px",
                        position: "relative",
                        height: o ? o + "px" : "auto",
                        overflow: o || r ? "hidden" : "visible",
                        clear: "both"
                    }), a && a.pageClassName && (t.className = a.pageClassName), y.push(t), t
                }

                function p(t) {
                    var e, n, i = t.getBoundingClientRect();
                    return 0 === i.width || 0 === i.height ? 0 : (e = w.getBoundingClientRect().top, n = o - b, i.height > n ? 3 : i.top - e > n ? 1 : i.bottom - e > n ? 2 : 0)
                }

                function g(t, e) {
                    var n, i, r, o, s;
                    /\S/.test(t.data) && (n = t.data.length, i = x.createRange(), i.selectNodeContents(t), r = p(i), r && (o = t, 1 == r ? d(e ? t.parentNode : t) : (! function a(e, n, r) {
                        return i.setEnd(t, n), e == n || n == r ? n : p(i) ? a(e, e + n >> 1, n) : a(n, n + r >> 1, r)
                    }(0, n >> 1, n), !/\S/.test("" + i) && e ? d(t.parentNode) : (o = t.splitText(i.endOffset), s = f(), i.setStartBefore(w), s.appendChild(i.extractContents()), w.parentNode.insertBefore(s, w), m(o.parentNode))), g(o)))
                }

                function m(t) {
                    var e = Dt(t, "li");
                    e && (e.setAttribute("kendo-no-bullet", "1"), m(e.parentNode))
                }
                var v = i(a.template),
                    x = e.ownerDocument,
                    y = [],
                    w = a._destructive ? e : Er(e),
                    _ = x.createElement("KENDO-PDF-DOCUMENT"),
                    b = 0;
                Bt(w.querySelectorAll("tfoot")).forEach(function(t) {
                    t.parentNode.appendChild(t)
                }), Bt(w.querySelectorAll("ol")).forEach(function(t) {
                    Bt(t.children).forEach(function(t, e) {
                        t.setAttribute("kendo-split-index", e)
                    })
                }), It(_, {
                    display: "block",
                    position: "absolute",
                    boxSizing: "content-box",
                    left: "-10000px",
                    top: "-10000px"
                }), r && (It(_, {
                    width: r + "px",
                    paddingLeft: s.left + "px",
                    paddingRight: s.right + "px"
                }), It(w, {
                    overflow: "hidden"
                })), e.parentNode.insertBefore(_, e), _.appendChild(w), a.beforePageBreak ? setTimeout(function() {
                    a.beforePageBreak(_, h)
                }, 15) : setTimeout(h, 15)
            }
            var o, s;
            if (e || (e = {}), o = Xe(), !t) return o.reject("No element to export");
            if ("function" != typeof window.getComputedStyle) throw Error("window.getComputedStyle is missing.  You are using an unsupported browser, or running in IE8 compatibility mode.  Drawing HTML is supported in Chrome, Firefox, Safari and IE9+.");
            return kendo.pdf.defineFont(qt(t.ownerDocument)), s = Ht(e.scale || 1), Jt(t, function() {
                var i, a = e && e.forcePageBreak,
                    h = e && e.paperSize && "auto" != e.paperSize,
                    l = kendo.pdf.getPaperOptions(function(t, n) {
                        return "paperSize" == t ? h ? e[t] : "A4" : t in e ? e[t] : n
                    }),
                    c = h && l.paperSize[0],
                    u = h && l.paperSize[1],
                    d = e.margin && l.margin,
                    f = !!d;
                a || u ? (d || (d = {
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0
                }), c && (c /= s.x), u && (u /= s.y), d.left /= s.x, d.right /= s.x, d.top /= s.y, d.bottom /= s.y, i = new Jn({
                    pdf: {
                        multiPage: !0,
                        paperSize: h ? l.paperSize : "auto",
                        _ignoreMargin: f
                    }
                }), r(function(t) {
                    if (e.progress) {
                        var r = !1,
                            s = 0;
                        ! function a() {
                            if (s < t.pages.length) {
                                var h = n(t.pages[s]);
                                i.append(h), e.progress({
                                    page: h,
                                    pageNum: ++s,
                                    totalPages: t.pages.length,
                                    cancel: function() {
                                        r = !0
                                    }
                                }), r ? t.container.parentNode.removeChild(t.container) : setTimeout(a)
                            } else t.container.parentNode.removeChild(t.container), o.resolve(i)
                        }()
                    } else t.pages.forEach(function(t) {
                        i.append(n(t))
                    }), t.container.parentNode.removeChild(t.container), o.resolve(i)
                }, t, a, c ? c - d.left - d.right : null, u ? u - d.top - d.bottom : null, d, e)) : o.resolve(n(t))
            }), o
        }

        function qt(t) {
            function e(t) {
                if (t) {
                    var e = null;
                    try {
                        e = t.cssRules
                    } catch (n) {}
                    e && i(t, e)
                }
            }

            function n(t) {
                var e, n = se(t.style, "src");
                return n ? Pr(n).reduce(function(t, e) {
                    var n = Or(e);
                    return n && t.push(n), t
                }, []) : (e = Or(t.cssText), e ? [e] : [])
            }

            function i(t, i) {
                var o, s, a, h, l, c, u;
                for (o = 0; o < i.length; ++o) switch (s = i[o], s.type) {
                    case 3:
                        e(s.styleSheet);
                        break;
                    case 5:
                        a = s.style, h = Pr(se(a, "font-family")), l = /^([56789]00|bold)$/i.test(se(a, "font-weight")), c = "italic" == se(a, "font-style"), u = n(s), u.length > 0 && r(t, h, l, c, u[0])
                }
            }

            function r(t, e, n, i, r) {
                /^data:/i.test(r) || /^[^\/:]+:\/\//.test(r) || /^\//.test(r) || (r = (t.href + "").replace(/[^\/]*$/, "") + r), e.forEach(function(t) {
                    t = t.replace(/^(['"]?)(.*?)\1$/, "$2"), n && (t += "|bold"), i && (t += "|italic"), o[t] = r
                })
            }
            var o, s;
            for (null == t && (t = document), o = {}, s = 0; s < t.styleSheets.length; ++s) e(t.styleSheets[s]);
            return o
        }

        function Gt(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e)
        }

        function $t(t) {
            return t = "_counter_" + t, Cr[t]
        }

        function Vt(t) {
            var e = [],
                n = Cr;
            for (t = "_counter_" + t; n;) Gt(n, t) && e.push(n[t]), n = Object.getPrototypeOf(n);
            return e.reverse()
        }

        function Ut(t, e) {
            var n = Cr;
            for (t = "_counter_" + t; n && !Gt(n, t);) n = Object.getPrototypeOf(n);
            n || (n = Cr._root), n[t] = (n[t] || 0) + (null == e ? 1 : e)
        }

        function Xt(t, e) {
            t = "_counter_" + t, Cr[t] = null == e ? 0 : e
        }

        function Yt(t, e, n) {
            var i, r, o;
            for (i = 0; i < t.length;) r = t[i++], o = parseFloat(t[i]), isNaN(o) ? e(r, n) : (e(r, o), ++i)
        }

        function Wt(t) {
            var e, n = se(t, "counter-reset");
            n && Yt(Pr(n, /^\s+/), Xt, 0), e = se(t, "counter-increment"), e && Yt(Pr(e, /^\s+/), Ut, 1)
        }

        function Qt(t, e) {
            var n = kendo.parseColor(t, !0);
            return n && (n = n.toRGB(), e ? n = n.toCssRgba() : 0 === n.a && (n = null)), n
        }

        function Zt(t, e) {
            function n() {
                --i <= 0 && e()
            }
            var i = 0;
            t.forEach(function(t) {
                var e, r, o = t.querySelectorAll("img");
                for (e = 0; e < o.length; ++e) r = o[e], r.complete || (i++, r.onload = r.onerror = n)
            }), i || n()
        }

        function Jt(t, e) {
            function n(t) {
                br[t] || (br[t] = !0, s.push(t))
            }

            function i(t) {
                /^img$/i.test(t.tagName) && n(t.src), Ar(se(oe(t), "background-image")).forEach(function(t) {
                    "url" == t.type && n(t.url)
                }), t.children && Bt(t.children).forEach(i)
            }

            function r() {
                --o <= 0 && e()
            }
            var o, s = [];
            Array.isArray(t) ? t.forEach(i) : i(t), o = s.length, 0 === o && r(), s.forEach(function(t) {
                var e = br[t] = new window.Image;
                /^data:/i.test(t) || (e.crossOrigin = "Anonymous"), e.src = t, e.complete ? r() : (e.onload = r, e.onerror = function() {
                    br[t] = null, r()
                })
            })
        }

        function Kt(t) {
            var e, n = "";
            do e = t % 26, n = String.fromCharCode(97 + e) + n, t = Math.floor(t / 26); while (t > 0);
            return n
        }

        function te(t, e, n) {
            var i, r;
            Cr = Object.create(Cr), Cr[t.tagName.toLowerCase()] = {
                element: t,
                style: e
            }, i = se(e, "text-decoration"), i && "none" != i && (r = se(e, "color"), i.split(/\s+/g).forEach(function(t) {
                Cr[t] || (Cr[t] = r)
            })), re(e) && (Cr._stackingContext = {
                element: t,
                group: n
            })
        }

        function ee() {
            Cr = Object.getPrototypeOf(Cr)
        }

        function ne(t) {
            if (null != Cr._clipbox) {
                var e = t.bbox(Cr._matrix);
                Cr._clipbox = Cr._clipbox ? un.intersect(Cr._clipbox, e) : e
            }
        }

        function ie() {
            var t = Cr._clipbox;
            return null == t || (t ? 0 === t.width() || 0 === t.height() : void 0)
        }

        function re(t) {
            function e(e) {
                return se(t, e)
            }
            if ("none" != e("transform") || "static" != e("position") || "auto" != e("z-index") || e("opacity") < 1) return !0
        }

        function oe(t, e) {
            return window.getComputedStyle(t, e || null)
        }

        function se(t, e, n) {
            var i = t.getPropertyValue(e);
            return null != i && "" !== i || (wr.webkit ? i = t.getPropertyValue("-webkit-" + e) : wr.mozilla ? i = t.getPropertyValue("-moz-" + e) : wr.opera ? i = t.getPropertyValue("-o-" + e) : Tr && (i = t.getPropertyValue("-ms-" + e))), arguments.length > 2 && (null == i || "" === i) ? n : i
        }

        function ae(t, e, n, i) {
            t.setProperty(e, n, i), wr.webkit ? t.setProperty("-webkit-" + e, n, i) : wr.mozilla ? t.setProperty("-moz-" + e, n, i) : wr.opera ? t.setProperty("-o-" + e, n, i) : Tr && (t.setProperty("-ms-" + e, n, i), e = "ms" + e.replace(/(^|-)([a-z])/g, function(t, e, n) {
                return e + n.toUpperCase()
            }), t[e] = n)
        }

        function he(t, e) {
            return e = "border-" + e, {
                width: parseFloat(se(t, e + "-width")),
                style: se(t, e + "-style"),
                color: Qt(se(t, e + "-color"), !0)
            }
        }

        function le(t, e) {
            var n = t.style.cssText,
                i = e();
            return t.style.cssText = n, i
        }

        function ce(t, e) {
            var n = se(t, "border-" + e + "-radius").split(/\s+/g).map(parseFloat);
            return 1 == n.length && n.push(n[0]), ye({
                x: n[0],
                y: n[1]
            })
        }

        function ue(t) {
            var e = t.getBoundingClientRect();
            return e = de(e, "border-*-width", t), e = de(e, "padding-*", t)
        }

        function de(t, e, n) {
            var i, r, o, s, a;
            return "string" == typeof e ? (i = oe(n), r = parseFloat(se(i, e.replace("*", "top"))), o = parseFloat(se(i, e.replace("*", "right"))), s = parseFloat(se(i, e.replace("*", "bottom"))), a = parseFloat(se(i, e.replace("*", "left")))) : "number" == typeof e && (r = o = s = a = e), {
                top: t.top + r,
                right: t.right - o,
                bottom: t.bottom - s,
                left: t.left + a,
                width: t.right - t.left - o - a,
                height: t.bottom - t.top - s - r
            }
        }

        function fe(t) {
            var e, n, i = se(t, "transform");
            return "none" == i ? null : (e = /^\s*matrix\(\s*(.*?)\s*\)\s*$/.exec(i), e ? (n = se(t, "transform-origin"), e = e[1].split(/\s*,\s*/g).map(parseFloat), n = n.split(/\s+/g).map(parseFloat), {
                matrix: e,
                origin: n
            }) : void 0)
        }

        function pe(t) {
            return 180 * t / Math.PI % 360
        }

        function ge(t) {
            var e = parseFloat(t);
            return /grad$/.test(t) ? Math.PI * e / 200 : /rad$/.test(t) ? e : /turn$/.test(t) ? Math.PI * e * 2 : /deg$/.test(t) ? Math.PI * e / 180 : void 0
        }

        function me(t, e) {
            return e = new hn(e[0], e[1], e[2], e[3], e[4], e[5]), t.transform(e), e
        }

        function ve(t, e) {
            t.clip(e)
        }

        function xe(t, e, n, i) {
            for (var r = new Tn([e, n], i).curvePoints(), o = 1; o < r.length;) t.curveTo(r[o++], r[o++], r[o++])
        }

        function ye(t) {
            return (t.x <= 0 || t.y <= 0) && (t.x = t.y = 0), t
        }

        function we(t, e, n, i, r) {
            var o = Math.max(0, e.x),
                s = Math.max(0, e.y),
                a = Math.max(0, n.x),
                h = Math.max(0, n.y),
                l = Math.max(0, i.x),
                c = Math.max(0, i.y),
                u = Math.max(0, r.x),
                d = Math.max(0, r.y),
                f = Math.min(t.width / (o + a), t.height / (h + c), t.width / (l + u), t.height / (d + s));
            return f < 1 && (o *= f, s *= f, a *= f, h *= f, l *= f, c *= f, u *= f, d *= f), {
                tl: {
                    x: o,
                    y: s
                },
                tr: {
                    x: a,
                    y: h
                },
                br: {
                    x: l,
                    y: c
                },
                bl: {
                    x: u,
                    y: d
                }
            }
        }

        function _e(t, e, n) {
            var i, r, o, s, a, h, l, c, u = oe(t),
                d = ce(u, "top-left"),
                f = ce(u, "top-right"),
                p = ce(u, "bottom-left"),
                g = ce(u, "bottom-right");
            return "padding" != n && "content" != n || (i = he(u, "top"), r = he(u, "right"), o = he(u, "bottom"), s = he(u, "left"), d.x -= s.width, d.y -= i.width, f.x -= r.width, f.y -= i.width, g.x -= r.width, g.y -= o.width, p.x -= s.width, p.y -= o.width, "content" == n && (a = parseFloat(se(u, "padding-top")), h = parseFloat(se(u, "padding-right")), l = parseFloat(se(u, "padding-bottom")), c = parseFloat(se(u, "padding-left")), d.x -= c, d.y -= a, f.x -= h, f.y -= a, g.x -= h, g.y -= l, p.x -= c, p.y -= l)), "number" == typeof n && (d.x -= n, d.y -= n, f.x -= n, f.y -= n, g.x -= n, g.y -= n, p.x -= n, p.y -= n), be(e, d, f, g, p)
        }

        function be(t, e, n, i, r) {
            var o = we(t, e, n, i, r),
                s = o.tl,
                a = o.tr,
                h = o.br,
                l = o.bl,
                c = new $n({
                    fill: null,
                    stroke: null
                });
            return c.moveTo(t.left, t.top + s.y), s.x && xe(c, t.left + s.x, t.top + s.y, {
                startAngle: -180,
                endAngle: -90,
                radiusX: s.x,
                radiusY: s.y
            }), c.lineTo(t.right - a.x, t.top), a.x && xe(c, t.right - a.x, t.top + a.y, {
                startAngle: -90,
                endAngle: 0,
                radiusX: a.x,
                radiusY: a.y
            }), c.lineTo(t.right, t.bottom - h.y), h.x && xe(c, t.right - h.x, t.bottom - h.y, {
                startAngle: 0,
                endAngle: 90,
                radiusX: h.x,
                radiusY: h.y
            }), c.lineTo(t.left + l.x, t.bottom), l.x && xe(c, t.left + l.x, t.bottom - l.y, {
                startAngle: 90,
                endAngle: 180,
                radiusX: l.x,
                radiusY: l.y
            }), c.close()
        }

        function Ce(t, e) {
            var i = parseFloat(t) + "";
            switch (e) {
                case "decimal-leading-zero":
                    return i.length < 2 && (i = "0" + i), i;
                case "lower-roman":
                    return n(t).toLowerCase();
                case "upper-roman":
                    return n(t).toUpperCase();
                case "lower-latin":
                case "lower-alpha":
                    return Kt(t - 1);
                case "upper-latin":
                case "upper-alpha":
                    return Kt(t - 1).toUpperCase();
                default:
                    return i
            }
        }

        function ke(t, e) {
            function n(t, e, n) {
                return n ? (n = n.replace(/^\s*(["'])(.*)\1\s*$/, "$2"), Vt(t).map(function(t) {
                    return Ce(t, e)
                }).join(n)) : Ce($t(t) || 0, e)
            }
            var i, r = Pr(e, /^\s+/),
                o = [];
            return r.forEach(function(e) {
                var r;
                (i = /^\s*(["'])(.*)\1\s*$/.exec(e)) ? o.push(i[2].replace(/\\([0-9a-f]{4})/gi, function(t, e) {
                    return String.fromCharCode(parseInt(e, 16))
                })): (i = /^\s*counter\((.*?)\)\s*$/.exec(e)) ? (r = Pr(i[1]), o.push(n(r[0], r[1]))) : (i = /^\s*counters\((.*?)\)\s*$/.exec(e)) ? (r = Pr(i[1]), o.push(n(r[0], r[2], r[1]))) : o.push((i = /^\s*attr\((.*?)\)\s*$/.exec(e)) ? t.getAttribute(i[1]) || "" : e)
            }), o.join("")
        }

        function Te(t) {
            var e, n;
            if (t.cssText) return t.cssText;
            for (e = [], n = 0; n < t.length; ++n) e.push(t[n] + ": " + se(t, t[n]));
            return e.join(";\n")
        }

        function Me(t, e) {
            function n(e, n) {
                var r, o = oe(t, e),
                    s = o.content;
                Wt(o), s && "normal" != s && "none" != s && "0px" != o.width && (r = t.ownerDocument.createElement(_r), r.style.cssText = Te(o), r.textContent = ke(t, s), t.insertBefore(r, n), i.push(r))
            }
            var i, r;
            return t.tagName == _r ? void Se(t, e) : (i = [], n(":before", t.firstChild), n(":after", null), void(i.length > 0 ? (r = t.className, t.className += " kendo-pdf-hide-pseudo-elements", Se(t, e), t.className = r, i.forEach(function(e) {
                t.removeChild(e)
            })) : Se(t, e)))
        }

        function Se(t, e) {
            function i(e) {
                var n, i, r, o, s, a;
                if (/^td$/i.test(t.tagName) && (n = Cr.table, n && "collapse" == se(n.style, "border-collapse"))) {
                    if (i = he(n.style, "left").width, r = he(n.style, "top").width, 0 === i && 0 === r) return e;
                    if (o = n.element.getBoundingClientRect(), s = n.element.rows[0].cells[0], a = s.getBoundingClientRect(), a.top == o.top || a.left == o.left) return Bt(e).map(function(t) {
                        return {
                            left: t.left + i,
                            top: t.top + r,
                            right: t.right + i,
                            bottom: t.bottom + r,
                            height: t.height,
                            width: t.width
                        }
                    })
                }
                return e
            }

            function r(t, n, i, r, o, s, a, h) {
                function l(e, n, r) {
                    var o = Math.PI / 2 * e / (e + i),
                        s = {
                            x: n.x - e,
                            y: n.y - i
                        },
                        a = new $n({
                            fill: {
                                color: t
                            },
                            stroke: null
                        }).moveTo(0, 0);
                    me(a, r), xe(a, 0, n.y, {
                        startAngle: -90,
                        endAngle: -pe(o),
                        radiusX: n.x,
                        radiusY: n.y
                    }), s.x > 0 && s.y > 0 ? (a.lineTo(s.x * Math.cos(o), n.y - s.y * Math.sin(o)), xe(a, 0, n.y, {
                        startAngle: -pe(o),
                        endAngle: -90,
                        radiusX: s.x,
                        radiusY: s.y,
                        anticlockwise: !0
                    })) : s.x > 0 ? a.lineTo(s.x, i).lineTo(0, i) : a.lineTo(s.x, i).lineTo(s.x, 0), u.append(a.close())
                }
                if (!(i <= 0)) {
                    var c, u = new Jn;
                    me(u, h), e.append(u), ye(s), ye(a), c = new $n({
                        fill: {
                            color: t
                        },
                        stroke: null
                    }), u.append(c), c.moveTo(s.x ? Math.max(s.x, r) : 0, 0).lineTo(n - (a.x ? Math.max(a.x, o) : 0), 0).lineTo(n - Math.max(a.x, o), i).lineTo(Math.max(s.x, r), i).close(), s.x && l(r, s, [-1, 0, 0, 1, s.x, 0]), a.x && l(o, a, [1, 0, 0, 1, n - a.x, 0])
                }
            }

            function o(t) {
                var n, i, r = new Jn;
                for (ve(r, be(t, S, E, P, A)), e.append(r), z && (n = new $n({
                        fill: {
                            color: z.toCssRgba()
                        },
                        stroke: null
                    }), n.moveTo(t.left, t.top).lineTo(t.right, t.top).lineTo(t.right, t.bottom).lineTo(t.left, t.bottom).close(), r.append(n)), i = l.length; --i >= 0;) s(r, t, l[i], c[i % c.length], u[i % u.length], d[i % d.length], f[i % f.length])
            }

            function s(e, n, i, r, o, s, a) {
                function h(e, n, i, h, l) {
                    function c() {
                        for (; m.origin.x > n.left;) m.origin.x -= i
                    }

                    function u() {
                        for (; m.origin.y > n.top;) m.origin.y -= h
                    }

                    function d() {
                        for (; m.origin.x < n.right;) l(e, m.clone()), m.origin.x += i
                    }
                    var f, p, g, m, v, x = i / h,
                        y = n;
                    switch ("content-box" == s ? (y = de(y, "border-*-width", t), y = de(y, "padding-*", t)) : "padding-box" == s && (y = de(y, "border-*-width", t)), /^\s*auto(\s+auto)?\s*$/.test(a) || ("contain" == a ? (f = Math.min(y.width / i, y.height / h), i *= f, h *= f) : "cover" == a ? (f = Math.max(y.width / i, y.height / h), i *= f, h *= f) : (p = a.split(/\s+/g), i = /%$/.test(p[0]) ? y.width * parseFloat(p[0]) / 100 : parseFloat(p[0]), h = 1 == p.length || "auto" == p[1] ? i / x : /%$/.test(p[1]) ? y.height * parseFloat(p[1]) / 100 : parseFloat(p[1]))), g = o + "") {
                        case "bottom":
                            g = "50% 100%";
                            break;
                        case "top":
                            g = "50% 0";
                            break;
                        case "left":
                            g = "0 50%";
                            break;
                        case "right":
                            g = "100% 50%";
                            break;
                        case "center":
                            g = "50% 50%"
                    }
                    if (g = g.split(/\s+/), 1 == g.length && (g[1] = "50%"), g[0] = /%$/.test(g[0]) ? parseFloat(g[0]) / 100 * (y.width - i) : parseFloat(g[0]), g[1] = /%$/.test(g[1]) ? parseFloat(g[1]) / 100 * (y.height - h) : parseFloat(g[1]), m = new un([y.left + g[0], y.top + g[1]], [i, h]), "no-repeat" == r) l(e, m);
                    else if ("repeat-x" == r) c(), d();
                    else if ("repeat-y" == r)
                        for (u(); m.origin.y < n.bottom;) l(e, m.clone()), m.origin.y += h;
                    else if ("repeat" == r)
                        for (c(), u(), v = m.origin.clone(); m.origin.y < n.bottom;) m.origin.x = v.x, d(), m.origin.y += h
                }
                if (i && "none" != i)
                    if ("url" == i.type) {
                        if (/^url\(\"data:image\/svg/i.test(i.url)) return;
                        var l = br[i.url];
                        l && l.width > 0 && l.height > 0 && h(e, n, l.width, l.height, function(t, e) {
                            t.append(new Qn(i.url, e))
                        })
                    } else {
                        if ("linear" != i.type) return;
                        h(e, n, n.width, n.height, Ee(i))
                    }
            }

            function a() {
                function i(n) {
                    le(t, function() {
                        t.style.position = "relative";
                        var i = t.ownerDocument.createElement(_r);
                        i.style.position = "absolute", i.style.boxSizing = "border-box", "outside" == o ? (i.style.width = "6em", i.style.left = "-6.8em", i.style.textAlign = "right") : i.style.left = "0px", n(i), t.insertBefore(i, t.firstChild), De(i, e), t.removeChild(i)
                    })
                }

                function r(e) {
                    var n, i = t.parentNode.children,
                        r = t.getAttribute("kendo-split-index");
                    if (null != r) return e(0 | r, i.length);
                    for (n = 0; n < i.length; ++n)
                        if (i[n] === t) return e(n, i.length)
                }
                var o, s = se(b, "list-style-type");
                if ("none" != s) switch (o = se(b, "list-style-position"), s) {
                    case "circle":
                    case "disc":
                    case "square":
                        i(function(t) {
                            t.style.fontSize = "60%", t.style.lineHeight = "200%", t.style.paddingRight = "0.5em", t.style.fontFamily = "DejaVu Serif", t.innerHTML = {
                                disc: "●",
                                circle: "◯",
                                square: "■"
                            }[s]
                        });
                        break;
                    case "decimal":
                    case "decimal-leading-zero":
                        i(function(t) {
                            r(function(e) {
                                ++e, "decimal-leading-zero" == s && e < 10 && (e = "0" + e), t.innerHTML = e + "."
                            })
                        });
                        break;
                    case "lower-roman":
                    case "upper-roman":
                        i(function(t) {
                            r(function(e) {
                                e = n(e + 1), "upper-roman" == s && (e = e.toUpperCase()), t.innerHTML = e + "."
                            })
                        });
                        break;
                    case "lower-latin":
                    case "lower-alpha":
                    case "upper-latin":
                    case "upper-alpha":
                        i(function(t) {
                            r(function(e) {
                                e = Kt(e), /^upper/i.test(s) && (e = e.toUpperCase()), t.innerHTML = e + "."
                            })
                        })
                }
            }

            function h(n, i, s) {
                function a(t) {
                    return {
                        x: t.y,
                        y: t.x
                    }
                }
                var h, l, c, u, d, f, p, g;
                if (0 !== n.width && 0 !== n.height && (o(n), h = M.width > 0 && (i && "ltr" == O || s && "rtl" == O), l = k.width > 0 && (s && "ltr" == O || i && "rtl" == O), 0 !== C.width || 0 !== M.width || 0 !== k.width || 0 !== T.width)) {
                    if (C.color == k.color && C.color == T.color && C.color == M.color && C.width == k.width && C.width == T.width && C.width == M.width && h && l) return n = de(n, C.width / 2), c = _e(t, n, C.width / 2), c.options.stroke = {
                        color: C.color,
                        width: C.width
                    }, void e.append(c);
                    if (0 === S.x && 0 === E.x && 0 === P.x && 0 === A.x && C.width < 2 && M.width < 2 && k.width < 2 && T.width < 2) return C.width > 0 && e.append(new $n({
                        stroke: {
                            width: C.width,
                            color: C.color
                        }
                    }).moveTo(n.left, n.top + C.width / 2).lineTo(n.right, n.top + C.width / 2)), T.width > 0 && e.append(new $n({
                        stroke: {
                            width: T.width,
                            color: T.color
                        }
                    }).moveTo(n.left, n.bottom - T.width / 2).lineTo(n.right, n.bottom - T.width / 2)), h && e.append(new $n({
                        stroke: {
                            width: M.width,
                            color: M.color
                        }
                    }).moveTo(n.left + M.width / 2, n.top).lineTo(n.left + M.width / 2, n.bottom)), void(l && e.append(new $n({
                        stroke: {
                            width: k.width,
                            color: k.color
                        }
                    }).moveTo(n.right - k.width / 2, n.top).lineTo(n.right - k.width / 2, n.bottom)));
                    u = we(n, S, E, P, A), d = u.tl, f = u.tr, p = u.br, g = u.bl, r(C.color, n.width, C.width, M.width, k.width, d, f, [1, 0, 0, 1, n.left, n.top]), r(T.color, n.width, T.width, k.width, M.width, p, g, [-1, 0, 0, -1, n.right, n.bottom]), r(M.color, n.height, M.width, T.width, C.width, a(g), a(d), [0, -1, 1, 0, n.left, n.bottom]), r(k.color, n.height, k.width, C.width, T.width, a(f), a(p), [0, 1, -1, 0, n.right, n.top])
                }
            }
            var l, c, u, d, f, p, g, m, v, x, y, w, _, b = oe(t),
                C = he(b, "top"),
                k = he(b, "right"),
                T = he(b, "bottom"),
                M = he(b, "left"),
                S = ce(b, "top-left"),
                E = ce(b, "top-right"),
                A = ce(b, "bottom-left"),
                P = ce(b, "bottom-right"),
                O = se(b, "direction"),
                z = se(b, "background-color");
            if (z = Qt(z), l = Ar(se(b, "background-image")), c = Pr(se(b, "background-repeat")), u = Pr(se(b, "background-position")), d = Pr(se(b, "background-origin")), f = Pr(se(b, "background-size")), Tr && (p = b.textOverflow, "ellipsis" == p && (g = t.style.textOverflow, t.style.textOverflow = "clip")), wr.msie && wr.version < 10 && (u = Pr(t.currentStyle.backgroundPosition)), m = de(t.getBoundingClientRect(), "border-*-width", t), function() {
                    var t, n, i, r, o, s, a, h = se(b, "clip"),
                        l = /^\s*rect\((.*)\)\s*$/.exec(h);
                    l && (t = l[1].split(/[ ,]+/g), n = "auto" == t[0] ? m.top : parseFloat(t[0]) + m.top, i = "auto" == t[1] ? m.right : parseFloat(t[1]) + m.left, r = "auto" == t[2] ? m.bottom : parseFloat(t[2]) + m.top, o = "auto" == t[3] ? m.left : parseFloat(t[3]) + m.left, s = new Jn, a = (new $n).moveTo(o, n).lineTo(i, n).lineTo(i, r).lineTo(o, r).close(), ve(s, a), e.append(s), e = s, ne(a))
                }(), w = se(b, "display"), "table-row" == w)
                for (v = [], x = 0, y = t.children; x < y.length; ++x) v.push(y[x].getBoundingClientRect());
            else v = t.getClientRects(), 1 == v.length && (v = [t.getBoundingClientRect()]);
            for (v = i(v), x = 0; x < v.length; ++x) h(v[x], 0 === x, x == v.length - 1);
            return "A" == t.tagName && t.href && !/^#?$/.test(t.getAttribute("href")) && (Cr._avoidLinks && Sr(t, Cr._avoidLinks) || (_ = document.createRange(), _.selectNodeContents(t), Bt(_.getClientRects()).forEach(function(n) {
                    var i = new Jn;
                    i._pdfLink = {
                        url: t.href,
                        top: n.top,
                        right: n.right,
                        bottom: n.bottom,
                        left: n.left
                    }, e.append(i)
                }))), v.length > 0 && "list-item" == w && !t.getAttribute("kendo-no-bullet") && a(v[0]),
                function() {
                    function n() {
                        var n = _e(t, m, "padding"),
                            i = new Jn;
                        ve(i, n), e.append(i), e = i, ne(n)
                    }
                    ze(t) ? n() : /^(hidden|auto|scroll)/.test(se(b, "overflow")) ? n() : /^(hidden|auto|scroll)/.test(se(b, "overflow-x")) ? n() : /^(hidden|auto|scroll)/.test(se(b, "overflow-y")) && n()
                }(), Ae(t, e) || Le(t, e), Tr && "ellipsis" == p && (t.style.textOverflow = g), e
        }

        function Ee(t) {
            return function(e, n) {
                var i, r, o, s, a, h, l, c, u, d, f, p, g, m = n.width(),
                    v = n.height();
                switch (t.type) {
                    case "linear":
                        switch (i = null != t.angle ? t.angle : Math.PI, t.to) {
                            case "top":
                                i = 0;
                                break;
                            case "left":
                                i = -Math.PI / 2;
                                break;
                            case "bottom":
                                i = Math.PI;
                                break;
                            case "right":
                                i = Math.PI / 2;
                                break;
                            case "top left":
                            case "left top":
                                i = -Math.atan2(v, m);
                                break;
                            case "top right":
                            case "right top":
                                i = Math.atan2(v, m);
                                break;
                            case "bottom left":
                            case "left bottom":
                                i = Math.PI + Math.atan2(v, m);
                                break;
                            case "bottom right":
                            case "right bottom":
                                i = Math.PI - Math.atan2(v, m)
                        }
                        t.reverse && (i -= Math.PI), i %= 2 * Math.PI, i < 0 && (i += 2 * Math.PI), r = Math.abs(m * Math.sin(i)) + Math.abs(v * Math.cos(i)), o = Math.atan(m * Math.tan(i) / v), s = Math.sin(o), a = Math.cos(o), h = Math.abs(s) + Math.abs(a), l = h / 2 * s, c = h / 2 * a, i > Math.PI / 2 && i <= 3 * Math.PI / 2 && (l = -l, c = -c), u = [], d = 0, f = t.stops.map(function(e, n) {
                            var i, o = e.percent;
                            return o ? o = parseFloat(o) / 100 : e.length ? o = parseFloat(e.length) / r : 0 === n ? o = 0 : n == t.stops.length - 1 && (o = 1), i = {
                                color: e.color.toCssRgba(),
                                offset: o
                            }, null != o ? (d = o, u.forEach(function(t, e) {
                                var n = t.stop;
                                n.offset = t.left + (d - t.left) * (e + 1) / (u.length + 1)
                            }), u = []) : u.push({
                                left: d,
                                stop: i
                            }), i
                        }), p = [.5 - l, .5 + c], g = [.5 + l, .5 - c], e.append($n.fromRect(n).stroke(null).fill(new ai({
                            start: p,
                            end: g,
                            stops: f,
                            userSpace: !1
                        })));
                        break;
                    case "radial":
                        window.console && window.console.log && window.console.log("Radial gradients are not yet supported in HTML renderer")
                }
            }
        }

        function Ae(t, e) {
            var n, i, r, o;
            return t._kendoExportVisual ? n = t._kendoExportVisual() : window.kendo && window.kendo.jQuery && t.getAttribute(window.kendo.attr("role")) && (i = window.kendo.widgetInstance(window.kendo.jQuery(t)), i && (i.exportDOMVisual || i.exportVisual) && (n = i.exportDOMVisual ? i.exportDOMVisual() : i.exportVisual())), !!n && (r = new Jn, r.children.push(n), o = t.getBoundingClientRect(), r.transform(E().translate(o.left, o.top)), e.append(r), !0)
        }

        function Pe(t, e, n) {
            var i = ue(t),
                r = new un([i.left, i.top], [i.width, i.height]),
                o = new Qn(e, r);
            ve(o, _e(t, i, "content")), n.append(o)
        }

        function Oe(t, e) {
            var n = oe(t),
                i = oe(e),
                r = parseFloat(se(n, "z-index")),
                o = parseFloat(se(i, "z-index")),
                s = se(n, "position"),
                a = se(i, "position");
            return isNaN(r) && isNaN(o) ? /static|absolute/.test(s) && /static|absolute/.test(a) ? 0 : "static" == s ? -1 : "static" == a ? 1 : 0 : isNaN(r) ? 0 === o ? 0 : o > 0 ? -1 : 1 : isNaN(o) ? 0 === r ? 0 : r > 0 ? 1 : -1 : parseFloat(r) - parseFloat(o)
        }

        function ze(t) {
            return /^(?:textarea|select|input)$/i.test(t.tagName)
        }

        function Ne(t) {
            return t.selectedOptions && t.selectedOptions.length > 0 ? t.selectedOptions[0] : t.options[t.selectedIndex]
        }

        function Re(t, e) {
            var n = oe(t),
                i = se(n, "color"),
                r = t.getBoundingClientRect();
            "checkbox" == t.type ? (e.append($n.fromRect(new un([r.left + 1, r.top + 1], [r.width - 2, r.height - 2])).stroke(i, 1)), t.checked && e.append((new $n).stroke(i, 1.2).moveTo(r.left + .22 * r.width, r.top + .55 * r.height).lineTo(r.left + .45 * r.width, r.top + .75 * r.height).lineTo(r.left + .78 * r.width, r.top + .22 * r.width))) : (e.append(new _n(new gn([(r.left + r.right) / 2, (r.top + r.bottom) / 2], Math.min(r.width - 2, r.height - 2) / 2)).stroke(i, 1)), t.checked && e.append(new _n(new gn([(r.left + r.right) / 2, (r.top + r.bottom) / 2], Math.min(r.width - 8, r.height - 8) / 2)).fill(i).stroke(null)))
        }

        function Be(t, e) {
            var n, i, r, o, s, a = t.tagName.toLowerCase();
            if ("input" == a && ("checkbox" == t.type || "radio" == t.type)) return Re(t, e);
            if (n = t.parentNode, i = t.ownerDocument, r = i.createElement(_r), r.style.cssText = Te(oe(t)), "input" == a && (r.style.whiteSpace = "pre"), "select" != a && "textarea" != a || (r.style.overflow = "auto"), "select" == a)
                if (t.multiple)
                    for (s = 0; s < t.options.length; ++s) o = i.createElement(_r), o.style.cssText = Te(oe(t.options[s])), o.style.display = "block", o.textContent = t.options[s].textContent, r.appendChild(o);
                else o = Ne(t), o && (r.textContent = o.textContent);
            else r.textContent = t.value;
            n.insertBefore(r, t), r.scrollLeft = t.scrollLeft, r.scrollTop = t.scrollTop, t.style.display = "none", Le(r, e), t.style.display = "", n.removeChild(r)
        }

        function Le(t, e) {
            var n, i, r, o, s, a, h;
            switch (Cr._stackingContext.element === t && (Cr._stackingContext.group = e), t.tagName.toLowerCase()) {
                case "img":
                    Pe(t, t.src, e);
                    break;
                case "canvas":
                    try {
                        Pe(t, t.toDataURL("image/png"), e)
                    } catch (l) {}
                    break;
                case "textarea":
                case "input":
                case "select":
                    Be(t, e);
                    break;
                default:
                    for (n = [], i = [], r = [], o = t.firstChild; o; o = o.nextSibling) switch (o.nodeType) {
                        case 3:
                            /\S/.test(o.data) && Fe(t, o, e);
                            break;
                        case 1:
                            s = oe(o), a = se(s, "float"), h = se(s, "position"), "static" != h ? r.push(o) : "none" != a ? i.push(o) : n.push(o)
                    }
                    f(n, Oe).forEach(function(t) {
                        De(t, e)
                    }), f(i, Oe).forEach(function(t) {
                        De(t, e)
                    }), f(r, Oe).forEach(function(t) {
                        De(t, e)
                    })
            }
        }

        function Fe(t, e, n) {
            function i(t) {
                var e, n, i, r, o;
                if (Tr || wr.chrome) {
                    for (e = t.getClientRects(), n = {
                            top: 1 / 0,
                            right: -(1 / 0),
                            bottom: -(1 / 0),
                            left: 1 / 0
                        }, i = !1, r = 0; r < e.length; ++r) o = e[r], o.width <= 1 || o.bottom === b || (n.left = Math.min(o.left, n.left), n.top = Math.min(o.top, n.top), n.right = Math.max(o.right, n.right), n.bottom = Math.max(o.bottom, n.bottom), i = !0);
                    return i ? (n.width = n.right - n.left, n.height = n.bottom - n.top, n) : t.getBoundingClientRect()
                }
                return t.getBoundingClientRect()
            }

            function r() {
                var t, n, r, s, a, u, d, f = l,
                    p = h.substr(l).search(/\S/);
                if (l += p, p < 0 || l >= c) return !0;
                if (g.setStart(e, l), g.setEnd(e, l + 1), t = i(g), n = !1, (v || x > 1) && (p = h.substr(l).search(/\s/), p >= 0 && (g.setEnd(e, l + p), r = i(g), r.bottom == t.bottom && (t = r, n = !0, l += p))), !n) {
                    if (p = function m(n, r, o) {
                            g.setEnd(e, r);
                            var s = i(g);
                            return s.bottom != t.bottom && n < r ? m(n, n + r >> 1, r) : s.right != t.right ? (t = s, r < o ? m(r, r + o >> 1, o) : r) : r
                        }(l, Math.min(c, l + _), c), p == l) return !0;
                    if (l = p, p = ("" + g).search(/\s+$/), 0 === p) return !1;
                    p > 0 && (g.setEnd(e, g.startOffset + p), t = i(g))
                }
                if (Tr && (t = g.getClientRects()[0]), s = "" + g, /^(?:pre|pre-wrap)$/i.test(y)) {
                    if (/\t/.test(s)) {
                        for (a = 0, p = f; p < g.startOffset; ++p) u = h.charCodeAt(p), 9 == u ? a += 8 - a % 8 : 10 == u || 13 == u ? a = 0 : a++;
                        for (;
                            (p = s.search("\t")) >= 0;) d = "        ".substr(0, 8 - (a + p) % 8), s = s.substr(0, p) + d + s.substr(p + 1)
                    }
                } else s = s.replace(/\s+/g, " ");
                n || (b = t.bottom), o(s, t)
            }

            function o(t, e) {
                var i, r, o;
                switch (Tr && !isNaN(d) && (i = zr(f), r = (e.top + e.bottom - i) / 2, e = {
                    top: r,
                    right: e.right,
                    bottom: r + i,
                    left: e.left,
                    height: i,
                    width: e.right - e.left
                }), w) {
                    case "uppercase":
                        t = t.toUpperCase();
                        break;
                    case "lowercase":
                        t = t.toLowerCase();
                        break;
                    case "capitalize":
                        t = t.replace(/(?:^|\s)\S/g, function(t) {
                            return t.toUpperCase()
                        })
                }
                o = new Mr(t, new un([e.left, e.top], [e.width, e.height]), {
                    font: f,
                    fill: {
                        color: p
                    }
                }), n.append(o)
            }

            function s(t) {
                function e(e, i) {
                    var r, o;
                    e && (r = u / 12, o = new $n({
                        stroke: {
                            width: r,
                            color: e
                        }
                    }), i -= r, o.moveTo(t.left, i).lineTo(t.right, i), n.append(o))
                }
                e(C, t.bottom), e(k, t.bottom - t.height / 2.7), e(T, t.top)
            }
            var a, h, l, c, u, d, f, p, g, m, v, x, y, w, _, b, C, k, T, M;
            if (!ie() && (a = oe(t), !(parseFloat(se(a, "text-indent")) < -500) && (h = e.data, l = 0, c = h.search(/\S\s*$/) + 1, c && (u = se(a, "font-size"), d = se(a, "line-height"), f = [se(a, "font-style"), se(a, "font-variant"), se(a, "font-weight"), u, se(a, "font-family")].join(" "), u = parseFloat(u), d = parseFloat(d), 0 !== u)))) {
                for (p = se(a, "color"), g = t.ownerDocument.createRange(), m = se(a, "text-align"), v = "justify" == m, x = se(a, "column-count", 1), y = se(a, "white-space"), w = se(a, "text-transform"), _ = t.getBoundingClientRect().width / u * 5, 0 === _ && (_ = 500), b = null, C = Cr.underline, k = Cr["line-through"], T = Cr.overline, M = C || k || T; !r(););
                M && (g.selectNode(e), Bt(g.getClientRects()).forEach(s))
            }
        }

        function Ie(t, e, n) {
            var i, r, o, s, a, h;
            for ("auto" != n ? (i = Cr._stackingContext.group, n = parseFloat(n)) : (i = e, n = 0), r = i.children, o = 0; o < r.length && !(null != r[o]._dom_zIndex && r[o]._dom_zIndex > n); ++o);
            return s = new Jn, i.insert(o, s), s._dom_zIndex = n, i !== e && Cr._clipbox && (a = Cr._matrix.invert(), h = Cr._clipbox.transformCopy(a), ve(s, $n.fromRect(h))), s
        }

        function De(t, e) {
            var n, i, r, o, s, a, h = oe(t);
            Wt(h), /^(style|script|link|meta|iframe|svg|col|colgroup)$/i.test(t.tagName) || null != Cr._clipbox && (n = parseFloat(se(h, "opacity")), i = se(h, "visibility"), r = se(h, "display"), 0 !== n && "hidden" != i && "none" != r && (o = fe(h), a = se(h, "z-index"), (o || n < 1) && "auto" == a && (a = 0), s = Ie(t, e, a), n < 1 && s.opacity(n * s.opacity()), te(t, h, s), o ? le(t, function() {
                var e, n, i, r;
                ae(t.style, "transform", "none", "important"), ae(t.style, "transition", "none", "important"), "static" == se(h, "position") && ae(t.style, "position", "relative", "important"), e = t.getBoundingClientRect(), n = e.left + o.origin[0], i = e.top + o.origin[1], r = [1, 0, 0, 1, -n, -i], r = He(r, o.matrix), r = He(r, [1, 0, 0, 1, n, i]), r = me(s, r), Cr._matrix = Cr._matrix.multiplyCopy(r), Me(t, s)
            }) : Me(t, s), ee()))
        }

        function He(t, e) {
            var n = t[0],
                i = t[1],
                r = t[2],
                o = t[3],
                s = t[4],
                a = t[5],
                h = e[0],
                l = e[1],
                c = e[2],
                u = e[3],
                d = e[4],
                f = e[5];
            return [n * h + i * c, n * l + i * u, r * h + o * c, r * l + o * u, s * h + a * c + d, s * l + a * u + f]
        }
        var je, qe, Ge, $e, Ve, Ue, Xe, Ye, We, Qe, Ze, Je, Ke, tn, en, nn, rn, on, sn, an, hn, ln, cn, un, dn, fn, pn, gn, mn, vn, xn, yn, wn, _n, bn, Cn, kn, Tn, Mn, Sn, En, An, Pn, On, zn, Nn, Rn, Bn, Ln, Fn, In, Dn, Hn, jn, qn, Gn, $n, Vn, Un, Xn, Yn, Wn, Qn, Zn, Jn, Kn, ti, ei, ni, ii, ri, oi, si, ai, hi, li, ci, ui, di, fi, pi, gi, mi, vi, xi, yi, wi, _i, bi, Ci, ki, Ti, Mi, Si, Ei, Ai, Pi, Oi, zi, Ni, Ri, Bi, Li, Fi, Ii, Di, Hi, ji, qi, Gi, $i, Vi, Ui, Xi, Yi, Wi, Qi, Zi, Ji, Ki, tr, er, nr, ir, rr, or, sr, ar, hr, lr, cr, ur, dr, fr, pr, gr, mr, vr, xr, yr, wr, _r, br, Cr, kr, Tr, Mr, Sr, Er, Ar, Pr, Or, zr, Nr;
        window.kendo = window.kendo || {}, je = kendo.drawing, qe = je.util, Ge = kendo.Class, $e = kendo.util, Ve = kendo.support, Ue = Ve.browser, Xe = qe.createPromise, Ye = qe.promiseAll, We = {
            extend: function(t) {
                var e, n = this;
                for (e in this) "extend" !== e && (t[e] = n[e])
            },
            observers: function() {
                return this._observers = this._observers || []
            },
            addObserver: function(t) {
                return this._observers ? this._observers.push(t) : this._observers = [t], this
            },
            removeObserver: function(t) {
                var e = this.observers(),
                    n = e.indexOf(t);
                return n !== -1 && e.splice(n, 1), this
            },
            trigger: function(t, e) {
                var n, i, r = this._observers;
                if (r && !this._suspended)
                    for (n = 0; n < r.length; n++) i = r[n], i[t] && i[t](e);
                return this
            },
            optionsChange: function(t) {
                void 0 === t && (t = {}), t.element = this, this.trigger("optionsChange", t)
            },
            geometryChange: function() {
                this.trigger("geometryChange", {
                    element: this
                })
            },
            suspend: function() {
                return this._suspended = (this._suspended || 0) + 1, this
            },
            resume: function() {
                return this._suspended = Math.max((this._suspended || 0) - 1, 0), this
            },
            _observerField: function(t, e) {
                this[t] && this[t].removeObserver(this), this[t] = e, e.addObserver(this)
            }
        }, Qe = {
            1: "i",
            10: "x",
            100: "c",
            2: "ii",
            20: "xx",
            200: "cc",
            3: "iii",
            30: "xxx",
            300: "ccc",
            4: "iv",
            40: "xl",
            400: "cd",
            5: "v",
            50: "l",
            500: "d",
            6: "vi",
            60: "lx",
            600: "dc",
            7: "vii",
            70: "lxx",
            700: "dcc",
            8: "viii",
            80: "lxxx",
            800: "dccc",
            9: "ix",
            90: "xc",
            900: "cm",
            1e3: "m"
        }, Ze = "undefined", Je = 1, Ke = Math.PI / 180, tn = Number.MAX_VALUE, en = -Number.MAX_VALUE, nn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=", rn = String.fromCharCode, on = {
            append: e,
            arabicToRoman: n,
            createPromise: Xe,
            defined: i,
            definitionId: r,
            deg: o,
            encodeBase64: a,
            eventCoordinates: h,
            eventElement: l,
            isTransparent: c,
            last: u,
            limitValue: d,
            mergeSort: f,
            promiseAll: Ye,
            rad: p,
            round: m,
            valueOrDefault: v,
            bindEvents: x,
            elementOffset: y,
            elementSize: b,
            elementStyles: w,
            unbindEvents: C,
            DEG_TO_RAD: Ke,
            MAX_NUM: tn,
            MIN_NUM: en
        }, sn = {}.toString, an = Ge.extend({
            init: function(t, e) {
                var n, i, r = this;
                void 0 === e && (e = ""), this.prefix = e;
                for (n in t) i = t[n], i = r._wrap(i, n), r[n] = i
            },
            get: function(t) {
                for (var e, n = t.split("."), i = this; n.length && i;) e = n.shift(), i = i[e];
                return i
            },
            set: function(t, e) {
                var n = this.get(t);
                n !== e && (this._set(t, this._wrap(e, t)), this.optionsChange({
                    field: this.prefix + t,
                    value: e
                }))
            },
            _set: function(t, e) {
                var n, i, r, o = this,
                    s = t.indexOf(".") >= 0,
                    a = this,
                    h = t;
                if (s) {
                    for (n = h.split("."), i = this.prefix; n.length > 1;) h = n.shift(), i += h + ".", r = a[h], r || (r = new an({}, i), r.addObserver(o), a[h] = r), a = r;
                    h = n[0]
                }
                a._clear(h), a[h] = e
            },
            _clear: function(t) {
                var e = this[t];
                e && e.removeObserver && e.removeObserver(this)
            },
            _wrap: function(t, e) {
                var n = sn.call(t),
                    r = t;
                return null !== r && i(r) && "[object Object]" === n && (t instanceof an || t instanceof Ge || (r = new an(r, this.prefix + e + ".")), r.addObserver(this)), r
            }
        }), We.extend(an.prototype), hn = Ge.extend({
            init: function(t, e, n, i, r, o) {
                void 0 === t && (t = 0), void 0 === e && (e = 0), void 0 === n && (n = 0), void 0 === i && (i = 0), void 0 === r && (r = 0), void 0 === o && (o = 0), this.a = t, this.b = e, this.c = n, this.d = i, this.e = r, this.f = o
            },
            multiplyCopy: function(t) {
                return new hn(this.a * t.a + this.c * t.b, this.b * t.a + this.d * t.b, this.a * t.c + this.c * t.d, this.b * t.c + this.d * t.d, this.a * t.e + this.c * t.f + this.e, this.b * t.e + this.d * t.f + this.f)
            },
            invert: function() {
                var t = this,
                    e = t.a,
                    n = t.b,
                    i = t.c,
                    r = t.d,
                    o = t.e,
                    s = t.f,
                    a = e * r - n * i;
                return 0 === a ? null : new hn(r / a, -n / a, -i / a, e / a, (i * s - r * o) / a, (n * o - e * s) / a)
            },
            clone: function() {
                return new hn(this.a, this.b, this.c, this.d, this.e, this.f)
            },
            equals: function(t) {
                return !!t && (this.a === t.a && this.b === t.b && this.c === t.c && this.d === t.d && this.e === t.e && this.f === t.f)
            },
            round: function(t) {
                return this.a = m(this.a, t), this.b = m(this.b, t), this.c = m(this.c, t), this.d = m(this.d, t), this.e = m(this.e, t), this.f = m(this.f, t), this
            },
            toArray: function(t) {
                var e, n = [this.a, this.b, this.c, this.d, this.e, this.f];
                if (i(t))
                    for (e = 0; e < n.length; e++) n[e] = m(n[e], t);
                return n
            },
            toString: function(t, e) {
                return void 0 === e && (e = ","), this.toArray(t).join(e)
            }
        }), hn.translate = function(t, e) {
            return new hn(1, 0, 0, 1, t, e)
        }, hn.unit = function() {
            return new hn(1, 0, 0, 1, 0, 0)
        }, hn.rotate = function(t, e, n) {
            var i = new hn;
            return i.a = Math.cos(p(t)), i.b = Math.sin(p(t)), i.c = -i.b, i.d = i.a, i.e = e - e * i.a + n * i.b || 0, i.f = n - n * i.a - e * i.b || 0, i
        }, hn.scale = function(t, e) {
            return new hn(t, 0, 0, e, 0, 0)
        }, hn.IDENTITY = hn.unit(), ln = Ge.extend({
            init: function(t, e) {
                this.x = t || 0, this.y = e || 0
            },
            equals: function(t) {
                return t && t.x === this.x && t.y === this.y
            },
            clone: function() {
                return new ln(this.x, this.y)
            },
            rotate: function(t, e) {
                var n = ln.create(e) || ln.ZERO;
                return this.transform(hn.rotate(t, n.x, n.y))
            },
            translate: function(t, e) {
                return this.x += t, this.y += e, this.geometryChange(), this
            },
            translateWith: function(t) {
                return this.translate(t.x, t.y)
            },
            move: function(t, e) {
                return this.x = this.y = 0, this.translate(t, e)
            },
            scale: function(t, e) {
                return void 0 === e && (e = t), this.x *= t, this.y *= e, this.geometryChange(), this
            },
            scaleCopy: function(t, e) {
                return this.clone().scale(t, e)
            },
            transform: function(t) {
                var e = S(t),
                    n = this,
                    i = n.x,
                    r = n.y;
                return this.x = e.a * i + e.c * r + e.e, this.y = e.b * i + e.d * r + e.f, this.geometryChange(), this
            },
            transformCopy: function(t) {
                var e = this.clone();
                return t && e.transform(t), e
            },
            distanceTo: function(t) {
                var e = this.x - t.x,
                    n = this.y - t.y;
                return Math.sqrt(e * e + n * n)
            },
            round: function(t) {
                return this.x = m(this.x, t), this.y = m(this.y, t), this.geometryChange(), this
            },
            toArray: function(t) {
                var e = i(t),
                    n = e ? m(this.x, t) : this.x,
                    r = e ? m(this.y, t) : this.y;
                return [n, r]
            },
            toString: function(t, e) {
                var n, r, o;
                return void 0 === e && (e = " "), n = this, r = n.x, o = n.y, i(t) && (r = m(r, t), o = m(o, t)), r + e + o
            }
        }), ln.create = function(t, e) {
            if (i(t)) return t instanceof ln ? t : 1 === arguments.length && 2 === t.length ? new ln(t[0], t[1]) : new ln(t, e)
        }, ln.min = function() {
            var t, e, n = arguments,
                i = tn,
                r = tn;
            for (t = 0; t < arguments.length; t++) e = n[t], i = Math.min(e.x, i), r = Math.min(e.y, r);
            return new ln(i, r)
        }, ln.max = function() {
            var t, e, n = arguments,
                i = en,
                r = en;
            for (t = 0; t < arguments.length; t++) e = n[t], i = Math.max(e.x, i), r = Math.max(e.y, r);
            return new ln(i, r)
        }, ln.minPoint = function() {
            return new ln(en, en)
        }, ln.maxPoint = function() {
            return new ln(tn, tn)
        }, Object.defineProperties && Object.defineProperties(ln, {
            ZERO: {
                get: function() {
                    return new ln(0, 0)
                }
            }
        }), M(ln.prototype, ["x", "y"]), We.extend(ln.prototype), cn = Ge.extend({
            init: function(t, e) {
                this.width = t || 0, this.height = e || 0
            },
            equals: function(t) {
                return t && t.width === this.width && t.height === this.height
            },
            clone: function() {
                return new cn(this.width, this.height)
            },
            toArray: function(t) {
                var e = i(t),
                    n = e ? m(this.width, t) : this.width,
                    r = e ? m(this.height, t) : this.height;
                return [n, r]
            }
        }), cn.create = function(t, e) {
            if (i(t)) return t instanceof cn ? t : 1 === arguments.length && 2 === t.length ? new cn(t[0], t[1]) : new cn(t, e)
        }, Object.defineProperties && Object.defineProperties(cn, {
            ZERO: {
                get: function() {
                    return new cn(0, 0)
                }
            }
        }), M(cn.prototype, ["width", "height"]), We.extend(cn.prototype), un = Ge.extend({
            init: function(t, e) {
                void 0 === t && (t = new ln), void 0 === e && (e = new cn), this.setOrigin(t), this.setSize(e)
            },
            clone: function() {
                return new un(this.origin.clone(), this.size.clone())
            },
            equals: function(t) {
                return t && t.origin.equals(this.origin) && t.size.equals(this.size)
            },
            setOrigin: function(t) {
                return this._observerField("origin", ln.create(t)), this.geometryChange(), this
            },
            getOrigin: function() {
                return this.origin
            },
            setSize: function(t) {
                return this._observerField("size", cn.create(t)), this.geometryChange(), this
            },
            getSize: function() {
                return this.size
            },
            width: function() {
                return this.size.width
            },
            height: function() {
                return this.size.height
            },
            topLeft: function() {
                return this.origin.clone()
            },
            bottomRight: function() {
                return this.origin.clone().translate(this.width(), this.height())
            },
            topRight: function() {
                return this.origin.clone().translate(this.width(), 0)
            },
            bottomLeft: function() {
                return this.origin.clone().translate(0, this.height())
            },
            center: function() {
                return this.origin.clone().translate(this.width() / 2, this.height() / 2)
            },
            bbox: function(t) {
                var e = this.topLeft().transformCopy(t),
                    n = this.topRight().transformCopy(t),
                    i = this.bottomRight().transformCopy(t),
                    r = this.bottomLeft().transformCopy(t);
                return un.fromPoints(e, n, i, r)
            },
            transformCopy: function(t) {
                return un.fromPoints(this.topLeft().transform(t), this.bottomRight().transform(t))
            },
            expand: function(t, e) {
                return void 0 === e && (e = t), this.size.width += 2 * t, this.size.height += 2 * e, this.origin.translate(-t, -e), this
            },
            expandCopy: function(t, e) {
                return this.clone().expand(t, e)
            },
            containsPoint: function(t) {
                var e = this.origin,
                    n = this.bottomRight();
                return !(t.x < e.x || t.y < e.y || n.x < t.x || n.y < t.y)
            },
            _isOnPath: function(t, e) {
                var n = this.expandCopy(e, e),
                    i = this.expandCopy(-e, -e);
                return n.containsPoint(t) && !i.containsPoint(t)
            }
        }), un.fromPoints = function() {
            var t = ln.min.apply(null, arguments),
                e = ln.max.apply(null, arguments),
                n = new cn(e.x - t.x, e.y - t.y);
            return new un(t, n)
        }, un.union = function(t, e) {
            return un.fromPoints(ln.min(t.topLeft(), e.topLeft()), ln.max(t.bottomRight(), e.bottomRight()))
        }, un.intersect = function(t, e) {
            var n = {
                    left: t.topLeft().x,
                    top: t.topLeft().y,
                    right: t.bottomRight().x,
                    bottom: t.bottomRight().y
                },
                i = {
                    left: e.topLeft().x,
                    top: e.topLeft().y,
                    right: e.bottomRight().x,
                    bottom: e.bottomRight().y
                };
            if (n.left <= i.right && i.left <= n.right && n.top <= i.bottom && i.top <= n.bottom) return un.fromPoints(new ln(Math.max(n.left, i.left), Math.max(n.top, i.top)), new ln(Math.min(n.right, i.right), Math.min(n.bottom, i.bottom)))
        }, We.extend(un.prototype), dn = Ge.extend({
            init: function(t) {
                void 0 === t && (t = hn.unit()), this._matrix = t
            },
            clone: function() {
                return new dn(this._matrix.clone())
            },
            equals: function(t) {
                return t && t._matrix.equals(this._matrix)
            },
            translate: function(t, e) {
                return this._matrix = this._matrix.multiplyCopy(hn.translate(t, e)), this._optionsChange(), this
            },
            scale: function(t, e, n) {
                void 0 === e && (e = t), void 0 === n && (n = null);
                var i = n;
                return i && (i = ln.create(i), this._matrix = this._matrix.multiplyCopy(hn.translate(i.x, i.y))), this._matrix = this._matrix.multiplyCopy(hn.scale(t, e)), i && (this._matrix = this._matrix.multiplyCopy(hn.translate(-i.x, -i.y))), this._optionsChange(), this
            },
            rotate: function(t, e) {
                var n = ln.create(e) || ln.ZERO;
                return this._matrix = this._matrix.multiplyCopy(hn.rotate(t, n.x, n.y)), this._optionsChange(), this
            },
            multiply: function(t) {
                var e = S(t);
                return this._matrix = this._matrix.multiplyCopy(e), this._optionsChange(), this
            },
            matrix: function(t) {
                return t ? (this._matrix = t, this._optionsChange(), this) : this._matrix
            },
            _optionsChange: function() {
                this.optionsChange({
                    field: "transform",
                    value: this
                })
            }
        }), We.extend(dn.prototype), fn = Ge.extend({
            init: function(t) {
                this._initOptions(t)
            },
            _initOptions: function(t) {
                var e, n;
                void 0 === t && (t = {}), e = t.clip, n = t.transform, n && (t.transform = E(n)), e && !e.id && (e.id = r()), this.options = new an(t), this.options.addObserver(this)
            },
            transform: function(t) {
                return i(t) ? void this.options.set("transform", E(t)) : this.options.get("transform")
            },
            parentTransform: function() {
                for (var t, e, n = this; n.parent;) n = n.parent, e = n.transform(), e && (t = e.matrix().multiplyCopy(t || hn.unit()));
                if (t) return E(t)
            },
            currentTransform: function(t) {
                var e, n, i, r;
                if (void 0 === t && (t = this.parentTransform()), e = this.transform(), n = S(e), i = S(t), r = n && i ? i.multiplyCopy(n) : n || i) return E(r)
            },
            visible: function(t) {
                return i(t) ? (this.options.set("visible", t), this) : this.options.get("visible") !== !1
            },
            clip: function(t) {
                var e = this.options;
                return i(t) ? (t && !t.id && (t.id = r()), e.set("clip", t), this) : e.get("clip")
            },
            opacity: function(t) {
                return i(t) ? (this.options.set("opacity", t), this) : v(this.options.get("opacity"), 1)
            },
            clippedBBox: function(t) {
                var e, n = this._clippedBBox(t);
                if (n) return e = this.clip(), e ? un.intersect(n, e.bbox(t)) : n
            },
            containsPoint: function(t, e) {
                var n, i;
                return !!this.visible() && (n = this.currentTransform(e), i = t, n && (i = t.transformCopy(n.matrix().invert())), this._hasFill() && this._containsPoint(i) || this._isOnPath && this._hasStroke() && this._isOnPath(i))
            },
            _hasFill: function() {
                var t = this.options.fill;
                return t && !c(t.color)
            },
            _hasStroke: function() {
                var t = this.options.stroke;
                return t && t.width > 0 && !c(t.color)
            },
            _clippedBBox: function(t) {
                return this.bbox(t)
            }
        }), fn.prototype.nodeType = "Element", We.extend(fn.prototype), pn = Math.PI / 2, gn = Ge.extend({
            init: function(t, e) {
                void 0 === t && (t = new ln), void 0 === e && (e = 0), this.setCenter(t), this.setRadius(e)
            },
            setCenter: function(t) {
                return this._observerField("center", ln.create(t)), this.geometryChange(), this
            },
            getCenter: function() {
                return this.center
            },
            equals: function(t) {
                return t && t.center.equals(this.center) && t.radius === this.radius
            },
            clone: function() {
                return new gn(this.center.clone(), this.radius)
            },
            pointAt: function(t) {
                return this._pointAt(p(t))
            },
            bbox: function(t) {
                var e, n, i, r, o = this,
                    s = A(this.center, this.radius, this.radius, t),
                    a = ln.maxPoint(),
                    h = ln.minPoint();
                for (e = 0; e < 4; e++) n = o._pointAt(s.x + e * pn).transformCopy(t), i = o._pointAt(s.y + e * pn).transformCopy(t), r = new ln(n.x, i.y), a = ln.min(a, r), h = ln.max(h, r);
                return un.fromPoints(a, h)
            },
            _pointAt: function(t) {
                var e = this,
                    n = e.center,
                    i = e.radius;
                return new ln(n.x + i * Math.cos(t), n.y + i * Math.sin(t))
            },
            containsPoint: function(t) {
                var e = this,
                    n = e.center,
                    i = e.radius,
                    r = Math.pow(t.x - n.x, 2) + Math.pow(t.y - n.y, 2) <= Math.pow(i, 2);
                return r
            },
            _isOnPath: function(t, e) {
                var n = this,
                    i = n.center,
                    r = n.radius,
                    o = i.distanceTo(t);
                return r - e <= o && o <= r + e
            }
        }), M(gn.prototype, ["radius"]), We.extend(gn.prototype), mn = "Gradient", vn = {
            extend: function(t) {
                t.fill = this.fill, t.stroke = this.stroke
            },
            fill: function(t, e) {
                var n, r = this.options;
                return i(t) ? (t && t.nodeType !== mn ? (n = {
                    color: t
                }, i(e) && (n.opacity = e), r.set("fill", n)) : r.set("fill", t), this) : r.get("fill")
            },
            stroke: function(t, e, n) {
                return i(t) ? (this.options.set("stroke.color", t), i(e) && this.options.set("stroke.width", e), i(n) && this.options.set("stroke.opacity", n), this) : this.options.get("stroke")
            }
        }, xn = "" + hn.IDENTITY, yn = {
            extend: function(t) {
                t.bbox = this.bbox, t.geometryChange = this.geometryChange
            },
            bbox: function(t) {
                var e, n, i = S(this.currentTransform(t)),
                    r = i ? "" + i : xn;
                return this._bboxCache && this._matrixHash === r ? e = this._bboxCache.clone() : (e = this._bbox(i), this._bboxCache = e ? e.clone() : null, this._matrixHash = r), n = this.options.get("stroke.width"), n && e && e.expand(n / 2), e
            },
            geometryChange: function() {
                delete this._bboxCache, this.trigger("geometryChange", {
                    element: this
                })
            }
        }, wn = "#000", _n = fn.extend({
            init: function(t, e) {
                void 0 === t && (t = new gn), void 0 === e && (e = {}), fn.fn.init.call(this, e), this.geometry(t), i(this.options.stroke) || this.stroke(wn)
            },
            rawBBox: function() {
                return this._geometry.bbox()
            },
            _bbox: function(t) {
                return this._geometry.bbox(t)
            },
            _containsPoint: function(t) {
                return this.geometry().containsPoint(t)
            },
            _isOnPath: function(t) {
                return this.geometry()._isOnPath(t, this.options.stroke.width / 2)
            }
        }), _n.prototype.nodeType = "Circle", vn.extend(_n.prototype), yn.extend(_n.prototype), O(_n.prototype, ["geometry"]), bn = 10, Cn = 45, kn = Math.pow, Tn = Ge.extend({
            init: function(t, e) {
                void 0 === t && (t = new ln), void 0 === e && (e = {}), this.setCenter(t), this.radiusX = e.radiusX, this.radiusY = e.radiusY || e.radiusX, this.startAngle = e.startAngle, this.endAngle = e.endAngle, this.anticlockwise = e.anticlockwise || !1, this.xRotation = e.xRotation
            },
            clone: function() {
                return new Tn(this.center, {
                    radiusX: this.radiusX,
                    radiusY: this.radiusY,
                    startAngle: this.startAngle,
                    endAngle: this.endAngle,
                    anticlockwise: this.anticlockwise
                })
            },
            setCenter: function(t) {
                return this._observerField("center", ln.create(t)), this.geometryChange(), this
            },
            getCenter: function() {
                return this.center
            },
            pointAt: function(t) {
                var e = this.center,
                    n = p(t);
                return new ln(e.x + this.radiusX * Math.cos(n), e.y + this.radiusY * Math.sin(n))
            },
            curvePoints: function() {
                var t, e, n, i, r = this,
                    o = this.startAngle,
                    s = this.anticlockwise ? -1 : 1,
                    a = [this.pointAt(o)],
                    h = this._arcInterval(),
                    l = h.endAngle - h.startAngle,
                    c = Math.ceil(l / Cn),
                    u = l / c,
                    d = o;
                for (this.xRotation && (t = E().rotate(this.xRotation, this.center)), e = 1; e <= c; e++) n = d + s * u, i = r._intervalCurvePoints(d, n, t), a.push(i.cp1, i.cp2, i.p2), d = n;
                return a
            },
            bbox: function(t) {
                for (var e, n, i = this, r = this._arcInterval(), s = r.startAngle, a = r.endAngle, h = A(this.center, this.radiusX, this.radiusY, t), l = o(h.x), c = o(h.y), u = this.pointAt(a).transformCopy(t), d = F(l, s), f = F(c, s), p = this.pointAt(s).transformCopy(t), g = ln.min(p, u), m = ln.max(p, u); d < a || f < a;) e = void 0, d < a && (e = i.pointAt(d).transformCopy(t), d += 90), n = void 0, f < a && (n = i.pointAt(f).transformCopy(t), f += 90), p = new ln(e.x, n.y), g = ln.min(g, p), m = ln.max(m, p);
                return un.fromPoints(g, m)
            },
            _arcInterval: function() {
                var t, e = this,
                    n = e.startAngle,
                    i = e.endAngle,
                    r = e.anticlockwise;
                return r && (t = n, n = i, i = t), (n > i || r && n === i) && (i += 360), {
                    startAngle: n,
                    endAngle: i
                }
            },
            _intervalCurvePoints: function(t, e, n) {
                var i = this.pointAt(t),
                    r = this.pointAt(e),
                    o = this._derivativeAt(t),
                    s = this._derivativeAt(e),
                    a = (p(e) - p(t)) / 3,
                    h = new ln(i.x + a * o.x, i.y + a * o.y),
                    l = new ln(r.x - a * s.x, r.y - a * s.y);
                return n && (i.transform(n), r.transform(n), h.transform(n), l.transform(n)), {
                    p1: i,
                    cp1: h,
                    cp2: l,
                    p2: r
                }
            },
            _derivativeAt: function(t) {
                var e = p(t);
                return new ln(-this.radiusX * Math.sin(e), this.radiusY * Math.cos(e))
            },
            containsPoint: function(t) {
                var e, n, i, r = this._arcInterval(),
                    o = r.endAngle - r.startAngle,
                    s = this,
                    a = s.center,
                    h = s.radiusX,
                    l = s.radiusY,
                    c = a.distanceTo(t),
                    u = Math.atan2(t.y - a.y, t.x - a.x),
                    d = h * l / Math.sqrt(kn(h, 2) * kn(Math.sin(u), 2) + kn(l, 2) * kn(Math.cos(u), 2)),
                    f = this.pointAt(this.startAngle).round(bn),
                    p = this.pointAt(this.endAngle).round(bn),
                    g = R(a, t.round(bn), f, p);
                return o < 180 ? e = g && N(a.distanceTo(g), c) && N(c, d) : (n = B(a.x, a.y, h, l, t.x, t.y), 360 !== n && (n = (360 + n) % 360), i = r.startAngle <= n && n <= r.endAngle, e = i && N(c, d) || !i && (!g || g.equals(t))), e
            },
            _isOnPath: function(t, e) {
                var n, i = this._arcInterval(),
                    r = this.center,
                    o = B(r.x, r.y, this.radiusX, this.radiusY, t.x, t.y);
                return 360 !== o && (o = (360 + o) % 360), n = i.startAngle <= o && o <= i.endAngle, n && this.pointAt(o).distanceTo(t) <= e
            }
        }), Tn.fromPoints = function(t, e, n, i, r, o, s) {
            var a = L({
                x1: t.x,
                y1: t.y,
                x2: e.x,
                y2: e.y,
                rx: n,
                ry: i,
                largeArc: r,
                swipe: o,
                rotation: s
            });
            return new Tn(a.center, {
                startAngle: a.startAngle,
                endAngle: a.endAngle,
                radiusX: a.radiusX,
                radiusY: a.radiusY,
                xRotation: a.xRotation,
                anticlockwise: 0 === o
            })
        }, M(Tn.prototype, ["radiusX", "radiusY", "startAngle", "endAngle", "anticlockwise"]), We.extend(Tn.prototype), Mn = [].push, Sn = [].pop, En = [].splice, An = [].shift, Pn = [].slice, On = [].unshift, zn = Ge.extend({
            init: function(t) {
                void 0 === t && (t = []), this.length = 0, this._splice(0, t.length, t)
            },
            elements: function(t) {
                return t ? (this._splice(0, this.length, t), this._change(), this) : this.slice(0)
            },
            push: function() {
                var t = arguments,
                    e = Mn.apply(this, t);
                return this._add(t), e
            },
            slice: function() {
                return Pn.call(this)
            },
            pop: function() {
                var t = this.length,
                    e = Sn.apply(this);
                return t && this._remove([e]), e
            },
            splice: function(t, e) {
                var n = Pn.call(arguments, 2),
                    i = this._splice(t, e, n);
                return this._change(), i
            },
            shift: function() {
                var t = this.length,
                    e = An.apply(this);
                return t && this._remove([e]), e
            },
            unshift: function() {
                var t = arguments,
                    e = On.apply(this, t);
                return this._add(t), e
            },
            indexOf: function(t) {
                var e, n = this,
                    i = this.length;
                for (e = 0; e < i; e++)
                    if (n[e] === t) return e;
                return -1
            },
            _splice: function(t, e, n) {
                var i = En.apply(this, [t, e].concat(n));
                return this._clearObserver(i), this._setObserver(n), i
            },
            _add: function(t) {
                this._setObserver(t), this._change()
            },
            _remove: function(t) {
                this._clearObserver(t), this._change()
            },
            _setObserver: function(t) {
                var e, n = this;
                for (e = 0; e < t.length; e++) t[e].addObserver(n)
            },
            _clearObserver: function(t) {
                var e, n = this;
                for (e = 0; e < t.length; e++) t[e].removeObserver(n)
            },
            _change: function() {}
        }), We.extend(zn.prototype), Nn = zn.extend({
            _change: function() {
                this.geometryChange()
            }
        }), Rn = Ge.extend({
            init: function(t, e) {
                void 0 === t && (t = 0), void 0 === e && (e = 0),
                    this.real = t, this.img = e
            },
            add: function(t) {
                return new Rn(m(this.real + t.real, bn), m(this.img + t.img, bn))
            },
            addConstant: function(t) {
                return new Rn(this.real + t, this.img)
            },
            negate: function() {
                return new Rn((-this.real), (-this.img))
            },
            multiply: function(t) {
                return new Rn(this.real * t.real - this.img * t.img, this.real * t.img + this.img * t.real)
            },
            multiplyConstant: function(t) {
                return new Rn(this.real * t, this.img * t)
            },
            nthRoot: function(t) {
                var e = Math.atan2(this.img, this.real),
                    n = Math.sqrt(Math.pow(this.img, 2) + Math.pow(this.real, 2)),
                    i = Math.pow(n, 1 / t);
                return new Rn(i * Math.cos(e / t), i * Math.sin(e / t))
            },
            equals: function(t) {
                return this.real === t.real && this.img === t.img
            },
            isReal: function() {
                return 0 === this.img
            }
        }), Bn = Ge.extend({
            init: function(t, e, n) {
                this.anchor(t || new ln), this.controlIn(e), this.controlOut(n)
            },
            bboxTo: function(t, e) {
                var n, i = this.anchor().transformCopy(e),
                    r = t.anchor().transformCopy(e);
                return n = this.controlOut() && t.controlIn() ? this._curveBoundingBox(i, this.controlOut().transformCopy(e), t.controlIn().transformCopy(e), r) : this._lineBoundingBox(i, r)
            },
            _lineBoundingBox: function(t, e) {
                return un.fromPoints(t, e)
            },
            _curveBoundingBox: function(t, e, n, i) {
                var r = [t, e, n, i],
                    o = this._curveExtremesFor(r, "x"),
                    s = this._curveExtremesFor(r, "y"),
                    a = W([o.min, o.max, t.x, i.x]),
                    h = W([s.min, s.max, t.y, i.y]);
                return un.fromPoints(new ln(a.min, h.min), new ln(a.max, h.max))
            },
            _curveExtremesFor: function(t, e) {
                var n = this._curveExtremes(t[0][e], t[1][e], t[2][e], t[3][e]);
                return {
                    min: j(n.min, e, t),
                    max: j(n.max, e, t)
                }
            },
            _curveExtremes: function(t, e, n, i) {
                var r, o, s = t - 3 * e + 3 * n - i,
                    a = -2 * (t - 2 * e + n),
                    h = t - e,
                    l = Math.sqrt(a * a - 4 * s * h),
                    c = 0,
                    u = 1;
                return 0 === s ? 0 !== a && (c = u = -h / a) : isNaN(l) || (c = (-a + l) / (2 * s), u = (-a - l) / (2 * s)), r = Math.max(Math.min(c, u), 0), (r < 0 || r > 1) && (r = 0), o = Math.min(Math.max(c, u), 1), (o > 1 || o < 0) && (o = 1), {
                    min: r,
                    max: o
                }
            },
            _intersectionsTo: function(t, e) {
                var n;
                return n = this.controlOut() && t.controlIn() ? X([this.anchor(), this.controlOut(), t.controlIn(), t.anchor()], e, this.bboxTo(t)) : Y(this.anchor(), t.anchor(), e)
            },
            _isOnCurveTo: function(t, e, n, i) {
                var r, o, s, a, h, l, c, u = this.bboxTo(t).expand(n, n);
                if (u.containsPoint(e)) return r = this.anchor(), o = this.controlOut(), s = t.controlIn(), a = t.anchor(), "start" === i && r.distanceTo(e) <= n ? !H(r, o, e) : "end" === i && a.distanceTo(e) <= n ? !H(a, s, e) : (h = [r, o, s, a], !(!U(h, e, "x", "y", n) && !U(h, e, "y", "x", n)) || (l = E().rotate(45, e), c = [r.transformCopy(l), o.transformCopy(l), s.transformCopy(l), a.transformCopy(l)], U(c, e, "x", "y", n) || U(c, e, "y", "x", n)))
            },
            _isOnLineTo: function(t, e, n) {
                var i = this.anchor(),
                    r = t.anchor(),
                    s = o(Math.atan2(r.y - i.y, r.x - i.x)),
                    a = new un([i.x, i.y - n / 2], [i.distanceTo(r), n]);
                return a.containsPoint(e.transformCopy(E().rotate(-s, i)))
            },
            _isOnPathTo: function(t, e, n, i) {
                var r;
                return r = this.controlOut() && t.controlIn() ? this._isOnCurveTo(t, e, n / 2, i) : this._isOnLineTo(t, e, n)
            }
        }), D(Bn.prototype, ["anchor", "controlIn", "controlOut"]), We.extend(Bn.prototype), Ln = fn.extend({
            init: function(t) {
                fn.fn.init.call(this, t), this.paths = new Nn, this.paths.addObserver(this), i(this.options.stroke) || this.stroke("#000")
            },
            moveTo: function(t, e) {
                var n = new $n;
                return n.moveTo(t, e), this.paths.push(n), this
            },
            lineTo: function(t, e) {
                return this.paths.length > 0 && u(this.paths).lineTo(t, e), this
            },
            curveTo: function(t, e, n) {
                return this.paths.length > 0 && u(this.paths).curveTo(t, e, n), this
            },
            arc: function(t, e, n, i, r) {
                return this.paths.length > 0 && u(this.paths).arc(t, e, n, i, r), this
            },
            arcTo: function(t, e, n, i, r, o) {
                return this.paths.length > 0 && u(this.paths).arcTo(t, e, n, i, r, o), this
            },
            close: function() {
                return this.paths.length > 0 && u(this.paths).close(), this
            },
            _bbox: function(t) {
                return Q(this.paths, !0, t)
            },
            rawBBox: function() {
                return Q(this.paths, !1)
            },
            _containsPoint: function(t) {
                var e, n = this.paths;
                for (e = 0; e < n.length; e++)
                    if (n[e]._containsPoint(t)) return !0;
                return !1
            },
            _isOnPath: function(t) {
                var e, n = this.paths,
                    i = this.options.stroke.width;
                for (e = 0; e < n.length; e++)
                    if (n[e]._isOnPath(t, i)) return !0;
                return !1
            },
            _clippedBBox: function(t) {
                return Z(this.paths, this.currentTransform(t))
            }
        }), Ln.prototype.nodeType = "MultiPath", vn.extend(Ln.prototype), yn.extend(Ln.prototype), Fn = {
            l: function(t, e) {
                var n, i, r = e.parameters,
                    o = e.position;
                for (n = 0; n < r.length; n += 2) i = new ln(r[n], r[n + 1]), e.isRelative && i.translateWith(o), t.lineTo(i.x, i.y), o.x = i.x, o.y = i.y
            },
            c: function(t, e) {
                var n, i, r, o, s = e.parameters,
                    a = e.position;
                for (n = 0; n < s.length; n += 6) i = new ln(s[n], s[n + 1]), r = new ln(s[n + 2], s[n + 3]), o = new ln(s[n + 4], s[n + 5]), e.isRelative && (r.translateWith(a), i.translateWith(a), o.translateWith(a)), t.curveTo(i, r, o), a.x = o.x, a.y = o.y
            },
            v: function(t, e) {
                var n = e.isRelative ? 0 : e.position.x;
                J(e.parameters, !0, n), this.l(t, e)
            },
            h: function(t, e) {
                var n = e.isRelative ? 0 : e.position.y;
                J(e.parameters, !1, n), this.l(t, e)
            },
            a: function(t, e) {
                var n, i, r, o, s, a, h, l = e.parameters,
                    c = e.position;
                for (n = 0; n < l.length; n += 7) i = l[n], r = l[n + 1], o = l[n + 2], s = l[n + 3], a = l[n + 4], h = new ln(l[n + 5], l[n + 6]), e.isRelative && h.translateWith(c), c.x === h.x && c.y === h.y || (t.arcTo(h, i, r, s, a, o), c.x = h.x, c.y = h.y)
            },
            s: function(t, e) {
                var n, i, r, o, s, a = e.parameters,
                    h = e.position,
                    l = e.previousCommand;
                for ("s" !== l && "c" !== l || (n = u(u(t.paths).segments).controlIn()), i = 0; i < a.length; i += 4) r = new ln(a[i], a[i + 1]), o = new ln(a[i + 2], a[i + 3]), s = void 0, e.isRelative && (r.translateWith(h), o.translateWith(h)), s = n ? K(n, h) : h.clone(), n = r, t.curveTo(s, r, o), h.x = o.x, h.y = o.y
            },
            q: function(t, e) {
                var n, i, r, o, s = e.parameters,
                    a = e.position;
                for (n = 0; n < s.length; n += 4) i = new ln(s[n], s[n + 1]), r = new ln(s[n + 2], s[n + 3]), e.isRelative && (i.translateWith(a), r.translateWith(a)), o = tt(a, i, r), t.curveTo(o.controlOut, o.controlIn, r), a.x = r.x, a.y = r.y
            },
            t: function(t, e) {
                var n, i, r, o, s, a = e.parameters,
                    h = e.position,
                    l = e.previousCommand;
                for ("q" !== l && "t" !== l || (i = u(u(t.paths).segments), n = i.controlIn().clone().translateWith(h.scaleCopy(-1 / 3)).scale(1.5)), r = 0; r < a.length; r += 2) o = new ln(a[r], a[r + 1]), e.isRelative && o.translateWith(h), n = n ? K(n, h) : h.clone(), s = tt(h, n, o), t.curveTo(s.controlOut, s.controlIn, o), h.x = o.x, h.y = o.y
            }
        }, In = 1 / 3, Dn = /([a-df-z]{1})([^a-df-z]*)(z)?/gi, Hn = /[,\s]?([+\-]?(?:\d*\.\d+|\d+)(?:[eE][+\-]?\d+)?)/g, jn = "m", qn = "z", Gn = Ge.extend({
            parse: function(t, e) {
                var n, i = new Ln(e),
                    r = new ln;
                return t.replace(Dn, function(t, e, o, s) {
                    var a = e.toLowerCase(),
                        h = a === e,
                        l = et(o.trim());
                    if (a === jn && (h ? (r.x += l[0], r.y += l[1]) : (r.x = l[0], r.y = l[1]), i.moveTo(r.x, r.y), l.length > 2 && (a = "l", l.splice(0, 2))), Fn[a]) Fn[a](i, {
                        parameters: l,
                        position: r,
                        isRelative: h,
                        previousCommand: n
                    }), s && s.toLowerCase() === qn && i.close();
                    else if (a !== jn) throw Error("Error while parsing SVG path. Unsupported command: " + a);
                    n = a
                }), i
            }
        }), Gn.current = new Gn, $n = fn.extend({
            init: function(t) {
                fn.fn.init.call(this, t), this.segments = new Nn, this.segments.addObserver(this), i(this.options.stroke) || (this.stroke("#000"), i(this.options.stroke.lineJoin) || this.options.set("stroke.lineJoin", "miter"))
            },
            moveTo: function(t, e) {
                return this.suspend(), this.segments.elements([]), this.resume(), this.lineTo(t, e), this
            },
            lineTo: function(t, e) {
                var n = i(e) ? new ln(t, e) : t,
                    r = new Bn(n);
                return this.segments.push(r), this
            },
            curveTo: function(t, e, n) {
                var i, r;
                return this.segments.length > 0 && (i = u(this.segments), r = new Bn(n, e), this.suspend(), i.controlOut(t), this.resume(), this.segments.push(r)), this
            },
            arc: function(t, e, n, i, r) {
                var o, s, a, h, l;
                return this.segments.length > 0 && (o = u(this.segments), s = o.anchor(), a = p(t), h = new ln(s.x - n * Math.cos(a), s.y - i * Math.sin(a)), l = new Tn(h, {
                    startAngle: t,
                    endAngle: e,
                    radiusX: n,
                    radiusY: i,
                    anticlockwise: r
                }), this._addArcSegments(l)), this
            },
            arcTo: function(t, e, n, i, r, o) {
                var s, a, h;
                return this.segments.length > 0 && (s = u(this.segments), a = s.anchor(), h = Tn.fromPoints(a, t, e, n, i, r, o), this._addArcSegments(h)), this
            },
            _addArcSegments: function(t) {
                var e, n, i = this;
                for (this.suspend(), e = t.curvePoints(), n = 1; n < e.length; n += 3) i.curveTo(e[n], e[n + 1], e[n + 2]);
                this.resume(), this.geometryChange()
            },
            close: function() {
                return this.options.closed = !0, this.geometryChange(), this
            },
            rawBBox: function() {
                return this._bbox()
            },
            _containsPoint: function(t) {
                var e, n, i, r = this.segments,
                    o = r.length,
                    s = 0;
                for (i = 1; i < o; i++) e = r[i - 1], n = r[i], s += e._intersectionsTo(n, t);
                return !this.options.closed && r[0].anchor().equals(r[o - 1].anchor()) || (s += Y(r[0].anchor(), r[o - 1].anchor(), t)), s % 2 !== 0
            },
            _isOnPath: function(t, e) {
                var n, i = this.segments,
                    r = i.length,
                    o = e || this.options.stroke.width;
                if (r > 1) {
                    if (i[0]._isOnPathTo(i[1], t, o, "start")) return !0;
                    for (n = 2; n <= r - 2; n++)
                        if (i[n - 1]._isOnPathTo(i[n], t, o)) return !0;
                    if (i[r - 2]._isOnPathTo(i[r - 1], t, o, "end")) return !0
                }
                return !1
            },
            _bbox: function(t) {
                var e, n, i, r, o = this.segments,
                    s = o.length;
                if (1 === s) n = o[0].anchor().transformCopy(t), e = new un(n, cn.ZERO);
                else if (s > 0)
                    for (i = 1; i < s; i++) r = o[i - 1].bboxTo(o[i], t), e = e ? un.union(e, r) : r;
                return e
            }
        }), $n.fromRect = function(t, e) {
            return new $n(e).moveTo(t.topLeft()).lineTo(t.topRight()).lineTo(t.bottomRight()).lineTo(t.bottomLeft()).close()
        }, $n.fromPoints = function(t, e) {
            var n, i, r;
            if (t) {
                for (n = new $n(e), i = 0; i < t.length; i++) r = ln.create(t[i]), r && (0 === i ? n.moveTo(r) : n.lineTo(r));
                return n
            }
        }, $n.fromArc = function(t, e) {
            var n = new $n(e),
                i = t.startAngle,
                r = t.pointAt(i);
            return n.moveTo(r.x, r.y), n.arc(i, t.endAngle, t.radiusX, t.radiusY, t.anticlockwise), n
        }, $n.prototype.nodeType = "Path", vn.extend($n.prototype), yn.extend($n.prototype), $n.parse = function(t, e) {
            return Gn.current.parse(t, e)
        }, Vn = "#000", Un = fn.extend({
            init: function(t, e) {
                void 0 === t && (t = new Tn), void 0 === e && (e = {}), fn.fn.init.call(this, e), this.geometry(t), i(this.options.stroke) || this.stroke(Vn)
            },
            _bbox: function(t) {
                return this._geometry.bbox(t)
            },
            rawBBox: function() {
                return this.geometry().bbox()
            },
            toPath: function() {
                var t, e = new $n,
                    n = this.geometry().curvePoints();
                if (n.length > 0)
                    for (e.moveTo(n[0].x, n[0].y), t = 1; t < n.length; t += 3) e.curveTo(n[t], n[t + 1], n[t + 2]);
                return e
            },
            _containsPoint: function(t) {
                return this.geometry().containsPoint(t)
            },
            _isOnPath: function(t) {
                return this.geometry()._isOnPath(t, this.options.stroke.width / 2)
            }
        }), Un.prototype.nodeType = "Arc", vn.extend(Un.prototype), yn.extend(Un.prototype), O(Un.prototype, ["geometry"]), Xn = "12px sans-serif", Yn = "#000", Wn = fn.extend({
            init: function(t, e, n) {
                void 0 === e && (e = new ln), void 0 === n && (n = {}), fn.fn.init.call(this, n), this.content(t), this.position(e), this.options.font || (this.options.font = Xn), i(this.options.fill) || this.fill(Yn)
            },
            content: function(t) {
                return i(t) ? (this.options.set("content", t), this) : this.options.get("content")
            },
            measure: function() {
                var t = $e.measureText(this.content(), {
                    font: this.options.get("font")
                });
                return t
            },
            rect: function() {
                var t = this.measure(),
                    e = this.position().clone();
                return new un(e, [t.width, t.height])
            },
            bbox: function(t) {
                var e = S(this.currentTransform(t));
                return this.rect().bbox(e)
            },
            rawBBox: function() {
                return this.rect().bbox()
            },
            _containsPoint: function(t) {
                return this.rect().containsPoint(t)
            }
        }), Wn.prototype.nodeType = "Text", vn.extend(Wn.prototype), D(Wn.prototype, ["position"]), Qn = fn.extend({
            init: function(t, e, n) {
                void 0 === e && (e = new un), void 0 === n && (n = {}), fn.fn.init.call(this, n), this.src(t), this.rect(e)
            },
            src: function(t) {
                return i(t) ? (this.options.set("src", t), this) : this.options.get("src")
            },
            bbox: function(t) {
                var e = S(this.currentTransform(t));
                return this._rect.bbox(e)
            },
            rawBBox: function() {
                return this._rect.bbox()
            },
            _containsPoint: function(t) {
                return this._rect.containsPoint(t)
            },
            _hasFill: function() {
                return this.src()
            }
        }), Qn.prototype.nodeType = "Image", O(Qn.prototype, ["rect"]), Zn = {
            extend: function(t, e) {
                t.traverse = function(t) {
                    var n, i, r = this[e];
                    for (n = 0; n < r.length; n++) i = r[n], i.traverse ? i.traverse(t) : t(i);
                    return this
                }
            }
        }, Jn = fn.extend({
            init: function(t) {
                fn.fn.init.call(this, t), this.children = []
            },
            childrenChange: function(t, e, n) {
                this.trigger("childrenChange", {
                    action: t,
                    items: e,
                    index: n
                })
            },
            append: function() {
                return e(this.children, arguments), this._reparent(arguments, this), this.childrenChange("add", arguments), this
            },
            insert: function(t, e) {
                return this.children.splice(t, 0, e), e.parent = this, this.childrenChange("add", [e], t), this
            },
            insertAt: function(t, e) {
                return this.insert(e, t)
            },
            remove: function(t) {
                var e = this.children.indexOf(t);
                return e >= 0 && (this.children.splice(e, 1), t.parent = null, this.childrenChange("remove", [t], e)), this
            },
            removeAt: function(t) {
                if (0 <= t && t < this.children.length) {
                    var e = this.children[t];
                    this.children.splice(t, 1), e.parent = null, this.childrenChange("remove", [e], t)
                }
                return this
            },
            clear: function() {
                var t = this.children;
                return this.children = [], this._reparent(t, null), this.childrenChange("remove", t, 0), this
            },
            bbox: function(t) {
                return Q(this.children, !0, this.currentTransform(t))
            },
            rawBBox: function() {
                return Q(this.children, !1)
            },
            _clippedBBox: function(t) {
                return Z(this.children, this.currentTransform(t))
            },
            currentTransform: function(t) {
                return fn.prototype.currentTransform.call(this, t) || null
            },
            containsPoint: function(t, e) {
                var n, i, r;
                if (this.visible())
                    for (n = this.children, i = this.currentTransform(e), r = 0; r < n.length; r++)
                        if (n[r].containsPoint(t, i)) return !0;
                return !1
            },
            _reparent: function(t, e) {
                var n, i, r, o = this;
                for (n = 0; n < t.length; n++) i = t[n], r = i.parent, r && r !== o && r.remove && r.remove(i), i.parent = e
            }
        }), Jn.prototype.nodeType = "Group", Zn.extend(Jn.prototype, "children"), Kn = {
            alignContent: "start",
            justifyContent: "start",
            alignItems: "start",
            spacing: 0,
            orientation: "horizontal",
            lineSpacing: 0,
            wrap: !0,
            revers: !1
        }, ti = function(t, e) {
            t.forEach(e)
        }, ei = function(t, e) {
            var n, i = t.length;
            for (n = i - 1; n >= 0; n--) e(t[n], n)
        }, ni = Jn.extend({
            init: function(e, n) {
                Jn.fn.init.call(this, t.extend({}, Kn, n)), this._rect = e, this._fieldMap = {}
            },
            rect: function(t) {
                return t ? (this._rect = t, this) : this._rect
            },
            _initMap: function() {
                var t = this.options,
                    e = this._fieldMap;
                "horizontal" === t.orientation ? (e.sizeField = "width", e.groupsSizeField = "height", e.groupAxis = "x", e.groupsAxis = "y") : (e.sizeField = "height", e.groupsSizeField = "width", e.groupAxis = "y", e.groupsAxis = "x"), t.reverse ? (this.forEach = ei, this.justifyAlign = rt) : (this.forEach = ti, this.justifyAlign = it)
            },
            reflow: function() {
                var t, e, n, i, r, o, s, a, h, l, c, u, d, f, p, g, m, v, x, y, w, _, b, C, k = this;
                if (this._rect && 0 !== this.children.length) {
                    for (this._initMap(), this.options.transform && this.transform(null), t = this.options, e = this._rect, n = this._initGroups(), i = n.groups, r = n.groupsSize, o = this._fieldMap, s = o.sizeField, a = o.groupsSizeField, h = o.groupAxis, l = o.groupsAxis, c = new ln, u = new ln, d = new cn, f = it(r, e, t.alignContent, l, a), v = function(e, n) {
                            var i = g.elements[n];
                            u[h] = p, u[l] = it(e.size[a], m, t.alignItems, l, a), nt(u, e, i), p += e.size[s] + t.spacing
                        }, x = 0; x < i.length; x++) g = i[x], c[h] = p = k.justifyAlign(g.size, e, t.justifyContent, h, s), c[l] = f, d[s] = g.size, d[a] = g.lineSize, m = new un(c, d), k.forEach(g.bboxes, v), f += g.lineSize + t.lineSpacing;
                    !t.wrap && g.size > e.size[s] && (y = e.size[s] / m.size[s], w = m.topLeft().scale(y, y), _ = m.size[a] * y, b = it(_, e, t.alignContent, l, a), C = E(), "x" === h ? C.translate(e.origin.x - w.x, b - w.y) : C.translate(b - w.x, e.origin.y - w.y), C.scale(y, y), this.transform(C))
                }
            },
            _initGroups: function() {
                var t, e, n, i = this,
                    r = this,
                    o = r.options,
                    s = r.children,
                    a = o.lineSpacing,
                    h = o.wrap,
                    l = o.spacing,
                    c = this._fieldMap.sizeField,
                    u = this._newGroup(),
                    d = [],
                    f = function() {
                        d.push(u), p += u.lineSize + a
                    },
                    p = -a;
                for (t = 0; t < s.length; t++) e = s[t], n = s[t].clippedBBox(), e.visible() && n && (h && u.size + n.size[c] + l > i._rect.size[c] ? 0 === u.bboxes.length ? (i._addToGroup(u, n, e), f(), u = i._newGroup()) : (f(), u = i._newGroup(), i._addToGroup(u, n, e)) : i._addToGroup(u, n, e));
                return u.bboxes.length && f(), {
                    groups: d,
                    groupsSize: p
                }
            },
            _addToGroup: function(t, e, n) {
                t.size += e.size[this._fieldMap.sizeField] + this.options.spacing, t.lineSize = Math.max(e.size[this._fieldMap.groupsSizeField], t.lineSize), t.bboxes.push(e), t.elements.push(n)
            },
            _newGroup: function() {
                return {
                    lineSize: 0,
                    size: -this.options.spacing,
                    bboxes: [],
                    elements: []
                }
            }
        }), ii = fn.extend({
            init: function(t, e) {
                void 0 === t && (t = new un), void 0 === e && (e = {}), fn.fn.init.call(this, e), this.geometry(t), i(this.options.stroke) || this.stroke("#000")
            },
            _bbox: function(t) {
                return this._geometry.bbox(t)
            },
            rawBBox: function() {
                return this._geometry.bbox()
            },
            _containsPoint: function(t) {
                return this._geometry.containsPoint(t)
            },
            _isOnPath: function(t) {
                return this.geometry()._isOnPath(t, this.options.stroke.width / 2)
            }
        }), ii.prototype.nodeType = "Rect", vn.extend(ii.prototype), yn.extend(ii.prototype), O(ii.prototype, ["geometry"]), ri = zn.extend({
            _change: function() {
                this.optionsChange({
                    field: "stops"
                })
            }
        }), oi = Ge.extend({
            init: function(t, e, n) {
                this.options = new an({
                    offset: t,
                    color: e,
                    opacity: i(n) ? n : 1
                }), this.options.addObserver(this)
            }
        }), oi.create = function(t) {
            if (i(t)) {
                var e;
                return e = t instanceof oi ? t : t.length > 1 ? new oi(t[0], t[1], t[2]) : new oi(t.offset, t.color, t.opacity)
            }
        }, xt(oi.prototype, ["offset", "color", "opacity"]), We.extend(oi.prototype), si = Ge.extend({
            init: function(t) {
                void 0 === t && (t = {}), this.stops = new ri(this._createStops(t.stops)), this.stops.addObserver(this), this._userSpace = t.userSpace, this.id = r()
            },
            userSpace: function(t) {
                return i(t) ? (this._userSpace = t, this.optionsChange(), this) : this._userSpace
            },
            _createStops: function(t) {
                var e, n;
                for (void 0 === t && (t = []), e = [], n = 0; n < t.length; n++) e.push(oi.create(t[n]));
                return e
            },
            addStop: function(t, e, n) {
                this.stops.push(new oi(t, e, n))
            },
            removeStop: function(t) {
                var e = this.stops.indexOf(t);
                e >= 0 && this.stops.splice(e, 1)
            }
        }), si.prototype.nodeType = "Gradient", We.extend(si.prototype), t.extend(si.prototype, {
            optionsChange: function(t) {
                this.trigger("optionsChange", {
                    field: "gradient" + (t ? "." + t.field : ""),
                    value: this
                })
            },
            geometryChange: function() {
                this.optionsChange()
            }
        }), ai = si.extend({
            init: function(t) {
                void 0 === t && (t = {}), si.fn.init.call(this, t), this.start(t.start || new ln), this.end(t.end || new ln(1, 0))
            }
        }), D(ai.prototype, ["start", "end"]), hi = si.extend({
            init: function(t) {
                void 0 === t && (t = {}), si.fn.init.call(this, t), this.center(t.center || new ln), this._radius = i(t.radius) ? t.radius : 1, this._fallbackFill = t.fallbackFill
            },
            radius: function(t) {
                return i(t) ? (this._radius = t, this.geometryChange(), this) : this._radius
            },
            fallbackFill: function(t) {
                return i(t) ? (this._fallbackFill = t, this.optionsChange(), this) : this._fallbackFill
            }
        }), D(hi.prototype, ["center"]), li = {
            swing: yt,
            linear: wt,
            easeOutElastic: _t
        }, ci = Ge.extend({
            init: function() {
                this._items = []
            },
            register: function(t, e) {
                this._items.push({
                    name: t,
                    type: e
                })
            },
            create: function(t, e) {
                var n, i, r, o = this._items;
                if (e && e.type)
                    for (i = e.type.toLowerCase(), r = 0; r < o.length; r++)
                        if (o[r].name.toLowerCase() === i) {
                            n = o[r];
                            break
                        }
                if (n) return new n.type(t, e)
            }
        }), ci.current = new ci, ui = Date.now || function() {
            return (new Date).getTime()
        }, di = Ge.extend({
            init: function(e, n) {
                this.options = t.extend({}, this.options, n), this.element = e
            },
            setup: function() {},
            step: function() {},
            play: function() {
                var t, e, n, i = this,
                    r = this.options,
                    o = r.duration,
                    s = r.delay;
                void 0 === s && (s = 0), t = li[r.easing], e = ui() + s, n = e + o, 0 === o ? (this.step(1), this.abort()) : setTimeout(function() {
                    var r = function() {
                        var s, a, h, l;
                        i._stopped || (s = ui(), a = d(s - e, 0, o), h = a / o, l = t(h, a, 0, 1, o), i.step(l), s < n ? kendo.animationFrame(r) : i.abort())
                    };
                    r()
                }, s)
            },
            abort: function() {
                this._stopped = !0
            },
            destroy: function() {
                this.abort()
            }
        }), di.prototype.options = {
            duration: 500,
            easing: "swing"
        }, di.create = function(t, e, n) {
            return ci.current.create(t, e, n)
        }, fi = Ge.extend({
            init: function() {
                this._items = []
            },
            register: function(t, e, n) {
                var i = this._items,
                    r = i[0],
                    o = {
                        name: t,
                        type: e,
                        order: n
                    };
                !r || n < r.order ? i.unshift(o) : i.push(o)
            },
            create: function(t, e) {
                var n, i, r = this._items,
                    o = r[0];
                if (e && e.type)
                    for (n = e.type.toLowerCase(), i = 0; i < r.length; i++)
                        if (r[i].name === n) {
                            o = r[i];
                            break
                        }
                return o ? new o.type(t, e) : void kendo.logToConsole("Warning: Unable to create Kendo UI Drawing Surface. Possible causes:\n- The browser does not support SVG and Canvas. User agent: " + navigator.userAgent)
            }
        }), fi.current = new fi, pi = ["click", "mouseenter", "mouseleave", "mousemove", "resize"], gi = kendo.Observable.extend({
            init: function(e, n) {
                kendo.Observable.fn.init.call(this), this.options = t.extend({}, n), this.element = e, this.element._kendoExportVisual = this.exportVisual.bind(this), this._click = this._handler("click"), this._mouseenter = this._handler("mouseenter"), this._mouseleave = this._handler("mouseleave"), this._mousemove = this._handler("mousemove"), this._visual = new Jn, b(e, this.options), this.bind(pi, this.options), this._enableTracking()
            },
            draw: function(t) {
                this._visual.children.push(t)
            },
            clear: function() {
                this._visual.children = []
            },
            destroy: function() {
                this._visual = null, this.element._kendoExportVisual = null, this.unbind()
            },
            eventTarget: function(t) {
                for (var e, n = this, i = l(t); !e && i && (e = i._kendoNode, i !== n.element);) i = i.parentElement;
                if (e) return e.srcElement
            },
            exportVisual: function() {
                return this._visual
            },
            getSize: function() {
                return b(this.element)
            },
            currentSize: function(t) {
                return t ? void(this._size = t) : this._size
            },
            setSize: function(t) {
                b(this.element, t), this.currentSize(t), this._resize()
            },
            resize: function(t) {
                var e = this.getSize(),
                    n = this.currentSize();
                (t || (e.width > 0 || e.height > 0) && (!n || e.width !== n.width || e.height !== n.height)) && (this.currentSize(e), this._resize(e, t), this.trigger("resize", e))
            },
            size: function(t) {
                return t ? void this.setSize(t) : this.getSize()
            },
            suspendTracking: function() {
                this._suspendedTracking = !0
            },
            resumeTracking: function() {
                this._suspendedTracking = !1
            },
            _enableTracking: function() {},
            _resize: function() {},
            _handler: function(t) {
                var e = this;
                return function(n) {
                    var i = e.eventTarget(n);
                    i && !e._suspendedTracking && e.trigger(t, {
                        element: i,
                        originalEvent: n,
                        type: t
                    })
                }
            },
            _elementOffset: function() {
                var t = this.element,
                    e = w(t, ["paddingLeft", "paddingTop"]),
                    n = e.paddingLeft,
                    i = e.paddingTop,
                    r = y(t),
                    o = r.left,
                    s = r.top;
                return {
                    left: o + parseInt(n, 10),
                    top: s + parseInt(i, 10)
                }
            },
            _surfacePoint: function(t) {
                var e = this._elementOffset(),
                    n = h(t),
                    i = n.x - e.left,
                    r = n.y - e.top;
                return new ln(i, r)
            }
        }), gi.create = function(t, e) {
            return fi.current.create(t, e)
        }, gi.support = {}, mi = Ge.extend({
            init: function(t) {
                this.childNodes = [], this.parent = null, t && (this.srcElement = t, this.observe())
            },
            destroy: function() {
                var t, e, n = this;
                for (this.srcElement && this.srcElement.removeObserver(this), t = this.childNodes, e = 0; e < t.length; e++) n.childNodes[e].destroy();
                this.parent = null
            },
            load: function() {},
            observe: function() {
                this.srcElement && this.srcElement.addObserver(this)
            },
            append: function(t) {
                this.childNodes.push(t), t.parent = this
            },
            insertAt: function(t, e) {
                this.childNodes.splice(e, 0, t), t.parent = this
            },
            remove: function(t, e) {
                var n, i = this,
                    r = t + e;
                for (n = t; n < r; n++) i.childNodes[n].removeSelf();
                this.childNodes.splice(t, e)
            },
            removeSelf: function() {
                this.clear(), this.destroy()
            },
            clear: function() {
                this.remove(0, this.childNodes.length)
            },
            invalidate: function() {
                this.parent && this.parent.invalidate()
            },
            geometryChange: function() {
                this.invalidate()
            },
            optionsChange: function() {
                this.invalidate()
            },
            childrenChange: function(t) {
                "add" === t.action ? this.load(t.items, t.index) : "remove" === t.action && this.remove(t.index, t.items.length), this.invalidate()
            }
        }), vi = {}, xi = "http://www.w3.org/2000/svg", yi = "none", wi = function(t, e) {
            t.innerHTML = e
        }, "undefined" != typeof document && (_i = "<svg xmlns='" + xi + "'></svg>", bi = document.createElement("div"), Ci = "undefined" != typeof DOMParser, bi.innerHTML = _i, Ci && bi.firstChild.namespaceURI !== xi && (wi = function(t, e) {
            var n = new DOMParser,
                i = n.parseFromString(e, "text/xml"),
                r = document.adoptNode(i.documentElement);
            t.innerHTML = "", t.appendChild(r)
        })), ki = wi, Ti = "transform", Mi = {
            clip: "clip-path",
            fill: "fill"
        }, Si = mi.extend({
            init: function(t, e) {
                mi.fn.init.call(this, t), this.definitions = {}, this.options = e
            },
            destroy: function() {
                this.element && (this.element._kendoNode = null, this.element = null), this.clearDefinitions(), mi.fn.destroy.call(this)
            },
            load: function(t, e) {
                var n, r, o, s, a, h = this;
                for (n = 0; n < t.length; n++) r = t[n], o = r.children, s = new vi[r.nodeType](r, h.options), i(e) ? h.insertAt(s, e) : h.append(s), s.createDefinitions(), o && o.length > 0 && s.load(o), a = h.element, a && s.attachTo(a, e)
            },
            root: function() {
                for (var t = this; t.parent;) t = t.parent;
                return t
            },
            attachTo: function(t, e) {
                var n, r = document.createElement("div");
                ki(r, "<svg xmlns='" + xi + "' version='1.1'>" + this.render() + "</svg>"), n = r.firstChild.firstChild, n && (i(e) ? t.insertBefore(n, t.childNodes[e] || null) : t.appendChild(n), this.setElement(n))
            },
            setElement: function(t) {
                var e, n, i;
                for (this.element && (this.element._kendoNode = null), this.element = t, this.element._kendoNode = this, e = this.childNodes, n = 0; n < e.length; n++) i = t.childNodes[n], e[n].setElement(i)
            },
            clear: function() {
                var t, e;
                for (this.clearDefinitions(), this.element && (this.element.innerHTML = ""), t = this.childNodes, e = 0; e < t.length; e++) t[e].destroy();
                this.childNodes = []
            },
            removeSelf: function() {
                if (this.element) {
                    var t = this.element.parentNode;
                    t && t.removeChild(this.element), this.element = null
                }
                mi.fn.removeSelf.call(this)
            },
            template: function() {
                return this.renderChildren()
            },
            render: function() {
                return this.template()
            },
            renderChildren: function() {
                var t, e = this.childNodes,
                    n = "";
                for (t = 0; t < e.length; t++) n += e[t].render();
                return n
            },
            optionsChange: function(t) {
                var e = t.field,
                    n = t.value;
                "visible" === e ? this.css("display", n ? "" : yi) : Mi[e] && Tt(e, n) ? this.updateDefinition(e, n) : "opacity" === e ? this.attr("opacity", n) : "cursor" === e ? this.css("cursor", n) : "id" === e && (n ? this.attr("id", n) : this.removeAttr("id")), mi.fn.optionsChange.call(this, t)
            },
            attr: function(t, e) {
                this.element && this.element.setAttribute(t, e)
            },
            allAttr: function(t) {
                var e, n = this;
                for (e = 0; e < t.length; e++) n.attr(t[e][0], t[e][1])
            },
            css: function(t, e) {
                this.element && (this.element.style[t] = e)
            },
            allCss: function(t) {
                var e, n = this;
                for (e = 0; e < t.length; e++) n.css(t[e][0], t[e][1])
            },
            removeAttr: function(t) {
                this.element && this.element.removeAttribute(t)
            },
            mapTransform: function(t) {
                var e = [];
                return t && e.push([Ti, "matrix(" + t.matrix().toString(6) + ")"]), e
            },
            renderTransform: function() {
                return Ct(this.mapTransform(this.srcElement.transform()))
            },
            transformChange: function(t) {
                t ? this.allAttr(this.mapTransform(t)) : this.removeAttr(Ti)
            },
            mapStyle: function() {
                var t = this.srcElement.options,
                    e = [
                        ["cursor", t.cursor]
                    ];
                return t.visible === !1 && e.push(["display", yi]), e
            },
            renderStyle: function() {
                return bt("style", kt(this.mapStyle(!0)))
            },
            renderOpacity: function() {
                return bt("opacity", this.srcElement.options.opacity)
            },
            renderId: function() {
                return bt("id", this.srcElement.options.id)
            },
            createDefinitions: function() {
                var t, e, n, i, r = this.srcElement,
                    o = this.definitions;
                if (r) {
                    t = r.options;
                    for (n in Mi) i = t.get(n), i && Tt(n, i) && (o[n] = i, e = !0);
                    e && this.definitionChange({
                        action: "add",
                        definitions: o
                    })
                }
            },
            definitionChange: function(t) {
                this.parent && this.parent.definitionChange(t)
            },
            updateDefinition: function(t, e) {
                var n = this.definitions,
                    i = n[t],
                    r = Mi[t],
                    o = {};
                i && (o[t] = i, this.definitionChange({
                    action: "remove",
                    definitions: o
                }), delete n[t]), e ? (o[t] = e, this.definitionChange({
                    action: "add",
                    definitions: o
                }), n[t] = e, this.attr(r, this.refUrl(e.id))) : i && this.removeAttr(r)
            },
            clearDefinitions: function() {
                var t = this.definitions;
                this.definitionChange({
                    action: "remove",
                    definitions: t
                }), this.definitions = {}
            },
            renderDefinitions: function() {
                return Ct(this.mapDefinitions())
            },
            mapDefinitions: function() {
                var t, e = this,
                    n = this.definitions,
                    i = [];
                for (t in n) i.push([Mi[t], e.refUrl(n[t].id)]);
                return i
            },
            refUrl: function(t) {
                var e = (this.options || {}).skipBaseHref,
                    n = this.baseUrl().replace(/'/g, "\\'"),
                    i = e ? "" : n;
                return "url(" + i + "#" + t + ")"
            },
            baseUrl: function() {
                return Mt()
            }
        }), Ei = Si.extend({
            template: function() {
                return "<stop " + this.renderOffset() + " " + this.renderStyle() + " />"
            },
            renderOffset: function() {
                return bt("offset", this.srcElement.offset())
            },
            mapStyle: function() {
                var t = this.srcElement;
                return [
                    ["stop-color", t.color()],
                    ["stop-opacity", t.opacity()]
                ]
            },
            optionsChange: function(t) {
                "offset" === t.field ? this.attr(t.field, t.value) : "color" !== t.field && "opacity" !== t.field || this.css("stop-" + t.field, t.value)
            }
        }), Ai = Si.extend({
            init: function(t) {
                Si.fn.init.call(this, t), this.id = t.id, this.loadStops()
            },
            loadStops: function() {
                var t, e, n = this,
                    i = this.srcElement.stops,
                    r = this.element;
                for (t = 0; t < i.length; t++) e = new Ei(i[t]), n.append(e), r && e.attachTo(r)
            },
            optionsChange: function(t) {
                "gradient.stops" === t.field ? (mi.prototype.clear.call(this), this.loadStops()) : "gradient" === t.field && this.allAttr(this.mapCoordinates())
            },
            renderCoordinates: function() {
                return Ct(this.mapCoordinates())
            },
            mapSpace: function() {
                return ["gradientUnits", this.srcElement.userSpace() ? "userSpaceOnUse" : "objectBoundingBox"]
            }
        }), Pi = Ai.extend({
            template: function() {
                return "<linearGradient id='" + this.id + "' " + this.renderCoordinates() + ">" + this.renderChildren() + "</linearGradient>"
            },
            mapCoordinates: function() {
                var t = this.srcElement,
                    e = t.start(),
                    n = t.end(),
                    i = [
                        ["x1", e.x],
                        ["y1", e.y],
                        ["x2", n.x],
                        ["y2", n.y], this.mapSpace()
                    ];
                return i
            }
        }), Oi = Ai.extend({
            template: function() {
                return "<radialGradient id='" + this.id + "' " + this.renderCoordinates() + ">" + this.renderChildren() + "</radialGradient>"
            },
            mapCoordinates: function() {
                var t = this.srcElement,
                    e = t.center(),
                    n = t.radius(),
                    i = [
                        ["cx", e.x],
                        ["cy", e.y],
                        ["r", n], this.mapSpace()
                    ];
                return i
            }
        }), zi = Si.extend({
            init: function(t) {
                Si.fn.init.call(this), this.srcElement = t, this.id = t.id, this.load([t])
            },
            template: function() {
                return "<clipPath id='" + this.id + "'>" + this.renderChildren() + "</clipPath>"
            }
        }), Ni = Si.extend({
            init: function() {
                Si.fn.init.call(this), this.definitionMap = {}
            },
            attachTo: function(t) {
                this.element = t
            },
            template: function() {
                return "<defs>" + this.renderChildren() + "</defs>"
            },
            definitionChange: function(t) {
                var e = t.definitions,
                    n = t.action;
                "add" === n ? this.addDefinitions(e) : "remove" === n && this.removeDefinitions(e)
            },
            createDefinition: function(t, e) {
                var n;
                return "clip" === t ? n = zi : "fill" === t && (e instanceof ai ? n = Pi : e instanceof hi && (n = Oi)), new n(e)
            },
            addDefinitions: function(t) {
                var e, n = this;
                for (e in t) n.addDefinition(e, t[e])
            },
            addDefinition: function(t, e) {
                var n, i = this,
                    r = i.element,
                    o = i.definitionMap,
                    s = e.id,
                    a = o[s];
                a ? a.count++ : (n = this.createDefinition(t, e), o[s] = {
                    element: n,
                    count: 1
                }, this.append(n), r && n.attachTo(this.element))
            },
            removeDefinitions: function(t) {
                var e, n = this;
                for (e in t) n.removeDefinition(t[e])
            },
            removeDefinition: function(t) {
                var e = this.definitionMap,
                    n = t.id,
                    i = e[n];
                i && (i.count--, 0 === i.count && (this.remove(this.childNodes.indexOf(i.element), 1), delete e[n]))
            }
        }), Ri = Si.extend({
            init: function(t) {
                Si.fn.init.call(this), this.options = t, this.defs = new Ni
            },
            attachTo: function(t) {
                this.element = t, this.defs.attachTo(t.firstElementChild)
            },
            clear: function() {
                mi.prototype.clear.call(this)
            },
            template: function() {
                return this.defs.render() + this.renderChildren()
            },
            definitionChange: function(t) {
                this.defs.definitionChange(t)
            }
        }), Bi = "rtl", Li = gi.extend({
            init: function(e, n) {
                gi.fn.init.call(this, e, n), this._root = new Ri(t.extend({
                    rtl: w(e, "direction").direction === Bi
                }, this.options)), ki(this.element, this._template()), this._rootElement = this.element.firstElementChild, St(this._rootElement), this._root.attachTo(this._rootElement), x(this.element, {
                    click: this._click,
                    mouseover: this._mouseenter,
                    mouseout: this._mouseleave,
                    mousemove: this._mousemove
                }), this.resize()
            },
            destroy: function() {
                this._root && (this._root.destroy(), this._root = null, this._rootElement = null, C(this.element, {
                    click: this._click,
                    mouseover: this._mouseenter,
                    mouseout: this._mouseleave,
                    mousemove: this._mousemove
                })), gi.fn.destroy.call(this)
            },
            translate: function(t) {
                var e = Math.round(t.x) + " " + Math.round(t.y) + " " + this._size.width + " " + this._size.height;
                this._offset = t, this._rootElement.setAttribute("viewBox", e)
            },
            draw: function(t) {
                gi.fn.draw.call(this, t), this._root.load([t])
            },
            clear: function() {
                gi.fn.clear.call(this), this._root.clear()
            },
            svg: function() {
                return "<?xml version='1.0' ?>" + this._template()
            },
            exportVisual: function() {
                var t, e = this,
                    n = e._visual,
                    i = e._offset;
                return i && (t = new Jn, t.children.push(n), t.transform(E().translate(-i.x, -i.y)), n = t), n
            },
            _resize: function() {
                this._offset && this.translate(this._offset)
            },
            _template: function() {
                return "<svg style='width: 100%; height: 100%; overflow: hidden;' xmlns='" + xi + "' xmlns:xlink='http://www.w3.org/1999/xlink' version='1.1'>" + this._root.render() + "</svg>"
            }
        }), Li.prototype.type = "svg", "undefined" != typeof document && document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure", "1.1") && (gi.support.svg = !0, fi.current.register("svg", Li, 10)), Fi = Si.extend({
            template: function() {
                return "<g" + (this.renderId() + this.renderTransform() + this.renderStyle() + this.renderOpacity() + this.renderDefinitions()) + ">" + this.renderChildren() + "</g>"
            },
            optionsChange: function(t) {
                "transform" === t.field && this.transformChange(t.value), Si.fn.optionsChange.call(this, t)
            }
        }), vi.Group = Fi, Ii = {
            dot: [1.5, 3.5],
            dash: [4, 3.5],
            longdash: [8, 3.5],
            dashdot: [3.5, 3.5, 1.5, 3.5],
            longdashdot: [8, 3.5, 1.5, 3.5],
            longdashdotdot: [8, 3.5, 1.5, 3.5, 1.5, 3.5]
        }, Di = "solid", Hi = "butt", ji = {
            "fill.opacity": "fill-opacity",
            "stroke.color": "stroke",
            "stroke.width": "stroke-width",
            "stroke.opacity": "stroke-opacity"
        }, qi = " ", Gi = Si.extend({
            geometryChange: function() {
                this.attr("d", this.renderData()), this.invalidate()
            },
            optionsChange: function(t) {
                switch (t.field) {
                    case "fill":
                        t.value ? this.allAttr(this.mapFill(t.value)) : this.removeAttr("fill");
                        break;
                    case "fill.color":
                        this.allAttr(this.mapFill({
                            color: t.value
                        }));
                        break;
                    case "stroke":
                        t.value ? this.allAttr(this.mapStroke(t.value)) : this.removeAttr("stroke");
                        break;
                    case "transform":
                        this.transformChange(t.value);
                        break;
                    default:
                        var e = ji[t.field];
                        e && this.attr(e, t.value)
                }
                Si.fn.optionsChange.call(this, t)
            },
            content: function() {
                this.element && (this.element.textContent = this.srcElement.content())
            },
            renderData: function() {
                return this.printPath(this.srcElement)
            },
            printPath: function(t) {
                var e, n, i, r, o, s = this,
                    a = t.segments,
                    h = a.length;
                if (h > 0) {
                    for (e = [], r = 1; r < h; r++) o = s.segmentType(a[r - 1], a[r]),
                        o !== i && (i = o, e.push(o)), e.push("L" === o ? s.printPoints(a[r].anchor()) : s.printPoints(a[r - 1].controlOut(), a[r].controlIn(), a[r].anchor()));
                    return n = "M" + this.printPoints(a[0].anchor()) + qi + e.join(qi), t.options.closed && (n += "Z"), n
                }
            },
            printPoints: function() {
                var t, e = arguments,
                    n = e.length,
                    i = [];
                for (t = 0; t < n; t++) i.push(e[t].toString(3));
                return i.join(" ")
            },
            segmentType: function(t, e) {
                return t.controlOut() && e.controlIn() ? "C" : "L"
            },
            mapStroke: function(t) {
                var e = [];
                return t && !c(t.color) ? (e.push(["stroke", t.color]), e.push(["stroke-width", t.width]), e.push(["stroke-linecap", this.renderLinecap(t)]), e.push(["stroke-linejoin", t.lineJoin]), i(t.opacity) && e.push(["stroke-opacity", t.opacity]), i(t.dashType) && e.push(["stroke-dasharray", this.renderDashType(t)])) : e.push(["stroke", yi]), e
            },
            renderStroke: function() {
                return Ct(this.mapStroke(this.srcElement.options.stroke))
            },
            renderDashType: function(t) {
                var e, n, i, r = t.dashType,
                    o = t.width;
                if (void 0 === o && (o = 1), r && r !== Di) {
                    for (e = Ii[r.toLowerCase()], n = [], i = 0; i < e.length; i++) n.push(e[i] * o);
                    return n.join(" ")
                }
            },
            renderLinecap: function(t) {
                var e = t.dashType,
                    n = t.lineCap;
                return e && "solid" !== e ? Hi : n
            },
            mapFill: function(t) {
                var e = [];
                return t && "Gradient" === t.nodeType || (t && !c(t.color) ? (e.push(["fill", t.color]), i(t.opacity) && e.push(["fill-opacity", t.opacity])) : e.push(["fill", yi])), e
            },
            renderFill: function() {
                return Ct(this.mapFill(this.srcElement.options.fill))
            },
            template: function() {
                return "<path " + this.renderId() + " " + this.renderStyle() + " " + this.renderOpacity() + " " + bt("d", this.renderData()) + this.renderStroke() + this.renderFill() + this.renderDefinitions() + this.renderTransform() + "></path>"
            }
        }), vi.Path = Gi, $i = Gi.extend({
            renderData: function() {
                return this.printPath(this.srcElement.toPath())
            }
        }), vi.Arc = $i, Vi = Gi.extend({
            geometryChange: function() {
                var t = this.center();
                this.attr("cx", t.x), this.attr("cy", t.y), this.attr("r", this.radius()), this.invalidate()
            },
            center: function() {
                return this.srcElement.geometry().center
            },
            radius: function() {
                return this.srcElement.geometry().radius
            },
            template: function() {
                return "<circle " + this.renderId() + " " + this.renderStyle() + " " + this.renderOpacity() + "cx='" + this.center().x + "' cy='" + this.center().y + "' r='" + this.radius() + "'" + this.renderStroke() + " " + this.renderFill() + " " + this.renderDefinitions() + this.renderTransform() + " ></circle>"
            }
        }), vi.Circle = Vi, Ui = Gi.extend({
            geometryChange: function() {
                var t = this.srcElement.geometry();
                this.attr("x", t.origin.x), this.attr("y", t.origin.y), this.attr("width", t.size.width), this.attr("height", t.size.height), this.invalidate()
            },
            size: function() {
                return this.srcElement.geometry().size
            },
            origin: function() {
                return this.srcElement.geometry().origin
            },
            template: function() {
                return "<rect " + this.renderId() + " " + this.renderStyle() + " " + this.renderOpacity() + " x='" + this.origin().x + "' y='" + this.origin().y + "' width='" + this.size().width + "' height='" + this.size().height + "' " + this.renderStroke() + " " + this.renderFill() + " " + this.renderDefinitions() + " " + this.renderTransform() + " />"
            }
        }), vi.Rect = Ui, Xi = Gi.extend({
            geometryChange: function() {
                this.allAttr(this.mapPosition()), this.invalidate()
            },
            optionsChange: function(t) {
                "src" === t.field && this.allAttr(this.mapSource()), Gi.fn.optionsChange.call(this, t)
            },
            mapPosition: function() {
                var t = this.srcElement.rect(),
                    e = t.topLeft();
                return [
                    ["x", e.x],
                    ["y", e.y],
                    ["width", t.width() + "px"],
                    ["height", t.height() + "px"]
                ]
            },
            renderPosition: function() {
                return Ct(this.mapPosition())
            },
            mapSource: function(t) {
                var e = this.srcElement.src();
                return t && (e = kendo.htmlEncode(e)), [
                    ["xlink:href", e]
                ]
            },
            renderSource: function() {
                return Ct(this.mapSource(!0))
            },
            template: function() {
                return "<image preserveAspectRatio='none' " + this.renderId() + " " + this.renderStyle() + " " + this.renderTransform() + " " + this.renderOpacity() + this.renderPosition() + " " + this.renderSource() + " " + this.renderDefinitions() + "></image>"
            }
        }), vi.Image = Xi, Yi = /&(?:[a-zA-Z]+|#\d+);/g, "undefined" != typeof document && (Et._element = document.createElement("span")), Wi = Gi.extend({
            geometryChange: function() {
                var t = this.pos();
                this.attr("x", t.x), this.attr("y", t.y), this.invalidate()
            },
            optionsChange: function(t) {
                "font" === t.field ? (this.attr("style", kt(this.mapStyle())), this.geometryChange()) : "content" === t.field && Gi.fn.content.call(this, this.srcElement.content()), Gi.fn.optionsChange.call(this, t)
            },
            mapStyle: function(t) {
                var e = Gi.fn.mapStyle.call(this, t),
                    n = this.srcElement.options.font;
                return t && (n = kendo.htmlEncode(n)), e.push(["font", n], ["white-space", "pre"]), e
            },
            pos: function() {
                var t = this.srcElement.position(),
                    e = this.srcElement.measure();
                return t.clone().setY(t.y + e.baseline)
            },
            renderContent: function() {
                var t = this.srcElement.content();
                return t = Et(t), t = kendo.htmlEncode(t), $e.normalizeText(t)
            },
            renderTextAnchor: function() {
                var t;
                return !(this.options || {}).rtl || Ue.msie || Ue.edge || (t = "end"), bt("text-anchor", t)
            },
            template: function() {
                return "<text " + this.renderId() + " " + this.renderTextAnchor() + " " + this.renderStyle() + " " + this.renderOpacity() + "x='" + this.pos().x + "' y='" + this.pos().y + "' " + this.renderStroke() + " " + this.renderTransform() + " " + this.renderDefinitions() + this.renderFill() + ">" + this.renderContent() + "</text>"
            }
        }), vi.Text = Wi, Qi = Gi.extend({
            renderData: function() {
                var t, e, n = this,
                    i = this.srcElement.paths;
                if (i.length > 0) {
                    for (t = [], e = 0; e < i.length; e++) t.push(n.printPath(i[e]));
                    return t.join(" ")
                }
            }
        }), vi.MultiPath = Qi, Zi = {
            Circle: gn,
            Arc: Tn,
            Rect: un,
            Point: ln,
            Segment: Bn,
            Matrix: hn,
            Size: cn,
            toMatrix: S,
            Transformation: dn,
            transform: E
        }, Ji = {
            Surface: Li,
            RootNode: Ri,
            Node: Si,
            GroupNode: Fi,
            ArcNode: $i,
            CircleNode: Vi,
            RectNode: Ui,
            ImageNode: Xi,
            TextNode: Wi,
            PathNode: Gi,
            MultiPathNode: Qi,
            DefinitionNode: Ni,
            ClipNode: zi,
            GradientStopNode: Ei,
            LinearGradientNode: Pi,
            RadialGradientNode: Oi,
            exportGroup: At
        }, Ki = {}, tr = mi.extend({
            init: function(t) {
                mi.fn.init.call(this, t), t && this.initClip()
            },
            initClip: function() {
                var t = this.srcElement.clip();
                t && (this.clip = t, t.addObserver(this))
            },
            clear: function() {
                this.srcElement && this.srcElement.removeObserver(this), this.clearClip(), mi.fn.clear.call(this)
            },
            clearClip: function() {
                this.clip && (this.clip.removeObserver(this), delete this.clip)
            },
            setClip: function(t) {
                this.clip && (t.beginPath(), Pt(t, this.clip), t.clip())
            },
            optionsChange: function(t) {
                "clip" === t.field && (this.clearClip(), this.initClip()), mi.fn.optionsChange.call(this, t)
            },
            setTransform: function(t) {
                if (this.srcElement) {
                    var e = this.srcElement.transform();
                    e && t.transform.apply(t, e.matrix().toArray(6))
                }
            },
            loadElements: function(t, e, n) {
                var r, o, s, a, h = this;
                for (r = 0; r < t.length; r++) o = t[r], s = o.children, a = new Ki[o.nodeType](o, n), s && s.length > 0 && a.load(s, e, n), i(e) ? h.insertAt(a, e) : h.append(a)
            },
            load: function(t, e, n) {
                this.loadElements(t, e, n), this.invalidate()
            },
            setOpacity: function(t) {
                if (this.srcElement) {
                    var e = this.srcElement.opacity();
                    i(e) && this.globalAlpha(t, e)
                }
            },
            globalAlpha: function(t, e) {
                var n = e;
                n && t.globalAlpha && (n *= t.globalAlpha), t.globalAlpha = n
            },
            visible: function() {
                var t = this.srcElement;
                return !t || t && t.options.visible !== !1
            }
        }), er = tr.extend({
            renderTo: function(t) {
                var e, n, i;
                if (this.visible()) {
                    for (t.save(), this.setTransform(t), this.setClip(t), this.setOpacity(t), e = this.childNodes, n = 0; n < e.length; n++) i = e[n], i.visible() && i.renderTo(t);
                    t.restore()
                }
            }
        }), Zn.extend(er.prototype, "childNodes"), Ki.Group = er, nr = 1e3 / 60, ir = er.extend({
            init: function(t) {
                er.fn.init.call(this), this.canvas = t, this.ctx = t.getContext("2d");
                var e = this._invalidate.bind(this);
                this.invalidate = kendo.throttle(function() {
                    kendo.animationFrame(e)
                }, nr)
            },
            destroy: function() {
                er.fn.destroy.call(this), this.canvas = null, this.ctx = null
            },
            load: function(t, e, n) {
                this.loadElements(t, e, n), this._invalidate()
            },
            _invalidate: function() {
                this.ctx && (this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height), this.renderTo(this.ctx))
            }
        }), Zn.extend(ir.prototype, "childNodes"), rr = Ge.extend({
            init: function() {
                this.shapes = []
            },
            _add: function(t, e) {
                this.shapes.push({
                    bbox: e,
                    shape: t
                }), t._quadNode = this
            },
            pointShapes: function(t) {
                var e, n = this.shapes,
                    i = n.length,
                    r = [];
                for (e = 0; e < i; e++) n[e].bbox.containsPoint(t) && r.push(n[e].shape);
                return r
            },
            insert: function(t, e) {
                this._add(t, e)
            },
            remove: function(t) {
                var e, n = this.shapes,
                    i = n.length;
                for (e = 0; e < i; e++)
                    if (n[e].shape === t) {
                        n.splice(e, 1);
                        break
                    }
            }
        }), or = rr.extend({
            init: function(t) {
                rr.fn.init.call(this), this.children = [], this.rect = t
            },
            inBounds: function(t) {
                var e = this.rect,
                    n = e.bottomRight(),
                    i = t.bottomRight(),
                    r = e.origin.x <= t.origin.x && e.origin.y <= t.origin.y && i.x <= n.x && i.y <= n.y;
                return r
            },
            pointShapes: function(t) {
                var n, i = this.children,
                    r = i.length,
                    o = rr.fn.pointShapes.call(this, t);
                for (n = 0; n < r; n++) e(o, i[n].pointShapes(t));
                return o
            },
            insert: function(t, e) {
                var n, i = this.children,
                    r = !1;
                if (this.inBounds(e)) {
                    if (this.shapes.length < 4) this._add(t, e);
                    else {
                        for (i.length || this._initChildren(), n = 0; n < i.length; n++)
                            if (i[n].insert(t, e)) {
                                r = !0;
                                break
                            }
                        r || this._add(t, e)
                    }
                    r = !0
                }
                return r
            },
            _initChildren: function() {
                var t = this,
                    e = t.rect,
                    n = t.children,
                    i = e.center(),
                    r = e.width() / 2,
                    o = e.height() / 2;
                n.push(new or(new un([e.origin.x, e.origin.y], [r, o])), new or(new un([i.x, e.origin.y], [r, o])), new or(new un([e.origin.x, i.y], [r, o])), new or(new un([i.x, i.y], [r, o])))
            }
        }), sr = 3e3, ar = 1e4, hr = 75, lr = Ge.extend({
            init: function() {
                this.initRoots()
            },
            initRoots: function() {
                this.rootMap = {}, this.root = new rr, this.rootElements = []
            },
            clear: function() {
                var t, e = this,
                    n = this.rootElements;
                for (t = 0; t < n.length; t++) e.remove(n[t]);
                this.initRoots()
            },
            pointShape: function(t) {
                var e, n = (this.rootMap[Math.floor(t.x / sr)] || {})[Math.floor(t.y / sr)],
                    i = this.root.pointShapes(t);
                for (n && (i = i.concat(n.pointShapes(t))), this.assignZindex(i), i.sort(Ot), e = 0; e < i.length; e++)
                    if (i[e].containsPoint(t)) return i[e]
            },
            assignZindex: function(t) {
                var e, n, i, r, o, s = this;
                for (e = 0; e < t.length; e++) {
                    for (n = t[e], i = 0, r = Math.pow(ar, hr), o = []; n;) o.push(n), n = n.parent;
                    for (; o.length;) n = o.pop(), i += ((n.parent ? n.parent.children : s.rootElements).indexOf(n) + 1) * r, r /= ar;
                    t[e]._zIndex = i
                }
            },
            optionsChange: function(t) {
                "transform" !== t.field && "stroke.width" !== t.field || this.bboxChange(t.element)
            },
            geometryChange: function(t) {
                this.bboxChange(t.element)
            },
            bboxChange: function(t) {
                var e, n = this;
                if ("Group" === t.nodeType)
                    for (e = 0; e < t.children.length; e++) n.bboxChange(t.children[e]);
                else t._quadNode && t._quadNode.remove(t), this._insertShape(t)
            },
            add: function(t) {
                var n = Array.isArray(t) ? t.slice(0) : [t];
                e(this.rootElements, n), this._insert(n)
            },
            childrenChange: function(t) {
                var e, n = this;
                if ("remove" === t.action)
                    for (e = 0; e < t.items.length; e++) n.remove(t.items[e]);
                else this._insert(Array.prototype.slice.call(t.items, 0))
            },
            _insert: function(t) {
                for (var n, i = this; t.length > 0;) n = t.pop(), n.addObserver(i), "Group" === n.nodeType ? e(t, n.children) : i._insertShape(n)
            },
            _insertShape: function(t) {
                var e, n, i, r, o = t.bbox();
                o && (e = this.getSectors(o), n = e[0][0], i = e[1][0], this.inRoot(e) ? this.root.insert(t, o) : (r = this.rootMap, r[n] || (r[n] = {}), r[n][i] || (r[n][i] = new or(new un([n * sr, i * sr], [sr, sr]))), r[n][i].insert(t, o)))
            },
            remove: function(t) {
                var e, n, i = this;
                if (t.removeObserver(this), "Group" === t.nodeType)
                    for (e = t.children, n = 0; n < e.length; n++) i.remove(e[n]);
                else t._quadNode && (t._quadNode.remove(t), delete t._quadNode)
            },
            inRoot: function(t) {
                return t[0].length > 1 || t[1].length > 1
            },
            getSectors: function(t) {
                var e, n, i = t.bottomRight(),
                    r = Math.floor(i.x / sr),
                    o = Math.floor(i.y / sr),
                    s = [
                        [],
                        []
                    ];
                for (e = Math.floor(t.origin.x / sr); e <= r; e++) s[0].push(e);
                for (n = Math.floor(t.origin.y / sr); n <= o; n++) s[1].push(n);
                return s
            }
        }), cr = Ge.extend({
            init: function(t) {
                t.bind("mouseenter", this._mouseenter.bind(this)), t.bind("mouseleave", this._mouseleave.bind(this)), this.element = t.element
            },
            clear: function() {
                this._resetCursor()
            },
            destroy: function() {
                this._resetCursor(), delete this.element
            },
            _mouseenter: function(t) {
                var e = this._shapeCursor(t);
                e ? (this._current || (this._defaultCursor = this._getCursor()), this._setCursor(e)) : this._resetCursor()
            },
            _mouseleave: function() {
                this._resetCursor()
            },
            _shapeCursor: function(t) {
                for (var e = t.element; e && !i(e.options.cursor);) e = e.parent;
                if (e) return e.options.cursor
            },
            _getCursor: function() {
                if (this.element) return this.element.style.cursor
            },
            _setCursor: function(t) {
                this.element && (this.element.style.cursor = t, this._current = t)
            },
            _resetCursor: function() {
                this._current && (this._setCursor(this._defaultCursor || ""), delete this._current)
            }
        }), ur = gi.extend({
            init: function(t, e) {
                var n, i;
                gi.fn.init.call(this, t, e), this.element.innerHTML = this._template(this), n = this.element.firstElementChild, i = b(t), n.width = i.width, n.height = i.height, this._rootElement = n, this._root = new ir(n), this._mouseTrackHandler = this._trackMouse.bind(this), x(this.element, {
                    click: this._mouseTrackHandler,
                    mousemove: this._mouseTrackHandler
                })
            },
            destroy: function() {
                gi.fn.destroy.call(this), this._root && (this._root.destroy(), this._root = null), this._searchTree && (this._searchTree.clear(), delete this._searchTree), this._cursor && (this._cursor.destroy(), delete this._cursor), C(this.element, {
                    click: this._mouseTrackHandler,
                    mousemove: this._mouseTrackHandler
                })
            },
            draw: function(t) {
                gi.fn.draw.call(this, t), this._root.load([t], void 0, this.options.cors), this._searchTree && this._searchTree.add([t])
            },
            clear: function() {
                gi.fn.clear.call(this), this._root.clear(), this._searchTree && this._searchTree.clear(), this._cursor && this._cursor.clear()
            },
            eventTarget: function(t) {
                var e, n;
                if (this._searchTree) return e = this._surfacePoint(t), n = this._searchTree.pointShape(e)
            },
            image: function() {
                var t, e, n = this,
                    i = n._root,
                    r = n._rootElement,
                    o = [];
                return i.traverse(function(t) {
                    t.loading && o.push(t.loading)
                }), t = Xe(), e = function() {
                    i._invalidate();
                    try {
                        var e = r.toDataURL();
                        t.resolve(e)
                    } catch (n) {
                        t.reject(n)
                    }
                }, Ye(o).then(e, e), t
            },
            suspendTracking: function() {
                gi.fn.suspendTracking.call(this), this._searchTree && (this._searchTree.clear(), delete this._searchTree)
            },
            resumeTracking: function() {
                var t, e, n;
                if (gi.fn.resumeTracking.call(this), !this._searchTree) {
                    for (this._searchTree = new lr, t = this._root.childNodes, e = [], n = 0; n < t.length; n++) e.push(t[n].srcElement);
                    this._searchTree.add(e)
                }
            },
            _resize: function() {
                this._rootElement.width = this._size.width, this._rootElement.height = this._size.height, this._root.invalidate()
            },
            _template: function() {
                return "<canvas style='width: 100%; height: 100%;'></canvas>"
            },
            _enableTracking: function() {
                this._searchTree = new lr, this._cursor = new cr(this), gi.fn._enableTracking.call(this)
            },
            _trackMouse: function(t) {
                var e, n;
                this._suspendedTracking || (e = this.eventTarget(t), "click" !== t.type ? (n = this._currentShape, n && n !== e && this.trigger("mouseleave", {
                    element: n,
                    originalEvent: t,
                    type: "mouseleave"
                }), e && n !== e && this.trigger("mouseenter", {
                    element: e,
                    originalEvent: t,
                    type: "mouseenter"
                }), this.trigger("mousemove", {
                    element: e,
                    originalEvent: t,
                    type: "mousemove"
                }), this._currentShape = e) : e && this.trigger("click", {
                    element: e,
                    originalEvent: t,
                    type: "click"
                }))
            }
        }), ur.prototype.type = "canvas", "undefined" != typeof document && document.createElement("canvas").getContext && (gi.support.canvas = !0, fi.current.register("canvas", ur, 20)), dr = tr.extend({
            renderTo: function(t) {
                t.save(), this.setTransform(t), this.setClip(t), this.setOpacity(t), t.beginPath(), this.renderPoints(t, this.srcElement), this.setLineDash(t), this.setLineCap(t), this.setLineJoin(t), this.setFill(t), this.setStroke(t), t.restore()
            },
            setFill: function(t) {
                var e = this.srcElement.options.fill,
                    n = !1;
                return e && ("Gradient" === e.nodeType ? (this.setGradientFill(t, e), n = !0) : c(e.color) || (t.fillStyle = e.color, t.save(), this.globalAlpha(t, e.opacity), t.fill(), t.restore(), n = !0)), n
            },
            setGradientFill: function(t, e) {
                var n, i, r, o, s = this.srcElement.rawBBox();
                e instanceof ai ? (i = e.start(), r = e.end(), n = t.createLinearGradient(i.x, i.y, r.x, r.y)) : e instanceof hi && (o = e.center(), n = t.createRadialGradient(o.x, o.y, 0, o.x, o.y, e.radius())), zt(n, e.stops), t.save(), e.userSpace() || t.transform(s.width(), 0, 0, s.height(), s.origin.x, s.origin.y), t.fillStyle = n, t.fill(), t.restore()
            },
            setStroke: function(t) {
                var e = this.srcElement.options.stroke;
                if (e && !c(e.color) && e.width > 0) return t.strokeStyle = e.color, t.lineWidth = v(e.width, 1), t.save(), this.globalAlpha(t, e.opacity), t.stroke(), t.restore(), !0
            },
            dashType: function() {
                var t = this.srcElement.options.stroke;
                if (t && t.dashType) return t.dashType.toLowerCase()
            },
            setLineDash: function(t) {
                var e, n = this.dashType();
                n && n !== Di && (e = Ii[n], t.setLineDash ? t.setLineDash(e) : (t.mozDash = e, t.webkitLineDash = e))
            },
            setLineCap: function(t) {
                var e = this.dashType(),
                    n = this.srcElement.options.stroke;
                e && e !== Di ? t.lineCap = Hi : n && n.lineCap && (t.lineCap = n.lineCap)
            },
            setLineJoin: function(t) {
                var e = this.srcElement.options.stroke;
                e && e.lineJoin && (t.lineJoin = e.lineJoin)
            },
            renderPoints: function(t, e) {
                Pt(t, e)
            }
        }), Ki.Path = dr, fr = dr.extend({
            renderPoints: function(t) {
                var e = this.srcElement.toPath();
                Pt(t, e)
            }
        }), Ki.Arc = fr, pr = dr.extend({
            renderPoints: function(t) {
                var e = this.srcElement.geometry(),
                    n = e.center,
                    i = e.radius;
                t.arc(n.x, n.y, i, 0, 2 * Math.PI)
            }
        }), Ki.Circle = pr, gr = dr.extend({
            renderPoints: function(t) {
                var e = this.srcElement.geometry(),
                    n = e.origin,
                    i = e.size;
                t.rect(n.x, n.y, i.width, i.height)
            }
        }), Ki.Rect = gr, mr = dr.extend({
            init: function(t, e) {
                dr.fn.init.call(this, t), this.onLoad = this.onLoad.bind(this), this.onError = this.onError.bind(this), this.loading = Xe();
                var n = this.img = new Image;
                e && !/^data:/i.test(t.src()) && (n.crossOrigin = e), n.src = t.src(), n.complete ? this.onLoad() : (n.onload = this.onLoad, n.onerror = this.onError)
            },
            renderTo: function(t) {
                "resolved" === this.loading.state() && (t.save(), this.setTransform(t), this.setClip(t), this.drawImage(t), t.restore())
            },
            optionsChange: function(t) {
                "src" === t.field ? (this.loading = Xe(), this.img.src = this.srcElement.src()) : dr.fn.optionsChange.call(this, t)
            },
            onLoad: function() {
                this.loading.resolve(), this.invalidate()
            },
            onError: function() {
                this.loading.reject(Error("Unable to load image '" + this.img.src + "'. Check for connectivity and verify CORS headers."))
            },
            drawImage: function(t) {
                var e = this.srcElement.rect(),
                    n = e.topLeft();
                t.drawImage(this.img, n.x, n.y, e.width(), e.height())
            }
        }), Ki.Image = mr, vr = dr.extend({
            renderTo: function(t) {
                var e = this.srcElement,
                    n = e.position(),
                    i = e.measure();
                t.save(), this.setTransform(t), this.setClip(t), this.setOpacity(t), t.beginPath(), t.font = e.options.font, t.textAlign = "left", this.setFill(t) && t.fillText(e.content(), n.x, n.y + i.baseline), this.setStroke(t) && (this.setLineDash(t), t.strokeText(e.content(), n.x, n.y + i.baseline)), t.restore()
            }
        }), Ki.Text = vr, xr = dr.extend({
            renderPoints: function(t) {
                var e, n = this.srcElement.paths;
                for (e = 0; e < n.length; e++) Pt(t, n[e])
            }
        }), Ki.MultiPath = xr, yr = {
            Surface: ur,
            RootNode: ir,
            Node: tr,
            GroupNode: er,
            ArcNode: fr,
            CircleNode: pr,
            RectNode: gr,
            ImageNode: mr,
            TextNode: vr,
            PathNode: dr,
            MultiPathNode: xr
        }, wr = Ue, _r = "KENDO-PSEUDO-ELEMENT", br = {}, Cr = {}, Cr._root = Cr, kr = "undefined" != typeof window, Tr = !!kr && (wr.msie || wr.edge), Mr = Wn.extend({
            init: function(t, e, n) {
                Wn.fn.init.call(this, t, e.getOrigin(), n), this._pdfRect = e
            },
            rect: function() {
                return this._pdfRect
            },
            rawBBox: function() {
                return this._pdfRect
            }
        }), Sr = "undefined" != typeof Element && Element.prototype && function(t) {
            return t.matches ? function(t, e) {
                return t.matches(e)
            } : t.webkitMatchesSelector ? function(t, e) {
                return t.webkitMatchesSelector(e)
            } : t.mozMatchesSelector ? function(t, e) {
                return t.mozMatchesSelector(e)
            } : t.msMatchesSelector ? function(t, e) {
                return t.msMatchesSelector(e)
            } : function(t) {
                return [].indexOf.call(document.querySelectorAll(t), this) !== -1
            }
        }(Element.prototype), Er = function(t) {
            return t ? function e(n) {
                var i, r, o, s, a = n.cloneNode(!1);
                if (1 == n.nodeType) {
                    i = t(n), r = t(a), s = i.data();
                    for (o in s) r.data(o, s[o]);
                    for (/^canvas$/i.test(n.tagName) ? a.getContext("2d").drawImage(n, 0, 0) : /^(?:input|select|textarea|option)$/i.test(n.tagName) && (a.removeAttribute("id"), a.removeAttribute("name"), a.value = n.value, a.checked = n.checked, a.selected = n.selected), o = n.firstChild; o; o = o.nextSibling) a.appendChild(e(o))
                }
                return a
            } : function(t) {
                var e, n = function r(t) {
                        var e, n = t.cloneNode(!1);
                        for (t._kendoExportVisual && (n._kendoExportVisual = t._kendoExportVisual), e = t.firstChild; e; e = e.nextSibling) n.appendChild(r(e));
                        return n
                    }(t),
                    i = t.querySelectorAll("canvas");
                return i.length && Bt(n.querySelectorAll("canvas")).forEach(function(t, e) {
                    t.getContext("2d").drawImage(i[e], 0, 0)
                }), e = t.querySelectorAll("input, select, textarea, option"), Bt(n.querySelectorAll("input, select, textarea, option")).forEach(function(t, n) {
                    t.removeAttribute("id"), t.removeAttribute("name"), t.value = e[n].value, t.checked = e[n].checked, t.selected = e[n].selected
                }), n
            }
        }("undefined" != typeof window && window.kendo && window.kendo.jQuery), jt.getFontFaces = qt, jt.drawText = function(t) {
            var e = new Jn;
            return Cr._clipbox = !1, Cr._matrix = hn.unit(), Cr._stackingContext = {
                element: t,
                group: e
            }, te(t, oe(t), e), 3 == t.firstChild.nodeType ? Fe(t, t.firstChild, e) : Se(t, e), ee(), e
        }, Ar = function() {
            function t(t) {
                function f() {
                    var e = s.exec(t);
                    e && (t = t.substr(e[1].length))
                }

                function p(e) {
                    f();
                    var n = e.exec(t);
                    if (n) return t = t.substr(n[1].length), n[1]
                }

                function g() {
                    var e, r, o, s = kendo.parseColor(t, !0);
                    if (s) return o = /^#[0-9a-f]+/i.exec(t) || /^rgba?\(.*?\)/i.exec(t) || /^..*?\b/.exec(t), t = t.substr(o[0].length), s = s.toRGB(), (e = p(i)) || (r = p(n)), {
                        color: s,
                        length: e,
                        percent: r
                    }
                }

                function m(e) {
                    var i, s, c, u, d, f, m = [],
                        v = !1;
                    if (p(a)) {
                        for (i = p(o), "0" == i && (i = "0deg"), i ? (i = ge(i), p(l)) : (s = p(r), "to" == s ? s = p(r) : s && /^-/.test(e) && (v = !0), c = p(r), p(l)), /-moz-/.test(e) && null == i && null == s && (u = p(n), d = p(n), v = !0, "0%" == u ? s = "left" : "100%" == u && (s = "right"), "0%" == d ? c = "top" : "100%" == d && (c = "bottom"), p(l)); t && !p(h) && (f = g());) m.push(f), p(l);
                        return {
                            type: "linear",
                            angle: i,
                            to: s && c ? s + " " + c : s ? s : c ? c : null,
                            stops: m,
                            reverse: v
                        }
                    }
                }

                function v() {
                    if (p(a)) {
                        var t = p(u);
                        return t = t.replace(/^['"]+|["']+$/g, ""), p(h), {
                            type: "url",
                            url: t
                        }
                    }
                }
                var x, y = t;
                return Gt(d, y) ? d[y] : ((x = p(e)) ? x = m(x) : (x = p(c)) && (x = v()), d[y] = x || {
                    type: "none"
                })
            }
            var e = /^((-webkit-|-moz-|-o-|-ms-)?linear-gradient\s*)\(/,
                n = /^([-0-9.]+%)/,
                i = /^([-0-9.]+px)/,
                r = /^(left|right|top|bottom|to|center)\W/,
                o = /^([-0-9.]+(deg|grad|rad|turn)|0)/,
                s = /^(\s+)/,
                a = /^(\()/,
                h = /^(\))/,
                l = /^(,)/,
                c = /^(url)\(/,
                u = /^(.*?)\)/,
                d = {},
                f = {};
            return function(e) {
                return Gt(f, e) ? f[e] : f[e] = Pr(e).map(t)
            }
        }(), Pr = function() {
            var t = {};
            return function(e, n) {
                function i(t) {
                    return u = t.exec(e.substr(h))
                }

                function r(t) {
                    return t.replace(/^\s+|\s+$/g, "")
                }
                var o, s, a, h, l, c, u;
                if (n || (n = /^\s*,\s*/), o = e + n, Gt(t, o)) return t[o];
                for (s = [], a = 0, h = 0, l = 0, c = !1; h < e.length;) !c && i(/^[\(\[\{]/) ? (l++, h++) : !c && i(/^[\)\]\}]/) ? (l--, h++) : !c && i(/^[\"\']/) ? (c = u[0], h++) : "'" == c && i(/^\\\'/) ? h += 2 : '"' == c && i(/^\\\"/) ? h += 2 : "'" == c && i(/^\'/) ? (c = !1, h++) : '"' == c && i(/^\"/) ? (c = !1, h++) : i(n) ? (!c && !l && h > a && (s.push(r(e.substring(a, h))), a = h + u[0].length), h += u[0].length) : h++;
                return a < h && s.push(r(e.substring(a, h))), t[o] = s
            }
        }(), Or = function(t) {
            return function(e) {
                var n, i = t[e];
                return i || ((n = /url\((['"]?)([^'")]*?)\1\)\s+format\((['"]?)truetype\3\)/.exec(e)) ? i = t[e] = n[2] : (n = /url\((['"]?)([^'")]*?\.ttf)\1\)/.exec(e)) && (i = t[e] = n[2])), i
            }
        }(Object.create ? Object.create(null) : {}), zr = function(t) {
            return function(e) {
                var n = t[e];
                return null == n && (n = t[e] = $e.measureText("Mapq", {
                    font: e
                }).height), n
            }
        }(Object.create ? Object.create(null) : {}), Nr = {
            svg: Ji,
            canvas: yr,
            util: on,
            PathParser: Gn,
            Surface: gi,
            BaseNode: mi,
            SurfaceFactory: fi,
            OptionsStore: an,
            exportImage: Nt,
            exportSVG: Rt,
            QuadNode: or,
            ShapesQuadTree: lr,
            ObserversMixin: We,
            Element: fn,
            Circle: _n,
            Arc: Un,
            Path: $n,
            MultiPath: Ln,
            Text: Wn,
            Image: Qn,
            Group: Jn,
            Layout: ni,
            Rect: ii,
            align: st,
            vAlign: at,
            stack: ct,
            vStack: ut,
            wrap: pt,
            vWrap: gt,
            fit: mt,
            LinearGradient: ai,
            RadialGradient: hi,
            GradientStop: oi,
            Gradient: si,
            Animation: di,
            AnimationFactory: ci,
            drawDOM: jt
        }, kendo.deepExtend(kendo, {
            drawing: Nr,
            geometry: Zi
        }), kendo.drawing.Segment = kendo.geometry.Segment, kendo.dataviz.drawing = kendo.drawing, kendo.dataviz.geometry = kendo.geometry, kendo.drawing.util.measureText = kendo.util.measureText, kendo.drawing.util.objectKey = kendo.util.objectKey, kendo.drawing.Color = kendo.Color, kendo.util.encodeBase64 = kendo.drawing.util.encodeBase64
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(t, e, n) {
    (n || e)()
}),
function(t, define) {
    define("drawing/surface-tooltip.min", ["kendo.popup.min", "drawing/kendo-drawing.min"], t)
}(function() {
    ! function(t) {
        var e = ".kendo",
            n = window.kendo,
            i = n.deepExtend,
            r = n.drawing.util,
            o = r.defined,
            s = r.limitValue,
            a = r.eventCoordinates,
            h = n._outerWidth,
            l = n._outerHeight,
            c = t.proxy,
            u = '<div class="k-tooltip"><div class="k-tooltip-content"></div></div>',
            d = '<div class="k-tooltip-button"><a href="\\#" class="k-icon k-i-close">close</a></div>',
            f = n.Class.extend({
                init: function(e, n) {
                    this.element = t(u), this.content = this.element.children(".k-tooltip-content"), n = n || {}, this.options = i({}, this.options, this._tooltipOptions(n)), this.popupOptions = {
                        appendTo: n.appendTo,
                        animation: n.animation,
                        copyAnchorStyles: !1,
                        collision: "fit fit"
                    }, this._openPopupHandler = t.proxy(this._openPopup, this), this.surface = e, this._bindEvents()
                },
                options: {
                    position: "top",
                    showOn: "mouseenter",
                    offset: 7,
                    autoHide: !0,
                    hideDelay: 0,
                    showAfter: 100
                },
                _bindEvents: function() {
                    this._showHandler = c(this._showEvent, this), this._surfaceLeaveHandler = c(this._surfaceLeave, this), this._mouseleaveHandler = c(this._mouseleave, this), this._mousemoveHandler = c(this._mousemove, this), this.surface.bind("click", this._showHandler), this.surface.bind("mouseenter", this._showHandler), this.surface.bind("mouseleave", this._mouseleaveHandler), this.surface.bind("mousemove", this._mousemoveHandler), this.surface.element.on("mouseleave" + e, this._surfaceLeaveHandler), this.element.on("click" + e, ".k-tooltip-button", c(this._hideClick, this)), this.element.on("mouseleave" + e, c(this._tooltipLeave, this))
                },
                getPopup: function() {
                    return this.popup || (this.popup = new n.ui.Popup(this.element, this.popupOptions)), this.popup
                },
                destroy: function() {
                    var t = this.popup;
                    this.surface.unbind("click", this._showHandler), this.surface.unbind("mouseenter", this._showHandler), this.surface.unbind("mouseleave", this._mouseleaveHandler), this.surface.unbind("mousemove", this._mousemoveHandler), this.surface.element.off("mouseleave" + e, this._surfaceLeaveHandler), this.element.off("click" + e), this.element.off("mouseleave" + e), t && (t.destroy(), delete this.popup), delete this.popupOptions, clearTimeout(this._timeout), delete this.element, delete this.content, delete this.surface
                },
                _tooltipOptions: function(t) {
                    return t = t || {}, {
                        position: t.position,
                        showOn: t.showOn,
                        offset: t.offset,
                        autoHide: t.autoHide,
                        width: t.width,
                        height: t.height,
                        content: t.content,
                        shared: t.shared,
                        hideDelay: t.hideDelay,
                        showAfter: t.showAfter
                    }
                },
                _tooltipShape: function(t) {
                    for (; t && !t.options.tooltip;) t = t.parent;
                    return t
                },
                _updateContent: function(t, e, i) {
                    var r = i.content;
                    if (n.isFunction(r) && (r = r({
                            element: e,
                            target: t
                        })), r) return this.content.html(r), !0
                },
                _position: function(t, e, n, i) {
                    var r, o = e.position,
                        h = e.offset || 0,
                        l = this.surface,
                        c = l._instance._elementOffset(),
                        u = l.getSize(),
                        d = l._instance._offset,
                        f = t.bbox(),
                        p = n.width,
                        g = n.height,
                        m = 0,
                        v = 0;
                    return f.origin.translate(c.left, c.top), d && f.origin.translate(-d.x, -d.y), "cursor" == o && i ? (r = a(i), m = r.x - p / 2, v = r.y - g - h) : "left" == o ? (m = f.origin.x - p - h, v = f.center().y - g / 2) : "right" == o ? (m = f.bottomRight().x + h, v = f.center().y - g / 2) : "bottom" == o ? (m = f.center().x - p / 2, v = f.bottomRight().y + h) : (m = f.center().x - p / 2, v = f.origin.y - g - h), {
                        left: s(m, c.left, c.left + u.width),
                        top: s(v, c.top, c.top + u.height)
                    }
                },
                show: function(t, e) {
                    this._show(t, t, i({}, this.options, this._tooltipOptions(t.options.tooltip), e))
                },
                hide: function() {
                    var t = this.popup,
                        e = this._current;
                    delete this._current, clearTimeout(this._showTimeout), t && t.visible() && e && !this.surface.trigger("tooltipClose", {
                        element: e.shape,
                        target: e.target,
                        popup: t
                    }) && t.close()
                },
                _hideClick: function(t) {
                    t.preventDefault(), this.hide()
                },
                _show: function(t, e, n, i, r) {
                    var o, s, a = this._current;
                    clearTimeout(this._timeout), a && (a.shape === e && n.shared || a.target === t) || (clearTimeout(this._showTimeout), o = this.getPopup(), !this.surface.trigger("tooltipOpen", {
                        element: e,
                        target: t,
                        popup: o
                    }) && this._updateContent(t, e, n) && (this._autoHide(n), s = this._measure(n), o.visible() && o.close(!0), this._current = {
                        options: n,
                        elementSize: s,
                        shape: e,
                        target: t,
                        position: this._position(n.shared ? e : t, n, s, i)
                    }, r ? this._showTimeout = setTimeout(this._openPopupHandler, n.showAfter || 0) : this._openPopup()))
                },
                _openPopup: function() {
                    var t = this._current,
                        e = t.position;
                    this.getPopup().open(e.left, e.top)
                },
                _autoHide: function(e) {
                    e.autoHide && this._closeButton && (this.element.removeClass("k-tooltip-closable"), this._closeButton.remove(), delete this._closeButton), e.autoHide || this._closeButton || (this.element.addClass("k-tooltip-closable"), this._closeButton = t(d).prependTo(this.element))
                },
                _showEvent: function(t) {
                    var e, n = this._tooltipShape(t.element);
                    n && (e = i({}, this.options, this._tooltipOptions(n.options.tooltip)), e && e.showOn == t.type && this._show(t.element, n, e, t.originalEvent, !0))
                },
                _measure: function(t) {
                    var e, n, i, r = this.getPopup();
                    return this.element.css({
                        width: "auto",
                        height: "auto"
                    }), i = r.visible(), i || r.wrapper.show(), this.element.css({
                        width: o(t.width) ? t.width : "auto",
                        height: o(t.height) ? t.height : "auto"
                    }), e = h(this.element), n = l(this.element), i || r.wrapper.hide(), {
                        width: e,
                        height: n
                    }
                },
                _mouseleave: function(t) {
                    var e, n;
                    this.popup && !this._popupRelatedTarget(t.originalEvent) && (e = this, n = e._current, n && n.options.autoHide && (e._timeout = setTimeout(function() {
                        clearTimeout(e._showTimeout), e.hide()
                    }, n.options.hideDelay || 0)))
                },
                _mousemove: function(t) {
                    var e, n, i = this._current;
                    i && t.element && (e = i.options, "cursor" == e.position && (n = this._position(t.element, e, i.elementSize, t.originalEvent), i.position = n, this.getPopup().wrapper.css({
                        left: n.left,
                        top: n.top
                    })))
                },
                _surfaceLeave: function(t) {
                    this.popup && !this._popupRelatedTarget(t) && (clearTimeout(this._showTimeout), this.hide())
                },
                _popupRelatedTarget: function(e) {
                    return e.relatedTarget && t(e.relatedTarget).closest(this.popup.wrapper).length
                },
                _tooltipLeave: function() {
                    var t = this,
                        e = t._current;
                    e && e.options.autoHide && (t._timeout = setTimeout(function() {
                        t.hide()
                    }, e.options.hideDelay || 0))
                }
            });
        n.drawing.SurfaceTooltip = f
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(t, e, n) {
    (n || e)()
}),
function(t, define) {
    define("drawing/surface.min", ["drawing/kendo-drawing.min", "drawing/surface-tooltip.min"], t)
}(function() {
    ! function(t) {
        function e(t) {
            this._instance.translate(t)
        }
        var n, i = window.kendo,
            r = i.drawing,
            o = r.Surface,
            s = i.ui.Widget,
            a = i.deepExtend,
            h = t.proxy;
        i.support.svg = o.support.svg, i.support.canvas = o.support.canvas, n = s.extend({
            init: function(t, n) {
                s.fn.init.call(this, t, {}), this.options = a({}, this.options, n), this._instance = o.create(this.element[0], n), this._instance.translate && (this.translate = e), this._triggerInstanceHandler = h(this._triggerInstanceEvent, this), this._bindHandler("click"), this._bindHandler("mouseenter"), this._bindHandler("mouseleave"), this._bindHandler("mousemove"), this._enableTracking()
            },
            options: {
                name: "Surface",
                tooltip: {}
            },
            events: ["click", "mouseenter", "mouseleave", "mousemove", "resize", "tooltipOpen", "tooltipClose"],
            _triggerInstanceEvent: function(t) {
                this.trigger(t.type, t)
            },
            _bindHandler: function(t) {
                this._instance.bind(t, this._triggerInstanceHandler)
            },
            draw: function(t) {
                this._instance.draw(t)
            },
            clear: function() {
                this._instance && this._instance.clear(), this.hideTooltip()
            },
            destroy: function() {
                this._instance && (this._instance.destroy(), delete this._instance), this._tooltip && (this._tooltip.destroy(), delete this._tooltip), s.fn.destroy.call(this)
            },
            exportVisual: function() {
                return this._instance.exportVisual()
            },
            eventTarget: function(t) {
                return this._instance.eventTarget(t)
            },
            showTooltip: function(t, e) {
                this._tooltip && this._tooltip.show(t, e)
            },
            hideTooltip: function() {
                this._tooltip && this._tooltip.hide()
            },
            suspendTracking: function() {
                this._instance.suspendTracking(), this.hideTooltip()
            },
            resumeTracking: function() {
                this._instance.resumeTracking()
            },
            getSize: function() {
                return {
                    width: this.element.width(),
                    height: this.element.height()
                }
            },
            setSize: function(t) {
                this.element.css({
                    width: t.width,
                    height: t.height
                }), this._size = t, this._instance.currentSize(t), this._resize()
            },
            _resize: function() {
                this._instance.currentSize(this._size), this._instance._resize()
            },
            _enableTracking: function() {
                i.ui.Popup && (this._tooltip = new r.SurfaceTooltip(this, this.options.tooltip || {}))
            }
        }), i.ui.plugin(n), n.create = function(t, e) {
            return new n(t, e)
        }, i.drawing.Surface = n
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(t, e, n) {
    (n || e)()
}),
function(t, define) {
    define("drawing/html.min", ["drawing/kendo-drawing.min"], t)
}(function() {
    ! function(t) {
        var e = window.kendo,
            n = e.drawing,
            i = n.drawDOM;
        n.drawDOM = function(e, n) {
            return i(t(e)[0], n)
        }, n.drawDOM.drawText = i.drawText, n.drawDOM.getFontFaces = i.getFontFaces
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(t, e, n) {
    (n || e)()
}),
function(t, define) {
    define("kendo.drawing.min", ["drawing/util.min", "drawing/kendo-drawing.min", "drawing/surface-tooltip.min", "drawing/surface.min", "drawing/html.min"], t)
}(function() {}, "function" == typeof define && define.amd ? define : function(t, e, n) {
    (n || e)()
});;
! function(t, define) {
    define("kendo.fx.min", ["kendo.core.min"], t)
}(function() {
    return function(t, e) {
        function i(t) {
            return parseInt(t, 10)
        }

        function r(t, e) {
            return i(t.css(e))
        }

        function n(t) {
            var e, i = [];
            for (e in t) i.push(e);
            return i
        }

        function s(t) {
            for (var e in t) L.indexOf(e) != -1 && Q.indexOf(e) == -1 && delete t[e];
            return t
        }

        function o(t, e) {
            var i, r, n, s, o = [],
                a = {};
            for (r in e) i = r.toLowerCase(), s = H && L.indexOf(i) != -1, !E.hasHW3D && s && Q.indexOf(i) == -1 ? delete e[r] : (n = e[r], s ? o.push(r + "(" + n + ")") : a[r] = n);
            return o.length && (a[at] = o.join(" ")), a
        }

        function a(t, e) {
            var r, n, s;
            return H ? (r = t.css(at), r == J ? "scale" == e ? 1 : 0 : (n = r.match(RegExp(e + "\\s*\\(([\\d\\w\\.]+)")), s = 0, n ? s = i(n[1]) : (n = r.match(I) || [0, 0, 0, 0, 0], e = e.toLowerCase(), A.test(e) ? s = parseFloat(n[3] / n[2]) : "translatey" == e ? s = parseFloat(n[4] / n[2]) : "scale" == e ? s = parseFloat(n[2]) : "rotate" == e && (s = parseFloat(Math.atan2(n[2], n[1])))), s)) : parseFloat(t.css(e))
        }

        function c(t) {
            return t.charAt(0).toUpperCase() + t.substring(1)
        }

        function l(t, e) {
            var i = h.extend(e),
                r = i.prototype.directions;
            P[c(t)] = i, P.Element.prototype[t] = function(t, e, r, n) {
                return new i(this.element, t, e, r, n)
            }, T(r, function(e, r) {
                P.Element.prototype[t + c(r)] = function(t, e, n) {
                    return new i(this.element, r, t, e, n)
                }
            })
        }

        function d(t, i, r, n) {
            l(t, {
                directions: v,
                startValue: function(t) {
                    return this._startValue = t, this
                },
                endValue: function(t) {
                    return this._endValue = t, this
                },
                shouldHide: function() {
                    return this._shouldHide
                },
                prepare: function(t, s) {
                    var o, a, c = this,
                        l = "out" === this._direction,
                        d = c.element.data(i),
                        u = !(isNaN(d) || d == r);
                    o = u ? d : e !== this._startValue ? this._startValue : l ? r : n, a = e !== this._endValue ? this._endValue : l ? n : r, this._reverse ? (t[i] = a, s[i] = o) : (t[i] = o, s[i] = a), c._shouldHide = s[i] === n
                }
            })
        }

        function u(t, e) {
            var i = C.directions[e].vertical,
                r = t[i ? Y : X]() / 2 + "px";
            return _[e].replace("$size", r)
        }
        var f, p, h, m, v, x, _, g, y, k, b, w, C = window.kendo,
            P = C.effects,
            T = t.each,
            N = t.extend,
            z = t.proxy,
            E = C.support,
            R = E.browser,
            H = E.transforms,
            D = E.transitions,
            O = {
                scale: 0,
                scalex: 0,
                scaley: 0,
                scale3d: 0
            },
            F = {
                translate: 0,
                translatex: 0,
                translatey: 0,
                translate3d: 0
            },
            S = e !== document.documentElement.style.zoom && !H,
            I = /matrix3?d?\s*\(.*,\s*([\d\.\-]+)\w*?,\s*([\d\.\-]+)\w*?,\s*([\d\.\-]+)\w*?,\s*([\d\.\-]+)\w*?/i,
            q = /^(-?[\d\.\-]+)?[\w\s]*,?\s*(-?[\d\.\-]+)?[\w\s]*/i,
            A = /translatex?$/i,
            V = /(zoom|fade|expand)(\w+)/,
            M = /(zoom|fade|expand)/,
            $ = /[xy]$/i,
            L = ["perspective", "rotate", "rotatex", "rotatey", "rotatez", "rotate3d", "scale", "scalex", "scaley", "scalez", "scale3d", "skew", "skewx", "skewy", "translate", "translatex", "translatey", "translatez", "translate3d", "matrix", "matrix3d"],
            Q = ["rotate", "scale", "scalex", "scaley", "skew", "skewx", "skewy", "translate", "translatex", "translatey", "matrix"],
            W = {
                rotate: "deg",
                scale: "",
                skew: "px",
                translate: "px"
            },
            j = H.css,
            B = Math.round,
            U = "",
            G = "px",
            J = "none",
            K = "auto",
            X = "width",
            Y = "height",
            Z = "hidden",
            tt = "origin",
            et = "abortId",
            it = "overflow",
            rt = "translate",
            nt = "position",
            st = "completeCallback",
            ot = j + "transition",
            at = j + "transform",
            ct = j + "backface-visibility",
            lt = j + "perspective",
            dt = "1500px",
            ut = "perspective(" + dt + ")",
            ft = {
                left: {
                    reverse: "right",
                    property: "left",
                    transition: "translatex",
                    vertical: !1,
                    modifier: -1
                },
                right: {
                    reverse: "left",
                    property: "left",
                    transition: "translatex",
                    vertical: !1,
                    modifier: 1
                },
                down: {
                    reverse: "up",
                    property: "top",
                    transition: "translatey",
                    vertical: !0,
                    modifier: 1
                },
                up: {
                    reverse: "down",
                    property: "top",
                    transition: "translatey",
                    vertical: !0,
                    modifier: -1
                },
                top: {
                    reverse: "bottom"
                },
                bottom: {
                    reverse: "top"
                },
                "in": {
                    reverse: "out",
                    modifier: -1
                },
                out: {
                    reverse: "in",
                    modifier: 1
                },
                vertical: {
                    reverse: "vertical"
                },
                horizontal: {
                    reverse: "horizontal"
                }
            };
        C.directions = ft, N(t.fn, {
            kendoStop: function(t, e) {
                return D ? P.stopQueue(this, t || !1, e || !1) : this.stop(t, e)
            }
        }), H && !D && (T(Q, function(i, r) {
            t.fn[r] = function(i) {
                if (e === i) return a(this, r);
                var n = t(this)[0],
                    s = r + "(" + i + W[r.replace($, "")] + ")";
                return n.style.cssText.indexOf(at) == -1 ? t(this).css(at, s) : n.style.cssText = n.style.cssText.replace(RegExp(r + "\\(.*?\\)", "i"), s), this
            }, t.fx.step[r] = function(e) {
                t(e.elem)[r](e.now)
            }
        }), f = t.fx.prototype.cur, t.fx.prototype.cur = function() {
            return Q.indexOf(this.prop) != -1 ? parseFloat(t(this.elem)[this.prop]()) : f.apply(this, arguments)
        }), C.toggleClass = function(t, e, i, r) {
            return e && (e = e.split(" "), D && (i = N({
                exclusive: "all",
                duration: 400,
                ease: "ease-out"
            }, i), t.css(ot, i.exclusive + " " + i.duration + "ms " + i.ease), setTimeout(function() {
                t.css(ot, "").css(Y)
            }, i.duration)), T(e, function(e, i) {
                t.toggleClass(i, r)
            })), t
        }, C.parseEffects = function(t, e) {
            var i = {};
            return "string" == typeof t ? T(t.split(" "), function(t, r) {
                var n = !M.test(r),
                    s = r.replace(V, function(t, e, i) {
                        return e + ":" + i.toLowerCase()
                    }),
                    o = s.split(":"),
                    a = o[1],
                    c = {};
                o.length > 1 && (c.direction = e && n ? ft[a].reverse : a), i[o[0]] = c
            }) : T(t, function(t) {
                var r = this.direction;
                r && e && !M.test(t) && (this.direction = ft[r].reverse), i[t] = this
            }), i
        }, D && N(P, {
            transition: function(e, i, r) {
                var s, a, c, l, d = 0,
                    u = e.data("keys") || [];
                r = N({
                    duration: 200,
                    ease: "ease-out",
                    complete: null,
                    exclusive: "all"
                }, r), c = !1, l = function() {
                    c || (c = !0, a && (clearTimeout(a), a = null), e.removeData(et).dequeue().css(ot, "").css(ot), r.complete.call(e))
                }, r.duration = t.fx ? t.fx.speeds[r.duration] || r.duration : r.duration, s = o(e, i), t.merge(u, n(s)), t.hasOwnProperty("uniqueSort") ? e.data("keys", t.uniqueSort(u)).height() : e.data("keys", t.unique(u)).height(), e.css(ot, r.exclusive + " " + r.duration + "ms " + r.ease).css(ot), e.css(s).css(at), D.event && (e.one(D.event, l), 0 !== r.duration && (d = 500)), a = setTimeout(l, r.duration + d), e.data(et, a), e.data(st, l)
            },
            stopQueue: function(t, e, i) {
                var r, n = t.data("keys"),
                    s = !i && n,
                    o = t.data(st);
                return s && (r = C.getComputedStyles(t[0], n)), o && o(), s && t.css(r), t.removeData("keys").stop(e)
            }
        }), p = C.Class.extend({
            init: function(t, e) {
                var i = this;
                i.element = t, i.effects = [], i.options = e, i.restore = []
            },
            run: function(e) {
                var i, r, n, a, c, l, d, u = this,
                    f = e.length,
                    p = u.element,
                    h = u.options,
                    m = t.Deferred(),
                    v = {},
                    x = {};
                for (u.effects = e, m.done(t.proxy(u, "complete")), p.data("animating", !0), r = 0; r < f; r++)
                    for (i = e[r], i.setReverse(h.reverse), i.setOptions(h), u.addRestoreProperties(i.restore), i.prepare(v, x), c = i.children(), n = 0, l = c.length; n < l; n++) c[n].duration(h.duration).run();
                for (d in h.effects) N(x, h.effects[d].properties);
                for (p.is(":visible") || N(v, {
                        display: p.data("olddisplay") || "block"
                    }), H && !h.reset && (a = p.data("targetTransform"), a && (v = N(a, v))), v = o(p, v), H && !D && (v = s(v)), p.css(v).css(at), r = 0; r < f; r++) e[r].setup();
                return h.init && h.init(), p.data("targetTransform", x), P.animate(p, x, N({}, h, {
                    complete: m.resolve
                })), m.promise()
            },
            stop: function() {
                t(this.element).kendoStop(!0, !0)
            },
            addRestoreProperties: function(t) {
                for (var e, i = this.element, r = 0, n = t.length; r < n; r++) e = t[r], this.restore.push(e), i.data(e) || i.data(e, i.css(e))
            },
            restoreCallback: function() {
                var t, e, i, r = this.element;
                for (t = 0, e = this.restore.length; t < e; t++) i = this.restore[t], r.css(i, r.data(i))
            },
            complete: function() {
                var e = this,
                    i = 0,
                    r = e.element,
                    n = e.options,
                    s = e.effects,
                    o = s.length;
                for (r.removeData("animating").dequeue(), n.hide && r.data("olddisplay", r.css("display")).hide(), this.restoreCallback(), S && !H && setTimeout(t.proxy(this, "restoreCallback"), 0); i < o; i++) s[i].teardown();
                n.completeCallback && n.completeCallback(r)
            }
        }), P.promise = function(t, e) {
            var i, r, n, s = [],
                o = new p(t, e),
                a = C.parseEffects(e.effects);
            e.effects = a;
            for (n in a) i = P[c(n)], i && (r = new i(t, a[n].direction), s.push(r));
            s[0] ? o.run(s) : (t.is(":visible") || t.css({
                display: t.data("olddisplay") || "block"
            }).css("display"), e.init && e.init(), t.dequeue(), o.complete())
        }, N(P, {
            animate: function(i, n, o) {
                var a = o.transition !== !1;
                delete o.transition, D && "transition" in P && a ? P.transition(i, n, o) : H ? i.animate(s(n), {
                    queue: !1,
                    show: !1,
                    hide: !1,
                    duration: o.duration,
                    complete: o.complete
                }) : i.each(function() {
                    var i = t(this),
                        s = {};
                    T(L, function(t, o) {
                        var a, c, l, d, u, f, p, h = n ? n[o] + " " : null;
                        h && (c = n, o in O && n[o] !== e ? (a = h.match(q), H && N(c, {
                            scale: +a[0]
                        })) : o in F && n[o] !== e && (l = i.css(nt), d = "absolute" == l || "fixed" == l, i.data(rt) || (d ? i.data(rt, {
                            top: r(i, "top") || 0,
                            left: r(i, "left") || 0,
                            bottom: r(i, "bottom"),
                            right: r(i, "right")
                        }) : i.data(rt, {
                            top: r(i, "marginTop") || 0,
                            left: r(i, "marginLeft") || 0
                        })), u = i.data(rt), a = h.match(q), a && (f = o == rt + "y" ? 0 : +a[1], p = o == rt + "y" ? +a[1] : +a[2], d ? (isNaN(u.right) ? isNaN(f) || N(c, {
                            left: u.left + f
                        }) : isNaN(f) || N(c, {
                            right: u.right - f
                        }), isNaN(u.bottom) ? isNaN(p) || N(c, {
                            top: u.top + p
                        }) : isNaN(p) || N(c, {
                            bottom: u.bottom - p
                        })) : (isNaN(f) || N(c, {
                            marginLeft: u.left + f
                        }), isNaN(p) || N(c, {
                            marginTop: u.top + p
                        })))), !H && "scale" != o && o in c && delete c[o], c && N(s, c))
                    }), R.msie && delete s.scale, i.animate(s, {
                        queue: !1,
                        show: !1,
                        hide: !1,
                        duration: o.duration,
                        complete: o.complete
                    })
                })
            }
        }), P.animatedPromise = P.promise, h = C.Class.extend({
            init: function(t, e) {
                var i = this;
                i.element = t, i._direction = e, i.options = {}, i._additionalEffects = [], i.restore || (i.restore = [])
            },
            reverse: function() {
                return this._reverse = !0, this.run()
            },
            play: function() {
                return this._reverse = !1, this.run()
            },
            add: function(t) {
                return this._additionalEffects.push(t), this
            },
            direction: function(t) {
                return this._direction = t, this
            },
            duration: function(t) {
                return this._duration = t, this
            },
            compositeRun: function() {
                var t = this,
                    e = new p(t.element, {
                        reverse: t._reverse,
                        duration: t._duration
                    }),
                    i = t._additionalEffects.concat([t]);
                return e.run(i)
            },
            run: function() {
                if (this._additionalEffects && this._additionalEffects[0]) return this.compositeRun();
                var e, i, r = this,
                    n = r.element,
                    a = 0,
                    c = r.restore,
                    l = c.length,
                    d = t.Deferred(),
                    u = {},
                    f = {},
                    p = r.children(),
                    h = p.length;
                for (d.done(t.proxy(r, "_complete")), n.data("animating", !0), a = 0; a < l; a++) e = c[a], n.data(e) || n.data(e, n.css(e));
                for (a = 0; a < h; a++) p[a].duration(r._duration).run();
                return r.prepare(u, f), n.is(":visible") || N(u, {
                    display: n.data("olddisplay") || "block"
                }), H && (i = n.data("targetTransform"), i && (u = N(i, u))), u = o(n, u), H && !D && (u = s(u)), n.css(u).css(at), r.setup(), n.data("targetTransform", f), P.animate(n, f, {
                    duration: r._duration,
                    complete: d.resolve
                }), d.promise()
            },
            stop: function() {
                var e = 0,
                    i = this.children(),
                    r = i.length;
                for (e = 0; e < r; e++) i[e].stop();
                return t(this.element).kendoStop(!0, !0), this
            },
            restoreCallback: function() {
                var t, e, i, r = this.element;
                for (t = 0, e = this.restore.length; t < e; t++) i = this.restore[t], r.css(i, r.data(i))
            },
            _complete: function() {
                var e = this,
                    i = e.element;
                i.removeData("animating").dequeue(), e.restoreCallback(), e.shouldHide() && i.data("olddisplay", i.css("display")).hide(), S && !H && setTimeout(t.proxy(e, "restoreCallback"), 0), e.teardown()
            },
            setOptions: function(t) {
                N(!0, this.options, t)
            },
            children: function() {
                return []
            },
            shouldHide: t.noop,
            setup: t.noop,
            prepare: t.noop,
            teardown: t.noop,
            directions: [],
            setReverse: function(t) {
                return this._reverse = t, this
            }
        }), m = ["left", "right", "up", "down"], v = ["in", "out"], l("slideIn", {
            directions: m,
            divisor: function(t) {
                return this.options.divisor = t, this
            },
            prepare: function(t, e) {
                var i, r = this,
                    n = r.element,
                    s = C._outerWidth,
                    o = C._outerHeight,
                    a = ft[r._direction],
                    c = -a.modifier * (a.vertical ? o(n) : s(n)),
                    l = c / (r.options && r.options.divisor || 1) + G,
                    d = "0px";
                r._reverse && (i = t, t = e, e = i), H ? (t[a.transition] = l, e[a.transition] = d) : (t[a.property] = l, e[a.property] = d)
            }
        }), l("tile", {
            directions: m,
            init: function(t, e, i) {
                h.prototype.init.call(this, t, e), this.options = {
                    previous: i
                }
            },
            previousDivisor: function(t) {
                return this.options.previousDivisor = t, this
            },
            children: function() {
                var t = this,
                    e = t._reverse,
                    i = t.options.previous,
                    r = t.options.previousDivisor || 1,
                    n = t._direction,
                    s = [C.fx(t.element).slideIn(n).setReverse(e)];
                return i && s.push(C.fx(i).slideIn(ft[n].reverse).divisor(r).setReverse(!e)), s
            }
        }), d("fade", "opacity", 1, 0), d("zoom", "scale", 1, .01), l("slideMargin", {
            prepare: function(t, e) {
                var i, r = this,
                    n = r.element,
                    s = r.options,
                    o = n.data(tt),
                    a = s.offset,
                    c = r._reverse;
                c || null !== o || n.data(tt, parseFloat(n.css("margin-" + s.axis))), i = n.data(tt) || 0, e["margin-" + s.axis] = c ? i : i + a
            }
        }), l("slideTo", {
            prepare: function(t, e) {
                var i = this,
                    r = i.element,
                    n = i.options,
                    s = n.offset.split(","),
                    o = i._reverse;
                H ? (e.translatex = o ? 0 : s[0], e.translatey = o ? 0 : s[1]) : (e.left = o ? 0 : s[0], e.top = o ? 0 : s[1]), r.css("left")
            }
        }), l("expand", {
            directions: ["horizontal", "vertical"],
            restore: [it],
            prepare: function(t, i) {
                var r = this,
                    n = r.element,
                    s = r.options,
                    o = r._reverse,
                    a = "vertical" === r._direction ? Y : X,
                    c = n[0].style[a],
                    l = n.data(a),
                    d = parseFloat(l || c),
                    u = B(n.css(a, K)[a]());
                t.overflow = Z, d = s && s.reset ? u || d : d || u, i[a] = (o ? 0 : d) + G, t[a] = (o ? d : 0) + G, l === e && n.data(a, c)
            },
            shouldHide: function() {
                return this._reverse
            },
            teardown: function() {
                var t = this,
                    e = t.element,
                    i = "vertical" === t._direction ? Y : X,
                    r = e.data(i);
                r != K && r !== U || setTimeout(function() {
                    e.css(i, K).css(i)
                }, 0)
            }
        }), x = {
            position: "absolute",
            marginLeft: 0,
            marginTop: 0,
            scale: 1
        }, l("transfer", {
            init: function(t, e) {
                this.element = t, this.options = {
                    target: e
                }, this.restore = []
            },
            setup: function() {
                this.element.appendTo(document.body)
            },
            prepare: function(t, e) {
                var i = this,
                    r = i.element,
                    n = P.box(r),
                    s = P.box(i.options.target),
                    o = a(r, "scale"),
                    c = P.fillScale(s, n),
                    l = P.transformOrigin(s, n);
                N(t, x), e.scale = 1, r.css(at, "scale(1)").css(at), r.css(at, "scale(" + o + ")"), t.top = n.top, t.left = n.left, t.transformOrigin = l.x + G + " " + l.y + G, i._reverse ? t.scale = c : e.scale = c
            }
        }), _ = {
            top: "rect(auto auto $size auto)",
            bottom: "rect($size auto auto auto)",
            left: "rect(auto $size auto auto)",
            right: "rect(auto auto auto $size)"
        }, g = {
            top: {
                start: "rotatex(0deg)",
                end: "rotatex(180deg)"
            },
            bottom: {
                start: "rotatex(-180deg)",
                end: "rotatex(0deg)"
            },
            left: {
                start: "rotatey(0deg)",
                end: "rotatey(-180deg)"
            },
            right: {
                start: "rotatey(180deg)",
                end: "rotatey(0deg)"
            }
        }, l("turningPage", {
            directions: m,
            init: function(t, e, i) {
                h.prototype.init.call(this, t, e), this._container = i
            },
            prepare: function(t, e) {
                var i = this,
                    r = i._reverse,
                    n = r ? ft[i._direction].reverse : i._direction,
                    s = g[n];
                t.zIndex = 1, i._clipInHalf && (t.clip = u(i._container, C.directions[n].reverse)), t[ct] = Z, e[at] = ut + (r ? s.start : s.end), t[at] = ut + (r ? s.end : s.start)
            },
            setup: function() {
                this._container.append(this.element)
            },
            face: function(t) {
                return this._face = t, this
            },
            shouldHide: function() {
                var t = this,
                    e = t._reverse,
                    i = t._face;
                return e && !i || !e && i
            },
            clipInHalf: function(t) {
                return this._clipInHalf = t, this
            },
            temporary: function() {
                return this.element.addClass("temp-page"), this
            }
        }), l("staticPage", {
            directions: m,
            init: function(t, e, i) {
                h.prototype.init.call(this, t, e), this._container = i
            },
            restore: ["clip"],
            prepare: function(t, e) {
                var i = this,
                    r = i._reverse ? ft[i._direction].reverse : i._direction;
                t.clip = u(i._container, r), t.opacity = .999, e.opacity = 1
            },
            shouldHide: function() {
                var t = this,
                    e = t._reverse,
                    i = t._face;
                return e && !i || !e && i
            },
            face: function(t) {
                return this._face = t, this
            }
        }), l("pageturn", {
            directions: ["horizontal", "vertical"],
            init: function(t, e, i, r) {
                h.prototype.init.call(this, t, e), this.options = {}, this.options.face = i, this.options.back = r
            },
            children: function() {
                var t, e = this,
                    i = e.options,
                    r = "horizontal" === e._direction ? "left" : "top",
                    n = C.directions[r].reverse,
                    s = e._reverse,
                    o = i.face.clone(!0).removeAttr("id"),
                    a = i.back.clone(!0).removeAttr("id"),
                    c = e.element;
                return s && (t = r, r = n, n = t), [C.fx(i.face).staticPage(r, c).face(!0).setReverse(s), C.fx(i.back).staticPage(n, c).setReverse(s), C.fx(o).turningPage(r, c).face(!0).clipInHalf(!0).temporary().setReverse(s), C.fx(a).turningPage(n, c).clipInHalf(!0).temporary().setReverse(s)]
            },
            prepare: function(t, e) {
                t[lt] = dt, t.transformStyle = "preserve-3d", t.opacity = .999, e.opacity = 1
            },
            teardown: function() {
                this.element.find(".temp-page").remove()
            }
        }), l("flip", {
            directions: ["horizontal", "vertical"],
            init: function(t, e, i, r) {
                h.prototype.init.call(this, t, e), this.options = {}, this.options.face = i, this.options.back = r
            },
            children: function() {
                var t, e = this,
                    i = e.options,
                    r = "horizontal" === e._direction ? "left" : "top",
                    n = C.directions[r].reverse,
                    s = e._reverse,
                    o = e.element;
                return s && (t = r, r = n, n = t), [C.fx(i.face).turningPage(r, o).face(!0).setReverse(s), C.fx(i.back).turningPage(n, o).setReverse(s)]
            },
            prepare: function(t) {
                t[lt] = dt, t.transformStyle = "preserve-3d"
            }
        }), y = !E.mobileOS.android, k = ".km-touch-scrollbar, .km-actionsheet-wrapper", l("replace", {
            _before: t.noop,
            _after: t.noop,
            init: function(e, i, r) {
                h.prototype.init.call(this, e), this._previous = t(i), this._transitionClass = r
            },
            duration: function() {
                throw Error("The replace effect does not support duration setting; the effect duration may be customized through the transition class rule")
            },
            beforeTransition: function(t) {
                return this._before = t, this
            },
            afterTransition: function(t) {
                return this._after = t, this
            },
            _both: function() {
                return t().add(this._element).add(this._previous)
            },
            _containerClass: function() {
                var t = this._direction,
                    e = "k-fx k-fx-start k-fx-" + this._transitionClass;
                return t && (e += " k-fx-" + t), this._reverse && (e += " k-fx-reverse"), e
            },
            complete: function(e) {
                if (!(!this.deferred || e && t(e.target).is(k))) {
                    var i = this.container;
                    i.removeClass("k-fx-end").removeClass(this._containerClass()).off(D.event, this.completeProxy), this._previous.hide().removeClass("k-fx-current"), this.element.removeClass("k-fx-next"), y && i.css(it, ""), this.isAbsolute || this._both().css(nt, ""), this.deferred.resolve(), delete this.deferred
                }
            },
            run: function() {
                if (this._additionalEffects && this._additionalEffects[0]) return this.compositeRun();
                var e, i = this,
                    r = i.element,
                    n = i._previous,
                    s = r.parents().filter(n.parents()).first(),
                    o = i._both(),
                    a = t.Deferred(),
                    c = r.css(nt);
                return s.length || (s = r.parent()), this.container = s, this.deferred = a, this.isAbsolute = "absolute" == c, this.isAbsolute || o.css(nt, "absolute"), y && (e = s.css(it), s.css(it, "hidden")), D ? (r.addClass("k-fx-hidden"), s.addClass(this._containerClass()), this.completeProxy = t.proxy(this, "complete"), s.on(D.event, this.completeProxy), C.animationFrame(function() {
                    r.removeClass("k-fx-hidden").addClass("k-fx-next"), n.css("display", "").addClass("k-fx-current"), i._before(n, r), C.animationFrame(function() {
                        s.removeClass("k-fx-start").addClass("k-fx-end"), i._after(n, r)
                    })
                })) : this.complete(), a.promise()
            },
            stop: function() {
                this.complete()
            }
        }), b = C.Class.extend({
            init: function() {
                var t = this;
                t._tickProxy = z(t._tick, t), t._started = !1
            },
            tick: t.noop,
            done: t.noop,
            onEnd: t.noop,
            onCancel: t.noop,
            start: function() {
                this.enabled() && (this.done() ? this.onEnd() : (this._started = !0, C.animationFrame(this._tickProxy)))
            },
            enabled: function() {
                return !0
            },
            cancel: function() {
                this._started = !1, this.onCancel()
            },
            _tick: function() {
                var t = this;
                t._started && (t.tick(), t.done() ? (t._started = !1, t.onEnd()) : C.animationFrame(t._tickProxy))
            }
        }), w = b.extend({
            init: function(t) {
                var e = this;
                N(e, t), b.fn.init.call(e)
            },
            done: function() {
                return this.timePassed() >= this.duration
            },
            timePassed: function() {
                return Math.min(this.duration, new Date - this.startDate)
            },
            moveTo: function(t) {
                var e = this,
                    i = e.movable;
                e.initial = i[e.axis], e.delta = t.location - e.initial, e.duration = "number" == typeof t.duration ? t.duration : 300, e.tick = e._easeProxy(t.ease), e.startDate = new Date, e.start()
            },
            _easeProxy: function(t) {
                var e = this;
                return function() {
                    e.movable.moveAxis(e.axis, t(e.timePassed(), e.initial, e.delta, e.duration))
                }
            }
        }), N(w, {
            easeOutExpo: function(t, e, i, r) {
                return t == r ? e + i : i * (-Math.pow(2, -10 * t / r) + 1) + e
            },
            easeOutBack: function(t, e, i, r, n) {
                return n = 1.70158, i * ((t = t / r - 1) * t * ((n + 1) * t + n) + 1) + e
            }
        }), P.Animation = b, P.Transition = w, P.createEffect = l, P.box = function(e) {
            e = t(e);
            var i = e.offset();
            return i.width = C._outerWidth(e), i.height = C._outerHeight(e), i
        }, P.transformOrigin = function(t, e) {
            var i = (t.left - e.left) * e.width / (e.width - t.width),
                r = (t.top - e.top) * e.height / (e.height - t.height);
            return {
                x: isNaN(i) ? 0 : i,
                y: isNaN(r) ? 0 : r
            }
        }, P.fillScale = function(t, e) {
            return Math.min(t.width / e.width, t.height / e.height)
        }, P.fitScale = function(t, e) {
            return Math.max(t.width / e.width, t.height / e.height)
        }
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, i) {
    (i || e)()
});;
! function(t, define) {
    define("util/text-metrics.min", ["kendo.core.min"], t)
}(function() {
    ! function(t) {
        function e(t) {
            return (t + "").replace(s, h)
        }

        function r(t) {
            var e, r = [];
            for (e in t) r.push(e + t[e]);
            return r.sort().join("")
        }

        function n(t) {
            var e, r = 2166136261;
            for (e = 0; e < t.length; ++e) r += (r << 1) + (r << 4) + (r << 7) + (r << 8) + (r << 24), r ^= t.charCodeAt(e);
            return r >>> 0
        }

        function i() {
            return {
                width: 0,
                height: 0,
                baseline: 0
            }
        }

        function o(t, e, r) {
            return u.current.measure(t, e, r)
        }
        var a, s, h, c, f, u;
        window.kendo.util = window.kendo.util || {}, a = kendo.Class.extend({
            init: function(t) {
                this._size = t, this._length = 0, this._map = {}
            },
            put: function(t, e) {
                var r = this._map,
                    n = {
                        key: t,
                        value: e
                    };
                r[t] = n, this._head ? (this._tail.newer = n, n.older = this._tail, this._tail = n) : this._head = this._tail = n, this._length >= this._size ? (r[this._head.key] = null, this._head = this._head.newer, this._head.older = null) : this._length++
            },
            get: function(t) {
                var e = this._map[t];
                if (e) return e === this._head && e !== this._tail && (this._head = e.newer, this._head.older = null), e !== this._tail && (e.older && (e.older.newer = e.newer, e.newer.older = e.older), e.older = this._tail, e.newer = null, this._tail.newer = e, this._tail = e), e.value
            }
        }), s = /\r?\n|\r|\t/g, h = " ", c = {
            baselineMarkerSize: 1
        }, "undefined" != typeof document && (f = document.createElement("div"), f.style.cssText = "position: absolute !important; top: -4000px !important; width: auto !important; height: auto !important;padding: 0 !important; margin: 0 !important; border: 0 !important;line-height: normal !important; visibility: hidden !important; white-space: pre!important;"), u = kendo.Class.extend({
            init: function(e) {
                this._cache = new a(1e3), this.options = t.extend({}, c, e)
            },
            measure: function(t, o, a) {
                var s, h, c, u, d, l, p, g, m;
                if (void 0 === a && (a = {}), !t) return i();
                if (s = r(o), h = n(t + s), c = this._cache.get(h)) return c;
                u = i(), d = a.box || f, l = this._baselineMarker().cloneNode(!1);
                for (p in o) g = o[p], void 0 !== g && (d.style[p] = g);
                return m = a.normalizeText !== !1 ? e(t) : t + "", d.textContent = m, d.appendChild(l), document.body.appendChild(d), m.length && (u.width = d.offsetWidth - this.options.baselineMarkerSize, u.height = d.offsetHeight, u.baseline = l.offsetTop + this.options.baselineMarkerSize), u.width > 0 && u.height > 0 && this._cache.put(h, u), d.parentNode.removeChild(d), u
            },
            _baselineMarker: function() {
                var t = document.createElement("div");
                return t.style.cssText = "display: inline-block; vertical-align: baseline;width: " + this.options.baselineMarkerSize + "px; height: " + this.options.baselineMarkerSize + "px;overflow: hidden;", t
            }
        }), u.current = new u, kendo.deepExtend(kendo.util, {
            LRUCache: a,
            TextMetrics: u,
            measureText: o,
            objectKey: r,
            hashKey: n,
            normalizeText: e
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(t, e, r) {
    (r || e)()
}),
function(t, define) {
    define("pdf/pako.min", ["kendo.core.min"], t)
}(function() {
    return function() {
        kendo.pdf = kendo.pdf || {}, kendo.pdf.supportsDeflate = function() {
            return window.pako && "function" == typeof window.pako.deflate
        }, kendo.pdf.deflate = function(t) {
            return window.pako.deflate(t)
        }
    }(), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, r) {
    (r || e)()
}),
function(t, define) {
    define("pdf/core.min", ["pdf/pako.min", "kendo.core.min", "kendo.color.min", "kendo.drawing.min"], t)
}(function() {
    return function(t) {
        function e(t) {
            function e() {
                return k >= T
            }

            function r() {
                return k < T ? t[k++] : 0
            }

            function n(e) {
                b(k), t[k++] = 255 & e, k > T && (T = k)
            }

            function i() {
                return r() << 8 | r()
            }

            function o(t) {
                n(t >> 8), n(t)
            }

            function a() {
                var t = i();
                return t >= 32768 ? t - 65536 : t
            }

            function s(t) {
                o(t < 0 ? t + 65536 : t)
            }

            function h() {
                return 65536 * i() + i()
            }

            function c(t) {
                o(t >>> 16 & 65535), o(65535 & t)
            }

            function f() {
                var t = h();
                return t >= 2147483648 ? t - 4294967296 : t
            }

            function u(t) {
                c(t < 0 ? t + 4294967296 : t)
            }

            function d() {
                return h() / 65536
            }

            function l(t) {
                c(Math.round(65536 * t))
            }

            function p() {
                return f() / 65536
            }

            function g(t) {
                u(Math.round(65536 * t))
            }

            function m(t) {
                return y(t, r)
            }

            function w(t) {
                return String.fromCharCode.apply(String, m(t))
            }

            function S(t) {
                for (var e = 0; e < t.length; ++e) n(t.charCodeAt(e))
            }

            function y(t, e) {
                for (var r = Array(t), n = 0; n < t; ++n) r[n] = e();
                return r
            }
            var b, x, v, _, C, k = 0,
                T = 0;
            return null == t ? t = Lt ? new Uint8Array(256) : [] : T = t.length, b = Lt ? function(e) {
                if (e >= t.length) {
                    var r = new Uint8Array(Math.max(e + 256, 2 * t.length));
                    r.set(t, 0), t = r
                }
            } : function() {}, x = Lt ? function() {
                return new Uint8Array(t.buffer, 0, T)
            } : function() {
                return t
            }, v = Lt ? function(e) {
                if ("string" == typeof e) return S(e);
                var r = e.length;
                b(k + r), t.set(e, k), k += r, k > T && (T = k)
            } : function(t) {
                if ("string" == typeof t) return S(t);
                for (var e = 0; e < t.length; ++e) n(t[e])
            }, _ = Lt ? function(e, r) {
                if (t.buffer.slice) return new Uint8Array(t.buffer.slice(e, e + r));
                var n = new Uint8Array(r);
                return n.set(new Uint8Array(t.buffer, e, r)), n
            } : function(e, r) {
                return t.slice(e, e + r)
            }, C = {
                eof: e,
                readByte: r,
                writeByte: n,
                readShort: i,
                writeShort: o,
                readLong: h,
                writeLong: c,
                readFixed: d,
                writeFixed: l,
                readShort_: a,
                writeShort_: s,
                readLong_: f,
                writeLong_: u,
                readFixed_: p,
                writeFixed_: g,
                read: m,
                write: v,
                readString: w,
                writeString: S,
                times: y,
                get: x,
                slice: _,
                offset: function(t) {
                    return null != t ? (k = t, C) : k
                },
                skip: function(t) {
                    k += t
                },
                toString: function() {
                    throw Error("FIX CALLER.  BinaryStream is no longer convertible to string!")
                },
                length: function() {
                    return T
                },
                saveExcursion: function(t) {
                    var e = k;
                    try {
                        return t()
                    } finally {
                        k = e
                    }
                },
                writeBase64: function(t) {
                    window.atob ? S(window.atob(t)) : v(Mt.decode(t))
                },
                base64: function() {
                    return Mt.encode(x())
                }
            }
        }

        function r(t) {
            for (var e, r, n = [], i = 0, o = t.length; i < o;) e = t.charCodeAt(i++), e >= 55296 && e <= 56319 && i < o ? (r = t.charCodeAt(i++), 56320 == (64512 & r) ? n.push(((1023 & e) << 10) + (1023 & r) + 65536) : (n.push(e), i--)) : n.push(e);
            return n
        }

        function n(t) {
            return t.map(function(t) {
                var e = "";
                return t > 65535 && (t -= 65536, e += String.fromCharCode(t >>> 10 & 1023 | 55296), t = 56320 | 1023 & t), e += String.fromCharCode(t)
            }).join("")
        }

        function i(t) {
            var e, r = window.atob(t),
                n = new Uint8Array(r.length);
            for (e = 0; e < r.length; e++) n[e] = r.charCodeAt(e);
            return n
        }

        function o(t) {
            var e, r = new Uint8Array(t.length);
            for (e = 0; e < t.length; e++) r[e] = t[e];
            return r
        }

        function a(t) {
            return window.atob ? i(t) : o(Mt.decode(t))
        }

        function s(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e)
        }

        function h(t) {
            return Object.keys(t).sort(function(t, e) {
                return t - e
            }).map(parseFloat)
        }

        function c(t) {
            var e, r, n;
            for (this.raw = t, this.scalerType = t.readLong(), this.tableCount = t.readShort(), this.searchRange = t.readShort(), this.entrySelector = t.readShort(), this.rangeShift = t.readShort(), e = this.tables = {}, r = 0; r < this.tableCount; ++r) n = {
                tag: t.readString(4),
                checksum: t.readLong(),
                offset: t.readLong(),
                length: t.readLong()
            }, e[n.tag] = n
        }

        function f(t) {
            function e(t, e) {
                this.definition = e, this.length = e.length, this.offset = e.offset, this.file = t, this.rawData = t.raw, this.parse(t.raw)
            }
            e.prototype.raw = function() {
                return this.rawData.slice(this.offset, this.length)
            };
            for (var r in t) s(t, r) && (e[r] = e.prototype[r] = t[r]);
            return e
        }

        function u() {
            var t, e = "",
                r = jt + "";
            for (t = 0; t < r.length; ++t) e += String.fromCharCode(r.charCodeAt(t) - 48 + 65);
            return ++jt, e
        }

        function d(t) {
            this.font = t, this.subset = {}, this.unicodes = {}, this.ogid2ngid = {
                0: 0
            }, this.ngid2ogid = {
                0: 0
            }, this.ncid2ogid = {}, this.next = this.firstChar = 1, this.nextGid = 1, this.psName = u() + "+" + this.font.psName
        }

        function l(t, r) {
            var n, i, o, a, s = this,
                h = s.contents = e(t);
            if ("ttcf" == h.readString(4)) {
                if (i = function() {
                        h.offset(n), s.parse()
                    }, !r) throw Error("Must specify a name for TTC files");
                for (h.readLong(), o = h.readLong(), a = 0; a < o; ++a)
                    if (n = h.readLong(), h.saveExcursion(i), s.psName == r) return;
                throw Error("Font " + r + " not found in collection")
            }
            h.offset(0), s.parse()
        }

        function p() {
            function t() {
                var e, r, i, o = arguments;
                for (e = 0; e < arguments.length; ++e) {
                    if (r = o[e], void 0 === r) throw Error("Cannot output undefined to PDF");
                    if (r instanceof A) r.beforeRender(t), r.render(t);
                    else if ($t(r)) D(r, t);
                    else if (T(r)) F(r, t);
                    else if ("number" == typeof r) {
                        if (isNaN(r)) throw Error("Cannot output NaN to PDF");
                        i = r.toFixed(7), i.indexOf(".") >= 0 && (i = i.replace(/\.?0+$/, "")), "-0" == i && (i = "0"), n.writeString(i)
                    } else /string|boolean/.test(typeof r) ? n.writeString(r + "") : "function" == typeof r.get ? n.write(r.get()) : "object" == typeof r && (r ? t(new re(r)) : n.writeString("null"))
                }
            }
            var r = 0,
                n = e();
            return t.writeData = function(t) {
                n.write(t)
            }, t.withIndent = function(e) {
                ++r, e(t), --r
            }, t.indent = function() {
                t(Ht, _("", 2 * r, "  ")), t.apply(null, arguments)
            }, t.offset = function() {
                return n.offset()
            }, t.toString = function() {
                throw Error("FIX CALLER")
            }, t.get = function() {
                return n.get()
            }, t.stream = function() {
                return n
            }, t
        }

        function g(t, e) {
            var r = t.beforeRender,
                n = t.render;
            t.beforeRender = function() {}, t.render = function(t) {
                t(e, " 0 R")
            }, t.renderFull = function(i) {
                t._offset = i.offset(), i(e, " 0 obj "), r.call(t, i), n.call(t, i), i(" endobj")
            }
        }

        function m(t) {
            var e, r, n;
            if ("function" != typeof t && (e = t, t = function(t, r) {
                    return t in e ? e[t] : r
                }), r = t("paperSize", Xt.a4), !r) return {};
            if ("string" == typeof r && (r = Xt[r.toLowerCase()], null == r)) throw Error("Unknown paper size");
            return r[0] = O(r[0]), r[1] = O(r[1]), t("landscape", !1) && (r = [Math.max(r[0], r[1]), Math.min(r[0], r[1])]), n = t("margin"), n && ("string" == typeof n || "number" == typeof n ? (n = O(n, 0), n = {
                left: n,
                top: n,
                right: n,
                bottom: n
            }) : n = {
                left: O(n.left, 0),
                top: O(n.top, 0),
                right: O(n.right, 0),
                bottom: O(n.bottom, 0)
            }, t("addMargin") && (r[0] += n.left + n.right, r[1] += n.top + n.bottom)), {
                paperSize: r,
                margin: n
            }
        }

        function w(t) {
            function e(e, r) {
                return t && null != t[e] ? t[e] : r
            }
            var r, n, i, o, a = this,
                s = p(),
                h = 0,
                c = [];
            a.getOption = e, a.attach = function(t) {
                return c.indexOf(t) < 0 && (g(t, ++h), c.push(t)), t
            }, a.pages = [], a.FONTS = {}, a.IMAGES = {}, a.GRAD_COL_FUNCTIONS = {}, a.GRAD_OPC_FUNCTIONS = {}, a.GRAD_COL = {}, a.GRAD_OPC = {}, r = a.attach(new ie), n = a.attach(new oe), e("autoPrint") && (i = {}, i.JavaScript = new re({
                Names: [new Vt("JS"), a.attach(new re({
                    S: P("JavaScript"),
                    JS: new Vt("print(true);")
                }))]
            }), r.props.Names = new re(i)), r.setPages(n), o = a.attach(new re({
                Producer: new Vt(e("producer", "Kendo UI PDF Generator")),
                Title: new Vt(e("title", "")),
                Author: new Vt(e("author", "")),
                Subject: new Vt(e("subject", "")),
                Keywords: new Vt(e("keywords", "")),
                Creator: new Vt(e("creator", "Kendo UI PDF Generator")),
                CreationDate: e("date", new Date)
            })), a.addPage = function(t) {
                var e, r, i, o = m(function(e, r) {
                        return t && null != t[e] ? t[e] : r
                    }),
                    s = o.paperSize,
                    h = o.margin,
                    c = s[0],
                    f = s[1];
                return h && (c -= h.left + h.right, f -= h.top + h.bottom), e = new ne(p(), null, (!0)), r = {
                    Contents: a.attach(e),
                    Parent: n,
                    MediaBox: [0, 0, s[0], s[1]]
                }, i = new fe(a, r), i._content = e, n.addPage(a.attach(i)), i.transform(1, 0, 0, -1, 0, s[1]), h && (i.translate(h.left, h.top), i.rect(0, 0, c, f), i.clip()), a.pages.push(i), i
            }, a.render = function() {
                var t, e;
                for (s("%PDF-1.4", Ht, "%ÂÁÚÏÎ", Ht, Ht), t = 0; t < c.length; ++t) c[t].renderFull(s), s(Ht, Ht);
                for (e = s.offset(), s("xref", Ht, 0, " ", c.length + 1, Ht), s("0000000000 65535 f ", Ht), t = 0; t < c.length; ++t) s(C(c[t]._offset, 10), " 00000 n ", Ht);
                return s(Ht), s("trailer", Ht), s(new re({
                    Size: c.length + 1,
                    Root: r,
                    Info: o
                }), Ht, Ht), s("startxref", Ht, e, Ht), s("%%EOF", Ht), s.stream().offset(0)
            }
        }

        function S(t, e) {
            function r() {
                window.console && (window.console.error ? window.console.error("Cannot load URL: %s", t) : window.console.log("Cannot load URL: %s", t)), e(null)
            }
            var n, i;
            return qt.msie && (n = /^data:.*?;base64,/i.exec(t)) ? void e(a(t.substr(n[0].length))) : (i = new XMLHttpRequest, i.open("GET", t, !0), Lt && (i.responseType = "arraybuffer"), i.onload = function() {
                200 == i.status || 304 == i.status ? e(Lt ? new Uint8Array(i.response) : new window.VBArray(i.responseBody).toArray()) : r()
            }, i.onerror = r, void i.send(null))
        }

        function y(t, e) {
            var r = Jt[t];
            r ? e(r) : S(t, function(r) {
                if (null == r) throw Error("Cannot load font from " + t);
                var n = new l(r);
                Jt[t] = n, e(n)
            })
        }

        function b() {
            Zt = {}
        }

        function x(t, r, n) {
            function i(t) {
                u.src = t, u.complete && !qt.msie ? s() : (u.onload = s, u.onerror = a)
            }

            function o() {
                var i, o, s, c, f, d, l, p, g, m, w;
                r || (r = {
                    width: u.width,
                    height: u.height
                }), i = document.createElement("canvas"), i.width = r.width, i.height = r.height, o = i.getContext("2d"), o.drawImage(u, 0, 0, r.width, r.height);
                try {
                    s = o.getImageData(0, 0, r.width, r.height)
                } catch (S) {
                    return void a()
                } finally {
                    h && URL.revokeObjectURL(h)
                }
                for (c = !1, f = e(), d = e(), l = s.data, p = 0; p < l.length;) f.writeByte(l[p++]), f.writeByte(l[p++]), f.writeByte(l[p++]), g = l[p++], g < 255 && (c = !0), d.writeByte(g);
                c ? u = new G(r.width, r.height, f, d) : (m = i.toDataURL("image/jpeg"), m = m.substr(m.indexOf(";base64,") + 8), w = e(), w.writeBase64(m), u = new E(w)), n(Zt[t] = u)
            }

            function a() {
                n(Zt[t] = "ERROR")
            }

            function s() {
                if (r && (r.width >= u.width || r.height >= u.height) && (r = null), !r && c && /^image\/jpe?g$/i.test(c.type)) {
                    var i = new FileReader;
                    i.onload = function() {
                        try {
                            var r = new E(e(new Uint8Array(this.result)));
                            URL.revokeObjectURL(h), n(Zt[t] = r)
                        } catch (i) {
                            o()
                        }
                    }, i.readAsArrayBuffer(c)
                } else o()
            }
            var h, c, f, u = Zt[t];
            u ? n(u) : (u = new Image, /^data:/i.test(t) || (u.crossOrigin = "Anonymous"), Lt && !/^data:/i.test(t) ? (f = new XMLHttpRequest, f.onload = function() {
                c = f.response, h = URL.createObjectURL(c), i(h)
            }, f.onerror = a, f.open("GET", t, !0), f.responseType = "blob", f.send()) : i(t))
        }

        function v(t) {
            return function(e, r) {
                function n() {
                    0 === --i && r()
                }
                var i = e.length,
                    o = i;
                if (0 === i) return r();
                for (; o-- > 0;) t(e[o], n)
            }
        }

        function _(t, e, r) {
            for (; t.length < e;) t = r + t;
            return t
        }

        function C(t, e) {
            return _(t + "", e, "0")
        }

        function k(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e)
        }

        function T(t) {
            return t instanceof Date
        }

        function D(t, e) {
            e("["), t.length > 0 && e.withIndent(function() {
                for (var r = 0; r < t.length; ++r) r > 0 && r % 8 === 0 ? e.indent(t[r]) : e(" ", t[r])
            }), e(" ]")
        }

        function F(t, e) {
            e("(D:", C(t.getUTCFullYear(), 4), C(t.getUTCMonth() + 1, 2), C(t.getUTCDate(), 2), C(t.getUTCHours(), 2), C(t.getUTCMinutes(), 2), C(t.getUTCSeconds(), 2), "Z)")
        }

        function I(t) {
            return t * (72 / 25.4)
        }

        function L(t) {
            return I(10 * t)
        }

        function M(t) {
            return 72 * t
        }

        function O(t, e) {
            var r, n;
            if ("number" == typeof t) return t;
            if ("string" == typeof t && (r = /^\s*([0-9.]+)\s*(mm|cm|in|pt)\s*$/.exec(t), r && (n = parseFloat(r[1]), !isNaN(n)))) return "pt" == r[2] ? n : {
                mm: I,
                cm: L,
                "in": M
            }[r[2]](n);
            if (null != e) return e;
            throw Error("Can't parse unit: " + t)
        }

        function A() {}

        function R(t, e, r) {
            r || (r = A), t.prototype = new r;
            for (var n in e) k(e, n) && (t.prototype[n] = e[n]);
            return t
        }

        function P(t) {
            return k(ee, t) ? ee[t] : ee[t] = new te(t)
        }

        function E(t) {
            var e, r, n, i, o, a, s, h, c;
            if (t.offset(0), o = t.readShort(), 65496 != o) throw Error("Invalid JPEG image");
            for (; !t.eof();) {
                if (a = t.readByte(), 255 != a) throw Error("Invalid JPEG image");
                if (s = t.readByte(), h = t.readShort(), ae.indexOf(s) >= 0) {
                    i = t.readByte(), r = t.readShort(), e = t.readShort(), n = t.readByte();
                    break
                }
                t.skip(h - 2)
            }
            if (null == n) throw Error("Invalid JPEG image");
            switch (c = {
                Type: P("XObject"),
                Subtype: P("Image"),
                Width: e,
                Height: r,
                BitsPerComponent: i,
                Filter: P("DCTDecode")
            }, n) {
                case 1:
                    c.ColorSpace = P("DeviceGray");
                    break;
                case 3:
                    c.ColorSpace = P("DeviceRGB");
                    break;
                case 4:
                    c.ColorSpace = P("DeviceCMYK"), c.Decode = [1, 0, 1, 0, 1, 0, 1, 0]
            }
            this.asStream = function() {
                t.offset(0);
                var e = new ne(t, c);
                return e._resourceName = P("I" + ++Wt), e
            }
        }

        function G(t, e, r, n) {
            this.asStream = function(i) {
                var o = new ne(n, {
                        Type: P("XObject"),
                        Subtype: P("Image"),
                        Width: t,
                        Height: e,
                        BitsPerComponent: 8,
                        ColorSpace: P("DeviceGray")
                    }, (!0)),
                    a = new ne(r, {
                        Type: P("XObject"),
                        Subtype: P("Image"),
                        Width: t,
                        Height: e,
                        BitsPerComponent: 8,
                        ColorSpace: P("DeviceRGB"),
                        SMask: i.attach(o)
                    }, (!0));
                return a._resourceName = P("I" + ++Wt), a
            }
        }

        function N(t) {
            return t.map(function(t) {
                return $t(t) ? N(t) : "number" == typeof t ? (Math.round(1e3 * t) / 1e3).toFixed(3) : t
            }).join(" ")
        }

        function B(t, e, r, n, i, o, a) {
            var s = N([e, r, n, i, o, a]),
                h = t.GRAD_COL_FUNCTIONS[s];
            return h || (h = t.GRAD_COL_FUNCTIONS[s] = t.attach(new re({
                FunctionType: 2,
                Domain: [0, 1],
                Range: [0, 1, 0, 1, 0, 1],
                N: 1,
                C0: [e, r, n],
                C1: [i, o, a]
            }))), h
        }

        function z(t, e, r) {
            var n = N([e, r]),
                i = t.GRAD_OPC_FUNCTIONS[n];
            return i || (i = t.GRAD_OPC_FUNCTIONS[n] = t.attach(new re({
                FunctionType: 2,
                Domain: [0, 1],
                Range: [0, 1],
                N: 1,
                C0: [e],
                C1: [r]
            }))), i
        }

        function U(t, e) {
            function r(t) {
                return 1 == t.length ? t[0] : {
                    FunctionType: 3,
                    Functions: t,
                    Domain: [0, 1],
                    Bounds: u,
                    Encode: d
                }
            }
            var n, i, o, a, s, h = !1,
                c = [],
                f = [],
                u = [],
                d = [];
            for (n = 1; n < e.length; ++n) i = e[n - 1], o = e[n], a = i.color, s = o.color, f.push(B(t, a.r, a.g, a.b, s.r, s.g, s.b)), (a.a < 1 || s.a < 1) && (h = !0), u.push(o.offset), d.push(0, 1);
            if (h)
                for (n = 1; n < e.length; ++n) i = e[n - 1], o = e[n], a = i.color, s = o.color, c.push(z(t, a.a, s.a));
            return u.pop(), {
                hasAlpha: h,
                colors: r(f),
                opacities: h ? r(c) : null
            }
        }

        function j(t, e, r, n, i, o) {
            var a, s, h;
            return o || (h = [e].concat(n), r.forEach(function(t) {
                h.push(t.offset, t.color.r, t.color.g, t.color.b)
            }), s = N(h), a = t.GRAD_COL[s]), a || (a = new re({
                Type: P("Shading"),
                ShadingType: e ? 3 : 2,
                ColorSpace: P("DeviceRGB"),
                Coords: n,
                Domain: [0, 1],
                Function: i,
                Extend: [!0, !0]
            }), t.attach(a), a._resourceName = "S" + ++Wt, s && (t.GRAD_COL[s] = a)), a
        }

        function q(t, e, r, n, i, o) {
            var a, s, h;
            return o || (h = [e].concat(n), r.forEach(function(t) {
                h.push(t.offset, t.color.a)
            }), s = N(h), a = t.GRAD_OPC[s]), a || (a = new re({
                Type: P("ExtGState"),
                AIS: !1,
                CA: 1,
                ca: 1,
                SMask: {
                    Type: P("Mask"),
                    S: P("Luminosity"),
                    G: t.attach(new ne("/a0 gs /s0 sh", {
                        Type: P("XObject"),
                        Subtype: P("Form"),
                        FormType: 1,
                        BBox: o ? [o.left, o.top + o.height, o.left + o.width, o.top] : [0, 1, 1, 0],
                        Group: {
                            Type: P("Group"),
                            S: P("Transparency"),
                            CS: P("DeviceGray"),
                            I: !0
                        },
                        Resources: {
                            ExtGState: {
                                a0: {
                                    CA: 1,
                                    ca: 1
                                }
                            },
                            Shading: {
                                s0: {
                                    ColorSpace: P("DeviceGray"),
                                    Coords: n,
                                    Domain: [0, 1],
                                    ShadingType: e ? 3 : 2,
                                    Function: i,
                                    Extend: [!0, !0]
                                }
                            }
                        }
                    }))
                }
            }), t.attach(a), a._resourceName = "O" + ++Wt, s && (t.GRAD_OPC[s] = a)), a
        }

        function H(t, e, r) {
            var n = "radial" == e.type,
                i = U(t, e.stops),
                o = n ? [e.start.x, e.start.y, e.start.r, e.end.x, e.end.y, e.end.r] : [e.start.x, e.start.y, e.end.x, e.end.y],
                a = j(t, n, e.stops, o, i.colors, e.userSpace && r),
                s = i.hasAlpha ? q(t, n, e.stops, o, i.opacities, e.userSpace && r) : null;
            return {
                hasAlpha: i.hasAlpha,
                shading: a,
                opacity: s
            }
        }

        function W(t) {
            return t.replace(/^\s*(['"])(.*)\1\s*$/, "$2")
        }

        function X(t) {
            var e, r = /^\s*((normal|italic)\s+)?((normal|small-caps)\s+)?((normal|bold|\d+)\s+)?(([0-9.]+)(px|pt))(\/(([0-9.]+)(px|pt)|normal))?\s+(.*?)\s*$/i,
                n = r.exec(t);
            return n ? (e = n[8] ? parseInt(n[8], 10) : 12, {
                italic: n[2] && "italic" == n[2].toLowerCase(),
                variant: n[4],
                bold: n[6] && /bold|700/i.test(n[6]),
                fontSize: e,
                lineHeight: n[12] ? "normal" == n[12] ? e : parseInt(n[12], 10) : null,
                fontFamily: n[14].split(/\s*,\s*/g).map(W)
            }) : {
                fontSize: 12,
                fontFamily: "sans-serif"
            }
        }

        function J(t) {
            function e(e) {
                return t.bold && (e += "|bold"), t.italic && (e += "|italic"), e.toLowerCase()
            }
            var r, n, i, o = t.fontFamily;
            if (o instanceof Array)
                for (i = 0; i < o.length && (r = e(o[i]), !(n = ue[r])); ++i);
            else n = ue[o.toLowerCase()];
            for (;
                "function" == typeof n;) n = n();
            return n || (n = "Times-Roman"), n
        }

        function Z(t, e) {
            t = t.toLowerCase(), ue[t] = function() {
                return ue[e]
            }, ue[t + "|bold"] = function() {
                return ue[e + "|bold"]
            }, ue[t + "|italic"] = function() {
                return ue[e + "|italic"]
            }, ue[t + "|bold|italic"] = function() {
                return ue[e + "|bold|italic"]
            }
        }

        function K(t, e) {
            if (1 == arguments.length)
                for (var r in t) k(t, r) && K(r, t[r]);
            else switch (t = t.toLowerCase(), ue[t] = e, t) {
                case "dejavu sans":
                    ue["sans-serif"] = e;
                    break;
                case "dejavu sans|bold":
                    ue["sans-serif|bold"] = e;
                    break;
                case "dejavu sans|italic":
                    ue["sans-serif|italic"] = e;
                    break;
                case "dejavu sans|bold|italic":
                    ue["sans-serif|bold|italic"] = e;
                    break;
                case "dejavu serif":
                    ue.serif = e;
                    break;
                case "dejavu serif|bold":
                    ue["serif|bold"] = e;
                    break;
                case "dejavu serif|italic":
                    ue["serif|italic"] = e;
                    break;
                case "dejavu serif|bold|italic":
                    ue["serif|bold|italic"] = e;
                    break;
                case "dejavu mono":
                    ue.monospace = e;
                    break;
                case "dejavu mono|bold":
                    ue["monospace|bold"] = e;
                    break;
                case "dejavu mono|italic":
                    ue["monospace|italic"] = e;
                    break;
                case "dejavu mono|bold|italic":
                    ue["monospace|bold|italic"] = e
            }
        }

        function Y(t, e) {
            var r = t[0],
                n = t[1],
                i = t[2],
                o = t[3],
                a = t[4],
                s = t[5],
                h = e[0],
                c = e[1],
                f = e[2],
                u = e[3],
                d = e[4],
                l = e[5];
            return [r * h + n * f, r * c + n * u, i * h + o * f, i * c + o * u, a * h + s * f + d, a * c + s * u + l]
        }

        function $(t) {
            return 1 === t[0] && 0 === t[1] && 0 === t[2] && 1 === t[3] && 0 === t[4] && 0 === t[5]
        }

        function V(t, e) {
            function r(t, e, r) {
                return r || (r = s), r.pdf && null != r.pdf[t] ? r.pdf[t] : e
            }

            function n() {
                function n(t) {
                    var e, n, i, a, s, h = t.options,
                        c = xt(t),
                        f = c.bbox;
                    t = c.root, e = r("paperSize", r("paperSize", "auto"), h), n = !1, "auto" == e && (f ? (i = f.getSize(), e = [i.width, i.height], n = !0, a = f.getOrigin(), c = new Dt.Group, c.transform(new It.Matrix(1, 0, 0, 1, (-a.x), (-a.y))), c.append(t), t = c) : e = "A4"), s = o.addPage({
                        paperSize: e,
                        margin: r("margin", r("margin"), h),
                        addMargin: n,
                        landscape: r("landscape", r("landscape", !1), h)
                    }), nt(t, s, o)
                }
                if (!(--i > 0)) {
                    var o = new w({
                        producer: r("producer"),
                        title: r("title"),
                        author: r("author"),
                        subject: r("subject"),
                        keywords: r("keywords"),
                        creator: r("creator"),
                        date: r("date"),
                        autoPrint: r("autoPrint")
                    });
                    h ? t.children.forEach(n) : n(t), e(o.render(), o)
                }
            }
            var i, o = [],
                a = {},
                s = t.options,
                h = r("multiPage"),
                c = r("imgDPI");
            c && b(), t.traverse(function(t) {
                rt({
                    Image: function(t) {
                        var e, r, n = t.src();
                        c ? (e = t.bbox().size, r = a[n], e = {
                            width: Math.ceil(e.width * c / 72),
                            height: Math.ceil(e.height * c / 72)
                        }, r && (e.width = Math.max(r.width, e.width), e.height = Math.max(r.height, e.height)), a[n] = e) : a[n] = null
                    },
                    Text: function(t) {
                        var e = X(t.options.font),
                            r = J(e);
                        o.indexOf(r) < 0 && o.push(r)
                    }
                }, t)
            }), i = 2, Kt(o, n), Yt(a, n)
        }

        function Q(t, e) {
            V(t, function(t) {
                e("data:application/pdf;base64," + t.base64())
            })
        }

        function tt(t, e) {
            V(t, function(t) {
                e(new window.Blob([t.get()], {
                    type: "application/pdf"
                }))
            })
        }

        function et(e, r, n, i) {
            window.Blob && !kt.safari ? tt(e, function(e) {
                t.saveAs({
                    dataURI: e,
                    fileName: r
                }), i && i(e)
            }) : Q(e, function(e) {
                t.saveAs({
                    dataURI: e,
                    fileName: r,
                    proxyURL: n
                }), i && i(e)
            })
        }

        function rt(t, e) {
            var r = t[e.nodeType];
            return r ? r.call.apply(r, arguments) : e
        }

        function nt(t, e, r) {
            var n, i, o;
            t.options._pdfDebug && e.comment("BEGIN: " + t.options._pdfDebug), n = t.transform(), i = t.opacity(), e.save(), null != i && i < 1 && e.setOpacity(i), it(t, e, r), ot(t, e, r), n && (o = n.matrix(), e.transform(o.a, o.b, o.c, o.d, o.e, o.f)), at(t, e, r), rt({
                Path: dt,
                MultiPath: lt,
                Circle: pt,
                Arc: gt,
                Text: mt,
                Image: St,
                Group: wt,
                Rect: yt
            }, t, e, r), e.restore(), t.options._pdfDebug && e.comment("END: " + t.options._pdfDebug)
        }

        function it(t, e) {
            var r, n, i, o, a, s, h = t.stroke && t.stroke();
            if (h) {
                if (r = h.color) {
                    if (r = bt(r), null == r) return;
                    e.setStrokeColor(r.r, r.g, r.b), 1 != r.a && e.setStrokeOpacity(r.a)
                }
                if (n = h.width, null != n) {
                    if (0 === n) return;
                    e.setLineWidth(n)
                }
                i = h.dashType, i && e.setDashPattern(pe[i], 0), o = h.lineCap, o && e.setLineCap(ge[o]), a = h.lineJoin, a && e.setLineJoin(me[a]), s = h.opacity, null != s && e.setStrokeOpacity(s)
            }
        }

        function ot(t, e) {
            var r, n, i = t.fill && t.fill();
            if (i && !(i instanceof Dt.Gradient)) {
                if (r = i.color) {
                    if (r = bt(r), null == r) return;
                    e.setFillColor(r.r, r.g, r.b), 1 != r.a && e.setFillOpacity(r.a)
                }
                n = i.opacity, null != n && e.setFillOpacity(n)
            }
        }

        function at(t, e, r) {
            var n = t.clip();
            n && (ut(n, e, r), e.clip())
        }

        function st(t) {
            return t && (t instanceof Dt.Gradient || t.color && !/^(none|transparent)$/i.test(t.color) && (null == t.width || t.width > 0) && (null == t.opacity || t.opacity > 0))
        }

        function ht(t, e, r, n) {
            var i, o, a, s, h, c, f, u, d = t.fill();
            if (d instanceof Dt.Gradient) return n ? e.clipStroke() : e.clip(), i = d instanceof Dt.RadialGradient, i ? (o = {
                x: d.center().x,
                y: d.center().y,
                r: 0
            }, a = {
                x: d.center().x,
                y: d.center().y,
                r: d.radius()
            }) : (o = {
                x: d.start().x,
                y: d.start().y
            }, a = {
                x: d.end().x,
                y: d.end().y
            }), s = d.stops.elements().map(function(t) {
                var e, r = t.offset();
                return r = /%$/.test(r) ? parseFloat(r) / 100 : parseFloat(r), e = bt(t.color()), e.a *= t.opacity(), {
                    offset: r,
                    color: e
                }
            }), s.unshift(s[0]), s.push(s[s.length - 1]), h = {
                userSpace: d.userSpace(),
                type: i ? "radial" : "linear",
                start: o,
                end: a,
                stops: s
            }, c = t.rawBBox(), f = c.topLeft(), u = c.getSize(), c = {
                left: f.x,
                top: f.y,
                width: u.width,
                height: u.height
            }, e.gradient(h, c), !0
        }

        function ct(t, e, r) {
            st(t.fill()) && st(t.stroke()) ? ht(t, e, r, !0) || e.fillStroke() : st(t.fill()) ? ht(t, e, r, !1) || e.fill() : st(t.stroke()) ? e.stroke() : e.nop()
        }

        function ft(t, e) {
            var r, n, i, o = t.segments;
            if (4 == o.length && t.options.closed) {
                for (r = [], n = 0; n < o.length; ++n) {
                    if (o[n].controlIn()) return !1;
                    r[n] = o[n].anchor()
                }
                if (i = r[0].y == r[1].y && r[1].x == r[2].x && r[2].y == r[3].y && r[3].x == r[0].x || r[0].x == r[1].x && r[1].y == r[2].y && r[2].x == r[3].x && r[3].y == r[0].y) return e.rect(r[0].x, r[0].y, r[2].x - r[0].x, r[2].y - r[0].y), !0
            }
        }

        function ut(t, e, r) {
            var n, i, o, a, s, h, c = t.segments;
            if (0 !== c.length && !ft(t, e, r)) {
                for (i = 0; i < c.length; ++i) o = c[i], a = o.anchor(), n ? (s = n.controlOut(), h = o.controlIn(), s && h ? e.bezier(s.x, s.y, h.x, h.y, a.x, a.y) : e.lineTo(a.x, a.y)) : e.moveTo(a.x, a.y), n = o;
                t.options.closed && e.close()
            }
        }

        function dt(t, e, r) {
            ut(t, e, r), ct(t, e, r)
        }

        function lt(t, e, r) {
            var n, i = t.paths;
            for (n = 0; n < i.length; ++n) ut(i[n], e, r);
            ct(t, e, r)
        }

        function pt(t, e, r) {
            var n = t.geometry();
            e.circle(n.center.x, n.center.y, n.radius), ct(t, e, r)
        }

        function gt(t, e, r) {
            var n, i = t.geometry().curvePoints();
            for (e.moveTo(i[0].x, i[0].y), n = 1; n < i.length;) e.bezier(i[n].x, i[n++].y, i[n].x, i[n++].y, i[n].x, i[n++].y);
            ct(t, e, r)
        }

        function mt(t, e) {
            var r, n = X(t.options.font),
                i = t._position;
            t.fill() && t.stroke() ? r = le.fillAndStroke : t.fill() ? r = le.fill : t.stroke() && (r = le.stroke), e.transform(1, 0, 0, -1, i.x, i.y + n.fontSize), e.beginText(), e.setFont(J(n), n.fontSize), e.setTextRenderingMode(r), e.showText(t.content(), t._pdfRect ? t._pdfRect.width() : null), e.endText()
        }

        function wt(t, e, r) {
            var n, i;
            for (t._pdfLink && e.addLink(t._pdfLink.url, t._pdfLink), n = t.children, i = 0; i < n.length; ++i) nt(n[i], e, r)
        }

        function St(t, e) {
            var r, n, i, o = t.src();
            o && (r = t.rect(), n = r.getOrigin(), i = r.getSize(), e.transform(i.width, 0, 0, -i.height, n.x, n.y + i.height), e.drawImage(o))
        }

        function yt(t, e, r) {
            var n = t.geometry();
            e.rect(n.origin.x, n.origin.y, n.size.width, n.size.height), ct(t, e, r)
        }

        function bt(e) {
            var r = t.parseColor(e, !0);
            return r ? r.toRGB() : null
        }

        function xt(t) {
            function e(t) {
                return s = !0, t
            }

            function r(t) {
                return t.visible() && t.opacity() > 0 && (st(t.fill()) || st(t.stroke()))
            }

            function n(t) {
                var e, r, n = [];
                for (e = 0; e < t.length; ++e) r = a(t[e]), null != r && n.push(r);
                return n
            }

            function i(t, e) {
                var r, n = h,
                    i = c;
                t.transform() && (c = c.multiplyCopy(t.transform().matrix())), r = t.clip(), r && (r = r.bbox(), r && (r = r.bbox(c), h = h ? It.Rect.intersect(h, r) : r));
                try {
                    return e()
                } finally {
                    h = n, c = i
                }
            }

            function o(t) {
                if (null == h) return !1;
                var e = t.rawBBox().bbox(c);
                return h && e && (e = It.Rect.intersect(e, h)), e
            }

            function a(a) {
                return i(a, function() {
                    if (!(a instanceof Dt.Group || a instanceof Dt.MultiPath)) {
                        var i = o(a);
                        if (!i) return e(null);
                        f = f ? It.Rect.union(f, i) : i
                    }
                    return rt({
                        Path: function(t) {
                            return 0 !== t.segments.length && r(t) ? t : e(null)
                        },
                        MultiPath: function(t) {
                            if (!r(t)) return e(null);
                            var i = new Dt.MultiPath(t.options);
                            return i.paths = n(t.paths), 0 === i.paths.length ? e(null) : i
                        },
                        Circle: function(t) {
                            return r(t) ? t : e(null)
                        },
                        Arc: function(t) {
                            return r(t) ? t : e(null)
                        },
                        Text: function(t) {
                            return /\S/.test(t.content()) && r(t) ? t : e(null)
                        },
                        Image: function(t) {
                            return t.visible() && t.opacity() > 0 ? t : e(null)
                        },
                        Group: function(r) {
                            if (!(r.visible() && r.opacity() > 0)) return e(null);
                            var i = new Dt.Group(r.options);
                            return i.children = n(r.children), i._pdfLink = r._pdfLink, r === t || 0 !== i.children.length || r._pdfLink ? i : e(null)
                        },
                        Rect: function(t) {
                            return r(t) ? t : e(null)
                        }
                    }, a)
                })
            }
            var s, h = !1,
                c = It.Matrix.unit(),
                f = null;
            do s = !1, t = a(t); while (t && s);
            return {
                root: t,
                bbox: f
            }
        }

        function vt(t, e) {
            var r, n = Ft.createPromise();
            for (r in e) "margin" == r && t.options.pdf && t.options.pdf._ignoreMargin || t.options.set("pdf." + r, e[r]);
            return Q(t, n.resolve), n
        }

        function _t(t, e) {
            var r, n = Ft.createPromise();
            for (r in e) "margin" == r && t.options.pdf && t.options.pdf._ignoreMargin || t.options.set("pdf." + r, e[r]);
            return window.Blob && !kt.safari ? tt(t, n.resolve) : Q(t, n.resolve), n
        }
        var Ct, kt, Tt, Dt, Ft, It, Lt, Mt, Ot, At, Rt, Pt, Et, Gt, Nt, Bt, zt, Ut, jt, qt, Ht, Wt, Xt, Jt, Zt, Kt, Yt, $t, Vt, Qt, te, ee, re, ne, ie, oe, ae, se, he, ce, fe, ue, de, le, pe, ge, me;
        window.kendo.pdf = window.kendo.pdf || {}, Ct = t.support, kt = Ct.browser, Tt = t.pdf, Dt = t.drawing, Ft = Dt.util, It = t.geometry, Lt = "undefined" != typeof Uint8Array && t.support.browser && (!t.support.browser.msie || t.support.browser.version > 9), Mt = function() {
            var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
            return {
                decode: function(e) {
                    for (var r, n, i, o, a, s, h, c = e.replace(/[^A-Za-z0-9\+\/\=]/g, ""), f = 0, u = c.length, d = []; f < u;) r = t.indexOf(c.charAt(f++)), n = t.indexOf(c.charAt(f++)), i = t.indexOf(c.charAt(f++)), o = t.indexOf(c.charAt(f++)), a = r << 2 | n >>> 4, s = (15 & n) << 4 | i >>> 2, h = (3 & i) << 6 | o, d.push(a), 64 != i && d.push(s), 64 != o && d.push(h);
                    return d
                },
                encode: function(e) {
                    for (var r, n, i, o, a, s, h, c = 0, f = e.length, u = ""; c < f;) r = e[c++], n = e[c++], i = e[c++], o = r >>> 2, a = (3 & r) << 4 | n >>> 4, s = (15 & n) << 2 | i >>> 6, h = 63 & i, c - f == 2 ? s = h = 64 : c - f == 1 && (h = 64), u += t.charAt(o) + t.charAt(a) + t.charAt(s) + t.charAt(h);
                    return u
                }
            }
        }(), c.prototype = {
            readTable: function(t, e) {
                var r = this.tables[t];
                if (!r) throw Error("Table " + t + " not found in directory");
                return this[t] = r.table = new e(this, r)
            },
            render: function(t) {
                var r, n, i, o, a, h, c, f, u = this,
                    d = Object.keys(t).length,
                    l = Math.pow(2, Math.floor(Math.log(d) / Math.LN2)),
                    p = 16 * l,
                    g = Math.floor(Math.log(l) / Math.LN2),
                    m = 16 * d - p,
                    w = e();
                w.writeLong(this.scalerType), w.writeShort(d), w.writeShort(p), w.writeShort(g), w.writeShort(m), r = 16 * d, n = w.offset() + r, i = null, o = e();
                for (a in t)
                    if (s(t, a))
                        for (h = t[a], w.writeString(a), w.writeLong(u.checksum(h)), w.writeLong(n), w.writeLong(h.length), o.write(h), "head" == a && (i = n), n += h.length; n % 4;) o.writeByte(0), n++;
                return w.write(o.get()), c = this.checksum(w.get()), f = 2981146554 - c, w.offset(i + 8), w.writeLong(f), w.get()
            },
            checksum: function(t) {
                t = e(t);
                for (var r = 0; !t.eof();) r += t.readLong();
                return 4294967295 & r
            }
        }, Ot = f({
            parse: function(t) {
                t.offset(this.offset), this.version = t.readLong(), this.revision = t.readLong(), this.checkSumAdjustment = t.readLong(), this.magicNumber = t.readLong(), this.flags = t.readShort(), this.unitsPerEm = t.readShort(), this.created = t.read(8), this.modified = t.read(8), this.xMin = t.readShort_(), this.yMin = t.readShort_(), this.xMax = t.readShort_(), this.yMax = t.readShort_(), this.macStyle = t.readShort(), this.lowestRecPPEM = t.readShort(), this.fontDirectionHint = t.readShort_(), this.indexToLocFormat = t.readShort_(), this.glyphDataFormat = t.readShort_()
            },
            render: function(t) {
                var r = e();
                return r.writeLong(this.version), r.writeLong(this.revision), r.writeLong(0), r.writeLong(this.magicNumber), r.writeShort(this.flags), r.writeShort(this.unitsPerEm), r.write(this.created), r.write(this.modified), r.writeShort_(this.xMin), r.writeShort_(this.yMin), r.writeShort_(this.xMax), r.writeShort_(this.yMax), r.writeShort(this.macStyle), r.writeShort(this.lowestRecPPEM), r.writeShort_(this.fontDirectionHint), r.writeShort_(t), r.writeShort_(this.glyphDataFormat), r.get()
            }
        }), At = f({
            parse: function(t) {
                t.offset(this.offset);
                var e = this.file.head.indexToLocFormat;
                this.offsets = 0 === e ? t.times(this.length / 2, function() {
                    return 2 * t.readShort()
                }) : t.times(this.length / 4, t.readLong)
            },
            offsetOf: function(t) {
                return this.offsets[t]
            },
            lengthOf: function(t) {
                return this.offsets[t + 1] - this.offsets[t]
            },
            render: function(t) {
                var r, n = e(),
                    i = t[t.length - 1] > 65535;
                for (r = 0; r < t.length; ++r) i ? n.writeLong(t[r]) : n.writeShort(t[r] / 2);
                return {
                    format: i ? 1 : 0,
                    table: n.get()
                }
            }
        }), Rt = f({
            parse: function(t) {
                t.offset(this.offset), this.version = t.readLong(), this.ascent = t.readShort_(), this.descent = t.readShort_(), this.lineGap = t.readShort_(), this.advanceWidthMax = t.readShort(), this.minLeftSideBearing = t.readShort_(), this.minRightSideBearing = t.readShort_(), this.xMaxExtent = t.readShort_(), this.caretSlopeRise = t.readShort_(), this.caretSlopeRun = t.readShort_(), this.caretOffset = t.readShort_(), t.skip(8), this.metricDataFormat = t.readShort_(), this.numOfLongHorMetrics = t.readShort()
            },
            render: function(t) {
                var r = e();
                return r.writeLong(this.version), r.writeShort_(this.ascent), r.writeShort_(this.descent), r.writeShort_(this.lineGap), r.writeShort(this.advanceWidthMax), r.writeShort_(this.minLeftSideBearing), r.writeShort_(this.minRightSideBearing), r.writeShort_(this.xMaxExtent), r.writeShort_(this.caretSlopeRise), r.writeShort_(this.caretSlopeRun), r.writeShort_(this.caretOffset), r.write([0, 0, 0, 0, 0, 0, 0, 0]), r.writeShort_(this.metricDataFormat), r.writeShort(t.length), r.get()
            }
        }), Pt = f({
            parse: function(t) {
                t.offset(this.offset), this.version = t.readLong(), this.numGlyphs = t.readShort(), this.maxPoints = t.readShort(), this.maxContours = t.readShort(), this.maxComponentPoints = t.readShort(), this.maxComponentContours = t.readShort(), this.maxZones = t.readShort(), this.maxTwilightPoints = t.readShort(), this.maxStorage = t.readShort(), this.maxFunctionDefs = t.readShort(), this.maxInstructionDefs = t.readShort(), this.maxStackElements = t.readShort(), this.maxSizeOfInstructions = t.readShort(), this.maxComponentElements = t.readShort(), this.maxComponentDepth = t.readShort()
            },
            render: function(t) {
                var r = e();
                return r.writeLong(this.version), r.writeShort(t.length), r.writeShort(this.maxPoints), r.writeShort(this.maxContours), r.writeShort(this.maxComponentPoints), r.writeShort(this.maxComponentContours), r.writeShort(this.maxZones), r.writeShort(this.maxTwilightPoints), r.writeShort(this.maxStorage), r.writeShort(this.maxFunctionDefs), r.writeShort(this.maxInstructionDefs), r.writeShort(this.maxStackElements), r.writeShort(this.maxSizeOfInstructions), r.writeShort(this.maxComponentElements), r.writeShort(this.maxComponentDepth), r.get()
            }
        }), Et = f({
            parse: function(t) {
                var e, r, n;
                t.offset(this.offset), e = this.file, r = e.hhea, this.metrics = t.times(r.numOfLongHorMetrics, function() {
                    return {
                        advance: t.readShort(),
                        lsb: t.readShort_()
                    }
                }), n = e.maxp.numGlyphs - e.hhea.numOfLongHorMetrics, this.leftSideBearings = t.times(n, t.readShort_)
            },
            forGlyph: function(t) {
                var e = this.metrics,
                    r = e.length;
                return t < r ? e[t] : {
                    advance: e[r - 1].advance,
                    lsb: this.leftSideBearings[t - r]
                }
            },
            render: function(t) {
                var r, n, i = this,
                    o = e();
                for (r = 0; r < t.length; ++r) n = i.forGlyph(t[r]), o.writeShort(n.advance), o.writeShort_(n.lsb);
                return o.get()
            }
        }), Gt = function() {
            function t(t) {
                this.raw = t
            }

            function r(t) {
                var e, r, s;
                for (this.raw = t, e = this.glyphIds = [], r = this.idOffsets = [];;) {
                    if (s = t.readShort(), r.push(t.offset()),
                        e.push(t.readShort()), !(s & o)) break;
                    t.skip(s & n ? 4 : 2), s & h ? t.skip(8) : s & a ? t.skip(4) : s & i && t.skip(2)
                }
            }
            var n, i, o, a, h;
            return t.prototype = {
                compound: !1,
                render: function() {
                    return this.raw.get()
                }
            }, n = 1, i = 8, o = 32, a = 64, h = 128, r.prototype = {
                compound: !0,
                render: function(t) {
                    var r, n, i = this,
                        o = e(this.raw.get());
                    for (r = 0; r < this.glyphIds.length; ++r) n = i.glyphIds[r], o.offset(i.idOffsets[r]), o.writeShort(t[n]);
                    return o.get()
                }
            }, f({
                parse: function() {
                    this.cache = {}
                },
                glyphFor: function(n) {
                    var i, o, a, h, c, f, u, d, l, p, g, m = this.cache;
                    return s(m, n) ? m[n] : (i = this.file.loca, o = i.lengthOf(n), 0 === o ? m[n] = null : (a = this.rawData, h = this.offset + i.offsetOf(n), c = e(a.slice(h, o)), f = c.readShort_(), u = c.readShort_(), d = c.readShort_(), l = c.readShort_(), p = c.readShort_(), g = m[n] = f == -1 ? new r(c) : new t(c), g.numberOfContours = f, g.xMin = u, g.yMin = d, g.xMax = l, g.yMax = p, g))
                },
                render: function(t, r, n) {
                    var i, o, a, s = e(),
                        h = [];
                    for (i = 0; i < r.length; ++i) o = r[i], a = t[o], h.push(s.offset()), a && s.write(a.render(n));
                    return h.push(s.offset()), {
                        table: s.get(),
                        offsets: h
                    }
                }
            })
        }(), Nt = function() {
            function t(t, e) {
                this.text = t, this.length = t.length, this.platformID = e.platformID, this.platformSpecificID = e.platformSpecificID, this.languageID = e.languageID, this.nameID = e.nameID
            }
            return f({
                parse: function(e) {
                    var r, n, i, o, a, s, h;
                    for (e.offset(this.offset), e.readShort(), r = e.readShort(), n = this.offset + e.readShort(), i = e.times(r, function() {
                            return {
                                platformID: e.readShort(),
                                platformSpecificID: e.readShort(),
                                languageID: e.readShort(),
                                nameID: e.readShort(),
                                length: e.readShort(),
                                offset: e.readShort() + n
                            }
                        }), o = this.strings = {}, a = 0; a < i.length; ++a) s = i[a], e.offset(s.offset), h = e.readString(s.length), o[s.nameID] || (o[s.nameID] = []), o[s.nameID].push(new t(h, s));
                    this.postscriptEntry = o[6][0], this.postscriptName = this.postscriptEntry.text.replace(/[^\x20-\x7F]/g, "")
                },
                render: function(r) {
                    var n, i, o, a, h, c, f = this,
                        u = this.strings,
                        d = 0;
                    for (n in u) s(u, n) && (d += u[n].length);
                    i = e(), o = e(), i.writeShort(0), i.writeShort(d), i.writeShort(6 + 12 * d);
                    for (n in u)
                        if (s(u, n))
                            for (a = 6 == n ? [new t(r, f.postscriptEntry)] : u[n], h = 0; h < a.length; ++h) c = a[h], i.writeShort(c.platformID), i.writeShort(c.platformSpecificID), i.writeShort(c.languageID), i.writeShort(c.nameID), i.writeShort(c.length), i.writeShort(o.offset()), o.writeString(c.text);
                    return i.write(o.get()), i.get()
                }
            })
        }(), Bt = function() {
            var t = ".notdef .null nonmarkingreturn space exclam quotedbl numbersign dollar percent ampersand quotesingle parenleft parenright asterisk plus comma hyphen period slash zero one two three four five six seven eight nine colon semicolon less equal greater question at A B C D E F G H I J K L M N O P Q R S T U V W X Y Z bracketleft backslash bracketright asciicircum underscore grave a b c d e f g h i j k l m n o p q r s t u v w x y z braceleft bar braceright asciitilde Adieresis Aring Ccedilla Eacute Ntilde Odieresis Udieresis aacute agrave acircumflex adieresis atilde aring ccedilla eacute egrave ecircumflex edieresis iacute igrave icircumflex idieresis ntilde oacute ograve ocircumflex odieresis otilde uacute ugrave ucircumflex udieresis dagger degree cent sterling section bullet paragraph germandbls registered copyright trademark acute dieresis notequal AE Oslash infinity plusminus lessequal greaterequal yen mu partialdiff summation product pi integral ordfeminine ordmasculine Omega ae oslash questiondown exclamdown logicalnot radical florin approxequal Delta guillemotleft guillemotright ellipsis nonbreakingspace Agrave Atilde Otilde OE oe endash emdash quotedblleft quotedblright quoteleft quoteright divide lozenge ydieresis Ydieresis fraction currency guilsinglleft guilsinglright fi fl daggerdbl periodcentered quotesinglbase quotedblbase perthousand Acircumflex Ecircumflex Aacute Edieresis Egrave Iacute Icircumflex Idieresis Igrave Oacute Ocircumflex apple Ograve Uacute Ucircumflex Ugrave dotlessi circumflex tilde macron breve dotaccent ring cedilla hungarumlaut ogonek caron Lslash lslash Scaron scaron Zcaron zcaron brokenbar Eth eth Yacute yacute Thorn thorn minus multiply onesuperior twosuperior threesuperior onehalf onequarter threequarters franc Gbreve gbreve Idotaccent Scedilla scedilla Cacute cacute Ccaron ccaron dcroat".split(/\s+/g);
            return f({
                parse: function(t) {
                    var e, r, n = this;
                    switch (t.offset(this.offset), this.format = t.readLong(), this.italicAngle = t.readFixed_(), this.underlinePosition = t.readShort_(), this.underlineThickness = t.readShort_(), this.isFixedPitch = t.readLong(), this.minMemType42 = t.readLong(), this.maxMemType42 = t.readLong(), this.minMemType1 = t.readLong(), this.maxMemType1 = t.readLong(), this.format) {
                        case 65536:
                        case 196608:
                            break;
                        case 131072:
                            for (e = t.readShort(), this.glyphNameIndex = t.times(e, t.readShort), this.names = [], r = this.offset + this.length; t.offset() < r;) n.names.push(t.readString(t.readByte()));
                            break;
                        case 151552:
                            e = t.readShort(), this.offsets = t.read(e);
                            break;
                        case 262144:
                            this.map = t.times(this.file.maxp.numGlyphs, t.readShort)
                    }
                },
                glyphFor: function(e) {
                    switch (this.format) {
                        case 65536:
                            return t[e] || ".notdef";
                        case 131072:
                            var r = this.glyphNameIndex[e];
                            return r < t.length ? t[r] : this.names[r - t.length] || ".notdef";
                        case 151552:
                        case 196608:
                            return ".notdef";
                        case 262144:
                            return this.map[e] || 65535
                    }
                },
                render: function(r) {
                    var n, i, o, a, s, h, c, f = this;
                    if (196608 == this.format) return this.raw();
                    for (n = e(this.rawData.slice(this.offset, 32)), n.writeLong(131072), n.offset(32), i = [], o = [], a = 0; a < r.length; ++a) s = r[a], h = f.glyphFor(s), c = t.indexOf(h), c >= 0 ? i.push(c) : (i.push(t.length + o.length), o.push(h));
                    for (n.writeShort(r.length), a = 0; a < i.length; ++a) n.writeShort(i[a]);
                    for (a = 0; a < o.length; ++a) n.writeByte(o[a].length), n.writeString(o[a]);
                    return n.get()
                }
            })
        }(), zt = function() {
            function t(t, e, r) {
                var n = this;
                n.platformID = t.readShort(), n.platformSpecificID = t.readShort(), n.offset = e + t.readLong(), t.saveExcursion(function() {
                    var e, i, o, a, s, h, c, f, u, d, l, p, g, m, w, S, y;
                    switch (t.offset(n.offset), n.format = t.readShort()) {
                        case 0:
                            for (n.length = t.readShort(), n.language = t.readShort(), i = 0; i < 256; ++i) r[i] = t.readByte();
                            break;
                        case 4:
                            for (n.length = t.readShort(), n.language = t.readShort(), o = t.readShort() / 2, t.skip(6), a = t.times(o, t.readShort), t.skip(2), s = t.times(o, t.readShort), h = t.times(o, t.readShort_), c = t.times(o, t.readShort), f = (n.length + n.offset - t.offset()) / 2, u = t.times(f, t.readShort), i = 0; i < o; ++i)
                                for (d = s[i], l = a[i], e = d; e <= l; ++e) 0 === c[i] ? p = e + h[i] : (g = c[i] / 2 - (o - i) + (e - d), p = u[g] || 0, 0 !== p && (p += h[i])), r[e] = 65535 & p;
                            break;
                        case 6:
                            for (n.length = t.readShort(), n.language = t.readShort(), e = t.readShort(), m = t.readShort(); m-- > 0;) r[e++] = t.readShort();
                            break;
                        case 12:
                            for (t.readShort(), n.length = t.readLong(), n.language = t.readLong(), w = t.readLong(); w-- > 0;)
                                for (e = t.readLong(), S = t.readLong(), y = t.readLong(); e <= S;) r[e++] = y++;
                            break;
                        default:
                            window.console && window.console.error("Unhandled CMAP format: " + n.format)
                    }
                })
            }

            function r(t, r) {
                function n(e) {
                    return r[t[e]]
                }
                var i, o, a, s, c, f, u, d, l, p, g, m, w, S, y, b, x, v = h(t),
                    _ = [],
                    C = [],
                    k = null,
                    T = null;
                for (i = 0; i < v.length; ++i) o = v[i], a = n(o), s = a - o, null != k && s === T || (k && C.push(k), _.push(o), T = s), k = o;
                for (k && C.push(k), C.push(65535), _.push(65535), c = _.length, f = 2 * c, u = 2 * Math.pow(2, Math.floor(Math.log(c) / Math.LN2)), d = Math.log(u / 2) / Math.LN2, l = f - u, p = [], g = [], m = [], i = 0; i < c; ++i) {
                    if (w = _[i], S = C[i], 65535 == w) {
                        p.push(0), g.push(0);
                        break
                    }
                    if (y = n(w), w - y >= 32768)
                        for (p.push(0), g.push(2 * (m.length + c - i)), b = w; b <= S; ++b) m.push(n(b));
                    else p.push(y - w), g.push(0)
                }
                return x = e(), x.writeShort(3), x.writeShort(1), x.writeLong(12), x.writeShort(4), x.writeShort(16 + 8 * c + 2 * m.length), x.writeShort(0), x.writeShort(f), x.writeShort(u), x.writeShort(d), x.writeShort(l), C.forEach(x.writeShort), x.writeShort(0), _.forEach(x.writeShort), p.forEach(x.writeShort_), g.forEach(x.writeShort), m.forEach(x.writeShort), x.get()
            }
            return f({
                parse: function(e) {
                    var r, n = this,
                        i = n.offset;
                    e.offset(i), n.codeMap = {}, n.version = e.readShort(), r = e.readShort(), n.tables = e.times(r, function() {
                        return new t(e, i, n.codeMap)
                    })
                },
                render: function(t, n) {
                    var i = e();
                    return i.writeShort(0), i.writeShort(1), i.write(r(t, n)), i.get()
                }
            })
        }(), Ut = f({
            parse: function(t) {
                t.offset(this.offset), this.version = t.readShort(), this.averageCharWidth = t.readShort_(), this.weightClass = t.readShort(), this.widthClass = t.readShort(), this.type = t.readShort(), this.ySubscriptXSize = t.readShort_(), this.ySubscriptYSize = t.readShort_(), this.ySubscriptXOffset = t.readShort_(), this.ySubscriptYOffset = t.readShort_(), this.ySuperscriptXSize = t.readShort_(), this.ySuperscriptYSize = t.readShort_(), this.ySuperscriptXOffset = t.readShort_(), this.ySuperscriptYOffset = t.readShort_(), this.yStrikeoutSize = t.readShort_(), this.yStrikeoutPosition = t.readShort_(), this.familyClass = t.readShort_(), this.panose = t.times(10, t.readByte), this.charRange = t.times(4, t.readLong), this.vendorID = t.readString(4), this.selection = t.readShort(), this.firstCharIndex = t.readShort(), this.lastCharIndex = t.readShort(), this.version > 0 && (this.ascent = t.readShort_(), this.descent = t.readShort_(), this.lineGap = t.readShort_(), this.winAscent = t.readShort(), this.winDescent = t.readShort(), this.codePageRange = t.times(2, t.readLong), this.version > 1 && (this.xHeight = t.readShort(), this.capHeight = t.readShort(), this.defaultChar = t.readShort(), this.breakChar = t.readShort(), this.maxContext = t.readShort()))
            },
            render: function() {
                return this.raw()
            }
        }), jt = 1e5, d.prototype = {
            use: function(t) {
                var e, n, i, o = this;
                return "string" == typeof t ? r(t).reduce(function(t, e) {
                    return t + String.fromCharCode(o.use(e))
                }, "") : (e = o.unicodes[t], e || (e = o.next++, o.subset[e] = t, o.unicodes[t] = e, n = o.font.cmap.codeMap[t], n && (o.ncid2ogid[e] = n, null == o.ogid2ngid[n] && (i = o.nextGid++, o.ogid2ngid[n] = i, o.ngid2ogid[i] = n))), e)
            },
            encodeText: function(t) {
                return this.use(t)
            },
            glyphIds: function() {
                return h(this.ogid2ngid)
            },
            glyphsFor: function(t, e) {
                var r, n, i, o = this;
                for (e || (e = {}), r = 0; r < t.length; ++r) n = t[r], e[n] || (i = e[n] = o.font.glyf.glyphFor(n), i && i.compound && o.glyphsFor(i.glyphIds, e));
                return e
            },
            render: function() {
                var t, e, r, n, i, o, a, c, f = this,
                    u = this.glyphsFor(this.glyphIds());
                for (t in u) s(u, t) && (t = parseInt(t, 10), null == f.ogid2ngid[t] && (e = f.nextGid++, f.ogid2ngid[t] = e, f.ngid2ogid[e] = t));
                return r = h(this.ngid2ogid), n = r.map(function(t) {
                    return this.ngid2ogid[t]
                }, this), i = this.font, o = i.glyf.render(u, n, this.ogid2ngid), a = i.loca.render(o.offsets), this.lastChar = this.next - 1, c = {
                    cmap: zt.render(this.ncid2ogid, this.ogid2ngid),
                    glyf: o.table,
                    loca: a.table,
                    hmtx: i.hmtx.render(n),
                    hhea: i.hhea.render(n),
                    maxp: i.maxp.render(n),
                    post: i.post.render(n),
                    name: i.name.render(this.psName),
                    head: i.head.render(a.format),
                    "OS/2": i.os2.render()
                }, this.font.directory.render(c)
            },
            cidToGidMap: function() {
                var t, r, n, i = this,
                    o = e(),
                    a = 0;
                for (t = this.firstChar; t < this.next; ++t) {
                    for (; a < t;) o.writeShort(0), a++;
                    r = i.ncid2ogid[t], r ? (n = i.ogid2ngid[r], o.writeShort(n)) : o.writeShort(0), a++
                }
                return o.get()
            }
        }, l.prototype = {
            parse: function() {
                var t = this.directory = new c(this.contents);
                this.head = t.readTable("head", Ot), this.loca = t.readTable("loca", At), this.hhea = t.readTable("hhea", Rt), this.maxp = t.readTable("maxp", Pt), this.hmtx = t.readTable("hmtx", Et), this.glyf = t.readTable("glyf", Gt), this.name = t.readTable("name", Nt), this.post = t.readTable("post", Bt), this.cmap = t.readTable("cmap", zt), this.os2 = t.readTable("OS/2", Ut), this.psName = this.name.postscriptName, this.ascent = this.os2.ascent || this.hhea.ascent, this.descent = this.os2.descent || this.hhea.descent, this.lineGap = this.os2.lineGap || this.hhea.lineGap, this.scale = 1e3 / this.head.unitsPerEm
            },
            widthOfGlyph: function(t) {
                return this.hmtx.forGlyph(t).advance * this.scale
            },
            makeSubset: function() {
                return new d(this)
            }
        }, qt = t.support.browser, Ht = "\n", Wt = 0, Xt = {
            a0: [2383.94, 3370.39],
            a1: [1683.78, 2383.94],
            a2: [1190.55, 1683.78],
            a3: [841.89, 1190.55],
            a4: [595.28, 841.89],
            a5: [419.53, 595.28],
            a6: [297.64, 419.53],
            a7: [209.76, 297.64],
            a8: [147.4, 209.76],
            a9: [104.88, 147.4],
            a10: [73.7, 104.88],
            b0: [2834.65, 4008.19],
            b1: [2004.09, 2834.65],
            b2: [1417.32, 2004.09],
            b3: [1000.63, 1417.32],
            b4: [708.66, 1000.63],
            b5: [498.9, 708.66],
            b6: [354.33, 498.9],
            b7: [249.45, 354.33],
            b8: [175.75, 249.45],
            b9: [124.72, 175.75],
            b10: [87.87, 124.72],
            c0: [2599.37, 3676.54],
            c1: [1836.85, 2599.37],
            c2: [1298.27, 1836.85],
            c3: [918.43, 1298.27],
            c4: [649.13, 918.43],
            c5: [459.21, 649.13],
            c6: [323.15, 459.21],
            c7: [229.61, 323.15],
            c8: [161.57, 229.61],
            c9: [113.39, 161.57],
            c10: [79.37, 113.39],
            executive: [521.86, 756],
            folio: [612, 936],
            legal: [612, 1008],
            letter: [612, 792],
            tabloid: [792, 1224]
        }, Jt = {
            "Times-Roman": !0,
            "Times-Bold": !0,
            "Times-Italic": !0,
            "Times-BoldItalic": !0,
            Helvetica: !0,
            "Helvetica-Bold": !0,
            "Helvetica-Oblique": !0,
            "Helvetica-BoldOblique": !0,
            Courier: !0,
            "Courier-Bold": !0,
            "Courier-Oblique": !0,
            "Courier-BoldOblique": !0,
            Symbol: !0,
            ZapfDingbats: !0
        }, Zt = {}, Kt = v(y), Yt = function(t, e) {
            function r() {
                0 === --i && e()
            }
            var n = Object.keys(t),
                i = n.length;
            return 0 === i ? e() : void n.forEach(function(e) {
                x(e, t[e], r)
            })
        }, w.prototype = {
            loadFonts: Kt,
            loadImages: Yt,
            getFont: function(t) {
                var e = this.FONTS[t];
                if (!e) {
                    if (e = Jt[t], !e) throw Error("Font " + t + " has not been loaded");
                    e = this.attach(e === !0 ? new se(t) : new he(this, e)), this.FONTS[t] = e
                }
                return e
            },
            getImage: function(t) {
                var e = this.IMAGES[t];
                if (!e) {
                    if (e = Zt[t], !e) throw Error("Image " + t + " has not been loaded");
                    if ("ERROR" === e) return null;
                    e = this.IMAGES[t] = this.attach(e.asStream(this))
                }
                return e
            },
            getOpacityGS: function(t, e) {
                var r, n, i, o = parseFloat(t).toFixed(3);
                return t = parseFloat(o), o += e ? "S" : "F", r = this._opacityGSCache || (this._opacityGSCache = {}), n = r[o], n || (i = {
                    Type: P("ExtGState")
                }, e ? i.CA = t : i.ca = t, n = this.attach(new re(i)), n._resourceName = P("GS" + ++Wt), r[o] = n), n
            },
            dict: function(t) {
                return new re(t)
            },
            name: function(t) {
                return P(t)
            },
            stream: function(t, e) {
                return new ne(e, t)
            }
        }, $t = Array.isArray || function(t) {
            return t instanceof Array
        }, A.prototype.beforeRender = function() {}, Vt = R(function(t) {
            this.value = t
        }, {
            render: function(t) {
                var e, r = "",
                    n = this.value;
                for (e = 0; e < n.length; ++e) r += String.fromCharCode(255 & n.charCodeAt(e));
                t("(", r.replace(/([\(\)\\])/g, "\\$1"), ")")
            },
            toString: function() {
                return this.value
            }
        }), Qt = R(function(t) {
            this.value = t
        }, {
            render: function(t) {
                var e, r = this;
                for (t("<"), e = 0; e < this.value.length; ++e) t(C(r.value.charCodeAt(e).toString(16), 4));
                t(">")
            }
        }, Vt), te = R(function(t) {
            this.name = t
        }, {
            render: function(t) {
                t("/" + this.escape())
            },
            escape: function() {
                return this.name.replace(/[^\x21-\x7E]/g, function(t) {
                    return "#" + C(t.charCodeAt(0).toString(16), 2)
                })
            },
            toString: function() {
                return this.name
            }
        }), ee = {}, te.get = P, re = R(function(t) {
            this.props = t
        }, {
            render: function(t) {
                var e = this.props,
                    r = !0;
                t("<<"), t.withIndent(function() {
                    for (var n in e) k(e, n) && !/^_/.test(n) && (r = !1, t.indent(P(n), " ", e[n]))
                }), r || t.indent(), t(">>")
            }
        }), ne = R(function(t, r, n) {
            if ("string" == typeof t) {
                var i = e();
                i.write(t), t = i
            }
            this.data = t, this.props = r || {}, this.compress = n
        }, {
            render: function(t) {
                var e = this.data.get(),
                    r = this.props;
                this.compress && Tt.supportsDeflate() && (r.Filter ? r.Filter instanceof Array || (r.Filter = [r.Filter]) : r.Filter = [], r.Filter.unshift(P("FlateDecode")), e = Tt.deflate(e)), r.Length = e.length, t(new re(r), " stream", Ht), t.writeData(e), t(Ht, "endstream")
            }
        }), ie = R(function() {
            this.props = {
                Type: P("Catalog")
            }
        }, {
            setPages: function(t) {
                this.props.Pages = t
            }
        }, re), oe = R(function() {
            this.props = {
                Type: P("Pages"),
                Kids: [],
                Count: 0
            }
        }, {
            addPage: function(t) {
                this.props.Kids.push(t), this.props.Count++
            }
        }, re), ae = [192, 193, 194, 195, 197, 198, 199, 201, 202, 203, 205, 206, 207], se = R(function(t) {
            this.props = {
                Type: P("Font"),
                Subtype: P("Type1"),
                BaseFont: P(t)
            }, this._resourceName = P("F" + ++Wt)
        }, {
            encodeText: function(t) {
                return new Vt(t + "")
            }
        }, re), he = R(function(t, e, r) {
            var n, i;
            r = this.props = r || {}, r.Type = P("Font"), r.Subtype = P("Type0"), r.Encoding = P("Identity-H"), this._pdf = t, this._font = e, this._sub = e.makeSubset(), this._resourceName = P("F" + ++Wt), n = e.head, this.name = e.psName, i = this.scale = e.scale, this.bbox = [n.xMin * i, n.yMin * i, n.xMax * i, n.yMax * i], this.italicAngle = e.post.italicAngle, this.ascent = e.ascent * i, this.descent = e.descent * i, this.lineGap = e.lineGap * i, this.capHeight = e.os2.capHeight || this.ascent, this.xHeight = e.os2.xHeight || 0, this.stemV = 0, this.familyClass = (e.os2.familyClass || 0) >> 8, this.isSerif = this.familyClass >= 1 && this.familyClass <= 7, this.isScript = 10 == this.familyClass, this.flags = (e.post.isFixedPitch ? 1 : 0) | (this.isSerif ? 2 : 0) | (this.isScript ? 8 : 0) | (0 !== this.italicAngle ? 64 : 0) | 32
        }, {
            encodeText: function(t) {
                return new Qt(this._sub.encodeText(t + ""))
            },
            getTextWidth: function(t, e) {
                var r, n, i = this,
                    o = 0,
                    a = this._font.cmap.codeMap;
                for (r = 0; r < e.length; ++r) n = a[e.charCodeAt(r)], o += i._font.widthOfGlyph(n || 0);
                return o * t / 1e3
            },
            beforeRender: function() {
                var t, r, n, i, o = this,
                    a = o._sub,
                    s = a.render(),
                    h = new ne(e(s), {
                        Length1: s.length
                    }, (!0)),
                    c = o._pdf.attach(new re({
                        Type: P("FontDescriptor"),
                        FontName: P(o._sub.psName),
                        FontBBox: o.bbox,
                        Flags: o.flags,
                        StemV: o.stemV,
                        ItalicAngle: o.italicAngle,
                        Ascent: o.ascent,
                        Descent: o.descent,
                        CapHeight: o.capHeight,
                        XHeight: o.xHeight,
                        FontFile2: o._pdf.attach(h)
                    })),
                    f = a.ncid2ogid,
                    u = a.firstChar,
                    d = a.lastChar,
                    l = [];
                ! function g(t, e) {
                    if (t <= d) {
                        var r = f[t];
                        null == r ? g(t + 1) : (e || l.push(t, e = []), e.push(o._font.widthOfGlyph(r)), g(t + 1, e))
                    }
                }(u), t = new re({
                    Type: P("Font"),
                    Subtype: P("CIDFontType2"),
                    BaseFont: P(o._sub.psName),
                    CIDSystemInfo: new re({
                        Registry: new Vt("Adobe"),
                        Ordering: new Vt("Identity"),
                        Supplement: 0
                    }),
                    FontDescriptor: c,
                    FirstChar: u,
                    LastChar: d,
                    DW: Math.round(o._font.widthOfGlyph(0)),
                    W: l,
                    CIDToGIDMap: o._pdf.attach(o._makeCidToGidMap())
                }), r = o.props, r.BaseFont = P(o._sub.psName), r.DescendantFonts = [o._pdf.attach(t)], n = new ce(u, d, a.subset), i = new ne(p(), null, (!0)), i.data(n), r.ToUnicode = o._pdf.attach(i)
            },
            _makeCidToGidMap: function() {
                return new ne(e(this._sub.cidToGidMap()), null, (!0))
            }
        }, re), ce = R(function(t, e, r) {
            this.firstChar = t, this.lastChar = e, this.map = r
        }, {
            render: function(t) {
                t.indent("/CIDInit /ProcSet findresource begin"), t.indent("12 dict begin"), t.indent("begincmap"), t.indent("/CIDSystemInfo <<"), t.indent("  /Registry (Adobe)"), t.indent("  /Ordering (UCS)"), t.indent("  /Supplement 0"), t.indent(">> def"), t.indent("/CMapName /Adobe-Identity-UCS def"), t.indent("/CMapType 2 def"), t.indent("1 begincodespacerange"), t.indent("  <0000><ffff>"), t.indent("endcodespacerange");
                var e = this;
                t.indent(e.lastChar - e.firstChar + 1, " beginbfchar"), t.withIndent(function() {
                    var r, i, o, a;
                    for (r = e.firstChar; r <= e.lastChar; ++r) {
                        for (i = e.map[r], o = n([i]), t.indent("<", C(r.toString(16), 4), ">", "<"), a = 0; a < o.length; ++a) t(C(o.charCodeAt(a).toString(16), 4));
                        t(">")
                    }
                }), t.indent("endbfchar"), t.indent("endcmap"), t.indent("CMapName currentdict /CMap defineresource pop"), t.indent("end"), t.indent("end")
            }
        }), fe = R(function(t, e) {
            this._pdf = t, this._rcount = 0, this._textMode = !1, this._fontResources = {}, this._gsResources = {}, this._xResources = {}, this._patResources = {}, this._shResources = {}, this._opacity = 1, this._matrix = [1, 0, 0, 1, 0, 0], this._annotations = [], this._font = null, this._fontSize = null, this._contextStack = [], e = this.props = e || {}, e.Type = P("Page"), e.ProcSet = [P("PDF"), P("Text"), P("ImageB"), P("ImageC"), P("ImageI")], e.Resources = new re({
                Font: new re(this._fontResources),
                ExtGState: new re(this._gsResources),
                XObject: new re(this._xResources),
                Pattern: new re(this._patResources),
                Shading: new re(this._shResources)
            }), e.Annots = this._annotations
        }, {
            _out: function() {
                this._content.data.apply(null, arguments)
            },
            transform: function(t, e, r, n, i, o) {
                $(arguments) || (this._matrix = Y(arguments, this._matrix), this._out(t, " ", e, " ", r, " ", n, " ", i, " ", o, " cm"), this._out(Ht))
            },
            translate: function(t, e) {
                this.transform(1, 0, 0, 1, t, e)
            },
            scale: function(t, e) {
                this.transform(t, 0, 0, e, 0, 0)
            },
            rotate: function(t) {
                var e = Math.cos(t),
                    r = Math.sin(t);
                this.transform(e, r, -r, e, 0, 0)
            },
            beginText: function() {
                this._textMode = !0, this._out("BT", Ht)
            },
            endText: function() {
                this._textMode = !1, this._out("ET", Ht)
            },
            _requireTextMode: function() {
                if (!this._textMode) throw Error("Text mode required; call page.beginText() first")
            },
            _requireFont: function() {
                if (!this._font) throw Error("No font selected; call page.setFont() first")
            },
            setFont: function(t, e) {
                this._requireTextMode(), null == t ? t = this._font : t instanceof he || (t = this._pdf.getFont(t)), null == e && (e = this._fontSize), this._fontResources[t._resourceName] = t, this._font = t, this._fontSize = e, this._out(t._resourceName, " ", e, " Tf", Ht)
            },
            setTextLeading: function(t) {
                this._requireTextMode(), this._out(t, " TL", Ht)
            },
            setTextRenderingMode: function(t) {
                this._requireTextMode(), this._out(t, " Tr", Ht)
            },
            showText: function(t, e) {
                var r, n;
                this._requireFont(), t.length > 1 && e && this._font instanceof he && (r = this._font.getTextWidth(this._fontSize, t), n = e / r * 100, this._out(n, " Tz ")), this._out(this._font.encodeText(t), " Tj", Ht)
            },
            showTextNL: function(t) {
                this._requireFont(), this._out(this._font.encodeText(t), " '", Ht)
            },
            addLink: function(t, e) {
                var r = this._toPage({
                        x: e.left,
                        y: e.bottom
                    }),
                    n = this._toPage({
                        x: e.right,
                        y: e.top
                    });
                this._annotations.push(new re({
                    Type: P("Annot"),
                    Subtype: P("Link"),
                    Rect: [r.x, r.y, n.x, n.y],
                    Border: [0, 0, 0],
                    A: new re({
                        Type: P("Action"),
                        S: P("URI"),
                        URI: new Vt(t)
                    })
                }))
            },
            setStrokeColor: function(t, e, r) {
                this._out(t, " ", e, " ", r, " RG", Ht)
            },
            setOpacity: function(t) {
                this.setFillOpacity(t), this.setStrokeOpacity(t), this._opacity *= t
            },
            setStrokeOpacity: function(t) {
                if (t < 1) {
                    var e = this._pdf.getOpacityGS(this._opacity * t, !0);
                    this._gsResources[e._resourceName] = e, this._out(e._resourceName, " gs", Ht)
                }
            },
            setFillColor: function(t, e, r) {
                this._out(t, " ", e, " ", r, " rg", Ht)
            },
            setFillOpacity: function(t) {
                if (t < 1) {
                    var e = this._pdf.getOpacityGS(this._opacity * t, !1);
                    this._gsResources[e._resourceName] = e, this._out(e._resourceName, " gs", Ht)
                }
            },
            gradient: function(t, e) {
                var r, n, i;
                this.save(), this.rect(e.left, e.top, e.width, e.height), this.clip(), t.userSpace || this.transform(e.width, 0, 0, e.height, e.left, e.top), r = H(this._pdf, t, e), n = r.shading._resourceName, this._shResources[n] = r.shading, r.hasAlpha && (i = r.opacity._resourceName, this._gsResources[i] = r.opacity, this._out("/" + i + " gs ")), this._out("/" + n + " sh", Ht), this.restore()
            },
            setDashPattern: function(t, e) {
                this._out(t, " ", e, " d", Ht)
            },
            setLineWidth: function(t) {
                this._out(t, " w", Ht)
            },
            setLineCap: function(t) {
                this._out(t, " J", Ht)
            },
            setLineJoin: function(t) {
                this._out(t, " j", Ht)
            },
            setMitterLimit: function(t) {
                this._out(t, " M", Ht)
            },
            save: function() {
                this._contextStack.push(this._context()), this._out("q", Ht)
            },
            restore: function() {
                this._out("Q", Ht), this._context(this._contextStack.pop())
            },
            moveTo: function(t, e) {
                this._out(t, " ", e, " m", Ht)
            },
            lineTo: function(t, e) {
                this._out(t, " ", e, " l", Ht)
            },
            bezier: function(t, e, r, n, i, o) {
                this._out(t, " ", e, " ", r, " ", n, " ", i, " ", o, " c", Ht)
            },
            bezier1: function(t, e, r, n) {
                this._out(t, " ", e, " ", r, " ", n, " y", Ht)
            },
            bezier2: function(t, e, r, n) {
                this._out(t, " ", e, " ", r, " ", n, " v", Ht)
            },
            close: function() {
                this._out("h", Ht)
            },
            rect: function(t, e, r, n) {
                this._out(t, " ", e, " ", r, " ", n, " re", Ht)
            },
            ellipse: function(t, e, r, n) {
                function i(e) {
                    return t + e
                }

                function o(t) {
                    return e + t
                }
                var a = .5522847498307936;
                this.moveTo(i(0), o(n)), this.bezier(i(r * a), o(n), i(r), o(n * a), i(r), o(0)), this.bezier(i(r), o(-n * a), i(r * a), o(-n), i(0), o(-n)), this.bezier(i(-r * a), o(-n), i(-r), o(-n * a), i(-r), o(0)), this.bezier(i(-r), o(n * a), i(-r * a), o(n), i(0), o(n))
            },
            circle: function(t, e, r) {
                this.ellipse(t, e, r, r)
            },
            stroke: function() {
                this._out("S", Ht)
            },
            nop: function() {
                this._out("n", Ht)
            },
            clip: function() {
                this._out("W n", Ht)
            },
            clipStroke: function() {
                this._out("W S", Ht)
            },
            closeStroke: function() {
                this._out("s", Ht)
            },
            fill: function() {
                this._out("f", Ht)
            },
            fillStroke: function() {
                this._out("B", Ht)
            },
            drawImage: function(t) {
                var e = this._pdf.getImage(t);
                e && (this._xResources[e._resourceName] = e, this._out(e._resourceName, " Do", Ht))
            },
            comment: function(t) {
                var e = this;
                t.split(/\r?\n/g).forEach(function(t) {
                    e._out("% ", t, Ht)
                })
            },
            _context: function(t) {
                return null == t ? {
                    opacity: this._opacity,
                    matrix: this._matrix
                } : (this._opacity = t.opacity, void(this._matrix = t.matrix))
            },
            _toPage: function(t) {
                var e = this._matrix,
                    r = e[0],
                    n = e[1],
                    i = e[2],
                    o = e[3],
                    a = e[4],
                    s = e[5];
                return {
                    x: r * t.x + i * t.y + a,
                    y: n * t.x + o * t.y + s
                }
            }
        }, re), ue = {
            serif: "Times-Roman",
            "serif|bold": "Times-Bold",
            "serif|italic": "Times-Italic",
            "serif|bold|italic": "Times-BoldItalic",
            "sans-serif": "Helvetica",
            "sans-serif|bold": "Helvetica-Bold",
            "sans-serif|italic": "Helvetica-Oblique",
            "sans-serif|bold|italic": "Helvetica-BoldOblique",
            monospace: "Courier",
            "monospace|bold": "Courier-Bold",
            "monospace|italic": "Courier-Oblique",
            "monospace|bold|italic": "Courier-BoldOblique",
            zapfdingbats: "ZapfDingbats",
            "zapfdingbats|bold": "ZapfDingbats",
            "zapfdingbats|italic": "ZapfDingbats",
            "zapfdingbats|bold|italic": "ZapfDingbats"
        }, Z("Times New Roman", "serif"), Z("Courier New", "monospace"), Z("Arial", "sans-serif"), Z("Helvetica", "sans-serif"), Z("Verdana", "sans-serif"), Z("Tahoma", "sans-serif"), Z("Georgia", "sans-serif"), Z("Monaco", "monospace"), Z("Andale Mono", "monospace"), de = {
            fill: 0,
            stroke: 1,
            fillAndStroke: 2,
            invisible: 3,
            fillAndClip: 4,
            strokeAndClip: 5,
            fillStrokeClip: 6,
            clip: 7
        }, le = de, pe = {
            dash: [4],
            dashDot: [4, 2, 1, 2],
            dot: [1, 2],
            longDash: [8, 2],
            longDashDot: [8, 2, 1, 2],
            longDashDotDot: [8, 2, 1, 2, 1, 2],
            solid: []
        }, ge = {
            butt: 0,
            round: 1,
            square: 2
        }, me = {
            miter: 0,
            round: 1,
            bevel: 2
        }, t.deepExtend(t.pdf, {
            Document: w,
            BinaryStream: e,
            defineFont: K,
            parseFontDef: X,
            getFontURL: J,
            loadFonts: Kt,
            loadImages: Yt,
            getPaperOptions: m,
            clearImageCache: b,
            TEXT_RENDERING_MODE: de,
            exportPDF: vt,
            exportPDFToBlob: _t,
            saveAs: et,
            toDataURL: Q,
            toBlob: tt,
            render: V
        }), t.drawing.exportPDF = t.pdf.exportPDF, t.drawing.pdf = t.pdf
    }(kendo), kendo
}, "function" == typeof define && define.amd ? define : function(t, e, r) {
    (r || e)()
}),
function(t, define) {
    define("pdf/mixins.min", ["pdf/core.min"], t)
}(function() {
    return function(t, e) {
        kendo.PDFMixin = {
            extend: function(t) {
                t.events.push("pdfExport"), t.options.pdf = this.options, t.saveAsPDF = this.saveAsPDF, t._drawPDF = this._drawPDF, t._drawPDFShadow = this._drawPDFShadow
            },
            options: {
                fileName: "Export.pdf",
                proxyURL: "",
                paperSize: "auto",
                allPages: !1,
                landscape: !1,
                margin: null,
                title: null,
                author: null,
                subject: null,
                keywords: null,
                creator: "Kendo UI PDF Generator v." + kendo.version,
                date: null
            },
            saveAsPDF: function() {
                var e, r = new t.Deferred,
                    n = r.promise(),
                    i = {
                        promise: n
                    };
                if (!this.trigger("pdfExport", i)) return e = this.options.pdf, e.multiPage = e.multiPage || e.allPages, this._drawPDF(r).then(function(t) {
                    return kendo.drawing.exportPDF(t, e)
                }).done(function(t) {
                    kendo.saveAs({
                        dataURI: t,
                        fileName: e.fileName,
                        proxyURL: e.proxyURL,
                        forceProxy: e.forceProxy,
                        proxyTarget: e.proxyTarget
                    }), r.resolve()
                }).fail(function(t) {
                    r.reject(t)
                }), n
            },
            _drawPDF: function(e) {
                var r = new t.Deferred;
                return kendo.drawing.drawDOM(this.wrapper).done(function(t) {
                    var n = {
                        page: t,
                        pageNumber: 1,
                        progress: 1,
                        totalPages: 1
                    };
                    e.notify(n), r.resolve(n.page)
                }).fail(function(t) {
                    r.reject(t)
                }), r
            },
            _drawPDFShadow: function(e, r) {
                var n, i, o;
                return e = e || {}, n = this.wrapper, i = t("<div class='k-pdf-export-shadow'>"), e.width && i.css({
                    width: e.width,
                    overflow: "visible"
                }), n.before(i), i.append(e.content || n.clone(!0, !0)), o = t.Deferred(), setTimeout(function() {
                    var t = kendo.drawing.drawDOM(i, r);
                    t.always(function() {
                        i.remove()
                    }).then(function() {
                        o.resolve.apply(o, arguments)
                    }).fail(function() {
                        o.reject.apply(o, arguments)
                    }).progress(function() {
                        o.progress.apply(o, arguments)
                    })
                }, 15), o.promise()
            }
        }
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, r) {
    (r || e)()
}),
function(t, define) {
    define("kendo.pdf.min", ["kendo.core.min", "kendo.drawing.min", "pdf/core.min", "pdf/mixins.min"], t)
}(function() {}, "function" == typeof define && define.amd ? define : function(t, e, r) {
    (r || e)()
});;
! function(t, define) {
    define("kendo.router.min", ["kendo.core.min"], t)
}(function() {
    return function(t, n) {
            function e(t, n) {
                if (!n) return t;
                t + "/" === n && (t = n);
                var e = RegExp("^" + n, "i");
                return e.test(t) || (t = n + "/" + t), d.protocol + "//" + (d.host + "/" + t).replace(/\/\/+/g, "/")
            }

            function r(t) {
                return t ? "#!" : "#"
            }

            function i(t) {
                var n = d.href;
                return "#!" === t && n.indexOf("#") > -1 && n.indexOf("#!") < 0 ? null : n.split(t)[1] || ""
            }

            function o(t, n) {
                return 0 === n.indexOf(t) ? n.substr(t.length).replace(/\/\//g, "/") : n
            }

            function a(t) {
                return t.replace(/^(#)?/, "#")
            }

            function s(t) {
                return t.replace(/^(#(!)?)?/, "#!")
            }
            var h = window.kendo,
                u = "change",
                c = "back",
                l = "same",
                f = h.support,
                d = window.location,
                p = window.history,
                g = 50,
                b = h.support.browser.msie,
                k = /^#*/,
                w = window.document,
                v = h.Class.extend({
                    back: function() {
                        b ? setTimeout(function() {
                            p.back()
                        }) : p.back()
                    },
                    forward: function() {
                        b ? setTimeout(function() {
                            p.forward()
                        }) : p.forward()
                    },
                    length: function() {
                        return p.length
                    },
                    replaceLocation: function(t) {
                        d.replace(t)
                    }
                }),
                x = v.extend({
                    init: function(t) {
                        this.root = t
                    },
                    navigate: function(t) {
                        p.pushState({}, w.title, e(t, this.root))
                    },
                    replace: function(t) {
                        p.replaceState({}, w.title, e(t, this.root))
                    },
                    normalize: function(t) {
                        return o(this.root, t)
                    },
                    current: function() {
                        var t = d.pathname;
                        return d.search && (t += d.search), o(this.root, t)
                    },
                    change: function(n) {
                        t(window).bind("popstate.kendo", n)
                    },
                    stop: function() {
                        t(window).unbind("popstate.kendo")
                    },
                    normalizeCurrent: function(t) {
                        var n, o = t.root,
                            a = d.pathname,
                            s = i(r(t.hashBang));
                        o === a + "/" && (n = o), o === a && s && (n = e(s.replace(k, ""), o)), n && p.pushState({}, w.title, n)
                    }
                }),
                _ = v.extend({
                    init: function(t) {
                        this._id = h.guid(), this.prefix = r(t), this.fix = t ? s : a
                    },
                    navigate: function(t) {
                        d.hash = this.fix(t)
                    },
                    replace: function(t) {
                        this.replaceLocation(this.fix(t))
                    },
                    normalize: function(t) {
                        return t.indexOf(this.prefix) < 0 ? t : t.split(this.prefix)[1]
                    },
                    change: function(n) {
                        f.hashChange ? t(window).on("hashchange." + this._id, n) : this._interval = setInterval(n, g)
                    },
                    stop: function() {
                        t(window).off("hashchange." + this._id), clearInterval(this._interval)
                    },
                    current: function() {
                        return i(this.prefix)
                    },
                    normalizeCurrent: function(t) {
                        var n = d.pathname,
                            e = t.root;
                        return !(!t.pushState || e === n) && (this.replaceLocation(e + this.prefix + o(e, n)), !0)
                    }
                }),
                m = h.Observable.extend({
                    start: function(n) {
                        if (n = n || {}, this.bind([u, c, l], n), !this._started) {
                            this._started = !0, n.root = n.root || "/";
                            var e, r = this.createAdapter(n);
                            r.normalizeCurrent(n) || (e = r.current(), t.extend(this, {
                                adapter: r,
                                root: n.root,
                                historyLength: r.length(),
                                current: e,
                                locations: [e]
                            }), r.change(t.proxy(this, "_checkUrl")))
                        }
                    },
                    createAdapter: function(t) {
                        return f.pushState && t.pushState ? new x(t.root) : new _(t.hashBang)
                    },
                    stop: function() {
                        this._started && (this.adapter.stop(), this.unbind(u), this._started = !1)
                    },
                    change: function(t) {
                        this.bind(u, t)
                    },
                    replace: function(t, n) {
                        this._navigate(t, n, function(n) {
                            n.replace(t), this.locations[this.locations.length - 1] = this.current
                        })
                    },
                    navigate: function(t, e) {
                        return "#:back" === t ? (this.backCalled = !0, this.adapter.back(), n) : (this._navigate(t, e, function(n) {
                            n.navigate(t), this.locations.push(this.current)
                        }), n)
                    },
                    _navigate: function(t, e, r) {
                        var i = this.adapter;
                        return t = i.normalize(t), this.current === t || this.current === decodeURIComponent(t) ? (this.trigger(l), n) : (!e && this.trigger(u, {
                            url: t,
                            decode: !1
                        }) || (this.current = t, r.call(this, i), this.historyLength = i.length()), n)
                    },
                    _checkUrl: function() {
                        var t = this.adapter,
                            e = t.current(),
                            r = t.length(),
                            i = this.historyLength === r,
                            o = e === this.locations[this.locations.length - 2] && i,
                            a = this.backCalled,
                            s = this.current;
                        return null === e || this.current === e || this.current === decodeURIComponent(e) || (this.historyLength = r, this.backCalled = !1, this.current = e, o && this.trigger("back", {
                            url: s,
                            to: e
                        }) ? (t.forward(), this.current = s, n) : this.trigger(u, {
                            url: e,
                            backButtonPressed: !a
                        }) ? (o ? t.forward() : (t.back(), this.historyLength--), this.current = s, n) : (o ? this.locations.pop() : this.locations.push(e), n))
                    }
                });
            h.History = m, h.History.HistoryAdapter = v, h.History.HashAdapter = _, h.History.PushStateAdapter = x, h.absoluteURL = e, h.history = new m
        }(window.kendo.jQuery),
        function() {
            function t(t, n) {
                return n ? t : "([^/]+)"
            }

            function n(n, e) {
                return RegExp("^" + n.replace(p, "\\$&").replace(l, "(?:$1)?").replace(f, t).replace(d, "(.*?)") + "$", e ? "i" : "")
            }

            function e(t) {
                return t.replace(/(\?.*)|(#.*)/g, "")
            }
            var r = window.kendo,
                i = r.history,
                o = r.Observable,
                a = "init",
                s = "routeMissing",
                h = "change",
                u = "back",
                c = "same",
                l = /\((.*?)\)/g,
                f = /(\(\?)?:\w+/g,
                d = /\*\w+/g,
                p = /[\-{}\[\]+?.,\\\^$|#\s]/g,
                g = r.Class.extend({
                    init: function(t, e, r) {
                        t instanceof RegExp || (t = n(t, r)), this.route = t, this._callback = e
                    },
                    callback: function(t, n, i) {
                        var o, a, s = 0,
                            h = r.parseQueryStringParams(t);
                        if (h._back = n, t = e(t), o = this.route.exec(t).slice(1), a = o.length, i)
                            for (; s < a; s++) void 0 !== o[s] && (o[s] = decodeURIComponent(o[s]));
                        o.push(h), this._callback.apply(null, o)
                    },
                    worksWith: function(t, n, r) {
                        return !!this.route.test(e(t)) && (this.callback(t, n, r), !0)
                    }
                }),
                b = o.extend({
                    init: function(t) {
                        t || (t = {}), o.fn.init.call(this), this.routes = [], this.pushState = t.pushState, this.hashBang = t.hashBang, this.root = t.root, this.ignoreCase = t.ignoreCase !== !1, this.bind([a, s, h, c, u], t)
                    },
                    destroy: function() {
                        i.unbind(h, this._urlChangedProxy), i.unbind(c, this._sameProxy), i.unbind(u, this._backProxy), this.unbind()
                    },
                    start: function() {
                        var t, n = this,
                            e = function() {
                                n._same()
                            },
                            r = function(t) {
                                n._back(t)
                            },
                            o = function(t) {
                                n._urlChanged(t)
                            };
                        i.start({
                            same: e,
                            change: o,
                            back: r,
                            pushState: n.pushState,
                            hashBang: n.hashBang,
                            root: n.root
                        }), t = {
                            url: i.current || "/",
                            preventDefault: $.noop
                        }, n.trigger(a, t) || n._urlChanged(t), this._urlChangedProxy = o, this._backProxy = r
                    },
                    route: function(t, n) {
                        this.routes.push(new g(t, n, this.ignoreCase))
                    },
                    navigate: function(t, n) {
                        r.history.navigate(t, n)
                    },
                    replace: function(t, n) {
                        r.history.replace(t, n)
                    },
                    _back: function(t) {
                        this.trigger(u, {
                            url: t.url,
                            to: t.to
                        }) && t.preventDefault()
                    },
                    _same: function() {
                        this.trigger(c)
                    },
                    _urlChanged: function(t) {
                        var n, e, i, o, a = t.url,
                            u = !!t.decode,
                            c = t.backButtonPressed;
                        if (a || (a = "/"), this.trigger(h, {
                                url: t.url,
                                params: r.parseQueryStringParams(t.url),
                                backButtonPressed: c
                            })) return void t.preventDefault();
                        for (n = 0, e = this.routes, o = e.length; n < o; n++)
                            if (i = e[n], i.worksWith(a, c, u)) return;
                        this.trigger(s, {
                            url: a,
                            params: r.parseQueryStringParams(a),
                            backButtonPressed: c
                        }) && t.preventDefault()
                    }
                });
            r.Router = b
        }(), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, n, e) {
    (e || n)()
});;
! function(e, define) {
    define("kendo.sortable.min", ["kendo.draganddrop.min"], e)
}(function() {
    return function(e, t) {
        function n(t, n) {
            try {
                return e.contains(t, n) || t == n
            } catch (r) {
                return !1
            }
        }

        function r(e) {
            return e.clone()
        }

        function i(e) {
            return e.clone().removeAttr("id").css("visibility", "hidden")
        }
        var o = window.kendo,
            s = o.ui.Widget,
            l = o._outerWidth,
            a = o._outerHeight,
            d = "start",
            h = "beforeMove",
            c = "move",
            u = "end",
            g = "change",
            f = "cancel",
            p = "sort",
            m = "remove",
            _ = "receive",
            v = ">*",
            x = -1,
            y = s.extend({
                init: function(e, t) {
                    var n = this;
                    s.fn.init.call(n, e, t), n.options.placeholder || (n.options.placeholder = i), n.options.hint || (n.options.hint = r), n.draggable = n._createDraggable()
                },
                events: [d, h, c, u, g, f],
                options: {
                    name: "Sortable",
                    hint: null,
                    placeholder: null,
                    filter: v,
                    holdToDrag: !1,
                    disabled: null,
                    container: null,
                    connectWith: null,
                    handler: null,
                    cursorOffset: null,
                    axis: null,
                    ignore: null,
                    autoScroll: !1,
                    cursor: "auto",
                    moveOnDragEnter: !1
                },
                destroy: function() {
                    this.draggable.destroy(), s.fn.destroy.call(this)
                },
                _createDraggable: function() {
                    var t = this,
                        n = t.element,
                        r = t.options;
                    return new o.ui.Draggable(n, {
                        filter: r.filter,
                        hint: o.isFunction(r.hint) ? r.hint : e(r.hint),
                        holdToDrag: r.holdToDrag,
                        container: r.container ? e(r.container) : null,
                        cursorOffset: r.cursorOffset,
                        axis: r.axis,
                        ignore: r.ignore,
                        autoScroll: r.autoScroll,
                        dragstart: e.proxy(t._dragstart, t),
                        dragcancel: e.proxy(t._dragcancel, t),
                        drag: e.proxy(t._drag, t),
                        dragend: e.proxy(t._dragend, t)
                    })
                },
                _dragstart: function(t) {
                    var n = this.draggedElement = t.currentTarget,
                        r = this.options.disabled,
                        i = this.options.handler,
                        s = this.options.placeholder,
                        l = this.placeholder = e(o.isFunction(s) ? s.call(this, n) : s);
                    r && n.is(r) ? t.preventDefault() : i && !e(t.initialTarget).is(i) ? t.preventDefault() : this.trigger(d, {
                        item: n,
                        draggableEvent: t
                    }) ? t.preventDefault() : (n.css("display", "none"), n.before(l), this._setCursor())
                },
                _dragcancel: function() {
                    this._cancel(), this.trigger(f, {
                        item: this.draggedElement
                    }), this._resetCursor()
                },
                _drag: function(n) {
                    var r, i, o, s, l, a = this.draggedElement,
                        d = this._findTarget(n),
                        h = {
                            left: n.x.location,
                            top: n.y.location
                        },
                        c = {
                            x: n.x.delta,
                            y: n.y.delta
                        },
                        u = this.options.axis,
                        g = this.options.moveOnDragEnter,
                        f = {
                            item: a,
                            list: this,
                            draggableEvent: n
                        };
                    if ("x" === u || "y" === u) return this._movementByAxis(u, h, c[u], f), t;
                    if (d) {
                        if (r = this._getElementCenter(d.element), i = {
                                left: Math.round(h.left - r.left),
                                top: Math.round(h.top - r.top)
                            }, e.extend(f, {
                                target: d.element
                            }), d.appendToBottom) return this._movePlaceholder(d, null, f), t;
                        if (d.appendAfterHidden && this._movePlaceholder(d, "next", f), this._isFloating(d.element) ? c.x < 0 && g || !g && i.left < 0 ? o = "prev" : (c.x > 0 && g || !g && i.left > 0) && (o = "next") : c.y < 0 && g || !g && i.top < 0 ? o = "prev" : (c.y > 0 && g || !g && i.top > 0) && (o = "next"), o) {
                            for (l = "prev" === o ? jQuery.fn.prev : jQuery.fn.next, s = l.call(d.element); s.length && !s.is(":visible");) s = l.call(s);
                            s[0] != this.placeholder[0] && this._movePlaceholder(d, o, f)
                        }
                    }
                },
                _dragend: function(n) {
                    var r, i, o, s, l = this.placeholder,
                        a = this.draggedElement,
                        d = this.indexOf(a),
                        h = this.indexOf(l),
                        c = this.options.connectWith;
                    return this._resetCursor(), o = {
                        action: p,
                        item: a,
                        oldIndex: d,
                        newIndex: h,
                        draggableEvent: n
                    }, h >= 0 ? i = this.trigger(u, o) : (r = l.parents(c).getKendoSortable(), o.action = m, s = e.extend({}, o, {
                        action: _,
                        oldIndex: x,
                        newIndex: r.indexOf(l)
                    }), i = !(!this.trigger(u, o) && !r.trigger(u, s))), i || h === d ? (this._cancel(), t) : (l.replaceWith(a), a.show(), this.draggable.dropped = !0, o = {
                        action: this.indexOf(a) != x ? p : m,
                        item: a,
                        oldIndex: d,
                        newIndex: this.indexOf(a),
                        draggableEvent: n
                    }, this.trigger(g, o), r && (s = e.extend({}, o, {
                        action: _,
                        oldIndex: x,
                        newIndex: r.indexOf(a)
                    }), r.trigger(g, s)), t)
                },
                _findTarget: function(n) {
                    var r, i, o = this._findElementUnderCursor(n),
                        s = this.options.connectWith;
                    return e.contains(this.element[0], o) ? (r = this.items(), i = r.filter(o)[0] || r.has(o)[0], i ? {
                        element: e(i),
                        sortable: this
                    } : null) : this.element[0] == o && this._isEmpty() ? {
                        element: this.element,
                        sortable: this,
                        appendToBottom: !0
                    } : this.element[0] == o && this._isLastHidden() ? (i = this.items().eq(0), {
                        element: i,
                        sortable: this,
                        appendAfterHidden: !0
                    }) : s ? this._searchConnectedTargets(o, n) : t
                },
                _findElementUnderCursor: function(e) {
                    var t = o.elementUnderCursor(e),
                        r = e.sender;
                    return n(r.hint[0], t) && (r.hint.hide(), t = o.elementUnderCursor(e), t || (t = o.elementUnderCursor(e)), r.hint.show()), t
                },
                _searchConnectedTargets: function(t, n) {
                    var r, i, o, s, l = e(this.options.connectWith);
                    for (s = 0; s < l.length; s++)
                        if (r = l.eq(s).getKendoSortable(), e.contains(l[s], t)) {
                            if (r) return i = r.items(), o = i.filter(t)[0] || i.has(t)[0], o ? (r.placeholder = this.placeholder, {
                                element: e(o),
                                sortable: r
                            }) : null
                        } else if (l[s] == t) {
                        if (r && r._isEmpty()) return {
                            element: l.eq(s),
                            sortable: r,
                            appendToBottom: !0
                        };
                        if (this._isCursorAfterLast(r, n)) return o = r.items().last(), {
                            element: o,
                            sortable: r
                        }
                    }
                },
                _isCursorAfterLast: function(e, t) {
                    var n, r, i = e.items().last(),
                        s = {
                            left: t.x.location,
                            top: t.y.location
                        };
                    return n = o.getOffset(i), n.top += a(i), n.left += l(i), r = this._isFloating(i) ? n.left - s.left : n.top - s.top, r < 0
                },
                _movementByAxis: function(t, n, r, i) {
                    var o, s = "x" === t ? n.left : n.top,
                        l = r < 0 ? this.placeholder.prev() : this.placeholder.next(),
                        a = this.items();
                    l.length && !l.is(":visible") && (l = r < 0 ? l.prev() : l.next()), a.filter(l).length && (e.extend(i, {
                        target: l
                    }), o = this._getElementCenter(l), o && (o = "x" === t ? o.left : o.top), l.length && r < 0 && s - o < 0 ? this._movePlaceholder({
                        element: l,
                        sortable: this
                    }, "prev", i) : l.length && r > 0 && s - o > 0 && this._movePlaceholder({
                        element: l,
                        sortable: this
                    }, "next", i))
                },
                _movePlaceholder: function(e, t, n) {
                    var r = this.placeholder;
                    e.sortable.trigger(h, n) || (t ? "prev" === t ? e.element.before(r) : "next" === t && e.element.after(r) : e.element.append(r), e.sortable.trigger(c, n))
                },
                _setCursor: function() {
                    var t, n = this.options.cursor;
                    n && "auto" !== n && (t = e(document.body), this._originalCursorType = t.css("cursor"), t.css({
                        cursor: n
                    }), this._cursorStylesheet || (this._cursorStylesheet = e("<style>* { cursor: " + n + " !important; }</style>")), this._cursorStylesheet.appendTo(t))
                },
                _resetCursor: function() {
                    this._originalCursorType && (e(document.body).css("cursor", this._originalCursorType), this._originalCursorType = null, this._cursorStylesheet.remove())
                },
                _getElementCenter: function(e) {
                    var t = e.length ? o.getOffset(e) : null;
                    return t && (t.top += a(e) / 2, t.left += l(e) / 2), t
                },
                _isFloating: function(e) {
                    var t = /left|right/.test(e.css("float")),
                        n = /inline|table-cell/.test(e.css("display")),
                        r = /flex/.test(e.parent().css("display")) && (/row|row-reverse/.test(e.parent().css("flex-direction")) || !e.parent().css("flex-direction"));
                    return t || n || r
                },
                _cancel: function() {
                    this.draggedElement.show(), this.placeholder.remove(), this.draggable.dropped = !0
                },
                _items: function() {
                    var e, t = this.options.filter;
                    return e = t ? this.element.find(t) : this.element.children()
                },
                indexOf: function(e) {
                    var t = this._items(),
                        n = this.placeholder,
                        r = this.draggedElement;
                    return n && e[0] == n[0] ? t.not(r).index(e) : t.not(n).index(e)
                },
                items: function() {
                    var e = this.placeholder,
                        t = this._items();
                    return e && (t = t.not(e)), t
                },
                _isEmpty: function() {
                    return !this.items().length
                },
                _isLastHidden: function() {
                    return 1 === this.items().length && this.items().is(":hidden")
                }
            });
        o.ui.plugin(y)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(e, define) {
    define("kendo.view.min", ["kendo.core.min", "kendo.binder.min", "kendo.fx.min"], e)
}(function() {
    return function(e, t) {
        function n(e) {
            if (!e) return {};
            var t = e.match(R) || [];
            return {
                type: t[1],
                direction: t[3],
                reverse: "reverse" === t[5]
            }
        }
        var i = window.kendo,
            r = i.attr,
            o = i.ui,
            a = i.attrValue,
            s = i.directiveSelector,
            d = i.Observable,
            c = i.ui.Widget,
            h = i.roleSelector,
            l = "SCRIPT",
            f = "init",
            w = "transitionStart",
            u = "transitionEnd",
            p = "show",
            v = "hide",
            g = "attach",
            m = "detach",
            _ = /unrecognized expression/,
            y = /<body[^>]*>(([\u000a\u000d\u2028\u2029]|.)*)<\/body>/i,
            V = "loadStart",
            C = "loadComplete",
            S = "showStart",
            b = "sameViewRequested",
            x = "viewShow",
            E = "viewTypeDetermined",
            T = "after",
            I = {
                content: "k-content",
                view: "k-view",
                stretchedView: "k-stretched-view",
                widget: "k-widget",
                header: "k-header",
                footer: "k-footer"
            },
            O = i.ui.Widget.extend({
                init: function(t, n) {
                    var r = this;
                    n = n || {}, r.id = i.guid(), d.fn.init.call(r), this.options = e.extend({}, this.options, n), r.content = t, r.options.renderOnInit && c.fn.init.call(r, r._createElement(), n), r.options.wrapInSections && r._renderSections(), r.tagName = n.tagName || "div", r.model = n.model, r._wrap = n.wrap !== !1, this._evalTemplate = n.evalTemplate || !1, r._fragments = {}, r.bind([f, p, v, w, u], n)
                },
                options: {
                    name: "View",
                    renderOnInit: !1,
                    wrapInSections: !1,
                    detachOnHide: !0,
                    detachOnDestroy: !0
                },
                render: function(t) {
                    var n = this,
                        r = !n.element;
                    return r && (n.element = n._createElement()), t && e(t).append(n.element), r && (i.bind(n.element, n.model), n.trigger(f)), t && (n._eachFragment(g), n.trigger(p)), n.element
                },
                clone: function() {
                    return new k(this)
                },
                triggerBeforeShow: function() {
                    return !0
                },
                triggerBeforeHide: function() {
                    return !0
                },
                showStart: function() {
                    var e = this,
                        t = e.render();
                    t && t.css("display", ""), this.trigger(S, {
                        view: this
                    })
                },
                showEnd: function() {},
                hideEnd: function() {
                    this.hide()
                },
                beforeTransition: function(e) {
                    this.trigger(w, {
                        type: e
                    })
                },
                afterTransition: function(e) {
                    this.trigger(u, {
                        type: e
                    })
                },
                hide: function() {
                    this.options.detachOnHide && (this._eachFragment(m), e(this.element).detach()), this.trigger(v)
                },
                destroy: function() {
                    var e = this,
                        t = e.element;
                    t && (c.fn.destroy.call(e), i.unbind(t), i.destroy(t), e.options.detachOnDestroy && t.remove())
                },
                purge: function() {
                    var t = this;
                    t.destroy(), e(t.element).add(t.content).add(t.wrapper).off().remove()
                },
                fragments: function(t) {
                    e.extend(this._fragments, t)
                },
                _eachFragment: function(e) {
                    for (var t in this._fragments) this._fragments[t][e](this, t)
                },
                _createElement: function() {
                    var t, n, r, o = this,
                        a = "<" + o.tagName + " />";
                    try {
                        n = e(document.getElementById(o.content) || o.content), n[0].tagName === l && (n = n.html())
                    } catch (s) {
                        _.test(s.message) && (n = o.content)
                    }
                    return "string" == typeof n ? (n = n.replace(/^\s+|\s+$/g, ""), o._evalTemplate && (n = i.template(n)(o.model || {})), t = e(a).append(n), o._wrap || (t = t.contents())) : (t = n, o._evalTemplate && (r = e(i.template(e("<div />").append(t.clone(!0)).html())(o.model || {})), e.contains(document, t[0]) && t.replaceWith(r), t = r), o._wrap && (t = t.wrapAll(a).parent())), t
                },
                _renderSections: function() {
                    var e = this;
                    e.options.wrapInSections && (e._wrapper(), e._createContent(), e._createHeader(), e._createFooter())
                },
                _wrapper: function() {
                    var e, t = this,
                        n = t.content;
                    t.wrapper = n.is(h("view")) ? t.content : n.wrap("<div data-" + i.ns + 'stretch="true" data-' + i.ns + 'role="view" data-' + i.ns + 'init-widgets="false"></div>').parent(), e = t.wrapper, e.attr("id", t.id), e.addClass(I.view), e.addClass(I.widget), e.attr("role", "view")
                },
                _createContent: function() {
                    var t, n = this,
                        i = e(n.wrapper),
                        o = h("content");
                    i.children(o)[0] || (t = i.children().filter(function() {
                        var t = e(this);
                        if (!t.is(h("header")) && !t.is(h("footer"))) return t
                    }), t.wrap("<div " + r("role") + '="content"></div>')), this.contentElement = i.children(h("content")), this.contentElement.addClass(I.stretchedView).addClass(I.content)
                },
                _createHeader: function() {
                    var e = this,
                        t = e.wrapper;
                    this.header = t.children(h("header")).addClass(I.header)
                },
                _createFooter: function() {
                    var e = this,
                        t = e.wrapper;
                    this.footer = t.children(h("footer")).addClass(I.footer)
                }
            }),
            k = i.Class.extend({
                init: function(t) {
                    e.extend(this, {
                        element: t.element.clone(!0),
                        transition: t.transition,
                        id: t.id
                    }), t.element.parent().append(this.element)
                },
                hideEnd: function() {
                    this.element.remove()
                },
                beforeTransition: e.noop,
                afterTransition: e.noop
            }),
            H = O.extend({
                init: function(e, t) {
                    O.fn.init.call(this, e, t), this.containers = {}
                },
                container: function(e) {
                    var t = this.containers[e];
                    return t || (t = this._createContainer(e), this.containers[e] = t), t
                },
                showIn: function(e, t, n) {
                    this.container(e).show(t, n)
                },
                _createContainer: function(e) {
                    var t, n = this.render(),
                        i = n.find(e);
                    if (!i.length && n.is(e)) {
                        if (!n.is(e)) throw Error("can't find a container with the specified " + e + " selector");
                        i = n
                    }
                    return t = new F(i), t.bind("accepted", function(e) {
                        e.view.render(i)
                    }), t
                }
            }),
            B = O.extend({
                attach: function(e, t) {
                    e.element.find(t).replaceWith(this.render())
                },
                detach: function() {}
            }),
            R = /^(\w+)(:(\w+))?( (\w+))?$/,
            F = d.extend({
                init: function(e) {
                    d.fn.init.call(this), this.container = e, this.history = [], this.view = null, this.running = !1
                },
                after: function() {
                    this.running = !1, this.trigger("complete", {
                        view: this.view
                    }), this.trigger("after")
                },
                end: function() {
                    this.view.showEnd(), this.previous.hideEnd(), this.after()
                },
                show: function(e, t, r) {
                    if (!e.triggerBeforeShow() || this.view && !this.view.triggerBeforeHide()) return this.trigger("after"), !1;
                    r = r || e.id;
                    var o = this,
                        a = e === o.view ? e.clone() : o.view,
                        s = o.history,
                        d = s[s.length - 2] || {},
                        c = d.id === r,
                        h = t || (c ? s[s.length - 1].transition : e.transition),
                        l = n(h);
                    return o.running && o.effect.stop(), "none" === h && (h = null), o.trigger("accepted", {
                        view: e
                    }), o.view = e, o.previous = a, o.running = !0, c ? s.pop() : s.push({
                        id: r,
                        transition: h
                    }), a ? (h && i.effects.enabled ? (e.element.addClass("k-fx-hidden"), e.showStart(), c && !t && (l.reverse = !l.reverse), o.effect = i.fx(e.element).replace(a.element, l.type).beforeTransition(function() {
                        e.beforeTransition("show"), a.beforeTransition("hide")
                    }).afterTransition(function() {
                        e.afterTransition("show"), a.afterTransition("hide")
                    }).direction(l.direction).setReverse(l.reverse), o.effect.run().then(function() {
                        o.end()
                    })) : (e.showStart(), o.end()), !0) : (e.showStart(), e.showEnd(), o.after(), !0)
                },
                destroy: function() {
                    var e = this,
                        t = e.view;
                    t && t.destroy && t.destroy()
                }
            }),
            L = d.extend({
                init: function(t) {
                    var n, r, o = this;
                    d.fn.init.call(o), o.options = t, e.extend(o, t), o.sandbox = e("<div />"), r = o.container, n = o._hideViews(r), o.rootView = n.first(), o.layouts = {}, o.viewContainer = new i.ViewContainer(o.container), o.viewContainer.bind("accepted", function(e) {
                        e.view.params = o.params
                    }), o.viewContainer.bind("complete", function(e) {
                        o.trigger(x, {
                            view: e.view
                        })
                    }), o.viewContainer.bind(T, function() {
                        o.trigger(T)
                    }), this.bind(this.events, t)
                },
                events: [S, T, x, V, C, b, E],
                destroy: function() {
                    var e, t = this,
                        n = t.viewContainer;
                    i.destroy(t.container);
                    for (e in t.layouts) this.layouts[e].destroy();
                    n && n.destroy()
                },
                view: function() {
                    return this.viewContainer.view
                },
                showView: function(e, t, n) {
                    if (e = e.replace(RegExp("^" + this.remoteViewURLPrefix), ""), "" === e && this.remoteViewURLPrefix && (e = "/"), e.replace(/^#/, "") === this.url) return this.trigger(b), !1;
                    this.trigger(S);
                    var r = this,
                        o = r._findViewElement(e),
                        a = i.widgetInstance(o);
                    return r.url = e.replace(/^#/, ""), r.params = n, a && a.reload && (a.purge(), o = []), this.trigger(E, {
                        remote: 0 === o.length,
                        url: e
                    }), !o[0] || (a || (a = r._createView(o)), r.viewContainer.show(a, t, e))
                },
                append: function(e, t) {
                    var n, i, o = this.sandbox,
                        a = (t || "").split("?")[0],
                        s = this.container;
                    return y.test(e) && (e = RegExp.$1), o[0].innerHTML = e, s.append(o.children("script, style")), n = this._hideViews(o), i = n.first(), i.length || (n = i = o.wrapInner("<div data-role=view />").children()), a && i.hide().attr(r("url"), a), s.append(n), this._createView(i)
                },
                _locate: function(e) {
                    return this.$angular ? s(e) : h(e)
                },
                _findViewElement: function(e) {
                    var t, n = e.split("?")[0];
                    return n ? (t = this.container.children("[" + r("url") + "='" + n + "']"), t[0] || n.indexOf("/") !== -1 || (t = this.container.children("#" === n.charAt(0) ? n : "#" + n)), t[0] || (t = this._findViewElementById(e)), t) : this.rootView
                },
                _findViewElementById: function(e) {
                    var t = this.container.children("[id='" + e + "']");
                    return t
                },
                _createView: function(e) {
                    return this._createSpaView(e)
                },
                _createMobileView: function(e) {
                    return i.initWidget(e, {
                        defaultTransition: this.transition,
                        loader: this.loader,
                        container: this.container,
                        getLayout: this.getLayoutProxy,
                        modelScope: this.modelScope,
                        reload: a(e, "reload")
                    }, o.roles)
                },
                _createSpaView: function(e) {
                    var t = (this.options || {}).viewOptions || {};
                    return new i.View(e, {
                        renderOnInit: t.renderOnInit,
                        wrap: t.wrap || !1,
                        wrapInSections: t.wrapInSections,
                        detachOnHide: t.detachOnHide,
                        detachOnDestroy: t.detachOnDestroy
                    })
                },
                _hideViews: function(e) {
                    return e.children(this._locate("view")).hide()
                }
            });
        i.ViewEngine = L, i.ViewContainer = F, i.Fragment = B, i.Layout = H, i.View = O, i.ViewClone = k
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(e, define) {
    define("kendo.mobile.scroller.min", ["kendo.fx.min", "kendo.draganddrop.min"], e)
}(function() {
    return function(e, i) {
        var n = window.kendo,
            t = n.mobile,
            s = n.effects,
            o = t.ui,
            l = e.proxy,
            a = e.extend,
            r = o.Widget,
            c = n.Class,
            h = n.ui.Movable,
            u = n.ui.Pane,
            d = n.ui.PaneDimensions,
            m = s.Transition,
            f = s.Animation,
            p = Math.abs,
            v = 500,
            b = .7,
            x = .96,
            y = 10,
            T = 55,
            w = .5,
            _ = 5,
            g = "km-scroller-release",
            E = "km-scroller-refresh",
            C = "pull",
            k = "change",
            S = "resize",
            z = "scroll",
            M = 2,
            A = f.extend({
                init: function(e) {
                    var i = this;
                    f.fn.init.call(i), a(i, e), i.userEvents.bind("gestureend", l(i.start, i)), i.tapCapture.bind("press", l(i.cancel, i))
                },
                enabled: function() {
                    return this.movable.scale < this.dimensions.minScale
                },
                done: function() {
                    return this.dimensions.minScale - this.movable.scale < .01
                },
                tick: function() {
                    var e = this.movable;
                    e.scaleWith(1.1), this.dimensions.rescale(e.scale)
                },
                onEnd: function() {
                    var e = this.movable;
                    e.scaleTo(this.dimensions.minScale), this.dimensions.rescale(e.scale)
                }
            }),
            O = f.extend({
                init: function(e) {
                    var i = this;
                    f.fn.init.call(i), a(i, e, {
                        transition: new m({
                            axis: e.axis,
                            movable: e.movable,
                            onEnd: function() {
                                i._end()
                            }
                        })
                    }), i.tapCapture.bind("press", function() {
                        i.cancel()
                    }), i.userEvents.bind("end", l(i.start, i)), i.userEvents.bind("gestureend", l(i.start, i)), i.userEvents.bind("tap", l(i.onEnd, i))
                },
                onCancel: function() {
                    this.transition.cancel()
                },
                freeze: function(e) {
                    var i = this;
                    i.cancel(), i._moveTo(e)
                },
                onEnd: function() {
                    var e = this;
                    e.paneAxis.outOfBounds() ? e._snapBack() : e._end()
                },
                done: function() {
                    return p(this.velocity) < 1
                },
                start: function(e) {
                    var i, n = this;
                    n.dimension.enabled && (n.paneAxis.outOfBounds() ? n.transition._started ? (n.transition.cancel(), n.velocity = Math.min(e.touch[n.axis].velocity * n.velocityMultiplier, T), f.fn.start.call(n)) : n._snapBack() : (i = e.touch.id === M ? 0 : e.touch[n.axis].velocity, n.velocity = Math.max(Math.min(i * n.velocityMultiplier, T), -T), n.tapCapture.captureNext(), f.fn.start.call(n)))
                },
                tick: function() {
                    var e = this,
                        i = e.dimension,
                        n = e.paneAxis.outOfBounds() ? w : e.friction,
                        t = e.velocity *= n,
                        s = e.movable[e.axis] + t;
                    !e.elastic && i.outOfBounds(s) && (s = Math.max(Math.min(s, i.max), i.min), e.velocity = 0), e.movable.moveAxis(e.axis, s)
                },
                _end: function() {
                    this.tapCapture.cancelCapture(), this.end()
                },
                _snapBack: function() {
                    var e = this,
                        i = e.dimension,
                        n = e.movable[e.axis] > i.max ? i.max : i.min;
                    e._moveTo(n)
                },
                _moveTo: function(e) {
                    this.transition.moveTo({
                        location: e,
                        duration: v,
                        ease: m.easeOutExpo
                    })
                }
            }),
            H = f.extend({
                init: function(e) {
                    var i = this;
                    n.effects.Animation.fn.init.call(this), a(i, e, {
                        origin: {},
                        destination: {},
                        offset: {}
                    })
                },
                tick: function() {
                    this._updateCoordinates(), this.moveTo(this.origin)
                },
                done: function() {
                    return p(this.offset.y) < _ && p(this.offset.x) < _
                },
                onEnd: function() {
                    this.moveTo(this.destination), this.callback && this.callback.call()
                },
                setCoordinates: function(e, i) {
                    this.offset = {}, this.origin = e, this.destination = i
                },
                setCallback: function(e) {
                    e && n.isFunction(e) ? this.callback = e : e = i
                },
                _updateCoordinates: function() {
                    this.offset = {
                        x: (this.destination.x - this.origin.x) / 4,
                        y: (this.destination.y - this.origin.y) / 4
                    }, this.origin = {
                        y: this.origin.y + this.offset.y,
                        x: this.origin.x + this.offset.x
                    }
                }
            }),
            B = c.extend({
                init: function(i) {
                    var n = this,
                        t = "x" === i.axis,
                        s = e('<div class="km-touch-scrollbar km-' + (t ? "horizontal" : "vertical") + '-scrollbar" />');
                    a(n, i, {
                        element: s,
                        elementSize: 0,
                        movable: new h(s),
                        scrollMovable: i.movable,
                        alwaysVisible: i.alwaysVisible,
                        size: t ? "width" : "height"
                    }), n.scrollMovable.bind(k, l(n.refresh, n)), n.container.append(s), i.alwaysVisible && n.show()
                },
                refresh: function() {
                    var e = this,
                        i = e.axis,
                        n = e.dimension,
                        t = n.size,
                        s = e.scrollMovable,
                        o = t / n.total,
                        l = Math.round(-s[i] * o),
                        a = Math.round(t * o);
                    o >= 1 ? this.element.css("display", "none") : this.element.css("display", ""), l + a > t ? a = t - l : l < 0 && (a += l, l = 0), e.elementSize != a && (e.element.css(e.size, a + "px"), e.elementSize = a), e.movable.moveAxis(i, l)
                },
                show: function() {
                    this.element.css({
                        opacity: b,
                        visibility: "visible"
                    })
                },
                hide: function() {
                    this.alwaysVisible || this.element.css({
                        opacity: 0
                    })
                }
            }),
            R = r.extend({
                init: function(t, s) {
                    var o, c, m, f, v, b, x, y, T, w = this;
                    return r.fn.init.call(w, t, s), t = w.element, (w._native = w.options.useNative && n.support.hasNativeScrolling) ? (t.addClass("km-native-scroller").prepend('<div class="km-scroll-header"/>'), a(w, {
                        scrollElement: t,
                        fixedContainer: t.children().first()
                    }), i) : (t.css("overflow", "hidden").addClass("km-scroll-wrapper").wrapInner('<div class="km-scroll-container"/>').prepend('<div class="km-scroll-header"/>'), o = t.children().eq(1), c = new n.TapCapture(t), m = new h(o), f = new d({
                        element: o,
                        container: t,
                        forcedEnabled: w.options.zoom
                    }), v = this.options.avoidScrolling, b = new n.UserEvents(t, {
                        touchAction: "pan-y",
                        fastTap: !0,
                        allowSelection: !0,
                        preventDragEvent: !0,
                        captureUpIfMoved: !0,
                        multiTouch: w.options.zoom,
                        supportDoubleTap: w.options.supportDoubleTap,
                        start: function(i) {
                            f.refresh();
                            var n = p(i.x.velocity),
                                t = p(i.y.velocity),
                                s = 2 * n >= t,
                                o = e.contains(w.fixedContainer[0], i.event.target),
                                l = 2 * t >= n;
                            !o && !v(i) && w.enabled && (f.x.enabled && s || f.y.enabled && l) ? b.capture() : b.cancel()
                        }
                    }), x = new u({
                        movable: m,
                        dimensions: f,
                        userEvents: b,
                        elastic: w.options.elastic
                    }), y = new A({
                        movable: m,
                        dimensions: f,
                        userEvents: b,
                        tapCapture: c
                    }), T = new H({
                        moveTo: function(e) {
                            w.scrollTo(e.x, e.y)
                        }
                    }), m.bind(k, function() {
                        w.scrollTop = -m.y, w.scrollLeft = -m.x, w.trigger(z, {
                            scrollTop: w.scrollTop,
                            scrollLeft: w.scrollLeft
                        })
                    }), w.options.mousewheelScrolling && t.on("DOMMouseScroll mousewheel", l(this, "_wheelScroll")), a(w, {
                        movable: m,
                        dimensions: f,
                        zoomSnapBack: y,
                        animatedScroller: T,
                        userEvents: b,
                        pane: x,
                        tapCapture: c,
                        pulled: !1,
                        enabled: !0,
                        scrollElement: o,
                        scrollTop: 0,
                        scrollLeft: 0,
                        fixedContainer: t.children().first()
                    }), w._initAxis("x"), w._initAxis("y"), w._wheelEnd = function() {
                        w._wheel = !1, w.userEvents.end(0, w._wheelY)
                    }, f.refresh(), w.options.pullToRefresh && w._initPullToRefresh(), i)
                },
                _wheelScroll: function(e) {
                    if (!e.ctrlKey) {
                        this._wheel || (this._wheel = !0, this._wheelY = 0, this.userEvents.press(0, this._wheelY)), clearTimeout(this._wheelTimeout), this._wheelTimeout = setTimeout(this._wheelEnd, 50);
                        var i = n.wheelDeltaY(e);
                        i && (this._wheelY += i, this.userEvents.move(0, this._wheelY)), e.preventDefault()
                    }
                },
                makeVirtual: function() {
                    this.dimensions.y.makeVirtual()
                },
                virtualSize: function(e, i) {
                    this.dimensions.y.virtualSize(e, i)
                },
                height: function() {
                    return this.dimensions.y.size
                },
                scrollHeight: function() {
                    return this.scrollElement[0].scrollHeight
                },
                scrollWidth: function() {
                    return this.scrollElement[0].scrollWidth
                },
                options: {
                    name: "Scroller",
                    zoom: !1,
                    pullOffset: 140,
                    visibleScrollHints: !1,
                    elastic: !0,
                    useNative: !1,
                    mousewheelScrolling: !0,
                    avoidScrolling: function() {
                        return !1
                    },
                    pullToRefresh: !1,
                    messages: {
                        pullTemplate: "Pull to refresh",
                        releaseTemplate: "Release to refresh",
                        refreshTemplate: "Refreshing"
                    }
                },
                events: [C, z, S],
                _resize: function() {
                    this._native || this.contentResized()
                },
                setOptions: function(e) {
                    var i = this;
                    r.fn.setOptions.call(i, e), e.pullToRefresh && i._initPullToRefresh()
                },
                reset: function() {
                    this._native ? this.scrollElement.scrollTop(0) : (this.movable.moveTo({
                        x: 0,
                        y: 0
                    }), this._scale(1))
                },
                contentResized: function() {
                    this.dimensions.refresh(), this.pane.x.outOfBounds() && this.movable.moveAxis("x", this.dimensions.x.min), this.pane.y.outOfBounds() && this.movable.moveAxis("y", this.dimensions.y.min)
                },
                zoomOut: function() {
                    var e = this.dimensions;
                    e.refresh(), this._scale(e.fitScale), this.movable.moveTo(e.centerCoordinates())
                },
                enable: function() {
                    this.enabled = !0
                },
                disable: function() {
                    this.enabled = !1
                },
                scrollTo: function(e, i) {
                    this._native ? (this.scrollElement.scrollLeft(p(e)), this.scrollElement.scrollTop(p(i))) : (this.dimensions.refresh(), this.movable.moveTo({
                        x: e,
                        y: i
                    }))
                },
                animatedScrollTo: function(e, i, n) {
                    var t, s;
                    this._native ? this.scrollTo(e, i) : (t = {
                        x: this.movable.x,
                        y: this.movable.y
                    }, s = {
                        x: e,
                        y: i
                    }, this.animatedScroller.setCoordinates(t, s), this.animatedScroller.setCallback(n), this.animatedScroller.start())
                },
                pullHandled: function() {
                    var e = this;
                    e.refreshHint.removeClass(E), e.hintContainer.html(e.pullTemplate({})), e.yinertia.onEnd(), e.xinertia.onEnd(), e.userEvents.cancel()
                },
                destroy: function() {
                    r.fn.destroy.call(this), this.userEvents && this.userEvents.destroy()
                },
                _scale: function(e) {
                    this.dimensions.rescale(e), this.movable.scaleTo(e)
                },
                _initPullToRefresh: function() {
                    var e = this;
                    e.dimensions.y.forceEnabled(), e.pullTemplate = n.template(e.options.messages.pullTemplate), e.releaseTemplate = n.template(e.options.messages.releaseTemplate), e.refreshTemplate = n.template(e.options.messages.refreshTemplate), e.scrollElement.prepend('<span class="km-scroller-pull"><span class="km-icon"></span><span class="km-loading-left"></span><span class="km-loading-right"></span><span class="km-template">' + e.pullTemplate({}) + "</span></span>"), e.refreshHint = e.scrollElement.children().first(), e.hintContainer = e.refreshHint.children(".km-template"), e.pane.y.bind("change", l(e._paneChange, e)), e.userEvents.bind("end", l(e._dragEnd, e))
                },
                _dragEnd: function() {
                    var e = this;
                    e.pulled && (e.pulled = !1, e.refreshHint.removeClass(g).addClass(E), e.hintContainer.html(e.refreshTemplate({})), e.yinertia.freeze(e.options.pullOffset / 2), e.trigger("pull"))
                },
                _paneChange: function() {
                    var e = this;
                    e.movable.y / w > e.options.pullOffset ? e.pulled || (e.pulled = !0, e.refreshHint.removeClass(E).addClass(g), e.hintContainer.html(e.releaseTemplate({}))) : e.pulled && (e.pulled = !1, e.refreshHint.removeClass(g), e.hintContainer.html(e.pullTemplate({})))
                },
                _initAxis: function(e) {
                    var i = this,
                        n = i.movable,
                        t = i.dimensions[e],
                        s = i.tapCapture,
                        o = i.pane[e],
                        l = new B({
                            axis: e,
                            movable: n,
                            dimension: t,
                            container: i.element,
                            alwaysVisible: i.options.visibleScrollHints
                        });
                    t.bind(k, function() {
                        l.refresh()
                    }), o.bind(k, function() {
                        l.show()
                    }), i[e + "inertia"] = new O({
                        axis: e,
                        paneAxis: o,
                        movable: n,
                        tapCapture: s,
                        userEvents: i.userEvents,
                        dimension: t,
                        elastic: i.options.elastic,
                        friction: i.options.friction || x,
                        velocityMultiplier: i.options.velocityMultiplier || y,
                        end: function() {
                            l.hide(), i.trigger("scrollEnd", {
                                axis: e,
                                scrollTop: i.scrollTop,
                                scrollLeft: i.scrollLeft
                            })
                        }
                    })
                }
            });
        o.plugin(R)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, i, n) {
    (n || i)()
});;
! function(e, define) {
    define("kendo.list.min", ["kendo.data.min", "kendo.popup.min"], e)
}(function() {
    return function(e, t) {
        function i(e, i) {
            return e !== t && "" !== e && null !== e && ("boolean" === i ? ("boolean" != typeof e && (e = "true" === e.toLowerCase()), e = !!e) : "number" === i ? e = +e : "string" === i && (e = "" + e)), e
        }

        function n(e) {
            return e[e.length - 1]
        }

        function a(e) {
            var t = e.selectedIndex;
            return t > -1 ? e.options[t] : {}
        }

        function s(e, t) {
            var i, n, a, s, r = t.length,
                l = e.length,
                o = [],
                u = [];
            if (l)
                for (a = 0; a < l; a++) {
                    for (i = e[a], n = !1, s = 0; s < r; s++)
                        if (i === t[s]) {
                            n = !0, o.push({
                                index: a,
                                item: i
                            });
                            break
                        }
                    n || u.push(i)
                }
            return {
                changed: o,
                unchanged: u
            }
        }

        function r(t) {
            return !(!t || e.isEmptyObject(t)) && !(t.filters && !t.filters.length)
        }

        function l(t, i) {
            var n, a = !1;
            return t.filters && (n = e.grep(t.filters, function(e) {
                return a = l(e, i), e.filters ? e.filters.length : e.field != i
            }), a || t.filters.length === n.length || (a = !0), t.filters = n), a
        }
        var o, u, c = window.kendo,
            d = c.ui,
            h = c._outerHeight,
            f = /^\d+(\.\d+)?%$/i,
            p = d.Widget,
            _ = c.keys,
            g = c.support,
            m = c.htmlEncode,
            v = c._activeElement,
            b = c._outerWidth,
            x = c.data.ObservableArray,
            I = "id",
            w = "change",
            S = "k-state-focused",
            y = "k-state-hover",
            T = "k-i-loading",
            F = ".k-group-header",
            k = ".k-item",
            V = "_label",
            C = "open",
            D = "close",
            H = "cascade",
            B = "select",
            E = "selected",
            P = "requestStart",
            L = "requestEnd",
            G = e.extend,
            W = e.proxy,
            A = e.isArray,
            q = g.browser,
            O = "k-hidden",
            N = "width",
            M = q.msie,
            R = M && q.version < 9,
            U = /"/g,
            z = {
                ComboBox: ["DropDownList", "MultiColumnComboBox"],
                DropDownList: ["ComboBox", "MultiColumnComboBox"],
                MultiColumnComboBox: ["ComboBox", "DropDownList"]
            },
            j = c.ui.DataBoundWidget.extend({
                init: function(t, i) {
                    var n, a = this,
                        s = a.ns;
                    p.fn.init.call(a, t, i), t = a.element, i = a.options, a._isSelect = t.is(B), a._isSelect && a.element[0].length && (i.dataSource || (i.dataTextField = i.dataTextField || "text", i.dataValueField = i.dataValueField || "value")), a.ul = e('<ul unselectable="on" class="k-list k-reset"/>').attr({
                        tabIndex: -1,
                        "aria-hidden": !0
                    }), a.list = e("<div class='k-list-container'/>").append(a.ul).on("mousedown" + s, W(a._listMousedown, a)), n = t.attr(I), n || (n = c.guid()), a.list.attr(I, n + "-list"), a.ul.attr(I, n + "_listbox"), i.columns && i.columns.length && (a.ul.removeClass("k-list").addClass("k-grid-list"), a._columnsHeader()), a._header(), a._noData(), a._footer(), a._accessors(), a._initValue()
                },
                options: {
                    valuePrimitive: !1,
                    footerTemplate: "",
                    headerTemplate: "",
                    noDataTemplate: !0,
                    messages: {
                        noData: "No data found.",
                        clear: "clear"
                    }
                },
                setOptions: function(e) {
                    p.fn.setOptions.call(this, e), e && e.enable !== t && (e.enabled = e.enable), e.columns && e.columns.length && this._columnsHeader(), this._header(), this._noData(), this._footer(), this._renderFooter(), this._renderNoData()
                },
                focus: function() {
                    this._focused.focus()
                },
                readonly: function(e) {
                    this._editable({
                        readonly: e === t || e,
                        disable: !1
                    })
                },
                enable: function(e) {
                    this._editable({
                        readonly: !1,
                        disable: !(e = e === t || e)
                    })
                },
                _header: function() {
                    var i, n = this,
                        a = e(n.header),
                        s = n.options.headerTemplate;
                    return this._angularElement(a, "cleanup"), c.destroy(a), a.remove(), s ? (i = "function" != typeof s ? c.template(s) : s, a = e(i({})), n.header = a[0] ? a : null, n.list.prepend(a), this._angularElement(n.header, "compile"), t) : (n.header = null, t)
                },
                _columnsHeader: function() {
                    var t, i, n, a, s, r, l, o, u, d, h, p = this,
                        _ = e(p.columnsHeader);
                    for (this._angularElement(_, "cleanup"), c.destroy(_), _.remove(), t = "<div class='k-grid-header'><div class='k-grid-header-wrap'><table role='presentation'>", i = "<colgroup>", n = "<tr>", a = 0; a < this.options.columns.length; a++) s = this.options.columns[a], r = s.title || s.field || "", l = s.headerTemplate || r, o = "function" != typeof l ? c.template(l) : l, u = s.width, d = parseInt(u, 10), h = "", u && !isNaN(d) && (h += "style='width:", h += d, h += f.test(u) ? "%" : "px", h += ";'"), i += "<col " + h + "/>", n += "<th class='k-header'>", n += o(s), n += "</th>";
                    i += "</colgroup>", n += "</tr>", t += i, t += n, t += "</table></div></div>", p.columnsHeader = _ = e(t), p.list.prepend(_), this._angularElement(p.columnsHeader, "compile")
                },
                _noData: function() {
                    var i = this,
                        n = e(i.noData),
                        a = i.options.noDataTemplate === !0 ? i.options.messages.noData : i.options.noDataTemplate;
                    return i.angular("cleanup", function() {
                        return {
                            elements: n
                        }
                    }), c.destroy(n), n.remove(), a ? (i.noData = e('<div class="k-nodata" style="display:none"><div></div></div>').appendTo(i.list), i.noDataTemplate = "function" != typeof a ? c.template(a) : a, t) : (i.noData = null, t)
                },
                _footer: function() {
                    var i = this,
                        n = e(i.footer),
                        a = i.options.footerTemplate;
                    return this._angularElement(n, "cleanup"), c.destroy(n), n.remove(), a ? (i.footer = e('<div class="k-footer"></div>').appendTo(i.list), i.footerTemplate = "function" != typeof a ? c.template(a) : a, t) : (i.footer = null, t)
                },
                _listOptions: function(t) {
                    var i = this,
                        n = i.options,
                        a = n.virtual,
                        s = {
                            change: W(i._listChange, i)
                        },
                        r = W(i._listBound, i);
                    return a = "object" == typeof a ? a : {}, t = e.extend({
                        autoBind: !1,
                        selectable: !0,
                        dataSource: i.dataSource,
                        click: W(i._click, i),
                        activate: W(i._activateItem, i),
                        columns: n.columns,
                        deactivate: W(i._deactivateItem, i),
                        dataBinding: function() {
                            i.trigger("dataBinding")
                        },
                        dataBound: r,
                        height: n.height,
                        dataValueField: n.dataValueField,
                        dataTextField: n.dataTextField,
                        groupTemplate: n.groupTemplate,
                        fixedGroupTemplate: n.fixedGroupTemplate,
                        template: n.template
                    }, t, a, s), t.template || (t.template = "#:" + c.expr(t.dataTextField, "data") + "#"), n.$angular && (t.$angular = n.$angular), t
                },
                _initList: function() {
                    var e = this,
                        t = e._listOptions({
                            selectedItemChange: W(e._listChange, e)
                        });
                    e.listView = e.options.virtual ? new c.ui.VirtualList(e.ul, t) : new c.ui.StaticList(e.ul, t), e.listView.bind("listBound", W(e._listBound, e)), e._setListValue()
                },
                _setListValue: function(e) {
                    e = e || this.options.value, e !== t && this.listView.value(e).done(W(this._updateSelectionState, this))
                },
                _updateSelectionState: e.noop,
                _listMousedown: function(e) {
                    this.filterInput && this.filterInput[0] === e.target || e.preventDefault()
                },
                _isFilterEnabled: function() {
                    var e = this.options.filter;
                    return e && "none" !== e
                },
                _hideClear: function() {
                    var e = this;
                    e._clear && e._clear.addClass(O)
                },
                _showClear: function() {
                    this._clear && this._clear.removeClass(O)
                },
                _clearValue: function() {
                    this._clearText(), this._accessor(""), this.listView.value([]), this._isSelect && (this._customOption = t), this._isFilterEnabled() && !this.options.enforceMinLength && (this._filter({
                        word: "",
                        open: !1
                    }), this.options.highlightFirst && this.listView.focus(0)), this._change()
                },
                _clearText: function() {
                    this.text("")
                },
                _clearFilter: function() {
                    this.options.virtual || this.listView.bound(!1), this._filterSource()
                },
                _filterSource: function(e, t) {
                    var i, n, a = this,
                        s = a.options,
                        o = s.filterFields && e && e.logic && e.filters && e.filters.length,
                        u = a.dataSource,
                        c = G({}, u.filter() || {}),
                        d = e || c.filters && c.filters.length && !e,
                        h = l(c, s.dataTextField);
                    if (this._clearFilterExpressions(c), !e && !h || !a.trigger("filtering", {
                            filter: e
                        })) return i = {
                        filters: [],
                        logic: "and"
                    }, o ? i.filters.push(e) : this._pushFilterExpression(i, e), r(c) && (i.logic === c.logic ? i.filters = i.filters.concat(c.filters) : i.filters.push(c)), a._cascading && this.listView.setDSFilter(i), n = G({}, {
                        page: d ? 1 : u.page(),
                        pageSize: d ? u.options.pageSize : u.pageSize(),
                        sort: u.sort(),
                        filter: u.filter(),
                        group: u.group(),
                        aggregate: u.aggregate()
                    }, {
                        filter: i
                    }), u[t ? "read" : "query"](u._mergeState(n))
                },
                _pushFilterExpression: function(e, t) {
                    r(t) && "" !== t.value && e.filters.push(t)
                },
                _clearFilterExpressions: function(e) {
                    var t, i;
                    if (e.filters) {
                        for (i = 0; i < e.filters.length; i++) "fromFilter" in e.filters[i] && (t = i);
                        isNaN(t) || e.filters.splice(t, 1)
                    }
                },
                _angularElement: function(e, t) {
                    e && this.angular(t, function() {
                        return {
                            elements: e
                        }
                    })
                },
                _renderNoData: function() {
                    var e = this,
                        t = e.noData;
                    t && (this._angularElement(t, "cleanup"), t.children(":first").html(e.noDataTemplate({
                        instance: e
                    })), this._angularElement(t, "compile"))
                },
                _toggleNoData: function(t) {
                    e(this.noData).toggle(t)
                },
                _toggleHeader: function(e) {
                    var t = this.listView.content.prev(F);
                    t.toggle(e)
                },
                _renderFooter: function() {
                    var e = this,
                        t = e.footer;
                    t && (this._angularElement(t, "cleanup"), t.html(e.footerTemplate({
                        instance: e
                    })), this._angularElement(t, "compile"))
                },
                _allowOpening: function() {
                    return this.options.noDataTemplate || this.dataSource.flatView().length
                },
                _initValue: function() {
                    var e = this,
                        t = e.options.value;
                    null !== t ? e.element.val(t) : (t = e._accessor(), e.options.value = t), e._old = t
                },
                _ignoreCase: function() {
                    var e, t = this,
                        i = t.dataSource.reader.model;
                    i && i.fields && (e = i.fields[t.options.dataTextField], e && e.type && "string" !== e.type && (t.options.ignoreCase = !1))
                },
                _focus: function(e) {
                    return this.listView.focus(e)
                },
                _filter: function(e) {
                    var t, i, n = this,
                        a = n.options,
                        s = e.word,
                        r = a.filterFields,
                        l = a.dataTextField;
                    if (r && r.length)
                        for (t = {
                                logic: "or",
                                filters: [],
                                fromFilter: !0
                            }, i = 0; i < r.length; i++) this._pushFilterExpression(t, n._buildExpression(s, r[i]));
                    else t = n._buildExpression(s, l);
                    n._open = e.open, n._filterSource(t)
                },
                _buildExpression: function(e, t) {
                    var i = this,
                        n = i.options,
                        a = n.ignoreCase,
                        s = i.dataSource.options.accentFoldingFiltering;
                    return {
                        value: a ? s ? e.toLocaleLowerCase(s) : e.toLowerCase() : e,
                        field: t,
                        operator: n.filter,
                        ignoreCase: a
                    }
                },
                _clearButton: function() {
                    var t = this,
                        i = t.options.messages.clear;
                    t._clear || (t._clear = e('<span unselectable="on" class="k-icon k-clear-value k-i-close" title="' + i + '"></span>').attr({
                        role: "button",
                        tabIndex: -1
                    })), t.options.clearButton || t._clear.remove(), this._hideClear()
                },
                search: function(t) {
                    var i = this.options;
                    t = "string" == typeof t ? t : this._inputValue(), clearTimeout(this._typingTimeout), (!i.enforceMinLength && !t.length || t.length >= i.minLength) && (this._state = "filter", this.listView && (this.listView._emptySearch = !e.trim(t).length), this._isFilterEnabled() ? this._filter({
                        word: t,
                        open: !0
                    }) : this._searchByWord(t))
                },
                current: function(e) {
                    return this._focus(e)
                },
                items: function() {
                    return this.ul[0].children
                },
                destroy: function() {
                    var e = this,
                        t = e.ns;
                    p.fn.destroy.call(e), e._unbindDataSource(), e.listView.destroy(), e.list.off(t), e.popup.destroy(), e._form && e._form.off("reset", e._resetHandler)
                },
                dataItem: function(i) {
                    var n = this;
                    if (i === t) return n.listView.selectedDataItems()[0];
                    if ("number" != typeof i) {
                        if (n.options.virtual) return n.dataSource.getByUid(e(i).data("uid"));
                        i = e(n.items()).index(i)
                    }
                    return n.dataSource.flatView()[i]
                },
                _activateItem: function() {
                    var e = this.listView.focus();
                    e && this._focused.add(this.filterInput).attr("aria-activedescendant", e.attr("id"))
                },
                _deactivateItem: function() {
                    this._focused.add(this.filterInput).removeAttr("aria-activedescendant")
                },
                _accessors: function() {
                    var e = this,
                        t = e.element,
                        i = e.options,
                        n = c.getter,
                        a = t.attr(c.attr("text-field")),
                        s = t.attr(c.attr("value-field"));
                    !i.dataTextField && a && (i.dataTextField = a), !i.dataValueField && s && (i.dataValueField = s), e._text = n(i.dataTextField), e._value = n(i.dataValueField)
                },
                _aria: function(e) {
                    var i = this,
                        n = i.options,
                        a = i._focused.add(i.filterInput);
                    n.suggest !== t && a.attr("aria-autocomplete", n.suggest ? "both" : "list"), e = e ? e + " " + i.ul[0].id : i.ul[0].id, a.attr("aria-owns", e), i.ul.attr("aria-live", i._isFilterEnabled() ? "polite" : "off"), i._ariaLabel()
                },
                _ariaLabel: function() {
                    var t, i = this,
                        n = i._focused,
                        a = i.element,
                        s = a.attr("id"),
                        r = e('label[for="' + s + '"]'),
                        l = a.attr("aria-label"),
                        o = a.attr("aria-labelledby");
                    n !== a && (l ? n.attr("aria-label", l) : o ? n.attr("aria-labelledby", o) : r.length && (t = r.attr("id") || i._generateLabelId(r, s || c.guid()), n.attr("aria-labelledby", t)))
                },
                _generateLabelId: function(e, t) {
                    var i = t + V;
                    return e.attr("id", i), i
                },
                _blur: function() {
                    var e = this;
                    e._change(), e.close()
                },
                _change: function() {
                    var e, n = this,
                        a = n.selectedIndex,
                        s = n.options.value,
                        r = n.value();
                    n._isSelect && !n.listView.bound() && s && (r = s), r !== i(n._old, typeof r) && r !== i(n._oldText, typeof r) ? e = !0 : n._valueBeforeCascade !== t && n._valueBeforeCascade !== i(n._old, typeof n._valueBeforeCascade) && n._userTriggered ? e = !0 : a === t || a === n._oldIndex || n.listView.isFiltered() || (e = !0), e && (n._valueBeforeCascade = n._old = null === n._old || "" === n._old || "" === r ? r : n.dataItem() ? n.options.dataValueField ? n.dataItem()[n.options.dataValueField] : n.dataItem() : null, n._oldIndex = a, n._oldText = n.text && n.text(), n._typing || n.element.trigger(w), n.trigger(w)), n.typing = !1
                },
                _data: function() {
                    return this.dataSource.view()
                },
                _enable: function() {
                    var e = this,
                        i = e.options,
                        n = e.element.is("[disabled]");
                    i.enable !== t && (i.enabled = i.enable), !i.enabled || n ? e.enable(!1) : e.readonly(e.element.is("[readonly]"))
                },
                _dataValue: function(e) {
                    var i = this._value(e);
                    return i === t && (i = this._text(e)), i
                },
                _offsetHeight: function() {
                    var t = 0,
                        i = this.listView.content.prevAll(":visible");
                    return i.each(function() {
                        var i = e(this);
                        t += h(i, !0)
                    }), t
                },
                _height: function(i) {
                    var n, a, s, r = this,
                        l = r.list,
                        o = r.options.height,
                        u = r.popup.visible();
                    if (i || r.options.noDataTemplate) {
                        if (a = l.add(l.parent(".k-animation-container")).show(), !l.is(":visible")) return a.hide(), t;
                        o = r.listView.content[0].scrollHeight > o ? o : "auto", a.height(o), "auto" !== o && (n = r._offsetHeight(), s = h(e(r.footer)) || 0, o = o - n - s), r.listView.content.height(o), u || a.hide()
                    }
                    return o
                },
                _openHandler: function(e) {
                    this._adjustListWidth(), this.trigger(C) ? e.preventDefault() : (this._focused.attr("aria-expanded", !0), this.ul.attr("aria-hidden", !1))
                },
                _adjustListWidth: function() {
                    var e, t, i = this,
                        n = i.list,
                        a = n[0].style.width,
                        s = i.wrapper;
                    if (n.data(N) || !a) return e = window.getComputedStyle ? window.getComputedStyle(s[0], null) : 0, t = parseFloat(e && e.width) || b(s), e && q.msie && (t += parseFloat(e.paddingLeft) + parseFloat(e.paddingRight) + parseFloat(e.borderLeftWidth) + parseFloat(e.borderRightWidth)), a = "border-box" !== n.css("box-sizing") ? t - (b(n) - n.width()) : t, n.css({
                        fontFamily: s.css("font-family"),
                        width: i.options.autoWidth ? "auto" : a,
                        minWidth: a,
                        whiteSpace: i.options.autoWidth ? "nowrap" : "normal"
                    }).data(N, a), !0
                },
                _closeHandler: function(e) {
                    this.trigger(D) ? e.preventDefault() : (this._focused.attr("aria-expanded", !1), this.ul.attr("aria-hidden", !0))
                },
                _focusItem: function() {
                    var e = this.listView,
                        i = !e.focus(),
                        a = n(e.select());
                    a === t && this.options.highlightFirst && i && (a = 0), a !== t ? e.focus(a) : i && e.scrollToIndex(0)
                },
                _calculateGroupPadding: function(e) {
                    var t = this.ul.children(".k-first:first"),
                        i = this.listView.content.prev(F),
                        n = 0,
                        a = "right";
                    i[0] && "none" !== i[0].style.display && ("auto" !== e && (n = c.support.scrollbar()), this.element.parents(".k-rtl").length && (a = "left"), n += parseFloat(t.css("border-" + a + "-width"), 10) + parseFloat(t.children(".k-group").css("padding-" + a), 10), i.css("padding-" + a, n))
                },
                _calculatePopupHeight: function(e) {
                    var t = this._height(this.dataSource.flatView().length || e);
                    this._calculateGroupPadding(t), this._calculateColumnsHeaderPadding(t)
                },
                _calculateColumnsHeaderPadding: function(e) {
                    var t, i, n;
                    this.options.columns && this.options.columns.length && (t = this, i = g.isRtl(t.wrapper), n = c.support.scrollbar(), t.columnsHeader.css(i ? "padding-left" : "padding-right", "auto" !== e ? n : 0))
                },
                _refreshScroll: function() {
                    var e = this.listView,
                        t = e.element.height() > e.content.height();
                    this.options.autoWidth && e.content.css({
                        overflowX: "hidden",
                        overflowY: t ? "scroll" : "auto"
                    })
                },
                _resizePopup: function(e) {
                    this.options.virtual || (this.popup.element.is(":visible") ? this._calculatePopupHeight(e) : (this.popup.one("open", function(e) {
                        return W(function() {
                            this._calculatePopupHeight(e)
                        }, this)
                    }.call(this, e)), this.popup.one("activate", W(this._refreshScroll, this))))
                },
                _popup: function() {
                    var e = this;
                    e.popup = new d.Popup(e.list, G({}, e.options.popup, {
                        anchor: e.wrapper,
                        open: W(e._openHandler, e),
                        close: W(e._closeHandler, e),
                        animation: e.options.animation,
                        isRtl: g.isRtl(e.wrapper),
                        autosize: e.options.autoWidth
                    }))
                },
                _makeUnselectable: function() {
                    R && this.list.find("*").not(".k-textbox").attr("unselectable", "on")
                },
                _toggleHover: function(t) {
                    e(t.currentTarget).toggleClass(y, "mouseenter" === t.type)
                },
                _toggle: function(e, i) {
                    var n = this,
                        a = g.mobileOS && (g.touch || g.MSPointers || g.pointers);
                    e = e !== t ? e : !n.popup.visible(), i || a || n._focused[0] === v() || (n._prevent = !0, n._focused.focus(), n._prevent = !1), n[e ? C : D]()
                },
                _triggerCascade: function() {
                    var e = this;
                    e._cascadeTriggered && e.value() === i(e._cascadedValue, typeof e.value()) || (e._cascadedValue = e.value(), e._cascadeTriggered = !0, e.trigger(H, {
                        userTriggered: e._userTriggered
                    }))
                },
                _triggerChange: function() {
                    this._valueBeforeCascade !== this.value() && this.trigger(w)
                },
                _unbindDataSource: function() {
                    var e = this;
                    e.dataSource.unbind(P, e._requestStartHandler).unbind(L, e._requestEndHandler).unbind("error", e._errorHandler)
                },
                requireValueMapper: function(e, t) {
                    var i = (e.value instanceof Array ? e.value.length : e.value) || (t instanceof Array ? t.length : t);
                    if (i && e.virtual && "function" != typeof e.virtual.valueMapper) throw Error("ValueMapper is not provided while the value is being set. See http://docs.telerik.com/kendo-ui/controls/editors/combobox/virtualization#the-valuemapper-function")
                }
            });
        G(j, {
            inArray: function(e, t) {
                var i, n, a = t.children;
                if (!e || e.parentNode !== t) return -1;
                for (i = 0, n = a.length; i < n; i++)
                    if (e === a[i]) return i;
                return -1
            },
            unifyType: i
        }), c.ui.List = j, d.Select = j.extend({
            init: function(e, t) {
                j.fn.init.call(this, e, t), this._initial = this.element.val()
            },
            setDataSource: function(e) {
                var t, i = this;
                i.options.dataSource = e, i._dataSource(), i.listView.bound() && (i._initialIndex = null, i.listView._current = null), i.listView.setDataSource(i.dataSource), i.options.autoBind && i.dataSource.fetch(), t = i._parentWidget(), t && i._cascadeSelect(t)
            },
            close: function() {
                this.popup.close()
            },
            select: function(e) {
                var i = this;
                return e === t ? i.selectedIndex : i._select(e).done(function() {
                    i._cascadeValue = i._old = i._accessor(), i._oldIndex = i.selectedIndex
                })
            },
            _accessor: function(e, t) {
                return this[this._isSelect ? "_accessorSelect" : "_accessorInput"](e, t)
            },
            _accessorInput: function(e) {
                var i = this.element[0];
                return e === t ? i.value : (null === e && (e = ""), i.value = e, t)
            },
            _accessorSelect: function(e, i) {
                var n, s = this.element[0];
                return e === t ? a(s).value || "" : (a(s).selected = !1, i === t && (i = -1), n = null !== e && "" !== e, n && i == -1 ? this._custom(e) : e ? s.value = e : s.selectedIndex = i, t)
            },
            _syncValueAndText: function() {
                return !0
            },
            _custom: function(t) {
                var i = this,
                    n = i.element,
                    a = i._customOption;
                a || (a = e("<option/>"), i._customOption = a, n.append(a)), a.text(t), a[0].selected = !0
            },
            _hideBusy: function() {
                var e = this;
                clearTimeout(e._busy), e._arrowIcon.removeClass(T), e._focused.attr("aria-busy", !1), e._busy = null, e._showClear()
            },
            _showBusy: function(e) {
                var t = this;
                e.isDefaultPrevented() || (t._request = !0, t._busy || (t._busy = setTimeout(function() {
                    t._arrowIcon && (t._focused.attr("aria-busy", !0), t._arrowIcon.addClass(T), t._hideClear())
                }, 100)))
            },
            _requestEnd: function() {
                this._request = !1, this._hideBusy()
            },
            _dataSource: function() {
                var t, i = this,
                    n = i.element,
                    a = i.options,
                    s = a.dataSource || {};
                s = e.isArray(s) ? {
                    data: s
                } : s, i._isSelect && (t = n[0].selectedIndex, t > -1 && (a.index = t), s.select = n, s.fields = [{
                    field: a.dataTextField
                }, {
                    field: a.dataValueField
                }]), i.dataSource ? i._unbindDataSource() : (i._requestStartHandler = W(i._showBusy, i), i._requestEndHandler = W(i._requestEnd, i), i._errorHandler = W(i._hideBusy, i)), i.dataSource = c.data.DataSource.create(s).bind(P, i._requestStartHandler).bind(L, i._requestEndHandler).bind("error", i._errorHandler)
            },
            _firstItem: function() {
                this.listView.focusFirst()
            },
            _lastItem: function() {
                this.listView.focusLast()
            },
            _nextItem: function() {
                this.listView.focusNext()
            },
            _prevItem: function() {
                this.listView.focusPrev()
            },
            _move: function(e) {
                var i, n, a, s, r, l, o, u = this,
                    c = u.listView,
                    d = e.keyCode,
                    h = d === _.DOWN;
                if (d === _.UP || h) {
                    if (e.altKey) u.toggle(h);
                    else {
                        if (!c.bound() && !u.ul[0].firstChild) return u._fetch || (u.dataSource.one(w, function() {
                            u._fetch = !1, u._move(e)
                        }), u._fetch = !0, u._filterSource()), e.preventDefault(), !0;
                        if (a = u._focus(), u._fetch || a && !a.hasClass("k-state-selected") || (h ? (u._nextItem(), u._focus() || u._lastItem()) : (u._prevItem(), u._focus() || u._firstItem())), i = c.dataItemByIndex(c.getElementIndex(u._focus())), u.trigger(B, {
                                dataItem: i,
                                item: u._focus()
                            })) return u._focus(a), t;
                        u._select(u._focus(), !0).done(function() {
                            u.popup.visible() || u._blur(), u._cascadedValue = null === u._cascadedValue ? u.value() : u.dataItem() ? u.dataItem()[u.options.dataValueField] || u.dataItem() : null
                        })
                    }
                    e.preventDefault(), n = !0
                } else if (d === _.ENTER || d === _.TAB) {
                    if (u.popup.visible() && e.preventDefault(), a = u._focus(), i = u.dataItem(), u.popup.visible() || i && u.text() === u._text(i) || (a = null), s = u.filterInput && u.filterInput[0] === v(), a) {
                        if (i = c.dataItemByIndex(c.getElementIndex(a)), l = !0, i && (l = u._value(i) !== j.unifyType(u.value(), typeof u._value(i))), l && u.trigger(B, {
                                dataItem: i,
                                item: a
                            })) return;
                        r = u._select(a)
                    } else u.input && ((u._syncValueAndText() || u._isSelect) && u._accessor(u.input.val()), u.listView.value(u.input.val()));
                    u._focusElement && u._focusElement(u.wrapper), s && d === _.TAB ? u.wrapper.focusout() : r && "function" == typeof r.done ? r.done(function() {
                        u._blur()
                    }) : u._blur(), u.close(), n = !0
                } else d === _.ESC ? (u.popup.visible() && e.preventDefault(), u.close(), n = !0) : !u.popup.visible() || d !== _.PAGEDOWN && d !== _.PAGEUP || (e.preventDefault(), o = d === _.PAGEDOWN ? 1 : -1, c.scrollWith(o * c.screenHeight()), n = !0);
                return n
            },
            _fetchData: function() {
                var e = this,
                    t = !!e.dataSource.view().length;
                e._request || e.options.cascadeFrom || e.listView.bound() || e._fetch || t || (e._fetch = !0, e.dataSource.fetch().done(function() {
                    e._fetch = !1
                }))
            },
            _options: function(e, i, n) {
                var s, r, l, o, u = this,
                    c = u.element,
                    d = c[0],
                    h = e.length,
                    f = "",
                    p = 0;
                for (i && (f = i); p < h; p++) s = "<option", r = e[p], l = u._text(r), o = u._value(r), o !== t && (o += "", o.indexOf('"') !== -1 && (o = o.replace(U, "&quot;")), s += ' value="' + o + '"'), s += ">", l !== t && (s += m(l)), s += "</option>", f += s;
                c.html(f), n !== t && (d.value = n, d.value && !n && (d.selectedIndex = -1)), d.selectedIndex !== -1 && (s = a(d), s && s.setAttribute(E, E))
            },
            _reset: function() {
                var t = this,
                    i = t.element,
                    n = i.attr("form"),
                    a = n ? e("#" + n) : i.closest("form");
                a[0] && (t._resetHandler = function() {
                    setTimeout(function() {
                        t.value(t._initial)
                    })
                }, t._form = a.on("reset", t._resetHandler))
            },
            _parentWidget: function() {
                var t, i, n, a = this.options.name;
                if (this.options.cascadeFrom) {
                    if (t = e("#" + this.options.cascadeFrom), i = t.data("kendo" + a), !i)
                        for (n = 0; n < z[a].length && !(i = t.data("kendo" + z[a][n])); n += 1);
                    return i
                }
            },
            _cascade: function() {
                var e, t = this,
                    i = t.options,
                    n = i.cascadeFrom;
                if (n) {
                    if (e = t._parentWidget(), !e) return;
                    t._cascadeHandlerProxy = W(t._cascadeHandler, t), t._cascadeFilterRequests = [], i.autoBind = !1, e.bind("set", function() {
                        t.one("set", function(e) {
                            t._selectedValue = e.value || t._accessor()
                        })
                    }), e.first(H, t._cascadeHandlerProxy), e.listView.bound() ? (t._toggleCascadeOnFocus(), t._cascadeSelect(e)) : (e.one("dataBound", function() {
                        t._toggleCascadeOnFocus(), e.popup.visible() && e._focused.focus()
                    }), e.value() || t.enable(!1))
                }
            },
            _toggleCascadeOnFocus: function() {
                var e = this,
                    t = e._parentWidget();
                t._focused.add(t.filterInput).bind("focus", function() {
                    t.unbind(H, e._cascadeHandlerProxy), t.first(w, e._cascadeHandlerProxy)
                }), t._focused.add(t.filterInput).bind("focusout", function() {
                    t.unbind(w, e._cascadeHandlerProxy), t.first(H, e._cascadeHandlerProxy)
                })
            },
            _cascadeHandler: function(e) {
                var t = this._parentWidget(),
                    i = this.value();
                this._userTriggered = e.userTriggered || t._userTriggered, this.listView.bound() && this._clearSelection(t, !0), this._cascadeSelect(t, i)
            },
            _cascadeChange: function(e) {
                var t = this,
                    n = t._accessor() || t._selectedValue;
                t._cascadeFilterRequests.length || (t._selectedValue = null), t._userTriggered ? t._clearSelection(e, !0) : n ? (n !== i(t.listView.value()[0], typeof n) && t.value(n), t.dataSource.view()[0] && t.selectedIndex !== -1 || t._clearSelection(e, !0)) : t.dataSource.flatView().length && t.select(t.options.index), t.enable(), t._triggerCascade(), t._triggerChange(), t._userTriggered = !1
            },
            _cascadeSelect: function(e, i) {
                var n, a, s = this,
                    r = e.dataItem(),
                    o = r ? r[s.options.cascadeFromParentField] || e._value(r) : null,
                    u = s.options.cascadeFromField || e.options.dataValueField;
                s._valueBeforeCascade = i !== t ? i : s.value(), o || 0 === o ? (n = s.dataSource.filter() || {}, l(n, u), a = function() {
                    var t = s._cascadeFilterRequests.shift();
                    t && s.unbind("dataBound", t), t = s._cascadeFilterRequests[0], t && s.first("dataBound", t), s._cascadeChange(e)
                }, s._cascadeFilterRequests.push(a), 1 === s._cascadeFilterRequests.length && s.first("dataBound", a), s._cascading = !0, s._filterSource({
                    field: u,
                    operator: "eq",
                    value: o
                }), s._cascading = !1) : (s.enable(!1), s._clearSelection(e), s._triggerCascade(), s._triggerChange(), s._userTriggered = !1)
            }
        }), o = ".StaticList", u = c.ui.DataBoundWidget.extend({
            init: function(t, i) {
                p.fn.init.call(this, t, i), this.element.attr("role", "listbox").on("click" + o, "li", W(this._click, this)).on("mouseenter" + o, "li", function() {
                    e(this).addClass(y)
                }).on("mouseleave" + o, "li", function() {
                    e(this).removeClass(y)
                }), g.touch && this._touchHandlers(), "multiple" === this.options.selectable && this.element.attr("aria-multiselectable", !0), this.content = this.element.wrap("<div class='k-list-scroller' unselectable='on'></div>").parent(), this.header = this.content.before('<div class="k-group-header" style="display:none"></div>').prev(), this.bound(!1), this._optionID = c.guid(), this._selectedIndices = [], this._view = [], this._dataItems = [], this._values = [];
                var n = this.options.value;
                n && (this._values = e.isArray(n) ? n.slice(0) : [n]), this._getter(), this._templates(), this.setDataSource(this.options.dataSource), this._onScroll = W(function() {
                    var e = this;
                    clearTimeout(e._scrollId), e._scrollId = setTimeout(function() {
                        e._renderHeader()
                    }, 50)
                }, this)
            },
            options: {
                name: "StaticList",
                dataValueField: null,
                valuePrimitive: !1,
                selectable: !0,
                template: null,
                groupTemplate: null,
                fixedGroupTemplate: null
            },
            events: ["click", w, "activate", "deactivate", "dataBinding", "dataBound", "selectedItemChange"],
            setDataSource: function(t) {
                var i, n = this,
                    a = t || {};
                a = e.isArray(a) ? {
                    data: a
                } : a, a = c.data.DataSource.create(a), n.dataSource ? (n.dataSource.unbind(w, n._refreshHandler), i = n.value(), n.value([]), n.bound(!1), n.value(i)) : n._refreshHandler = W(n.refresh, n), n.setDSFilter(a.filter()), n.dataSource = a.bind(w, n._refreshHandler), n._fixedHeader()
            },
            _touchHandlers: function() {
                var t, i, n = this,
                    a = function(e) {
                        return (e.originalEvent || e).changedTouches[0].pageY
                    };
                n.element.on("touchstart" + o, function(e) {
                    t = a(e)
                }), n.element.on("touchend" + o, function(s) {
                    s.isDefaultPrevented() || (i = a(s), Math.abs(i - t) < 10 && (n._touchTriggered = !0, n._triggerClick(e(s.target).closest(k).get(0))))
                })
            },
            skip: function() {
                return this.dataSource.skip()
            },
            setOptions: function(e) {
                p.fn.setOptions.call(this, e), this._getter(), this._templates(), this._render()
            },
            destroy: function() {
                this.element.off(o), this._refreshHandler && this.dataSource.unbind(w, this._refreshHandler), clearTimeout(this._scrollId), p.fn.destroy.call(this)
            },
            dataItemByIndex: function(e) {
                return this.dataSource.flatView()[e]
            },
            screenHeight: function() {
                return this.content[0].clientHeight
            },
            scrollToIndex: function(e) {
                var t = this.element[0].children[e];
                t && this.scroll(t)
            },
            scrollWith: function(e) {
                this.content.scrollTop(this.content.scrollTop() + e)
            },
            scroll: function(e) {
                if (e) {
                    e[0] && (e = e[0]);
                    var t = this.content[0],
                        i = e.offsetTop,
                        n = e.offsetHeight,
                        a = t.scrollTop,
                        s = t.clientHeight,
                        r = i + n;
                    a > i ? a = i : r > a + s && (a = r - s), t.scrollTop = a
                }
            },
            selectedDataItems: function(e) {
                return e === t ? this._dataItems.slice() : (this._dataItems = e, this._values = this._getValues(e), t)
            },
            _getValues: function(t) {
                var i = this._valueGetter;
                return e.map(t, function(e) {
                    return i(e)
                })
            },
            focusNext: function() {
                var e = this.focus();
                e = e ? e.next() : 0, this.focus(e)
            },
            focusPrev: function() {
                var e = this.focus();
                e = e ? e.prev() : this.element[0].children.length - 1, this.focus(e)
            },
            focusFirst: function() {
                this.focus(this.element[0].children[0])
            },
            focusLast: function() {
                this.focus(n(this.element[0].children))
            },
            focus: function(i) {
                var a, s = this,
                    r = s._optionID;
                return i === t ? s._current : (i = n(s._get(i)), i = e(this.element[0].children[i]), s._current && (s._current.removeClass(S).removeAttr(I), s.trigger("deactivate")), a = !!i[0], a && (i.addClass(S), s.scroll(i), i.attr("id", r)), s._current = a ? i : null, s.trigger("activate"), t)
            },
            focusIndex: function() {
                return this.focus() ? this.focus().index() : t
            },
            skipUpdate: function(e) {
                this._skipUpdate = e
            },
            select: function(i) {
                var a, s, r, l = this,
                    o = l.options.selectable,
                    u = "multiple" !== o && o !== !1,
                    c = l._selectedIndices,
                    d = [this.element.find(".k-state-selected").index()],
                    h = [],
                    f = [];
                return i === t ? c.slice() : (i = l._get(i), 1 === i.length && i[0] === -1 && (i = []), s = e.Deferred().resolve(), r = l.isFiltered(), r && !u && l._deselectFiltered(i) ? s : u && !r && e.inArray(n(i), c) !== -1 && e.inArray(n(i), d) !== -1 ? (l._dataItems.length && l._view.length && (l._dataItems = [l._view[c[0]].item]), s) : (a = l._deselect(i), f = a.removed, i = a.indices, i.length && (u && (i = [n(i)]), h = l._select(i)), (h.length || f.length) && (l._valueComparer = null, l.trigger(w, {
                    added: h,
                    removed: f
                })), s))
            },
            removeAt: function(e) {
                return this._selectedIndices.splice(e, 1), this._values.splice(e, 1), this._valueComparer = null, {
                    position: e,
                    dataItem: this._dataItems.splice(e, 1)[0]
                }
            },
            setValue: function(t) {
                t = e.isArray(t) || t instanceof x ? t.slice(0) : [t], this._values = t, this._valueComparer = null
            },
            value: function(i) {
                var n, a = this,
                    s = a._valueDeferred;
                return i === t ? a._values.slice() : (a.setValue(i), s && "resolved" !== s.state() || (a._valueDeferred = s = e.Deferred()), a.bound() && (n = a._valueIndices(a._values), "multiple" === a.options.selectable && a.select(-1), a.select(n), s.resolve()), a._skipUpdate = !1, s)
            },
            items: function() {
                return this.element.children(k)
            },
            _click: function(e) {
                return this._touchTriggered ? (this._touchTriggered = !1, t) : (e.isDefaultPrevented() || this._triggerClick(e.currentTarget), t)
            },
            _triggerClick: function(t) {
                this.trigger("click", {
                    item: e(t)
                }) || this.select(t)
            },
            _valueExpr: function(e, t) {
                var n, a, s = this,
                    r = 0,
                    l = [];
                if (!s._valueComparer || s._valueType !== e) {
                    for (s._valueType = e; r < t.length; r++) l.push(i(t[r], e));
                    n = "for (var idx = 0; idx < " + l.length + "; idx++) { if (current === values[idx]) {   return idx; }} return -1;", a = Function("current", "values", n), s._valueComparer = function(e) {
                        return a(e, l)
                    }
                }
                return s._valueComparer
            },
            _dataItemPosition: function(e, t) {
                var i = this._valueGetter(e),
                    n = this._valueExpr(typeof i, t);
                return n(i)
            },
            _getter: function() {
                this._valueGetter = c.getter(this.options.dataValueField)
            },
            _deselect: function(t) {
                var i, n, a, s = this,
                    r = s.element[0].children,
                    l = s.options.selectable,
                    o = s._selectedIndices,
                    u = s._dataItems,
                    c = s._values,
                    d = [],
                    h = 0,
                    f = 0;
                if (t = t.slice(), l !== !0 && t.length) {
                    if ("multiple" === l)
                        for (; h < t.length; h++)
                            if (n = t[h], e(r[n]).hasClass("k-state-selected"))
                                for (i = 0; i < o.length; i++)
                                    if (a = o[i], a === n) {
                                        e(r[a]).removeClass("k-state-selected").attr("aria-selected", !1), d.push({
                                            position: i + f,
                                            dataItem: u.splice(i, 1)[0]
                                        }), o.splice(i, 1), t.splice(h, 1), c.splice(i, 1), f += 1, h -= 1, i -= 1;
                                        break
                                    }
                } else {
                    for (; h < o.length; h++) e(r[o[h]]).removeClass("k-state-selected").attr("aria-selected", !1), d.push({
                        position: h,
                        dataItem: u[h]
                    });
                    s._values = [], s._dataItems = [], s._selectedIndices = []
                }
                return {
                    indices: t,
                    removed: d
                }
            },
            _deselectFiltered: function(t) {
                for (var i, n, a, s = this.element[0].children, r = [], l = 0; l < t.length; l++) n = t[l], i = this._view[n].item, a = this._dataItemPosition(i, this._values), a > -1 && (r.push(this.removeAt(a)), e(s[n]).removeClass("k-state-selected"));
                return !!r.length && (this.trigger(w, {
                    added: [],
                    removed: r
                }), !0)
            },
            _select: function(t) {
                var i, a, s = this,
                    r = s.element[0].children,
                    l = s._view,
                    o = [],
                    u = 0;
                for (n(t) !== -1 && s.focus(t); u < t.length; u++) a = t[u], i = l[a], a !== -1 && i && (i = i.item, s._selectedIndices.push(a), s._dataItems.push(i), s._values.push(s._valueGetter(i)), e(r[a]).addClass("k-state-selected").attr("aria-selected", !0), o.push({
                    dataItem: i
                }));
                return o
            },
            getElementIndex: function(t) {
                return e(t).data("offset-index")
            },
            _get: function(e) {
                return "number" == typeof e ? e = [e] : A(e) || (e = this.getElementIndex(e), e = [e !== t ? e : -1]), e
            },
            _template: function() {
                var e = this,
                    t = e.options,
                    i = t.template;
                return i ? (i = c.template(i), i = function(e) {
                    return '<li tabindex="-1" role="option" unselectable="on" class="k-item">' + i(e) + "</li>"
                }) : i = c.template('<li tabindex="-1" role="option" unselectable="on" class="k-item">${' + c.expr(t.dataTextField, "data") + "}</li>", {
                    useWithBlock: !1
                }), i
            },
            _templates: function() {
                var e, t, i, n, a, s = this.options,
                    r = {
                        template: s.template,
                        groupTemplate: s.groupTemplate,
                        fixedGroupTemplate: s.fixedGroupTemplate
                    };
                if (s.columns)
                    for (t = 0; t < s.columns.length; t++) i = s.columns[t], n = i.field ? "" + i.field : "text", r["column" + t] = i.template || "#: " + n + "#";
                for (a in r) e = r[a], e && "function" != typeof e && (r[a] = c.template(e));
                this.templates = r
            },
            _normalizeIndices: function(e) {
                for (var i = [], n = 0; n < e.length; n++) e[n] !== t && i.push(e[n]);
                return i
            },
            _valueIndices: function(e, t) {
                var i, n = this._view,
                    a = 0;
                if (t = t ? t.slice() : [], !e.length) return [];
                for (; a < n.length; a++) i = this._dataItemPosition(n[a].item, e), i !== -1 && (t[i] = a);
                return this._normalizeIndices(t)
            },
            _firstVisibleItem: function() {
                for (var t = this.element[0], i = this.content[0], n = i.scrollTop, a = e(t.children[0]).height(), s = Math.floor(n / a) || 0, r = t.children[s] || t.lastChild, l = r.offsetTop < n; r;)
                    if (l) {
                        if (r.offsetTop + a > n || !r.nextSibling) break;
                        r = r.nextSibling
                    } else {
                        if (r.offsetTop <= n || !r.previousSibling) break;
                        r = r.previousSibling
                    }
                return this._view[e(r).data("offset-index")]
            },
            _fixedHeader: function() {
                this.isGrouped() && this.templates.fixedGroupTemplate ? (this.header.show(), this.content.scroll(this._onScroll)) : (this.header.hide(), this.content.off("scroll", this._onScroll))
            },
            _renderHeader: function() {
                var e, t = this.templates.fixedGroupTemplate;
                t && (e = this._firstVisibleItem(), e && ("" + e.group).length && this.header.html(t(e.group)))
            },
            _renderItem: function(e) {
                var t = '<li tabindex="-1" role="option" unselectable="on" class="k-item',
                    i = e.item,
                    n = 0 !== e.index,
                    a = e.selected,
                    s = this.isGrouped(),
                    r = this.options.columns && this.options.columns.length;
                return n && e.newGroup && (t += " k-first"), e.isLastGroupedItem && r && (t += " k-last"),
                    a && (t += " k-state-selected"), t += '" aria-selected="' + (a ? "true" : "false") + '" data-offset-index="' + e.index + '">', t += r ? this._renderColumns(i) : this.templates.template(i), n && e.newGroup ? t += r ? '<div class="k-cell k-group-cell"><span>' + this.templates.groupTemplate(e.group) + "</span></div>" : '<div class="k-group">' + this.templates.groupTemplate(e.group) + "</div>" : s && r && (t += "<div class='k-cell k-spacer-cell'></div>"), t + "</li>"
            },
            _renderColumns: function(e) {
                var t, i, n, a, s = "";
                for (t = 0; t < this.options.columns.length; t++) i = this.options.columns[t].width, n = parseInt(i, 10), a = "", i && !isNaN(n) && (a += "style='width:", a += n, a += f.test(i) ? "%" : "px", a += ";'"), s += "<span class='k-cell' " + a + ">", s += this.templates["column" + t](e), s += "</span>";
                return s
            },
            _render: function() {
                var e, t, i, n, a = "",
                    s = 0,
                    r = 0,
                    l = [],
                    o = this.dataSource.view(),
                    u = this.value(),
                    c = this.isGrouped();
                if (c)
                    for (s = 0; s < o.length; s++)
                        for (t = o[s], i = !0, n = 0; n < t.items.length; n++) e = {
                            selected: this._selected(t.items[n], u),
                            item: t.items[n],
                            group: t.value,
                            newGroup: i,
                            isLastGroupedItem: n === t.items.length - 1,
                            index: r
                        }, l[r] = e, r += 1, a += this._renderItem(e), i = !1;
                else
                    for (s = 0; s < o.length; s++) e = {
                        selected: this._selected(o[s], u),
                        item: o[s],
                        index: s
                    }, l[s] = e, a += this._renderItem(e);
                this._view = l, this.element[0].innerHTML = a, c && l.length && this._renderHeader()
            },
            _selected: function(e, t) {
                var i = !this.isFiltered() || "multiple" === this.options.selectable;
                return i && this._dataItemPosition(e, t) !== -1
            },
            setDSFilter: function(e) {
                this._lastDSFilter = G({}, e)
            },
            isFiltered: function() {
                return this._lastDSFilter || this.setDSFilter(this.dataSource.filter()), !c.data.Query.compareFilters(this.dataSource.filter(), this._lastDSFilter)
            },
            refresh: function(e) {
                var t, i = this,
                    n = e && e.action,
                    a = i.options.skipUpdateOnBind,
                    r = "itemchange" === n;
                i.trigger("dataBinding"), i._angularItems("cleanup"), i._fixedHeader(), i._render(), i.bound(!0), r || "remove" === n ? (t = s(i._dataItems, e.items), t.changed.length && (r ? i.trigger("selectedItemChange", {
                    items: t.changed
                }) : i.value(i._getValues(t.unchanged)))) : i.isFiltered() || i._skipUpdate || i._emptySearch ? (i.focus(0), i._skipUpdate && (i._skipUpdate = !1, i._selectedIndices = i._valueIndices(i._values, i._selectedIndices))) : a || n && "add" !== n || i.value(i._values), i._valueDeferred && i._valueDeferred.resolve(), i._angularItems("compile"), i.trigger("dataBound")
            },
            bound: function(e) {
                return e === t ? this._bound : (this._bound = e, t)
            },
            isGrouped: function() {
                return (this.dataSource.group() || []).length
            }
        }), d.plugin(u)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, i) {
    (i || t)()
});;
! function(e, define) {
    define("kendo.autocomplete.min", ["kendo.list.min", "kendo.mobile.scroller.min", "kendo.virtuallist.min"], e)
}(function() {
    return function(e, t) {
        function s(e, t, s) {
            return s ? t.substring(0, e).split(s).length - 1 : 0
        }

        function i(e, t, i) {
            return t.split(i)[s(e, t, i)]
        }

        function o(e, t, i, o, a) {
            var n = t.split(o);
            return n.splice(s(e, t, o), 1, i), o && "" !== n[n.length - 1] && n.push(""), n.join(a)
        }
        var a = window.kendo,
            n = a.support,
            r = a.caret,
            l = a._activeElement,
            c = n.placeholder,
            u = a.ui,
            p = u.List,
            d = a.keys,
            _ = a.data.DataSource,
            h = "aria-disabled",
            f = "aria-readonly",
            g = "change",
            v = "k-state-default",
            m = "disabled",
            y = "readonly",
            w = "k-state-focused",
            C = "k-state-selected",
            b = "k-state-disabled",
            x = "off",
            k = "k-state-hover",
            T = ".kendoAutoComplete",
            V = "mouseenter" + T + " mouseleave" + T,
            S = e.proxy,
            L = p.extend({
                init: function(t, s) {
                    var i, o, n = this;
                    n.ns = T, s = e.isArray(s) ? {
                        dataSource: s
                    } : s, p.fn.init.call(n, t, s), t = n.element, s = n.options, s.placeholder = s.placeholder || t.attr("placeholder"), c && t.attr("placeholder", s.placeholder), n._wrapper(), n._loader(), n._clearButton(), n._dataSource(), n._ignoreCase(), t[0].type = "text", i = n.wrapper, n._popup(), t.addClass("k-input").on("keydown" + T, S(n._keydown, n)).on("keypress" + T, S(n._keypress, n)).on("input" + T, S(n._search, n)).on("paste" + T, S(n._search, n)).on("focus" + T, function() {
                        n._prev = n._accessor(), n._oldText = n._prev, n._placeholder(!1), i.addClass(w)
                    }).on("focusout" + T, function() {
                        n._change(), n._placeholder(), n.close(), i.removeClass(w)
                    }).attr({
                        autocomplete: x,
                        role: "textbox",
                        "aria-haspopup": !0
                    }), n._clear.on("click" + T + " touchend" + T, S(n._clearValue, n)), n._enable(), n._old = n._accessor(), t[0].id && t.attr("aria-owns", n.ul[0].id), n._aria(), n._placeholder(), n._initList(), o = e(n.element).parents("fieldset").is(":disabled"), o && n.enable(!1), n.listView.bind("click", function(e) {
                        e.preventDefault()
                    }), n._resetFocusItemHandler = e.proxy(n._resetFocusItem, n), a.notify(n), n._toggleCloseVisibility()
                },
                options: {
                    name: "AutoComplete",
                    enabled: !0,
                    suggest: !1,
                    template: "",
                    groupTemplate: "#:data#",
                    fixedGroupTemplate: "#:data#",
                    dataTextField: "",
                    minLength: 1,
                    enforceMinLength: !1,
                    delay: 200,
                    height: 200,
                    filter: "startswith",
                    ignoreCase: !0,
                    highlightFirst: !1,
                    separator: null,
                    placeholder: "",
                    animation: {},
                    virtual: !1,
                    value: null,
                    clearButton: !0,
                    autoWidth: !1,
                    popup: null
                },
                _dataSource: function() {
                    var e = this;
                    e.dataSource && e._refreshHandler ? e._unbindDataSource() : (e._progressHandler = S(e._showBusy, e), e._errorHandler = S(e._hideBusy, e)), e.dataSource = _.create(e.options.dataSource).bind("progress", e._progressHandler).bind("error", e._errorHandler)
                },
                setDataSource: function(e) {
                    this.options.dataSource = e, this._dataSource(), this.listView.setDataSource(this.dataSource)
                },
                events: ["open", "close", g, "select", "filtering", "dataBinding", "dataBound"],
                setOptions: function(e) {
                    var t = this._listOptions(e);
                    p.fn.setOptions.call(this, e), this.listView.setOptions(t), this._accessors(), this._aria(), this._clearButton()
                },
                _listOptions: function(t) {
                    var s = p.fn._listOptions.call(this, e.extend(t, {
                        skipUpdateOnBind: !0
                    }));
                    return s.dataValueField = s.dataTextField, s.selectedItemChange = null, s
                },
                _editable: function(e) {
                    var t = this,
                        s = t.element,
                        i = t.wrapper.off(T),
                        o = e.readonly,
                        a = e.disable;
                    o || a ? (i.addClass(a ? b : v).removeClass(a ? v : b), s.attr(m, a).attr(y, o).attr(h, a).attr(f, o)) : (i.addClass(v).removeClass(b).on(V, t._toggleHover), s.removeAttr(m).removeAttr(y).attr(h, !1).attr(f, !1))
                },
                close: function() {
                    var e = this,
                        t = e.listView.focus();
                    t && t.removeClass(C), e.popup.close()
                },
                destroy: function() {
                    var e = this;
                    e.element.off(T), e._clear.off(T), e.wrapper.off(T), p.fn.destroy.call(e)
                },
                refresh: function() {
                    this.listView.refresh()
                },
                select: function(e) {
                    this._select(e)
                },
                search: function(t) {
                    var s, o = this,
                        a = o.options,
                        n = a.ignoreCase,
                        l = o._separator(),
                        c = o.dataSource.options.accentFoldingFiltering;
                    t = t || o._accessor(), clearTimeout(o._typingTimeout), l && (t = i(r(o.element)[0], t, l)), s = t.length, (!a.enforceMinLength && !s || s >= a.minLength) && (o._open = !0, o._mute(function() {
                        this.listView.value([])
                    }), o._filterSource({
                        value: n ? c ? t.toLocaleLowerCase(c) : t.toLowerCase() : t,
                        operator: a.filter,
                        field: a.dataTextField,
                        ignoreCase: n
                    }), o.one("close", e.proxy(o._unifySeparators, o))), o._toggleCloseVisibility()
                },
                suggest: function(e) {
                    var i, o = this,
                        a = o._last,
                        n = o._accessor(),
                        c = o.element[0],
                        u = r(c)[0],
                        _ = o._separator(),
                        h = n.split(_),
                        f = s(u, n, _),
                        g = u,
                        v = o.dataSource.options.accentFoldingFiltering;
                    return a == d.BACKSPACE || a == d.DELETE ? (o._last = t, t) : (e = e || "", "string" != typeof e && (e[0] && (e = o.dataSource.view()[p.inArray(e[0], o.ul[0])]), e = e ? o._text(e) : ""), u <= 0 && (u = (v ? n.toLocaleLowerCase(v) : n.toLowerCase()).indexOf(v ? e.toLocaleLowerCase(v) : e.toLowerCase()) + 1), i = n.substring(0, u).lastIndexOf(_), i = i > -1 ? u - (i + _.length) : u, n = h[f].substring(0, i), e && (e = "" + e, i = (v ? e.toLocaleLowerCase(v) : e.toLowerCase()).indexOf(v ? n.toLocaleLowerCase(v) : n.toLowerCase()), i > -1 && (e = e.substring(i + n.length), g = u + e.length, n += e), _ && "" !== h[h.length - 1] && h.push("")), h[f] = n, o._accessor(h.join(_ || "")), c === l() && r(c, u, g), t)
                },
                value: function(e) {
                    return e === t ? this._accessor() : (this.listView.value(e), this._accessor(e), this._old = this._accessor(), this._oldText = this._accessor(), this._toggleCloseVisibility(), t)
                },
                _click: function(e) {
                    var s = e.item,
                        i = this,
                        o = i.element,
                        a = i.listView.dataItemByIndex(i.listView.getElementIndex(s));
                    return e.preventDefault(), i._active = !0, i.trigger("select", {
                        dataItem: a,
                        item: s
                    }) ? (i.close(), t) : (i._oldText = o.val(), i._select(s).done(function() {
                        i._blur(), r(o, o.val().length)
                    }), t)
                },
                _clearText: e.noop,
                _resetFocusItem: function() {
                    var e = this.options.highlightFirst ? 0 : -1;
                    this.options.virtual && this.listView.scrollTo(0), this.listView.focus(e)
                },
                _listBound: function() {
                    var e, s = this,
                        i = s.popup,
                        o = s.options,
                        a = s.dataSource.flatView(),
                        n = a.length,
                        r = s.dataSource._group.length,
                        c = s.element[0] === l();
                    s._renderFooter(), s._renderNoData(), s._toggleNoData(!n), s._toggleHeader(!!r && !!n), s._resizePopup(), i.position(), n && o.suggest && c && s.suggest(a[0]), s._open && (s._open = !1, e = s._allowOpening() ? "open" : "close", s._typingTimeout && !c && (e = "close"), n && (s._resetFocusItem(), o.virtual && s.popup.unbind("activate", s._resetFocusItemHandler).one("activate", s._resetFocusItemHandler)), i[e](), s._typingTimeout = t), s._touchScroller && s._touchScroller.reset(), s._hideBusy(), s._makeUnselectable(), s.trigger("dataBound")
                },
                _mute: function(e) {
                    this._muted = !0, e.call(this), this._muted = !1
                },
                _listChange: function() {
                    var e = this._active || this.element[0] === l();
                    e && !this._muted && this._selectValue(this.listView.selectedDataItems()[0])
                },
                _selectValue: function(e) {
                    var t = this._separator(),
                        s = "";
                    e && (s = this._text(e)), null === s && (s = ""), t && (s = o(r(this.element)[0], this._accessor(), s, t, this._defaultSeparator())), this._prev = s, this._accessor(s), this._placeholder()
                },
                _unifySeparators: function() {
                    return this._accessor(this.value().split(this._separator()).join(this._defaultSeparator())), this
                },
                _preselect: function(e, t) {
                    this._inputValue(t), this._accessor(e), this._old = this.oldText = this._accessor(), this.listView.setValue(e), this._placeholder()
                },
                _change: function() {
                    var e = this,
                        t = e._unifySeparators().value(),
                        s = t !== p.unifyType(e._old, typeof t),
                        i = s && !e._typing,
                        o = e._oldText !== t;
                    e._old = t, e._oldText = t, (i || o) && e.element.trigger(g), s && e.trigger(g), e.typing = !1, e._toggleCloseVisibility()
                },
                _accessor: function(e) {
                    var s = this,
                        i = s.element[0];
                    return e === t ? (e = i.value, i.className.indexOf("k-readonly") > -1 && e === s.options.placeholder ? "" : e) : (i.value = null === e ? "" : e, s._placeholder(), t)
                },
                _keydown: function(e) {
                    var t, s, i = this,
                        o = e.keyCode,
                        a = i.listView,
                        n = i.popup.visible(),
                        r = a.focus();
                    if (i._last = o, o === d.DOWN) n ? this._move(r ? "focusNext" : "focusFirst") : i.value() && i._filterSource({
                        value: i.ignoreCase ? i.value().toLowerCase() : i.value(),
                        operator: i.options.filter,
                        field: i.options.dataTextField,
                        ignoreCase: i.ignoreCase
                    }).done(function() {
                        i._allowOpening() && (i._resetFocusItem(), i.popup.open())
                    }), e.preventDefault();
                    else if (o === d.UP) n && this._move(r ? "focusPrev" : "focusLast"), e.preventDefault();
                    else if (o === d.HOME) this._move("focusFirst");
                    else if (o === d.END) this._move("focusLast");
                    else if (o === d.ENTER || o === d.TAB) {
                        if (o === d.ENTER && n && e.preventDefault(), n && r) {
                            if (t = a.dataItemByIndex(a.getElementIndex(r)), i.trigger("select", {
                                    dataItem: t,
                                    item: r
                                })) return;
                            this._select(r)
                        }
                        this._blur()
                    } else o === d.ESC ? (n ? e.preventDefault() : i._clearValue(), i.close()) : !i.popup.visible() || o !== d.PAGEDOWN && o !== d.PAGEUP ? (i.popup._hovered = !0, i._search()) : (e.preventDefault(), s = o === d.PAGEDOWN ? 1 : -1, a.scrollWith(s * a.screenHeight()))
                },
                _keypress: function() {
                    this._oldText = this.element.val(), this._typing = !0
                },
                _move: function(e) {
                    this.listView[e](), this.options.suggest && this.suggest(this.listView.focus())
                },
                _hideBusy: function() {
                    var e = this;
                    clearTimeout(e._busy), e._loading.hide(), e.element.attr("aria-busy", !1), e._busy = null, e._showClear()
                },
                _showBusy: function() {
                    var e = this;
                    e._busy || (e._busy = setTimeout(function() {
                        e.element.attr("aria-busy", !0), e._loading.show(), e._hideClear()
                    }, 100))
                },
                _placeholder: function(e) {
                    if (!c) {
                        var s, i = this,
                            o = i.element,
                            a = i.options.placeholder;
                        if (a) {
                            if (s = o.val(), e === t && (e = !s), e || (a = s !== a ? s : ""), s === i._old && !e) return;
                            o.toggleClass("k-readonly", e).val(a), a || o[0] !== document.activeElement || r(o[0], 0, 0)
                        }
                    }
                },
                _separator: function() {
                    var e = this.options.separator;
                    return e instanceof Array ? RegExp(e.join("|"), "gi") : e
                },
                _defaultSeparator: function() {
                    var e = this.options.separator;
                    return e instanceof Array ? e[0] : e
                },
                _inputValue: function() {
                    return this.element.val()
                },
                _search: function() {
                    var e = this;
                    clearTimeout(e._typingTimeout), e._typingTimeout = setTimeout(function() {
                        e._prev !== e._accessor() && (e._prev = e._accessor(), e.search())
                    }, e.options.delay)
                },
                _select: function(e) {
                    var t = this;
                    return t._active = !0, t.listView.select(e).done(function() {
                        t._active = !1
                    })
                },
                _loader: function() {
                    this._loading = e('<span class="k-icon k-i-loading" style="display:none"></span>').insertAfter(this.element)
                },
                _clearButton: function() {
                    p.fn._clearButton.call(this), this.options.clearButton && (this._clear.insertAfter(this.element), this.wrapper.addClass("k-autocomplete-clearable"))
                },
                _toggleHover: function(t) {
                    e(t.currentTarget).toggleClass(k, "mouseenter" === t.type)
                },
                _toggleCloseVisibility: function() {
                    this.value() ? this._showClear() : this._hideClear()
                },
                _wrapper: function() {
                    var t, s = this,
                        i = s.element,
                        o = i[0];
                    t = i.parent(), t.is("span.k-widget") || (t = i.wrap("<span />").parent()), t.attr("tabindex", -1), t.attr("role", "presentation"), t[0].style.cssText = o.style.cssText, i.css({
                        width: "",
                        height: o.style.height
                    }), s._focused = s.element, s.wrapper = t.addClass("k-widget k-autocomplete").addClass(o.className), s._inputWrapper = e(t[0])
                },
                _clearValue: function() {
                    p.fn._clearValue.call(this), this.element.focus()
                }
            });
        u.plugin(L)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, s) {
    (s || t)()
});;
! function(e, define) {
    define("kendo.breadcrumb.min", ["kendo.core.min"], e)
}(function() {
    return function(e, t) {
        var i = window.kendo,
            r = i.ui.Widget,
            n = e.extend,
            o = e.isPlainObject,
            a = e.proxy,
            s = ".kendoBreadcrumb",
            l = "aria-hidden",
            p = "aria-label",
            d = "click",
            c = "focus",
            u = "blur",
            m = "keydown",
            h = "change",
            f = ".",
            v = {
                widget: "k-widget k-breadcrumb",
                overlay: "k-breadcrumb-container",
                textbox: "k-textbox",
                link: "k-breadcrumb-link",
                item: "k-breadcrumb-item",
                delimiter: "k-breadcrumb-delimiter-icon",
                rootItem: "k-breadcrumb-root-item",
                rootLink: "k-breadcrumb-root-link",
                overflowIcon: "k-breadcrumb-overflow-icon",
                focused: "k-state-focused",
                hidden: "k-hidden",
                inputWrapper: "k-breadcrumb-input-container"
            },
            w = r.extend({
                init: function(e, t) {
                    var n = this;
                    t = t || {}, r.fn.init.call(n, e, t), n._wrapper(), t.editable && (n._editable(), n._tabindex()), n.wrapper.on(d + s, "a:not(.k-state-disabled)", a(n._click, n)), t.value || t.bindToLocation || !t.items ? n._value() : t.items && n.items(t.items), n._resizeHandler = i.onResize(function() {
                        n.resize(!0)
                    })
                },
                options: {
                    editable: !1,
                    navigational: !1,
                    bindToLocation: !1,
                    items: null,
                    name: "Breadcrumb",
                    gap: 0,
                    rootIcon: "home",
                    delimiterIcon: "arrow-chevron-right",
                    messages: {
                        rootTitle: "Go to root"
                    }
                },
                events: [h, d],
                destroy: function() {
                    var e = this;
                    r.fn.destroy.call(e), i.unbindResize(e._resizeHandler), e.wrapper.add(e.wrapper.find("input")).add(e.wrapper.find("a")).off(s)
                },
                items: function(e) {
                    var i = this;
                    return e === t ? i.options.items : (i.options.items = e, i._segments = e, i.refresh(), t)
                },
                _update: function(e) {
                    var t = this;
                    e !== t.value() && (t._generateSegments(e), t.refresh(), t.trigger(h, {
                        sender: this,
                        value: e
                    }))
                },
                _generateSegments: function(e) {
                    var i, r, n = this,
                        o = n.options,
                        a = o.items,
                        s = n._split(e);
                    if (!a) return n.options.items = n._segments = s, t;
                    for (n._segments = [], r = 0; r < s.length; r++) i = n._path(a.slice(0, r + 1)), n._segments.push("" !== i && e.indexOf(i) > -1 && a[r] && a[r].text === s[r] ? a[r] : s[r])
                },
                _click: function(t) {
                    var i = this,
                        r = i.options,
                        n = e(t.target).closest(f + v.item),
                        o = n.prevAll().addBack(),
                        a = i._getItems(o),
                        s = i._path(a),
                        l = i._segments[n.index()];
                    r.navigational || t.preventDefault(), i.trigger(d, {
                        sender: i,
                        originalEvent: t,
                        isRoot: "rootitem" === l.type,
                        item: l
                    }) || i._update(s)
                },
                _getItems: function(t) {
                    var i = this;
                    return e.map(t, function(t) {
                        return i._segments[e(t).index()] || t.innerText
                    })
                },
                _edit: function() {
                    var e = this,
                        t = e.input;
                    e.oldValue = e.value(), e.inputWrapper.css("height", e.wrapper.height()), e.overlay.hide(), e.input.val(e.value()), e.input.attr(l, !1), e.inputWrapper.show(), setTimeout(function() {
                        t.select()
                    })
                },
                _blur: function(e) {
                    var t = this,
                        i = t.input,
                        r = t.inputWrapper,
                        n = t.wrapper,
                        o = t.overlay,
                        a = i.val().replace(/\/{2,}/g, "/");
                    o.is(":visible") || (e && (a = t.oldValue), i.attr(l, !0), r.hide(), o.show(), i.val(""), t._update(a), n.removeClass(v.focused))
                },
                _keydown: function(e) {
                    var t = this,
                        r = e.keyCode,
                        n = r === i.keys.ENTER,
                        o = r === i.keys.ESC;
                    (n || o) && (t._blur(o), setTimeout(function() {
                        t.overlay.find("a:first").focus()
                    }))
                },
                isNavigational: function(e) {
                    var t = e.hasClass(v.textbox) || e.closest(f + v.item);
                    return e[0] !== this.wrapper[0] && (t && !e.hasClass("k-breadcrumb-last-item"))
                },
                _wrapperKeydown: function(t) {
                    var r = this,
                        n = e(t.target),
                        o = r.isNavigational(n);
                    t.keyCode !== i.keys.ENTER || o || r._edit()
                },
                _wrapperClick: function(t) {
                    var i = this,
                        r = e(t.target),
                        n = i.isNavigational(r);
                    n || this._edit()
                },
                _wrapperFocus: function(t) {
                    e(t.target).addClass(v.focused)
                },
                _wrapperBlur: function(t) {
                    e(t.target).removeClass(v.focused)
                },
                _wrapper: function() {
                    var t = this,
                        i = this.element,
                        r = i.is("input");
                    t.wrapper = r ? i.wrap(e("<nav />")).parent() : i, r ? (t.element.wrap(e("<div />").addClass(v.inputWrapper)).addClass(v.textbox).parent().hide(), t.inputWrapper = t.wrapper.find(f + v.inputWrapper)) : t.inputWrapper = t.wrapper.append(e("<div />").addClass(v.inputWrapper)).find(f + v.inputWrapper).hide(), t.wrapper.addClass(v.widget), t.wrapper.attr(p, "Breadcrumb"), t.overlay = t.wrapper.append(e("<ol />").addClass(v.overlay)).find(f + v.overlay)
                },
                _editable: function() {
                    var t = this,
                        i = t.element,
                        r = i.is("input");
                    t.input = r ? t.element : e("<input />"), t.inputWrapper.append(t.input), t.input.addClass(v.textbox).attr(l, !0), t.input.on(u + s, a(t._blur, t, !1)).on(m + s, a(t._keydown, t)), t.wrapper.on(c + s, a(t._wrapperFocus, t)).on(u + s, a(t._wrapperBlur, t)).on(m + s, a(t._wrapperKeydown, t)).on(d + s, a(t._wrapperClick, t))
                },
                _value: function() {
                    var e = this,
                        t = e.options;
                    e.value(t.value ? t.value : t.bindToLocation ? window.location.href.replace(/http(s?):\/\//, "").replace(/\/$/, "") : "")
                },
                _split: function(e) {
                    return e.split("/").filter(function(e, t) {
                        return !(t > 0 && "" === e)
                    })
                },
                isRtl: function() {
                    return i.support.isRtl(this.wrapper)
                },
                refresh: function() {
                    var r, a, s, l, p = this,
                        d = p.options,
                        c = d.messages,
                        u = p.options.delimiterIcon,
                        m = "",
                        h = "",
                        f = "" === p.value(),
                        w = p._segments;
                    for ("arrow-chevron-right" == u && p.isRtl() && (u = "arrow-chevron-left"), a = 0, s = w.length; a < s; a++) r = w[a], l = a === w.length - 1, r !== t && (m ? h += r.text || r || "" : h = "/", "string" == typeof r ? (r = {
                        type: m ? "item" : "rootitem",
                        href: d.navigational ? h : "#",
                        text: r,
                        showIcon: !m,
                        showText: !!m,
                        icon: m ? "" : d.rootIcon,
                        itemClass: m ? "" : "k-breadcrumb-root-item",
                        linkClass: m ? "" : v.rootLink,
                        delimiterIcon: u,
                        renderDelimiter: !l && !f,
                        lastSegment: l,
                        iconClass: ""
                    }, p._segments.splice(a, 1, r)) : o(r) && (r = n({}, r, {
                        type: r.type ? r.type.toLowerCase() : "item"
                    }), r = n({}, r, {
                        text: r.text || "",
                        title: r.text || "",
                        icon: r.icon || ("rootitem" === r.type ? d.rootIcon : ""),
                        iconClass: r.iconClass || "",
                        lastSegment: l,
                        renderDelimiter: !l && w.length > 1,
                        href: d.navigational ? r.href : "#",
                        delimiterIcon: u,
                        itemClass: r.itemClass || "",
                        linkClass: r.linkClass || "",
                        showIcon: r.showIcon === t ? "rootitem" === r.type && "item" !== r.type : r.showIcon,
                        showText: r.showText === t ? "item" === r.type && "rootitem" !== r.type : r.showText
                    }), "rootitem" === r.type && (r.itemClass += " k-breadcrumb-root-item", r.linkClass += " " + v.rootLink)), "rootitem" === r.type && "" === r.text && (r.title = c.rootTitle), h += h.match(/\/$/) ? "" : "/", m += i.template(this.itemTemplate)(r));
                    this.overlay.empty().append(e(m)), this.resize(!0)
                },
                itemTemplate: '<li class="k-breadcrumb-item #:itemClass# #if(lastSegment){#k-breadcrumb-last-item#}#"><a href="#:href#" class="#:linkClass# #if(type !== "rootitem"){# k-breadcrumb-link#}##if(showText && showIcon){# k-breadcrumb-icontext-link#}##if(showIcon && !showText){# k-breadcrumb-icon-link#}##if(lastSegment && type !== "rootitem"){# k-state-disabled#}#"#if(lastSegment){# aria-current="page"#}# title="#:text || title#">#if(showIcon) {#<span class="#if(icon){#k-icon k-i-#:icon##}# #:iconClass#"></span>#}##if(showText) {##:text##}#</a>#if(renderDelimiter) {#<span class="k-breadcrumb-delimiter-icon k-icon k-i-#:delimiterIcon#" aria-hidden="true"></span>#}##if(type === "rootitem" && renderDelimiter) {#<span class="k-breadcrumb-delimiter-icon k-hidden k-icon k-i-#:delimiterIcon#" aria-hidden="true"></span>#}#</li>',
                _displayOverflowIcons: function(e) {
                    var t = this,
                        i = t.wrapper.find(f + v.rootItem);
                    e ? i.find(f + v.delimiter).addClass(v.overflowIcon).removeClass(v.hidden) : i.find(f + v.overflowIcon).removeClass(v.overflowIcon).last().addClass(v.hidden)
                },
                _shrinkItems: function() {
                    var t, r, n = this,
                        o = n.wrapper,
                        a = n.overlay,
                        s = n.overlay.find(f + v.item + ":visible:not(.k-breadcrumb-root-item)"),
                        l = o.width() - n.options.gap;
                    if (1 != s.length)
                        for (r = 0; r < s.length; r += 1)
                            if (t = e(s[r]), i._outerWidth(a) >= l) {
                                if (r == s.length - 1) break;
                                t.hide(), n._displayOverflowIcons(!0)
                            }
                },
                _showItem: function(e, t, r) {
                    return !!(e.length && r > t + i._outerWidth(e, !0)) && (e.show(), !0)
                },
                _stretchItems: function() {
                    var t, r, n, o = this,
                        a = o.wrapper,
                        s = o.overlay,
                        l = o.overlay.find(f + v.item + ":hidden:not(.k-breadcrumb-root-item)"),
                        p = a.width() - o.options.gap;
                    for (l.length || o._displayOverflowIcons(!1), n = l.length - 1; n >= 0 && (t = e(l[n]), r = i._outerWidth(s), !(r > p) && this._showItem(t, r, p)); n--);
                },
                _resize: function() {
                    this._shrinkItems(), this._stretchItems()
                },
                getSize: function() {
                    return i.dimensions(this.wrapper)
                },
                value: function(e) {
                    var i = this;
                    return e !== t ? (i._generateSegments(e), i.refresh(), t) : i._path(i._segments)
                },
                _path: function(t) {
                    return e.map(t, function(e) {
                        var t = o(e) ? e.text : e;
                        return "/" === t ? "" : t
                    }).join("/")
                }
            });
        i.ui.plugin(w)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, i) {
    (i || t)()
});;
! function(e, define) {
    define("kendo.badge.min", ["kendo.core.min"], e)
}(function() {
    return function(e, n) {
        var t = window.kendo,
            i = t.ui.Widget,
            a = t.ui,
            l = "k-badge-primary",
            o = "k-badge-secondary",
            s = "k-badge-info",
            d = "k-badge-success",
            r = "k-badge-warning",
            u = "k-badge-error",
            c = "k-badge-outline",
            m = "k-badge-pill",
            f = "function",
            p = "string",
            g = i.extend({
                init: function(a, l) {
                    var o, s = this;
                    i.fn.init.call(s, a, l), l = e.extend(!0, {}, l), o = l.type || "primary", s.element = e(a).addClass("k-badge").addClass(s.classPerType[o]), "outline" == l.look && s.element.addClass(c), "rectangle" != l.appearance && s.element.addClass(m), n === l.visible || l.visible || s.element.hide(), s._setInitialValue(), t.notify(s)
                },
                options: {
                    name: "Badge",
                    value: "",
                    visible: !0,
                    appearance: "rectangle",
                    template: null,
                    type: "secondary",
                    look: null
                },
                classPerType: {
                    primary: l,
                    info: s,
                    success: d,
                    warning: r,
                    error: u,
                    secondary: o
                },
                value: function(e) {
                    var i = this;
                    return e ? (i.element.html(t.htmlEncode(i._createContent(e))), i._value = e, n) : i._value
                },
                _createContent: function(e) {
                    var n, i = this.options.template,
                        a = typeof i;
                    return n = a == f ? i(e) : a === p ? t.template(i)({
                        value: e
                    }) : e
                },
                _setInitialValue: function() {
                    var e = this,
                        n = e.options.value || e.element.html();
                    /\S/.test(n) || (n = ""), e._value = n, e.element.html(t.htmlEncode(e._createContent(n)))
                },
                hide: function() {
                    this.element.hide()
                },
                show: function() {
                    this.element.show()
                },
                setOptions: function(e) {
                    var n = this;
                    n.element.removeClass(function(e, t) {
                        t.indexOf("k-") >= 0 && n.element.removeClass(t)
                    }), n.init(n.element, e)
                }
            });
        a.plugin(g)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, n, t) {
    (t || n)()
});;
! function(e, define) {
    define("kendo.button.min", ["kendo.core.min", "kendo.badge.min"], e)
}(function() {
    return function(e, n) {
        var t = window.kendo,
            o = t.ui.Widget,
            a = t.ui,
            i = e.proxy,
            s = t.keys,
            l = "click",
            d = t.support.mousedown,
            r = t.support.mouseup,
            c = "mouseout",
            u = "k-button",
            p = "k-button-icon",
            f = "k-button-icontext",
            b = ".kendoButton",
            k = "disabled",
            m = "k-state-disabled",
            v = "k-state-focused",
            g = "k-state-active",
            h = "k-badge-overlay",
            C = o.extend({
                init: function(e, n) {
                    var a = this;
                    o.fn.init.call(a, e, n), e = a.wrapper = a.element, n = a.options, e.addClass(u).attr("role", "button"), n.enable = n.enable && n.enabled && !e.attr(k), a.enable(n.enable), n.enable && a._tabindex(), n.badge && a.createBadge(n.badge), a.iconElement(), e.on(l + b, i(a._click, a)).on("focus" + b, i(a._focus, a)).on("blur" + b, i(a._blur, a)).on("keydown" + b, i(a._keydown, a)).on("keyup" + b, i(a._removeActive, a)).on(d + b, i(a._addActive, a)).on(r + b + " " + c + b, i(a._removeActive, a)), t.notify(a)
                },
                destroy: function() {
                    var e = this;
                    e.wrapper.off(b), e.badge && e.badge.destroy(), o.fn.destroy.call(e)
                },
                events: [l],
                options: {
                    name: "Button",
                    icon: "",
                    iconClass: "",
                    spriteCssClass: "",
                    imageUrl: "",
                    enable: !0,
                    enabled: !0
                },
                _isNativeButton: function() {
                    return "button" == this.element.prop("tagName").toLowerCase()
                },
                _click: function(e) {
                    this.options.enable && this.trigger(l, {
                        event: e
                    }) && e.preventDefault()
                },
                _focus: function() {
                    this.options.enable && this.element.addClass(v)
                },
                _blur: function() {
                    var e = this;
                    e.element.removeClass(v), setTimeout(function() {
                        e.element.removeClass(g)
                    })
                },
                _keydown: function(e) {
                    var n = this;
                    e.keyCode != s.ENTER && e.keyCode != s.SPACEBAR || (n._addActive(), n._isNativeButton() || (e.keyCode == s.SPACEBAR && e.preventDefault(), n._click(e)))
                },
                _removeActive: function() {
                    this.element.removeClass(g)
                },
                _addActive: function() {
                    this.options.enable && this.element.addClass(g)
                },
                iconElement: function() {
                    var n, t, o, a = this,
                        i = a.element,
                        s = a.options,
                        l = s.icon,
                        d = s.iconClass,
                        r = s.spriteCssClass,
                        c = s.imageUrl;
                    (r || c || l || d) && (o = !0, i.contents().filter(function() {
                        return !e(this).hasClass("k-sprite") && !e(this).hasClass("k-icon") && !e(this).hasClass("k-image")
                    }).each(function(n, t) {
                        (1 == t.nodeType || 3 == t.nodeType && e.trim(t.nodeValue).length > 0) && (o = !1)
                    }), i.addClass(o ? p : f)), c ? (t = i.children("img.k-image").first(), t[0] || (t = e('<img alt="icon" class="k-image" />').prependTo(i)), t.attr("src", c)) : l || d ? (n = i.children("span.k-icon").first(), n[0] || (n = e("<span></span>").prependTo(i)), n.attr("class", l ? "k-icon k-i-" + l : d)) : r && (n = i.children("span.k-sprite").first(), n[0] || (n = e('<span class="k-sprite"></span>').prependTo(i)), n.addClass(r))
                },
                enable: function(e) {
                    var t = this,
                        o = t.element;
                    e === n && (e = !0), e = !!e, t.options.enable = e, o.toggleClass(m, !e).attr("aria-disabled", !e).attr(k, !e), e && t._tabindex();
                    try {
                        o.blur()
                    } catch (a) {}
                },
                createBadge: function(n) {
                    var t = this,
                        o = e("<span />").appendTo(t.element);
                    n.overlay !== !1 && t.element.addClass(h), t.badge = "string" == typeof n || "number" == typeof n ? new a.Badge(o, {
                        value: n
                    }) : "boolean" == typeof n ? new a.Badge(o) : new a.Badge(o, n)
                }
            });
        t.ui.plugin(C)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, n, t) {
    (t || n)()
});;
! function(e, define) {
    define("kendo.buttongroup.min", ["kendo.core.min"], e)
}(function() {
    return function(e, t) {
        function n(t, n) {
            var s = e("<span />").appendTo(n);
            n.badge = "string" == typeof t || "number" == typeof t ? new i.Badge(s, {
                value: t,
                appearance: "rectangle"
            }) : "boolean" == typeof t ? new i.Badge(s) : new i.Badge(s, t)
        }
        var s = window.kendo,
            i = s.ui,
            a = i.Widget,
            o = s.keys,
            d = e.proxy,
            l = s.template,
            r = ".kendoButtonGroup",
            c = "k-widget",
            u = "k-button-group",
            f = "k-button",
            m = "k-button-icontext",
            p = "k-button-icon",
            h = "k-state-active",
            g = "k-state-focused",
            b = "k-state-disabled",
            C = "select",
            k = "click",
            v = "keydown",
            y = "focus",
            x = "blur",
            _ = "mousedown",
            w = {
                item: l('<span #= item.enabled === false ? "disabled" : "" # >#= icon(iconClass) ##= image(item) ##= text #</span>'),
                image: l('<img alt="icon" src="#=data.imageUrl#" />'),
                icon: l('<span class="#=data#" />'),
                empty: l("")
            },
            I = a.extend({
                init: function(t, n) {
                    var s = this;
                    a.fn.init.call(s, t, n), s.wrapper = s.element, s.options.items && s._renderItems(s.options.items), s.selectedIndices = [], s.element.addClass(c + " " + u).attr("role", "group").attr("tabindex", s.element.attr("tabindex") || "0").children().each(function() {
                        var t = e(this);
                        s._updateClasses.bind(s)(t)
                    }), s._enable = !0, s.options.enable && s.options.enabled || (s._enable = !1, s.element.attr("aria-disabled", !0).addClass(b)), s.select(s.options.index), s.element.on(k + r, "." + f, d(s._click, s)).on(y + r, d(s._focus, s)).on(v + r, d(s._keyDown, s)).on(x + r, function() {
                        s.preventFocus = !1, s.element.find("." + f).removeClass(g)
                    }).on(_ + r, function() {
                        s.preventFocus = !0
                    })
                },
                events: [C],
                options: {
                    name: "ButtonGroup",
                    selection: "single",
                    index: -1,
                    enable: !0,
                    enabled: !0
                },
                current: function() {
                    return this.element.find("." + h)
                },
                _renderItems: function(t) {
                    var i = this;
                    t.forEach(function(t) {
                        var a = e(w.item({
                            image: t.imageUrl ? w.image : w.empty,
                            icon: t.imageUrl || !t.iconClass && !t.icon ? w.empty : w.icon,
                            iconClass: t.iconClass || "k-icon k-i-" + t.icon,
                            item: t,
                            text: t.text ? t.encoded === !1 ? t.text : s.htmlEncode(t.text) : ""
                        }));
                        t.attributes && a.attr(t.attributes), t.selected && a.addClass(h), (t.iconClass || t.icon || t.imageUrl) && a.addClass(t.text ? "k-button-icontext" : "k-button-icon"), t.badge && n(t.badge, a), a.appendTo(i.element)
                    })
                },
                _focus: function() {
                    var t = e(this.element);
                    this.preventFocus || (t.find("." + h).length ? t.find("." + h).first().focus().addClass(g) : t.children().first().focus().addClass(g))
                },
                _keyDown: function(t) {
                    var n, i = this,
                        a = e(i.element),
                        d = a.find("." + f),
                        l = a.find("." + g),
                        r = d.index(l),
                        c = s.support.isRtl(i.element);
                    t.keyCode === o.LEFT && !c || t.keyCode === o.RIGHT && c ? (l.removeClass(g), n = 0 === r ? d.eq(d.length - 1) : e(d[r - 1]), n.focus().addClass(g), t.preventDefault()) : t.keyCode === o.LEFT && c || t.keyCode === o.RIGHT && !c ? (l.removeClass(g), n = r + 1 === d.length ? d.eq(0) : e(d[r + 1]), n.focus().addClass(g), t.preventDefault()) : t.keyCode !== o.ENTER && t.keyCode !== o.SPACEBAR || (i._select(l), t.preventDefault())
                },
                select: function(n) {
                    var s, i = this,
                        a = -1;
                    n !== t && n !== -1 && (i.element.find("." + f).removeClass(g), "number" == typeof n ? (a = n, n = i.element.children().eq(n)) : n.nodeType && (n = e(n), a = n.index()), "multiple" === i.options.selection ? (s = "true" === n.attr("aria-pressed"), n.attr("aria-pressed", !s).toggleClass(h), i.selectedIndices.indexOf(a) === -1 ? i.selectedIndices.push(a) : i.selectedIndices.splice(i.selectedIndices.indexOf(a), 1)) : (i.selectedIndices = [], i.current().attr("aria-pressed", !1).removeClass(h), n.attr("aria-pressed", !0).addClass(h), i.selectedIndices.push(a)), i.trigger(C, {
                        indices: i.selectedIndices
                    }))
                },
                badge: function(e, i) {
                    var a, o = this.element,
                        d = isNaN(e) ? o.find(e) : o.children().eq(e),
                        l = i || 0 === i;
                    if (d.length) {
                        if (a = d.children(".k-badge").eq(0).data("kendoBadge"), !a && l) return n({
                            value: s.htmlEncode(i)
                        }, d), s.htmlEncode(i);
                        if (l) a.value(s.htmlEncode(i));
                        else if (i === !1) return a.element.empty().remove(), a.destroy(), t;
                        return a ? a.value() : null
                    }
                },
                enable: function(e) {
                    t === e && (e = !0), this.element.attr("aria-disabled", !e).toggleClass(b, !e), this._enable = this.options.enable = e
                },
                destroy: function() {
                    var t = this;
                    t.element.off(r), t.element.find(".k-badge").each(function() {
                        e(this).data("kendoBadge").destroy()
                    }), a.fn.destroy.call(t)
                },
                _updateClasses: function(t) {
                    var i = s.attrValue(t, "icon"),
                        a = s.attrValue(t, "badge"),
                        o = t.find("img").addClass("k-image"),
                        d = !0;
                    t.attr("aria-pressed", !1).attr("role", "button").addClass(f), (t.is("[disabled]") || t.hasClass(b)) && t.addClass(b).attr("aria-disabled", !0).removeAttr("disabled"), t.is("." + h) && (t.removeClass(h), (!t.hasClass(b) && "single" === this.options.selection || "multiple" === this.options.selection) && this.select(t[0])), !o[0] && i && t.prepend(e(w.icon("k-icon k-i-" + i))), t.contents().filter(function() {
                        return !e(this).hasClass("k-icon") && !e(this).hasClass("k-image")
                    }).each(function() {
                        (1 == this.nodeType || 3 == this.nodeType && e.trim(this.nodeValue).length > 0) && (d = !1)
                    }), (o[0] || i) && t.addClass(d ? p : m), (a || 0 === a) && n(a, t)
                },
                _click: function(t) {
                    var n = e(t.target).closest("." + f);
                    t.isDefaultPrevented() || this._select(n)
                },
                _select: function(e) {
                    var n = e;
                    return this.element.find("." + f).removeClass(g), !this._enable || n.is("." + b) ? (n.addClass(g), t) : (this.select(e[0]), n.addClass(g), t)
                }
            });
        i.plugin(I)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(e, define) {
    define("kendo.selectable.min", ["kendo.core.min", "kendo.userevents.min"], e)
}(function() {
    return function(e, t) {
        function n(e, t) {
            if (!e.is(":visible")) return !1;
            var n = s.getOffset(e),
                i = t.left + t.width,
                l = t.top + t.height;
            return n.right = n.left + s._outerWidth(e), n.bottom = n.top + s._outerHeight(e), !(n.left > i || n.right < t.left || n.top > l || n.bottom < t.top)
        }
        var i, s = window.kendo,
            l = s.ui.Widget,
            a = e.proxy,
            o = Math.abs,
            r = "aria-selected",
            c = "k-state-selected",
            u = "k-state-selecting",
            d = "k-selectable",
            f = "change",
            v = ".kendoSelectable",
            m = "unselect",
            p = "k-state-unselecting",
            h = "input,a,textarea,.k-multiselect-wrap,select,button,.k-button>span,.k-button>img,span.k-icon.k-i-arrow-60-down,span.k-icon.k-i-arrow-60-up,label.k-checkbox-label.k-no-text,.k-icon.k-i-collapse,.k-icon.k-i-expand,span.k-numeric-wrap,.k-focusable",
            _ = s.support.browser.msie,
            g = !1;
        ! function(e) {
            ! function() {
                e('<div class="parent"><span /></div>').on("click", ">*", function() {
                    g = !0
                }).find("span").trigger("click").end().off()
            }()
        }(e), i = l.extend({
            init: function(t, n) {
                var i, o = this;
                l.fn.init.call(o, t, n), o._marquee = e("<div class='k-marquee'><div class='k-marquee-color'></div></div>"), o._lastActive = null, o.element.addClass(d), o.relatedTarget = o.options.relatedTarget, i = o.options.multiple, this.options.aria && i && o.element.attr("aria-multiselectable", !0), o.userEvents = new s.UserEvents(o.element, {
                    global: !0,
                    allowSelection: !0,
                    filter: (g ? "" : "." + d + " ") + o.options.filter,
                    tap: a(o._tap, o),
                    touchAction: i ? "none" : "pan-x pan-y"
                }), i && o.userEvents.bind("start", a(o._start, o)).bind("move", a(o._move, o)).bind("end", a(o._end, o)).bind("select", a(o._select, o))
            },
            events: [f, m],
            options: {
                name: "Selectable",
                filter: ">*",
                inputSelectors: h,
                multiple: !1,
                relatedTarget: e.noop
            },
            _isElement: function(e) {
                var t, n = this.element,
                    i = n.length,
                    s = !1;
                for (e = e[0], t = 0; t < i; t++)
                    if (n[t] === e) {
                        s = !0;
                        break
                    }
                return s
            },
            _tap: function(t) {
                var n, i = e(t.target),
                    s = this,
                    l = t.event.ctrlKey || t.event.metaKey,
                    a = s.options.multiple,
                    o = a && t.event.shiftKey,
                    r = t.event.which,
                    u = t.event.button;
                !s._isElement(i.closest("." + d)) || r && 3 == r || u && 2 == u || this._allowSelection(t.event.target) && (n = i.hasClass(c), a && l || s.clear(), i = i.add(s.relatedTarget(i)), o ? s.selectRange(s._firstSelectee(), i, t) : (n && l ? (s._unselect(i), s._notify(f, t)) : s.value(i, t), s._lastActive = s._downTarget = i))
            },
            _start: function(n) {
                var i, s = this,
                    l = e(n.target),
                    a = l.hasClass(c),
                    o = n.event.ctrlKey || n.event.metaKey;
                if (this._allowSelection(n.event.target)) {
                    if (s._downTarget = l, !s._isElement(l.closest("." + d))) return s.userEvents.cancel(), t;
                    s.options.useAllItems ? s._items = s.element.find(s.options.filter) : (i = l.closest(s.element), s._items = i.find(s.options.filter)), n.sender.capture(), s._marquee.appendTo(document.body).css({
                        left: n.x.client + 1,
                        top: n.y.client + 1,
                        width: 0,
                        height: 0
                    }), o || s.clear(), l = l.add(s.relatedTarget(l)), a && (s._selectElement(l, !0), o && l.addClass(p))
                }
            },
            _move: function(e) {
                var t = this,
                    n = {
                        left: e.x.startLocation > e.x.location ? e.x.location : e.x.startLocation,
                        top: e.y.startLocation > e.y.location ? e.y.location : e.y.startLocation,
                        width: o(e.x.initialDelta),
                        height: o(e.y.initialDelta)
                    };
                t._marquee.css(n), t._invalidateSelectables(n, e.event.ctrlKey || e.event.metaKey), e.preventDefault()
            },
            _end: function(e) {
                var t, n = this;
                n._marquee.remove(), n._unselect(n.element.find(n.options.filter + "." + p)).removeClass(p), t = n.element.find(n.options.filter + "." + u), t = t.add(n.relatedTarget(t)), n.value(t, e), n._lastActive = n._downTarget, n._items = null
            },
            _invalidateSelectables: function(e, t) {
                var i, s, l, a, o = this._downTarget[0],
                    r = this._items;
                for (i = 0, s = r.length; i < s; i++) a = r.eq(i), l = a.add(this.relatedTarget(a)), n(a, e) ? a.hasClass(c) ? t && o !== a[0] && l.removeClass(c).addClass(p) : a.hasClass(u) || a.hasClass(p) || l.addClass(u) : a.hasClass(u) ? l.removeClass(u) : t && a.hasClass(p) && l.removeClass(p).addClass(c)
            },
            value: function(e, n) {
                var i = this,
                    s = a(i._selectElement, i);
                return e ? (e.each(function() {
                    s(this)
                }), i._notify(f, n), t) : i.element.find(i.options.filter + "." + c)
            },
            _firstSelectee: function() {
                var e, t = this;
                return null !== t._lastActive ? t._lastActive : (e = t.value(), e.length > 0 ? e[0] : t.element.find(t.options.filter)[0])
            },
            _selectElement: function(t, n) {
                var i = e(t),
                    s = !n && this._notify("select", {
                        element: t
                    });
                i.removeClass(u), s || (i.addClass(c), this.options.aria && i.attr(r, !0))
            },
            _notify: function(e, t) {
                return t = t || {}, this.trigger(e, t)
            },
            _unselect: function(e) {
                if (!this.trigger(m, {
                        element: e
                    })) return e.removeClass(c), this.options.aria && e.attr(r, !1), e
            },
            _select: function(t) {
                this._allowSelection(t.event.target) && (!_ || _ && !e(s._activeElement()).is(this.options.inputSelectors)) && t.preventDefault()
            },
            _allowSelection: function(t) {
                return !e(t).is(this.options.inputSelectors) || (this.userEvents.cancel(), this._downTarget = null, !1)
            },
            resetTouchEvents: function() {
                this.userEvents.cancel()
            },
            clear: function() {
                var e = this.element.find(this.options.filter + "." + c);
                this._unselect(e)
            },
            selectRange: function(t, n, i) {
                var s, l, a, o = this;
                for (o.clear(), o.element.length > 1 && (a = o.options.continuousItems()), a && a.length || (a = o.element.find(o.options.filter)), t = e.inArray(e(t)[0], a), n = e.inArray(e(n)[0], a), t > n && (l = t, t = n, n = l), o.options.useAllItems || (n += o.element.length - 1), s = t; s <= n; s++) o._selectElement(a[s]);
                o._notify(f, i)
            },
            destroy: function() {
                var e = this;
                l.fn.destroy.call(e), e.element.off(v), e.userEvents.destroy(), e._marquee = e._lastActive = e.element = e.userEvents = null
            }
        }), i.parseOptions = function(e) {
            var t = "string" == typeof e && e.toLowerCase();
            return {
                multiple: t && t.indexOf("multiple") > -1,
                cell: t && t.indexOf("cell") > -1
            }
        }, s.ui.plugin(i)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(e, define) {
    define("kendo.calendar.min", ["kendo.core.min", "kendo.selectable.min"], e)
}(function() {
    return function(e, t) {
        function a(e, t, a, n) {
            var l, r = e.getFullYear(),
                i = t.getFullYear(),
                s = a.getFullYear();
            return r -= r % n, l = r + (n - 1), r < i && (r = i), l > s && (l = s), r + "-" + l
        }

        function n(e) {
            var t, a = 0,
                n = e.min,
                l = e.max,
                r = e.start,
                i = e.setter,
                o = e.build,
                c = e.weekNumberBuild,
                u = e.cells || 12,
                d = e.isWeekColumnVisible,
                f = e.perRow || 4,
                g = e.otherMonth,
                v = e.lastDayOfMonth,
                h = e.weekNumber || j,
                m = e.content || z,
                p = e.empty || q,
                b = e.otherMonthCellTemplate || U,
                k = e.html || '<table tabindex="0" role="grid" class="k-content k-meta-view" cellspacing="0"><tbody><tr role="row">';
            for (d && (k += h(c(r))); a < u; a++) a > 0 && a % f === 0 && (k += '</tr><tr role="row">', d && (k += h(g || +r <= +v ? c(r) : {
                weekNumber: "&nbsp;"
            }))), r = _(r.getFullYear(), r.getMonth(), r.getDate()), V(r, 0), t = o(r, a, e.disableDates), k += t.cssClass.indexOf(ue) === -1 || g ? s(r, n, l) ? m(t) : p(t) : b(t), i(r, 1);
            return k + "</tr></tbody></table>"
        }

        function l(e, t, a) {
            var n = e.getFullYear(),
                l = t.getFullYear(),
                r = l,
                i = 0;
            return a && (l -= l % a, r = l - l % a + a - 1), n > r ? i = 1 : n < l && (i = -1), i
        }

        function r() {
            var e = new Oe;
            return new Oe(e.getFullYear(), e.getMonth(), e.getDate())
        }

        function i(e, t, a) {
            var n = r();
            return e && (n = new Oe((+e))), t > n ? n = new Oe((+t)) : a < n && (n = new Oe((+a))), n
        }

        function s(e, t, a) {
            return +e >= +t && +e <= +a
        }

        function o(e, t) {
            return e.slice(t).concat(e.slice(0, t))
        }

        function c(e, t, a) {
            t = t instanceof Oe ? t.getFullYear() : e.getFullYear() + a * t, e.setFullYear(t)
        }

        function u(e, t) {
            var a, n, l;
            return +t < +e && (a = +e, M.views[0].setDate(e, t), M.views[0].setDate(t, new Date(a))), n = Date.UTC(e.getFullYear(), e.getMonth(), e.getDate()), l = Date.UTC(t.getFullYear(), t.getMonth(), t.getDate()), Math.ceil((+l - +n) / T.date.MS_PER_DAY)
        }

        function d(e, t, a, n) {
            var l, r;
            for (l = 0; l <= t; l++) r = new Date(a.getTime()), r = new Date(r.setDate(r.getDate() + l)), n(r) || e.push(r)
        }

        function f(t) {
            var a = e(this).hasClass("k-state-disabled");
            a || e(this).toggleClass(se, De.indexOf(t.type) > -1 || t.type == be)
        }

        function g(e) {
            e.preventDefault()
        }

        function _(e, t, a) {
            var n = new Oe(e, t, a);
            return n.setFullYear(e, t, a), n
        }

        function v(e) {
            return I(e).calendars.standard
        }

        function h(e) {
            var a = Ve[e.start],
                n = Ve[e.depth],
                l = I(e.culture);
            e.format = E(e.format || l.calendars.standard.patterns.d), isNaN(a) && (a = 0, e.start = ae), (n === t || n > a) && (e.depth = ae), null === e.dates && (e.dates = [])
        }

        function m(e) {
            K && e.find("*").attr("unselectable", "on")
        }

        function p(e, t) {
            e.addClass("k-" + t)
        }

        function b(e, t) {
            for (var a = 0, n = t.length; a < n; a++)
                if (e === +t[a]) return !0;
            return !1
        }

        function k(e, t) {
            return !!e && (e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate())
        }

        function D(e, t) {
            return !!e && (e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth())
        }

        function w(t) {
            return T.isFunction(t) ? t : e.isArray(t) ? S(t) : e.noop
        }

        function y(e) {
            var t, a = [];
            for (t = 0; t < e.length; t++) a.push(e[t].setHours(0, 0, 0, 0));
            return a
        }

        function S(t) {
            var a, n, l, r, i, s = [],
                o = ["su", "mo", "tu", "we", "th", "fr", "sa"],
                c = "if (found) { return true } else {return false}";
            if (t[0] instanceof Oe) s = y(t), a = "var found = date && window.kendo.jQuery.inArray(date.setHours(0, 0, 0, 0),[" + s + "]) > -1;" + c;
            else {
                for (l = 0; l < t.length; l++) r = t[l].slice(0, 2).toLowerCase(), i = e.inArray(r, o), i > -1 && s.push(i);
                a = "var found = date && window.kendo.jQuery.inArray(date.getDay(),[" + s + "]) > -1;" + c
            }
            return n = Function("date", a)
        }

        function C(e, t) {
            return e instanceof Date && t instanceof Date && (e = e.getTime(), t = t.getTime()), e === t
        }

        function F(t) {
            var a = e(t).attr(T.attr(ie)).split("/");
            return a = _(a[0], a[1], a[2])
        }
        var M, T = window.kendo,
            x = T.support,
            Y = T.ui,
            A = Y.Widget,
            N = T.keys,
            O = T.parseDate,
            V = T.date.adjustDST,
            B = T.date.weekInYear,
            H = T.ui.Selectable,
            E = T._extractFormat,
            W = T.template,
            I = T.getCulture,
            P = T.support.transitions,
            R = P ? P.css + "transform-origin" : "",
            z = W('<td#=data.cssClass# role="gridcell"><a tabindex="-1" class="k-link" href="\\#" data-#=data.ns#value="#=data.dateString#">#=data.value#</a></td>', {
                useWithBlock: !1
            }),
            q = W('<td role="gridcell" class="k-out-of-range"><a class="k-link"></a></td>', {
                useWithBlock: !1
            }),
            U = W('<td role="gridcell" class="k-out-of-range">&nbsp;</td>', {
                useWithBlock: !1
            }),
            j = W('<td class="k-alt">#= data.weekNumber #</td>', {
                useWithBlock: !1
            }),
            G = T.support.browser,
            K = G.msie && G.version < 9,
            L = T._outerWidth,
            Q = ".kendoCalendar",
            J = "click" + Q,
            X = "keydown" + Q,
            Z = "id",
            $ = "min",
            ee = "left",
            te = "slideIn",
            ae = "month",
            ne = "century",
            le = "change",
            re = "navigate",
            ie = "value",
            se = "k-state-hover",
            oe = "k-state-disabled",
            ce = "k-state-focused",
            ue = "k-other-month",
            de = ' class="' + ue + '"',
            fe = "k-out-of-range",
            ge = "k-nav-today",
            _e = "td:has(.k-link)",
            ve = "td:has(.k-link):not(." + oe + "):not(." + fe + ")",
            he = "td:not(:has(.k-link))",
            me = "k-state-selected",
            pe = "blur" + Q,
            be = "focus",
            ke = be + Q,
            De = x.touch ? "touchstart" : "mouseenter",
            we = x.touch ? "touchstart" + Q : "mouseenter" + Q,
            ye = x.touch ? "touchend" + Q + " touchmove" + Q : "mouseleave" + Q,
            Se = 6e4,
            Ce = 864e5,
            Fe = "_prevArrow",
            Me = "_nextArrow",
            Te = "aria-disabled",
            xe = "aria-selected",
            Ye = "aria-label",
            Ae = e.proxy,
            Ne = e.extend,
            Oe = Date,
            Ve = {
                month: 0,
                year: 1,
                decade: 2,
                century: 3
            },
            Be = A.extend({
                init: function(t, a) {
                    var n, l, s = this;
                    A.fn.init.call(s, t, a), t = s.wrapper = s.element, a = s.options, a.url = T.unescape(a.url), s.options.disableDates = w(s.options.disableDates), s._templates(), s._selectable(), s._header(), s._viewWrapper(), s._footer(s.footer), l = t.addClass("k-widget k-calendar " + (a.weekNumber ? " k-week-number" : "")).on(we + " " + ye, _e, f).on(X, "table.k-content", Ae(s._move, s)).on(J, _e, function(t) {
                        var n = t.currentTarget.firstChild,
                            l = F(n);
                        n.href.indexOf("#") != -1 && t.preventDefault(), "month" == s._view.name && s.options.disableDates(l) || "month" == s._view.name && "single" != a.selectable || s._click(e(n))
                    }).on("mouseup" + Q, "table.k-content, .k-footer", function() {
                        s._focusView(s.options.focusOnNav !== !1)
                    }).attr(Z), l && (s._cellID = l + "_cell_selected"), s._isMultipleSelection() && s.options.weekNumber && t.on(J, he, function(t) {
                        var a = e(t.currentTarget).closest("tr").find(ve).first(),
                            n = s.selectable._lastActive = e(t.currentTarget).closest("tr").find(ve).last();
                        s.selectable.selectRange(a, n, {
                            event: t
                        }), s._current = s._value = F(n.find("a")), s._class(ce, s._current)
                    }), h(a), n = O(a.value, a.format, a.culture), s._selectDates = [], s._index = Ve[a.start], s._current = new Oe((+i(n, a.min, a.max))), s._addClassProxy = function() {
                        if (s._active = !0, s._cell.hasClass(oe)) {
                            var e = s._view.toDateString(r());
                            s._cell = s._cellByDate(e)
                        }
                        s._cell.addClass(ce)
                    }, s._removeClassProxy = function() {
                        s._active = !1, s._cell.removeClass(ce)
                    }, s.value(n), s._isMultipleSelection() && a.selectDates.length > 0 && s.selectDates(a.selectDates), T.notify(s)
                },
                options: {
                    name: "Calendar",
                    value: null,
                    min: new Oe(1900, 0, 1),
                    max: new Oe(2099, 11, 31),
                    dates: [],
                    disableDates: null,
                    url: "",
                    culture: "",
                    footer: "",
                    format: "",
                    month: {},
                    weekNumber: !1,
                    selectable: "single",
                    selectDates: [],
                    start: ae,
                    depth: ae,
                    animation: {
                        horizontal: {
                            effects: te,
                            reverse: !0,
                            duration: 500,
                            divisor: 2
                        },
                        vertical: {
                            effects: "zoomIn",
                            duration: 400
                        }
                    },
                    messages: {
                        weekColumnHeader: ""
                    }
                },
                events: [le, re],
                setOptions: function(e) {
                    var t = this;
                    h(e), e.disableDates = w(e.disableDates), t._destroySelectable(), A.fn.setOptions.call(t, e), t._templates(), t._selectable(), t._viewWrapper(), t._footer(t.footer), t._index = Ve[t.options.start], t.navigate(), e.weekNumber && t.element.addClass("k-week-number")
                },
                destroy: function() {
                    var e = this,
                        t = e._today;
                    e.element.off(Q), e._title.off(Q), e[Fe].off(Q), e[Me].off(Q), e._destroySelectable(), T.destroy(e._table), t && T.destroy(t.off(Q)), A.fn.destroy.call(e)
                },
                current: function() {
                    return this._current
                },
                view: function() {
                    return this._view
                },
                focus: function(e) {
                    e = e || this._table, this._bindTable(e), e.trigger("focus")
                },
                min: function(e) {
                    return this._option($, e)
                },
                max: function(e) {
                    return this._option("max", e)
                },
                navigateToPast: function() {
                    this._navigate(Fe, -1)
                },
                navigateToFuture: function() {
                    this._navigate(Me, 1)
                },
                navigateUp: function() {
                    var e = this,
                        t = e._index;
                    e._title.hasClass(oe) || e.navigate(e._current, ++t)
                },
                navigateDown: function(e) {
                    var a = this,
                        n = a._index,
                        l = a.options.depth;
                    if (e) return n === Ve[l] ? (C(a._value, a._current) && C(a._value, e) || (a.value(e), a.trigger(le)), t) : (a.navigate(e, --n), t)
                },
                navigate: function(a, n) {
                    var l, r, s, o, c, u, d, f, g, _, v, h, b, k, D, w;
                    n = isNaN(n) ? Ve[n] : n, l = this, r = l.options, s = r.culture, o = r.min, c = r.max, u = l._title, d = l._table, f = l._oldTable, g = l._current, _ = a && +a > +g, v = n !== t && n !== l._index, a || (a = g), l._current = a = new Oe((+i(a, o, c))), n === t ? n = l._index : l._index = n, l._view = b = M.views[n], k = b.compare, D = n === Ve[ne], u.toggleClass(oe, D).attr(Te, D), D = k(a, o) < 1, l[Fe].toggleClass(oe, D).attr(Te, D), l[Fe].hasClass(oe) && l[Fe].removeClass(se), D = k(a, c) > -1, l[Me].toggleClass(oe, D).attr(Te, D), l[Me].hasClass(oe) && l[Me].removeClass(se), d && f && f.data("animating") && (f.kendoStop(!0, !0), d.kendoStop(!0, !0)), l._oldTable = d, d && !l._changeView || (u.html(b.title(a, o, c, s)), l._table = h = e(b.content(Ne({
                        min: o,
                        max: c,
                        date: a,
                        url: r.url,
                        dates: r.dates,
                        format: r.format,
                        otherMonth: !0,
                        culture: s,
                        disableDates: r.disableDates,
                        isWeekColumnVisible: r.weekNumber,
                        messages: r.messages
                    }, l[b.name]))), p(h, b.name), m(h), w = d && d.data("start") === h.data("start"), l._animate({
                        from: d,
                        to: h,
                        vertical: v,
                        future: _,
                        replace: w
                    }), l.trigger(re), l._focus(a)), n === Ve[r.depth] && l._selectDates.length > 0 && l._visualizeSelectedDatesInView(), "single" === l.options.selectable && n === Ve[r.depth] && l._value && !l.options.disableDates(l._value) && l._class("k-state-selected", l._value), l._class(ce, a), !d && l._cell && l._cell.removeClass(ce), l._changeView = !0
                },
                selectDates: function(a) {
                    var n, l, r = this;
                    return a === t ? r._selectDates : (l = a.map(function(e) {
                        return e.getTime()
                    }).filter(function(e, t, a) {
                        return a.indexOf(e) === t
                    }).map(function(e) {
                        return new Date(e)
                    }), n = e.grep(l, function(e) {
                        if (e) return +r._validateValue(new Date(e.setHours(0, 0, 0, 0))) === +e
                    }), r._selectDates = n.length > 0 ? n : 0 === l.length ? l : r._selectDates, r._visualizeSelectedDatesInView(), t)
                },
                value: function(e) {
                    var a, n = this,
                        l = n._view,
                        r = n._view;
                    return e === t ? n._value : (e = n._validateValue(e), e && n._isMultipleSelection() && (a = new Date((+e)), a.setHours(0, 0, 0, 0), n._selectDates = [a], n.selectable._lastActive = null), l && null === e && n._cell ? n._cell.removeClass(me) : (n._changeView = !e || r && 0 !== r.compare(e, n._current), n.navigate(e)), t)
                },
                _validateValue: function(e) {
                    var a = this,
                        n = a.options,
                        l = n.min,
                        r = n.max;
                    return null === e && (a._current = _(a._current.getFullYear(), a._current.getMonth(), a._current.getDate())), e = O(e, n.format, n.culture), null !== e && (e = new Oe((+e)), s(e, l, r) || (e = null)), null !== e && a.options.disableDates(new Date((+e))) ? a._value === t && (a._value = null) : a._value = e, a._value
                },
                _visualizeSelectedDatesInView: function() {
                    var t, a = this,
                        n = {};
                    e.each(a._selectDates, function(e, t) {
                        n[T.calendar.views[0].toDateString(t)] = t
                    }), a.selectable.clear(), t = a._table.find(_e).filter(function(t, a) {
                        return n[e(a.firstChild).attr(T.attr(ie))]
                    }), t.length > 0 && a.selectable._selectElement(t, !0)
                },
                _isMultipleSelection: function() {
                    var e = this;
                    return "multiple" === e.options.selectable
                },
                _selectable: function() {
                    var e, t, a = this;
                    a._isMultipleSelection() && (e = a.options.selectable, t = H.parseOptions(e), t.multiple && a.element.attr("aria-multiselectable", "true"), a.selectable = new H(a.wrapper, {
                        aria: !0,
                        inputSelectors: "input,textarea,.k-multiselect-wrap,select,button,.k-button>span,.k-button>img,span.k-icon.k-i-arrow-60-down,span.k-icon.k-i-arrow-60-up",
                        multiple: t.multiple,
                        filter: "table.k-month:eq(0) " + ve,
                        change: Ae(a._onSelect, a),
                        relatedTarget: Ae(a._onRelatedTarget, a)
                    }))
                },
                _onRelatedTarget: function(e) {
                    var t = this;
                    t.selectable.options.multiple && e.is(ve) && (t._current = F(e.find("a")), t._class(ce, F(e.find("a"))))
                },
                _onSelect: function(a) {
                    var n = this,
                        l = a,
                        r = H.parseOptions(n.options.selectable);
                    return r.multiple ? (l.event.ctrlKey || l.event.metaKey ? e(l.event.currentTarget).is(ve) ? n._toggleSelection(e(l.event.currentTarget)) : (n._cellsBySelector(ve).each(function(t, a) {
                        var l = F(e(a).find("a"));
                        n._deselect(l)
                    }), n._addSelectedCellsToArray()) : l.event.shiftKey ? n._rangeSelection(n._cell) : e(l.event.currentTarget).is(_e) ? n.value(F(e(l.event.currentTarget).find("a"))) : (n._selectDates = [], n._addSelectedCellsToArray()), n.trigger(le), t) : (e(l.event.currentTarget).is("td") && !e(l.event.currentTarget).hasClass("k-state-selected") ? e(l.event.currentTarget).addClass("k-state-selected") : n._click(e(l.event.currentTarget).find("a")), t)
                },
                _destroySelectable: function() {
                    var e = this;
                    e.selectable && (e.selectable.destroy(), e.selectable = null)
                },
                _toggleSelection: function(e) {
                    var t = this,
                        a = F(e.find("a"));
                    e.hasClass("k-state-selected") ? t._selectDates.push(a) : t._deselect(a)
                },
                _rangeSelection: function(e, t) {
                    var a, n = this,
                        l = t || F(n.selectable.value().first().find("a")),
                        r = F(e.find("a"));
                    n.selectable._lastActive || n._value ? l = n.selectable._lastActive ? F(n.selectable._lastActive.find("a")) : new Date((+n._value)) : n.selectable._lastActive = t ? n._cellByDate(n._view.toDateString(t), ve) : n.selectable.value().first(), n._selectDates = [], a = u(l, r), d(n._selectDates, a, l, n.options.disableDates), n._visualizeSelectedDatesInView()
                },
                _cellsBySelector: function(e) {
                    var t = this;
                    return t._table.find(e)
                },
                _addSelectedCellsToArray: function() {
                    var t = this;
                    t.selectable.value().each(function(a, n) {
                        var l = F(e(n.firstChild));
                        t.options.disableDates(l) || t._selectDates.push(l)
                    })
                },
                _deselect: function(e) {
                    var t = this,
                        a = t._selectDates.map(Number).indexOf(+e);
                    a != -1 && t._selectDates.splice(a, 1)
                },
                _dateInView: function(e) {
                    var t = this,
                        a = F(t._cellsBySelector(ve + ":first").find("a")),
                        n = F(t._cellsBySelector(ve + ":last").find("a"));
                    return +e <= +n && +e >= +a
                },
                _isNavigatable: function(e, t) {
                    var a, n, l = this,
                        r = l.options.disableDates;
                    return "month" == l._view.name ? !r(e) : (n = l.wrapper.find("." + ce).index(), a = l.wrapper.find(".k-content td:eq(" + (n + t) + ")"), a.is(ve) || !r(e))
                },
                _move: function(a) {
                    var n, l, r, o, c, u = this,
                        d = u.options,
                        f = a.keyCode,
                        g = u._view,
                        v = u._index,
                        h = u.options.min,
                        m = u.options.max,
                        p = new Oe((+u._current)),
                        b = T.support.isRtl(u.wrapper),
                        k = u.options.disableDates;
                    return a.target === u._table[0] && (u._active = !0), f == N.RIGHT && !b || f == N.LEFT && b ? (n = 1, l = !0) : f == N.LEFT && !b || f == N.RIGHT && b ? (n = -1, l = !0) : f == N.UP ? (n = 0 === v ? -7 : -4, l = !0) : f == N.DOWN ? (n = 0 === v ? 7 : 4, l = !0) : f == N.SPACEBAR ? (n = 0, l = !0) : f != N.HOME && f != N.END || (r = f == N.HOME ? "first" : "last", o = g[r](p), p = new Oe(o.getFullYear(), o.getMonth(), o.getDate(), p.getHours(), p.getMinutes(), p.getSeconds(), p.getMilliseconds()), p.setFullYear(o.getFullYear()), l = !0), a.ctrlKey || a.metaKey ? f == N.RIGHT && !b || f == N.LEFT && b ? (u.navigateToFuture(), l = !0) : f == N.LEFT && !b || f == N.RIGHT && b ? (u.navigateToPast(), l = !0) : f == N.UP ? (u.navigateUp(), l = !0) : f == N.DOWN ? (u._click(e(u._cell[0].firstChild)), l = !0) : f != N.ENTER && f != N.SPACEBAR || !u._isMultipleSelection() || (u._keyboardToggleSelection(a), c = F(e(u._cell[0]).find("a")), u._class(ce, c)) : a.shiftKey ? (n !== t || r) && (r || g.setDate(p, n), s(p, h, m) || (p = i(p, d.min, d.max)), k(p) && (p = u._nextNavigatable(p, n)), h = _(h.getFullYear(), h.getMonth(), h.getDate()), u._isMultipleSelection() ? u._keyboardRangeSelection(a, p) : u._focus(p)) : (f == N.ENTER || f == N.SPACEBAR ? ("month" == g.name && u._isMultipleSelection() ? (u.value(F(e(u._cell.find("a")))), u.selectable._lastActive = e(u._cell[0]), u.trigger(le)) : u._click(e(u._cell[0].firstChild)), l = !0) : f == N.PAGEUP ? (l = !0, u.navigateToPast()) : f == N.PAGEDOWN && (l = !0, u.navigateToFuture()), (n || r) && (r || g.setDate(p, n), h = _(h.getFullYear(), h.getMonth(), h.getDate()), s(p, h, m) || (p = i(p, d.min, d.max)), u._isNavigatable(p, n) || (p = u._nextNavigatable(p, n)), u._isMultipleSelection() ? u._dateInView(p) ? (u._current = p, u._class(ce, p)) : u.navigate(p) : u._focus(p))), l && a.preventDefault(), u._current
                },
                _keyboardRangeSelection: function(e, a) {
                    var n, l, r = this;
                    return r._dateInView(a) ? (r.selectable.options.filter = r.wrapper.find("table").length > 1 && +a > +r._current ? "table.k-month:eq(1) " + ve : "table.k-month:eq(0) " + ve, r._class(ce, a), r._current = a, r._rangeSelection(r._cellByDate(r._view.toDateString(a), ve), a), r.trigger(le), r.selectable.options.filter = "table.k-month:eq(0) " + ve, t) : (r._selectDates = [], n = r.selectable._lastActive ? F(r.selectable._lastActive.find("a")) : a, l = u(n, new Date((+a))), d(r._selectDates, l, n, r.options.disableDates), r.navigate(a), r._current = a, r.selectable._lastActive = r.selectable._lastActive || r._cellByDate(r._view.toDateString(a), ve), r.trigger(le), t)
                },
                _keyboardToggleSelection: function(t) {
                    var a = this;
                    t.currentTarget = a._cell[0], a.selectable._lastActive = e(a._cell[0]), e(a._cell[0]).hasClass(me) ? (a.selectable._unselect(e(a._cell[0])), a.selectable.trigger(le, {
                        event: t
                    })) : a.selectable.value(e(a._cell[0]), {
                        event: t
                    })
                },
                _nextNavigatable: function(e, t) {
                    var a = this,
                        n = !0,
                        l = a._view,
                        r = a.options.min,
                        i = a.options.max,
                        o = a.options.disableDates,
                        c = new Date(e.getTime());
                    for (l.setDate(c, -t); n;) {
                        if (l.setDate(e, t), !s(e, r, i)) {
                            e = c;
                            break
                        }
                        n = o(e)
                    }
                    return e
                },
                _animate: function(e) {
                    var t = this,
                        a = e.from,
                        n = e.to,
                        l = t._active,
                        r = t.element.children(".k-calendar-view");
                    a ? a.parent().data("animating") ? (a.off(Q), a.parent().kendoStop(!0, !0).remove(), a.remove(), r.append(n), t._focusView(l)) : !a.is(":visible") || t.options.animation === !1 || e.replace ? (n.insertAfter(a), a.off(Q).remove(), t._focusView(l)) : t[e.vertical ? "_vertical" : "_horizontal"](a, n, e.future) : (r.append(n), t._bindTable(n))
                },
                _horizontal: function(e, t, a) {
                    var n = this,
                        l = n._active,
                        r = n.options.animation.horizontal,
                        i = r.effects,
                        s = L(e);
                    i && i.indexOf(te) != -1 && (e.add(t).css({
                        width: s
                    }), e.wrap("<div/>"), n._focusView(l, e), e.parent().css({
                        position: "relative",
                        width: 2 * s,
                        "float": ee,
                        "margin-left": a ? 0 : -s
                    }), t[a ? "insertAfter" : "insertBefore"](e), Ne(r, {
                        effects: te + ":" + (a ? "right" : ee),
                        complete: function() {
                            e.off(Q).remove(), n._oldTable = null, t.unwrap(), n._focusView(l)
                        }
                    }), e.parent().kendoStop(!0, !0).kendoAnimate(r))
                },
                _vertical: function(e, t) {
                    var a, n, l = this,
                        r = l.options.animation.vertical,
                        i = r.effects,
                        s = l._active;
                    i && i.indexOf("zoom") != -1 && (t.insertBefore(e), e.css({
                        position: "absolute",
                        width: t.width()
                    }), R && (a = l._cellByDate(l._view.toDateString(l._current)), n = a.position(), n = n.left + parseInt(a.width() / 2, 10) + "px " + (n.top + parseInt(a.height() / 2, 10) + "px"), t.css(R, n)), e.kendoStop(!0, !0).kendoAnimate({
                        effects: "fadeOut",
                        duration: 600,
                        complete: function() {
                            e.off(Q).remove(), l._oldTable = null, l._focusView(s)
                        }
                    }), t.kendoStop(!0, !0).kendoAnimate(r))
                },
                _cellByDate: function(t, a) {
                    return this._table.find(a ? a : "td:not(." + ue + ")").filter(function() {
                        return e(this.firstChild).attr(T.attr(ie)) === t
                    })
                },
                _class: function(e, t) {
                    var a, n = this,
                        l = n._cellID,
                        r = n._cell,
                        i = n._view.toDateString(t);
                    r && r.length && (r[0].removeAttribute(xe), r[0].removeAttribute(Ye), r[0].removeAttribute(Z)), t && "month" == n._view.name && (a = n.options.disableDates(t)), n._cellsBySelector(n._isMultipleSelection() ? _e : "td:not(." + ue + ")").removeClass(e), r = n._cellByDate(i, "multiple" == n.options.selectable ? _e : "td:not(." + ue + ")").attr(xe, !0), (e === ce && !n._active && n.options.focusOnNav !== !1 || a) && (e = ""), r.addClass(e), r[0] && (n._cell = r), l && (r.attr(Z, l), n._table[0].removeAttribute("aria-activedescendant"), n._table.attr("aria-activedescendant", l))
                },
                _bindTable: function(e) {
                    e.on(ke, this._addClassProxy).on(pe, this._removeClassProxy)
                },
                _click: function(e) {
                    var t = this,
                        a = t.options,
                        n = new Date((+t._current)),
                        l = F(e);
                    V(l, 0), "month" == t._view.name && t.options.disableDates(l) && (l = t._value), t._view.setDate(n, l), t.navigateDown(i(n, a.min, a.max))
                },
                _focus: function(e) {
                    var t = this,
                        a = t._view;
                    0 !== a.compare(e, t._current) ? t.navigate(e) : (t._current = e, t._class(ce, e))
                },
                _focusView: function(e, t) {
                    e && this.focus(t)
                },
                _viewWrapper: function() {
                    var t = this,
                        a = t.element,
                        n = a.children(".k-calendar-view");
                    n[0] || (n = e("<div class='k-calendar-view' />").insertAfter(a.find(".k-header")))
                },
                _footer: function(a) {
                    var n = this,
                        l = r(),
                        i = n.element,
                        s = i.find(".k-footer");
                    return a ? (s[0] || (s = e('<div class="k-footer"><a href="#" class="k-link k-nav-today"></a></div>').appendTo(i)), n._today = s.show().find(".k-link").html(a(l)).attr("title", T.toString(l, "D", n.options.culture)), n._toggle(), t) : (n._toggle(!1), s.hide(), t)
                },
                _header: function() {
                    var e, t = this,
                        a = t.element;
                    a.find(".k-header")[0] || a.html('<div class="k-header"><a href="#" role="button" class="k-link k-nav-prev" ' + Ye + '="Previous"><span class="k-icon k-i-arrow-60-left"></span></a><a href="#" role="button" aria-live="assertive" aria-atomic="true" class="k-link k-nav-fast"></a><a href="#" role="button" class="k-link k-nav-next" ' + Ye + '="Next"><span class="k-icon k-i-arrow-60-right"></span></a></div>'), e = a.find(".k-link").on(we + " " + ye + " " + ke + " " + pe, f).on(J + " touchend" + Q, function() {
                        return !1
                    }), t._title = e.eq(1).on(J + " touchend" + Q, function() {
                        t._active = t.options.focusOnNav !== !1, t.navigateUp()
                    }), t[Fe] = e.eq(0).on(J + " touchend" + Q, function() {
                        t._active = t.options.focusOnNav !== !1, t.navigateToPast()
                    }), t[Me] = e.eq(2).on(J + " touchend" + Q, function() {
                        t._active = t.options.focusOnNav !== !1, t.navigateToFuture()
                    })
                },
                _navigate: function(e, t) {
                    var a, n = this,
                        l = n._index + 1,
                        r = new Oe((+n._current));
                    n._isMultipleSelection() && (a = n._table.find("td:not(.k-other-month):not(.k-out-of-range)").has(".k-link").first(), r = F(a.find("a")), n._current = new Date((+r))), e = n[e], e.hasClass(oe) || (l > 3 ? r.setFullYear(r.getFullYear() + 100 * t) : M.views[l].setDate(r, t), n.navigate(r))
                },
                _option: function(e, a) {
                    var n, l = this,
                        r = l.options,
                        i = l._value || l._current;
                    return a === t ? r[e] : (a = O(a, r.format, r.culture), a && (r[e] = new Oe((+a)), n = e === $ ? a > i : i > a, (n || D(i, a)) && (n && (l._value = null), l._changeView = !0), l._changeView || (l._changeView = !(!r.month.content && !r.month.empty)), l.navigate(l._value), l._toggle()), t)
                },
                _toggle: function(e) {
                    var a = this,
                        n = a.options,
                        l = a.options.disableDates(r()),
                        i = a._today;
                    e === t && (e = s(r(), n.min, n.max)), i && (i.off(J), e && !l ? i.addClass(ge).removeClass(oe).on(J, Ae(a._todayClick, a)) : i.removeClass(ge).addClass(oe).on(J, g))
                },
                _todayClick: function(e) {
                    var t = this,
                        a = Ve[t.options.depth],
                        n = t.options.disableDates,
                        l = r();
                    e.preventDefault(), n(l) || (0 === t._view.compare(t._current, l) && t._index == a && (t._changeView = !1), t._isMultipleSelection() && (t._selectDates = [l], t.selectable._lastActive = null), t._value = l, t.navigate(l, a), t.trigger(le))
                },
                _templates: function() {
                    var e = this,
                        t = e.options,
                        a = t.footer,
                        n = t.month,
                        l = n.content,
                        r = n.weekNumber,
                        i = n.empty,
                        s = '#= kendo.toString(data,"D","' + t.culture + '") #';
                    e.month = {
                        content: W('<td#=data.cssClass# role="gridcell"><a tabindex="-1" class="k-link#=data.linkClass#" href="#=data.url#" ' + T.attr(ie) + '="#=data.dateString#" title="#=data.title#">' + (l || "#=data.value#") + "</a></td>", {
                            useWithBlock: !!l
                        }),
                        empty: W('<td role="gridcell">' + (i || "&nbsp;") + "</td>", {
                            useWithBlock: !!i
                        }),
                        weekNumber: W('<td class="k-alt">' + (r || "#= data.weekNumber #") + "</td>", {
                            useWithBlock: !!r
                        })
                    }, a && a !== !0 && (s = a), e.footer = a !== !1 ? W(s, {
                        useWithBlock: !1
                    }) : null
                }
            });
        Y.plugin(Be), M = {
            firstDayOfMonth: function(e) {
                return _(e.getFullYear(), e.getMonth(), 1)
            },
            firstVisibleDay: function(e, t) {
                t = t || T.culture().calendar;
                var a = t.firstDay,
                    n = new Oe(e.getFullYear(), e.getMonth(), 1, e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds());
                for (n.setFullYear(e.getFullYear()); n.getDay() != a;) M.setTime(n, -1 * Ce);
                return n
            },
            setTime: function(e, t) {
                var a = e.getTimezoneOffset(),
                    n = new Oe(e.getTime() + t),
                    l = n.getTimezoneOffset() - a;
                e.setTime(n.getTime() + l * Se)
            },
            views: [{
                name: ae,
                title: function(e, t, a, n) {
                    return v(n).months.names[e.getMonth()] + " " + e.getFullYear()
                },
                content: function(e) {
                    var t = this,
                        a = 0,
                        l = e.min,
                        i = e.max,
                        s = e.date,
                        c = e.dates,
                        u = e.format,
                        d = e.culture,
                        f = e.url,
                        g = e.showHeader,
                        h = e.otherMonth,
                        m = e.isWeekColumnVisible,
                        p = f && c[0],
                        k = v(d),
                        D = k.firstDay,
                        w = k.days,
                        y = o(w.names, D),
                        S = o(w.namesShort, D),
                        C = M.firstVisibleDay(s, k),
                        F = t.first(s),
                        x = t.last(s),
                        Y = t.toDateString,
                        A = r(),
                        N = '<table tabindex="0" role="grid" class="k-content" cellspacing="0" data-start="' + Y(C) + '">';
                    for (N += g ? '<caption class="k-month-header">' + this.title(s, l, i, d) + '</caption><thead><tr role="row">' : '<thead><tr role="row">', m && (N += '<th scope="col" class="k-alt">' + e.messages.weekColumnHeader + "</th>"); a < 7; a++) N += '<th scope="col" title="' + y[a] + '">' + S[a] + "</th>";
                    return V(A, 0), A = +A, n({
                        cells: 42,
                        perRow: 7,
                        html: N += '</tr></thead><tbody><tr role="row">',
                        start: C,
                        isWeekColumnVisible: m,
                        weekNumber: e.weekNumber,
                        min: _(l.getFullYear(), l.getMonth(), l.getDate()),
                        max: _(i.getFullYear(), i.getMonth(), i.getDate()),
                        otherMonth: h,
                        content: e.content,
                        lastDayOfMonth: x,
                        empty: e.empty,
                        setter: t.setDate,
                        disableDates: e.disableDates,
                        build: function(e, t, a) {
                            var n = [],
                                l = e.getDay(),
                                r = "",
                                i = "#";
                            return (e < F || e > x) && n.push(ue), a(e) && n.push(oe), +e === A && n.push("k-today"), 0 !== l && 6 !== l || n.push("k-weekend"), p && b(+e, c) && (i = f.replace("{0}", T.toString(e, u, d)), r = " k-action-link"), {
                                date: e,
                                dates: c,
                                ns: T.ns,
                                title: T.toString(e, "D", d),
                                value: e.getDate(),
                                dateString: Y(e),
                                cssClass: n[0] ? ' class="' + n.join(" ") + '"' : "",
                                linkClass: r,
                                url: i
                            }
                        },
                        weekNumberBuild: function(e) {
                            return {
                                weekNumber: B(e, T.culture().calendar.firstDay),
                                currentDate: e
                            }
                        }
                    })
                },
                first: function(e) {
                    return M.firstDayOfMonth(e)
                },
                last: function(e) {
                    var t = _(e.getFullYear(), e.getMonth() + 1, 0),
                        a = M.firstDayOfMonth(e),
                        n = Math.abs(t.getTimezoneOffset() - a.getTimezoneOffset());
                    return n && t.setHours(a.getHours() + n / 60), t
                },
                compare: function(e, t) {
                    var a, n = e.getMonth(),
                        l = e.getFullYear(),
                        r = t.getMonth(),
                        i = t.getFullYear();
                    return a = l > i ? 1 : l < i ? -1 : n == r ? 0 : n > r ? 1 : -1
                },
                setDate: function(e, t) {
                    var a = e.getHours();
                    t instanceof Oe ? e.setFullYear(t.getFullYear(), t.getMonth(), t.getDate()) : M.setTime(e, t * Ce), V(e, a)
                },
                toDateString: function(e) {
                    return e.getFullYear() + "/" + e.getMonth() + "/" + e.getDate()
                }
            }, {
                name: "year",
                title: function(e) {
                    return e.getFullYear()
                },
                content: function(e) {
                    var t = v(e.culture).months.namesAbbr,
                        a = this.toDateString,
                        l = e.min,
                        r = e.max,
                        i = "";
                    return e.showHeader && (i += '<table tabindex="0" role="grid" class="k-content k-meta-view" cellspacing="0"><caption class="k-meta-header">', i += this.title(e.date), i += '</caption><tbody><tr role="row">'), n({
                        min: _(l.getFullYear(), l.getMonth(), 1),
                        max: _(r.getFullYear(), r.getMonth(), 1),
                        start: _(e.date.getFullYear(), 0, 1),
                        html: i,
                        setter: this.setDate,
                        build: function(e) {
                            return {
                                value: t[e.getMonth()],
                                ns: T.ns,
                                dateString: a(e),
                                cssClass: ""
                            }
                        }
                    })
                },
                first: function(e) {
                    return _(e.getFullYear(), 0, e.getDate())
                },
                last: function(e) {
                    return _(e.getFullYear(), 11, e.getDate())
                },
                compare: function(e, t) {
                    return l(e, t)
                },
                setDate: function(e, t) {
                    var a, n = e.getHours();
                    t instanceof Oe ? (a = t.getMonth(), e.setFullYear(t.getFullYear(), a, e.getDate()), a !== e.getMonth() && e.setDate(0)) : (a = e.getMonth() + t, e.setMonth(a), a > 11 && (a -= 12), a > 0 && e.getMonth() != a && e.setDate(0)), V(e, n)
                },
                toDateString: function(e) {
                    return e.getFullYear() + "/" + e.getMonth() + "/1"
                }
            }, {
                name: "decade",
                title: function(e, t, n) {
                    return a(e, t, n, 10)
                },
                content: function(e) {
                    var t = e.date.getFullYear(),
                        a = this.toDateString,
                        l = "";
                    return e.showHeader && (l += '<table tabindex="0" role="grid" class="k-content k-meta-view" cellspacing="0"><caption class="k-meta-header">', l += this.title(e.date, e.min, e.max), l += '</caption><tbody><tr role="row">'), n({
                        start: _(t - t % 10 - 1, 0, 1),
                        min: _(e.min.getFullYear(), 0, 1),
                        max: _(e.max.getFullYear(), 0, 1),
                        otherMonth: e.otherMonth,
                        html: l,
                        setter: this.setDate,
                        build: function(e, t) {
                            return {
                                value: e.getFullYear(),
                                ns: T.ns,
                                dateString: a(e),
                                cssClass: 0 === t || 11 == t ? de : ""
                            }
                        }
                    })
                },
                first: function(e) {
                    var t = e.getFullYear();
                    return _(t - t % 10, e.getMonth(), e.getDate())
                },
                last: function(e) {
                    var t = e.getFullYear();
                    return _(t - t % 10 + 9, e.getMonth(), e.getDate())
                },
                compare: function(e, t) {
                    return l(e, t, 10)
                },
                setDate: function(e, t) {
                    c(e, t, 1)
                },
                toDateString: function(e) {
                    return e.getFullYear() + "/0/1"
                }
            }, {
                name: ne,
                title: function(e, t, n) {
                    return a(e, t, n, 100)
                },
                content: function(e) {
                    var t = e.date.getFullYear(),
                        a = e.min.getFullYear(),
                        l = e.max.getFullYear(),
                        r = this.toDateString,
                        i = a,
                        s = l,
                        o = "";
                    return i -= i % 10, s -= s % 10, s - i < 10 && (s = i + 9), e.showHeader && (o += '<table tabindex="0" role="grid" class="k-content k-meta-view" cellspacing="0"><caption class="k-meta-header">', o += this.title(e.date, e.min, e.max), o += '</caption><tbody><tr role="row">'), n({
                        start: _(t - t % 100 - 10, 0, 1),
                        min: _(i, 0, 1),
                        max: _(s, 0, 1),
                        otherMonth: e.otherMonth,
                        html: o,
                        setter: this.setDate,
                        build: function(e, t) {
                            var n = e.getFullYear(),
                                i = n + 9;
                            return n < a && (n = a), i > l && (i = l), {
                                ns: T.ns,
                                value: n + " - " + i,
                                dateString: r(e),
                                cssClass: 0 === t || 11 == t ? de : ""
                            }
                        }
                    })
                },
                first: function(e) {
                    var t = e.getFullYear();
                    return _(t - t % 100, e.getMonth(), e.getDate())
                },
                last: function(e) {
                    var t = e.getFullYear();
                    return _(t - t % 100 + 99, e.getMonth(), e.getDate())
                },
                compare: function(e, t) {
                    return l(e, t, 100)
                },
                setDate: function(e, t) {
                    c(e, t, 10)
                },
                toDateString: function(e) {
                    var t = e.getFullYear();
                    return t - t % 10 + "/0/1"
                }
            }]
        }, M.isEqualDatePart = k, M.isEqualDate = C, M.makeUnselectable = m, M.restrictValue = i, M.isInRange = s, M.addClassToViewContainer = p, M.normalize = h, M.viewsEnum = Ve, M.disabled = w, M.toDateObject = F, M.getToday = r, M.createDate = _, T.calendar = M
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, a) {
    (a || t)()
});;
! function(e, define) {
    define("kendo.slider.min", ["kendo.draganddrop.min"], e)
}(function() {
    return function(e, t) {
        function n(e, t, n) {
            var i = n ? " k-slider-horizontal" : " k-slider-vertical",
                a = e.style ? e.style : t.attr("style"),
                o = t.attr("class") ? " " + t.attr("class") : "",
                r = "";
            return "bottomRight" == e.tickPlacement ? r = " k-slider-bottomright" : "topLeft" == e.tickPlacement && (r = " k-slider-topleft"), a = a ? " style='" + a + "'" : "", "<div class='k-widget k-slider" + i + o + "'" + a + "><div class='k-slider-wrap" + (e.showButtons ? " k-slider-buttons" : "") + r + "'></div></div>"
        }

        function i(e, t, n, i) {
            var a = "";
            return a = n ? !i && "increase" == t || i && "increase" != t ? "k-i-arrow-60-right" : "k-i-arrow-60-left" : "increase" == t ? "k-i-arrow-60-up" : "k-i-arrow-60-down", "<a class='k-button k-button-" + t + "' title='" + e[t + "ButtonTitle"] + "' aria-label='" + e[t + "ButtonTitle"] + "'><span class='k-icon " + a + "'></span></a>"
        }

        function a(e, t) {
            var n, i = "<ul class='k-reset k-slider-items'>",
                a = H.floor(u(t / e.smallStep)) + 1;
            for (n = 0; n < a; n++) i += "<li class='k-tick' role='presentation'>&nbsp;</li>";
            return i += "</ul>"
        }

        function o(e, t) {
            var n = t.is("input") ? 1 : 2,
                i = 2 == n ? e.leftDragHandleTitle : e.dragHandleTitle;
            return "<div class='k-slider-track'><div class='k-slider-selection'><!-- --></div><a href='#' class='k-draghandle' title='" + i + "' role='slider' aria-valuemin='" + e.min + "' aria-valuemax='" + e.max + "' aria-valuenow='" + (n > 1 ? e.selectionStart || e.min : e.value || e.min) + "'></a>" + (n > 1 ? "<a href='#' class='k-draghandle' title='" + e.rightDragHandleTitle + "'role='slider' aria-valuemin='" + e.min + "' aria-valuemax='" + e.max + "' aria-valuenow='" + (e.selectionEnd || e.max) + "'></a>" : "") + "</div>"
        }

        function r(e) {
            return function(t) {
                return t + e
            }
        }

        function l(e) {
            return function() {
                return e
            }
        }

        function s(e) {
            return (e + "").replace(".", m.cultures.current.numberFormat["."])
        }

        function d(e) {
            var t = "" + e,
                n = 0;
            return t = t.split("."), t[1] && (n = t[1].length), n = n > 10 ? 10 : n
        }

        function u(e) {
            var t, n;
            return e = parseFloat(e, 10), t = d(e), n = H.pow(10, t || 0), H.round(e * n) / n
        }

        function p(e, n) {
            var i = x(e.getAttribute(n));
            return null === i && (i = t), i
        }

        function c(e) {
            return typeof e !== Q
        }

        function f(e) {
            return 1e4 * e
        }
        var _, m = window.kendo,
            v = m.ui.Widget,
            h = m.ui.Draggable,
            g = m._outerWidth,
            w = m._outerHeight,
            k = e.extend,
            S = m.format,
            x = m.parseFloat,
            D = e.proxy,
            b = e.isArray,
            H = Math,
            T = m.support,
            y = T.pointers,
            z = T.msPointers,
            I = "change",
            E = "slide",
            C = ".slider",
            F = "touchstart" + C + " mousedown" + C,
            R = y ? "pointerdown" + C : z ? "MSPointerDown" + C : F,
            A = "touchend" + C + " mouseup" + C,
            V = y ? "pointerup" : z ? "MSPointerUp" + C : A,
            q = "moveSelection",
            M = "keydown" + C,
            P = "click" + C,
            W = "mouseover" + C,
            N = "focus" + C,
            O = "blur" + C,
            B = ".k-draghandle",
            L = ".k-slider-track",
            Z = ".k-tick",
            U = "k-state-selected",
            X = "k-state-focused",
            Y = "k-state-default",
            j = "k-state-disabled",
            K = "disabled",
            Q = "undefined",
            G = "tabindex",
            J = m.getTouches,
            $ = v.extend({
                init: function(e, t) {
                    var n, i = this;
                    if (v.fn.init.call(i, e, t), t = i.options, i._isHorizontal = "horizontal" == t.orientation, i._isRtl = i._isHorizontal && m.support.isRtl(e), i._position = i._isHorizontal ? "left" : "bottom", i._sizeFn = i._isHorizontal ? "width" : "height", i._outerSize = i._isHorizontal ? g : w, t.tooltip.format = t.tooltip.enabled ? t.tooltip.format || "{0}" : "{0}", t.smallStep <= 0) throw Error("Kendo UI Slider smallStep must be a positive number.");
                    i._createHtml(), i.wrapper = i.element.closest(".k-slider"), i._trackDiv = i.wrapper.find(L), i._setTrackDivWidth(), i._maxSelection = i._trackDiv[i._sizeFn](), i._sliderItemsInit(), i._reset(), i._tabindex(i.wrapper.find(B)), i[t.enabled ? "enable" : "disable"](), n = m.support.isRtl(i.wrapper) ? -1 : 1, i._keyMap = {
                        37: r(-1 * n * t.smallStep),
                        40: r(-t.smallStep),
                        39: r(1 * n * t.smallStep),
                        38: r(+t.smallStep),
                        35: l(t.max),
                        36: l(t.min),
                        33: r(+t.largeStep),
                        34: r(-t.largeStep)
                    }, m.notify(i)
                },
                events: [I, E],
                options: {
                    enabled: !0,
                    min: 0,
                    max: 10,
                    smallStep: 1,
                    largeStep: 5,
                    orientation: "horizontal",
                    tickPlacement: "both",
                    tooltip: {
                        enabled: !0,
                        format: "{0}"
                    }
                },
                _distance: function() {
                    return u(this.options.max - this.options.min)
                },
                _resize: function() {
                    this._setTrackDivWidth(), this.wrapper.find(".k-slider-items").remove(), this._maxSelection = this._trackDiv[this._sizeFn](), this._sliderItemsInit(), this._refresh(), this.options.enabled && this.enable(!0)
                },
                _sliderItemsInit: function() {
                    var t = this,
                        n = t.options,
                        i = t._maxSelection / ((n.max - n.min) / n.smallStep),
                        o = t._calculateItemsWidth(H.floor(t._distance() / n.smallStep));
                    "none" != n.tickPlacement && i >= 2 && (e(this.element).parent().find(".k-slider-items").remove(), t._trackDiv.before(a(n, t._distance())), t._setItemsWidth(o), t._setItemsTitle()), t._calculateSteps(o), "none" != n.tickPlacement && i >= 2 && n.largeStep >= n.smallStep && t._setItemsLargeTick()
                },
                getSize: function() {
                    return m.dimensions(this.wrapper)
                },
                _setTrackDivWidth: function() {
                    var e = this,
                        t = 2 * parseFloat(e._trackDiv.css(e._isRtl ? "right" : e._position), 10);
                    e._trackDiv[e._sizeFn](e.wrapper[e._sizeFn]() - 2 - t)
                },
                _setItemsWidth: function(t) {
                    var n, i = this,
                        a = i.options,
                        o = 0,
                        r = t.length - 1,
                        l = i.wrapper.find(Z),
                        s = 0,
                        d = 2,
                        u = l.length,
                        p = 0;
                    for (n = 0; n < u - 2; n++) e(l[n + 1])[i._sizeFn](t[n]);
                    if (i._isHorizontal ? (e(l[o]).addClass("k-first")[i._sizeFn](t[r - 1]), e(l[r]).addClass("k-last")[i._sizeFn](t[r])) : (e(l[r]).addClass("k-first")[i._sizeFn](t[r]), e(l[o]).addClass("k-last")[i._sizeFn](t[r - 1])), i._distance() % a.smallStep !== 0 && !i._isHorizontal) {
                        for (n = 0; n < t.length; n++) p += t[n];
                        s = i._maxSelection - p, s += parseFloat(i._trackDiv.css(i._position), 10) + d, i.wrapper.find(".k-slider-items").css("padding-top", s)
                    }
                },
                _setItemsTitle: function() {
                    for (var t = this, n = t.options, i = t.wrapper.find(Z), a = n.min, o = i.length, r = t._isHorizontal && !t._isRtl ? 0 : o - 1, l = t._isHorizontal && !t._isRtl ? o : -1, s = t._isHorizontal && !t._isRtl ? 1 : -1; r - l !== 0; r += s) e(i[r]).attr("title", S(n.tooltip.format, u(a))), a += n.smallStep
                },
                _setItemsLargeTick: function() {
                    var t, n, i, a = this,
                        o = a.options,
                        r = a.wrapper.find(Z),
                        l = 0;
                    if (f(o.largeStep) % f(o.smallStep) === 0 || a._distance() / o.largeStep >= 3)
                        for (a._isHorizontal || a._isRtl || (r = e.makeArray(r).reverse()), l = 0; l < r.length; l++) t = e(r[l]), n = a._values[l], i = u(f(n - this.options.min)), i % f(o.smallStep) === 0 && i % f(o.largeStep) === 0 && (t.addClass("k-tick-large").html("<span class='k-label'>" + t.attr("title") + "</span>"), 0 !== l && l !== r.length - 1 && t.css("line-height", t[a._sizeFn]() + "px"))
                },
                _calculateItemsWidth: function(e) {
                    var t, n, i, a = this,
                        o = a.options,
                        r = parseFloat(a._trackDiv.css(a._sizeFn)) + 1,
                        l = a._distance(),
                        s = r / l;
                    for (l / o.smallStep - H.floor(l / o.smallStep) > 0 && (r -= l % o.smallStep * s), t = r / e, n = [], i = 0; i < e - 1; i++) n[i] = t;
                    return n[e - 1] = n[e] = t / 2, a._roundWidths(n)
                },
                _roundWidths: function(e) {
                    var t, n = 0,
                        i = e.length;
                    for (t = 0; t < i; t++) n += e[t] - H.floor(e[t]), e[t] = H.floor(e[t]);
                    return n = H.round(n), this._addAdditionalSize(n, e)
                },
                _addAdditionalSize: function(e, t) {
                    if (0 === e) return t;
                    var n, i = parseFloat(t.length - 1) / parseFloat(1 == e ? e : e - 1);
                    for (n = 0; n < e; n++) t[parseInt(H.round(i * n), 10)] += 1;
                    return t
                },
                _calculateSteps: function(e) {
                    var t, n = this,
                        i = n.options,
                        a = i.min,
                        o = 0,
                        r = n._distance(),
                        l = H.ceil(r / i.smallStep),
                        s = 1;
                    if (l += r / i.smallStep % 1 === 0 ? 1 : 0, e.splice(0, 0, 2 * e[l - 2]), e.splice(l - 1, 1, 2 * e.pop()), n._pixelSteps = [o], n._values = [a], 0 !== l) {
                        for (; s < l;) o += (e[s - 1] + e[s]) / 2, n._pixelSteps[s] = o, a += i.smallStep, n._values[s] = u(a), s++;
                        t = r % i.smallStep === 0 ? l - 1 : l, n._pixelSteps[t] = n._maxSelection, n._values[t] = i.max, n._isRtl && (n._pixelSteps.reverse(), n._values.reverse())
                    }
                },
                _getValueFromPosition: function(e, t) {
                    var n, i = this,
                        a = i.options,
                        o = H.max(a.smallStep * (i._maxSelection / i._distance()), 0),
                        r = 0,
                        l = o / 2;
                    if (i._isHorizontal ? (r = e - t.startPoint, i._isRtl && (r = i._maxSelection - r)) : r = t.startPoint - e, i._maxSelection - (parseInt(i._maxSelection % o, 10) - 3) / 2 < r) return a.max;
                    for (n = 0; n < i._pixelSteps.length; n++)
                        if (H.abs(i._pixelSteps[n] - r) - 1 <= l) return u(i._values[n])
                },
                _getFormattedValue: function(e, t) {
                    var n, i, a, o = this,
                        r = "",
                        l = o.options.tooltip;
                    return b(e) ? (i = e[0], a = e[1]) : t && t.type && (i = t.selectionStart, a = t.selectionEnd), t && (n = t.tooltipTemplate), !n && l.template && (n = m.template(l.template)), b(e) || t && t.type ? n ? r = n({
                        selectionStart: i,
                        selectionEnd: a
                    }) : (i = S(l.format, i), a = S(l.format, a), r = i + " - " + a) : (t && (t.val = e), r = n ? n({
                        value: e
                    }) : S(l.format, e)), r
                },
                _getDraggableArea: function() {
                    var e = this,
                        t = m.getOffset(e._trackDiv);
                    return {
                        startPoint: e._isHorizontal ? t.left : t.top + e._maxSelection,
                        endPoint: e._isHorizontal ? t.left + e._maxSelection : t.top
                    }
                },
                _createHtml: function() {
                    var e = this,
                        t = e.element,
                        a = e.options,
                        r = t.find("input");
                    2 == r.length ? (r.eq(0).prop("value", s(a.selectionStart)), r.eq(1).prop("value", s(a.selectionEnd))) : t.prop("value", s(a.value)), t.wrap(n(a, t, e._isHorizontal)).hide(), a.showButtons && t.before(i(a, "increase", e._isHorizontal, e._isRtl)).before(i(a, "decrease", e._isHorizontal, e._isRtl)), t.before(o(a, t))
                },
                _focus: function(t) {
                    var n = this,
                        i = t.target,
                        a = n.value(),
                        o = n._drag;
                    o || (i == n.wrapper.find(B).eq(0)[0] ? (o = n._firstHandleDrag, n._activeHandle = 0) : (o = n._lastHandleDrag, n._activeHandle = 1), a = a[n._activeHandle]), e(i).addClass(X + " " + U), o && (n._activeHandleDrag = o, o.selectionStart = n.options.selectionStart, o.selectionEnd = n.options.selectionEnd, o._updateTooltip(a))
                },
                _focusWithMouse: function(t) {
                    t = e(t);
                    var n = this,
                        i = t.is(B) ? t.index() : 0;
                    window.setTimeout(function() {
                        n.wrapper.find(B)[2 == i ? 1 : 0].focus()
                    }, 1), n._setTooltipTimeout()
                },
                _blur: function(t) {
                    var n = this,
                        i = n._activeHandleDrag;
                    e(t.target).removeClass(X + " " + U), i && (i._removeTooltip(), delete n._activeHandleDrag, delete n._activeHandle)
                },
                _setTooltipTimeout: function() {
                    var e = this;
                    e._tooltipTimeout = window.setTimeout(function() {
                        var t = e._drag || e._activeHandleDrag;
                        t && t._removeTooltip()
                    }, 300)
                },
                _clearTooltipTimeout: function() {
                    var e, t = this;
                    window.clearTimeout(this._tooltipTimeout), e = t._drag || t._activeHandleDrag, e && e.tooltipDiv && e.tooltipDiv.stop(!0, !1).css("opacity", 1)
                },
                _reset: function() {
                    var t = this,
                        n = t.element,
                        i = n.attr("form"),
                        a = i ? e("#" + i) : n.closest("form");
                    a[0] && (t._form = a.on("reset", D(t._formResetHandler, t)))
                },
                min: function(e) {
                    return e ? (this.setOptions({
                        min: e
                    }), t) : this.options.min
                },
                max: function(e) {
                    return e ? (this.setOptions({
                        max: e
                    }), t) : this.options.max
                },
                setOptions: function(e) {
                    v.fn.setOptions.call(this, e), this._sliderItemsInit(), this._refresh()
                },
                destroy: function() {
                    this._form && this._form.off("reset", this._formResetHandler), v.fn.destroy.call(this)
                }
            }),
            ee = $.extend({
                init: function(n, i) {
                    var a, o = this;
                    n.type = "text", i = k({}, {
                        value: p(n, "value"),
                        min: p(n, "min"),
                        max: p(n, "max"),
                        smallStep: p(n, "step")
                    }, i), n = e(n), i && i.enabled === t && (i.enabled = !n.is("[disabled]")), $.fn.init.call(o, n, i), i = o.options, c(i.value) && null !== i.value || (i.value = i.min, n.prop("value", s(i.min))), i.value = H.max(H.min(i.value, i.max), i.min), a = o.wrapper.find(B), this._selection = new ee.Selection(a, o, i), o._drag = new ee.Drag(a, "", o, i)
                },
                options: {
                    name: "Slider",
                    showButtons: !0,
                    increaseButtonTitle: "Increase",
                    decreaseButtonTitle: "Decrease",
                    dragHandleTitle: "drag",
                    tooltip: {
                        format: "{0:#,#.##}"
                    },
                    value: null
                },
                enable: function(n) {
                    var i, a, o, r = this,
                        l = r.options;
                    r.disable(), n !== !1 && (r.wrapper.removeClass(j).addClass(Y), r.wrapper.find("input").removeAttr(K), i = function(n) {
                        var i, a, o, l = J(n)[0];
                        if (l) {
                            if (i = r._isHorizontal ? l.location.pageX : l.location.pageY, a = r._getDraggableArea(), o = e(n.target), o.hasClass("k-draghandle")) return o.addClass(X + " " + U), t;
                            r._update(r._getValueFromPosition(i, a)), r._focusWithMouse(n.target), r._drag.dragstart(n), n.preventDefault()
                        }
                    }, r.wrapper.find(Z + ", " + L).on(R, i).end().on(R, function() {
                        e(document.documentElement).one("selectstart", m.preventDefault)
                    }).on(V, function() {
                        r._drag._end()
                    }), r.wrapper.find(B).attr(G, 0).on(A, function() {
                        r._setTooltipTimeout()
                    }).on(P, function(e) {
                        r._focusWithMouse(e.target), e.preventDefault()
                    }).on(N, D(r._focus, r)).on(O, D(r._blur, r)), a = D(function(e) {
                        var t = r._nextValueByIndex(r._valueIndex + 1 * e);
                        r._setValueInRange(t), r._drag._updateTooltip(t)
                    }, r), l.showButtons && (o = D(function(e, t) {
                        this._clearTooltipTimeout(), (1 === e.which || T.touch && 0 === e.which) && (a(t), this.timeout = setTimeout(D(function() {
                            this.timer = setInterval(function() {
                                a(t)
                            }, 60)
                        }, this), 200))
                    }, r), r.wrapper.find(".k-button").on(A, D(function(e) {
                        this._clearTimer(), r._focusWithMouse(e.target)
                    }, r)).on(W, function(t) {
                        e(t.currentTarget).addClass("k-state-hover")
                    }).on("mouseout" + C, D(function(t) {
                        e(t.currentTarget).removeClass("k-state-hover"), this._clearTimer()
                    }, r)).eq(0).on(F, D(function(e) {
                        o(e, 1)
                    }, r)).click(!1).end().eq(1).on(F, D(function(e) {
                        o(e, -1)
                    }, r)).click(m.preventDefault)), r.wrapper.find(B).off(M, !1).on(M, D(this._keydown, r)), l.enabled = !0)
                },
                disable: function() {
                    var t = this;
                    t.wrapper.removeClass(Y).addClass(j), e(t.element).prop(K, K), t.wrapper.find(".k-button").off(F).on(F, function(t) {
                        t.preventDefault(), e(this).addClass("k-state-active")
                    }).off(A).on(A, function(t) {
                        t.preventDefault(), e(this).removeClass("k-state-active")
                    }).off("mouseleave" + C).on("mouseleave" + C, m.preventDefault).off(W).on(W, m.preventDefault), t.wrapper.find(Z + ", " + L).off(R).off(V), t.wrapper.find(B).attr(G, -1).off(A).off(M).off(P).off(N).off(O), t.options.enabled = !1
                },
                _update: function(e) {
                    var t = this,
                        n = t.value() != e;
                    t.value(e), n && t.trigger(I, {
                        value: t.options.value
                    })
                },
                value: function(e) {
                    var n = this,
                        i = n.options;
                    return e = u(e), isNaN(e) ? i.value : (e >= i.min && e <= i.max && i.value != e && (n.element.prop("value", s(e)), i.value = e, n._refreshAriaAttr(e), n._refresh()), t)
                },
                _refresh: function() {
                    this.trigger(q, {
                        value: this.options.value
                    })
                },
                _refreshAriaAttr: function(e) {
                    var t, n = this,
                        i = n._drag;
                    t = i && i._tooltipDiv ? i._tooltipDiv.text() : n._getFormattedValue(e, null), this.wrapper.find(B).attr("aria-valuenow", e).attr("aria-valuetext", t)
                },
                _clearTimer: function() {
                    clearTimeout(this.timeout), clearInterval(this.timer)
                },
                _keydown: function(e) {
                    var t = this;
                    e.keyCode in t._keyMap && (t._clearTooltipTimeout(), t._setValueInRange(t._keyMap[e.keyCode](t.options.value)), t._drag._updateTooltip(t.value()), e.preventDefault())
                },
                _setValueInRange: function(e) {
                    var n = this,
                        i = n.options;
                    return e = u(e), isNaN(e) ? (n._update(i.min), t) : (e = H.max(H.min(e, i.max), i.min), n._update(e), t)
                },
                _nextValueByIndex: function(e) {
                    var t = this._values.length;
                    return this._isRtl && (e = t - 1 - e), this._values[H.max(0, H.min(e, t - 1))]
                },
                _formResetHandler: function() {
                    var e = this,
                        t = e.options.min;
                    setTimeout(function() {
                        var n = e.element[0].value;
                        e.value("" === n || isNaN(n) ? t : n)
                    })
                },
                destroy: function() {
                    var e = this;
                    $.fn.destroy.call(e), e.wrapper.off(C).find(".k-button").off(C).end().find(B).off(C).end().find(Z + ", " + L).off(C).end(), e._drag.draggable.destroy(), e._drag._removeTooltip(!0)
                }
            });
        ee.Selection = function(e, t, n) {
            function i(i) {
                var a = i - n.min,
                    o = t._valueIndex = H.ceil(u(a / n.smallStep)),
                    r = parseInt(t._pixelSteps[o], 10),
                    l = t._trackDiv.find(".k-slider-selection"),
                    s = parseInt(t._outerSize(e) / 2, 10),
                    d = t._isRtl ? 2 : 0;
                l[t._sizeFn](t._isRtl ? t._maxSelection - r : r), e.css(t._position, r - s - d)
            }
            i(n.value), t.bind([E, q], function(e) {
                i(parseFloat(e.value, 10))
            }), t.bind(I, function(e) {
                i(parseFloat(e.sender.value(), 10))
            })
        }, ee.Drag = function(e, t, n, i) {
            var a = this;
            a.owner = n, a.options = i, a.element = e, a.type = t, a.draggable = new h(e, {
                distance: 0,
                dragstart: D(a._dragstart, a),
                drag: D(a.drag, a),
                dragend: D(a.dragend, a),
                dragcancel: D(a.dragcancel, a)
            }), e.click(!1), e.on("dragstart", function(e) {
                e.preventDefault()
            })
        }, ee.Drag.prototype = {
            dragstart: function(e) {
                this.owner._activeDragHandle = this, this.draggable.userEvents.cancel(), this._dragstart(e), this.dragend()
            },
            _dragstart: function(n) {
                var i = this,
                    a = i.owner,
                    o = i.options;
                return o.enabled ? (this.owner._activeDragHandle = this, a.element.off(W), a.wrapper.find("." + X).removeClass(X + " " + U), i.element.addClass(X + " " + U), e(document.documentElement).css("cursor", "pointer"), i.dragableArea = a._getDraggableArea(), i.step = H.max(o.smallStep * (a._maxSelection / a._distance()), 0), i.type ? (i.selectionStart = o.selectionStart, i.selectionEnd = o.selectionEnd, a._setZIndex(i.type)) : i.oldVal = i.val = o.value, i._removeTooltip(!0), i._createTooltip(), t) : (n.preventDefault(), t)
            },
            _createTooltip: function() {
                var t, n, i = this,
                    a = i.owner,
                    o = i.options.tooltip,
                    r = "",
                    l = e(window);
                o.enabled && (o.template && (t = i.tooltipTemplate = m.template(o.template)), e(".k-slider-tooltip").remove(), i.tooltipDiv = e("<div class='k-widget k-tooltip k-slider-tooltip'><!-- --></div>").appendTo(document.body), r = a._getFormattedValue(i.val || a.value(), i), i.type || (n = "k-callout-" + (a._isHorizontal ? "s" : "e"), i.tooltipInnerDiv = "<div class='k-callout " + n + "'><!-- --></div>", r += i.tooltipInnerDiv), i.tooltipDiv.html(r), i._scrollOffset = {
                    top: l.scrollTop(),
                    left: l.scrollLeft()
                }, i.moveTooltip())
            },
            drag: function(e) {
                var t, n = this,
                    i = n.owner,
                    a = e.x.location,
                    o = e.y.location,
                    r = n.dragableArea.startPoint,
                    l = n.dragableArea.endPoint;
                e.preventDefault(), n.val = i._isHorizontal ? i._isRtl ? n.constrainValue(a, r, l, a < l) : n.constrainValue(a, r, l, a >= l) : n.constrainValue(o, l, r, o <= l), n.oldVal != n.val && (n.oldVal = n.val, n.type ? ("firstHandle" == n.type ? n.selectionStart = n.val < n.selectionEnd ? n.val : n.selectionEnd = n.val : n.val > n.selectionStart ? n.selectionEnd = n.val : n.selectionStart = n.selectionEnd = n.val, t = {
                    values: [n.selectionStart, n.selectionEnd],
                    value: [n.selectionStart, n.selectionEnd]
                }) : t = {
                    value: n.val
                }, i.trigger(E, t)), n._updateTooltip(n.val)
            },
            _updateTooltip: function(e) {
                var t = this,
                    n = t.options,
                    i = n.tooltip,
                    a = "";
                i.enabled && (t.tooltipDiv || t._createTooltip(), a = t.owner._getFormattedValue(u(e), t), t.type || (a += t.tooltipInnerDiv), t.tooltipDiv.html(a), t.moveTooltip())
            },
            dragcancel: function() {
                return this.owner._refresh(), e(document.documentElement).css("cursor", ""), this._end()
            },
            dragend: function() {
                var t = this,
                    n = t.owner;
                return e(document.documentElement).css("cursor", ""), t.type ? n._update(t.selectionStart, t.selectionEnd) : (n._update(t.val), t.draggable.userEvents._disposeAll()), t.draggable.userEvents.cancel(), t._end()
            },
            _end: function() {
                var e = this,
                    t = e.owner;
                return t._focusWithMouse(e.element), t.element.on(W), !1
            },
            _removeTooltip: function(t) {
                var n = this,
                    i = n.owner;
                n.tooltipDiv && i.options.tooltip.enabled && i.options.enabled && (t ? (n.tooltipDiv.remove(), n.tooltipDiv = null) : n.tooltipDiv.fadeOut("slow", function() {
                    e(this).remove(), n.tooltipDiv = null
                }))
            },
            moveTooltip: function() {
                var t, n, i, a, o = this,
                    r = o.owner,
                    l = 0,
                    s = 0,
                    d = o.element,
                    u = m.getOffset(d),
                    p = 8,
                    c = e(window),
                    f = o.tooltipDiv.find(".k-callout"),
                    _ = g(o.tooltipDiv),
                    v = w(o.tooltipDiv);
                o.type ? (t = r.wrapper.find(B), u = m.getOffset(t.eq(0)), n = m.getOffset(t.eq(1)), r._isHorizontal ? (l = n.top, s = u.left + (n.left - u.left) / 2) : (l = u.top + (n.top - u.top) / 2, s = n.left), a = g(t.eq(0)) + 2 * p) : (l = u.top, s = u.left, a = g(d) + 2 * p), r._isHorizontal ? (s -= parseInt((_ - r._outerSize(d)) / 2, 10), l -= v + p + (f.length ? f.height() : 0)) : (l -= parseInt((v - r._outerSize(d)) / 2, 10), s -= _ + p + (f.length ? f.width() : 0)), r._isHorizontal ? (i = o._flip(l, v, a, w(c) + o._scrollOffset.top), l += i, s += o._fit(s, _, g(c) + o._scrollOffset.left)) : (i = o._flip(s, _, a, g(c) + o._scrollOffset.left), l += o._fit(l, v, w(c) + o._scrollOffset.top), s += i), i > 0 && f && (f.removeClass(), f.addClass("k-callout k-callout-" + (r._isHorizontal ? "n" : "w"))), o.tooltipDiv.css({
                    top: l,
                    left: s
                })
            },
            _fit: function(e, t, n) {
                var i = 0;
                return e + t > n && (i = n - (e + t)), e < 0 && (i = -e), i
            },
            _flip: function(e, t, n, i) {
                var a = 0;
                return e + t > i && (a += -(n + t)), e + a < 0 && (a += n + t), a
            },
            constrainValue: function(e, t, n, i) {
                var a = this,
                    o = 0;
                return o = t < e && e < n ? a.owner._getValueFromPosition(e, a.dragableArea) : i ? a.options.max : a.options.min
            }
        }, m.ui.plugin(ee), _ = $.extend({
            init: function(n, i) {
                var a, o = this,
                    r = e(n).find("input"),
                    l = r.eq(0)[0],
                    d = r.eq(1)[0];
                l.type = "text", d.type = "text", i && i.showButtons && (window.console && window.console.warn("showbuttons option is not supported for the range slider, ignoring"), i.showButtons = !1), i = k({}, {
                    selectionStart: p(l, "value"),
                    min: p(l, "min"),
                    max: p(l, "max"),
                    smallStep: p(l, "step")
                }, {
                    selectionEnd: p(d, "value"),
                    min: p(d, "min"),
                    max: p(d, "max"),
                    smallStep: p(d, "step")
                }, i), i && i.enabled === t && (i.enabled = !r.is("[disabled]")), $.fn.init.call(o, n, i), i = o.options, c(i.selectionStart) && null !== i.selectionStart || (i.selectionStart = i.min, r.eq(0).prop("value", s(i.min))), c(i.selectionEnd) && null !== i.selectionEnd || (i.selectionEnd = i.max, r.eq(1).prop("value", s(i.max))), a = o.wrapper.find(B), this._selection = new _.Selection(a, o, i), o._firstHandleDrag = new ee.Drag(a.eq(0), "firstHandle", o, i), o._lastHandleDrag = new ee.Drag(a.eq(1), "lastHandle", o, i)
            },
            options: {
                name: "RangeSlider",
                leftDragHandleTitle: "drag",
                rightDragHandleTitle: "drag",
                tooltip: {
                    format: "{0:#,#.##}"
                },
                selectionStart: null,
                selectionEnd: null
            },
            enable: function(n) {
                var i, a = this,
                    o = a.options;
                a.disable(), n !== !1 && (a.wrapper.removeClass(j).addClass(Y), a.wrapper.find("input").removeAttr(K), i = function(n) {
                    var i, r, l, s, d, u, p, c = J(n)[0];
                    if (c) {
                        if (i = a._isHorizontal ? c.location.pageX : c.location.pageY, r = a._getDraggableArea(), l = a._getValueFromPosition(i, r), s = e(n.target), s.hasClass("k-draghandle")) return a.wrapper.find("." + X).removeClass(X + " " + U), s.addClass(X + " " + U), t;
                        l < o.selectionStart ? (d = l, u = o.selectionEnd, p = a._firstHandleDrag) : l > a.selectionEnd ? (d = o.selectionStart, u = l, p = a._lastHandleDrag) : l - o.selectionStart <= o.selectionEnd - l ? (d = l, u = o.selectionEnd, p = a._firstHandleDrag) : (d = o.selectionStart, u = l, p = a._lastHandleDrag), p.dragstart(n), a._setValueInRange(d, u), a._focusWithMouse(p.element)
                    }
                }, a.wrapper.find(Z + ", " + L).on(R, i).end().on(R, function() {
                    e(document.documentElement).one("selectstart", m.preventDefault)
                }).on(V, function() {
                    a._activeDragHandle && a._activeDragHandle._end()
                }), a.wrapper.find(B).attr(G, 0).on(A, function() {
                    a._setTooltipTimeout()
                }).on(P, function(e) {
                    a._focusWithMouse(e.target), e.preventDefault()
                }).on(N, D(a._focus, a)).on(O, D(a._blur, a)), a.wrapper.find(B).off(M, m.preventDefault).eq(0).on(M, D(function(e) {
                    this._keydown(e, "firstHandle")
                }, a)).end().eq(1).on(M, D(function(e) {
                    this._keydown(e, "lastHandle")
                }, a)), a.options.enabled = !0)
            },
            disable: function() {
                var e = this;
                e.wrapper.removeClass(Y).addClass(j), e.wrapper.find("input").prop(K, K), e.wrapper.find(Z + ", " + L).off(R).off(V), e.wrapper.find(B).attr(G, -1).off(A).off(M).off(P).off(N).off(O), e.options.enabled = !1
            },
            _keydown: function(e, t) {
                var n, i, a, o = this,
                    r = o.options.selectionStart,
                    l = o.options.selectionEnd;
                e.keyCode in o._keyMap && (o._clearTooltipTimeout(), "firstHandle" == t ? (a = o._activeHandleDrag = o._firstHandleDrag, r = o._keyMap[e.keyCode](r), r > l && (l = r)) : (a = o._activeHandleDrag = o._lastHandleDrag, l = o._keyMap[e.keyCode](l), r > l && (r = l)), o._setValueInRange(u(r), u(l)), n = Math.max(r, o.options.selectionStart), i = Math.min(l, o.options.selectionEnd), a.selectionEnd = Math.max(i, o.options.selectionStart), a.selectionStart = Math.min(n, o.options.selectionEnd), a._updateTooltip(o.value()[o._activeHandle]), e.preventDefault())
            },
            _update: function(e, t) {
                var n = this,
                    i = n.value(),
                    a = i[0] != e || i[1] != t;
                n.value([e, t]), a && n.trigger(I, {
                    values: [e, t],
                    value: [e, t]
                })
            },
            value: function(e) {
                return e && e.length ? this._value(e[0], e[1]) : this._value()
            },
            _value: function(e, n) {
                var i = this,
                    a = i.options,
                    o = a.selectionStart,
                    r = a.selectionEnd;
                return isNaN(e) && isNaN(n) ? [o, r] : (e = u(e), n = u(n), e >= a.min && e <= a.max && n >= a.min && n <= a.max && e <= n && (o == e && r == n || (i.element.find("input").eq(0).prop("value", s(e)).end().eq(1).prop("value", s(n)), a.selectionStart = e, a.selectionEnd = n, i._refresh(), i._refreshAriaAttr(e, n))), t)
            },
            values: function(e, t) {
                return b(e) ? this._value(e[0], e[1]) : this._value(e, t)
            },
            _refresh: function() {
                var e = this,
                    t = e.options;
                e.trigger(q, {
                    values: [t.selectionStart, t.selectionEnd],
                    value: [t.selectionStart, t.selectionEnd]
                }), t.selectionStart == t.max && t.selectionEnd == t.max && e._setZIndex("firstHandle")
            },
            _refreshAriaAttr: function(e, t) {
                var n, i = this,
                    a = i.wrapper.find(B),
                    o = i._activeHandleDrag;
                n = i._getFormattedValue([e, t], o), a.eq(0).attr("aria-valuenow", e), a.eq(1).attr("aria-valuenow", t), a.attr("aria-valuetext", n)
            },
            _setValueInRange: function(e, t) {
                var n = this.options;
                e = H.max(H.min(e, n.max), n.min), t = H.max(H.min(t, n.max), n.min), e == n.max && t == n.max && this._setZIndex("firstHandle"), this._update(H.min(e, t), H.max(e, t))
            },
            _setZIndex: function(t) {
                this.wrapper.find(B).each(function(n) {
                    e(this).css("z-index", "firstHandle" == t ? 1 - n : n)
                })
            },
            _formResetHandler: function() {
                var e = this,
                    t = e.options;
                setTimeout(function() {
                    var n = e.element.find("input"),
                        i = n[0].value,
                        a = n[1].value;
                    e.values("" === i || isNaN(i) ? t.min : i, "" === a || isNaN(a) ? t.max : a)
                })
            },
            destroy: function() {
                var e = this;
                $.fn.destroy.call(e), e.wrapper.off(C).find(Z + ", " + L).off(C).end().find(B).off(C), e._firstHandleDrag.draggable.destroy(), e._lastHandleDrag.draggable.destroy()
            }
        }), _.Selection = function(e, t, n) {
            function i(i) {
                i = i || [];
                var o = i[0] - n.min,
                    r = i[1] - n.min,
                    l = H.ceil(u(o / n.smallStep)),
                    s = H.ceil(u(r / n.smallStep)),
                    d = t._pixelSteps[l],
                    p = t._pixelSteps[s],
                    c = parseInt(t._outerSize(e.eq(0)) / 2, 10),
                    f = t._isRtl ? 2 : 0;
                e.eq(0).css(t._position, d - c - f).end().eq(1).css(t._position, p - c - f), a(d, p)
            }

            function a(e, n) {
                var i, a, o = t._trackDiv.find(".k-slider-selection");
                i = H.abs(e - n), o[t._sizeFn](i), t._isRtl ? (a = H.max(e, n), o.css("right", t._maxSelection - a - 1)) : (a = H.min(e, n), o.css(t._position, a - 1))
            }
            i(t.value()), t.bind([I, E, q], function(e) {
                i(e.values)
            })
        }, m.ui.plugin(_)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(e, define) {
    define("kendo.colorpicker.min", ["kendo.core.min", "kendo.color.min", "kendo.popup.min", "kendo.slider.min", "kendo.userevents.min", "kendo.button.min"], e)
}(function() {
    return function(e, t, a) {
        function s(e, t, a) {
            a = d(a), a && !a.equals(e.color()) && ("change" == t && (e._value = a), a = 1 != a.a ? a.toCssRgba() : a.toCss(), e.trigger(t, {
                value: a
            }))
        }

        function l(e, t, a) {
            var s, l;
            return e = Array.prototype.slice.call(e), s = e.length, l = e.indexOf(t), l < 0 ? a < 0 ? e[s - 1] : e[0] : (l += a, l < 0 ? l += s : l %= s, e[l])
        }

        function o(e) {
            e.preventDefault()
        }

        function n(e, t) {
            return function() {
                return e.apply(t, arguments)
            }
        }
        var i = window.kendo,
            r = i.ui,
            c = r.Widget,
            d = i.parseColor,
            p = i.Color,
            u = i.keys,
            C = "background-color",
            h = "k-state-selected",
            F = "000000,7f7f7f,880015,ed1c24,ff7f27,fff200,22b14c,00a2e8,3f48cc,a349a4,ffffff,c3c3c3,b97a57,ffaec9,ffc90e,efe4b0,b5e61d,99d9ea,7092be,c8bfe7",
            f = "FFFFFF,FFCCFF,FF99FF,FF66FF,FF33FF,FF00FF,CCFFFF,CCCCFF,CC99FF,CC66FF,CC33FF,CC00FF,99FFFF,99CCFF,9999FF,9966FF,9933FF,9900FF,FFFFCC,FFCCCC,FF99CC,FF66CC,FF33CC,FF00CC,CCFFCC,CCCCCC,CC99CC,CC66CC,CC33CC,CC00CC,99FFCC,99CCCC,9999CC,9966CC,9933CC,9900CC,FFFF99,FFCC99,FF9999,FF6699,FF3399,FF0099,CCFF99,CCCC99,CC9999,CC6699,CC3399,CC0099,99FF99,99CC99,999999,996699,993399,990099,FFFF66,FFCC66,FF9966,FF6666,FF3366,FF0066,CCFF66,CCCC66,CC9966,CC6666,CC3366,CC0066,99FF66,99CC66,999966,996666,993366,990066,FFFF33,FFCC33,FF9933,FF6633,FF3333,FF0033,CCFF33,CCCC33,CC9933,CC6633,CC3333,CC0033,99FF33,99CC33,999933,996633,993333,990033,FFFF00,FFCC00,FF9900,FF6600,FF3300,FF0000,CCFF00,CCCC00,CC9900,CC6600,CC3300,CC0000,99FF00,99CC00,999900,996600,993300,990000,66FFFF,66CCFF,6699FF,6666FF,6633FF,6600FF,33FFFF,33CCFF,3399FF,3366FF,3333FF,3300FF,00FFFF,00CCFF,0099FF,0066FF,0033FF,0000FF,66FFCC,66CCCC,6699CC,6666CC,6633CC,6600CC,33FFCC,33CCCC,3399CC,3366CC,3333CC,3300CC,00FFCC,00CCCC,0099CC,0066CC,0033CC,0000CC,66FF99,66CC99,669999,666699,663399,660099,33FF99,33CC99,339999,336699,333399,330099,00FF99,00CC99,009999,006699,003399,000099,66FF66,66CC66,669966,666666,663366,660066,33FF66,33CC66,339966,336666,333366,330066,00FF66,00CC66,009966,006666,003366,000066,66FF33,66CC33,669933,666633,663333,660033,33FF33,33CC33,339933,336633,333333,330033,00FF33,00CC33,009933,006633,003333,000033,66FF00,66CC00,669900,666600,663300,660000,33FF00,33CC00,339900,336600,333300,330000,00FF00,00CC00,009900,006600,003300,000000",
            _ = "#ffffff",
            v = {
                apply: "Apply",
                cancel: "Cancel",
                noColor: "no color",
                clearColor: "Clear color",
                previewInput: "Color Hexadecimal Code"
            },
            k = ".kendoColorTools",
            g = "click" + k,
            m = "keydown" + k,
            b = i.support.browser,
            y = b.msie && b.version < 9,
            w = c.extend({
                init: function(e, t) {
                    var a, s = this;
                    c.fn.init.call(s, e, t), e = s.element, t = s.options, s._value = t.value = d(t.value), s._tabIndex = e.attr("tabIndex") || 0, a = s._ariaId = t.ariaId, a && e.attr("aria-labelledby", a), t._standalone && (s._triggerSelect = s._triggerChange)
                },
                options: {
                    name: "ColorSelector",
                    value: null,
                    _standalone: !0
                },
                events: ["change", "select", "cancel"],
                color: function(e) {
                    return e !== a && (this._value = d(e), this._updateUI(this._value)), this._value
                },
                value: function(e) {
                    return e = this.color(e), e && (e = this.options.opacity ? e.toCssRgba() : e.toCss()), e || null
                },
                enable: function(t) {
                    0 === arguments.length && (t = !0), e(".k-disabled-overlay", this.wrapper).remove(), t || this.wrapper.append("<div class='k-disabled-overlay'></div>"), this._onEnable(t)
                },
                _select: function(e, t) {
                    var a = this._value;
                    e = this.color(e), t || (this.element.trigger("change"), e.equals(a) ? this._standalone || this.trigger("cancel") : this.trigger("change", {
                        value: this.value()
                    }))
                },
                _triggerSelect: function(e) {
                    s(this, "select", e)
                },
                _triggerChange: function(e) {
                    s(this, "change", e)
                },
                destroy: function() {
                    this.element && this.element.off(k), this.wrapper && this.wrapper.off(k).find("*").off(k), this.wrapper = null, c.fn.destroy.call(this)
                },
                _updateUI: e.noop,
                _selectOnHide: function() {
                    return null
                },
                _cancel: function() {
                    this.trigger("cancel")
                }
            }),
            I = w.extend({
                init: function(t, a) {
                    var s, l, o, r, c = this;
                    if (w.fn.init.call(c, t, a), t = c.wrapper = c.element, a = c.options, s = a.palette, "websafe" == s ? (s = f, a.columns = 18) : "basic" == s && (s = F), "string" == typeof s && (s = s.split(",")), e.isArray(s) && (s = e.map(s, function(e) {
                            return d(e)
                        })), c._selectedID = (a.ariaId || i.guid()) + "_selected", t.addClass("k-widget k-colorpalette").attr("role", "grid").attr("aria-readonly", "true").append(e(c._template({
                            colors: s,
                            columns: a.columns,
                            tileSize: a.tileSize,
                            value: c._value,
                            id: a.ariaId
                        }))).on(g, ".k-item", function(t) {
                            c._select(e(t.currentTarget).css(C))
                        }).attr("tabIndex", c._tabIndex).on(m, n(c._keydown, c)), l = a.tileSize) {
                        if (/number|string/.test(typeof l)) o = r = parseFloat(l);
                        else {
                            if ("object" != typeof l) throw Error("Unsupported value for the 'tileSize' argument");
                            o = parseFloat(l.width), r = parseFloat(l.height)
                        }
                        t.find(".k-item").css({
                            width: o,
                            height: r
                        })
                    }
                },
                focus: function() {
                    this.wrapper && !this.wrapper.is("[unselectable='on']") && this.wrapper.focus()
                },
                options: {
                    name: "ColorPalette",
                    columns: 10,
                    tileSize: null,
                    palette: "basic"
                },
                _onEnable: function(e) {
                    e ? this.wrapper.attr("tabIndex", this._tabIndex) : this.wrapper.removeAttr("tabIndex")
                },
                _keydown: function(t) {
                    var a, s, n = this.wrapper,
                        i = n.find(".k-item"),
                        r = i.filter("." + h).get(0),
                        c = t.keyCode;
                    if (c == u.LEFT ? a = l(i, r, -1) : c == u.RIGHT ? a = l(i, r, 1) : c == u.DOWN ? a = l(i, r, this.options.columns) : c == u.UP ? a = l(i, r, -this.options.columns) : c == u.ENTER ? (o(t), r && this._select(e(r).css(C))) : c == u.ESC && this._cancel(), a) {
                        o(t), this._current(a);
                        try {
                            s = d(a.css(C)), this._triggerSelect(s)
                        } catch (p) {}
                    }
                },
                _current: function(t) {
                    this.wrapper.find("." + h).removeClass(h).attr("aria-selected", !1).removeAttr("id"), e(t).addClass(h).attr("aria-selected", !0).attr("id", this._selectedID), this.element.removeAttr("aria-activedescendant").attr("aria-activedescendant", this._selectedID)
                },
                _updateUI: function(t) {
                    var a = null;
                    this.wrapper.find(".k-item").each(function() {
                        var s = d(e(this).css(C));
                        if (s && s.equals(t)) return a = this, !1
                    }), this._current(a)
                },
                _template: i.template('<table class="k-palette k-reset" role="presentation"><tr role="row"># for (var i = 0; i < colors.length; ++i) { ## var selected = colors[i].equals(value); ## if (i && i % columns == 0) { # </tr><tr role="row"> # } #<td role="gridcell" unselectable="on" style="background-color:#= colors[i].toCss() #"#= selected ? " aria-selected=true" : "" # #=(id && i === 0) ? "id=\\""+id+"\\" " : "" # class="k-item#= selected ? " ' + h + '" : "" #" aria-label="#= colors[i].toCss() #"></td># } #</tr></table>')
            }),
            S = w.extend({
                init: function(t, a) {
                    var s = this;
                    w.fn.init.call(s, t, a), a = s.options, a.messages = a.options ? e.extend(s.options.messages, a.options.messages) : s.options.messages, t = s.element, s.wrapper = t.addClass("k-widget k-flatcolorpicker").append(s._template(a)), s._hueElements = e(".k-hsv-rectangle, .k-alpha-slider .k-slider-track", t), s._selectedColor = e(".k-selected-color-display", t), s._colorAsText = e("input.k-color-value", t), s._sliders(), s._hsvArea(), s._updateUI(s._value || d("#f00")), t.find("input.k-color-value").on(m, function(t) {
                        var a, l, o = this;
                        if (t.keyCode == u.ENTER) try {
                            a = d(o.value), l = s.color(), s._select(a, a.equals(l))
                        } catch (n) {
                            e(o).addClass("k-state-error")
                        } else s.options.autoupdate && setTimeout(function() {
                            var e = d(o.value, !0);
                            e && s._updateUI(e, !0)
                        }, 10)
                    }).end().on(g, ".k-controls button.apply", function() {
                        s.options._clearedColor ? s.trigger("change") : s._select(s._getHSV())
                    }).on(g, ".k-controls button.cancel", function() {
                        s._updateUI(s.color()), s._cancel()
                    }), y && s._applyIEFilter()
                },
                destroy: function() {
                    this._hueSlider.destroy(), this._opacitySlider && this._opacitySlider.destroy(), this._hueSlider = this._opacitySlider = this._hsvRect = this._hsvHandle = this._hueElements = this._selectedColor = this._colorAsText = null, w.fn.destroy.call(this)
                },
                options: {
                    name: "FlatColorPicker",
                    opacity: !1,
                    buttons: !1,
                    input: !0,
                    preview: !0,
                    clearButton: !1,
                    autoupdate: !0,
                    messages: v
                },
                _applyIEFilter: function() {
                    var e = this.element.find(".k-hue-slider .k-slider-track")[0],
                        t = e.currentStyle.backgroundImage;
                    t = t.replace(/^url\([\'\"]?|[\'\"]?\)$/g, ""), e.style.filter = "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + t + "', sizingMethod='scale')"
                },
                _sliders: function() {
                    function e(e) {
                        a._updateUI(a._getHSV(e.value, null, null, null))
                    }

                    function t(e) {
                        a._updateUI(a._getHSV(null, null, null, e.value / 100))
                    }
                    var a = this,
                        s = a.element,
                        l = s.find(".k-hue-slider"),
                        o = s.find(".k-alpha-slider");
                    l.attr("aria-label", "hue saturation"), a._hueSlider = l.kendoSlider({
                        min: 0,
                        max: 360,
                        tickPlacement: "none",
                        showButtons: !1,
                        slide: e,
                        change: e
                    }).data("kendoSlider"), o.attr("aria-label", "opacity"), a._opacitySlider = o.kendoSlider({
                        min: 0,
                        max: 100,
                        tickPlacement: "none",
                        showButtons: !1,
                        slide: t,
                        change: t
                    }).data("kendoSlider")
                },
                _hsvArea: function() {
                    function e(e, a) {
                        var s = this.offset,
                            l = e - s.left,
                            o = a - s.top,
                            n = this.width,
                            i = this.height;
                        l = l < 0 ? 0 : l > n ? n : l, o = o < 0 ? 0 : o > i ? i : o, t._svChange(l / n, 1 - o / i)
                    }
                    var t = this,
                        a = t.element,
                        s = a.find(".k-hsv-rectangle"),
                        l = s.find(".k-draghandle").attr("tabIndex", 0).on(m, n(t._keydown, t));
                    t._hsvEvents = new i.UserEvents(s, {
                        global: !0,
                        press: function(t) {
                            this.offset = i.getOffset(s), this.width = s.width(), this.height = s.height(), l.focus(), e.call(this, t.x.location, t.y.location)
                        },
                        start: function() {
                            s.addClass("k-dragging"), l.focus()
                        },
                        move: function(t) {
                            t.preventDefault(), e.call(this, t.x.location, t.y.location)
                        },
                        end: function() {
                            s.removeClass("k-dragging")
                        }
                    }), t._hsvRect = s, t._hsvHandle = l
                },
                _onEnable: function(e) {
                    this._hueSlider.enable(e), this._opacitySlider && this._opacitySlider.enable(e), this.wrapper.find("input").attr("disabled", !e);
                    var t = this._hsvRect.find(".k-draghandle");
                    e ? t.attr("tabIndex", this._tabIndex) : t.removeAttr("tabIndex")
                },
                _keydown: function(e) {
                    function t(t, a) {
                        var l = s._getHSV();
                        l[t] += a * (e.shiftKey ? .01 : .05), l[t] < 0 && (l[t] = 0), l[t] > 1 && (l[t] = 1), s._updateUI(l), o(e)
                    }

                    function a(t) {
                        var a = s._getHSV();
                        a.h += t * (e.shiftKey ? 1 : 5), a.h < 0 && (a.h = 0), a.h > 359 && (a.h = 359), s._updateUI(a), o(e)
                    }
                    var s = this;
                    switch (e.keyCode) {
                        case u.LEFT:
                            e.ctrlKey ? a(-1) : t("s", -1);
                            break;
                        case u.RIGHT:
                            e.ctrlKey ? a(1) : t("s", 1);
                            break;
                        case u.UP:
                            t(e.ctrlKey && s._opacitySlider ? "a" : "v", 1);
                            break;
                        case u.DOWN:
                            t(e.ctrlKey && s._opacitySlider ? "a" : "v", -1);
                            break;
                        case u.ENTER:
                            s._select(s._getHSV());
                            break;
                        case u.F2:
                            s.wrapper.find("input.k-color-value").focus().select();
                            break;
                        case u.ESC:
                            s._cancel()
                    }
                },
                focus: function() {
                    this._hsvHandle.focus()
                },
                _getHSV: function(e, t, a, s) {
                    var l = this._hsvRect,
                        o = l.width(),
                        n = l.height(),
                        i = this._hsvHandle.position();
                    return null == e && (e = this._hueSlider.value()), null == t && (t = i.left / o), null == a && (a = 1 - i.top / n), null == s && (s = this._opacitySlider ? this._opacitySlider.value() / 100 : 1), p.fromHSV(e, t, a, s)
                },
                _svChange: function(e, t) {
                    var a = this._getHSV(null, e, t, null);
                    this._updateUI(a)
                },
                _updateUI: function(e, t) {
                    var a = this,
                        s = a._hsvRect;
                    e && (this._colorAsText.attr("title", a.options.messages.previewInput), this._colorAsText.removeClass("k-state-error"), a._selectedColor.css(C, e.toDisplay()), t || a._colorAsText.val(a._opacitySlider ? e.toCssRgba() : e.toCss()), a._triggerSelect(e), e = e.toHSV(), a._hsvHandle.css({
                        left: e.s * s.width() + "px",
                        top: (1 - e.v) * s.height() + "px"
                    }), a._hueElements.css(C, p.fromHSV(e.h, 1, 1, 1).toCss()), a._hueSlider.value(e.h), a._opacitySlider && a._opacitySlider.value(100 * e.a))
                },
                _selectOnHide: function() {
                    return this.options.buttons ? null : this._getHSV()
                },
                _template: i.template('# if (preview) { #<div class="k-selected-color"><div class="k-selected-color-display"><div class="k-color-input"><input class="k-color-value" # if (clearButton && !_standalone) { #placeholder="#: messages.noColor #" # } ##= !data.input ? \'style="visibility: hidden;"\' : "" #># if (clearButton && !_standalone) { #<span class="k-clear-color k-button k-bare" title="#: messages.clearColor #"></span># } #</div></div></div># } ## if (clearButton && !_standalone && !preview) { #<div class="k-clear-color-container"><span class="k-clear-color k-button k-bare">#: messages.clearColor #</span></div># } #<div class="k-hsv-rectangle"><div class="k-hsv-gradient"></div><div class="k-draghandle"></div></div><div class="k-sliders-wrap k-vbox"><input class="k-hue-slider" /># if (opacity) { #<input class="k-alpha-slider k-transparency-slider" /># } #</div># if (buttons) { #<div unselectable="on" class="k-controls"><button class="k-button k-primary apply">#: messages.apply #</button> <button class="k-button cancel">#: messages.cancel #</button></div># } #')
            }),
            x = c.extend({
                init: function(t, a) {
                    var s, l, o, n, i, r = this;
                    c.fn.init.call(r, t, a), a = r.options, t = r.element, s = t.attr("value") || t.val(), s = s ? d(s, !0) : d(a.value, !0), r._value = a.value = s, l = r.wrapper = e(r._template(a)), t.hide().after(l), t.is("input") && (t.appendTo(l), o = t.closest("label"), n = t.attr("id"), n && (o = o.add('label[for="' + n + '"]')), o.click(function(e) {
                        r.open(), e.preventDefault()
                    })), r._tabIndex = t.attr("tabIndex") || 0, r.enable(!t.attr("disabled")), i = t.attr("accesskey"), i && (t.attr("accesskey", null), l.attr("accesskey", i)), r.bind("activate", function(e) {
                        e.isDefaultPrevented() || r.toggle()
                    }), r._updateUI(s)
                },
                destroy: function() {
                    this.wrapper.off(k).find("*").off(k), this._popup && (this._selector.destroy(), this._popup.destroy()), this._selector = this._popup = this.wrapper = null, c.fn.destroy.call(this)
                },
                enable: function(e) {
                    var t = this,
                        a = t.wrapper,
                        s = a.children(".k-picker-wrap"),
                        l = s.find(".k-select");
                    0 === arguments.length && (e = !0), t.element.attr("disabled", !e), a.attr("aria-disabled", !e), l.off(k).on("mousedown" + k, o), a.addClass("k-state-disabled").removeAttr("tabIndex").add("*", a).off(k), e ? a.removeClass("k-state-disabled").attr("tabIndex", t._tabIndex).on("mouseenter" + k, function() {
                        s.addClass("k-state-hover")
                    }).on("mouseleave" + k, function() {
                        s.removeClass("k-state-hover")
                    }).on("focus" + k, function() {
                        s.addClass("k-state-focused")
                    }).on("blur" + k, function() {
                        s.removeClass("k-state-focused")
                    }).on(m, n(t._keydown, t)).on(g, ".k-select", n(t.toggle, t)).on(g, t.options.toolIcon ? ".k-tool-icon" : ".k-selected-color", function() {
                        t.trigger("activate")
                    }) : t.close()
                },
                _template: i.template('<span role="textbox" aria-haspopup="true" class="k-widget k-colorpicker"><span class="k-picker-wrap k-state-default"># if (toolIcon) { #<span class="k-icon k-tool-icon #= toolIcon #"><span class="k-selected-color"></span></span># } else { #<span class="k-selected-color"><span class="k-icon k-i-line" style="display: none;"></span></span># } #<span class="k-select" unselectable="on" aria-label="select"><span class="k-icon k-i-arrow-60-down"></span></span></span></span>'),
                options: {
                    name: "ColorPicker",
                    palette: null,
                    columns: 10,
                    toolIcon: null,
                    value: null,
                    messages: v,
                    opacity: !1,
                    buttons: !0,
                    preview: !0,
                    clearButton: !1,
                    ARIATemplate: 'Current selected color is #=data || ""#'
                },
                events: ["activate", "change", "select", "open", "close"],
                open: function() {
                    this.element.prop("disabled") || this._getPopup().open()
                },
                close: function() {
                    var e = this._selector && this._selector.options || {};
                    e._closing = !0, this._getPopup().close(), delete e._closing
                },
                toggle: function() {
                    this.element.prop("disabled") || this._getPopup().toggle()
                },
                _noColorIcon: function() {
                    return this.wrapper.find(".k-picker-wrap > .k-selected-color > .k-icon.k-i-line")
                },
                color: w.fn.color,
                value: w.fn.value,
                _select: w.fn._select,
                _triggerSelect: w.fn._triggerSelect,
                _isInputTypeColor: function() {
                    var e = this.element[0];
                    return /^input$/i.test(e.tagName) && /^color$/i.test(e.type)
                },
                _updateUI: function(e) {
                    var t = "";
                    e && (t = this._isInputTypeColor() || 1 == e.a ? e.toCss() : e.toCssRgba(), this.element.val(t)), this._ariaTemplate || (this._ariaTemplate = i.template(this.options.ARIATemplate)), this.wrapper.attr("aria-label", this._ariaTemplate(t)), this._triggerSelect(e), this.wrapper.find(".k-selected-color").css(C, e ? e.toDisplay() : _), this._noColorIcon()[t ? "hide" : "show"]()
                },
                _keydown: function(e) {
                    var t = e.keyCode;
                    this._getPopup().visible() ? (t == u.ESC ? this._selector._cancel() : this._selector._keydown(e), o(e)) : t != u.ENTER && t != u.DOWN || (this.open(), o(e))
                },
                _getPopup: function() {
                    var t, s, l, o, n = this,
                        r = n._popup;
                    return r || (t = n.options, s = t.palette ? I : S, t._standalone = !1, delete t.select, delete t.change, delete t.cancel, l = i.guid(), o = n._selector = new s(e('<div id="' + l + '"/>').appendTo(document.body), t), n.wrapper.attr("aria-owns", l), n._popup = r = o.wrapper.kendoPopup({
                        anchor: n.wrapper,
                        adjustSize: {
                            width: 5,
                            height: 0
                        }
                    }).data("kendoPopup"), o.element.find(".k-clear-color").kendoButton({
                        icon: "reset-color",
                        click: function(e) {
                            o.options._clearedColor = !0, n.value(null), n.element.val(null), n._updateUI(null), o._colorAsText.val(""), o._hsvHandle.css({
                                top: "0px",
                                left: "0px"
                            }), o._selectedColor.css(C, _), n.trigger("change", {
                                value: n.value()
                            }), e.preventDefault()
                        }
                    }), o.bind({
                        select: function(e) {
                            n._updateUI(d(e.value)), delete o.options._clearedColor
                        },
                        change: function() {
                            o.options._clearedColor || n._select(o.color()), n.close()
                        },
                        cancel: function() {
                            o.options._clearedColor && !n.value() && o.value() && n._select(o.color(), !0), n.close()
                        }
                    }), r.bind({
                        close: function(e) {
                            var t, s, l, i;
                            return n.trigger("close") ? (e.preventDefault(), a) : (n.wrapper.children(".k-picker-wrap").removeClass("k-state-focused"), t = o._selectOnHide(), s = o.value(), l = n.value(), i = o.options, t ? i._clearedColor && !l || n._select(t) : (setTimeout(function() {
                                n.wrapper && !n.wrapper.is("[unselectable='on']") && n.wrapper.focus()
                            }), !i._closing && i._clearedColor && !l && s ? n._select(s, !0) : n._updateUI(n.color())), a)
                        },
                        open: function(e) {
                            n.trigger("open") ? e.preventDefault() : n.wrapper.children(".k-picker-wrap").addClass("k-state-focused")
                        },
                        activate: function() {
                            o._select(n.color(), !0), o.focus(), n.wrapper.children(".k-picker-wrap").addClass("k-state-focused")
                        }
                    })), r
                }
            });
        r.plugin(I), r.plugin(S), r.plugin(x)
    }(jQuery, parseInt), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, a) {
    (a || t)()
});;
! function(e, define) {
    define("kendo.combobox.min", ["kendo.list.min", "kendo.mobile.scroller.min", "kendo.virtuallist.min"], e)
}(function() {
    return function(e, t) {
        var i = window.kendo,
            s = i.ui,
            n = s.List,
            o = s.Select,
            a = i.caret,
            l = i.support,
            u = l.placeholder,
            r = i._activeElement,
            c = i.keys,
            d = ".kendoComboBox",
            p = d + "FocusEvent",
            _ = "click" + d,
            h = "mousedown" + d,
            f = "disabled",
            g = "readonly",
            v = "change",
            m = "k-i-loading",
            x = "k-state-default",
            w = "k-state-focused",
            y = "k-state-disabled",
            V = "aria-disabled",
            b = "off",
            I = "filter",
            C = "accept",
            T = "rebind",
            k = "mouseenter" + d + " mouseleave" + d,
            F = e.proxy,
            S = /(\r\n|\n|\r)/gm,
            B = o.extend({
                init: function(t, s) {
                    var n, a, l = this;
                    l.ns = d, s = e.isArray(s) ? {
                        dataSource: s
                    } : s, o.fn.init.call(l, t, s), s = l.options, t = l.element.on("focus" + d, F(l._focusHandler, l)), s.placeholder = s.placeholder || t.attr("placeholder"), l._reset(), l._wrapper(), l._input(), l._clearButton(), l._tabindex(l.input), l._popup(), l._dataSource(), l._ignoreCase(), l._enable(), l._attachFocusEvents(), l._oldIndex = l.selectedIndex = -1, l._aria(), l._initialIndex = s.index, l.requireValueMapper(l.options), l._initList(), l._cascade(), s.autoBind ? l._filterSource() : (n = s.text, !n && l._isSelect && (n = t.children(":selected").text()), n && l._setText(n)), n || l._placeholder(), a = e(l.element).parents("fieldset").is(":disabled"), a && l.enable(!1), i.notify(l), l._toggleCloseVisibility()
                },
                options: {
                    name: "ComboBox",
                    enabled: !0,
                    index: -1,
                    text: null,
                    value: null,
                    autoBind: !0,
                    delay: 200,
                    dataTextField: "",
                    dataValueField: "",
                    minLength: 1,
                    enforceMinLength: !1,
                    height: 200,
                    highlightFirst: !0,
                    filter: "none",
                    placeholder: "",
                    suggest: !1,
                    cascadeFrom: "",
                    cascadeFromField: "",
                    cascadeFromParentField: "",
                    ignoreCase: !0,
                    animation: {},
                    virtual: !1,
                    template: null,
                    groupTemplate: "#:data#",
                    fixedGroupTemplate: "#:data#",
                    clearButton: !0,
                    syncValueAndText: !0,
                    autoWidth: !1,
                    popup: null
                },
                events: ["open", "close", v, "select", "filtering", "dataBinding", "dataBound", "cascade", "set"],
                setOptions: function(e) {
                    var t = this._listOptions(e);
                    o.fn.setOptions.call(this, e), this.listView.setOptions(t), this._accessors(), this._aria(), this._clearButton()
                },
                destroy: function() {
                    var e = this;
                    e.input.off(d), e.input.off(p), e.element.off(d), e.wrapper.off(d), e._inputWrapper.off(d), clearTimeout(e._pasteTimeout), e._arrow.off(_ + " " + h), e._clear.off(_ + " " + h), o.fn.destroy.call(e)
                },
                _change: function() {
                    var e = this,
                        i = e.text(),
                        s = i && i !== e._oldText && i !== e.options.placeholder,
                        n = e.selectedIndex,
                        a = n === -1;
                    return !e.options.syncValueAndText && !e.value() && a && s ? (e._old = "", e._oldIndex = n, e._oldText = i, e._typing || e.element.trigger(v), e.trigger(v), e._typing = !1, t) : (o.fn._change.call(e), e._toggleCloseVisibility(), t)
                },
                _attachFocusEvents: function() {
                    var e = this;
                    e.input.on("focus" + p, F(e._inputFocus, e)).on("focusout" + p, F(e._inputFocusout, e))
                },
                _focusHandler: function() {
                    this.input.focus()
                },
                _arrowClick: function() {
                    this._toggle()
                },
                _inputFocus: function() {
                    this._inputWrapper.addClass(w), this._placeholder(!1)
                },
                _inputFocusout: function() {
                    var e, i, s = this,
                        n = s.value();
                    return s._userTriggered = !0, s._inputWrapper.removeClass(w), clearTimeout(s._typingTimeout), s._typingTimeout = null, s.text(s.text()), e = s._focus(), i = this.listView.dataItemByIndex(this.listView.getElementIndex(e)), n !== s.value() && s.trigger("select", {
                        dataItem: i,
                        item: e
                    }) ? (s.value(n), t) : (s._placeholder(), s._blur(), s.element.blur(), t)
                },
                _inputPaste: function() {
                    var e = this;
                    clearTimeout(e._pasteTimeout), e._pasteTimeout = null, e._pasteTimeout = setTimeout(function() {
                        e.search()
                    })
                },
                _editable: function(e) {
                    var t = this,
                        i = e.disable,
                        s = e.readonly,
                        n = t._inputWrapper.off(d),
                        o = t.element.add(t.input.off(d)),
                        a = t._arrow.off(_ + " " + h),
                        l = t._clear;
                    s || i ? (n.addClass(i ? y : x).removeClass(i ? x : y), o.attr(f, i).attr(g, s).attr(V, i)) : (n.addClass(x).removeClass(y).on(k, t._toggleHover), o.removeAttr(f).removeAttr(g).attr(V, !1), a.on(_, F(t._arrowClick, t)).on(h, function(e) {
                        e.preventDefault()
                    }), l.on(_ + " touchend" + d, F(t._clearValue, t)), t.input.on("keydown" + d, F(t._keydown, t)).on("input" + d, F(t._search, t)).on("paste" + d, F(t._inputPaste, t)), t.wrapper.on(_ + d, F(t._focusHandler, t))), t._toggleCloseVisibility()
                },
                open: function() {
                    var e = this,
                        t = e._state,
                        i = !!e.dataSource.filter() && e.dataSource.filter().filters.length > 0,
                        s = !e.ul.find(e.listView.focus()).length;
                    e.popup.visible() || (!e.listView.bound() && t !== I || t === C ? (e._open = !0, e._state = T, 1 !== e.options.minLength && !i || i && e.value() && e.selectedIndex === -1 ? (e.refresh(), e._openPopup(), this.options.virtual || e.listView.bound(!1)) : e._filterSource()) : e._allowOpening() && (e.popup._hovered = !0, e._openPopup(), e.options.virtual ? e._focusItem() : s && e.options.highlightFirst && e.listView.focus(0)))
                },
                _scrollToFocusedItem: function() {
                    var e = this.listView;
                    e.scrollToIndex(e.getElementIndex(e.focus()))
                },
                _openPopup: function() {
                    this.popup.one("activate", F(this._scrollToFocusedItem, this)), this.popup.open()
                },
                _updateSelectionState: function() {
                    var e = this,
                        i = e.options.text,
                        s = e.options.value;
                    e.listView.isFiltered() || (e.selectedIndex === -1 ? (i !== t && null !== i || (i = s), e._accessor(s), e.input.val(i || e.input.val()), e._placeholder()) : e._oldIndex === -1 && (e._oldIndex = e.selectedIndex))
                },
                _buildOptions: function(e) {
                    var i, s = this;
                    s._isSelect && (i = s._customOption, s._state === T && (s._state = ""), s._customOption = t, s._options(e, "", s.value()), i && i[0].selected && !s.listView._emptySearch && s._custom(i.val()))
                },
                _updateSelection: function() {
                    var i, s = this,
                        n = s.listView,
                        o = s._initialIndex,
                        a = null !== o && o > -1,
                        l = s._state === I;
                    return l ? (e(n.focus()).removeClass("k-state-selected"), t) : (s._fetch || (n.value().length || (a ? s.select(o) : s._accessor() && n.value(s._accessor())), s._initialIndex = null, i = n.selectedDataItems()[0], i && (s._value(i) !== s.value() ? s._custom(s._value(i)) : s._value(i) !== s.element[0].value && s._accessor(s._value(i)), s.text() && s.text() !== s._text(i) && s._selectValue(i))), t)
                },
                _updateItemFocus: function() {
                    var e = this.listView;
                    this.options.highlightFirst ? e.focus() || e.focusIndex() || e.focus(0) : e.focus(-1)
                },
                _listBound: function() {
                    var e = this,
                        i = e.input[0] === r(),
                        s = e.dataSource.flatView(),
                        n = e.listView.skip(),
                        o = s.length,
                        a = e.dataSource._group ? e.dataSource._group.length : 0,
                        l = n === t || 0 === n;
                    e._presetValue = !1, e._renderFooter(), e._renderNoData(), e._toggleNoData(!o), e._toggleHeader(!!a && !!o), e._resizePopup(), e.popup.position(), e._buildOptions(s), e._makeUnselectable(), e._updateSelection(), s.length && l && (e._updateItemFocus(), e.options.suggest && i && e.input.val() && e.suggest(s[0])), e._open && (e._open = !1, e._typingTimeout && !i ? e.popup.close() : e.toggle(e._allowOpening()), e._typingTimeout = null), e._hideBusy(), e.trigger("dataBound")
                },
                _listChange: function() {
                    this._selectValue(this.listView.selectedDataItems()[0]), this._presetValue && (this._oldIndex = this.selectedIndex)
                },
                _get: function(e) {
                    var t, i, s;
                    if ("function" == typeof e) {
                        for (t = this.dataSource.flatView(), s = 0; s < t.length; s++)
                            if (e(t[s])) {
                                e = s, i = !0;
                                break
                            }
                        i || (e = -1)
                    }
                    return e
                },
                _select: function(e, t) {
                    var i = this;
                    return e = i._get(e), e === -1 && (i.input[0].value = "", i._accessor("")), i.listView.select(e).done(function() {
                        t || i._state !== I || (i._state = C), i._toggleCloseVisibility()
                    })
                },
                _selectValue: function(e) {
                    var i = this.listView.select(),
                        s = "",
                        n = "";
                    i = i[i.length - 1], i === t && (i = -1), this.selectedIndex = i, this.listView.isFiltered() && i !== -1 && (this._valueBeforeCascade = this._old), i !== -1 || e ? ((e || 0 === e) && (s = this._dataValue(e), n = this._text(e)), null === s && (s = "")) : (this.options.syncValueAndText ? (n = this.options.dataTextField === this.options.dataValueField ? this._accessor() : this.input[0].value, s = n) : n = this.text(), this.listView.focus(-1)), this._setDomInputValue(n), this._accessor(s !== t ? s : n, i), this._placeholder(), this._triggerCascade()
                },
                _setDomInputValue: function(e) {
                    var t, i, s = this,
                        n = a(this.input);
                    n && n.length && (t = n[0]), this._prev = this.input[0].value = e, t && this.selectedIndex === -1 && (i = l.mobileOS, i.wp || i.android ? setTimeout(function() {
                        s.input[0].setSelectionRange(t, t)
                    }, 0) : this.input[0].setSelectionRange(t, t))
                },
                refresh: function() {
                    this.listView.refresh()
                },
                _toggleCloseVisibility: function() {
                    var e = this.element.is(":disabled") || this.element.is("[readonly]");
                    this.text() && !e ? this._showClear() : this._hideClear()
                },
                suggest: function(e) {
                    var i, s = this,
                        o = s.input[0],
                        l = s.text(),
                        u = a(o)[0],
                        d = s._last,
                        p = s.dataSource.options.accentFoldingFiltering;
                    return d == c.BACKSPACE || d == c.DELETE ? (s._last = t, t) : (e = e || "", "string" != typeof e && (e[0] && (e = s.dataSource.view()[n.inArray(e[0], s.ul[0])]), e = e ? s._text(e) : ""), u <= 0 && (u = (p ? l.toLocaleLowerCase(p) : l.toLowerCase()).indexOf(p ? e.toLocaleLowerCase(p) : e.toLowerCase()) + 1), e ? (e = "" + e, i = (p ? e.toLocaleLowerCase(p) : e.toLowerCase()).indexOf(p ? l.toLocaleLowerCase(p) : l.toLowerCase()), i > -1 && (l += e.substring(i + l.length))) : l = l.substring(0, u), l.length === u && e || (o.value = l, o === r() && a(o, u, l.length)), t)
                },
                text: function(e) {
                    var i, s, o, a, l, u;
                    return e = null === e ? "" : e, i = this, s = i.input[0], o = i.options.ignoreCase, a = e, e === t ? s.value : i.options.autoBind !== !1 || i.listView.bound() ? (l = i.dataItem(), l && i._text(l).replace && i._text(l).replace(S, "") === e && (u = i._value(l), u === n.unifyType(i._old, typeof u)) ? (i._triggerCascade(), t) : (o && (a = a.toLowerCase()), i.dataItem() && i._text(i.dataItem()) === e || (i._select(function(e) {
                        return e = i._text(e), o && (e = (e + "").toLowerCase()), e === a
                    }).done(function() {
                        i.selectedIndex < 0 && (s.value = e, i.options.syncValueAndText && i._accessor(e), i._cascadeTriggered = !0, i._triggerCascade()), i._prev = s.value
                    }), i._toggleCloseVisibility()), t)) : (i._setText(e), t)
                },
                toggle: function(e) {
                    this._toggle(e, !0)
                },
                value: function(e) {
                    var i = this,
                        s = i.options,
                        n = i.listView;
                    return e === t ? (e = i._accessor() || i.listView.value()[0], e === t || null === e ? "" : e) : (i.requireValueMapper(i.options, e), i.trigger("set", {
                        value: e
                    }), e === s.value && i.input.val() === s.text || (i._accessor(e), i._isFilterEnabled() && n.bound() && n.isFiltered() ? i._clearFilter() : i._fetchData(), n.value(e).done(function() {
                        i.selectedIndex !== -1 || n._selectedDataItems && n._selectedDataItems.length || (i._accessor(e), i.input.val(e), i._placeholder(!0)), i._old = i._valueBeforeCascade = i._accessor(), i._oldIndex = i.selectedIndex, i._prev = i.input.val(), i._state === I && (i._state = C), i._toggleCloseVisibility()
                    })), t)
                },
                _hideBusy: function() {
                    var e = this;
                    clearTimeout(e._busy), e._arrowIcon.removeClass(m), e._focused.attr("aria-busy", !1), e._busy = null, e._toggleCloseVisibility()
                },
                _click: function(e) {
                    var i = this,
                        s = e.item,
                        o = i.listView.dataItemByIndex(i.listView.getElementIndex(s)),
                        a = !0;
                    return e.preventDefault(), o && (a = i._value(o) !== n.unifyType(i.value(), typeof i._value(o)), a || i.input.val(i._text(o))), a && i.trigger("select", {
                        dataItem: o,
                        item: s
                    }) ? (i.close(), t) : (i._userTriggered = !0, i._select(s).done(function() {
                        i._blur()
                    }), t)
                },
                _syncValueAndText: function() {
                    return this.options.syncValueAndText
                },
                _inputValue: function() {
                    return this.text()
                },
                _searchByWord: function(e) {
                    var i, s = this,
                        n = s.options,
                        o = s.dataSource,
                        a = n.ignoreCase,
                        l = function(i) {
                            var n = s._text(i);
                            if (n !== t) return n += "", ("" === n || "" !== e) && (a && (n = n.toLowerCase()), 0 === n.indexOf(e))
                        };
                    return a && (e = e.toLowerCase()), s.ul[0].firstChild ? (this.listView.focus(this._get(l)), i = this.listView.focus(), i && (n.suggest && s.suggest(i), this.open()), this.options.highlightFirst && !e && this.listView.focusFirst(), t) : (o.one(v, function() {
                        o.view()[0] && s.search(e)
                    }).fetch(), t)
                },
                _input: function() {
                    var t, i, s = this,
                        n = s.element.removeClass("k-input")[0],
                        o = n.accessKey,
                        a = s.wrapper,
                        l = "input.k-input",
                        r = n.name || "";
                    r && (r = 'name="' + r + '_input" '), t = a.find(l), t[0] || (a.append('<span tabindex="-1" unselectable="on" class="k-dropdown-wrap k-state-default"><input ' + r + 'class="k-input" type="text" autocomplete="' + b + '"/><span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-arrow-60-down"></span></span></span>').append(s.element), t = a.find(l)), t[0].style.cssText = n.style.cssText, t[0].title = n.title, i = parseInt(this.element.prop("maxlength") || this.element.attr("maxlength"), 10), i > -1 && (t[0].maxLength = i), t.addClass(n.className).css({
                        width: "",
                        height: n.style.height
                    }).attr({
                        role: "combobox",
                        "aria-expanded": !1
                    }).show(), u && t.attr("placeholder", s.options.placeholder), o && (n.accessKey = "", t[0].accessKey = o), s._focused = s.input = t, s._inputWrapper = e(a[0].firstChild), s._arrow = a.find(".k-select").attr({
                        role: "button",
                        tabIndex: -1
                    }), s._arrowIcon = s._arrow.find(".k-icon"), n.id && s._arrow.attr("aria-controls", s.ul[0].id)
                },
                _clearButton: function() {
                    n.fn._clearButton.call(this), this.options.clearButton && (this._clear.insertAfter(this.input), this.wrapper.addClass("k-combobox-clearable"))
                },
                _keydown: function(e) {
                    var t, i, s, o = this,
                        a = e.keyCode;
                    if (o._last = a, clearTimeout(o._typingTimeout), o._typingTimeout = null, a === c.HOME) o._firstItem();
                    else if (a === c.END) o._lastItem();
                    else if (a === c.ENTER || a === c.TAB && o.popup.visible())
                        if (t = o.listView.focus(), i = o.dataItem(), s = !0, o.popup.visible() || i && o.text() === o._text(i) || (t = null), t) {
                            if (o.popup.visible() && e.preventDefault(), i = o.listView.dataItemByIndex(o.listView.getElementIndex(t)), i && (s = o._value(i) !== n.unifyType(o.value(), typeof o._value(i))), s && o.trigger("select", {
                                    dataItem: i,
                                    item: t
                                })) return;
                            o._userTriggered = !0, o._select(t).done(function() {
                                o._blur(), o._valueBeforeCascade = o._old = o.value()
                            })
                        } else(o._syncValueAndText() || o._isSelect) && o._accessor(o.input.val()), o.listView.value(o.input.val()), o._blur();
                    else a == c.TAB || o._move(e) ? a === c.ESC && !o.popup.visible() && o.text() && o._clearValue() : o._search()
                },
                _placeholder: function(e) {
                    if (!u) {
                        var i, s = this,
                            n = s.input,
                            o = s.options.placeholder;
                        if (o) {
                            if (i = s.value(), e === t && (e = !i), n.toggleClass("k-readonly", e), !e) {
                                if (i) return;
                                o = ""
                            }
                            n.val(o), o || n[0] !== r() || a(n[0], 0, 0)
                        }
                    }
                },
                _search: function() {
                    var e = this;
                    clearTimeout(e._typingTimeout), e._typingTimeout = setTimeout(function() {
                        var t = e.text();
                        e._prev !== t && (e._prev = t, "none" === e.options.filter && e.options.virtual && e.listView.select(-1), e.search(t), e._toggleCloseVisibility()), e._typingTimeout = null
                    }, e.options.delay)
                },
                _setText: function(e) {
                    this.input.val(e), this._prev = e
                },
                _wrapper: function() {
                    var e = this,
                        t = e.element,
                        i = t.parent();
                    i.is("span.k-widget") || (i = t.hide().wrap("<span />").parent(), i[0].style.cssText = t[0].style.cssText), e.wrapper = i.addClass("k-widget k-combobox").addClass(t[0].className).css("display", "")
                },
                _clearSelection: function(e, t) {
                    var i = this,
                        s = e.value(),
                        n = s && e.selectedIndex === -1;
                    this.selectedIndex == -1 && this.value() || (t || !s || n) && (i.options.value = "", i.value(""))
                },
                _preselect: function(e, t) {
                    this.input.val(t), this._accessor(e), this._old = this._accessor(), this._oldIndex = this.selectedIndex, this.listView.setValue(e), this._placeholder(), this._initialIndex = null, this._presetValue = !0, this._toggleCloseVisibility()
                },
                _clearText: function() {
                    this._old = this.value(), this.text("")
                },
                _clearValue: function() {
                    o.fn._clearValue.call(this), this.input.focus()
                }
            });
        s.plugin(B)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, i) {
    (i || t)()
});;
! function(e, define) {
    define("kendo.datepicker.min", ["kendo.calendar.min", "kendo.popup.min", "kendo.dateinput.min"], e)
}(function() {
    return function(e, t) {
        function a(t) {
            var a = t.parseFormats,
                n = t.format;
            S.normalize(t), a = e.isArray(a) ? a : [a], a.length || a.push("yyyy-MM-dd"), e.inArray(n, a) === -1 && a.splice(0, 0, t.format), t.parseFormats = a
        }

        function n(e) {
            e.preventDefault()
        }
        var i, o = window.kendo,
            r = o.ui,
            l = r.Widget,
            s = o.parseDate,
            u = o.keys,
            d = o.support,
            p = o.template,
            c = o._activeElement,
            m = "<div />",
            f = "<span />",
            _ = ".kendoDatePicker",
            v = "click" + _,
            h = d.mouseAndTouchPresent ? o.applyEventMap("up", _.slice(1)) : v,
            g = "open",
            w = "close",
            b = "change",
            k = "disabled",
            y = "readonly",
            D = "k-state-default",
            x = "k-state-focused",
            I = "k-state-selected",
            A = "k-state-disabled",
            T = "k-state-hover",
            V = "mouseenter" + _ + " mouseleave" + _,
            C = "mousedown" + _,
            O = "id",
            R = "min",
            E = "max",
            P = "month",
            N = "aria-disabled",
            F = "aria-expanded",
            W = "aria-hidden",
            S = o.calendar,
            H = S.isInRange,
            M = S.restrictValue,
            q = S.isEqualDatePart,
            z = e.extend,
            K = e.proxy,
            U = Date,
            j = function(t) {
                var a, n = this,
                    i = document.body,
                    l = e(m).attr(W, "true").addClass("k-calendar-container").appendTo(i);
                n.options = t = t || {}, a = t.id, a && (a += "_dateview", l.attr(O, a), n._dateViewID = a), n.popup = new r.Popup(l, z(t.popup, t, {
                    name: "Popup",
                    isRtl: o.support.isRtl(t.anchor)
                })), n.div = l, n.value(t.value)
            };
        j.prototype = {
            _calendar: function() {
                var t, a = this,
                    i = a.calendar,
                    l = a.options;
                i || (t = e(m).attr(O, o.guid()).appendTo(a.popup.element).on(C, n).on(v, "td:has(.k-link)", K(a._click, a)), a.calendar = i = new r.Calendar(t), a._setOptions(l), o.calendar.makeUnselectable(i.element), i.navigate(a._value || a._current, l.start), a.value(a._value))
            },
            _setOptions: function(e) {
                this.calendar.setOptions({
                    focusOnNav: !1,
                    change: e.change,
                    culture: e.culture,
                    dates: e.dates,
                    depth: e.depth,
                    footer: e.footer,
                    format: e.format,
                    max: e.max,
                    min: e.min,
                    month: e.month,
                    weekNumber: e.weekNumber,
                    start: e.start,
                    disableDates: e.disableDates
                })
            },
            setOptions: function(e) {
                var t = this.options,
                    a = e.disableDates;
                a && (e.disableDates = S.disabled(a)), this.options = z(t, e, {
                    change: t.change,
                    close: t.close,
                    open: t.open
                }), this.calendar && this._setOptions(this.options)
            },
            destroy: function() {
                this.popup.destroy()
            },
            open: function() {
                var e, t = this;
                t._calendar(), e = t.popup._hovered, t.popup._hovered = !0, t.popup.open(), setTimeout(function() {
                    t.popup._hovered = e
                }, 1)
            },
            close: function() {
                this.popup.close()
            },
            min: function(e) {
                this._option(R, e)
            },
            max: function(e) {
                this._option(E, e)
            },
            toggle: function() {
                var e = this;
                e[e.popup.visible() ? w : g]()
            },
            move: function(e) {
                var t = this,
                    a = e.keyCode,
                    n = t.calendar,
                    i = e.ctrlKey && a == u.DOWN || a == u.ENTER,
                    o = !1;
                if (e.altKey) a == u.DOWN ? (t.open(), e.preventDefault(), o = !0) : a == u.UP && (t.close(), e.preventDefault(), o = !0);
                else if (t.popup.visible()) {
                    if (a == u.ESC || i && n._cell.hasClass(I)) return t.close(), e.preventDefault(), !0;
                    a != u.SPACEBAR && (t._current = n._move(e)), o = !0
                }
                return o
            },
            current: function(e) {
                this._current = e, this.calender && this.calendar._focus(e)
            },
            value: function(e) {
                var t = this,
                    a = t.calendar,
                    n = t.options,
                    i = n.disableDates;
                i && i(e) && (e = null), t._value = e, t._current = new U((+M(e, n.min, n.max))), a && a.value(e)
            },
            _click: function(e) {
                e.currentTarget.className.indexOf(I) !== -1 && (this.calendar.trigger("change"), this.close())
            },
            _option: function(e, t) {
                var a = this,
                    n = a.calendar;
                a.options[e] = t, n && n[e](t)
            }
        }, j.normalize = a, o.DateView = j, i = l.extend({
            init: function(t, n) {
                var i, r, u = this;
                l.fn.init.call(u, t, n), t = u.element, n = u.options, n.disableDates = o.calendar.disabled(n.disableDates), n.min = s(t.attr("min")) || s(n.min), n.max = s(t.attr("max")) || s(n.max), a(n), u._initialOptions = z({}, n), u._wrapper(), u.dateView = new j(z({}, n, {
                    id: t.attr(O),
                    anchor: u.wrapper,
                    change: function() {
                        u._change(this.value()), u.close()
                    },
                    close: function(e) {
                        u.trigger(w) ? e.preventDefault() : (t.attr(F, !1), r.attr(W, !0))
                    },
                    open: function(e) {
                        var a, n = u.options;
                        u.trigger(g) ? e.preventDefault() : (u.element.val() !== u._oldText && (a = s(t.val(), n.parseFormats, n.culture), u.dateView[a ? "current" : "value"](a)), t.attr(F, !0), r.attr(W, !1), u._updateARIA(a))
                    }
                })), r = u.dateView.div, u._icon();
                try {
                    t[0].setAttribute("type", "text")
                } catch (d) {
                    t[0].type = "text"
                }
                t.addClass("k-input").attr({
                    role: "combobox",
                    "aria-expanded": !1,
                    "aria-owns": u.dateView._dateViewID,
                    autocomplete: "off"
                }), u._reset(), u._template(), i = t.is("[disabled]") || e(u.element).parents("fieldset").is(":disabled"), i ? u.enable(!1) : u.readonly(t.is("[readonly]")), u._createDateInput(n), u._old = u._update(n.value || u.element.val()), u._oldText = t.val(), o.notify(u)
            },
            events: [g, w, b],
            options: {
                name: "DatePicker",
                value: null,
                footer: "",
                format: "",
                culture: "",
                parseFormats: [],
                min: new Date(1900, 0, 1),
                max: new Date(2099, 11, 31),
                start: P,
                depth: P,
                animation: {},
                month: {},
                dates: [],
                disableDates: null,
                ARIATemplate: 'Current focused date is #=kendo.toString(data.current, "D")#',
                dateInput: !1,
                weekNumber: !1
            },
            setOptions: function(e) {
                var t = this,
                    n = t._value;
                l.fn.setOptions.call(t, e), e = t.options, e.min = s(e.min), e.max = s(e.max), a(e), t.dateView.setOptions(e), t._createDateInput(e), t._dateInput || t.element.val(o.toString(n, e.format, e.culture)), n && t._updateARIA(n)
            },
            _editable: function(e) {
                var t = this,
                    a = t._dateIcon.off(_),
                    i = t.element.off(_),
                    o = t._inputWrapper.off(_),
                    r = e.readonly,
                    l = e.disable;
                r || l ? (o.addClass(l ? A : D).removeClass(l ? D : A), i.attr(k, l).attr(y, r).attr(N, l)) : (o.addClass(D).removeClass(A).on(V, t._toggleHover), i && i.length && (i[0].removeAttribute(k), i[0].removeAttribute(y)), i.attr(N, !1).on("keydown" + _, K(t._keydown, t)).on("focusout" + _, K(t._blur, t)).on("focus" + _, function() {
                    t._inputWrapper.addClass(x)
                }), a.on(h, K(t._click, t)).on(C, n))
            },
            readonly: function(e) {
                this._editable({
                    readonly: e === t || e,
                    disable: !1
                }), this._dateInput && this._dateInput._editable({
                    readonly: e === t || e,
                    disable: !1
                })
            },
            enable: function(e) {
                this._editable({
                    readonly: !1,
                    disable: !(e = e === t || e)
                }), this._dateInput && this._dateInput._editable({
                    readonly: !1,
                    disable: !(e = e === t || e)
                })
            },
            destroy: function() {
                var e = this;
                l.fn.destroy.call(e), e.dateView.destroy(), e.element.off(_), e._dateIcon.off(_), e._inputWrapper.off(_), e._form && e._form.off("reset", e._resetHandler)
            },
            open: function() {
                this.dateView.open()
            },
            close: function() {
                this.dateView.close()
            },
            min: function(e) {
                return this._option(R, e)
            },
            max: function(e) {
                return this._option(E, e)
            },
            value: function(e) {
                var a = this;
                return e === t ? a._value : (a._old = a._update(e), null === a._old && a.element.val(""), a._oldText = a.element.val(), t)
            },
            _toggleHover: function(t) {
                e(t.currentTarget).toggleClass(T, "mouseenter" === t.type)
            },
            _blur: function () {
                var e = this,
                    t = e.element.val();
                e.close(), t !== e._oldText && e._change(t), e._inputWrapper.removeClass(x)
            },
            _click: function(e) {
                var t = this;
                t.dateView.toggle(), t._focusElement(e.type)
            },
            _focusElement: function(e) {
                var t = this.element;
                d.touch && (!d.mouseAndTouchPresent || (e || "").match(/touch/i)) || t[0] === c() || t.trigger("focus")
            },
            _change: function(e) {
                var t, a, n, i = this,
                    r = i.element.val();
                e = i._update(e), t = !o.calendar.isEqualDate(i._old, e), a = t && !i._typing, n = r !== i.element.val(), (a || n) && i.element.trigger(b), t && (i._old = e, i._oldText = i.element.val(), i.trigger(b)), i._typing = !1
            },
            _keydown: function(e) {
                var t = this,
                    a = t.dateView,
                    n = t.element.val(),
                    i = !1;
                a.popup.visible() || e.keyCode != u.ENTER || n === t._oldText ? (i = a.move(e), t._updateARIA(a._current), i ? t._dateInput && e.stopImmediatePropagation && e.stopImmediatePropagation() : t._typing = !0) : t._change(n)
            },
            _icon: function() {
                var t, a = this,
                    n = a.element;
                t = n.next("span.k-select"), t[0] || (t = e('<span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-calendar"></span></span>').insertAfter(n)), a._dateIcon = t.attr({
                    role: "button",
                    "aria-controls": a.dateView._dateViewID
                })
            },
            _option: function(e, a) {
                var n = this,
                    i = n.options;
                return a === t ? i[e] : (a = s(a, i.parseFormats, i.culture), a && (i[e] = new U((+a)), n.dateView[e](a)), t)
            },
            _update: function(e) {
                var t, a = this,
                    n = a.options,
                    i = n.min,
                    r = n.max,
                    l = a._value,
                    u = s(e, n.parseFormats, n.culture),
                    d = null === u && null === l || u instanceof Date && l instanceof Date;
                return n.disableDates(u) && (u = null, a._old || a.element.val() || (e = null)), +u === +l && d ? (t = o.toString(u, n.format, n.culture), t !== e && a.element.val(null === u ? e : t), u) : (null !== u && q(u, i) ? u = M(u, i, r) : H(u, i, r) || (u = null), a._value = u, a.dateView.value(u), a._dateInput && u ? a._dateInput.value(u || e) : a.element.val(o.toString(u || e, n.format, n.culture)), a._updateARIA(u), u)
            },
            _wrapper: function() {
                var t, a = this,
                    n = a.element;
                t = n.parents(".k-datepicker"), t[0] || (t = n.wrap(f).parent().addClass("k-picker-wrap k-state-default"), t = t.wrap(f).parent()), t[0].style.cssText = n[0].style.cssText, n.css({
                    width: "100%",
                    height: n[0].style.height
                }), a.wrapper = t.addClass("k-widget k-datepicker").addClass(n[0].className), a._inputWrapper = e(t[0].firstChild)
            },
            _reset: function() {
                var t = this,
                    a = t.element,
                    n = a.attr("form"),
                    i = t.options,
                    r = i.disableDates,
                    l = i.parseFormats.length ? i.parseFormats : null,
                    s = t._initialOptions.value,
                    u = n ? e("#" + n) : a.closest("form"),
                    d = a[0].defaultValue;
                s && r && r(s) && (s = null), d && o.parseDate(d, l, i.culture) || !s || a.attr("value", o.toString(s, i.format, i.culture)), u[0] && (t._resetHandler = function() {
                    t.value(s || a[0].defaultValue), t.max(t._initialOptions.max), t.min(t._initialOptions.min)
                }, t._form = u.on("reset", t._resetHandler))
            },
            _template: function() {
                this._ariaTemplate = p(this.options.ARIATemplate)
            },
            _createDateInput: function(e) {
                this._dateInput && (this._dateInput.destroy(), this._dateInput = null), e.dateInput && (this._dateInput = new r.DateInput(this.element, {
                    culture: e.culture,
                    format: e.format,
                    min: e.min,
                    max: e.max
                }))
            },
            _updateARIA: function(e) {
                var t, a = this,
                    n = a.dateView.calendar;
                a.element && a.element.length && a.element[0].removeAttribute("aria-activedescendant"), n && (t = n._cell, t.attr("aria-label", a._ariaTemplate({
                    current: e || n.current()
                })), a.element.attr("aria-activedescendant", t.attr("id")))
            }
        }), r.plugin(i)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, a) {
    (a || t)()
});;
! function(e, define) {
    define("kendo.timepicker.min", ["kendo.popup.min", "kendo.dateinput.min"], e)
}(function() {
    return function(e, t) {
        function n() {
            var e = new Q,
                t = new Q(e.getFullYear(), e.getMonth(), e.getDate(), 0, 0, 0),
                n = new Q(e.getFullYear(), e.getMonth(), e.getDate(), 12, 0, 0);
            return -1 * (t.getTimezoneOffset() - n.getTimezoneOffset())
        }

        function i(e) {
            return 60 * e.getHours() * A + e.getMinutes() * A + 1e3 * e.getSeconds() + e.getMilliseconds()
        }

        function a(e) {
            var t = new Date(2100, 0, 1);
            return t.setMinutes(-e), t
        }

        function o(e, t, n) {
            var a, o = i(t),
                r = i(n);
            return !e || o == r || (a = i(e), o > a && (a += O), r < o && (r += O), a >= o && a <= r)
        }

        function r(e) {
            var t = e.parseFormats;
            e.format = h(e.format || p.getCulture(e.culture).calendars.standard.patterns.t), t = z(t) ? t : [t], t.splice(0, 0, e.format), e.parseFormats = t
        }

        function l(e) {
            e.preventDefault()
        }

        function s(e, t) {
            return new Date(e.getFullYear(), e.getMonth(), e.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds())
        }
        var u, c, p = window.kendo,
            d = p.keys,
            f = p.parseDate,
            m = p._activeElement,
            h = p._extractFormat,
            _ = p.support,
            g = _.browser,
            v = p.ui,
            w = v.Widget,
            k = "open",
            b = "close",
            x = "change",
            y = ".kendoTimePicker",
            D = "click" + y,
            C = "k-state-default",
            T = "disabled",
            I = "readonly",
            V = "li",
            F = "<span/>",
            M = "k-state-focused",
            S = "k-state-hover",
            H = "mouseenter" + y + " mouseleave" + y,
            W = "mousedown" + y,
            A = 6e4,
            O = 864e5,
            E = "k-state-selected",
            P = "k-state-disabled",
            R = "aria-selected",
            Y = "aria-expanded",
            B = "aria-hidden",
            N = "aria-disabled",
            L = "aria-activedescendant",
            j = "id",
            z = e.isArray,
            K = e.extend,
            q = e.proxy,
            Q = Date,
            U = new Q;
        U = new Q(U.getFullYear(), U.getMonth(), U.getDate(), 0, 0, 0), u = function(t) {
            var n = this,
                i = t.id;
            n.options = t, n._dates = [], n.ul = e('<ul tabindex="-1" role="listbox" aria-hidden="true" unselectable="on" class="k-list k-reset"/>').css({
                overflow: _.kineticScrollNeeded ? "" : "auto"
            }).on(D, V, q(n._click, n)).on("mouseenter" + y, V, function() {
                e(this).addClass(S)
            }).on("mouseleave" + y, V, function() {
                e(this).removeClass(S)
            }), n.list = e("<div class='k-list-container k-list-scroller' unselectable='on'/>").append(n.ul).on(W, l), i && (n._timeViewID = i + "_timeview", n._optionID = i + "_option_selected", n.ul.attr(j, n._timeViewID)), n._popup(), n._heightHandler = q(n._height, n), n.template = p.template('<li tabindex="-1" role="option" class="k-item" unselectable="on">#=data#</li>', {
                useWithBlock: !1
            })
        }, u.prototype = {
            current: function(n) {
                var i = this,
                    a = i.options.active;
                return n === t ? i._current : (i._current && (i._current.removeClass(E), i._current && i._current.length && (i._current[0].removeAttribute(j), i._current[0].removeAttribute(R))), n && (n = e(n).addClass(E).attr(j, i._optionID).attr(R, !0), i.scroll(n[0])), i._current = n, a && a(n), t)
            },
            close: function() {
                this.popup.close()
            },
            destroy: function() {
                var e = this;
                e.ul.off(y), e.list.off(y), e.popup.destroy()
            },
            open: function() {
                var e, t = this;
                t.ul[0].firstChild || t.bind(), e = t.popup._hovered, t.popup._hovered = !0, t.popup.open(), setTimeout(function() {
                    t.popup._hovered = e
                }, 1), t._current && t.scroll(t._current[0])
            },
            dataBind: function(e) {
                for (var t, n = this, i = n.options, a = i.format, r = p.toString, l = n.template, s = e.length, u = 0, c = ""; u < s; u++) t = e[u], o(t, i.min, i.max) && (c += l(r(t, a, i.culture)));
                n._html(c)
            },
            refresh: function() {
                var e, t, o = this,
                    r = o.options,
                    l = r.format,
                    u = n(),
                    c = u < 0,
                    d = p.parseDate(o._value),
                    f = d ? s(d, r.min) : s(new Date, r.min),
                    m = r.min,
                    h = r.max,
                    _ = i(m),
                    g = i(h),
                    v = i(a(r.interval)),
                    w = r.interval * A,
                    k = p.toString,
                    b = o.template,
                    x = r.useValueToRender ? f : new Date((+r.min)),
                    y = new Q(x),
                    D = "";
                for (t = c ? (O + u * A) / w : O / w, _ == g && v !== g || (_ > g && (g += O), t = (g - _) / w + 1);;) {
                    if (g && (i(x) >= g || y.getDate() != x.getDate())) {
                        e = i(x), y < x && (e += O), e > g && (x = new Q((+h))), i(x) > 0 && (D += b(k(x, l, r.culture)));
                        break
                    }
                    if (y.getDate() != x.getDate()) break;
                    D += b(k(x, l, r.culture)), x.setTime(x.getTime() + w)
                }
                o._html(D)
            },
            bind: function() {
                var e = this,
                    t = e.options.dates;
                t && t[0] ? e.dataBind(t) : e.refresh()
            },
            _html: function(e) {
                var t = this;
                t.ul[0].innerHTML = e, t.popup.unbind(k, t._heightHandler), t.popup.one(k, t._heightHandler), t.current(null), t.select(t._value)
            },
            scroll: function(e) {
                if (e) {
                    var t = this.list[0],
                        n = e.offsetTop,
                        i = e.offsetHeight,
                        a = t.scrollTop,
                        o = t.clientHeight,
                        r = n + i;
                    a > n ? a = n : r > a + o && (a = r - o), t.scrollTop = a
                }
            },
            select: function(t) {
                var n, i = this,
                    a = i.options,
                    o = i._current;
                t instanceof Date && (t = p.toString(t, a.format, a.culture)), "string" == typeof t && (o && o.text() === t ? t = o : (t = e.grep(i.ul[0].childNodes, function(e) {
                    return (e.textContent || e.innerText) == t
                }), t = t[0] ? t : null)), n = i._distinctSelection(t), i.current(n)
            },
            _distinctSelection: function(t) {
                var n, a, o = this;
                return t && t.length > 1 && (n = i(o._value), a = e.inArray(n, o._dates), t = o.ul.children()[a]), t
            },
            setOptions: function(e) {
                var t = this.options;
                e.min = f(e.min), e.max = f(e.max), this.options = K(t, e, {
                    active: t.active,
                    change: t.change,
                    close: t.close,
                    open: t.open
                }), this.bind()
            },
            toggle: function() {
                var e = this;
                e.popup.visible() ? e.close() : e.open()
            },
            value: function(e) {
                var t = this;
                t._value = e, t.ul[0].firstChild && t.select(e)
            },
            _click: function(t) {
                var n = this,
                    i = e(t.currentTarget),
                    a = i.text(),
                    o = n.options.dates;
                o && o.length > 0 && (a = o[i.index()]), t.isDefaultPrevented() || (n.select(i), n.options.change(a, !0), n.close())
            },
            _height: function() {
                var e = this,
                    t = e.list,
                    n = t.parent(".k-animation-container"),
                    i = e.options.height;
                e.ul[0].children.length && t.add(n).show().height(e.ul[0].scrollHeight > i ? i : "auto").hide()
            },
            _parse: function(e) {
                var t = this,
                    n = t.options,
                    a = i(n.min) != i(U) ? n.min : null,
                    o = i(n.max) != i(U) ? n.max : null,
                    r = t._value || a || o || U;
                return e instanceof Q ? e : (e = f(e, n.parseFormats, n.culture), e && (e = new Q(r.getFullYear(), r.getMonth(), r.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds())), e)
            },
            _adjustListWidth: function() {
                var e, t, n = this.list,
                    i = n[0].style.width,
                    a = this.options.anchor,
                    o = p._outerWidth;
                !n.data("width") && i || (e = window.getComputedStyle ? window.getComputedStyle(a[0], null) : 0, t = e ? parseFloat(e.width) : o(a), e && (g.mozilla || g.msie) && (t += parseFloat(e.paddingLeft) + parseFloat(e.paddingRight) + parseFloat(e.borderLeftWidth) + parseFloat(e.borderRightWidth)), i = t - (o(n) - n.width()), n.css({
                    fontFamily: a.css("font-family"),
                    width: i
                }).data("width", i))
            },
            _popup: function() {
                var e = this,
                    t = e.list,
                    n = e.options,
                    i = n.anchor;
                e.popup = new v.Popup(t, K(n.popup, {
                    anchor: i,
                    open: n.open,
                    close: n.close,
                    animation: n.animation,
                    isRtl: _.isRtl(n.anchor)
                }))
            },
            move: function(e) {
                var n = this,
                    i = e.keyCode,
                    a = n.ul[0],
                    o = n._current,
                    r = i === d.DOWN;
                if (i === d.UP || r) {
                    if (e.altKey) return n.toggle(r), t;
                    o = r ? o ? o[0].nextSibling : a.firstChild : o ? o[0].previousSibling : a.lastChild, o && n.select(o), n.options.change(n._current.text()), e.preventDefault()
                } else i !== d.ENTER && i !== d.TAB && i !== d.ESC || (e.preventDefault(), o && n.options.change(o.text(), !0), n.close())
            }
        }, u.getMilliseconds = i, p.TimeView = u, c = w.extend({
            init: function(t, n) {
                var a, o, l, s, c, d, m = this;
                w.fn.init.call(m, t, n), t = m.element, n = m.options, n.min = f(t.attr("min")) || f(n.min), n.max = f(t.attr("max")) || f(n.max), r(n), m._initialOptions = K({}, n), m._wrapper(), m.timeView = o = new u(K({}, n, {
                    id: t.attr(j),
                    anchor: m.wrapper,
                    format: n.format,
                    change: function(e, n) {
                        n ? m._change(e) : t.val(e)
                    },
                    open: function(e) {
                        m.timeView._adjustListWidth(), m.trigger(k) ? e.preventDefault() : (t.attr(Y, !0), a.attr(B, !1))
                    },
                    close: function(e) {
                        m.trigger(b) ? e.preventDefault() : (t.attr(Y, !1), a.attr(B, !0))
                    },
                    active: function(e) {
                        t && t.length && t[0].removeAttribute(L), e && t.attr(L, o._optionID)
                    }
                })), a = o.ul, m._icon(), m._reset();
                try {
                    t[0].setAttribute("type", "text")
                } catch (h) {
                    t[0].type = "text"
                }
                t.addClass("k-input").attr({
                    role: "combobox",
                    "aria-expanded": !1,
                    "aria-owns": o._timeViewID,
                    autocomplete: "off"
                }), l = t.is("[disabled]") || e(m.element).parents("fieldset").is(":disabled"), l ? m.enable(!1) : m.readonly(t.is("[readonly]")), n.dateInput && (s = n.min, c = n.max, d = new Q, i(s) == i(c) && (s = new Q(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0), c = new Q(d.getFullYear(), d.getMonth(), d.getDate(), 24, 0, 0)), m._dateInput = new v.DateInput(t, {
                    culture: n.culture,
                    format: n.format,
                    min: s,
                    max: c,
                    value: n.value,
                    interval: n.interval
                })), m._old = m._update(n.value || m.element.val()), m._oldText = t.val(), p.notify(m)
            },
            options: {
                name: "TimePicker",
                min: U,
                max: U,
                format: "",
                dates: [],
                parseFormats: [],
                value: null,
                interval: 30,
                height: 200,
                animation: {},
                dateInput: !1
            },
            events: [k, b, x],
            setOptions: function(e) {
                var t = this,
                    n = t._value;
                w.fn.setOptions.call(t, e), e = t.options, r(e), t.timeView.setOptions(e), n && t.element.val(p.toString(n, e.format, e.culture))
            },
            dataBind: function(e) {
                z(e) && this.timeView.dataBind(e)
            },
            _editable: function(e) {
                var t = this,
                    n = e.disable,
                    i = e.readonly,
                    a = t._arrow.off(y),
                    o = t.element.off(y),
                    r = t._inputWrapper.off(y);
                t._dateInput && t._dateInput._unbindInput(), i || n ? (r.addClass(n ? P : C).removeClass(n ? C : P), o.attr(T, n).attr(I, i).attr(N, n)) : (r.addClass(C).removeClass(P).on(H, t._toggleHover), o && o.length && (o[0].removeAttribute(T), o[0].removeAttribute(I)), o.attr(N, !1).on("keydown" + y, q(t._keydown, t)).on("focusout" + y, q(t._blur, t)).on("focus" + y, function() {
                    t._inputWrapper.addClass(M)
                }), t._dateInput && t._dateInput._bindInput(), a.on(D, q(t._click, t)).on(W, l))
            },
            readonly: function(e) {
                this._editable({
                    readonly: e === t || e,
                    disable: !1
                })
            },
            enable: function(e) {
                this._editable({
                    readonly: !1,
                    disable: !(e = e === t || e)
                })
            },
            destroy: function() {
                var e = this;
                w.fn.destroy.call(e), e.timeView.destroy(), e.element.off(y), e._arrow.off(y), e._inputWrapper.off(y), e._form && e._form.off("reset", e._resetHandler)
            },
            close: function() {
                this.timeView.close()
            },
            open: function() {
                this.timeView.open()
            },
            min: function(e) {
                return this._option("min", e)
            },
            max: function(e) {
                return this._option("max", e)
            },
            value: function(e) {
                var n = this;
                return e === t ? n._value : (n._old = n._update(e), null === n._old && n.element.val(""), n._oldText = n.element.val(), t)
            },
            _blur: function() {
                var e = this,
                    t = e.element.val();
                e.close(), t !== e._oldText && e._change(t), e._inputWrapper.removeClass(M)
            },
            _click: function() {
                var e = this,
                    t = e.element;
                e.timeView.toggle(), _.touch || t[0] === m() || t.trigger("focus")
            },
            _change: function(e) {
                var t, n, i, a = this,
                    o = a.element.val();
                e = a._update(e), t = !p.calendar.isEqualDate(a._old, e), n = t && !a._typing, i = o !== a.element.val(), (n || i) && a.element.trigger(x), t && (a._old = e, a._oldText = a.element.val(), a.trigger(x)), a._typing = !1
            },
            _icon: function() {
                var t, n = this,
                    i = n.element;
                t = i.next("span.k-select"), t[0] || (t = e('<span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-clock"></span></span>').insertAfter(i)), n._arrow = t.attr({
                    role: "button",
                    "aria-controls": n.timeView._timeViewID
                })
            },
            _keydown: function(e) {
                var t = this,
                    n = e.keyCode,
                    i = t.timeView,
                    a = t.element.val();
                i.popup.visible() || e.altKey ? (i.move(e), t._dateInput && e.stopImmediatePropagation && e.stopImmediatePropagation()) : n === d.ENTER && a !== t._oldText ? t._change(a) : t._typing = !0
            },
            _option: function(e, n) {
                var i = this,
                    a = i.options;
                return n === t ? a[e] : (n = i.timeView._parse(n), n && (n = new Q((+n)), a[e] = n, i.timeView.options[e] = n, i.timeView.bind()), t)
            },
            _toggleHover: function(t) {
                e(t.currentTarget).toggleClass(S, "mouseenter" === t.type)
            },
            _update: function(e) {
                var t = this,
                    n = t.options,
                    i = t.timeView,
                    a = i._parse(e);
                return o(a, n.min, n.max) || (a = null), t._value = a, t._dateInput && a ? t._dateInput.value(a || e) : t.element.val(p.toString(a || e, n.format, n.culture)), i.value(a), a
            },
            _wrapper: function() {
                var t, n = this,
                    i = n.element;
                t = i.parents(".k-timepicker"), t[0] || (t = i.wrap(F).parent().addClass("k-picker-wrap k-state-default"), t = t.wrap(F).parent()), t[0].style.cssText = i[0].style.cssText, n.wrapper = t.addClass("k-widget k-timepicker").addClass(i[0].className), i.css({
                    width: "100%",
                    height: i[0].style.height
                }), n._inputWrapper = e(t[0].firstChild)
            },
            _reset: function() {
                var t = this,
                    n = t.element,
                    i = n.attr("form"),
                    a = i ? e("#" + i) : n.closest("form");
                a[0] && (t._resetHandler = function() {
                    t.value(n[0].defaultValue), t.max(t._initialOptions.max), t.min(t._initialOptions.min)
                }, t._form = a.on("reset", t._resetHandler))
            }
        }), v.plugin(c)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(e, define) {
    define("kendo.datetimepicker.min", ["kendo.datepicker.min", "kendo.timepicker.min"], e)
}(function() {
    return function(e, t) {
        function a(e) {
            var t = new Date(2100, 0, 1);
            return t.setMinutes(-e), t
        }

        function n(e) {
            e.preventDefault()
        }

        function i(t) {
            var a, n = r.getCulture(t.culture).calendars.standard.patterns,
                i = !t.parseFormats.length;
            t.format = m(t.format || n.g), t.timeFormat = a = m(t.timeFormat || n.t), r.DateView.normalize(t), i && t.parseFormats.unshift("yyyy-MM-ddTHH:mm:ss"), e.inArray(a, t.parseFormats) === -1 && t.parseFormats.push(a)
        }
        var r = window.kendo,
            o = r.TimeView,
            l = r.parseDate,
            s = r.support,
            u = r._activeElement,
            m = r._extractFormat,
            d = r.calendar,
            c = d.isInRange,
            p = d.restrictValue,
            f = d.isEqualDatePart,
            _ = o.getMilliseconds,
            v = r.ui,
            g = v.Widget,
            h = "open",
            w = "close",
            x = "change",
            k = ".kendoDateTimePicker",
            b = "click" + k,
            y = s.mouseAndTouchPresent ? r.applyEventMap("up", k.slice(1)) : b,
            I = "disabled",
            D = "readonly",
            V = "k-state-default",
            T = "k-state-focused",
            A = "k-state-hover",
            F = "k-state-disabled",
            C = "mouseenter" + k + " mouseleave" + k,
            O = "mousedown" + k,
            R = "month",
            M = "<span/>",
            E = "aria-activedescendant",
            H = "aria-expanded",
            S = "aria-hidden",
            W = "aria-owns",
            B = "aria-disabled",
            P = Date,
            N = new P(1800, 0, 1),
            q = new P(2099, 11, 31),
            j = {
                view: "date"
            },
            Y = {
                view: "time"
            },
            z = e.extend,
            K = g.extend({
                init: function(t, a) {
                    var n, o = this;
                    g.fn.init.call(o, t, a), t = o.element, a = o.options, a.disableDates = r.calendar.disabled(a.disableDates), a.min = l(t.attr("min")) || l(a.min), a.max = l(t.attr("max")) || l(a.max), i(a), o._initialOptions = z({}, a), o._wrapper(), o._views(), o._icons(), o._reset(), o._template();
                    try {
                        t[0].setAttribute("type", "text")
                    } catch (s) {
                        t[0].type = "text"
                    }
                    t.addClass("k-input").attr({
                        role: "combobox",
                        "aria-expanded": !1,
                        autocomplete: "off"
                    }), o._midnight = o._calculateMidnight(a.min, a.max), n = t.is("[disabled]") || e(o.element).parents("fieldset").is(":disabled"), n ? o.enable(!1) : o.readonly(t.is("[readonly]")), o._createDateInput(a), o._old = o._update(a.value || o.element.val()), o._oldText = t.val(), r.notify(o)
                },
                options: {
                    name: "DateTimePicker",
                    value: null,
                    format: "",
                    timeFormat: "",
                    culture: "",
                    parseFormats: [],
                    dates: [],
                    disableDates: null,
                    min: new P(N),
                    max: new P(q),
                    interval: 30,
                    height: 200,
                    footer: "",
                    start: R,
                    depth: R,
                    animation: {},
                    month: {},
                    ARIATemplate: 'Current focused date is #=kendo.toString(data.current, "d")#',
                    dateButtonText: "Open the date view",
                    timeButtonText: "Open the time view",
                    dateInput: !1,
                    weekNumber: !1
                },
                events: [h, w, x],
                setOptions: function(e) {
                    var t, a, n, o = this,
                        s = o._value;
                    g.fn.setOptions.call(o, e), e = o.options, e.min = t = l(e.min), e.max = a = l(e.max), i(e), o._midnight = o._calculateMidnight(e.min, e.max), n = e.value || o._value || o.dateView._current, t && !f(t, n) && (t = new P(N)), a && !f(a, n) && (a = new P(q)), o.dateView.setOptions(e), o.timeView.setOptions(z({}, e, {
                        format: e.timeFormat,
                        min: t,
                        max: a
                    })), o._createDateInput(e), o._dateInput || o.element.val(r.toString(s, e.format, e.culture)), s && o._updateARIA(s)
                },
                _editable: function(t) {
                    var a = this,
                        i = a.element.off(k),
                        o = a._dateIcon.off(k),
                        l = a._timeIcon.off(k),
                        s = a._inputWrapper.off(k),
                        u = t.readonly,
                        m = t.disable;
                    u || m ? (s.addClass(m ? F : V).removeClass(m ? V : F), i.attr(I, m).attr(D, u).attr(B, m)) : (s.addClass(V).removeClass(F).on(C, a._toggleHover), i && i.length && (i[0].removeAttribute(I), i[0].removeAttribute(D, !1), i[0].removeAttribute(B, !1)), i.on("keydown" + k, e.proxy(a._keydown, a)).on("focus" + k, function() {
                        a._inputWrapper.addClass(T)
                    }).on("focusout" + k, function() {
                        a._inputWrapper.removeClass(T), i.val() !== a._oldText && (a._change(i.val()), i.val() || a.dateView.current(r.calendar.getToday())), a.close("date"), a.close("time")
                    }), o.on(O, n).on(y, function(e) {
                        a.toggle("date"), a._focusElement(e.type)
                    }), l.on(O, n).on(y, function(e) {
                        a.toggle("time"), a._focusElement(e.type)
                    }))
                },
                _focusElement: function(e) {
                    var t = this.element;
                    s.touch && (!s.mouseAndTouchPresent || (e || "").match(/touch/i)) || t[0] === u() || t.trigger("focus")
                },
                readonly: function(e) {
                    this._editable({
                        readonly: e === t || e,
                        disable: !1
                    })
                },
                enable: function(e) {
                    this._editable({
                        readonly: !1,
                        disable: !(e = e === t || e)
                    })
                },
                destroy: function() {
                    var e = this;
                    g.fn.destroy.call(e), e.dateView.destroy(), e.timeView.destroy(), e.element.off(k), e._dateIcon.off(k), e._timeIcon.off(k), e._inputWrapper.off(k), e._form && e._form.off("reset", e._resetHandler)
                },
                close: function(e) {
                    "time" !== e && (e = "date"), this[e + "View"].close()
                },
                open: function(e) {
                    "time" !== e && (e = "date"), this[e + "View"].open()
                },
                min: function(e) {
                    return this._option("min", e)
                },
                max: function(e) {
                    return this._option("max", e)
                },
                toggle: function(e) {
                    var t = "timeView";
                    "time" !== e ? e = "date" : t = "dateView", this[e + "View"].toggle(), this[t].close()
                },
                value: function(e) {
                    var a = this;
                    return e === t ? a._value : (a._old = a._update(e), null === a._old && a.element.val(""), a._oldText = a.element.val(), t)
                },
                _change: function(e) {
                    var t, a, n, i = this,
                        r = i.element.val();
                    e = i._update(e), t = +i._old != +e, a = t && !i._typing, n = r !== i.element.val(), (a || n) && i.element.trigger(x), t && (i._old = e, i._oldText = i.element.val(), i.trigger(x)), i._typing = !1
                },
                _option: function(e, n) {
                    var i, r, o = this,
                        s = o.options,
                        u = o.timeView,
                        m = u.options,
                        d = o._value || o._old;
                    if (n === t) return s[e];
                    if (n = l(n, s.parseFormats, s.culture)) {
                        if (s.min.getTime() === s.max.getTime() && (m.dates = []), s[e] = new P(n.getTime()), o.dateView[e](n), o._midnight = o._calculateMidnight(s.min, s.max), d && (i = f(s.min, d), r = f(s.max, d)), i || r) {
                            if (m[e] = n, i && !r && (m.max = a(s.interval)), r) {
                                if (o._midnight) return u.dataBind([q]), t;
                                i || (m.min = N)
                            }
                        } else m.max = q, m.min = N;
                        u.bind()
                    }
                },
                _toggleHover: function(t) {
                    e(t.currentTarget).toggleClass(A, "mouseenter" === t.type)
                },
                _update: function(t) {
                    var n, i, o, s, u, m = this,
                        d = m.options,
                        _ = d.min,
                        v = d.max,
                        g = d.dates,
                        h = m.timeView,
                        w = m._value,
                        k = l(t, d.parseFormats, d.culture),
                        b = null === k && null === w || k instanceof Date && w instanceof Date;
                    return d.disableDates && d.disableDates(k) && (k = null, m._old || m.element.val() || (t = null)), +k === +w && b ? (u = r.toString(k, d.format, d.culture), u !== t && (m.element.val(null === k ? t : u), t instanceof String && m.element.trigger(x)), k) : (null !== k && f(k, _) ? k = p(k, _, v) : c(k, _, v) || (k = null), m._value = k, h.value(k), m.dateView.value(k), k && (o = m._old, i = h.options, g[0] && (g = e.grep(g, function(e) {
                        return f(k, e)
                    }), g[0] && (h.dataBind(g), s = !0)), s || (f(k, _) && (i.min = _, i.max = a(d.interval), n = !0), f(k, v) && (m._midnight ? (h.dataBind([q]), s = !0) : (i.max = v, n || (i.min = N), n = !0))), !s && (!o && n || o && !f(o, k)) && (n || (i.max = q, i.min = N), h.bind())), m._dateInput && k ? m._dateInput.value(k || t) : m.element.val(r.toString(k || t, d.format, d.culture)), m._updateARIA(k), k)
                },
                _keydown: function(e) {
                    var t = this,
                        a = t.dateView,
                        n = t.timeView,
                        i = t.element.val(),
                        o = a.popup.visible(),
                        l = t._dateInput && e.stopImmediatePropagation;
                    e.altKey && e.keyCode === r.keys.DOWN ? t.toggle(o ? "time" : "date") : o ? (a.move(e), t._updateARIA(a._current)) : n.popup.visible() ? n.move(e) : e.keyCode === r.keys.ENTER && i !== t._oldText ? t._change(i) : (t._typing = !0, l = !1), l && e.stopImmediatePropagation()
                },
                _views: function() {
                    var e, t, a, n, i, s, u = this,
                        m = u.element,
                        d = u.options,
                        p = m.attr("id");
                    u.dateView = e = new r.DateView(z({}, d, {
                        id: p,
                        anchor: u.wrapper,
                        change: function() {
                            var t, a, n = e.calendar.value(),
                                i = +n,
                                o = +d.min,
                                l = +d.max;
                            i !== o && i !== l || (t = i === o ? o : l, t = new P(u._value || t), t.setFullYear(n.getFullYear(), n.getMonth(), n.getDate()), c(t, o, l) && (n = t)), u._value && (a = r.date.setHours(new Date(n), u._value), c(a, o, l) && (n = a)), u._change(n), u.close("date")
                        },
                        close: function(e) {
                            u.trigger(w, j) ? e.preventDefault() : (m.attr(H, !1), a.attr(S, !0), t.popup.visible() || m && m.length && m[0].removeAttribute(W))
                        },
                        open: function(t) {
                            u.trigger(h, j) ? t.preventDefault() : (m.val() !== u._oldText && (s = l(m.val(), d.parseFormats, d.culture), u.dateView[s ? "current" : "value"](s)), a.attr(S, !1), m.attr(H, !0).attr(W, e._dateViewID), u._updateARIA(s))
                        }
                    })), a = e.div, i = d.min.getTime(), u.timeView = t = new o({
                        id: p,
                        value: d.value,
                        anchor: u.wrapper,
                        animation: d.animation,
                        format: d.timeFormat,
                        culture: d.culture,
                        height: d.height,
                        interval: d.interval,
                        min: new P(N),
                        max: new P(q),
                        dates: i === d.max.getTime() ? [new Date(i)] : [],
                        parseFormats: d.parseFormats,
                        change: function(a, n) {
                            a = t._parse(a), a < d.min ? (a = new P((+d.min)), t.options.min = a) : a > d.max && (a = new P((+d.max)), t.options.max = a), n ? (u._timeSelected = !0, u._change(a)) : (m.val(r.toString(a, d.format, d.culture)), e.value(a), u._updateARIA(a))
                        },
                        close: function(t) {
                            u.trigger(w, Y) ? t.preventDefault() : (n.attr(S, !0), m.attr(H, !1), e.popup.visible() || m && m.length && m[0].removeAttribute(W))
                        },
                        open: function(e) {
                            t._adjustListWidth(), u.trigger(h, Y) ? e.preventDefault() : (m.val() !== u._oldText && (s = l(m.val(), d.parseFormats, d.culture), u.timeView.value(s)), n.attr(S, !1), m.attr(H, !0).attr(W, t._timeViewID), t.options.active(t.current()))
                        },
                        active: function(e) {
                            m && m.length && m[0].removeAttribute(E), e && m.attr(E, t._optionID)
                        },
                        popup: d.popup,
                        useValueToRender: !0
                    }), n = t.ul
                },
                _icons: function() {
                    var t = this,
                        a = t.element,
                        n = t.options,
                        i = a.next("span.k-select");
                    i[0] || (i = e('<span unselectable="on" class="k-select"><span class="k-link k-link-date" aria-label="' + n.dateButtonText + '"><span unselectable="on" class="k-icon k-i-calendar"></span></span><span class="k-link k-link-time" aria-label="' + n.timeButtonText + '"><span unselectable="on" class="k-icon k-i-clock"></span></span></span>').insertAfter(a)), i = i.children(), t._dateIcon = i.eq(0).attr("aria-controls", t.dateView._dateViewID), t._timeIcon = i.eq(1).attr("aria-controls", t.timeView._timeViewID)
                },
                _wrapper: function() {
                    var t, a = this,
                        n = a.element;
                    t = n.parents(".k-datetimepicker"), t[0] || (t = n.wrap(M).parent().addClass("k-picker-wrap k-state-default"), t = t.wrap(M).parent()), t[0].style.cssText = n[0].style.cssText, n.css({
                        width: "100%",
                        height: n[0].style.height
                    }), a.wrapper = t.addClass("k-widget k-datetimepicker").addClass(n[0].className), a._inputWrapper = e(t[0].firstChild)
                },
                _reset: function() {
                    var t = this,
                        a = t.element,
                        n = a.attr("form"),
                        i = n ? e("#" + n) : a.closest("form"),
                        o = t.options,
                        l = o.disableDates,
                        s = o.parseFormats.length ? o.parseFormats : null,
                        u = t._initialOptions.value,
                        m = a[0].defaultValue;
                    u && l && l(u) && (u = null), m && r.parseDate(m, s, o.culture) || !u || a.attr("value", r.toString(u, o.format, o.culture)), i[0] && (t._resetHandler = function() {
                        t.value(u || a[0].defaultValue), t.max(t._initialOptions.max), t.min(t._initialOptions.min)
                    }, t._form = i.on("reset", t._resetHandler))
                },
                _template: function() {
                    this._ariaTemplate = r.template(this.options.ARIATemplate)
                },
                _createDateInput: function(e) {
                    this._dateInput && (this._dateInput.destroy(), this._dateInput = null), e.dateInput && (this._dateInput = new v.DateInput(this.element, {
                        culture: e.culture,
                        format: e.format,
                        min: e.min,
                        max: e.max,
                        interval: e.interval
                    }))
                },
                _calculateMidnight: function(e, t) {
                    return _(e) + _(t) === 0
                },
                _updateARIA: function(e) {
                    var t, a = this,
                        n = a.dateView.calendar;
                    a.element && a.element.length && a.element[0].removeAttribute(E), n && (t = n._cell, t.attr("aria-label", a._ariaTemplate({
                        current: e || n.current()
                    })), a.element.attr(E, t.attr("id")))
                }
            });
        v.plugin(K)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, a) {
    (a || t)()
});;
! function(t, define) {
    define("kendo.dialog.min", ["kendo.core.min", "kendo.popup.min"], t)
}(function() {
    return function(t, e) {
        function n(t) {
            return e !== t
        }

        function i(t, e, n) {
            return Math.max(Math.min(parseInt(t, 10), n === 1 / 0 ? n : parseInt(n, 10)), parseInt(e, 10))
        }

        function o(t) {
            return t.keyCode == v.ENTER || t.keyCode == v.SPACEBAR
        }
        var a, r, s, l, c, d, p, u, h = window.kendo,
            f = h.ui.Widget,
            m = h.ui.Popup.TabKeyTrap,
            _ = t.proxy,
            g = h.template,
            v = h.keys,
            w = t.isFunction,
            k = "kendoWindow",
            y = ".k-dialog",
            b = ".k-window",
            x = ".k-dialog-close",
            C = "k-content k-window-content k-dialog-content",
            O = ".k-window-content",
            T = ".k-content",
            S = "k-scroll",
            A = "k-dialog-titleless",
            F = ".k-dialog-title",
            H = F + "bar",
            I = ".k-dialog-buttongroup",
            E = ".k-button",
            z = "k-alert",
            D = "k-confirm",
            R = "k-prompt",
            W = ".k-textbox",
            B = ".k-overlay",
            M = ":visible",
            N = "zIndex",
            L = "body",
            K = "initOpen",
            j = "touchstart",
            P = "touchmove",
            Y = "open",
            Q = "close",
            V = "show",
            q = "hide",
            G = "width",
            J = {
                small: "k-window-sm",
                medium: "k-window-md",
                large: "k-window-lg"
            },
            U = "hidden",
            X = "overflow",
            Z = "original-overflow-rule",
            $ = "tap-y",
            tt = 100,
            et = h.support.cssFlexbox,
            nt = {
                okText: "OK",
                cancel: "Cancel",
                promptInput: "Input"
            },
            it = Math.ceil,
            ot = ":not(link,meta,script,style)",
            at = f.extend({
                init: function(t, e) {
                    var n = this;
                    f.fn.init.call(n, t, e), n._init(n.element, n.options), h.notify(n)
                },
                _init: function(i, o) {
                    var r, s = this;
                    s._centerCallback = _(s._center, s), s.appendTo = t(L), n(o.visible) && null !== o.visible || (o.visible = i.is(M)), s.wrapperTemplate === e && (s.wrapperTemplate = a.wrapper), s._createDialog(), r = s.wrapper = i.closest(y), o._defaultFocus === e && (s._defaultFocus = i[0]), s._tabindex(i), s._dimensions(), this._tabKeyTrap = new m(r), s.options.visible ? s._triggerOpen() : s.wrapper.hide()
                },
                setOptions: function(n) {
                    var i, o = this,
                        a = o.options.size;
                    n = t.extend(o.options, n), f.fn.setOptions.call(o, n), n.title !== e && o.title(n.title), n.content && (h.destroy(o.element.children()), o.element.html(n.content)), n.actions && (o.wrapper.children(I).remove(), o._createActionbar(o.wrapper)), o.wrapper.show(), o._closable(o.wrapper), o.wrapper.removeClass(J[a]), o._dimensions(), n.visible ? o._triggerOpen() : o.wrapper.hide(), e !== n.modal && (i = o.options.visible !== !1, o._enableDocumentScrolling(), o._overlay(n.modal && i))
                },
                _dimensions: function() {
                    var t, e, n = this,
                        o = n.wrapper,
                        a = n.options,
                        r = a.width,
                        s = a.height,
                        l = a.size,
                        c = ["minWidth", "minHeight", "maxWidth", "maxHeight"];
                    for (t = 0; t < c.length; t++) e = a[c[t]], e && e != 1 / 0 && o.css(c[t], e);
                    this._setElementMaxHeight(), r && (("" + r).indexOf("%") > 0 ? o.width(r) : o.outerWidth(i(r, a.minWidth, a.maxWidth))), s && (("" + s).indexOf("%") > 0 ? o.height(s) : o.outerHeight(i(s, a.minHeight, a.maxHeight)), this._setElementHeight()), l && J[l] && o.addClass(J[l])
                },
                _setElementMaxHeight: function() {
                    var t, e, n = this,
                        i = n.element,
                        o = n.options.maxHeight;
                    o != 1 / 0 && (t = n._paddingBox(i), e = parseFloat(o, 10) - n._uiHeight() - t.vertical, e > 0 && i.css({
                        maxHeight: it(e) + "px"
                    }))
                },
                _paddingBox: function(t) {
                    var e = parseFloat(t.css("padding-top"), 10),
                        n = parseFloat(t.css("padding-left"), 10),
                        i = parseFloat(t.css("padding-bottom"), 10),
                        o = parseFloat(t.css("padding-right"), 10);
                    return {
                        vertical: e + i,
                        horizontal: n + o
                    }
                },
                _setElementHeight: function() {
                    var t = this,
                        e = t.element,
                        n = t.options.height,
                        i = t._paddingBox(e),
                        o = parseFloat(n, 10) - t._uiHeight() - i.vertical;
                    o < 0 && (o = 0), e.css({
                        height: it(o) + "px"
                    }), this._applyScrollClassName(e)
                },
                _applyScrollClassName: function(t) {
                    var e = t.get(0).scrollHeight > t.outerHeight();
                    e ? t.addClass(S) : t.removeClass(S)
                },
                _uiHeight: function() {
                    var t = this,
                        e = t.wrapper,
                        n = e.children(I),
                        i = n[0] && n[0].offsetHeight || 0,
                        o = e.children(H),
                        a = o[0] && o[0].offsetHeight || 0;
                    return i + a
                },
                _overlay: function(e) {
                    var n = this.appendTo.children(B),
                        i = this.wrapper;
                    return n.length || (n = t(a.overlay)), n.insertBefore(i[0]).toggle(e).css(N, parseInt(i.css(N), 10) - 1), e ? this._waiAriaOverlay() : this._removeWaiAriaOverlay(), this.options.modal.preventScroll && this._stopDocumentScrolling(), n
                },
                _waiAriaOverlay: function() {
                    var e = this.wrapper;
                    this._overlayedNodes = e.prevAll(ot).add(e.nextAll(ot)).each(function() {
                        var e = t(this);
                        e.data("ariaHidden", e.attr("aria-hidden")), e.attr("aria-hidden", "true")
                    })
                },
                _removeWaiAriaOverlay: function() {
                    return this._overlayedNodes && this._overlayedNodes.each(function() {
                        var e = t(this),
                            n = e.data("ariaHidden");
                        n ? e.attr("aria-hidden", n) : e.removeAttr("aria-hidden")
                    })
                },
                _closeClick: function(t) {
                    t.preventDefault(), this.close(!1)
                },
                _closeKeyHandler: function(t) {
                    (o(t) || t.keyCode == v.ESC) && this.close(!1)
                },
                _keydown: function(t) {
                    var e = this,
                        n = e.options,
                        i = t.keyCode;
                    i == v.ESC && !e._closing && n.closable && e.close(!1)
                },
                _createDialog: function() {
                    var e = this,
                        n = e.element,
                        i = e.options,
                        o = h.support.isRtl(n),
                        r = t(a.titlebar(i)),
                        s = (n.id || h.guid()) + "_title",
                        l = t(e.wrapperTemplate(i));
                    l.toggleClass("k-rtl", o), n.addClass(C), e.appendTo.append(l), i.title !== !1 ? (l.append(r), r.attr("id", s), l.attr("aria-labelledby", s)) : l.addClass(A), e._closable(l), l.append(n), i.content && (h.destroy(n.children()), n.html(i.content)), i.actions.length && e._createActionbar(l)
                },
                _closable: function(t) {
                    var e = this,
                        n = e.options,
                        i = t.children(H),
                        o = i.find(".k-window-actions"),
                        r = o.length ? o.find(".k-dialog-close") : t.find(".k-dialog-close");
                    r.remove(), n.closable !== !1 && (n.title !== !1 && o.length ? o.append(a.close(n)) : t.prepend(a.close(n)), t.autoApplyNS(k), e.element.autoApplyNS(k), t.find(x).on("click", _(e._closeClick, e)).on("keydown", _(e._closeKeyHandler, e)), e.element.on("keydown", _(e._keydown, e)))
                },
                _createActionbar: function(e) {
                    var n = "stretched" === this.options.buttonLayout,
                        i = n ? "stretched" : "normal",
                        o = t(a.actionbar({
                            buttonLayout: i
                        }));
                    this._addButtons(o), n && !et && this._normalizeButtonSize(o), e.append(o)
                },
                _addButtons: function(e) {
                    var n, i, o, r, s = this,
                        l = s.options,
                        c = _(s._actionClick, s),
                        d = _(s._actionKeyHandler, s),
                        p = s.options.actions,
                        u = p.length,
                        h = Math.round(tt / u);
                    for (o = 0; o < u; o++) n = p[o], i = s._mergeTextWithOptions(n), r = t(a.action(n)).autoApplyNS(k).html(i).appendTo(e).data("action", n.action).on("click", c).on("keydown", d), "stretched" !== l.buttonLayout || et || (o == u - 1 && (h = tt - o * h), r.css(G, h + "%"))
                },
                _mergeTextWithOptions: function(t) {
                    var e = t.text;
                    return e ? g(e)(this.options) : ""
                },
                _normalizeButtonSize: function(t) {
                    var e = this,
                        n = e.options,
                        i = t.children(E + ":last"),
                        o = parseFloat(i[0] ? i[0].style[G] : 0),
                        a = tt - n.actions.length * o;
                    a > 0 && i.css(G, o + a + "%")
                },
                _tabindex: function(t) {
                    var e, n = this,
                        i = n.wrapper,
                        o = i.find(x),
                        a = i.find(I + " " + E);
                    f.fn._tabindex.call(this, t), e = t.attr("tabindex"), o.attr("tabIndex", e), a.attr("tabIndex", e)
                },
                _actionClick: function(t) {
                    this.wrapper.is(M) && this._runActionBtn(t.currentTarget)
                },
                _actionKeyHandler: function(t) {
                    o(t) ? this._runActionBtn(t.currentTarget) : t.keyCode == v.ESC && this.close(!1)
                },
                _runActionBtn: function(e) {
                    var n, i, o = this;
                    o._closing || (n = t(e).data("action"), i = w(n) && n({
                        sender: o
                    }) === !1, i || o.close(!1))
                },
                _triggerOpen: function() {
                    var t = this,
                        e = t.options,
                        n = t.wrapper;
                    t.toFront(), t._triggerInitOpen(), t.trigger(Y), e.modal && (t._overlay(n.is(M)).css({
                        opacity: .5
                    }), t._focusDialog())
                },
                open: function() {
                    var t, e, n, i = this,
                        o = i.wrapper,
                        a = this._animationOptions(Y),
                        r = i.options;
                    return this._triggerInitOpen(), i.trigger(Y) || (i._closing && o.kendoStop(!0, !0), i._closing = !1, i.toFront(), r.visible = !0, r.modal && (e = !!i._modals().length, t = i._overlay(e), t.kendoStop(!0, !0), a.duration && h.effects.Fade && !e ? (n = h.fx(t).fadeIn(), n.duration(a.duration || 0), n.endValue(.5), n.play()) : t.css("opacity", .5), t.show()), o.show().kendoStop().kendoAnimate({
                        effects: a.effects,
                        duration: a.duration,
                        complete: _(i._openAnimationEnd, i)
                    }), o.show()), i
                },
                _animationOptions: function(t) {
                    var e = this.options.animation,
                        n = {
                            open: {
                                effects: {}
                            },
                            close: {
                                hide: !0,
                                effects: {}
                            }
                        };
                    return e && e[t] || n[t]
                },
                _openAnimationEnd: function() {
                    this.options.modal && this._focusDialog(), this.trigger(V)
                },
                _triggerInitOpen: function() {
                    n(this._initOpenTriggered) || (this._initOpenTriggered = !0, this.trigger(K))
                },
                toFront: function() {
                    var e = this,
                        n = e.wrapper,
                        i = +n.css(N),
                        o = i;
                    return e.center(), t(b).each(function(e, n) {
                        var o = t(n),
                            a = o.css(N);
                        isNaN(a) || (i = Math.max(+a, i))
                    }), (!n[0].style.zIndex || o < i) && n.css(N, i + 2), e.element.find("> .k-overlay").remove(), n = null, e
                },
                close: function(t) {
                    return arguments.length || (t = !0), this._close(t), this._stopCenterOnResize(), this
                },
                _close: function(t) {
                    var e = this,
                        n = e.wrapper,
                        i = e.options,
                        o = this._animationOptions("open"),
                        a = this._animationOptions("close");
                    if (n.is(M) && !e.trigger(Q, {
                            userTriggered: !t
                        })) {
                        if (e._closing) return;
                        e._closing = !0, i.visible = !1, this._removeOverlay(), n.kendoStop().kendoAnimate({
                            effects: a.effects || o.effects,
                            reverse: a.reverse === !0,
                            duration: a.duration,
                            complete: _(this._closeAnimationEnd, this)
                        })
                    }
                    return e
                },
                center: function() {
                    this._center(), this._centerOnResize()
                },
                _center: function() {
                    var e = this,
                        n = e.wrapper,
                        i = t(window),
                        o = 0,
                        a = 0,
                        r = a + Math.max(0, (i.width() - n.width()) / 2),
                        s = o + Math.max(0, (i.height() - n.height() - parseInt(n.css("paddingTop"), 10)) / 2);
                    return n.css({
                        left: r,
                        top: s
                    }), e
                },
                _centerOnResize: function() {
                    this._trackResize || (h.onResize(this._centerCallback), this._trackResize = !0)
                },
                _stopCenterOnResize: function() {
                    h.unbindResize(this._centerCallback), this._trackResize = !1
                },
                _removeOverlay: function() {
                    var t = this._modals(),
                        e = this.options,
                        n = e.modal && !t.length;
                    n ? (this._overlay(!1).remove(), e.modal.preventScroll && this._enableDocumentScrolling()) : t.length && (this._object(t.last())._overlay(!0), e.modal.preventScroll && this._stopDocumentScrolling())
                },
                _stopDocumentScrolling: function() {
                    var e, n, i = this,
                        o = t("body");
                    i._storeOverflowRule(o), o.css(X, U), e = t("html"), n = e[0], i._storeOverflowRule(e), e.css(X, U), h.support.mobileOS.ios && (n.addEventListener(j, i._touchStart, {
                        passive: !1
                    }), n.addEventListener(P, i._touchMove, {
                        passive: !1
                    }))
                },
                _touchStart: function(e) {
                    t(this).data($, e.changedTouches[0].pageY)
                },
                _touchMove: function(e) {
                    var n = e.target,
                        i = t(e.target),
                        o = e.changedTouches[0].pageY - t(this).data($) > 0,
                        a = i.is(O) && o && 0 === i.scrollTop() || !o && i.scrollTop() === n.scrollHeight - n.clientHeight;
                    i.is(O) && !a || e.preventDefault()
                },
                _enableDocumentScrolling: function() {
                    var e = this,
                        n = t(document.body),
                        i = t("html"),
                        o = i[0];
                    e._restoreOverflowRule(n), e._restoreOverflowRule(i), h.support.mobileOS.ios && (i.removeData($), o.removeEventListener(j, e._touchStart, {
                        passive: !1
                    }), o.removeEventListener(P, e._touchMove, {
                        passive: !1
                    }))
                },
                _storeOverflowRule: function(t) {
                    if (!this._isOverflowStored(t)) {
                        var e = t.get(0).style.overflow;
                        "string" == typeof e && t.data(Z, e)
                    }
                },
                _isOverflowStored: function(t) {
                    return "string" == typeof t.data(Z)
                },
                _restoreOverflowRule: function(t) {
                    var n = t.data(Z);
                    null !== n && n !== e ? (t.css(X, n), t.removeData(Z)) : t.css(X, "")
                },
                _closeAnimationEnd: function() {
                    var t, e = this;
                    e._closing = !1, e.wrapper.hide().css("opacity", ""), e.trigger(q), e.options.modal && (t = e._object(e._modals().last()), t && t.toFront())
                },
                _modals: function() {
                    var e = this,
                        n = t(b).filter(function() {
                            var n = t(this),
                                i = e._object(n),
                                o = i && i.options;
                            return o && o.modal && e.options.appendTo == o.appendTo && o.visible && n.is(M)
                        }).sort(function(e, n) {
                            return +t(e).css("zIndex") - +t(n).css("zIndex")
                        });
                    return e = null, n
                },
                _object: function(t) {
                    var n = t.children(T),
                        i = h.widgetInstance(n);
                    return i ? i : e
                },
                destroy: function() {
                    var e = this;
                    e._destroy(), f.fn.destroy.call(e), e.wrapper.remove(), e.wrapper = e.element = t()
                },
                _destroy: function() {
                    var t = this,
                        e = "." + k;
                    t.wrapper.off(e), t.element.off(e), t.wrapper.find(x + "," + I + " > " + E).off(e), t._stopCenterOnResize()
                },
                title: function(e) {
                    var n = this,
                        i = n.wrapper,
                        o = n.options,
                        r = i.children(H),
                        s = r.children(F),
                        l = h.htmlEncode(e);
                    return arguments.length ? (e === !1 ? (r.remove(), i.addClass(A)) : (r.length || (r = t(a.titlebar(o)).prependTo(i), s = r.children(F), i.removeClass(A)), s.html(l)), n.options.title = l, n) : s.html()
                },
                content: function(t, e) {
                    var i = this,
                        o = i.wrapper.children(T);
                    return n(t) ? (this.angular("cleanup", function() {
                        return {
                            elements: o.children()
                        }
                    }), h.destroy(o.children()), o.html(t), this.angular("compile", function() {
                        var t, n = [];
                        for (t = o.length; --t >= 0;) n.push({
                            dataItem: e
                        });
                        return {
                            elements: o.children(),
                            data: n
                        }
                    }), i.options.content = t, i) : o.html()
                },
                _focusDialog: function() {
                    this._defaultFocus && this._focus(this._defaultFocus), this._tabKeyTrap.trap()
                },
                _focus: function(t) {
                    t && t.focus()
                },
                events: [K, Y, Q, V, q],
                options: {
                    title: "",
                    buttonLayout: "stretched",
                    actions: [],
                    modal: !0,
                    size: "auto",
                    width: null,
                    height: null,
                    minWidth: 0,
                    minHeight: 0,
                    maxWidth: 1 / 0,
                    maxHeight: 1 / 0,
                    content: null,
                    visible: null,
                    appendTo: L,
                    closable: !0
                }
            }),
            rt = at.extend({
                options: {
                    name: "Dialog",
                    messages: {
                        close: "Close"
                    }
                }
            });
        h.ui.plugin(rt), r = at.extend({
            _init: function(t, e) {
                var n = this;
                n.wrapperTemplate = a.alertWrapper, e._defaultFocus = null, n._ensureContentId(t), at.fn._init.call(n, t, e), n.bind(q, _(n.destroy, n)), n._ariaDescribedBy(), n._initFocus()
            },
            _ensureContentId: function(e) {
                var n = t(e);
                n.attr("id") || n.attr("id", h.guid() + "_k-popup")
            },
            _ariaDescribedBy: function() {
                this.wrapper.attr("aria-describedby", this.element.attr("id"))
            },
            _initFocus: function() {
                var t = this.options;
                this._defaultFocus = this._chooseEntryFocus(), this._defaultFocus && t.visible && t.modal && this._focusDialog()
            },
            _chooseEntryFocus: function() {
                return this.wrapper.find(I + " > " + E)[0]
            },
            options: {
                title: window.location.host,
                closable: !1,
                messages: nt
            }
        }), s = r.extend({
            _init: function(t, e) {
                var n = this;
                r.fn._init.call(n, t, e), n.wrapper.addClass(z)
            },
            options: {
                name: "Alert",
                modal: !0,
                actions: [{
                    text: "#: messages.okText #"
                }]
            }
        }), h.ui.plugin(s), l = function(e) {
            return t(a.alert).kendoAlert({
                content: e
            }).data("kendoAlert").open()
        }, c = r.extend({
            _init: function(e, n) {
                var i = this;
                r.fn._init.call(i, e, n), i.wrapper.addClass(D), i.result = t.Deferred()
            },
            options: {
                name: "Confirm",
                modal: !0,
                actions: [{
                    text: "#: messages.okText #",
                    primary: !0,
                    action: function(t) {
                        t.sender.result.resolve()
                    }
                }, {
                    text: "#: messages.cancel #",
                    action: function(t) {
                        t.sender.result.reject()
                    }
                }]
            }
        }), h.ui.plugin(c), d = function(e) {
            var n = t(a.confirm).kendoConfirm({
                content: e
            }).data("kendoConfirm").open();
            return n.result
        }, p = r.extend({
            _init: function(e, n) {
                var i = this;
                r.fn._init.call(i, e, n), i.wrapper.addClass(R), i._createPrompt(), i.result = t.Deferred()
            },
            _createPrompt: function() {
                var e = this.options.value,
                    n = t(a.promptInputContainer(this.options)).insertAfter(this.element);
                e && n.children(W).val(e), this._defaultFocus = this._chooseEntryFocus(), this._focusDialog()
            },
            _chooseEntryFocus: function() {
                return this.wrapper.find(W)[0]
            },
            options: {
                name: "Prompt",
                modal: !0,
                value: "",
                actions: [{
                    text: "#: messages.okText #",
                    primary: !0,
                    action: function(t) {
                        var e = t.sender,
                            n = e.wrapper.find(W).val();
                        e.result.resolve(n)
                    }
                }, {
                    text: "#: messages.cancel #",
                    action: function(t) {
                        var e = t.sender,
                            n = e.wrapper.find(W).val();
                        t.sender.result.reject(n)
                    }
                }]
            }
        }), h.ui.plugin(p), u = function(e, n) {
            var i = t(a.prompt).kendoPrompt({
                content: e,
                value: n
            }).data("kendoPrompt").open();
            return i.result
        }, a = {
            wrapper: g("<div class='k-widget k-window k-dialog' role='dialog' />"),
            action: g("<button type='button' class='k-button# if (data.primary) { # k-primary# } role='button' #'></button>"),
            titlebar: g("<div class='k-window-titlebar k-dialog-titlebar k-header'><span class='k-window-title k-dialog-title'>#: title #</span><div class='k-window-actions k-dialog-actions' /></div>"),
            close: g("<a role='button' href='\\#' class='k-button k-bare k-button-icon k-window-action k-dialog-action k-dialog-close' title='#: messages.close #' aria-label='#: messages.close #' tabindex='-1'><span class='k-icon k-i-close'></span></a>"),
            actionbar: g("<div class='k-dialog-buttongroup k-dialog-button-layout-#: buttonLayout #' role='toolbar' />"),
            overlay: "<div class='k-overlay' />",
            alertWrapper: g("<div class='k-widget k-window k-dialog' role='alertdialog' />"),
            alert: "<div />",
            confirm: "<div />",
            prompt: "<div />",
            promptInputContainer: g("<div class='k-prompt-container'><input type='text' class='k-textbox' title='#: messages.promptInput #' aria-label='#: messages.promptInput #' /></div>")
        }, h.alert = l, h.confirm = d, h.prompt = u
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, n) {
    (n || e)()
});;
! function(e, define) {
    define("kendo.dropdownlist.min", ["kendo.list.min", "kendo.mobile.scroller.min", "kendo.virtuallist.min"], e)
}(function() {
    return function(e, t) {
        function i(e, t, i) {
            for (var n, s = 0, o = t.length - 1; s < o; ++s) n = t[s], n in e || (e[n] = {}), e = e[n];
            e[t[o]] = i
        }

        function n(e, t) {
            return e >= t && (e -= t), e
        }

        function s(e, t) {
            for (var i = 0; i < e.length; i++)
                if (e.charAt(i) !== t) return !1;
            return !0
        }
        var o = window.kendo,
            a = o.ui,
            l = a.List,
            r = a.Select,
            p = o.support,
            u = o._activeElement,
            c = o.data.ObservableObject,
            d = o.keys,
            f = ".kendoDropDownList",
            _ = f + "FocusEvent",
            h = "disabled",
            m = "readonly",
            b = "change",
            v = "k-state-focused",
            w = "k-state-default",
            I = "k-state-disabled",
            g = "aria-disabled",
            x = "click" + f + " touchend" + f,
            L = "mouseenter" + f + " mouseleave" + f,
            k = "tabindex",
            y = "filter",
            T = "accept",
            V = "The `optionLabel` option is not valid due to missing fields. Define a custom optionLabel as shown here http://docs.telerik.com/kendo-ui/api/javascript/ui/dropdownlist#configuration-optionLabel",
            C = e.proxy,
            O = r.extend({
                init: function(i, n) {
                    var s, a, l, p = this,
                        u = n && n.index;
                    p.ns = f, n = e.isArray(n) ? {
                        dataSource: n
                    } : n, r.fn.init.call(p, i, n), n = p.options, i = p.element.on("focus" + f, C(p._focusHandler, p)), p._focusInputHandler = e.proxy(p._focusInput, p), p.optionLabel = e(), p._optionLabel(), p._inputTemplate(), p._reset(), p._prev = "", p._word = "", p._wrapper(), p._tabindex(), p.wrapper.data(k, p.wrapper.attr(k)), p._span(), p._popup(), p._mobile(), p._dataSource(), p._ignoreCase(), p._filterHeader(), p._aria(), p.wrapper.attr("aria-live", "polite"), p._enable(), p._attachFocusHandlers(), p._oldIndex = p.selectedIndex = -1, u !== t && (n.index = u), p._initialIndex = n.index, p.requireValueMapper(p.options), p._initList(), p._cascade(), p.one("set", function(e) {
                        !e.sender.listView.bound() && p.hasOptionLabel() && p._textAccessor(p._optionLabelText())
                    }), n.autoBind ? p.dataSource.fetch() : p.selectedIndex === -1 && (a = n.text || "", a || (s = n.optionLabel, s && 0 === n.index ? a = s : p._isSelect && (a = i.children(":selected").text())), p._textAccessor(a)), l = e(p.element).parents("fieldset").is(":disabled"), l && p.enable(!1), p.listView.bind("click", function(e) {
                        e.preventDefault()
                    }), o.notify(p)
                },
                options: {
                    name: "DropDownList",
                    enabled: !0,
                    autoBind: !0,
                    index: 0,
                    text: null,
                    value: null,
                    delay: 500,
                    height: 200,
                    dataTextField: "",
                    dataValueField: "",
                    optionLabel: "",
                    cascadeFrom: "",
                    cascadeFromField: "",
                    cascadeFromParentField: "",
                    ignoreCase: !0,
                    animation: {},
                    filter: "none",
                    minLength: 1,
                    enforceMinLength: !1,
                    virtual: !1,
                    template: null,
                    valueTemplate: null,
                    optionLabelTemplate: null,
                    groupTemplate: "#:data#",
                    fixedGroupTemplate: "#:data#",
                    autoWidth: !1,
                    popup: null
                },
                events: ["open", "close", b, "select", "filtering", "dataBinding", "dataBound", "cascade", "set"],
                setOptions: function(e) {
                    r.fn.setOptions.call(this, e), this.listView.setOptions(this._listOptions(e)), this._optionLabel(), this._inputTemplate(), this._accessors(), this._filterHeader(), this._enable(), this._aria(), !this.value() && this.hasOptionLabel() && this.select(0)
                },
                destroy: function() {
                    var e = this;
                    r.fn.destroy.call(e), e.wrapper.off(f), e.wrapper.off(_), e.element.off(f), e._inputWrapper.off(f), e._arrow.off(), e._arrow = null, e._arrowIcon = null, e.optionLabel.off(), e.filterInput && e.filterInput.off(_)
                },
                open: function() {
                    var e = this,
                        t = !!e.dataSource.filter() && e.dataSource.filter().filters.length > 0;
                    e.popup.visible() || (e.listView.bound() && e._state !== T ? e._allowOpening() && (e._focusFilter = !0, e.popup.one("activate", e._focusInputHandler), e.popup._hovered = !0, e.popup.open(), e._resizeFilterInput(), e._focusItem()) : (e._open = !0, e._state = "rebind", e.filterInput && (e.filterInput.val(""), e._prev = ""), e.filterInput && 1 !== e.options.minLength && !t ? (e.refresh(), e.popup.one("activate", e._focusInputHandler), e.popup.open(), e._resizeFilterInput()) : e._filterSource()))
                },
                _focusInput: function() {
                    this._focusElement(this.filterInput)
                },
                _resizeFilterInput: function() {
                    var e, t, i = this.filterInput,
                        n = this._prevent;
                    i && (e = this.filterInput[0] === u(), t = o.caret(this.filterInput[0])[0], this._prevent = !0, i.css("display", "none").css("width", this.popup.element.css("width")).css("display", "inline-block"), e && (i.focus(), o.caret(i[0], t)), this._prevent = n)
                },
                _allowOpening: function() {
                    return this.hasOptionLabel() || this.filterInput || r.fn._allowOpening.call(this)
                },
                toggle: function(e) {
                    this._toggle(e, !0)
                },
                current: function(e) {
                    var i;
                    return e === t ? (i = this.listView.focus(), !i && 0 === this.selectedIndex && this.hasOptionLabel() ? this.optionLabel : i) : (this._focus(e), t)
                },
                dataItem: function(i) {
                    var n = this,
                        s = null;
                    if (null === i) return i;
                    if (i === t) s = n.listView.selectedDataItems()[0];
                    else {
                        if ("number" != typeof i) {
                            if (n.options.virtual) return n.dataSource.getByUid(e(i).data("uid"));
                            i = i.hasClass("k-list-optionlabel") ? -1 : e(n.items()).index(i)
                        } else n.hasOptionLabel() && (i -= 1);
                        s = n.dataSource.flatView()[i]
                    }
                    return s || (s = n._optionLabelDataItem()), s
                },
                refresh: function() {
                    this.listView.refresh()
                },
                text: function(e) {
                    var i, n = this,
                        s = n.options.ignoreCase;
                    return e = null === e ? "" : e, e === t ? n._textAccessor() : "string" != typeof e ? (n._textAccessor(e), t) : (i = s ? e.toLowerCase() : e, n._select(function(e) {
                        return e = n._text(e), s && (e = (e + "").toLowerCase()), e === i
                    }).done(function() {
                        n._textAccessor(n.dataItem() || e)
                    }), t)
                },
                _clearFilter: function() {
                    e(this.filterInput).val(""), r.fn._clearFilter.call(this)
                },
                value: function(e) {
                    var i = this,
                        n = i.listView,
                        s = i.dataSource;
                    return e === t ? (e = i._accessor() || i.listView.value()[0], e === t || null === e ? "" : e) : (i.requireValueMapper(i.options, e), !e && i.hasOptionLabel() || (i._initialIndex = null), this.trigger("set", {
                        value: e
                    }), i._request && i.options.cascadeFrom && i.listView.bound() ? (i._valueSetter && s.unbind(b, i._valueSetter), i._valueSetter = C(function() {
                        i.value(e)
                    }, i), s.one(b, i._valueSetter), t) : (i._isFilterEnabled() && n.bound() && n.isFiltered() ? i._clearFilter() : i._fetchData(), n.value(e).done(function() {
                        i._old = i._valueBeforeCascade = i._accessor(), i._oldIndex = i.selectedIndex
                    }), t))
                },
                hasOptionLabel: function() {
                    return this.optionLabel && !!this.optionLabel[0]
                },
                _optionLabel: function() {
                    var i = this,
                        n = i.options,
                        s = n.optionLabel,
                        a = n.optionLabelTemplate;
                    return s ? (a || (a = "#:", a += "string" == typeof s ? "data" : o.expr(n.dataTextField, "data"), a += "#"), "function" != typeof a && (a = o.template(a)), i.optionLabelTemplate = a, i.hasOptionLabel() || (i.optionLabel = e('<div class="k-list-optionlabel"></div>').prependTo(i.list)), i.optionLabel.html(a(s)).off().on(x, C(i._click, i)).on(L, i._toggleHover), i.angular("compile", function() {
                        return {
                            elements: i.optionLabel,
                            data: [{
                                dataItem: i._optionLabelDataItem()
                            }]
                        }
                    }), t) : (i.optionLabel.off().remove(), i.optionLabel = e(), t)
                },
                _optionLabelText: function() {
                    var e = this.options.optionLabel;
                    return "string" == typeof e ? e : this._text(e)
                },
                _optionLabelDataItem: function() {
                    var i = this,
                        n = i.options.optionLabel;
                    return i.hasOptionLabel() ? e.isPlainObject(n) ? new c(n) : i._assignInstance(i._optionLabelText(), "") : t
                },
                _buildOptions: function(e) {
                    var i, n, s, o = this;
                    o._isSelect && (i = o.listView.value()[0], n = o._optionLabelDataItem(), s = n && o._value(n), i !== t && null !== i || (i = ""), n && (s !== t && null !== s || (s = ""), n = '<option value="' + s + '">' + o._text(n) + "</option>"), o._options(e, n, i), i !== l.unifyType(o._accessor(), typeof i) && (o._customOption = null, o._custom(i)))
                },
                _listBound: function() {
                    var e, t = this,
                        i = t._initialIndex,
                        n = t._state === y,
                        s = t.dataSource.flatView();
                    t._presetValue = !1, t._renderFooter(), t._renderNoData(), t._toggleNoData(!s.length), t._resizePopup(!0), t.popup.position(), t._buildOptions(s), t._makeUnselectable(), n || (t._open && t.toggle(t._allowOpening()), t._open = !1, t._fetch || (s.length ? (!t.listView.value().length && i > -1 && null !== i && t.select(i), t._initialIndex = null, e = t.listView.selectedDataItems()[0], e && t.text() !== t._text(e) && t._selectValue(e)) : t._textAccessor() !== t._optionLabelText() && (t.listView.value(""), t._selectValue(null), t._oldIndex = t.selectedIndex))), t._hideBusy(), t.trigger("dataBound")
                },
                _listChange: function() {
                    this._selectValue(this.listView.selectedDataItems()[0]), (this._presetValue || this._old && this._oldIndex === -1) && (this._oldIndex = this.selectedIndex)
                },
                _filterPaste: function() {
                    this._search()
                },
                _attachFocusHandlers: function() {
                    var e = this,
                        t = e.wrapper;
                    t.on("focusin" + _, C(e._focusinHandler, e)).on("focusout" + _, C(e._focusoutHandler, e)), e.filterInput && e.filterInput.on("focusin" + _, C(e._focusinHandler, e)).on("focusout" + _, C(e._focusoutHandler, e))
                },
                _focusHandler: function() {
                    this.wrapper.focus()
                },
                _focusinHandler: function() {
                    this._inputWrapper.addClass(v), this._prevent = !1
                },
                _focusoutHandler: function() {
                    var e = this,
                        t = window.self !== window.top;
                    e._prevent || (clearTimeout(e._typingTimeout), p.mobileOS.ios && t ? e._change() : e._blur(), e._inputWrapper.removeClass(v), e._prevent = !0, e._open = !1, e.element.blur())
                },
                _wrapperMousedown: function() {
                    this._prevent = !!this.filterInput
                },
                _wrapperClick: function(e) {
                    e.preventDefault(), this.popup.unbind("activate", this._focusInputHandler), this._focused = this.wrapper, this._prevent = !1, this._toggle()
                },
                _editable: function(e) {
                    var t = this,
                        i = t.element,
                        n = e.disable,
                        s = e.readonly,
                        a = t.wrapper.add(t.filterInput).off(f),
                        l = t._inputWrapper.off(L);
                    s || n ? n ? (a.removeAttr(k), l.addClass(I).removeClass(w)) : l.addClass(w).removeClass(I) : (i.removeAttr(h).removeAttr(m), l.addClass(w).removeClass(I).on(L, t._toggleHover), a.attr(k, a.data(k)).attr(g, !1).on("keydown" + f, C(t._keydown, t)).on(o.support.mousedown + f, C(t._wrapperMousedown, t)).on("paste" + f, C(t._filterPaste, t)), t.wrapper.on("click" + f, C(t._wrapperClick, t)), t.filterInput ? a.on("input" + f, C(t._search, t)) : a.on("keypress" + f, C(t._keypress, t))), i.attr(h, n).attr(m, s), a.attr(g, n)
                },
                _keydown: function(e) {
                    var i, n, s, o = this,
                        a = e.keyCode,
                        l = e.altKey,
                        r = o.popup.visible();
                    if (o.filterInput && (i = o.filterInput[0] === u()), a === d.LEFT ? (a = d.UP, n = !0) : a === d.RIGHT && (a = d.DOWN, n = !0), !n || !i) {
                        if (e.keyCode = a, (l && a === d.UP || a === d.ESC) && o._focusElement(o.wrapper), o._state === y && a === d.ESC && (o._clearFilter(), o._open = !1, o._state = T), a === d.ENTER && o._typingTimeout && o.filterInput && r) return e.preventDefault(), t;
                        if (a !== d.SPACEBAR || i || (o.toggle(!r), e.preventDefault()), n = o._move(e), !n) {
                            if ((!r || !o.filterInput) && (s = o._focus(), a === d.HOME ? (n = !0, o._firstItem()) : a === d.END && (n = !0, o._lastItem()), n)) {
                                if (o.trigger("select", {
                                        dataItem: o._getElementDataItem(o._focus()),
                                        item: o._focus()
                                    })) return o._focus(s), t;
                                o._select(o._focus(), !0).done(function() {
                                    r || o._blur()
                                }), e.preventDefault()
                            }
                            l || n || !o.filterInput || o._search()
                        }
                    }
                },
                _matchText: function(e, i) {
                    var n = this.options.ignoreCase;
                    return e !== t && null !== e && (e += "", n && (e = e.toLowerCase()), 0 === e.indexOf(i))
                },
                _shuffleData: function(e, t) {
                    var i = this._optionLabelDataItem();
                    return i && (e = [i].concat(e)), e.slice(t).concat(e.slice(0, t))
                },
                _selectNext: function() {
                    var e, t, i, o = this,
                        a = o.dataSource.flatView(),
                        l = a.length + (o.hasOptionLabel() ? 1 : 0),
                        r = s(o._word, o._last),
                        p = o.selectedIndex;
                    for (p === -1 ? p = 0 : (p += r ? 1 : 0, p = n(p, l)), a = a.toJSON ? a.toJSON() : a.slice(), a = o._shuffleData(a, p), i = 0; i < l && (t = o._text(a[i]), !r || !o._matchText(t, o._last)) && !o._matchText(t, o._word); i++);
                    i !== l && (e = o._focus(), o._select(n(p + i, l)).done(function() {
                        var t = function() {
                            o.popup.visible() || o._change()
                        };
                        o.trigger("select", {
                            dataItem: o._getElementDataItem(o._focus()),
                            item: o._focus()
                        }) ? o._select(e).done(t) : t()
                    }))
                },
                _keypress: function(e) {
                    var t, i = this;
                    0 !== e.which && e.keyCode !== o.keys.ENTER && (t = String.fromCharCode(e.charCode || e.keyCode), i.options.ignoreCase && (t = t.toLowerCase()), " " === t && e.preventDefault(), i._word += t, i._last = t, i._search())
                },
                _popupOpen: function() {
                    var e = this.popup;
                    e.wrapper = o.wrap(e.element), e.element.closest(".km-root")[0] && (e.wrapper.addClass("km-popup km-widget"), this.wrapper.addClass("km-widget"))
                },
                _popup: function() {
                    r.fn._popup.call(this), this.popup.one("open", C(this._popupOpen, this))
                },
                _getElementDataItem: function(e) {
                    return e && e[0] ? e[0] === this.optionLabel[0] ? this._optionLabelDataItem() : this.listView.dataItemByIndex(this.listView.getElementIndex(e)) : null
                },
                _click: function(i) {
                    var n = this,
                        s = i.item || e(i.currentTarget);
                    return i.preventDefault(), n.trigger("select", {
                        dataItem: n._getElementDataItem(s),
                        item: s
                    }) ? (n.close(), t) : (n._userTriggered = !0, n._select(s).done(function() {
                        n._blur(), n._focusElement(n.wrapper)
                    }), t)
                },
                _focusElement: function(e) {
                    var t = u(),
                        i = this.wrapper,
                        n = this.filterInput,
                        s = e === n ? i : n,
                        o = p.mobileOS && (p.touch || p.MSPointers || p.pointers);
                    n && n[0] === e[0] && o || n && (s[0] === t || this._focusFilter) && (this._focusFilter = !1, this._prevent = !0, this._focused = e.focus())
                },
                _searchByWord: function(e) {
                    var t, i;
                    e && (t = this, i = t.options.ignoreCase, i && (e = e.toLowerCase()), t._select(function(i) {
                        return t._matchText(t._text(i), e)
                    }))
                },
                _inputValue: function() {
                    return this.text()
                },
                _search: function() {
                    var e = this,
                        i = e.dataSource;
                    if (clearTimeout(e._typingTimeout), e._isFilterEnabled()) e._typingTimeout = setTimeout(function() {
                        var t = e.filterInput.val();
                        e._prev !== t && (e._prev = t, e.search(t), e._resizeFilterInput()), e._typingTimeout = null
                    }, e.options.delay);
                    else {
                        if (e._typingTimeout = setTimeout(function() {
                                e._word = ""
                            }, e.options.delay), !e.listView.bound()) return i.fetch().done(function() {
                            e._selectNext()
                        }), t;
                        e._selectNext()
                    }
                },
                _get: function(t) {
                    var i, n, s, o = "function" == typeof t,
                        a = o ? e() : e(t);
                    if (this.hasOptionLabel() && ("number" == typeof t ? t > -1 && (t -= 1) : a.hasClass("k-list-optionlabel") && (t = -1)), o) {
                        for (i = this.dataSource.flatView(), s = 0; s < i.length; s++)
                            if (t(i[s])) {
                                t = s, n = !0;
                                break
                            }
                        n || (t = -1)
                    }
                    return t
                },
                _firstItem: function() {
                    this.hasOptionLabel() ? this._focus(this.optionLabel) : this.listView.focusFirst()
                },
                _lastItem: function() {
                    this._resetOptionLabel(), this.listView.focusLast()
                },
                _nextItem: function() {
                    this.optionLabel.hasClass("k-state-focused") ? (this._resetOptionLabel(), this.listView.focusFirst()) : this.listView.focusNext()
                },
                _prevItem: function() {
                    this.optionLabel.hasClass("k-state-focused") || (this.listView.focusPrev(), this.listView.focus() || this._focus(this.optionLabel))
                },
                _focusItem: function() {
                    var e = this.options,
                        i = this.listView,
                        n = i.focus(),
                        s = i.select();
                    s = s[s.length - 1], s === t && e.highlightFirst && !n && (s = 0), s !== t ? i.focus(s) : !e.optionLabel || e.virtual && "dataItem" === e.virtual.mapValueTo ? i.scrollToIndex(0) : (this._focus(this.optionLabel), this._select(this.optionLabel), this.listView.content.scrollTop(0))
                },
                _resetOptionLabel: function(e) {
                    this.optionLabel.removeClass("k-state-focused" + (e || "")).removeAttr("id")
                },
                _focus: function(e) {
                    var i = this.listView,
                        n = this.optionLabel;
                    return e === t ? (e = i.focus(), !e && n.hasClass("k-state-focused") && (e = n), e) : (this._resetOptionLabel(), e = this._get(e), i.focus(e), e === -1 && (n.addClass("k-state-focused").attr("id", i._optionID), this._focused.add(this.filterInput).removeAttr("aria-activedescendant").attr("aria-activedescendant", i._optionID)), t)
                },
                _select: function(e, t) {
                    var i = this;
                    return e = i._get(e), i.listView.select(e).done(function() {
                        t || i._state !== y || (i._state = T), e === -1 && i._selectValue(null)
                    })
                },
                _selectValue: function(e) {
                    var i = this,
                        n = i.options.optionLabel,
                        s = i.listView.select(),
                        o = "",
                        a = "";
                    s = s[s.length - 1], s === t && (s = -1), this._resetOptionLabel(" k-state-selected"), e || 0 === e ? (a = e, o = i._dataValue(e), n && (s += 1)) : n && (i._focus(i.optionLabel.addClass("k-state-selected")), a = i._optionLabelText(), o = "string" == typeof n ? "" : i._value(n), s = 0), i.selectedIndex = s, null === o && (o = ""), i._textAccessor(a), i._accessor(o, s), i._triggerCascade()
                },
                _mobile: function() {
                    var e = this,
                        t = e.popup,
                        i = p.mobileOS,
                        n = t.element.parents(".km-root").eq(0);
                    n.length && i && (t.options.animation.open.effects = i.android || i.meego ? "fadeIn" : i.ios || i.wp ? "slideIn:up" : t.options.animation.open.effects)
                },
                _filterHeader: function() {
                    var t;
                    this.filterInput && (this.filterInput.off(f).parent().remove(), this.filterInput = null), this._isFilterEnabled() && (t = '<span class="k-icon k-i-zoom"></span>', this.filterInput = e('<input class="k-textbox"/>').attr({
                        placeholder: this.element.attr("placeholder"),
                        title: this.element.attr("title"),
                        role: "listbox",
                        "aria-haspopup": !0,
                        "aria-expanded": !1
                    }), this.list.prepend(e('<span class="k-list-filter" />').append(this.filterInput.add(t))))
                },
                _span: function() {
                    var t, i = this,
                        n = i.wrapper,
                        s = "span.k-input";
                    t = n.find(s), t[0] || (n.append('<span unselectable="on" class="k-dropdown-wrap k-state-default"><span unselectable="on" class="k-input">&nbsp;</span><span unselectable="on" class="k-select" aria-label="select"><span class="k-icon k-i-arrow-60-down"></span></span></span>').append(i.element), t = n.find(s)), i.span = t, i._inputWrapper = e(n[0].firstChild), i._arrow = n.find(".k-select"), i._arrowIcon = i._arrow.find(".k-icon")
                },
                _wrapper: function() {
                    var e, t = this,
                        i = t.element,
                        n = i[0];
                    e = i.parent(), e.is("span.k-widget") || (e = i.wrap("<span />").parent(), e[0].style.cssText = n.style.cssText, e[0].title = n.title), t._focused = t.wrapper = e.addClass("k-widget k-dropdown").addClass(n.className).css("display", "").attr({
                        accesskey: i.attr("accesskey"),
                        unselectable: "on",
                        role: "listbox",
                        "aria-haspopup": !0,
                        "aria-expanded": !1
                    }), i.hide().removeAttr("accesskey")
                },
                _clearSelection: function(e) {
                    this.select(e.value() ? 0 : -1)
                },
                _inputTemplate: function() {
                    var t = this,
                        i = t.options.valueTemplate;
                    if (i = i ? o.template(i) : e.proxy(o.template("#:this._text(data)#", {
                            useWithBlock: !1
                        }), t), t.valueTemplate = i, t.hasOptionLabel() && !t.options.optionLabelTemplate) try {
                        t.valueTemplate(t._optionLabelDataItem())
                    } catch (n) {
                        throw Error(V)
                    }
                },
                _textAccessor: function(i) {
                    var n, s = null,
                        o = this.valueTemplate,
                        a = this._optionLabelText(),
                        l = this.span;
                    if (i === t) return l.text();
                    e.isPlainObject(i) || i instanceof c ? s = i : a && a === i && (s = this.options.optionLabel), s || (s = this._assignInstance(i, this._accessor())), this.hasOptionLabel() && (s !== a && this._text(s) !== a || (o = this.optionLabelTemplate, "string" != typeof this.options.optionLabel || this.options.optionLabelTemplate || (s = a))), n = function() {
                        return {
                            elements: l.get(),
                            data: [{
                                dataItem: s
                            }]
                        }
                    }, this.angular("cleanup", n);
                    try {
                        l.html(o(s))
                    } catch (r) {
                        l.html("")
                    }
                    this.angular("compile", n)
                },
                _preselect: function(e, t) {
                    e || t || (t = this._optionLabelText()), this._accessor(e), this._textAccessor(t), this._old = this._accessor(), this._oldIndex = this.selectedIndex, this.listView.setValue(e), this._initialIndex = null, this._presetValue = !0
                },
                _assignInstance: function(e, t) {
                    var n = this.options.dataTextField,
                        s = {};
                    return n ? (i(s, n.split("."), e), i(s, this.options.dataValueField.split("."), t), s = new c(s)) : s = e, s
                }
            });
        a.plugin(O)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, i) {
    (i || t)()
});;
! function(e, define) {
    define("kendo.listview.min", ["kendo.data.min", "kendo.editable.min", "kendo.selectable.min"], e)
}(function() {
    return function(e, t) {
        var n = window.kendo,
            a = "change",
            i = "cancel",
            r = "dataBound",
            l = "dataBinding",
            o = n.ui.Widget,
            s = n.keys,
            d = ">*:not(.k-loading-mask)",
            c = "progress",
            u = "error",
            m = "k-state-focused",
            f = "k-state-selected",
            p = "k-edit-item",
            g = "edit",
            h = "remove",
            _ = "save",
            b = "mousedown",
            v = "click",
            S = "touchstart",
            k = ".kendoListView",
            w = e.proxy,
            E = n._activeElement,
            y = n.ui.progress,
            x = n.data.DataSource,
            T = n.ui.DataBoundWidget.extend({
                init: function(t, a) {
                    var i = this;
                    a = e.isArray(a) ? {
                        dataSource: a
                    } : a, o.fn.init.call(i, t, a), a = i.options, i.wrapper = t = i.element, t[0].id && (i._itemId = t[0].id + "_lv_active"), i._element(), i._dataSource(), i._templates(), i._navigatable(), i._selectable(), i._pageable(), i._crudHandlers(), i._scrollable(), i.options.autoBind && i.dataSource.fetch(), n.notify(i)
                },
                events: [a, i, l, r, g, h, _],
                options: {
                    name: "ListView",
                    autoBind: !0,
                    selectable: !1,
                    navigatable: !1,
                    height: null,
                    template: "",
                    altTemplate: "",
                    editTemplate: ""
                },
                setOptions: function(e) {
                    o.fn.setOptions.call(this, e), this._templates(), this.selectable && (this.selectable.destroy(), this.selectable = null), this._selectable()
                },
                _templates: function() {
                    var e = this.options;
                    this.template = n.template(e.template || ""), this.altTemplate = n.template(e.altTemplate || e.template), this.editTemplate = n.template(e.editTemplate || "")
                },
                _item: function(e) {
                    return this.element.children()[e]()
                },
                items: function() {
                    return this.element.children()
                },
                dataItem: function(t) {
                    var a = n.attr("uid"),
                        i = e(t).closest("[" + a + "]").attr(a);
                    return this.dataSource.getByUid(i)
                },
                setDataSource: function(e) {
                    this.options.dataSource = e, this._dataSource(), this.options.autoBind && e.fetch()
                },
                _unbindDataSource: function() {
                    var e = this;
                    e.dataSource.unbind(a, e._refreshHandler).unbind(c, e._progressHandler).unbind(u, e._errorHandler)
                },
                _dataSource: function() {
                    var e = this;
                    e.dataSource && e._refreshHandler ? e._unbindDataSource() : (e._refreshHandler = w(e.refresh, e), e._progressHandler = w(e._progress, e), e._errorHandler = w(e._error, e)), e.dataSource = x.create(e.options.dataSource).bind(a, e._refreshHandler).bind(c, e._progressHandler).bind(u, e._errorHandler)
                },
                _progress: function(e) {
                    var t = this.element;
                    y(t, e, {
                        opacity: !0
                    })
                },
                _error: function() {
                    y(this.element, !1)
                },
                _element: function() {
                    var e = this.options.height;
                    this.element.addClass("k-widget k-listview").attr("role", "listbox"), e && this.element.css("height", e)
                },
                refresh: function(e) {
                    var a, i, o, s, d, c = this,
                        u = c.dataSource.view(),
                        m = "",
                        f = c.template,
                        p = c.altTemplate,
                        g = E(),
                        h = c._endlessFetchInProgress,
                        _ = h ? c._skipRerenderItemsCount : 0,
                        b = c.options.scrollable;
                    if (e = e || {}, "itemchange" === e.action) return c._hasBindingTarget() || c.editable || (a = e.items[0], o = c.items().filter("[" + n.attr("uid") + "=" + a.uid + "]"), o.length > 0 && (s = o.index(), c.angular("cleanup", function() {
                        return {
                            elements: [o]
                        }
                    }), o.replaceWith(f(a)), o = c.items().eq(s), o.attr(n.attr("uid"), a.uid), c.angular("compile", function() {
                        return {
                            elements: [o],
                            data: [{
                                dataItem: a
                            }]
                        }
                    }), c.trigger("itemChange", {
                        item: o,
                        data: a
                    }))), t;
                    if (!c.trigger(l, {
                            action: e.action || "rebind",
                            items: e.items,
                            index: e.index
                        })) {
                        for (c._angularItems("cleanup"), h || c._destroyEditable(), s = _, d = u.length; s < d; s++) m += s % 2 ? p(u[s]) : f(u[s]);
                        for (h ? c.element.append(m) : c.element.html(m), i = c.items().not(".k-loading-mask"), s = _, d = u.length; s < d; s++) i.eq(s).attr(n.attr("uid"), u[s].uid).attr("role", "option").attr("aria-selected", "false");
                        c.element[0] === g && c.options.navigatable && (c._focusNext ? c.current(c.current().next()) : b || c.current(i.eq(0))), c._angularItems("compile"), c._progress(!1), c._endlessFetchInProgress = null, c.trigger(r, {
                            action: e.action || "rebind",
                            items: e.items,
                            index: e.index
                        })
                    }
                },
                _pageable: function() {
                    var t, a, i = this,
                        r = i.options.pageable;
                    e.isPlainObject(r) && (a = r.pagerId, t = e.extend({}, r, {
                        dataSource: i.dataSource,
                        pagerId: null
                    }), i.pager = new n.ui.Pager(e("#" + a), t))
                },
                _selectable: function() {
                    var e, i, r = this,
                        l = r.options.selectable,
                        o = r.options.navigatable;
                    l && (e = n.ui.Selectable.parseOptions(l).multiple, r.selectable = new n.ui.Selectable(r.element, {
                        aria: !0,
                        multiple: e,
                        filter: d,
                        change: function() {
                            r.trigger(a)
                        }
                    }), o && r.element.on("keydown" + k, function(n) {
                        if (n.keyCode === s.SPACEBAR) {
                            if (i = r.current(), n.target == n.currentTarget && n.preventDefault(), e)
                                if (n.ctrlKey) {
                                    if (i && i.hasClass(f)) return i.removeClass(f), t
                                } else r.selectable.clear();
                            else r.selectable.clear();
                            r.selectable.value(i)
                        }
                    }))
                },
                _scrollable: function() {
                    var e, t = this,
                        n = t.options.scrollable;
                    n && (t.element.css({
                        "overflow-y": "scroll",
                        position: "relative",
                        "-webkit-overflow-scrolling": "touch"
                    }), "endless" === n && (e = t._endlessPageSize = t.dataSource.options.pageSize, t.element.off("scroll" + k).on("scroll" + k, function() {
                        this.scrollTop + this.clientHeight - this.scrollHeight >= -15 && !t._endlessFetchInProgress && t._endlessPageSize < t.dataSource.total() && (t._skipRerenderItemsCount = t._endlessPageSize, t._endlessPageSize = t._skipRerenderItemsCount + e, t.dataSource.options.endless = !0, t._endlessFetchInProgress = !0, t.dataSource.pageSize(t._endlessPageSize))
                    })))
                },
                current: function(e) {
                    var n = this,
                        a = n.element,
                        i = n._current,
                        r = n._itemId;
                    return e === t ? i : (i && i[0] && (i[0].id === r && i.removeAttr("id"), i.removeClass(m), a.removeAttr("aria-activedescendant")), e && e[0] && (r = e[0].id || r, n._scrollTo(e[0]), a.attr("aria-activedescendant", r), e.addClass(m).attr("id", r)), n._current = e, t)
                },
                _scrollTo: function(t) {
                    var n, a, i = this,
                        r = !1,
                        l = "scroll";
                    "auto" == i.wrapper.css("overflow") || i.wrapper.css("overflow") == l || i.wrapper.css("overflow-y") == l ? n = i.wrapper[0] : (n = window, r = !0), a = function(a, i) {
                        var o = r ? e(t).offset()[a.toLowerCase()] : t["offset" + a],
                            s = t["client" + i],
                            d = e(n)[l + a](),
                            c = e(n)[i.toLowerCase()]();
                        o + s > d + c ? e(n)[l + a](o + s - c) : o < d && e(n)[l + a](o)
                    }, a("Top", "Height"), a("Left", "Width")
                },
                _navigatable: function() {
                    var t = this,
                        a = t.options.navigatable,
                        i = t.element,
                        r = function(a) {
                            t.current(e(a.currentTarget)), e(a.target).is(":button,a,:input,a>.k-icon,textarea") || n.focusElement(i)
                        };
                    a && (t._tabindex(), i.on("focus" + k, function() {
                        var e = t._current;
                        e && e.is(":visible") || (e = t._item("first")), t.current(e)
                    }).on("focusout" + k, function() {
                        t._current && t._current.removeClass(m)
                    }).on("keydown" + k, function(a) {
                        var r, l, o = a.keyCode,
                            d = t.current(),
                            c = e(a.target),
                            u = !c.is(":button,textarea,a,a>.t-icon,input"),
                            m = c.is(":text,:password"),
                            f = n.preventDefault,
                            g = i.find("." + p),
                            h = E(),
                            _ = t.options.scrollable;
                        if (!(!u && !m && s.ESC != o || m && s.ESC != o && s.ENTER != o))
                            if (s.UP === o || s.LEFT === o) d && d[0] && (d = d.prev()), d && d[0] ? t.current(d) : _ || t.current(t._item("last")), f(a);
                            else if (s.DOWN === o || s.RIGHT === o) _ ? "endless" !== t.options.scrollable || d.next().length ? (d = d.next(), d && d[0] && t.current(d)) : (t.element[0].scrollTop = t.element[0].scrollHeight, t._focusNext = !0) : (d = d.next(), t.current(d && d[0] ? d : t._item("first"))), f(a);
                        else if (s.PAGEUP === o) t.current(null), t.dataSource.page(t.dataSource.page() - 1), f(a);
                        else if (s.PAGEDOWN === o) t.current(null), t.dataSource.page(t.dataSource.page() + 1), f(a);
                        else if (s.HOME === o) t.current(t._item("first")), f(a);
                        else if (s.END === o) t.current(t._item("last")), f(a);
                        else if (s.ENTER === o) 0 !== g.length && (u || m) ? (r = t.items().index(g), h && h.blur(), t.save(), l = function() {
                            t.element.trigger("focus"), t.current(t.items().eq(r))
                        }, t.one("dataBound", l)) : "" !== t.options.editTemplate && t.edit(d);
                        else if (s.ESC === o) {
                            if (g = i.find("." + p), 0 === g.length) return;
                            r = t.items().index(g), t.cancel(), t.element.trigger("focus"), t.current(t.items().eq(r))
                        }
                    }), i.on(b + k + " " + S + k, d, w(r, t)))
                },
                clearSelection: function() {
                    var e = this;
                    e.selectable.clear(), e.trigger(a)
                },
                select: function(n) {
                    var a = this,
                        i = a.selectable;
                    return n = e(n), n.length ? (i.options.multiple || (i.clear(), n = n.first()), i.value(n), t) : i.value()
                },
                _destroyEditable: function() {
                    var e = this;
                    e.editable && (e.editable.destroy(), delete e.editable)
                },
                _modelFromElement: function(e) {
                    var t = e.attr(n.attr("uid"));
                    return this.dataSource.getByUid(t)
                },
                _closeEditable: function() {
                    var e, t, a, i = this,
                        r = i.editable,
                        l = i.template;
                    return r && (r.element.index() % 2 && (l = i.altTemplate), i.angular("cleanup", function() {
                        return {
                            elements: [r.element]
                        }
                    }), e = i._modelFromElement(r.element), i._destroyEditable(), a = r.element.index(), r.element.replaceWith(l(e)), t = i.items().eq(a), t.attr(n.attr("uid"), e.uid), t.attr("role", "option"), i._hasBindingTarget() && n.bind(t, e), i.angular("compile", function() {
                        return {
                            elements: [t],
                            data: [{
                                dataItem: e
                            }]
                        }
                    })), !0
                },
                edit: function(e) {
                    var t, a, i = this,
                        r = i._modelFromElement(e),
                        l = r.uid;
                    i.cancel(), e = i.items().filter("[" + n.attr("uid") + "=" + l + "]"), a = e.index(), e.replaceWith(i.editTemplate(r)), t = i.items().eq(a).addClass(p).attr(n.attr("uid"), r.uid), i.editable = t.kendoEditable({
                        model: r,
                        clearContainer: !1,
                        errorTemplate: !1,
                        target: i
                    }).data("kendoEditable"), i.trigger(g, {
                        model: r,
                        item: t
                    })
                },
                save: function() {
                    var e, t, n = this,
                        a = n.editable;
                    a && (t = a.element, e = n._modelFromElement(t), a.end() && !n.trigger(_, {
                        model: e,
                        item: t
                    }) && (n._closeEditable(), n.dataSource.sync()))
                },
                remove: function(e) {
                    var t = this,
                        n = t.dataSource,
                        a = t._modelFromElement(e);
                    t.editable && (n.cancelChanges(t._modelFromElement(t.editable.element)), t._closeEditable()), t.trigger(h, {
                        model: a,
                        item: e
                    }) || (e.hide(), n.remove(a), n.sync())
                },
                add: function() {
                    var e, t = this,
                        n = t.dataSource,
                        a = n.indexOf((n.view() || [])[0]);
                    a < 0 && (a = 0), t.cancel(), e = n.insert(a, {}), t.edit(t.element.find("[data-uid='" + e.uid + "']"))
                },
                cancel: function() {
                    var e, t, n = this,
                        a = n.dataSource;
                    n.editable && (e = n.editable.element, t = n._modelFromElement(e), n.trigger(i, {
                        model: t,
                        container: e
                    }) || (a.cancelChanges(t), n._closeEditable()))
                },
                _crudHandlers: function() {
                    var t = this,
                        a = b + k,
                        i = S + k,
                        r = v + k;
                    t.element.on(a + " " + i, ".k-edit-button", function(a) {
                        a.preventDefault();
                        var i = e(this).closest("[" + n.attr("uid") + "]");
                        setTimeout(function() {
                            t.edit(i)
                        })
                    }), t.element.on(a + " " + i, ".k-delete-button", function(a) {
                        a.preventDefault();
                        var i = e(this).closest("[" + n.attr("uid") + "]");
                        setTimeout(function() {
                            t.remove(i)
                        })
                    }), t.element.on(r, ".k-update-button", function(e) {
                        t.save(), e.preventDefault()
                    }), t.element.on(r, ".k-cancel-button", function(e) {
                        t.cancel(), e.preventDefault()
                    })
                },
                destroy: function() {
                    var e = this;
                    o.fn.destroy.call(e), e._unbindDataSource(), e._destroyEditable(), e.element.off(k), e._endlessFetchInProgress = e._endlessPageSize = e._skipRerenderItemsCount = e._focusNext = null, e.pager && e.pager.destroy(), n.destroy(e.element)
                }
            });
        n.ui.plugin(T)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(e, define) {
    define("kendo.upload.min", ["kendo.core.min"], e)
}(function() {
    return function(e, t) {
        function a(t) {
            return e.map(n(t), function(e) {
                return e.name
            }).join(", ")
        }

        function n(e) {
            var t = e[0];
            return t.files ? o(t.files) : [{
                name: s(t.value),
                extension: r(t.value),
                size: null
            }]
        }

        function o(t) {
            return e.map(t, function(e) {
                return i(e)
            })
        }

        function i(e) {
            var t = e.name || e.fileName;
            return {
                name: U.htmlEncode(t),
                extension: r(t),
                size: "number" == typeof e.size ? e.size : e.fileSize,
                rawFile: e
            }
        }

        function r(e) {
            var t = e.match(x);
            return t ? t[0] : ""
        }

        function s(e) {
            var t = e.lastIndexOf("\\");
            return t != -1 ? e.substr(t + 1) : e
        }

        function l(t, a) {
            var n = U.guid();
            return e.map(t, function(e) {
                return e.uid = a ? U.guid() : n, e
            })
        }

        function p(e, t) {
            var a, n = d(t.allowedExtensions),
                o = t.maxFileSize,
                i = t.minFileSize;
            for (a = 0; a < e.length; a++) u(e[a], n), c(e[a], i, o)
        }

        function d(t) {
            var a = e.map(t, function(e) {
                var t = "." === e.substring(0, 1) ? e : "." + e;
                return t.toLowerCase()
            });
            return a
        }

        function u(t, a) {
            a.length > 0 && a.indexOf(t.extension.toLowerCase()) < 0 && (t.validationErrors = t.validationErrors || [], e.inArray(V, t.validationErrors) === -1 && t.validationErrors.push(V))
        }

        function c(t, a, n) {
            0 !== a && t.size < a && (t.validationErrors = t.validationErrors || [], e.inArray(Z, t.validationErrors) === -1 && t.validationErrors.push(Z)), 0 !== n && t.size > n && (t.validationErrors = t.validationErrors || [], e.inArray(O, t.validationErrors) === -1 && t.validationErrors.push(O))
        }

        function f(e) {
            var t, a = 0;
            if ("number" != typeof e[0].size) return "";
            for (t = 0; t < e.length; t++) e[t].size && (a += e[t].size);
            return a /= 1024, a < 1024 ? a.toFixed(2) + " KB" : (a / 1024).toFixed(2) + " MB"
        }

        function h(t) {
            return !t.multiple && e(".k-file", t.wrapper).length > 1
        }

        function m(a, n, o, i) {
            var r, s;
            return n._supportsRemove() ? (r = a.data("fileNames"), s = e.map(r, function(e) {
                return e.name
            }), i === !1 ? (n._removeFileEntry(a), t) : (n._submitRemove(s, o, function(e, t, o) {
                var i = n.trigger(R, {
                    operation: "remove",
                    files: r,
                    response: e,
                    XMLHttpRequest: o
                });
                i || n._removeFileEntry(a)
            }, function(e) {
                h(n) && n._removeFileEntry(a), n.trigger(I, {
                    operation: "remove",
                    files: r,
                    XMLHttpRequest: e
                }), b("Server response: " + e.responseText)
            }), t)) : (!h(n) && i || n._removeFileEntry(a), t)
        }

        function k(t, a, n) {
            var o = !1,
                i = "";
            try {
                i = e.parseJSON(v(t)), o = !0
            } catch (r) {
                n()
            }
            o && a(i)
        }

        function v(e) {
            return t !== e && "" !== e || (e = "{}"), e
        }

        function g(e) {
            e.stopPropagation(), e.preventDefault()
        }

        function _(e, t, a, n) {
            var o, i;
            e.on("dragenter" + t, function(e) {
                a(e), i = new Date, o || (o = setInterval(function() {
                    var e = new Date - i;
                    e > 100 && (n(), clearInterval(o), o = null)
                }, 100))
            }).on("dragover" + t, function() {
                i = new Date
            })
        }

        function y(e) {
            return e.is(".k-file-progress, .k-file-success, .k-file-error")
        }

        function F(t) {
            return e(t.target).closest(".k-file")
        }
        var w, C, U = window.kendo,
            S = U.ui.Widget,
            z = U.antiForgeryTokens,
            b = U.logToConsole,
            x = /\.([^\.]+)$/,
            D = ".kendoUpload",
            E = "select",
            A = "upload",
            R = "success",
            I = "error",
            P = "complete",
            T = "cancel",
            N = "clear",
            B = "pause",
            H = "resume",
            q = "progress",
            M = "remove",
            L = "validationErrors",
            O = "invalidMaxFileSize",
            Z = "invalidMinFileSize",
            V = "invalidFileExtension",
            j = 1e3,
            X = 2e3,
            W = {
                loading: "k-i-loading",
                warning: "k-i-warning",
                success: "k-i-check"
            },
            K = S.extend({
                init: function(t, a) {
                    var n, o, i, r = this;
                    S.fn.init.call(r, t, a), r.name = t.name, r.multiple = r.options.multiple, r.directory = r.options.directory, r.localization = r.options.localization, n = r.element, r.wrapper = n.closest(".k-upload"), 0 === r.wrapper.length && (r.wrapper = r._wrapInput(n)), r._activeInput(n), r.toggle(r.options.enabled), o = r._ns = D + "-" + U.guid(), n.closest("form").on("submit" + o, e.proxy(r._onParentFormSubmit, r)).on("reset" + o, e.proxy(r._onParentFormReset, r)), r.options.async.saveUrl ? (r._module = r._supportsFormData() ? new C(r) : new w(r), r._async = !0, i = r.options.files, i.length > 0 && r._renderInitialFiles(i)) : r._module = new G(r), r._toggleDropZone(), r.wrapper.on("click", ".k-upload-action", e.proxy(r._onFileAction, r)).on("click", ".k-clear-selected", e.proxy(r._onClearSelected, r)).on("click", ".k-upload-selected", e.proxy(r._onUploadSelected, r)), r.element.val() && r._onInputChange({
                        target: r.element
                    })
                },
                events: [E, A, R, I, P, T, N, q, M, B, H],
                options: {
                    name: "Upload",
                    enabled: !0,
                    multiple: !0,
                    directory: !1,
                    showFileList: !0,
                    template: "",
                    files: [],
                    async: {
                        autoRetryAfter: 0,
                        bufferChunkSize: 1e7,
                        maxAutoRetries: 1,
                        removeVerb: "POST",
                        autoUpload: !0,
                        withCredentials: !0,
                        accept: "*/*; q=0.5, application/json",
                        useArrayBuffer: !1
                    },
                    localization: {
                        select: "Select files...",
                        cancel: "Cancel",
                        retry: "Retry",
                        remove: "Remove",
                        pause: "Pause",
                        resume: "Resume",
                        clearSelectedFiles: "Clear",
                        uploadSelectedFiles: "Upload",
                        dropFilesHere: "Drop files here to upload",
                        invalidFiles: "Invalid file(s). Please check file upload requirements.",
                        statusUploading: "uploading",
                        statusUploaded: "uploaded",
                        statusWarning: "warning",
                        statusFailed: "failed",
                        headerStatusUploading: "Uploading...",
                        headerStatusPaused: "Paused",
                        headerStatusUploaded: "Done",
                        invalidMaxFileSize: "File size too large.",
                        invalidMinFileSize: "File size too small.",
                        invalidFileExtension: "File type not allowed."
                    },
                    validation: {
                        allowedExtensions: [],
                        maxFileSize: 0,
                        minFileSize: 0
                    },
                    dropZone: ""
                },
                setOptions: function(t) {
                    var a = this,
                        n = a.element;
                    e(a.options.dropZone).off(a._ns), S.fn.setOptions.call(a, t), a.multiple = a.options.multiple, a.directory = a.options.directory, n.attr("multiple", !!a._supportsMultiple() && a.multiple), a.directory && (n.attr("webkitdirectory", a.directory), n.attr("directory", a.directory)), a.toggle(a.options.enabled), a._toggleDropZone()
                },
                enable: function(e) {
                    e = t === e || e, this.toggle(e)
                },
                disable: function() {
                    this.toggle(!1)
                },
                toggle: function(e) {
                    e = t === e ? e : !e, this.wrapper.toggleClass("k-state-disabled", e), this.element.prop("disabled", e)
                },
                focus: function() {
                    this.element.focus()
                },
                destroy: function() {
                    var t = this,
                        a = e(t.options.dropZone);
                    e(document).add(e(".k-dropzone", t.wrapper)).add(t.wrapper.closest("form")).off(t._ns), a.length > 0 && a.off(t._ns), e(t.element).off(D), S.fn.destroy.call(t)
                },
                pause: function(t) {
                    this._module.onPause({
                        target: e(t, this.wrapper)
                    });
                    var a = t.find(".k-i-pause-sm");
                    a.removeClass("k-i-pause-sm").addClass("k-i-play-sm").attr("title", this.localization.resume), e(a).parent().attr("aria-label", this.localization.resume)
                },
                resume: function(t) {
                    this._module.onResume({
                        target: e(t, this.wrapper)
                    });
                    var a = t.find(".k-i-play-sm");
                    a.removeClass("k-i-play-sm").addClass("k-i-pause-sm").attr("title", this.localization.pause), e(a).parent().attr("aria-label", this.localization.pause)
                },
                upload: function() {
                    var e = this;
                    e._module.onSaveSelected()
                },
                getFiles: function() {
                    var t, a, n, o = this,
                        i = [],
                        r = o.wrapper.find(".k-file");
                    for (a = 0; a < r.length; a++)
                        if (t = e(r[a]).data("fileNames"))
                            for (n = 0; n < t.length; n++) i.push(t[n]);
                    return i
                },
                clearAllFiles: function() {
                    var e = this,
                        t = e.wrapper.find(".k-file");
                    t.each(function(t, a) {
                        e._removeFileByDomElement(a, !1)
                    })
                },
                removeAllFiles: function() {
                    var e = this,
                        t = e.wrapper.find(".k-file");
                    t.each(function(t, a) {
                        e._removeFileByDomElement(a, !0)
                    })
                },
                removeFileByUid: function(e) {
                    this._removeFileByUid(e, !0)
                },
                clearFileByUid: function(e) {
                    this._removeFileByUid(e, !1)
                },
                _removeFileByUid: function(t, a) {
                    var n, o = this;
                    "string" == typeof t && (n = e(".k-file[" + U.attr("uid") + '="' + t + '"]', o.wrapper), n.length > 0 && o._removeFileByDomElement(n, a))
                },
                clearFile: function(e) {
                    this._removeFile(e, !1)
                },
                removeFile: function(e) {
                    this._removeFile(e, !0)
                },
                _removeFile: function(t, a) {
                    var n, o = this,
                        i = o.wrapper.find(".k-file");
                    "function" == typeof t && i.each(function(i, r) {
                        n = e(r).data("fileNames"), t(n) && o._removeFileByDomElement(r, a)
                    })
                },
                _removeFileByDomElement: function(t, a) {
                    var n, o = this,
                        i = {
                            target: e(t, o.wrapper)
                        };
                    o.options.async.saveUrl ? (e(t).hasClass("k-file-progress") ? o._module.onCancel(i) : o._module.onRemove(i, {}, a), n = e(".k-file", o.wrapper), 0 === n.length ? o._hideHeaderUploadstatus() : o._updateHeaderUploadStatus()) : o._module.onRemove(i, {}, a)
                },
                _addInput: function(t) {
                    if (t[0].nodeType) {
                        var a = this,
                            n = t.clone().val("");
                        n.insertAfter(a.element).data("kendo" + a.options.prefix + a.options.name, a), e(a.element).hide().attr("tabindex", "-1").removeAttr("id").off(D), a._activeInput(n), a.element.focus()
                    }
                },
                _activeInput: function(t) {
                    var a = this,
                        n = a.wrapper;
                    a.element = t, a.directory && (t.attr("webkitdirectory", a.directory), t.attr("directory", a.directory)), t.attr("multiple", !!a._supportsMultiple() && a.multiple).attr("autocomplete", "off").on("click" + D, function(e) {
                        n.hasClass("k-state-disabled") && e.preventDefault()
                    }).on("focus" + D, function() {
                        e(this).parent().addClass("k-state-focused")
                    }).on("blur" + D, function() {
                        e(this).parent().removeClass("k-state-focused")
                    }).on("change" + D, e.proxy(a._onInputChange, a)).on("keydown" + D, e.proxy(a._onInputKeyDown, a))
                },
                _onInputKeyDown: function(e) {
                    var t = this,
                        a = t.wrapper.find(".k-upload-action:visible:first");
                    e.keyCode === U.keys.TAB && a.length > 0 && !e.shiftKey && (e.preventDefault(), a.focus())
                },
                _onInputChange: function(t) {
                    var a, n = this,
                        o = e(t.target),
                        i = l(n._inputFiles(o), n._isAsyncNonBatch());
                    p(i, n.options.validation), a = n.trigger(E, {
                        files: i
                    }), a ? (n._addInput(o), o.remove()) : n._module.onSelect({
                        target: o
                    }, i)
                },
                _readDirectory: function(t) {
                    var a = new e.Deferred,
                        n = t.createReader(),
                        o = [],
                        i = function() {
                            n.readEntries(function(e) {
                                e.length ? (o = o.concat(e), i()) : a.resolve(o)
                            }, a.reject)
                        };
                    return i(), a.promise()
                },
                _readFile: function(e) {
                    var t = this,
                        a = e.fullPath;
                    e.file(function(e) {
                        e.relativePath = a.slice(1), t.droppedFolderFiles.push(e), t.droppedFolderCounter--, 0 === t.droppedFolderCounter && setTimeout(function() {
                            0 === t.droppedFolderCounter && t.droppedFolderFiles.length && (t._proceedDroppedItems(t.droppedFolderFiles), t.droppedFolderFiles = [])
                        }, 0)
                    }, function() {
                        b("File error.")
                    })
                },
                _traverseFileTree: function(e, t) {
                    var a = this;
                    t || a.droppedFolderCounter--, this._readDirectory(e).then(function(e) {
                        a.droppedFolderCounter += e.length;
                        for (var t = 0; t < e.length; t++) e[t].isFile ? a._readFile(e[t]) : e[t].isDirectory && a._traverseFileTree(e[t])
                    })
                },
                _onDrop: function(e) {
                    var t, a, n, o = e.originalEvent.dataTransfer,
                        i = this,
                        r = o.files;
                    if (g(e), i.options.directoryDrop && o.items)
                        for (t = o.items.length, i.droppedFolderCounter = 0, i.droppedFolderFiles = [], a = 0; a < t; a++) o.items[a].webkitGetAsEntry ? (n = o.items[a].webkitGetAsEntry(), n.isDirectory ? i._traverseFileTree(n, !0) : n.isFile && i.droppedFolderFiles.push(o.files[a])) : i._proceedDroppedItems(r);
                    else i._proceedDroppedItems(r)
                },
                _proceedDroppedItems: function(t) {
                    var a, n = this,
                        i = l(o(t), n._isAsyncNonBatch());
                    t.length > 0 && !n.wrapper.hasClass("k-state-disabled") && (!n.multiple && i.length > 1 && i.splice(1, i.length - 1), p(i, n.options.validation), a = n.trigger(E, {
                        files: i
                    }), a || n._module.onSelect({
                        target: e(".k-dropzone", n.wrapper)
                    }, i))
                },
                _filesContainValidationErrors: function(t) {
                    var a = !1;
                    return e(t).each(function(e, t) {
                        if (t[L] && t[L].length > 0) return a = !0, !1
                    }), a
                },
                _isAsyncNonBatch: function() {
                    return this._async && !this.options.async.batch || !1
                },
                _renderInitialFiles: function(e) {
                    var t, a, n = this,
                        o = 0;
                    for (e = l(e, !0), o = 0; o < e.length; o++) t = e[o], a = n._enqueueFile(t.name, {
                        fileNames: [t]
                    }), a.addClass("k-file-success").data("files", [e[o]]), n._supportsRemove() && n._fileAction(a, M)
                },
                _prepareTemplateData: function(e, t) {
                    var a = t.fileNames,
                        n = {},
                        o = 0,
                        i = 0;
                    for (i = 0; i < a.length; i++) o += a[i].size;
                    return n.name = e, n.size = o, n.files = t.fileNames, n
                },
                _prepareDefaultSingleFileEntryTemplate: function(t) {
                    var a = this,
                        n = t.fileNames[0],
                        o = f(t.fileNames),
                        i = U.getFileGroup(n.extension, !0),
                        r = n[L],
                        s = "";
                    return s += r && r.length > 0 ? "<li class='k-file k-file-invalid'><span class='k-progress'></span><span class='k-file-invalid-group-wrapper'><span class='k-file-group k-icon k-i-" + i + "'></span><span class='k-file-state'></span></span><span class='k-file-name-size-wrapper'><span class='k-file-name k-file-name-invalid' title='" + n.name + "'>" + n.name + "</span><span class='k-file-validation-message'>" + a.localization[r[0]] + "</span></span>" : "<li class='k-file'><span class='k-progress'></span><span class='k-file-group-wrapper'><span class='k-file-group k-icon k-i-" + i + "'></span><span class='k-file-state'></span></span><span class='k-file-name-size-wrapper'><span class='k-file-name' title='" + n.name + "'>" + n.name + "</span><span class='k-file-size'>" + o + "</span></span>", s += "<strong class='k-upload-status'></strong>", e(s)
                },
                _prepareDefaultMultipleFileEntriesTemplate: function(t) {
                    var a, n, o = this,
                        i = t.fileNames,
                        r = o._filesContainValidationErrors(i),
                        s = f(i),
                        l = "";
                    for (l += r ? "<li class='k-file k-file-invalid'><span class='k-progress'></span><span class='k-multiple-files-invalid-group-wrapper'><span class='k-file-group k-icon k-i-files'></span>" : "<li class='k-file'><span class='k-progress'></span><span class='k-multiple-files-group-wrapper'><span class='k-file-group k-icon k-i-files'></span>", l += "<span class='k-file-state'></span></span>", i.sort(function(e, t) {
                            return e[L] ? -1 : t[L] ? 1 : 0
                        }), l += "<span class='k-file-name-size-wrapper'>", a = 0; a < i.length; a++) n = i[a], l += n[L] && n[L].length > 0 ? "<span class='k-file-name k-file-name-invalid' title='" + n.name + "'>" + n.name + "</span>" : "<span class='k-file-name' title='" + n.name + "'>" + n.name + "</span>";
                    return l += r ? "<span class='k-file-validation-message'>" + o.localization.invalidFiles + "</span>" : "<span class='k-file-information'>Total: " + i.length + " files, " + s + "</span>", l += "</span><strong class='k-upload-status'></strong>", e(l)
                },
                _enqueueFile: function(t, a) {
                    var n, o, i, r, s = this,
                        l = a.fileNames[0].uid,
                        p = e(".k-upload-files", s.wrapper),
                        d = s.options,
                        u = d.template;
                    return 0 === p.length && (p = e("<ul class='k-upload-files k-reset'></ul>").appendTo(s.wrapper), s.options.showFileList || p.hide(), s.wrapper.removeClass("k-upload-empty")), n = e(".k-file", p), u ? (i = s._prepareTemplateData(t, a), u = U.template(u), o = e("<li class='k-file'>" + u(i) + "</li>"), o.find(".k-upload-action").addClass("k-button"), s.angular("compile", function() {
                        return {
                            elements: o,
                            data: [i]
                        }
                    })) : o = 1 === a.fileNames.length ? s._prepareDefaultSingleFileEntryTemplate(a) : s._prepareDefaultMultipleFileEntriesTemplate(a), o.attr(U.attr("uid"), l).appendTo(p).data(a), s._async || e(".k-progress", o).width("100%"), !s.multiple && n.length > 0 && (r = {
                        files: n.data("fileNames"),
                        headers: {}
                    }, s.trigger(M, r) || s._module.onRemove({
                        target: e(n, s.wrapper)
                    }, r)), o
                },
                _removeFileEntry: function(t) {
                    var a, n, o, i = this,
                        r = t.closest(".k-upload-files");
                    t.remove(), a = e(".k-file", r), n = e(".k-file-success, .k-file-error", r), o = e(".k-file-invalid", r), n.length !== a.length && o.length !== a.length || this._hideUploadButton(), 0 === a.length ? (r.remove(), i.wrapper.addClass("k-upload-empty"), i._hideHeaderUploadstatus()) : i._updateHeaderUploadStatus()
                },
                _fileAction: function(e, t, a) {
                    var n, o = {
                            remove: "k-i-x",
                            cancel: "k-i-cancel",
                            retry: "k-i-retry",
                            pause: "k-i-pause-sm"
                        },
                        i = {
                            remove: "k-i-close",
                            cancel: "k-i-close",
                            retry: "k-i-reload-sm",
                            pause: "k-i-pause-sm"
                        };
                    o.hasOwnProperty(t) && (a || this._clearFileAction(e), this.options.template ? (n = e.find(".k-upload-action").first(), n.find(".k-icon").length ? n.next(".k-upload-action").length && n.next(".k-upload-action").addClass("k-button").append("<span class='k-icon " + i[t] + " " + o[t] + "' title='" + this.localization[t] + "'aria-label='" + this.localization[t] + "'></span>").show() : n.addClass("k-button").append("<span class='k-icon " + i[t] + " " + o[t] + "' title='" + this.localization[t] + "'aria-label='" + this.localization[t] + "'></span>").show()) : (a || e.find(".k-upload-status .k-upload-action").remove(), e.find(".k-upload-status").append(this._renderAction(o[t], this.localization[t], i[t]))))
                },
                _fileState: function(t, a) {
                    var n = this.localization,
                        o = {
                            uploading: {
                                text: n.statusUploading
                            },
                            uploaded: {
                                text: n.statusUploaded
                            },
                            failed: {
                                text: n.statusFailed
                            }
                        },
                        i = o[a];
                    i && e("span.k-file-state", t).text(i.text)
                },
                _renderAction: function(t, a, n) {
                    return "" !== t ? e("<button type='button' class='k-button k-upload-action' aria-label='" + a + "'><span class='k-icon " + n + " " + t + "' title='" + a + "'></span></button>").on("focus", function() {
                        e(this).addClass("k-state-focused")
                    }).on("blur", function() {
                        e(this).removeClass("k-state-focused")
                    }) : e("<button type='button' class='k-button'>" + a + "</button>")
                },
                _clearFileAction: function(t) {
                    e(".k-upload-action", t).empty().hide()
                },
                _onFileAction: function(t) {
                    var a, n, o, i, r, s, l = this;
                    return l.wrapper.hasClass("k-state-disabled") || (a = e(t.target).closest(".k-upload-action"), n = a.find(".k-icon"), o = a.closest(".k-file"), i = o.data("fileNames"), r = l._filesContainValidationErrors(i), s = {
                        files: i,
                        headers: {}
                    }, l._retryClicked = !1, n.hasClass("k-i-x") ? l.trigger(M, s) || l._module.onRemove({
                        target: e(o, l.wrapper)
                    }, s, !r) : n.hasClass("k-i-cancel") ? (l.trigger(T, s), l._module.onCancel({
                        target: e(o, l.wrapper)
                    }), l._checkAllComplete(), l._updateHeaderUploadStatus()) : n.hasClass("k-i-pause-sm") ? (l.trigger(B, s), l.pause(o), l._updateHeaderUploadStatus()) : n.hasClass("k-i-play-sm") ? (l.trigger(H, s), l.resume(o)) : n.hasClass("k-i-retry") && (e(".k-i-warning", o).remove(), e(".k-progress", o).finish().show(), l._module.onRetry({
                        target: e(o, l.wrapper)
                    }), l._retryClicked = !0)), !1
                },
                _onUploadSelected: function() {
                    var e = this,
                        t = e.wrapper;
                    return t.hasClass("k-state-disabled") || this._module.onSaveSelected(), !1
                },
                _onClearSelected: function() {
                    var e = this,
                        t = e.wrapper,
                        a = {};
                    return t.hasClass("k-state-disabled") || e.trigger(N, a) || e.clearAllFiles(), !1
                },
                _onFileProgress: function(t, a) {
                    var n, o;
                    a > 100 && (a = 100), this.options.template ? e(".k-progress", t.target).width(a + "%") : (n = e(".k-upload-pct", t.target), o = e(".k-i-warning", t.target), o.length ? o.removeClass("k-i-warning").removeClass("k-icon").addClass("k-upload-pct") : 0 === n.length && e(".k-upload-status", t.target).prepend("<span class='k-upload-pct'></span>"), 100 !== a ? e(".k-upload-pct", t.target).text(a + "%") : e(".k-upload-pct", t.target).remove(), e(".k-progress", t.target).width(a + "%")), this.trigger(q, {
                        files: F(t).data("fileNames"),
                        percentComplete: a
                    })
                },
                _onUploadSuccess: function(e, t, a) {
                    var n = this,
                        o = F(e),
                        i = n.trigger(R, {
                            files: o.data("fileNames"),
                            response: t,
                            operation: "upload",
                            XMLHttpRequest: a
                        });
                    i ? n._setUploadErrorState(o) : (n._fileState(o, "uploaded"), o.removeClass("k-file-progress").addClass("k-file-success"), n._updateHeaderUploadStatus(), n._supportsRemove() ? n._fileAction(o, M) : n._clearFileAction(o)), n._hideUploadProgress(o), n._checkAllComplete()
                },
                _onUploadError: function(e, t) {
                    var a = this,
                        n = a._module,
                        o = F(e),
                        i = o.data("uid");
                    a._setUploadErrorState(o), a.trigger(I, {
                        operation: "upload",
                        files: o.data("fileNames"),
                        XMLHttpRequest: t
                    }), b("Server response: " + t.responseText), a.options.async.chunkSize ? n._decreasePosition && n._decreasePosition(i) : a._hideUploadProgress(o), a._checkAllComplete(), this.options.async.autoRetryAfter && this._autoRetryAfter(o)
                },
                _autoRetryAfter: function(e) {
                    var t = this,
                        a = this._module.retries;
                    a && (a[e.data("uid")] || (a[e.data("uid")] = 1), a[e.data("uid")] <= this.options.async.maxAutoRetries && (a[e.data("uid")]++, setTimeout(function() {
                        t._module.performUpload(e)
                    }, this.options.async.autoRetryAfter)))
                },
                _setUploadErrorState: function(t) {
                    var a, n = this;
                    n._fileState(t, "failed"), t.removeClass("k-file-progress").addClass("k-file-error"), n._updateUploadProgress(t), a = e(".k-upload-pct", t), a.length > 0 ? (a.parent().find(".k-i-warning").length || a.removeClass("k-upload-pct").addClass("k-icon k-i-warning"), a.empty()) : e(".k-upload-status", t).prepend("<span class='k-icon k-i-warning'></span>"), this._updateHeaderUploadStatus(), this._fileAction(t, "retry"), this._fileAction(t, M, !0), n._retryClicked && t.find(".k-i-retry").parent().focus()
                },
                _updateUploadProgress: function(t) {
                    var a, n, o, i = this;
                    i.options.async.chunkSize ? (a = t.data("uid"), i._module.metaData && (n = i._module.metaData[a], n && (o = n.totalChunks ? Math.round(n.chunkIndex / n.totalChunks * 100) : 100, i._onFileProgress({
                        target: e(t, i.wrapper)
                    }, o)))) : e(".k-progress", t).width("100%")
                },
                _hideUploadProgress: function(t) {
                    e(".k-progress", t).delay(j).fadeOut(X, function() {
                        e(this).css("width", "0%")
                    })
                },
                _showUploadButton: function() {
                    var t = this,
                        a = e(".k-upload-selected", t.wrapper),
                        n = e(".k-clear-selected", t.wrapper);
                    0 === a.length && (a = t._renderAction("", this.localization.uploadSelectedFiles).addClass("k-upload-selected"), n = t._renderAction("", this.localization.clearSelectedFiles).addClass("k-clear-selected")), this.wrapper.append(n, a)
                },
                _hideUploadButton: function() {
                    e(".k-upload-selected, .k-clear-selected", this.wrapper).remove()
                },
                _showHeaderUploadStatus: function(t) {
                    var a = this,
                        n = a.localization,
                        o = e(".k-dropzone", a.wrapper),
                        i = e(".k-upload-status-total", a.wrapper);
                    0 !== i.length && i.remove(), i = '<strong class="k-upload-status k-upload-status-total"><span class="k-icon"></span></strong>', t ? (i = e(i).append(n.headerStatusUploading), i.find(".k-icon").addClass(W.loading)) : (i = e(i).append(n.headerStatusUploaded), i.find(".k-icon").addClass(W.warning)), o.length > 0 ? o.append(i) : e(".k-upload-button", a.wrapper).after(i)
                },
                _updateHeaderUploadStatus: function() {
                    var t, a, n = this,
                        o = e(".k-upload-status-total", this.wrapper),
                        i = e(".k-file", n.wrapper).not(".k-file-success, .k-file-error, .k-file-invalid"),
                        r = e(".k-file-invalid", n.wrapper),
                        s = e(".k-file-error", n.wrapper),
                        l = e(".k-file", n.wrapper).find(".k-i-play-sm");
                    !l.length || l.length !== i.length && n.options.async.concurrent ? (0 === i.length || r.length > 0 || s.length > 0) && (t = e(".k-file.k-file-error, .k-file.k-file-invalid", n.wrapper), o = e(".k-upload-status-total", n.wrapper), a = e(".k-icon", o).removeClass().addClass("k-icon").addClass(0 !== t.length ? W.warning : W.success), o.html(a).append(n.localization.headerStatusUploaded)) : (a = e(".k-icon", o).removeClass().addClass("k-icon").addClass("k-i-pause-sm"), o.html(a).append(n.localization.headerStatusPaused))
                },
                _hideHeaderUploadstatus: function() {
                    e(".k-upload-status-total", this.wrapper).remove()
                },
                _onParentFormSubmit: function() {
                    var a, n = this,
                        o = n.element;
                    t !== this._module.onAbort && this._module.onAbort(), o.value || (a = e(o), a.attr("disabled", "disabled"), window.setTimeout(function() {
                        a.removeAttr("disabled")
                    }, 0))
                },
                _onParentFormReset: function() {
                    e(".k-upload-files", this.wrapper).remove()
                },
                _supportsFormData: function() {
                    return "undefined" != typeof FormData
                },
                _supportsMultiple: function() {
                    var e = this._userAgent().indexOf("Windows") > -1;
                    return !(U.support.browser.opera || U.support.browser.safari && e)
                },
                _supportsDrop: function() {
                    var e = this._userAgent().toLowerCase(),
                        t = /chrome/.test(e),
                        a = !t && /safari/.test(e),
                        n = a && /windows/.test(e);
                    return !n && this._supportsFormData() && this.options.async.saveUrl
                },
                _userAgent: function() {
                    return navigator.userAgent
                },
                _setupDropZone: function() {
                    var t = this,
                        a = t._ns,
                        n = e(".k-dropzone", t.wrapper).on("dragenter" + a, g).on("dragover" + a, function(e) {
                            e.preventDefault()
                        }).on("drop" + a, e.proxy(t._onDrop, t));
                    n.find(".k-dropzone-hint").length || n.append(e("<em class='k-dropzone-hint'>" + t.localization.dropFilesHere + "</em>")), _(n, a, function() {
                        n.closest(".k-upload").hasClass("k-state-disabled") || n.addClass("k-dropzone-hovered")
                    }, function() {
                        n.removeClass("k-dropzone-hovered")
                    }), t._bindDocumentDragEventWrappers(n)
                },
                _setupCustomDropZone: function() {
                    var t, a = this,
                        n = e(a.options.dropZone);
                    a.wrapper.find(".k-dropzone-hint").length || e(".k-dropzone", a.wrapper).append(e("<em class='k-dropzone-hint'>" + a.localization.dropFilesHere + "</em>")), t = a._ns, n.on("dragenter" + t, g).on("dragover" + t, function(e) {
                        e.preventDefault()
                    }).on("drop" + t, e.proxy(a._onDrop, a)), _(n, t, function(t) {
                        a.wrapper.hasClass("k-state-disabled") || (n.removeClass("k-dropzone-hovered"), n.addClass("k-dropzone-hovered"), e(t.target).addClass("k-dropzone-hovered"))
                    }, function() {
                        n.removeClass("k-dropzone-hovered"), n.find(".k-dropzone-hovered").removeClass("k-dropzone-hovered")
                    }), a._bindDocumentDragEventWrappers(n)
                },
                _bindDocumentDragEventWrappers: function(t) {
                    var a = this,
                        n = a._ns;
                    _(e(document), n, function() {
                        a.wrapper.hasClass("k-state-disabled") || (t.addClass("k-dropzone-active"), t.closest(".k-upload").removeClass("k-upload-empty"))
                    }, function() {
                        t.removeClass("k-dropzone-active"), 0 === e("li.k-file", t.closest(".k-upload")).length && t.closest(".k-upload").addClass("k-upload-empty")
                    })
                },
                _toggleDropZone: function() {
                    var t = this,
                        a = t.options.dropZone;
                    t._supportsDrop() && (e(a).off(t._ns), e(".k-dropzone", t.wrapper).off(t._ns), "" !== a ? t._setupCustomDropZone() : t._setupDropZone())
                },
                _supportsRemove: function() {
                    return !!this.options.async.removeUrl
                },
                _submitRemove: function(t, a, n, o) {
                    var i = this,
                        r = i.options.async.removeField || "fileNames",
                        s = e.extend(a.data, z());
                    s[r] = t, jQuery.ajax({
                        type: this.options.async.removeVerb,
                        dataType: "json",
                        dataFilter: v,
                        url: this.options.async.removeUrl,
                        traditional: !0,
                        data: s,
                        headers: a.headers,
                        success: n,
                        error: o,
                        xhrFields: {
                            withCredentials: this.options.async.withCredentials
                        }
                    })
                },
                _wrapInput: function(e) {
                    var t = this,
                        a = t.options;
                    return e.wrap("<div class='k-widget k-upload'><div class='k-dropzone'><div class='k-button k-upload-button' aria-label='" + this.localization.select + "'></div></div></div>"), a.async.saveUrl ? e.closest(".k-upload").addClass("k-upload-async") : e.closest(".k-upload").addClass("k-upload-sync"), e.closest(".k-upload").addClass("k-upload-empty"), e.closest(".k-button").append("<span>" + this.localization.select + "</span>"), e.closest(".k-upload")
                },
                _checkAllComplete: function() {
                    0 === e(".k-file.k-file-progress", this.wrapper).length && this.trigger(P)
                },
                _inputFiles: function(e) {
                    return n(e)
                }
            }),
            G = function(e) {
                this.name = "syncUploadModule", this.element = e.wrapper, this.upload = e, this.element.closest("form").attr("enctype", "multipart/form-data").attr("encoding", "multipart/form-data")
            };
        G.prototype = {
            onSelect: function(t, n) {
                var o, i, r = this.upload,
                    s = e(t.target),
                    l = r._filesContainValidationErrors(n);
                r._addInput(s), o = {
                    fileNames: n
                }, l ? s.remove() : o.relatedInput = s, i = r._enqueueFile(a(s), o), l && r._hideUploadProgress(i), r._fileAction(i, M)
            },
            onRemove: function(e) {
                var t = F(e),
                    a = t.data("relatedInput");
                a && a.remove(), this.upload._removeFileEntry(t)
            }
        }, w = function(e) {
            this.name = "iframeUploadModule", this.element = e.wrapper, this.upload = e, this.iframes = []
        }, K._frameId = 0, w.prototype = {
            onSelect: function(t, a) {
                var n = this.upload,
                    o = e(t.target),
                    i = n._filesContainValidationErrors(a),
                    r = this.prepareUpload(o, a, i);
                n.options.async.autoUpload ? i ? (n._fileAction(r, M), n._showHeaderUploadStatus(!1)) : this.performUpload(r) : (n._fileAction(r, M), i ? n._updateHeaderUploadStatus() : n._showUploadButton()), i && n._hideUploadProgress(r)
            },
            prepareUpload: function(t, n, o) {
                var i, r, s, l, p = this.upload,
                    d = e(p.element),
                    u = p.options.async.saveField || t.attr("name");
                return p._addInput(t), t.attr("name", u), o ? (t.remove(), r = {
                    fileNames: n
                }) : (s = this.createFrame(p.name + "_" + K._frameId++), this.registerFrame(s), l = this.createForm(p.options.async.saveUrl, s.attr("name")).append(d), r = {
                    frame: s,
                    relatedInput: d,
                    fileNames: n
                }), i = p._enqueueFile(a(t), r), s && s.data({
                    form: l,
                    file: i
                }), i
            },
            performUpload: function(t) {
                var a, n, o, i = {
                        files: t.data("fileNames")
                    },
                    r = t.data("frame"),
                    s = this.upload;
                if (s.trigger(A, i)) s._removeFileEntry(r.data("file")), this.cleanupFrame(r), this.unregisterFrame(r);
                else {
                    s._hideUploadButton(), s._showHeaderUploadStatus(!0), r.appendTo(document.body), a = r.data("form").attr("action", s.options.async.saveUrl).appendTo(document.body), i.data = e.extend({}, i.data, z());
                    for (n in i.data) o = a.find("input[name='" + n + "']"), 0 === o.length && (o = e("<input>", {
                        type: "hidden",
                        name: n
                    }).prependTo(a)), o.val(i.data[n]);
                    s._fileAction(t, T), s._fileState(t, "uploading"), e(t).removeClass("k-file-error").addClass("k-file-progress"), r.one("load", e.proxy(this.onIframeLoad, this)), a[0].submit()
                }
            },
            onSaveSelected: function() {
                var t = this,
                    a = t.upload;
                e(".k-file", this.element).each(function() {
                    var n = e(this),
                        o = y(n),
                        i = a._filesContainValidationErrors(n.data("fileNames"));
                    o || i || t.performUpload(n)
                })
            },
            onIframeLoad: function(t) {
                var a, n = e(t.target);
                try {
                    a = n.contents().text()
                } catch (o) {
                    a = "Error trying to get server response: " + o
                }
                this.processResponse(n, a)
            },
            processResponse: function(t, a) {
                var n = t.data("file"),
                    o = this,
                    i = {
                        responseText: a
                    };
                k(a, function(a) {
                    e.extend(i, {
                        statusText: "OK",
                        status: "200"
                    }), o.upload._onFileProgress({
                        target: e(n, o.upload.wrapper)
                    }, 100), o.upload._onUploadSuccess({
                        target: e(n, o.upload.wrapper)
                    }, a, i), o.cleanupFrame(t), o.unregisterFrame(t)
                }, function() {
                    e.extend(i, {
                        statusText: "error",
                        status: "500"
                    }), o.upload._onUploadError({
                        target: e(n, o.upload.wrapper)
                    }, i)
                })
            },
            onCancel: function(t) {
                var a = e(t.target).data("frame");
                this.stopFrameSubmit(a), this.cleanupFrame(a), this.unregisterFrame(a), this.upload._removeFileEntry(a.data("file"))
            },
            onRetry: function(e) {
                var t = F(e);
                this.performUpload(t)
            },
            onRemove: function(e, t, a) {
                var n = this,
                    o = n.upload,
                    i = F(e),
                    r = i.data("frame");
                r ? (n.unregisterFrame(r), o._removeFileEntry(i), n.cleanupFrame(r)) : i.hasClass("k-file-success") ? m(i, o, t, a) : o._removeFileEntry(i)
            },
            onAbort: function() {
                var t = this.element,
                    a = this;
                e.each(this.iframes, function() {
                    e("input", this.data("form")).appendTo(t), a.stopFrameSubmit(this[0]), this.data("form").remove(), this.remove()
                }), this.iframes = []
            },
            createFrame: function(t) {
                return e("<iframe name='" + t + "' id='" + t + "' style='display:none;' />")
            },
            createForm: function(t, a) {
                return e("<form enctype='multipart/form-data' method='POST' action='" + t + "' target='" + a + "'/>")
            },
            stopFrameSubmit: function(e) {
                t !== e.stop ? e.stop() : e.document && e.document.execCommand("Stop")
            },
            registerFrame: function(e) {
                this.iframes.push(e)
            },
            unregisterFrame: function(t) {
                this.iframes = e.grep(this.iframes, function(e) {
                    return e.attr("name") != t.attr("name")
                })
            },
            cleanupFrame: function(e) {
                var t = e.data("form");
                e.data("file").data("frame", null), setTimeout(function() {
                    t.remove(), e.remove()
                }, 1)
            }
        }, C = function(e) {
            this.name = "formDataUploadModule", this.element = e.wrapper, this.upload = e, this.position = {}, this.metaData = {}, this.cancelled = {}, this.resume = {}, this.paused = {}, this.retries = {}
        }, C.prototype = {
            onSelect: function(t, a) {
                var n, o, i = this.upload,
                    r = this,
                    s = e(t.target),
                    l = this.prepareUpload(s, a);
                e.each(l, function(t) {
                    n = i._filesContainValidationErrors(e(this.data("fileNames"))), i.options.async.autoUpload ? n ? (i._fileAction(this, M), i._showHeaderUploadStatus(!1)) : i.options.async.chunkSize ? (r.prepareChunk(this), o = this.prev(), (i.options.async.concurrent || 0 === t && !o.length || 0 === t && o.hasClass("k-file-success")) && r.performUpload(this)) : r.performUpload(this) : (i._fileAction(this, M), n ? i._updateHeaderUploadStatus() : (i._showUploadButton(), this.addClass("k-toupload"))), n && i._hideUploadProgress(this)
                })
            },
            prepareUpload: function(t, a) {
                var n = this.enqueueFiles(a);
                return t.is("input") && (e.each(n, function() {
                    e(this).data("relatedInput", t)
                }), t.data("relatedFileEntries", n), this.upload._addInput(t)), n
            },
            enqueueFiles: function(t) {
                var a, n, o, i, r = this.upload,
                    s = t.length,
                    l = [];
                if (r.options.async.batch === !0) a = e.map(t, function(e) {
                    return e.name
                }).join(", "), (r.directory || r.options.directoryDrop) && e(t).each(function() {
                    (this.rawFile.webkitRelativePath || this.rawFile.relativePath) && (this.name = this.rawFile.webkitRelativePath || this.rawFile.relativePath)
                }), i = r._enqueueFile(a, {
                    fileNames: t
                }), i.data("files", t), l.push(i);
                else
                    for (n = 0; n < s; n++) o = t[n], a = o.name, (r.directory || r.options.directoryDrop) && (o.rawFile.webkitRelativePath || o.rawFile.relativePath) && (o.name = o.rawFile.webkitRelativePath || o.rawFile.relativePath), i = r._enqueueFile(a, {
                        fileNames: [o]
                    }), i.data("files", [o]), l.push(i);
                return l
            },
            performUpload: function(t) {
                var a, n, o = this.upload,
                    i = this.createFormData(),
                    r = this.createXHR(),
                    s = {
                        files: t.data("fileNames"),
                        XMLHttpRequest: r
                    };
                if (o.trigger(A, s)) this.removeFileEntry(t);
                else {
                    if (0 === t.find(".k-i-cancel").length && (o.options.async.chunkSize && o._fileAction(t, B), o._fileAction(t, T, o.options.async.chunkSize)), o.wrapper.find(".k-toupload").length || o._hideUploadButton(), o._showHeaderUploadStatus(!0), s.formData) i = s.formData;
                    else {
                        s.data = e.extend({}, s.data, z());
                        for (n in s.data) i.append(n, s.data[n]);
                        a = t.data("files"), a && this.populateFormData(i, a)
                    }
                    o._fileState(t, "uploading"), e(t).removeClass("k-file-error").addClass("k-file-progress"), o.options.async.useArrayBuffer && window.FileReader ? this._readFile(o.options.async.saveUrl, i, t, r) : this.postFormData(o.options.async.saveUrl, i, t, r)
                }
            },
            _readFile: function(a, n, o, i) {
                var r = this,
                    s = r.upload,
                    l = o.data("files")[0],
                    p = new FileReader;
                p.onload = function(p) {
                    try {
                        r.fileArrayBuffer = r.fileArrayBuffer ? r._appendBuffer(r.fileArrayBuffer, p.target.result) : p.target.result
                    } catch (d) {
                        return s._onUploadError({
                            target: e(o, s.wrapper)
                        }, i), t
                    }
                    r.position[l.uid] > l.size ? (r.postFormData(s.options.async.saveUrl, r.fileArrayBuffer, o, i), r.fileArrayBuffer = null) : r._readFile(a, n, o, i)
                }, p.onerror = function() {
                    s._onUploadError({
                        target: e(o, s.wrapper)
                    }, i)
                }, p.readAsArrayBuffer(r._getCurrentChunk(l.rawFile, l.uid))
            },
            _appendBuffer: function(e, t) {
                var a = new Uint8Array(e.byteLength + t.byteLength);
                return a.set(new Uint8Array(e), 0), a.set(new Uint8Array(t), e.byteLength), a.buffer
            },
            onSaveSelected: function() {
                var t = this,
                    a = t.upload;
                e(".k-toupload", this.element).filter(function() {
                    var t = e(this),
                        n = y(t),
                        o = a._filesContainValidationErrors(t.data("fileNames"));
                    return !n && !o
                }).each(function(n) {
                    var o = e(this),
                        i = o.prev();
                    o.removeClass("k-toupload"), a.options.async.chunkSize ? (t.prepareChunk(o), (a.options.async.concurrent || 0 === n && !i.length || 0 === n && i.hasClass("k-file-success") || i.hasClass("k-file-error")) && t.performUpload(o)) : t.performUpload(o)
                })
            },
            onCancel: function(e) {
                var t = F(e);
                this.upload.options.async.chunkSize && (this.cancelled[t.data("uid")] = !0), this.stopUploadRequest(t), this.removeFileEntry(t)
            },
            onPause: function(e) {
                var t = F(e),
                    a = t.data("uid"),
                    n = this.upload.options.async;
                n.chunkSize && (this.retries[a] = n.maxAutoRetries + 1, this.paused[a] = !0, this.resume[a] = !1)
            },
            onResume: function(e) {
                var t = F(e),
                    a = t.data("uid");
                this.upload.options.async.chunkSize && (delete this.paused[a], this.resume[a] = !0, this.retries[t.data("uid")] = 1, this._increaseChunkIndex(a), this.performUpload(t))
            },
            onRetry: function(e) {
                var t = F(e),
                    a = this.upload.options.async;
                a.chunkSize && (this.retries[t.data("uid")] = a.maxAutoRetries + 1, delete this.paused[t.data("uid")]), this.performUpload(t)
            },
            onRemove: function(e, t, a) {
                var n = this,
                    o = n.upload,
                    i = F(e),
                    r = this.upload.options.async;
                r.chunkSize && (this.retries[i.data("uid")] = r.maxAutoRetries + 1), i.hasClass("k-file-success") ? m(i, o, t, a) : n.removeFileEntry(i)
            },
            createXHR: function() {
                return new XMLHttpRequest
            },
            postFormData: function(e, t, a, n) {
                var o, i = this;
                a.data("request", n), n.addEventListener("load", function(e) {
                    i.onRequestSuccess.call(i, e, a)
                }, !1), n.addEventListener(I, function(e) {
                    i.onRequestError.call(i, e, a)
                }, !1), n.upload.addEventListener("progress", function(e) {
                    i.onRequestProgress.call(i, e, a)
                }, !1), n.open("POST", e, !0), n.withCredentials = this.upload.options.async.withCredentials, o = this.upload.options.async.accept, o && n.setRequestHeader("Accept", o), n.send(t)
            },
            createFormData: function() {
                return new FormData
            },
            populateFormData: function(e, t) {
                var a, n, o, i, r = t.length,
                    s = this.upload;
                if (s.options.async.chunkSize) o = t[0].uid, a = this._getCurrentChunk(t[0].rawFile, o), e.append(s.options.async.saveField || s.name, a), i = JSON.stringify(this.metaData[o]), e.append("metadata", i);
                else
                    for (n = 0; n < r; n++) e.append(s.options.async.saveField || s.name, t[n].rawFile);
                return e
            },
            onRequestSuccess: function(t, a) {
                function n() {
                    r.upload._onUploadError({
                        target: e(a, r.upload.wrapper)
                    }, i)
                }

                function o(t) {
                    var n = r.upload.options.async.batch,
                        o = r.upload.options.async.chunkSize,
                        s = r.upload.options.async.concurrent,
                        l = t.fileUid;
                    r.paused[l] || r.cancelled[l] || (delete r.retries[l], !o || n || t.uploaded ? !o || n || s || !a.next().length || a.next().hasClass("k-toupload") ? (r.upload._onFileProgress({
                        target: e(a, r.upload.wrapper)
                    }, 100), r.upload._onUploadSuccess({
                        target: e(a, r.upload.wrapper)
                    }, t, i), r.cleanupFileEntry(a)) : (r.upload._onFileProgress({
                        target: e(a, r.upload.wrapper)
                    }, 100), r._resetChunkIndex(l), r.upload._onUploadSuccess({
                        target: e(a, r.upload.wrapper)
                    }, t, i), r.performUpload(a.next())) : (r._increaseChunkIndex(l), r.performUpload(a)))
                }
                var i = t.target,
                    r = this;
                i.status >= 200 && i.status <= 299 ? k(i.responseText, o, n) : n()
            },
            onRequestError: function(t, a) {
                var n = t.target;
                this.upload._onUploadError({
                    target: e(a, this.upload.wrapper)
                }, n)
            },
            cleanupFileEntry: function(t) {
                var a = t.data("relatedInput"),
                    n = !0;
                a && (e.each(a.data("relatedFileEntries") || [], function() {
                    this.parent().length > 0 && this[0] != t[0] && (n = n && this.hasClass("k-file-success"))
                }), n && a.remove())
            },
            removeFileEntry: function(e) {
                var t = this.upload.options.async.chunkSize,
                    a = this.upload.options.async.concurrent,
                    n = this.upload.wrapper.find(".k-upload-selected").length > 0;
                this.cleanupFileEntry(e), !t || a || n || e.next().length && this.performUpload(e.next()), this.upload._removeFileEntry(e)
            },
            onRequestProgress: function(t, a) {
                var n, o = Math.round(100 * t.loaded / t.total),
                    i = a.data("uid");
                this.upload.options.async.chunkSize && (n = this.metaData[i], o = n && n.totalChunks ? Math.round(n.chunkIndex / n.totalChunks * 100) : 100), this.upload._onFileProgress({
                    target: e(a, this.upload.wrapper)
                }, o)
            },
            stopUploadRequest: function(e) {
                e.data("request").abort()
            },
            prepareChunk: function(e) {
                var t = e.data("files")[0],
                    a = t.rawFile,
                    n = t.uid,
                    o = this.upload.options.async.chunkSize;
                this.position[n] = 0, this.metaData[n] = {
                    chunkIndex: 0,
                    contentType: a.type,
                    fileName: a.name,
                    relativePath: t.name,
                    totalFileSize: a.size,
                    totalChunks: Math.ceil(a.size / o),
                    uploadUid: n
                }
            },
            _decreaseChunkIndex: function(e) {
                this.metaData[e].chunkIndex--
            },
            _increaseChunkIndex: function(e) {
                this.metaData[e].chunkIndex++
            },
            _resetChunkIndex: function(e) {
                this.metaData[e].chunkIndex = 0
            },
            _decreasePosition: function(e) {
                this.position[e] -= this.upload.options.async.chunkSize
            },
            _getCurrentChunk: function(e, t) {
                var a, n = this.position[t],
                    o = this.upload.options.async,
                    i = o.chunkSize || o.bufferChunkSize;
                return this.position[t] || (this.position[t] = 0), this.position[t] += i, (a = this._getChunker(e)) ? e[a](n, this.position[t]) : e
            },
            _getChunker: function(e) {
                return e.slice ? "slice" : e.mozSlice ? "mozSlice" : e.webkitSlice ? "webkitSlice" : null
            }
        }, U.ui.plugin(K)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, a) {
    (a || t)()
});;
! function(e, define) {
    define("kendo.filebrowser.min", ["kendo.listview.min", "kendo.dropdownlist.min", "kendo.upload.min", "kendo.breadcrumb.min"], e)
}(function() {
    return function(e, t) {
        function a(e, t, a) {
            var o, i;
            e.on("dragenter" + y, function() {
                t(), i = new Date, o || (o = setInterval(function() {
                    var e = new Date - i;
                    e > 100 && (a(), clearInterval(o), o = null)
                }, 100))
            }).on("dragover" + y, function() {
                i = new Date
            })
        }

        function o(e, a) {
            return e !== t && e.match(/\/$/) || (e = (e || "") + "/"), e + a
        }

        function i(e) {
            if (!e) return "";
            var t = " bytes";
            return e >= 1073741824 ? (t = " GB", e /= 1073741824) : e >= 1048576 ? (t = " MB", e /= 1048576) : e >= 1024 && (t = " KB", e /= 1024), Math.round(100 * e) / 100 + t
        }

        function r(e, t) {
            var a = e[t];
            return u(a) ? a.from || a.field || t : a
        }
        var n, s, l, d = window.kendo,
            c = d.ui.Widget,
            u = e.isPlainObject,
            p = e.proxy,
            f = e.extend,
            h = d.support.placeholder,
            m = d.support.browser,
            v = d.isFunction,
            k = /(^\/|\/$)/g,
            g = "change",
            _ = "apply",
            w = "error",
            b = "click",
            y = ".kendoFileBrowser",
            S = ".kendoSearchBox",
            x = "name",
            F = "size",
            T = "type",
            B = {
                field: T,
                dir: "asc"
            },
            D = d.template('<li class="k-tile-empty"><strong>${text}</strong></li>'),
            C = '<div class="k-widget k-filebrowser-toolbar k-header k-floatwrap"><div class="k-toolbar-wrap"># if (showUpload) { # <div class="k-widget k-upload"><div class="k-button k-button-icontext k-upload-button"><span class="k-icon k-i-plus"></span>#=messages.uploadFile#<input type="file" name="file" /></div></div># } ## if (showCreate) { #<button type="button" class="k-button k-button-icon"><span class="k-icon k-i-folder-add" /></button># } ## if (showDelete) { #<button type="button" class="k-button k-button-icon k-state-disabled"><span class="k-icon k-i-close" /></button>&nbsp;# } #</div><div class="k-tiles-arrange"><label>#=messages.orderBy#: <select /></label></div></div>';
        f(!0, d.data, {
            schemas: {
                filebrowser: {
                    data: function(e) {
                        return e.items || e || []
                    },
                    model: {
                        id: "name",
                        fields: {
                            name: "name",
                            size: "size",
                            type: "type"
                        }
                    }
                }
            }
        }), f(!0, d.data, {
            transports: {
                filebrowser: d.data.RemoteTransport.extend({
                    init: function(t) {
                        d.data.RemoteTransport.fn.init.call(this, e.extend(!0, {}, this.options, t))
                    },
                    _call: function(t, a) {
                        a.data = e.extend({}, a.data, {
                            path: this.options.path()
                        }), v(this.options[t]) ? this.options[t].call(this, a) : d.data.RemoteTransport.fn[t].call(this, a)
                    },
                    read: function(e) {
                        this._call("read", e)
                    },
                    create: function(e) {
                        this._call("create", e)
                    },
                    destroy: function(e) {
                        this._call("destroy", e)
                    },
                    update: function() {},
                    options: {
                        read: {
                            type: "POST"
                        },
                        update: {
                            type: "POST"
                        },
                        create: {
                            type: "POST"
                        },
                        destroy: {
                            type: "POST"
                        }
                    }
                })
            }
        }), n = m.msie && m.version < 8 ? function(e) {
            return e.offsetTop
        } : function(t) {
            return t.offsetTop - e(t).height()
        }, s = c.extend({
            init: function(e, t) {
                var a = this;
                t = t || {}, c.fn.init.call(a, e, t), a.element.addClass("k-filebrowser"), a.element.on(b + y, ".k-filebrowser-toolbar button:not(.k-state-disabled):has(.k-i-close)", p(a._deleteClick, a)).on(b + y, ".k-filebrowser-toolbar button:not(.k-state-disabled):has(.k-i-folder-add)", p(a._addClick, a)).on("keydown" + y, "li.k-state-selected input", p(a._directoryKeyDown, a)).on("blur" + y, "li.k-state-selected input", p(a._directoryBlur, a)), a._dataSource(), a.refresh(), a.path(a.options.path)
            },
            options: {
                name: "FileBrowser",
                messages: {
                    uploadFile: "Upload",
                    orderBy: "Arrange by",
                    orderByName: "Name",
                    orderBySize: "Size",
                    directoryNotFound: "A directory with this name was not found.",
                    emptyFolder: "Empty Folder",
                    deleteFile: 'Are you sure you want to delete "{0}"?',
                    invalidFileType: 'The selected file "{0}" is not valid. Supported file types are {1}.',
                    overwriteFile: 'A file with name "{0}" already exists in the current directory. Do you want to overwrite it?',
                    dropFilesHere: "drop file here to upload",
                    search: "Search"
                },
                transport: {},
                path: "/",
                fileTypes: "*.*"
            },
            events: [w, g, _],
            destroy: function() {
                var e = this;
                c.fn.destroy.call(e), e.dataSource.unbind(w, e._errorHandler), e.element.add(e.list).add(e.toolbar).off(y), d.destroy(e.element)
            },
            value: function() {
                var e, t = this,
                    a = t._selectedItem(),
                    i = t.options.transport.fileUrl;
                if (a && "f" === a.get(T)) return e = o(t.path(), a.get(x)).replace(k, ""), i && (e = v(i) ? i(e) : d.format(i, encodeURIComponent(e))), e
            },
            _selectedItem: function() {
                var e = this.listView,
                    t = e.select();
                if (t.length) return this.dataSource.getByUid(t.attr(d.attr("uid")))
            },
            _toolbar: function() {
                var t = this,
                    a = d.template(C),
                    o = t.options.messages,
                    i = [{
                        text: o.orderByName,
                        value: "name"
                    }, {
                        text: o.orderBySize,
                        value: "size"
                    }];
                t.toolbar = e(a({
                    messages: o,
                    showUpload: t.options.transport.uploadUrl,
                    showCreate: t.options.transport.create,
                    showDelete: t.options.transport.destroy
                })).appendTo(t.element).find(".k-upload input").kendoUpload({
                    multiple: !1,
                    localization: {
                        dropFilesHere: o.dropFilesHere
                    },
                    async: {
                        saveUrl: t.options.transport.uploadUrl,
                        autoUpload: !0
                    },
                    upload: p(t._fileUpload, t),
                    error: function(e) {
                        t._error({
                            xhr: e.XMLHttpRequest,
                            status: "error"
                        })
                    }
                }).end(), t.upload = t.toolbar.find(".k-upload input").data("kendoUpload"), t.arrangeBy = t.toolbar.find(".k-tiles-arrange select").kendoDropDownList({
                    dataSource: i,
                    dataTextField: "text",
                    dataValueField: "value",
                    change: function() {
                        t.orderBy(this.value())
                    }
                }).data("kendoDropDownList"), t._attachDropzoneEvents()
            },
            _attachDropzoneEvents: function() {
                var t = this;
                t.options.transport.uploadUrl && (a(e(document.documentElement), e.proxy(t._dropEnter, t), e.proxy(t._dropLeave, t)), t._scrollHandler = p(t._positionDropzone, t))
            },
            _dropEnter: function() {
                this._positionDropzone(), e(document).on("scroll" + y, this._scrollHandler)
            },
            _dropLeave: function() {
                this._removeDropzone(), e(document).off("scroll" + y, this._scrollHandler)
            },
            _positionDropzone: function() {
                var e = this,
                    t = e.element,
                    a = t.offset();
                e.toolbar.find(".k-dropzone").addClass("k-filebrowser-dropzone").offset(a).css({
                    width: t[0].clientWidth,
                    height: t[0].clientHeight,
                    lineHeight: t[0].clientHeight + "px"
                })
            },
            _removeDropzone: function() {
                this.toolbar.find(".k-dropzone").removeClass("k-filebrowser-dropzone").css({
                    width: "",
                    height: "",
                    lineHeight: "",
                    top: "",
                    left: ""
                })
            },
            _deleteClick: function() {
                var e = this,
                    t = e.listView.select(),
                    a = d.format(e.options.messages.deleteFile, t.find("strong").text());
                t.length && e._showMessage(a, "confirm") && e.listView.remove(t)
            },
            _addClick: function() {
                this.createDirectory()
            },
            _getFieldName: function(e) {
                return r(this.dataSource.reader.model.fields, e)
            },
            _fileUpload: function(e) {
                var t, a = this,
                    o = a.options,
                    i = o.fileTypes,
                    r = RegExp(("(" + i.split(",").join(")|(") + ")").replace(/\*\./g, ".*."), "i"),
                    n = e.files[0].name,
                    s = e.files[0].size,
                    l = x,
                    c = F;
                r.test(n) ? (e.data = {
                    path: a.path()
                }, t = a._createFile(n, s), t ? a.upload.one("success", function(e) {
                    var o = a._insertFileToList(t);
                    o._override && (o.set(l, e.response[a._getFieldName(l)]), o.set(c, e.response[a._getFieldName(c)]), a.listView.dataSource.pushUpdate(o)), a._tiles = a.listView.items().filter("[" + d.attr("type") + "=f]")
                }) : e.preventDefault()) : (e.preventDefault(), a._showMessage(d.format(o.messages.invalidFileType, n, i)))
            },
            _findFile: function(e) {
                var t, a, o, i = this.dataSource.data(),
                    r = T,
                    n = x;
                for (e = e.toLowerCase(), t = 0, o = i.length; t < o; t++)
                    if ("f" === i[t].get(r) && i[t].get(n).toLowerCase() === e) {
                        a = i[t];
                        break
                    }
                return a
            },
            _createFile: function(e, t) {
                var a = this,
                    o = {},
                    i = T,
                    r = a._findFile(e);
                return r ? a._showMessage(d.format(a.options.messages.overwriteFile, e), "confirm") ? (r._override = !0, r) : null : (o[i] = "f", o[x] = e, o[F] = t, o)
            },
            _insertFileToList: function(e) {
                var t, a, o, i, r;
                if (e._override) return e;
                for (a = this.dataSource, o = a.view(), i = 0, r = o.length; i < r; i++)
                    if ("f" === o[i].get(T)) {
                        t = i;
                        break
                    }
                return a.insert(++t, e)
            },
            createDirectory: function() {
                var e, t, a = this,
                    o = 0,
                    i = T,
                    r = x,
                    n = a.dataSource.data(),
                    s = a._nameDirectory(),
                    l = new a.dataSource.reader.model;
                for (e = 0, t = n.length; e < t; e++) "d" === n[e].get(i) && (o = e);
                l.set(i, "d"), l.set(r, s), a.listView.one("dataBound", function() {
                    var e = a.listView.items().filter("[" + d.attr("uid") + "=" + l.uid + "]");
                    e.length && this.edit(e), this.element.scrollTop(e.attr("offsetTop") - this.element[0].offsetHeight), setTimeout(function() {
                        a.listView.element.find(".k-edit-item input").select()
                    })
                }).one("save", function(e) {
                    var t = e.model.get(r);
                    t ? e.model.set(r, a._nameExists(t, l.uid) ? a._nameDirectory() : t) : e.model.set(r, s)
                }), a.dataSource.insert(++o, l)
            },
            _directoryKeyDown: function(e) {
                13 == e.keyCode && e.currentTarget.blur()
            },
            _directoryBlur: function() {
                this.listView.save()
            },
            _nameExists: function(e, t) {
                var a, o, i = this.dataSource.data(),
                    r = T,
                    n = x;
                for (a = 0, o = i.length; a < o; a++)
                    if ("d" === i[a].get(r) && i[a].get(n).toLowerCase() === e.toLowerCase() && i[a].uid !== t) return !0;
                return !1
            },
            _nameDirectory: function() {
                var t, a, o, i = "New folder",
                    r = this.dataSource.data(),
                    n = [],
                    s = T,
                    l = x;
                for (a = 0, o = r.length; a < o; a++) "d" === r[a].get(s) && r[a].get(l).toLowerCase().indexOf(i.toLowerCase()) > -1 && n.push(r[a].get(l));
                if (e.inArray(i, n) > -1) {
                    a = 2;
                    do t = i + " (" + a + ")", a++; while (e.inArray(t, n) > -1);
                    i = t
                }
                return i
            },
            orderBy: function(e) {
                this.dataSource.sort([{
                    field: T,
                    dir: "asc"
                }, {
                    field: e,
                    dir: "asc"
                }])
            },
            search: function(e) {
                this.dataSource.filter({
                    field: x,
                    operator: "contains",
                    value: e
                })
            },
            _content: function() {
                var t = this;
                t.list = e('<ul class="k-reset k-floats k-tiles" />').appendTo(t.element).on("dblclick" + y, "li", p(t._dblClick, t)), t.listView = new d.ui.ListView(t.list, {
                    dataSource: t.dataSource,
                    template: t._itemTmpl(),
                    editTemplate: t._editTmpl(),
                    selectable: !0,
                    autoBind: !1,
                    dataBinding: function(e) {
                        t.toolbar.find(".k-i-close").parent().addClass("k-state-disabled"), "remove" !== e.action && "sync" !== e.action || (e.preventDefault(), d.ui.progress(t.listView.element, !1))
                    },
                    dataBound: function() {
                        t.dataSource.view().length ? t._tiles = this.items().filter("[" + d.attr("type") + "=f]") : this.wrapper.append(D({
                            text: t.options.messages.emptyFolder
                        }))
                    },
                    change: p(t._listViewChange, t)
                })
            },
            _dblClick: function(t) {
                var a, i = this,
                    r = e(t.currentTarget);
                r.hasClass("k-edit-item") && i._directoryBlur(), r.filter("[" + d.attr("type") + "=d]").length ? (a = i.dataSource.getByUid(r.attr(d.attr("uid"))), a && (i.path(o(i.path(), a.get(x))), i.breadcrumbs.value("/" + i.path()))) : r.filter("[" + d.attr("type") + "=f]").length && i.trigger(_)
            },
            _listViewChange: function() {
                var e = this._selectedItem();
                e && (this.toolbar.find(".k-i-close").parent().removeClass("k-state-disabled"), this.trigger(g, {
                    selected: e
                }))
            },
            _dataSource: function() {
                var e, t = this,
                    a = t.options,
                    o = a.transport,
                    i = f({}, B),
                    r = {
                        field: x,
                        dir: "asc"
                    },
                    n = {
                        type: o.type || "filebrowser",
                        sort: [i, r]
                    };
                u(o) && (o.path = p(t.path, t), n.transport = o), u(a.schema) ? n.schema = a.schema : o.type && u(d.data.schemas[o.type]) && (e = d.data.schemas[o.type]), t.dataSource && t._errorHandler ? t.dataSource.unbind(w, t._errorHandler) : t._errorHandler = p(t._error, t), t.dataSource = d.data.DataSource.create(n).bind(w, t._errorHandler)
            },
            _navigation: function() {
                var t = this,
                    a = e('<div class="k-floatwrap"><nav/><input/></div>').appendTo(this.element);
                t.breadcrumbs = a.find("nav:first").kendoBreadcrumb({
                    editable: !0,
                    gap: 50,
                    value: t.options.path || "/",
                    change: function() {
                        t.path(this.value())
                    }
                }).data("kendoBreadcrumb"), t.searchBox = a.parent().find("input:last").kendoSearchBox({
                    label: t.options.messages.search,
                    change: function() {
                        t.search(this.value())
                    }
                }).data("kendoSearchBox")
            },
            _error: function(e) {
                var t, a, o = this;
                o.trigger(w, e) || (t = e.xhr.status, "error" == e.status ? "404" == t ? o._showMessage(o.options.messages.directoryNotFound) : "0" != t && o._showMessage("Error! The requested URL returned " + t + " - " + e.xhr.statusText) : "timeout" == t && o._showMessage("Error! Server timeout."), a = o.dataSource, a.hasChanges() && a.cancelChanges())
            },
            _showMessage: function(e, t) {
                return window[t || "alert"](e)
            },
            refresh: function() {
                var e = this;
                e._navigation(), e._toolbar(), e._content()
            },
            _editTmpl: function() {
                var e = '<li class="k-tile k-state-selected" ' + d.attr("uid") + '="#=uid#" ';
                return e += d.attr("type") + '="${' + T + '}">', e += "#if(" + T + ' == "d") { #', e += '<div class="k-thumb"><span class="k-icon k-i-folder"></span></div>', e += "#}else{#", e += '<div class="k-thumb"><span class="k-icon k-i-loading"></span></div>', e += "#}#", e += "#if(" + T + ' == "d") { #', e += '<input class="k-input" ' + d.attr("bind") + '="value:' + x + '"/>', e += "#}#", e += "</li>", p(d.template(e), {
                    sizeFormatter: i
                })
            },
            _itemTmpl: function() {
                var e = '<li class="k-tile" ' + d.attr("uid") + '="#=uid#" ';
                return e += d.attr("type") + '="${' + T + '}">', e += "#if(" + T + ' == "d") { #', e += '<div class="k-thumb"><span class="k-icon k-i-folder"></span></div>', e += "#}else{#", e += '<div class="k-thumb"><span class="k-icon k-i-file"></span></div>', e += "#}#", e += "<strong>${" + x + "}</strong>", e += "#if(" + T + ' == "f") { # <span class="k-filesize">${this.sizeFormatter(' + F + ")}</span> #}#", e += "</li>", p(d.template(e), {
                    sizeFormatter: i
                })
            },
            path: function(e) {
                var a = this,
                    o = a._path || "";
                return e !== t ? (a._path = e.replace(k, "") + "/", a.dataSource.read({
                    path: a._path
                }), t) : (o && (o = o.replace(k, "")), "/" === o || "" === o ? "" : o + "/")
            }
        }), l = c.extend({
            init: function(e, t) {
                var a = this;
                t = t || {}, c.fn.init.call(a, e, t), h && a.element.attr("placeholder", a.options.label), a._wrapper(), a.element.on("keydown" + S, p(a._keydown, a)).on("change" + S, p(a._updateValue, a)), a.wrapper.on(b + S, "a", p(a._click, a)), h || a.element.on("focus" + S, p(a._focus, a)).on("blur" + S, p(a._blur, a))
            },
            options: {
                name: "SearchBox",
                label: "Search",
                value: ""
            },
            events: [g],
            destroy: function() {
                var e = this;
                e.wrapper.add(e.element).add(e.label).off(S), c.fn.destroy.call(e)
            },
            _keydown: function(e) {
                13 === e.keyCode && this._updateValue()
            },
            _click: function(e) {
                e.preventDefault(), this._updateValue()
            },
            _updateValue: function() {
                var e = this,
                    t = e.element.val();
                t !== e.value() && (e.value(t), e.trigger(g))
            },
            _blur: function() {
                this._updateValue(), this._toggleLabel()
            },
            _toggleLabel: function() {
                h || this.label.toggle(!this.element.val())
            },
            _focus: function() {
                this.label.hide()
            },
            _wrapper: function() {
                var t = this.element,
                    a = t.parents(".k-search-wrap");
                t[0].style.width = "", t.addClass("k-input"), a.length || (a = t.wrap(e('<div class="k-widget k-search-wrap k-textbox"/>')).parent(), h || e('<label style="display:block">' + this.options.label + "</label>").insertBefore(t), e('<a href="#" class="k-icon k-i-zoom k-search"/>').appendTo(a)), this.wrapper = a, this.label = a.find(">label")
            },
            value: function(e) {
                var a = this;
                return e !== t ? (a.options.value = e, a.element.val(e), a._toggleLabel(), t) : a.options.value
            }
        }), d.ui.plugin(s), d.ui.plugin(l)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, a) {
    (a || t)()
});;
! function(e, define) {
    define("kendo.imagebrowser.min", ["kendo.filebrowser.min"], e)
}(function() {
    return function(e, t) {
        function i(e, i) {
            return e !== t && e.match(/\/$/) || (e = (e || "") + "/"), e + i
        }

        function a(e) {
            if (!e) return "";
            var t = " bytes";
            return e >= 1073741824 ? (t = " GB", e /= 1073741824) : e >= 1048576 ? (t = " MB", e /= 1048576) : e >= 1024 && (t = " KB", e /= 1024), Math.round(100 * e) / 100 + t
        }
        var n, o, s = window.kendo,
            r = s.ui.FileBrowser,
            l = e.isPlainObject,
            d = e.proxy,
            p = e.extend,
            c = s.support.browser,
            u = s.isFunction,
            f = /(^\/|\/$)/g,
            m = "error",
            h = ".kendoImageBrowser",
            g = "name",
            _ = "size",
            v = "type",
            y = {
                field: v,
                dir: "asc"
            },
            k = s.template('<li class="k-tile-empty"><strong>${text}</strong></li>');
        p(!0, s.data, {
            schemas: {
                imagebrowser: {
                    data: function(e) {
                        return e.items || e || []
                    },
                    model: {
                        id: "name",
                        fields: {
                            name: "name",
                            size: "size",
                            type: "type"
                        }
                    }
                }
            }
        }), p(!0, s.data, {
            transports: {
                imagebrowser: s.data.RemoteTransport.extend({
                    init: function(t) {
                        s.data.RemoteTransport.fn.init.call(this, e.extend(!0, {}, this.options, t))
                    },
                    _call: function(t, i) {
                        i.data = e.extend({}, i.data, {
                            path: this.options.path()
                        }), u(this.options[t]) ? this.options[t].call(this, i) : s.data.RemoteTransport.fn[t].call(this, i)
                    },
                    read: function(e) {
                        this._call("read", e)
                    },
                    create: function(e) {
                        this._call("create", e)
                    },
                    destroy: function(e) {
                        this._call("destroy", e)
                    },
                    update: function() {},
                    options: {
                        read: {
                            type: "POST"
                        },
                        update: {
                            type: "POST"
                        },
                        create: {
                            type: "POST"
                        },
                        destroy: {
                            type: "POST"
                        }
                    }
                })
            }
        }), n = c.msie && c.version < 8 ? function(e) {
            return e.offsetTop
        } : function(t) {
            return t.offsetTop - e(t).height()
        }, o = r.extend({
            init: function(e, t) {
                var i = this;
                t = t || {}, r.fn.init.call(i, e, t), i.element.addClass("k-imagebrowser")
            },
            options: {
                name: "ImageBrowser",
                fileTypes: "*.png,*.gif,*.jpg,*.jpeg"
            },
            value: function() {
                var e, t = this,
                    a = t._selectedItem(),
                    n = t.options.transport.imageUrl;
                if (a && "f" === a.get(v)) return e = i(t.path(), a.get(g)).replace(f, ""), n && (e = u(n) ? n(e) : s.format(n, encodeURIComponent(e))), e
            },
            _fileUpload: function(e) {
                var i, a = this,
                    n = a.options,
                    o = n.fileTypes,
                    r = RegExp(("(" + o.split(",").join(")|(") + ")").replace(/\*\./g, ".*."), "i"),
                    l = e.files[0].name,
                    d = e.files[0].size,
                    p = g,
                    c = _;
                r.test(l) ? (e.data = {
                    path: a.path()
                }, i = a._createFile(l, d), i ? (i._uploading = !0, a.upload.one("error", function() {
                    i = t
                }), a.upload.one("success", function(e) {
                    if (i) {
                        delete i._uploading;
                        var t = a._insertFileToList(i);
                        t._override && (t.set(p, e.response[a._getFieldName(p)]), t.set(c, e.response[a._getFieldName(c)]), a.listView.dataSource.pushUpdate(t)), a._tiles = a.listView.items().filter("[" + s.attr("type") + "=f]"), a._scroll()
                    }
                })) : e.preventDefault()) : (e.preventDefault(), a._showMessage(s.format(n.messages.invalidFileType, l, o)))
            },
            _content: function() {
                var t = this;
                t.list = e('<ul class="k-reset k-floats k-tiles" />').appendTo(t.element).on("scroll" + h, d(t._scroll, t)).on("dblclick" + h, "li", d(t._dblClick, t)), t.listView = new s.ui.ListView(t.list, {
                    dataSource: t.dataSource,
                    template: t._itemTmpl(),
                    editTemplate: t._editTmpl(),
                    selectable: !0,
                    autoBind: !1,
                    dataBinding: function(e) {
                        t.toolbar.find(".k-i-close").parent().addClass("k-state-disabled"), "remove" !== e.action && "sync" !== e.action || (e.preventDefault(), s.ui.progress(t.listView.element, !1))
                    },
                    dataBound: function() {
                        t.dataSource.view().length ? (t._tiles = this.items().filter("[" + s.attr("type") + "=f]"), t._scroll()) : this.wrapper.append(k({
                            text: t.options.messages.emptyFolder
                        }))
                    },
                    change: d(t._listViewChange, t)
                })
            },
            _dataSource: function() {
                var e, t = this,
                    i = t.options,
                    a = i.transport,
                    n = p({}, y),
                    o = {
                        field: g,
                        dir: "asc"
                    },
                    r = {
                        type: a.type || "imagebrowser",
                        sort: [n, o]
                    };
                l(a) && (a.path = d(t.path, t), r.transport = a), l(i.schema) ? r.schema = i.schema : a.type && l(s.data.schemas[a.type]) && (e = s.data.schemas[a.type]), t.dataSource && t._errorHandler ? t.dataSource.unbind(m, t._errorHandler) : t._errorHandler = d(t._error, t), t.dataSource = s.data.DataSource.create(r).bind(m, t._errorHandler)
            },
            _loadImage: function(t) {
                var i = this,
                    a = e(t),
                    n = i.dataSource.getByUid(a.attr(s.attr("uid"))),
                    o = n.get(g),
                    r = i.options.transport.thumbnailUrl,
                    l = e("<img />", {
                        alt: o
                    }),
                    d = "?";
                n._uploading || (l.hide().on("load" + h, function() {
                    e(this).prev().remove().end().addClass("k-image").fadeIn()
                }), a.find(".k-i-loading").after(l), u(r) ? r = r(i.path(), encodeURIComponent(o)) : (r.indexOf("?") >= 0 && (d = "&"), r = r + d + "path=" + encodeURIComponent(i.path() + o), n._override && (r += "&_=" + (new Date).getTime(), delete n._override)), l.attr("src", r), t.loaded = !0)
            },
            _scroll: function() {
                var e = this;
                e.options.transport && e.options.transport.thumbnailUrl && (clearTimeout(e._timeout), e._timeout = setTimeout(function() {
                    var t = s._outerHeight(e.list),
                        i = e.list.scrollTop(),
                        a = i + t;
                    e._tiles.each(function() {
                        var t = n(this),
                            o = t + this.offsetHeight;
                        if ((t >= i && t < a || o >= i && o < a) && e._loadImage(this), t > a) return !1
                    }), e._tiles = e._tiles.filter(function() {
                        return !this.loaded
                    })
                }, 250))
            },
            _itemTmpl: function() {
                var e = this,
                    t = '<li class="k-tile" ' + s.attr("uid") + '="#=uid#" ';
                return t += s.attr("type") + '="${' + v + '}">', t += "#if(" + v + ' == "d") { #', t += '<div class="k-thumb"><span class="k-icon k-i-folder"></span></div>', t += "#}else{#", t += e.options.transport && e.options.transport.thumbnailUrl ? '<div class="k-thumb"><span class="k-icon k-i-loading"></span></div>' : '<div class="k-thumb"><span class="k-icon k-i-file"></span></div>', t += "#}#", t += "<strong>${" + g + "}</strong>", t += "#if(" + v + ' == "f") { # <span class="k-filesize">${this.sizeFormatter(' + _ + ")}</span> #}#", t += "</li>", d(s.template(t), {
                    sizeFormatter: a
                })
            }
        }), s.ui.plugin(o)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, i) {
    (i || t)()
});;
! function(i, define) {
    define("kendo.resizable.min", ["kendo.core.min", "kendo.draganddrop.min"], i)
}(function() {
    return function(i, t) {
        var n = window.kendo,
            o = n.ui,
            e = o.Widget,
            s = i.proxy,
            r = n.isFunction,
            a = i.extend,
            l = "horizontal",
            c = "vertical",
            d = "start",
            u = "resize",
            p = "resizeend",
            g = e.extend({
                init: function(i, t) {
                    var n = this;
                    e.fn.init.call(n, i, t), n.orientation = n.options.orientation.toLowerCase() != c ? l : c, n._positionMouse = n.orientation == l ? "x" : "y", n._position = n.orientation == l ? "left" : "top", n._sizingDom = n.orientation == l ? "outerWidth" : "outerHeight", n.draggable = new o.Draggable(t.draggableElement || i, {
                        distance: 1,
                        filter: t.handle,
                        drag: s(n._resize, n),
                        dragcancel: s(n._cancel, n),
                        dragstart: s(n._start, n),
                        dragend: s(n._stop, n)
                    }), n.userEvents = n.draggable.userEvents
                },
                events: [u, p, d],
                options: {
                    name: "Resizable",
                    orientation: l
                },
                resize: function() {},
                _max: function(i) {
                    var n = this,
                        o = n.hint ? n.hint[n._sizingDom]() : 0,
                        e = n.options.max;
                    return r(e) ? e(i) : e !== t ? n._initialElementPosition + e - o : e
                },
                _min: function(i) {
                    var n = this,
                        o = n.options.min;
                    return r(o) ? o(i) : o !== t ? n._initialElementPosition + o : o
                },
                _start: function(t) {
                    var n = this,
                        o = n.options.hint,
                        e = i(t.currentTarget);
                    n._initialElementPosition = e.position()[n._position], n._initialMousePosition = t[n._positionMouse].startLocation, o && (n.hint = r(o) ? i(o(e)) : o, n.hint.css({
                        position: "absolute"
                    }).css(n._position, n._initialElementPosition).appendTo(n.element)), n.trigger(d, t), n._maxPosition = n._max(t), n._minPosition = n._min(t), i(document.body).css("cursor", e.css("cursor"))
                },
                _resize: function(i) {
                    var n, o = this,
                        e = o._maxPosition,
                        s = o._minPosition,
                        r = o._initialElementPosition + (i[o._positionMouse].location - o._initialMousePosition);
                    n = s !== t ? Math.max(s, r) : r, o.position = n = e !== t ? Math.min(e, n) : n, o.hint && o.hint.toggleClass(o.options.invalidClass || "", n == e || n == s).css(o._position, n), o.resizing = !0, o.trigger(u, a(i, {
                        position: n
                    }))
                },
                _stop: function(t) {
                    var n = this;
                    n.hint && n.hint.remove(), n.resizing = !1, n.trigger(p, a(t, {
                        position: n.position
                    })), i(document.body).css("cursor", "")
                },
                _cancel: function(i) {
                    var n = this;
                    n.hint && (n.position = t, n.hint.css(n._position, n._initialElementPosition), n._stop(i))
                },
                destroy: function() {
                    var i = this;
                    e.fn.destroy.call(i), i.draggable && i.draggable.destroy()
                },
                press: function(i) {
                    if (i) {
                        var t = i.position(),
                            n = this;
                        n.userEvents.press(t.left, t.top, i[0]), n.targetPosition = t, n.target = i
                    }
                },
                move: function(i) {
                    var n = this,
                        o = n._position,
                        e = n.targetPosition,
                        s = n.position;
                    s === t && (s = e[o]), e[o] = s + i, n.userEvents.move(e.left, e.top)
                },
                end: function() {
                    this.userEvents.end(), this.target = this.position = t
                }
            });
        n.ui.plugin(g)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(i, t, n) {
    (n || t)()
});;
! function(t, define) {
    define("kendo.tabstrip.min", ["kendo.data.min"], t)
}(function() {
    return function(t, e) {
        function n(e) {
            e.children(_).addClass(S), e.children("a").addClass(y).children(_).addClass(S), e.filter(":not([disabled]):not([class*=k-state-disabled])").addClass(W), e.filter("li[disabled]").addClass(N).attr("aria-disabled", "true").removeAttr("disabled"), e.filter(":not([class*=k-state])").children("a").filter(":focus").parent().addClass(L + " " + z), e.attr("role", "tab"), e.filter("." + L).attr("aria-selected", !0), e.each(function() {
                var e = t(this);
                e.children("." + y).length || e.contents().filter(function() {
                    return !(this.nodeName.match(g) || 3 == this.nodeType && !d(this.nodeValue))
                }).wrapAll("<span UNSELECTABLE='on' class='" + y + "'/>")
            })
        }

        function r(t) {
            var e = t.children(".k-item");
            e.filter(".k-first:not(:first-child)").removeClass(E), e.filter(".k-last:not(:last-child)").removeClass(G), e.filter(":first-child").addClass(E), e.filter(":last-child").addClass(G)
        }

        function a(t, e) {
            return "<span class='k-button k-button-icon k-bare k-tabstrip-" + t + "' unselectable='on'><span class='k-icon " + e + "'></span></span>"
        }
        var i = window.kendo,
            s = i.ui,
            o = i.keys,
            l = t.map,
            c = t.each,
            d = t.trim,
            p = t.extend,
            u = i.isFunction,
            f = i.template,
            h = i._outerWidth,
            m = i._outerHeight,
            b = s.Widget,
            g = /^(a|div)$/i,
            v = ".kendoTabStrip",
            _ = "img",
            k = "href",
            w = "prev",
            C = "next",
            x = "show",
            y = "k-link",
            G = "k-last",
            U = "click",
            T = "error",
            A = ":empty",
            S = "k-image",
            E = "k-first",
            I = "select",
            P = "activate",
            B = "k-content",
            R = "contentUrl",
            D = "mouseenter",
            F = "mouseleave",
            H = "contentLoad",
            N = "k-state-disabled",
            W = "k-state-default",
            L = "k-state-active",
            q = "k-state-focused",
            M = "k-state-hover",
            z = "k-tab-on-top",
            O = ".k-item:not(." + N + ")",
            j = ".k-item",
            Q = ".k-tabstrip-items > " + O + ":not(." + L + ")",
            V = 200,
            X = {
                content: f("<div class='k-content'#= contentAttributes(data) # role='tabpanel'>#= content(item) #</div>"),
                itemWrapper: f("<#= tag(item) # class='k-link'#= contentUrl(item) ##= textAttributes(item) #>#= image(item) ##= sprite(item) ##= text(item) #</#= tag(item) #>"),
                item: f("<li class='#= wrapperCssClass(group, item) #' role='tab' #=item.active ? \"aria-selected='true'\" : ''#>#= itemWrapper(data) #</li>"),
                image: f("<img class='k-image' alt='' src='#= imageUrl #' />"),
                sprite: f("<span class='k-sprite #= spriteCssClass #'></span>"),
                empty: f("")
            },
            J = {
                wrapperCssClass: function(t, e) {
                    var n = "k-item",
                        r = e.index;
                    return n += e.enabled === !1 ? " k-state-disabled" : " k-state-default", 0 === r && (n += " k-first"), r == t.length - 1 && (n += " k-last"), n
                },
                textAttributes: function(t) {
                    return t.url ? " href='" + t.url + "'" : ""
                },
                text: function(t) {
                    return t.encoded === !1 ? t.text : i.htmlEncode(t.text)
                },
                tag: function(t) {
                    return t.url ? "a" : "span"
                },
                contentAttributes: function(t) {
                    return t.active !== !0 ? " style='display:none' aria-hidden='true' aria-expanded='false'" : ""
                },
                content: function(t) {
                    return t.content ? t.content : t.contentUrl ? "" : "&nbsp;"
                },
                contentUrl: function(t) {
                    return t.contentUrl ? i.attr("content-url") + '="' + t.contentUrl + '"' : ""
                }
            },
            $ = b.extend({
                init: function(e, n) {
                    var r, a, s, o = this;
                    b.fn.init.call(o, e, n), o._animations(o.options), n = o.options, o._contentUrls = n.contentUrls || [], o._wrapper(), o._isRtl = i.support.isRtl(o.wrapper), o._tabindex(), o._updateClasses(), o._dataSource(), n.dataSource && o.dataSource.fetch(), o._tabPosition(), o._scrollable(), o._contentUrls.length ? o.wrapper.find(".k-tabstrip-items > .k-item").each(function(e, n) {
                        var r = o._contentUrls[e];
                        "string" == typeof r && t(n).find(">." + y).data(R, r)
                    }) : o._contentUrls.length = o.tabGroup.find("li.k-item").length, o.wrapper.on(D + v + " " + F + v, Q, o._toggleHover).on("focus" + v, t.proxy(o._active, o)).on("blur" + v, function() {
                        o._current(null)
                    }), o._keyDownProxy = t.proxy(o._keydown, o), n.navigatable && o.wrapper.on("keydown" + v, o._keyDownProxy), o.options.value && (r = o.options.value), o.wrapper.children(".k-tabstrip-items").on(U + v, ".k-state-disabled .k-link", !1).on(U + v, " > " + O, function(e) {
                        var n, r = o.wrapper[0];
                        if (r !== document.activeElement)
                            if (n = i.support.browser.msie) try {
                                r.setActive()
                            } catch (a) {
                                r.focus()
                            } else r.focus();
                        o._click(t(e.currentTarget)) && e.preventDefault()
                    }), a = o.tabGroup.children("li." + L), s = o.contentHolder(a.index()), a[0] && s.length > 0 && 0 === s[0].childNodes.length && o.activateTab(a.eq(0)), o.element.attr("role", "tablist"), o.element[0].id && (o._ariaId = o.element[0].id + "_ts_active"), o.value(r), i.notify(o)
                },
                _active: function() {
                    var t = this.tabGroup.children().filter("." + L);
                    t = t[0] ? t : this._endItem("first"), t[0] && this._current(t)
                },
                _endItem: function(t) {
                    return this.tabGroup.children(O)[t]()
                },
                _getItem: function(t) {
                    return this.tabGroup.children(j)[t]()
                },
                _item: function(t, e) {
                    var n;
                    return n = e === w ? "last" : "first", t ? (t = t[e](), t[0] || (t = this.tabGroup.children(j)[n]()), t.hasClass(N) && t.addClass(q), (t.hasClass(N) || t.hasClass(L)) && (this._focused = t), t) : this._endItem(n)
                },
                _current: function(t) {
                    var n = this,
                        r = n._focused,
                        a = n._ariaId;
                    return t === e ? r : (r && (n.tabGroup.children("#" + a).removeAttr("id"), r.removeClass(q)), t && (t.hasClass(L) || t.addClass(q), n.element.removeAttr("aria-activedescendant"), a = t[0].id || a, a && (t.attr("id", a), n.element.attr("aria-activedescendant", a))), n._focused = t, e)
                },
                _keydown: function(t) {
                    var n, r = this,
                        a = t.keyCode,
                        i = r._current(),
                        s = r._isRtl,
                        l = /top|bottom/.test(r.options.tabPosition);
                    if (t.target == t.currentTarget && i) {
                        if (a !== o.DOWN || l)
                            if (a !== o.UP || l)
                                if (a === o.RIGHT && l) n = s ? w : C;
                                else if (a === o.LEFT && l) n = s ? C : w;
                        else if (a == o.ENTER || a == o.SPACEBAR) r._click(i), t.preventDefault();
                        else {
                            if (a == o.HOME) return r._click(r._getItem("first")), t.preventDefault(), e;
                            if (a == o.END) return r._click(r._getItem("last")), t.preventDefault(), e
                        } else n = w;
                        else n = C;
                        n && (r._click(r._item(i, n)), t.preventDefault())
                    }
                },
                _dataSource: function() {
                    var e = this;
                    e.dataSource && e._refreshHandler ? e.dataSource.unbind("change", e._refreshHandler) : e._refreshHandler = t.proxy(e.refresh, e), e.dataSource = i.data.DataSource.create(e.options.dataSource).bind("change", e._refreshHandler)
                },
                setDataSource: function(t) {
                    var e = this;
                    e.options.dataSource = t, e._dataSource(), e.dataSource.fetch()
                },
                _animations: function(t) {
                    t && "animation" in t && !t.animation && (t.animation = {
                        open: {
                            effects: {}
                        },
                        close: {
                            effects: {}
                        }
                    })
                },
                refresh: function(t) {
                    var e, n, r, a, s = this,
                        o = s.options,
                        l = i.getter(o.dataEncodedField),
                        c = i.getter(o.dataTextField),
                        d = i.getter(o.dataContentField),
                        p = i.getter(o.dataContentUrlField),
                        u = i.getter(o.dataImageUrlField),
                        f = i.getter(o.dataUrlField),
                        h = i.getter(o.dataSpriteCssClass),
                        m = [],
                        b = s.dataSource.view();
                    for (t = t || {}, r = t.action, r && (b = t.items), e = 0, a = b.length; e < a; e++) n = {
                        text: c(b[e])
                    }, o.dataEncodedField && (n.encoded = l(b[e])), o.dataContentField && (n.content = d(b[e])), o.dataContentUrlField && (n.contentUrl = p(b[e])), o.dataUrlField && (n.url = f(b[e])), o.dataImageUrlField && (n.imageUrl = u(b[e])), o.dataSpriteCssClass && (n.spriteCssClass = h(b[e])), m[e] = n;
                    if ("add" == t.action) t.index < s.tabGroup.children().length ? s.insertBefore(m, s.tabGroup.children().eq(t.index)) : s.append(m);
                    else if ("remove" == t.action)
                        for (e = 0; e < b.length; e++) s.remove(t.index);
                    else "itemchange" == t.action ? (e = s.dataSource.view().indexOf(b[0]), t.field === o.dataTextField && s.tabGroup.children().eq(e).find(".k-link").text(b[0].get(t.field)), t.field === o.dataUrlField && (s._contentUrls[e] = b[0].get(t.field))) : (s.trigger("dataBinding"), s.remove("li"), s._contentUrls = [], s.append(m), s.trigger("dataBound"))
                },
                value: function(n) {
                    var r = this;
                    return n === e ? r.select().text() : (n != r.value() && r.tabGroup.children().each(function() {
                        t.trim(t(this).text()) == n && r.select(this)
                    }), e)
                },
                items: function() {
                    return this.tabGroup[0].children
                },
                setOptions: function(t) {
                    var e = this,
                        n = e.options.animation;
                    e._animations(t), t.contentUrls && (e._contentUrls = t.contentUrls), t.animation = p(!0, n, t.animation), t.navigatable ? e.wrapper.on("keydown" + v, e._keyDownProxy) : e.wrapper.off("keydown" + v, e._keyDownProxy), b.fn.setOptions.call(e, t)
                },
                events: [I, P, x, T, H, "change", "dataBinding", "dataBound"],
                options: {
                    name: "TabStrip",
                    dataEncodedField: "",
                    dataTextField: "",
                    dataContentField: "",
                    dataImageUrlField: "",
                    dataUrlField: "",
                    dataSpriteCssClass: "",
                    dataContentUrlField: "",
                    tabPosition: "top",
                    animation: {
                        open: {
                            effects: "expand:vertical fadeIn",
                            duration: 200
                        },
                        close: {
                            duration: 200
                        }
                    },
                    collapsible: !1,
                    navigatable: !0,
                    contentUrls: !1,
                    scrollable: {
                        distance: V
                    }
                },
                destroy: function() {
                    var t = this,
                        e = t.scrollWrap;
                    b.fn.destroy.call(t), t._refreshHandler && t.dataSource.unbind("change", t._refreshHandler), t.wrapper.off(v), t.wrapper.children(".k-tabstrip-items").off(v), t._scrollableModeActive && (t._scrollPrevButton.off().remove(), t._scrollNextButton.off().remove()), i.destroy(t.wrapper), e.children(".k-tabstrip").unwrap()
                },
                select: function(e) {
                    var n = this;
                    return 0 === arguments.length ? n.tabGroup.children("li." + L) : (isNaN(e) || (e = n.tabGroup.children().get(e)), e = n.tabGroup.find(e), t(e).each(function(e, r) {
                        r = t(r), r.hasClass(L) || n.trigger(I, {
                            item: r[0],
                            contentElement: n.contentHolder(r.index())[0]
                        }) || n.activateTab(r)
                    }), n)
                },
                enable: function(t, e) {
                    return this._toggleDisabled(t, e !== !1), this
                },
                disable: function(t) {
                    return this._toggleDisabled(t, !1), this
                },
                reload: function(e) {
                    var n, r;
                    return e = this.tabGroup.find(e), n = this, r = n._contentUrls, e.each(function() {
                        var e = t(this),
                            a = e.find("." + y).data(R) || r[e.index()],
                            i = n.contentHolder(e.index());
                        a && n.ajaxRequest(e, i, null, a)
                    }), n
                },
                append: function(t) {
                    var e = this,
                        n = e._create(t);
                    return c(n.tabs, function(t) {
                        var r = n.contents[t];
                        e.tabGroup.append(this), "bottom" == e.options.tabPosition ? e.tabGroup.before(r) : e._scrollableModeActive ? e._scrollPrevButton.before(r) : e.wrapper.append(r), e.angular("compile", function() {
                            return {
                                elements: [r]
                            }
                        })
                    }), r(e.tabGroup), e._updateContentElements(), e.resize(!0), e
                },
                _appendUrlItem: function(t) {
                    this._contentUrls.push(t)
                },
                _moveUrlItem: function(t, e) {
                    this._contentUrls.splice(e, 0, this._contentUrls.splice(t, 1)[0])
                },
                _removeUrlItem: function(t) {
                    this._contentUrls.splice(t, 1)
                },
                insertBefore: function(e, n) {
                    n = t(e).is(t(n)) ? this.tabGroup.find(n).next() : this.tabGroup.find(n);
                    var a = this,
                        i = a._create(e),
                        s = a.element.find("[id='" + n.attr("aria-controls") + "']");
                    return c(i.tabs, function(e) {
                        var r = i.contents[e],
                            o = i.newTabsCreated ? a._contentUrls.length - (i.tabs.length - e) : t(r).index() - 1;
                        n.before(this), s.before(r), a._moveUrlItem(o, t(this).index()), a.angular("compile", function() {
                            return {
                                elements: [r]
                            }
                        })
                    }), r(a.tabGroup), a._updateContentElements(i.newTabsCreated), a.resize(!0), a
                },
                insertAfter: function(e, n) {
                    n = t(e).is(t(n)) ? this.tabGroup.find(n).prev() : this.tabGroup.find(n);
                    var a = this,
                        i = a._create(e),
                        s = a.element.find("[id='" + n.attr("aria-controls") + "']");
                    return c(i.tabs, function(e) {
                        var r = i.contents[e],
                            o = i.newTabsCreated ? a._contentUrls.length - (i.tabs.length - e) : t(r).index() - 1;
                        n.after(this), s.after(r), a._moveUrlItem(o, t(this).index()), a.angular("compile", function() {
                            return {
                                elements: [r]
                            }
                        })
                    }), r(a.tabGroup), a._updateContentElements(i.newTabsCreated), a.resize(!0), a
                },
                remove: function(e) {
                    var n, r = this,
                        a = typeof e;
                    return "string" === a ? e = r.tabGroup.find(e) : "number" === a && (e = r.tabGroup.children().eq(e)), n = e.map(function() {
                        var e = t(this).index(),
                            n = r.contentElement(e);
                        return i.destroy(n), r._removeUrlItem(e), n
                    }), e.remove(), n.empty(), n.remove(), r._updateContentElements(), r.resize(!0), r
                },
                _create: function(e) {
                    var r, a, s, o = this,
                        c = !1;
                    return e = e instanceof i.data.ObservableArray ? e.toJSON() : e, t.isPlainObject(e) || t.isArray(e) ? (e = t.isArray(e) ? e : [e], c = !0, r = l(e, function(n, r) {
                        return o._appendUrlItem(e[r].contentUrl || null), t($.renderItem({
                            group: o.tabGroup,
                            item: p(n, {
                                index: r
                            })
                        }))
                    }), a = l(e, function(e, n) {
                        if ("string" == typeof e.content || e.contentUrl) return t($.renderContent({
                            item: p(e, {
                                index: n
                            })
                        }))
                    })) : (r = "string" == typeof e && "<" != e[0] ? o.element.find(e) : t(e), a = t(), r.each(function() {
                        if (/k-tabstrip-items/.test(this.parentNode.className)) {
                            var e = o.element.find("[id='" + this.getAttribute("aria-controls") + "']");
                            s = e
                        } else s = t("<div class='" + B + "'/>");
                        a = a.add(s)
                    }), n(r)), {
                        tabs: r,
                        contents: a,
                        newTabsCreated: c
                    }
                },
                _toggleDisabled: function(e, n) {
                    e = this.tabGroup.find(e), e.each(function() {
                        t(this).toggleClass(W, n).toggleClass(N, !n).attr("aria-disabled", !n)
                    })
                },
                _updateClasses: function() {
                    var a, i, s, o = this;
                    o.wrapper.addClass("k-widget k-header k-tabstrip"), o.tabGroup = o.wrapper.children("ul").addClass("k-tabstrip-items k-reset"), o.tabGroup[0] || (o.tabGroup = t("<ul class='k-tabstrip-items k-reset'/>").appendTo(o.wrapper)), a = o.tabGroup.find("li").addClass("k-item"), a.length && (i = a.filter("." + L).index(), s = i >= 0 ? i : e, o.tabGroup.contents().filter(function() {
                        return 3 == this.nodeType && !d(this.nodeValue)
                    }).remove()), i >= 0 && a.eq(i).addClass(z), o.contentElements = o.wrapper.children("div"), o.contentElements.addClass(B).eq(s).addClass(L).css({
                        display: "block"
                    }), a.length && (n(a), r(o.tabGroup), o._updateContentElements(!0))
                },
                _elementId: function(t, e) {
                    var n, r = t.attr("id"),
                        a = this.element.attr("id");
                    return !r || r.indexOf(a + "-") > -1 ? (n = (a || i.guid()) + "-", n + (e + 1)) : r
                },
                _updateContentElements: function(e) {
                    var n = this,
                        r = n._contentUrls,
                        a = n.tabGroup.children(".k-item"),
                        s = n.wrapper.children("div"),
                        o = n._elementId.bind(n);
                    s.length && a.length > s.length ? s.each(function(n) {
                        var r = o(t(this), n),
                            i = a.filter("[aria-controls=" + (this.id || 0) + "]")[0];
                        !i && e && (i = a[n]), i && i.setAttribute("aria-controls", r), this.setAttribute("id", r)
                    }) : a.each(function(e) {
                        var a = s.eq(e),
                            i = o(a, e);
                        this.setAttribute("aria-controls", i), !a.length && r[e] ? t("<div class='" + B + "'/>").appendTo(n.wrapper).attr("id", i) : (a.attr("id", i), t(this).children(".k-loading")[0] || r[e] || t("<span class='k-loading k-complete'/>").prependTo(this)), a.attr("role", "tabpanel"), a.filter(":not(." + L + ")").attr("aria-hidden", !0).attr("aria-expanded", !1), a.filter("." + L).attr("aria-expanded", !0)
                    }), n.contentElements = n.contentAnimators = n.wrapper.children("div"), n.tabsHeight = m(n.tabGroup) + parseInt(n.wrapper.css("border-top-width"), 10) + parseInt(n.wrapper.css("border-bottom-width"), 10), i.kineticScrollNeeded && i.mobile.ui.Scroller && (i.touchScroller(n.contentElements), n.contentElements = n.contentElements.children(".km-scroll-container"))
                },
                _wrapper: function() {
                    var t = this;
                    t.wrapper = t.element.is("ul") ? t.element.wrapAll("<div />").parent() : t.element, t.scrollWrap = t.wrapper.parent(".k-tabstrip-wrapper"), t.scrollWrap[0] || (t.scrollWrap = t.wrapper.wrapAll("<div class='k-tabstrip-wrapper' />").parent())
                },
                _tabPosition: function() {
                    var t = this,
                        e = t.options.tabPosition;
                    t.wrapper.addClass("k-floatwrap k-tabstrip-" + e), "bottom" == e && t.tabGroup.appendTo(t.wrapper), t.resize(!0)
                },
                _setContentElementsDimensions: function() {
                    var t, e, n, r, a, i, s = this,
                        o = s.options.tabPosition;
                    "left" != o && "right" != o || (t = s.wrapper.children(".k-content"), e = t.filter(":visible"), n = "margin-" + o, r = s.tabGroup, a = h(r), i = Math.ceil(r.height()) - parseInt(e.css("padding-top"), 10) - parseInt(e.css("padding-bottom"), 10) - parseInt(e.css("border-top-width"), 10) - parseInt(e.css("border-bottom-width"), 10), setTimeout(function() {
                        t.css(n, a).css("min-height", i)
                    }))
                },
                _resize: function() {
                    this._setContentElementsDimensions(), this._scrollable()
                },
                _sizeScrollWrap: function(t) {
                    var e, n;
                    t.is(":visible") && (e = this.options.tabPosition, n = Math.floor(m(t, !0)) + ("left" === e || "right" === e ? 2 : this.tabsHeight), this.scrollWrap.css("height", n).css("height"))
                },
                _toggleHover: function(e) {
                    t(e.currentTarget).toggleClass(M, e.type == D)
                },
                _click: function(t) {
                    var e, n, r = this,
                        a = t.find("." + y),
                        i = a.attr(k),
                        s = r.options.collapsible,
                        o = t.index(),
                        l = r.contentHolder(o),
                        c = t.parent().children(),
                        d = c.filter("." + q);
                    if (t.closest(".k-widget")[0] == r.wrapper[0]) {
                        if (t.is("." + N + (s ? "" : ",." + L))) return d.removeClass(q), r._focused = t, t.addClass(q), r._current(t), r._scrollableModeActive && r._scrollTabsToItem(t), !0;
                        if (n = a.data(R) || r._contentUrls[o] || i && ("#" == i.charAt(i.length - 1) || i.indexOf("#" + r.element[0].id + "-") != -1), e = !i || n, r.tabGroup.children("[data-animating]").length) return e;
                        if (r.trigger(I, {
                                item: t[0],
                                contentElement: l[0]
                            })) return !0;
                        if (e !== !1) return s && t.is("." + L) ? (r.deactivateTab(t), !0) : (r.activateTab(t) && (e = !0), e)
                    }
                },
                _scrollable: function() {
                    var t, e, n, r, s, o, l, c, d = this,
                        p = d.options;
                    d._scrollableAllowed() && (d.wrapper.addClass("k-tabstrip-scrollable"), t = d.wrapper[0].offsetWidth, e = d.tabGroup[0].scrollWidth, e > t && !d._scrollableModeActive ? (d._nowScrollingTabs = !1, d._isRtl = i.support.isRtl(d.element), s = i.support.mobileOS ? "touchstart" : "mousedown", o = i.support.mobileOS ? "touchend" : "mouseup", l = i.support.browser, c = d._isRtl && !l.msie && !l.edge, d.wrapper.append(a("prev", "k-i-arrow-60-left") + a("next", "k-i-arrow-60-right")), n = d._scrollPrevButton = d.wrapper.children(".k-tabstrip-prev"), r = d._scrollNextButton = d.wrapper.children(".k-tabstrip-next"), d.tabGroup.css({
                        marginLeft: h(n) + 9,
                        marginRight: h(r) + 12
                    }), n.on(s + v, function() {
                        d._nowScrollingTabs = !0, d._scrollTabsByDelta(p.scrollable.distance * (c ? 1 : -1))
                    }), r.on(s + v, function() {
                        d._nowScrollingTabs = !0, d._scrollTabsByDelta(p.scrollable.distance * (c ? -1 : 1))
                    }), n.add(r).on(o + v, function() {
                        d._nowScrollingTabs = !1
                    }), d._scrollableModeActive = !0, d._toggleScrollButtons()) : d._scrollableModeActive && e <= t ? (d._scrollableModeActive = !1, d.wrapper.removeClass("k-tabstrip-scrollable"), d._scrollPrevButton.off().remove(), d._scrollNextButton.off().remove(), d.tabGroup.css({
                        marginLeft: "",
                        marginRight: ""
                    })) : d._scrollableModeActive ? d._toggleScrollButtons() : d.wrapper.removeClass("k-tabstrip-scrollable"))
                },
                _scrollableAllowed: function() {
                    var t = this.options;
                    return t.scrollable && !t.scrollable.distance && (t.scrollable = {
                        distance: V
                    }), t.scrollable && !isNaN(t.scrollable.distance) && ("top" == t.tabPosition || "bottom" == t.tabPosition)
                },
                _scrollTabsToItem: function(t) {
                    var e, n = this,
                        r = n.tabGroup,
                        a = r.scrollLeft(),
                        i = h(t),
                        s = n._isRtl ? t.position().left : t.position().left - r.children().first().position().left,
                        o = r[0].offsetWidth,
                        l = Math.ceil(parseFloat(r.css("padding-left")));
                    n._isRtl ? s < 0 ? e = a + s - (o - a) - l : s + i > o && (e = a + s - i + 2 * l) : a + o < s + i ? e = s + i - o + 2 * l : a > s && (e = s - l), r.finish().animate({
                        scrollLeft: e
                    }, "fast", "linear", function() {
                        n._toggleScrollButtons()
                    })
                },
                _scrollTabsByDelta: function(t) {
                    var e = this,
                        n = e.tabGroup,
                        r = n.scrollLeft();
                    n.finish().animate({
                        scrollLeft: r + t
                    }, "fast", "linear", function() {
                        e._nowScrollingTabs && !jQuery.fx.off ? e._scrollTabsByDelta(t) : e._toggleScrollButtons()
                    })
                },
                _toggleScrollButtons: function() {
                    var t = this,
                        e = t.tabGroup,
                        n = i.scrollLeft(e);
                    t._scrollPrevButton.toggle(0 !== n), t._scrollNextButton.toggle(n < e[0].scrollWidth - e[0].offsetWidth - 1)
                },
                deactivateTab: function(t) {
                    var e = this,
                        n = e.options.animation,
                        r = n.open,
                        a = p({}, n.close),
                        s = a && "effects" in a;
                    t = e.tabGroup.find(t), a = p(s ? a : p({
                        reverse: !0
                    }, r), {
                        hide: !0
                    }), i.size(r.effects) ? (t.kendoAddClass(W, {
                        duration: r.duration
                    }), t.kendoRemoveClass(L, {
                        duration: r.duration
                    })) : (t.addClass(W), t.removeClass(L)), t.removeAttr("aria-selected"), e.contentAnimators.filter("." + L).kendoStop(!0, !0).kendoAnimate(a).removeClass(L).attr("aria-hidden", !0)
                },
                activateTab: function(t) {
                    var e, n, r, a, s, o, l, c, d, u, f, h, b, g, v, _;
                    if (!this.tabGroup.children("[data-animating]").length) return t = this.tabGroup.find(t), e = this, n = e.options.animation, r = n.open, a = p({}, n.close), s = a && "effects" in a, o = t.parent().children(), l = o.filter("." + L), c = o.index(t), d = r && "duration" in r && "effects" in r, a = p(s ? a : p({
                        reverse: !0
                    }, r), {
                        hide: !0
                    }), i.size(r.effects) ? (l.kendoRemoveClass(L, {
                        duration: a.duration
                    }), t.kendoRemoveClass(M, {
                        duration: a.duration
                    })) : (l.removeClass(L), t.removeClass(M)), u = e.contentAnimators, e.inRequest && (e.xhr.abort(), e.inRequest = !1), 0 === u.length ? (e.tabGroup.find("." + z).removeClass(z), t.addClass(z).css("z-index"), t.addClass(L), e._current(t), e.trigger("change"), e._scrollableModeActive && e._scrollTabsToItem(t), !1) : (f = u.filter("." + L), h = e.contentHolder(c), b = h.closest(".k-content"), e.tabsHeight = m(e.tabGroup) + parseInt(e.wrapper.css("border-top-width"), 10) + parseInt(e.wrapper.css("border-bottom-width"), 10), e._sizeScrollWrap(f), 0 === h.length ? (f.removeClass(L).attr("aria-hidden", !0).kendoStop(!0, !0).kendoAnimate(a), !1) : (t.attr("data-animating", !0), g = (t.children("." + y).data(R) || e._contentUrls[c] || !1) && h.is(A), v = function() {
                        l.removeAttr("aria-selected"), t.attr("aria-selected", !0), e._current(t), e._sizeScrollWrap(b), b.addClass(L).removeAttr("aria-hidden").kendoStop(!0, !0).attr("aria-expanded", !0).kendoAnimate(p({
                            init: function() {
                                e.trigger(x, {
                                    item: t[0],
                                    contentElement: h[0]
                                }), i.resize(h)
                            }
                        }, r, {
                            complete: function() {
                                t.removeAttr("data-animating"), e.trigger(P, {
                                    item: t[0],
                                    contentElement: h[0]
                                }), i.resize(h), e.scrollWrap.css("height", "").css("height"), d && (i.support.browser.msie || i.support.browser.edge) && h.finish().animate({
                                    opacity: .9
                                }, "fast", "linear", function() {
                                    h.finish().animate({
                                        opacity: 1
                                    }, "fast", "linear")
                                })
                            }
                        }))
                    }, _ = function() {
                        g ? (t.removeAttr("data-animating"), e.ajaxRequest(t, h, function() {
                            t.attr("data-animating", !0), v(), e.trigger("change")
                        })) : (v(), e.trigger("change")), e._scrollableModeActive && e._scrollTabsToItem(t)
                    }, f.removeClass(L), e.tabGroup.find("." + z).removeClass(z), t.addClass(z).css("z-index"), i.size(r.effects) ? (l.kendoAddClass(W, {
                        duration: r.duration
                    }), t.kendoAddClass(L, {
                        duration: r.duration
                    })) : (l.addClass(W), t.addClass(L)), f.attr("aria-hidden", !0), f.attr("aria-expanded", !1), f.length ? f.kendoStop(!0, !0).kendoAnimate(p({
                        complete: _
                    }, a)) : _(), !0))
                },
                contentElement: function(n) {
                    var r, a, s, o;
                    if (isNaN(n - 0)) return e;
                    if (r = this.contentElements && this.contentElements[0] && !i.kineticScrollNeeded ? this.contentElements : this.contentAnimators, a = t(this.tabGroup.children()[n]).attr("aria-controls"), r)
                        for (s = 0, o = r.length; s < o; s++)
                            if (r.eq(s).closest(".k-content")[0].id == a) return r[s];
                    return e
                },
                contentHolder: function(e) {
                    var n = t(this.contentElement(e)),
                        r = n.children(".km-scroll-container");
                    return i.support.touch && r[0] ? r : n
                },
                ajaxRequest: function(e, n, r, a) {
                    var s, o, l, c, d, p, f, h, m, b;
                    e = this.tabGroup.find(e), s = this, o = t.ajaxSettings.xhr, l = e.find("." + y), c = {}, d = e.width() / 2, p = !1, f = e.find(".k-loading").removeClass("k-complete"), f[0] || (f = t("<span class='k-loading'/>").prependTo(e)), h = 2 * d - f.width(), m = function() {
                        f.animate({
                            marginLeft: (parseInt(f.css("marginLeft"), 10) || 0) < d ? h : 0
                        }, 500, m)
                    }, i.support.browser.msie && i.support.browser.version < 10 && setTimeout(m, 40), a = a || l.data(R) || s._contentUrls[e.index()] || l.attr(k), s.inRequest = !0, b = {
                        type: "GET",
                        cache: !1,
                        url: a,
                        dataType: "html",
                        data: c,
                        xhr: function() {
                            var e = this,
                                n = o(),
                                r = e.progressUpload ? "progressUpload" : !!e.progress && "progress";
                            return n && t.each([n, n.upload], function() {
                                this.addEventListener && this.addEventListener("progress", function(t) {
                                    r && e[r](t)
                                }, !1)
                            }), e.noProgress = !(window.XMLHttpRequest && "upload" in new XMLHttpRequest), n
                        },
                        progress: function(t) {
                            if (t.lengthComputable) {
                                var e = parseInt(t.loaded / t.total * 100, 10) + "%";
                                f.stop(!0).addClass("k-progress").css({
                                    width: e,
                                    marginLeft: 0
                                })
                            }
                        },
                        error: function(t, e) {
                            s.trigger("error", {
                                xhr: t,
                                status: e
                            }) && this.complete()
                        },
                        stopProgress: function() {
                            clearInterval(p), f.stop(!0).addClass("k-progress")[0].style.cssText = ""
                        },
                        complete: function(t) {
                            s.inRequest = !1, this.noProgress ? setTimeout(this.stopProgress, 500) : this.stopProgress(), "abort" == t.statusText && f.remove()
                        },
                        success: function(t) {
                            var o, l, c;
                            f.addClass("k-complete");
                            try {
                                o = this, l = 10, o.noProgress && (f.width(l + "%"), p = setInterval(function() {
                                    o.progress({
                                        lengthComputable: !0,
                                        loaded: Math.min(l, 100),
                                        total: 100
                                    }), l += 10
                                }, 40)), s.angular("cleanup", function() {
                                    return {
                                        elements: n.get()
                                    }
                                }), i.destroy(n), n.html(t)
                            } catch (d) {
                                c = window.console, c && c.error && c.error(d.name + ": " + d.message + " in " + a), this.error(this.xhr, "error")
                            }
                            r && r.call(s, n), s.angular("compile", function() {
                                return {
                                    elements: n.get()
                                }
                            }), s.trigger(H, {
                                item: e[0],
                                contentElement: n[0]
                            })
                        }
                    }, "object" == typeof a && (b = t.extend(!0, {}, b, a), u(b.url) && (b.url = b.url())), s.xhr = t.ajax(b)
                }
            });
        p($, {
            renderItem: function(t) {
                t = p({
                    tabStrip: {},
                    group: {}
                }, t);
                var e = X.empty,
                    n = t.item;
                return X.item(p(t, {
                    image: n.imageUrl ? X.image : e,
                    sprite: n.spriteCssClass ? X.sprite : e,
                    itemWrapper: X.itemWrapper
                }, J))
            },
            renderContent: function(t) {
                return X.content(p(t, J))
            }
        }), i.ui.plugin($)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, n) {
    (n || e)()
});;
! function(e, define) {
    define("kendo.numerictextbox.min", ["kendo.core.min", "kendo.userevents.min"], e)
}(function() {
    return function(e, t) {
        function n(e, t) {
            var n = "k-i-arrow-" + ("increase" === e ? "60-up" : "60-down");
            return '<span unselectable="on" class="k-link k-link-' + e + '" aria-label="' + t + '" title="' + t + '"><span unselectable="on" class="' + H + " " + n + '"></span></span>'
        }

        function a(e, t) {
            var n = ("" + parseFloat(e, 10)).split(E);
            return n[1] && (n[1] = n[1].substring(0, t)), n.join(E)
        }
        var r = window.kendo,
            o = r.caret,
            i = r.keys,
            s = r.ui,
            l = s.Widget,
            u = r._activeElement,
            p = r._extractFormat,
            d = r.parseFloat,
            c = r.support.placeholder,
            _ = r.getCulture,
            f = "change",
            m = "disabled",
            v = "readonly",
            x = "k-input",
            g = "spin",
            h = ".kendoNumericTextBox",
            w = "touchend",
            y = "mouseleave" + h,
            k = "mouseenter" + h + " " + y,
            b = "k-state-default",
            A = "k-state-focused",
            C = "k-state-hover",
            T = "focus",
            E = ".",
            H = "k-icon",
            W = "k-state-selected",
            O = "k-state-disabled",
            D = "k-state-invalid",
            I = "aria-disabled",
            R = /^(-)?(\d*)$/,
            F = null,
            S = e.proxy,
            N = e.extend,
            j = l.extend({
                init: function(n, a) {
                    var o, i, s, u, d, c, _ = this,
                        f = a && a.step !== t;
                    l.fn.init.call(_, n, a), a = _.options, n = _.element.on("focusout" + h, S(_._focusout, _)).attr("role", "spinbutton"), a.placeholder = a.placeholder || n.attr("placeholder"), o = _.min(n.attr("min")), i = _.max(n.attr("max")), s = _._parse(n.attr("step")), a.min === F && o !== F && (a.min = o), a.max === F && i !== F && (a.max = i), f || s === F || (a.step = s), _._initialOptions = N({}, a), c = n.attr("type"), _._reset(), _._wrapper(), _._arrows(), _._validation(), _._input(), r.support.mobileOS ? _._text.on(w + h + " " + T + h, function() {
                        r.support.browser.edge ? _._text.one(T + h, function() {
                            _._toggleText(!1), n.focus()
                        }) : (_._toggleText(!1), n.focus())
                    }) : _._text.on(T + h, S(_._click, _)), n.attr("aria-valuemin", a.min !== F ? a.min * a.factor : a.min).attr("aria-valuemax", a.max !== F ? a.max * a.factor : a.max), a.format = p(a.format), u = a.value, u == F && (u = "number" == c ? parseFloat(n.val()) : n.val()), _.value(u), d = n.is("[disabled]") || e(_.element).parents("fieldset").is(":disabled"), d ? _.enable(!1) : _.readonly(n.is("[readonly]")), _.angular("compile", function() {
                        return {
                            elements: _._text.get()
                        }
                    }), r.notify(_)
                },
                options: {
                    name: "NumericTextBox",
                    decimals: F,
                    restrictDecimals: !1,
                    min: F,
                    max: F,
                    value: F,
                    step: 1,
                    round: !0,
                    culture: "",
                    format: "n",
                    spinners: !0,
                    placeholder: "",
                    factor: 1,
                    upArrowText: "Increase value",
                    downArrowText: "Decrease value"
                },
                events: [f, g],
                _editable: function(e) {
                    var t = this,
                        n = t.element,
                        a = e.disable,
                        r = e.readonly,
                        o = t._text.add(n),
                        i = t._inputWrapper.off(k);
                    t._toggleText(!0), t._upArrowEventHandler.unbind("press"), t._downArrowEventHandler.unbind("press"), n.off("keydown" + h).off("keypress" + h).off("keyup" + h).off("paste" + h), r || a ? (i.addClass(a ? O : b).removeClass(a ? b : O), o.attr(m, a).attr(v, r).attr(I, a)) : (i.addClass(b).removeClass(O).on(k, t._toggleHover), o.removeAttr(m).removeAttr(v).attr(I, !1), t._upArrowEventHandler.bind("press", function(e) {
                        e.preventDefault(), t._spin(1), t._upArrow.addClass(W)
                    }), t._downArrowEventHandler.bind("press", function(e) {
                        e.preventDefault(), t._spin(-1), t._downArrow.addClass(W)
                    }), t.element.on("keydown" + h, S(t._keydown, t)).on("keypress" + h, S(t._keypress, t)).on("keyup" + h, S(t._keyup, t)).on("paste" + h, S(t._paste, t)))
                },
                readonly: function(e) {
                    this._editable({
                        readonly: e === t || e,
                        disable: !1
                    })
                },
                enable: function(e) {
                    this._editable({
                        readonly: !1,
                        disable: !(e = e === t || e)
                    })
                },
                setOptions: function(e) {
                    var n = this;
                    l.fn.setOptions.call(n, e), n._arrowsWrap.toggle(n.options.spinners), n._inputWrapper.toggleClass("k-expand-padding", !n.options.spinners), n._text.prop("placeholder", n.options.placeholder), n._placeholder(n.options.placeholder), n.element.attr({
                        "aria-valuemin": n.options.min !== F ? n.options.min * n.options.factor : n.options.min,
                        "aria-valuemax": n.options.max !== F ? n.options.max * n.options.factor : n.options.max
                    }), n.options.format = p(n.options.format), e.value !== t && n.value(e.value)
                },
                destroy: function() {
                    var e = this;
                    e.element.add(e._text).add(e._upArrow).add(e._downArrow).add(e._inputWrapper).off(h), e._upArrowEventHandler.destroy(), e._downArrowEventHandler.destroy(), e._form && e._form.off("reset", e._resetHandler), l.fn.destroy.call(e)
                },
                min: function(e) {
                    return this._option("min", e)
                },
                max: function(e) {
                    return this._option("max", e)
                },
                step: function(e) {
                    return this._option("step", e)
                },
                value: function(e) {
                    var n, a = this;
                    return e === t ? a._value : (e = a._parse(e), n = a._adjust(e), e === n && (a._update(e), a._old = a._value), t)
                },
                focus: function() {
                    this._focusin()
                },
                _adjust: function(e) {
                    var t = this,
                        n = t.options,
                        a = n.min,
                        r = n.max;
                    return e === F ? e : (a !== F && e < a ? e = a : r !== F && e > r && (e = r), e)
                },
                _arrows: function() {
                    var t, a = this,
                        o = function() {
                            clearTimeout(a._spinning), t.removeClass(W)
                        },
                        i = a.options,
                        s = i.spinners,
                        l = a.element;
                    t = l.siblings("." + H), t[0] || (t = e(n("increase", i.upArrowText) + n("decrease", i.downArrowText)).insertAfter(l), a._arrowsWrap = t.wrapAll('<span class="k-select"/>').parent()), s || (t.parent().toggle(s), a._inputWrapper.addClass("k-expand-padding")), a._upArrow = t.eq(0), a._upArrowEventHandler = new r.UserEvents(a._upArrow, {
                        release: o
                    }), a._downArrow = t.eq(1), a._downArrowEventHandler = new r.UserEvents(a._downArrow, {
                        release: o
                    })
                },
                _validation: function() {
                    var t = this,
                        n = t.element;
                    t._validationIcon = e("<span class='" + H + " k-i-warning'></span>").hide().insertAfter(n)
                },
                _blur: function() {
                    var e = this;
                    e._toggleText(!0), e._change(e.element.val())
                },
                _click: function(e) {
                    var t = this;
                    clearTimeout(t._focusing), t._focusing = setTimeout(function() {
                        var n, a, r, i = e.target,
                            s = o(i)[0],
                            l = i.value.substring(0, s),
                            u = t._format(t.options.format),
                            p = u[","],
                            d = 0;
                        p && (a = RegExp("\\" + p, "g"), r = RegExp("(^(-)$)|(^(-)?([\\d\\" + p + "]+)(\\" + u[E] + ")?(\\d+)?)")), r && (n = r.exec(l)), n && (d = n[0].replace(a, "").length, l.indexOf("(") != -1 && t._value < 0 && d++), t._focusin(), o(t.element[0], d)
                    })
                },
                _change: function(e) {
                    var t = this,
                        n = t.options.factor;
                    n && 1 !== n && (e = r.parseFloat(e), null !== e && (e /= n)), t._update(e), e = t._value, t._old != e && (t._old = e, t._typing || t.element.trigger(f), t.trigger(f)), t._typing = !1
                },
                _culture: function(e) {
                    return e || _(this.options.culture)
                },
                _focusin: function() {
                    var e = this;
                    e._inputWrapper.addClass(A), e._toggleText(!1), e.element[0].focus()
                },
                _focusout: function() {
                    var e = this;
                    clearTimeout(e._focusing), e._inputWrapper.removeClass(A).removeClass(C), e._blur(), e._removeInvalidState()
                },
                _format: function(e, t) {
                    var n = this._culture(t).numberFormat;
                    return e = e.toLowerCase(), e.indexOf("c") > -1 ? n = n.currency : e.indexOf("p") > -1 && (n = n.percent), n
                },
                _input: function() {
                    var t, n = this,
                        a = n.options,
                        r = "k-formatted-value",
                        o = n.element.addClass(x).show()[0],
                        i = o.accessKey,
                        s = n.wrapper;
                    t = s.find(E + r), t[0] || (t = e('<input type="text"/>').insertBefore(o).addClass(r));
                    try {
                        o.setAttribute("type", "text")
                    } catch (l) {
                        o.type = "text"
                    }
                    t[0].title = o.title, t[0].tabIndex = o.tabIndex, t[0].style.cssText = o.style.cssText, t.prop("placeholder", a.placeholder), i && (t.attr("accesskey", i), o.accessKey = ""), n._text = t.addClass(o.className).attr({
                        role: "spinbutton",
                        "aria-valuemin": a.min !== F ? a.min * a.factor : a.min,
                        "aria-valuemax": a.max !== F ? a.max * a.factor : a.max,
                        autocomplete: "off"
                    })
                },
                _keydown: function(e) {
                    var t = this,
                        n = e.keyCode;
                    t._key = n, n == i.DOWN ? t._step(-1) : n == i.UP ? t._step(1) : n == i.ENTER ? t._change(t.element.val()) : n != i.TAB && (t._typing = !0)
                },
                _keypress: function(e) {
                    var t, n, a, r, s, l, u, p, d, c, _;
                    0 === e.which || e.metaKey || e.ctrlKey || e.keyCode === i.BACKSPACE || e.keyCode === i.ENTER || (t = this, n = t.options.min, a = t.element, r = o(a), s = r[0], l = r[1], u = String.fromCharCode(e.which), p = t._format(t.options.format), d = t._key === i.NUMPAD_DOT, c = a.val(), d && (u = p[E]), c = c.substring(0, s) + u + c.substring(l), _ = t._numericRegex(p).test(c), _ && d ? (a.val(c), o(a, s + u.length), e.preventDefault()) : (null !== n && n >= 0 && "-" === c.charAt(0) || !_) && (t._addInvalidState(), e.preventDefault()), t._key = 0)
                },
                _keyup: function() {
                    this._removeInvalidState()
                },
                _addInvalidState: function() {
                    var e = this;
                    e._inputWrapper.addClass(D), e._validationIcon.show()
                },
                _removeInvalidState: function() {
                    var e = this;
                    e._inputWrapper.removeClass(D), e._validationIcon.hide()
                },
                _numericRegex: function(e) {
                    var t = this,
                        n = e[E],
                        a = t.options.decimals,
                        r = "*";
                    return n === E && (n = "\\" + n), a === F && (a = e.decimals), 0 === a && t.options.restrictDecimals ? R : (t.options.restrictDecimals && (r = "{0," + a + "}"), t._separator !== n && (t._separator = n, t._floatRegExp = RegExp("^(-)?(((\\d+(" + n + "\\d" + r + ")?)|(" + n + "\\d" + r + ")))?$")), t._floatRegExp)
                },
                _paste: function(e) {
                    var t = this,
                        n = e.target,
                        a = n.value,
                        r = t._format(t.options.format);
                    setTimeout(function() {
                        var e = t._parse(n.value);
                        e === F ? t._update(a) : (n.value = ("" + e).replace(E, r[E]), t._adjust(e) === e && t._numericRegex(r).test(n.value) || t._update(a))
                    })
                },
                _option: function(e, n) {
                    var a = this,
                        r = a.element,
                        o = a.options;
                    return n === t ? o[e] : (n = a._parse(n), (n || "step" !== e) && (o[e] = n, r.add(a._text).attr("aria-value" + e, n), r.attr(e, n)), t)
                },
                _spin: function(e, t) {
                    var n = this;
                    t = t || 500, clearTimeout(n._spinning), n._spinning = setTimeout(function() {
                        n._spin(e, 50)
                    }, t), n._step(e)
                },
                _step: function(e) {
                    var t = this,
                        n = t.element,
                        a = t._value,
                        r = t._parse(n.val()) || 0,
                        o = t.options.decimals || 2;
                    u() != n[0] && t._focusin(), t.options.factor && r && (r /= t.options.factor), r = +(r + t.options.step * e).toFixed(o), r = t._adjust(r), t._update(r), t._typing = !1, a !== r && t.trigger(g)
                },
                _toggleHover: function(t) {
                    e(t.currentTarget).toggleClass(C, "mouseenter" === t.type)
                },
                _toggleText: function(e) {
                    var t = this;
                    t._text.toggle(e), t.element.toggle(!e)
                },
                _parse: function(e, t) {
                    return d(e, this._culture(t), this.options.format)
                },
                _round: function(e, t) {
                    var n = this.options.round ? r._round : a;
                    return n(e, t)
                },
                _update: function(e) {
                    var t, n = this,
                        a = n.options,
                        o = a.factor,
                        i = a.format,
                        s = a.decimals,
                        l = n._culture(),
                        u = n._format(i, l);
                    s === F && (s = u.decimals), e = n._parse(e, l), t = e !== F, t && (e = parseFloat(n._round(e, s), 10)), n._value = e = n._adjust(e), n._placeholder(r.toString(e, i, l)), t ? (o && (e = parseFloat(n._round(e * o, s), 10)), e = "" + e, e.indexOf("e") !== -1 && (e = n._round(+e, s)), e = e.replace(E, u[E])) : e = null, n.element.val(e), n.element.add(n._text).attr("aria-valuenow", e)
                },
                _placeholder: function(e) {
                    var t = this._text;
                    t.val(e), c || e || t.val(this.options.placeholder), t.attr("title", this.element.attr("title") || t.val())
                },
                _wrapper: function() {
                    var t, n = this,
                        a = n.element,
                        r = a[0];
                    t = a.parents(".k-numerictextbox"), t.is("span.k-numerictextbox") || (t = a.hide().wrap('<span class="k-numeric-wrap k-state-default" />').parent(), t = t.wrap("<span/>").parent()), t[0].style.cssText = r.style.cssText, r.style.width = "", n.wrapper = t.addClass("k-widget k-numerictextbox").addClass(r.className).css("display", ""), n._inputWrapper = e(t[0].firstChild)
                },
                _reset: function() {
                    var t = this,
                        n = t.element,
                        a = n.attr("form"),
                        r = a ? e("#" + a) : n.closest("form");
                    r[0] && (t._resetHandler = function() {
                        setTimeout(function() {
                            t.value(n[0].value), t.max(t._initialOptions.max), t.min(t._initialOptions.min)
                        })
                    }, t._form = r.on("reset", t._resetHandler))
                }
            });
        s.plugin(j)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(t, define) {
    define("kendo.window.min", ["kendo.draganddrop.min", "kendo.popup.min"], t)
}(function() {
    return function(t, i) {
        function e(t) {
            return i !== t
        }

        function n(t, i) {
            return parseInt(t.css(i), 10) || 0
        }

        function o(t, i, e) {
            var n;
            return n = t && isNaN(t) && ("" + t).indexOf("px") < 0 ? t : Math.max(Math.min(parseInt(t, 10), e === 1 / 0 ? e : parseInt(e, 10)), i === -(1 / 0) ? i : parseInt(i, 10))
        }

        function s() {
            return !this.type || this.type.toLowerCase().indexOf("script") >= 0
        }

        function r(i) {
            for (var e, n, o = {
                    top: i.offsetTop,
                    left: i.offsetLeft
                }, s = i.offsetParent; s;) o.top += s.offsetTop, o.left += s.offsetLeft, e = t(s).css("overflowX"), n = t(s).css("overflowY"), "auto" !== n && "scroll" !== n || (o.top -= s.scrollTop), "auto" !== e && "scroll" !== e || (o.left -= s.scrollLeft), s = s.offsetParent;
            return o
        }

        function a(t) {
            var i = this;
            i.owner = t, i._preventDragging = !1, i._draggable = new h(t.wrapper, {
                filter: ">" + O,
                group: t.wrapper.id + "-resizing",
                dragstart: w(i.dragstart, i),
                drag: w(i.drag, i),
                dragend: w(i.dragend, i)
            }), i._draggable.userEvents.bind("press", w(i.addOverlay, i)), i._draggable.userEvents.bind("release", w(i.removeOverlay, i))
        }

        function l(t, i) {
            var e = this;
            e.owner = t, e._preventDragging = !1, e._draggable = new h(t.wrapper, {
                filter: i,
                group: t.wrapper.id + "-moving",
                dragstart: w(e.dragstart, e),
                drag: w(e.drag, e),
                dragend: w(e.dragend, e),
                dragcancel: w(e.dragcancel, e)
            }), e._draggable.userEvents.stopPropagation = !1
        }
        var d = window.kendo,
            p = d.ui.Widget,
            c = d.ui.Popup.TabKeyTrap,
            h = d.ui.Draggable,
            f = t.isPlainObject,
            m = d._activeElement,
            g = d._outerWidth,
            u = d._outerHeight,
            w = t.proxy,
            _ = t.extend,
            v = t.each,
            x = d.template,
            b = "body",
            z = ".kendoWindow",
            k = ".kendoWindowModal",
            T = ".k-window",
            y = ".k-window-title",
            L = y + "bar",
            M = ".k-window-content",
            P = ".k-dialog-content",
            O = ".k-resize-handle",
            W = ".k-overlay",
            S = "k-content-frame",
            H = "k-i-loading",
            D = "k-state-hover",
            I = "k-state-focused",
            C = "k-window-maximized",
            E = ":visible",
            F = "hidden",
            R = "cursor",
            j = "open",
            A = "activate",
            N = "deactivate",
            K = "close",
            B = "refresh",
            q = "minimize",
            U = "maximize",
            G = "resizeStart",
            J = "resize",
            V = "resizeEnd",
            Q = "dragstart",
            X = "dragend",
            Y = "error",
            $ = "overflow",
            Z = "original-overflow-rule",
            tt = "zIndex",
            it = ".k-window-actions .k-i-window-minimize,.k-window-actions .k-i-window-maximize",
            et = ".k-i-pin",
            nt = ".k-i-unpin",
            ot = et + "," + nt,
            st = ".k-window-titlebar .k-window-action",
            rt = ".k-window-titlebar .k-i-refresh",
            at = "WindowEventsHandled",
            lt = /^0[a-z]*$/i,
            dt = d.isLocalUrl,
            pt = {
                small: "k-window-sm",
                medium: "k-window-md",
                large: "k-window-lg"
            },
            ct = p.extend({
                init: function(n, o) {
                    var r, a, l, h, m, g, u, _, v, x = this,
                        b = {},
                        k = !1,
                        O = o && o.actions && !o.actions.length;
                    p.fn.init.call(x, n, o), o = x.options, h = o.position, n = x.element, m = o.content, _ = t(window), O && (o.actions = []), x.appendTo = t(o.appendTo), x.containment = o.draggable.containment ? t(o.draggable.containment).first() : null, m && !f(m) && (m = o.content = {
                        url: m
                    }), n.find("script").filter(s).remove(), n.parent().is(x.appendTo) || x.containment || h.top !== i && h.left !== i || (n.is(E) ? (b = n.offset(), k = !0) : (a = n.css("visibility"), l = n.css("display"), n.css({
                        visibility: F,
                        display: ""
                    }), b = n.offset(), n.css({
                        visibility: a,
                        display: l
                    })), h.top === i && (h.top = b.top), h.left === i && (h.left = b.left)), e(o.visible) && null !== o.visible || (o.visible = n.is(E)), r = x.wrapper = n.closest(T), n.is(".k-content") && r[0] || (n.addClass("k-window-content k-content"), x._createWindow(n, o), r = x.wrapper = n.closest(T), x.title(x.options.title), x._dimensions()), x.minTop = x.minLeft = -(1 / 0), x.maxTop = x.maxLeft = 1 / 0, x._position(), m && x.refresh(m), o.visible && x.toFront(), g = r.children(M), x._tabindex(g), o.visible && o.modal && x._overlay(r.is(E)).css({
                        opacity: .5
                    }), r.on("mouseenter" + z, st, w(x._buttonEnter, x)).on("mouseleave" + z, st, w(x._buttonLeave, x)).on("click" + z, "> " + st, w(x._windowActionHandler, x)).on("keydown" + z, w(x._keydown, x)).on("focus" + z, w(x._focus, x)).on("blur" + z, w(x._blur, x)), g.on("keydown" + z, w(x._keydown, x)).on("focus" + z, w(x._focus, x)).on("blur" + z, w(x._blur, x)), u = g.find("." + S)[0], u && !_.data(at) && (_.on("blur" + z, function() {
                        var i, e = t(document.activeElement).parent(M);
                        e.length && (i = d.widgetInstance(e), i._focus())
                    }), _.on("focus" + z, function() {
                        t(M).not(P).each(function(i, e) {
                            d.widgetInstance(t(e))._blur()
                        })
                    }), _.data(at, !0)), this._resizable(), this._draggable(), o.pinned && this.wrapper.is(":visible") && x.pin(), v = n.attr("id"), v && (v += "_wnd_title", r.children(L).children(y).attr("id", v), g.attr({
                        role: "dialog",
                        "aria-labelledby": v
                    })), r.add(r.children(".k-resize-handle," + L)).on("mousedown" + z, w(x.toFront, x)), x.touchScroller = d.touchScroller(n), x._resizeHandler = w(x._onDocumentResize, x), x._marker = d.guid().substring(0, 8), t(window).on("resize" + z + x._marker, x._resizeHandler), o.visible && (x.trigger(j), x.trigger(A)), d.notify(x), this.options.modal && (this._tabKeyTrap = new c(r), this._tabKeyTrap.trap(), this._tabKeyTrap.shouldTrap = function() {
                        return g.data("isFront")
                    })
                },
                _buttonEnter: function(i) {
                    t(i.currentTarget).addClass(D)
                },
                _buttonLeave: function(i) {
                    t(i.currentTarget).removeClass(D)
                },
                _focus: function() {
                    this.wrapper.addClass(I)
                },
                _blur: function() {
                    this.wrapper.removeClass(I)
                },
                _dimensions: function() {
                    var t, i, e = this.wrapper,
                        s = this.options,
                        r = s.width,
                        a = s.height,
                        l = s.maxHeight,
                        d = s.size,
                        p = ["minWidth", "minHeight", "maxWidth", "maxHeight"],
                        c = "content-box" == e.css("box-sizing"),
                        h = c ? n(e, "border-left-width") + n(e, "border-right-width") : 0,
                        f = c ? n(e, "border-top-width") + n(e, "border-bottom-width") : 0,
                        m = c ? n(e, "padding-top") : 0;
                    for (this.containment && !this._isPinned && (this._updateBoundaries(), s.maxHeight = Math.min(this.containment.height - (f + m), l), s.maxWidth = Math.min(this.containment.width - h, s.maxWidth)), t = 0; t < p.length; t++) i = s[p[t]] || "", i != 1 / 0 && e.css(p[t], i);
                    l != 1 / 0 && this.element.css("maxHeight", l), e.width(r ? o(r, s.minWidth, s.maxWidth) : ""), e.height(a ? o(a, s.minHeight, s.maxHeight) : ""), s.visible || e.hide(), d && pt[d] && e.addClass(pt[d])
                },
                _position: function() {
                    var t = this.wrapper,
                        i = this.options.position;
                    this._updateBoundaries(), this.containment && (i.top = Math.min(this.minTop + (i.top || 0), this.maxTop), i.left = Math.min(this.minLeft + (i.left || 0), this.maxLeft)), 0 === i.top && (i.top = "" + i.top), 0 === i.left && (i.left = "" + i.left), t.css({
                        top: i.top || "",
                        left: i.left || ""
                    })
                },
                _updateBoundaries: function() {
                    var t = this.containment;
                    return t ? (t.width = t.innerWidth(), t.height = t.innerHeight(), parseInt(t.width, 10) > t[0].clientWidth && (t.width -= d.support.scrollbar()), parseInt(t.height, 10) > t[0].clientHeight && (t.height -= d.support.scrollbar()), t.position = r(t[0]), this._isPinned ? (this.minTop = this.minLeft = -(1 / 0), this.maxTop = this.maxLeft = 1 / 0) : (this.minTop = t.scrollTop(), this.minLeft = t.scrollLeft(), this.maxLeft = this.minLeft + t.width - g(this.wrapper, !0), this.maxTop = this.minTop + t.height - u(this.wrapper, !0)), i) : null
                },
                _animationOptions: function(t) {
                    var i = this.options.animation,
                        e = {
                            open: {
                                effects: {}
                            },
                            close: {
                                hide: !0,
                                effects: {}
                            }
                        };
                    return i && i[t] || e[t]
                },
                _resize: function() {
                    d.resize(this.element.children())
                },
                _resizable: function() {
                    var i = this.options.resizable,
                        e = this.wrapper;
                    this.resizing && (e.off("dblclick" + z).children(O).remove(), this.resizing.destroy(), this.resizing = null), i && (e.on("dblclick" + z, L, w(function(i) {
                        t(i.target).closest(".k-window-action").length || this.toggleMaximization()
                    }, this)), v("n e s w se sw ne nw".split(" "), function(t, i) {
                        e.append(ht.resizeHandle(i))
                    }), this.resizing = new a(this)), e = null
                },
                _draggable: function() {
                    var t = this.options.draggable;
                    this.dragging && (this.dragging.destroy(), this.dragging = null), t && (this.dragging = new l(this, t.dragHandle || L))
                },
                _actions: function() {
                    var i = this.options,
                        e = i.actions,
                        n = i.pinned,
                        o = this.wrapper.children(L),
                        s = o.find(".k-window-actions"),
                        r = ["maximize", "minimize"];
                    e = t.map(e, function(t) {
                        return t = n && "pin" === t.toLowerCase() ? "unpin" : t, {
                            name: r.indexOf(t.toLowerCase()) > -1 ? "window-" + t : t
                        }
                    }), s.html(d.render(ht.action, e))
                },
                setOptions: function(t) {
                    var e, n, o = this,
                        s = o.options.size,
                        r = JSON.parse(JSON.stringify(t));
                    _(t.position, o.options.position), _(t.position, r.position), p.fn.setOptions.call(o, t), e = o.options.scrollable !== !1, o.restore(), i !== t.title && o.title(t.title), o.wrapper.removeClass(pt[s]), o._dimensions(), o._position(), o._resizable(), o._draggable(), o._actions(), i !== t.modal && (n = o.options.visible !== !1, o._enableDocumentScrolling(), o._overlay(t.modal && n)), o.element.css($, e ? "" : "hidden")
                },
                events: [j, A, N, K, q, U, B, G, J, V, Q, X, Y],
                options: {
                    name: "Window",
                    animation: {
                        open: {
                            effects: {
                                zoom: {
                                    direction: "in"
                                },
                                fade: {
                                    direction: "in"
                                }
                            },
                            duration: 350
                        },
                        close: {
                            effects: {
                                zoom: {
                                    direction: "out",
                                    properties: {
                                        scale: .7
                                    }
                                },
                                fade: {
                                    direction: "out"
                                }
                            },
                            duration: 350,
                            hide: !0
                        }
                    },
                    title: "",
                    actions: ["Close"],
                    autoFocus: !0,
                    modal: !1,
                    size: "auto",
                    resizable: !0,
                    draggable: !0,
                    minWidth: 90,
                    minHeight: 50,
                    maxWidth: 1 / 0,
                    maxHeight: 1 / 0,
                    pinned: !1,
                    scrollable: !0,
                    position: {},
                    content: null,
                    visible: null,
                    height: null,
                    width: null,
                    appendTo: "body",
                    isMaximized: !1,
                    isMinimized: !1
                },
                _closable: function() {
                    return t.inArray("close", t.map(this.options.actions, function(t) {
                        return t.toLowerCase()
                    })) > -1
                },
                _keydown: function(t) {
                    var i, e, s, r, a, l, p = this,
                        c = p.options,
                        h = d.keys,
                        f = t.keyCode,
                        m = p.wrapper,
                        g = 10,
                        u = c.isMaximized,
                        w = c.isMinimized;
                    f == h.ESC && p._closable() && (t.stopPropagation(), p._close(!1)), t.target != t.currentTarget || p._closing || (t.altKey && 82 == f && p.refresh(), t.altKey && 80 == f && (p.options.pinned ? p.unpin() : p.pin()), t.altKey && f == h.UP ? w ? (p.restore(), p.element.focus()) : u || (p.maximize(), p.element.focus()) : t.altKey && f == h.DOWN && (w || u ? u && (p.restore(), p.element.focus()) : (p.minimize(), p.wrapper.focus())), i = d.getOffset(m), p.containment && !p._isPinned && (i = p.options.position), !c.draggable || t.ctrlKey || t.altKey || u || (p._updateBoundaries(), f == h.UP ? (i.top = o(i.top - g, p.minTop, p.maxTop), e = m.css("top", i.top)) : f == h.DOWN ? (i.top = o(i.top + g, p.minTop, p.maxTop), e = m.css("top", i.top)) : f == h.LEFT ? (i.left = o(i.left - g, p.minLeft, p.maxLeft), e = m.css("left", i.left)) : f == h.RIGHT && (i.left = o(i.left + g, p.minLeft, p.maxLeft), e = m.css("left", i.left))), c.resizable && t.ctrlKey && !u && !w && (f == h.UP ? (e = !0, r = m.height() - g) : f == h.DOWN && (e = !0, r = p.containment && !p._isPinned ? Math.min(m.height() + g, p.containment.height - i.top - n(m, "padding-top") - n(m, "borderBottomWidth") - n(m, "borderTopWidth")) : m.height() + g), f == h.LEFT ? (e = !0, s = m.width() - g) : f == h.RIGHT && (e = !0, s = p.containment && !p._isPinned ? Math.min(m.width() + g, p.containment.width - i.left - n(m, "borderLeftWidth") - n(m, "borderRightWidth")) : m.width() + g), e && (a = o(s, c.minWidth, c.maxWidth), l = o(r, c.minHeight, c.maxHeight), isNaN(a) || (m.width(a), p.options.width = a + "px"), isNaN(l) || (m.height(l), p.options.height = l + "px"), p.resize())), e && t.preventDefault())
                },
                _overlay: function(i) {
                    var e = this.containment ? this.containment.children(W) : this.appendTo.children(W),
                        n = this.wrapper;
                    return e.length || (e = t("<div class='k-overlay' />")), e.insertBefore(n[0]).toggle(i).css(tt, parseInt(n.css(tt), 10) - 1), this.options.modal.preventScroll && !this.containment && this._stopDocumentScrolling(), e
                },
                _actionForIcon: function(t) {
                    var i = /\bk-i(-\w+)+\b/.exec(t[0].className)[0];
                    return {
                        "k-i-close": "_close",
                        "k-i-window-maximize": "maximize",
                        "k-i-window-minimize": "minimize",
                        "k-i-window-restore": "restore",
                        "k-i-refresh": "refresh",
                        "k-i-pin": "pin",
                        "k-i-unpin": "unpin"
                    }[i]
                },
                _windowActionHandler: function(e) {
                    var n, o;
                    if (!this._closing) return n = t(e.target).closest(".k-window-action").find(".k-icon"), o = this._actionForIcon(n), o ? (e.preventDefault(), this[o](), !1) : i
                },
                _modals: function() {
                    var i = this,
                        e = t(T).filter(function() {
                            var e = t(this),
                                n = i._object(e),
                                o = n && n.options;
                            return o && o.modal && o.visible && o.appendTo === i.options.appendTo && e.is(E)
                        }).sort(function(i, e) {
                            return +t(i).css("zIndex") - +t(e).css("zIndex")
                        });
                    return i = null, e
                },
                _object: function(t) {
                    var e = t.children(M),
                        n = d.widgetInstance(e);
                    return n ? n : i
                },
                center: function() {
                    var i, e, o = this,
                        s = o.options.position,
                        r = o.wrapper,
                        a = t(window),
                        l = 0,
                        d = 0;
                    return o.options.isMaximized ? o : (o.options.pinned && !o._isPinned && o.pin(), o.options.pinned || (l = a.scrollTop(), d = a.scrollLeft()), this.containment && !o.options.pinned ? (i = this.minTop + (this.maxTop - this.minTop) / 2, e = this.minLeft + (this.maxLeft - this.minLeft) / 2) : (o._scrollIsAppended = !0, e = d + Math.max(0, (a.width() - r.width()) / 2), i = l + Math.max(0, (a.height() - r.height() - n(r, "paddingTop")) / 2)), r.css({
                        left: e,
                        top: i
                    }), s.top = i, s.left = e, o)
                },
                title: function(e) {
                    var n, o, s, r, a = this,
                        l = !0,
                        p = a.wrapper,
                        c = p.children(L),
                        h = c.children(y);
                    return arguments.length ? (t.isPlainObject(e) ? (n = i !== e.text ? e.text : "", l = e.encoded !== !1) : n = e, n === !1 ? (p.addClass("k-window-titleless"), p.css("padding-top", 0), c.remove()) : (c.length ? h.html(l ? d.htmlEncode(n) : n) : (p.prepend(ht.titlebar({
                        title: l ? d.htmlEncode(n) : n
                    })), a._actions(), c = p.children(L)), r = p.css("visibility"), s = p.css("display"), r === F ? (p.css({
                        display: ""
                    }), o = parseInt(u(c), 10), p.css({
                        display: s
                    })) : (p.css({
                        visibility: F,
                        display: ""
                    }), o = parseInt(u(c), 10), p.css({
                        visibility: r,
                        display: s
                    })), p.css("padding-top", o), c.css("margin-top", -o)), a.options.title = n, a) : h.html()
                },
                content: function(t, i) {
                    var n = this.wrapper.children(M),
                        o = n.children(".km-scroll-container");
                    return n = o[0] ? o : n, e(t) ? (this.angular("cleanup", function() {
                        return {
                            elements: n.children()
                        }
                    }), d.destroy(this.element.children()), n.empty().html(t), this.angular("compile", function() {
                        var t, e = [];
                        for (t = n.length; --t >= 0;) e.push({
                            dataItem: i
                        });
                        return {
                            elements: n.children(),
                            data: e
                        }
                    }), this) : n.html()
                },
                open: function() {
                    var i, e, n, o = this,
                        s = o.wrapper,
                        r = o.options,
                        a = this._animationOptions("open"),
                        l = s.children(M),
                        p = this.containment && !o._isPinned,
                        c = p ? this.containment : t(document);
                    return o.trigger(j) || (o._closing && s.kendoStop(!0, !0), o._closing = !1, o.toFront(), r.autoFocus && o.element.focus(), r.visible = !0, r.modal && (e = !!o._modals().length, i = o._overlay(e), i.kendoStop(!0, !0), a.duration && d.effects.Fade && !e ? (n = d.fx(i).fadeIn(), n.duration(a.duration || 0), n.endValue(.5), n.play()) : i.css("opacity", .5), i.show(), t(window).on("focus" + k, function() {
                        l.data("isFront") && !t(document.activeElement).closest(l).length && o.element.focus()
                    })), s.is(E) || (l.css($, F), o.wrapper.find(st).addClass("k-bare"), s.show().kendoStop().kendoAnimate({
                        effects: a.effects,
                        duration: a.duration,
                        complete: w(this._activate, this)
                    }))), r.isMaximized && (o._containerScrollTop = c.scrollTop(), o._containerScrollLeft = c.scrollLeft(), o._stopDocumentScrolling()), this.options.pinned && !this._isPinned && this.pin(), o
                },
                _activate: function() {
                    var t = this.options.scrollable !== !1;
                    this.options.autoFocus && this.element.focus(), this.element.css($, t ? "" : "hidden"), d.resize(this.element.children()), this.trigger(A)
                },
                _removeOverlay: function(e) {
                    var n, o = this._modals(),
                        s = this.options,
                        r = s.modal && !o.length,
                        a = s.modal ? this._overlay(!0) : t(i),
                        l = this._animationOptions("close");
                    r ? (!e && l.duration && d.effects.Fade ? (n = d.fx(a).fadeOut(), n.duration(l.duration || 0), n.startValue(.5), n.play()) : this._overlay(!1).remove(), s.modal.preventScroll && this._enableDocumentScrolling()) : o.length && (this._object(o.last())._overlay(!0), s.modal.preventScroll && this._stopDocumentScrolling())
                },
                _close: function(i) {
                    var e, n = this,
                        o = n.wrapper,
                        s = n.options,
                        r = this._animationOptions("open"),
                        a = this._animationOptions("close"),
                        l = this.containment && !n._isPinned,
                        d = l ? this.containment : t(document);
                    n._closing || (e = n.trigger(K, {
                        userTriggered: !i
                    }), n._closing = !e, o.is(E) && !e && (s.visible = !1, t(T).each(function(i, e) {
                        var n = t(e).children(M);
                        e != o && n.find("> ." + S).length > 0 && n.children(W).remove()
                    }), this._removeOverlay(), n.wrapper.find(st).removeClass("k-bare"), o.kendoStop().kendoAnimate({
                        effects: a.effects || r.effects,
                        reverse: a.reverse === !0,
                        duration: a.duration,
                        complete: w(this._deactivate, this)
                    }), t(window).off(k)), n.options.isMaximized && (n._enableDocumentScrolling(), n._containerScrollTop && n._containerScrollTop > 0 && d.scrollTop(n._containerScrollTop), n._containerScrollLeft && n._containerScrollLeft > 0 && d.scrollLeft(n._containerScrollLeft)))
                },
                _deactivate: function() {
                    var t, i = this;
                    i.wrapper.hide().css("opacity", ""), i.trigger(N), i.options.modal && (t = i._object(i._modals().last()), t && t.toFront())
                },
                close: function() {
                    return this._close(!0), this
                },
                _actionable: function(i) {
                    return t(i).is(st + "," + st + " .k-icon,:input,a")
                },
                _shouldFocus: function(i) {
                    var e = m(),
                        n = this.element;
                    return this.options.autoFocus && !t(e).is(n) && !this._actionable(i) && (!n.find(e).length || !n.find(i).length)
                },
                toFront: function(i) {
                    var e, n, o = this,
                        s = o.wrapper,
                        r = s[0],
                        a = o.containment && !o._isPinned,
                        l = +s.css(tt),
                        d = l,
                        p = i && i.target || null;
                    return t(T).each(function(i, e) {
                        var n = t(e),
                            o = n.css(tt),
                            s = n.children(M);
                        isNaN(o) || (l = Math.max(+o, l)), s.data("isFront", e == r), e != r && s.find("> ." + S).length > 0 && s.append(ht.overlay)
                    }), (!s[0].style.zIndex || d < l) && s.css(tt, l + 2), o.element.find("> .k-overlay").remove(), o._shouldFocus(p) && (o.isMinimized() ? o.wrapper.focus() : t(p).is(W) ? setTimeout(function() {
                        o.element.focus()
                    }) : o.element.focus(), e = a ? o.containment.scrollTop() : t(window).scrollTop(), n = parseInt(s.position().top, 10), !o.options.pinned && n > 0 && n < e && (e > 0 ? t(window).scrollTop(n) : s.css("top", e))), s = null, o
                },
                toggleMaximization: function() {
                    return this._closing ? this : this[this.options.isMaximized ? "restore" : "maximize"]()
                },
                restore: function() {
                    var i, e = this,
                        n = e.options,
                        s = n.minHeight,
                        r = e.restoreOptions,
                        a = e.containment && !e._isPinned ? e.containment : t(document);
                    return n.isMaximized || n.isMinimized ? (s && s != 1 / 0 && e.wrapper.css("min-height", s), r && !n.isMaximized && (r.height = o(r.height, e.options.minHeight, e.options.maxHeight), i = n.position.top + parseInt(r.height, 10) > e.maxTop, i && (n.position.top = o(n.position.top, e.minTop, e.maxTop - parseInt(r.height, 10)), _(r, {
                        left: n.position.left,
                        top: n.position.top
                    }))), e.wrapper.css({
                        position: n.pinned ? "fixed" : "absolute",
                        left: r.left,
                        top: r.top,
                        width: r.width,
                        height: r.height
                    }).removeClass(C).find(".k-window-content,.k-resize-handle").show().end().find(".k-window-titlebar .k-i-window-restore").parent().remove().end().end().find(it).parent().show().end().end().find(ot).parent().show(), n.isMaximized ? e.wrapper.find(".k-i-window-maximize").parent().focus() : n.isMinimized && e.wrapper.find(".k-i-window-minimize").parent().focus(), e.options.width = r.width, e.options.height = r.height, e.options.modal.preventScroll || e._enableDocumentScrolling(), e._containerScrollTop && e._containerScrollTop > 0 && a.scrollTop(e._containerScrollTop), e._containerScrollLeft && e._containerScrollLeft > 0 && a.scrollLeft(e._containerScrollLeft), n.isMaximized = n.isMinimized = !1, e.wrapper.removeAttr("tabindex"), e.wrapper.removeAttr("aria-labelled-by"), e.resize(), e) : e
                },
                _sizingAction: function(t, i) {
                    var e = this,
                        n = e.wrapper,
                        o = n[0].style,
                        s = e.options;
                    return s.isMaximized || s.isMinimized ? e : (e.restoreOptions = {
                        width: o.width,
                        height: o.height
                    }, n.children(O).hide().end().children(L).find(it).parent().hide().eq(0).before(ht.action({
                        name: "window-restore"
                    })), i.call(e), e.wrapper.children(L).find(ot).parent().toggle("maximize" !== t), e.trigger(t), n.find(".k-i-window-restore").parent().focus(), e)
                },
                maximize: function() {
                    return this._sizingAction("maximize", function() {
                        var i = this,
                            e = i.wrapper,
                            n = this.containment && !i._isPinned,
                            o = e.position(),
                            s = t(document);
                        _(i.restoreOptions, {
                            left: o.left + (n ? this.containment.scrollLeft() : 0),
                            top: o.top + (n ? this.containment.scrollTop() : 0)
                        }), this._containerScrollTop = n ? this.containment.scrollTop() : s.scrollTop(), this._containerScrollLeft = n ? this.containment.scrollLeft() : s.scrollLeft(), i._stopDocumentScrolling(), e.css({
                            top: n ? this.containment.scrollTop() : 0,
                            left: n ? this.containment.scrollLeft() : 0,
                            position: n ? "absolute" : "fixed"
                        }).addClass(C), i.options.isMaximized = !0, i._onDocumentResize()
                    }), this
                },
                _stopDocumentScrolling: function() {
                    var e, n, o = this,
                        s = o.containment;
                    return s && !o._isPinned ? (o._storeOverflowRule(s), s.css($, F), o.wrapper.css({
                        maxWidth: s.innerWidth(),
                        maxHeight: s.innerHeight()
                    }), i) : (e = t("body"), o._storeOverflowRule(e), e.css($, F), n = t("html"), o._storeOverflowRule(n), n.css($, F), i)
                },
                _enableDocumentScrolling: function() {
                    var e = this,
                        n = e.containment;
                    return n && !e._isPinned ? (e._restoreOverflowRule(n), e.wrapper.css({
                        maxWidth: n.width,
                        maxHeight: n.height
                    }), i) : (e._restoreOverflowRule(t(document.body)), e._restoreOverflowRule(t("html")), i)
                },
                _storeOverflowRule: function(t) {
                    if (!this._isOverflowStored(t)) {
                        var i = t.get(0).style.overflow;
                        "string" == typeof i && t.data(Z, i)
                    }
                },
                _isOverflowStored: function(t) {
                    return "string" == typeof t.data(Z)
                },
                _restoreOverflowRule: function(t) {
                    var e = t.data(Z);
                    null !== e && e !== i ? (t.css($, e), t.removeData(Z)) : t.css($, "")
                },
                isMaximized: function() {
                    return this.options.isMaximized
                },
                minimize: function() {
                    return this._sizingAction("minimize", function() {
                        var t = this;
                        t.wrapper.css({
                            height: "",
                            minHeight: ""
                        }), t.element.hide(), t.options.isMinimized = !0
                    }), this.wrapper.attr("tabindex", 0), this.wrapper.attr("aria-labelled-by", this.element.attr("aria-labelled-by")), this._updateBoundaries(), this
                },
                isMinimized: function() {
                    return this.options.isMinimized
                },
                pin: function() {
                    var i = this,
                        e = t(window),
                        o = i.wrapper,
                        s = i.options,
                        a = s.position,
                        l = this.containment ? r(o[0]).top + n(this.containment, "borderTopWidth") : n(o, "top"),
                        d = this.containment ? r(o[0]).left + n(this.containment, "borderLeftWidth") : n(o, "left");
                    i.options.isMaximized || (a.top = l, a.left = d, !i._scrollIsAppended || this.containment && "fixed" === this.containment.css("position") || (a.top -= e.scrollTop(), a.left -= e.scrollLeft(), i._scrollIsAppended = !1), o.css(_(a, {
                        position: "fixed"
                    })), o.children(L).find(et).addClass("k-i-unpin").removeClass("k-i-pin"), i._isPinned = !0, i.options.pinned = !0, this.containment && (s.maxWidth = s.maxHeight = 1 / 0, o.css({
                        maxWidth: "",
                        maxHeight: ""
                    })))
                },
                unpin: function() {
                    var i = this,
                        e = t(window),
                        s = i.wrapper,
                        r = i.options,
                        a = i.options.position,
                        l = i.containment,
                        d = parseInt(s.css("top"), 10) + e.scrollTop(),
                        p = parseInt(s.css("left"), 10) + e.scrollLeft();
                    i.options.isMaximized || (i._isPinned = !1, i._scrollIsAppended = !0, i.options.pinned = !1, l && (i._updateBoundaries(), r.maxWidth = Math.min(l.width, r.maxWidth), r.maxHeight = Math.min(l.height - n(s, "padding-top"), r.maxHeight), s.css({
                        maxWidth: r.maxWidth,
                        maxHeight: r.maxHeight
                    }), d = d < l.position.top ? i.minTop : d > l.position.top + l.height ? i.maxTop : d + l.scrollTop() - (l.position.top + n(l, "border-top-width")), p = p < l.position.left ? i.minLeft : p > l.position.left + l.width ? i.maxLeft : p + l.scrollLeft() - (l.position.left + n(l, "border-left-width"))), a.top = o(d, i.minTop, i.maxTop), a.left = o(p, i.minLeft, i.maxLeft), s.css(_(a, {
                        position: ""
                    })), s.children(L).find(nt).addClass("k-i-pin").removeClass("k-i-unpin"))
                },
                _onDocumentResize: function() {
                    var i, e, o, s, r, a = this,
                        l = a.wrapper,
                        p = t(window),
                        c = d.support.zoomLevel(),
                        h = "content-box" == l.css("box-sizing");
                    a.options.isMaximized && (o = h ? n(l, "border-left-width") + n(l, "border-right-width") : 0, s = h ? n(l, "border-top-width") + n(l, "border-bottom-width") : 0, r = h ? n(l, "padding-top") : 0, a.containment && !a._isPinned ? (i = a.containment.innerWidth() - o, e = a.containment.innerHeight() - (s + r)) : (i = p.width() / c - o, e = p.height() / c - (s + r)), l.css({
                        width: i,
                        height: e
                    }), a.options.width = i, a.options.height = e, a.resize())
                },
                refresh: function(i) {
                    var n, o, s, r = this,
                        a = r.options,
                        l = t(r.element);
                    return f(i) || (i = {
                        url: i
                    }), i = _({}, a.content, i), o = e(a.iframe) ? a.iframe : i.iframe, s = i.url, s ? (e(o) || (o = !dt(s)), o ? (n = l.find("." + S)[0], n ? n.src = s || n.src : l.html(ht.contentFrame(_({}, a, {
                        content: i
                    }))), l.find("." + S).unbind("load" + z).on("load" + z, w(this._triggerRefresh, this))) : r._ajaxRequest(i)) : (i.template && r.content(x(i.template)({})), r.trigger(B)), l.toggleClass("k-window-iframecontent", !!o), r
                },
                _triggerRefresh: function() {
                    this.trigger(B)
                },
                _ajaxComplete: function() {
                    clearTimeout(this._loadingIconTimeout), this.wrapper.find(rt).removeClass(H)
                },
                _ajaxError: function(t, i) {
                    this.trigger(Y, {
                        status: i,
                        xhr: t
                    })
                },
                _ajaxSuccess: function(t) {
                    return function(i) {
                        var e = i;
                        t && (e = x(t)(i || {})), this.content(e, i), this.element.prop("scrollTop", 0), this.trigger(B)
                    }
                },
                _showLoading: function() {
                    this.wrapper.find(rt).addClass(H)
                },
                _ajaxRequest: function(i) {
                    this._loadingIconTimeout = setTimeout(w(this._showLoading, this), 100), t.ajax(_({
                        type: "GET",
                        dataType: "html",
                        cache: !1,
                        error: w(this._ajaxError, this),
                        complete: w(this._ajaxComplete, this),
                        success: w(this._ajaxSuccess(i.template), this)
                    }, i))
                },
                _destroy: function() {
                    this.resizing && this.resizing.destroy(), this.dragging && this.dragging.destroy(), this.wrapper.off(z).children(M).off(z).end().find(".k-resize-handle,.k-window-titlebar").off(z), t(window).off("resize" + z + this._marker), t(window).off(k), t(window).off(z), clearTimeout(this._loadingIconTimeout), p.fn.destroy.call(this), this.unbind(i), d.destroy(this.wrapper), this._removeOverlay(!0)
                },
                destroy: function() {
                    this._destroy(), this.wrapper.empty().remove(), this.wrapper = this.appendTo = this.element = t()
                },
                _createWindow: function() {
                    var i, e, n = this.element,
                        o = this.options,
                        s = d.support.isRtl(n);
                    o.scrollable === !1 && n.css("overflow", "hidden"), e = t(ht.wrapper(o)), i = n.find("iframe:not(.k-content)").map(function() {
                        var t = this.getAttribute("src");
                        return this.src = "", t
                    }), e.toggleClass("k-rtl", s).append(n).find("iframe:not(.k-content)").each(function(t) {
                        this.src = i[t]
                    }), this.containment ? this.containment.prepend(e) : this.appendTo && e.appendTo(this.appendTo), e.find(".k-window-title").css(s ? "left" : "right", g(e.find(".k-window-actions")) + 10), n.css("visibility", "").show(), n.find("[data-role=editor]").each(function() {
                        var i = t(this).data("kendoEditor");
                        i && i.refresh()
                    }), e = n = null
                }
            }),
            ht = {
                wrapper: x("<div class='k-widget k-window' />"),
                action: x("<a role='button' href='\\#' class='k-button k-bare k-button-icon k-window-action' aria-label='#= name #'><span class='k-icon k-i-#= name.toLowerCase() #'></span></a>"),
                titlebar: x("<div class='k-window-titlebar k-header'><span class='k-window-title'>#= title #</span><div class='k-window-actions' /></div>"),
                overlay: "<div class='k-overlay' />",
                contentFrame: x("<iframe frameborder='0' title='#= title #' class='" + S + "' src='#= content.url #'>This page requires frames in order to show content</iframe>"),
                resizeHandle: x("<div class='k-resize-handle k-resize-#= data #'></div>")
            };
        a.prototype = {
            addOverlay: function() {
                this.owner.wrapper.append(ht.overlay)
            },
            removeOverlay: function() {
                this.owner.wrapper.find(W).remove()
            },
            dragstart: function(i) {
                var e, n, o, s, a, l, p, c = this,
                    h = c.owner,
                    f = h.wrapper;
                c._preventDragging = h.trigger(G), c._preventDragging || (c.elementPadding = parseInt(f.css("padding-top"), 10), c.initialPosition = d.getOffset(f, "position"), c.resizeDirection = i.currentTarget.prop("className").replace("k-resize-handle k-resize-", ""), c.initialSize = {
                    width: f.width(),
                    height: f.height()
                }, h._updateBoundaries(), c.containerOffset = h.containment ? h.containment.position : d.getOffset(h.appendTo, "position"), e = f.offsetParent(), e.is("html") ? c.containerOffset.top = c.containerOffset.left = 0 : (n = e.css("margin-top"), o = e.css("margin-left"), s = !lt.test(n) || !lt.test(o), s && (a = r(f[0]), l = a.left - c.containerOffset.left - c.initialPosition.left, p = a.top - c.containerOffset.top - c.initialPosition.top, c._relativeElMarginLeft = l > 1 ? l : 0, c._relativeElMarginTop = p > 1 ? p : 0, c.initialPosition.left += c._relativeElMarginLeft, c.initialPosition.top += c._relativeElMarginTop)), f.children(O).not(i.currentTarget).hide(), t(b).css(R, i.currentTarget.css(R)))
            },
            drag: function(i) {
                var e, n, s, r, a, l, p, c, h, f, m, g, u, w, _, v, x, b, z, k;
                this._preventDragging || (e = this, n = e.owner, s = n.wrapper, r = n.options, a = r.position, l = e.resizeDirection, p = e.containerOffset, c = e.initialPosition, h = e.initialSize, f = n.containment && !n._isPinned, m = d.support.isRtl(n.containment), g = f && m && n.containment.innerWidth() > n.containment.width ? d.support.scrollbar() : 0, u = f ? {
                    top: n.containment.scrollTop(),
                    left: n.containment.scrollLeft()
                } : {
                    top: 0,
                    left: 0
                }, b = Math.max(i.x.location, 0), z = Math.max(i.y.location, 0), l.indexOf("e") >= 0 ? (w = n.containment && b - h.width >= n.maxLeft - u.left + p.left + g ? n.maxLeft + g - c.left + h.width - u.left : b - c.left - p.left, s.width(o(w, r.minWidth, r.maxWidth))) : l.indexOf("w") >= 0 && (x = c.left + h.width + p.left, w = o(x - b, r.minWidth, r.maxWidth), a.left = x - w - p.left - g - (e._relativeElMarginLeft || 0) + u.left, n.containment && a.left <= n.minLeft && (a.left = n.minLeft, w = o(x - g - a.left - p.left + u.left, r.minWidth, r.maxWidth)), s.css({
                    left: a.left,
                    width: w
                })), k = z, n.options.pinned && (k -= t(window).scrollTop()), l.indexOf("s") >= 0 ? (_ = k - c.top - e.elementPadding - p.top, k - h.height - e.elementPadding >= n.maxTop + p.top - u.top && (_ = n.maxTop - c.top + h.height - u.top), s.height(o(_, r.minHeight, r.maxHeight))) : l.indexOf("n") >= 0 && (v = c.top + h.height + p.top, _ = o(v - k, r.minHeight, r.maxHeight), a.top = v - _ - p.top - (e._relativeElMarginTop || 0) + u.top, a.top <= n.minTop && n.containment && (a.top = n.minTop, _ = o(v - a.top - p.top + u.top, r.minHeight, r.maxHeight)), s.css({
                    top: a.top,
                    height: _
                })), w && (n.options.width = w + "px"), _ && (n.options.height = _ + "px"), n.resize())
            },
            dragend: function(i) {
                if (!this._preventDragging) {
                    var e = this,
                        n = e.owner,
                        o = n.wrapper;
                    return o.children(O).not(i.currentTarget).show(), t(b).css(R, ""), n.touchScroller && n.touchScroller.reset(), 27 == i.keyCode && o.css(e.initialPosition).css(e.initialSize), n.trigger(V), !1
                }
            },
            destroy: function() {
                this._draggable && this._draggable.destroy(), this._draggable = this.owner = null
            }
        }, l.prototype = {
            dragstart: function(i) {
                var e = this.owner,
                    n = e.options.draggable,
                    o = e.element,
                    s = o.find(".k-window-actions"),
                    r = d.getOffset(e.appendTo);
                this._preventDragging = e.trigger(Q) || !n, this._preventDragging || e.isMaximized() || (e.initialWindowPosition = d.getOffset(e.wrapper, "position"), e.initialPointerPosition = {
                    left: e.options.position.left,
                    top: e.options.position.top
                }, e.startPosition = {
                    left: i.x.client - e.initialWindowPosition.left,
                    top: i.y.client - e.initialWindowPosition.top
                }, e._updateBoundaries(), e.containment || (e.minLeft = s.length > 0 ? g(s) + parseInt(s.css("right"), 10) - g(o) : 20 - g(o), e.minLeft -= r.left, e.minTop = -r.top), e.wrapper.append(ht.overlay).children(O).hide(), t(b).css(R, i.currentTarget.css(R)))
            },
            drag: function(i) {
                var e, n, s = this.owner,
                    r = s.options.position,
                    a = s.options.draggable.axis;
                this._preventDragging || s.isMaximized() || (a && "x" !== a.toLowerCase() || (e = i.x.client - s.startPosition.left, s.containment && !s._isPinned && (e += s.containment.scrollLeft()), r.left = o(e, s.minLeft, s.maxLeft)), a && "y" !== a.toLowerCase() || (n = i.y.client - s.startPosition.top, s.containment && !s._isPinned && (n += s.containment.scrollTop()), r.top = o(n, s.minTop, s.maxTop)), d.support.transforms ? t(s.wrapper).css("transform", "translate(" + (r.left - s.initialPointerPosition.left) + "px, " + (r.top - s.initialPointerPosition.top) + "px)") : t(s.wrapper).css(r))
            },
            _finishDrag: function() {
                var i = this.owner;
                i.wrapper.children(O).toggle(!i.options.isMinimized).end().find(W).remove(), t(b).css(R, "")
            },
            dragcancel: function(t) {
                this._preventDragging || (this._finishDrag(), t.currentTarget.closest(T).css(this.owner.initialWindowPosition))
            },
            dragend: function() {
                var i = this.owner;
                if (!this._preventDragging && !i.isMaximized()) return t(i.wrapper).css(i.options.position).css("transform", ""), this._finishDrag(), i.trigger(X), !1
            },
            destroy: function() {
                this._draggable && this._draggable.destroy(), this._draggable = this.owner = null
            }
        }, d.ui.plugin(ct)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, i, e) {
    (e || i)()
});;
! function(e, define) {
    define("util/undoredostack.min", ["kendo.core.min"], e)
}(function() {
    ! function(e) {
        var t = e.Observable.extend({
            init: function(t) {
                e.Observable.fn.init.call(this, t), this.clear()
            },
            events: ["undo", "redo"],
            push: function(e) {
                this.stack = this.stack.slice(0, this.currentCommandIndex + 1), this.currentCommandIndex = this.stack.push(e) - 1
            },
            undo: function() {
                if (this.canUndo()) {
                    var e = this.stack[this.currentCommandIndex--];
                    e.undo(), this.trigger("undo", {
                        command: e
                    })
                }
            },
            redo: function() {
                if (this.canRedo()) {
                    var e = this.stack[++this.currentCommandIndex];
                    e.redo(), this.trigger("redo", {
                        command: e
                    })
                }
            },
            clear: function() {
                this.stack = [], this.currentCommandIndex = -1
            },
            canUndo: function() {
                return this.currentCommandIndex >= 0
            },
            canRedo: function() {
                return this.currentCommandIndex != this.stack.length - 1
            }
        });
        e.deepExtend(e, {
            util: {
                UndoRedoStack: t
            }
        })
    }(kendo)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/main.min", ["util/undoredostack.min", "kendo.combobox.min", "kendo.dropdownlist.min", "kendo.window.min", "kendo.colorpicker.min"], e)
}(function() {
    ! function(e, t) {
        var n, i, o, r, a = window.kendo,
            s = a.Class,
            l = a.ui.Widget,
            d = a.support.mobileOS,
            c = a.support.browser,
            u = e.extend,
            f = e.proxy,
            p = a.deepExtend,
            m = a.keys,
            h = "select",
            g = "select.k-select-overlay",
            b = "k-placeholder",
            v = "placeholder",
            y = 200,
            k = "en",
            w = s.extend({
                init: function(e) {
                    this.options = e
                },
                getHtml: function() {
                    var e = this.options;
                    return a.template(e.template, {
                        useWithBlock: !1
                    })(e)
                }
            }),
            C = {
                editorWrapperTemplate: '<table cellspacing="4" cellpadding="0" class="k-widget k-editor k-header" role="presentation"><tbody><tr role="presentation"><td class="k-editor-toolbar-wrap" role="presentation"><ul class="k-editor-toolbar" role="toolbar" /></td></tr><tr><td class="k-editable-area" /></tr></tbody></table>',
                buttonTemplate: '# var iconCssClass= "k-icon k-i-" + kendo.toHyphens(data.cssClass.replace("k-", ""));#<a tabindex="0" role="button" class="k-tool"#= data.popup ? " data-popup" : "" # unselectable="on" title="#= data.title #" aria-label="#= data.title #"><span unselectable="on" class="k-tool-icon #= iconCssClass #"></span></a>',
                tableWizardButtonTemplate: '# var iconCssClass= "k-icon k-i-" + kendo.toHyphens(data.cssClass.replace("k-", ""));#<a tabindex="0" role="button" class="k-tool"#= data.popup ? " data-popup" : "" # unselectable="on" title="#= data.title #"><span unselectable="on" class="k-tool-icon #= iconCssClass #"></span><span class="k-tool-text">#= data.title #</span></a>',
                colorPickerTemplate: '<input class="k-colorpicker k-icon k-i-#= data.cssClass.replace("k-", "") #" />',
                comboBoxTemplate: '<select title="#= data.title #" aria-label="#= data.title #" class="#= data.cssClass #" />',
                dropDownListTemplate: '<span class="k-editor-dropdown"><select title="#= data.title #" aria-label="#= data.title #" class="#= data.cssClass #" /></span>',
                separatorTemplate: '<span class="k-separator" />',
                overflowAnchorTemplate: '<a tabindex="0" role="button" class="k-tool k-overflow-anchor" data-popup unselectable="on" title="#= data.title #" aria-label="#= data.title #" aria-haspopup="true" aria-expanded="false"><span unselectable="on" class="k-icon k-i-more-vertical"></span></a>',
                formatByName: function(t, n) {
                    for (var i = 0; i < n.length; i++)
                        if (e.inArray(t, n[i].tags) >= 0) return n[i]
                },
                getToolCssClass: function(e) {
                    var t = {
                            superscript: "sup-script",
                            subscript: "sub-script",
                            justifyLeft: "align-left",
                            justifyCenter: "align-center",
                            justifyRight: "align-right",
                            justifyFull: "align-justify",
                            insertUnorderedList: "list-unordered",
                            insertOrderedList: "list-ordered",
                            "import": "login",
                            indent: "indent-increase",
                            outdent: "indent-decrease",
                            createLink: "link-horizontal",
                            unlink: "unlink-horizontal",
                            insertImage: "image",
                            insertFile: "file-add",
                            viewHtml: "html",
                            foreColor: "foreground-color",
                            backColor: "paint",
                            createTable: "table-insert",
                            addColumnLeft: "table-column-insert-left",
                            addColumnRight: "table-column-insert-right",
                            addRowAbove: "table-row-insert-above",
                            addRowBelow: "table-row-insert-below",
                            deleteRow: "table-row-delete",
                            deleteColumn: "table-column-delete",
                            mergeCellsHorizontally: "cells-merge-horizontally",
                            mergeCellsVertically: "cells-merge-vertically",
                            splitCellHorizontally: "cell-split-horizontally",
                            splitCellVertically: "cell-split-vertically",
                            tableWizard: "table-properties",
                            tableWizardInsert: "table-wizard",
                            cleanFormatting: "clear-css",
                            copyFormat: "copy-format",
                            applyFormat: "apply-format"
                        },
                        n = t[e];
                    return n ? n : e
                },
                registerTool: function(e, t) {
                    var n = t.options;
                    n && n.template && (n.template.options.cssClass = "k-" + C.getToolCssClass(e)), t.name || (t.options.name = e, t.name = e.toLowerCase()), N.defaultTools[e] = t
                },
                registerFormat: function(e, t) {
                    N.fn.options.formats[e] = t
                },
                cacheComments: function(e, t) {
                    for (var n in t) e = e.replace(t[n], "{" + n + "}");
                    return e
                },
                retrieveComments: function(e, t) {
                    for (var n in t) e = e.replace("{" + n + "}", t[n]);
                    return e
                }
            },
            x = {
                bold: "Bold",
                italic: "Italic",
                underline: "Underline",
                strikethrough: "Strikethrough",
                superscript: "Superscript",
                subscript: "Subscript",
                justifyCenter: "Center text",
                justifyLeft: "Align text left",
                justifyRight: "Align text right",
                justifyFull: "Justify",
                insertUnorderedList: "Insert unordered list",
                insertOrderedList: "Insert ordered list",
                indent: "Indent",
                outdent: "Outdent",
                createLink: "Insert hyperlink",
                unlink: "Remove hyperlink",
                insertImage: "Insert image",
                insertFile: "Insert file",
                insertHtml: "Insert HTML",
                viewHtml: "View HTML",
                fontName: "Select font family",
                fontNameInherit: "(inherited font)",
                fontSize: "Select font size",
                fontSizeInherit: "(inherited size)",
                formatBlock: "Format",
                formatting: "Format",
                foreColor: "Color",
                backColor: "Background color",
                style: "Styles",
                emptyFolder: "Empty Folder",
                editAreaTitle: "Editable area. Press F10 for toolbar.",
                uploadFile: "Upload",
                overflowAnchor: "More tools",
                orderBy: "Arrange by:",
                orderBySize: "Size",
                orderByName: "Name",
                invalidFileType: 'The selected file "{0}" is not valid. Supported file types are {1}.',
                deleteFile: 'Are you sure you want to delete "{0}"?',
                overwriteFile: 'A file with name "{0}" already exists in the current directory. Do you want to overwrite it?',
                directoryNotFound: "A directory with this name was not found.",
                imageWebAddress: "Web address",
                imageAltText: "Alternate text",
                imageWidth: "Width (px)",
                imageHeight: "Height (px)",
                fileWebAddress: "Web address",
                fileTitle: "Title",
                fileText: "Text",
                linkWebAddress: "Web address",
                linkText: "Text",
                linkToolTip: "ToolTip",
                linkOpenInNewWindow: "Open link in new window",
                dialogUpdate: "Update",
                dialogInsert: "Insert",
                dialogOk: "Ok",
                dialogCancel: "Cancel",
                cleanFormatting: "Clean formatting",
                createTable: "Create a table",
                createTableHint: "Create a {0} x {1} table",
                addColumnLeft: "Add column on the left",
                addColumnRight: "Add column on the right",
                addRowAbove: "Add row above",
                addRowBelow: "Add row below",
                deleteRow: "Delete row",
                deleteColumn: "Delete column",
                mergeCellsHorizontally: "Merge cells horizontally",
                mergeCellsVertically: "Merge cells vertically",
                splitCellHorizontally: "Split cells horizontally",
                splitCellVertically: "Split cells vertically",
                tableWizard: "Table Wizard",
                tableTab: "Table",
                cellTab: "Cell",
                accessibilityTab: "Accessibility",
                caption: "Caption",
                summary: "Summary",
                width: "Width",
                height: "Height",
                units: "Units",
                cellSpacing: "Cell Spacing",
                cellPadding: "Cell Padding",
                cellMargin: "Cell Margin",
                alignment: "Alignment",
                background: "Background",
                cssClass: "CSS Class",
                id: "ID",
                border: "Border",
                borderStyle: "Border Style",
                collapseBorders: "Collapse borders",
                wrapText: "Wrap text",
                associateCellsWithHeaders: "Associate headers",
                alignLeft: "Align Left",
                alignCenter: "Align Center",
                alignRight: "Align Right",
                alignLeftTop: "Align Left Top",
                alignCenterTop: "Align Center Top",
                alignRightTop: "Align Right Top",
                alignLeftMiddle: "Align Left Middle",
                alignCenterMiddle: "Align Center Middle",
                alignRightMiddle: "Align Right Middle",
                alignLeftBottom: "Align Left Bottom",
                alignCenterBottom: "Align Center Bottom",
                alignRightBottom: "Align Right Bottom",
                alignRemove: "Remove Alignment",
                columns: "Columns",
                rows: "Rows",
                selectAllCells: "Select All Cells",
                exportAs: "Export As",
                "import": "Import",
                print: "Print",
                headerRows: "Header Rows",
                headerColumns: "Header Cols",
                tableSummaryPlaceholder: "Summary attribute is not HTML5 compatible.",
                associateNone: "None",
                associateScope: "Associate using 'scope' attribute",
                associateIds: "Associate using Ids",
                copyFormat: "Copy format",
                applyFormat: "Apply format"
            },
            T = !d || d.ios && d.flatVersion >= 500 || !d.ios && t !== document.documentElement.contentEditable,
            _ = {
                basic: ["bold", "italic", "underline"],
                alignment: ["justifyLeft", "justifyCenter", "justifyRight"],
                lists: ["insertUnorderedList", "insertOrderedList"],
                indenting: ["indent", "outdent"],
                formatPainter: ["copyFormat", "applyFormat"],
                links: ["createLink", "unlink"],
                tables: ["tableWizard", "createTable", "addColumnLeft", "addColumnRight", "addRowAbove", "addRowBelow", "deleteRow", "deleteColumn", "mergeCellsHorizontally", "mergeCellsVertically", "splitCellHorizontally", "splitCellVertically"]
            },
            N = l.extend({
                init: function(n, i) {
                    var o, r, s, d, c, m, h = this,
                        g = a.ui.editor,
                        b = g.Dom;
                    T && (l.fn.init.call(h, n, i), h.options = p({}, h.options, i), h.options.tools = h.options.tools.slice(), n = h.element, m = n[0], d = b.name(m), this._registerHandler(n.closest("form"), "submit", f(h.update, h, t)), s = u({}, h.options), s.editor = h, "textarea" == d ? (h._wrapTextarea(), r = h.wrapper.find(".k-editor-toolbar"), m.id && r.attr("aria-controls", m.id)) : (h.element.attr("contenteditable", !0).addClass("k-widget k-editor k-editor-inline"), s.popup = !0, r = e('<ul class="k-editor-toolbar" role="toolbar" />').insertBefore(n)), h.toolbar = new g.Toolbar(r[0], s), h.toolbar.bindTo(h), "textarea" == d && setTimeout(function() {
                        var e = h.wrapper[0].style.height,
                            t = parseInt(e, 10),
                            n = h.wrapper.height();
                        e.indexOf("px") > 0 && !isNaN(t) && n > t && h.wrapper.height(t - (n - t))
                    }), h._resizable(), h._initializeContentElement(h), h.keyboard = new g.Keyboard([new g.BackspaceHandler(h), new g.TypingHandler(h), new g.SystemHandler(h), new g.SelectAllHandler(h)]), h.clipboard = new g.Clipboard(this), h.undoRedoStack = new a.util.UndoRedoStack, i && i.value ? o = i.value : h.textarea ? (o = m.value, h.options.encoded && e.trim(m.defaultValue).length && (o = m.defaultValue), c = b.getAllComments(e("<div></div>").html(o)[0]), o = C.cacheComments(o, c), o = o.replace(/[\r\n\v\f\t ]+/gi, " "), o = C.retrieveComments(o, c)) : o = m.innerHTML, h.value(o || "\ufeff"), this._registerHandler(document, {
                        mousedown: function() {
                            h._endTyping()
                        },
                        mouseup: function(e) {
                            h._mouseup(e)
                        }
                    }), h._initializeImmutables(), h.toolbar.resize(), a.notify(h))
                },
                setOptions: function(e) {
                    var t = this;
                    l.fn.setOptions.call(t, e), e.tools && t.toolbar.bindTo(t), this._initializePlaceholder()
                },
                _togglePlaceholder: function(t) {
                    var n = this,
                        i = n.body,
                        o = e(i),
                        r = n.options.placeholder;
                    n.textarea && r && (o.attr("aria-label", function() {
                        return t ? r : ""
                    }), o.toggleClass(b, t))
                },
                _endTyping: function() {
                    var e = this.keyboard;
                    try {
                        e.isTypingInProgress() && (e.endTyping(!0), this.saveSelection())
                    } catch (t) {}
                },
                _selectionChange: function() {
                    this._selectionStarted = !1, this.saveSelection(), this.trigger("select", {})
                },
                _resizable: function() {
                    var n, i, o = this.options.resizable,
                        r = e.isPlainObject(o) ? o.content === t || o.content === !0 : o;
                    r && this.textarea && (n = e("<div class='k-resize-handle'><span class='k-icon k-i-arrow-45-down-right' /></div>").insertAfter(this.textarea), this.wrapper.addClass("k-resizable"), this.wrapper.kendoResizable(u({}, this.options.resizable, {
                        draggableElement: n,
                        start: function(t) {
                            var n = this.editor = e(t.currentTarget).closest(".k-editor");
                            this.initialSize = n.height(), n.find("td:last").append("<div class='k-overlay' />")
                        },
                        resize: function(e) {
                            var t = e.y.initialDelta,
                                n = this.initialSize + t,
                                i = this.options.min || 0,
                                o = this.options.max || 1 / 0;
                            n = Math.min(o, Math.max(i, n)), this.editor.height(n)
                        },
                        resizeend: function() {
                            this.editor.find(".k-overlay").remove(), this.editor = null
                        }
                    })), a.support.mobileOS.ios && (i = this.wrapper.getKendoResizable(), i.draggable.options.ignore = g))
                },
                _initializeTableResizing: function() {
                    var e = this;
                    a.ui.editor.TableResizing.create(e), e._showTableResizeHandlesProxy = f(e._showTableResizeHandles, e), e.bind(h, e._showTableResizeHandlesProxy)
                },
                _destroyTableResizing: function() {
                    var e = this,
                        t = e.tableResizing;
                    t && (t.destroy(), e.tableResizing = null), e._showTableResizeHandlesProxy && e.unbind(h, e._showTableResizeHandlesProxy)
                },
                _showTableResizeHandles: function() {
                    var e = this,
                        t = e.tableResizing;
                    t && t.showResizeHandles()
                },
                _initializeColumnResizing: function() {
                    a.ui.editor.ColumnResizing.create(this)
                },
                _destroyColumnResizing: function() {
                    var e = this;
                    e.columnResizing && (e.columnResizing.destroy(), e.columnResizing = null)
                },
                _initializeRowResizing: function() {
                    a.ui.editor.RowResizing.create(this)
                },
                _destroyRowResizing: function() {
                    var e = this;
                    e.rowResizing && (e.rowResizing.destroy(), e.rowResizing = null)
                },
                _wrapTextarea: function() {
                    var t = this,
                        n = t.element,
                        i = n[0].style.width,
                        o = n[0].style.height,
                        r = C.editorWrapperTemplate,
                        a = e(r).insertBefore(n).width(i).height(o),
                        s = a.find(".k-editable-area");
                    n.attr("autocomplete", "off").appendTo(s).addClass("k-content k-raw-content").css("display", "none"), t.textarea = n, t.wrapper = a
                },
                _createContentElement: function(t) {
                    var n, i, o, r = this,
                        s = r.textarea,
                        l = r.options.domain,
                        c = l || document.domain,
                        u = "",
                        f = 'javascript:""',
                        p = "";
                    return s.hide(), n = e("<iframe />", {
                        title: r.options.messages.editAreaTitle,
                        frameBorder: "0"
                    })[0], e(n).css("display", "").addClass("k-content").attr("tabindex", s[0].tabIndex).insertBefore(s), (l || c != location.hostname) && (u = '<script>document.domain="' + c + '"</script>', f = "javascript:document.write('" + u + "')", n.src = f), i = n.contentWindow || n, o = i.document || n.contentDocument, e(n).one("load", function() {
                        r.toolbar.decorateFrom(o.body)
                    }), p = document.getElementsByTagName("html")[0].getAttribute("lang") || k, o.open(), o.write("<!DOCTYPE html><html lang='" + p + "'><head><meta charset='utf-8' /><title>Kendo UI Editor content</title><style>html{padding:0;margin:0;height:100%;min-height:100%;cursor:text;}body{padding:0;margin:0;}body{box-sizing:border-box;font-size:12px;font-family:Verdana,Geneva,sans-serif;margin-top:-1px;padding:5px .4em 0;word-wrap: break-word;-webkit-nbsp-mode: space;-webkit-line-break: after-white-space;" + (a.support.isRtl(s) ? "direction:rtl;" : "") + (d.ios ? "word-break:keep-all;" : "") + "}h1{font-size:2em;margin:.67em 0}h2{font-size:1.5em}h3{font-size:1.16em}h4{font-size:1em}h5{font-size:.83em}h6{font-size:.7em}p{margin:0 0 1em;}.k-marker{display:none;}.k-paste-container,.Apple-style-span{position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden}ul,ol{padding-left:2.5em}span{-ms-high-contrast-adjust:none;}a{color:#00a}code{font-size:1.23em}telerik\\3Ascript{display: none;}.k-table{width:100%;border-spacing:0;margin: 0 0 1em;}.k-table td{min-width:1px;padding:.2em .3em;}.k-table,.k-table td{outline:0;border: 1px dotted #ccc;}.k-table th{outline:0;border: 1px dotted #999;}.k-table p{margin:0;padding:0;}.k-column-resize-handle-wrapper {position: absolute; height: 10px; width:10px; cursor: col-resize; z-index: 2;}.k-column-resize-handle {width: 100%; height: 100%;}.k-column-resize-handle > .k-column-resize-marker {width:2px; height:100%; margin:0 auto; background-color:#00b0ff; display:none; opacity:0.8;}.k-row-resize-handle-wrapper {position: absolute; cursor: row-resize; z-index:2; width: 10px; height: 10px;}.k-row-resize-handle {display: table; width: 100%; height: 100%;}.k-row-resize-marker-wrapper{display: table-cell; height:100%; width:100%; margin:0; padding:0; vertical-align: middle;}.k-row-resize-marker{margin: 0; padding:0; width:100%; height:2px; background-color: #00b0ff; opacity:0.8; display:none;}.k-table-resize-handle-wrapper {position: absolute; background-color: #fff; border: 1px solid #000; z-index: 100; width: 5px; height: 5px;}.k-table-resize-handle {width: 100%; height: 100%;}.k-table-resize-handle.k-resize-east{cursor:e-resize;}.k-table-resize-handle.k-resize-north{cursor:n-resize;}.k-table-resize-handle.k-resize-northeast{cursor:ne-resize;}.k-table-resize-handle.k-resize-northwest{cursor:nw-resize;}.k-table-resize-handle.k-resize-south{cursor:s-resize;}.k-table-resize-handle.k-resize-southeast{cursor:se-resize;}.k-table-resize-handle.k-resize-southwest{cursor:sw-resize;}.k-table-resize-handle.k-resize-west{cursor:w-resize;}.k-table.k-table-resizing{opacity:0.6;}.k-placeholder{color:grey}k\\:script{display:none;}</style>" + u + e.map(t, function(e) {
                        return "<link rel='stylesheet' href='" + e + "'>"
                    }).join("") + "</head><body autocorrect='off' contenteditable='true'></body></html>"), o.close(), i
                },
                _blur: function() {
                    var e = this.textarea,
                        t = e ? e.val() : this._oldValue,
                        n = this.options.encoded ? this.encodedValue() : this.value();
                    this.update(), e && e.trigger("blur"), n != t && (this.trigger("change"), e && e.trigger("change"))
                },
                _spellCorrect: function(e) {
                    var n, i = !1;
                    this._registerHandler(e.body, {
                        contextmenu: function() {
                            e.one("select", function() {
                                n = null
                            }), e._spellCorrectTimeout = setTimeout(function() {
                                n = new a.ui.editor.RestorePoint(e.getRange(), e.body), i = !1
                            }, 10)
                        },
                        input: function() {
                            if (n) return a.support.browser.mozilla && !i ? (i = !0, t) : (a.ui.editor._finishUpdate(e, n), t)
                        }
                    })
                },
                _registerHandler: function(t, n, i) {
                    var o, r, s, l = this,
                        d = ".kendoEditor";
                    if (t = e(t), this._handlers || (this._handlers = []), t.length)
                        if (e.isPlainObject(n))
                            for (s in n) n.hasOwnProperty(s) && this._registerHandler(t, s, n[s]);
                        else
                            for (o = a.applyEventMap(n).split(" "), r = 0; r < o.length; r++) l._handlers.push({
                                element: t,
                                type: o[r] + d,
                                handler: i
                            }), t.on(o[r] + d, i)
                },
                _deregisterHandlers: function() {
                    var e, t, n = this._handlers;
                    for (e = 0; e < n.length; e++) t = n[e], t.element.off(t.type, t.handler);
                    this._handlers = []
                },
                _initializeContentElement: function() {
                    var n, i, o, r, s, l = this;
                    l.textarea ? (l.window = l._createContentElement(l.options.stylesheets), n = l.document = l.window.contentDocument || l.window.document, n.body || (r = n.createElement("body"), r.setAttribute("contenteditable", "true"), r.setAttribute("autocorrect", "off"), n.getElementsByTagName("html")[0].appendChild(r), s = setInterval(function() {
                        e(l.document).find("body").length > 1 && (e(l.document).find("body:last").remove(), window.clearInterval(s))
                    }, 10)), l.body = n.body, i = l.window, o = n, this._registerHandler(n, "mouseup", f(this._mouseup, this))) : (l.window = window, n = l.document = document, l.body = l.element[0], i = l.body, o = l.body, l.toolbar.decorateFrom(l.body)), this._registerHandler(i, "blur", f(this._blur, this)), l._registerHandler(o, "down", f(l._mousedown, l));
                    try {
                        n.execCommand("enableInlineTableEditing", null, !1)
                    } catch (d) {}
                    a.support.touch && this._registerHandler(n, {
                        keydown: function() {
                            a._activeElement() != n.body && l.window.focus()
                        }
                    }), this._initializePlaceholder(), this._spellCorrect(l), this._registerHandler(l.body, {
                        keydown: function(e) {
                            var n, i, o, r, a, s, d, c, u, p;
                            return (e.keyCode !== m.BACKSPACE && e.keyCode !== m.DELETE || "true" === l.body.getAttribute("contenteditable")) && (e.keyCode === m.F10 ? (setTimeout(f(l.toolbar.focus, l.toolbar), 100), l.toolbar.preventPopupHide = !0, e.preventDefault(), t) : (e.keyCode != m.LEFT && e.keyCode != m.RIGHT || (n = l.getRange(), i = e.keyCode == m.LEFT, o = n[i ? "startContainer" : "endContainer"], r = n[i ? "startOffset" : "endOffset"], a = i ? -1 : 1, s = r + a, d = i ? s : r, 3 == o.nodeType && "\ufeff" == o.nodeValue[d] && (n.setStart(o, s), n.collapse(!0), l.selectRange(n))), c = l.toolbar.tools, u = l.keyboard.toolFromShortcut(c, e), p = u ? c[u].options : {}, u && !p.keyPressCommand ? (e.preventDefault(), /^(undo|redo)$/.test(u) || l.keyboard.endTyping(!0), l.trigger("keydown", e), l.exec(u), l._runPostContentKeyCommands(e), !1) : (l.keyboard.clearTimeout(), l.keyboard.keydown(e), t)))
                        },
                        keypress: function(e) {
                            setTimeout(function() {
                                l._runPostContentKeyCommands(e), l._showTableResizeHandles()
                            }, 0)
                        },
                        keyup: function(t) {
                            var n = [m.BACKSPACE, m.TAB, m.PAGEUP, m.PAGEDOWN, m.END, m.HOME, m.LEFT, m.UP, m.RIGHT, m.DOWN, m.INSERT, m.DELETE];
                            (e.inArray(t.keyCode, n) > -1 || 65 == t.keyCode && t.ctrlKey && !t.altKey && !t.shiftKey) && (window.clearTimeout(this._refreshInterval), this._refreshInterval = window.setTimeout(function() {
                                l._selectionChange()
                            }, y)), l.keyboard.keyup(t)
                        },
                        click: function(e) {
                            var t, n = a.ui.editor.Dom;
                            "img" === n.name(e.target) && (t = l.createRange(), t.selectNode(e.target), l.selectRange(t))
                        },
                        "cut copy paste drop dragover": function(e) {
                            l.clipboard["on" + e.type](e)
                        },
                        focusin: function() {
                            l.body.hasAttribute("contenteditable") && (e(this).addClass("k-state-active"), l.toolbar.show(), l._togglePlaceholder(!1))
                        },
                        focusout: function() {
                            setTimeout(function() {
                                var t, n = a._activeElement(),
                                    i = l.body,
                                    o = l.toolbar;
                                o.options.popup && (t = o.window.element.get(0), t && !e.contains(t, n) && t != n && (o.preventPopupHide = !1)), n == i || e.contains(i, n) || e(n).is(".k-editortoolbar-dragHandle") || o.focused() || (e(i).removeClass("k-state-active"), o.hide()), l._togglePlaceholder(!l.value().trim())
                            }, 10)
                        }
                    }), l._initializeColumnResizing(), l._initializeRowResizing(), l._initializeTableResizing()
                },
                _initializePlaceholder: function() {
                    var t, n, i = this,
                        o = i.options.placeholder;
                    i.textarea && o && (t = "<style id='" + v + "'>." + b + ":before { content: '" + o + "'; }</style>", n = e(i.document.head), n.find("#" + v).remove(), n.append(t), i._togglePlaceholder(!i.value().trim()))
                },
                _initializeImmutables: function() {
                    var e = this,
                        t = a.ui.editor;
                    e.options.immutables && (e.immutables = new t.Immutables(e))
                },
                _mousedown: function(t) {
                    var n, i = this;
                    i._selectionStarted = !0, e(i.body).parents(".k-window").length && t.stopPropagation(), c.gecko || (n = e(t.target).closest("a[href]"), (2 == t.which || 1 == t.which && t.ctrlKey) && n && n.is("a[href]") && window.open(n.attr("href"), "_new"), t.target.tagName && "html" === t.target.tagName.toLowerCase() && setTimeout(function() {
                        i.body.focus()
                    }, 0))
                },
                _mouseup: function(t) {
                    var n = this;
                    a.support.mobileOS.ios && t && e(t.target).is(g) || n._selectionStarted && setTimeout(function() {
                        n._selectionChange()
                    }, 1)
                },
                _runPostContentKeyCommands: function(e) {
                    var t, n, i, o, r = this.getRange(),
                        a = this.keyboard.toolsFromShortcut(this.toolbar.tools, e);
                    for (t = 0; t < a.length; t++) n = a[t], i = n.options, i.keyPressCommand && (o = new i.command({
                        range: r
                    }), o.changesContent() && (this.keyboard.endTyping(!0), this.exec(n.name)))
                },
                refresh: function() {
                    var e, t = this;
                    t.textarea && (t._destroyResizings(), e = t.value(), t.textarea.val(e), t.wrapper.find("iframe").remove(), t._initializeContentElement(t), t.value(e))
                },
                events: ["select", "change", "execute", "error", "paste", "keydown", "keyup"],
                options: {
                    name: "Editor",
                    messages: x,
                    placeholder: "",
                    formats: {},
                    encoded: !0,
                    domain: null,
                    resizable: !1,
                    deserialization: {
                        custom: null
                    },
                    serialization: {
                        entities: !0,
                        semantic: !0,
                        scripts: !1
                    },
                    pasteCleanup: {
                        all: !1,
                        css: !1,
                        custom: null,
                        keepNewLines: !1,
                        msAllFormatting: !1,
                        msConvertLists: !0,
                        msTags: !0,
                        none: !1,
                        span: !1
                    },
                    stylesheets: [],
                    dialogOptions: {
                        modal: !0,
                        resizable: !1,
                        draggable: !0,
                        animation: !1
                    },
                    imageBrowser: null,
                    fileBrowser: null,
                    fontName: [{
                        text: "Arial",
                        value: "Arial, Helvetica, sans-serif"
                    }, {
                        text: "Courier New",
                        value: '"Courier New", Courier, monospace'
                    }, {
                        text: "Georgia",
                        value: "Georgia, serif"
                    }, {
                        text: "Impact",
                        value: "Impact, Charcoal, sans-serif"
                    }, {
                        text: "Lucida Console",
                        value: '"Lucida Console", Monaco, monospace'
                    }, {
                        text: "Tahoma",
                        value: "Tahoma, Geneva, sans-serif"
                    }, {
                        text: "Times New Roman",
                        value: '"Times New Roman", Times, serif'
                    }, {
                        text: "Trebuchet MS",
                        value: '"Trebuchet MS", Helvetica, sans-serif'
                    }, {
                        text: "Verdana",
                        value: "Verdana, Geneva, sans-serif"
                    }],
                    fontSize: [{
                        text: "1 (8pt)",
                        value: "xx-small"
                    }, {
                        text: "2 (10pt)",
                        value: "x-small"
                    }, {
                        text: "3 (12pt)",
                        value: "small"
                    }, {
                        text: "4 (14pt)",
                        value: "medium"
                    }, {
                        text: "5 (18pt)",
                        value: "large"
                    }, {
                        text: "6 (24pt)",
                        value: "x-large"
                    }, {
                        text: "7 (36pt)",
                        value: "xx-large"
                    }],
                    formatBlock: [{
                        text: "Paragraph",
                        value: "p"
                    }, {
                        text: "Quotation",
                        value: "blockquote"
                    }, {
                        text: "Heading 1",
                        value: "h1"
                    }, {
                        text: "Heading 2",
                        value: "h2"
                    }, {
                        text: "Heading 3",
                        value: "h3"
                    }, {
                        text: "Heading 4",
                        value: "h4"
                    }, {
                        text: "Heading 5",
                        value: "h5"
                    }, {
                        text: "Heading 6",
                        value: "h6"
                    }],
                    tools: [].concat.call(["formatting"], _.basic, _.alignment, _.formatPainter, _.lists, _.indenting, _.links, ["insertImage"], _.tables)
                },
                destroy: function() {
                    var e = this;
                    l.fn.destroy.call(this), this._endTyping(!0), this._deregisterHandlers(), clearTimeout(this._spellCorrectTimeout), this._focusOutside(), this.toolbar.destroy(), e._destroyUploadWidget(), e._destroyResizings(), a.destroy(this.wrapper)
                },
                _destroyResizings: function() {
                    var e = this;
                    e._destroyTableResizing(), a.ui.editor.TableResizing.dispose(e), e._destroyRowResizing(), a.ui.editor.RowResizing.dispose(e), e._destroyColumnResizing(), a.ui.editor.ColumnResizing.dispose(e)
                },
                _focusOutside: function() {
                    if (a.support.browser.msie && this.textarea) {
                        var t = e("<input style='position:fixed;left:1px;top:1px;width:1px;height:1px;font-size:0;border:0;opacity:0' />").appendTo(document.body).focus();
                        t.blur().remove()
                    }
                },
                _destroyUploadWidget: function() {
                    var e = this;
                    e._uploadWidget && (e._uploadWidget.destroy(), e._uploadWidget = null)
                },
                state: function(e) {
                    var t, n, i = N.defaultTools[e],
                        o = i && (i.options.finder || i.finder),
                        r = a.ui.editor.RangeUtils;
                    return !!o && (t = this.getRange(), n = r.textNodes(t), !n.length && t.collapsed && (n = [t.startContainer]), o.getFormat ? o.getFormat(n) : o.isFormatted(n))
                },
                value: function(e) {
                    var n = this.body,
                        i = a.ui.editor,
                        o = this.options,
                        r = i.Serializer.domToXhtml(n, o.serialization);
                    return e === t ? r : (e != r && (i.Serializer.htmlToDom(e, n, o.deserialization), this.selectionRestorePoint = null, this.update(), this.toolbar.refreshTools()), t)
                },
                saveSelection: function(t) {
                    t = t || this.getRange();
                    var n = t.commonAncestorContainer,
                        i = this.body;
                    (n == i || e.contains(i, n)) && (this.selectionRestorePoint = new a.ui.editor.RestorePoint(t, i))
                },
                _focusBody: function() {
                    var e, t = this.body,
                        n = this.wrapper && this.wrapper.find("iframe")[0],
                        i = this.document.documentElement,
                        o = a._activeElement();
                    !n && t.scrollHeight > t.clientHeight ? (e = t.scrollTop, t.focus(), t.scrollTop = e) : o != t && o != n && (e = i.scrollTop, t.focus(), i.scrollTop = e)
                },
                restoreSelection: function() {
                    this._focusBody(), this.selectionRestorePoint && this.selectRange(this.selectionRestorePoint.toRange())
                },
                focus: function() {
                    this.restoreSelection()
                },
                update: function(e) {
                    e = e || this.options.encoded ? this.encodedValue() : this.value(), this.textarea ? (this.textarea.val(e), this._togglePlaceholder(!e.trim())) : this._oldValue = e
                },
                encodedValue: function() {
                    return a.ui.editor.Dom.encode(this.value())
                },
                createRange: function(e) {
                    return a.ui.editor.RangeUtils.createRange(e || this.document)
                },
                getSelection: function() {
                    return a.ui.editor.SelectionUtils.selectionFromDocument(this.document)
                },
                selectRange: function(e) {
                    this._focusBody();
                    var t = this.getSelection();
                    t.removeAllRanges(), t.addRange(e), this.saveSelection(e)
                },
                getRange: function() {
                    var e = this.getSelection(),
                        t = e && e.rangeCount > 0 ? e.getRangeAt(0) : this.createRange(),
                        n = this.document;
                    return t.startContainer != n || t.endContainer != n || t.startOffset || t.endOffset || (t.setStart(this.body, 0), t.collapse(!0)), t
                },
                _containsRange: function(e) {
                    var t = a.ui.editor.Dom,
                        n = this.body;
                    return e && t.isAncestorOrSelf(n, e.startContainer) && t.isAncestorOrSelf(n, e.endContainer)
                },
                _deleteSavedRange: function() {
                    "_range" in this && delete this._range
                },
                selectedHtml: function() {
                    return a.ui.editor.Serializer.domToXhtml(this.getRange().cloneContents())
                },
                paste: function(t, n) {
                    this.focus();
                    var i = new a.ui.editor.InsertHtmlCommand(e.extend({
                        range: this.getRange(),
                        html: t
                    }, n));
                    i.editor = this, i.exec()
                },
                exec: function(e, n) {
                    var i, o, r, a, s = this,
                        l = null;
                    if (!e) throw Error("kendoEditor.exec(): `name` parameter cannot be empty");
                    if ("true" !== s.body.getAttribute("contenteditable") && "print" !== e && "pdf" !== e && "exportAs" !== e) return !1;
                    if (e = e.toLowerCase(), s.keyboard.isTypingInProgress() || (s._focusBody(), s.selectRange(s._range || s.getRange())), o = s.toolbar.toolById(e), !o)
                        for (a in N.defaultTools)
                            if (a.toLowerCase() == e) {
                                o = N.defaultTools[a];
                                break
                            }
                    if (o) {
                        if (i = s.getRange(), o.command && (l = o.command(u({
                                range: i,
                                body: s.body,
                                immutables: !!s.immutables
                            }, n))), r = s.trigger("execute", {
                                name: e,
                                command: l
                            })) return;
                        if (/^(undo|redo)$/i.test(e)) s.undoRedoStack[e]();
                        else if (l && (s.execCommand(l), l.async)) return l.change = f(s._selectionChange, s), t;
                        s._selectionChange()
                    }
                },
                execCommand: function(e) {
                    e.managesUndoRedo || this.undoRedoStack.push(e), e.editor = this, e.exec()
                }
            });
        N.defaultTools = {
            undo: {
                options: {
                    key: "Z",
                    ctrl: !0
                }
            },
            redo: {
                options: {
                    key: "Y",
                    ctrl: !0
                }
            }
        }, a.ui.plugin(N), n = s.extend({
            init: function(e) {
                this.options = e
            },
            initialize: function(e, t) {
                e.attr({
                    unselectable: "on",
                    title: t.title,
                    "aria-label": t.title
                })
            },
            command: function(e) {
                return new this.options.command(e)
            },
            update: e.noop
        }), n.exec = function(e, t, n) {
            e.exec(t, {
                value: n
            })
        }, C.registerTool("separator", new n({
            template: new w({
                template: C.separatorTemplate
            })
        })), i = c.msie && c.version < 9 ? "\ufeff" : "", o = "\ufeff", r = o, (c.msie || c.edge) && (r = o = "&nbsp;"), u(a.ui, {
            editor: {
                ToolTemplate: w,
                EditorUtils: C,
                Tool: n,
                _bomFill: i,
                emptyElementContent: o,
                emptyTableCellContent: r
            }
        }), a.PDFMixin && (a.PDFMixin.extend(N.prototype), N.prototype._drawPDF = function() {
            return a.drawing.drawDOM(this.body, this.options.pdf)
        }, N.prototype.saveAsPDF = function() {
            var t, n = new e.Deferred,
                i = n.promise(),
                o = {
                    promise: i
                };
            if (!this.trigger("pdfExport", o)) return t = this.options.pdf, this._drawPDF(n).then(function(e) {
                return a.drawing.exportPDF(e, t)
            }).done(function(e) {
                a.saveAs({
                    dataURI: e,
                    fileName: t.fileName,
                    proxyURL: t.proxyURL,
                    proxyTarget: t.proxyTarget,
                    forceProxy: t.forceProxy
                }), n.resolve()
            }).fail(function(e) {
                n.reject(e)
            }), i
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/dom.min", ["editor/main.min"], e)
}(function() {
    ! function(e) {
        function t(e) {
            var t, n, i = {};
            for (t = 0, n = e.length; t < n; t++) i[e[t]] = !0;
            return i
        }
        var n, i, o, r, a, s, l, d, c, u, f, p = window.kendo,
            m = e.map,
            h = e.extend,
            g = p.support.browser,
            b = "style",
            v = "float",
            y = "cssFloat",
            k = "styleFloat",
            w = "class",
            C = "k-marker",
            x = t("area,base,basefont,br,col,frame,hr,img,input,isindex,link,meta,param,embed".split(",")),
            T = "p,div,h1,h2,h3,h4,h5,h6,address,applet,blockquote,button,center,dd,dir,dl,dt,fieldset,form,frameset,hr,iframe,isindex,map,menu,noframes,noscript,object,pre,script,table,tbody,td,tfoot,th,thead,tr,header,article,nav,footer,section,aside,main,figure,figcaption".split(","),
            _ = T.concat(["ul", "ol", "li"]),
            N = t(_),
            S = t("area,base,br,col,command,embed,hr,img,input,keygen,link,menuitem,meta,param,source,track,wbr".split(",")),
            R = "span,em,a,abbr,acronym,applet,b,basefont,bdo,big,br,button,cite,code,del,dfn,font,i,iframe,img,input,ins,kbd,label,map,object,q,s,samp,script,select,small,strike,strong,sub,sup,textarea,tt,u,var,data,time,mark,ruby".split(","),
            A = t(R),
            z = t("checked,compact,declare,defer,disabled,ismap,multiple,nohref,noresize,noshade,nowrap,readonly,selected".split(",")),
            E = function(e) {
                1 == e.nodeType && e.normalize()
            };
        g.msie && g.version >= 8 && (E = function(e) {
            if (1 == e.nodeType && e.firstChild) {
                var t = e.firstChild,
                    n = t;
                for (E(n);;) {
                    if (n = n.nextSibling, !n) break;
                    E(n), 3 == n.nodeType && 3 == t.nodeType && (n.nodeValue = t.nodeValue + n.nodeValue, f.remove(t)), t = n
                }
            }
        }), n = /^\s+$/, i = /^[\n\r\t]+$/, o = /rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/i, r = /\ufeff/g, a = /^(\s+|\ufeff)$/, l = "color,padding-left,padding-right,padding-top,padding-bottom,background-color,background-attachment,background-image,background-position,background-repeat,border-top-style,border-top-width,border-top-color,border-bottom-style,border-bottom-width,border-bottom-color,border-left-style,border-left-width,border-left-color,border-right-style,border-right-width,border-right-color,font-family,font-size,font-style,font-variant,font-weight,line-height".split(","), d = /[<>\&]/g, c = /[\u00A0-\u2666<>\&]/g, u = {
            34: "quot",
            38: "amp",
            39: "apos",
            60: "lt",
            62: "gt",
            160: "nbsp",
            161: "iexcl",
            162: "cent",
            163: "pound",
            164: "curren",
            165: "yen",
            166: "brvbar",
            167: "sect",
            168: "uml",
            169: "copy",
            170: "ordf",
            171: "laquo",
            172: "not",
            173: "shy",
            174: "reg",
            175: "macr",
            176: "deg",
            177: "plusmn",
            178: "sup2",
            179: "sup3",
            180: "acute",
            181: "micro",
            182: "para",
            183: "middot",
            184: "cedil",
            185: "sup1",
            186: "ordm",
            187: "raquo",
            188: "frac14",
            189: "frac12",
            190: "frac34",
            191: "iquest",
            192: "Agrave",
            193: "Aacute",
            194: "Acirc",
            195: "Atilde",
            196: "Auml",
            197: "Aring",
            198: "AElig",
            199: "Ccedil",
            200: "Egrave",
            201: "Eacute",
            202: "Ecirc",
            203: "Euml",
            204: "Igrave",
            205: "Iacute",
            206: "Icirc",
            207: "Iuml",
            208: "ETH",
            209: "Ntilde",
            210: "Ograve",
            211: "Oacute",
            212: "Ocirc",
            213: "Otilde",
            214: "Ouml",
            215: "times",
            216: "Oslash",
            217: "Ugrave",
            218: "Uacute",
            219: "Ucirc",
            220: "Uuml",
            221: "Yacute",
            222: "THORN",
            223: "szlig",
            224: "agrave",
            225: "aacute",
            226: "acirc",
            227: "atilde",
            228: "auml",
            229: "aring",
            230: "aelig",
            231: "ccedil",
            232: "egrave",
            233: "eacute",
            234: "ecirc",
            235: "euml",
            236: "igrave",
            237: "iacute",
            238: "icirc",
            239: "iuml",
            240: "eth",
            241: "ntilde",
            242: "ograve",
            243: "oacute",
            244: "ocirc",
            245: "otilde",
            246: "ouml",
            247: "divide",
            248: "oslash",
            249: "ugrave",
            250: "uacute",
            251: "ucirc",
            252: "uuml",
            253: "yacute",
            254: "thorn",
            255: "yuml",
            402: "fnof",
            913: "Alpha",
            914: "Beta",
            915: "Gamma",
            916: "Delta",
            917: "Epsilon",
            918: "Zeta",
            919: "Eta",
            920: "Theta",
            921: "Iota",
            922: "Kappa",
            923: "Lambda",
            924: "Mu",
            925: "Nu",
            926: "Xi",
            927: "Omicron",
            928: "Pi",
            929: "Rho",
            931: "Sigma",
            932: "Tau",
            933: "Upsilon",
            934: "Phi",
            935: "Chi",
            936: "Psi",
            937: "Omega",
            945: "alpha",
            946: "beta",
            947: "gamma",
            948: "delta",
            949: "epsilon",
            950: "zeta",
            951: "eta",
            952: "theta",
            953: "iota",
            954: "kappa",
            955: "lambda",
            956: "mu",
            957: "nu",
            958: "xi",
            959: "omicron",
            960: "pi",
            961: "rho",
            962: "sigmaf",
            963: "sigma",
            964: "tau",
            965: "upsilon",
            966: "phi",
            967: "chi",
            968: "psi",
            969: "omega",
            977: "thetasym",
            978: "upsih",
            982: "piv",
            8226: "bull",
            8230: "hellip",
            8242: "prime",
            8243: "Prime",
            8254: "oline",
            8260: "frasl",
            8472: "weierp",
            8465: "image",
            8476: "real",
            8482: "trade",
            8501: "alefsym",
            8592: "larr",
            8593: "uarr",
            8594: "rarr",
            8595: "darr",
            8596: "harr",
            8629: "crarr",
            8656: "lArr",
            8657: "uArr",
            8658: "rArr",
            8659: "dArr",
            8660: "hArr",
            8704: "forall",
            8706: "part",
            8707: "exist",
            8709: "empty",
            8711: "nabla",
            8712: "isin",
            8713: "notin",
            8715: "ni",
            8719: "prod",
            8721: "sum",
            8722: "minus",
            8727: "lowast",
            8730: "radic",
            8733: "prop",
            8734: "infin",
            8736: "ang",
            8743: "and",
            8744: "or",
            8745: "cap",
            8746: "cup",
            8747: "int",
            8756: "there4",
            8764: "sim",
            8773: "cong",
            8776: "asymp",
            8800: "ne",
            8801: "equiv",
            8804: "le",
            8805: "ge",
            8834: "sub",
            8835: "sup",
            8836: "nsub",
            8838: "sube",
            8839: "supe",
            8853: "oplus",
            8855: "otimes",
            8869: "perp",
            8901: "sdot",
            8968: "lceil",
            8969: "rceil",
            8970: "lfloor",
            8971: "rfloor",
            9001: "lang",
            9002: "rang",
            9674: "loz",
            9824: "spades",
            9827: "clubs",
            9829: "hearts",
            9830: "diams",
            338: "OElig",
            339: "oelig",
            352: "Scaron",
            353: "scaron",
            376: "Yuml",
            710: "circ",
            732: "tilde",
            8194: "ensp",
            8195: "emsp",
            8201: "thinsp",
            8204: "zwnj",
            8205: "zwj",
            8206: "lrm",
            8207: "rlm",
            8211: "ndash",
            8212: "mdash",
            8216: "lsquo",
            8217: "rsquo",
            8218: "sbquo",
            8220: "ldquo",
            8221: "rdquo",
            8222: "bdquo",
            8224: "dagger",
            8225: "Dagger",
            8240: "permil",
            8249: "lsaquo",
            8250: "rsaquo",
            8364: "euro"
        }, f = {
            block: N,
            inline: A,
            findNodeIndex: function(e, t) {
                var n = 0;
                if (!e) return -1;
                for (;;) {
                    if (e = e.previousSibling, !e) break;
                    t && 3 == e.nodeType || n++
                }
                return n
            },
            isDataNode: function(e) {
                return e && null !== e.nodeValue && null !== e.data
            },
            isAncestorOf: function(t, n) {
                try {
                    return !f.isDataNode(t) && (e.contains(t, f.isDataNode(n) ? n.parentNode : n) || n.parentNode == t)
                } catch (i) {
                    return !1
                }
            },
            isAncestorOrSelf: function(e, t) {
                return f.isAncestorOf(e, t) || e == t
            },
            findClosestAncestor: function(e, t) {
                if (f.isAncestorOf(e, t))
                    for (; t && t.parentNode != e;) t = t.parentNode;
                return t
            },
            getAllComments: function(e) {
                for (var t = [], n = document.createNodeIterator(e, NodeFilter.SHOW_COMMENT, function() {
                        return NodeFilter.FILTER_ACCEPT
                    }, !1), i = n.nextNode(); i;) t.push(i.nodeValue), i = n.nextNode();
                return t
            },
            getNodeLength: function(e) {
                return f.isDataNode(e) ? e.length : e.childNodes.length
            },
            splitDataNode: function(e, t) {
                for (var n, i = e.cloneNode(!1), o = "", r = e.nextSibling; r && 3 == r.nodeType && r.nodeValue;) o += r.nodeValue, n = r, r = r.nextSibling, f.remove(n);
                e.deleteData(t, e.length), i.deleteData(0, t), i.nodeValue += o, f.insertAfter(i, e)
            },
            attrEquals: function(e, t) {
                var n, i;
                for (n in t)
                    if (i = e[n], n == v && (i = e[p.support.cssFloat ? y : k]), "object" == typeof i) {
                        if (!f.attrEquals(i, t[n])) return !1
                    } else if (i != t[n]) return !1;
                return !0
            },
            blockParentOrBody: function(e) {
                return f.parentOfType(e, _) || e.ownerDocument.body
            },
            blockParents: function(t) {
                var n, i, o, r = [];
                for (n = 0, i = t.length; n < i; n++) o = f.parentOfType(t[n], f.blockElements), o && e.inArray(o, r) < 0 && r.push(o);
                return r
            },
            windowFromDocument: function(e) {
                return e.defaultView || e.parentWindow
            },
            normalize: E,
            blockElements: _,
            nonListBlockElements: T,
            inlineElements: R,
            empty: x,
            fillAttrs: z,
            nodeTypes: {
                ELEMENT_NODE: 1,
                ATTRIBUTE_NODE: 2,
                TEXT_NODE: 3,
                CDATA_SECTION_NODE: 4,
                ENTITY_REFERENCE_NODE: 5,
                ENTITY_NODE: 6,
                PROCESSING_INSTRUCTION_NODE: 7,
                COMMENT_NODE: 8,
                DOCUMENT_NODE: 9,
                DOCUMENT_TYPE_NODE: 10,
                DOCUMENT_FRAGMENT_NODE: 11,
                NOTATION_NODE: 12
            },
            toHex: function(e) {
                var t = o.exec(e);
                return t ? "#" + m(t.slice(1), function(e) {
                    return e = parseInt(e, 10).toString(16), e.length > 1 ? e : "0" + e
                }).join("") : e
            },
            encode: function(e, t) {
                var n = !t || t.entities ? c : d;
                return e.replace(n, function(e) {
                    var t = e.charCodeAt(0),
                        n = u[t];
                    return n ? "&" + n + ";" : e
                })
            },
            isBom: function(e) {
                return e && 3 === e.nodeType && /^[\ufeff]+$/.test(e.nodeValue)
            },
            stripBom: function(e) {
                return (e || "").replace(r, "")
            },
            stripBomNode: function(e) {
                f.isBom(e) && e.parentNode.removeChild(e)
            },
            insignificant: function(e) {
                var t = e.attributes;
                return "k-marker" == e.className || f.is(e, "br") && ("k-br" == e.className || t._moz_dirty || t._moz_editor_bogus_node) || f.is(e, "span") && "k-br" == e.className
            },
            tableCell: function(e) {
                return f.is(e, "td") || f.is(e, "th")
            },
            significantNodes: function(t) {
                return e.grep(t, function(e) {
                    var t = f.name(e);
                    return "br" != t && (!f.insignificant(e) && (!f.emptyTextNode(e) && !(1 == e.nodeType && !x[t] && f.emptyNode(e))))
                })
            },
            emptyTextNode: function(e) {
                return e && 3 == e.nodeType && a.test(e.nodeValue)
            },
            emptyNode: function(e) {
                return 1 == e.nodeType && !f.significantNodes(e.childNodes).length
            },
            name: function(e) {
                return e.nodeName.toLowerCase()
            },
            significantChildNodes: function(t) {
                return e.grep(t.childNodes, function(e) {
                    return 3 != e.nodeType || !f.isWhitespace(e)
                })
            },
            lastTextNode: function(e) {
                var t, n = null;
                if (3 == e.nodeType) return e;
                for (t = e.lastChild; t; t = t.previousSibling)
                    if (n = f.lastTextNode(t)) return n;
                return n
            },
            is: function(e, t) {
                return e && f.name(e) == t
            },
            isMarker: function(e) {
                return e.className == C
            },
            isWhitespace: function(e) {
                return n.test(e.nodeValue)
            },
            allWhitespaceContent: function(e) {
                for (var t = e.firstChild; t && f.isWhitespace(t);) t = t.nextSibling;
                return !t
            },
            isEmptyspace: function(e) {
                return i.test(e.nodeValue)
            },
            htmlIndentSpace: function(t) {
                var n, o, a, s, l, d;
                return !(!f.isDataNode(t) || !f.isWhitespace(t)) && (!!i.test(t.nodeValue) || (n = function(e, t) {
                    for (; e[t];)
                        if (e = e[t], f.significantNodes([e]).length > 0) return e
                }, o = t.parentNode, a = n(t, "previousSibling"), s = n(t, "nextSibling"), r.test(t.nodeValue) ? !(!a && !s) : !!e(o).is("tr,tbody,thead,tfoot,table,ol,ul") || !!((f.isBlock(o) || f.is(o, "body")) && (l = a && f.isBlock(a), d = s && f.isBlock(s), !s && l || !a && d || l && d))))
            },
            isBlock: function(e) {
                return N[f.name(e)]
            },
            isSelfClosing: function(e) {
                return S[f.name(e)]
            },
            isEmpty: function(e) {
                return x[f.name(e)]
            },
            isInline: function(e) {
                return A[f.name(e)]
            },
            isBr: function(e) {
                return "br" == f.name(e)
            },
            list: function(e) {
                var t = e ? f.name(e) : "";
                return "ul" == t || "ol" == t || "dl" == t
            },
            scrollContainer: function(e) {
                var t = f.windowFromDocument(e),
                    n = (t.contentWindow || t).document || t.ownerDocument || t;
                return n = "BackCompat" == n.compatMode ? n.body : n.scrollingElement || n.documentElement
            },
            scrollTo: function(t, n) {
                var i, o, r, a, s = t.ownerDocument,
                    l = f.windowFromDocument(s),
                    d = l.innerHeight,
                    c = f.scrollContainer(s);
                f.isDataNode(t) ? n ? (a = f.create(s, "span", {
                    innerHTML: "&#xfeff;"
                }), f.insertBefore(a, t), i = e(a)) : i = e(t.parentNode) : i = e(t), o = i.offset().top, r = i[0].offsetHeight, !n && r || (r = parseInt(i.css("line-height"), 10) || Math.ceil(1.2 * parseInt(i.css("font-size"), 10)) || 15), a && f.remove(a), r + o > c.scrollTop + d && (c.scrollTop = r + o - d)
            },
            persistScrollTop: function(e) {
                s = f.scrollContainer(e).scrollTop
            },
            offset: function(e, t) {
                for (var n = {
                        top: e.offsetTop,
                        left: e.offsetLeft
                    }, i = e.offsetParent; i && (!t || f.isAncestorOf(t, i));) n.top += i.offsetTop, n.left += i.offsetLeft, i = i.offsetParent;
                return n
            },
            restoreScrollTop: function(e) {
                "number" == typeof s && (f.scrollContainer(e).scrollTop = s, s = void 0)
            },
            insertAt: function(e, t, n) {
                e.insertBefore(t, e.childNodes[n] || null)
            },
            insertBefore: function(e, t) {
                return t.parentNode ? t.parentNode.insertBefore(e, t) : t
            },
            insertAfter: function(e, t) {
                return t.parentNode.insertBefore(e, t.nextSibling)
            },
            remove: function(e) {
                e.parentNode && e.parentNode.removeChild(e)
            },
            removeChildren: function(e) {
                for (; e.firstChild;) e.removeChild(e.firstChild)
            },
            removeTextSiblings: function(e) {
                for (var t = e.parentNode; e.nextSibling && 3 == e.nextSibling.nodeType;) t.removeChild(e.nextSibling);
                for (; e.previousSibling && 3 == e.previousSibling.nodeType;) t.removeChild(e.previousSibling)
            },
            trim: function(e) {
                var t, n;
                for (t = e.childNodes.length - 1; t >= 0; t--) n = e.childNodes[t], f.isDataNode(n) ? f.stripBom(n.nodeValue).length || f.remove(n) : n.className != C && (f.trim(n), (!f.isEmpty(n) && 0 === n.childNodes.length || f.isBlock(n) && f.allWhitespaceContent(n)) && f.remove(n));
                return e
            },
            closest: function(e, t) {
                for ("string" == typeof t && (t = [t]); e && t.indexOf(f.name(e)) < 0;) e = e.parentNode;
                return e
            },
            closestBy: function(e, t, n) {
                for (; e && !t(e);) {
                    if (n && n(e)) return null;
                    e = e.parentNode
                }
                return e
            },
            sibling: function(e, t) {
                do e = e[t]; while (e && 1 != e.nodeType);
                return e
            },
            next: function(e) {
                return f.sibling(e, "nextSibling")
            },
            prev: function(e) {
                return f.sibling(e, "previousSibling")
            },
            parentOfType: function(e, t) {
                do e = e.parentNode; while (e && !f.ofType(e, t));
                return e
            },
            ofType: function(t, n) {
                return e.inArray(f.name(t), n) >= 0
            },
            changeTag: function(e, t, n) {
                var i, o, r, a, s, l = f.create(e.ownerDocument, t),
                    d = e.attributes;
                if (!n)
                    for (i = 0, o = d.length; i < o; i++) s = d[i], s.specified && (r = s.nodeName, a = s.nodeValue, r == w ? l.className = a : r == b ? l.style.cssText = e.style.cssText : l.setAttribute(r, a));
                for (; e.firstChild;) l.appendChild(e.firstChild);
                return f.insertBefore(l, e), f.remove(e), l
            },
            editableParent: function(e) {
                for (; e && (3 == e.nodeType || "true" !== e.contentEditable);) e = e.parentNode;
                return e
            },
            wrap: function(e, t) {
                return f.insertBefore(t, e), t.appendChild(e), t
            },
            unwrap: function(e) {
                for (var t = e.parentNode; e.firstChild;) t.insertBefore(e.firstChild, e);
                t.removeChild(e)
            },
            wrapper: function(t) {
                var n = f.closestBy(t, function(e) {
                    return e.parentNode && f.significantNodes(e.parentNode.childNodes).length > 1
                });
                return e(n).is("body,.k-editor") ? void 0 : n
            },
            create: function(e, t, n) {
                return f.attr(e.createElement(t), n)
            },
            createEmptyNode: function(e, t, n) {
                var i = f.attr(e.createElement(t), n);
                return i.innerHTML = "\ufeff", i
            },
            attr: function(e, t) {
                t = h({}, t), t && b in t && (f.style(e, t.style), delete t.style);
                for (var n in t) null === t[n] ? (e.removeAttribute(n), delete t[n]) : "className" == n && (e[n] = t[n]);
                return h(e, t)
            },
            mergeAttributes: function(t, n) {
                t.attributes.length && e.each(t.attributes, function() {
                    "contenteditable" !== this.name && e(n).attr(this.name, this.value)
                })
            },
            style: function(t, n) {
                e(t).css(n || {})
            },
            unstyle: function(e, t) {
                for (var n in t) n == v && (n = p.support.cssFloat ? y : k), e.style[n] = "";
                "" === e.style.cssText && e.removeAttribute(b)
            },
            inlineStyle: function(t, n, i) {
                var o, r = e(f.create(t.ownerDocument, n, i));
                return t.appendChild(r[0]), o = m(l, function(e) {
                    return g.msie && "line-height" == e && "1px" == r.css(e) ? "line-height:1.5" : e + ":" + r.css(e)
                }).join(";"), r.remove(), o
            },
            getEffectiveBackground: function(e) {
                var t = e.css("background-color") || "";
                return t.indexOf("rgba(0, 0, 0, 0") < 0 && "transparent" !== t ? t : "html" === e[0].tagName.toLowerCase() ? "Window" : f.getEffectiveBackground(e.parent())
            },
            innerText: function(e) {
                var t = e.innerHTML;
                return t = t.replace(/<!--(.|\s)*?-->/gi, ""), t = t.replace(/<\/?[^>]+?\/?>/gm, "")
            },
            removeClass: function(t, n) {
                var i, o, r = " " + t.className + " ",
                    a = n.split(" ");
                for (i = 0, o = a.length; i < o; i++) r = r.replace(" " + a[i] + " ", " ");
                r = e.trim(r), r.length ? t.className = r : t.removeAttribute(w)
            },
            commonAncestor: function() {
                var e, t, n, i, o, r = arguments.length,
                    a = [],
                    s = 1 / 0,
                    l = null;
                if (!r) return null;
                if (1 == r) return arguments[0];
                for (e = 0; e < r; e++) {
                    for (t = [], n = arguments[e]; n;) t.push(n), n = n.parentNode;
                    a.push(t.reverse()), s = Math.min(s, t.length)
                }
                if (1 == r) return a[0][0];
                for (e = 0; e < s; e++) {
                    for (i = a[0][e], o = 1; o < r; o++)
                        if (i != a[o][e]) return l;
                    l = i
                }
                return l
            },
            closestSplittableParent: function(t) {
                var n, i, o;
                return n = 1 == t.length ? f.parentOfType(t[0], ["ul", "ol"]) : f.commonAncestor.apply(null, t), n || (n = f.parentOfType(t[0], ["p", "td"]) || t[0].ownerDocument.body), f.isInline(n) && (n = f.blockParentOrBody(n)), i = m(t, f.editableParent), o = f.commonAncestor(i)[0], e.contains(n, o) && (n = o), n
            },
            closestEditable: function(t, n) {
                var i, o = f.editableParent(t);
                return i = f.ofType(t, n) ? t : f.parentOfType(t, n), i && o && e.contains(i, o) ? i = o : !i && o && (i = o), i
            },
            closestEditableOfType: function(t, n) {
                var i = f.closestEditable(t, n);
                if (i && f.ofType(i, n) && !e(i).is(".k-editor")) return i
            },
            filter: function(e, t, n) {
                var i = function(t) {
                    return f.name(t) == e
                };
                return f.filterBy(t, i, n)
            },
            filterBy: function(e, t, n) {
                for (var i, o = 0, r = e.length, a = []; o < r; o++) i = t(e[o]), (i && !n || !i && n) && a.push(e[o]);
                return a
            },
            ensureTrailingBreaks: function(t) {
                var n = e(t).find("p,td,th"),
                    i = n.length,
                    o = 0;
                if (i)
                    for (; o < i; o++) f.ensureTrailingBreak(n[o]);
                else f.ensureTrailingBreak(t)
            },
            removeTrailingBreak: function(t) {
                e(t).find("br[type=_moz],.k-br").remove()
            },
            ensureTrailingBreak: function(e) {
                var t, n, i;
                f.removeTrailingBreak(e), t = e.lastChild, n = t && f.name(t), (!n || "br" != n && "img" != n || "br" == n && "k-br" != t.className) && (i = e.ownerDocument.createElement("br"), i.className = "k-br", e.appendChild(i))
            },
            reMapTableColumns: function(e, t) {
                f._mapColIndices(e, t)
            },
            clearTableMappings: function(t, n) {
                e(t).find("[" + n + "]").removeAttr(n)
            },
            _mapColIndices: function(e, t) {
                var n, i, o, r, a, s = {};
                for (n = 0; n < e.rows.length; n++)
                    for (i = e.rows[n].cells, o = 0, r = 0; r < i.length; r++, o++) {
                        if (a = i[r], a.rowSpan > 1 && this._mapColspan(a, n, o, s), s[n])
                            for (; s[n][o];) o++;
                        a.setAttribute(t, o), a.colSpan > 1 && (o = o + a.colSpan - 1)
                    }
            },
            _mapColspan: function(e, t, n, i) {
                var o, r, a, s = e.rowSpan,
                    l = e.colSpan;
                for (r = 0; r < l; r++)
                    for (o = n + r, a = t + 1; a < t + s; a++) {
                        if (i[a] || (i[a] = {}, i[a].length = 0), i[t])
                            for (; i[t][o];) o++;
                        i[a][o] = !0, i[a].length++
                    }
            },
            associateWithIds: function(e) {
                var t, n, i = this,
                    o = 0,
                    r = e.rows,
                    a = r.length,
                    s = [],
                    l = [];
                if (e.tHead) t = e.tHead.rows, o = t.length;
                else
                    for (o = i._getNumberOfHeaderRows(e), t = [], n = 0; n < o; n++) t.push(r[n]);
                for (n = 0; n < o; n++) s.push([]);
                for (n = 0; n < a; n++) l.push([]);
                i._generateIdsForColumns(s, t), i._generateIdsForRows(s, l, o, r), i._assignIds(s, l, o, r)
            },
            _generateIdsForColumns: function(e, t) {
                var n, i, o, r, a, s, l, d, c, u, f, p = (new Date).getTime(),
                    m = t ? t.length : 0;
                for (d = 0; d < m; d++)
                    for (n = t[d], i = n.cells, r = 0, c = 0; c < i.length; c++) {
                        for (o = i[c], a = "table" + d + c + ++p, o.setAttribute("id", a), s = o.getAttribute("colspan") || 1, l = o.getAttribute("rowspan") || 1; e[d][c + r];) r += 1;
                        for (u = 0; u < l; u++)
                            for (f = 0; f < s; f++) e[d + u][c + r + f] = a
                    }
            },
            _generateIdsForRows: function(t, n, i, o) {
                var r, a, s, l, d, c, u, f, p, m, h, g, b, v = this,
                    y = (new Date).getTime(),
                    k = o.length,
                    w = function(e) {
                        b.push(e[g])
                    };
                for (f = i; f < k; f++)
                    for (r = o[f], a = e(r.cells).filter("th"), l = 0, p = 0; p < a.length; p++) {
                        for (s = a[p], d = "table" + f + p + ++y, s.setAttribute("id", d), c = s.getAttribute("colspan") || 1, u = s.getAttribute("rowspan") || 1; n[f][p + l];) l += 1;
                        for (m = 0; m < u; m++)
                            for (h = 0; h < c; h++) n[f + m][p + l + h] = d;
                        g = s.getAttribute("col-index"), b = [], t.forEach(w), b = b.filter(v._onlyUnique), s.setAttribute("headers", b.join(" ").trim())
                    }
            },
            _assignIds: function(t, n, i, o) {
                var r, a, s, l, d, c, u, f = this,
                    p = o.length,
                    m = function(e) {
                        u.push(e[c])
                    };
                for (l = i; l < p; l++)
                    for (r = o[l], a = e(r.cells).filter("td"), d = 0; d < a.length; d++) s = a[d], c = s.getAttribute("col-index"), u = n[l].slice(), t.forEach(m), u = u.filter(f._onlyUnique), s.setAttribute("headers", u.join(" ").trim())
            },
            _getNumberOfColumns: function(t) {
                var n, i, o, r = e(t).find("th, td"),
                    a = 0;
                for (i = 0; i < r.length; i++) n = r[i], o = +n.getAttribute("col-index") + 1, o > a && (a = o);
                return a
            },
            _getNumberOfHeaderColumns: function(e, t) {
                var n, i, o, r, a, s = e.rows,
                    l = 0;
                for (o = t; o < s.length; o++)
                    for (i = s[o], r = 0; r < i.cells.length; r++) a = i.cells[r], this.is(a, "th") && (n = +a.getAttribute("col-index") + 1, n > l && (l = n));
                return l
            },
            _getNumberOfHeaderRows: function(e) {
                var t, n, i, o, r = e.rows,
                    a = e.tHead,
                    s = a && e.tHead.rows ? e.tHead.rows.length : 0;
                if (0 === s)
                    for (n = r[0], o = n.cells && n.cells.length; n && o && this.is(n.cells[0], "th");) {
                        for (t = 0; t < o; t++) i = n ? n.cells[t] : null, this.is(i, "th") || (n = null);
                        n && (s += 1, n = this.next(n), o = n && n.cells && n.cells.length)
                    }
                return s
            },
            _onlyUnique: function(e, t, n) {
                return n.indexOf(e) === t
            }
        }, p.ui.editor.Dom = f
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/serializer.min", ["editor/dom.min"], e)
}(function() {
    ! function(e, t) {
        var n, i, o, r, a = window.kendo,
            s = a.ui.editor,
            l = s.Dom,
            d = e.extend,
            c = "xx-small,x-small,small,medium,large,x-large,xx-large".split(","),
            u = /"/g,
            f = /<br[^>]*>/i,
            p = /^\d+(\.\d*)?(px)?$/i,
            m = /<p>(?:&nbsp;)?<\/p>/i,
            h = /(\*?[-#\/\*\\\w]+(?:\[[0-9a-z_-]+\])?)\s*:\s*((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^\)]*?\)|[^};])+)/g,
            g = /^sizzle-\d+/i,
            b = /^k-script-/i,
            v = /\s*onerror\s*=\s*(?:'|")?([^'">\s]*)(?:'|")?/i,
            y = '<br class="k-br">',
            k = "<span class='k-br'>\ufeff</span>",
            w = document.createElement("div");
        w.innerHTML = " <hr>", n = 3 === w.firstChild.nodeType, w = null, i = e.isFunction, o = "td", r = {
            toEditableHtml: function(e) {
                return (e || "").replace(/<!\[CDATA\[(.*)?\]\]>/g, "<!--[CDATA[$1]]-->").replace(/<(\/?)script([^>]*)>/gi, "<$1k:script$2>").replace(/<img([^>]*)>/gi, function(e) {
                    return e.replace(v, "")
                }).replace(/(<\/?img[^>]*>)[\r\n\v\f\t ]+/gi, "$1").replace(/^<(table|blockquote)/i, y + "<$1").replace(/^[\s]*(&nbsp;|\u00a0)/i, "$1").replace(/<\/(table|blockquote)>$/i, "</$1>" + y)
            },
            _toEditableImmutables: function(t) {
                for (var n = s.Immutables.immutable, i = l.emptyTextNode, o = t.firstChild, r = t.lastChild; i(o);) o = o.nextSibling;
                for (; i(r);) r = r.previousSibling;
                o && n(o) && e(k).prependTo(t), r && n(r) && e(k).appendTo(t)
            },
            _fillEmptyElements: function(t) {
                e(t).find("p,td").each(function() {
                    var t, n = e(this);
                    if (/^\s*$/g.test(n.text()) && !n.find("img,input").length) {
                        for (t = this; t.firstChild && 3 != t.firstChild.nodeType;) t = t.firstChild;
                        1 != t.nodeType || l.empty[l.name(t)] || (t.innerHTML = l.is(t, "td") ? a.ui.editor.emptyTableCellContent : a.ui.editor.emptyElementContent)
                    }
                })
            },
            _removeSystemElements: function(t) {
                e(".k-paste-container", t).remove()
            },
            _resetOrderedLists: function(e) {
                var t, n, i, o = e.getElementsByTagName("ol");
                for (t = 0; t < o.length; t++) n = o[t], i = n.getAttribute("start"), n.setAttribute("start", 1), i ? n.setAttribute("start", i) : n.removeAttribute(i)
            },
            _preventScriptExecution: function(t) {
                e(t).find("*").each(function() {
                    var e, t, n, i, o = this.attributes,
                        r = [];
                    for (t = 0, n = o.length; t < n; t++) e = o[t], i = e.nodeName, e.specified && /^on/i.test(i) && (this.setAttribute("k-script-" + i, e.value), r.push(i));
                    for (t = 0, n = r.length; t < n; t++) this.removeAttribute(r[t])
                })
            },
            htmlToDom: function(t, n, o) {
                var s = a.support.browser,
                    d = s.msie,
                    c = d && s.version < 9,
                    u = "originalsrc",
                    f = "originalhref",
                    p = o || {},
                    m = p.immutables;
                return t = r.toEditableHtml(t), c && (t = "<br/>" + t, t = t.replace(/href\s*=\s*(?:'|")?([^'">\s]*)(?:'|")?/, f + '="$1"'), t = t.replace(/src\s*=\s*(?:'|")?([^'">\s]*)(?:'|")?/, u + '="$1"')), i(p.custom) && (t = p.custom(t) || t), n.innerHTML = t, m && m.deserialize(n), c ? (l.remove(n.firstChild), e(n).find("k\\:script,script,link,img,a").each(function() {
                    var e = this;
                    e[f] && (e.setAttribute("href", e[f]), e.removeAttribute(f)), e[u] && (e.setAttribute("src", e[u]), e.removeAttribute(u))
                })) : d && (l.normalize(n), r._resetOrderedLists(n)), r._preventScriptExecution(n), r._fillEmptyElements(n), r._removeSystemElements(n), r._toEditableImmutables(n), e("table", n).addClass("k-table"), n
            },
            domToXhtml: function(i, r) {
                function d(t) {
                    return e.grep(t, function(e) {
                        return "style" != e.name
                    })
                }

                function v(e, t) {
                    A.push("<" + t), C(e), A.push(">")
                }

                function y(t) {
                    var n, i, o, r = e.trim,
                        a = r(t),
                        s = [];
                    for (h.lastIndex = 0;;) {
                        if (n = h.exec(a), !n) break;
                        i = r(n[1].toLowerCase()), o = r(n[2]), "font-size-adjust" != i && "font-stretch" != i && (i.indexOf("color") >= 0 ? o = l.toHex(o) : i.indexOf("font") >= 0 ? o = o.replace(u, "'") : /\burl\(/g.test(o) && (o = o.replace(u, "")), s.push({
                            property: i,
                            value: o
                        }))
                    }
                    return s
                }

                function k(e) {
                    var t, n = y(e);
                    for (t = 0; t < n.length; t++) A.push(n[t].property), A.push(":"), A.push(n[t].value), A.push(";")
                }

                function w(e) {
                    var t, n, i, o, a, s, d = [],
                        c = e.attributes;
                    for (n = 0, i = c.length; n < i; n++) t = c[n], o = t.nodeName, a = t.value, s = t.specified, "value" == o && "value" in e && e.value ? s = !0 : "type" == o && "text" == a ? s = !0 : "class" != o || a ? g.test(o) ? s = !1 : "complete" == o ? s = !1 : "altHtml" == o ? s = !1 : "start" == o && l.is(e, "ul") ? s = !1 : "start" == o && l.is(e, "ol") && "1" == a ? s = !1 : o.indexOf("_moz") >= 0 ? s = !1 : b.test(o) ? s = !!r.scripts : "data-role" == o && "resizable" == a && (l.is(e, "tr") || l.is(e, "td")) && (s = !1) : s = !1, s && d.push(t);
                    return d
                }

                function C(n, i) {
                    var o, r, s, d, c, u, f, m;
                    if (i = i || w(n), l.is(n, "img") && (u = n.style.width, f = n.style.height, m = e(n), u && p.test(u) && (m.attr("width", parseInt(u, 10)), l.unstyle(n, {
                            width: t
                        })), f && p.test(f) && (m.attr("height", parseInt(f, 10)), l.unstyle(n, {
                            height: t
                        }))), i.length)
                        for (o = 0, r = i.length; o < r; o++) s = i[o], d = s.nodeName, c = s.value, "class" == d && "k-table" == c || (d = d.replace(b, ""), A.push(" "), A.push(d), A.push('="'), "style" == d ? k(c || n.style.cssText) : A.push("src" == d || "href" == d ? a.htmlEncode(n.getAttribute(d, 2)) : l.fillAttrs[d] ? d : c), A.push('"'))
                }

                function x(e, t, n) {
                    for (var i = e.firstChild; i; i = i.nextSibling) N(i, t, n)
                }

                function T(e) {
                    return e.nodeValue.replace(/\ufeff/g, "")
                }

                function _(e) {
                    if (l.isBom(e)) {
                        do {
                            if (e = e.parentNode, l.is(e, o) && 1 === e.childNodes.length) return !0;
                            if (1 !== e.childNodes.length) return !1
                        } while (!l.isBlock(e));
                        return !0
                    }
                    return !1
                }

                function N(i, o, a) {
                    var d, c, u, f, p, m, h = i.nodeType;
                    if (z && s.Immutables.immutable(i)) A.push(z.serialize(i));
                    else if (1 == h) {
                        if (d = l.name(i), m = e(i), m.hasClass("k-table-resize-handle-wrapper") || m.hasClass("k-column-resize-handle-wrapper") || m.hasClass("k-row-resize-handle-wrapper")) return;
                        if (!d || l.insignificant(i)) return;
                        if (!r.scripts && ("script" == d || "k:script" == d)) return;
                        if (c = E[d], c && (t === c.semantic || r.semantic ^ c.semantic)) return c.start(i), x(i, !1, c.skipEncoding), c.end(i), t;
                        A.push("<"), A.push(d), C(i), l.empty[d] ? A.push(" />") : (A.push(">"), x(i, o || l.is(i, "pre")), A.push("</"), A.push(d), A.push(">"))
                    } else if (3 == h) {
                        if (_(i)) return A.push("&nbsp;"), t;
                        f = T(i), !o && n && (u = i.parentNode, p = i.previousSibling, p || (p = (l.isInline(u) ? u : i).previousSibling), p && "" !== p.innerHTML && !l.isBlock(p) || (f = f.replace(/^[\r\n\v\f\t ]+/, "")), f = f.replace(/ +/, " ")), A.push(a ? f : l.encode(f, r))
                    } else 4 == h ? (A.push("<![CDATA["), A.push(i.data), A.push("]]>")) : 8 == h && (i.data.indexOf("[CDATA[") < 0 ? (A.push("<!--"), A.push(i.data), A.push("-->")) : (A.push("<!"), A.push(i.data), A.push(">")))
                }

                function S(e) {
                    var t = e.childNodes.length,
                        n = t && 3 == e.firstChild.nodeType;
                    return n && (1 == t || 2 == t && l.insignificant(e.lastChild))
                }

                function R() {
                    e.isFunction(r.custom) && (A = r.custom(A) || A)
                }
                var A = [],
                    z = r && r.immutables,
                    E = {
                        iframe: {
                            start: function(e) {
                                v(e, "iframe")
                            },
                            end: function() {
                                A.push("</iframe>")
                            }
                        },
                        "k:script": {
                            start: function(e) {
                                v(e, "script")
                            },
                            end: function() {
                                A.push("</script>")
                            },
                            skipEncoding: !0
                        },
                        span: {
                            semantic: !0,
                            start: function(t) {
                                var n, i, o = t.style,
                                    r = w(t),
                                    a = d(r);
                                a.length && (A.push("<span"), C(t, a), A.push(">")), "underline" == o.textDecoration && A.push("<u>"), n = [], o.color && n.push('color="' + l.toHex(o.color) + '"'), o.fontFamily && n.push('face="' + o.fontFamily + '"'), o.fontSize && (i = e.inArray(o.fontSize, c), n.push('size="' + i + '"')), n.length && A.push("<font " + n.join(" ") + ">")
                            },
                            end: function(e) {
                                var t = e.style;
                                (t.color || t.fontFamily || t.fontSize) && A.push("</font>"), "underline" == t.textDecoration && A.push("</u>"), d(w(e)).length && A.push("</span>")
                            }
                        },
                        strong: {
                            semantic: !0,
                            start: function(e) {
                                v(e, "b")
                            },
                            end: function() {
                                A.push("</b>")
                            }
                        },
                        em: {
                            semantic: !0,
                            start: function(e) {
                                v(e, "i")
                            },
                            end: function() {
                                A.push("</i>")
                            }
                        },
                        b: {
                            semantic: !1,
                            start: function(e) {
                                v(e, "strong")
                            },
                            end: function() {
                                A.push("</strong>")
                            }
                        },
                        i: {
                            semantic: !1,
                            start: function(e) {
                                v(e, "em")
                            },
                            end: function() {
                                A.push("</em>")
                            }
                        },
                        u: {
                            semantic: !1,
                            start: function(t) {
                                var n, i, o;
                                A.push("<span"), n = w(t), i = e(n).filter(function(e, t) {
                                    return "style" == t.name
                                })[0], o = {
                                    nodeName: "style",
                                    value: "text-decoration:underline;"
                                }, i && (o.value = i.value, /text-decoration/i.test(o.value) || (o.value = "text-decoration:underline;" + o.value), n.splice(e.inArray(i, n), 1)), n.push(o), C(t, n), A.push(">")
                            },
                            end: function() {
                                A.push("</span>")
                            }
                        },
                        font: {
                            semantic: !1,
                            start: function(e) {
                                var t, n, i;
                                A.push('<span style="'), t = e.getAttribute("color"), n = c[e.getAttribute("size")], i = e.getAttribute("face"), t && (A.push("color:"), A.push(l.toHex(t)), A.push(";")), i && (A.push("font-family:"), A.push(i), A.push(";")), n && (A.push("font-size:"), A.push(n), A.push(";")), A.push('">')
                            },
                            end: function() {
                                A.push("</span>")
                            }
                        }
                    };
                return E.script = E["k:script"], r = r || {}, t === r.semantic && (r.semantic = !0), S(i) ? (A = l.encode(T(i.firstChild).replace(/[\r\n\v\f\t ]+/, " "), r), R(), A) : (x(i), A = A.join(""), R(), "" === A.replace(f, "").replace(m, "") ? "" : A)
            }
        }, d(s, {
            Serializer: r
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/components.min", ["editor/serializer.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            i = n.ui.DropDownList,
            o = n.ui.editor.Dom,
            r = i.extend({
                init: function(t, o) {
                    var r = this;
                    i.fn.init.call(r, t, o), n.support.mobileOS.ios && (this._initSelectOverlay(), this.bind("dataBound", e.proxy(this._initSelectOverlay, this))), r.text(r.options.title), r.element.attr("title", r.options.title), r.wrapper.attr("title", r.options.title), r.bind("open", function() {
                        if (r.options.autoSize) {
                            var e, t = r.list;
                            t.css({
                                whiteSpace: "nowrap",
                                width: "auto"
                            }), e = t.width(), e > 0 ? e += 20 : e = r._listWidth, t.css("width", e + n.support.scrollbar()), r._listWidth = e
                        }
                    })
                },
                options: {
                    name: "SelectBox",
                    index: -1
                },
                _initSelectOverlay: function() {
                    var t, i, o, r, a = this,
                        s = a.value(),
                        l = this.dataSource.view(),
                        d = "",
                        c = n.htmlEncode;
                    for (i = 0; i < l.length; i++) t = l[i], d += "<option value='" + c(t.value) + "'", t.value == s && (d += " selected"), d += ">" + c(t.text) + "</option>";
                    o = e("<select class='k-select-overlay'>" + d + "</select>"), r = e(this.element).closest(".k-widget"), r.next(".k-select-overlay").remove(), o.insertAfter(r), o.on("change", function() {
                        a.value(this.value), a.trigger("change")
                    })
                },
                value: function(e) {
                    var n = this,
                        o = i.fn.value.call(n, e);
                    return e === t ? o : (i.fn.value.call(n) || n.text(n.options.title), t)
                },
                decorate: function(t) {
                    var n, i, r, a, s = this,
                        l = s.dataSource,
                        d = l.data();
                    for (t && s.list.css("background-color", o.getEffectiveBackground(e(t))), n = 0; n < d.length; n++) i = d[n].tag || "span", r = d[n].className, a = o.inlineStyle(t, i, {
                        className: r
                    }), a = a.replace(/"/g, "'"), d[n].style = a + ";display:inline-block";
                    l.trigger("change")
                }
            });
        n.ui.plugin(r), n.ui.editor.SelectBox = r
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/range.min", ["editor/components.min"], e)
}(function() {
    ! function(e) {
        function t(e, t, n, i) {
            var o, r, a, s;
            if (e == t) return i - n;
            for (o = t; o && o.parentNode != e;) o = o.parentNode;
            if (o) return C(o) - n;
            for (o = e; o && o.parentNode != t;) o = o.parentNode;
            if (o) return i - C(o) - 1;
            for (r = w.commonAncestor(e, t), a = e; a && a.parentNode != r;) a = a.parentNode;
            for (a || (a = r), s = t; s && s.parentNode != r;) s = s.parentNode;
            return s || (s = r), a == s ? 0 : C(s) - C(a)
        }

        function n(e, n) {
            function i(e) {
                try {
                    return t(e.startContainer, e.endContainer, e.startOffset, e.endOffset) < 0
                } catch (n) {
                    return !0
                }
            }
            i(e) && (n ? (e.commonAncestorContainer = e.endContainer = e.startContainer, e.endOffset = e.startOffset) : (e.commonAncestorContainer = e.startContainer = e.endContainer, e.startOffset = e.endOffset), e.collapsed = !0)
        }

        function i(e) {
            e.collapsed = e.startContainer == e.endContainer && e.startOffset == e.endOffset;
            for (var t = e.startContainer; t && t != e.endContainer && !w.isAncestorOf(t, e.endContainer);) t = t.parentNode;
            e.commonAncestorContainer = t
        }

        function o(e) {
            var t = e.duplicate(),
                n = e.duplicate();
            return t.collapse(!0), n.collapse(!1), w.commonAncestor(e.parentElement(), t.parentElement(), n.parentElement())
        }

        function r(e, t, n) {
            var i, o = t[n ? "startContainer" : "endContainer"],
                r = t[n ? "startOffset" : "endOffset"],
                a = 0,
                s = x(o),
                l = s ? o : o.childNodes[r] || null,
                d = s ? o.parentNode : o,
                c = t.ownerDocument,
                u = c.body.createTextRange();
            3 != o.nodeType && 4 != o.nodeType || (a = r), d || (d = c.body), "img" == d.nodeName.toLowerCase() ? (u.moveToElementText(d), u.collapse(!1), e.setEndPoint(n ? "StartToStart" : "EndToStart", u)) : (i = d.insertBefore(w.create(c, "a"), l), u.moveToElementText(i), w.remove(i), u[n ? "moveStart" : "moveEnd"]("character", a), u.collapse(!1), e.setEndPoint(n ? "StartToStart" : "EndToStart", u))
        }

        function a(e, t, n, i) {
            var o, r, a, s, l, d, c, u = w.create(t.ownerDocument, "a"),
                f = e.duplicate(),
                p = i ? "StartToStart" : "StartToEnd",
                m = !1;
            u.innerHTML = "\ufeff", f.collapse(i), r = f.parentElement(), w.isAncestorOrSelf(n, r) || (r = n);
            do m ? r.insertBefore(u, u.previousSibling) : (r.appendChild(u), m = !0), f.moveToElementText(u); while ((o = f.compareEndPoints(p, e)) > 0 && u.previousSibling);
            a = u.nextSibling, o == -1 && x(a) ? (f.setEndPoint(i ? "EndToStart" : "EndToEnd", e), w.remove(u), d = [a, f.text.length]) : (s = !i && u.previousSibling, l = i && u.nextSibling, x(l) ? d = [l, 0] : x(s) ? d = [s, s.length] : (c = C(u), d = r.nextSibling && c == r.childNodes.length - 1 ? [r.nextSibling, 0] : [r, c]), w.remove(u)), t[i ? "setStart" : "setEnd"].apply(t, d)
        }
        var s, l, d, c, u, f, p, m, h, g = window.kendo,
            b = g.Class,
            v = e.extend,
            y = g.ui.editor,
            k = g.support.browser,
            w = y.Dom,
            C = w.findNodeIndex,
            x = w.isDataNode,
            T = w.findClosestAncestor,
            _ = w.getNodeLength,
            N = w.normalize,
            S = {
                selectionFromWindow: function(e) {
                    return "getSelection" in e ? e.getSelection() : new l(e.document)
                },
                selectionFromRange: function(e) {
                    var t = h.documentFromRange(e);
                    return S.selectionFromDocument(t)
                },
                selectionFromDocument: function(e) {
                    return S.selectionFromWindow(w.windowFromDocument(e))
                }
            },
            R = b.extend({
                init: function(t) {
                    e.extend(this, {
                        ownerDocument: t,
                        startContainer: t,
                        endContainer: t,
                        commonAncestorContainer: t,
                        startOffset: 0,
                        endOffset: 0,
                        collapsed: !0
                    })
                },
                setStart: function(e, t) {
                    this.startContainer = e, this.startOffset = t, i(this), n(this, !0)
                },
                setEnd: function(e, t) {
                    this.endContainer = e, this.endOffset = t, i(this), n(this, !1)
                },
                setStartBefore: function(e) {
                    this.setStart(e.parentNode, C(e))
                },
                setStartAfter: function(e) {
                    this.setStart(e.parentNode, C(e) + 1)
                },
                setEndBefore: function(e) {
                    this.setEnd(e.parentNode, C(e))
                },
                setEndAfter: function(e) {
                    this.setEnd(e.parentNode, C(e) + 1)
                },
                selectNode: function(e) {
                    this.setStartBefore(e), this.setEndAfter(e)
                },
                selectNodeContents: function(e) {
                    this.setStart(e, 0), this.setEnd(e, e[1 === e.nodeType ? "childNodes" : "nodeValue"].length)
                },
                collapse: function(e) {
                    var t = this;
                    e ? t.setEnd(t.startContainer, t.startOffset) : t.setStart(t.endContainer, t.endOffset)
                },
                deleteContents: function() {
                    var e = this,
                        t = e.cloneRange();
                    e.startContainer != e.commonAncestorContainer && e.setStartAfter(T(e.commonAncestorContainer, e.startContainer)), e.collapse(!0),
                        function n(e) {
                            for (; e.next();) e.hasPartialSubtree() ? n(e.getSubtreeIterator()) : e.remove()
                        }(new s(t))
                },
                cloneContents: function() {
                    var e = h.documentFromRange(this);
                    return function t(n) {
                        for (var i, o = e.createDocumentFragment(); i = n.next();) i = i.cloneNode(!n.hasPartialSubtree()), n.hasPartialSubtree() && i.appendChild(t(n.getSubtreeIterator())), o.appendChild(i);
                        return o
                    }(new s(this))
                },
                extractContents: function() {
                    var e, t = this,
                        n = t.cloneRange();
                    return t.startContainer != t.commonAncestorContainer && t.setStartAfter(T(t.commonAncestorContainer, t.startContainer)), t.collapse(!0), e = h.documentFromRange(t),
                        function i(n) {
                            for (var o, r = e.createDocumentFragment(); o = n.next();) n.hasPartialSubtree() ? (o = o.cloneNode(!1), o.appendChild(i(n.getSubtreeIterator()))) : n.remove(t.originalRange), r.appendChild(o);
                            return r
                        }(new s(n))
                },
                insertNode: function(e) {
                    var t = this;
                    x(t.startContainer) ? (t.startOffset != t.startContainer.nodeValue.length && w.splitDataNode(t.startContainer, t.startOffset), w.insertAfter(e, t.startContainer)) : w.insertAt(t.startContainer, e, t.startOffset), t.setStart(t.startContainer, t.startOffset)
                },
                cloneRange: function() {
                    return e.extend(new R(this.ownerDocument), {
                        startContainer: this.startContainer,
                        endContainer: this.endContainer,
                        commonAncestorContainer: this.commonAncestorContainer,
                        startOffset: this.startOffset,
                        endOffset: this.endOffset,
                        collapsed: this.collapsed,
                        originalRange: this
                    })
                },
                toString: function() {
                    var e = this.startContainer.nodeName,
                        t = this.endContainer.nodeName;
                    return ("#text" == e ? this.startContainer.nodeValue : e) + "(" + this.startOffset + ") : " + ("#text" == t ? this.endContainer.nodeValue : t) + "(" + this.endOffset + ")"
                }
            });
        R.fromNode = function(e) {
            return new R(e.ownerDocument)
        }, s = b.extend({
            init: function(t) {
                if (e.extend(this, {
                        range: t,
                        _current: null,
                        _next: null,
                        _end: null
                    }), !t.collapsed) {
                    var n = t.commonAncestorContainer;
                    this._next = t.startContainer != n || x(t.startContainer) ? T(n, t.startContainer) : t.startContainer.childNodes[t.startOffset], this._end = t.endContainer != n || x(t.endContainer) ? T(n, t.endContainer).nextSibling : t.endContainer.childNodes[t.endOffset]
                }
            },
            hasNext: function() {
                return !!this._next
            },
            next: function() {
                var e = this,
                    t = e._current = e._next;
                return e._next = e._current && e._current.nextSibling != e._end ? e._current.nextSibling : null, x(e._current) && (e.range.endContainer == e._current && (t = t.cloneNode(!0), t.deleteData(e.range.endOffset, t.length - e.range.endOffset)), e.range.startContainer == e._current && (t = t.cloneNode(!0), t.deleteData(0, e.range.startOffset))), t
            },
            traverse: function(e) {
                function t() {
                    return i._current = i._next, i._next = i._current && i._current.nextSibling != i._end ? i._current.nextSibling : null, i._current
                }
                for (var n, i = this; n = t();) i.hasPartialSubtree() ? i.getSubtreeIterator().traverse(e) : e(n);
                return n
            },
            remove: function(e) {
                var t, n, i, o, r, a = this,
                    s = a.range.startContainer == a._current,
                    l = a.range.endContainer == a._current;
                x(a._current) && (s || l) ? (t = s ? a.range.startOffset : 0, n = l ? a.range.endOffset : a._current.length, i = n - t, e && (s || l) && (a._current == e.startContainer && t <= e.startOffset && (e.startOffset -= i), a._current == e.endContainer && n <= e.endOffset && (e.endOffset -= i)), a._current.deleteData(t, i)) : (o = a._current.parentNode, !e || a.range.startContainer != o && a.range.endContainer != o || (r = C(a._current), o == e.startContainer && r <= e.startOffset && (e.startOffset -= 1), o == e.endContainer && r < e.endOffset && (e.endOffset -= 1)), w.remove(a._current))
            },
            hasPartialSubtree: function() {
                return !x(this._current) && (w.isAncestorOrSelf(this._current, this.range.startContainer) || w.isAncestorOrSelf(this._current, this.range.endContainer))
            },
            getSubtreeIterator: function() {
                return new s(this.getSubRange())
            },
            getSubRange: function() {
                var e = this,
                    t = e.range.cloneRange();
                return t.selectNodeContents(e._current), w.isAncestorOrSelf(e._current, e.range.startContainer) && t.setStart(e.range.startContainer, e.range.startOffset), w.isAncestorOrSelf(e._current, e.range.endContainer) && t.setEnd(e.range.endContainer, e.range.endOffset), t
            }
        }), l = b.extend({
            init: function(e) {
                this.ownerDocument = e, this.rangeCount = 1
            },
            addRange: function(e) {
                var t = this.ownerDocument.body.createTextRange();
                r(t, e, !1), r(t, e, !0), t.select()
            },
            removeAllRanges: function() {
                var e = this.ownerDocument.selection;
                "None" != e.type && e.empty()
            },
            getRangeAt: function() {
                var e, t, n, i, r, s, l, d, c = new R(this.ownerDocument),
                    u = this.ownerDocument.selection;
                try {
                    if (e = u.createRange(), t = e.item ? e.item(0) : e.parentElement(), t.ownerDocument != this.ownerDocument) return c
                } catch (f) {
                    return c
                }
                if ("Control" == u.type) c.selectNode(e.item(0));
                else if (n = o(e), a(e, c, n, !0), a(e, c, n, !1), 9 == c.startContainer.nodeType && c.setStart(c.endContainer, c.startOffset), 9 == c.endContainer.nodeType && c.setEnd(c.startContainer, c.endOffset), 0 === e.compareEndPoints("StartToEnd", e) && c.collapse(!1), i = c.startContainer, r = c.endContainer, s = this.ownerDocument.body, !(c.collapsed || 0 !== c.startOffset || c.endOffset != _(c.endContainer) || i == r && x(i) && i.parentNode == s)) {
                    for (l = !1, d = !1; 0 === C(i) && i == i.parentNode.firstChild && i != s;) i = i.parentNode, l = !0;
                    for (; C(r) == _(r.parentNode) - 1 && r == r.parentNode.lastChild && r != s;) r = r.parentNode, d = !0;
                    i == s && r == s && l && d && (c.setStart(i, 0), c.setEnd(r, _(s)))
                }
                return c
            }
        }), d = b.extend({
            init: function(e) {
                this.enumerate = function() {
                    function t(e) {
                        if (w.is(e, "img") || 3 == e.nodeType && (!w.isEmptyspace(e) || "\ufeff" == e.nodeValue)) n.push(e);
                        else
                            for (e = e.firstChild; e;) t(e), e = e.nextSibling
                    }
                    var n = [];
                    return new s(e).traverse(t), n
                }
            }
        }), c = s.extend({
            hasPartialSubtree: function() {
                var e = y.Immutables && y.Immutables.immutable;
                return e && !e(this._current) && s.fn.hasPartialSubtree.call(this)
            },
            getSubtreeIterator: function() {
                return new c(this.getSubRange())
            }
        }), u = b.extend({
            init: function(e) {
                this.enumerate = function() {
                    function t(e) {
                        if (i && !i(e))
                            if (w.is(e, "img") || 3 == e.nodeType && (!w.isEmptyspace(e) || "\ufeff" == e.nodeValue)) n.push(e);
                            else
                                for (e = e.firstChild; e;) t(e), e = e.nextSibling
                    }
                    var n = [],
                        i = y.Immutables && y.Immutables.immutable;
                    return new c(e).traverse(t), n
                }
            }
        }), f = b.extend({
            init: function(e, t, n) {
                var i = this;
                i.range = e, i.rootNode = h.documentFromRange(e), i.body = t || i.getEditable(e), "body" != w.name(i.body) && (i.rootNode = i.body), i.startContainer = i.nodeToPath(e.startContainer), i.endContainer = i.nodeToPath(e.endContainer), i.startOffset = i.offset(e.startContainer, e.startOffset), i.endOffset = i.offset(e.endContainer, e.endOffset), i.immutables = n && n.immutables, i.immutables && (i.serializedImmutables = y.Immutables.removeImmutables(i.body)), i.html = i.body.innerHTML, i.immutables && !i.serializedImmutables.empty && y.Immutables.restoreImmutables(i.body, i.serializedImmutables)
            },
            index: function(e) {
                for (var t, n = 0, i = e.nodeType; e = e.previousSibling;) t = e.nodeType, 3 == t && i == t || n++, i = t;
                return n
            },
            getEditable: function(e) {
                for (var t = e.commonAncestorContainer; t && (3 == t.nodeType || t.attributes && (!t.attributes.contentEditable || "false" == t.attributes.contentEditable.nodeValue.toLowerCase()));) t = t.parentNode;
                return t
            },
            restoreHtml: function() {
                var e = this;
                w.removeChildren(e.body), e.body.innerHTML = e.html, e.immutables && !e.serializedImmutables.empty && y.Immutables.restoreImmutables(e.body, e.serializedImmutables)
            },
            offset: function(e, t) {
                if (3 == e.nodeType)
                    for (;
                        (e = e.previousSibling) && 3 == e.nodeType;) t += e.nodeValue.length;
                return t
            },
            nodeToPath: function(e) {
                for (var t = []; e != this.rootNode;) t.push(this.index(e)), e = e.parentNode;
                return t
            },
            toRangePoint: function(e, t, n, i) {
                for (var o = this.rootNode, r = n.length, a = i; r-- && o;) o = o.childNodes[n[r]];
                for (; o && 3 == o.nodeType && o.nodeValue.length < a;) a -= o.nodeValue.length, o = o.nextSibling;
                o && a >= 0 && e[t ? "setStart" : "setEnd"](o, a)
            },
            toRange: function() {
                var e = this,
                    t = e.range.cloneRange();
                return e.toRangePoint(t, !0, e.startContainer, e.startOffset), e.toRangePoint(t, !1, e.endContainer, e.endOffset), t
            }
        }), p = b.extend({
            init: function() {
                this.caret = null
            },
            addCaret: function(e) {
                var t = this,
                    n = t.caret = w.create(h.documentFromRange(e), "span", {
                        className: "k-marker"
                    });
                return e.insertNode(n), w.stripBomNode(n.previousSibling), w.stripBomNode(n.nextSibling), e.selectNode(n), n
            },
            removeCaret: function(e) {
                var t, n, i, o, r = this,
                    a = r.caret.previousSibling,
                    s = 0;
                a && (s = x(a) ? a.nodeValue.length : C(a)), t = r.caret.parentNode, n = a ? C(a) : 0, w.remove(r.caret), N(t), i = t.childNodes[n], x(i) ? e.setStart(i, s) : i ? (o = w.lastTextNode(i), o ? e.setStart(o, o.nodeValue.length) : e[a ? "setStartAfter" : "setStartBefore"](i)) : (k.msie || t.innerHTML || (t.innerHTML = '<br _moz_dirty="" />'), e.selectNodeContents(t)), e.collapse(!0)
            },
            add: function(e, t) {
                var n, i, o = this,
                    r = e.collapsed && !h.isExpandable(e),
                    a = h.documentFromRange(e);
                return t && e.collapsed && (o.addCaret(e), e = h.expand(e)), n = e.cloneRange(), n.collapse(!1), o.end = w.create(a, "span", {
                    className: "k-marker"
                }), n.insertNode(o.end), n = e.cloneRange(), n.collapse(!0), o.start = o.end.cloneNode(!0), n.insertNode(o.start), o._removeDeadMarkers(o.start, o.end), r && (i = a.createTextNode("\ufeff"), w.insertAfter(i.cloneNode(), o.start), w.insertBefore(i, o.end)), N(e.commonAncestorContainer), e.setStartBefore(o.start), e.setEndAfter(o.end), e
            },
            _removeDeadMarkers: function(e, t) {
                e.previousSibling && "\ufeff" == e.previousSibling.nodeValue && w.remove(e.previousSibling), t.nextSibling && "\ufeff" == t.nextSibling.nodeValue && w.remove(t.nextSibling)
            },
            _normalizedIndex: function(e) {
                for (var t = C(e), n = e; n.previousSibling;) 3 == n.nodeType && 3 == n.previousSibling.nodeType && t--, n = n.previousSibling;
                return t
            },
            remove: function(e) {
                var t, n, i, o, r, a, s, l, d, c, u, f, p = this,
                    m = p.start,
                    h = p.end;
                for (N(e.commonAncestorContainer); !m.nextSibling && m.parentNode;) m = m.parentNode;
                for (; !h.previousSibling && h.parentNode;) h = h.parentNode;
                if (t = m.previousSibling && 3 == m.previousSibling.nodeType && m.nextSibling && 3 == m.nextSibling.nodeType, n = h.previousSibling && 3 == h.previousSibling.nodeType && h.nextSibling && 3 == h.nextSibling.nodeType, i = t && n, m = m.nextSibling, h = h.previousSibling, o = m === h && w.isBom(m), o && m.length > 1 && (m.nodeValue = m.nodeValue.charAt(0)), r = o, a = !1, m == p.end && (a = !!p.start.previousSibling, m = h = p.start.previousSibling || p.end.nextSibling, r = !0), w.remove(p.start), w.remove(p.end), !m || !h) return e.selectNodeContents(e.commonAncestorContainer), void e.collapse(!0);
                if (s = r ? x(m) ? m.nodeValue.length : m.childNodes.length : 0, l = x(h) ? h.nodeValue.length : h.childNodes.length, 3 == m.nodeType)
                    for (; m.previousSibling && 3 == m.previousSibling.nodeType;) m = m.previousSibling, s += m.nodeValue.length;
                if (3 == h.nodeType)
                    for (; h.previousSibling && 3 == h.previousSibling.nodeType;) h = h.previousSibling, l += h.nodeValue.length;
                d = m.parentNode, c = h.parentNode, u = this._normalizedIndex(m), f = this._normalizedIndex(h), N(d), 3 == m.nodeType && (m = d.childNodes[u]), N(c), 3 == h.nodeType && (h = c.childNodes[f]), r ? (3 == m.nodeType ? e.setStart(m, s) : e[a ? "setStartAfter" : "setStartBefore"](m), e.collapse(!0)) : (3 == m.nodeType ? e.setStart(m, s) : e.setStartBefore(m), 3 == h.nodeType ? e.setEnd(h, l) : e.setEndAfter(h)), p.caret && p.removeCaret(e)
            }
        }), m = /[\u0009-\u000d]|\u0020|\u00a0|\ufeff|\.|,|;|:|!|\(|\)|\?/, h = {
            nodes: function(e) {
                var t = h.textNodes(e);
                return t.length || (e.selectNodeContents(e.commonAncestorContainer), t = h.textNodes(e), t.length || (t = w.significantChildNodes(e.commonAncestorContainer))), t
            },
            textNodes: function(e) {
                return new d(e).enumerate()
            },
            editableTextNodes: function(e) {
                var t = [],
                    n = y.Immutables && y.Immutables.immutableParent;
                return n && !n(e.commonAncestorContainer) && (t = new u(e).enumerate()), t
            },
            documentFromRange: function(e) {
                var t = e.startContainer;
                return 9 == t.nodeType ? t : t.ownerDocument
            },
            createRange: function(e) {
                return k.msie && k.version < 9 ? new R(e) : e.createRange()
            },
            selectRange: function(e) {
                var t, n = h.image(e);
                n && (e.setStartAfter(n), e.setEndAfter(n)), t = S.selectionFromRange(e), t.removeAllRanges(), t.addRange(e)
            },
            stringify: function(e) {
                return g.format("{0}:{1} - {2}:{3}", w.name(e.startContainer), e.startOffset, w.name(e.endContainer), e.endOffset)
            },
            split: function(e, t, n) {
                function i(i) {
                    var o, r = e.cloneRange();
                    r.collapse(i), r[i ? "setStartBefore" : "setEndAfter"](t), o = r.extractContents(), n && (o = w.trim(o)), w[i ? "insertBefore" : "insertAfter"](o, t)
                }
                i(!0), i(!1)
            },
            mapAll: function(t, n) {
                var i = [];
                return new s(t).traverse(function(t) {
                    var o = n(t);
                    o && e.inArray(o, i) < 0 && i.push(o)
                }), i
            },
            getAll: function(e, t) {
                var n = t;
                return "string" == typeof t && (t = function(e) {
                    return w.is(e, n)
                }), h.mapAll(e, function(e) {
                    if (t(e)) return e
                })
            },
            getMarkers: function(e) {
                return h.getAll(e, function(e) {
                    return "k-marker" == e.className
                })
            },
            image: function(e) {
                var t = h.getAll(e, "img");
                if (1 == t.length) return t[0]
            },
            isStartOf: function(e, t) {
                var n, i, o;
                if (0 !== e.startOffset) return !1;
                for (n = e.cloneRange(); 0 === n.startOffset && n.startContainer != t;) {
                    for (i = w.findNodeIndex(n.startContainer), o = n.startContainer.parentNode; i > 0 && o[i - 1] && w.insignificant(o[i - 1]);) i--;
                    n.setStart(o, i)
                }
                return 0 === n.startOffset && n.startContainer == t
            },
            isEndOf: function(e, t) {
                function n(e) {
                    w.insignificant(e) || w.isDataNode(e) && /^[\ufeff]*$/.test(e.nodeValue) || o.push(e)
                }
                var i, o, r = e.cloneRange();
                return r.collapse(!1), i = r.startContainer, w.isDataNode(i) && r.startOffset == w.getNodeLength(i) && (r.setStart(i.parentNode, w.findNodeIndex(i) + 1), r.collapse(!0)), r.setEnd(t, w.getNodeLength(t)), o = [], new s(r).traverse(n), !o.length
            },
            wrapSelectedElements: function(e) {
                function t(e, t) {
                    var n, i = w.getNodeLength(t);
                    if (e == i) return !0;
                    for (n = e; n < i; n++)
                        if (!w.insignificant(t.childNodes[n])) return !1;
                    return !0
                }
                for (var n = w.editableParent(e.startContainer), i = w.editableParent(e.endContainer); 0 === e.startOffset && e.startContainer != n;) e.setStart(e.startContainer.parentNode, w.findNodeIndex(e.startContainer));
                for (; t(e.endOffset, e.endContainer) && e.endContainer != i;) e.setEnd(e.endContainer.parentNode, w.findNodeIndex(e.endContainer) + 1);
                return e
            },
            expand: function(e) {
                var t, n, i, o, r = e.cloneRange(),
                    a = r.startContainer.childNodes[0 === r.startOffset ? 0 : r.startOffset - 1],
                    s = r.endContainer.childNodes[r.endOffset];
                return x(a) && x(s) ? (t = a.nodeValue, n = s.nodeValue, t && n ? (i = t.split("").reverse().join("").search(m), o = n.search(m), i && o ? (o = o == -1 ? n.length : o, i = i == -1 ? 0 : t.length - i, r.setStart(a, i), r.setEnd(s, o), r) : r) : r) : r
            },
            isExpandable: function(e) {
                var t, n, i, o, r, a, s = e.startContainer,
                    l = h.documentFromRange(e);
                return s != l && s != l.body && (t = e.cloneRange(), !!(n = s.nodeValue) && (i = n.substring(0, t.startOffset), o = n.substring(t.startOffset), r = 0, a = 0, i && (r = i.split("").reverse().join("").search(m)), o && (a = o.search(m)), r && a))
            }
        }, v(y, {
            SelectionUtils: S,
            W3CRange: R,
            RangeIterator: s,
            W3CSelection: l,
            RangeEnumerator: d,
            RestorePoint: f,
            Marker: p,
            RangeUtils: h
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/immutables.min", ["editor/range.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            i = n.Class,
            o = n.ui.editor,
            r = o.Dom,
            a = n.template,
            s = o.RangeUtils,
            l = ["ul", "ol", "tbody", "thead", "table"],
            d = ["bold", "italic", "underline", "strikethrough", "superscript", "subscript", "forecolor", "backcolor", "fontname", "fontsize", "createlink", "unlink", "autolink", "addcolumnleft", "addcolumnright", "addrowabove", "addrowbelow", "deleterow", "deletecolumn", "mergecells", "formatting", "cleanformatting"],
            c = "k-immutable",
            u = "[" + c + "]",
            f = "[contenteditable='false']",
            p = function(t) {
                return e(t).is("body,.k-editor")
            },
            m = function(e) {
                return e.getAttribute && "false" == e.getAttribute("contenteditable")
            },
            h = function(e) {
                return r.closestBy(e, m, p)
            },
            g = function(e) {
                var t = h(e.startContainer),
                    n = h(e.endContainer);
                (t || n) && (t && e.setStartBefore(t), n && e.setEndAfter(n))
            },
            b = function(e) {
                if (h(e.commonAncestorContainer)) return !0;
                if (h(e.startContainer) || h(e.endContainer)) {
                    var t = s.editableTextNodes(e);
                    if (0 === t.length) return !0
                }
                return !1
            },
            v = function(e) {
                var t, n = "",
                    i = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
                for (t = e || 10; t > 0; --t) n += i.charAt(Math.round(Math.random() * (i.length - 1)));
                return n
            },
            y = function(t) {
                var n, i, o, a = {
                    empty: !0
                };
                return e(t).find(f).each(function(t, s) {
                    n = r.name(s), i = v(), o = "<" + n + " " + c + "='" + i + "'></" + n + ">", a[i] = {
                        node: s,
                        style: e(s).attr("style")
                    }, a.empty = !1, e(s).replaceWith(o)
                }), a
            },
            k = function(t, n) {
                var i, o;
                e(t).find(u).each(function(t, r) {
                    i = r.getAttribute(c), o = n[i], e(r).replaceWith(o.node), o.style != e(o.node).attr("style") && e(o.node).removeAttr("style").attr("style", o.style)
                })
            },
            w = function(e) {
                var t = n.keys;
                return e === t.BACKSPACE || e == t.DELETE
            },
            C = function(e) {
                var n = e ? e.options : t;
                n && n.finder && n.finder._initOptions({
                    immutables: !0
                })
            },
            x = i.extend({
                init: function(t) {
                    this.editor = t, this.serializedImmutables = {}, this.options = e.extend({}, t && t.options && t.options.immutables);
                    var n = t.toolbar.tools;
                    C(n.justifyLeft), C(n.justifyCenter), C(n.justifyRight), C(n.justifyFull)
                },
                serialize: function(e) {
                    var t, n = this._toHtml(e);
                    return n.indexOf(c) === -1 ? (t = this.randomId(), n = n.replace(/>/, " " + c + '="' + t + '">')) : t = n.match(/k-immutable\s*=\s*['"](.*)['"]/)[1], this.serializedImmutables[t] = e, n
                },
                _toHtml: function(e) {
                    var t, n = this.options.serialization,
                        i = typeof n;
                    switch (i) {
                        case "string":
                            return a(n)(e);
                        case "function":
                            return n(e);
                        default:
                            return t = r.name(e), "<" + t + "></" + t + ">"
                    }
                },
                deserialize: function(t) {
                    var i = this,
                        o = this.options.deserialization;
                    e(u, t).each(function() {
                        var t = this.getAttribute(c),
                            r = i.serializedImmutables[t];
                        n.isFunction(o) && o(this, r), e(this).replaceWith(r)
                    }), i.serializedImmutables = {}
                },
                randomId: function(e) {
                    return v(e)
                },
                keydown: function(e, t) {
                    var n = w(e.keyCode),
                        i = n && this._cancelDeleting(e, t) || !n && this._cancelTyping(e, t);
                    if (i) return e.preventDefault(), !0
                },
                _cancelTyping: function(e, t) {
                    var n = this.editor,
                        i = n.keyboard;
                    return t.collapsed && !i.typingInProgress && i.isTypingKey(e) && b(t)
                },
                _cancelDeleting: function(e, t) {
                    var i, o, a, s, d = n.keys,
                        c = e.keyCode === d.BACKSPACE,
                        u = e.keyCode == d.DELETE;
                    if (!c && !u) return !1;
                    if (i = !1, t.collapsed) {
                        if (b(t)) return !0;
                        if (o = this.nextImmutable(t, u), o && c && (a = r.closest(t.commonAncestorContainer, "li"), a && (s = r.closest(o, "li"), s && s !== a))) return i;
                        if (o && !r.tableCell(o)) {
                            if (r.parentOfType(o, l) === r.parentOfType(t.commonAncestorContainer, l)) {
                                for (; o && 1 == o.parentNode.childNodes.length;) o = o.parentNode;
                                if (r.tableCell(o)) return i;
                                this._removeImmutable(o, t)
                            }
                            i = !0
                        }
                    }
                    return i
                },
                nextImmutable: function(e, t) {
                    var n, i = e.commonAncestorContainer;
                    if (r.isBom(i) || t && s.isEndOf(e, i) || !t && s.isStartOf(e, i)) {
                        if (n = this._nextNode(i, t), n && r.isBlock(n) && !h(n))
                            for (; n && n.children && n.children[t ? 0 : n.children.length - 1];) n = n.children[t ? 0 : n.children.length - 1];
                        return h(n)
                    }
                },
                _removeImmutable: function(e, t) {
                    var n = this.editor,
                        i = new o.RestorePoint(t, n.body);
                    r.remove(e), o._finishUpdate(n, i)
                },
                _nextNode: function(e, t) {
                    for (var n, i = t ? "nextSibling" : "previousSibling", o = e; o && !n;) n = o[i], n && r.isDataNode(n) && /^\s|[\ufeff]$/.test(n.nodeValue) && (o = n, n = o[i]), n || (o = o.parentNode);
                    return n
                }
            });
        x.immutable = m, x.immutableParent = h, x.expandImmutablesIn = g, x.immutablesContext = b, x.toolsToBeUpdated = d, x.removeImmutables = y, x.restoreImmutables = k, o.Immutables = x
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/command.min", ["editor/immutables.min"], e)
}(function() {
    ! function(e) {
        function t(e, t) {
            var n = e.selectionRestorePoint = new a(e.getRange(), e.body),
                i = new c(t, n);
            return i.editor = e, e.undoRedoStack.push(i), n
        }
        var n = window.kendo,
            i = n.Class,
            o = n.ui.editor,
            r = o.Dom,
            a = o.RestorePoint,
            s = o.Marker,
            l = e.extend,
            d = i.extend({
                init: function(e) {
                    this.options = e, this.restorePoint = new a(e.range, e.body, {
                        immutables: e.immutables
                    }), this.marker = new s, this.formatter = e.formatter
                },
                getRange: function() {
                    return this.restorePoint.toRange()
                },
                lockRange: function(e) {
                    return this.marker.add(this.getRange(), e)
                },
                releaseRange: function(e) {
                    this.marker.remove(e), this.editor.selectRange(e)
                },
                undo: function() {
                    var e = this.restorePoint;
                    e.restoreHtml(), this.editor.selectRange(e.toRange())
                },
                redo: function() {
                    this.exec()
                },
                createDialog: function(t, i) {
                    var o = this.editor;
                    return e(t).appendTo(document.body).kendoWindow(l({}, o.options.dialogOptions, i)).closest(".k-window").toggleClass("k-rtl", n.support.isRtl(o.wrapper)).end()
                },
                exec: function() {
                    var e = this.lockRange(!0);
                    this.formatter.editor = this.editor, this.formatter.toggle(e), this.releaseRange(e)
                },
                immutables: function() {
                    return this.editor && this.editor.options.immutables
                },
                expandImmutablesIn: function(e) {
                    this.immutables() && (n.ui.editor.Immutables.expandImmutablesIn(e), this.restorePoint = new a(e, this.editor.body))
                }
            }),
            c = i.extend({
                init: function(e, t) {
                    this.body = e.body, this.startRestorePoint = e, this.endRestorePoint = t
                },
                redo: function() {
                    r.removeChildren(this.body), this.body.innerHTML = this.endRestorePoint.html, this.editor.selectRange(this.endRestorePoint.toRange())
                },
                undo: function() {
                    r.removeChildren(this.body), this.body.innerHTML = this.startRestorePoint.html, this.editor.selectRange(this.startRestorePoint.toRange())
                }
            });
        l(o, {
            _finishUpdate: t,
            Command: d,
            GenericCommand: c
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/toolbar.min", ["editor/range.min"], e)
}(function() {
    ! function(e, t) {
        var n, i = window.kendo,
            o = i.ui,
            r = o.editor,
            a = o.Widget,
            s = e.extend,
            l = e.proxy,
            d = i.keys,
            c = ".kendoEditor",
            u = r.EditorUtils,
            f = r.ToolTemplate,
            p = r.Tool,
            m = i._outerWidth,
            h = i._outerHeight,
            g = "overflowAnchor",
            b = ".k-tool-group:visible a.k-tool:not(.k-state-disabled),.k-tool.k-overflow-anchor:visible,.k-tool-group:visible .k-widget.k-colorpicker,.k-tool-group:visible .k-selectbox,.k-tool-group:visible .k-dropdown,.k-tool-group:visible .k-combobox .k-input",
            v = {
                "k-i-sup-script": "superscript",
                "k-i-sub-script": "subscript",
                "k-i-align-left": "justifyLeft",
                "k-i-align-center": "justifyCenter",
                "k-i-align-right": "justifyRight",
                "k-i-align-justify": "justifyFull",
                "k-i-list-unordered": "insertUnorderedList",
                "k-i-list-ordered": "insertOrderedList",
                "k-i-login": "import",
                "k-i-indent-increase": "indent",
                "k-i-indent-decrease": "outdent",
                "k-i-link-horizontal": "createLink",
                "k-i-unlink-horizontal": "unlink",
                "k-i-image": "insertImage",
                "k-i-file-add": "insertFile",
                "k-i-html": "viewHtml",
                "k-i-foreground-color": "foreColor",
                "k-i-paint": "backColor",
                "k-i-table-insert": "createTable",
                "k-i-table-column-insert-left": "addColumnLeft",
                "k-i-table-column-insert-right": "addColumnRight",
                "k-i-table-row-insert-above": "addRowAbove",
                "k-i-table-row-insert-below": "addRowBelow",
                "k-i-table-row-delete": "deleteRow",
                "k-i-table-column-delete": "deleteColumn",
                "k-i-table-properties": "tableWizard",
                "k-i-table-wizard": "tableWizardInsert",
                "k-i-clear-css": "cleanFormatting",
                "k-i-cells-merge-horizontally": "mergeCellsHorizontally",
                "k-i-cells-merge-vertically": "mergeCellsVertically",
                "k-i-cell-split-horizontally": "splitCellHorizontally",
                "k-i-cell-split-vertically": "splitCellVertically",
                "k-i-copy-format": "copyFormat",
                "k-i-apply-format": "applyFormat"
            },
            y = p.extend({
                initialize: function(t, n) {
                    t.attr({
                        unselectable: "on"
                    });
                    var i = n.editor.toolbar;
                    t.attr("aria-controls", n.editor.element.attr("id")).on("click", e.proxy(function() {
                        this.overflowPopup.toggle()
                    }, i))
                },
                options: {
                    name: g
                },
                command: e.noop,
                update: e.noop,
                destroy: e.noop
            });
        u.registerTool(g, new y({
            key: "",
            ctrl: !0,
            template: new f({
                template: u.overflowAnchorTemplate
            })
        })), n = a.extend({
            init: function(e, t) {
                var n = this;
                t = s({}, t, {
                    name: "EditorToolbar"
                }), a.fn.init.call(n, e, t), t.popup && n._initPopup(), t.resizable && t.resizable.toolbar && (n._resizeHandler = i.onResize(function() {
                    n.resize(!0)
                }), n.element.addClass("k-toolbar-resizable"))
            },
            events: ["execute"],
            groups: {
                basic: ["bold", "italic", "underline", "strikethrough"],
                scripts: ["subscript", "superscript"],
                alignment: ["justifyLeft", "justifyCenter", "justifyRight", "justifyFull"],
                links: ["insertImage", "insertFile", "createLink", "unlink"],
                lists: ["insertUnorderedList", "insertOrderedList", "indent", "outdent"],
                tablesInsert: ["createTable"],
                tablesAddDelete: ["addColumnLeft", "addColumnRight", "addRowAbove", "addRowBelow", "deleteRow", "deleteColumn"],
                tablesMerge: ["mergeCellsHorizontally", "mergeCellsVertically", "splitCellHorizontally", "splitCellVertically"],
                advanced: ["viewHtml", "cleanFormatting", "print", "pdf", "exportAs", "import"],
                fonts: ["fontName", "fontSize"],
                colors: ["foreColor", "backColor"],
                formatPainter: ["copyFormat", "applyFormat"]
            },
            overflowFlaseTools: ["formatting", "fontName", "fontSize", "foreColor", "backColor", "insertHtml"],
            _initPopup: function() {
                var t = this;
                this.window = e(this.element).wrap("<div class='editorToolbarWindow k-header' />").parent().prepend("<button class='k-button k-bare k-editortoolbar-dragHandle'><span class='k-icon k-i-handler-drag' /></button>").kendoWindow({
                    title: !1,
                    resizable: !1,
                    draggable: {
                        dragHandle: ".k-editortoolbar-dragHandle"
                    },
                    animation: {
                        open: {
                            effects: "fade:in"
                        },
                        close: {
                            effects: "fade:out"
                        }
                    },
                    minHeight: 42,
                    visible: !1,
                    autoFocus: !1,
                    actions: [],
                    dragend: function() {
                        this._moved = !0
                    }
                }).on("mousedown", function(n) {
                    e(n.target).is(".k-icon") || (t.preventPopupHide = !0)
                }).on("focusout", function() {
                    t.options.editor.element.focusout()
                }).data("kendoWindow")
            },
            _toggleOverflowStyles: function(e, t) {
                e.find("> li").toggleClass("k-item k-state-default", t).find(".k-tool:not(.k-state-disabled),.k-overflow-button").toggleClass("k-overflow-button k-button", t)
            },
            _initOverflowPopup: function(t) {
                var n = this,
                    o = "<ul class='k-editor-overflow-popup k-overflow-container k-list-container'></ul>";
                n.overflowPopup = e(o).appendTo("body").kendoPopup({
                    anchor: t,
                    origin: i.support.isRtl(n.element) ? "bottom left" : "bottom right",
                    position: i.support.isRtl(n.element) ? "top left" : "top right",
                    copyAnchorStyles: !1,
                    open: function(e) {
                        this.element.is(":empty") && e.preventDefault(), n._toggleOverflowStyles(this.element, !0), t.attr("aria-expanded", !0)
                    },
                    close: function() {
                        t.attr("aria-expanded", !1)
                    },
                    activate: l(n.focusOverflowPopup, n)
                }).data("kendoPopup")
            },
            items: function() {
                var e, t, n = this.options.resizable && this.options.resizable.toolbar;
                return t = this.element.children().find("> *, select"), n && (e = this.overflowPopup, t = t.add(e.element.children().find("> *"))), t
            },
            focused: function() {
                return this.element.find(".k-state-focused").length > 0 || this.preventPopupHide || this.overflowPopup && this.overflowPopup.visible()
            },
            toolById: function(e) {
                var t, n = this.tools;
                for (t in n)
                    if (t.toLowerCase() == e) return n[t]
            },
            toolGroupFor: function(t) {
                var n, i = this.groups;
                if (this.isCustomTool(t)) return "custom";
                for (n in i)
                    if (e.inArray(t, i[n]) >= 0) return n
            },
            bindTo: function(t) {
                var n = this,
                    i = n.window;
                n._editor && n._editor.unbind("select", l(n.resize, n)), n._editor = t, n.options.resizable && n.options.resizable.toolbar && t.options.tools.push(g), n.tools = n.expandTools(t.options.tools), n.render(), n.element.find(".k-combobox .k-input").keydown(function(t) {
                    var n = e(this).closest(".k-combobox").data("kendoComboBox"),
                        i = t.keyCode;
                    i == d.RIGHT || i == d.LEFT ? n.close() : i == d.DOWN && (n.dropDown.isOpened() || (t.stopImmediatePropagation(), n.open()))
                }), n._attachEvents(), n.items().each(function() {
                    var i, o = n._toolName(this),
                        r = "moreVertical" !== o ? n.tools[o] : n.tools.overflowAnchor,
                        a = r && r.options,
                        s = t.options.messages,
                        l = a && a.tooltip || s[o],
                        d = e(this);
                    r && r.initialize && ("fontSize" != o && "fontName" != o || (i = s[o + "Inherit"], d.find("input").val(i).end().find("span.k-input").text(i).end()), r.initialize(d, {
                        title: n._appendShortcutSequence(l, r),
                        editor: n._editor
                    }), d.closest(".k-widget", n.element).addClass("k-editor-widget"), d.closest(".k-colorpicker", n.element).next(".k-colorpicker").addClass("k-editor-widget"))
                }), t.bind("select", l(n.resize, n)), n.update(), i && i.wrapper.css({
                    top: "",
                    left: "",
                    width: ""
                })
            },
            show: function() {
                var e, t, n, o = this,
                    r = o.window,
                    a = o.options.editor,
                    s = i.support.browser;
                r && (e = r.wrapper, t = a.element, e.is(":visible") && o.window.options.visible || (e[0].style.width || e.width(this._getWindowWidth()), r._moved || (n = t.offset(), e.css({
                    top: Math.max(0, parseInt(n.top, 10) - h(e) - parseInt(o.window.element.css("padding-bottom"), 10)),
                    left: Math.max(0, parseInt(n.left, 10))
                })), (s.msie || s.edge) && o._overlaps(t) ? setTimeout(function() {
                    r.open()
                }, 0) : r.open()))
            },
            _getWindowWidth: function() {
                var e = this,
                    t = e.window.wrapper,
                    n = e.options.editor.element;
                return m(n) - parseInt(t.css("border-left-width"), 10) - parseInt(t.css("border-right-width"), 10)
            },
            _overlaps: function(e) {
                var t = this.window.wrapper,
                    n = t.offset(),
                    i = n.left,
                    o = n.top,
                    r = e.offset(),
                    a = r.left,
                    s = r.top;
                return !(a + e.width() < i || a > i + t.width() || s + e.height() < o || s > o + t.height())
            },
            hide: function() {
                this.window && this.window.close()
            },
            focus: function() {
                var e = "tabIndex",
                    t = this.element,
                    n = this._editor.element.attr(e);
                t.attr(e, n || 0).focus().find(b).first().focus(), n || 0 === n || t.removeAttr(e)
            },
            focusOverflowPopup: function() {
                var e = "tabIndex",
                    t = this.overflowPopup.element,
                    n = this._editor.element.attr(e);
                t.closest(".k-animation-container").addClass("k-overflow-wrapper"), t.attr(e, n || 0).find(b).first().focus(), n || 0 === n || t.removeAttr(e)
            },
            _appendShortcutSequence: function(e, t) {
                if (!t.key) return e;
                var n = e + " (";
                return t.ctrl && (n += "Ctrl + "), t.shift && (n += "Shift + "), t.alt && (n += "Alt + "), n += t.key + ")"
            },
            _nativeTools: ["insertLineBreak", "insertParagraph", "redo", "undo", "autoLink"],
            tools: {},
            isCustomTool: function(e) {
                return !(e in i.ui.Editor.defaultTools)
            },
            expandTools: function(t) {
                var n, o, a, l, d = this._nativeTools,
                    c = i.deepExtend({}, i.ui.Editor.defaultTools),
                    u = {};
                for (o = 0; o < t.length; o++) n = t[o], l = n.name, e.isPlainObject(n) ? l && c[l] ? (u[l] = s({}, c[l]), s(u[l].options, n)) : (a = s({
                    cssClass: "k-i-gear",
                    type: "button",
                    title: ""
                }, n), a.name || (a.name = "custom"), a.cssClass = "k-" + a.name, a.template || "button" != a.type || (a.template = r.EditorUtils.buttonTemplate, a.title = a.title || a.tooltip), u[l] = {
                    options: a
                }) : c[n] && (u[n] = c[n]);
                for (o = 0; o < d.length; o++) u[d[o]] || (u[d[o]] = c[d[o]]);
                return u
            },
            render: function() {
                function t(t) {
                    var n;
                    return t.getHtml ? n = t.getHtml() : (e.isFunction(t) || (t = i.template(t)), n = t(r)), e.trim(n)
                }

                function n() {
                    f.children().length && (C && (f.data("position", w), w++), f.appendTo(v))
                }

                function o(t) {
                    t !== g ? (f = e("<li class='k-tool-group' role='presentation' />"), f.data("overflow", e.inArray(t, x) === -1)) : f = e("<li class='k-overflow-tools' />")
                }
                var r, a, s, d, c, u, f, p, m = this,
                    h = m.tools,
                    b = m._editor.element,
                    v = m.element.empty(),
                    y = m._editor.options.tools,
                    k = i.support.browser,
                    w = 0,
                    C = m.options.resizable && m.options.resizable.toolbar,
                    x = this.overflowFlaseTools;
                for (v.empty(), y.length && (d = y[0].name || y[0]), o(d, x), p = 0; p < y.length; p++) d = y[p].name || y[p], r = h[d] && h[d].options, !r && e.isPlainObject(d) && (r = d), a = r && r.template, "break" == d && (n(), e("<li class='k-row-break' />").appendTo(m.element), o(d, x)), a && (u = m.toolGroupFor(d), c == u && d != g || (n(), o(d, x), c = u), d == g && (a.options.title = m.options.messages.overflowAnchor), a = t(a), s = e(a).appendTo(f), "custom" == u && (n(), o(d, x)), r.exec && s.hasClass("k-tool") && s.click(l(r.exec, b[0])));
                n(), e(m.element).children(":has(> .k-tool)").addClass("k-button-group"), m.options.popup && k.msie && k.version < 9 && m.window.wrapper.find("*").attr("unselectable", "on"), m.updateGroups(), C && m._initOverflowPopup(m.element.find(".k-overflow-anchor")), m.angular("compile", function() {
                    return {
                        elements: m.element
                    }
                })
            },
            updateGroups: function() {
                e(this.element).children().each(function() {
                    e(this).addClass("k-state-disabled"), e(this).children().filter(function() {
                        return !e(this).hasClass("k-state-disabled")
                    }).removeClass("k-group-end").first().addClass("k-group-start").end().last().addClass("k-group-end").end().parent().removeClass("k-state-disabled").css("display", "")
                })
            },
            decorateFrom: function(t) {
                this.items().filter(".k-decorated").each(function() {
                    var n = e(this).data("kendoSelectBox");
                    n && n.decorate(t)
                })
            },
            destroy: function() {
                a.fn.destroy.call(this);
                var e, t = this.tools;
                for (e in t) t[e].destroy && t[e].destroy();
                this.window && this.window.destroy(), this._resizeHandler && i.unbindResize(this._resizeHandler), this.overflowPopup && this.overflowPopup.destroy()
            },
            _attachEvents: function() {
                var t = this,
                    n = t.overflowPopup ? t.overflowPopup.element : e([]);
                t.attachToolsEvents(t.element.add(n))
            },
            attachToolsEvents: function(t) {
                var n = this,
                    o = "[role=button].k-tool",
                    r = o + ":not(.k-state-disabled)",
                    a = o + ".k-state-disabled",
                    s = ".k-dropdown",
                    l = ".k-colorpicker",
                    u = [o, s, l].join(",");
                t.off(c).on("mouseenter" + c, r, function() {
                    e(this).addClass("k-state-hover")
                }).on("mouseleave" + c, r, function() {
                    e(this).removeClass("k-state-hover")
                }).on("mousedown" + c, u, function(e) {
                    e.preventDefault()
                }).on("keydown" + c, b, function(t) {
                    function o(e, t, n) {
                        var i = t.find(b),
                            o = i.index(l) + e;
                        return n && (o = Math.max(0, Math.min(i.length - 1, o))), i[o]
                    }
                    var r, a, s, l = this,
                        c = n.options.resizable && n.options.resizable.toolbar,
                        u = i.support.isRtl(n.element) ? -1 : 1,
                        f = t.keyCode;
                    f == d.RIGHT || f == d.LEFT ? a = e(l).is(".k-dropdown") ? e(l) : o(f == d.RIGHT ? 1 * u : -1 * u, n.element, !0) : !c || f != d.UP && f != d.DOWN ? f == d.HOME ? (a = n.element.find(b)[0], t.preventDefault()) : f == d.END ? (r = n.element.find(b).filter(function() {
                        return "hidden" !== e(this).css("visibility")
                    }), a = r[r.length - 1], t.preventDefault()) : f == d.ESC ? (n.overflowPopup && n.overflowPopup.visible() && n.overflowPopup.close(), a = n._editor) : f != d.TAB || t.ctrlKey || t.altKey || (s = c && e(l.parentElement).hasClass("k-overflow-tool-group") ? n.overflowPopup.element : n.element, t.shiftKey ? a = o(-1, s) : (a = o(1, s), a && "hidden" !== e(a).closest(".k-overflow-tools").css("visibility") || (a = n._editor))) : a = o(f == d.DOWN ? 1 : -1, n.overflowPopup.element, !0), a && (t.preventDefault(), a.focus()), f !== d.ENTER && f !== d.SPACEBAR || !e(l).is("a") || e(l).attr("href") || n._executeToolCommand(l, t)
                }).on("click" + c, r, function(e) {
                    n._executeToolCommand(this, e)
                }).on("click" + c, a, function(e) {
                    e.preventDefault()
                })
            },
            _executeToolCommand: function(t, n) {
                var i = this,
                    o = e(t);
                n.preventDefault(), n.stopPropagation(), o.removeClass("k-state-hover"), o.is("[data-popup]") || i._editor.exec(i._toolName(t))
            },
            _toolName: function(t) {
                var n, o, r;
                if (t) return n = t.className, /k-tool\b/i.test(n) && (n = t.firstChild.className), o = e.grep(n.split(" "), function(e) {
                    return !/^k-(widget|tool|tool-icon|icon|state-hover|header|combobox|dropdown|selectbox|colorpicker)$/i.test(e)
                }), o[0] ? (r = o[0], v[r] && (r = v[r]), r.indexOf("k-i-") >= 0 ? i.toCamelCase(r.substring(r.indexOf("k-i-") + 4)) : r.substring(r.lastIndexOf("-") + 1)) : "custom"
            },
            refreshTools: function() {
                var t = this,
                    n = t._editor,
                    i = n.getRange(),
                    o = r.RangeUtils.textNodes(i),
                    a = n.options.immutables,
                    s = t._immutablesContext(i);
                o = r.Dom.filterBy(o, r.Dom.htmlIndentSpace, !0), o.length || (o = [i.startContainer]), t.items().each(function() {
                    var n, i = t.tools[t._toolName(this)];
                    i && (n = e(this), i.update && i.update(n, o), a && t._updateImmutablesState(i, n, s))
                }), this.update()
            },
            _immutablesContext: function(e) {
                if (this._editor.options.immutables) return e.collapsed ? r.Immutables.immutablesContext(e) : 0 === r.RangeUtils.editableTextNodes(e).length
            },
            _updateImmutablesState: function(n, i, o) {
                var a, s, l, d, c, u = n.name,
                    f = i,
                    p = n.options.trackImmutables;
                if (p === t && (p = e.inArray(u, r.Immutables.toolsToBeUpdated) > -1), p) {
                    if (a = o ? "none" : "", !i.is(".k-tool")) {
                        s = i.data();
                        for (l in s)
                            if (l.match(/^kendo[A-Z][a-zA-Z]*/)) {
                                d = s[l], f = d.wrapper;
                                break
                            }
                    }
                    f.css("display", a), c = f.closest("li"), 0 === c.children(":visible").length && c.css("display", a)
                }
            },
            update: function() {
                this.updateGroups()
            },
            _resize: function(e) {
                var t = e.width,
                    n = this.options.resizable && this.options.resizable.toolbar,
                    i = this.overflowPopup,
                    o = this.options.editor.element,
                    r = this.window;
                this.refreshTools(), n && (r && (r.wrapper.width(this._getWindowWidth()), r._moved || r.wrapper.css({
                    left: Math.max(0, parseInt(o.offset().left, 10))
                })), i.visible() && i.close(!0), this._refreshWidths(), this._shrink(t), this._stretch(t), this._toggleOverflowStyles(this.element, !1), this._toggleOverflowStyles(this.overflowPopup.element, !0), this.element.children("li.k-overflow-tools").css("visibility", i.element.is(":empty") ? "hidden" : "visible"))
            },
            _refreshWidths: function() {
                this.element.children("li").each(function(t, n) {
                    var i = e(n);
                    i.data("outerWidth", m(i, !0))
                })
            },
            _shrink: function(e) {
                var t, n, i;
                if (e < this._groupsWidth())
                    for (n = this._visibleGroups().filter(":not(.k-overflow-tools)"), i = n.length - 1; i >= 0 && (t = n.eq(i), !(e > this._groupsWidth())); i--) this._hideGroup(t)
            },
            _stretch: function(e) {
                var t, n, i;
                if (e > this._groupsWidth())
                    for (n = this._hiddenGroups(), i = 0; i < n.length && (t = n.eq(i), !(e < this._groupsWidth()) && this._showGroup(t, e)); i++);
            },
            _hiddenGroups: function() {
                var t = this.overflowPopup,
                    n = this.element.children("li.k-tool-group").filter(":hidden");
                return n = n.add(t.element.children("li")), n.sort(function(t, n) {
                    return e(t).data("position") > e(n).data("position") ? 1 : -1
                }), n
            },
            _visibleGroups: function() {
                return this.element.children("li.k-tool-group, li.k-overflow-tools").filter(":visible")
            },
            _groupsWidth: function() {
                var t = 0;
                return this._visibleGroups().each(function() {
                    t += e(this).data("outerWidth")
                }), Math.ceil(t)
            },
            _hideGroup: function(e) {
                if (e.data("overflow")) {
                    var t = this.overflowPopup;
                    e.detach().prependTo(t.element).addClass("k-overflow-tool-group")
                } else e.hide()
            },
            _showGroup: function(t, n) {
                var i, o;
                return !!t.hasClass("k-state-disabled") || !!(t.length && n > this._groupsWidth() + t.data("outerWidth")) && (t.hasClass("k-overflow-tool-group") ? (i = t.data("position"), 0 === i ? t.detach().prependTo(this.element) : (o = this.element.children().filter(function(t, n) {
                    return e(n).data("position") === i - 1
                }), t.detach().insertAfter(o)), t.removeClass("k-overflow-tool-group")) : t.show(), !0)
            }
        }), e.extend(r, {
            Toolbar: n
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/viewhtml.min", ["editor/command.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            i = e.extend,
            o = n.ui.editor,
            r = o.EditorUtils,
            a = o.Command,
            s = o.Tool,
            l = o.ToolTemplate,
            d = o.Dom,
            c = a.extend({
                init: function(e) {
                    var t = this;
                    t.options = e, a.fn.init.call(t, e), t.attributes = null, t.async = !0
                },
                exec: function() {
                    function i(e) {
                        f.deserialization.immutables = u.immutables, u.value(m.find(h).val()), f.deserialization.immutables = t, o(e), l.change && l.change(), u.trigger("change")
                    }

                    function o(e) {
                        e.preventDefault(), m.data("kendoWindow").destroy(), u.immutables && (u.immutables.serializedImmutables = {}), u.focus()
                    }
                    var a, s, l = this,
                        u = l.editor,
                        f = u.options,
                        p = u.options.messages,
                        m = e(n.template(c.template)(p)).appendTo(document.body),
                        h = ".k-editor-textarea";
                    f.serialization.immutables = u.immutables, s = d.getAllComments(u.body), a = r.cacheComments(u.value(), s), a = c.indent(a), a = r.retrieveComments(a, s), f.serialization.immutables = t, this.createDialog(m, {
                        title: p.viewHtml,
                        close: o,
                        visible: !1
                    }).find(h).val(a).end().find(".k-dialog-update").click(i).end().find(".k-dialog-close").click(o).end().data("kendoWindow").center().open(), m.find(h).focus()
                }
            });
        i(c, {
            template: "<div class='k-editor-dialog k-popup-edit-form k-viewhtml-dialog'><div class='k-edit-form-container'></div><textarea class='k-editor-textarea k-input'></textarea><div class='k-edit-buttons k-state-default'><button class='k-dialog-update k-button k-primary'>#: dialogUpdate #</button><button class='k-dialog-close k-button'>#: dialogCancel #</button></div></div></div>",
            indent: function(e) {
                return e.replace(/<\/(p|li|ul|ol|h[1-6]|table|tr|td|th)>/gi, "</$1>\n").replace(/<(ul|ol)([^>]*)><li/gi, "<$1$2>\n<li").replace(/<br \/>/gi, "<br />\n").replace(/\n$/, "")
            }
        }), n.ui.editor.ViewHtmlCommand = c, o.EditorUtils.registerTool("viewHtml", new s({
            command: c,
            template: new l({
                template: r.buttonTemplate,
                title: "View HTML"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/format.min", ["editor/command.min"], e)
}(function() {
    ! function(e) {
        var t = window.kendo,
            n = e.extend,
            i = t.ui.editor,
            o = i.Tool,
            r = i.Command,
            a = i.EditorUtils,
            s = r.extend({
                init: function(e) {
                    e.formatter = e.formatter();
                    var t = e.formatter.finder;
                    t && a.formatByName("immutable", t.format) && t._initOptions({
                        immutables: e.immutables
                    }), r.fn.init.call(this, e)
                }
            }),
            l = o.extend({
                init: function(e) {
                    o.fn.init.call(this, e)
                },
                command: function(e) {
                    var t = this;
                    return new s(n(e, {
                        formatter: t.options.formatter
                    }))
                },
                update: function(e, t) {
                    var n = this.options.finder.isFormatted(t);
                    e.toggleClass("k-state-selected", n), e.attr("aria-pressed", n)
                }
            });
        e.extend(i, {
            FormatCommand: s,
            FormatTool: l
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/inlineformat.min", ["editor/plugins/format.min"], e)
}(function() {
    ! function(e) {
        var t = window.kendo,
            n = t.Class,
            i = t.ui.editor,
            o = t.ui.Editor.fn.options.formats,
            r = i.EditorUtils,
            a = i.Tool,
            s = i.ToolTemplate,
            l = i.FormatTool,
            d = i.Dom,
            c = i.RangeUtils,
            u = e.extend,
            f = i.EditorUtils.registerTool,
            p = i.EditorUtils.registerFormat,
            m = "mousedown.kendoEditor",
            h = "keydown.kendoEditor",
            g = "k-marker",
            b = n.extend({
                init: function(e) {
                    this.format = e
                },
                numberOfSiblings: function(e) {
                    var t, n = 0,
                        i = 0,
                        o = 0,
                        r = e.parentNode;
                    for (t = r.firstChild; t; t = t.nextSibling) t != e && (t.className == g ? o++ : 3 == t.nodeType ? n++ : i++);
                    return o > 1 && r.firstChild.className == g && r.lastChild.className == g ? 0 : i + n
                },
                findSuitable: function(e, t) {
                    var n, i;
                    if (!t && this.numberOfSiblings(e) > 0) return null;
                    for (n = e.parentNode, i = this.format[0].tags; !d.ofType(n, i);) {
                        if (this.numberOfSiblings(n) > 0) return null;
                        n = n.parentNode
                    }
                    return n
                },
                findFormat: function(e) {
                    var t, n, i, o, r, a = this.format,
                        s = d.attrEquals;
                    for (t = 0, n = a.length; t < n; t++) {
                        if (i = e, o = a[t].tags, r = a[t].attr, i && d.ofType(i, o) && s(i, r)) return i;
                        for (; i;)
                            if (i = d.parentOfType(i, o), i && s(i, r)) return i
                    }
                    return null
                },
                isFormatted: function(e) {
                    var t, n;
                    for (t = 0, n = e.length; t < n; t++)
                        if (this.findFormat(e[t])) return !0;
                    return !1
                }
            }),
            v = n.extend({
                init: function(e, t) {
                    this.finder = new b(e), this.attributes = u({}, e[0].attr, t), this.tag = e[0].tags[0]
                },
                wrap: function(e) {
                    return d.wrap(e, d.create(e.ownerDocument, this.tag, this.attributes))
                },
                activate: function(e, t) {
                    this.finder.isFormatted(t) ? (this.split(e), this.remove(t)) : this.apply(t)
                },
                toggle: function(e) {
                    var t = this.immutables() ? c.editableTextNodes : c.textNodes,
                        n = t(e);
                    n.length > 0 && this.activate(e, n)
                },
                immutables: function() {
                    return this.editor && this.editor.options.immutables
                },
                apply: function(e) {
                    var t, n, i, o, r = [];
                    if (e.length > 1)
                        for (t = 0, n = e.length; t < n; t++) i = e[t], o = this.format(i, !0), r.push(o);
                    else i = e[0], o = this.format(i, !1);
                    this.consolidate(r)
                },
                format: function(e, t) {
                    var n = this.finder.findSuitable(e),
                        i = this.attributes,
                        o = i ? i.style || {} : {};
                    if (n) d.is(n, "font") && (o.color && n.removeAttribute("color"), o.fontName && n.removeAttribute("face"), o.fontSize && n.removeAttribute("size")), d.attr(n, i);
                    else {
                        for (; !d.isBlock(e.parentNode) && 1 == e.parentNode.childNodes.length && "true" !== e.parentNode.contentEditable && t;) e = e.parentNode;
                        n = this.wrap(e)
                    }
                    return n
                },
                remove: function(e) {
                    var t, n, i;
                    for (t = 0, n = e.length; t < n; t++) i = this.finder.findFormat(e[t]), i && (this.attributes && this.attributes.style ? (d.unstyle(i, this.attributes.style), i.style.cssText || i.attributes["class"] || d.unwrap(i)) : d.unwrap(i))
                },
                split: function(e) {
                    var t, n, i = c.textNodes(e),
                        o = i.length;
                    if (o > 0)
                        for (t = 0; t < o; t++) n = this.finder.findFormat(i[t]), n && c.split(e, n, !0)
                },
                consolidate: function(e) {
                    for (var t, n; e.length > 1;)
                        if (t = e.pop(), n = e[e.length - 1], t.previousSibling && t.previousSibling.className == g && n.appendChild(t.previousSibling), t.tagName == n.tagName && t.previousSibling == n && t.style.cssText == n.style.cssText && t.className === n.className) {
                            for (; t.firstChild;) n.appendChild(t.firstChild);
                            d.remove(t)
                        }
                }
            }),
            y = b.extend({
                init: function(e, t) {
                    this.format = e, this.greedyProperty = t, b.fn.init.call(this, e)
                },
                getInlineCssValue: function(t) {
                    var n, i, o, r, a, s, l, c, u, f, p, m, h = t.attributes,
                        g = e.trim;
                    if (h)
                        for (n = 0, i = h.length; n < i; n++)
                            if (o = h[n], r = o.nodeName, a = o.nodeValue, o.specified && "style" == r)
                                for (s = g(a || t.style.cssText).split(";"), c = 0, u = s.length; c < u; c++)
                                    if (l = s[c], l.length) {
                                        if (f = l.split(":"), p = g(f[0].toLowerCase()), m = g(f[1]), p != this.greedyProperty) continue;
                                        return p.indexOf("color") >= 0 ? d.toHex(m) : m
                                    }
                },
                getFormatInner: function(t) {
                    var n, i, o, r = e(d.isDataNode(t) ? t.parentNode : t),
                        a = r.parentsUntil("[contentEditable]").addBack().toArray().reverse();
                    for (n = 0, i = a.length; n < i; n++)
                        if (o = "className" == this.greedyProperty ? a[n].className : this.getInlineCssValue(a[n])) return o;
                    return "inherit"
                },
                getFormat: function(e) {
                    var t, n, i = this.getFormatInner(e[0]);
                    for (t = 1, n = e.length; t < n; t++)
                        if (i != this.getFormatInner(e[t])) return "";
                    return i
                },
                isFormatted: function(e) {
                    return "" !== this.getFormat(e)
                }
            }),
            k = v.extend({
                init: function(e, n, i) {
                    v.fn.init.call(this, e, n), this.values = n, this.finder = new y(e, i), i && (this.greedyProperty = t.toCamelCase(i))
                },
                activate: function(e, t) {
                    var n = this.greedyProperty,
                        i = "apply";
                    this.split(e), n && "inherit" == this.values.style[n] && (i = "remove"), this[i](t)
                }
            }),
            w = l.extend({
                init: function(e) {
                    l.fn.init.call(this, u(e, {
                        finder: new b(e.format),
                        formatter: function() {
                            return new v(e.format)
                        }
                    }))
                }
            }),
            C = a.extend({
                update: function(e, t) {
                    var n = e.data(this.type);
                    n.close(), n.value(this.finder.getFormat(t))
                }
            }),
            x = C.extend({
                init: function(e) {
                    a.fn.init.call(this, e), this.type = t.support.browser.msie || t.support.touch ? "kendoDropDownList" : "kendoComboBox", this.format = [{
                        tags: ["span", "font"]
                    }], this.finder = new y(this.format, e.cssAttr)
                },
                command: function(e) {
                    var t = this.options,
                        n = this.format,
                        o = {};
                    return new i.FormatCommand(u(e, {
                        formatter: function() {
                            return o[t.domAttr] = e.value, new k(n, {
                                style: o
                            }, t.cssAttr)
                        }
                    }))
                },
                initialize: function(e, n) {
                    var i, o, r, s = n.editor,
                        l = this.options,
                        d = l.name,
                        c = [];
                    l.defaultValue && (c = [{
                        text: s.options.messages[l.defaultValue[0].text],
                        value: l.defaultValue[0].value
                    }]), i = c.concat(l.items ? l.items : s.options[d] || []), e.attr({
                        title: n.title
                    }), e[this.type]({
                        dataTextField: "text",
                        dataValueField: "value",
                        dataSource: i,
                        change: function() {
                            s._range = o, a.exec(s, d, this.value())
                        },
                        close: function() {
                            setTimeout(function() {
                                s._deleteSavedRange()
                            }, 0)
                        },
                        highlightFirst: !1
                    }), e.closest(".k-widget").removeClass("k-" + d).find("*").addBack().attr("unselectable", "on"), r = e.data(this.type), r.value("inherit"), r.wrapper.on(m, ".k-select,.k-input", function() {
                        var e = s.getRange();
                        o = s._containsRange(e) ? e : o
                    }).on(h, function(e) {
                        e.keyCode === t.keys.ENTER && (s._deleteSavedRange(), e.preventDefault())
                    })
                }
            }),
            T = a.extend({
                init: function(e) {
                    a.fn.init.call(this, e), this.format = [{
                        tags: ["span", "font"]
                    }], this.finder = new y(this.format, e.cssAttr)
                },
                options: {
                    palette: "websafe"
                },
                update: function() {
                    this._widget.close()
                },
                command: function(e) {
                    var t = this.options,
                        n = this.format,
                        o = {};
                    return new i.FormatCommand(u(e, {
                        formatter: function() {
                            return o[t.domAttr] = e.value, new k(n, {
                                style: o
                            }, t.cssAttr)
                        }
                    }))
                },
                initialize: function(n, i) {
                    var o = this,
                        s = i.editor,
                        l = this.name,
                        d = u({}, T.fn.options, this.options),
                        c = d.palette,
                        f = d.columns;
                    n = this._widget = new t.ui.ColorPicker(n, {
                        toolIcon: "k-icon k-i-" + r.getToolCssClass(d.name),
                        palette: c,
                        columns: f,
                        change: function() {
                            var e = n.value();
                            t.support.browser.msie && o.storedRange && o._inputFocused && s.selectRange(o.storedRange), e && a.exec(s, l, e), delete o.storedRange, delete o._inputFocused, s.focus()
                        },
                        open: function(t) {
                            var n = t.sender;
                            o.storedRange = s.getRange(), n._popup.element.on(m, function(t) {
                                e(t.target).is("input.k-color-value") || t.preventDefault()
                            }), n._popup.element.is("[unselectable='on']") || n._popup.element.attr({
                                unselectable: "on"
                            }).find("*:not(input)").attr("unselectable", "on").end().find("input").on("focus", function() {
                                o._inputFocused = !0
                            })
                        },
                        close: function(e) {
                            e.sender._popup.element.off(m), t.support.browser.msie && o.storedRange && o._inputFocused && s.selectRange(o.storedRange)
                        },
                        activate: function(e) {
                            e.preventDefault(), "rgba(255, 255, 255, 0)" !== e.sender._value.toCssRgba() && n.trigger("change")
                        }
                    }), n.wrapper.attr({
                        title: i.title,
                        unselectable: "on"
                    }).find("*:not(input)").attr("unselectable", "on"), n.value("transparent")
                }
            });
        u(i, {
            InlineFormatFinder: b,
            InlineFormatter: v,
            DelayedExecutionTool: C,
            GreedyInlineFormatFinder: y,
            GreedyInlineFormatter: k,
            InlineFormatTool: w,
            FontTool: x,
            ColorTool: T
        }), p("bold", [{
            tags: ["strong", "b"]
        }, {
            tags: ["span"],
            attr: {
                style: {
                    fontWeight: "bold"
                }
            }
        }]), f("bold", new w({
            key: "B",
            ctrl: !0,
            format: o.bold,
            template: new s({
                template: r.buttonTemplate,
                title: "Bold"
            })
        })), p("italic", [{
            tags: ["em", "i"]
        }, {
            tags: ["span"],
            attr: {
                style: {
                    fontStyle: "italic"
                }
            }
        }]), f("italic", new w({
            key: "I",
            ctrl: !0,
            format: o.italic,
            template: new s({
                template: r.buttonTemplate,
                title: "Italic"
            })
        })), p("underline", [{
            tags: ["span"],
            attr: {
                style: {
                    textDecoration: "underline"
                }
            }
        }, {
            tags: ["u"]
        }]), f("underline", new w({
            key: "U",
            ctrl: !0,
            format: o.underline,
            template: new s({
                template: r.buttonTemplate,
                title: "Underline"
            })
        })), p("strikethrough", [{
            tags: ["del", "strike"]
        }, {
            tags: ["span"],
            attr: {
                style: {
                    textDecoration: "line-through"
                }
            }
        }]), f("strikethrough", new w({
            format: o.strikethrough,
            template: new s({
                template: r.buttonTemplate,
                title: "Strikethrough"
            })
        })), p("superscript", [{
            tags: ["sup"]
        }]), f("superscript", new w({
            format: o.superscript,
            template: new s({
                template: r.buttonTemplate,
                title: "Superscript"
            })
        })), p("subscript", [{
            tags: ["sub"]
        }]), f("subscript", new w({
            format: o.subscript,
            template: new s({
                template: r.buttonTemplate,
                title: "Subscript"
            })
        })), f("foreColor", new T({
            cssAttr: "color",
            domAttr: "color",
            name: "foreColor",
            template: new s({
                template: r.colorPickerTemplate,
                title: "Color"
            })
        })), f("backColor", new T({
            cssAttr: "background-color",
            domAttr: "backgroundColor",
            name: "backColor",
            template: new s({
                template: r.colorPickerTemplate,
                title: "Background Color"
            })
        })), f("fontName", new x({
            cssAttr: "font-family",
            domAttr: "fontFamily",
            name: "fontName",
            defaultValue: [{
                text: "fontNameInherit",
                value: "inherit"
            }],
            template: new s({
                template: r.comboBoxTemplate,
                title: "Font Name"
            })
        })), f("fontSize", new x({
            cssAttr: "font-size",
            domAttr: "fontSize",
            name: "fontSize",
            defaultValue: [{
                text: "fontSizeInherit",
                value: "inherit"
            }],
            template: new s({
                template: r.comboBoxTemplate,
                title: "Font Size"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/link.min", ["editor/plugins/inlineformat.min"], e)
}(function() {
    ! function(e, t) {
        function n(e, t) {
            for (var n = e.length; n-- && !t.test(e[n]););
            return n
        }

        function i(e, t) {
            var n = t.exec(e);
            return n ? n.index : -1
        }
        var o = window.kendo,
            r = o.Class,
            a = e.extend,
            s = e.proxy,
            l = o.ui.editor,
            d = l.Dom,
            c = l.RangeUtils,
            u = l.EditorUtils,
            f = l.Command,
            p = l.Tool,
            m = l.ToolTemplate,
            h = l.InlineFormatter,
            g = l.InlineFormatFinder,
            b = c.textNodes,
            v = c.editableTextNodes,
            y = l.EditorUtils.registerTool,
            k = o.keys,
            w = "http://",
            C = /^\w*:\/\//,
            x = /[\w\/\$\-_\*\?]/i,
            T = r.extend({
                findSuitable: function(e) {
                    return d.parentOfType(e, ["a"])
                }
            }),
            _ = r.extend({
                init: function() {
                    this.finder = new T
                },
                apply: function(e, t) {
                    var n, i, o, r, a, s, l, u = this.immutables ? v(e) : b(e);
                    if (t.innerText) {
                        for (i = c.documentFromRange(e), n = c.getMarkers(e), e.deleteContents(), r = d.create(i, "a", t), e.insertNode(r), a = r.parentNode, "a" == d.name(a) && d.insertAfter(r, a), d.emptyNode(a) && d.remove(a), s = r, l = 0; l < n.length; l++) d.insertAfter(n[l], s), s = n[l];
                        n.length && (d.insertBefore(i.createTextNode("\ufeff"), n[1] || n[0]), d.insertAfter(i.createTextNode("\ufeff"), n[1] || n[0]), e.setStartBefore(n[0]), e.setEndAfter(n[n.length - 1]))
                    } else o = new h([{
                        tags: ["a"]
                    }], t), o.finder = this.finder, o.apply(u)
                }
            }),
            N = f.extend({
                init: function(e) {
                    var t = this;
                    e.formatter = {
                        toggle: function(e) {
                            var n = t.immutables() ? v(e) : b(e);
                            new h([{
                                tags: ["a"]
                            }]).remove(n)
                        }
                    }, this.options = e, f.fn.init.call(this, e)
                }
            }),
            S = f.extend({
                init: function(e) {
                    var t;
                    this.options = e, f.fn.init.call(this, e), this.formatter = new _, e.url ? this.exec = function() {
                        this.formatter.immutables = t && t.immutables(), this.formatter.apply(e.range, {
                            href: e.url,
                            innerText: e.text || e.url,
                            target: e.target
                        })
                    } : (this.attributes = null, this.async = !0)
                },
                _dialogTemplate: function() {
                    return o.template("<div class=\"k-editor-dialog k-popup-edit-form\"><div class=\"k-edit-form-container\"><div class='k-edit-label'><label for='k-editor-link-url'>#: messages.linkWebAddress #</label></div><div class='k-edit-field'><input type='text' class='k-textbox' id='k-editor-link-url'></div><div class='k-edit-label k-editor-link-text-row'><label for='k-editor-link-text'>#: messages.linkText #</label></div><div class='k-edit-field k-editor-link-text-row'><input type='text' class='k-textbox' id='k-editor-link-text'></div><div class='k-edit-label'><label for='k-editor-link-title'>#: messages.linkToolTip #</label></div><div class='k-edit-field'><input type='text' class='k-textbox' id='k-editor-link-title'></div><div class='k-edit-label'></div><div class='k-edit-field'><input type='checkbox' class='k-checkbox' id='k-editor-link-target'><label for='k-editor-link-target' class='k-checkbox-label'>#: messages.linkOpenInNewWindow #</label></div><div class='k-edit-buttons k-state-default'><button class=\"k-dialog-insert k-button k-primary\">#: messages.dialogInsert #</button><button class=\"k-dialog-close k-button\">#: messages.dialogCancel #</button></div></div></div>")({
                        messages: this.editor.options.messages
                    })
                },
                exec: function() {
                    var t, n, i, o, r = this.editor.options.messages;
                    this._initialText = "", this._range = this.lockRange(!0), this.formatter.immutables = this.immutables(), t = b(this._range), n = t.length ? this.formatter.finder.findSuitable(t[0]) : null, i = t.length && "img" == d.name(t[0]), o = this.createDialog(this._dialogTemplate(), {
                        title: r.createLink,
                        close: s(this._close, this),
                        visible: !1
                    }), n && (this._range.selectNodeContents(n), t = b(this._range)), this._initialText = this.linkText(t), o.find(".k-dialog-insert").click(s(this._apply, this)).end().find(".k-dialog-close").click(s(this._close, this)).end().find(".k-edit-field input").keydown(s(this._keydown, this)).end().find("#k-editor-link-url").val(this.linkUrl(n)).end().find("#k-editor-link-text").val(this._initialText).end().find("#k-editor-link-title").val(n ? n.title : "").end().find("#k-editor-link-target").attr("checked", !!n && "_blank" == n.target).end().find(".k-editor-link-text-row").toggle(!i), this._dialog = o.data("kendoWindow").center().open(), e("#k-editor-link-url", o).focus().select()
                },
                _keydown: function(e) {
                    var t = o.keys;
                    e.keyCode == t.ENTER ? this._apply(e) : e.keyCode == t.ESC && this._close(e)
                },
                _apply: function(t) {
                    var n, i, o, r = this._dialog.element,
                        a = e("#k-editor-link-url", r).val(),
                        s = e("#k-editor-link-text", r);
                    a && a != w && (a.indexOf("@") > 0 && !/^(\w+:)|(\/\/)/i.test(a) && (a = "mailto:" + a), this.attributes = {
                        href: a
                    }, n = e("#k-editor-link-title", r).val(), n && (this.attributes.title = n), s.is(":visible") && (i = s.val(), i || this._initialText ? i && i !== this._initialText && (this.attributes.innerText = d.stripBom(i)) : this.attributes.innerText = a), o = e("#k-editor-link-target", r).is(":checked"), this.attributes.target = o ? "_blank" : null, this.formatter.apply(this._range, this.attributes)), this._close(t), this.change && this.change()
                },
                _close: function(e) {
                    e.preventDefault(), this._dialog.destroy(), d.windowFromDocument(c.documentFromRange(this._range)).focus(), this.releaseRange(this._range)
                },
                linkUrl: function(e) {
                    return e ? e.getAttribute("href", 2) : w
                },
                linkText: function(e) {
                    var t, n = "";
                    for (t = 0; t < e.length; t++) n += e[t].nodeValue;
                    return d.stripBom(n || "")
                },
                redo: function() {
                    var e = this.lockRange(!0);
                    this.formatter.apply(e, this.attributes), this.releaseRange(e)
                }
            }),
            R = f.extend({
                init: function(e) {
                    f.fn.init.call(this, e), this.formatter = new _
                },
                exec: function() {
                    var e, t, n, i = this.detectLink();
                    i && (e = this.getRange(), t = new o.ui.editor.Marker, n = e.cloneRange(), n.setStart(i.start.node, i.start.offset), n.setEnd(i.end.node, i.end.offset), e = this.lockRange(), t.add(n), this.formatter.apply(n, {
                        href: this._ensureWebProtocol(i.text)
                    }), t.remove(n), this.releaseRange(e))
                },
                detectLink: function() {
                    var e, t, n = this.getRange(),
                        i = n.startContainer,
                        o = n.startOffset,
                        r = i.previousSibling;
                    return !r && (d.isBom(i) && !i.nextSibling || !o && d.isDataNode(i)) && (i = i.parentNode, o = 0), e = new P({
                        node: i,
                        offset: o,
                        cancelAtNode: function(e) {
                            return e && "a" === d.name(e)
                        }
                    }), t = new z(e), t.detectLink()
                },
                changesContent: function() {
                    return !!this.detectLink()
                },
                _ensureWebProtocol: function(e) {
                    var t = this._hasProtocolPrefix(e);
                    return t ? e : this._prefixWithWebProtocol(e)
                },
                _hasProtocolPrefix: function(e) {
                    return C.test(e)
                },
                _prefixWithWebProtocol: function(e) {
                    return w + e
                }
            }),
            A = p.extend({
                init: function(t) {
                    this.options = t, this.finder = new g([{
                        tags: ["a"]
                    }]), p.fn.init.call(this, e.extend(t, {
                        command: N
                    }))
                },
                initialize: function(e, t) {
                    p.fn.initialize.call(this, e, t), e.addClass("k-state-disabled")
                },
                update: function(e, t) {
                    e.toggleClass("k-state-disabled", !this.finder.isFormatted(t)).removeClass("k-state-hover")
                }
            }),
            z = r.extend({
                init: function(e) {
                    this.traverser = e, this.start = E(), this.end = E(), this.text = ""
                },
                detectLink: function() {
                    var t, n, i, o, r = this.traverser.node,
                        a = this.traverser.offset;
                    if (d.isDataNode(r)) {
                        if (t = r.data.substring(0, a), /\s{2}$/.test(d.stripBom(t))) return
                    } else 0 === a && (n = d.closestEditableOfType(r, d.blockElements), n && n.previousSibling && this.traverser.init({
                        node: n.previousSibling
                    }));
                    return this.traverser.traverse(e.proxy(this._detectEnd, this)), this.end.blank() || (this.traverser = this.traverser.clone(this.end), this.traverser.traverse(e.proxy(this._detectStart, this)), this._isLinkDetected() || (i = this.traverser.extendOptions(this.start), o = new D(i), o.traverse(e.proxy(this._skipStartPuntuation, this)), this._isLinkDetected() || (this.start = E()))), this.start.blank() ? null : {
                        start: this.start,
                        end: this.end,
                        text: this.text
                    }
                },
                _isLinkDetected: function() {
                    return C.test(this.text) || /^w{3}\./i.test(this.text)
                },
                _detectEnd: function(e, t) {
                    var i = n(e, x);
                    if (i > -1) return this.end.node = t, this.end.offset = i + 1, !1
                },
                _detectStart: function(e, t) {
                    var i = n(e, /\s/),
                        o = i + 1;
                    if (this.text = e.substring(o) + this.text, this.start.node = t, this.start.offset = o, i > -1) return !1
                },
                _skipStartPuntuation: function(e, t, n) {
                    var o = i(e, /\w/),
                        r = o;
                    if (o === -1 && (r = e.length), this.text = this.text.substring(r), this.start.node = t, this.start.offset = r + (0 | n), o > -1) return !1
                }
            }),
            E = function() {
                return {
                    node: null,
                    offset: null,
                    blank: function() {
                        return null === this.node && null === this.offset
                    }
                }
            },
            I = r.extend({
                init: function(n) {
                    this.node = n.node, this.offset = n.offset === t ? d.isDataNode(this.node) && this.node.length || 0 : n.offset, this.cancelAtNode = n.cancelAtNode || this.cancelAtNode || e.noop
                },
                traverse: function(e) {
                    e && (this.cancel = !1, this._traverse(e, this.node, this.offset))
                },
                _traverse: function(e, n, i) {
                    var o, r, a, s;
                    if (n && !this.cancel) {
                        if (3 !== n.nodeType) return r = this.edgeNode(n), this.cancel = this.cancel || this.cancelAtNode(r), this._traverse(e, r);
                        if (o = n.data, i !== t && (o = this.subText(o, i)), this.cancel = e(o, n, i) === !1, a = this.next(n), !a)
                            for (s = n.parentNode; !a && d.isInline(s);) a = this.next(s), s = s.parentNode;
                        this.cancel = this.cancel || this.cancelAtNode(a), this._traverse(e, a)
                    }
                },
                extendOptions: function(t) {
                    return e.extend({
                        node: this.node,
                        offset: this.offset,
                        cancelAtNode: this.cancelAtNode
                    }, t || {})
                },
                edgeNode: function(e) {},
                next: function(e) {},
                subText: function(e, t) {}
            }),
            P = I.extend({
                subText: function(e, t) {
                    return e.substring(0, t)
                },
                next: function(e) {
                    return e.previousSibling
                },
                edgeNode: function(e) {
                    return e.lastChild
                },
                clone: function(e) {
                    var t = this.extendOptions(e);
                    return new P(t)
                }
            }),
            D = I.extend({
                subText: function(e, t) {
                    return e.substring(t)
                },
                next: function(e) {
                    return e.nextSibling
                },
                edgeNode: function(e) {
                    return e.firstChild
                },
                clone: function(e) {
                    var t = this.extendOptions(e);
                    return new D(t)
                }
            });
        a(o.ui.editor, {
            LinkFormatFinder: T,
            LinkFormatter: _,
            UnlinkCommand: N,
            LinkCommand: S,
            AutoLinkCommand: R,
            UnlinkTool: A,
            DomTextLinkDetection: z,
            LeftDomTextTraverser: P,
            RightDomTextTraverser: D
        }), y("createLink", new p({
            key: "K",
            ctrl: !0,
            command: S,
            template: new m({
                template: u.buttonTemplate,
                title: "Create Link"
            })
        })), y("unlink", new A({
            key: "K",
            ctrl: !0,
            shift: !0,
            template: new m({
                template: u.buttonTemplate,
                title: "Remove Link"
            })
        })), y("autoLink", new p({
            key: [k.ENTER, k.SPACEBAR],
            keyPressCommand: !0,
            command: R
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/formatblock.min", ["editor/plugins/format.min"], e)
}(function() {
    ! function(e) {
        var t, n = window.kendo,
            i = n.Class,
            o = e.extend,
            r = n.ui.editor,
            a = n.ui.Editor.fn.options.formats,
            s = r.Dom,
            l = r.ToolTemplate,
            d = r.FormatTool,
            c = r.EditorUtils,
            u = c.registerTool,
            f = c.registerFormat,
            p = r.RangeUtils,
            m = i.extend({
                init: function(e) {
                    this.format = e
                },
                contains: function(e, t) {
                    var n, i, o;
                    for (n = 0, i = t.length; n < i; n++)
                        if (o = t[n], !o || !s.isAncestorOrSelf(e, o)) return !1;
                    return !0
                },
                findSuitable: function(t) {
                    var n, i, o, r, a = this.format,
                        l = [];
                    for (n = 0, i = t.length; n < i; n++) {
                        for (r = a.length - 1; r >= 0 && !(o = s.ofType(t[n], a[r].tags) ? t[n] : s.closestEditableOfType(t[n], a[r].tags)); r--);
                        if (!o || "true" === o.contentEditable) return [];
                        e.inArray(o, l) < 0 && l.push(o)
                    }
                    for (this._resolveListsItems(l), n = 0, i = l.length; n < i; n++)
                        if (this.contains(l[n], l)) return [l[n]];
                    return l
                },
                _resolveListsItems: function(e) {
                    var t, n, i;
                    for (t = 0; t < e.length; t++) n = e[t], i = s.is(n, "li") ? n : s.wrapper(n), i = i && s.list(i) ? i.children[0] : i, s.is(i, "li") && (n = e[t] = i)
                },
                findFormat: function(e) {
                    var t, n, i, o, a, l, d = this.format,
                        c = s.editableParent(e),
                        u = this.options && this.options.immutables,
                        f = r.Immutables;
                    for (t = 0, n = d.length; t < n; t++) {
                        if (i = e, o = d[t].tags, a = d[t].attr, u && o && "immutable" == o[0] && (l = f.immutableParent(i), l && s.attrEquals(l, a))) return i;
                        for (; i && s.isAncestorOf(c, i);) {
                            if (s.ofType(i, o) && s.attrEquals(i, a)) return i;
                            i = i.parentNode
                        }
                    }
                    return null
                },
                getFormat: function(e) {
                    var t, n, i = this,
                        o = function(e) {
                            return i.findFormat(s.isDataNode(e) ? e.parentNode : e)
                        },
                        r = o(e[0]);
                    if (!r) return "";
                    for (t = 1, n = e.length; t < n; t++)
                        if (r != o(e[t])) return "";
                    return r.nodeName.toLowerCase()
                },
                isFormatted: function(e) {
                    for (var t = 0, n = e.length; t < n; t++)
                        if (!this.findFormat(e[t])) return !1;
                    return !0
                }
            }),
            h = i.extend({
                init: function(e, t) {
                    this.format = e, this.values = t, this.finder = new m(e)
                },
                wrap: function(e, t, n) {
                    var i, o, r, a, l, d = 1 == n.length ? s.blockParentOrBody(n[0]) : s.commonAncestor.apply(null, n);
                    for (s.isInline(d) && (d = s.blockParentOrBody(d)), i = s.significantChildNodes(d), o = s.findNodeIndex(i[0]), r = s.create(d.ownerDocument, e, t), a = 0; a < i.length; a++) l = i[a], s.isBlock(l) ? (s.attr(l, t), r.childNodes.length && (s.insertBefore(r, l), r = r.cloneNode(!1)), o = s.findNodeIndex(l) + 1) : r.appendChild(l);
                    r.firstChild && s.insertAt(d, r, o)
                },
                apply: function(t) {
                    function n(e) {
                        return o({}, e && e.attr, m)
                    }
                    var i, r, a, l, d, u, f, p, m = this.values;
                    if (this._handleImmutables(t, !0), r = s.filter("img", t), a = c.formatByName("img", this.format), l = n(a), e.each(r, function() {
                            s.attr(this, l)
                        }), r.length != t.length)
                        if (d = s.filter("img", t, !0), u = this.finder.findSuitable(d), u.length)
                            for (f = 0, p = u.length; f < p; f++) i = c.formatByName(s.name(u[f]), this.format), s.attr(u[f], n(i));
                        else i = this.format[0], this.wrap(i.tags[0], n(i), d)
                },
                _handleImmutables: function(e, t) {
                    var n, i, o, a, l;
                    if (this.immutables() && (n = c.formatByName("immutable", this.format)))
                        for (i = r.Immutables, o = e.length - 1, a = o; a >= 0; a--) l = i.immutableParent(e[a]), l && (l !== e[a + 1] && (t ? s.attr(l, n.attr) : s.unstyle(l, n.attr.style)), e.splice(a, 1))
                },
                immutables: function() {
                    return this.editor && this.editor.options.immutables
                },
                remove: function(e) {
                    var t, n, i, o, r;
                    for (this._handleImmutables(e, !1), t = 0, n = e.length; t < n; t++) i = this.finder.findFormat(e[t]), i && (r = s.name(i), o = c.formatByName(r, this.format), o.attr.style && s.unstyle(i, o.attr.style), o.attr.className && s.removeClass(i, o.attr.className))
                },
                toggle: function(e) {
                    var t = this,
                        n = s.filterBy(p.nodes(e), s.htmlIndentSpace, !0);
                    t.finder.isFormatted(n) ? t.remove(n) : t.apply(n)
                }
            }),
            g = i.extend({
                init: function(e, t) {
                    var n = this;
                    n.format = e, n.values = t, n.finder = new m(e)
                },
                apply: function(e) {
                    var t, n, i, o, a, l, d, c, u, f, p = this.format,
                        m = s.blockParents(e),
                        g = p[0].tags[0];
                    if (m.length)
                        for (t = 0, n = m.length; t < n; t++) c = m[t], u = this.immutables() && r.Immutables.immutableParent(c), u || (d = s.name(c), "li" == d ? (i = c.parentNode, o = new r.ListFormatter(i.nodeName.toLowerCase(), g), a = this.editor.createRange(), a.selectNode(m[t]), o.toggle(a)) : g && ("td" == d || c.attributes.contentEditable) ? new h(p, this.values).apply(c.childNodes) : (l = s.changeTag(c, g), s.attr(l, p[0].attr)));
                    else f = new h(p, this.values), f.editor = this.editor, f.apply(e)
                },
                toggle: function(e) {
                    var t = p.textNodes(e);
                    t.length || (e.selectNodeContents(e.commonAncestorContainer), t = p.textNodes(e), t.length || (t = s.significantChildNodes(e.commonAncestorContainer))), this.apply(t)
                },
                immutables: function() {
                    return this.editor && this.editor.options.immutables
                }
            }),
            b = d.extend({
                init: function(e) {
                    d.fn.init.call(this, o(e, {
                        finder: new m(e.format),
                        formatter: function() {
                            return new h(e.format)
                        }
                    }))
                }
            });
        o(r, {
            BlockFormatFinder: m,
            BlockFormatter: h,
            GreedyBlockFormatter: g,
            BlockFormatTool: b
        }), t = ["ul", "ol", "li"], f("justifyLeft", [{
            tags: s.nonListBlockElements,
            attr: {
                style: {
                    textAlign: "left"
                }
            }
        }, {
            tags: ["img"],
            attr: {
                style: {
                    "float": "left",
                    display: "",
                    marginLeft: "",
                    marginRight: ""
                }
            }
        }, {
            tags: ["immutable"],
            attr: {
                style: {
                    "float": "left",
                    display: "",
                    marginLeft: "",
                    marginRight: ""
                }
            }
        }, {
            tags: t,
            attr: {
                style: {
                    textAlign: "left",
                    listStylePosition: ""
                }
            }
        }]), u("justifyLeft", new b({
            format: a.justifyLeft,
            template: new l({
                template: c.buttonTemplate,
                title: "Justify Left"
            })
        })), f("justifyCenter", [{
            tags: s.nonListBlockElements,
            attr: {
                style: {
                    textAlign: "center"
                }
            }
        }, {
            tags: ["img"],
            attr: {
                style: {
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                    "float": ""
                }
            }
        }, {
            tags: ["immutable"],
            attr: {
                style: {
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                    "float": ""
                }
            }
        }, {
            tags: t,
            attr: {
                style: {
                    textAlign: "center",
                    listStylePosition: "inside"
                }
            }
        }]), u("justifyCenter", new b({
            format: a.justifyCenter,
            template: new l({
                template: c.buttonTemplate,
                title: "Justify Center"
            })
        })), f("justifyRight", [{
            tags: s.nonListBlockElements,
            attr: {
                style: {
                    textAlign: "right"
                }
            }
        }, {
            tags: ["img"],
            attr: {
                style: {
                    "float": "right",
                    display: "",
                    marginLeft: "",
                    marginRight: ""
                }
            }
        }, {
            tags: ["immutable"],
            attr: {
                style: {
                    "float": "right",
                    display: "",
                    marginLeft: "",
                    marginRight: ""
                }
            }
        }, {
            tags: t,
            attr: {
                style: {
                    textAlign: "right",
                    listStylePosition: "inside"
                }
            }
        }]), u("justifyRight", new b({
            format: a.justifyRight,
            template: new l({
                template: c.buttonTemplate,
                title: "Justify Right"
            })
        })), f("justifyFull", [{
            tags: s.nonListBlockElements,
            attr: {
                style: {
                    textAlign: "justify"
                }
            }
        }, {
            tags: ["img"],
            attr: {
                style: {
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                    "float": ""
                }
            }
        }, {
            tags: ["immutable"],
            attr: {
                style: {
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                    "float": ""
                }
            }
        }, {
            tags: t,
            attr: {
                style: {
                    textAlign: "justify",
                    listStylePosition: ""
                }
            }
        }]), u("justifyFull", new b({
            format: a.justifyFull,
            template: new l({
                template: c.buttonTemplate,
                title: "Justify Full"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/lists.min", ["editor/plugins/formatblock.min"], e)
}(function() {
    ! function(e) {
        var t = window.kendo,
            n = t.Class,
            i = e.extend,
            o = t.ui.editor,
            r = o.Dom,
            a = o.RangeUtils,
            s = o.EditorUtils,
            l = o.Command,
            d = o.ToolTemplate,
            c = o.FormatTool,
            u = o.BlockFormatFinder,
            f = a.textNodes,
            p = o.EditorUtils.registerTool,
            m = u.extend({
                init: function(e) {
                    this.tag = e;
                    var t = this.tags = ["ul" == e ? "ol" : "ul", e];
                    u.fn.init.call(this, [{
                        tags: t
                    }])
                },
                isFormatted: function(e) {
                    var t, n, i = [];
                    for (n = 0; n < e.length; n++) t = this.findFormat(e[n]), t && r.name(t) == this.tag && i.push(t);
                    if (i.length < 1) return !1;
                    if (i.length != e.length) return !1;
                    for (n = 0; n < i.length && i[n].parentNode == t.parentNode; n++)
                        if (i[n] != t) return !1;
                    return !0
                },
                findSuitable: function(e) {
                    var t = this.findFormat(e[0]);
                    return t && r.name(t) == this.tag ? t : null
                }
            }),
            h = n.extend({
                init: function(e, t) {
                    var n = this;
                    n.finder = new m(e), n.tag = e, n.unwrapTag = t
                },
                isList: function(e) {
                    return r.list(e)
                },
                immutables: function() {
                    return this.editor && !!this.editor.options.immutables
                },
                wrap: function(t, n) {
                    var i, a, s = r.create(t.ownerDocument, "li"),
                        l = this.immutables() ? o.Immutables.immutable : e.noop;
                    for (i = 0; i < n.length; i++)
                        if (a = n[i], r.is(a, "li")) t.appendChild(a);
                        else if (this.isList(a))
                        for (; a.firstChild;) t.appendChild(a.firstChild);
                    else if (r.is(a, "td")) {
                        for (; a.firstChild;) s.appendChild(a.firstChild);
                        t.appendChild(s), a.appendChild(t), t = t.cloneNode(!1), s = s.cloneNode(!1)
                    } else s.appendChild(a), r.isBlock(a) && (t.appendChild(s), l(a) || r.unwrap(a), s = s.cloneNode(!1));
                    s.firstChild && t.appendChild(s)
                },
                containsAny: function(e, t) {
                    for (var n = 0; n < t.length; n++)
                        if (r.isAncestorOrSelf(e, t[n])) return !0;
                    return !1
                },
                suitable: function(e, t) {
                    if ("k-marker" == e.className) {
                        var n = e.nextSibling;
                        if (n && r.isBlock(n)) return !1;
                        if (n = e.previousSibling, n && r.isBlock(n)) return !1
                    }
                    return this.containsAny(e, t) || r.isInline(e) || 3 == e.nodeType
                },
                _parentLists: function(t) {
                    var n = r.closestEditable(t);
                    return e(t).parentsUntil(n, "ul,ol")
                },
                split: function(e) {
                    var t, n, i, o, s, l, d = f(e);
                    if (d.length)
                        for (t = r.parentOfType(d[0], ["li"]), n = r.parentOfType(d[d.length - 1], ["li"]), e.setStartBefore(t), e.setEndAfter(n), o = 0, s = d.length; o < s; o++) l = this.finder.findFormat(d[o]), l && (i = this._parentLists(l), i.length ? a.split(e, i.last()[0], !0) : a.split(e, l, !0))
                },
                merge: function(e, t) {
                    for (var n, i = t.previousSibling; i && ("k-marker" == i.className || 3 == i.nodeType && r.isWhitespace(i));) i = i.previousSibling;
                    if (i && r.name(i) == e) {
                        for (; t.firstChild;) i.appendChild(t.firstChild);
                        r.remove(t), t = i
                    }
                    for (n = t.nextSibling; n && ("k-marker" == n.className || 3 == n.nodeType && r.isWhitespace(n));) n = n.nextSibling;
                    if (n && r.name(n) == e) {
                        for (; t.lastChild;) n.insertBefore(t.lastChild, n.firstChild);
                        r.remove(t)
                    }
                },
                breakable: function(e) {
                    return e != e.ownerDocument.body && !/table|tbody|thead|tr|td/.test(r.name(e)) && !e.attributes.contentEditable
                },
                applyOnSection: function(t, n) {
                    function i() {
                        u.push(this)
                    }
                    var o, a, s, l, d = this.tag,
                        c = r.closestSplittableParent(n),
                        u = [],
                        f = this.finder.findSuitable(n);
                    for (f || (f = new m("ul" == d ? "ol" : "ul").findSuitable(n)), /table|tbody|thead/.test(r.name(c)) ? o = e.map(n, function(e) {
                            return r.parentOfType(e, ["td"])
                        }) : (o = r.significantChildNodes(c), e.grep(o, r.isBlock).length && (o = e.grep(o, e.proxy(function(e) {
                            return this.containsAny(e, n)
                        }, this))), o.length || (o = n)), a = 0; a < o.length; a++) s = o[a], l = (!f || !r.isAncestorOrSelf(f, s)) && this.suitable(s, n), l && (f && this.isList(s) ? (e.each(s.children, i), r.remove(s)) : u.push(s));
                    for (u.length == o.length && this.breakable(c) && (u = [c]), f || (f = r.create(c.ownerDocument, d), r.isBlock(u[0]) && r.mergeAttributes(u[0], f), r.insertBefore(f, u[0])), this.wrap(f, u); r.isBom(f.nextSibling);) r.remove(f.nextSibling);
                    r.is(f, d) || r.changeTag(f, d), this.merge(d, f)
                },
                apply: function(t) {
                    function n() {
                        i && c.push({
                            section: i,
                            nodes: a
                        })
                    }
                    var i, a, s, l, d = 0,
                        c = [],
                        u = t.length,
                        f = this.immutables() ? o.Immutables.immutableParent : e.noop;
                    for (d = 0; d < u; d++) l = f(t[d]) || t[d], s = r.closestEditable(l, ["td", "th", "body"]), i && s == i ? a.push(l) : (n(), a = [l], i = s);
                    for (n(), d = 0; d < c.length; d++) this.applyOnSection(c[d].section, c[d].nodes)
                },
                unwrap: function(e) {
                    var t, n, i, o, a = e.ownerDocument.createDocumentFragment(),
                        s = this.unwrapTag;
                    for (n = e.firstChild; n; n = n.nextSibling) {
                        for (i = r.create(e.ownerDocument, s || "p"); n.firstChild;) o = n.firstChild, r.isBlock(o) ? (i.firstChild && (a.appendChild(i), i = r.create(e.ownerDocument, s || "p")), a.appendChild(o)) : i.appendChild(o);
                        i.firstChild && a.appendChild(i)
                    }
                    t = this._parentLists(e), t[0] ? (r.insertAfter(a, t.last()[0]), t.last().remove()) : r.insertAfter(a, e), r.remove(e)
                },
                remove: function(e) {
                    var t, n, i;
                    for (n = 0, i = e.length; n < i; n++) t = this.finder.findFormat(e[n]),
                        t && this.unwrap(t)
                },
                toggle: function(e) {
                    var t, n = this,
                        i = f(e),
                        o = e.commonAncestorContainer;
                    i.length || (e.selectNodeContents(o), i = f(e), i.length || (t = o.ownerDocument.createTextNode(""), e.startContainer.appendChild(t), i = [t], e.selectNode(t.parentNode))), i = r.filterBy(i, r.htmlIndentSpace, !0), n.finder.isFormatted(i) ? (n.split(e), n.remove(i)) : n.apply(i)
                }
            }),
            g = l.extend({
                init: function(e) {
                    e.formatter = new h(e.tag), l.fn.init.call(this, e)
                }
            }),
            b = c.extend({
                init: function(e) {
                    this.options = e, c.fn.init.call(this, i(e, {
                        finder: new m(e.tag)
                    }))
                },
                command: function(e) {
                    return new g(i(e, {
                        tag: this.options.tag
                    }))
                }
            });
        i(o, {
            ListFormatFinder: m,
            ListFormatter: h,
            ListCommand: g,
            ListTool: b
        }), p("insertUnorderedList", new b({
            tag: "ul",
            template: new d({
                template: s.buttonTemplate,
                title: "Insert unordered list"
            })
        })), p("insertOrderedList", new b({
            tag: "ol",
            template: new d({
                template: s.buttonTemplate,
                title: "Insert ordered list"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/formatting.min", ["editor/plugins/inlineformat.min"], e)
}(function() {
    ! function(e) {
        function t(e) {
            var t, o, r = l.closestEditableOfType(e, ["li"]);
            r && (t = new i.ListFormatter(l.name(r.parentNode)), o = n.ui.editor.W3CRange.fromNode(e), o.selectNode(r), t.toggle(o))
        }
        var n = window.kendo,
            i = n.ui.editor,
            o = i.Tool,
            r = i.ToolTemplate,
            a = i.DelayedExecutionTool,
            s = i.Command,
            l = i.Dom,
            d = i.EditorUtils,
            c = i.RangeUtils,
            u = d.registerTool,
            f = a.extend({
                init: function(e) {
                    var t = this;
                    o.fn.init.call(t, n.deepExtend({}, t.options, e)), t.type = "kendoSelectBox", t.finder = {
                        getFormat: function() {
                            return ""
                        }
                    }
                },
                options: {
                    items: [{
                        text: "Paragraph",
                        value: "p"
                    }, {
                        text: "Quotation",
                        value: "blockquote"
                    }, {
                        text: "Heading 1",
                        value: "h1"
                    }, {
                        text: "Heading 2",
                        value: "h2"
                    }, {
                        text: "Heading 3",
                        value: "h3"
                    }, {
                        text: "Heading 4",
                        value: "h4"
                    }, {
                        text: "Heading 5",
                        value: "h5"
                    }, {
                        text: "Heading 6",
                        value: "h6"
                    }],
                    width: 110
                },
                toFormattingItem: function(e) {
                    var t, n = e.value;
                    return n ? e.tag || e.className ? e : (t = n.indexOf("."), 0 === t ? e.className = n.substring(1) : t == -1 ? e.tag = n : (e.tag = n.substring(0, t), e.className = n.substring(t + 1)), e) : e
                },
                command: function(t) {
                    var n = this,
                        o = t.value;
                    return o = this.toFormattingItem(o), new i.FormatCommand({
                        range: t.range,
                        formatter: function() {
                            var t, r = (o.tag || o.context || "span").split(","),
                                a = [{
                                    tags: r,
                                    attr: {
                                        className: o.className || ""
                                    }
                                }];
                            return t = e.inArray(r[0], l.inlineElements) >= 0 ? new i.GreedyInlineFormatter(a) : new i.GreedyBlockFormatter(a), t.editor = n.editor, t
                        }
                    })
                },
                initialize: function(e, t) {
                    var i, r = t.editor,
                        a = this.options,
                        s = a.name,
                        l = this;
                    l.editor = r, e.width(a.width), i = e.kendoSelectBox({
                        dataTextField: "text",
                        dataValueField: "value",
                        dataSource: a.items || r.options[s],
                        title: r.options.messages[s],
                        autoSize: !0,
                        change: function() {
                            var e = this.dataItem();
                            e && o.exec(r, s, e.toJSON())
                        },
                        dataBound: function() {
                            var e, t = this.dataSource.data();
                            for (e = 0; e < t.length; e++) t[e] = l.toFormattingItem(t[e])
                        },
                        highlightFirst: !1,
                        template: n.template('<span unselectable="on" style="display:block;#=(data.style||"")#">#:data.text#</span>')
                    }).data("kendoSelectBox"), e.attr("title", t.title), i.wrapper.attr("title", t.title), e.addClass("k-decorated").closest(".k-widget").removeClass("k-" + s).find("*").addBack().attr("unselectable", "on")
                },
                getFormattingValue: function(t, n) {
                    var i, o, r, a, s, l, d;
                    for (i = 0; i < t.length; i++)
                        if (o = t[i], r = o.tag || o.context || "", a = o.className ? "." + o.className : "", s = r + a, l = e(n[0]).closest(s)[0]) {
                            if (1 == n.length) return o.value;
                            for (d = 1; d < n.length && e(n[d]).closest(s)[0]; d++)
                                if (d == n.length - 1) return o.value
                        }
                    return ""
                },
                update: function(t, n) {
                    var i, o, r, s, d, c = e(t).data(this.type);
                    if (c && (i = c.dataSource, o = i.data(), d = l.commonAncestor.apply(null, n), d == l.closestEditable(d) || this._ancestor != d)) {
                        for (this._ancestor = d, r = 0; r < o.length; r++) s = o[r].context, o[r].visible = !s || !!e(d).closest(s).length;
                        i.filter([{
                            field: "visible",
                            operator: "eq",
                            value: !0
                        }]), a.fn.update.call(this, t, n), c.value(this.getFormattingValue(i.view(), n)), c.wrapper.toggleClass("k-state-disabled", !i.view().length)
                    }
                },
                destroy: function() {
                    this._ancestor = null
                }
            }),
            p = s.extend({
                exec: function() {
                    var e, t, n, i = this.lockRange(!0);
                    for (this.tagsToClean = this.options.remove || "strong,em,span,sup,sub,del,b,i,u,font".split(","), c.wrapSelectedElements(i), e = c.mapAll(i, function(e) {
                            return e
                        }), t = e.length - 1; t >= 0; t--) n = e[t], this.immutableParent(n) || this.clean(n);
                    this.releaseRange(i)
                },
                clean: function(n) {
                    var o, r, a, s, d;
                    if (n && !l.isMarker(n)) {
                        if (o = l.name(n), "ul" == o || "ol" == o)
                            for (r = new i.ListFormatter(o), a = n.previousSibling, s = n.nextSibling, r.unwrap(n); a && a != s; a = a.nextSibling) this.clean(a);
                        else if ("blockquote" == o) l.changeTag(n, "p");
                        else if (1 != n.nodeType || l.insignificant(n)) t(n);
                        else {
                            for (d = n.childNodes.length - 1; d >= 0; d--) this.clean(n.childNodes[d]);
                            n.removeAttribute("style"), n.removeAttribute("class")
                        }
                        e.inArray(o, this.tagsToClean) > -1 && l.unwrap(n)
                    }
                },
                immutableParent: function(e) {
                    return this.immutables() && i.Immutables.immutableParent(e)
                }
            });
        e.extend(i, {
            FormattingTool: f,
            CleanFormatCommand: p
        }), u("formatting", new f({
            template: new r({
                template: d.dropDownListTemplate,
                title: "Format"
            })
        })), u("cleanFormatting", new o({
            command: p,
            template: new r({
                template: d.buttonTemplate,
                title: "Clean formatting"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/image.min", ["kendo.imagebrowser.min", "editor/command.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            i = e.extend,
            o = n.ui.editor,
            r = o.EditorUtils,
            a = o.Dom,
            s = r.registerTool,
            l = o.ToolTemplate,
            d = o.RangeUtils,
            c = o.Command,
            u = n.keys,
            f = "#k-editor-image-url",
            p = "#k-editor-image-title",
            m = "#k-editor-image-width",
            h = "#k-editor-image-height",
            g = c.extend({
                init: function(e) {
                    var t = this;
                    c.fn.init.call(t, e), t.async = !0, t.attributes = {}
                },
                insertImage: function(e, t) {
                    var n, i = this.attributes,
                        o = d.documentFromRange(t);
                    if (i.src && "http://" != i.src) {
                        if (n = function() {
                                setTimeout(function() {
                                    i.width || e.removeAttribute("width"), i.height || e.removeAttribute("height"), e.removeAttribute("complete")
                                })
                            }, !e) return e = a.create(o, "img", i), e.onload = e.onerror = n, t.deleteContents(), t.insertNode(e), e.nextSibling || a.insertAfter(o.createTextNode("\ufeff"), e), n(), t.setStartAfter(e), t.setEndAfter(e), d.selectRange(t), !0;
                        e.onload = e.onerror = n, a.attr(e, i), n()
                    }
                    return !1
                },
                _dialogTemplate: function(e) {
                    return n.template('<div class="k-editor-dialog k-popup-edit-form"><div class="k-edit-form-container"><div class="k-edit-form-content"># if (showBrowser) { #<div class="k-filebrowser k-imagebrowser"></div># } #<div class=\'k-edit-label\'><label for="k-editor-image-url">#: messages.imageWebAddress #</label></div><div class=\'k-edit-field\'><input type="text" class="k-textbox" id="k-editor-image-url"></div><div class=\'k-edit-label\'><label for="k-editor-image-title">#: messages.imageAltText #</label></div><div class=\'k-edit-field\'><input type="text" class="k-textbox" id="k-editor-image-title"></div><div class=\'k-edit-label\'><label for="k-editor-image-width">#: messages.imageWidth #</label></div><div class=\'k-edit-field\'><input type="text" class="k-textbox" id="k-editor-image-width"></div><div class=\'k-edit-label\'><label for="k-editor-image-height">#: messages.imageHeight #</label></div><div class=\'k-edit-field\'><input type="text" class="k-textbox" id="k-editor-image-height"></div></div><div class="k-edit-buttons k-state-default"><button class="k-dialog-insert k-button k-primary">#: messages.dialogInsert #</button><button class="k-dialog-close k-button">#: messages.dialogCancel #</button></div></div></div>')({
                        messages: this.editor.options.messages,
                        showBrowser: e
                    })
                },
                redo: function() {
                    var e = this,
                        t = e.lockRange();
                    e.insertImage(d.image(t), t) || e.releaseRange(t)
                },
                exec: function() {
                    function e(e) {
                        var t = s.element,
                            n = parseInt(t.find(m).val(), 10),
                            i = parseInt(t.find(h).val(), 10);
                        g.attributes = {
                            src: t.find(f).val().replace(/ /g, "%20"),
                            alt: t.find(p).val()
                        }, g.attributes.width = null, g.attributes.height = null, !isNaN(n) && n > 0 && (g.attributes.width = n), !isNaN(i) && i > 0 && (g.attributes.height = i), v = g.insertImage(y, b), o(e), g.change && g.change()
                    }

                    function o(e) {
                        e.preventDefault(), s.destroy(), a.windowFromDocument(d.documentFromRange(b)).focus(), v || g.releaseRange(b)
                    }

                    function r(t) {
                        t.keyCode == u.ENTER ? e(t) : t.keyCode == u.ESC && o(t)
                    }
                    var s, l, c, g = this,
                        b = g.lockRange(),
                        v = !1,
                        y = d.image(b),
                        k = y && y.getAttribute("width") || "",
                        w = y && y.getAttribute("height") || "",
                        C = n.support.browser.msie,
                        x = g.editor.options,
                        T = x.messages,
                        _ = x.imageBrowser,
                        N = !!(n.ui.ImageBrowser && _ && _.transport && _.transport.read !== t),
                        S = {
                            title: T.insertImage,
                            visible: !1,
                            resizable: N
                        };
                    this.expandImmutablesIn(b), S.close = o, N && (S.width = 750), s = this.createDialog(g._dialogTemplate(N), S).toggleClass("k-filebrowser-dialog", N).find(".k-dialog-insert").click(e).end().find(".k-dialog-close").click(o).end().find(".k-edit-field input").keydown(r).end().find(f).val(y ? y.getAttribute("src", 2) : "http://").end().find(p).val(y ? y.alt : "").end().find(m).val(k).end().find(h).val(w).end().data("kendoWindow"), l = s.element, N && (this._imageBrowser = new n.ui.ImageBrowser(l.find(".k-imagebrowser"), i({}, _)), this._imageBrowser.bind("change", function(e) {
                        "f" === e.selected.get("type") && l.find(f).val(this.value())
                    }), this._imageBrowser.bind("apply", e)), C && (c = l.closest(".k-window").height(), l.css("max-height", c)), s.center().open(), l.find(f).focus().select()
                }
            });
        n.ui.editor.ImageCommand = g, s("insertImage", new o.Tool({
            command: g,
            template: new l({
                template: r.buttonTemplate,
                title: "Insert Image"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/import.min", ["editor/main.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            i = e.extend,
            o = e.proxy,
            r = n.ui.editor,
            a = r.EditorUtils,
            s = r.Command,
            l = r.Tool,
            d = a.registerTool,
            c = r.ToolTemplate,
            u = '<div contenteditable="false" class="k-loading-mask" style="width: 100%; height: 100%; position: absolute; top: 0px; left: 0px;"><div class="k-loading-image"></div><div class="k-loading-color"></div></div>',
            f = s.extend({
                exec: function() {
                    (this.editor._uploadWidget || this._initializeUploadWidget()).element.click()
                },
                _initializeUploadWidget: function() {
                    var t = this,
                        n = t.editor,
                        i = n.options["import"],
                        r = e('<input id="editorImport" name="files" type="file" />').kendoUpload({
                            success: o(t._onUploadSuccess, t),
                            progress: o(t._onUploadProgress, t),
                            select: o(t._onUploadSelect, t),
                            error: o(t._onUploadError, t),
                            complete: o(t._onUploadComplete, t),
                            showFileList: !1,
                            multiple: !1,
                            async: {
                                saveUrl: i.proxyUrl,
                                autoUpload: !0,
                                saveField: "file"
                            },
                            validation: {
                                allowedExtensions: i.allowedExtensions,
                                maxFileSize: i.maxFileSize
                            }
                        }).getKendoUpload();
                    return n._uploadWidget = r, r
                },
                _onUploadComplete: function(e) {
                    this._trigger("complete", e), e.sender.clearAllFiles(), this._removeLoadingOverlay()
                },
                _onUploadSuccess: function(e) {
                    this.editor.value(e.response.html.replace(/<\/?body>/gi, "")), this._trigger("success", e)
                },
                _onUploadProgress: function(e) {
                    this._trigger("progress", e)
                },
                _onUploadSelect: function(e) {
                    this._trigger("select", e), e.files[0].validationErrors || this._initLoadingOverlay()
                },
                _onUploadError: function(e) {
                    this._trigger("error", e)
                },
                _trigger: function(e, t) {
                    var n = this.editor,
                        i = n.options["import"];
                    "function" == typeof i[e] && i[e].call(n, t)
                },
                _initLoadingOverlay: function() {
                    var t = this.editor.body;
                    r.Dom.is(t, "body") ? this._iframeWrapper = this._container = this.editor.wrapper.find("iframe").parent().css({
                        position: "relative"
                    }).append(u) : this._container = e(t).append(u), n.ui.progress(this._container, !0)
                },
                _removeLoadingOverlay: function() {
                    n.ui.progress(this._container, !1), e(this._iframeWrapper).css({
                        position: ""
                    }), delete this._container, delete this._iframeWrapper
                }
            });
        i(r, {
            ImportCommand: f
        }), d("import", new l({
            command: f,
            template: new c({
                template: a.buttonTemplate,
                title: "Import"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/insert.min", ["editor/command.min"], e)
}(function() {
    ! function(e) {
        var t = window.kendo,
            n = t.ui.editor,
            i = n.Command,
            o = n.GenericCommand,
            r = n.EditorUtils,
            a = r.registerTool,
            s = n.Tool,
            l = n.ToolTemplate,
            d = n.RestorePoint,
            c = e.extend,
            u = i.extend({
                init: function(e) {
                    i.fn.init.call(this, e), this.managesUndoRedo = !0
                },
                exec: function() {
                    var e, t = this.editor,
                        n = this.options,
                        i = n.range,
                        r = t.body,
                        a = new d(i, r),
                        s = n.html || n.value || "";
                    t.selectRange(i), t.clipboard.paste(s, n), n.postProcess && n.postProcess(t, t.getRange()), e = new o(a, new d(t.getRange(), r)), e.editor = t, t.undoRedoStack.push(e), t.focus()
                }
            }),
            f = s.extend({
                initialize: function(e, t) {
                    var i = t.editor,
                        o = this.options,
                        r = o.items ? o.items : i.options.insertHtml;
                    this._selectBox = new n.SelectBox(e, {
                        dataSource: r,
                        dataTextField: "text",
                        dataValueField: "value",
                        change: function() {
                            s.exec(i, "insertHtml", this.value())
                        },
                        title: i.options.messages.insertHtml,
                        highlightFirst: !1
                    }), e.attr("title", t.title), this._selectBox.wrapper.attr("title", t.title)
                },
                command: function(e) {
                    return new u(e)
                },
                update: function(e) {
                    var t = e.data("kendoSelectBox") || e.find("select").data("kendoSelectBox");
                    t.close(), t.value(t.options.title)
                }
            });
        c(n, {
            InsertHtmlCommand: u,
            InsertHtmlTool: f
        }), a("insertHtml", new f({
            template: new l({
                template: r.dropDownListTemplate,
                title: "Insert HTML",
                initialValue: "Insert HTML"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/export.min", ["editor/main.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            i = e.extend,
            o = e.proxy,
            r = n.ui.editor,
            a = r.EditorUtils,
            s = r.Command,
            l = r.Tool,
            d = a.registerTool,
            c = r.ToolTemplate,
            u = [{
                text: "Docx",
                value: "docx"
            }, {
                text: "Rtf",
                value: "rtf"
            }, {
                text: "Pdf",
                value: "pdf"
            }, {
                text: "Html",
                value: "html"
            }, {
                text: "Plain Text",
                value: "txt"
            }],
            f = s.extend({
                init: function(e) {
                    var t = this;
                    t.options = e, s.fn.init.call(t, e), t.attributes = null, t.exportType = e.exportType
                },
                exec: function() {
                    var e = this,
                        t = this.lockRange(!0);
                    e.postToProxy(), e.releaseRange(t)
                },
                postToProxy: function() {
                    this.generateForm().appendTo("body").submit().remove()
                },
                generateForm: function() {
                    var t = this,
                        n = t.editor.options.exportAs,
                        i = e("<form>").attr({
                            action: n && n.proxyURL || "",
                            method: "POST"
                        });
                    return i.append([t.valueInput(), t.exportTypeInput(), t.fileNameInput()]), i
                },
                valueInput: function() {
                    var t = this.editor;
                    return e("<input>").attr({
                        value: t.encodedValue(),
                        name: "value",
                        type: "hidden"
                    })
                },
                exportTypeInput: function() {
                    var t = this;
                    return e("<input>").attr({
                        value: t.exportType,
                        name: "exportType",
                        type: "hidden"
                    })
                },
                fileNameInput: function() {
                    var t = this.editor,
                        n = t.options.exportAs,
                        i = n && n.fileName || t.element.attr("id") || "editor";
                    return e("<input>").attr({
                        value: i,
                        name: "fileName",
                        type: "hidden"
                    })
                }
            }),
            p = l.extend({
                init: function(e) {
                    var t = this;
                    l.fn.init.call(t, n.deepExtend({}, t.options, e)), t.type = "kendoSelectBox"
                },
                options: {
                    items: u,
                    width: 115
                },
                command: function(e) {
                    var t = e.value;
                    return new r.ExportAsCommand({
                        range: e.range,
                        exportType: t.exportType
                    })
                },
                initialize: function(e, t) {
                    var i, r = this,
                        a = t.editor,
                        s = r.options,
                        l = s.name,
                        d = o(r.changeHandler, r),
                        c = s.items || a.options[l];
                    c.unshift({
                        text: a.options.messages[l],
                        value: ""
                    }), r.editor = a, e.width(s.width), i = e.kendoSelectBox({
                        dataTextField: "text",
                        dataValueField: "value",
                        dataSource: c,
                        autoSize: !0,
                        change: d,
                        open: function(e) {
                            var t = e.sender;
                            t.items()[0].style.display = "none", t.unbind("open")
                        },
                        highlightFirst: !1,
                        template: n.template('<span unselectable="on" style="display:block;#=(data.style||"")#">#:data.text#</span>')
                    }).data("kendoSelectBox"), e.attr("title", t.title), i.wrapper.attr("title", t.title), e.addClass("k-decorated").closest(".k-widget").removeClass("k-" + l).find("*").addBack().attr("unselectable", "on")
                },
                changeHandler: function(e) {
                    var t = e.sender,
                        n = t.dataItem(),
                        i = n && n.value;
                    this._exec(i), t.value("")
                },
                _exec: function(e) {
                    e && l.exec(this.editor, this.options.name, {
                        exportType: e
                    })
                },
                destroy: function() {
                    this._ancestor = null
                }
            });
        i(r, {
            ExportAsTool: p,
            ExportAsCommand: f
        }), d("exportAs", new p({
            template: new c({
                template: a.dropDownListTemplate,
                title: "Export As"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/indent.min", ["editor/plugins/formatblock.min"], e)
}(function() {
    ! function(e, t) {
        function n(n, i) {
            var o = "rtl" == e(n).css("direction"),
                r = o ? "Right" : "Left",
                a = "td" != s.name(n) ? "margin" + r : "padding" + r;
            return i === t ? n.style[a] || 0 : (i > 0 ? n.style[a] = i + "px" : (n.style[a] = "", n.style.cssText || n.removeAttribute("style")), t)
        }
        var i = window.kendo,
            o = i.Class,
            r = e.extend,
            a = i.ui.editor,
            s = a.Dom,
            l = a.EditorUtils,
            d = l.registerTool,
            c = a.Command,
            u = a.Tool,
            f = a.ToolTemplate,
            p = a.RangeUtils,
            m = s.blockElements,
            h = a.BlockFormatFinder,
            g = a.BlockFormatter,
            b = o.extend({
                init: function() {
                    this.finder = new h([{
                        tags: s.blockElements
                    }])
                },
                apply: function(t) {
                    var i, o, r, a, l, d, c, u, f, p, m, h;
                    if (t = s.filterBy(t, s.htmlIndentSpace, !0), i = this.finder.findSuitable(t), o = [], i = this.mapImmutables(i), i.length) {
                        for (r = 0, a = i.length; r < a; r++) s.is(i[r], "li") ? e(i[r]).index() ? e.inArray(i[r].parentNode, o) < 0 && o.push(i[r]) : o.push(i[r].parentNode) : o.push(i[r]);
                        for (; o.length;)
                            if (l = o.shift(), s.is(l, "li"))
                                if (d = l.parentNode, c = e(l).prev("li"), u = c.find("ul,ol").last(), f = e(l).children("ul,ol")[0], f && c[0]) u[0] ? (u.append(l), u.append(e(f).children()), s.remove(f)) : (c.append(f), f.insertBefore(l, f.firstChild));
                                else
                                    for (f = c.children("ul,ol")[0], f || (f = s.create(l.ownerDocument, s.name(d)), c.append(f)); l && l.parentNode == d;) f.appendChild(l), l = o.shift();
                        else
                            for (p = parseInt(n(l), 10) + 30, n(l, p), m = 0; m < o.length; m++) e.contains(l, o[m]) && o.splice(m, 1)
                    } else h = new g([{
                        tags: ["p"]
                    }], {
                        style: {
                            marginLeft: 30
                        }
                    }), h.apply(t)
                },
                mapImmutables: function(t) {
                    if (this.immutables) {
                        var n = [];
                        return e.map(t, function(t) {
                            var i = a.Immutables.immutableParent(t);
                            if (i) {
                                if (e.inArray(i, n) !== -1) return null;
                                n.push(i)
                            }
                            return i || t
                        })
                    }
                    return t
                },
                remove: function(t) {
                    t = s.filterBy(t, s.htmlIndentSpace, !0);
                    var i, o, r, a, l, d, c, u, f = this.finder.findSuitable(t);
                    for (f = this.mapImmutables(f), o = 0, r = f.length; o < r; o++) {
                        if (c = e(f[o]), c.is("li")) {
                            if (a = c.parent(), l = a.parent(), l.is("li,ul,ol") && !n(a[0])) {
                                if (i && e.contains(i, l[0])) continue;
                                d = c.nextAll("li"), d.length && e(a[0].cloneNode(!1)).appendTo(c).append(d), l.is("li") ? c.insertAfter(l) : c.appendTo(l), a.children("li").length || a.remove();
                                continue
                            }
                            if (i == a[0]) continue;
                            i = a[0]
                        } else i = f[o];
                        u = parseInt(n(i), 10) - 30, n(i, u)
                    }
                }
            }),
            v = c.extend({
                init: function(t) {
                    var n = this;
                    t.formatter = {
                        toggle: e.proxy(function(e) {
                            var t = new b;
                            t.immutables = this.editor && this.editor.options.immutables, t.apply(p.nodes(e))
                        }, n)
                    }, c.fn.init.call(this, t)
                }
            }),
            y = c.extend({
                init: function(t) {
                    var n = this;
                    t.formatter = {
                        toggle: e.proxy(function(e) {
                            var t = new b;
                            t.immutables = this.editor && this.editor.options.immutables, t.remove(p.nodes(e))
                        }, n)
                    }, c.fn.init.call(this, t)
                }
            }),
            k = u.extend({
                init: function(e) {
                    u.fn.init.call(this, e), this.finder = new h([{
                        tags: m
                    }])
                },
                initialize: function(t, n) {
                    u.fn.initialize.call(this, t, n), e.extend(this.options, {
                        immutables: n.editor && n.editor.options.immutables
                    }), t.addClass("k-state-disabled")
                },
                update: function(i, o) {
                    var r, l, d, c, u, f, p = this.finder.findSuitable(o);
                    for (d = 0, c = p.length; d < c; d++)
                        if (u = p[d], this.options.immutables && (f = a.Immutables.immutableParent(u), f && (u = f)), r = n(u), r || (l = e(u).parents("ul,ol").length, r = s.is(u, "li") && (l > 1 || n(u.parentNode)) || s.ofType(u, ["ul", "ol"]) && l > 0), r) return i.removeClass("k-state-disabled"), t;
                    i.addClass("k-state-disabled").removeClass("k-state-hover")
                }
            });
        r(a, {
            IndentFormatter: b,
            IndentCommand: v,
            OutdentCommand: y,
            OutdentTool: k
        }), d("indent", new u({
            command: v,
            template: new f({
                template: l.buttonTemplate,
                title: "Indent"
            })
        })), d("outdent", new k({
            command: y,
            template: new f({
                template: l.buttonTemplate,
                title: "Outdent"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/linebreak.min", ["editor/plugins/formatblock.min"], e)
}(function() {
    ! function(e) {
        var t = window.kendo,
            n = e.extend,
            i = t.ui.editor,
            o = i.Dom,
            r = i.Command,
            a = i.Tool,
            s = i.BlockFormatter,
            l = o.normalize,
            d = i.RangeUtils,
            c = i.EditorUtils.registerTool,
            u = r.extend({
                init: function(e) {
                    this.options = e, r.fn.init.call(this, e)
                },
                _insertMarker: function(e, t) {
                    var n, i = o.create(e, "a");
                    return i.className = "k-marker", t.insertNode(i), i.parentNode || (n = t.commonAncestorContainer, n.innerHTML = "", n.appendChild(i)), l(i.parentNode), i
                },
                _moveFocus: function(e, t) {
                    var n, i;
                    if (o.isEmpty(t)) e.setStartBefore(t);
                    else {
                        if (e.selectNodeContents(t), n = d.textNodes(e)[0], !n) {
                            for (; t.childNodes.length && !o.is(t.firstChild, "br");) t = t.firstChild;
                            n = t
                        }
                        o.isEmpty(n) ? e.setStartBefore(n) : (o.emptyNode(n) && (n.innerHTML = "\ufeff"), i = n.firstChild || n, o.isDataNode(i) ? e.setStart(i, 0) : e.setStartBefore(i))
                    }
                },
                shouldTrim: function(e) {
                    var t = "p,h1,h2,h3,h4,h5,h6".split(","),
                        n = o.parentOfType(e.startContainer, t),
                        i = o.parentOfType(e.endContainer, t);
                    return n && !i || !n && i
                },
                _blankAfter: function(e) {
                    for (; e && (o.isMarker(e) || "" === o.stripBom(e.nodeValue));) e = e.nextSibling;
                    return !e
                },
                exec: function() {
                    var t, n, r, a, c, u, f, p, m, h, g, b, v, y, k = this.getRange(),
                        w = d.documentFromRange(k),
                        C = i.emptyElementContent;
                    this.expandImmutablesIn(k), h = this.shouldTrim(k), k.deleteContents(), c = this._insertMarker(w, k), o.stripBomNode(c.previousSibling), o.stripBomNode(c.nextSibling), u = o.closestEditableOfType(c, ["li"]), f = o.closestEditableOfType(c, "h1,h2,h3,h4,h5,h6".split(",")), p = o.is(c.parentNode, "table") && c.parentNode, u ? o.emptyNode(u) && (a = o.create(w, "p"), o.next(u) && (m = k.cloneRange(), m.selectNode(u), d.split(m, u.parentNode)), g = e("br", u), 1 == g.length && g.remove(), b = u.parentNode, v = u.parentNode.children.length, y = v > 1 && 1 == u.childNodes.length && u.children[0], o.insertAfter(a, b), o.remove(1 == v ? u.parentNode : u), y && y !== c ? (a.appendChild(y), a.appendChild(c)) : a.innerHTML = C, r = a) : f && this._blankAfter(c) ? (a = this._insertParagraphAfter(f), o.remove(c), r = a) : p && (a = this._insertParagraphAfter(p), o.remove(c), r = a), r || (u || f || new s([{
                        tags: ["p"]
                    }]).apply([c]), k.selectNode(c), t = o.parentOfType(c, [u ? "li" : f ? o.name(f) : "p"]), d.split(k, t, h), n = t.previousSibling, o.is(n, "li") && n.firstChild && !o.is(n.firstChild, "br") && (n = n.firstChild), r = t.nextSibling, this.clean(n, {
                        links: !0
                    }), this.clean(r, {
                        links: !0
                    }), o.is(r, "li") && r.firstChild && !o.is(r.firstChild, "br") && (r = r.firstChild), o.remove(t), l(n)), l(r), this._moveFocus(k, r), k.collapse(!0), o.scrollTo(r, !0), d.selectRange(k)
                },
                _insertParagraphAfter: function(e) {
                    var t = this.getRange(),
                        n = d.documentFromRange(t),
                        r = i.emptyElementContent,
                        a = o.create(n, "p");
                    return o.insertAfter(a, e), a.innerHTML = r, a
                },
                clean: function(t, n) {
                    var r, a = t;
                    if (t.firstChild && o.is(t.firstChild, "br") && o.remove(t.firstChild), o.isDataNode(t) && !t.nodeValue && (t = t.parentNode), t) {
                        for (r = !1; t.firstChild && 1 == t.firstChild.nodeType;) r = r || o.significantNodes(t.childNodes).length > 1, t = t.firstChild;
                        if (o.isEmpty(t) || !/^\s*$/.test(t.innerHTML) || r || (e(a).find(".k-br").remove(), t.innerHTML = i.emptyElementContent), n && n.links)
                            for (; t != a;) {
                                if (o.is(t, "a") && o.emptyNode(t)) {
                                    o.unwrap(t);
                                    break
                                }
                                t = t.parentNode
                            }
                    }
                }
            }),
            f = r.extend({
                init: function(e) {
                    this.options = e, r.fn.init.call(this, e)
                },
                exec: function() {
                    var e, n, i, r, a, s, c = this.getRange();
                    this.expandImmutablesIn(c), e = o.create(d.documentFromRange(c), "br"), n = c.startContainer, r = t.support.browser, a = r.msie && r.version < 11, s = o.is(n, "table") && n, c.deleteContents(), s ? o.insertAfter(e, s) : c.insertNode(e), l(e.parentNode), a || e.nextSibling && !o.isWhitespace(e.nextSibling) || (i = e.cloneNode(!0), i.className = "k-br", o.insertAfter(i, e)), c.setStartAfter(e), c.collapse(!0), o.scrollTo(e.nextSibling || e, !0), d.selectRange(c)
                }
            });
        n(i, {
            ParagraphCommand: u,
            NewLineCommand: f
        }), c("insertLineBreak", new a({
            key: 13,
            shift: !0,
            command: f
        })), c("insertParagraph", new a({
            key: 13,
            command: u
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/file.min", ["kendo.filebrowser.min", "editor/plugins/link.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            i = e.extend,
            o = n.ui.editor,
            r = o.EditorUtils,
            a = o.Dom,
            s = r.registerTool,
            l = o.ToolTemplate,
            d = o.RangeUtils,
            c = o.Command,
            u = o.LinkFormatter,
            f = d.textNodes,
            p = n.keys,
            m = "#k-editor-file-url",
            h = "#k-editor-file-text",
            g = "#k-editor-file-title",
            b = c.extend({
                init: function(e) {
                    var t = this;
                    c.fn.init.call(t, e), t.formatter = new u, t.async = !0, t.attributes = {}
                },
                insertFile: function(e, t) {
                    var n = this.attributes,
                        i = d.documentFromRange(t);
                    if (n.href && "http://" != n.href) {
                        if (!e) return e = a.create(i, "a", {
                            href: n.href
                        }), e.innerHTML = n.innerHTML, e.title = n.title, t.deleteContents(), t.insertNode(e), e.nextSibling || a.insertAfter(i.createTextNode("\ufeff"), e), t.setStartAfter(e), t.setEndAfter(e), d.selectRange(t), !0;
                        a.attr(e, n)
                    }
                    return !1
                },
                _dialogTemplate: function(e) {
                    return n.template('<div class="k-editor-dialog k-popup-edit-form"><div class="k-edit-form-container"><div class="k-edit-form-content"># if (showBrowser) { #<div class="k-filebrowser"></div># } #<div class=\'k-edit-label\'><label for="k-editor-file-url">#: messages.fileWebAddress #</label></div><div class=\'k-edit-field\'><input type="text" class="k-textbox" id="k-editor-file-url"></div><div class=\'k-edit-label\'><label for="k-editor-file-text">#: messages.fileText #</label></div><div class=\'k-edit-field\'><input type="text" class="k-textbox" id="k-editor-file-text"></div><div class=\'k-edit-label\'><label for="k-editor-file-title">#: messages.fileTitle #</label></div><div class=\'k-edit-field\'><input type="text" class="k-textbox" id="k-editor-file-title"></div></div><div class="k-edit-buttons k-state-default"><button class="k-dialog-insert k-button k-primary">#: messages.dialogInsert #</button><button class="k-dialog-close k-button">#: messages.dialogCancel #</button></div></div></div>')({
                        messages: this.editor.options.messages,
                        showBrowser: e
                    })
                },
                redo: function() {
                    var e = this,
                        t = e.lockRange();
                    this.formatter.apply(t, this.attributes), e.releaseRange(t)
                },
                exec: function() {
                    function e(e) {
                        var t = s.element,
                            n = t.find(m).val().replace(/ /g, "%20"),
                            i = t.find(h).val(),
                            r = t.find(g).val();
                        u.attributes = {
                            href: n,
                            innerHTML: "" !== i ? i : n,
                            title: r
                        }, y = u.insertFile(k, b), o(e), u.change && u.change()
                    }

                    function o(e) {
                        e.preventDefault(), s.destroy(), a.windowFromDocument(d.documentFromRange(b)).focus(), y || u.releaseRange(b)
                    }

                    function r(t) {
                        t.keyCode == p.ENTER ? e(t) : t.keyCode == p.ESC && o(t)
                    }
                    var s, l, c, u = this,
                        b = u.lockRange(),
                        v = f(b),
                        y = !1,
                        k = v.length ? this.formatter.finder.findSuitable(v[0]) : null,
                        w = n.support.browser.msie,
                        C = u.editor.options,
                        x = C.messages,
                        T = C.fileBrowser,
                        _ = !!(n.ui.FileBrowser && T && T.transport && T.transport.read !== t),
                        N = {
                            title: x.insertFile,
                            visible: !1,
                            resizable: _
                        };
                    this.expandImmutablesIn(b), N.close = o, _ && (N.width = 750), s = this.createDialog(u._dialogTemplate(_), N).toggleClass("k-filebrowser-dialog", _).find(".k-dialog-insert").click(e).end().find(".k-dialog-close").click(o).end().find(".k-edit-field input").keydown(r).end().find(m).val(k ? k.getAttribute("href", 2) : "http://").end().find(h).val(k ? k.innerText : "").end().find(g).val(k ? k.title : "").end().data("kendoWindow"), l = s.element, _ && (u._fileBrowser = new n.ui.FileBrowser(l.find(".k-filebrowser"), i({}, T)), u._fileBrowser.bind("change", function(e) {
                        "f" === e.selected.get("type") && l.find(m).val(this.value())
                    }), u._fileBrowser.bind("apply", e)), w && (c = l.closest(".k-window").height(), l.css("max-height", c)), s.center().open(), l.find(m).focus().select()
                }
            });
        n.ui.editor.FileCommand = b, s("insertFile", new o.Tool({
            command: b,
            template: new l({
                template: r.buttonTemplate,
                title: "Insert File"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/tables.min", ["editor/plugins/formatblock.min", "editor/plugins/insert.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            i = e.extend,
            o = e.proxy,
            r = n.ui.editor,
            a = r.Dom,
            s = r.EditorUtils,
            l = r.RangeUtils,
            d = r.Command,
            c = "kendoEditor",
            u = "k-state-active",
            f = "k-state-selected",
            p = "scope",
            m = "row",
            h = "col",
            g = "rowgroup",
            b = "colgroup",
            v = "colspan",
            y = "rowspan",
            k = "table",
            w = "thead",
            C = "tbody",
            x = "tr",
            T = "td",
            _ = "th",
            N = r.Tool,
            S = r.ToolTemplate,
            R = r.InsertHtmlCommand,
            A = r.BlockFormatFinder,
            z = r.EditorUtils.registerTool,
            E = n.getTouches,
            I = n.template,
            P = "<td style='width:#=width#%;'>#=content#</td>",
            D = new A([{
                tags: [k]
            }]),
            H = R.extend({
                init: function(t) {
                    var n = e.extend({
                        postProcess: this.postProcess,
                        skipCleaners: !0
                    }, t || {});
                    R.fn.init.call(this, n)
                },
                _tableHtml: function(e, t) {
                    var n, i;
                    return e = e || 1, t = t || 1, n = I(P)({
                        width: 100 / t,
                        content: r.emptyTableCellContent
                    }), i = 100 / e, "<table class='k-table' data-last>" + Array(e + 1).join("<tr style='height:" + i + "%;'>" + Array(t + 1).join(n) + "</tr>") + "</table>"
                },
                postProcess: function(t, n) {
                    var i = e("table[data-last]", t.document).removeAttr("data-last");
                    n.setStart(i.find(T)[0], 0), n.collapse(!0), t.selectRange(n)
                },
                exec: function() {
                    var e = this.options;
                    e.html = this._tableHtml(e.rows, e.columns), R.fn.exec.call(this)
                }
            }),
            B = N.extend({
                initialize: function(t, n) {
                    var i, a, l, d;
                    N.fn.initialize.call(this, t, n), i = e(this.options.popupTemplate).appendTo("body").kendoPopup({
                        anchor: t,
                        copyAnchorStyles: !1,
                        open: o(this._open, this),
                        activate: o(this._activate, this),
                        close: o(this._close, this)
                    }).data("kendoPopup"), t.click(o(this._toggle, this)).keydown(o(this._keydown, this)), a = this._editor = n.editor, this._popup = i, l = new r.TableWizardTool({
                        template: new S({
                            template: s.tableWizardButtonTemplate,
                            title: a.options.messages.tableWizard
                        }),
                        command: r.TableWizardCommand,
                        insertNewTable: !0
                    }), z("tableWizardInsert", l), d = e("<div class='k-editor-toolbar'>" + l.options.template.getHtml() + "</div>"), d.appendTo(i.element), a.toolbar && a.toolbar.attachToolsEvents(d)
                },
                popup: function() {
                    return this._popup
                },
                _activate: e.noop,
                _open: function() {
                    this._popup.options.anchor.addClass(u)
                },
                _close: function() {
                    this._popup.options.anchor.removeClass(u)
                },
                _keydown: function(e) {
                    var t = n.keys,
                        i = e.keyCode;
                    i == t.DOWN && e.altKey ? this._popup.open() : i == t.ESC && this._popup.close()
                },
                _toggle: function(t) {
                    var n = e(t.target).closest(".k-tool");
                    n.hasClass("k-state-disabled") || this.popup().toggle()
                },
                update: function(e) {
                    var t = this.popup();
                    t.wrapper && "block" == t.wrapper.css("display") && t.close(), e.removeClass("k-state-hover")
                },
                destroy: function() {
                    this._popup.destroy()
                }
            }),
            F = B.extend({
                init: function(t) {
                    this.cols = 8, this.rows = 6, B.fn.init.call(this, e.extend(t, {
                        command: H,
                        popupTemplate: "<div class='k-ct-popup'>" + Array(this.cols * this.rows + 1).join("<span class='k-ct-cell k-state-disabled' />") + "<div class='k-status'></div></div>"
                    }))
                },
                _activate: function() {
                    function t(t) {
                        var n = e(window);
                        return {
                            row: Math.floor((t.clientY + n.scrollTop() - u.top) / o) + 1,
                            col: Math.floor((t.clientX + n.scrollLeft() - u.left) / i) + 1
                        }
                    }
                    var i, o, r = this,
                        a = r._popup.element,
                        s = a.find(".k-ct-cell"),
                        l = s.eq(0),
                        d = s.eq(s.length - 1),
                        u = n.getOffset(l),
                        f = n.getOffset(d),
                        p = r.cols,
                        m = r.rows;
                    a.find("*").addBack().attr("unselectable", "on"), f.left += d[0].offsetWidth, f.top += d[0].offsetHeight, i = (f.left - u.left) / p, o = (f.top - u.top) / m, a.autoApplyNS(c).on("mousemove", ".k-ct-cell", function(e) {
                        r._setTableSize(t(e))
                    }).on("mouseleave", ".k-ct-cell", function() {
                        r._setTableSize()
                    }).on("down", ".k-ct-cell", function(e) {
                        e.preventDefault();
                        var n = E(e)[0];
                        r._exec(t(n.location))
                    })
                },
                _valid: function(e) {
                    return e && e.row > 0 && e.col > 0 && e.row <= this.rows && e.col <= this.cols
                },
                _exec: function(e) {
                    this._valid(e) && (this._editor.exec("createTable", {
                        rows: e.row,
                        columns: e.col
                    }), this._popup.close())
                },
                _setTableSize: function(t) {
                    var i = this._popup.element,
                        o = i.find(".k-status"),
                        r = i.find(".k-ct-cell"),
                        a = this.cols,
                        s = this._editor.options.messages;
                    this._valid(t) ? (o.text(n.format(s.createTableHint, t.row, t.col)), r.each(function(n) {
                        e(this).toggleClass(f, n % a < t.col && n / a < t.row)
                    })) : (o.text(s.createTable), r.removeClass(f))
                },
                _keydown: function(e) {
                    var t, i, o, r, a, s, l, d;
                    B.fn._keydown.call(this, e), this._popup.visible() && (t = n.keys, i = e.keyCode, o = this._popup.element.find(".k-ct-cell"), r = Math.max(o.filter(".k-state-selected").last().index(), 0), a = Math.floor(r / this.cols), s = r % this.cols, l = !1, i != t.DOWN || e.altKey ? i == t.UP ? (l = !0, a--) : i == t.RIGHT ? (l = !0, s++) : i == t.LEFT && (l = !0, s--) : (l = !0, a++), d = {
                        row: Math.max(1, Math.min(this.rows, a + 1)),
                        col: Math.max(1, Math.min(this.cols, s + 1))
                    }, i == t.ENTER ? this._exec(d) : this._setTableSize(d), l && (e.preventDefault(), e.stopImmediatePropagation()))
                },
                _open: function() {
                    var e = this._editor.options.messages;
                    B.fn._open.call(this), this.popup().element.find(".k-status").text(e.createTable).end().find(".k-ct-cell").removeClass(f)
                },
                _close: function() {
                    B.fn._close.call(this), this.popup().element.off("." + c)
                }
            }),
            O = d.extend({
                _clearColIndexAttr: function(e) {
                    a.clearTableMappings(e, "col-index")
                },
                _mapColIndices: function(e) {
                    a.reMapTableColumns(e, "col-index")
                },
                _findRowSpanCell: function(t, n, i) {
                    var o, r, a;
                    for (a = n; a >= 0; a--)
                        if (o = t.rows[a], r = e(o).find("[col-index=" + i + "]"), r.length) return r
                },
                _resetTableResizing: function(e) {
                    e._destroyResizings(), e._initializeColumnResizing(), e._initializeRowResizing(), e._initializeTableResizing()
                },
                _findNextTdInRow: function(e, t) {
                    var n, i, o = e.find("td:last-child"),
                        r = parseInt(o.attr("col-index"), 10) + o.prop("colSpan") - 1;
                    for (i = t; i <= r; i++)
                        if (n = e.find("[col-index=" + i + "]"), n.length) return n
                },
                _adjustColgroups: function(e, t) {
                    for (var n, i, o, r = t.getElementsByTagName(h), s = t.getElementsByTagName(b), l = e.cells, d = l.length; r.length > 0;) r[0].remove();
                    for (; s.length > 0;) s[0].remove();
                    for (n = d - 1; n >= 0; n--) o = l[n], o.getAttribute(p) === b ? (i = a.createEmptyNode(this.editor.document, b), i.setAttribute("span", o.getAttribute(v)), t.prepend(i)) : t.prepend(a.createEmptyNode(this.editor.document, h))
                },
                _associateHeaderIds: function(t) {
                    a.clearTableMappings(t, "col-index"), a.reMapTableColumns(t, "col-index"), e(t).find("th, td").removeAttr("id headers"), a.associateWithIds(t)
                },
                _getNumberOfColumns: function(e) {
                    return a._getNumberOfColumns(e, "td, th")
                }
            }),
            L = O.extend({
                exec: function() {
                    var n, i, o, s, l, d, c, u, f = this.lockRange(!0),
                        h = a.closest(f.endContainer, [T, _]),
                        b = a.closest(h, k),
                        v = this.options.position || "after";
                    if (!b || this.immutables() && r.Immutables.immutableParent(h)) return this.releaseRange(f), t;
                    for (this._mapColIndices(b), i = h.parentNode, l = a.findNodeIndex(i, !0), h.rowSpan > 1 && "after" === v && (i = b.rows[l + h.rowSpan - 1]), n = this._getNumberOfColumns(b), s = i.cloneNode(!0), e(s).empty(), u = 0; u < n; u += o.prop("colSpan")) o = e(i).find("[col-index=" + u + "]"), o.length ? o.prop("rowSpan") > 1 && "after" === v && o ? o.attr(y, o.prop("rowSpan") + 1) : this._appendCell(s, o) : (l = a.findNodeIndex(i, !0), o = this._findRowSpanCell(i.parentElement, l, u), d = o.closest(x).index(), d + o.prop("rowSpan") - 1 === l && "after" === v ? this._appendCell(s, o) : o.attr(y, o.prop("rowSpan") + 1)), c = e(s).find("[col-index=" + u + "]"), c.attr(p) !== g || c.attr(y) || c.attr(p, m);
                    "before" == v ? a.insertBefore(s, i) : a.insertAfter(s, i), e(b).find("[headers]").length > 0 && this._associateHeaderIds(b), this._clearColIndexAttr(b), this.releaseRange(f), this._resetTableResizing(this.editor)
                },
                _appendCell: function(e, t) {
                    var n;
                    n = t.clone(), n.html(r.emptyTableCellContent), n.removeAttr(y), n.appendTo(e)
                }
            }),
            M = O.extend({
                exec: function() {
                    var n, i, o, s, l = this.lockRange(!0),
                        d = a.closest(l.endContainer, [T, _]),
                        c = a.closest(d, k),
                        u = c.getElementsByTagName(h),
                        f = c.getElementsByTagName(b),
                        m = c && c.rows,
                        g = this.options.position || "after";
                    if (!d || this.immutables() && r.Immutables.immutableParent(d)) return this.releaseRange(l), t;
                    for (this._mapColIndices(c), n = parseInt(d.getAttribute("col-index"), 10), d.colSpan > 1 && "after" === g && (d.setAttribute("col-index", n + d.colSpan - 1), n = n + d.colSpan - 1), i = 0; i < m.length; i++) o = this._processForColSpan(m[i], n, g, d), o && (s = o.cloneNode(), s.innerHTML = r.emptyTableCellContent, s.removeAttribute(v), s.getAttribute(p) && s.getAttribute(p) === b && s.setAttribute(p, h), "before" == g ? a.insertBefore(s, o) : a.insertAfter(s, o), this._resizeCells(s, o));
                    (u.length > 0 || f.length > 0) && this._adjustColgroups(m[0], c), e(c).find("[headers]").length > 0 && this._associateHeaderIds(c), this._clearColIndexAttr(c), this.releaseRange(l), this._resetTableResizing(this.editor)
                },
                _processForColSpan: function(n, i, o, r) {
                    var a, s, l = i - 1;
                    if (a = e(n).find("[col-index=" + i + "]")[0], a && a.colSpan > 1 && "after" === o && a !== r) return a.colSpan += 1, t;
                    if (a) return a;
                    for (l; l >= 0 && (a = e(n).find("[col-index=" + l + "]")[0], !(a && a.colSpan > 1)); l--);
                    return a ? (s = parseInt(a.getAttribute("col-index"), 10) + a.colSpan - 1, s === i && "after" === o ? a : (i <= s && a.setAttribute(v, a.colSpan + 1), t)) : t
                },
                _resizeCells: function(e, t) {
                    var n, i, o, r = e.style.width;
                    r && (n = parseFloat(r), i = r.slice(("" + n).length), o = n / 2 + i, e.style.width = o, t.style.width = o)
                }
            }),
            W = O.extend({
                exec: function() {
                    var n, i, o, s = this.lockRange(),
                        d = l.mapAll(s, function(t) {
                            return e(t).closest(x)[0]
                        }),
                        c = a.closest(s.endContainer, [T, _]),
                        u = d[0],
                        f = c ? c.rowSpan : 1,
                        p = e(d[0]).index(),
                        m = a.closest(u, k),
                        h = u.parentElement;
                    if (!m || this.immutables() && r.Immutables.immutableParent(u)) return this.releaseRange(s), t;
                    for (i = 0; i < f; i++) d.indexOf(h.rows[p + i]) < 0 && d.push(h.rows[p + i]);
                    if (m.rows.length <= d.length) n = a.next(m), n && !a.insignificant(n) || (n = a.prev(m)), a.remove(m), this._resetTableResizing(this.editor);
                    else if (h.rows.length <= d.length) n = h.nextSibling, n || (n = h.previousSibling), a.remove(h);
                    else {
                        for (this._mapColIndices(m), o = 0; o < d.length; o++) u = d[o], a.removeTextSiblings(u), n = a.next(u) || a.prev(u), n = n.cells[0], this._handleRowSpanCells(m, u), a.remove(u);
                        this._clearColIndexAttr(m)
                    }
                    e(m).find("[headers]").length > 0 ? this._associateHeaderIds(m) : a.is(h, w) && e(m).find("[scope]").length > 0 && this._adjustColgroups(h.rows[0], m), n && (s.setStart(n, 0), s.collapse(!0), this.editor.selectRange(s)), this._resetTableResizing(this.editor)
                },
                _handleRowSpanCells: function(t, n) {
                    var i, o, r, s, l = a.findNodeIndex(n, !0),
                        d = t.rows[0],
                        c = d.cells[d.cells.length - 1],
                        u = parseInt(c.getAttribute("col-index"), 10) + c.colSpan - 1;
                    for (i = 0; i <= u; i += o.prop("colSpan")) o = e(n).find("[col-index=" + i + "]"), o.length && o.prop("rowSpan") > 1 && (s = t.rows[l + 1], r = e(s).find("[col-index=" + (i + 1) + "]"), r.length ? r.before(o) : e(s).append(o), this._reduceRowSpan(o)), o.length || (o = this._findRowSpanCell(n.parentElement, l, i), this._reduceRowSpan(o))
                },
                _reduceRowSpan: function(e) {
                    var t = e.prop("rowSpan") - 1;
                    t <= 1 ? (e.removeAttr(y), e.attr(p) === g && e.attr(p, m)) : e.attr(y, t)
                }
            }),
            U = O.extend({
                exec: function() {
                    var n, i, o, s, l = this.lockRange(),
                        d = a.closest(l.endContainer, [T, _]),
                        c = a.closest(d, k),
                        u = c && c.rows,
                        f = a.findNodeIndex(d, !0),
                        p = u && u[0].cells.length,
                        m = c.getElementsByTagName(h),
                        g = c.getElementsByTagName(b);
                    if (!d || this.immutables() && r.Immutables.immutableParent(d)) return this.releaseRange(l), t;
                    if (1 == p || d.colSpan == p) n = a.next(c), n && !a.insignificant(n) || (n = a.prev(c)), a.remove(c), this._resetTableResizing(this.editor);
                    else {
                        for (a.removeTextSiblings(d), n = a.next(d) || a.prev(d), this._mapColIndices(c), f = parseInt(d.getAttribute("col-index"), 10), s = 0; s < d.colSpan; s++)
                            for (i = 0; i < u.length; i += o.prop("rowSpan") || 1) o = e(u[i]).find("[col-index=" + (f + s) + "]"), o.length && o.prop("colSpan") <= 1 ? o.remove() : this._handleColSpanCells(u[i], f + s);
                        this._clearColIndexAttr(c)
                    }(m.length > 0 || g.length > 0) && this._adjustColgroups(u[0], c), e(c).find("[headers]").length > 0 && this._associateHeaderIds(c), n && (l.setStart(n, 0), l.collapse(!0), this.editor.selectRange(l)), this._resetTableResizing(this.editor)
                },
                _handleColSpanCells: function(n, i) {
                    var o, r, a = e(n).find("[col-index=" + i + "]");
                    if (a.length && a.prop("colSpan") > 1) return o = a.clone(!0), a.after(o), this._reduceColSpan(o), o.attr("col-index", parseInt(a.attr("col-index"), 10) + 1), a.remove(), t;
                    for (r = i; r >= 0; r--)
                        if (a = e(n).find("[col-index=" + r + "]"), a.length) return this._reduceColSpan(a), a.attr("col-index", parseInt(a.attr("col-index"), 10) + 1), t
                },
                _reduceColSpan: function(e) {
                    var t = e.prop("colSpan") - 1;
                    t <= 1 ? (e.removeAttr(v), e.attr(p) === b && e.attr(p, h)) : e.attr(v, t)
                }
            }),
            V = O.extend({
                exec: function() {
                    var n, i, o, s, l, d = this.lockRange(),
                        c = a.closest(d.endContainer, [T, _]);
                    return c ? (n = a.closest(c, k), i = c.parentNode, o = a.findNodeIndex(c, !0), s = i.children[o + 1], this.immutables() && r.Immutables.immutableParent(c) ? (this.releaseRange(d), t) : (this._mapColIndices(n), o = parseInt(e(c).attr("col-index"), 10), s = e(i).find("[col-index=" + (o + 1 + this._getColspan(c) - 1) + "]").get(0), s && s.rowSpan === c.rowSpan && c.tagName === s.tagName ? (l = this._getColspan(c) + this._getColspan(s), e(c).prop(v, l).append(a.emptyNode(s) ? "" : "<br/>" + s.innerHTML), e(c).width(c.offsetWidth), e(s).remove(), c.getAttribute(p) === h && c.setAttribute(p, b), c.getAttribute(p) === b && this._adjustColgroups(i, n), e(n).find("[headers]").length > 0 && this._associateHeaderIds(n), this._clearColIndexAttr(n), this.releaseRange(d), this._resetTableResizing(this.editor), t) : (this._clearColIndexAttr(n), this.releaseRange(d), t))) : (this.releaseRange(d), t)
                },
                _getColspan: function(e) {
                    return parseInt(e.getAttribute(v), 10) || 1
                }
            }),
            j = O.extend({
                exec: function() {
                    var n, i, o, s, l, d, c, u = this.lockRange(),
                        f = a.closest(u.endContainer, [T, _]);
                    return f ? (n = a.closest(f, x), i = a.closest(f, [w, C]), o = a.closest(f, k), s = a.findNodeIndex(f, !0), l = a.findNodeIndex(n, !0), l + 1 === i.rows.length ? (this.releaseRange(u), t) : (d = i.rows[l + this._getRowspan(f)], c = d && d.children[s], this.immutables() && r.Immutables.immutableParent(f) ? (this.releaseRange(u), t) : (this._mapColIndices(o), s = e(f).attr("col-index"), c = e(d).find("[col-index=" + s + "]").get(0), c && c.colSpan === f.colSpan && f.tagName === c.tagName ? (e(f).prop(y, this._getRowspan(f) + this._getRowspan(c)).append(a.emptyNode(c) ? "" : "<br/>" + c.innerHTML), f.getAttribute(p) === m && f.setAttribute(p, g), e(c).remove(), e(o).find("[headers]").length > 0 && this._associateHeaderIds(o), this._clearColIndexAttr(o), this.releaseRange(u), t) : (this._clearColIndexAttr(o), this.releaseRange(u), t)))) : (this.releaseRange(u), t)
                },
                _getRowspan: function(e) {
                    return parseInt(e.getAttribute(y), 10) || 1
                }
            }),
            K = O.extend({
                exec: function() {
                    var n = this.lockRange(),
                        i = this.options.type,
                        o = "row" === i ? v : y,
                        s = a.closest(n.endContainer, [T, _]),
                        l = a.closest(s, [w, C]),
                        d = a.closest(s, k),
                        c = a.createEmptyNode(this.editor.document, s.nodeName.toLowerCase());
                    return !s || this.immutables() && r.Immutables.immutableParent(s) ? (this.releaseRange(n), t) : (this._mapColIndices(d), "row" === i && e(s).is("[" + o + "]") ? this._splitCellHorizontally(s, l, o, c) : "column" === i && e(s).is("[" + o + "]") && this._splitCellVertically(s, l, o, c), e(s).prop(o.toLowerCase()) <= 1 && e(s).removeAttr(o), e(d).find("[headers]").length > 0 && this._associateHeaderIds(d), this._clearColIndexAttr(d), this.releaseRange(n), t)
                },
                _getRowspanValue: function(e) {
                    return parseInt(e.getAttribute(y), 10)
                },
                _getColspanValue: function(e) {
                    return parseInt(e.getAttribute(v), 10)
                },
                _splitCellHorizontally: function(t, n, i, o) {
                    var r = t.rowSpan,
                        a = t.colSpan,
                        s = e(o),
                        l = Math.floor(a / 2);
                    l > 1 && s.attr(v, l), r > 1 && s.attr(y, r), e(t).prop(i, a - l).after(s), e(t).width(t.offsetWidth), s.width(s[0].offsetWidth), t.hasAttribute(p) && (t.getAttribute(p) === b ? (s.attr(p, h), t.getAttribute(v) && "1" !== t.getAttribute(v) || t.setAttribute(p, h), this._adjustColgroups(t.parentNode, n.parentNode)) : s.attr(p, t.getAttribute(p)))
                },
                _splitCellVertically: function(t, n, i, o) {
                    var r = a.closest(t, x),
                        s = parseInt(e(t).attr("col-index"), 10),
                        l = a.findNodeIndex(r, !0),
                        d = t.rowSpan,
                        c = t.colSpan,
                        u = Math.floor(d / 2),
                        f = e(n).find(x).eq(l + d - u),
                        h = this._findNextTdInRow(f, s + c),
                        b = e(o);
                    u > 1 && b.attr(y, u), c > 1 && b.attr(v, c), h && h.length ? h.before(b) : f.append(b), e(t).prop(i, d - u), t.hasAttribute(p) && (t.getAttribute(p) === g ? (b.attr(p, m), t.getAttribute(y) && "1" !== t.getAttribute(y) || t.setAttribute(p, m)) : b.attr(p, t.getAttribute(p)))
                }
            }),
            $ = N.extend({
                command: function(e) {
                    var t = {
                        row: {
                            insert: L,
                            "delete": W,
                            merge: V,
                            split: K
                        },
                        column: {
                            insert: M,
                            "delete": U,
                            merge: j,
                            split: K
                        }
                    };
                    return e = i(e, this.options), e.action = e.action || "insert", new t[e.type][e.action](e)
                },
                initialize: function(e, t) {
                    N.fn.initialize.call(this, e, t), e.addClass("k-state-disabled")
                },
                update: function(e, t) {
                    var n = !D.isFormatted(t);
                    e.toggleClass("k-state-disabled", n)
                }
            });
        i(n.ui.editor, {
            PopupTool: B,
            TableCommand: H,
            InsertTableTool: F,
            TableModificationTool: $,
            InsertRowCommand: L,
            InsertColumnCommand: M,
            DeleteRowCommand: W,
            DeleteColumnCommand: U,
            MergeCellsHorizontallyCommand: V,
            MergeCellsVerticallyCommand: j,
            SplitCellCommand: K
        }), z("createTable", new F({
            template: new S({
                template: s.buttonTemplate,
                popup: !0,
                title: "Create table"
            })
        })), z("addColumnLeft", new $({
            type: "column",
            position: "before",
            template: new S({
                template: s.buttonTemplate,
                title: "Add column on the left"
            })
        })), z("addColumnRight", new $({
            type: "column",
            template: new S({
                template: s.buttonTemplate,
                title: "Add column on the right"
            })
        })), z("addRowAbove", new $({
            type: "row",
            position: "before",
            template: new S({
                template: s.buttonTemplate,
                title: "Add row above"
            })
        })), z("addRowBelow", new $({
            type: "row",
            template: new S({
                template: s.buttonTemplate,
                title: "Add row below"
            })
        })), z("deleteRow", new $({
            type: "row",
            action: "delete",
            template: new S({
                template: s.buttonTemplate,
                title: "Delete row"
            })
        })), z("deleteColumn", new $({
            type: "column",
            action: "delete",
            template: new S({
                template: s.buttonTemplate,
                title: "Delete column"
            })
        })), z("mergeCellsHorizontally", new $({
            type: "row",
            action: "merge",
            template: new S({
                template: s.buttonTemplate,
                title: "Merge Cell Right"
            })
        })), z("mergeCellsVertically", new $({
            type: "column",
            action: "merge",
            template: new S({
                template: s.buttonTemplate,
                title: "Merge Cell Down"
            })
        })), z("splitCellHorizontally", new $({
            type: "row",
            action: "split",
            template: new S({
                template: s.buttonTemplate,
                title: "Split Cell"
            })
        })), z("splitCellVertically", new $({
            type: "column",
            action: "split",
            template: new S({
                template: s.buttonTemplate,
                title: "Split Cell"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/clipboard.min", ["editor/command.min"], e)
}(function() {
    ! function(e) {
        var t = window.kendo,
            n = t.Class,
            i = t.ui.editor,
            o = i.RangeUtils,
            r = i.Dom,
            a = i.RestorePoint,
            s = i.Marker,
            l = t.support.browser,
            d = e.extend,
            c = n.extend({
                init: function(e) {
                    this.editor = e;
                    var t = e.options.pasteCleanup;
                    this.cleaners = [new f(t), new p(t), new m(t), new h(t), new b(t), new v(t), new C(t), new x(t)]
                },
                htmlToFragment: function(e) {
                    var t = this.editor,
                        n = t.document,
                        i = r.create(n, "div"),
                        o = n.createDocumentFragment();
                    for (i.innerHTML = e; i.firstChild;) o.appendChild(i.firstChild);
                    return o
                },
                isBlock: function(e) {
                    return /<(div|p|ul|ol|table|h[1-6])/i.test(e)
                },
                _startModification: function() {
                    var e, t, n = this.editor;
                    if (!this._inProgress) return this._inProgress = !0, e = n.getRange(), t = new a(e, n.body), r.persistScrollTop(n.document), {
                        range: e,
                        restorePoint: t
                    }
                },
                _endModification: function(e) {
                    i._finishUpdate(this.editor, e.restorePoint), this.editor._selectionChange(), this._inProgress = !1
                },
                _contentModification: function(e, t) {
                    var n = this,
                        i = n.editor,
                        o = n._startModification();
                    o && (e.call(n, i, o.range), setTimeout(function() {
                        t.call(n, i, o.range), n._endModification(o)
                    }))
                },
                _removeBomNodes: function(e) {
                    var t, n = o.textNodes(e);
                    for (t = 0; t < n.length; t++) n[t].nodeValue = r.stripBom(n[t].nodeValue) || n[t].nodeValue
                },
                _onBeforeCopy: function(e) {
                    var t = new s;
                    t.add(e), this._removeBomNodes(e), t.remove(e), this.editor.selectRange(e)
                },
                oncopy: function() {
                    this._onBeforeCopy(this.editor.getRange())
                },
                oncut: function() {
                    this._onBeforeCopy(this.editor.getRange()), this._contentModification(e.noop, e.noop)
                },
                _fileToDataURL: function(t) {
                    var n = e.Deferred(),
                        i = new FileReader;
                    return t instanceof window.File || !t.getAsFile || (t = t.getAsFile()), i.onload = e.proxy(n.resolve, n), i.readAsDataURL(t), n.promise()
                },
                _triggerPaste: function(e, t) {
                    var n = {
                        html: e || ""
                    };
                    n.html = n.html.replace(/\ufeff/g, ""), this.editor.trigger("paste", n), this.paste(n.html, t || {})
                },
                _handleImagePaste: function(e) {
                    var t, n;
                    if ("FileReader" in window && !(l.msie && l.version > 10)) return t = e.clipboardData || e.originalEvent.clipboardData || window.clipboardData || {}, n = t.items || t.files, this._insertImages(n)
                },
                _insertImages: function(t) {
                    var n, i, o;
                    if (t && (n = e.grep(t, function(e) {
                            return /^image\//i.test(e.type)
                        }), i = e.grep(t, function(e) {
                            return /^text\/html/i.test(e.type)
                        }), !i.length && n.length && (o = this._startModification()))) return e.when.apply(e, e.map(n, this._fileToDataURL)).done(e.proxy(function() {
                        var t = Array.prototype.slice.call(arguments),
                            n = e.map(t, function(e) {
                                return '<img src="' + e.target.result + '" />'
                            }).join("");
                        this._triggerPaste(n), this._endModification(o)
                    }, this)), !0
                },
                onpaste: function(n) {
                    if ("false" !== this.editor.body.contentEditable) {
                        if (this._handleImagePaste(n)) return void n.preventDefault();
                        this.expandImmutablesIn(), this._contentModification(function(i, o) {
                            var a, s, l, d = r.create(i.document, "div", {
                                    className: "k-paste-container",
                                    innerHTML: "\ufeff"
                                }),
                                c = t.support.browser,
                                u = i.body;
                            this._decoreateClipboardNode(d, u), u.appendChild(d), c.webkit && this._moveToCaretPosition(d, o), c.msie && c.version < 11 ? (n.preventDefault(), a = i.createRange(), a.selectNodeContents(d), i.selectRange(a), s = i.document.body.createTextRange(), s.moveToElementText(d), e(u).unbind("paste"), s.execCommand("Paste"), e(u).bind("paste", e.proxy(this.onpaste, this))) : (l = i.createRange(), l.selectNodeContents(d), i.selectRange(l)), o.deleteContents()
                        }, function(t, n) {
                            var i, o = "";
                            t.selectRange(n), i = e(t.body).children(".k-paste-container"), i.each(function() {
                                var e = this.lastChild;
                                e && r.is(e, "br") && r.remove(e), o += this.innerHTML
                            }), i.remove(), this._triggerPaste(o, {
                                clean: !0
                            })
                        })
                    }
                },
                ondragover: function(e) {
                    (l.msie || l.edge) && (e.stopPropagation(), e.preventDefault())
                },
                ondrop: function(e) {
                    var t, n;
                    "FileReader" in window && (t = (e.originalEvent || e).dataTransfer || {}, n = t.items || t.files, this._insertImages(n) && e.preventDefault())
                },
                _decoreateClipboardNode: function(t, n) {
                    var i, o, r, a;
                    (l.msie || l.webkit) && (t = e(t), t.css({
                        borderWidth: "0px",
                        width: "0px",
                        height: "0px",
                        overflow: "hidden",
                        margin: "0",
                        padding: "0"
                    }), l.msie && (i = e(n.ownerDocument.documentElement), t.css({
                        fontVariant: "normal",
                        fontWeight: "normal",
                        lineSpacing: "normal",
                        lineHeight: "normal",
                        textDecoration: "none"
                    }), o = i.css("color"), o && t.css("color", o), r = i.css("fontFamily"), r && t.css("fontFamily", r), a = i.css("fontSize"), a && t.css("fontSize", a)))
                },
                _moveToCaretPosition: function(t, n) {
                    var i = this,
                        o = i.editor.body,
                        a = r.offset(t, o),
                        s = i._caretOffset(n, o),
                        l = s.left - a.left,
                        d = s.top - a.top,
                        c = "translate(" + l + "px," + d + "px)";
                    e(t).css({
                        "-webkit-transform": c,
                        transform: c
                    })
                },
                _caretOffset: function(e, t) {
                    var n, i, o, a, s, l, d = this.editor,
                        c = r.create(d.document, "span", {
                            innerHTML: "\ufeff"
                        }),
                        u = e.startContainer;
                    return e.collapsed ? (i = r.isDataNode(u), i && (r.isBom(u) || 0 === e.startOffset) ? r.insertBefore(c, u) : i && e.startOffset === u.length ? r.insertAfter(c, u) : (e.insertNode(c), n = !0)) : (u = u === t ? u.childNodes[e.startOffset] : u, r.insertBefore(c, u)), o = r.offset(c, t), a = c.previousSibling, s = c.nextSibling, r.remove(c), n && r.isDataNode(a) && r.isDataNode(s) && !r.isBom(a) && !r.isBom(s) && (l = a.length, s.data = a.data + s.data, e.setStart(s, l), r.remove(a), e.collapse(!0), d.selectRange(e)), o
                },
                expandImmutablesIn: function(e) {
                    var n, i, o, r = this.editor;
                    r && r.options.immutables && (n = r.body, e = e || r.getRange(), t.ui.editor.Immutables.expandImmutablesIn(e), e.startContainer === n && 0 === e.startOffset && (i = n.ownerDocument, o = i.createTextNode("\ufeff"), n.insertBefore(o, n.childNodes[0]), e.setStartBefore(o)), r.selectRange(e))
                },
                splittableParent: function(e, t) {
                    var n, i;
                    if (e) return r.closestEditableOfType(t, ["p", "ul", "ol"]) || t.parentNode;
                    if (n = t.parentNode, i = t.ownerDocument.body, r.isInline(n))
                        for (; n.parentNode != i && !r.isBlock(n.parentNode);) n = n.parentNode;
                    return n
                },
                paste: function(t, n) {
                    var i, a, l, c, u, f, p, m, h, g, b, v, y, k, w, C, x, T = this.editor;
                    if (this.expandImmutablesIn(), n = d({
                            clean: !1,
                            split: !0
                        }, n), !n.skipCleaners)
                        for (i = 0, a = this.cleaners.length; i < a; i++) this.cleaners[i].applicable(t) && (t = this.cleaners[i].clean(t));
                    if (n.clean && (t = t.replace(/(<br>(\s|&nbsp;)*)+(<\/?(div|p|li|col|t))/gi, "$3"), t = t.replace(/<(a|span)[^>]*><\/\1>/gi, "")), t = t.replace(/<(a|span|font)([^>]*)> <\/\1>/gi, "<$1$2>&nbsp;</$1>"), t = t.replace(/^<li/i, "<ul><li").replace(/li>$/g, "li></ul>"), c = this.isBlock(t), T.focus(), u = T.getRange(), u.deleteContents(), u.startContainer == T.document && u.selectNodeContents(T.body), f = new s, p = f.addCaret(u), m = this.splittableParent(c, p), h = !1, g = m != T.body && !r.is(m, "td"), n.split && g && (c || r.isInline(m)) && (u.selectNode(p), o.split(u, m, !0), h = !0), b = this.htmlToFragment(t), b.firstChild && "k-paste-container" === b.firstChild.className) {
                        for (v = [], i = 0, a = b.childNodes.length; i < a; i++) v.push(b.childNodes[i].innerHTML);
                        b = this.htmlToFragment(v.join("<br />"))
                    }
                    if (l = b.childNodes, e(l).filter("table").addClass("k-table").end().find("table").addClass("k-table"), e(l).each(function(e, t) {
                            r.isBlock(t) && !r.isSelfClosing(t) && "" === t.innerHTML && t.appendChild(T.document.createTextNode("\ufeff"))
                        }), u.insertNode(b), m = this.splittableParent(c, p), h) {
                        for (; p.parentNode != m;) r.unwrap(p.parentNode);
                        r.unwrap(p.parentNode)
                    }
                    if (r.normalize(u.commonAncestorContainer), p.style.display = "inline", r.restoreScrollTop(T.document), r.scrollTo(p), f.removeCaret(u), y = u.commonAncestorContainer.parentNode, (u.collapsed && "tbody" == r.name(y) || u.collapsed && "thead" == r.name(y)) && (u.setStartAfter(e(y).closest("table")[0]), u.collapse(!0)), k = e(u.commonAncestorContainer.parentNode).closest("table"), k.get(0)) {
                        for (w = k.parent().contents(), C = w.length - 1, x = w.get(C); null !== x.nodeValue && (" " === x.nodeValue || "" === x.nodeValue);) C -= 1, x = w.get(C);
                        x !== k.get(0) || k.parents("table").length || r.insertAfter(r.createEmptyNode(T.document, "p"), k[0])
                    }
                    T.selectRange(u)
                }
            }),
            u = n.extend({
                init: function(e) {
                    this.options = e || {}, this.replacements = []
                },
                clean: function(e, t) {
                    var n, i, o = this,
                        r = t || o.replacements;
                    for (n = 0, i = r.length; n < i; n += 2) e = e.replace(r[n], r[n + 1]);
                    return e
                }
            }),
            f = u.extend({
                init: function(e) {
                    u.fn.init.call(this, e), this.replacements = [/<(\/?)script([^>]*)>/i, "<$1telerik:script$2>"]
                },
                applicable: function(e) {
                    return !this.options.none && /<script[^>]*>/i.test(e)
                }
            }),
            p = u.extend({
                init: function(e) {
                    u.fn.init.call(this, e);
                    var t = " ";
                    this.replacements = [/<span\s+class="Apple-tab-span"[^>]*>\s*<\/span>/gi, t, /\t/gi, t, /&nbsp;&nbsp; &nbsp;/gi, t]
                },
                applicable: function(e) {
                    return /&nbsp;&nbsp; &nbsp;|class="?Apple-tab-span/i.test(e)
                }
            }),
            m = u.extend({
                init: function(e) {
                    u.fn.init.call(this, e), this.junkReplacements = [/<\?xml[^>]*>/gi, "", /<!--(.|\n)*?-->/g, "", /&quot;/g, "'", /<o:p>&nbsp;<\/o:p>/gi, "&nbsp;", /<\/?(meta|link|style|o:|v:|x:)[^>]*>((?:.|\n)*?<\/(meta|link|style|o:|v:|x:)[^>]*>)?/gi, "", /<\/o>/g, ""], this.replacements = this.junkReplacements.concat([/(?:<br>&nbsp;[\s\r\n]+|<br>)*(<\/?(h[1-6]|hr|p|div|table|tbody|thead|tfoot|th|tr|td|li|ol|ul|caption|address|pre|form|blockquote|dl|dt|dd|dir|fieldset)[^>]*>)(?:<br>&nbsp;[\s\r\n]+|<br>)*/g, "$1", /<br><br>/g, "<BR><BR>", /<br>(?!\n)/g, " ", /<table([^>]*)>(\s|&nbsp;)+<t/gi, "<table$1><t", /<tr[^>]*>(\s|&nbsp;)*<\/tr>/gi, "", /<tbody[^>]*>(\s|&nbsp;)*<\/tbody>/gi, "", /<table[^>]*>(\s|&nbsp;)*<\/table>/gi, "", /<BR><BR>/g, "<br>", /^\s*(&nbsp;)+/gi, "", /(&nbsp;|<br[^>]*>)+\s*$/gi, "", /mso-[^;"]*;?/gi, "", /<(\/?)b(\s[^>]*)?>/gi, "<$1strong$2>", /<(\/?)font(\s[^>]*)?>/gi, this.convertFontMatch, /<(\/?)i(\s[^>]*)?>/gi, "<$1em$2>", /style=(["|'])\s*\1/g, "", /(<br[^>]*>)?\n/g, function(e, t) {
                        return t ? e : " "
                    }])
                },
                convertFontMatch: function(e, t, n) {
                    var i = /face=['"]([^'"]+)['"]/i,
                        o = i.exec(n),
                        r = n && o && o[1];
                    return t ? "</span>" : r ? '<span style="font-family:' + r + '">' : "<span>"
                },
                applicable: function(e) {
                    return /class="?Mso/i.test(e) || /style="[^"]*mso-/i.test(e) || /urn:schemas-microsoft-com:office/.test(e)
                },
                stripEmptyAnchors: function(e) {
                    return e.replace(/<a([^>]*)>\s*<\/a>/gi, function(e, t) {
                        return !t || t.indexOf("href") < 0 ? "" : e
                    })
                },
                listType: function(e, t) {
                    var n, i = e.innerHTML,
                        o = r.innerText(e),
                        a = i.match(/^(?:<span [^>]*texhtml[^>]*>)?<span [^>]*(?:Symbol|Wingdings)[^>]*>([^<]+)/i),
                        s = a && a[1],
                        l = /^[a-z\d]/i.test(s),
                        d = function(e) {
                            return e.replace(/^(?:&nbsp;|[\u00a0\n\r\s])+/, "")
                        };
                    return a && (n = !0), i = i.replace(/<\/?\w+[^>]*>/g, "").replace(/&nbsp;/g, " "), !n && /^[\u2022\u00b7\u00a7\u00d8o]\u00a0+/.test(i) || n && /^.\u00a0+/.test(i) || s && !l && t ? {
                        tag: "ul",
                        style: this._guessUnorderedListStyle(d(o))
                    } : /^\s*\w+[\.\)][\u00a0 ]{2,}/.test(i) ? {
                        tag: "ol",
                        style: this._guessOrderedListStyle(d(o))
                    } : void 0
                },
                _convertToLi: function(e) {
                    var t, n = r.name(e);
                    return 1 == e.childNodes.length ? t = e.firstChild.nodeType === r.nodeTypes.TEXT_NODE ? r.innerText(e) : e.firstChild.innerHTML.replace(/^\w+[\.\)](&nbsp;)+ /, "") : (r.remove(e.firstChild), 3 == e.firstChild.nodeType && /^[ivxlcdm]+\.$/i.test(e.firstChild.nodeValue) && r.remove(e.firstChild), /^(&nbsp;|\s)+$/i.test(e.firstChild.innerHTML) && r.remove(e.firstChild), t = "p" != n ? "<" + n + ">" + e.innerHTML + "</" + n + ">" : e.innerHTML), r.remove(e), r.create(document, "li", {
                        innerHTML: t
                    })
                },
                _guessUnorderedListStyle: function(e) {
                    return /^[\u2022\u00b7\u00FC\u00D8\u002dv-]/.test(e) ? null : /^o/.test(e) ? "circle" : "square"
                },
                _guessOrderedListStyle: function(e) {
                    var t = null;
                    return /^\d/.test(e) || (t = (/^[a-z]/.test(e) ? "lower-" : "upper-") + (/^[ivxlcdm]/i.test(e) ? "roman" : "alpha")), t
                },
                extractListLevels: function(e) {
                    var n = /style=['"]?[^'"]*?mso-list:\s?[a-zA-Z]+(\d+)\s[a-zA-Z]+(\d+)\s(\w+)/gi;
                    return e = e.replace(n, function(e, n, i) {
                        return t.format('data-list="{0}" data-level="{1}" {2}', n, i, e)
                    })
                },
                _createList: function(e, t) {
                    return r.create(document, e, {
                        style: {
                            listStyleType: t
                        }
                    })
                },
                lists: function(t) {
                    var n, i, o, a, s, d, c, u, f, p, m, h, g, b, v, y, k = e(t).find(r.blockElements.join(",")),
                        w = -1,
                        C = {},
                        x = ["p", "h1", "h2", "h3", "h4", "h5", "h6"],
                        T = !1;
                    for (u = 0; u < k.length; u++) f = k[u], g = e(f).data(), b = g.list, n = r.name(f), T = !!e(f).parents("table").length, T || (v = this.listType(f, g), p = v && v.tag, !p || x.indexOf(n) < 0 ? f.innerHTML ? i && !d && i.appendChild(f) : r.remove(f) : l.msie || (m = g.level || parseFloat(f.style.marginLeft || 0), y = p + b, C[m] || (C[m] = {}), (!o || o < 0) && (o = m, a = b, s = e(t).find("[data-list='" + a + "']:last")[0], c = this._createList(p, v.style), r.insertBefore(c, f), w = m, C[m][y] = c), d = s === f, h = C[m][y], (m > w || !h) && (h = this._createList(p, v.style), C[m][y] = h, i.appendChild(h)), i = this._convertToLi(f), h.appendChild(i), d ? o = w = -1 : w = m))
                },
                removeAttributes: function(e) {
                    for (var t = e.attributes, n = t.length; n--;) "colspan" != r.name(t[n]) && e.removeAttributeNode(t[n])
                },
                createColGroup: function(n) {
                    var i = n.cells,
                        o = e(n).closest("table"),
                        r = o.children("colgroup");
                    i.length < 2 || (r.length && (i = r.children(), r[0].parentNode.removeChild(r[0])), r = e(e.map(i, function(e) {
                        var n = e.width;
                        return n && 0 !== parseInt(n, 10) ? t.format('<col style="width:{0}px;"/>', n) : "<col />"
                    }).join("")), r.is("colgroup") || (r = e("<colgroup/>").append(r)), r.prependTo(o))
                },
                convertHeaders: function(t) {
                    var n, i = t.cells,
                        o = e.map(i, function(t) {
                            var n = e(t).children("p").children("strong")[0];
                            if (n && "strong" == r.name(n)) return n
                        });
                    if (o.length == i.length) {
                        for (n = 0; n < o.length; n++) r.unwrap(o[n]);
                        for (e(t).closest("table").find("colgroup").after("<thead></thead>").end().find("thead").append(t), n = 0; n < i.length; n++) r.changeTag(i[n], "th")
                    }
                },
                removeParagraphs: function(t) {
                    var n, i, o, a, s;
                    for (n = 0; n < t.length; n++)
                        for (this.removeAttributes(t[n]), a = e(t[n]), s = a.children("p"), i = 0, o = s.length; i < o; i++) i < o - 1 && r.insertAfter(r.create(document, "br"), s[i]), r.unwrap(s[i])
                },
                removeDefaultColors: function(e) {
                    for (var t = 0; t < e.length; t++) /^\s*color:\s*[^;]*;?$/i.test(e[t].style.cssText) && r.unwrap(e[t])
                },
                tables: function(t) {
                    var n, i, o, r, a, s = e(t).find("table"),
                        l = this;
                    for (r = 0; r < s.length; r++) {
                        for (n = s[r].rows, o = i = n[0], a = 1; a < n.length; a++) n[a].cells.length > o.cells.length && (o = n[a]);
                        l.createColGroup(o), l.convertHeaders(i), l.removeAttributes(s[r]), l.removeParagraphs(s.eq(r).find("td,th")), l.removeDefaultColors(s.eq(r).find("span"))
                    }
                },
                headers: function(t) {
                    var n, i = e(t).find("p.MsoTitle");
                    for (n = 0; n < i.length; n++) r.changeTag(i[n], "h1")
                },
                removeFormatting: function(t) {
                    e(t).find("*").each(function() {
                        e(this).css({
                            fontSize: "",
                            fontFamily: ""
                        }), this.getAttribute("style") || this.style.cssText || this.removeAttribute("style")
                    })
                },
                clean: function(e) {
                    var t, n = this,
                        i = this.options;
                    return i.none ? (e = u.fn.clean.call(n, e, this.junkReplacements), e = n.stripEmptyAnchors(e)) : (e = i.msConvertLists ? this.extractListLevels(e) : e, e = u.fn.clean.call(n, e), e = n.stripEmptyAnchors(e), t = r.create(document, "div", {
                        innerHTML: e
                    }), n.headers(t), i.msConvertLists && n.lists(t), n.tables(t), i.msAllFormatting && n.removeFormatting(t), e = t.innerHTML.replace(/(<[^>]*)\s+class="?[^"\s>]*"?/gi, "$1")), e
                }
            }),
            h = u.extend({
                init: function(e) {
                    u.fn.init.call(this, e), this.replacements = [/\s+class="Apple-style-span[^"]*"/gi, "", /<(div|p|h[1-6])\s+style="[^"]*"/gi, "<$1", /^<div>(.*)<\/div>$/, "$1"]
                },
                applicable: function(e) {
                    return /class="?Apple-style-span|style="[^"]*-webkit-nbsp-mode/i.test(e)
                }
            }),
            g = u.extend({
                clean: function(e) {
                    var t = r.create(document, "div", {
                        innerHTML: e
                    });
                    return t = this.cleanDom(t), t.innerHTML
                },
                cleanDom: function(e) {
                    return e
                }
            }),
            b = g.extend({
                cleanDom: function(t) {
                    var n = this.collectTags();
                    return e(t).find(n).each(function() {
                        r.unwrap(this)
                    }), t
                },
                collectTags: function() {
                    if (this.options.span) return "span"
                },
                applicable: function() {
                    return this.options.span
                }
            }),
            v = g.extend({
                cleanDom: function(t) {
                    var n = this.collectAttr(),
                        i = e(t).find("[" + n.join("],[") + "]");
                    return i.removeAttr(n.join(" ")), t
                },
                collectAttr: function() {
                    return this.options.css ? ["class", "style"] : []
                },
                applicable: function() {
                    return this.options.css
                }
            }),
            y = function() {
                this.text = "", this.add = function(e) {
                    this.text += e
                }
            },
            k = n.extend({
                init: function(e) {
                    this.separators = e || {
                        text: " ",
                        line: "<br/>"
                    }, this.lines = [], this.inlineBlockText = [], this.resetLine()
                },
                appendText: function(e) {
                    3 === e.nodeType && (e = e.nodeValue), this.textContainer.add(e)
                },
                appendInlineBlockText: function(e) {
                    this.inlineBlockText.push(e)
                },
                flashInlineBlockText: function() {
                    this.inlineBlockText.length && (this.appendText(this.inlineBlockText.join(" ")), this.inlineBlockText = [])
                },
                endLine: function() {
                    this.flashInlineBlockText(), this.resetLine()
                },
                html: function() {
                    var e, t, n, i, o, r, a, s, l = this.separators,
                        d = "",
                        c = this.lines;
                    for (this.flashInlineBlockText(), e = 0, t = c.length, n = t - 1; e < t; e++) {
                        for (i = c[e], o = 0, r = i.length, a = r - 1; o < r; o++) s = i[o].text, d += s, o !== a && (d += l.text);
                        e !== n && (d += l.line)
                    }
                    return d
                },
                resetLine: function() {
                    this.textContainer = new y, this.line = [], this.line.push(this.textContainer), this.lines.push(this.line)
                }
            }),
            w = n.extend({
                init: function(e) {
                    this.callback = e
                },
                enumerate: function(e) {
                    var t, n;
                    e && (t = this.callback(e), n = e.firstChild, !t && n && this.enumerate(n), this.enumerate(e.nextSibling))
                }
            }),
            C = u.extend({
                init: function(t) {
                    u.fn.init.call(this, t), this.hasText = !1, this.enumerator = new w(e.proxy(this.buildText, this))
                },
                clean: function(e) {
                    var t = r.create(document, "div", {
                        innerHTML: e
                    });
                    return this.cleanDom(t)
                },
                cleanDom: function(e) {
                    return this.separators = this.getDefaultSeparators(), this.htmlLines = new k(this.separators), this.enumerator.enumerate(e.firstChild), this.hasText = !1, this.htmlLines.html()
                },
                buildText: function(e) {
                    if (r.isDataNode(e)) {
                        if (r.isEmptyspace(e)) return;
                        this.htmlLines.appendText(e.nodeValue.replace("\n", this.separators.line)), this.hasText = !0
                    } else {
                        if (r.isBlock(e) && this.hasText) {
                            var t = this.actions[r.name(e)] || this.actions.block;
                            return t(this, e)
                        }
                        r.isBr(e) && this.htmlLines.appendText(this.separators.line)
                    }
                },
                applicable: function() {
                    var e = this.options;
                    return e.all || e.keepNewLines
                },
                getDefaultSeparators: function() {
                    return this.options.all ? {
                        text: " ",
                        line: " "
                    } : {
                        text: " ",
                        line: "<br/>"
                    }
                },
                actions: {
                    ul: e.noop,
                    ol: e.noop,
                    table: e.noop,
                    thead: e.noop,
                    tbody: e.noop,
                    td: function(e, t) {
                        var n = new C({
                                all: !0
                            }),
                            i = n.cleanDom(t);
                        return e.htmlLines.appendInlineBlockText(i), !0
                    },
                    block: function(e) {
                        e.htmlLines.endLine()
                    }
                }
            }),
            x = u.extend({
                clean: function(e) {
                    return this.options.custom(e)
                },
                applicable: function() {
                    return "function" == typeof this.options.custom
                }
            });
        d(i, {
            Clipboard: c,
            Cleaner: u,
            ScriptCleaner: f,
            TabCleaner: p,
            MSWordFormatCleaner: m,
            WebkitFormatCleaner: h,
            HtmlTagsCleaner: b,
            HtmlAttrCleaner: v,
            HtmlContentCleaner: C,
            HtmlTextLines: k,
            CustomCleaner: x
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/keyboard.min", ["editor/command.min"], e)
}(function() {
    ! function(e) {
        function t(e, t) {
            return t.startContainer === e && t.endContainer === e && 0 === t.startOffset && t.endOffset == e.childNodes.length
        }

        function n(e, t, n) {
            for (var i = e ? e[t] : null; i && !n(i);) i = i[t];
            return i
        }
        var i = window.kendo,
            o = i.Class,
            r = i.ui.editor,
            a = r.RangeUtils,
            s = r.Dom,
            l = r.RestorePoint,
            d = r.Marker,
            c = i.support.browser,
            u = "<span  class='k-br'>\ufeff</span>",
            f = e.extend,
            p = s.nodeTypes,
            m = "previousSibling",
            h = "td,th,caption",
            g = "table,tbody,thead,tfoot,tr",
            b = g + "," + h,
            v = function(t) {
                return !t.collapsed && e(t.commonAncestorContainer).is(g)
            },
            y = o.extend({
                remove: function(t) {
                    var n, i, o, r, l, c, u, f = this,
                        p = new d;
                    p.add(t, !1), n = a.getAll(t, function(t) {
                        return e(t).is(b)
                    }), i = a.documentFromRange(t), o = p.start, r = p.end, l = h.split(","), c = s.parentOfType(o, l), u = s.parentOfType(r, l), f._removeContent(o, c, !0), f._removeContent(r, u, !1), e(n).each(function(t, n) {
                        n = e(n), (n.is(h) ? n : n.find(h)).each(function(e, t) {
                            t.innerHTML = "&#65279;"
                        })
                    }), c && !o.previousSibling && s.insertBefore(i.createTextNode("\ufeff"), o), u && !r.nextSibling && s.insertAfter(i.createTextNode("\ufeff"), r), c ? t.setStartBefore(o) : n[0] && (c = e(n[0]), c = c.is(h) ? c : c.find(h).first(), c.length && t.setStart(c.get(0), 0)), t.collapse(!0), s.remove(o), s.remove(r)
                },
                _removeContent: function(t, n, i) {
                    if (n) {
                        var o, r = i ? "nextSibling" : "previousSibling",
                            a = function(t) {
                                for (; t && !t[r];) t = t.parentNode;
                                return t && e.contains(n, t) ? t[r] : null
                            };
                        for (t = a(t); t;) o = a(t), s.remove(t), t = o
                    }
                }
            }),
            k = o.extend({
                init: function(e) {
                    this.editor = e
                },
                keydown: function(n) {
                    var i, o, a, s, d = this,
                        u = d.editor,
                        p = u.keyboard,
                        m = p.isTypingKey(n),
                        h = f(e.Event(), n);
                    return d.editor.trigger("keydown", h), h.isDefaultPrevented() ? (n.preventDefault(), !0) : !(h.isDefaultPrevented() || !m || p.isTypingInProgress()) && (i = u.getRange(), o = u.body, d.startRestorePoint = new l(i, o), v(i) && (a = new y(u), a.remove(i), u.selectRange(i)), c.webkit && !i.collapsed && t(o, i) && (o.innerHTML = ""), u.immutables && r.Immutables.immutablesContext(i) && (s = new r.BackspaceHandler(u), s.deleteSelection(i)), p.startTyping(function() {
                        d.endRestorePoint = r._finishUpdate(u, d.startRestorePoint)
                    }), !0)
                },
                keyup: function(e) {
                    var t = this.editor.keyboard;
                    return this.editor.trigger("keyup", e), !!t.isTypingInProgress() && (t.endTyping(), !0)
                }
            }),
            w = o.extend({
                init: function(e) {
                    this.editor = e
                },
                _addCaret: function(e) {
                    var t = s.create(this.editor.document, "a");
                    return !i.support.browser.chrome && e.firstChild && e.firstChild.nodeType === p.ELEMENT_NODE && (e = e.firstChild), s.insertAt(e, t, 0), s.stripBomNode(t.previousSibling), s.stripBomNode(t.nextSibling), t
                },
                _restoreCaret: function(e) {
                    var t = this.editor.createRange();
                    !e.nextSibling && s.isDataNode(e.previousSibling) ? t.setStart(e.previousSibling, e.previousSibling.length) : t.setStartAfter(e), t.collapse(!0), this.editor.selectRange(t), s.remove(e)
                },
                _handleDelete: function(e) {
                    var t, n, i = e.endContainer,
                        o = s.closestEditableOfType(i, s.blockElements);
                    return !(!o || !r.RangeUtils.isEndOf(e, o)) && (t = s.next(o), !(!t || "p" != s.name(t)) && (n = this._addCaret(t), this._merge(o, t), this._restoreCaret(n), !0))
                },
                _cleanBomBefore: function(e) {
                    for (var t = e.startOffset, n = e.startContainer, i = n.nodeValue, o = 0; t - o >= 0 && "\ufeff" == i[t - o - 1];) o++;
                    o > 0 && (n.deleteData(t - o, o), e.setStart(n, Math.max(0, t - o)), e.collapse(!0), this.editor.selectRange(e))
                },
                _handleBackspace: function(t) {
                    var i, o, a, l, d, c, u, f, p, h, g, b, v, y = t.startContainer,
                        k = s.closestEditableOfType(y, ["li"]),
                        w = s.closestEditableOfType(y, "p,h1,h2,h3,h4,h5,h6".split(",")),
                        C = this.editor;
                    if (s.isDataNode(y)) {
                        if (t.collapsed && /^\s[\ufeff]+$/.test(y.nodeValue)) return t.setStart(y, 0), t.setEnd(y, y.length), C.selectRange(t), !1;
                        this._cleanBomBefore(t)
                    }
                    return i = n(w, m, function(e) {
                        return !s.htmlIndentSpace(e)
                    }), t.collapsed && t.startOffset !== t.endOffset && t.startOffset < 0 && (t.startOffset = 0, t.endOffset = 0, C.selectRange(t)), o = k && r.RangeUtils.isStartOf(t, k), a = k && e(k).index(), l = o && a > 0, l && (w = k, i = s.prev(k)), w && i && s.is(i, "table") && r.RangeUtils.isStartOf(t, w) ? ("" === w.innerText && (w.innerHTML = "\ufeff"), !0) : r.RangeUtils.isStartOf(t, w) && (parseInt(w.style.marginLeft, 10) > 0 || parseInt(w.style.marginRight, 10) > 0) ? (C.exec("outdent"), !0) : w && i && r.RangeUtils.isStartOf(t, w) || l ? (d = this._addCaret(w), this._merge(i, w), this._restoreCaret(d), !0) : o && 0 === a ? (c = k.firstChild, c || (k.innerHTML = r.emptyElementContent, c = k.firstChild), u = new r.ListFormatter(s.name(k.parentNode), "p"), t.selectNodeContents(k), u.toggle(t), s.insignificant(c) ? t.setStartBefore(c) : t.setStart(c, 0), C.selectRange(t), !0) : (f = y.childNodes[t.startOffset - 1], p = t, h = f && s.closestEditableOfType(f, ["a"]), g = n(f || y, m, function(e) {
                        return !s.isDataNode(e) || !s.isBom(e) && e.length > 0
                    }), (h || (0 === t.startOffset || f) && s.is(g, "a")) && (h = h || g, p = C.createRange(), p.setStart(h, h.childNodes.length), p.collapse(!0)), h = h || s.closestEditableOfType(f || p.startContainer, ["a"]), b = h && r.RangeUtils.isEndOf(p, h), b && (v = new r.UnlinkCommand({
                        range: p,
                        body: C.body,
                        immutables: !!C.immutables
                    }), C.execCommand(v), C._selectionChange()), !1)
                },
                _handleSelection: function(t) {
                    var n, i, o, a, l = t.commonAncestorContainer,
                        c = s.closest(l, "table"),
                        u = r.emptyElementContent,
                        f = this.editor;
                    return v(t) ? (n = new y(f), n.remove(t), f.selectRange(t), !0) : (i = new d, i.add(t, !1), t.commonAncestorContainer === f.body && this._surroundFullyContent(i, t), f.immutables && this._handleImmutables(i), this._surroundFullySelectedAnchor(i, t), t.setStartAfter(i.start), t.setEndBefore(i.end), o = t.startContainer, a = t.endContainer, t.deleteContents(), "li" === a.tagName.toLocaleLowerCase() && s.emptyNode(a) && (t.selectNode(a), t.deleteContents()), c && "" === e(c).text() && (t.selectNode(c), t.deleteContents()), l = t.commonAncestorContainer, "p" === s.name(l) && "" === l.innerHTML && (l.innerHTML = u, t.setStart(l, 0)), this._join(o, a), s.insertAfter(f.document.createTextNode("\ufeff"), i.start), i.remove(t), o = t.startContainer, "tr" == s.name(o) && (o = o.childNodes[Math.max(0, t.startOffset - 1)], t.setStart(o, s.getNodeLength(o))), t.collapse(!0), f.selectRange(t), s.isDataNode(o) && !s.emptyNode(o.parentElement) && this._cleanBomBefore(t), !0)
                },
                _handleImmutables: function(e) {
                    var t = r.Immutables.immutableParent,
                        n = t(e.start),
                        i = t(e.start);
                    n && s.insertBefore(e.start, n), i && s.insertAfter(e.end, i), n && s.remove(n), i && i.parentNode && s.remove(i)
                },
                _surroundFullyContent: function(e, t) {
                    var n = t.commonAncestorContainer.children,
                        i = n[0],
                        o = n[n.length - 1];
                    this._moveMarker(e, t, i, o)
                },
                _surroundFullySelectedAnchor: function(t, n) {
                    var i = t.start,
                        o = e(i).closest("a").get(0),
                        r = t.end,
                        a = e(r).closest("a").get(0);
                    this._moveMarker(t, n, o, a)
                },
                _moveMarker: function(e, t, n, i) {
                    var o = e.start,
                        r = e.end;
                    n && a.isStartOf(t, n) && s.insertBefore(o, n), i && a.isEndOf(t, i) && s.insertAfter(r, i)
                },
                _root: function(e) {
                    for (; e && "body" != s.name(e) && e.parentNode && "body" != s.name(e.parentNode);) e = e.parentNode;
                    return e
                },
                _join: function(e, t) {
                    e = this._root(e), t = this._root(t), e != t && s.is(t, "p") && this._merge(e, t)
                },
                _merge: function(e, t) {
                    for (s.removeTrailingBreak(e); e && t.firstChild;) 1 == e.nodeType ? (e = s.list(e) ? e.children[e.children.length - 1] : e, e && e.appendChild(t.firstChild)) : e.nodeType === p.TEXT_NODE ? this._mergeWithTextNode(e, t.firstChild) : e.parentNode.appendChild(t.firstChild);
                    s.remove(t)
                },
                _mergeWithTextNode: function(e, t) {
                    e && e.nodeType === p.TEXT_NODE && (e.nextSibling && this._isCaret(e.nextSibling) ? s.insertAfter(t, e.nextSibling) : s.insertAfter(t, e))
                },
                _isCaret: function(t) {
                    return e(t).is("a")
                },
                keydown: function(e) {
                    var t, n, o = this.editor,
                        a = o.getRange(),
                        s = e.keyCode,
                        d = i.keys,
                        c = s === d.BACKSPACE,
                        u = s == d.DELETE;
                    o.immutables && o.immutables.keydown(e, a) || (!c && !u || a.collapsed ? c ? t = "_handleBackspace" : u && (t = "_handleDelete") : t = "_handleSelection", t && (n = new l(a, o.body), this[t](a) && (e.preventDefault(), r._finishUpdate(o, n))))
                },
                deleteSelection: function(e) {
                    this._handleSelection(e)
                },
                keyup: e.noop
            }),
            C = o.extend({
                init: function(e) {
                    this.editor = e, this.systemCommandIsInProgress = !1
                },
                createUndoCommand: function() {
                    this.startRestorePoint = this.endRestorePoint = r._finishUpdate(this.editor, this.startRestorePoint)
                },
                changed: function() {
                    return !!this.startRestorePoint && this.startRestorePoint.html != this.editor.body.innerHTML
                },
                keydown: function(e) {
                    var t = this,
                        n = t.editor,
                        i = n.keyboard;
                    return i.isModifierKey(e) ? (i.isTypingInProgress() && i.endTyping(!0), t.startRestorePoint = new l(n.getRange(), n.body), !0) : !!i.isSystem(e) && (t.systemCommandIsInProgress = !0, t.changed() && (t.systemCommandIsInProgress = !1, t.createUndoCommand()), !0)
                },
                keyup: function() {
                    var e = this;
                    return !(!e.systemCommandIsInProgress || !e.changed()) && (e.systemCommandIsInProgress = !1, e.createUndoCommand(), !0)
                }
            }),
            x = o.extend({
                init: function(e) {
                    this.editor = e
                },
                keydown: function(e) {
                    !c.webkit || e.isDefaultPrevented() || !e.ctrlKey || 65 != e.keyCode || e.altKey || e.shiftKey || (this.editor.options.immutables && this._toSelectableImmutables(), this._selectEditorBody())
                },
                _selectEditorBody: function() {
                    var e = this.editor,
                        t = e.getRange();
                    t.selectNodeContents(e.body), e.selectRange(t)
                },
                _toSelectableImmutables: function() {
                    for (var t = this.editor, n = t.body, i = r.Immutables.immutable, o = s.emptyTextNode, a = n.firstChild, l = n.lastChild; o(a);) a = a.nextSibling;
                    for (; o(l);) l = l.previousSibling;
                    a && i(a) && e(u).prependTo(n), l && i(l) && e(u).appendTo(n)
                },
                keyup: e.noop
            }),
            T = o.extend({
                init: function(e) {
                    this.handlers = e, this.typingInProgress = !1
                },
                isCharacter: function(e) {
                    return e >= 48 && e <= 90 || e >= 96 && e <= 111 || e >= 186 && e <= 192 || e >= 219 && e <= 222 || 229 == e
                },
                toolFromShortcut: function(t, n) {
                    var i, o, r = String.fromCharCode(n.keyCode),
                        a = this._getShortcutModifier(n, navigator.platform);
                    for (i in t)
                        if (o = e.extend({
                                ctrl: !1,
                                alt: !1,
                                shift: !1
                            }, t[i].options), (o.key == r || o.key == n.keyCode) && o.ctrl == a && o.alt == n.altKey && o.shift == n.shiftKey) return i
                },
                _getShortcutModifier: function(e, t) {
                    var n = t.toUpperCase().indexOf("MAC") >= 0;
                    return n ? e.metaKey : e.ctrlKey
                },
                toolsFromShortcut: function(t, n) {
                    var i, o, r, a = String.fromCharCode(n.keyCode),
                        s = [],
                        l = function(e) {
                            return e == a || e == n.keyCode || e == n.charCode
                        };
                    for (i in t) o = e.extend({
                        ctrl: !1,
                        alt: !1,
                        shift: !1
                    }, t[i].options), r = e.isArray(o.key) ? e.grep(o.key, l).length > 0 : l(o.key), r && o.ctrl == n.ctrlKey && o.alt == n.altKey && o.shift == n.shiftKey && s.push(t[i]);
                    return s
                },
                isTypingKey: function(e) {
                    var t = e.keyCode;
                    return this.isCharacter(t) && !e.ctrlKey && !e.altKey || 32 == t || 13 == t || 8 == t || 46 == t && !e.shiftKey && !e.ctrlKey && !e.altKey
                },
                isModifierKey: function(e) {
                    var t = e.keyCode;
                    return 17 == t && !e.shiftKey && !e.altKey || 16 == t && !e.ctrlKey && !e.altKey || 18 == t && !e.ctrlKey && !e.shiftKey
                },
                isSystem: function(e) {
                    return 46 == e.keyCode && e.ctrlKey && !e.altKey && !e.shiftKey
                },
                startTyping: function(e) {
                    this.onEndTyping = e, this.typingInProgress = !0
                },
                stopTyping: function() {
                    this.typingInProgress && this.onEndTyping && this.onEndTyping(), this.typingInProgress = !1
                },
                endTyping: function(t) {
                    var n = this;
                    n.clearTimeout(), t ? n.stopTyping() : n.timeout = window.setTimeout(e.proxy(n.stopTyping, n), 1e3)
                },
                isTypingInProgress: function() {
                    return this.typingInProgress
                },
                clearTimeout: function() {
                    window.clearTimeout(this.timeout)
                },
                notify: function(e, t) {
                    var n, i = this.handlers;
                    for (n = 0; n < i.length && !i[n][t](e); n++);
                },
                keydown: function(e) {
                    this.notify(e, "keydown")
                },
                keyup: function(e) {
                    this.notify(e, "keyup")
                }
            });
        f(r, {
            TypingHandler: k,
            SystemHandler: C,
            BackspaceHandler: w,
            SelectAllHandler: x,
            Keyboard: T
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/exportpdf.min", ["editor/command.min"], e)
}(function() {
    ! function(e) {
        var t = window.kendo,
            n = t.ui.editor,
            i = n.Command,
            o = n.EditorUtils,
            r = o.registerTool,
            a = n.Tool,
            s = n.ToolTemplate,
            l = e.extend,
            d = i.extend({
                init: function(e) {
                    this.async = !0, i.fn.init.call(this, e)
                },
                exec: function() {
                    var e = this,
                        t = e.lockRange(!0),
                        n = e.editor;
                    n._destroyResizings(), n.saveAsPDF().then(function() {
                        e.releaseRange(t), n._initializeColumnResizing(), n._initializeRowResizing(), n._initializeTableResizing()
                    })
                }
            });
        l(n, {
            ExportPdfCommand: d
        }), r("pdf", new a({
            command: d,
            template: new s({
                template: o.buttonTemplate,
                title: "Export PDF"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/print.min", ["editor/command.min"], e)
}(function() {
    ! function(e) {
        var t = window.kendo,
            n = t.ui.editor,
            i = n.Command,
            o = n.EditorUtils,
            r = o.registerTool,
            a = n.Tool,
            s = n.ToolTemplate,
            l = e.extend,
            d = i.extend({
                init: function(e) {
                    i.fn.init.call(this, e), this.managesUndoRedo = !0
                },
                exec: function() {
                    var e = this.editor;
                    t.support.browser.msie ? e.document.execCommand("print", !1, null) : e.window.print && e.window.print()
                }
            });
        l(n, {
            PrintCommand: d
        }), r("print", new a({
            command: d,
            template: new s({
                template: o.buttonTemplate,
                title: "Print"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/plugins/formatpainter.min", ["editor/command.min"], e)
}(function() {
    ! function(e) {
        var t = window.kendo,
            n = t.ui.editor,
            i = n.Tool,
            o = n.Command,
            r = n.ToolTemplate,
            a = n.EditorUtils,
            s = n.Dom,
            l = n.RangeUtils,
            d = a.registerTool,
            c = o.extend({
                init: function(e) {
                    o.fn.init.call(this, e)
                },
                exec: function() {
                    var e = this.lockRange(!0);
                    this.inlineStyles = [], this.blockStyles = [], this.collectStyles(e), this.editor.inlineStyles = this.inlineStyles, this.editor.blockStyles = this.blockStyles, this.releaseRange(e)
                },
                collectStyles: function(e) {
                    var t, n = l.nodes(e);
                    for (t = 1 === n.length ? n[0].parentNode : e.startContainer; t && !s.is(t, "body") && "editor" !== t.getAttribute("data-role");) s.isBlock(t) ? (this.populateStyles(t, "blockStyles"), t = s.is(t, "li") ? t.parentNode : null) : (this.populateStyles(t, "inlineStyles"), t = t.parentNode)
                },
                populateStyles: function(e, t) {
                    var n, i, o, r, a, s = e.style,
                        l = e.attributes,
                        d = {
                            tags: [e.tagName],
                            attr: {
                                style: {}
                            }
                        };
                    for (a = 0; s && a < s.length; a++) i = s[a], n = s[i], d.attr.style[i] = n;
                    for (a = 0; l && a < l.length; a++) o = l[a].nodeName, r = l[a].nodeValue, "style" !== o && ("class" === o ? d.attr.className = r : d.attr[o] = r);
                    this[t].push(d)
                }
            }),
            u = o.extend({
                init: function(e) {
                    o.fn.init.call(this, e)
                },
                exec: function() {
                    var e, t = this.lockRange(!0),
                        n = l.getMarkers(t),
                        i = this.editor,
                        o = i.inlineStyles,
                        r = i.blockStyles;
                    (o && 0 !== o.length || r && 0 !== r.length) && (3 === n.length && (this.marker.removeCaret(t), this.marker.caret = null), this.removeEmptyElementsFromRange(t), e = l.nodes(t), this.cleanInlineParents(e), s.normalize(t.commonAncestorContainer), 2 === n.length ? (t.setStartAfter(n[0]), t.setEndBefore(n[1])) : (t.setStartBefore(e[0]), t.setEndAfter(e[0])), e = l.nodes(t), e && r && r.length && this.applyBlockStyles(e, r), e && o && o.length && this.applyInlineStyles(e, o), this.releaseRange(t))
                },
                removeEmptyElementsFromRange: function(e) {
                    var t, n = function(e) {
                            return s.isInline(e) && !e.firstChild && !s.isMarker(e)
                        },
                        i = l.getAll(e, n);
                    if (i && i.length > 0)
                        for (t = 0; t < i.length; t++) i[t].parentNode.removeChild(i[t])
                },
                cleanInlineParents: function(e) {
                    var t, n, i, o, r, a, l;
                    for (t = 0; t < e.length; t++)
                        if (n = e[t], i = n.parentNode, !this.immutableParent(n))
                            for (; i && s.isInline(i);) {
                                for (o = i.childNodes, r = 0; r < o.length; r++) a = o[r], s.isMarker(a) || a === n || (l = i.cloneNode(!0), l.innerHTML = "", s.wrap(a, l));
                                s.unwrap(i), i = n.parentNode
                            }
                },
                applyBlockStyles: function(e, t) {
                    var n, i, o, r, a, l, d, c, u, f, p, m, h, g, b, v = t[0].tags[0],
                        y = t[0].attr,
                        k = this.editor.document;
                    for (n = 0, i = e.length; n < i; n++)
                        if (o = e[n], !s.isWhitespace(o) && !this.immutableParent(o))
                            if (a = s.blockParentOrBody(o), "BODY" !== a.tagName && a.tagName !== v) {
                                if ("LI" !== a.tagName && "TD" !== a.tagName && "TH" !== a.tagName) {
                                    for (d = [], c = [], u = o.previousSibling, f = o.nextSibling; u;) s.isMarker(u) || d.push(u), u = u.previousSibling;
                                    if (d.length)
                                        for (p = a.cloneNode(!0), p.innerHTML = "", s.insertBefore(p, d[0]), g = 0; g < d.length; g++) h = d[g], s.insertAt(p, h, 0);
                                    for (; f;) s.isMarker(f) || c.push(f), f = f.nextSibling;
                                    if (c.length)
                                        for (m = a.cloneNode(!0), m.innerHTML = "", s.insertBefore(m, c[0]), g = 0; g < c.length; g++) h = c[g], m.appendChild(h);
                                    s.unwrap(a)
                                }
                                r = s.create(k, v, y), s.wrap(o, r)
                            } else a.tagName === v && s.attr(a, y);
                    if (2 === t.length && "LI" !== a.tagName && "LI" === v) {
                        for (b = []; s.is(r, "li");) b.push(r), r = s.prev(r);
                        for (l = s.create(k, t[1].tags[0], t[1].attr), s.insertBefore(l, b[b.length - 1]), l.appendChild(b[0]), n = 1, i = b.length; n < i; n++) s.insertBefore(b[n], l.firstChild)
                    } else 2 === t.length && "LI" !== a.tagName && (l = s.create(k, t[1].tags[0], t[1].attr), s.wrap(r, l))
                },
                applyInlineStyles: function(e, t) {
                    var n, i, o, r, a, l, d = this.editor.document;
                    for (r = 0; r < t.length; r++) n = t[r], i = s.create(d, n.tags[0], n.attr), o && i.appendChild(o), o = i;
                    if (o)
                        for (r = 0; r < e.length; r++)
                            if (l = e[r], !s.isWhitespace(l) && !this.immutableParent(l)) {
                                for (a = o.cloneNode(!0), s.insertBefore(a, l); a.children && a.children.length;) a = a.children[0];
                                a.appendChild(l)
                            }
                },
                immutables: function() {
                    return this.editor && this.editor.options.immutables
                },
                immutableParent: function(e) {
                    return this.immutables() && n.Immutables.immutableParent(e)
                }
            }),
            f = i.extend({
                init: function(e) {
                    i.fn.init.call(this, e)
                },
                command: function(e) {
                    return new c(e)
                }
            }),
            p = i.extend({
                init: function(e) {
                    i.fn.init.call(this, e)
                },
                command: function(e) {
                    return new u(e)
                }
            });
        e.extend(n, {
            CopyFormatCommand: c,
            ApplyFormatCommand: u,
            CopyFormatTool: f,
            ApplyFormatTool: p
        }), d("copyFormat", new f({
            template: new r({
                template: a.buttonTemplate,
                title: "Copy format"
            })
        })), d("applyFormat", new p({
            template: new r({
                template: a.buttonTemplate,
                title: "Apply format"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/resizing/resizing-utils.min", ["editor/main.min"], e)
}(function() {
    ! function(e, t) {
        function n(e) {
            var t = e.value,
                n = e.min,
                i = e.max;
            return f(u(p(t), p(i)), p(n))
        }

        function i(t) {
            return t && !m(t).is("body") && t.scrollHeight > t.clientHeight ? e.support.scrollbar() : 0
        }

        function o(e, t) {
            return r(e) ? p(e) : p(e) / t * 100
        }

        function r(e) {
            return typeof e === w && y.test(e)
        }

        function a(e) {
            return typeof e === w && k.test(e)
        }

        function s(e) {
            return p(e) + b
        }

        function l(e) {
            return p(e) + v
        }
        var d = window,
            c = d.Math,
            u = c.min,
            f = c.max,
            p = d.parseFloat,
            m = e.jQuery,
            h = m.extend,
            g = e.ui.editor,
            b = "%",
            v = "px",
            y = /(\d+)(\.?)(\d*)%/,
            k = /(\d+)(\.?)(\d*)px/,
            w = "string",
            C = {
                constrain: n,
                getScrollBarWidth: i,
                calculatePercentageRatio: o,
                inPercentages: r,
                inPixels: a,
                toPercentages: s,
                toPixels: l
            };
        h(g, {
            ResizingUtils: C
        })
    }(window.kendo)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/resizing/table-element-resizing.min", ["editor/main.min", "kendo.resizable.min", "editor/resizing/resizing-utils.min"], e)
}(function() {
    ! function(e, t) {
        var n = e.jQuery,
            i = n.extend,
            o = n.noop,
            r = n.proxy,
            a = e.ui.editor,
            s = e.Class,
            l = "keydown",
            d = "mousedown",
            c = "mouseenter",
            u = "mouseleave",
            f = "mousemove",
            p = "mouseup",
            m = ",",
            h = ".",
            g = ":last-child",
            b = "table",
            v = s.extend({
                init: function(e, t) {
                    var o = this;
                    o.options = i({}, o.options, t), o.options.tags = n.isArray(o.options.tags) ? o.options.tags : [o.options.tags], n(e).is(b) && (o.element = e, o._attachEventHandlers())
                },
                destroy: function() {
                    var e = this,
                        t = e.options.eventNamespace;
                    e.element && (n(e.element).off(t), e.element = null), n(e.options.rootElement).off(l + t), e._destroyResizeHandle()
                },
                options: {
                    tags: [],
                    min: 0,
                    rootElement: null,
                    eventNamespace: "",
                    rtl: !1,
                    handle: {
                        dataAttribute: "",
                        height: 0,
                        width: 0,
                        classNames: {},
                        template: ""
                    }
                },
                _attachEventHandlers: function() {
                    var e = this,
                        t = e.options;
                    n(e.element).on(f + t.eventNamespace, t.tags.join(m), r(e.detectElementBorderHovering, e))
                },
                resizingInProgress: function() {
                    var e = this,
                        t = e._resizable;
                    return !!t && !!t.resizing
                },
                resize: o,
                detectElementBorderHovering: function(e) {
                    var t = this,
                        i = t.options,
                        o = i.handle,
                        r = n(e.currentTarget),
                        a = t.resizeHandle,
                        s = o.dataAttribute;
                    t.resizingInProgress() || (!r.is(g) && t.elementBorderHovered(r, e) ? a ? a.data(s) && a.data(s) !== r[0] && t.showResizeHandle(r, e) : t.showResizeHandle(r, e) : a && t._destroyResizeHandle())
                },
                elementBorderHovered: o,
                showResizeHandle: function(e, t) {
                    var n = this;
                    0 === t.buttons && (n._initResizeHandle(), n.setResizeHandlePosition(e), n.setResizeHandleDimensions(), n.setResizeHandleDataAttributes(e[0]), n._attachResizeHandleEventHandlers(), n._initResizable(e), n._hideResizeMarker(), n.resizeHandle.show())
                },
                _initResizeHandle: function() {
                    var e = this,
                        t = e.options;
                    e._destroyResizeHandle(), e.resizeHandle = n(t.handle.template).appendTo(t.rootElement)
                },
                setResizeHandlePosition: o,
                setResizeHandleDimensions: o,
                setResizeHandleDataAttributes: function(e) {
                    var t = this;
                    t.resizeHandle.data(t.options.handle.dataAttribute, e)
                },
                _attachResizeHandleEventHandlers: function() {
                    var e = this,
                        t = e.options,
                        n = t.eventNamespace,
                        i = t.handle.classNames.marker,
                        o = e.resizeHandle;
                    e.resizeHandle.on(d + n, function() {
                        o.find(h + i).show()
                    }).on(p + n, function() {
                        o.find(h + i).hide()
                    })
                },
                _hideResizeMarker: function() {
                    var e = this;
                    e.resizeHandle.find(h + e.options.handle.classNames.marker).hide()
                },
                _destroyResizeHandle: function() {
                    var e = this;
                    e.resizeHandle && (e._destroyResizable(), e.resizeHandle.off(e.options.eventNamespace).remove(), e.resizeHandle = null)
                },
                _initResizable: function(t) {
                    var n = this;
                    n.resizeHandle && (n._destroyResizable(), n._resizable = new e.ui.Resizable(t, {
                        draggableElement: n.resizeHandle[0],
                        start: r(n.onResizeStart, n),
                        resize: r(n.onResize, n),
                        resizeend: r(n.onResizeEnd, n)
                    }))
                },
                _destroyResizable: function() {
                    var e = this;
                    e._resizable && (e._resizable.destroy(), e._resizable = null)
                },
                onResizeStart: function() {
                    this._disableKeyboard()
                },
                onResize: function(e) {
                    this.setResizeHandleDragPosition(e)
                },
                setResizeHandleDragPosition: o,
                onResizeEnd: function(e) {
                    var t = this;
                    t.resize(e), t._destroyResizeHandle(), t._enableKeyboard()
                },
                _enableKeyboard: function() {
                    var e = this.options;
                    n(e.rootElement).off(l + e.eventNamespace)
                },
                _disableKeyboard: function() {
                    var e = this.options;
                    n(e.rootElement).on(l + e.eventNamespace, function(e) {
                        e.preventDefault()
                    })
                },
                _forceResizing: function(e) {
                    var t = this._resizable;
                    t && t.userEvents && t.userEvents._end(e)
                }
            }),
            y = s.extend({
                create: function(e, t) {
                    var i = this,
                        o = t.name,
                        r = t.eventNamespace;
                    n(e.body).on(c + r, b, function(n) {
                        var r = n.currentTarget,
                            a = e[o];
                        n.stopPropagation(), a ? a.element === r || a.resizingInProgress() || (i._destroyResizing(e, t), i._initResizing(e, r, t)) : i._initResizing(e, r, t)
                    }).on(u + r, b, function(r) {
                        var a, s = e[o];
                        r.stopPropagation(), !s || s.resizingInProgress() || s.resizeHandle || (a = n(s.element).parents(b)[0], a && (i._destroyResizing(e, t), i._initResizing(e, a, t)))
                    }).on(u + r, function() {
                        var n = e[o];
                        n && !n.resizingInProgress() && i._destroyResizing(e, t)
                    }).on(p + r, function(r) {
                        var a, s = e[o];
                        s && s.resizingInProgress() && (a = n(r.target).parents(b)[0], a && (s._forceResizing(r), i._destroyResizing(e, t), i._initResizing(e, a, t)))
                    })
                },
                dispose: function(e, t) {
                    n(e.body).off(t.eventNamespace)
                },
                _initResizing: function(t, n, i) {
                    var o = i.name,
                        r = i.type;
                    t[o] = new r(n, {
                        rtl: e.support.isRtl(t.element),
                        rootElement: t.body
                    })
                },
                _destroyResizing: function(e, t) {
                    var n = t.name;
                    e[n] && (e[n].destroy(), e[n] = null)
                }
            });
        y.current = new y, v.create = function(e, t) {
            y.current.create(e, t)
        }, v.dispose = function(e, t) {
            y.current.dispose(e, t)
        }, i(a, {
            TableElementResizing: v
        })
    }(window.kendo)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/resizing/column-resizing.min", ["editor/main.min", "editor/resizing/resizing-utils.min", "editor/resizing/table-element-resizing.min", "editor/dom.min"], e)
}(function() {
    ! function(e, t) {
        var n = window,
            i = n.Math,
            o = i.abs,
            r = e.jQuery,
            a = r.extend,
            s = e.ui.editor,
            l = s.Dom,
            d = s.TableElementResizing,
            c = s.ResizingUtils,
            u = c.constrain,
            f = c.calculatePercentageRatio,
            p = c.getScrollBarWidth,
            m = c.inPercentages,
            h = c.toPercentages,
            g = c.toPixels,
            b = e._outerWidth,
            v = ".kendoEditorColumnResizing",
            y = "k-column-resize-handle",
            k = "k-column-resize-marker",
            w = "body",
            C = "tbody",
            x = "thead",
            T = "td",
            _ = "th",
            N = "tr",
            S = "col-index",
            R = ",",
            A = "width",
            z = d.extend({
                options: {
                    tags: [T, _],
                    min: 20,
                    rootElement: null,
                    eventNamespace: v,
                    rtl: !1,
                    handle: {
                        dataAttribute: "column",
                        width: 10,
                        height: 0,
                        classNames: {
                            handle: y,
                            marker: k
                        },
                        template: '<div class="k-column-resize-handle-wrapper" unselectable="on" contenteditable="false"><div class="' + y + '"><div class="' + k + '"></div></div></div>'
                    }
                },
                elementBorderHovered: function(e, t) {
                    var n = this,
                        i = n.options,
                        o = i.handle.width,
                        a = e.offset().left + (i.rtl ? 0 : b(e)),
                        s = t.clientX + r(e[0].ownerDocument).scrollLeft();
                    return s > a - o && s < a + o
                },
                setResizeHandlePosition: function(e) {
                    var t = this,
                        n = r(t.element.tHead || t.element.tBodies[0]),
                        i = t.options,
                        o = i.rtl,
                        a = i.handle.width,
                        s = r(i.rootElement),
                        l = s.is(w) ? 0 : s.scrollTop(),
                        d = s.is(w) ? 0 : s.scrollLeft(),
                        c = o ? 0 : b(e),
                        u = o ? p(s[0]) : 0,
                        f = e.offset().left - (s.offset().left + parseFloat(s.css("borderLeftWidth"))) - parseFloat(e.css("marginLeft")),
                        m = n.offset().top - (s.offset().top + parseFloat(s.css("borderTopWidth"))) - parseFloat(n.css("marginTop"));
                    t.resizeHandle.css({
                        top: m + l,
                        left: f + c + (d - u) - a / 2,
                        position: "absolute"
                    })
                },
                setResizeHandleDimensions: function() {
                    var e = this,
                        t = r(e.element).children(x),
                        n = r(e.element).children(C),
                        i = t.length > 0 ? t.height() + n.height() : n.height();
                    e.resizeHandle.css({
                        width: e.options.handle.width,
                        height: i
                    })
                },
                setResizeHandleDragPosition: function(e) {
                    var t = this,
                        n = r(r(e.currentTarget).data(t.options.handle.dataAttribute)),
                        i = t.options,
                        o = r(i.rootElement),
                        a = i.handle ? i.handle.width : 0,
                        s = i.min,
                        l = i.rtl,
                        d = b(n),
                        c = n.offset().left - (o.offset().left + parseFloat(o.css("borderLeftWidth"))) - parseFloat(n.css("marginLeft")),
                        f = b(n.next()),
                        m = r(t.resizeHandle),
                        h = o.is(w) ? 0 : o.scrollLeft(),
                        g = l ? p(o[0]) : 0,
                        v = m.offset().left - (o.offset().left + parseFloat(o.css("borderLeftWidth"))) - parseFloat(m.css("marginLeft")),
                        y = u({
                            value: v + (h - g) + e.x.delta,
                            min: c + (h - g) - (l ? f : 0) + s,
                            max: c + d + (h - g) + (l ? 0 : f) - a - s
                        });
                    m.css({
                        left: y
                    })
                },
                resize: function(e) {
                    var t, n, i, o, a, s = this,
                        d = r(r(e.currentTarget).data(s.options.handle.dataAttribute)),
                        c = s.options,
                        f = c.rtl ? -1 : 1,
                        p = c.min,
                        m = f * e.x.initialDelta;
                    l.reMapTableColumns(s.element, S), o = parseInt(d.attr(S), 10), d.prop("colSpan") > 1 && (d = r(s.element).find("[" + S + "=" + (o + d.prop("colSpan") - 1) + "]").eq(0), o = parseInt(d.attr(S), 10)), a = r(s.element).find("[" + S + "=" + (o + 1) + "]:not([colspan])"), s._setTableComputedWidth(), s._setColumnsComputedWidth(), i = b(d), n = b(a), t = u({
                        value: i + m,
                        min: p,
                        max: i + n - p
                    }), s._resizeColumn(d[0], t), s._resizeTopAndBottomColumns(d[0], t), s._resizeAdjacentColumns(parseInt(d.attr(S), 10), n, i, i - t), l.clearTableMappings(s.element, S)
                },
                _setTableComputedWidth: function() {
                    var e = this.element;
                    "" === e.style[A] && (e.style[A] = g(b(r(e))))
                },
                _setColumnsComputedWidth: function() {
                    var e, t = this,
                        n = r(t.element.tHead || t.element.tBodies[0]),
                        i = b(n),
                        o = n.children(N).children(T),
                        a = o.length,
                        s = o.map(function() {
                            return b(r(this))
                        });
                    for (e = 0; e < a; e++) o[e].style[A] = m(o[e].style[A]) ? h(f(s[e], i)) : g(s[e])
                },
                _resizeTopAndBottomColumns: function(e, t) {
                    var n, i = this,
                        o = r(e).attr(S),
                        a = r(i.element).children(C + R + x).children(N).children(i.options.tags.join(R)).filter(function() {
                            var t = this;
                            return r(t).attr(S) === o && t !== e
                        }),
                        s = a.length;
                    for (n = 0; n < s; n++) i._resizeColumn(a[n], t)
                },
                _resizeColumn: function(e, t) {
                    var n = r(this.element.tHead || this.element.tBodies[0]);
                    e.style[A] = m(e.style[A]) ? h(f(t, b(n))) : g(t)
                },
                _resizeAdjacentColumns: function(e, t, n, i) {
                    var o, a = this,
                        s = r(a.element).children(C + R + x).children(N).children(a.options.tags.join(R)).filter(function() {
                            return parseInt(r(this).attr(S), 10) === e + 1
                        }),
                        l = s.length;
                    for (o = 0; o < l; o++) a._resizeAdjacentColumn(s[o], t, n, i)
                },
                _resizeAdjacentColumn: function(e, t, n, i) {
                    var r = this,
                        a = r.options.min,
                        s = u({
                            value: t + i,
                            min: a,
                            max: o(n + t - a)
                        });
                    r._resizeColumn(e, s)
                }
            });
        z.create = function(e) {
            d.create(e, {
                name: "columnResizing",
                type: z,
                eventNamespace: v
            })
        }, z.dispose = function(e) {
            d.dispose(e, {
                eventNamespace: v
            })
        }, a(s, {
            ColumnResizing: z
        })
    }(window.kendo)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/resizing/row-resizing.min", ["editor/main.min", "editor/resizing/resizing-utils.min", "editor/resizing/table-element-resizing.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.Math,
            i = n.abs,
            o = e.jQuery,
            r = o.extend,
            a = e.ui.editor,
            s = a.TableElementResizing,
            l = a.ResizingUtils,
            d = l.getScrollBarWidth,
            c = l.constrain,
            u = l.calculatePercentageRatio,
            f = l.inPercentages,
            p = l.toPercentages,
            m = l.toPixels,
            h = e._outerHeight,
            g = ".kendoEditorRowResizing",
            b = "k-row-resize-handle",
            v = "k-row-resize-marker-wrapper",
            y = "k-row-resize-marker",
            k = "body",
            w = "tr",
            C = "tbody",
            x = "thead",
            T = ",",
            _ = "height",
            N = s.extend({
                options: {
                    tags: [w],
                    min: 20,
                    rootElement: null,
                    eventNamespace: g,
                    rtl: !1,
                    handle: {
                        dataAttribute: "row",
                        width: 0,
                        height: 10,
                        classNames: {
                            handle: b,
                            marker: y
                        },
                        template: '<div class="k-row-resize-handle-wrapper" unselectable="on" contenteditable="false"><div class="' + b + '"><div class="' + v + '"><div class="' + y + '"></div></div></div></div>'
                    }
                },
                elementBorderHovered: function(e, t) {
                    var n = this,
                        i = n.options.handle[_],
                        r = e.offset().top + h(e),
                        a = t.clientY + o(e[0].ownerDocument).scrollTop();
                    return a > r - i && a < r + i
                },
                setResizeHandlePosition: function(e) {
                    var t = this,
                        n = t.options,
                        i = n.handle[_],
                        r = o(n.rootElement),
                        a = r.is(k) ? 0 : r.scrollTop(),
                        s = r.is(k) ? 0 : r.scrollLeft(),
                        l = n.rtl ? d(r[0]) : 0,
                        c = e.offset().left - (r.offset().left + parseFloat(r.css("borderLeftWidth"))) - parseFloat(e.css("marginLeft")),
                        u = e.offset().top - (r.offset().top + parseFloat(r.css("borderTopWidth"))) - parseFloat(e.css("marginTop"));
                    t.resizeHandle.css({
                        top: u + h(e) + a - i / 2,
                        left: c + (s - l),
                        position: "absolute"
                    })
                },
                setResizeHandleDimensions: function() {
                    var e = this,
                        t = o(e.element.tHead || e.element.tBodies[0]);
                    e.resizeHandle.css({
                        width: t.width(),
                        height: e.options.handle[_]
                    })
                },
                setResizeHandleDragPosition: function(e) {
                    var t = this,
                        n = t.options,
                        i = n.min,
                        r = o(t.element).children(x),
                        a = o(t.element).children(C),
                        s = r.length > 0 ? r : a,
                        l = o(t.resizeHandle),
                        d = o(e.currentTarget).data(n.handle.dataAttribute),
                        u = o(d),
                        f = o(n.rootElement),
                        p = f.is(k) ? 0 : f.scrollTop(),
                        m = s.offset().top - (f.offset().top + parseFloat(f.css("borderTopWidth"))) - parseFloat(s.css("marginTop")),
                        g = u.offset().top - (f.offset().top + parseFloat(f.css("borderTopWidth"))) - parseFloat(u.css("marginTop")),
                        b = l.offset().top - (Math.max(0, f.offset().top) + parseFloat(f.css("borderTopWidth"))) - parseFloat(l.css("marginTop")),
                        v = c({
                            value: b + p + e.y.delta,
                            min: g + p + i,
                            max: m + h(r) + h(a) + p - n.handle[_] - i
                        });
                    l.css({
                        top: v
                    })
                },
                resize: function(e) {
                    var t = this,
                        n = t.options,
                        r = o(e.currentTarget).data(n.handle.dataAttribute),
                        a = h(o(r)),
                        s = o(t.element),
                        l = h(s),
                        d = s.children(x),
                        u = d.length > 0 ? d.height() : 0,
                        p = s.children(C),
                        g = p.height(),
                        b = r.style[_],
                        v = c({
                            value: a + e.y.initialDelta,
                            min: n.min,
                            max: i(u + g - n.min)
                        });
                    t._setRowsHeightInPixels(), r.style[_] = m(v), t._setTableHeight(l + (v - a)), f(b) && t._setRowsHeightInPercentages()
                },
                _setRowsHeightInPixels: function() {
                    var e, t = this,
                        n = o(t.element).children(C + T + x).children(w),
                        i = n.length,
                        r = n.map(function() {
                            return h(o(this))
                        });
                    for (e = 0; e < i; e++) n[e].style[_] = m(r[e])
                },
                _setRowsHeightInPercentages: function() {
                    var e, t = this,
                        n = o(t.element).children(x),
                        i = n.length > 0 ? n.height() : 0,
                        r = o(t.element).children(C),
                        a = r.height(),
                        s = o(t.element).children(x + T + C).children(w),
                        l = s.length,
                        d = s.map(function() {
                            return h(o(this))
                        });
                    for (e = 0; e < l; e++) s[e].style[_] = p(u(d[e], i + a))
                },
                _setTableHeight: function(e) {
                    var t = this.element;
                    t.style[_] = f(t.style[_]) ? p(u(e, o(t).parent().height())) : m(e)
                }
            });
        N.create = function(e) {
            s.create(e, {
                name: "rowResizing",
                type: N,
                eventNamespace: g
            })
        }, N.dispose = function(e) {
            s.dispose(e, {
                eventNamespace: g
            })
        }, r(a, {
            RowResizing: N
        })
    }(window.kendo)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/resizing/table-resize-handle.min", ["editor/main.min", "kendo.draganddrop.min", "editor/resizing/resizing-utils.min"], e)
}(function() {
    ! function(e, t) {
        var n, i, o, r, a, s, l, d, c, u, f, p, m, h, g, b, v, y, k, w, C, x, T = e.jQuery,
            _ = T.extend,
            N = T.noop,
            S = T.proxy,
            R = e.ui.editor,
            A = e.Class,
            z = e.ui.Draggable,
            E = e.Observable,
            I = R.ResizingUtils.getScrollBarWidth,
            P = e._outerWidth,
            D = e._outerHeight,
            H = ".kendoEditorTableResizeHandle",
            B = "k-table-resize-handle",
            F = "dragStart",
            O = "drag",
            L = "dragEnd",
            M = "halfInside",
            W = "mouseover",
            U = "mouseout",
            V = "body",
            j = "table",
            K = "east",
            $ = "north",
            q = "northeast",
            G = "northwest",
            Q = "south",
            X = "southeast",
            Y = "southwest",
            J = "west",
            Z = ".",
            ee = E.extend({
                init: function(e) {
                    var t = this;
                    E.fn.init.call(t), t.options = _({}, t.options, e), t.element = T(t.options.template).appendTo(t.options.appendTo)[0], t._attachEventHandlers(), t._addStyles(), t._initDraggable(), t._initPositioningStrategy(), t._initDraggingStrategy(), T(t.element).data(j, t.options.resizableElement)
                },
                destroy: function() {
                    var e = this;
                    T(e.element).off(H).remove(), e.element = null, e._destroyDraggable(), e.unbind()
                },
                options: {
                    appendTo: null,
                    direction: X,
                    resizableElement: null,
                    rtl: !1,
                    template: "<div class='k-table-resize-handle-wrapper' unselectable='on' contenteditable='false'><div class='" + B + "'></div></div>"
                },
                events: [F, O, L, W, U],
                show: function() {
                    this._setPosition()
                },
                _setPosition: function() {
                    var e = this,
                        t = e._positioningStrategy.getPosition();
                    T(e.element).css({
                        top: t.top,
                        left: t.left,
                        position: "absolute"
                    })
                },
                _attachEventHandlers: function() {
                    var e = this;
                    T(e.element).on(W + H, S(e._onMouseOver, e)).on(U + H, S(e._onMouseOut, e))
                },
                _onMouseOver: function() {
                    this.trigger(W)
                },
                _onMouseOut: function() {
                    this.trigger(U)
                },
                _addStyles: function() {
                    var e = this;
                    T(e.element).children(Z + B).addClass("k-resize-" + e.options.direction)
                },
                _initPositioningStrategy: function() {
                    var e = this,
                        t = e.options;
                    e._positioningStrategy = n.create({
                        name: t.direction,
                        handle: e.element,
                        resizableElement: t.resizableElement,
                        rootElement: t.rootElement,
                        rtl: t.rtl
                    })
                },
                _initDraggable: function() {
                    var e = this,
                        t = e.element;
                    !e._draggable && t && (e._draggable = new z(t, {
                        dragstart: S(e._onDragStart, e),
                        drag: S(e._onDrag, e),
                        dragend: S(e._onDragEnd, e)
                    }))
                },
                _onDragStart: function() {
                    this.trigger(F)
                },
                _onDrag: function(e) {
                    var t = this;
                    t.trigger(O, t._draggingStrategy.adjustDragDelta({
                        deltaX: e.x.delta,
                        deltaY: e.y.delta,
                        initialDeltaX: e.x.initialDelta,
                        initialDeltaY: e.y.initialDelta
                    }))
                },
                _onDragEnd: function() {
                    this.trigger(L)
                },
                _destroyDraggable: function() {
                    var e = this;
                    e._draggable && (e._draggable.destroy(), e._draggable = null)
                },
                _initDraggingStrategy: function() {
                    var e = this;
                    e._draggingStrategy = f.create({
                        name: e.options.direction
                    })
                }
            }),
            te = A.extend({
                init: function() {
                    this._items = []
                },
                register: function(e, t) {
                    this._items.push({
                        name: e,
                        type: t
                    })
                },
                create: function(e) {
                    var t, n, i, o = this._items,
                        r = o.length,
                        a = e.name ? e.name.toLowerCase() : "";
                    for (i = 0; i < r; i++)
                        if (n = o[i], n.name.toLowerCase() === a) {
                            t = n;
                            break
                        }
                    if (t) return new t.type(e)
                }
            }),
            ne = te.extend({});
        ne.current = new ne, n = A.extend({
            init: function(e) {
                var t = this;
                t.options = _({}, t.options, e)
            },
            options: {
                handle: null,
                offset: M,
                resizableElement: null,
                rootElement: null,
                rtl: !1
            },
            getPosition: function() {
                var e = this,
                    t = e.calculatePosition(),
                    n = e.applyHandleOffset(t),
                    i = e.applyScrollOffset(n);
                return i
            },
            calculatePosition: N,
            applyHandleOffset: function(e) {
                var t = this.options,
                    n = T(t.handle);
                return t.offset === M ? {
                    top: e.top - D(n) / 2,
                    left: e.left - P(n) / 2
                } : e
            },
            applyScrollOffset: function(e) {
                var t = this.options,
                    n = T(t.rootElement),
                    i = t.rtl ? I(n[0]) : 0;
                return n.is(V) ? e : {
                    top: e.top + (n.scrollTop() || 0),
                    left: e.left + (n.scrollLeft() || 0) - i
                }
            }
        }), n.create = function(e) {
            return ne.current.create(e)
        }, i = n.extend({
            calculatePosition: function() {
                var e = T(this.options.resizableElement),
                    t = e.position();
                return {
                    top: t.top + D(e) / 2,
                    left: t.left + P(e)
                }
            }
        }), ne.current.register(K, i), o = n.extend({
            calculatePosition: function() {
                var e = T(this.options.resizableElement),
                    t = e.position();
                return {
                    top: t.top,
                    left: t.left + P(e) / 2
                }
            }
        }), ne.current.register($, o), r = n.extend({
            calculatePosition: function() {
                var e = T(this.options.resizableElement),
                    t = e.position();
                return {
                    top: t.top,
                    left: t.left + P(e)
                }
            }
        }), ne.current.register(q, r), a = n.extend({
            calculatePosition: function() {
                var e = T(this.options.resizableElement),
                    t = e.position();
                return {
                    top: t.top,
                    left: t.left
                }
            }
        }), ne.current.register(G, a), s = n.extend({
            calculatePosition: function() {
                var e = T(this.options.resizableElement),
                    t = e.position();
                return {
                    top: t.top + D(e),
                    left: t.left + P(e) / 2
                }
            }
        }), ne.current.register(Q, s), l = n.extend({
            calculatePosition: function() {
                var e = T(this.options.resizableElement),
                    t = e.position();
                return {
                    top: t.top + D(e),
                    left: t.left + P(e)
                }
            }
        }), ne.current.register(X, l), d = n.extend({
            calculatePosition: function() {
                var e = T(this.options.resizableElement),
                    t = e.position();
                return {
                    top: t.top + D(e),
                    left: t.left
                }
            }
        }), ne.current.register(Y, d), c = n.extend({
            calculatePosition: function() {
                var e = T(this.options.resizableElement),
                    t = e.position();
                return {
                    top: t.top + D(e) / 2,
                    left: t.left
                }
            }
        }), ne.current.register(J, c), u = te.extend({}), u.current = new u, f = A.extend({
            init: function(e) {
                var t = this;
                t.options = _({}, t.options, e)
            },
            options: {
                deltaX: {
                    adjustment: null,
                    modifier: null
                },
                deltaY: {
                    adjustment: null,
                    modifier: null
                }
            },
            adjustDragDelta: function(e) {
                var t = this.options,
                    n = t.deltaX.adjustment * t.deltaX.modifier,
                    i = t.deltaY.adjustment * t.deltaY.modifier;
                return {
                    deltaX: e.deltaX * n,
                    deltaY: e.deltaY * i,
                    initialDeltaX: e.initialDeltaX * n,
                    initialDeltaY: e.initialDeltaY * i
                }
            }
        }), f.create = function(e) {
            return u.current.create(e)
        }, p = f.extend({
            options: {
                deltaX: {
                    adjustment: 1,
                    modifier: 1
                },
                deltaY: {
                    adjustment: 0,
                    modifier: 0
                }
            }
        }), m = p.extend({
            options: {
                deltaX: {
                    modifier: 1
                }
            }
        }), u.current.register(K, m), h = p.extend({
            options: {
                deltaX: {
                    modifier: -1
                }
            }
        }), u.current.register(J, h), g = f.extend({
            options: {
                deltaX: {
                    adjustment: 0,
                    modifier: 0
                },
                deltaY: {
                    adjustment: 1,
                    modifier: 1
                }
            }
        }), b = g.extend({
            options: {
                deltaY: {
                    modifier: -1
                }
            }
        }), u.current.register($, b), v = g.extend({
            options: {
                deltaY: {
                    modifier: 1
                }
            }
        }), u.current.register(Q, v), y = f.extend({
            options: {
                deltaX: {
                    adjustment: 1,
                    modifier: 1
                },
                deltaY: {
                    adjustment: 1,
                    modifier: 1
                }
            }
        }), k = y.extend({
            options: {
                deltaX: {
                    modifier: 1
                },
                deltaY: {
                    modifier: -1
                }
            }
        }), u.current.register(q, k), w = y.extend({
            options: {
                deltaX: {
                    modifier: -1
                },
                deltaY: {
                    modifier: -1
                }
            }
        }), u.current.register(G, w), C = y.extend({
            options: {
                deltaX: {
                    modifier: 1
                },
                deltaY: {
                    modifier: 1
                }
            }
        }), u.current.register(X, C), x = y.extend({
            options: {
                deltaX: {
                    modifier: -1
                },
                deltaY: {
                    modifier: 1
                }
            }
        }), u.current.register(Y, x), _(R, {
            TableResizeHandle: ee
        })
    }(window.kendo)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/resizing/table-resizing.min", ["editor/main.min", "editor/resizing/table-resize-handle.min", "editor/resizing/resizing-utils.min"], e)
}(function() {
    ! function(e, t) {
        function n(e) {
            return t === e
        }
        var i = window,
            o = i.Math,
            r = o.min,
            a = o.max,
            s = e.jQuery,
            l = s.contains,
            d = s.extend,
            c = s.proxy,
            u = e.support.browser,
            f = e.ui.editor,
            p = e.Class,
            m = f.TableResizeHandle,
            h = f.ResizingUtils,
            g = h.calculatePercentageRatio,
            b = h.constrain,
            v = h.inPercentages,
            y = h.inPixels,
            k = h.toPercentages,
            w = h.toPixels,
            C = e._outerWidth,
            x = e._outerHeight,
            T = ".kendoEditorTableResizing",
            _ = "k-table-resize-handle-wrapper",
            N = "k-table",
            S = "k-table-resizing",
            R = "dragStart",
            A = "drag",
            z = "dragEnd",
            E = "keydown",
            I = "mousedown",
            P = "mouseover",
            D = "mouseout",
            H = "td",
            B = "tr",
            F = "tbody",
            O = "thead",
            L = "table",
            M = ",",
            W = "width",
            U = "height",
            V = "east",
            j = "north",
            K = "northeast",
            $ = "northwest",
            q = "south",
            G = "southeast",
            Q = "southwest",
            X = "west",
            Y = ".",
            J = p.extend({
                init: function(e, t) {
                    var n = this;
                    n.options = d({}, n.options, t), n.handles = [], s(e).is(L) && (n.element = e)
                },
                destroy: function() {
                    var e = this;
                    s(e.element).off(T), e.element = null, s(e.options.rootElement).off(E + T), e._destroyResizeHandles()
                },
                options: {
                    appendHandlesTo: null,
                    rtl: !1,
                    rootElement: null,
                    minWidth: 10,
                    minHeight: 10,
                    handles: [{
                        direction: $
                    }, {
                        direction: j
                    }, {
                        direction: K
                    }, {
                        direction: V
                    }, {
                        direction: G
                    }, {
                        direction: q
                    }, {
                        direction: Q
                    }, {
                        direction: X
                    }]
                },
                resize: function(e) {
                    var t = this,
                        n = d({}, {
                            deltaX: 0,
                            deltaY: 0,
                            initialDeltaX: 0,
                            initialDeltaY: 0
                        }, e);
                    t._resizeWidth(n.deltaX, n.initialDeltaX), t._resizeHeight(n.deltaY, n.initialDeltaY), t.showResizeHandles()
                },
                _resizeWidth: function(e, t) {
                    var i, o, l, d, c = this,
                        u = s(c.element),
                        f = u[0].style[W],
                        p = C(u),
                        m = u.parent().width(),
                        h = c._getMaxDimensionValue(W);
                    0 !== e && (n(c._initialElementWidth) && (c._initialElementWidth = p), d = b({
                        value: c._initialElementWidth + t,
                        min: c.options.minWidth,
                        max: h
                    }), v(f) ? (p + e > m ? (o = a(d, m), l = r(d, m)) : (o = r(d, m), l = a(d, m)), i = k(g(o, l))) : i = w(d), c._setColumnsWidth(), u[0].style[W] = i)
                },
                _resizeHeight: function(e, t) {
                    var i, o, l, d, c = this,
                        u = s(c.element),
                        f = u[0].style[U],
                        p = x(u),
                        m = u.parent(),
                        h = m.height(),
                        y = c._getMaxDimensionValue(U),
                        C = c.options.minHeight,
                        T = c._hasRowsInPixels();
                    0 !== e && (n(c._initialElementHeight) && (c._initialElementHeight = p), d = b({
                        value: c._initialElementHeight + t,
                        min: C,
                        max: y
                    }), T && e < 0 && c._setRowsHeightInPercentages(), v(f) ? (p + e > h ? (o = a(d, h), l = r(d, h)) : (o = r(d, h), l = a(d, h)), i = k(g(o, l))) : i = w(d), u[0].style[U] = i, T && e < 0 && c._setRowsHeightInPixels())
                },
                _getMaxDimensionValue: function(e) {
                    var t = this,
                        n = s(t.element),
                        i = e.toLowerCase(),
                        o = t.options.rtl ? -1 : 1,
                        r = s(t.element).parent(),
                        a = r[0],
                        l = r[i](),
                        d = o * (e === W ? r.scrollLeft() : r.scrollTop());
                    return a === n.closest(H)[0] ? "" !== a.style[i] || v(t.element.style[i]) ? l + d : 1 / 0 : l + d
                },
                _setColumnsWidth: function() {
                    function e(e) {
                        var t = e.style.width;
                        return "" !== t ? !!v(t) : !!s(e).hasClass(N)
                    }
                    var t, n = this,
                        i = s(n.element),
                        o = i.parent()[0],
                        r = i.closest(H),
                        a = r.closest(B).children(),
                        l = a.length;
                    if (e(i[0]) && o === r[0] && "" === o.style[W])
                        for (t = 0; t < l; t++) a[t].style[W] = w(s(a[t]).width())
                },
                _hasRowsInPixels: function() {
                    var e, t = this,
                        n = s(t.element).children(O + M + F).children(B);
                    for (e = 0; e < n.length; e++)
                        if ("" === n[e].style.height || y(n[e].style.height)) return !0;
                    return !1
                },
                _setRowsHeightInPercentages: function() {
                    var e, t = this,
                        n = s(t.element).children(O),
                        i = n.length > 0 ? n.height() : 0,
                        o = s(t.element).children(F),
                        r = o.height(),
                        a = s(t.element).children(O + M + F).children(B),
                        l = a.length,
                        d = a.map(function() {
                            return x(s(this))
                        });
                    for (e = 0; e < l; e++) a[e].style[U] = k(g(d[e], i + r))
                },
                _setRowsHeightInPixels: function() {
                    var e, t = this,
                        n = s(t.element).children(O + M + F).children(B),
                        i = n.length,
                        o = n.map(function() {
                            return x(s(this))
                        });
                    for (e = 0; e < i; e++) n[e].style[U] = w(o[e])
                },
                showResizeHandles: function() {
                    var e = this;
                    e._initResizeHandles(), e._showResizeHandles()
                },
                _initResizeHandles: function() {
                    var e, t = this,
                        n = t.handles,
                        i = t.options,
                        o = t.options.handles,
                        r = o.length;
                    if (!(n && n.length > 0)) {
                        for (e = 0; e < r; e++) t.handles.push(new m(d({
                            appendTo: i.appendHandlesTo,
                            resizableElement: t.element,
                            rootElement: i.rootElement,
                            rtl: i.rtl
                        }, o[e])));
                        t._bindToResizeHandlesEvents()
                    }
                },
                _destroyResizeHandles: function() {
                    var e, t = this,
                        n = t.handles ? t.handles.length : 0;
                    for (e = 0; e < n; e++) t.handles[e].destroy()
                },
                _showResizeHandles: function() {
                    var e, t = this,
                        n = t.handles || [],
                        i = n.length;
                    for (e = 0; e < i; e++) t.handles[e].show()
                },
                _bindToResizeHandlesEvents: function() {
                    var e, t, n = this,
                        i = n.handles || [],
                        o = i.length;
                    for (e = 0; e < o; e++) t = i[e], t.bind(R, c(n._onResizeHandleDragStart, n)), t.bind(A, c(n._onResizeHandleDrag, n)), t.bind(z, c(n._onResizeHandleDragEnd, n)), t.bind(P, c(n._onResizeHandleMouseOver, n)), t.bind(D, c(n._onResizeHandleMouseOut, n))
                },
                _onResizeHandleDragStart: function() {
                    var e = this,
                        t = s(e.element);
                    t.addClass(S), e._initialElementHeight = x(t), e._initialElementWidth = C(t), e._disableKeyboard()
                },
                _onResizeHandleDrag: function(e) {
                    this.resize(e)
                },
                _onResizeHandleDragEnd: function() {
                    var e = this;
                    s(e.element).removeClass(S), e._enableKeyboard()
                },
                _enableKeyboard: function() {
                    s(this.options.rootElement).off(E + T)
                },
                _disableKeyboard: function() {
                    s(this.options.rootElement).on(E + T, function(e) {
                        e.preventDefault()
                    })
                }
            }),
            Z = p.extend({
                create: function(e) {
                    var t = this;
                    s(e.body).on(I + T, L, function(n) {
                        var i = n.target,
                            o = n.currentTarget,
                            r = e.tableResizing,
                            a = r ? r.element : null;
                        if (r) {
                            if (a && o !== a) {
                                if (l(o, a) && a !== i && l(a, i)) return;
                                a !== i && (e._destroyTableResizing(), t._initResizing(e, o))
                            }
                        } else t._initResizing(e, o);
                        e._showTableResizeHandles()
                    }).on(I + T, function(t) {
                        var n = e.tableResizing,
                            i = n ? n.element : null,
                            o = t.target,
                            r = s(o).hasClass(_) || s(o).parents(Y + _).length > 0;
                        !n || i === o || l(i, o) || r || e._destroyTableResizing()
                    })
                },
                dispose: function(e) {
                    s(e.body).off(T)
                },
                _initResizing: function(t, n) {
                    u.msie || u.mozilla || (t.tableResizing = new J(n, {
                        appendHandlesTo: t.body,
                        rtl: e.support.isRtl(t.element),
                        rootElement: t.body
                    }))
                }
            });
        Z.current = new Z, J.create = function(e) {
            Z.current.create(e)
        }, J.dispose = function(e) {
            Z.current.dispose(e)
        }, d(f, {
            TableResizing: J
        })
    }(window.kendo)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/table-wizard/table-wizard-command.min", ["editor/plugins/tables.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            i = n.ui.editor,
            o = i.EditorUtils,
            r = i.RangeUtils,
            a = i.Dom,
            s = o.registerTool,
            l = i.ToolTemplate,
            d = i.Command,
            c = new i.BlockFormatFinder([{
                tags: ["table"]
            }]),
            u = new i.BlockFormatFinder([{
                tags: ["td", "th"]
            }]),
            f = /([a-z]+|%)$/i,
            p = "col",
            m = "row",
            h = "colgroup",
            g = "scope",
            b = "col-index",
            v = "th",
            y = "td",
            k = "thead",
            w = "headers",
            C = "table",
            x = d.extend({
                exec: function() {
                    var o = this,
                        r = o.editor,
                        a = o.range = o.lockRange(),
                        s = o._sourceTable = o.options.insertNewTable ? t : o._selectedTable(a),
                        l = o._selectedTableCells = s ? o._selectedCells(a) : t,
                        d = {
                            visible: !1,
                            messages: r.options.messages,
                            closeCallback: e.proxy(o.onDialogClose, o),
                            table: o.parseTable(s, l),
                            dialogOptions: r.options.dialogOptions,
                            isRtl: n.support.isRtl(r.wrapper)
                        },
                        c = new i.TableWizardDialog(d);
                    c.open()
                },
                onDialogClose: function(e) {
                    var t = this;
                    t.releaseRange(t.range), e && (t.options.insertNewTable ? t.insertTable(t.createNewTable(e)) : t.updateTable(e, t._sourceTable, t._selectedTableCells))
                },
                releaseRange: function(e) {
                    var t = this,
                        n = t.editor.document;
                    a.windowFromDocument(n).focus(), d.fn.releaseRange.call(t, e)
                },
                insertTable: function(e) {
                    var t = this.range;
                    t.insertNode(e), t.collapse(!0), this.editor.selectRange(t), this._ensureFocusableAfterTable(e)
                },
                _ensureFocusableAfterTable: function(t) {
                    for (var n = e(t).parent().contents(), i = n.length - 1, o = n.get(i); null !== o.nodeValue && (" " === o.nodeValue || "" === o.nodeValue);) i -= 1, o = n.get(i);
                    o === t && a.insertAfter(a.createEmptyNode(this.editor.document, "p"), t)
                },
                updateTable: function(t, n, i) {
                    for (var o, r, s, l, d, c, u, f, p = this, m = e(n.rows).toArray(), h = t.tableProperties, g = h.rows, v = h.columns, y = n.tHead, k = function(e) {
                            return e[e.length - 1]
                        }; i.length > 1;) i.pop();
                    if (o = i.length ? k(i).parentNode : k(m), p._deleteTableRows(m, m.length - g), m.length < g)
                        for (l = e(o).index(), d = o.cells.length, c = g - m.length, s = o.parentNode; c;) r = s.insertRow(l + 1), p._insertCells(d - r.cells.length, r), c--;
                    m[0].cells.length > v && e(m).each(function(e, t) {
                        for (; t.cells.length > v;) t.deleteCell(-1)
                    }), m[0].cells.length < v && (u = e(k(i) || k(o.cells)).index(), e(m).each(function(e, t) {
                        p._insertCells(v - t.cells.length, t, u + 1)
                    })), p._updateTableProperties(n, h), f = t.cellProperties, i[0] && a.attr(i[0], {
                        id: f.id || null
                    }), (f.selectAllCells ? e(m).children() : e(i)).each(function(e, t) {
                        p._updateCellProperties(t, f)
                    }), p._updateCaption(n, h), a.reMapTableColumns(n, b), y ? p._updateHeadersWithThead(n, t) : p._updateHeadersNoThead(n, t), p._updateHeaderAssociates(n, h), a.clearTableMappings(n, b)
                },
                _isHeadingRow: function(e) {
                    return a.is(e.cells[0], v) && a.is(e.parentNode, k)
                },
                _isHeadingCell: function(e) {
                    return a.is(e, v)
                },
                cellsWithHeadersAssociated: function(t) {
                    var n, i = e(t.rows).children(),
                        o = [],
                        r = function(e) {
                            return o.indexOf(e) > -1
                        };
                    return i.each(function(e, t) {
                        t.id && a.is(t, v) && o.push(t.id)
                    }), n = i.filter(function(e, t) {
                        var n, i = t.getAttribute(w);
                        return !!(i && !a.is(t, v) && (n = i.split(" "), n && n.length > 0)) && n.some(r)
                    }), !!n.length
                },
                _insertCells: function(e, t, n) {
                    n = isNaN(n) ? -1 : n;
                    for (var i, o = 0; o < e; o++) i = t.insertCell(n), i.innerHTML = "&nbsp;"
                },
                _deleteTableRows: function(e, t) {
                    for (var n, i, o = 0; o < t; o++) n = e.pop(), i = n.parentNode, i.removeChild(n), i.rows.length || a.remove(i)
                },
                createNewTable: function(e) {
                    var t, n, i = this,
                        o = i.editor.document,
                        r = e.tableProperties,
                        s = a.create(o, C),
                        l = 0;
                    return i._updateTableProperties(s, r), i._updateCaption(s, r), r.headerRows && r.headerRows > 0 && (t = s.createTHead(), i._createTableRows(e, t, l, !0), l += r.headerRows), n = s.createTBody(), i._createTableRows(e, n, l, !1), a.reMapTableColumns(s, b), "ids" === r.cellsWithHeaders ? a.associateWithIds(s) : "scope" === r.cellsWithHeaders && i._addScopes(s, r.headerRows, r.headerColumns), a.clearTableMappings(s, b), s
                },
                _createTableRows: function(e, t, n, i) {
                    var o, r, a, s, l = this,
                        d = e.tableProperties,
                        c = e.cellProperties,
                        u = d.columns,
                        f = i ? d.headerRows : d.rows,
                        p = c.selectAllCells,
                        m = d.headerColumns;
                    for (o = n; o < f; o++)
                        for (r = t.insertRow(), a = 0; a < u; a++) s = i || m > a ? document.createElement(v) : document.createElement(y), r.appendChild(s), s.innerHTML = "&nbsp;", 0 === o && 0 === a && c.id && (s.id = c.id), l._updateCellProperties(s, p || 0 === o && 0 === a ? c : {})
                },
                _updateTableProperties: function(t, n) {
                    var i = this._getStylesData(n);
                    a.attr(t, {
                        cellSpacing: n.cellSpacing || null,
                        cellPadding: n.cellPadding || null,
                        className: n.className || null,
                        id: n.id || null,
                        summary: n.summary || null,
                        style: i || null
                    }), e(t).addClass("k-table")
                },
                _updateCellProperties: function(e, t) {
                    var n = this._getStylesData(t);
                    n.padding = t.cellPadding || null, n.margin = t.cellMargin || null, a.attr(e, {
                        style: n || null,
                        className: t.className || null
                    })
                },
                _updateCaption: function(e, t) {
                    var n, i;
                    e.caption && !t.captionContent ? e.deleteCaption() : t.captionContent && (n = e.createCaption(), n.innerHTML = t.captionContent, i = this._getAlignmentData(t.captionAlignment), a.attr(n, {
                        style: {
                            textAlign: i.textAlign,
                            verticalAlign: i.verticalAlign
                        }
                    }))
                },
                _updateHeadersNoThead: function(e, t) {
                    var n, i, o, r, s, l = this,
                        d = t.tableProperties,
                        c = e.rows;
                    for (r = 0; r < c.length; r++)
                        for (n = c[r], i = n.cells, s = 0; s < i.length; s++) o = i[s], !l._isHeadingCell(o) && (r < d.headerRows || d.headerColumns > o.getAttribute(b)) ? a.changeTag(o, v, !1) : l._isHeadingCell(o) && r >= d.headerRows && d.headerColumns <= o.getAttribute(b) && a.changeTag(o, y, !1)
                },
                _updateHeadersWithThead: function(e, t) {
                    var n, i, o, r = this,
                        s = t.tableProperties,
                        l = e.tHead,
                        d = 0,
                        c = e.tBodies[0];
                    if (c || (c = e.createTBody()), s.headerRows && s.headerRows > 0) {
                        for (l || (l = e.createTHead()); l.rows.length < s.headerRows;) l.appendChild(c.rows[0]);
                        for (; l.rows.length > s.headerRows;) c.appendChild(l.rows[0]);
                        r._swapToHeaderCells(l)
                    } else if (l) {
                        for (; l.rows.length > 0;) c.appendChild(l.rows[l.rows.length - 1]);
                        e.deleteTHead()
                    }
                    for (; c.rows.length > d;) {
                        for (n = c.rows[d], o = 0; o < n.cells.length; o++) i = n.cells[o], r._isHeadingCell(i) && s.headerColumns <= i.getAttribute(b) ? a.changeTag(i, y, !1) : !r._isHeadingCell(i) && s.headerColumns > i.getAttribute(b) && a.changeTag(i, v, !1);
                        d += 1
                    }
                },
                _updateHeaderAssociates: function(e, t) {
                    var n = this;
                    "ids" === t.cellsWithHeaders ? (n.cellsWithHeadersAssociated(e) || n._removeScopes(e), a.associateWithIds(e)) : "scope" === t.cellsWithHeaders ? (n.cellsWithHeadersAssociated(e) && n._removeAssociates(e), n._addScopes(e, t.headerRows, t.headerColumns)) : n.cellsWithHeadersAssociated(e) ? n._removeAssociates(e) : n._removeScopes(e)
                },
                _addScopes: function(e, t, n) {
                    var i, o, r, a, s = e.rows;
                    for (i = 0; i < s.length; i++)
                        for (r = s[i], o = 0; o < r.cells.length; o++) a = r.cells[o], i < t ? a.setAttribute(g, p) : a.getAttribute(b) < n && a.setAttribute(g, m)
                },
                _removeScopes: function(t) {
                    e(t).find(v).removeAttr(g), e(t).find(p).remove(), e(t).find(h).remove()
                },
                _removeAssociates: function(t) {
                    e(t).find("th, td").removeAttr("id headers")
                },
                _swapToHeaderCells: function(t) {
                    var n = e(t).find("td"),
                        i = function(e, t) {
                            a.changeTag(t, v, !1)
                        };
                    n.each(i)
                },
                _getStylesData: function(e) {
                    var t = this._getAlignmentData(e.alignment),
                        n = "wrapText" in e ? e.wrapText ? "" : "nowrap" : null;
                    return {
                        width: e.width ? e.width + e.widthUnit : null,
                        height: e.height ? e.height + e.heightUnit : null,
                        textAlign: t.textAlign,
                        verticalAlign: t.verticalAlign,
                        backgroundColor: e.bgColor || "",
                        borderWidth: e.borderWidth,
                        borderStyle: e.borderStyle,
                        borderColor: e.borderColor || "",
                        borderCollapse: e.collapseBorders ? "collapse" : null,
                        whiteSpace: n
                    }
                },
                _getAlignmentData: function(e) {
                    var t, n = "",
                        i = n;
                    return e && (e.indexOf(" ") != -1 ? (t = e.split(" "), n = t[0], i = t[1]) : n = e), {
                        textAlign: n,
                        verticalAlign: i
                    }
                },
                parseTable: function(n, i) {
                    var o, r, s, l, d, c, u, f, p, m, h, g, v;
                    return n ? (o = this, r = n.style, s = n.rows, l = n.caption, d = e(l ? l.cloneNode(!0) : t), d.find(".k-marker").remove(), c = n.className, c = c.replace(/^k-table\s|\sk-table$/, ""), c = c.replace(/\sk-table\s/, " "), c = c.replace(/^k-table$/, ""), u = o._getAlignment(n, !0), f = l ? o._getAlignment(l) : t, p = a._getNumberOfHeaderRows(n), m = o.cellsWithHeadersAssociated(n) ? "ids" : e(n).find("th[scope]").length > 0 ? "scope" : "none", a.reMapTableColumns(n, b), h = a._getNumberOfColumns(n), g = a._getNumberOfHeaderColumns(n, p), a.clearTableMappings(n, b), v = {
                        tableProperties: {
                            width: r.width || n.width ? parseFloat(r.width || n.width) : null,
                            height: r.height || n.height ? parseFloat(r.height || n.height) : null,
                            columns: h,
                            rows: s.length,
                            widthUnit: o._getUnit(r.width),
                            heightUnit: o._getUnit(r.height),
                            cellSpacing: n.cellSpacing,
                            cellPadding: n.cellPadding,
                            alignment: u.textAlign,
                            bgColor: r.backgroundColor || n.bgColor,
                            className: c,
                            id: n.id,
                            borderWidth: r.borderWidth || n.border,
                            borderColor: r.borderColor,
                            borderStyle: r.borderStyle || "",
                            collapseBorders: !!r.borderCollapse,
                            summary: n.summary,
                            captionContent: l ? d.html() : "",
                            captionAlignment: l && f.textAlign ? f.textAlign + " " + f.verticalAlign : "",
                            headerRows: p,
                            headerColumns: g,
                            cellsWithHeaders: m
                        },
                        selectedCells: []
                    }, v.rows = o.parseTableRows(s, i, v), v) : {
                        tableProperties: {},
                        selectedCells: []
                    }
                },
                parseTableRows: function(t, n, i) {
                    var o, r, a, s, l, d, c, u = this,
                        f = [];
                    for (d = 0; d < t.length; d++)
                        for (o = t[d], r = {
                                cells: []
                            }, a = o.cells, f.push(r), c = 0; c < a.length; c++) s = a[c], l = u.parseCell(s), e.inArray(s, n) != -1 && i.selectedCells.push(l), r.cells.push(l);
                    return f
                },
                parseCell: function(e) {
                    var t, n = this,
                        i = e.style,
                        o = n._getAlignment(e);
                    return o = o.textAlign ? o.textAlign + " " + o.verticalAlign : "", t = {
                        width: i.width || e.width ? parseFloat(i.width || e.width) : null,
                        height: i.height || e.height ? parseFloat(i.height || e.height) : null,
                        widthUnit: n._getUnit(i.width),
                        heightUnit: n._getUnit(i.height),
                        cellMargin: i.margin,
                        cellPadding: i.padding,
                        alignment: o,
                        bgColor: i.backgroundColor || e.bgColor,
                        className: e.className,
                        id: e.id,
                        borderWidth: i.borderWidth || e.border,
                        borderColor: i.borderColor,
                        borderStyle: i.borderStyle,
                        wrapText: "nowrap" != i.whiteSpace
                    }
                },
                _getAlignment: function(e, t) {
                    var n, i = e.style,
                        o = i.textAlign || e.align || "";
                    return t ? {
                        textAlign: o
                    } : (n = i.verticalAlign || e.vAlign || "", o && n ? {
                        textAlign: o,
                        verticalAlign: n
                    } : !o && n ? {
                        textAlign: "left",
                        verticalAlign: n
                    } : o && !n ? {
                        textAlign: o,
                        verticalAlign: "top"
                    } : {
                        textAlign: "",
                        verticalAlign: ""
                    })
                },
                _getUnit: function(e) {
                    var t = (e || "").match(f);
                    return t ? t[0] : "px"
                },
                _selectedTable: function(e) {
                    var t = a.filterBy(r.nodes(e), a.htmlIndentSpace, !0);
                    return c.findSuitable(t)[0]
                },
                _selectedCells: function(e) {
                    var t = a.filterBy(r.nodes(e), a.htmlIndentSpace, !0);
                    return u.findSuitable(t)
                }
            }),
            T = i.Tool.extend({
                command: function(e) {
                    return e.insertNewTable = this.options.insertNewTable, new x(e)
                }
            }),
            _ = T.extend({
                update: function(e, t) {
                    var n = !c.isFormatted(t);
                    e.toggleClass("k-state-disabled", n)
                }
            });
        n.ui.editor.TableWizardTool = T, n.ui.editor.TableWizardCommand = x, s("tableWizard", new _({
            command: x,
            insertNewTable: !1,
            template: new l({
                template: o.buttonTemplate,
                title: "Table Wizard"
            })
        }))
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("editor/table-wizard/table-wizard-dialog.min", ["editor/table-wizard/table-wizard-command.min", "kendo.tabstrip.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            i = {
                format: "0",
                min: 0
            },
            o = ["px", "em"],
            r = ["solid", "dotted", "dashed", "double", "groove", "ridge", "inset", "outset", "initial", "inherit", "none", "hidden"],
            a = 4,
            s = {
                dataSource: [{
                    className: "k-icon k-i-table-align-middle-left",
                    value: "left"
                }, {
                    className: "k-icon k-i-table-align-middle-center",
                    value: "center"
                }, {
                    className: "k-icon k-i-table-align-middle-right",
                    value: "right"
                }, {
                    className: "k-icon k-i-align-remove",
                    value: ""
                }],
                dataTextField: "className",
                dataValueField: "value",
                template: "<span class='#: className #' title='#: tooltip #'></span>",
                valueTemplate: "<span class='k-align-group #: className #' title='#: tooltip #'></span>"
            },
            l = {
                dataSource: [{
                    className: "k-icon k-i-table-align-top-left",
                    value: "left top"
                }, {
                    className: "k-icon k-i-table-align-top-center",
                    value: "center top"
                }, {
                    className: "k-icon k-i-table-align-top-right",
                    value: "right top"
                }, {
                    className: "k-icon k-i-table-align-middle-left",
                    value: "left middle"
                }, {
                    className: "k-icon k-i-table-align-middle-center",
                    value: "center middle"
                }, {
                    className: "k-icon k-i-table-align-middle-right",
                    value: "right middle"
                }, {
                    className: "k-icon k-i-table-align-bottom-left",
                    value: "left bottom"
                }, {
                    className: "k-icon k-i-table-align-bottom-center",
                    value: "center bottom"
                }, {
                    className: "k-icon k-i-table-align-bottom-right",
                    value: "right bottom"
                }, {
                    className: "k-icon k-i-align-remove",
                    value: ""
                }],
                dataTextField: "className",
                dataValueField: "value",
                template: "<span class='#: className #' title='#: tooltip #'></span>",
                valueTemplate: "<span class='k-align-group #: className #' title='#: tooltip #'></span>"
            },
            d = {
                dataSource: [{
                    className: "k-icon k-i-table-align-top-left",
                    value: "left top"
                }, {
                    className: "k-icon k-i-table-align-top-center",
                    value: "center top"
                }, {
                    className: "k-icon k-i-table-align-top-right",
                    value: "right top"
                }, {
                    className: "k-icon k-i-table-align-bottom-left",
                    value: "left bottom"
                }, {
                    className: "k-icon k-i-table-align-bottom-center",
                    value: "center bottom"
                }, {
                    className: "k-icon k-i-table-align-bottom-right",
                    value: "right bottom"
                }, {
                    className: "k-icon k-i-align-remove",
                    value: ""
                }],
                dataTextField: "className",
                dataValueField: "value",
                template: "<span class='#: className #' title='#: tooltip #'></span>",
                valueTemplate: "<span class='k-align-group #: className #' title='#: tooltip #'></span>"
            },
            c = '<div class="k-editor-dialog k-editor-table-wizard-dialog k-action-window k-popup-edit-form"><div class="k-edit-form-container"><div id="k-table-wizard-tabs" class="k-root-tabs"><ul><li class="k-state-active">#= messages.tableTab #</li><li>#= messages.cellTab #</li><li>#= messages.accessibilityTab #</li></ul><div id="k-table-properties"><div class="k-edit-label"><label for="k-editor-table-width">#= messages.width #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-width" /><input id="k-editor-table-width-type" aria-label="#= messages.units #" /></div><div class="k-edit-label"><label for="k-editor-table-height">#= messages.height #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-height" /><input id="k-editor-table-height-type" aria-label="#= messages.units #" /></div><div class="k-edit-label"><label for="k-editor-table-columns">#= messages.columns #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-columns" /></div><div class="k-edit-label"><label for="k-editor-table-rows">#= messages.rows #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-rows" /></div><div class="k-edit-label"><label for="k-editor-table-cell-spacing">#= messages.cellSpacing #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-cell-spacing" /></div><div class="k-edit-label"><label for="k-editor-table-cell-padding">#= messages.cellPadding #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-cell-padding" /></div><div class="k-edit-label"><label for="k-editor-table-alignment">#= messages.alignment #</label></div><div class="k-edit-field"><input id="k-editor-table-alignment" class="k-align" /></div><div class="k-edit-label"><label for="k-editor-table-bg">#= messages.background #</label></div><div class="k-edit-field"><input id="k-editor-table-bg" /></div><div class="k-edit-label"><label for="k-editor-css-class">#= messages.cssClass #</label></div><div class="k-edit-field"><input id="k-editor-css-class" class="k-textbox" type="text" /></div><div class="k-edit-label"><label for="k-editor-id">#= messages.id #</label></div><div class="k-edit-field"><input id="k-editor-id" class="k-textbox" type="text" /></div><div class="k-edit-label"><label for="k-editor-border-width">#= messages.border #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-border-width" /><input id="k-editor-border-color" /></div><div class="k-edit-label"><label for="k-editor-border-style">#= messages.borderStyle #</label></div><div class="k-edit-field"><input id="k-editor-border-style" /></div><div class="k-edit-label">&nbsp;</div><div class="k-edit-field"><input id="k-editor-collapse-borders" type="checkbox" class="k-checkbox" /><label for="k-editor-collapse-borders" class="k-checkbox-label">#= messages.collapseBorders #</label></div></div><div id="k-cell-properties"><div class="k-edit-field"><input id="k-editor-selectAllCells" type="checkbox" class="k-checkbox" /><label for="k-editor-selectAllCells" class="k-checkbox-label">#= messages.selectAllCells #</label></div><div class="k-edit-label"><label for="k-editor-cell-width">#= messages.width #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-cell-width" /><input id="k-editor-cell-width-type" aria-label="#= messages.units #" /></div><div class="k-edit-label"><label for="k-editor-cell-height">#= messages.height #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-cell-height" /><input id="k-editor-cell-height-type" aria-label="#= messages.units #" /></div><div class="k-edit-label"><label for="k-editor-table-cell-margin">#= messages.cellMargin #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-cell-margin" /></div><div class="k-edit-label"><label for="k-editor-table-cells-padding">#= messages.cellPadding #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-cells-padding" /></div><div class="k-edit-label"><label for="k-editor-cell-alignment">#= messages.alignment #</label></div><div class="k-edit-field"><input id="k-editor-cell-alignment" class="k-align" /></div><div class="k-edit-label"><label for="k-editor-cell-bg">#= messages.background #</label></div><div class="k-edit-field"><input id="k-editor-cell-bg" /></div><div class="k-edit-label"><label for="k-editor-cell-css-class">#= messages.cssClass #</label></div><div class="k-edit-field"><input id="k-editor-cell-css-class" class="k-textbox" type="text" /></div><div class="k-edit-label"><label for="k-editor-cell-id">#= messages.id #</label></div><div class="k-edit-field"><input id="k-editor-cell-id" class="k-textbox" type="text" /></div><div class="k-edit-label"><label for="k-editor-cell-border-width">#= messages.border #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-cell-border-width" /><input id="k-editor-cell-border-color" /></div><div class="k-edit-label"><label for="k-editor-cell-border-style">#= messages.borderStyle #</label></div><div class="k-edit-field"><input id="k-editor-cell-border-style" /></div><div class="k-edit-label">&nbsp;</div><div class="k-edit-field"><input id="k-editor-wrap-text" type="checkbox" class="k-checkbox" /><label for="k-editor-wrap-text" class="k-checkbox-label">#= messages.wrapText #</label></div></div><div id="k-accessibility-properties"><div class="k-edit-label"><label for="k-editor-table-header-rows">#= messages.headerRows #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-header-rows" /></div><div class="k-edit-label"><label for="k-editor-table-header-columns">#= messages.headerColumns #</label></div><div class="k-edit-field"><input type="numeric" id="k-editor-table-header-columns" /></div><div class="k-edit-label"><label for="k-editor-table-caption">#= messages.caption #</label></div><div class="k-edit-field"><input id="k-editor-table-caption" class="k-textbox" type="text"/></div><div class="k-edit-label"><label for="k-editor-accessibility-alignment">#= messages.alignment #</label></div><div class="k-edit-field"><input id="k-editor-accessibility-alignment" class="k-align" /></div><div class="k-edit-label"><label for="k-editor-accessibility-summary">#= messages.summary #</label></div><div class="k-edit-field"><textarea id="k-editor-accessibility-summary" rows="5" class="k-textbox k-editor-accessibility-summary" placeholder="#= messages.tableSummaryPlaceholder #"></textarea></div><div class="k-edit-label"><label for="k-editor-cells-headers">#= messages.associateCellsWithHeaders #</label></div><div class="k-edit-field"><select id="k-editor-cells-headers"><option value="none">#= messages.associateNone #</option><option value="scope">#= messages.associateScope #</option><option value="ids">#= messages.associateIds #</option></select></div></div></div><div class="k-edit-buttons k-state-default"><button class="k-button k-primary k-dialog-ok">#= messages.dialogOk #</button><button class="k-button k-dialog-close">#= messages.dialogCancel #</button></div></div></div>',
            u = n.Class.extend({
                init: function(e) {
                    this.options = e
                },
                open: function() {
                    function t(e) {
                        e.preventDefault(), l.destroy(), r.destroy()
                    }

                    function i(e) {
                        l.collectDialogValues(u), t(e), l.change && l.change(), d.closeCallback(u)
                    }

                    function o(e) {
                        t(e), d.closeCallback()
                    }
                    var r, a, s, l = this,
                        d = l.options,
                        c = d.dialogOptions,
                        u = d.table,
                        f = d.messages,
                        p = n.support.browser.msie;
                    c.close = o, c.title = f.tableWizard, c.visible = d.visible, r = e(l._dialogTemplate(f)).appendTo(document.body).kendoWindow(c).closest(".k-window").toggleClass("k-rtl", d.isRtl).end().find(".k-dialog-ok").click(i).end().find(".k-dialog-close").click(o).end().data("kendoWindow"), a = r.element, l._initTabStripComponent(a), l._initTableViewComponents(a, u), l._initCellViewComponents(a, u), l._initAccessibilityViewComponents(a, u), r.center(), r.open(), p && (s = a.closest(".k-window").height(), a.css("max-height", s))
                },
                _initTabStripComponent: function(e) {
                    var t = this.components = {};
                    t.tabStrip = e.find("#k-table-wizard-tabs").kendoTabStrip({
                        animation: !1
                    }).data("kendoTabStrip")
                },
                collectDialogValues: function() {
                    var e = this,
                        t = e.options.table;
                    e._collectTableViewValues(t), e._collectCellViewValues(t), e._collectAccessibilityViewValues(t)
                },
                _collectTableViewValues: function(e) {
                    var t = this.components.tableView,
                        n = e.tableProperties;
                    n.width = t.width.value(), n.widthUnit = t.widthUnit.value(), n.height = t.height.value(), n.columns = t.columns.value(), n.rows = t.rows.value(), n.heightUnit = t.heightUnit.value(), n.cellSpacing = t.cellSpacing.value(), n.cellPadding = t.cellPadding.value(), n.alignment = t.alignment.value(), n.bgColor = t.bgColor.value(), n.className = t.className.value, n.id = t.id.value, n.borderWidth = t.borderWidth.value(), n.borderColor = t.borderColor.value(), n.borderStyle = t.borderStyle.value(), n.collapseBorders = t.collapseBorders.checked
                },
                _collectCellViewValues: function(e) {
                    var t = e.cellProperties = {},
                        n = this.components.cellView;
                    t.selectAllCells = n.selectAllCells.checked, t.width = n.width.value(), t.widthUnit = n.widthUnit.value(), t.height = n.height.value(), t.heightUnit = n.heightUnit.value(), t.cellMargin = n.cellMargin.value(), t.cellPadding = n.cellPadding.value(), t.alignment = n.alignment.value(), t.bgColor = n.bgColor.value(), t.className = n.className.value, t.id = n.id.value, t.borderWidth = n.borderWidth.value(), t.borderColor = n.borderColor.value(), t.borderStyle = n.borderStyle.value(), t.wrapText = n.wrapText.checked, t.width || (t.selectAllCells = !0, t.width = 100 / e.tableProperties.columns, t.widthUnit = "%")
                },
                _collectAccessibilityViewValues: function(e) {
                    var t = e.tableProperties,
                        n = this.components.accessibilityView;
                    t.captionContent = n.captionContent.value, t.captionAlignment = n.captionAlignment.value(), t.summary = n.summary.value, t.cellsWithHeaders = n.cellsWithHeaders.value(), t.headerRows = n.headerRows.value(), t.headerColumns = n.headerColumns.value()
                },
                _addUnit: function(t, n) {
                    n && e.inArray(n, t) == -1 && t.push(n)
                },
                _initTableViewComponents: function(e, t) {
                    var n, i, s = this,
                        l = s.components,
                        d = l.tableView = {},
                        c = t.tableProperties = t.tableProperties || {};
                    c.borderStyle = c.borderStyle || "", n = function(e) {
                        var t = s.components.accessibilityView,
                            n = t.headerColumns,
                            i = n.value(),
                            o = e.sender.value();
                        o < i && n.value(o), n.max(o)
                    }, i = function(e) {
                        var t = s.components.accessibilityView,
                            n = t.headerRows,
                            i = n.value(),
                            o = e.sender.value();
                        o < i && n.value(o), n.max(o)
                    }, s._addUnit(o, c.widthUnit), s._addUnit(o, c.heightUnit), s._initNumericTextbox(e.find("#k-editor-table-width"), "width", c, d), s._initNumericTextbox(e.find("#k-editor-table-height"), "height", c, d), s._initNumericTextbox(e.find("#k-editor-table-columns"), "columns", c, d, {
                        min: 1,
                        value: a,
                        change: n
                    }), s._initNumericTextbox(e.find("#k-editor-table-rows"), "rows", c, d, {
                        min: 1,
                        value: a,
                        change: i
                    }), s._initDropDownList(e.find("#k-editor-table-width-type"), "widthUnit", c, d, o), s._initDropDownList(e.find("#k-editor-table-height-type"), "heightUnit", c, d, o), s._initNumericTextbox(e.find("#k-editor-table-cell-spacing"), "cellSpacing", c, d), s._initNumericTextbox(e.find("#k-editor-table-cell-padding"), "cellPadding", c, d), s._initTableAlignmentDropDown(e.find("#k-editor-table-alignment"), c), s._initColorPicker(e.find("#k-editor-table-bg"), "bgColor", c, d), s._initInput(e.find("#k-editor-css-class"), "className", c, d), s._initInput(e.find("#k-editor-id"), "id", c, d), s._initNumericTextbox(e.find("#k-editor-border-width"), "borderWidth", c, d), s._initColorPicker(e.find("#k-editor-border-color"), "borderColor", c, d), s._initDropDownList(e.find("#k-editor-border-style"), "borderStyle", c, d, r), s._initCheckbox(e.find("#k-editor-collapse-borders"), "collapseBorders", c, d)
                },
                _initCellViewComponents: function(e, t) {
                    var n, i = this.components,
                        a = i.cellView = {};
                    t.selectedCells = t.selectedCells = t.selectedCells || [], n = t.selectedCells[0] || {
                            borderStyle: "",
                            wrapText: !0
                        }, this._addUnit(o, n.widthUnit), this._addUnit(o, n.heightUnit), this._initCheckbox(e.find("#k-editor-selectAllCells"), "selectAllCells", t.tableProperties, a), this._initNumericTextbox(e.find("#k-editor-cell-width"), "width", n, a), this._initNumericTextbox(e.find("#k-editor-cell-height"), "height", n, a), this._initDropDownList(e.find("#k-editor-cell-width-type"), "widthUnit", n, a, o), this._initDropDownList(e.find("#k-editor-cell-height-type"), "heightUnit", n, a, o), this._initNumericTextbox(e.find("#k-editor-table-cell-margin"), "cellMargin", n, a), this._initNumericTextbox(e.find("#k-editor-table-cells-padding"), "cellPadding", n, a), this._initCellAlignmentDropDown(e.find("#k-editor-cell-alignment"), n),
                        this._initColorPicker(e.find("#k-editor-cell-bg"), "bgColor", n, a), this._initInput(e.find("#k-editor-cell-css-class"), "className", n, a), this._initInput(e.find("#k-editor-cell-id"), "id", n, a), this._initNumericTextbox(e.find("#k-editor-cell-border-width"), "borderWidth", n, a), this._initColorPicker(e.find("#k-editor-cell-border-color"), "borderColor", n, a), this._initDropDownList(e.find("#k-editor-cell-border-style"), "borderStyle", n, a, r), this._initCheckbox(e.find("#k-editor-wrap-text"), "wrapText", n, a)
                },
                _initAccessibilityViewComponents: function(e, t) {
                    var n = this.components,
                        i = n.accessibilityView = {},
                        o = t.tableProperties;
                    this._initInput(e.find("#k-editor-table-caption"), "captionContent", o, i), this._initAccessibilityAlignmentDropDown(e.find("#k-editor-accessibility-alignment"), o), this._initInput(e.find("#k-editor-accessibility-summary"), "summary", o, i), this._initAssociationDropDown(e.find("#k-editor-cells-headers"), "cellsWithHeaders", {
                        valuePrimitive: !0
                    }, o, i), this._initNumericTextbox(e.find("#k-editor-table-header-rows"), "headerRows", o, i, {
                        max: o.rows || a
                    }), this._initNumericTextbox(e.find("#k-editor-table-header-columns"), "headerColumns", o, i, {
                        max: o.columns || a
                    })
                },
                _initNumericTextbox: function(t, n, o, r, a) {
                    var s = r[n] = t.kendoNumericTextBox(a ? e.extend({}, i, a) : i).data("kendoNumericTextBox");
                    n in o && s.value(parseInt(o[n], 10))
                },
                _initDropDownList: function(e, t, n, i, o) {
                    var r = i[t] = e.kendoDropDownList({
                        dataSource: o
                    }).data("kendoDropDownList");
                    this._setComponentValue(r, n, t)
                },
                _initTableAlignmentDropDown: function(e, t) {
                    var n = this.options.messages,
                        i = this.components.tableView,
                        o = s.dataSource;
                    o[0].tooltip = n.alignLeft, o[1].tooltip = n.alignCenter, o[2].tooltip = n.alignRight, o[3].tooltip = n.alignRemove, this._initAlignmentDropDown(e, s, "alignment", t, i)
                },
                _initCellAlignmentDropDown: function(e, t) {
                    var n = this.options.messages,
                        i = this.components.cellView,
                        o = l.dataSource;
                    o[0].tooltip = n.alignLeftTop, o[1].tooltip = n.alignCenterTop, o[2].tooltip = n.alignRightTop, o[3].tooltip = n.alignLeftMiddle, o[4].tooltip = n.alignCenterMiddle, o[5].tooltip = n.alignRightMiddle, o[6].tooltip = n.alignLeftBottom, o[7].tooltip = n.alignCenterBottom, o[8].tooltip = n.alignRightBottom, o[9].tooltip = n.alignRemove, this._initAlignmentDropDown(e, l, "alignment", t, i)
                },
                _initAccessibilityAlignmentDropDown: function(e, t) {
                    var n = this.options.messages,
                        i = this.components.accessibilityView,
                        o = d.dataSource;
                    o[0].tooltip = n.alignLeftTop, o[1].tooltip = n.alignCenterTop, o[2].tooltip = n.alignRightTop, o[3].tooltip = n.alignLeftBottom, o[4].tooltip = n.alignCenterBottom, o[5].tooltip = n.alignRightBottom, o[6].tooltip = n.alignRemove, this._initAlignmentDropDown(e, d, "captionAlignment", t, i)
                },
                _initAlignmentDropDown: function(e, t, n, i, o) {
                    var r = o[n] = e.kendoDropDownList(t).data("kendoDropDownList");
                    r.list.addClass("k-align").css("width", "110px"), this._setComponentValue(r, i, n)
                },
                _initAssociationDropDown: function(e, t, n, i, o) {
                    var r = o[t] = e.kendoDropDownList(n).data("kendoDropDownList");
                    this._setComponentValue(r, i, t)
                },
                _setComponentValue: function(e, t, n) {
                    n in t && e.value(t[n])
                },
                _initColorPicker: function(e, t, n, i) {
                    var o = i[t] = e.kendoColorPicker({
                        buttons: !1,
                        clearButton: !0
                    }).data("kendoColorPicker");
                    n[t] && o.value(n[t])
                },
                _initInput: function(e, t, n, i) {
                    var o = i[t] = e.get(0);
                    t in n && (o.value = n[t])
                },
                _initCheckbox: function(e, t, n, i) {
                    var o = i[t] = e.get(0);
                    t in n && (o.checked = n[t])
                },
                destroy: function() {
                    this._destroyComponents(this.components.tableView), this._destroyComponents(this.components.cellView), this._destroyComponents(this.components.accessibilityView), this._destroyComponents(this.components), delete this.components
                },
                _destroyComponents: function(e) {
                    for (var t in e) e[t].destroy && e[t].destroy(), delete e[t]
                },
                _dialogTemplate: function(e) {
                    return n.template(c)({
                        messages: e
                    })
                }
            });
        n.ui.editor.TableWizardDialog = u
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("kendo.editor.min", ["kendo.combobox.min", "kendo.dropdownlist.min", "kendo.resizable.min", "kendo.window.min", "kendo.colorpicker.min", "kendo.imagebrowser.min", "kendo.numerictextbox.min", "util/undoredostack.min", "editor/main.min", "editor/dom.min", "editor/serializer.min", "editor/range.min", "editor/command.min", "editor/components.min", "editor/toolbar.min", "editor/immutables.min", "editor/plugins/viewhtml.min", "editor/plugins/link.min", "editor/plugins/lists.min", "editor/plugins/formatting.min", "editor/plugins/image.min", "editor/plugins/import.min", "editor/plugins/insert.min", "editor/plugins/export.min", "editor/plugins/indent.min", "editor/plugins/linebreak.min", "editor/plugins/format.min", "editor/plugins/inlineformat.min", "editor/plugins/formatblock.min", "editor/plugins/file.min", "editor/plugins/tables.min", "editor/plugins/clipboard.min", "editor/plugins/keyboard.min", "editor/plugins/exportpdf.min", "editor/plugins/print.min", "editor/plugins/formatpainter.min", "editor/resizing/column-resizing.min", "editor/resizing/row-resizing.min", "editor/resizing/table-resizing.min", "editor/resizing/table-resize-handle.min", "editor/table-wizard/table-wizard-command.min", "editor/table-wizard/table-wizard-dialog.min"], e)
}(function() {
    return window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(t, define) {
    define("kendo.validator.min", ["kendo.core.min"], t)
}(function() {
    return function(t, e) {
        function a(e) {
            var a, r = s.ui.validator.ruleResolvers || {},
                n = {};
            for (a in r) t.extend(!0, n, r[a].resolve(e));
            return n
        }

        function r(t) {
            return t.replace(/&amp/g, "&amp;").replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&lt;/g, "<").replace(/&gt;/g, ">")
        }

        function n(t) {
            return t = (t + "").split("."), t.length > 1 ? t[1].length : 0
        }

        function i(e) {
            return t(t.parseHTML ? t.parseHTML(e) : e)
        }

        function u(e, a) {
            var r, n, i, u, l = t();
            for (i = 0, u = e.length; i < u; i++) r = e[i], c.test(r.className) && (n = r.getAttribute(s.attr("for")), n === a && (l = l.add(r)));
            return l
        }
        var l, s = window.kendo,
            o = s.ui.Widget,
            d = ".kendoValidator",
            F = "k-invalid-msg",
            c = RegExp(F, "i"),
            p = "k-invalid",
            f = "k-valid",
            h = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/i,
            m = /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i,
            v = ":input:not(:button,[type=submit],[type=reset],[disabled],[readonly])",
            g = ":checkbox:not([disabled],[readonly])",
            D = "[type=number],[type=range]",
            _ = "blur",
            y = "name",
            k = "form",
            E = "novalidate",
            A = "validate",
            C = "change",
            b = "validateInput",
            x = t.proxy,
            z = function(t, e) {
                return "string" == typeof e && (e = RegExp("^(?:" + e + ")$")), e.test(t)
            },
            w = function(t, e, a) {
                var r = t.val();
                return !t.filter(e).length || "" === r || z(r, a)
            },
            M = function(t, e) {
                return !!t.length && null != t[0].attributes[e]
            };
        s.ui.validator || (s.ui.validator = {
            rules: {},
            messages: {}
        }), l = o.extend({
            init: function(e, r) {
                var n = this,
                    i = a(e),
                    u = "[" + s.attr("validate") + "!=false]";
                r = r || {}, r.rules = t.extend({}, s.ui.validator.rules, i.rules, r.rules), r.messages = t.extend({}, s.ui.validator.messages, i.messages, r.messages), o.fn.init.call(n, e, r), n._errorTemplate = s.template(n.options.errorTemplate), n.element.is(k) && n.element.attr(E, E), n._inputSelector = v + u, n._checkboxSelector = g + u, n._errors = {}, n._attachEvents(), n._isValidated = !1
            },
            events: [A, C, b],
            options: {
                name: "Validator",
                errorTemplate: '<span class="k-widget k-tooltip k-tooltip-validation"><span class="k-icon k-i-warning"> </span> #=message#</span>',
                messages: {
                    required: "{0} is required",
                    pattern: "{0} is not valid",
                    min: "{0} should be greater than or equal to {1}",
                    max: "{0} should be smaller than or equal to {1}",
                    step: "{0} is not valid",
                    email: "{0} is not valid email",
                    url: "{0} is not valid URL",
                    date: "{0} is not valid date",
                    dateCompare: "End date should be greater than or equal to the start date"
                },
                rules: {
                    required: function(t) {
                        var e = t.filter("[type=checkbox]").length && !t.is(":checked"),
                            a = t.val();
                        return !(M(t, "required") && (!a || "" === a || 0 === a.length || e))
                    },
                    pattern: function(t) {
                        return !t.filter("[type=text],[type=email],[type=url],[type=tel],[type=search],[type=password]").filter("[pattern]").length || "" === t.val() || z(t.val(), t.attr("pattern"))
                    },
                    min: function(t) {
                        if (t.filter(D + ",[" + s.attr("type") + "=number]").filter("[min]").length && "" !== t.val()) {
                            var e = parseFloat(t.attr("min")) || 0,
                                a = s.parseFloat(t.val());
                            return e <= a
                        }
                        return !0
                    },
                    max: function(t) {
                        if (t.filter(D + ",[" + s.attr("type") + "=number]").filter("[max]").length && "" !== t.val()) {
                            var e = parseFloat(t.attr("max")) || 0,
                                a = s.parseFloat(t.val());
                            return e >= a
                        }
                        return !0
                    },
                    step: function(t) {
                        if (t.filter(D + ",[" + s.attr("type") + "=number]").filter("[step]").length && "" !== t.val()) {
                            var e, a = parseFloat(t.attr("min")) || 0,
                                r = parseFloat(t.attr("step")) || 1,
                                i = parseFloat(t.val()),
                                u = n(r);
                            return u ? (e = Math.pow(10, u), Math.floor((i - a) * e) % (r * e) / Math.pow(100, u) === 0) : (i - a) % r === 0
                        }
                        return !0
                    },
                    email: function(t) {
                        return w(t, "[type=email],[" + s.attr("type") + "=email]", h)
                    },
                    url: function(t) {
                        return w(t, "[type=url],[" + s.attr("type") + "=url]", m)
                    },
                    date: function(t) {
                        return !t.filter("[type^=date],[" + s.attr("type") + "=date]").length || "" === t.val() || null !== s.parseDate(t.val(), t.attr(s.attr("format")))
                    }
                },
                validateOnBlur: !0
            },
            destroy: function() {
                o.fn.destroy.call(this), this.element.off(d)
            },
            value: function() {
                return !!this._isValidated && 0 === this.errors().length
            },
            _submit: function(t) {
                return !!this.validate() || (t.stopPropagation(), t.stopImmediatePropagation(), t.preventDefault(), !1)
            },
            _checkElement: function(t) {
                var e = this.value();
                this.validateInput(t), this.value() !== e && this.trigger(C)
            },
            _attachEvents: function() {
                var e = this;
                e.element.is(k) && e.element.on("submit" + d, x(e._submit, e)), e.options.validateOnBlur && (e.element.is(v) ? (e.element.on(_ + d, function() {
                    e._checkElement(e.element)
                }), e.element.is(g) && e.element.on("click" + d, function() {
                    e._checkElement(e.element)
                })) : (e.element.on(_ + d, e._inputSelector, function() {
                    e._checkElement(t(this))
                }), e.element.on("click" + d, e._checkboxSelector, function() {
                    e._checkElement(t(this))
                })))
            },
            validate: function() {
                var t, e, a, r, n = !1,
                    i = this.value();
                if (this._errors = {}, this.element.is(v)) n = this.validateInput(this.element);
                else {
                    for (r = !1, t = this.element.find(this._inputSelector), e = 0, a = t.length; e < a; e++) this.validateInput(t.eq(e)) || (r = !0);
                    n = !r
                }
                return this.trigger(A, {
                    valid: n
                }), i !== n && this.trigger(C), n
            },
            validateInput: function(e) {
                var a, n, u, l, o, d, c, h, m, v, g, D;
                return e = t(e), this._isValidated = !0, a = this, n = a._errorTemplate, u = a._checkValidity(e), l = u.valid, o = "." + F, d = e.attr(y) || "", c = a._findMessageContainer(d).add(e.next(o).filter(function() {
                    var e = t(this);
                    return !e.filter("[" + s.attr("for") + "]").length || e.attr(s.attr("for")) === d
                })).hide(), m = !e.attr("aria-invalid"), e.removeAttr("aria-invalid"), l ? delete a._errors[d] : (h = a._extractMessage(e, u.key), a._errors[d] = h, v = i(n({
                    message: r(h)
                })), g = c.attr("id"), a._decorateMessageContainer(v, d), g && v.attr("id", g), c.replaceWith(v).length || v.insertAfter(e), v.show(), e.attr("aria-invalid", !0)), m !== l && this.trigger(b, {
                    valid: l,
                    input: e
                }), e.toggleClass(p, !l), e.toggleClass(f, l), s.widgetInstance(e) && (D = s.widgetInstance(e)._inputWrapper, D && (D.toggleClass(p, !l), D.toggleClass(p, !l))), l
            },
            hideMessages: function() {
                var t = this,
                    e = "." + F,
                    a = t.element;
                a.is(v) ? a.next(e).hide() : a.find(e).hide()
            },
            _findMessageContainer: function(e) {
                var a, r, n, i = s.ui.validator.messageLocators,
                    l = t();
                for (r = 0, n = this.element.length; r < n; r++) l = l.add(u(this.element[r].getElementsByTagName("*"), e));
                for (a in i) l = l.add(i[a].locate(this.element, e));
                return l
            },
            _decorateMessageContainer: function(t, e) {
                var a, r = s.ui.validator.messageLocators;
                t.addClass(F).attr(s.attr("for"), e || "");
                for (a in r) r[a].decorate(t, e);
                t.attr("role", "alert")
            },
            _extractMessage: function(t, e) {
                var a, r = this,
                    n = r.options.messages[e],
                    i = t.attr(y);
                return s.ui.Validator.prototype.options.messages[e] || (a = s.isFunction(n) ? n(t) : n), n = s.isFunction(n) ? n(t) : n, s.format(t.attr(s.attr(e + "-msg")) || t.attr("validationMessage") || a || t.attr("title") || n || "", i, t.attr(e) || t.attr(s.attr(e)))
            },
            _checkValidity: function(t) {
                var e, a = this.options.rules;
                for (e in a)
                    if (!a[e].call(this, t)) return {
                        valid: !1,
                        key: e
                    };
                return {
                    valid: !0
                }
            },
            errors: function() {
                var t, e = [],
                    a = this._errors;
                for (t in a) e.push(a[t]);
                return e
            }
        }), s.ui.plugin(l)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, a) {
    (a || e)()
});;
! function(e, define) {
    define("kendo.editable.min", ["kendo.datepicker.min", "kendo.numerictextbox.min", "kendo.validator.min", "kendo.binder.min"], e)
}(function() {
    return function(e, t) {
        function n(t) {
            return t = null != t ? t : "", t.type || e.type(t) || "string"
        }

        function a(t) {
            t.find(":input:not(:button, .k-combobox .k-input, [" + d.attr("role") + "=listbox], [" + d.attr("role") + "=upload], [" + d.attr("skip") + "], [type=file])").each(function() {
                var t = d.attr("bind"),
                    n = this.getAttribute(t) || "",
                    a = "checkbox" === this.type || "radio" === this.type ? "checked:" : "value:",
                    i = this.name;
                n.indexOf(a) === -1 && i && (n += (n.length ? "," : "") + a + i, e(this).attr(t, n))
            })
        }

        function i(e) {
            var t, a, i, o, r, l = (e.model.fields || e.model)[e.field],
                s = n(l),
                u = l ? l.validation : {},
                p = d.attr("type"),
                f = d.attr("bind"),
                g = {
                    name: e.field,
                    title: e.title ? e.title : e.field
                };
            for (t in u) a = u[t], m(t, _) >= 0 ? g[p] = t : v(a) || (i = d.getCulture(), "number" == typeof a && i.name.length ? (o = i.numberFormat, r = ("" + a).replace(b, o[b]), g[t] = r) : g[t] = c(a) ? a.value || t : a), g[d.attr(t + "-msg")] = a.message, g.autocomplete = y;
            return m(s, _) >= 0 && (g[p] = s), g[f] = ("boolean" === s ? "checked:" : "value:") + e.field, g
        }

        function o(e, t) {
            var n = e.attr("id");
            return n && (t.id = n, e.removeAttr("id")), t
        }

        function r(e) {
            var t, n, a, i, o, r;
            if (e && e.length)
                for (r = [], t = 0, n = e.length; t < n; t++) a = e[t], o = a.text || a.value || a, i = null == a.value ? a.text || a : a.value, r[t] = {
                    text: o,
                    value: i
                };
            return r
        }

        function l(e, t) {
            var n, a, i = e ? e.validation || {} : {};
            for (n in i) a = i[n], c(a) && a.value && (a = a.value), v(a) && (t[n] = a)
        }
        var d = window.kendo,
            s = d.ui,
            u = s.Widget,
            p = e.extend,
            f = d.support.browser.msie && d.support.browser.version < 9,
            v = d.isFunction,
            c = e.isPlainObject,
            m = e.inArray,
            b = ".",
            g = d.support,
            y = g.browser.chrome ? "disabled" : "off",
            k = /("|\%|'|\[|\]|\$|\.|\,|\:|\;|\+|\*|\&|\!|\#|\(|\)|<|>|\=|\?|\@|\^|\{|\}|\~|\/|\||`)/g,
            h = '<div class="k-widget k-tooltip k-tooltip-validation" style="margin:0.5em"><span class="k-icon k-i-warning"> </span>#=message#<div class="k-callout k-callout-n"></div></div>',
            x = "change",
            T = "equalSet",
            _ = ["url", "email", "number", "date", "boolean"],
            w = {
                number: function(t, n) {
                    var a = i(n);
                    e('<input type="text"/>').attr(a).appendTo(t).kendoNumericTextBox({
                        format: n.format
                    }), e("<span " + d.attr("for") + '="' + n.field + '" class="k-invalid-msg"/>').hide().appendTo(t)
                },
                date: function(t, n) {
                    var a = i(n),
                        o = n.format;
                    o && (o = d._extractFormat(o)), a[d.attr("format")] = o, e('<input type="text"/>').attr(a).appendTo(t).kendoDatePicker({
                        format: n.format
                    }), e("<span " + d.attr("for") + '="' + n.field + '" class="k-invalid-msg"/>').hide().appendTo(t)
                },
                string: function(t, n) {
                    var a = i(n);
                    e('<input type="text" class="k-textbox"/>').attr(a).appendTo(t)
                },
                "boolean": function(t, n) {
                    var a = i(n);
                    e('<input type="checkbox" />').attr(a).appendTo(t)
                },
                values: function(t, n) {
                    var a = i(n),
                        o = d.stringify(r(n.values));
                    e("<select " + d.attr("text-field") + '="text"' + d.attr("value-field") + '="value"' + d.attr("source") + "='" + (o ? o.replace(/\'/g, "&apos;") : o) + "'" + d.attr("role") + '="dropdownlist"/>').attr(a).appendTo(t), e("<span " + d.attr("for") + '="' + n.field + '" class="k-invalid-msg"/>').hide().appendTo(t)
                }
            },
            P = {
                number: function(t, n) {
                    var a = i(n);
                    a = o(t, a), e('<input type="number"/>').attr(a).appendTo(t)
                },
                date: function(t, n) {
                    var a = i(n);
                    a = o(t, a), e('<input type="date"/>').attr(a).appendTo(t)
                },
                string: function(t, n) {
                    var a = i(n);
                    a = o(t, a), e('<input type="text" />').attr(a).appendTo(t)
                },
                "boolean": function(t, n) {
                    var a = i(n);
                    a = o(t, a), e('<input type="checkbox" />').attr(a).appendTo(t)
                },
                values: function(t, n) {
                    var a, r = i(n),
                        l = n.values,
                        d = e("<select />");
                    r = o(t, r);
                    for (a in l) e('<option value="' + l[a].value + '">' + l[a].text + "</option>").appendTo(d);
                    d.attr(r).appendTo(t)
                }
            },
            E = u.extend({
                init: function(t, n) {
                    var a = this;
                    n.target && (n.$angular = n.target.options.$angular, n.target.pane && (a._isMobile = !0)), u.fn.init.call(a, t, n), a._validateProxy = e.proxy(a._validate, a), a.refresh()
                },
                events: [x],
                options: {
                    name: "Editable",
                    editors: w,
                    mobileEditors: P,
                    clearContainer: !0,
                    errorTemplate: h,
                    skipFocus: !1
                },
                editor: function(e, t) {
                    var a = this,
                        i = a._isMobile ? P : a.options.editors,
                        o = c(e),
                        r = o ? e.field : e,
                        l = a.options.model || {},
                        s = o && e.values,
                        u = s ? "values" : n(t),
                        f = o && e.editor,
                        v = f ? e.editor : i[u],
                        m = a.element.find("[" + d.attr("container-for") + "=" + r.replace(k, "\\$1") + "]");
                    v = v ? v : i.string, f && "string" == typeof e.editor && (v = function(t) {
                        t.append(e.editor)
                    }), m = m.length ? m : a.element, v(m, p(!0, {}, o ? e : {
                        field: r
                    }, {
                        model: l
                    }))
                },
                _validate: function(t) {
                    var n, a = this,
                        i = t.value,
                        o = a._validationEventInProgress,
                        r = {},
                        l = d.attr("bind"),
                        s = t.field.replace(k, "\\$1"),
                        u = RegExp("(value|checked)\\s*:\\s*" + s + "\\s*(,|$)");
                    r[t.field] = t.value, n = e(":input[" + l + '*="' + s + '"]', a.element).filter("[" + d.attr("validate") + "!='false']").filter(function() {
                        return u.test(e(this).attr(l))
                    }), n.length > 1 && (n = n.filter(function() {
                        var t = e(this);
                        return !t.is(":radio") || t.val() == i
                    }));
                    try {
                        a._validationEventInProgress = !0, (!a.validatable.validateInput(n) || !o && a.trigger(x, {
                            values: r
                        })) && t.preventDefault()
                    } finally {
                        a._validationEventInProgress = !1
                    }
                },
                end: function() {
                    return this.validatable.validate()
                },
                destroy: function() {
                    var e = this;
                    e.angular("cleanup", function() {
                        return {
                            elements: e.element
                        }
                    }), u.fn.destroy.call(e), e.options.model.unbind("set", e._validateProxy), e.options.model.unbind(T, e._validateProxy), d.unbind(e.element), e.validatable && e.validatable.destroy(), d.destroy(e.element), e.element.removeData("kendoValidator"), e.element.is("[" + d.attr("role") + "=editable]") && e.element.removeAttr(d.attr("role"))
                },
                refresh: function() {
                    var n, i, o, r, s, u, p, v, m = this,
                        b = m.options.fields || [],
                        g = m.options.clearContainer ? m.element.empty() : m.element,
                        y = m.options.model || {},
                        k = {};
                    for (e.isArray(b) || (b = [b]), n = 0, i = b.length; n < i; n++) o = b[n], r = c(o), s = r ? o.field : o, u = (y.fields || y)[s], l(u, k), m.editor(o, u);
                    if (m.options.target && m.angular("compile", function() {
                            return {
                                elements: g,
                                data: g.map(function() {
                                    return {
                                        dataItem: y
                                    }
                                })
                            }
                        }), !i) {
                        p = y.fields || y;
                        for (s in p) l(p[s], k)
                    }
                    a(g), m.validatable && m.validatable.destroy(), d.bind(g, m.options.model), m.options.model.unbind("set", m._validateProxy), m.options.model.bind("set", m._validateProxy), m.options.model.unbind(T, m._validateProxy), m.options.model.bind(T, m._validateProxy), m.validatable = new d.ui.Validator(g, {
                        validateOnBlur: !1,
                        errorTemplate: m.options.errorTemplate || t,
                        rules: k
                    }), m.options.skipFocus || (v = g.find(":kendoFocusable").eq(0).focus(), f && v.focus())
                }
            });
        s.plugin(E)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(e, define) {
    define("kendo.filtermenu.min", ["kendo.datepicker.min", "kendo.numerictextbox.min", "kendo.dropdownlist.min", "kendo.binder.min"], e)
}(function() {
    return function(e, t) {
        function l(t, s) {
            t.filters && (t.filters = e.grep(t.filters, function(e) {
                return l(e, s), e.filters ? e.filters.length : e.field != s
            }))
        }

        function s(e) {
            var t, l, s, i, a, r;
            if (e && e.length)
                for (r = [], t = 0, l = e.length; t < l; t++) s = e[t], a = "" !== s.text ? s.text || s.value || s : s.text, i = null == s.value ? s.text || s : s.value, r[t] = {
                    text: a,
                    value: i
                };
            return r
        }

        function i(t, l) {
            return e.grep(t, function(t) {
                return t.filters ? (t.filters = e.grep(t.filters, function(e) {
                    return e.field != l
                }), t.filters.length) : t.field != l
            })
        }

        function a(t, l) {
            t.filters && (t.filters = e.grep(t.filters, function(e) {
                return a(e, l), e.filters ? e.filters.length : e.field == l && "eq" == e.operator
            }))
        }

        function r(l) {
            return "and" == l.logic && l.filters.length > 1 ? [] : l.filters ? e.map(l.filters, function(e) {
                return r(e)
            }) : l.value !== t ? [l.value] : []
        }

        function n(e, l) {
            for (var s, i, a = c.getter(l, !0), r = [], n = 0, o = {}; n < e.length;) s = e[n++], i = a(s), i === t || o.hasOwnProperty(i) || (r.push(s), o[i] = !0);
            return r
        }

        function o(e, t) {
            return function(l) {
                var s = e(l);
                return n(s, t)
            }
        }
        var c = window.kendo,
            u = c.ui,
            p = e.proxy,
            d = c.support,
            f = d.browser.chrome ? "disabled" : "off",
            h = "kendoPopup",
            m = "init",
            k = "open",
            g = "refresh",
            v = "change",
            b = ".kendoFilterMenu",
            _ = "Is equal to",
            y = "Is not equal to",
            x = {
                number: "numerictextbox",
                date: "datepicker"
            },
            w = {
                string: "text",
                number: "number",
                date: "date"
            },
            S = c.isFunction,
            F = u.Widget,
            C = '<div class="k-filter-menu-container"><div class="k-filter-help-text">#=messages.info#</div><label><input type="radio" data-#=ns#bind="checked: filters[0].value" value="true" name="filters[0].value"/>#=messages.isTrue#</label><label><input type="radio" data-#=ns#bind="checked: filters[0].value" value="false" name="filters[0].value"/>#=messages.isFalse#</label><div class="k-action-buttons"><button type="submit" title="#=messages.filter#" class="k-button k-primary">#=messages.filter#</button><button type="reset" title="#=messages.clear#" class="k-button">#=messages.clear#</button></div></div>',
            A = '<div class="k-filter-menu-container"><div class="k-filter-help-text">#=messages.info#</div><label><input class="k-textbox" data-#=ns#bind="value: filters[0].value" name="filters[0].value"/></label><div class="k-action-buttons"><button type="submit" title="#=messages.filter#" class="k-button k-primary">#=messages.filter#</button><button type="reset" title="#=messages.clear#" class="k-button">#=messages.clear#</button></div></div>',
            T = '<div class="k-filter-menu-container"><div class="k-filter-help-text">#=messages.info#</div><select title="#=messages.operator#" data-#=ns#bind="value: filters[0].operator" data-#=ns#role="dropdownlist">#for(var op in operators){#<option value="#=op#">#=operators[op]#</option>#}#</select>#if(values){#<select title="#=messages.value#" data-#=ns#bind="value:filters[0].value" data-#=ns#text-field="text" data-#=ns#value-field="value" data-#=ns#source=\'#=kendo.stringify(values).replace(/\'/g,"&\\#39;")#\' data-#=ns#role="dropdownlist" data-#=ns#option-label="#=messages.selectValue#" data-#=ns#value-primitive="true"></select>#}else{#<input title="#=messages.value#" data-#=ns#bind="value:filters[0].value" class="k-textbox" type="text" #=role ? "data-" + ns + "role=\'" + role + "\'" : ""# />#}##if(extra){#<select title="#=messages.logic#" class="k-filter-and" data-#=ns#bind="value: logic" data-#=ns#role="dropdownlist"><option value="and">#=messages.and#</option><option value="or">#=messages.or#</option></select><select title="#=messages.additionalOperator#" data-#=ns#bind="value: filters[1].operator" data-#=ns#role="dropdownlist">#for(var op in operators){#<option value="#=op#">#=operators[op]#</option>#}#</select>#if(values){#<select title="#=messages.additionalValue#" data-#=ns#bind="value:filters[1].value" data-#=ns#text-field="text" data-#=ns#value-field="value" data-#=ns#source=\'#=kendo.stringify(values).replace(/\'/g,"&\\#39;")#\' data-#=ns#role="dropdownlist" data-#=ns#option-label="#=messages.selectValue#" data-#=ns#value-primitive="true"></select>#}else{#<input title="#=messages.additionalValue#" data-#=ns#bind="value: filters[1].value" class="k-textbox" type="text" #=role ? "data-" + ns + "role=\'" + role + "\'" : ""#/>#}##}#<div class="k-action-buttons"><button type="submit" title="#=messages.filter#" class="k-button k-primary">#=messages.filter#</button><button type="reset" title="#=messages.clear#" class="k-button">#=messages.clear#</button></div></div>',
            M = '<div data-#=ns#role="view" class="k-grid-filter-menu"><div data-#=ns#role="header" class="k-header"><a href="\\#" class="k-header-cancel k-link" title="#=messages.cancel#" aria-label="#=messages.cancel#"><span class="k-icon k-i-arrow-chevron-left"></span></a>#=messages.filter# #=messages.into# #=title#<a href="\\#" class="k-header-done k-link" title="#=messages.done#" aria-label="#=messages.done#"><span class="k-icon k-i-check"></span></a></div><form title="#=messages.title#" class="k-filter-menu"><ul class="k-reset"><li><span class="k-list-title k-filter-help-text">#=messages.info#</span><ul class="k-listgroup k-listgroup-flush"><li class="k-item k-listgroup-item"><label class="k-listgroup-form-row k-label"><span class="k-listgroup-form-field-label k-filter-operator-text">#=messages.operator#</span><span class="k-listgroup-form-field-wrapper"><select id="operator_#=filterMenuGuid#" title="#=messages.operator#" class="k-filter-operator" data-#=ns#bind="value: filters[0].operator" autocomplete="' + f + '" >#for(var op in operators){#<option value="#=op#">#=operators[op]#</option>#}#</select></span></label></li><li class="k-item k-listgroup-item"><label class="k-listgroup-form-row k-label"><span class="k-listgroup-form-field-label k-filter-input-text">#=messages.value#</span><span class="k-listgroup-form-field-wrapper">#if(values){#<select id="value_#=filterMenuGuid#" title="#=messages.value#" data-#=ns#bind="value:filters[0].value" autocomplete="' + f + '" ><option value="">#=messages.selectValue#</option>#for(var val in values){#<option value="#=values[val].value#">#=values[val].text#</option>#}#</select>#}else{#<input id="value_#=filterMenuGuid#" title="#=messages.value#" data-#=ns#bind="value:filters[0].value" class="k-value-input" type="#=inputType#" autocomplete="' + f + '" />#}#</span></label></li></ul>#if(extra){#<ul class="k-listgroup k-listgroup-flush"><li class="k-item k-listgroup-item"><label class="k-listgroup-form-row k-label"><span class="k-listgroup-form-field-label k-filter-logic-and-text">#=messages.and#</span><span class="k-listgroup-form-field-wrapper"><input id="and_#=filterMenuGuid#" title="#=messages.and#" type="radio" name="logic"data-#=ns#bind="checked: logic" value="and" autocomplete="' + f + '" /></span></label></li><li class="k-item k-listgroup-item"><label class="k-listgroup-form-row k-label"><span class="k-listgroup-form-field-label k-filter-logic-or-text">#=messages.or#</span><span class="k-listgroup-form-field-wrapper"><input id="or_#=filterMenuGuid#" title="#=messages.or#" type="radio" name="logic" data-#=ns#bind="checked: logic" value="or" autocomplete="' + f + '" /></span></label></li></ul><ul class="k-listgroup k-listgroup-flush"><li class="k-item k-listgroup-item"><label class="k-listgroup-form-row k-label"><span class="k-listgroup-form-field-label k-filter-operator-text">#=messages.additionalOperator#</span><span class="k-listgroup-form-field-wrapper"><select id="additionalOperator_#=filterMenuGuid#" title="#=messages.additionalOperator#" class="k-filter-operator" data-#=ns#bind="value: filters[1].operator" autocomplete="' + f + '" >#for(var op in operators){#<option value="#=op#">#=operators[op]#</option>#}#</select></span></label></li><li class="k-item k-listgroup-item"><label class="k-listgroup-form-row k-label"><span class="k-listgroup-form-field-label k-filter-input-text">#=messages.additionalValue#</span><span class="k-listgroup-form-field-wrapper">#if(values){#<select id="additionalValue_#=filterMenuGuid#" title="#=messages.additionalValue#" data-#=ns#bind="value:filters[1].value" autocomplete="' + f + '" ><option value="">#=messages.selectValue#</option>#for(var val in values){#<option value="#=values[val].value#">#=values[val].text#</option>#}#</select>#}else{#<input id="additionalValue_#=filterMenuGuid#" title="#=messages.additionalValue#" data-#=ns#bind="value:filters[1].value" class="k-value-input" type="#=inputType#" autocomplete="' + f + '" />#}#</span></label></li></ul>#}#</li><li class="k-item k-clear-wrap"><span class="k-list-title">&nbsp;</span><ul class="k-listgroup k-listgroup-flush"><li class="k-listgroup-item"><span class="k-link k-label k-clear" title="#=messages.clear#" aria-label="#=messages.clear#">#=messages.clear#</span></li></ul></li></ul></form></div>',
            H = '<div data-#=ns#role="view" class="k-grid-filter-menu"><div data-#=ns#role="header" class="k-header"><a href="\\#" class="k-header-cancel k-link" title="#=messages.cancel#" aria-label="#=messages.cancel#"><span class="k-icon k-i-arrow-chevron-left"></span></a>#=messages.filter# #=messages.into# #=title#<a href="\\#" class="k-header-done k-link" title="#=messages.done#" aria-label="#=messages.done#"><span class="k-icon k-i-check"></span></a></div><form title="#=messages.title#" class="k-filter-menu"><ul class="k-reset"><li><span class="k-list-title k-filter-help-text">#=messages.info#</span><ul class="k-listgroup k-listgroup-flush k-multicheck-bool-wrap"><li class="k-item k-listgroup-item"><label class="k-listgroup-form-row k-label"><span class="k-listgroup-form-field-label k-item-title">#=messages.isTrue#</span><span class="k-listgroup-form-field-wrapper"></span><input id="true_#=filterMenuGuid#" title="#=messages.isTrue#" type="radio" data-#=ns#bind="checked: filters[0].value" value="true" name="filters[0].value" autocomplete="' + f + '" /></span></label></li><li class="k-item k-listgroup-item"><label class="k-listgroup-form-row k-label"><span for="false_#=filterMenuGuid#" class="k-listgroup-form-field-label k-item-title">#=messages.isFalse#</span><span class="k-listgroup-form-field-wrapper"><input id="false_#=filterMenuGuid#" title="#=messages.isFalse#" type="radio" data-#=ns#bind="checked: filters[0].value" value="false" name="filters[0].value" autocomplete="' + f + '" /></span></label></li></ul></li><li class="k-item k-clear-wrap"><span class="k-list-title">&nbsp;</span><ul class="k-listgroup k-listgroup-flush"><li class="k-listgroup-item"><span class="k-link k-label k-clear" title="#=messages.clear#" aria-label="#=messages.clear#">#=messages.clear#</span></li></ul></li></ul></form></div>',
            I = F.extend({
                init: function(t, l) {
                    var s, i, a, r, n = this,
                        o = "string";
                    F.fn.init.call(n, t, l), s = n.operators = l.operators || {}, t = n.element, l = n.options, l.appendToElement || (a = t.addClass("k-with-icon k-filterable").find(".k-grid-filter"), a[0] || (a = t.prepend('<a class="k-grid-filter" href="#" title="' + l.messages.filter + '" aria-label="' + l.messages.filter + '"><span class="k-icon k-i-filter"></span></a>').find(".k-grid-filter")), a.attr("tabindex", -1).on("click" + b, p(n._click, n))), n.link = a || e(), n.dataSource = V.create(l.dataSource), n.field = l.field || t.attr(c.attr("field")), n.model = n.dataSource.reader.model, n._parse = function(e) {
                        return null != e ? e + "" : e
                    }, n.model && n.model.fields && (r = n.model.fields[n.field], r && (o = r.type || "string", r.parse && (n._parse = p(r.parse, r)))), l.values && (o = "enums"), n.type = o, s = s[o] || l.operators[o];
                    for (i in s) break;
                    n._defaultFilter = function() {
                        return {
                            field: n.field,
                            operator: i || "eq",
                            value: ""
                        }
                    }, n._refreshHandler = p(n.refresh, n), n.dataSource.bind(v, n._refreshHandler), l.appendToElement ? n._init() : n.refresh()
                },
                _init: function() {
                    var t, l = this,
                        s = l.options.ui,
                        i = S(s);
                    l.pane = l.options.pane, l.pane && (l._isMobile = !0), i || (t = s || x[l.type]), l._isMobile ? l._createMobileForm(t) : l._createForm(t), l.form.on("submit" + b, p(l._submit, l)).on("reset" + b, p(l._reset, l)), i && l.form.find(".k-textbox").removeClass("k-textbox").each(function() {
                        s(e(this))
                    }), l.form.find("[" + c.attr("role") + "=numerictextbox]").removeClass("k-textbox").end().find("[" + c.attr("role") + "=datetimepicker]").removeClass("k-textbox").end().find("[" + c.attr("role") + "=timepicker]").removeClass("k-textbox").end().find("[" + c.attr("role") + "=datepicker]").removeClass("k-textbox"), l.refresh(), l.trigger(m, {
                        field: l.field,
                        container: l.form
                    }), c.cycleForm(l.form)
                },
                _createForm: function(t) {
                    var l = this,
                        i = l.options,
                        a = l.operators || {},
                        r = l.type,
                        n = S(l.options.ui);
                    a = a[r] || i.operators[r], l.form = e('<form title="' + l.options.messages.title + '" class="k-filter-menu"/>').html(c.template("boolean" === r ? n ? A : C : T)({
                        field: l.field,
                        format: i.format,
                        ns: c.ns,
                        messages: i.messages,
                        extra: i.extra,
                        operators: a,
                        type: r,
                        role: t,
                        values: s(i.values)
                    })), i.appendToElement ? (l.element.append(l.form), l.popup = l.element.closest(".k-popup").data(h)) : l.popup = l.form[h]({
                        anchor: l.link,
                        open: p(l._open, l),
                        activate: p(l._activate, l),
                        close: function() {
                            l.options.closeCallback && l.options.closeCallback(l.element)
                        }
                    }).data(h), l.form.on("keydown" + b, p(l._keydown, l))
                },
                _createMobileForm: function(t) {
                    var l = this,
                        i = l.options,
                        a = l.operators || {},
                        r = c.guid(),
                        n = l.type;
                    a = a[n] || i.operators[n], l.form = e("<div />").html(c.template("boolean" === n ? H : M)({
                        field: l.field,
                        title: i.title || l.field,
                        format: i.format,
                        ns: c.ns,
                        messages: i.messages,
                        extra: i.extra,
                        operators: a,
                        filterMenuGuid: r,
                        type: n,
                        role: t,
                        inputType: w[n],
                        values: s(i.values)
                    })), l.view = l.pane.append(l.form.html()), l.form = l.view.element.find("form"), l.view.element.on("click", ".k-header-done", function(e) {
                        l.form.submit(), e.preventDefault()
                    }).on("click", ".k-header-cancel", function(e) {
                        l._closeForm(), e.preventDefault()
                    }).on("click", ".k-clear", function(e) {
                        l._mobileClear(), e.preventDefault()
                    }), l.view.bind("showStart", function() {
                        l.refresh()
                    })
                },
                refresh: function() {
                    var e = this,
                        t = e.dataSource.filter() || {
                            filters: [],
                            logic: "and"
                        },
                        l = [e._defaultFilter()],
                        s = e._defaultFilter().operator;
                    (e.options.extra || "isnull" !== s && "isnullorempty" !== s && "isnotnullorempty" !== s && "isnotnull" !== s && "isempty" !== s && "isnotempty" !== s) && l.push(e._defaultFilter()), e.filterModel = c.observable({
                        logic: "and",
                        filters: l
                    }), e.form && c.bind(e.form.children().first(), e.filterModel), e._bind(t) ? e.link.addClass("k-state-active") : e.link.removeClass("k-state-active")
                },
                destroy: function() {
                    var e = this;
                    F.fn.destroy.call(e), e.form && (c.unbind(e.form), c.destroy(e.form), e.form.unbind(b), e.popup && (e.popup.destroy(), e.popup = null), e.form = null), e.view && (e.view.purge(), e.view = null), e.link.unbind(b), e._refreshHandler && (e.dataSource.unbind(v, e._refreshHandler), e.dataSource = null), e.element = e.link = e._refreshHandler = e.filterModel = null
                },
                _bind: function(e) {
                    var t, l, s, i, a = this,
                        r = e.filters,
                        n = !1,
                        o = 0,
                        c = a.filterModel;
                    for (t = 0, l = r.length; t < l; t++) i = r[t], i.field == a.field ? (c.set("logic", e.logic), s = c.filters[o], s || (c.filters.push({
                        field: a.field
                    }), s = c.filters[o]), s.set("value", a._parse(i.value)), s.set("operator", i.operator), o++, n = !0) : i.filters && (n = n || a._bind(i));
                    return n
                },
                _stripFilters: function(t) {
                    return e.grep(t, function(e) {
                        return "" !== e.value && null != e.value || "isnull" === e.operator || "isnotnull" === e.operator || "isempty" === e.operator || "isnotempty" === e.operator || "isnullorempty" == e.operator || "isnotnullorempty" == e.operator
                    })
                },
                _merge: function(e) {
                    var t, s, i, a = this,
                        r = e.logic || "and",
                        n = this._stripFilters(e.filters),
                        o = a.dataSource.filter() || {
                            filters: [],
                            logic: "and"
                        };
                    for (l(o, a.field), s = 0, i = n.length; s < i; s++) t = n[s], t.value = a._parse(t.value);
                    return n.length && (o.filters.length ? (e.filters = n, "and" !== o.logic && (o.filters = [{
                        logic: o.logic,
                        filters: o.filters
                    }], o.logic = "and"), o.filters.push(n.length > 1 ? e : n[0])) : (o.filters = n, o.logic = r)), o
                },
                filter: function(e) {
                    var t = this._stripFilters(e.filters);
                    t.length && this.trigger("change", {
                        filter: {
                            logic: e.logic,
                            filters: t
                        },
                        field: this.field
                    }) || (e = this._merge(e), e.filters.length && this.dataSource.filter(e))
                },
                clear: function() {
                    var e = this,
                        t = e.dataSource.filter() || {
                            filters: []
                        };
                    this.trigger("change", {
                        filter: null,
                        field: e.field
                    }) || e._removeFilter(t)
                },
                _mobileClear: function() {
                    var t, l, s, i, a, r = this,
                        n = r.view.element;
                    "boolean" === r.type ? (t = n.find("[type='radio']:checked"), l = t.val(), t.val(""), t.trigger("change"), t.val(l), t.prop("checked", !1)) : (s = n.find("select"), s.each(function(t, l) {
                        var s = e(l);
                        s.val(s.find("option:first").val()), s.trigger("change")
                    }), "string" !== r.type && "date" !== r.type && "number" !== r.type || (i = n.find(".k-value-input"), i.each(function(t, l) {
                        var s = e(l);
                        s.val(""), s.trigger("change")
                    })), r.options.extra && (a = n.find("[name=logic]").first(), a.prop("checked", !0), a.trigger("change")))
                },
                _removeFilter: function(t) {
                    var l = this;
                    t.filters = e.grep(t.filters, function(e) {
                        return e.filters ? (e.filters = i(e.filters, l.field), e.filters.length) : e.field != l.field
                    }), t.filters.length || (t = null), l.dataSource.filter(t)
                },
                _submit: function(t) {
                    var l, s, i;
                    t.preventDefault(), t.stopPropagation(), l = this.filterModel.toJSON(), s = e.grep(l.filters, function(e) {
                        return "" !== e.value && null !== e.value
                    }), this._checkForNullOrEmptyFilter(l) || s && s.length ? this.filter(l) : (i = this.dataSource.filter(), i && (i.filters.push(l), l = i), this._removeFilter(l)), this._closeForm()
                },
                _checkForNullOrEmptyFilter: function(e) {
                    var t, l, s;
                    return !!(e && e.filters && e.filters.length) && (t = !1, l = !1, e.filters[0] && (s = e.filters[0].operator, t = "isnull" == s || "isnotnull" == s || "isnotempty" == s || "isempty" == s || "isnullorempty" == s || "isnotnullorempty" == s), e.filters[1] && (s = e.filters[1].operator, l = "isnull" == s || "isnotnull" == s || "isnotempty" == s || "isempty" == s || "isnullorempty" == s || "isnotnullorempty" == s), !this.options.extra && t || this.options.extra && (t || l))
                },
                _reset: function() {
                    this.clear(), this.options.search && this.container && this.container.find("label").parent().show(), this._closeForm()
                },
                _closeForm: function() {
                    this._isMobile ? this.pane.navigate("", this.options.animations.right) : this.popup.close()
                },
                _click: function(e) {
                    e.preventDefault(), e.stopPropagation(), this.popup || this.pane || this._init(), this._isMobile ? this.pane.navigate(this.view, this.options.animations.left) : this.popup.toggle()
                },
                _open: function() {
                    var t;
                    e(".k-filter-menu").not(this.form).each(function() {
                        t = e(this).data(h), t && t.close()
                    })
                },
                _activate: function() {
                    this.form.find(":kendoFocusable:first").focus(), this.trigger(k, {
                        field: this.field,
                        container: this.form
                    })
                },
                _keydown: function(e) {
                    e.keyCode == c.keys.ESC && this.popup.close()
                },
                events: [m, "change", k],
                options: {
                    name: "FilterMenu",
                    extra: !0,
                    appendToElement: !1,
                    type: "string",
                    operators: {
                        string: {
                            eq: _,
                            neq: y,
                            startswith: "Starts with",
                            contains: "Contains",
                            doesnotcontain: "Does not contain",
                            endswith: "Ends with",
                            isnull: "Is null",
                            isnotnull: "Is not null",
                            isempty: "Is empty",
                            isnotempty: "Is not empty",
                            isnullorempty: "Has no value",
                            isnotnullorempty: "Has value"
                        },
                        number: {
                            eq: _,
                            neq: y,
                            gte: "Is greater than or equal to",
                            gt: "Is greater than",
                            lte: "Is less than or equal to",
                            lt: "Is less than",
                            isnull: "Is null",
                            isnotnull: "Is not null"
                        },
                        date: {
                            eq: _,
                            neq: y,
                            gte: "Is after or equal to",
                            gt: "Is after",
                            lte: "Is before or equal to",
                            lt: "Is before",
                            isnull: "Is null",
                            isnotnull: "Is not null"
                        },
                        enums: {
                            eq: _,
                            neq: y,
                            isnull: "Is null",
                            isnotnull: "Is not null"
                        }
                    },
                    messages: {
                        info: "Show items with value that:",
                        title: "Show items with value that:",
                        isTrue: "is true",
                        isFalse: "is false",
                        filter: "Filter",
                        clear: "Clear",
                        and: "And",
                        or: "Or",
                        selectValue: "-Select value-",
                        operator: "Operator",
                        value: "Value",
                        additionalValue: "Additional value",
                        additionalOperator: "Additional operator",
                        logic: "Filters logic",
                        cancel: "Cancel",
                        done: "Done",
                        into: "in"
                    },
                    animations: {
                        left: "slide",
                        right: "slide:right"
                    }
                }
            }),
            q = ".kendoFilterMultiCheck",
            V = c.data.DataSource,
            B = '<div data-#=ns#role="view" class="k-grid-filter-menu"><div data-#=ns#role="header" class="k-header"><a href="\\#" class="k-header-cancel k-link" title="#=messages.cancel#" aria-label="#=messages.cancel#"><span class="k-icon k-i-arrow-chevron-left"></span></a>#=messages.filter# #=messages.into# #=title#<a href="\\#" class="k-header-done k-link" title="#=messages.done#" aria-label="#=messages.done#"><span class="k-icon k-i-check"></span></a></div><form class="k-filter-menu"><ul class="k-reset">#if(search){#<li class="k-textbox k-space-right"><input placeholder="#=messages.search#" title="#=messages.search#" autocomplete="' + f + '"  /><span class="k-icon k-i-zoom" /></li>#}#<li class="k-filter-tools"><span style="#=checkAll ? "" : "visibility: hidden;" #" class="k-label k-select-all" title="#=messages.checkAll#" aria-label="#=messages.checkAll#">#=messages.checkAll#</span><span class="k-label k-clear-all" title="#=messages.clearAll#" aria-label="#=messages.clearAll#">#=messages.clearAll#</span></li>#if(messages.selectedItemsFormat){#<li><div class="k-filter-selected-items"></div></li>#}#<li><ul class="k-multicheck-wrap k-listgroup k-listgroup-flush"></ul></li></ul></form></div>',
            D = F.extend({
                init: function(t, l) {
                    var s, i;
                    F.fn.init.call(this, t, l), l = this.options, this.element = e(t), s = this.field = this.options.field || this.element.attr(c.attr("field")), i = l.checkSource, this._foreignKeyValues() ? (this.checkSource = V.create(l.values), this.checkSource.fetch()) : l.forceUnique ? (i = e.extend(!0, {}, l.dataSource.options), delete i.pageSize, this.checkSource = V.create(i), this.checkSource.reader.data = o(this.checkSource.reader.data, this.field)) : this.checkSource = V.create(i), this.dataSource = l.dataSource, this.model = this.dataSource.reader.model, this._parse = function(e) {
                        return e + ""
                    }, this.model && this.model.fields && (s = this.model.fields[this.field], s && ("number" == s.type ? this._parse = function(e) {
                        return "string" == typeof e && "null" === e.toLowerCase() ? null : parseFloat(e)
                    } : s.parse && (this._parse = p(s.parse, s)), this.type = s.type || "string")), l.appendToElement ? this._init() : this._createLink(), this._refreshHandler = p(this.refresh, this), this.dataSource.bind(v, this._refreshHandler)
                },
                _createLink: function() {
                    var e = this.element,
                        t = e.addClass("k-with-icon k-filterable").find(".k-grid-filter");
                    t[0] || (t = e.prepend('<a class="k-grid-filter" href="#" title="' + this.options.messages.filter + '" aria-label="' + this.options.messages.filter + '"><span class="k-icon k-i-filter"/></a>').find(".k-grid-filter")), this._link = t.attr("tabindex", -1).on("click" + b, p(this._click, this))
                },
                _init: function() {
                    var e = this,
                        t = this.options.forceUnique,
                        l = this.options;
                    this.pane = l.pane, this.pane && (this._isMobile = !0), this._createForm(), this._foreignKeyValues() ? this.refresh() : t && !this.checkSource.options.serverPaging && this.dataSource.data().length ? (this.checkSource.data(n(this.dataSource.data(), this.field)), this.refresh()) : (this._attachProgress(), this.checkSource.fetch(function() {
                        e.refresh.call(e)
                    })), this.options.forceUnique || (this.checkChangeHandler = function() {
                        e.container.empty(), e.refresh()
                    }, this.checkSource.bind(v, this.checkChangeHandler)), this.form.on("keydown" + q, p(this._keydown, this)).on("submit" + q, p(this._filter, this)).on("reset" + q, p(this._reset, this)), this.trigger(m, {
                        field: this.field,
                        container: this.form
                    })
                },
                _attachProgress: function() {
                    var e = this;
                    this._progressHandler = function() {
                        u.progress(e.container, !0)
                    }, this._progressHideHandler = function() {
                        u.progress(e.container, !1)
                    }, this.checkSource.bind("progress", this._progressHandler).bind("change", this._progressHideHandler)
                },
                _input: function() {
                    var e = this;
                    e._clearTypingTimeout(), e._typingTimeout = setTimeout(function() {
                        e.search()
                    }, 100)
                },
                _clearTypingTimeout: function() {
                    this._typingTimeout && (clearTimeout(this._typingTimeout), this._typingTimeout = null)
                },
                search: function() {
                    var e, t, l, s = this.options.ignoreCase,
                        i = this.searchTextBox[0].value,
                        a = this.container.find("label");
                    for (s && (i = i.toLowerCase()), e = 0, this.options.checkAll && a.length && (this._isMobile ? this.view.element.find(".k-select-all")[0].style.visibility = i ? "hidden" : "" : (a[0].parentNode.style.display = i ? "none" : "", e++)); e < a.length;) t = a[e], l = t.textContent || t.innerText, s && (l = l.toLowerCase()), t.parentNode.style.display = l.indexOf(i) >= 0 ? "" : "none", e++
                },
                _activate: function() {
                    this.form.find(":kendoFocusable:first").focus(), this.trigger(k, {
                        field: this.field,
                        container: this.form
                    })
                },
                _createForm: function() {
                    var t, l = this.options,
                        s = "",
                        i = this;
                    this._isMobile || (s += "<div class='k-filter-menu-container'>", l.search && (s += "<div class='k-textbox k-space-right'><input placeholder='" + l.messages.search + "'/><span class='k-icon k-i-zoom' /></div>"), s += "<ul class='k-reset k-multicheck-wrap'></ul>", l.messages.selectedItemsFormat && (s += "<div class='k-filter-selected-items'>" + c.format(l.messages.selectedItemsFormat, 0) + "</div>"), s += "<div class='k-action-buttons'>", s += "<button type='submit' class='k-button k-primary'>" + l.messages.filter + "</button>", s += "<button type='reset' class='k-button'>" + l.messages.clear + "</button>", s += "</div>", s += "</div>", this.form = e('<form class="k-filter-menu"/>').html(s), this.container = this.form.find(".k-multicheck-wrap")), this._isMobile ? (i.form = e("<div />").html(c.template(B)({
                        field: i.field,
                        title: l.title || i.field,
                        ns: c.ns,
                        messages: l.messages,
                        search: l.search,
                        checkAll: l.checkAll
                    })), i.view = i.pane.append(i.form.html()), i.form = i.view.element.find("form"), t = this.view.element, this.container = t.find(".k-multicheck-wrap"), t.on("click", ".k-header-done", function(e) {
                        i.form.submit(), e.preventDefault()
                    }).on("click", ".k-header-cancel", function(e) {
                        i._closeForm(), e.preventDefault()
                    }).on("click", ".k-clear-all", function(e) {
                        i._mobileCheckAll(!1), e.preventDefault()
                    }).on("click", ".k-select-all", function(e) {
                        i._mobileCheckAll(!0), e.preventDefault()
                    }), i.view.bind("showStart", function() {
                        i.refresh()
                    })) : l.appendToElement ? (this.popup = this.element.closest(".k-popup").data(h), this.element.append(this.form)) : i.popup = i.form.kendoPopup({
                        anchor: i._link,
                        open: p(i._open, i),
                        activate: p(i._activate, i),
                        close: function() {
                            i.options.closeCallback && i.options.closeCallback(i.element)
                        }
                    }).data(h), l.search && (this.searchTextBox = this.form.find(".k-textbox > input"), this.searchTextBox.on("input", p(this._input, this)))
                },
                createCheckAllItem: function() {
                    var t = this.options,
                        l = c.template(t.itemTemplate({
                            field: "all",
                            mobile: this._isMobile
                        })),
                        s = e(l({
                            all: t.messages.checkAll
                        }));
                    this.container.prepend(s), this.checkBoxAll = s.find(":checkbox").eq(0).addClass("k-check-all"), this.checkAllHandler = p(this.checkAll, this), this.checkBoxAll.on(v + q, this.checkAllHandler)
                },
                updateCheckAllState: function() {
                    if (this.options.messages.selectedItemsFormat && this.form.find(".k-filter-selected-items").text(c.format(this.options.messages.selectedItemsFormat, this.container.find(":checked:not(.k-check-all)").length)), this.checkBoxAll) {
                        var e = this.container.find(":checkbox:not(.k-check-all)").length == this.container.find(":checked:not(.k-check-all)").length;
                        this.checkBoxAll.prop("checked", e)
                    }
                },
                refresh: function(e) {
                    var t = this.options.forceUnique,
                        l = this.dataSource,
                        s = this.getFilterArray();
                    this._link && this._link.toggleClass("k-state-active", 0 !== s.length), this.form && (e && t && e.sender === l && !l.options.serverPaging && ("itemchange" == e.action || "add" == e.action || "remove" == e.action || l.options.autoSync && "sync" === e.action) && !this._foreignKeyValues() && (this.checkSource.data(n(this.dataSource.data(), this.field)), this.container.empty()), this.container.is(":empty") && this.createCheckBoxes(), this.checkValues(s), this.trigger(g))
                },
                getFilterArray: function() {
                    var t, l = e.extend(!0, {}, {
                        filters: [],
                        logic: "and"
                    }, this.dataSource.filter());
                    return a(l, this.field), t = r(l)
                },
                createCheckBoxes: function() {
                    var e, t, l, s = this.options,
                        i = {
                            field: this.field,
                            format: s.format,
                            mobile: this._isMobile,
                            type: this.type
                        };
                    this.options.forceUnique ? this._foreignKeyValues() ? (e = this.checkSource.data(), i.valueField = "value", i.field = "text") : e = this.checkSource.data() : e = this.checkSource.view(), t = c.template(s.itemTemplate(i)), l = c.render(t, e), s.checkAll && !this._isMobile && this.createCheckAllItem(), this.container.on(v + q, ":checkbox", p(this.updateCheckAllState, this)), this.container.append(l)
                },
                checkAll: function() {
                    var e = this.checkBoxAll.is(":checked");
                    this.container.find(":checkbox").prop("checked", e)
                },
                checkValues: function(t) {
                    var l = this;
                    e(e.grep(this.container.find(":checkbox").prop("checked", !1), function(s) {
                        var i, a, r = !1;
                        if (!e(s).is(".k-check-all"))
                            for (i = l._parse(e(s).val()), a = 0; a < t.length; a++)
                                if (r = "date" == l.type ? t[a] && i ? t[a].getTime() == i.getTime() : null === t[a] && null === i : t[a] == i) return r
                    })).prop("checked", !0), this.updateCheckAllState()
                },
                _mobileCheckAll: function(t) {
                    var l = this,
                        s = l.container.find(":checkbox");
                    s.each(function(l, s) {
                        var i = e(s);
                        i.prop("checked", t), i.trigger("change")
                    })
                },
                _filter: function(t) {
                    var l, s;
                    t.preventDefault(), t.stopPropagation(), l = {
                        logic: "or"
                    }, s = this, l.filters = e.map(this.form.find(":checkbox:checked:not(.k-check-all)"), function(t) {
                        return {
                            value: e(t).val(),
                            operator: "eq",
                            field: s.field
                        }
                    }), l.filters.length && this.trigger("change", {
                        filter: l,
                        field: s.field
                    }) || (l = this._merge(l), l.filters.length ? this.dataSource.filter(l) : this.clear(), this._closeForm())
                },
                _stripFilters: function(t) {
                    return e.grep(t, function(e) {
                        return null != e.value
                    })
                },
                _foreignKeyValues: function() {
                    var e = this.options;
                    return e.values && !e.checkSource
                },
                destroy: function() {
                    var e = this;
                    F.fn.destroy.call(e), e.form && (c.unbind(e.form), c.destroy(e.form), e.form.unbind(q), e.popup && (e.popup.destroy(), e.popup = null), e.form = null, e.container && (e.container.unbind(q), e.container = null), e.checkBoxAll && e.checkBoxAll.unbind(q)), e.view && (e.view.purge(), e.view = null), e._link && e._link.unbind(b), e._refreshHandler && (e.dataSource.unbind(v, e._refreshHandler), e.dataSource = null), e.checkChangeHandler && e.checkSource.unbind(v, e.checkChangeHandler), e._progressHandler && e.checkSource.unbind("progress", e._progressHandler), e._progressHideHandler && e.checkSource.unbind("change", e._progressHideHandler), this._clearTypingTimeout(), this.searchTextBox = null, e.element = e.checkSource = e.container = e.checkBoxAll = e._link = e._refreshHandler = e.checkAllHandler = null
                },
                options: {
                    name: "FilterMultiCheck",
                    itemTemplate: function(e) {
                        var l = e.field,
                            s = e.format,
                            i = e.valueField,
                            a = e.mobile,
                            r = "";
                        return i === t && (i = l), "date" == e.type && (r = ":yyyy-MM-ddTHH:mm:sszzz"), a ? "<li class='k-item k-listgroup-item'><label class='k-label k-listgroup-form-row'><span class='k-listgroup-form-field-label k-item-title '>#:kendo.format('" + (s ? s : "{0}") + "', " + l + ")#</span><span class=\"k-listgroup-form-field-wrapper\"><input type='checkbox' value='#:kendo.format('{0" + r + "}'," + i + ")#'/></span></label></li>" : "<li class='k-item'><label class='k-label'><input type='checkbox' value='#:kendo.format('{0" + r + "}'," + i + ")#'/><span>#:kendo.format('" + (s ? s : "{0}") + "', " + l + ")#</span></label></li>"
                    },
                    checkAll: !0,
                    search: !1,
                    ignoreCase: !0,
                    appendToElement: !1,
                    messages: {
                        checkAll: "Select All",
                        clearAll: "Clear All",
                        clear: "Clear",
                        filter: "Filter",
                        search: "Search",
                        cancel: "Cancel",
                        selectedItemsFormat: "{0} items selected",
                        done: "Done",
                        into: "in"
                    },
                    forceUnique: !0,
                    animations: {
                        left: "slide",
                        right: "slide:right"
                    }
                },
                events: [m, g, "change", k]
            });
        e.extend(D.fn, {
            _click: I.fn._click,
            _keydown: I.fn._keydown,
            _reset: I.fn._reset,
            _closeForm: I.fn._closeForm,
            _removeFilter: I.fn._removeFilter,
            clear: I.fn.clear,
            _merge: I.fn._merge
        }), u.plugin(I), u.plugin(D)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, l) {
    (l || t)()
});;
! function(t, define) {
    define("kendo.data.odata.min", ["kendo.core.min"], t)
}(function() {
    return function(t, e) {
        function n(a, o) {
            var r, s, d, i, p, c, u, l, f = [],
                y = a.logic || "and",
                m = a.filters;
            for (r = 0, s = m.length; r < s; r++) a = m[r], d = a.field, u = a.value, c = a.operator, a.filters ? a = n(a, o) : (l = a.ignoreCase, d = d.replace(/\./g, "/"), a = v[c], o && (a = b[c]), "isnullorempty" === c ? a = h.format("{0} {1} null or {0} {1} ''", d, a) : "isnotnullorempty" === c ? a = h.format("{0} {1} null and {0} {1} ''", d, a) : "isnull" === c || "isnotnull" === c ? a = h.format("{0} {1} null", d, a) : "isempty" === c || "isnotempty" === c ? a = h.format("{0} {1} ''", d, a) : a && u !== e && (i = t.type(u), "string" === i ? (p = "'{1}'", u = u.replace(/'/g, "''"), l === !0 && (d = "tolower(" + d + ")")) : "date" === i ? o ? (p = "{1:yyyy-MM-ddTHH:mm:ss+00:00}", u = h.timezone.apply(u, "Etc/UTC")) : p = "datetime'{1:yyyy-MM-ddTHH:mm:ss}'" : p = "{1}", a.length > 3 ? "substringof" !== a ? p = "{0}({2}," + p + ")" : (p = "{0}(" + p + ",{2})", "doesnotcontain" === c && (o ? (p = "{0}({2},'{1}') eq -1", a = "indexof") : p += " eq false")) : p = "{2} {0} " + p, a = h.format(p, a, u, d))), f.push(a);
            return a = f.join(" " + y + " "), f.length > 1 && (a = "(" + a + ")"), a
        }

        function a(t) {
            for (var e in t) 0 === e.indexOf("@odata") && delete t[e]
        }

        function o() {
            return Math.floor(65536 * (1 + Math.random())).toString(16).substr(1)
        }

        function r(t) {
            return t + o() + "-" + o() + "-" + o()
        }

        function s(t, e) {
            var n = g + "--" + t;
            return e && (n += "--"), n
        }

        function d(t, e, n, a) {
            var o = t.options[a].url,
                r = h.format("{0} ", n);
            return j(o) ? r + o(e) : r + o
        }

        function i(t, e) {
            var n = "";
            return n += s(t, !1), n += g + "Content-Type: application/http", n += g + "Content-Transfer-Encoding: binary", n += g + "Content-ID: " + e
        }

        function p(t) {
            var e = "";
            return e += g + "Content-Type: application/json;odata=minimalmetadata", e += g + "Prefer: return=representation", e += T + h.stringify(t)
        }

        function c(t, e, n, a, o, r) {
            var s, c = "";
            for (s = 0; s < t.length; s++) c += i(e, n), c += T + d(o, t[s], o.options[a].type, a) + " HTTP/1.1", r || (c += p(t[s])), c += g, n++;
            return c
        }

        function u(t, e, n, a, o, r, d) {
            var i = "";
            return i += l(e, n), i += c(t, n, a, r, o, d), i += s(n, !0), i += g
        }

        function l(t, e) {
            var n = "";
            return n += "--" + t + g, n += "Content-Type: multipart/mixed; boundary=" + e + g
        }

        function f(t, e) {
            var n = {},
                a = r("sf_batch_"),
                o = "",
                d = 0,
                i = t.options.batch.url,
                p = r("sf_changeset_");
            return n.type = t.options.batch.type, n.url = j(i) ? i() : i, n.headers = {
                "Content-Type": "multipart/mixed; boundary=" + a
            }, e.updated.length && (o += u(e.updated, a, p, d, t, "update", !1), d += e.updated.length, p = r("sf_changeset_")), e.destroyed.length && (o += u(e.destroyed, a, p, d, t, "destroy", !0), d += e.destroyed.length, p = r("sf_changeset_")), e.created.length && (o += u(e.created, a, p, d, t, "create", !1)), o += s(a, !0), n.data = o, n
        }

        function y(t) {
            var e, n, a, o, r, s, d = t.match(/--changesetresponse_[a-z0-9-]+$/gm),
                i = 0,
                p = [];
            for (p.push({
                    models: [],
                    passed: !0
                }), s = 0; s < d.length; s++) o = d[s], o.lastIndexOf("--", o.length - 1) ? s < d.length - 1 && p.push({
                models: [],
                passed: !0
            }) : (i = i ? t.indexOf(o, i + o.length) : t.indexOf(o), e = t.substring(i, t.indexOf("--", i + 1)), n = e.match(/^HTTP\/1\.\d (\d{3}) (.*)$/gm).pop(), a = h.parseFloat(n.match(/\d{3}/g).pop()), a >= 200 && a <= 299 ? (r = e.match(/\{.*\}/gm), r && p[p.length - 1].models.push(JSON.parse(r[0]))) : p[p.length - 1].passed = !1);
            return p
        }
        var h = window.kendo,
            m = t.extend,
            g = "\r\n",
            T = "\r\n\r\n",
            j = h.isFunction,
            v = {
                eq: "eq",
                neq: "ne",
                gt: "gt",
                gte: "ge",
                lt: "lt",
                lte: "le",
                contains: "substringof",
                doesnotcontain: "substringof",
                endswith: "endswith",
                startswith: "startswith",
                isnull: "eq",
                isnotnull: "ne",
                isnullorempty: "eq",
                isnotnullorempty: "ne",
                isempty: "eq",
                isnotempty: "ne"
            },
            b = m({}, v, {
                contains: "contains"
            }),
            E = {
                pageSize: t.noop,
                page: t.noop,
                filter: function(t, e, a) {
                    e && (e = n(e, a), e && (t.$filter = e))
                },
                sort: function(e, n) {
                    var a = t.map(n, function(t) {
                        var e = t.field.replace(/\./g, "/");
                        return "desc" === t.dir && (e += " desc"), e
                    }).join(",");
                    a && (e.$orderby = a)
                },
                skip: function(t, e) {
                    e && (t.$skip = e)
                },
                take: function(t, e) {
                    e && (t.$top = e)
                }
            },
            w = {
                read: {
                    dataType: "jsonp"
                }
            };
        m(!0, h.data, {
            schemas: {
                odata: {
                    type: "json",
                    data: function(t) {
                        return t.d.results || [t.d]
                    },
                    total: "d.__count"
                }
            },
            transports: {
                odata: {
                    read: {
                        cache: !0,
                        dataType: "jsonp",
                        jsonp: "$callback"
                    },
                    update: {
                        cache: !0,
                        dataType: "json",
                        contentType: "application/json",
                        type: "PUT"
                    },
                    create: {
                        cache: !0,
                        dataType: "json",
                        contentType: "application/json",
                        type: "POST"
                    },
                    destroy: {
                        cache: !0,
                        dataType: "json",
                        type: "DELETE"
                    },
                    parameterMap: function(t, e, n) {
                        var a, o, r, s;
                        if (t = t || {}, e = e || "read", s = (this.options || w)[e], s = s ? s.dataType : "json", "read" === e) {
                            a = {
                                $inlinecount: "allpages"
                            }, "json" != s && (a.$format = "json");
                            for (r in t) E[r] ? E[r](a, t[r], n) : a[r] = t[r]
                        } else {
                            if ("json" !== s) throw Error("Only json dataType can be used for " + e + " operation.");
                            if ("destroy" !== e) {
                                for (r in t) o = t[r], "number" == typeof o && (t[r] = o + "");
                                a = h.stringify(t)
                            }
                        }
                        return a
                    }
                }
            }
        }), m(!0, h.data, {
            schemas: {
                "odata-v4": {
                    type: "json",
                    data: function(e) {
                        if (t.isArray(e)) {
                            for (var n = 0; n < e.length; n++) a(e[n]);
                            return e
                        }
                        return e = t.extend({}, e), a(e), e.value ? e.value : [e]
                    },
                    total: function(t) {
                        return t["@odata.count"]
                    }
                }
            },
            transports: {
                "odata-v4": {
                    batch: {
                        type: "POST"
                    },
                    read: {
                        cache: !0,
                        dataType: "json"
                    },
                    update: {
                        cache: !0,
                        dataType: "json",
                        contentType: "application/json;IEEE754Compatible=true",
                        type: "PUT"
                    },
                    create: {
                        cache: !0,
                        dataType: "json",
                        contentType: "application/json;IEEE754Compatible=true",
                        type: "POST"
                    },
                    destroy: {
                        cache: !0,
                        dataType: "json",
                        type: "DELETE"
                    },
                    parameterMap: function(t, e) {
                        var n = h.data.transports.odata.parameterMap(t, e, !0);
                        return "read" == e && (n.$count = !0, delete n.$inlinecount), n
                    },
                    submit: function(e) {
                        var n = this,
                            a = f(n, e.data),
                            o = e.data;
                        (o.updated.length || o.destroyed.length || o.created.length) && t.ajax(m(!0, {}, {
                            success: function(t) {
                                var n, a = y(t),
                                    r = 0;
                                o.updated.length && (n = a[r], n.passed && e.success(n.models.length ? n.models : [], "update"), r++), o.destroyed.length && (n = a[r], n.passed && e.success([], "destroy"), r++), o.created.length && (n = a[r], n.passed && e.success(n.models, "create"))
                            },
                            error: function(t, n, a) {
                                e.error(t, n, a)
                            }
                        }, a))
                    }
                }
            }
        })
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, n) {
    (n || e)()
});;
! function(e, define) {
    define("kendo.menu.min", ["kendo.popup.min", "kendo.data.min"], e)
}(function() {
    return function(e, t) {
        function n(e, t) {
            return e = e.split(" ")[!t + 0] || e, e.replace("top", "up").replace("bottom", "down")
        }

        function o(e, t, n) {
            e = e.split(" ")[!t + 0] || e;
            var o = {
                    origin: ["bottom", n ? "right" : "left"],
                    position: ["top", n ? "right" : "left"]
                },
                i = /left|right/.test(e);
            return i ? (o.origin = ["top", e], o.position[1] = O.directions[e].reverse) : (o.origin[0] = e, o.position[0] = O.directions[e].reverse), o.origin = o.origin.join(" "), o.position = o.position.join(" "), o
        }

        function i(t, n) {
            try {
                return e.contains(t, n)
            } catch (o) {
                return !1
            }
        }

        function r(t) {
            t = e(t), t.addClass("k-item").children(G).addClass(Q), t.children("a").addClass(K).children(G).addClass(Q), t.filter(":not([disabled])").addClass(ye), t.filter(".k-separator").empty().append("&nbsp;"), t.filter("li[disabled]").addClass(Te).removeAttr("disabled").attr("aria-disabled", !0), t.filter("[role]").length || t.attr("role", "menuitem"), t.children(X).length || t.contents().filter(function() {
                return !(this.nodeName.match(L) || 3 == this.nodeType && !e.trim(this.nodeValue))
            }).wrapAll("<span class='" + K + "'/>"), a(t), l(t)
        }

        function a(t) {
            t = e(t), t.find("> .k-link > [class*=k-i-arrow-60]:not(.k-sprite)").remove(), t.filter(":has(.k-menu-group)").children(".k-link:not(:has([class*=k-i-arrow]:not(.k-sprite)))").each(function() {
                var t = e(this),
                    n = s(t);
                t.append("<span class='k-icon" + n + " k-menu-expand-arrow'/>")
            })
        }

        function s(e) {
            var t, n = e.parent().parent(),
                o = O.support.isRtl(n);
            return t = n.hasClass(J + "-horizontal") ? " k-i-arrow-60-down" : o ? " k-i-arrow-60-left" : " k-i-arrow-60-right"
        }

        function l(t) {
            t = e(t), t.filter(".k-first:not(:first-child)").removeClass($), t.filter(".k-last:not(:last-child)").removeClass(q), t.filter(":first-child").addClass($), t.filter(":last-child").addClass(q)
        }

        function p(e) {
            var t, n;
            if (e && e.length)
                for (t in e) n = e.eq(t), n.find("ul").length ? n.attr("aria-haspopup", !0) : n.removeAttr("aria-haspopup")
        }

        function c(e) {
            if (!e.hasClass(J)) return e.parentsUntil("." + J, "li")
        }

        function u(t, n) {
            var o = f(n);
            o && d(t, o), n.items && e(t).children("ul").children("li").each(function(e) {
                u(this, n.items[e])
            })
        }

        function d(t, n) {
            e(t).children(".k-link").data({
                selectHandler: n
            })
        }

        function f(e) {
            var t = e.select,
                n = O.isFunction;
            return t && n(t) ? t : null
        }

        function m(e) {
            return e ? "li[data-groupparent='" + e + "']" : "li[data-groupparent]"
        }

        function h(e) {
            var t = e ? "[data-group='" + e + "']" : "[data-group]";
            return "ul" + t + ",div" + t
        }

        function v(t, n) {
            var o = t.find(m()),
                i = [];
            return o.each(function(o, r) {
                var a, s;
                for (r = e(r), a = r.data(we), s = t; a;) s = n.find(h(a) + ":visible"), s.length && i.push(s), r = s.find(m()), a = r.data(we)
            }), i
        }

        function g(t, n) {
            var o = t.data(ke);
            return o ? n.find(m(o)) : e([])
        }

        function _(t, n) {
            var o = t.data(we);
            return o ? n.children(Se).children(h(o)) : e([])
        }

        function k(t, n) {
            var o, i, r = [],
                a = function(e) {
                    for (; e.parentNode && !n.is(e.parentNode);) r.push(e.parentNode), e = e.parentNode
                },
                s = t[0] || t;
            for (a(s), o = r[r.length - 1]; e(o).is(Se) && (i = e(o).children("ul"), s = g(i, n)[0]);) r.push(s), a(s), o = r[r.length - 1];
            return r
        }

        function w(e) {
            var t = 0;
            return e.wheelDelta && (t = -e.wheelDelta / 120, t = t > 0 ? Math.ceil(t) : Math.floor(t)), e.detail && (t = Math.round(e.detail / 3)), t
        }

        function C(e, t) {
            for (var n = 0, o = e.parentNode; o && !isNaN(o[t]);) n += o[t], o = o.parentNode;
            return n
        }

        function b(e) {
            return se && e.originalEvent && e.originalEvent.pointerType in Fe
        }

        function y(e) {
            var t = e.originalEvent;
            return x && /touch/i.test(t.type || "")
        }

        function P(e) {
            e.contents().filter(function() {
                return "LI" != this.nodeName
            }).remove()
        }
        var O = window.kendo,
            T = O.ui,
            H = O._activeElement,
            x = O.support.touch && O.support.mobileOS,
            I = e.isArray,
            S = O.data.HierarchicalDataSource,
            W = "mousedown",
            E = "click",
            A = 30,
            D = 50,
            M = e.extend,
            B = e.proxy,
            N = e.each,
            R = O.template,
            U = O.keys,
            z = T.Widget,
            L = /^(ul|a|div)$/i,
            F = ".kendoMenu",
            G = "img",
            j = "open",
            J = "k-menu",
            K = "k-link k-menu-link",
            X = ".k-link",
            Y = ".k-menu-expand-arrow",
            q = "k-last",
            V = "close",
            Z = "timer",
            $ = "k-first",
            Q = "k-image",
            ee = "select",
            te = "zIndex",
            ne = "activate",
            oe = "deactivate",
            ie = "touchstart" + F + " MSPointerDown" + F + " pointerdown" + F,
            re = O.support.pointers,
            ae = O.support.msPointers,
            se = ae || re,
            le = "change",
            pe = "error",
            ce = O.support.touch ? "touchstart" : "",
            ue = re ? "pointerover" : ae ? "MSPointerOver" : "mouseenter",
            de = re ? "pointerout" : ae ? "MSPointerOut" : "mouseleave",
            fe = "DOMMouseScroll" + F + " mousewheel" + F,
            me = O.support.resize + F,
            he = "scrollWidth",
            ve = "scrollHeight",
            ge = "offsetWidth",
            _e = "offsetHeight",
            ke = "group",
            we = "groupparent",
            Ce = e(document.documentElement),
            be = "kendoPopup",
            ye = "k-state-default",
            Pe = "k-state-hover",
            Oe = "k-state-focused",
            Te = "k-state-disabled",
            He = "k-state-selected",
            xe = ".k-menu",
            Ie = ".k-menu-group",
            Se = ".k-animation-container",
            We = Ie + "," + Se,
            Ee = ":not(.k-list) > .k-item",
            Ae = ".k-item.k-state-disabled",
            De = ".k-item",
            Me = ".k-item:not(.k-state-disabled)",
            Be = ".k-item:not(.k-state-disabled) > .k-link",
            Ne = ":not(.k-item.k-separator)",
            Re = De + Ne + ":eq(0)",
            Ue = De + Ne + ":last",
            ze = "div:not(.k-animation-container,.k-list-container)",
            Le = ".k-menu-scroll-button",
            Fe = {
                2: 1,
                touch: 1
            },
            Ge = "string",
            je = "dataBound",
            Je = {
                text: "dataTextField",
                url: "dataUrlField",
                spriteCssClass: "dataSpriteCssClassField",
                imageUrl: "dataImageUrlField",
                imageAttr: "dataImageAttrField",
                content: "dataContentField"
            },
            Ke = {
                wrapperCssClass: function(e, t) {
                    var n = "k-item",
                        o = t.index;
                    return n += t.enabled === !1 ? " k-state-disabled" : " k-state-default", e.firstLevel && 0 === o && (n += " k-first"), o == e.length - 1 && (n += " k-last"), t.cssClass && (n += " " + t.cssClass), t.attr && t.attr.hasOwnProperty("class") && (n += " " + t.attr["class"]), t.selected && (n += " " + He), n
                },
                itemCssAttributes: function(e) {
                    var t, n = "",
                        o = e.attr || {};
                    for (t in o) o.hasOwnProperty(t) && "class" !== t && (n += t + '="' + o[t] + '" ');
                    return n
                },
                imageCssAttributes: function(e) {
                    var t, n = "",
                        o = e && e.toJSON ? e.toJSON() : {};
                    o["class"] ? o["class"] += " " + Q : o["class"] = Q;
                    for (t in o) o.hasOwnProperty(t) && (n += t + '="' + o[t] + '" ');
                    return n
                },
                contentCssAttributes: function(e) {
                    var t, n = "",
                        o = e.contentAttr || {},
                        i = "k-content k-group k-menu-group";
                    o["class"] ? o["class"] += " " + i : o["class"] = i;
                    for (t in o) o.hasOwnProperty(t) && (n += t + '="' + o[t] + '" ');
                    return n
                },
                textClass: function() {
                    return K
                },
                arrowClass: function(e, t) {
                    var n = "k-icon";
                    return n += t.horizontal ? " k-i-arrow-60-down" : " k-i-arrow-60-right"
                },
                groupAttributes: function(e) {
                    return e.expanded !== !0 ? " style='display:none'" : ""
                },
                groupCssClass: function() {
                    return "k-group k-menu-group"
                },
                content: function(e) {
                    return e.content ? e.content : "&nbsp;"
                }
            },
            Xe = O.ui.DataBoundWidget.extend({
                init: function(e, t) {
                    var n = this;
                    z.fn.init.call(n, e, t), e = n.wrapper = n.element, t = n.options, n._accessors(), n._templates(), n._dataSource(), n._updateClasses(), n._animations(t), n.nextItemZIndex = 100, n._tabindex(), n._initOverflow(t), n._attachMenuEventsHandlers(), t.openOnClick && (n.clicked = !1), e.attr("role", "menubar"), e[0].id && (n._ariaId = O.format("{0}_mn_active", e[0].id)), O.notify(n)
                },
                events: [j, V, ne, oe, ee, je],
                options: {
                    name: "Menu",
                    animation: {
                        open: {
                            duration: 200
                        },
                        close: {
                            duration: 100
                        }
                    },
                    orientation: "horizontal",
                    direction: "default",
                    openOnClick: !1,
                    closeOnClick: !0,
                    hoverDelay: 100,
                    scrollable: !1,
                    popupCollision: t
                },
                _initData: function() {
                    var e = this;
                    e.dataSource && (e.angular("cleanup", function() {
                        return {
                            elements: e.element.children()
                        }
                    }), e.element.empty(), e.append(e.dataSource.view(), e.element), e.angular("compile", function() {
                        return {
                            elements: e.element.children()
                        }
                    }))
                },
                _attachMenuEventsHandlers: function() {
                    var t = this,
                        n = t.element,
                        o = t.options,
                        i = t._overflowWrapper();
                    (i || n).on(ie, De, B(t._focusHandler, t)).on(E + F, Ae, !1).on(E + F, De, B(t._click, t)).on(ie + " " + W + F, ".k-content", B(t._preventClose, t)).on(ue + F, Me, B(t._mouseenter, t)).on(de + F, Me, B(t._mouseleave, t)).on(W + F, Me, B(t._mousedown, t)).on(ce + F + " " + ue + F + " " + de + F + " " + W + F + " " + E + F, Be, B(t._toggleHover, t)), n.on("keydown" + F, B(t._keydown, t)).on("focus" + F, B(t._focus, t)).on("focus" + F, ".k-content", B(t._focus, t)).on("blur" + F, B(t._removeHoverItem, t)).on("blur" + F, "[tabindex]", B(t._checkActiveElement, t)), i && i.on(de + F, We, B(t._mouseleavePopup, t)).on(ue + F, We, B(t._mouseenterPopup, t)), o.openOnClick && (t._documentClickHandler = B(t._documentClick, t), e(document).click(t._documentClickHandler))
                },
                _detachMenuEventsHandlers: function() {
                    var t = this,
                        n = t._overflowWrapper();
                    n && n.off(F), t.element.off(F), t._documentClickHandler && e(document).unbind("click", t._documentClickHandler)
                },
                _initOverflow: function(t) {
                    var n, o, i, r, a = this,
                        s = "horizontal" == t.orientation;
                    t.scrollable && (a._openedPopups = {}, a._scrollWrapper = a.element.wrap("<div class='k-menu-scroll-wrapper " + t.orientation + "'></div>").parent(), s && P(a.element), n = e(a.templates.scrollButton({
                        direction: s ? "left" : "up"
                    })), o = e(a.templates.scrollButton({
                        direction: s ? "right" : "down"
                    })), n.add(o).appendTo(a._scrollWrapper), a._initScrolling(a.element, n, o, s), i = a.element.outerWidth(), r = a.element[0].style.width, r = "auto" === r ? "" : r, s && e(window).on(me, O.throttle(function() {
                        a._setOverflowWrapperWidth(i, r), a._toggleScrollButtons(a.element, n, o, s)
                    }, 100)), a._setOverflowWrapperWidth(i, r), a._toggleScrollButtons(a.element, n, o, s))
                },
                _overflowWrapper: function() {
                    return this._scrollWrapper || this._popupsWrapper
                },
                _setOverflowWrapperWidth: function(e, t) {
                    var n, o, i, r, a = this,
                        s = a._scrollWrapper.css("width");
                    a._scrollWrapper.css({
                        width: ""
                    }), n = a._scrollWrapper.outerWidth(), a._scrollWrapper.css({
                        width: s
                    }), o = a.element.outerWidth(), i = a.element[0].offsetWidth - a.element[0].clientWidth, o != n && n > 0 && (r = t ? Math.min(e, n) : n, a.element.width(r - i), a._scrollWrapper.width(r))
                },
                _reinitOverflow: function(e) {
                    var t = this,
                        n = e.scrollable && !t.options.scrollable || !e.scrollable && t.options.scrollable || e.scrollable && t.options.scrollable && e.scrollable.distance != t.options.scrollable.distance || e.orientation != t.options.orientation;
                    n && (t._detachMenuEventsHandlers(), t._destroyOverflow(), t._initOverflow(e), t._attachMenuEventsHandlers())
                },
                _destroyOverflow: function() {
                    var n = this,
                        o = n._overflowWrapper();
                    o && (o.off(F), o.find(Le).off(F).remove(), o.children(Se).each(function(t, n) {
                        var i, r = e(n).children(Ie);
                        r.off(fe), i = g(r, o), i.length && i.append(n)
                    }), o.find(m()).removeAttr("data-groupparent"), o.find(h()).removeAttr("data-group"), n.element.off(fe), e(window).off(me), o.contents().unwrap(), n._scrollWrapper = n._popupsWrapper = n._openedPopups = t)
                },
                _initScrolling: function(t, n, o, i) {
                    var r = this,
                        a = r.options.scrollable,
                        s = e.isNumeric(a.distance) ? a.distance : D,
                        l = s / 2,
                        p = "-=" + s,
                        c = "+=" + s,
                        u = "-=" + 2 * s,
                        d = "+=" + 2 * s,
                        f = !1,
                        m = !1,
                        h = function(e) {
                            var a = i ? {
                                scrollLeft: e
                            } : {
                                scrollTop: e
                            };
                            t.finish().animate(a, "fast", "linear", function() {
                                f && h(e)
                            }), r._toggleScrollButtons(t, n, o, i)
                        },
                        v = function(e) {
                            f || m || (h(e.data.direction), f = !0)
                        },
                        g = function(a) {
                            var s = i ? {
                                scrollLeft: a.data.direction
                            } : {
                                scrollTop: a.data.direction
                            };
                            m = y(a) || b(a), t.stop().animate(s, "fast", "linear", function() {
                                m ? (r._toggleScrollButtons(t, n, o, i), f = !0) : e(a.currentTarget).trigger(ue)
                            }), f = !1, a.stopPropagation(), a.preventDefault()
                        };
                    n.on(ue + F, {
                        direction: p
                    }, v).on(O.eventMap.down + F, {
                        direction: u
                    }, g), o.on(ue + F, {
                        direction: c
                    }, v).on(O.eventMap.down + F, {
                        direction: d
                    }, g), n.add(o).on(de + F, function() {
                        t.stop(), f = !1, r._toggleScrollButtons(t, n, o, i)
                    }), t.on(fe, function(e) {
                        var a, s, p, c;
                        e.ctrlKey || e.shiftKey || e.altKey || (a = w(e.originalEvent), s = Math.abs(a) * l, p = (a > 0 ? "+=" : "-=") + s, c = i ? {
                            scrollLeft: p
                        } : {
                            scrollTop: p
                        }, r._closeChildPopups(t), t.finish().animate(c, "fast", "linear", function() {
                            r._toggleScrollButtons(t, n, o, i)
                        }), e.preventDefault())
                    })
                },
                _toggleScrollButtons: function(e, t, n, o) {
                    var i = o ? e.scrollLeft() : e.scrollTop(),
                        r = o ? he : ve,
                        a = o ? ge : _e;
                    t.toggle(0 !== i), n.toggle(i < e[0][r] - e[0][a] - 1)
                },
                setOptions: function(e) {
                    var t = this.options.animation;
                    this._animations(e), e.animation = M(!0, t, e.animation), "dataSource" in e && this._dataSource(e), this._updateClasses(), this._reinitOverflow(e), z.fn.setOptions.call(this, e)
                },
                destroy: function() {
                    var e = this;
                    z.fn.destroy.call(e), e._detachMenuEventsHandlers(), e._destroyOverflow(), O.destroy(e.element)
                },
                enable: function(e, t) {
                    return this._toggleDisabled(e, t !== !1), this
                },
                disable: function(e) {
                    return this._toggleDisabled(e, !1), this
                },
                attemptGetItem: function(t) {
                    var n, o;
                    return t = t || this.element, n = this.element.find(t), o = this._overflowWrapper(), n.length || t === this.element ? n : o ? o.find(t) : e()
                },
                append: function(e, t) {
                    t = this.attemptGetItem(t);
                    var n = this._insert(e, t, t.length ? this._childPopupElement(t) : null);
                    return N(n.items, function(t) {
                        n.group.append(this), a(this), u(this, e[t] || e)
                    }), a(t), l(n.group.find(".k-first, .k-last").add(n.items)), p(c(n.group)), this
                },
                insertBefore: function(e, t) {
                    t = this.attemptGetItem(t);
                    var n = this._insert(e, t, t.parent());
                    return N(n.items, function(n) {
                        t.before(this), a(this), l(this), u(this, e[n] || e)
                    }), l(t), this
                },
                insertAfter: function(e, t) {
                    t = this.attemptGetItem(t);
                    var n = this._insert(e, t, t.parent());
                    return N(n.items, function(n) {
                        t.after(this), a(this), l(this), u(this, e[n] || e)
                    }), l(t), this
                },
                _insert: function(t, n, o) {
                    var i, a, s, l, p = this;
                    return n && n.length || (o = p.element), s = e.isPlainObject(t) || t instanceof O.data.ObservableObject, l = {
                        firstLevel: o.hasClass(J),
                        horizontal: o.hasClass(J + "-horizontal"),
                        expanded: !0,
                        length: o.children().length
                    }, n && !o.length && (o = e(p.renderGroup({
                        group: l,
                        options: p.options
                    })).appendTo(n)), s || I(t) || t instanceof O.data.ObservableArray ? i = e(e.map(s ? [t] : t, function(t, n) {
                        return "string" == typeof t ? e(t).get() : e(p.renderItem({
                            group: l,
                            item: M(t, {
                                index: n
                            })
                        })).get()
                    })) : (i = "string" == typeof t && "<" != t.charAt(0) ? p.element.find(t) : e(t), a = i.find("> ul").addClass("k-menu-group").attr("role", "menu"), i = i.filter("li"), i.add(a.find("> li")).each(function() {
                        r(this)
                    })), {
                        items: i,
                        group: o
                    }
                },
                remove: function(e) {
                    var t, n, o, i, r;
                    return e = this.attemptGetItem(e), t = this, n = e.parentsUntil(t.element, Ee), o = e.parent("ul:not(.k-menu)"), e.remove(), o && !o.children(Ee).length && (i = c(o), r = o.parent(Se), r.length ? r.remove() : o.remove(), p(i)), n.length && (n = n.eq(0), a(n), l(n)), t
                },
                _openAfterLoad: function(e, t) {
                    var n = this;
                    t.loaded() ? (n.open(e), n._loading = !1) : t.one(le, function() {
                        e.find(Y).removeClass("k-i-loading"), n._loading && (n.open(e), n._loading = !1)
                    })
                },
                open: function(i) {
                    var r, a, s, l = this,
                        p = l.options,
                        c = "horizontal" == p.orientation,
                        u = p.direction,
                        d = O.support.isRtl(l.wrapper),
                        f = l._overflowWrapper();
                    return i = (f || l.element).find(i), r = l.dataSource && l.dataSource.getByUid(i.data(O.ns + "uid")), r && r.hasChildren && !r.loaded() && !l._loading ? (l._loading = !0, i.find(Y).addClass("k-i-loading"), r.load(), l._openAfterLoad(i, r), t) : (/^(top|bottom|default)$/.test(u) && (u = d ? c ? (u + " left").replace("default", "bottom") : "left" : c ? (u + " right").replace("default", "bottom") : "right"), a = ">.k-popup:visible,>.k-animation-container>.k-popup:visible", s = function() {
                        var t = e(this).data(be);
                        t && l.close(e(this).closest("li.k-item"), !0)
                    }, i.siblings().find(a).each(s), f && i.find(a).each(s), l.options.openOnClick && (l.clicked = !0), i.each(function() {
                        var i = e(this);
                        clearTimeout(i.data(Z)), i.data(Z, setTimeout(function() {
                            var r, a, s, h, v, g, _, k, w, C, b = i.find(".k-menu-group:first:hidden");
                            !b[0] && f && (a = l._getPopup(i), b = a && a.element), b.is(":visible") || b[0] && l._triggerEvent({
                                item: i[0],
                                type: j
                            }) === !1 && (!b.find(".k-menu-group")[0] && b.children(".k-item").length > 1 ? (s = e(window).height(), h = function() {
                                b.css({
                                    maxHeight: s - (O._outerHeight(b) - b.height()) - O.getShadows(b).bottom,
                                    overflow: "auto"
                                })
                            }, O.support.browser.msie && O.support.browser.version <= 7 ? setTimeout(h, 0) : h()) : b.css({
                                maxHeight: "",
                                overflow: ""
                            }), i.data(te, i.css(te)), v = l.nextItemZIndex++, i.css(te, v), l.options.scrollable && i.parent().siblings(Le).css({
                                zIndex: ++v
                            }), r = b.data(be), g = i.parent().hasClass(J), _ = g && c, k = o(u, g, d), w = p.animation.open.effects, C = w !== t ? w : "slideIn:" + n(u, g), r ? (r = b.data(be), r.options.origin = k.origin, r.options.position = k.position, r.options.animation.open.effects = C) : r = b.kendoPopup({
                                activate: function() {
                                    l._triggerEvent({
                                        item: this.wrapper.parent(),
                                        type: ne
                                    })
                                },
                                deactivate: function(e) {
                                    l._closing = !1, e.sender.element.removeData("targetTransform").css({
                                        opacity: ""
                                    }), l._triggerEvent({
                                        item: this.wrapper.parent(),
                                        type: oe
                                    })
                                },
                                origin: k.origin,
                                position: k.position,
                                collision: p.popupCollision !== t ? p.popupCollision : _ ? "fit" : "fit flip",
                                anchor: i,
                                appendTo: f || i,
                                animation: {
                                    open: M(!0, {
                                        effects: C
                                    }, p.animation.open),
                                    close: p.animation.close
                                },
                                open: B(l._popupOpen, l),
                                close: function(e) {
                                    var t, n;
                                    l._closing = !0, t = e.sender.wrapper.parent(), f && (n = e.sender.element.data(ke), n && (t = (f || l.element).find(m(n))), e.sender.wrapper.children(Le).hide()), l._triggerEvent({
                                        item: t[0],
                                        type: V
                                    }) ? e.preventDefault() : (t.css(te, t.data(te)), t.removeData(te), l.options.scrollable && t.parent().siblings(Le).css({
                                        zIndex: ""
                                    }), (x || se || O.support.mouseAndTouchPresent) && (t.removeClass(Pe), l._removeHoverItem()))
                                }
                            }).data(be), b.removeAttr("aria-hidden"), l._configurePopupOverflow(r, i), r._hovered = !0, r.open(), l._initPopupScrolling(r))
                        }, l.options.hoverDelay))
                    }), l)
                },
                _configurePopupOverflow: function(e, t) {
                    var n, o = this;
                    o.options.scrollable && (o._wrapPopupElement(e), t.attr("data-groupparent") || (n = (new Date).getTime(), t.attr("data-groupparent", n), e.element.attr("data-group", n)))
                },
                _wrapPopupElement: function(e) {
                    e.element.parent().is(Se) || (e.wrapper = O.wrap(e.element, e.options.autosize).css({
                        overflow: "hidden",
                        display: "block",
                        position: "absolute"
                    }))
                },
                _initPopupScrolling: function(e, t, n) {
                    var o = this;
                    o.options.scrollable && e.element[0].scrollHeight > e.element[0].offsetHeight && o._initPopupScrollButtons(e, t, n)
                },
                _initPopupScrollButtons: function(t, n, o) {
                    var i = this,
                        r = t.wrapper.children(Le),
                        a = i.options.animation,
                        s = (a && a.open && a.open.duration || 0) + A;
                    setTimeout(function() {
                        var a, s;
                        r.length || (a = e(i.templates.scrollButton({
                            direction: n ? "left" : "up"
                        })), s = e(i.templates.scrollButton({
                            direction: n ? "right" : "down"
                        })), r = a.add(s).appendTo(t.wrapper), i._initScrolling(t.element, a, s, n), o || r.on(ue + F, function() {
                            var n = i._overflowWrapper();
                            e(v(t.element, n)).each(function(e, t) {
                                var o = n.find(m(t.data(ke)));
                                i.close(o)
                            })
                        }).on(de + F, function() {
                            setTimeout(function() {
                                e.isEmptyObject(i._openedPopups) && i._closeParentPopups(t.element)
                            }, A)
                        })), i._toggleScrollButtons(t.element, r.first(), r.last(), n)
                    }, s)
                },
                _popupOpen: function(e) {
                    this._keyTriggered || e.sender.element.children("." + Oe).removeClass(Oe), this.options.scrollable && this._setPopupHeight(e.sender)
                },
                _setPopupHeight: function(t, n) {
                    var o, i, r, a, s, l, p, c, u, d = t.element,
                        f = d.add(d.parent(Se));
                    f.height(d.hasClass(J) && this._initialHeight || ""), o = t._location(n), i = e(window).height(), r = o.height, a = n ? 0 : Math.max(o.top, 0), s = n ? 0 : C(this._overflowWrapper()[0], "scrollTop"), l = window.innerHeight - i, p = i - O.getShadows(d).bottom + l, c = p + s > r + a, c || (u = Math.min(p, p - a + s), f.css({
                        overflow: "hidden",
                        height: u + "px"
                    }))
                },
                close: function(t, n) {
                    var o, i, r = this,
                        a = r._overflowWrapper(),
                        s = a || r.element;
                    return t = s.find(t), t.length || (t = s.find(">.k-item")), o = function(t) {
                        var n = !1;
                        return e.isEmptyObject(r._openedPopups) ? n : (e(v(t, a)).each(function(e, t) {
                            return n = !!r._openedPopups["" + t.data(ke)], !n
                        }), n)
                    }, i = function(e) {
                        var t = e.data(we);
                        return !a || !t || !r._openedPopups["" + t]
                    }, t.each(function() {
                        var s = e(this);
                        !n && r._isRootItem(s) && (r.clicked = !1), clearTimeout(s.data(Z)), s.data(Z, setTimeout(function() {
                            var e = r._getPopup(s);
                            if (e && (i(s) || r._forceClose)) {
                                if (!r._forceClose && o(e.element)) return;
                                e.close(), e.element.attr("aria-hidden", !0), a && r._forceClose && t.last().is(s[0]) && delete r._forceClose
                            }
                        }, r.options.hoverDelay))
                    }), r
                },
                _getPopup: function(e) {
                    var t, n, o = this,
                        i = e.find(".k-menu-group:not(.k-list-container):not(.k-calendar-container):first:visible").data(be),
                        r = o._overflowWrapper();
                    return !i && r && (t = e.data(we), t && (n = r.find(h(t)), i = n.data(be))), i
                },
                _toggleDisabled: function(t, n) {
                    this.element.find(t).each(function() {
                        e(this).toggleClass(ye, n).toggleClass(Te, !n).attr("aria-disabled", !n)
                    })
                },
                _toggleHover: function(t) {
                    var n = e(O.eventTarget(t) || t.target).closest(Ee),
                        o = t.type == ue || W.indexOf(t.type) !== -1;
                    n.siblings().removeClass(Pe), n.parents("li." + Te).length || n.toggleClass(Pe, o || "mousedown" == t.type || "pointerover" == t.type || t.type == ce), this._removeHoverItem()
                },
                _preventClose: function() {
                    this.options.closeOnClick || (this._closurePrevented = !0)
                },
                _checkActiveElement: function(t) {
                    var n = this,
                        o = e(t ? t.currentTarget : this._hoverItem()),
                        r = n._findRootParent(o)[0];
                    this._closurePrevented || setTimeout(function() {
                        document.hasFocus() && (i(r, O._activeElement()) || !t || i(r, t.currentTarget)) || n.close(r)
                    }, 0), this._closurePrevented = !1
                },
                _removeHoverItem: function() {
                    var e = this._hoverItem();
                    e && e.hasClass(Oe) && (e.removeClass(Oe), this._oldHoverItem = null)
                },
                _updateClasses: function() {
                    var e, t = this.element,
                        n = ".k-menu-init div ul";
                    t.removeClass("k-menu-horizontal k-menu-vertical"), t.addClass("k-widget k-reset k-header k-menu-init " + J).addClass(J + "-" + this.options.orientation), t.find("li > ul").filter(function() {
                        return !O.support.matchesSelector.call(this, n)
                    }).addClass("k-group k-menu-group").attr("role", "menu").attr("aria-hidden", t.is(":visible")).parent("li").attr("aria-haspopup", "true").end().find("li > div").addClass("k-content").attr("tabindex", "-1"), e = t.find("> li,.k-menu-group > li"), t.removeClass("k-menu-init"), e.each(function() {
                        r(this)
                    })
                },
                _mouseenter: function(t) {
                    var n = this,
                        o = e(t.currentTarget),
                        r = n._itemHasChildren(o),
                        a = o.data(we) || o.parent().data(ke),
                        s = b(t);
                    a && (n._openedPopups["" + a] = !0), n._closing || t.delegateTarget != o.parents(xe)[0] && t.delegateTarget != o.parents(".k-menu-scroll-wrapper,.k-popups-wrapper")[0] || (n._keyTriggered = !1, n.options.openOnClick.rootMenuItems && n._isRootItem(o.closest(Ee)) || n.options.openOnClick.subMenuItems && !n._isRootItem(o.closest(Ee)) || (!(n.options.openOnClick === !1 || n.options.openOnClick.rootMenuItems === !1 && n._isRootItem(o.closest(Ee)) || n.options.openOnClick.subMenuItems === !1 && !n._isRootItem(o.closest(Ee)) || n.clicked) || x || s && n._isRootItem(o.closest(Ee)) || !i(t.currentTarget, t.relatedTarget) && r && n.open(o), (n.options.openOnClick === !0 && n.clicked || x) && o.siblings().each(B(function(e, t) {
                        n.close(t, !0)
                    }, n))))
                },
                _mousedown: function(t) {
                    var n = this,
                        o = e(t.currentTarget);
                    (n.options.openOnClick.subMenuItems && !n._isRootItem(o) || x) && o.siblings().each(B(function(e, t) {
                        n.close(t, !0)
                    }, n))
                },
                _mouseleave: function(n) {
                    var o = this,
                        r = e(n.currentTarget),
                        a = r.data(we),
                        s = r.children(Se).length || r.children(Ie).length || a,
                        l = e(window);
                    return a && delete o._openedPopups["" + a], r.parentsUntil(Se, ".k-list-container,.k-calendar-container")[0] ? (n.stopImmediatePropagation(), t) : o.options.openOnClick !== !1 && (o.options.openOnClick.rootMenuItems || !o._isRootItem(r)) && (o.options.openOnClick.subMenuItems || o._isRootItem(r)) || x || b(n) || i(n.currentTarget, n.relatedTarget || n.target) || !s || i(n.currentTarget, O._activeElement()) ? ((O.support.browser.msie && !n.toElement && !n.relatedTarget && !b(n) || n.clientX < 0 || n.clientY < 0 || n.clientY > l.height() || n.clientX > l.width()) && o.close(r), t) : (o.close(r, !0), o._loading = !1, t)
                },
                _mouseenterPopup: function(t) {
                    var n, o = this,
                        i = e(t.currentTarget);
                    i.parent().is(Se) || (i = i.children("ul"), n = i.data(ke), n && (o._openedPopups["" + n] = !0))
                },
                _mouseleavePopup: function(t) {
                    var n = this,
                        o = e(t.currentTarget);
                    !b(t) && o.is(Se) && n._closePopups(o.children("ul"))
                },
                _closePopups: function(t) {
                    var n, o = this,
                        i = o._overflowWrapper(),
                        r = t.data(ke);
                    r && (delete o._openedPopups["" + r], n = i.find(m(r)), setTimeout(function() {
                        if (o.options.openOnClick) o._closeChildPopups(t);
                        else if (e.isEmptyObject(o._openedPopups)) {
                            var i = o._innerPopup(t);
                            o._closeParentPopups(i)
                        } else o.close(n, !0)
                    }, 0))
                },
                _closeChildPopups: function(t) {
                    var n = this,
                        o = n._overflowWrapper();
                    e(v(t, o)).each(function() {
                        var e = o.find(m(this.data(ke)));
                        n.close(e, !0)
                    })
                },
                _innerPopup: function(e) {
                    var t = this._overflowWrapper(),
                        n = v(e, t);
                    return n[n.length - 1] || e
                },
                _closeParentPopups: function(e) {
                    var t = this,
                        n = t._overflowWrapper(),
                        o = e.data(ke),
                        i = n.find(m(o));
                    for (o = i.parent().data(ke), t.close(i, !0); o && !t._openedPopups[o] && !i.parent().is(xe);) i = n.find(m(o)), t.close(i, !0), o = i.parent().data(ke)
                },
                _click: function(n) {
                    for (var o, i, r, a, s, l, p = this, c = p.options, u = e(O.eventTarget(n)), d = u[0], f = u[0] ? u[0].nodeName.toUpperCase() : "", m = "INPUT" == f || "SELECT" == f || "BUTTON" == f || "LABEL" == f, v = u.closest(X), g = u.closest(Ee), _ = g[0], k = v.attr("href"), w = u.attr("href"), C = e("<a href='#' />").attr("href"), y = !!k && k !== C, P = y && !!k.match(/^#/), T = !!w && w !== C, H = p._overflowWrapper(); d && d.parentNode != _;) d = d.parentNode;
                    if (!e(d).is(ze)) {
                        if (g.hasClass(Te)) return n.preventDefault(), t;
                        if (n.handled || !p._triggerSelect(u, _) || m || n.preventDefault(), n.handled = !0, i = g.children(We), H && (s = g.data(we), s && (i = H.find(h(s)))), r = i.is(":visible"), a = c.openOnClick && r && p._isRootItem(g), c.closeOnClick && (!y || P) && (!i.length || a)) return g.removeClass(Pe).css("height"), p._oldHoverItem = p._findRootParent(g), l = p._parentsUntil(v, p.element, Ee), p._forceClose = !!H, p.close(l), p.clicked = !1, "MSPointerUp".indexOf(n.type) != -1 && n.preventDefault(), t;
                        y && n.enterKey && v[0].click(), (p._isRootItem(g) && c.openOnClick !== !1 || c.openOnClick.subMenuItems || O.support.touch || b(n) && p._isRootItem(g.closest(Ee))) && (y || m || T || n.preventDefault(), p.clicked = !0, o = i.is(":visible") ? V : j, (c.closeOnClick || o != V) && p[o](g))
                    }
                },
                _parentsUntil: function(n, o, i) {
                    var r, a, s = this._overflowWrapper();
                    return s ? (r = k(n, s), a = [], e(r).each(function() {
                        var n = e(this);
                        return !n.is(o) && (n.is(i) && a.push(this), t)
                    }), e(a)) : n.parentsUntil(o, i)
                },
                _triggerSelect: function(e, t) {
                    var n, o, i, r;
                    return e = e.is(".k-link") ? e : e.closest(".k-link"), n = e.data("selectHandler"), n && (o = this._getEventData(e), n.call(this, o)), i = o && o.isDefaultPrevented(), r = this._triggerEvent({
                        item: t,
                        type: ee
                    }), i || r
                },
                _getEventData: function(e) {
                    var t = {
                        sender: this,
                        target: e,
                        _defaultPrevented: !1,
                        preventDefault: function() {
                            this._defaultPrevented = !0
                        },
                        isDefaultPrevented: function() {
                            return this._defaultPrevented
                        }
                    };
                    return t
                },
                _documentClick: function(e) {
                    var t = this;
                    i((t._overflowWrapper() || t.element)[0], e.target) || (t.clicked = !1)
                },
                _focus: function(n) {
                    var o = this,
                        i = n.target,
                        r = o._hoverItem(),
                        a = H();
                    return i == o.wrapper[0] || e(i).is(":kendoFocusable") ? (a === n.currentTarget && (r.length ? o._moveHover([], r) : o._oldHoverItem || o._moveHover([], o.wrapper.children().first())), t) : (n.stopPropagation(), e(i).closest(".k-content").closest(".k-menu-group").closest(".k-item").addClass(Oe), o.wrapper.focus(), t)
                },
                _keydown: function(e) {
                    var n, o, i, r = this,
                        a = e.keyCode,
                        s = r._oldHoverItem,
                        l = O.support.isRtl(r.wrapper);
                    if (e.target == e.currentTarget || a == U.ESC) {
                        if (s || (s = r._oldHoverItem = r._hoverItem()), o = r._itemBelongsToVertival(s), i = r._itemHasChildren(s), r._keyTriggered = !0, a == U.RIGHT) n = r[l ? "_itemLeft" : "_itemRight"](s, o, i);
                        else if (a == U.LEFT) n = r[l ? "_itemRight" : "_itemLeft"](s, o, i);
                        else if (a == U.DOWN) n = r._itemDown(s, o, i);
                        else if (a == U.UP) n = r._itemUp(s, o, i);
                        else if (a == U.HOME) r._moveHover(s, s.parent().children().first()), e.preventDefault();
                        else if (a == U.END) r._moveHover(s, s.parent().children().last()), e.preventDefault();
                        else if (a == U.ESC) n = r._itemEsc(s, o);
                        else if (a == U.ENTER || a == U.SPACEBAR) n = s.children(".k-link"), n.length > 0 && (r._click({
                            target: n[0],
                            preventDefault: function() {},
                            enterKey: !0
                        }), i && !s.hasClass(Te) ? (r.open(s), r._moveHover(s, r._childPopupElement(s).children().first())) : r._moveHover(s, r._findRootParent(s)));
                        else if (a == U.TAB) return n = r._findRootParent(s), r._moveHover(s, n), r._checkActiveElement(), t;
                        n && n[0] && (e.preventDefault(), e.stopPropagation())
                    }
                },
                _hoverItem: function() {
                    return this.wrapper.find(".k-item.k-state-hover,.k-item.k-state-focused").filter(":visible")
                },
                _itemBelongsToVertival: function(e) {
                    var t = this.wrapper.hasClass("k-menu-vertical");
                    return e.length ? e.parent().hasClass("k-menu-group") || t : t
                },
                _itemHasChildren: function(e) {
                    return !!(e && e.length && e[0].nodeType) && (e.children(".k-menu-group, div.k-animation-container").length > 0 || !!e.data(we) && !!this._overflowWrapper().children(h(e.data(we))))
                },
                _moveHover: function(t, n) {
                    var o = this,
                        i = o._ariaId;
                    t.length && n.length && t.removeClass(Oe), n.length && (n[0].id && (i = n[0].id), n.addClass(Oe), o._oldHoverItem = n, i && (o.element.removeAttr("aria-activedescendant"), e("#" + i).removeAttr("id"), n.attr("id", i), o.element.attr("aria-activedescendant", i)), o._scrollToItem(n))
                },
                _findRootParent: function(e) {
                    return this._isRootItem(e) ? e : this._parentsUntil(e, xe, "li.k-item").last()
                },
                _isRootItem: function(e) {
                    return e.parent().hasClass(J)
                },
                _itemRight: function(e, t, n) {
                    var o, i, r, a, s = this;
                    return t ? n && !e.hasClass(Te) ? (s.open(e), o = s._childPopupElement(e).children().first()) : "horizontal" == s.options.orientation && (i = s._findRootParent(e), r = s._overflowWrapper(), r && (a = _(i, r), s._closeChildPopups(a)), s.close(i), o = i.nextAll(Re)) : (o = e.nextAll(Re), o.length || (o = e.prevAll(Ue)), s.close(e)), o && !o.length ? o = s.wrapper.children(".k-item").first() : o || (o = []), s._moveHover(e, o), o
                },
                _itemLeft: function(e, t) {
                    var n, o, i = this;
                    return t ? (n = e.parent().closest(".k-item"), o = i._overflowWrapper(), !n.length && o && (n = g(e.parent(), o)), i.close(n), i._isRootItem(n) && "horizontal" == i.options.orientation && (n = n.prevAll(Re))) : (n = e.prevAll(Re), n.length || (n = e.nextAll(Ue)), i.close(e)), n.length || (n = i.wrapper.children(".k-item").last()), i._moveHover(e, n), n
                },
                _itemDown: function(e, t, n) {
                    var o, i = this;
                    if (t) o = e.nextAll(Re);
                    else {
                        if (!n || e.hasClass(Te)) return;
                        i.open(e), o = i._childPopupElement(e).children().first()
                    }
                    return !o.length && e.length ? o = e.parent().children().first() : e.length || (o = i.wrapper.children(".k-item").first()), i._moveHover(e, o), o
                },
                _itemUp: function(e, t) {
                    var n, o = this;
                    if (t) return n = e.prevAll(Re), !n.length && e.length ? n = e.parent().children().last() : e.length || (n = o.wrapper.children(".k-item").last()), o._moveHover(e, n), n
                },
                _scrollToItem: function(e) {
                    var t, n, o, i, r, a, s, l, p, c, u, d, f = this;
                    f.options.scrollable && e && e.length && (t = e.parent(), n = !!t.hasClass(J) && "horizontal" == f.options.orientation, o = n ? "scrollLeft" : "scrollTop", i = n ? O._outerWidth : O._outerHeight, r = t[o](), a = i(e), s = e[0][n ? "offsetLeft" : "offsetTop"], l = i(t), p = t.siblings(Le), c = p.length ? i(p.first()) : 0, r + l < s + a + c ? u = s + a - l + c : r > s - c && (u = s - c), isNaN(u) || (d = {}, d[o] = u, t.finish().animate(d, "fast", "linear", function() {
                        f._toggleScrollButtons(t, p.first(), p.last(), n)
                    })))
                },
                _itemEsc: function(e, t) {
                    var n, o = this;
                    return t ? (n = e.parent().closest(".k-item"), o.close(n), o._moveHover(e, n), n) : e
                },
                _childPopupElement: function(e) {
                    var t = e.find(".k-menu-group"),
                        n = this._overflowWrapper();
                    return !t.length && n && (t = _(e, n)), t
                },
                _triggerEvent: function(e) {
                    var t = this;
                    return t.trigger(e.type, {
                        type: e.type,
                        item: e.item
                    })
                },
                _focusHandler: function(t) {
                    var n = this,
                        o = e(O.eventTarget(t)).closest(Ee);
                    o.hasClass(Te) || setTimeout(function() {
                        n._moveHover([], o), o.children(".k-content")[0] && o.parent().closest(".k-item").removeClass(Oe)
                    }, 200)
                },
                _animations: function(e) {
                    e && "animation" in e && !e.animation && (e.animation = {
                        open: {
                            effects: {}
                        },
                        close: {
                            hide: !0,
                            effects: {}
                        }
                    })
                },
                _dataSource: function(e) {
                    var t = this,
                        n = e ? e.dataSource : t.options.dataSource;
                    n && (n = I(n) ? {
                        data: n
                    } : n, t._unbindDataSource(), n.fields || (n.fields = [{
                        field: "uid"
                    }, {
                        field: "text"
                    }, {
                        field: "url"
                    }, {
                        field: "cssClass"
                    }, {
                        field: "spriteCssClass"
                    }, {
                        field: "imageUrl"
                    }, {
                        field: "imageAttr"
                    }, {
                        field: "attr"
                    }, {
                        field: "contentAttr"
                    }, {
                        field: "content"
                    }, {
                        field: "encoded"
                    }, {
                        field: "items"
                    }, {
                        field: "select"
                    }]), t.dataSource = S.create(n), t._bindDataSource(), t.dataSource.fetch())
                },
                _bindDataSource: function() {
                    this._refreshHandler = B(this.refresh, this), this._errorHandler = B(this._error, this), this.dataSource.bind(le, this._refreshHandler), this.dataSource.bind(pe, this._errorHandler)
                },
                _unbindDataSource: function() {
                    var e = this.dataSource;
                    e && (e.unbind(le, this._refreshHandler), e.unbind(pe, this._errorHandler))
                },
                _error: function() {},
                findByUid: function(e) {
                    var t = this._overflowWrapper() || this.element;
                    return t.find("[" + O.attr("uid") + "=" + e + "]")
                },
                refresh: function(t) {
                    var n = this,
                        o = t.node,
                        i = t.action,
                        r = o ? n.findByUid(o.uid) : n.element,
                        a = t.items,
                        s = t.index,
                        l = e.proxy(n._updateItem, n),
                        p = e.proxy(n._removeItem, n);
                    "add" == i ? n._appendItems(a, s, r) : "remove" == i ? a.forEach(p) : "itemchange" == i ? a.forEach(l) : "itemloaded" === i ? n.append(t.items, r) : this._initData(), this.trigger(je, {
                        item: r,
                        dataItem: o
                    })
                },
                _appendItems: function(e, t, n) {
                    var o = this,
                        i = n.find(De).eq(t);
                    i.length ? o.insertBefore(e, i) : o.append(e, n)
                },
                _removeItem: function(e) {
                    var t = this,
                        n = t.findByUid(e.uid);
                    t.remove(n)
                },
                _updateItem: function(e) {
                    var t = this,
                        n = t.findByUid(e.uid),
                        o = n.next(),
                        i = e.parentNode();
                    t.remove(n), o.length ? t.insertBefore(e, o) : t.append(e, i && t.findByUid(i.uid))
                },
                _accessors: function() {
                    var e, t, n, o = this,
                        i = o.options,
                        r = o.element;
                    for (e in Je) t = i[Je[e]], n = r.attr(O.attr(e + "-field")), !t && n && (t = n), t || (t = e), I(t) || (t = [t]), i[Je[e]] = t
                },
                _fieldAccessor: function(t) {
                    var n = this.options[Je[t]] || [],
                        o = n.length,
                        i = "(function(item) {";
                    return 0 === o ? i += "return item['" + t + "'];" : (i += "var levels = [" + e.map(n, function(e) {
                        return "function(d){ return " + O.expr(e) + "}"
                    }).join(",") + "];", i += "if(item.level){return levels[Math.min(item.level(), " + o + "-1)](item);}else", i += "{return levels[" + o + "-1](item)}"), i += "})"
                },
                _templates: function() {
                    var e = this,
                        t = e.options,
                        n = B(e._fieldAccessor, e);
                    t.template && typeof t.template == Ge ? t.template = R(t.template) : t.template || (t.template = R("# var text = " + n("text") + "(data.item); ## if (typeof data.item.encoded != 'undefined' && data.item.encoded === false) {##= text ## } else { ##: text ## } #")), e.templates = {
                        content: R("#var contentHtml = " + n("content") + "(item);#<div #= contentCssAttributes(item.toJSON ? item.toJSON() : item) # tabindex='-1'>#= contentHtml || '' #</div>"),
                        group: R("<ul class='#= groupCssClass(group) #'#= groupAttributes(group) # role='menu' aria-hidden='true'>#= renderItems(data) #</ul>"),
                        itemWrapper: R("# var url = " + n("url") + "(item); ## var imageUrl = " + n("imageUrl") + "(item); ## var imgAttributes = " + n("imageAttr") + "(item);## var tag = url ? 'a' : 'span' #<#= tag # class='#= textClass(item) #' #if(url){#href='#= url #'#}#># if (imageUrl) { #<img #= imageCssAttributes(imgAttributes) #  alt='' src='#= imageUrl #' /># } ##= sprite(item) ##= data.menu.options.template(data) ##= arrow(data) #</#= tag #>"),
                        item: R("#var contentHtml = " + n("content") + "(item);#<li class='#= wrapperCssClass(group, item) #' #= itemCssAttributes(item.toJSON ? item.toJSON() : item) # role='menuitem'  #=item.items ? \"aria-haspopup='true'\": \"\"##=item.enabled === false ? \"aria-disabled='true'\" : ''#" + O.attr("uid") + "='#= item.uid #' >#= itemWrapper(data) ##if (item.hasChildren || item.items) { ##= subGroup({ items: item.items, menu: menu, group: { expanded: item.expanded } }) ## } else if (item.content || item.contentUrl || contentHtml) { ##= renderContent(data) ## } #</li>"),
                        scrollButton: R("<span class='k-button k-button-icon k-menu-scroll-button k-scroll-#= direction #' unselectable='on'><span class='k-icon k-i-arrow-60-#= direction #'></span></span>"),
                        arrow: R("<span class='#= arrowClass(item, group) #'></span>"),
                        sprite: R("# var spriteCssClass = " + n("spriteCssClass") + "(data); if(spriteCssClass) {#<span class='k-sprite #= spriteCssClass #'></span>#}#"),
                        empty: R("")
                    }
                },
                renderItem: function(e) {
                    var t, n, o = this;
                    return e = M({
                        menu: o,
                        group: {}
                    }, e), t = o.templates.empty, n = e.item, o.templates.item(M(e, {
                        sprite: o.templates.sprite,
                        itemWrapper: o.templates.itemWrapper,
                        renderContent: o.renderContent,
                        arrow: n.items || n.content || n[o.options.dataContentField[0]] ? o.templates.arrow : t,
                        subGroup: o.renderGroup
                    }, Ke))
                },
                renderGroup: function(e) {
                    var t = this,
                        n = t.templates || e.menu.templates;
                    return n.group(M({
                        renderItems: function(e) {
                            for (var t = "", n = 0, o = e.items, i = o ? o.length : 0, r = M({
                                    length: i
                                }, e.group); n < i; n++) t += e.menu.renderItem(M(e, {
                                group: r,
                                item: M({
                                    index: n
                                }, o[n])
                            }));
                            return t
                        }
                    }, e, Ke))
                },
                renderContent: function(e) {
                    return e.menu.templates.content(M(e, Ke))
                }
            }),
            Ye = Xe.extend({
                init: function(t, n) {
                    var o = this;
                    Xe.fn.init.call(o, t, n), o._marker = O.guid().substring(0, 8), o.target = e(o.options.target), o._popup(), o._wire()
                },
                _initOverflow: function(e) {
                    var t = this;
                    e.scrollable && !t._overflowWrapper() && (t._openedPopups = {}, t._popupsWrapper = (t.element.parent().is(Se) ? t.element.parent() : t.element).wrap("<div class='k-popups-wrapper " + e.orientation + "'></div>").parent(), "horizontal" == t.options.orientation && P(t.element), e.appendTo && e.appendTo.append(t._popupsWrapper), t._initialHeight = t.element[0].style.height, t._initialWidth = t.element[0].style.width)
                },
                options: {
                    name: "ContextMenu",
                    filter: null,
                    showOn: "contextmenu",
                    orientation: "vertical",
                    alignToAnchor: !1,
                    copyAnchorStyles: !0,
                    target: "body"
                },
                events: [j, V, ne, oe, ee],
                setOptions: function(t) {
                    var n = this;
                    Xe.fn.setOptions.call(n, t), n.target.off(n.showOn + F + n._marker, n._showProxy), n.userEvents && n.userEvents.destroy(), n.target = e(n.options.target), t.orientation && n.popup.wrapper[0] && n.popup.element.unwrap(), n._wire(), Xe.fn.setOptions.call(this, t)
                },
                destroy: function() {
                    var e = this;
                    e.target.off(e.options.showOn + F + e._marker), Ce.off(O.support.mousedown + F + e._marker, e._closeProxy), e.userEvents && e.userEvents.destroy(), Xe.fn.destroy.call(e)
                },
                open: function(n, o) {
                    var r, a, s = this;
                    return n = e(n)[0], i(s.element[0], e(n)[0]) || s._itemHasChildren(e(n)) ? Xe.fn.open.call(s, n) : s._triggerEvent({
                        item: s.element,
                        type: j
                    }) === !1 && (s.popup.visible() && s.options.filter && (s.popup.close(!0), s.popup.element.kendoStop(!0)), o !== t ? (r = s._overflowWrapper(), r && (a = r.offset(), n -= a.left, o -= a.top), s.popup.wrapper.hide(), s._configurePopupScrolling(n, o), s.popup.open(n, o)) : (s.popup.options.anchor = (n ? n : s.popup.anchor) || s.target, s.popup.element.kendoStop(!0), s._configurePopupScrolling(), s.popup.open()), Ce.off(s.popup.downEvent, s.popup._mousedownProxy), Ce.on(O.support.mousedown + F + s._marker, s._closeProxy)), s
                },
                _configurePopupScrolling: function(e, n) {
                    var o = this,
                        i = o.popup,
                        r = "horizontal" == o.options.orientation;
                    o.options.scrollable && (o._wrapPopupElement(i), i.element.parent().css({
                        position: "",
                        height: ""
                    }), i.element.css({
                        visibility: "hidden",
                        display: "",
                        position: ""
                    }), r ? o._setPopupWidth(i, isNaN(e) ? t : {
                        isFixed: !0,
                        x: e,
                        y: n
                    }) : o._setPopupHeight(i, isNaN(e) ? t : {
                        isFixed: !0,
                        x: e,
                        y: n
                    }), i.element.css({
                        visibility: "",
                        display: "none",
                        position: "absolute"
                    }), o._initPopupScrollButtons(i, r, !0), i.element.siblings(Le).hide())
                },
                _setPopupWidth: function(t, n) {
                    var o, i, r, a, s, l, p, c, u = t.element,
                        d = u.add(u.parent(Se));
                    d.width(this._initialWidth || ""), o = t._location(n), i = e(window).width(), r = o.width, a = Math.max(o.left, 0), s = n ? 0 : C(this._overflowWrapper()[0], "scrollLeft"), l = O.getShadows(u), p = i - l.left - l.right, c = p + s > r + a, c || d.css({
                        overflow: "hidden",
                        width: p - a + s + "px"
                    })
                },
                close: function() {
                    var t = this;
                    i(t.element[0], e(arguments[0])[0]) || t._itemHasChildren(arguments[0]) ? Xe.fn.close.call(t, arguments[0]) : t.popup.visible() && t._triggerEvent({
                        item: t.element,
                        type: V
                    }) === !1 && (t.popup.close(), Ce.off(O.support.mousedown + F + t._marker, t._closeProxy), t.unbind(ee, t._closeTimeoutProxy))
                },
                _showHandler: function(t) {
                    var n, o = t,
                        r = this,
                        a = r.options,
                        s = e(O.support.mobileOS ? o.target : o.currentTarget);
                    t.event && (o = t.event, o.pageX = t.x.location, o.pageY = t.y.location), i(r.element[0], t.relatedTarget || t.target) || (r._eventOrigin = o, o.preventDefault(), o.stopImmediatePropagation(), r.element.find("." + Oe).removeClass(Oe), (a.filter && s.is(a.filter) || !a.filter) && (a.alignToAnchor ? (r.popup.options.anchor = o.currentTarget, r.open(o.currentTarget)) : (r.popup.options.anchor = o.currentTarget, r._targetChild ? (n = r.target.offset(), r.open(o.pageX - n.left, o.pageY - n.top)) : r.open(o.pageX, o.pageY))))
                },
                _closeHandler: function(t) {
                    var n, o = this,
                        r = e(t.relatedTarget || t.target),
                        a = r.closest(o.target.selector)[0] == o.target[0],
                        s = r.closest(De),
                        l = o._itemHasChildren(s),
                        p = o._overflowWrapper(),
                        c = i(o.element[0], r[0]) || p && i(p[0], r[0]);
                    o._eventOrigin = t, n = 3 !== t.which, o.popup.visible() && (n && a || !a) && (o.options.closeOnClick && !l && c || !c) && (c ? (this.unbind(ee, this._closeTimeoutProxy), o.bind(ee, o._closeTimeoutProxy)) : o.close())
                },
                _wire: function() {
                    var e = this,
                        t = e.options,
                        n = e.target;
                    e._showProxy = B(e._showHandler, e), e._closeProxy = B(e._closeHandler, e), e._closeTimeoutProxy = B(e.close, e), n[0] && (O.support.mobileOS && "contextmenu" == t.showOn ? (e.userEvents = new O.UserEvents(n, {
                        filter: t.filter,
                        allowSelection: !1
                    }), n.on(t.showOn + F + e._marker, !1), e.userEvents.bind("hold", e._showProxy)) : t.filter ? n.on(t.showOn + F + e._marker, t.filter, e._showProxy) : n.on(t.showOn + F + e._marker, e._showProxy))
                },
                _triggerEvent: function(n) {
                    var o = this,
                        i = e(o.popup.options.anchor)[0],
                        r = o._eventOrigin;
                    return o._eventOrigin = t, o.trigger(n.type, M({
                        type: n.type,
                        item: n.item || this.element[0],
                        target: i
                    }, r ? {
                        event: r
                    } : {}))
                },
                _popup: function() {
                    var t = this,
                        n = t._overflowWrapper();
                    t._triggerProxy = B(t._triggerEvent, t), t.popup = t.element.addClass("k-context-menu").kendoPopup({
                        autosize: "horizontal" === t.options.orientation,
                        anchor: t.target || "body",
                        copyAnchorStyles: t.options.copyAnchorStyles,
                        collision: t.options.popupCollision || "fit",
                        animation: t.options.animation,
                        activate: t._triggerProxy,
                        deactivate: t._triggerProxy,
                        appendTo: n || t.options.appendTo,
                        close: n ? function(t) {
                            e(v(t.sender.element, n)).each(function(e, t) {
                                var n = t.data(be);
                                n && n.close(!0)
                            })
                        } : e.noop
                    }).data(be), t._targetChild = i(t.target[0], t.popup.element[0])
                }
            });
        T.plugin(Xe), T.plugin(Ye)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(e, define) {
    define("kendo.columnmenu.min", ["kendo.popup.min", "kendo.filtermenu.min", "kendo.menu.min"], e)
}(function() {
    return function(e, n) {
        function s(n) {
            return e.trim(n).replace(/&nbsp;/gi, "")
        }

        function t(e, n) {
            var s, t, i, l = {};
            for (s = 0, t = e.length; s < t; s++) i = e[s], l[i[n]] = i;
            return l
        }

        function i(e) {
            var n, s = [];
            for (n = 0; n < e.length; n++) e[n].columns ? s = s.concat(i(e[n].columns)) : s.push(e[n]);
            return s
        }

        function l(e, n) {
            return "[" + c.attr(e) + "='" + (n || "").replace(/'/g, '"') + "']"
        }

        function a(e, n, s) {
            e > 0 ? n.insertAfter(s.children().eq(e - 1)) : s.prepend(n)
        }

        function o(e) {
            var n, s, t = {};
            for (s = 0; s < e.length; s++) n = JSON.stringify(e[s]), t[n] ? t[n].push(s) : t[n] = [s];
            return t
        }

        function r(e, n) {
            var s, t, i, l, a, o, r = c.attr("index"),
                u = c.attr("field"),
                d = {};
            for (o = 0; o < e.length; o++) t = n.eq(o), i = parseInt(t.attr(r), 10), l = t.attr(u), a = t.attr("title"), s = l ? l : a, d[s] ? d[s].push(i) : d[s] = [i];
            return d
        }
        var c = window.kendo,
            u = c.ui,
            d = e.proxy,
            p = e.extend,
            m = e.grep,
            k = e.map,
            f = e.inArray,
            h = "k-state-selected",
            g = "asc",
            v = "desc",
            C = "change",
            w = "init",
            _ = "open",
            b = "select",
            M = "kendoPopup",
            x = "kendoFilterMenu",
            S = "kendoMenu",
            y = ".kendoColumnMenu",
            H = u.Widget,
            I = H.extend({
                init: function(n, s) {
                    var t, i = this;
                    H.fn.init.call(i, n, s), n = i.element, s = i.options, i.owner = s.owner, i.dataSource = s.dataSource, i.field = n.attr(c.attr("field")), i.title = n.attr(c.attr("title")), t = n.find(".k-header-column-menu"), t[0] || (t = n.addClass("k-with-icon").prepend('<a class="k-header-column-menu" href="#" title="' + s.messages.settings + '" aria-label="' + s.messages.settings + '"><span class="k-icon k-i-more-vertical"></span></a>').find(".k-header-column-menu")), i.link = t.attr("tabindex", -1).on("click" + y, d(i._click, i)), i.wrapper = e('<div class="k-column-menu"/>'), i._refreshHandler = d(i.refresh, i), i.dataSource.bind(C, i._refreshHandler)
                },
                _init: function() {
                    var e = this;
                    e.pane = e.options.pane, e.pane && (e._isMobile = !0), e._isMobile ? e._createMobileMenu() : e._createMenu(), e.owner._muteAngularRebind(function() {
                        e._angularItems("compile")
                    }), e._sort(), e._columns(), e._filter(), e._lockColumns(), e.trigger(w, {
                        field: e.field,
                        container: e.wrapper
                    })
                },
                events: [w, _, "sort", "filtering"],
                options: {
                    name: "ColumnMenu",
                    messages: {
                        sortAscending: "Sort Ascending",
                        sortDescending: "Sort Descending",
                        filter: "Filter",
                        column: "Column",
                        columns: "Columns",
                        columnVisibility: "Column Visibility",
                        clear: "Clear",
                        cancel: "Cancel",
                        done: "Done",
                        settings: "Edit Column Settings",
                        lock: "Lock",
                        unlock: "Unlock"
                    },
                    filter: "",
                    columns: !0,
                    sortable: !0,
                    filterable: !0,
                    animations: {
                        left: "slide"
                    }
                },
                _createMenu: function() {
                    var e = this,
                        n = e.options;
                    e.wrapper.html(c.template(L)({
                        uid: c.guid(),
                        ns: c.ns,
                        messages: n.messages,
                        sortable: n.sortable,
                        filterable: n.filterable,
                        columns: e._ownerColumns(),
                        showColumns: n.columns,
                        lockedColumns: n.lockedColumns
                    })), e.popup = e.wrapper[M]({
                        anchor: e.link,
                        open: d(e._open, e),
                        activate: d(e._activate, e),
                        deactivate: d(e._deactivate, e),
                        close: function() {
                            e.menu._closing = !0, e.options.closeCallback && e.options.closeCallback(e.element)
                        }
                    }).data(M), e.menu = e.wrapper.children()[S]({
                        orientation: "vertical",
                        closeOnClick: !1,
                        open: function() {
                            e._updateMenuItems()
                        }
                    }).data(S)
                },
                _deactivate: function() {
                    this.menu._closing = !1
                },
                _createMobileMenu: function() {
                    var e, n = this,
                        s = n.options,
                        t = c.template($)({
                            ns: c.ns,
                            field: n.field,
                            title: n.title || n.field,
                            messages: s.messages,
                            sortable: s.sortable,
                            filterable: s.filterable,
                            columns: n._ownerColumns(),
                            showColumns: s.columns,
                            lockedColumns: s.lockedColumns
                        });
                    n.view = n.pane.append(t), n.view.state = {
                        columns: {}
                    }, n.wrapper = n.view.element.find(".k-column-menu"), n.menu = new D(n.wrapper.children(), {
                        pane: n.pane,
                        columnMenu: n
                    }), n.menu.element.on("transitionend" + y, function(e) {
                        e.stopPropagation()
                    }), e = n.view.wrapper && n.view.wrapper[0] ? n.view.wrapper : n.view.element, e.on("click", ".k-header-done", function(e) {
                        e.preventDefault(), n.menu._applyChanges(), n.menu._cancelChanges(!1), n.close()
                    }), e.on("click", ".k-header-cancel", function(e) {
                        e.preventDefault(), n.menu._cancelChanges(!0), n.close()
                    }), n.view.bind("showStart", function() {
                        var e = n.view || {
                            columns: {}
                        };
                        n.options.lockedColumns && n._updateLockedColumns(), e.element.find(".k-sort-asc.k-state-selected").length ? e.state.initialSort = "asc" : e.element.find(".k-sort-desc.k-state-selected").length && (e.state.initialSort = "desc")
                    })
                },
                _angularItems: function(n) {
                    var s = this;
                    s.angular(n, function() {
                        var n = s.wrapper.find(".k-columns-item input[" + c.attr("field") + "]").map(function() {
                                return e(this).closest("li")
                            }),
                            t = k(s._ownerColumns(), function(e) {
                                return {
                                    column: e._originalObject
                                }
                            });
                        return {
                            elements: n,
                            data: t
                        }
                    })
                },
                destroy: function() {
                    var e = this;
                    e._angularItems("cleanup"), H.fn.destroy.call(e), e.filterMenu && e.filterMenu.destroy(), e._refreshHandler && e.dataSource.unbind(C, e._refreshHandler), e.options.columns && e.owner && (e._updateColumnsMenuHandler && (e.owner.unbind("columnShow", e._updateColumnsMenuHandler), e.owner.unbind("columnHide", e._updateColumnsMenuHandler)), e._updateColumnsLockedStateHandler && (e.owner.unbind("columnLock", e._updateColumnsLockedStateHandler), e.owner.unbind("columnUnlock", e._updateColumnsLockedStateHandler))), e.menu && (e.menu.element.off(y), e.menu.destroy()), e.wrapper.off(y), e.popup && e.popup.destroy(), e.view && e.view.purge(), e.link.off(y), e.owner = null, e.wrapper = null, e.element = null
                },
                close: function() {
                    this.menu.close(), this.popup && (this.popup.close(), this.popup.element.off("keydown" + y))
                },
                _click: function(e) {
                    var n, s = this;
                    e.preventDefault(), e.stopPropagation(), n = this.options, n.filter && this.element.is(!n.filter) || (this.popup || this.pane ? s._updateMenuItems() : this._init(), this._isMobile ? this.pane.navigate(this.view, this.options.animations.left) : this.popup.toggle())
                },
                _updateMenuItems: function() {
                    var e = this;
                    e._setMenuItemsVisibility(), e._reorderMenuItems()
                },
                _setMenuItemsVisibility: function() {
                    var e = this;
                    e._eachRenderedMenuItem(function(e, n, s) {
                        n.matchesMedia === !1 ? s.hide() : s.show()
                    })
                },
                _reorderMenuItems: function() {
                    var e = this;
                    e._eachRenderedMenuItem(function(e, n, s, t) {
                        s[0] && s.index() !== e && a(e, s, t)
                    })
                },
                _eachRenderedMenuItem: function(n) {
                    var t, a, c, u, d, p, k, f = this,
                        h = m(i(f.owner.columns), function(e) {
                            var n = !0,
                                t = s(e.title || "");
                            return e.menu !== !1 && (e.field || t.length) || (n = !1), n
                        }).map(function(e) {
                            return {
                                field: e.field,
                                title: e.title,
                                matchesMedia: e.matchesMedia
                            }
                        }),
                        g = f._isMobile && f.view ? e(f.view.element).find(".k-columns-item").children("ul") : e(f.wrapper).find(".k-menu-group").first(),
                        v = g.find("span." + (this._isMobile ? "k-listgroup-form-field-wrapper" : "k-menu-link")),
                        C = r(v, g.find("input[type=checkbox]")),
                        w = o(h);
                    for (p = 0; p < h.length; p++) {
                        for (u = h[p], c = u.field ? u.field : u.title, a = e.inArray(p, w[JSON.stringify(u)]), d = e(), k = 0; k < C[c].length; k++) d = d.add(v.eq(C[c][k]));
                        t = d.find(l("field", c)).closest("li").eq(a), n(p, u, t, g)
                    }
                },
                _open: function() {
                    var n = this;
                    e(".k-column-menu").not(n.wrapper).each(function() {
                        e(this).data(M).close()
                    }), n.popup.element.on("keydown" + y, function(e) {
                        e.keyCode == c.keys.ESC && n.close()
                    }), n.options.lockedColumns && n._updateLockedColumns()
                },
                _activate: function() {
                    this.menu.element.focus(), this.trigger(_, {
                        field: this.field,
                        container: this.wrapper
                    })
                },
                _ownerColumns: function() {
                    var e = i(this.owner.columns),
                        n = m(e, function(e) {
                            var n = !0,
                                t = s(e.title || "");
                            return e.menu !== !1 && (e.field || t.length) || (n = !1), n
                        });
                    return k(n, function(n) {
                        return {
                            originalField: n.field,
                            field: n.field || n.title,
                            title: n.title || n.field,
                            hidden: n.hidden,
                            matchesMedia: n.matchesMedia,
                            index: f(n, e),
                            locked: !!n.locked,
                            _originalObject: n
                        }
                    })
                },
                _sort: function() {
                    var n = this;
                    n.options.sortable && (n.refresh(), n.menu.bind(b, function(s) {
                        var t, i = e(s.item);
                        i.hasClass("k-sort-asc") ? t = g : i.hasClass("k-sort-desc") && (t = v), t && (i.parent().find(".k-sort-" + (t == g ? v : g)).removeClass(h), n._sortDataSource(i, t), n._isMobile || n.close())
                    }))
                },
                _sortDataSource: function(e, s) {
                    var t, i, l = this,
                        a = l.options.sortable,
                        o = null === a.compare ? n : a.compare,
                        r = l.dataSource,
                        c = r.sort() || [],
                        u = e.hasClass(h) && a && a.allowUnsort !== !1;
                    if (s = u ? n : s, !l.trigger("sort", {
                            sort: {
                                field: l.field,
                                dir: s,
                                compare: o
                            }
                        })) {
                        if (u ? e.removeClass(h) : e.addClass(h), "multiple" === a.mode) {
                            for (t = 0, i = c.length; t < i; t++)
                                if (c[t].field === l.field) {
                                    c.splice(t, 1);
                                    break
                                }
                            c.push({
                                field: l.field,
                                dir: s,
                                compare: o
                            })
                        } else c = [{
                            field: l.field,
                            dir: s,
                            compare: o
                        }];
                        r.sort(c)
                    }
                },
                _columns: function() {
                    var n = this;
                    n.options.columns && (n._updateColumnsMenu(), n._updateColumnsMenuHandler = d(n._updateColumnsMenu, n), n.owner.bind(["columnHide", "columnShow"], n._updateColumnsMenuHandler), n._updateColumnsLockedStateHandler = d(n._updateColumnsLockedState, n), n.owner.bind(["columnUnlock", "columnLock"], n._updateColumnsLockedStateHandler), n.menu.bind(b, function(t) {
                        var l, a, o = e(t.item),
                            r = m(i(n.owner.columns), function(e) {
                                var n = !0,
                                    t = s(e.title || "");
                                return e.menu !== !1 && (e.field || t.length) || (n = !1), n
                            });
                        n._isMobile && t.preventDefault(), o.parent().closest("li.k-columns-item")[0] && (l = o.find(":checkbox"), l.attr("disabled") || (a = r[o.index()], a.hidden === !0 ? n.owner.showColumn(a) : n.owner.hideColumn(a)))
                    }))
                },
                _updateColumnsMenu: function() {
                    var e, n, t, l, a, o, r, u = c.attr("field"),
                        d = c.attr("locked"),
                        p = m(i(this.owner.columns), function(e) {
                            var n = !0,
                                t = s(e.title || "");
                            return e.menu !== !1 && (e.field || t.length) || (n = !1), n
                        }),
                        k = m(this._ownerColumns(), function(e) {
                            return !e.hidden && e.matchesMedia !== !1
                        }),
                        f = m(k, function(e) {
                            return e.originalField
                        }),
                        h = m(f, function(e) {
                            return e.locked === !0
                        }).length,
                        g = m(f, function(e) {
                            return e.locked !== !0
                        }).length,
                        v = m(this.owner.columns, function(e) {
                            return e.menu === !1
                        }),
                        C = m(v, function(e) {
                            return e.hidden
                        });
                    for (this.wrapper.find("[role='menuitemcheckbox']").attr("aria-checked", !1), o = this.wrapper.find(".k-columns-item input[" + u + "]").prop("disabled", !1).prop("checked", !1), e = 0, n = o.length; e < n; e++) t = o.eq(e), a = "true" === t.attr(d), l = !1, r = t.data("kendoSwitch"), l = !p[e].hidden && p[e].matchesMedia !== !1, t.prop("checked", l), r && (r.enable(!0), r.check(l)), t.closest("[role='menuitemcheckbox']").attr("aria-checked", l), l && (1 == h && a && (t.prop("disabled", !0), r && r.enable(!1)), 0 !== v.length && v.length !== C.length || 1 != g || a || (t.prop("disabled", !0), r && r.enable(!1)))
                },
                _updateColumnsLockedState: function() {
                    var e, n, s, i, l = c.attr("field"),
                        a = c.attr("locked"),
                        o = t(this._ownerColumns(), "field"),
                        r = this.wrapper.find(".k-columns-item input[type=checkbox]");
                    for (e = 0, n = r.length; e < n; e++) s = r.eq(e), i = o[s.attr(l)], i && s.attr(a, i.locked);
                    this._updateColumnsMenu()
                },
                _filter: function() {
                    var n = this,
                        s = x,
                        t = n.options;
                    t.filterable !== !1 && (t.filterable.multi && (s = "kendoFilterMultiCheck", t.filterable.dataSource && (t.filterable.checkSource = t.filterable.dataSource, delete t.filterable.dataSource)), n.filterMenu = n.wrapper.find(".k-filterable")[s](p(!0, {}, {
                        appendToElement: !0,
                        dataSource: t.dataSource,
                        values: t.values,
                        field: n.field,
                        title: n.title,
                        change: function(e) {
                            n.trigger("filtering", {
                                filter: e.filter,
                                field: e.field
                            }) && e.preventDefault()
                        }
                    }, t.filterable)).data(s), n._isMobile && n.menu.bind(b, function(s) {
                        var t = e(s.item);
                        t.hasClass("k-filter-item") && n.pane.navigate(n.filterMenu.view, n.options.animations.left)
                    }))
                },
                _lockColumns: function() {
                    var n = this;
                    n.menu.bind(b, function(s) {
                        var t = e(s.item);
                        t.hasClass("k-lock") ? (n.owner.lockColumn(n.field), n._isMobile || n.close()) : t.hasClass("k-unlock") && (n.owner.unlockColumn(n.field), n._isMobile || n.close())
                    })
                },
                _updateLockedColumns: function() {
                    var e, n, s, t, i = this.field,
                        l = this.owner.columns,
                        a = m(l, function(e) {
                            return e.field == i || e.title == i
                        })[0];
                    a && (e = a.locked === !0, n = m(l, function(n) {
                        return !n.hidden && (n.locked && e || !n.locked && !e)
                    }).length, s = this.wrapper.find(".k-lock").removeClass("k-state-disabled"), t = this.wrapper.find(".k-unlock").removeClass("k-state-disabled"), (e || 1 == n) && s.addClass("k-state-disabled"), e && 1 != n || t.addClass("k-state-disabled"), this._updateColumnsLockedState())
                },
                refresh: function() {
                    var e, n, s, t = this,
                        i = t.options.dataSource.sort() || [],
                        l = t.field;
                    for (t.wrapper.find(".k-sort-asc, .k-sort-desc").removeClass(h), n = 0, s = i.length; n < s; n++) e = i[n], l == e.field && t.wrapper.find(".k-sort-" + e.dir).addClass(h);
                    t.link[t._filterExist(t.dataSource.filter()) ? "addClass" : "removeClass"]("k-state-active")
                },
                _filterExist: function(e) {
                    var n, s, t, i = !1;
                    if (e) {
                        for (e = e.filters, s = 0, t = e.length; s < t; s++) n = e[s], n.field == this.field ? i = !0 : n.filters && (i = i || this._filterExist(n));
                        return i
                    }
                }
            }),
            L = '<ul id="#=uid#">#if(sortable){#<li class="k-item k-sort-asc"><span class="k-link"><span class="k-icon k-i-sort-asc-sm"></span>${messages.sortAscending}</span></li><li class="k-item k-sort-desc"><span class="k-link"><span class="k-icon k-i-sort-desc-sm"></span>${messages.sortDescending}</span></li>#if(showColumns || filterable){#<li class="k-separator" role="presentation"></li>#}##}##if(showColumns){#<li class="k-item k-columns-item" aria-haspopup="true"><span class="k-link"><span class="k-icon k-i-columns"></span>${messages.columns}</span><ul>#for (var idx = 0; idx < columns.length; idx++) {#<li role="menuitemcheckbox" aria-checked="false" #=columns[idx].matchesMedia === false ? "style=\'display:none;\'" : ""#><input type="checkbox" title="#=columns[idx].title#" data-#=ns#field="#=columns[idx].field.replace(/"/g,"&\\#34;")#" data-#=ns#index="#=columns[idx].index#" data-#=ns#locked="#=columns[idx].locked#"/>#=columns[idx].title#</li>#}#</ul></li>#if(filterable || lockedColumns){#<li class="k-separator" role="presentation"></li>#}##}##if(filterable){#<li class="k-item k-filter-item" aria-haspopup="true"><span class="k-link"><span class="k-icon k-i-filter"></span>${messages.filter}</span><ul><li><div class="k-filterable"></div></li></ul></li>#if(lockedColumns){#<li class="k-separator" role="presentation"></li>#}##}##if(lockedColumns){#<li class="k-item k-lock"><span class="k-link"><span class="k-icon k-i-lock"></span>${messages.lock}</span></li><li class="k-item k-unlock"><span class="k-link"><span class="k-icon k-i-unlock"></span>${messages.unlock}</span></li>#}#</ul>',
            $ = '<div data-#=ns#role="view" class="k-grid-column-menu"><div data-#=ns#role="header" class="k-header"><a href="\\#" class="k-header-cancel k-link" title="#=messages.cancel#" aria-label="#=messages.cancel#"><span class="k-icon k-i-arrow-chevron-left"></span></a>${messages.settings}<a href="\\#" class="k-header-done k-link" title="#=messages.done#" aria-label="#=messages.done#"><span class="k-icon k-i-check"></span></a></div><div class="k-column-menu"><ul class="k-reset"><li><span class="k-list-title">#=messages.column#: ${title}</span><ul class="k-listgroup k-listgroup-flush">#if(sortable){#<li id="#=kendo.guid()#" class="k-item k-listgroup-item k-sort-asc"><span class="k-link"><span class="k-icon k-i-sort-asc-sm"></span><span class="k-item-title">${messages.sortAscending}</span></span></li><li id="#=kendo.guid()#" class="k-item k-listgroup-item k-sort-desc"><span class="k-link"><span class="k-icon k-i-sort-desc-sm"></span><span class="k-item-title">${messages.sortDescending}</span></span></li>#}##if(lockedColumns){#<li id="#=kendo.guid()#" class="k-item k-listgroup-item k-lock"><span class="k-link"><span class="k-icon k-i-lock"></span><span class="k-item-title">${messages.lock}</span></span></li><li id="#=kendo.guid()#" class="k-item k-listgroup-item k-unlock"><span class="k-link"><span class="k-icon k-i-unlock"></span><span class="k-item-title">${messages.unlock}</span></span></li>#}##if(filterable){#<li id="#=kendo.guid()#" class="k-item k-listgroup-item k-filter-item"><span class="k-link k-filterable"><span class="k-icon k-i-filter"></span><span class="k-item-title">${messages.filter}</span><span class="k-select"><span class="k-icon k-i-arrow-chevron-right"></span></span></span></li>#}#</ul></li>#if(showColumns){#<li class="k-columns-item"><span class="k-list-title">${messages.columnVisibility}</span><ul class="k-listgroup k-listgroup-flush">#for (var idx = 0; idx < columns.length; idx++) {#<li id="#=kendo.guid()#" class="k-item k-listgroup-item"><span class="k-listgroup-form-row"><span class="k-listgroup-form-field-label k-item-title">#=columns[idx].title#</span><span class="k-listgroup-form-field-wrapper"><input type="checkbox" title="#=columns[idx].title#"  data-#=ns#field="#=columns[idx].field.replace(/"/g,"&\\#34;")#" data-#=ns#index="#=columns[idx].index#" data-#=ns#locked="#=columns[idx].locked#" /></span></span></li>#}#</ul></li>#}#<li class="k-item k-clear-wrap"><span class="k-list-title">&nbsp;</span><ul class="k-listgroup k-listgroup-flush"><li class="k-listgroup-item"><span class="k-link k-label k-clear" title="#=messages.clear#" aria-label="#=messages.clear#">#=messages.clear#</span></li></ul></li></ul></div></div>',
            D = H.extend({
                init: function(e, n) {
                    var s = this;
                    H.fn.init.call(s, e, n), s._createCheckBoxes(), s.element.on("click" + y, "li.k-item:not(.k-separator):not(.k-state-disabled):not(:has(.k-switch))", "_click")
                },
                events: [b],
                _click: function(s) {
                    var t = this;
                    return e(s.target).is("[type=checkbox]") || s.preventDefault(), e(s.target).hasClass("k-clear") ? (t._cancelChanges(!0), n) : e(s.target).hasClass("k-filterable") ? (t._cancelChanges(!0), t.trigger(b, {
                        item: s.currentTarget
                    }), n) : (t._updateSelectedItems(s.currentTarget), n)
                },
                _updateSelectedItems: function(n) {
                    var s, t, i, l = this,
                        a = e(n),
                        o = l.options.columnMenu.view.state || {
                            columns: {}
                        },
                        r = a.prop("id");
                    a.hasClass("k-filter-item") || (o[r] = !o[r], (a.hasClass("k-sort-asc") || a.hasClass("k-sort-desc")) && (a.hasClass("k-sort-asc") ? (s = "asc", t = l.element.find(".k-sort-desc")) : (s = "desc", t = l.element.find(".k-sort-asc")), i = t.prop("id"), s !== o.initialSort || a.hasClass("k-state-selected") || (o[r] = !1), o[i] && (o[i] = !1), t.removeClass(h)), a.hasClass(h) ? a.removeClass(h) : a.addClass(h))
                },
                _cancelChanges: function(e) {
                    var n, s, t, i, l = this,
                        a = l.options.columnMenu,
                        o = a.view,
                        r = o.state || {
                            columns: {}
                        },
                        c = r.columns;
                    if (l.element.find("." + h).removeClass(h), a.refresh(), e) {
                        n = [];
                        for (s in c) c.hasOwnProperty(s) && c[s] === !0 && (t = o.element.find("#" + s), n.push(t[0]));
                        for (i = n.length - 1; i >= 0; i--) l.trigger(b, {
                            item: n[i]
                        });
                        a.options.lockedColumns && a._updateLockedColumns()
                    }
                    l.options.columnMenu.view.state = {
                        columns: {}
                    }
                },
                _applyChanges: function() {
                    var e, n, s = this,
                        t = s.options.columnMenu.view,
                        i = t.state || {
                            columns: {}
                        };
                    for (e in i) i.hasOwnProperty(e) && "initialSort" !== e && "columns" !== e && i[e] === !0 && (n = t.element.find("#" + e), n.hasClass(h) ? n.removeClass(h) : n.addClass(h), s.trigger(b, {
                        item: n[0]
                    }))
                },
                _createCheckBoxes: function() {
                    var e = this;
                    e.element.find(".k-columns-item").find("[type='checkbox']").kendoSwitch({
                        messages: {
                            checked: "",
                            unchecked: ""
                        },
                        change: function(n) {
                            var s = n.sender.element.closest(".k-item"),
                                t = e.options.columnMenu.view.state || {
                                    columns: {}
                                },
                                i = s.prop("id");
                            t.columns[i] = !t.columns[i], e.trigger(b, {
                                item: s
                            })
                        }
                    })
                },
                _destroyCheckBoxes: function() {
                    var e, n, s = this,
                        t = s.element.find(".k-columns-item").find("[type='checkbox']");
                    for (n = 0; n < t.length; n++) e = t.eq(n).data("kendoSwitch"), e && e.destroy()
                },
                close: function() {
                    this.options.pane.navigate("")
                },
                destroy: function() {
                    var e = this;
                    H.fn.destroy.call(e), e.element.off(y), e._destroyCheckBoxes()
                }
            });
        u.plugin(I)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, n, s) {
    (s || n)()
});;
! function(t, define) {
    define("kendo.groupable.min", ["kendo.core.min", "kendo.draganddrop.min"], t)
}(function() {
    return function(t, e) {
        var r = window.kendo,
            a = r.ui.Widget,
            n = r._outerWidth,
            i = r.attr,
            o = t.extend,
            d = t.each,
            s = t.proxy,
            l = !1,
            g = "dir",
            c = "field",
            u = "title",
            p = "asc",
            f = "desc",
            h = "group-sort",
            m = ".kendoGroupable",
            k = "change",
            v = r.template('<div class="k-group-indicator" data-#=data.ns#field="${data.field}" data-#=data.ns#title="${data.title || ""}" data-#=data.ns#dir="${data.dir || "asc"}"><a href="\\#" class="k-link"><span class="k-icon k-i-sort-${(data.dir || "asc") == "asc" ? "asc-sm" : "desc-sm"}" title="(sorted ${(data.dir || "asc") == "asc" ? "ascending": "descending"})"></span>${data.title ? data.title: data.field}</a><a class="k-button k-button-icon k-bare"><span class="k-icon k-i-close"></span></a></div>', {
                useWithBlock: !1
            }),
            _ = function(e) {
                var a = e.attr(r.attr("title"));
                return a && (a = r.htmlEncode(a)), t('<div class="k-header k-group-clue k-drag-clue" />').html(a || e.attr(r.attr("field"))).prepend('<span class="k-icon k-drag-status k-i-cancel" />')
            },
            C = t('<div class="k-grouping-dropclue"/>'),
            b = a.extend({
                init: function(d, c) {
                    var u, v, b = this,
                        I = r.guid(),
                        D = s(b._intializePositions, b),
                        y = b._dropCuePositions = [];
                    a.fn.init.call(b, d, c), l = r.support.isRtl(d), v = l ? "right" : "left", b.draggable = u = b.options.draggable || new r.ui.Draggable(b.element, {
                        filter: b.options.draggableElements,
                        hint: _,
                        group: I
                    }), b.groupContainer = t(b.options.groupContainer, b.element).kendoDropTarget({
                        group: u.options.group,
                        dragenter: function(t) {
                            b._canDrag(t.draggable.currentTarget) && (t.draggable.hint.find(".k-drag-status").removeClass("k-i-cancel").addClass("k-i-plus"), C.css(v, 0).appendTo(b.groupContainer))
                        },
                        dragleave: function(t) {
                            t.draggable.hint.find(".k-drag-status").removeClass("k-i-plus").addClass("k-i-cancel"), C.remove()
                        },
                        drop: function(e) {
                            var a, n = e.draggable.currentTarget,
                                i = n.attr(r.attr("field")),
                                d = n.attr(r.attr("title")),
                                s = b.indicator(i),
                                g = b._dropCuePositions,
                                c = g[g.length - 1],
                                u = o({}, b.options.sort, n.data(h)),
                                p = u.dir;
                            (n.hasClass("k-group-indicator") || b._canDrag(n)) && (c ? (a = b._dropCuePosition(r.getOffset(C).left + parseInt(c.element.css("marginLeft"), 10) * (l ? -1 : 1) + parseInt(c.element.css("marginRight"), 10)), a && b._canDrop(t(s), a.element, a.left) && (a.before ? a.element.before(s || b.buildIndicator(i, d, p)) : a.element.after(s || b.buildIndicator(i, d, p)), b._setIndicatorSortOptions(i, u), b._change())) : (b.groupContainer.empty(), b.groupContainer.append(b.buildIndicator(i, d, p)), b._setIndicatorSortOptions(i, u), b._change()))
                        }
                    }).kendoDraggable({
                        filter: "div.k-group-indicator",
                        hint: _,
                        group: u.options.group,
                        dragcancel: s(b._dragCancel, b),
                        dragstart: function(t) {
                            var e = t.currentTarget,
                                r = parseInt(e.css("marginLeft"), 10),
                                a = e.position(),
                                i = l ? a.left - r : a.left + n(e);
                            D(), C.css("left", i).appendTo(b.groupContainer), this.hint.find(".k-drag-status").removeClass("k-i-cancel").addClass("k-i-plus")
                        },
                        dragend: function() {
                            b._dragEnd(this)
                        },
                        drag: s(b._drag, b)
                    }).on("click" + m, ".k-button", function(e) {
                        e.preventDefault(), b._removeIndicator(t(this).parent())
                    }).on("click" + m, ".k-link", function(e) {
                        var r = t(this).parent(),
                            a = r.attr(i(g)) === p ? f : p;
                        r.attr(i(g), a), b._change(), e.preventDefault()
                    }), u.bind(["dragend", "dragcancel", "dragstart", "drag"], {
                        dragend: function() {
                            b._dragEnd(this)
                        },
                        dragcancel: s(b._dragCancel, b),
                        dragstart: function(t) {
                            var r, a, i;
                            return b.options.allowDrag || b._canDrag(t.currentTarget) ? (D(), y.length ? (r = y[y.length - 1].element, a = parseInt(r.css("marginRight"), 10), i = r.position().left + n(r) + a) : i = 0, e) : (t.preventDefault(), e)
                        },
                        drag: s(b._drag, b)
                    }), b.dataSource = b.options.dataSource, b.dataSource && b._refreshHandler ? b.dataSource.unbind(k, b._refreshHandler) : b._refreshHandler = s(b.refresh, b), b.dataSource && (b.dataSource.bind("change", b._refreshHandler), b.refresh())
                },
                refresh: function() {
                    var e, r = this,
                        a = r.dataSource,
                        n = a.group() || [],
                        s = i(c),
                        l = i(u);
                    r.groupContainer && (r.groupContainer.empty(), d(n, function(a, n) {
                        var i = n.field,
                            d = n.dir,
                            g = r.element.find(r.options.filter).filter(function() {
                                return t(this).attr(s) === i
                            });
                        e = r.buildIndicator(i, g.attr(l), d), r.groupContainer.append(e), r._setIndicatorSortOptions(i, o({}, r.options.sort, {
                            dir: d,
                            compare: n.compare
                        }))
                    })), r._invalidateGroupContainer()
                },
                destroy: function() {
                    var t = this;
                    a.fn.destroy.call(t), t.groupContainer.off(m), t.groupContainer.data("kendoDropTarget") && t.groupContainer.data("kendoDropTarget").destroy(), t.groupContainer.data("kendoDraggable") && t.groupContainer.data("kendoDraggable").destroy(), t.options.draggable || t.draggable.destroy(), t.dataSource && t._refreshHandler && (t.dataSource.unbind("change", t._refreshHandler), t._refreshHandler = null), t.groupContainer = t.element = t.draggable = null
                },
                events: ["change"],
                options: {
                    name: "Groupable",
                    filter: "th",
                    draggableElements: "th",
                    messages: {
                        empty: "Drag a column header and drop it here to group by that column"
                    },
                    sort: {
                        dir: p,
                        compare: null
                    }
                },
                indicator: function(e) {
                    var a = t(".k-group-indicator", this.groupContainer);
                    return t.grep(a, function(a) {
                        return t(a).attr(r.attr("field")) === e
                    })[0]
                },
                buildIndicator: function(t, e, a) {
                    var n = this,
                        i = v({
                            ns: r.ns,
                            field: t.replace(/"/g, "'"),
                            title: e,
                            dir: a || (n.options.sort || {}).dir || p
                        });
                    return i
                },
                _setIndicatorSortOptions: function(e, r) {
                    var a = t(this.indicator(e));
                    a.data(h, r)
                },
                aggregates: function() {
                    var e, a, n, i = this;
                    return i.element.find(i.options.filter).map(function() {
                        var i = t(this),
                            o = i.attr(r.attr("aggregates")),
                            d = i.attr(r.attr("field"));
                        if (o && "" !== o)
                            for (e = o.split(","), o = [], a = 0, n = e.length; a < n; a++) o.push({
                                field: d,
                                aggregate: e[a]
                            });
                        return o
                    }).toArray()
                },
                descriptors: function() {
                    var e, a = this,
                        n = t(".k-group-indicator", a.groupContainer),
                        i = a.aggregates();
                    return t.map(n, function(n) {
                        var o, d;
                        return n = t(n), e = n.attr(r.attr("field")), o = a.options.sort || {}, d = n.data(h) || {}, {
                            field: e,
                            dir: n.attr(r.attr("dir")),
                            aggregates: i || [],
                            compare: d.compare || o.compare
                        }
                    })
                },
                _removeIndicator: function(t) {
                    var e = this;
                    t.off(), t.removeData(), t.remove(), e._invalidateGroupContainer(), e._change()
                },
                _change: function() {
                    var t, r = this;
                    if (r.dataSource) {
                        if (t = r.descriptors(), r.trigger("change", {
                                groups: t
                            })) return r.refresh(), e;
                        r.dataSource.group(t)
                    }
                },
                _dropCuePosition: function(e) {
                    var r, a, i, o, d, s = this._dropCuePositions;
                    if (C.is(":visible") && 0 !== s.length) return e = Math.ceil(e), r = s[s.length - 1], a = r.left, i = r.right, o = parseInt(r.element.css("marginLeft"), 10), d = parseInt(r.element.css("marginRight"), 10), e >= i && !l || e < a && l ? e = {
                        left: r.element.position().left + (l ? -o : n(r.element) + d),
                        element: r.element,
                        before: !1
                    } : (e = t.grep(s, function(t) {
                        return t.left <= e && e <= t.right || l && e > t.right
                    })[0], e && (e = {
                        left: l ? e.element.position().left + n(e.element) + d : e.element.position().left - o,
                        element: e.element,
                        before: !0
                    })), e
                },
                _drag: function(t) {
                    var e = this._dropCuePosition(t.x.location);
                    e && C.css({
                        left: e.left,
                        right: "auto"
                    })
                },
                _canDrag: function(t) {
                    var e = t.attr(r.attr("field"));
                    return "false" != t.attr(r.attr("groupable")) && e && (t.hasClass("k-group-indicator") || !this.indicator(e))
                },
                _canDrop: function(t, e, r) {
                    var a = t.next(),
                        n = t[0] !== e[0] && (!a[0] || e[0] !== a[0] || !l && r > a.position().left || l && r < a.position().left);
                    return n
                },
                _dragEnd: function(e) {
                    var a = this,
                        n = e.currentTarget.attr(r.attr("field")),
                        i = a.indicator(n);
                    e !== a.options.draggable && !e.dropped && i && a._removeIndicator(t(i)), a._dragCancel()
                },
                _dragCancel: function() {
                    C.remove(), this._dropCuePositions = []
                },
                _intializePositions: function() {
                    var e, a = this,
                        i = t(".k-group-indicator", a.groupContainer);
                    a._dropCuePositions = t.map(i, function(a) {
                        return a = t(a), e = r.getOffset(a).left, {
                            left: parseInt(e, 10),
                            right: parseInt(e + n(a), 10),
                            element: a
                        }
                    })
                },
                _invalidateGroupContainer: function() {
                    var t = this.groupContainer;
                    t && t.is(":empty") && t.html(this.options.messages.empty)
                }
            });
        r.ui.plugin(b)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, r) {
    (r || e)()
});;
! function(e, define) {
    define("kendo.filtercell.min", ["kendo.autocomplete.min", "kendo.datepicker.min", "kendo.numerictextbox.min", "kendo.combobox.min", "kendo.dropdownlist.min"], e)
}(function() {
    return function(e, t) {
        function r(t) {
            var r = "string" == typeof t ? t : t.operator;
            return e.inArray(r, v) > -1
        }

        function a(t, r) {
            var o, n, l = [];
            if (e.isPlainObject(t))
                if (t.hasOwnProperty("filters")) l = t.filters;
                else if (t.field == r) return t;
            for (e.isArray(t) && (l = t), o = 0; o < l.length; o++)
                if (n = a(l[o], r)) return n
        }

        function o(t, r) {
            t.filters && (t.filters = e.grep(t.filters, function(e) {
                return o(e, r), e.filters ? e.filters.length : e.field != r
            }))
        }

        function n(e, t) {
            var r = l.getter(t, !0);
            return function(t) {
                for (var a, o, n = e(t), l = [], i = 0, s = {}; i < n.length;) a = n[i++], o = r(a), s.hasOwnProperty(o) || (l.push(a), s[o] = !0);
                return l
            }
        }
        var l = window.kendo,
            i = l.ui,
            s = l.data.DataSource,
            u = i.Widget,
            p = "change",
            d = "boolean",
            c = "enums",
            f = "string",
            g = "Is equal to",
            h = "Is not equal to",
            m = e.proxy,
            v = ["isnull", "isnotnull", "isempty", "isnotempty", "isnullorempty", "isnotnullorempty"],
            w = u.extend({
                init: function(a, o) {
                    var n, i, s, g, h, v, w, b, y, I, S, D, _;
                    if (a = e(a).addClass("k-filtercell"), n = this.wrapper = e("<span/>").appendTo(a), i = this, h = o, b = i.operators = o.operators || {}, y = i.input = e("<input/>").attr(l.attr("bind"), "value: value").appendTo(n), I = o ? o.suggestDataSource : null, I && (o = e.extend({}, o, {
                            suggestDataSource: {}
                        })), u.fn.init.call(i, a[0], o), I && (i.options.suggestDataSource = I), o = i.options, s = i.dataSource = o.dataSource, i.model = s.reader.model, w = o.type = f, S = l.getter("reader.model.fields", !0)(s) || {}, D = S[o.field], D && D.type && (w = o.type = D.type), o.values && (o.type = w = c), b = b[w] || o.operators[w], !h.operator)
                        for (v in b) {
                            o.operator = v;
                            break
                        }
                    i._parse = function(e) {
                        return null != e ? e + "" : e
                    }, i.model && i.model.fields && (_ = i.model.fields[o.field], _ && _.parse && (i._parse = m(_.parse, _))), i.defaultOperator = o.operator, i.viewModel = g = l.observable({
                        operator: o.operator,
                        value: null,
                        operatorVisible: function() {
                            var e = this.get("value");
                            return null !== e && e !== t && "undefined" != e || r(this.get("operator")) && !i._clearInProgress
                        }
                    }), g.bind(p, m(i.updateDsFilter, i)), w == f && i.initSuggestDataSource(o), null !== o.inputWidth && (y.addClass("k-sized-input"), y.width(o.inputWidth)), y.attr("aria-label", i._getColumnTitle()), y.attr("title", i._getColumnTitle()), i._setInputType(o, w), w != d && o.showOperators !== !1 ? i._createOperatorDropDown(b) : (e('<div unselectable="on" />').css("display", "none").text("eq").appendTo(n), n.addClass("k-operator-hidden")), i._createClearIcon(), l.bind(this.wrapper, g), w == f && (o.template || i.setAutoCompleteSource()), w == c && i.setComboBoxSource(i.options.values), i._refreshUI(), i._refreshHandler = m(i._refreshUI, i), i.dataSource.bind(p, i._refreshHandler)
                },
                _setInputType: function(t, r) {
                    var a, o, n, i, s, u = this,
                        p = u.input;
                    "function" == typeof t.template ? (t.template.call(u.viewModel, {
                        element: u.input,
                        dataSource: u.suggestDataSource
                    }), u._angularItems("compile")) : r == f ? p.attr(l.attr("role"), "autocomplete").attr(l.attr("text-field"), t.dataTextField || t.field).attr(l.attr("filter"), t.suggestionOperator).attr(l.attr("delay"), t.delay).attr(l.attr("min-length"), t.minLength).attr(l.attr("value-primitive"), !0) : "date" == r ? p.attr(l.attr("role"), "datepicker") : r == d ? (p.remove(), a = e("<input type='radio'/>"), o = u.wrapper, n = l.guid(), i = e("<label/>").text(t.messages.isTrue).append(a), a.attr(l.attr("bind"), "checked:value").attr("name", n).val("true"), s = i.clone().text(t.messages.isFalse), a.clone().val("false").appendTo(s), o.append([i, s])) : "number" == r ? p.attr(l.attr("role"), "numerictextbox").attr("title", u._getColumnTitle()) : r == c && p.attr(l.attr("role"), "combobox").attr(l.attr("text-field"), "text").attr(l.attr("suggest"), !0).attr(l.attr("filter"), "contains").attr(l.attr("value-field"), "value").attr(l.attr("value-primitive"), !0)
                },
                _getColumnTitle: function() {
                    var e = this.options.column;
                    return e ? e.title || e.field : ""
                },
                _createOperatorDropDown: function(t) {
                    var r, a, o = [],
                        n = this.viewModel;
                    for (r in t) o.push({
                        text: t[r],
                        value: r
                    });
                    a = e('<input class="k-dropdown-operator" ' + l.attr("bind") + '="value: operator"/>').appendTo(this.wrapper), this.operatorDropDown = a.kendoDropDownList({
                        dataSource: o,
                        dataTextField: "text",
                        dataValueField: "value",
                        open: function() {
                            this.popup.element.width(150)
                        },
                        valuePrimitive: !0
                    }).data("kendoDropDownList"), n.bind("change", function() {
                        var e = t[n.operator];
                        a.attr("aria-label", e)
                    }), this.operatorDropDown.wrapper.find(".k-i-arrow-60-down").removeClass("k-i-arrow-60-down").addClass("k-i-filter")
                },
                initSuggestDataSource: function(e) {
                    var r = e.suggestDataSource;
                    r instanceof s || (!e.customDataSource && r && (r.group = t), r = this.suggestDataSource = s.create(r)), e.customDataSource || (r._pageSize = t, r.reader.data = n(r.reader.data, this.options.field)), this.suggestDataSource = r
                },
                setAutoCompleteSource: function() {
                    var e = this.input.data("kendoAutoComplete");
                    e && e.setDataSource(this.suggestDataSource)
                },
                setComboBoxSource: function(e) {
                    var t = s.create({
                            data: e
                        }),
                        r = this.input.data("kendoComboBox");
                    r && !this.options.template && r.setDataSource(t)
                },
                _refreshUI: function() {
                    var t = this,
                        r = a(t.dataSource.filter(), this.options.field) || {},
                        o = t.viewModel;
                    t.manuallyUpdatingVM = !0, r = e.extend(!0, {}, r), t.options.type == d && o.value !== r.value && t.wrapper.find(":radio").prop("checked", !1), r.operator && o.set("operator", r.operator), o.set("value", r.value), t.manuallyUpdatingVM = !1
                },
                updateDsFilter: function(a) {
                    var o, n, l, i, s = this,
                        u = s.viewModel;
                    s.manuallyUpdatingVM || "operator" == a.field && u.value === t && !r(u) || "operator" == a.field && s._clearInProgress && null !== u.value || (o = e.extend({}, s.viewModel.toJSON(), {
                        field: s.options.field
                    }), n = {
                        logic: "and",
                        filters: []
                    }, l = !1, (o.value !== t && null !== o.value || r(o) && !this._clearInProgress) && (n.filters.push(o), l = s.trigger(p, {
                        filter: n,
                        field: s.options.field
                    })), (s._clearInProgress || null === o.value) && (l = s.trigger(p, {
                        filter: null,
                        field: s.options.field
                    })), l || (i = s._merge(n), s.dataSource.filter(i.filters.length ? i : {})))
                },
                _merge: function(t) {
                    var a, n, l, i = this,
                        s = t.logic || "and",
                        u = t.filters,
                        p = i.dataSource.filter() || {
                            filters: [],
                            logic: "and"
                        };
                    for (o(p, i.options.field), n = 0, l = u.length; n < l; n++) a = u[n], a.value = i._parse(a.value);
                    return u = e.grep(u, function(e) {
                        return "" !== e.value && null !== e.value || r(e)
                    }), u.length && (p.filters.length ? (t.filters = u, "and" !== p.logic && (p.filters = [{
                        logic: p.logic,
                        filters: p.filters
                    }], p.logic = "and"), p.filters.push(u.length > 1 ? t : u[0])) : (p.filters = u, p.logic = s)), p
                },
                _createClearIcon: function() {
                    var t = this;
                    e("<button type='button' class='k-button k-button-icon' title = " + t.options.messages.clear + "/>").attr("aria-label", t.options.messages.clear).attr(l.attr("bind"), "visible:operatorVisible").html("<span class='k-icon k-i-filter-clear'/>").click(m(t.clearFilter, t)).appendTo(t.wrapper)
                },
                clearFilter: function() {
                    this._clearInProgress = !0, r(this.viewModel.operator) && this.viewModel.set("operator", this.defaultOperator), this.viewModel.set("value", null), this._clearInProgress = !1
                },
                _angularItems: function(e) {
                    var t = this.wrapper.closest("th").get(),
                        r = this.options.column;
                    this.angular(e, function() {
                        return {
                            elements: t,
                            data: [{
                                column: r
                            }]
                        }
                    })
                },
                destroy: function() {
                    var e = this;
                    e.filterModel = null, e.operatorDropDown = null, e._angularItems("cleanup"), e._refreshHandler && (e.dataSource.bind(p, e._refreshHandler), e._refreshHandler = null), l.unbind(e.element), u.fn.destroy.call(e), l.destroy(e.element)
                },
                events: [p],
                options: {
                    name: "FilterCell",
                    delay: 200,
                    minLength: 1,
                    inputWidth: null,
                    values: t,
                    customDataSource: !1,
                    field: "",
                    dataTextField: "",
                    type: "string",
                    suggestDataSource: null,
                    suggestionOperator: "startswith",
                    operator: "eq",
                    showOperators: !0,
                    template: null,
                    messages: {
                        isTrue: "is true",
                        isFalse: "is false",
                        filter: "Filter",
                        clear: "Clear",
                        operator: "Operator"
                    },
                    operators: {
                        string: {
                            eq: g,
                            neq: h,
                            startswith: "Starts with",
                            contains: "Contains",
                            doesnotcontain: "Does not contain",
                            endswith: "Ends with",
                            isnull: "Is null",
                            isnotnull: "Is not null",
                            isempty: "Is empty",
                            isnotempty: "Is not empty",
                            isnullorempty: "Has no value",
                            isnotnullorempty: "Has value"
                        },
                        number: {
                            eq: g,
                            neq: h,
                            gte: "Is greater than or equal to",
                            gt: "Is greater than",
                            lte: "Is less than or equal to",
                            lt: "Is less than",
                            isnull: "Is null",
                            isnotnull: "Is not null"
                        },
                        date: {
                            eq: g,
                            neq: h,
                            gte: "Is after or equal to",
                            gt: "Is after",
                            lte: "Is before or equal to",
                            lt: "Is before",
                            isnull: "Is null",
                            isnotnull: "Is not null"
                        },
                        enums: {
                            eq: g,
                            neq: h,
                            isnull: "Is null",
                            isnotnull: "Is not null"
                        }
                    }
                }
            });
        i.plugin(w)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, r) {
    (r || t)()
});;
! function(e, define) {
    define("kendo.pager.min", ["kendo.data.min"], e)
}(function() {
    return function(e, t) {
        function a(e, t, a, n, s) {
            return e({
                idx: t,
                text: a,
                ns: p.ns,
                numeric: n,
                title: s || ""
            })
        }

        function n(e, t, a) {
            return T({
                className: e.substring(1),
                text: t,
                wrapClassName: a || ""
            })
        }

        function s(e, t, a, n) {
            e.find(t).parent().attr(p.attr("page"), a).attr("tabindex", -1).toggleClass("k-state-disabled", n)
        }

        function i(e, t) {
            s(e, m, 1, t <= 1)
        }

        function l(e, t) {
            s(e, f, Math.max(1, t - 1), t <= 1)
        }

        function r(e, t, a) {
            s(e, h, Math.min(a, t + 1), t >= a)
        }

        function o(e, t, a) {
            s(e, c, a, t >= a)
        }
        var p = window.kendo,
            d = p.ui,
            g = d.Widget,
            u = e.proxy,
            m = ".k-i-arrow-end-left",
            c = ".k-i-arrow-end-right",
            f = ".k-i-arrow-60-left",
            h = ".k-i-arrow-60-right",
            k = "k-pager-lg k-pager-md k-pager-sm",
            v = "change",
            w = ".kendoPager",
            S = "click",
            x = "keydown",
            _ = "disabled",
            b = "down",
            z = e(document.documentElement),
            C = Number.MAX_VALUE,
            T = p.template('<a href="\\#" aria-label="#=text#" title="#=text#" class="k-link k-pager-nav #= wrapClassName #"><span class="k-icon #= className #"></span></a>'),
            y = g.extend({
                init: function(t, a) {
                    var s, d, k, _, z = this,
                        C = null;
                    g.fn.init.call(z, t, a), a = z.options, z._createDataSource(a), z.linkTemplate = p.template(z.options.linkTemplate), z.selectTemplate = p.template(z.options.selectTemplate), z.currentPageTemplate = p.template(z.options.currentPageTemplate), s = z.page(), d = z.totalPages(), z._refreshHandler = u(z.refresh, z), z.dataSource.bind(v, z._refreshHandler), z.downEvent = p.applyEventMap(b, p.guid()), a.previousNext && (z.element.find(m).length || (z.element.append(n(m, a.messages.first, "k-pager-first")), i(z.element, s, d)), z.element.find(f).length || (z.element.append(n(f, a.messages.previous)), l(z.element, s, d))), a.numeric && (z.list = z.element.find(".k-pager-numbers"), z.list.length || (z.list = e('<ul class="k-pager-numbers k-reset" />').appendTo(z.element)), a.dataSource && !a.dataSource.total() && z.list.empty().append(z.currentPageTemplate({
                        text: 0
                    })).append(z.selectTemplate({
                        text: 0
                    })), z.list.wrap('<div class="k-pager-numbers-wrap"></div>')), a.input && (z.element.find(".k-pager-input").length || z.element.append('<span class="k-pager-input k-label">' + a.messages.page + '<input class="k-textbox">' + p.format(a.messages.of, d) + "</span>"), z.element.on(x + w, ".k-pager-input input", u(z._keydown, z))), a.previousNext && (z.element.find(h).length || (z.element.append(n(h, a.messages.next)), r(z.element, s, d)), z.element.find(c).length || (z.element.append(n(c, a.messages.last, "k-pager-last")), o(z.element, s, d))), a.pageSizes && (z.element.find(".k-pager-sizes").length || (k = a.pageSizes.length ? a.pageSizes : ["all", 5, 10, 20], _ = e.map(k, function(e) {
                        return e.toLowerCase && "all" === e.toLowerCase() ? "<option value='all'>" + a.messages.allPages + "</option>" : "<option>" + e + "</option>"
                    }), e('<span class="k-pager-sizes k-label"><select/>' + a.messages.itemsPerPage + "</span>").appendTo(z.element).find("select").html(_.join("")).end().appendTo(z.element)), z.element.find(".k-pager-sizes select").val(z.pageSize()), p.ui.DropDownList && z.element.find(".k-pager-sizes select").show().kendoDropDownList(), z.element.on(v + w, ".k-pager-sizes select", u(z._change, z))), a.refresh && (z.element.find(".k-pager-refresh").length || z.element.append('<a href="#" class="k-pager-refresh k-link" title="' + a.messages.refresh + '" aria-label="' + a.messages.refresh + '"><span class="k-icon k-i-reload"></span></a>'), z.element.on(S + w, ".k-pager-refresh", u(z._refreshClick, z))), a.info && (z.element.find(".k-pager-info").length || z.element.append('<span class="k-pager-info k-label" />')), z.element.on(S + w, "a", u(z._click, z)).addClass("k-pager-wrap k-widget k-floatwrap"), z.element.on(S + w, ".k-current-page", u(z._toggleActive, z)), a.autoBind && z.refresh(), z._resizeHandler = u(z.resize, z, !0), e(window).on("resize" + w, z._resizeHandler), C = z._getWidthSizeClass(z.element.width()), C && z.element.addClass(C), p.notify(z)
                },
                destroy: function() {
                    var t = this;
                    g.fn.destroy.call(t), t.element.off(w), t.dataSource.unbind(v, t._refreshHandler), t._refreshHandler = null, e(window).off("resize" + w, this._resizeHandler), p.destroy(t.element), t.element = t.list = null
                },
                events: [v],
                options: {
                    name: "Pager",
                    selectTemplate: '<li><span class="k-state-selected">#=text#</span></li>',
                    currentPageTemplate: '<li class="k-current-page"><span class="k-link k-pager-nav">#=text#</span></li>',
                    linkTemplate: '<li><a tabindex="-1" href="\\#" class="k-link" data-#=ns#page="#=idx#" #if (title !== "") {# title="#=title#" #}#>#=text#</a></li>',
                    buttonCount: 10,
                    autoBind: !0,
                    numeric: !0,
                    info: !0,
                    input: !1,
                    previousNext: !0,
                    pageSizes: !1,
                    refresh: !1,
                    responsive: !0,
                    messages: {
                        allPages: "All",
                        display: "{0} - {1} of {2} items",
                        empty: "No items to display",
                        page: "Page",
                        of: "of {0}",
                        itemsPerPage: "items per page",
                        first: "Go to the first page",
                        previous: "Go to the previous page",
                        next: "Go to the next page",
                        last: "Go to the last page",
                        refresh: "Refresh",
                        morePages: "More pages"
                    }
                },
                setDataSource: function(e) {
                    var t = this;
                    t.dataSource.unbind(v, t._refreshHandler), t.dataSource = t.options.dataSource = e, e.bind(v, t._refreshHandler), t.options.autoBind && e.fetch()
                },
                _resize: function(e) {
                    var t, a;
                    e.width && (t = this._getWidthSizeClass(e.width), a = this.element, t ? a.hasClass(t) || (a.removeClass(k), a.addClass(t)) : a.removeClass(k))
                },
                _createDataSource: function(e) {
                    this.dataSource = p.data.DataSource.create(e.dataSource)
                },
                refresh: function(t) {
                    var n, s, d, g, u, m, c = this,
                        f = 1,
                        h = c.page(),
                        k = "",
                        v = c.options,
                        w = c.pageSize(),
                        S = c._collapsedTotal(),
                        x = c.dataSource.total(),
                        b = c.totalPages(),
                        T = c.linkTemplate,
                        y = v.buttonCount;
                    if (z.unbind(c.downEvent, e.proxy(c._hideList, c)), !t || "itemchange" != t.action) {
                        if (v.numeric) {
                            for (h > y && (d = h % y, f = 0 === d ? h - y + 1 : h - d + 1), s = Math.min(f + y - 1, b), f > 1 && (k += a(T, f - 1, "...", !1, v.messages.morePages)), n = f; n <= s; n++) k += a(n == h ? c.selectTemplate : T, n, n, !0);
                            s < b && (k += a(T, n, "...", !1, v.messages.morePages)), "" === k && (k = c.selectTemplate({
                                text: 0
                            })), k = this.currentPageTemplate({
                                text: h
                            }) + k, c.list.removeClass("k-state-expanded").html(k)
                        }
                        v.info && (k = x > 0 ? p.format(v.messages.display, c.dataSource.options.endless ? 1 : Math.min((h - 1) * (c.dataSource.pageSize() || 0) + 1, S), Math.min(h * w, S), x) : v.messages.empty, c.element.find(".k-pager-info").html(k)), v.input && c.element.find(".k-pager-input").html(c.options.messages.page + '<input class="k-textbox" aria-label="' + h + '">' + p.format(v.messages.of, b)).find("input").val(h).attr(_, x < 1).toggleClass("k-state-disabled", x < 1), v.previousNext && (i(c.element, h, b), l(c.element, h, b), r(c.element, h, b), o(c.element, h, b)), v.pageSizes && (g = c.element.find(".k-pager-sizes option[value='all']").length > 0, u = g && (w === this.dataSource.total() || w == C), m = w, u && (w = "all", m = v.messages.allPages), /*c.element.find(".k-pager-sizes select").val(w).attr("aria-label", w).filter("[" + p.attr("role") + "=dropdownlist]").kendoDropDownList("value", w).kendoDropDownList("text", m))*/m)
                    }
                },
                _collapsedTotal: function() {
                    return this.dataSource.total()
                },
                _keydown: function(e) {
                    if (e.keyCode === p.keys.ENTER) {
                        var t = this.element.find(".k-pager-input").find("input"),
                            a = parseInt(t.val(), 10);
                        (isNaN(a) || a < 1 || a > this.totalPages()) && (a = this.page()), t.val(a), this.page(a)
                    }
                },
                _refreshClick: function(e) {
                    e.preventDefault(), this.dataSource.read()
                },
                _change: function(e) {
                    var a = e.currentTarget.value,
                        n = parseInt(a, 10),
                        s = this.dataSource;
                    isNaN(n) ? "all" == (a + "").toLowerCase() && (s._pageSize = t, s._take = t, s._skip = 0, s.fetch()) : s.pageSize(n)
                },
                _toggleActive: function() {
                    var t = this;
                    t.list.hasClass("k-state-expanded") ? z.unbind(t.downEvent, e.proxy(t._hideList, t)) : z.bind(t.downEvent, e.proxy(t._hideList, t)), t.list.toggleClass("k-state-expanded")
                },
                _hideList: function(t) {
                    var a = this,
                        n = p.eventTarget(t);
                    e.contains(a.list[0], n) || (z.unbind(a.downEvent, e.proxy(a._hideList, a)), a.list.removeClass("k-state-expanded"))
                },
                _click: function(t) {
                    var a = e(t.currentTarget);
                    t.preventDefault(), a.is(".k-state-disabled") || this.page(parseInt(a.attr(p.attr("page")), 10))
                },
                totalPages: function() {
                    return Math.ceil((this.dataSource.total() || 0) / (this.pageSize() || 1))
                },
                pageSize: function() {
                    return this.dataSource.pageSize() || this.dataSource.total()
                },
                page: function(e) {
                    return e ? (this.trigger("pageChange", {
                        index: e
                    }) || (this.dataSource.page(e), this.trigger(v, {
                        index: e
                    })), t) : this.dataSource.total() > 0 ? this.dataSource.page() : 0
                },
                _getWidthSizeClass: function(e) {
                    var t = this,
                        a = k.split(" ");
                    return t.options.responsive ? e <= 480 ? a[2] : e <= 640 ? a[1] : e <= 1024 ? a[0] : null : null
                }
            });
        d.plugin(y)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, a) {
    (a || t)()
});;
! function(e, define) {
    define("kendo.reorderable.min", ["kendo.core.min", "kendo.draganddrop.min"], e)
}(function() {
    return function(e, r) {
        function n(r, n) {
            r = e(r), n ? r.find(".k-drag-status").removeClass("k-i-plus").addClass("k-i-cancel") : r.find(".k-drag-status").removeClass("k-i-cancel").addClass("k-i-plus")
        }
        var t = window.kendo,
            a = t._outerWidth,
            d = t._outerHeight,
            o = t.getOffset,
            i = t.ui.Widget,
            g = "change",
            l = "k-reorderable",
            s = i.extend({
                init: function(r, s) {
                    var u, f = this,
                        c = t.guid() + "-reorderable";
                    i.fn.init.call(f, r, s), r = f.element.addClass(l), s = f.options, f.draggable = u = s.draggable || new t.ui.Draggable(r, {
                        group: c,
                        autoScroll: !0,
                        filter: s.filter,
                        hint: s.hint
                    }), f.reorderDropCue = e('<div class="k-reorder-cue"></div></div>'), r.find(u.options.filter).kendoDropTarget({
                        group: u.options.group,
                        dragenter: function(e) {
                            var r, t, i, g;
                            f._draggable && (r = this.element, i = !f._dropTargetAllowed(r) || f._isLastDraggable(), n(e.draggable.hint, i), i || (t = o(r), g = t.left, s.inSameContainer && !s.inSameContainer({
                                source: r,
                                target: f._draggable,
                                sourceIndex: f._index(r),
                                targetIndex: f._index(f._draggable)
                            }) ? f._dropTarget = r : f._index(r) > f._index(f._draggable) && (g += a(r)), f.reorderDropCue.css({
                                height: d(r),
                                top: t.top,
                                left: g
                            }).appendTo(document.body)))
                        },
                        dragleave: function(e) {
                            n(e.draggable.hint, !0), f.reorderDropCue.remove(), f._dropTarget = null
                        },
                        drop: function() {
                            var e, r;
                            f._dropTarget = null, f._draggable && (e = this.element, r = f._draggable, f._dropTargetAllowed(e) && !f._isLastDraggable() && f.trigger(g, {
                                element: f._draggable,
                                target: e,
                                oldIndex: f._index(r),
                                newIndex: f._index(e),
                                position: o(f.reorderDropCue).left > o(e).left ? "after" : "before"
                            }))
                        }
                    }), u.bind(["dragcancel", "dragend", "dragstart", "drag"], {
                        dragcancel: function() {
                            f.reorderDropCue.remove(), f._draggable = null, f._elements = null
                        },
                        dragend: function() {
                            f.reorderDropCue.remove(), f._draggable = null, f._elements = null
                        },
                        dragstart: function(e) {
                            f._draggable = e.currentTarget, f._elements = f.element.find(f.draggable.options.filter)
                        },
                        drag: function(e) {
                            var r, n;
                            f._dropTarget && !this.hint.find(".k-drag-status").hasClass("k-i-cancel") && (r = o(f._dropTarget).left, n = a(f._dropTarget), f.reorderDropCue.css(e.pageX > r + n / 2 ? {
                                left: r + n
                            } : {
                                left: r
                            }))
                        }
                    })
                },
                options: {
                    name: "Reorderable",
                    filter: "*"
                },
                events: [g],
                _isLastDraggable: function() {
                    var e, r = this.options.inSameContainer,
                        n = this._draggable[0],
                        t = this._elements.get(),
                        a = !1;
                    if (!r) return !1;
                    for (; !a && t.length > 0;) e = t.pop(), a = n !== e && r({
                        source: n,
                        target: e,
                        sourceIndex: this._index(n),
                        targetIndex: this._index(e)
                    });
                    return !a
                },
                _dropTargetAllowed: function(e) {
                    var r = this.options.inSameContainer,
                        n = this.options.dragOverContainers,
                        t = this._draggable;
                    return t[0] !== e[0] && (!r || !n || (!!r({
                        source: t,
                        target: e,
                        sourceIndex: this._index(t),
                        targetIndex: this._index(e)
                    }) || n(this._index(t), this._index(e))))
                },
                _index: function(e) {
                    return this._elements.index(e)
                },
                destroy: function() {
                    var r = this;
                    i.fn.destroy.call(r), r.element.find(r.draggable.options.filter).each(function() {
                        var r = e(this);
                        r.data("kendoDropTarget") && r.data("kendoDropTarget").destroy()
                    }), r.draggable && (r.draggable.destroy(), r.draggable.element = r.draggable = null), r.elements = r.reorderDropCue = r._elements = r._draggable = null
                }
            });
        t.ui.plugin(s)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, r, n) {
    (n || r)()
});;
! function(i, define) {
    define("kendo.pane.min", ["kendo.view.min"], i)
}(function() {
    return function(i, e) {
        var t = window.kendo,
            n = t.roleSelector,
            o = t.ui,
            a = o.Widget,
            r = t.ViewEngine,
            s = t.View,
            l = i.extend,
            c = "navigate",
            p = "viewShow",
            d = "sameViewRequested",
            u = t.support.mobileOS,
            h = u.ios && !u.appMode && u.flatVersion >= 700,
            v = "#:back",
            f = ".",
            w = {
                pane: "k-pane",
                paneWrapper: "k-pane-wrapper",
                collapsiblePane: "k-collapsible-pane",
                vertical: "k-vertical"
            },
            g = a.extend({
                init: function(i, e) {
                    var n = this;
                    a.fn.init.call(n, i, e), e = n.options, i = n.element, i.addClass(w.pane), n.options.collapsible && i.addClass(w.collapsiblePane), this.history = [], this.historyCallback = function(i, e, t) {
                        var o = n.transition;
                        return n.transition = null, h && t && (o = "none"), n.viewEngine.showView(i, o, e)
                    }, this._historyNavigate = function(i) {
                        if (i === v) {
                            if (1 === n.history.length) return;
                            n.history.pop(), i = n.history[n.history.length - 1]
                        } else i instanceof s && (i = ""), n.history.push(i);
                        n.historyCallback(i, t.parseQueryStringParams(i))
                    }, this._historyReplace = function(i) {
                        var e = t.parseQueryStringParams(i);
                        n.history[n.history.length - 1] = i, n.historyCallback(i, e)
                    }, n.viewEngine = new r(l({}, {
                        container: i,
                        transition: e.transition,
                        modelScope: e.modelScope,
                        rootNeeded: !e.initial,
                        serverNavigation: e.serverNavigation,
                        remoteViewURLPrefix: e.root || "",
                        layout: e.layout,
                        $angular: e.$angular,
                        showStart: function() {
                            n.closeActiveDialogs()
                        },
                        after: function() {},
                        viewShow: function(i) {
                            n.trigger(p, i)
                        },
                        loadStart: function() {},
                        loadComplete: function() {},
                        sameViewRequested: function() {
                            n.trigger(d)
                        },
                        viewTypeDetermined: function(i) {
                            i.remote && n.options.serverNavigation || n.trigger(c, {
                                url: i.url
                            })
                        }
                    }, this.options.viewEngine)), this._setPortraitWidth(), t.onResize(function() {
                        n._setPortraitWidth()
                    })
                },
                closeActiveDialogs: function() {
                    var e = this.element.find(n("actionsheet popover modalview")).filter(":visible");
                    e.each(function() {
                        t.widgetInstance(i(this), o).close()
                    })
                },
                navigateToInitial: function() {
                    var i = this.options.initial;
                    return i && this.navigate(i), i
                },
                options: {
                    name: "Pane",
                    portraitWidth: "",
                    transition: "",
                    layout: "",
                    collapsible: !1,
                    initial: null,
                    modelScope: window
                },
                events: [c, p, d],
                append: function(i) {
                    return this.viewEngine.append(i)
                },
                destroy: function() {
                    var i = this;
                    a.fn.destroy.call(i), i.viewEngine && i.viewEngine.destroy()
                },
                navigate: function(i, e) {
                    i instanceof s && (i = i.id), this.transition = e, this._historyNavigate(i)
                },
                replace: function(i, e) {
                    i instanceof s && (i = i.id), this.transition = e, this._historyReplace(i)
                },
                view: function() {
                    return this.viewEngine.view()
                },
                _setPortraitWidth: function() {
                    var i, e = this.options.portraitWidth;
                    e && (i = t.mobile.application.element.is(f + w.vertical) ? e : "auto", this.element.css("width", i))
                }
            });
        g.wrap = function(i, e) {
            var o, a;
            return i.is(n("view")) || (i = i.wrap("<div data-" + t.ns + 'role="view" data-stretch="true"></div>').parent()), o = i.wrap('<div class="' + w.paneWrapper + ' k-widget"><div></div></div>').parent(), a = new g(o, e), a.navigate(""), a
        }, t.Pane = g
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(i, e, t) {
    (t || e)()
});;
! function(e, define) {
    define("kendo.switch.min", ["kendo.core.min"], e)
}(function() {
    return function(e, t) {
        var n = window.kendo,
            c = n.ui,
            a = ".kendoSwitch",
            i = c.Widget,
            s = n.support,
            d = "change",
            l = {
                widget: "k-switch k-widget",
                container: "k-switch-container",
                handle: "k-switch-handle",
                checked: "k-switch-on",
                checkedLabel: "k-switch-label-on",
                unchecked: "k-switch-off",
                uncheckedLabel: "k-switch-label-off",
                disabled: "k-state-disabled",
                readonly: "k-state-readonly",
                active: "k-state-active"
            },
            r = "disabled",
            o = "aria-disabled",
            h = "readonly",
            k = "aria-readonly",
            p = "aria-checked",
            u = "checked",
            w = s.click + a,
            f = s.pointers ? "pointerup" : "touchend",
            y = "keydown" + a,
            b = "_label",
            g = e.proxy,
            m = n.template('<span class="#=styles.widget#" role="switch"></span>'),
            v = n.template("<span class='#=styles.container#'><span class='#=styles.checkedLabel#'>#=checked#</span><span class='#=styles.uncheckedLabel#'>#=unchecked#</span><span class='#=styles.handle#'></span></span>"),
            _ = i.extend({
                init: function(t, c) {
                    var a, s = this;
                    i.fn.init.call(s, t, c), c = s.options, t = s.element[0], t.type = "checkbox", a = e(m({
                        styles: l
                    })), s.wrapper = s.element.wrap(a).parent(), s.wrapper.append(e(v({
                        styles: l,
                        checked: c.messages.checked,
                        unchecked: c.messages.unchecked
                    }))).addClass(t.className), s.wrapper.on(w, g(s._click, s)).on(f, g(s._touchEnd, s)).on(y, g(s._keydown, s)), s.options.enabled && s._tabindex(), s._initSettings(), s._aria(), n.notify(s, n.ui)
                },
                setOptions: function(n) {
                    var c, a, i = this,
                        s = n.messages;
                    i.options = e.extend(i.options, n), s && s.checked !== t && (c = i.wrapper.find("." + l.checkedLabel), c.text(s.checked)), s && s.unchecked !== t && (a = i.wrapper.find("." + l.uncheckedLabel), a.text(s.unchecked)), n.width && i.wrapper.css({
                        width: n.width
                    }), n.enabled !== t && i.enable(n.enabled), n.readonly !== t && i.readonly(n.readonly), i.check(n.checked)
                },
                _initSettings: function() {
                    var e = this,
                        t = e.element[0],
                        n = e.options;
                    n.width && e.wrapper.css({
                        width: n.width
                    }), null === n.checked && (n.checked = t.checked), e.check(n.checked), n.enabled = n.enabled && !e.element.attr(r), e.enable(n.enabled), n.readonly = n.readonly || !!e.element.attr(h), e.readonly(n.readonly)
                },
                _aria: function() {
                    var t, c = this,
                        a = c.element,
                        i = c.wrapper,
                        s = a.attr("id"),
                        d = e('label[for="' + s + '"]'),
                        l = a.attr("aria-label"),
                        r = a.attr("aria-labelledby"),
                        db = a.attr("aria-describedby");
                    l ? i.attr("aria-label", l) : r ? i.attr("aria-labelledby", r) : d.length && (t = d.attr("id"), t || (t = (s || n.guid()) + b, d.attr("id", t)), i.attr("aria-labelledby", t)) && db ? i.attr("aria-describedby", db) : d.length && db ? i.attr("aria-describedby", db) : d.length
                },
                events: [d],
                options: {
                    name: "Switch",
                    messages: {
                        checked: "On",
                        unchecked: "Off"
                    },
                    width: null,
                    checked: null,
                    enabled: !0,
                    readonly: !1
                },
                check: function(e) {
                    var n = this,
                        c = n.element[0];
                    return e === t ? c.checked : (c.checked !== e && (n.options.checked = c.checked = e), n.wrapper.attr(p, e).toggleClass(l.checked, e).toggleClass(l.unchecked, !e), e ? n.element.attr(u, u) : n.element.removeAttr(u), t)
                },
                value: function(e) {
                    return "string" == typeof e && (e = "true" === e), this.check.apply(this, [e])
                },
                destroy: function() {
                    i.fn.destroy.call(this), this.wrapper.off(a)
                },
                toggle: function() {
                    var e = this;
                    e.check(!e.element[0].checked)
                },
                enable: function(e) {
                    var n = this.element,
                        c = this.wrapper;
                    t === e && (e = !0), this.options.enabled = e, e ? (n.removeAttr(r), c.removeAttr(o)) : (n.attr(r, r), c.attr(o, !0)), c.toggleClass(l.disabled, !e)
                },
                readonly: function(e) {
                    var n = this,
                        c = n.element,
                        a = n.wrapper;
                    t === e && (e = !0), n.options.readonly = e, e ? (c.attr(h, !0), a.attr(k, !0)) : (c.removeAttr(h), a.removeAttr(k)), a.toggleClass(l.readonly, e)
                },
                _check: function() {
                    var e = this,
                        n = e.element[0].checked = !e.element[0].checked;
                    return e.wrapper.focus(), !e.options.enabled || e.options.readonly || e.trigger(d, {
                        checked: n
                    }) ? (e.element[0].checked = !n, t) : (e.check(n), t)
                },
                _keydown: function(e) {
                    e.keyCode === n.keys.SPACEBAR && (this._check(), e.preventDefault())
                },
                _isTouch: function(e) {
                    return /touch/.test(e.type) || e.originalEvent && /touch/.test(e.originalEvent.pointerType)
                },
                _click: function(e) {
                    this._isTouch(e) || 1 !== e.which || this._check()
                },
                _touchEnd: function(e) {
                    this._isTouch(e) && (this._check(), e.preventDefault())
                }
            });
        c.plugin(_)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(e, define) {
    define("ooxml/utils.min", ["kendo.core.min"], e)
}(function() {
    ! function() {
        kendo.ooxml = kendo.ooxml || {}, kendo.ooxml.createZip = function() {
            if ("undefined" == typeof JSZip) throw Error("JSZip not found. Check http://docs.telerik.com/kendo-ui/framework/excel/introduction#requirements for more details.");
            return new JSZip
        }
    }()
}, "function" == typeof define && define.amd ? define : function(e, n, t) {
    (t || n)()
}),
function(e, define) {
    define("ooxml/kendo-ooxml.min", ["kendo.core.min", "ooxml/utils.min"], e)
}(function() {
    ! function(e) {
        function n(e, n, t) {
            return (1461 * (e + 4800 + ((n - 13) / 12 | 0)) / 4 | 0) + (367 * (n - 1 - 12 * ((n - 13) / 12 | 0)) / 12 | 0) - (3 * ((e + 4900 + ((n - 13) / 12 | 0)) / 100 | 0) / 4 | 0) + t - 32075
        }

        function t(e, t, o) {
            return n(e, t, o) - V
        }

        function o(e, n, t, o) {
            return (e + (n + (t + o / 1e3) / 60) / 60) / 24
        }

        function r(e) {
            var n = o(e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()),
                r = t(e.getFullYear(), e.getMonth(), e.getDate());
            return r < 0 ? r - 1 + n : r + n
        }

        function i(e) {
            return U + e
        }

        function s(e, n) {
            return n.indexOf(e)
        }

        function l(e) {
            return (e + "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;").replace(/\'/g, "&#39;")
        }

        function a(e, n) {
            var t, o = "";
            for (t = 0; t < e; ++t) o += n(t);
            return o
        }

        function m(e, n) {
            var t, o = "";
            if (null != e)
                if (Array.isArray(e))
                    for (t = 0; t < e.length; ++t) o += n(e[t], t);
                else "object" == typeof e && Object.keys(e).forEach(function(t, r) {
                    o += n(e[t], t, r)
                });
            return o
        }

        function c(e) {
            return "string" == typeof e ? "<f>" + l(e) + "</f>" : '<f t="array" ref="' + e.ref + '">' + l(e.src) + "</f>"
        }

        function f(e) {
            var n = Math.floor(e / 26) - 1;
            return (n >= 0 ? f(n) : "") + String.fromCharCode(65 + e % 26)
        }

        function d(e, n) {
            return f(n) + (e + 1)
        }

        function u(e, n) {
            return "$" + f(n) + "$" + (e + 1)
        }

        function p(e) {
            var n = e.frozenRows || (e.freezePane || {}).rowSplit || 1;
            return n - 1
        }

        function h(e) {
            var n = 7;
            return e / n - Math.floor(128 / n) / 256
        }

        function g(e) {
            return .75 * e
        }

        function x(e) {
            return (e + "").replace(/[\x00-\x09\x0B\x0C\x0E-\x1F]/g, "").replace(/\r?\n/g, "\r\n")
        }

        function y(e) {
            var n = e.length;
            return e.forEach(function(e) {
                e.index && e.index >= n && (n = e.index + 1)
            }), n
        }

        function v(e) {
            var n = e;
            return n.length < 6 && (n = n.replace(/(\w)/g, function(e, n) {
                return n + n
            })), n = n.substring(1).toUpperCase(), n.length < 8 && (n = "FF" + n), n
        }

        function w(e) {
            var n = "thin";
            return 2 === e ? n = "medium" : 3 === e && (n = "thick"), n
        }

        function b(e, n) {
            var t = "";
            return n && (t += "<" + e + ' style="' + w(n.size) + '">', n.color && (t += '<color rgb="' + v(n.color) + '"/>'), t += "</" + e + ">"), t
        }

        function k(e) {
            return "<border>" + b("left", e.left) + b("right", e.right) + b("top", e.top) + b("bottom", e.bottom) + "</border>"
        }

        function I(e, n) {
            var t, o, r, i = [],
                s = [];
            for (T(e, function(e, n) {
                    var t = {
                        _source: e,
                        index: n,
                        height: e.height,
                        level: e.level,
                        cells: []
                    };
                    i.push(t), s[n] = t
                }), t = _(i).slice(0), o = {
                    rowData: i,
                    rowsByIndex: s,
                    mergedCells: n
                }, r = 0; r < t.length; r++) P(t[r], o), delete t[r]._source;
            return _(i)
        }

        function T(e, n) {
            var t, o, r;
            for (t = 0; t < e.length; t++) o = e[t], o && (r = o.index, "number" != typeof r && (r = t), n(o, r))
        }

        function _(e) {
            return e.sort(function(e, n) {
                return e.index - n.index
            })
        }

        function C(e, n) {
            e.indexOf(n) < 0 && e.push(n)
        }

        function S(e, n) {
            var t, o, r, i, s;
            for (t = 0; t < e.length; ++t)
                if (o = e[t], r = o.split(":"), i = r[0], i === n) return s = r[1], i = D(i), s = D(s), {
                    rowSpan: s.row - i.row + 1,
                    colSpan: s.col - i.col + 1
                }
        }

        function D(e) {
            function n(e) {
                var n, t = e.toUpperCase(),
                    o = 0;
                for (n = 0; n < t.length; ++n) o = 26 * o + t.charCodeAt(n) - 64;
                return o - 1
            }

            function t(e) {
                return parseInt(e, 10) - 1
            }
            var o = /^([a-z]+)(\d+)$/i.exec(e);
            return {
                row: t(o[2]),
                col: n(o[1])
            }
        }

        function F(e) {
            return Math.round(9525 * e)
        }

        function P(e, n) {
            var t, o, r, i, s, l, a, m, c, f = e._source,
                u = e.index,
                p = f.cells,
                h = e.cells;
            if (p)
                for (t = 0; t < p.length; t++)
                    if (o = p[t] || he, r = o.rowSpan || 1, i = o.colSpan || 1, s = L(h, o), l = d(u, s), 1 === r && 1 === i && (a = S(n.mergedCells, l), a && (i = a.colSpan, r = a.rowSpan)), R(o, h, s, i), (r > 1 || i > 1) && C(n.mergedCells, l + ":" + d(u + r - 1, s + i - 1)), r > 1)
                        for (m = u + 1; m < u + r; m++) c = n.rowsByIndex[m], c || (c = n.rowsByIndex[m] = {
                            index: m,
                            cells: []
                        }, n.rowData.push(c)), R(o, c.cells, s - 1, i + 1)
        }

        function L(e, n) {
            var t;
            return "number" == typeof n.index ? (t = n.index, M(e, n, n.index)) : t = A(e, n), t
        }

        function M(e, n, t) {
            e[t] = n
        }

        function A(e, n) {
            var t, o = e.length;
            for (t = 0; t < e.length + 1; t++)
                if (!e[t]) {
                    e[t] = n, o = t;
                    break
                }
            return o
        }

        function R(e, n, t, o) {
            var r, i;
            for (r = 1; r < o; r++) i = {
                borderTop: e.borderTop,
                borderRight: e.borderRight,
                borderBottom: e.borderBottom,
                borderLeft: e.borderLeft
            }, M(n, i, t + r)
        }

        function O(e) {
            return ge({
                ref: e.ref,
                columns: e.columns,
                generators: {
                    custom: xe,
                    dynamic: ye,
                    top: ve,
                    value: we
                }
            })
        }

        function E(e) {
            return /^\'/.test(e) ? e : /^[a-z_][a-z0-9_]*$/i.test(e) ? e : "'" + e.replace(/\x27/g, "\\'") + "'"
        }
        var N, q, z, j, B, V, W, U, X, H, J, Z, $, G, Q, K, Y, ee, ne, te, oe, re, ie, se, le, ae, me, ce, fe, de, ue, pe, he, ge, xe, ye, ve, we;
        window.kendo.ooxml = window.kendo.ooxml || {}, N = kendo.ooxml, q = e.map, z = N.createZip, j = {
            toString: function(e) {
                return e
            }
        }, B = kendo.Class.extend({}), B.register = function(e) {
            j = e
        }, B.toString = function(e, n) {
            return j.toString(e, n)
        }, V = n(1900, 0, -1), W = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", U = "data:" + W + ";base64,", X = {
            compression: "DEFLATE",
            type: "base64"
        }, H = {
            compression: "DEFLATE",
            type: "blob"
        }, J = {
            compression: "DEFLATE",
            type: "arraybuffer"
        }, Z = JSON.parse.bind(JSON), $ = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r', G = $ + '\n            <Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">\n               <Relationship Id="rId3" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties" Target="docProps/app.xml"/>\n               <Relationship Id="rId2" Type="http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties" Target="docProps/core.xml"/>\n               <Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>\n            </Relationships>', Q = function(e) {
            var n = e.creator,
                t = e.lastModifiedBy,
                o = e.created,
                r = e.modified;
            return $ + '\n <cp:coreProperties xmlns:cp="http://schemas.openxmlformats.org/package/2006/metadata/core-properties"\n   xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:dcterms="http://purl.org/dc/terms/"\n   xmlns:dcmitype="http://purl.org/dc/dcmitype/" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance">\n   <dc:creator>' + l(n) + "</dc:creator>\n   <cp:lastModifiedBy>" + l(t) + '</cp:lastModifiedBy>\n   <dcterms:created xsi:type="dcterms:W3CDTF">' + l(o) + '</dcterms:created>\n   <dcterms:modified xsi:type="dcterms:W3CDTF">' + l(r) + "</dcterms:modified>\n</cp:coreProperties>"
        }, K = function(e) {
            var n = e.sheets;
            return $ + '\n<Properties xmlns="http://schemas.openxmlformats.org/officeDocument/2006/extended-properties" xmlns:vt="http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes">\n  <Application>Microsoft Excel</Application>\n  <DocSecurity>0</DocSecurity>\n  <ScaleCrop>false</ScaleCrop>\n  <HeadingPairs>\n    <vt:vector size="2" baseType="variant">\n      <vt:variant>\n        <vt:lpstr>Worksheets</vt:lpstr>\n      </vt:variant>\n      <vt:variant>\n        <vt:i4>' + n.length + '</vt:i4>\n      </vt:variant>\n    </vt:vector>\n  </HeadingPairs>\n  <TitlesOfParts>\n    <vt:vector size="' + n.length + '" baseType="lpstr">' + m(n, function(e, n) {
                return e.options.title ? "<vt:lpstr>" + l(e.options.title) + "</vt:lpstr>" : "<vt:lpstr>Sheet" + (n + 1) + "</vt:lpstr>"
            }) + "</vt:vector>\n  </TitlesOfParts>\n  <LinksUpToDate>false</LinksUpToDate>\n  <SharedDoc>false</SharedDoc>\n  <HyperlinksChanged>false</HyperlinksChanged>\n  <AppVersion>14.0300</AppVersion>\n</Properties>"
        }, Y = function(e) {
            var n = e.sheetCount,
                t = e.commentFiles,
                o = e.drawingFiles;
            return $ + '\n<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">\n  <Default Extension="png" ContentType="image/png"/>\n  <Default Extension="gif" ContentType="image/gif"/>\n  <Default Extension="jpg" ContentType="image/jpeg"/>\n  <Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml" />\n  <Default Extension="xml" ContentType="application/xml" />\n  <Default Extension="vml" ContentType="application/vnd.openxmlformats-officedocument.vmlDrawing"/>\n  <Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" />\n  <Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>\n  <Override PartName="/xl/sharedStrings.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml"/>\n  ' + a(n, function(e) {
                return '<Override PartName="/xl/worksheets/sheet' + (e + 1) + '.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" />'
            }) + "\n  " + m(t, function(e) {
                return '<Override PartName="/xl/' + e + '" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml"/>'
            }) + "\n  " + m(o, function(e) {
                return '<Override PartName="/xl/drawings/' + e + '" ContentType="application/vnd.openxmlformats-officedocument.drawing+xml"/>'
            }) + '\n  <Override PartName="/docProps/core.xml" ContentType="application/vnd.openxmlformats-package.core-properties+xml" />\n  <Override PartName="/docProps/app.xml" ContentType="application/vnd.openxmlformats-officedocument.extended-properties+xml" />\n</Types>'
        }, ee = function(e) {
            var n = e.sheets,
                t = e.filterNames,
                o = e.userNames;
            return $ + '\n<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">\n  <fileVersion appName="xl" lastEdited="5" lowestEdited="5" rupBuild="9303" />\n  <workbookPr defaultThemeVersion="124226" />\n  <bookViews>\n    <workbookView xWindow="240" yWindow="45" windowWidth="18195" windowHeight="7995" />\n  </bookViews>\n  <sheets>\n  ' + m(n, function(e, n) {
                var t = e.options,
                    o = t.name || t.title || "Sheet" + (n + 1);
                return '<sheet name="' + l(o) + '" sheetId="' + (n + 1) + '" r:id="rId' + (n + 1) + '" />'
            }) + "\n  </sheets>\n  " + (t.length || o.length ? "\n    <definedNames>\n      " + m(t, function(e) {
                return '\n         <definedName name="_xlnm._FilterDatabase" hidden="1" localSheetId="' + e.localSheetId + '">' + l(E(e.name)) + "!" + l(e.from) + ":" + l(e.to) + "</definedName>"
            }) + "\n      " + m(o, function(e) {
                return '\n         <definedName name="' + e.name + '" hidden="' + (e.hidden ? 1 : 0) + '" ' + (null != e.localSheetId ? 'localSheetId="' + e.localSheetId + '"' : "") + ">" + l(e.value) + "</definedName>"
            }) + "\n    </definedNames>" : "") + '\n  <calcPr fullCalcOnLoad="1" calcId="145621" />\n</workbook>'
        }, ne = function(e) {
            var n = e.frozenColumns,
                t = e.frozenRows,
                o = e.columns,
                r = e.defaults,
                i = e.data,
                s = e.index,
                a = e.mergeCells,
                f = e.autoFilter,
                u = e.filter,
                p = e.showGridLines,
                x = e.hyperlinks,
                y = e.validations,
                v = e.defaultCellStyleId,
                w = e.rtl,
                b = e.legacyDrawing,
                k = e.drawing,
                I = e.lastRow,
                T = e.lastCol;
            return $ + '\n<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac" mc:Ignorable="x14ac">\n   <dimension ref="A1:' + d(I - 1, T - 1) + '" />\n\n   <sheetViews>\n     <sheetView ' + (w ? 'rightToLeft="1"' : "") + " " + (0 === s ? 'tabSelected="1"' : "") + ' workbookViewId="0" ' + (p === !1 ? 'showGridLines="0"' : "") + ">\n     " + (t || n ? '\n       <pane state="frozen"\n         ' + (n ? 'xSplit="' + n + '"' : "") + "\n         " + (t ? 'ySplit="' + t + '"' : "") + '\n         topLeftCell="' + (String.fromCharCode(65 + (n || 0)) + ((t || 0) + 1)) + '"\n       />' : "") + '\n     </sheetView>\n   </sheetViews>\n\n   <sheetFormatPr x14ac:dyDescent="0.25" customHeight="1" defaultRowHeight="' + (r.rowHeight ? .75 * r.rowHeight : 15) + '"\n     ' + (r.columnWidth ? 'defaultColWidth="' + h(r.columnWidth) + '"' : "") + " />\n\n   " + (null != v || o && o.length > 0 ? "\n     <cols>\n       " + (o && o.length ? "" : '\n         <col min="1" max="16384" style="' + v + '"\n              ' + (r.columnWidth ? 'width="' + h(r.columnWidth) + '"' : "") + " /> ") + "\n       " + m(o, function(e, n) {
                var t = "number" == typeof e.index ? e.index + 1 : n + 1;
                return 0 === e.width ? "<col " + (null != v ? 'style="' + v + '"' : "") + '\n                        min="' + t + '" max="' + t + '" hidden="1" customWidth="1" />' : "<col " + (null != v ? 'style="' + v + '"' : "") + '\n                      min="' + t + '" max="' + t + '" customWidth="1"\n                      ' + (e.autoWidth ? 'width="' + (7 * e.width + 5) / 7 * 256 / 256 + '" bestFit="1"' : 'width="' + h(e.width) + '"') + " />"
            }) + "\n     </cols>" : "") + "\n\n   <sheetData>\n     " + m(i, function(e, n) {
                var t = "number" == typeof e.index ? e.index + 1 : n + 1;
                return '\n         <row r="' + t + '" x14ac:dyDescent="0.25"\n              ' + (e.level ? 'outlineLevel="' + e.level + '"' : "") + "\n              " + (0 === e.height ? 'hidden="1"' : e.height ? 'ht="' + g(e.height) + '" customHeight="1"' : "") + ">\n           " + m(e.data, function(e) {
                    return '\n             <c r="' + e.ref + '" ' + (e.style ? 's="' + e.style + '"' : "") + " " + (e.type ? 't="' + e.type + '"' : "") + ">\n               " + (null != e.formula ? c(e.formula) : "") + "\n               " + (null != e.value ? "<v>" + l(e.value) + "</v>" : "") + "\n             </c>"
                }) + "\n         </row>\n       "
            }) + "\n   </sheetData>\n\n   " + (f ? '<autoFilter ref="' + f.from + ":" + f.to + '"/>' : u ? O(u) : "") + "\n\n   " + (a.length ? '\n     <mergeCells count="' + a.length + '">\n       ' + m(a, function(e) {
                return '<mergeCell ref="' + e + '"/>'
            }) + "\n     </mergeCells>" : "") + "\n\n   " + (y.length ? "\n     <dataValidations>\n       " + m(y, function(e) {
                return '\n         <dataValidation sqref="' + e.sqref.join(" ") + '"\n                         showErrorMessage="' + e.showErrorMessage + '"\n                         type="' + l(e.type) + '"\n                         ' + ("list" !== e.type ? 'operator="' + l(e.operator) + '"' : "") + '\n                         allowBlank="' + e.allowBlank + '"\n                         showDropDown="' + e.showDropDown + '"\n                         ' + (e.error ? 'error="' + l(e.error) + '"' : "") + "\n                         " + (e.errorTitle ? 'errorTitle="' + l(e.errorTitle) + '"' : "") + ">\n           " + (e.formula1 ? "<formula1>" + l(e.formula1) + "</formula1>" : "") + "\n           " + (e.formula2 ? "<formula2>" + l(e.formula2) + "</formula2>" : "") + "\n         </dataValidation>"
            }) + "\n     </dataValidations>" : "") + "\n\n   " + (x.length ? "\n     <hyperlinks>\n       " + m(x, function(e) {
                return '\n         <hyperlink ref="' + e.ref + '" r:id="' + e.rId + '"/>'
            }) + "\n     </hyperlinks>" : "") + '\n\n   <pageMargins left="0.7" right="0.7" top="0.75" bottom="0.75" header="0.3" footer="0.3" />\n   ' + (k ? '<drawing r:id="' + k + '"/>' : "") + "\n   " + (b ? '<legacyDrawing r:id="' + b + '"/>' : "") + "\n</worksheet>"
        }, te = function(e) {
            var n = e.count;
            return $ + '\n<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">\n  ' + a(n, function(e) {
                return '\n    <Relationship Id="rId' + (e + 1) + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet' + (e + 1) + '.xml" />'
            }) + '\n  <Relationship Id="rId' + (n + 1) + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml" />\n  <Relationship Id="rId' + (n + 2) + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings" Target="sharedStrings.xml" />\n</Relationships>'
        }, oe = function(e) {
            var n = e.hyperlinks,
                t = e.comments,
                o = e.sheetIndex,
                r = e.drawings;
            return $ + '\n<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">\n  ' + m(n, function(e) {
                return '\n    <Relationship Id="' + e.rId + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink" Target="' + l(e.target) + '" TargetMode="External" />'
            }) + "\n  " + (t.length ? '\n    <Relationship Id="comment' + o + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments" Target="../comments' + o + '.xml"/>\n    <Relationship Id="vml' + o + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing" Target="../drawings/vmlDrawing' + o + '.vml"/>' : "") + "\n  " + (r.length ? '\n    <Relationship Id="drw' + o + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing" Target="../drawings/drawing' + o + '.xml"/>' : "") + "\n</Relationships>"
        }, re = function(e) {
            var n = e.comments;
            return $ + '\n<comments xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">\n  <authors>\n    <author></author>\n  </authors>\n  <commentList>\n    ' + m(n, function(e) {
                return '\n      <comment ref="' + e.ref + '" authorId="0">\n        <text>\n          <r>\n            <rPr>\n              <sz val="8"/>\n              <color indexed="81"/>\n              <rFont val="Tahoma"/>\n              <charset val="1"/>\n            </rPr>\n            <t>' + l(e.text) + "</t>\n          </r>\n        </text>\n      </comment>"
            }) + "\n  </commentList>\n</comments>"
        }, ie = function(e) {
            var n = e.comments;
            return '<xml xmlns:v="urn:schemas-microsoft-com:vml"\n     xmlns:o="urn:schemas-microsoft-com:office:office"\n     xmlns:x="urn:schemas-microsoft-com:office:excel">\n  <v:shapetype id="_x0000_t202" path="m,l,21600r21600,l21600,xe"></v:shapetype>\n  ' + m(n, function(e) {
                return '\n    <v:shape type="#_x0000_t202" style="visibility: hidden" fillcolor="#ffffe1" o:insetmode="auto">\n      <v:shadow on="t" color="black" obscured="t"/>\n      <x:ClientData ObjectType="Note">\n        <x:MoveWithCells/>\n        <x:SizeWithCells/>\n        <x:Anchor>' + e.anchor + "</x:Anchor>\n        <x:AutoFill>False</x:AutoFill>\n        <x:Row>" + e.row + "</x:Row>\n        <x:Column>" + e.col + "</x:Column>\n      </x:ClientData>\n    </v:shape>"
            }) + "\n</xml>"
        }, se = function(e) {
            return $ + '\n<xdr:wsDr xmlns:xdr="http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing"\n          xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main"\n          xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">\n  ' + m(e, function(e, n) {
                return '\n    <xdr:oneCellAnchor editAs="oneCell">\n      <xdr:from>\n        <xdr:col>' + e.col + "</xdr:col>\n        <xdr:colOff>" + e.colOffset + "</xdr:colOff>\n        <xdr:row>" + e.row + "</xdr:row>\n        <xdr:rowOff>" + e.rowOffset + '</xdr:rowOff>\n      </xdr:from>\n      <xdr:ext cx="' + e.width + '" cy="' + e.height + '" />\n      <xdr:pic>\n        <xdr:nvPicPr>\n          <xdr:cNvPr id="' + (n + 1) + '" name="Picture ' + (n + 1) + '"/>\n          <xdr:cNvPicPr/>\n        </xdr:nvPicPr>\n        <xdr:blipFill>\n          <a:blip r:embed="' + e.imageId + '"/>\n          <a:stretch>\n            <a:fillRect/>\n          </a:stretch>\n        </xdr:blipFill>\n        <xdr:spPr>\n          <a:prstGeom prst="rect">\n            <a:avLst/>\n          </a:prstGeom>\n        </xdr:spPr>\n      </xdr:pic>\n      <xdr:clientData/>\n    </xdr:oneCellAnchor>'
            }) + "\n</xdr:wsDr>"
        }, le = function(e) {
            return $ + '\n<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">\n  ' + m(e, function(e) {
                return '\n    <Relationship Id="' + e.rId + '" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/image" Target="' + e.target + '"/>'
            }) + "\n</Relationships>"
        }, ae = function(e) {
            var n = e.count,
                t = e.uniqueCount,
                o = e.indexes;
            return $ + '\n<sst xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" count="' + n + '" uniqueCount="' + t + '">\n  ' + m(Object.keys(o), function(e) {
                return '\n    <si><t xml:space="preserve">' + l(e.substring(1)) + "</t></si>"
            }) + "\n</sst>"
        }, me = function(e) {
            var n = e.formats,
                t = e.fonts,
                o = e.fills,
                r = e.borders,
                i = e.styles;
            return $ + '\n<styleSheet\n    xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main"\n    xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006"\n    mc:Ignorable="x14ac"\n    xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac">\n  <numFmts count="' + n.length + '">\n  ' + m(n, function(e, n) {
                return '\n    <numFmt formatCode="' + l(e.format) + '" numFmtId="' + (165 + n) + '" />'
            }) + '\n  </numFmts>\n  <fonts count="' + (t.length + 1) + '" x14ac:knownFonts="1">\n    <font>\n       <sz val="11" />\n       <color theme="1" />\n       <name val="Calibri" />\n       <family val="2" />\n       <scheme val="minor" />\n    </font>\n    ' + m(t, function(e) {
                return '\n    <font>\n      <sz val="' + (e.fontSize || 11) + '" />\n      ' + (e.bold ? "<b/>" : "") + "\n      " + (e.italic ? "<i/>" : "") + "\n      " + (e.underline ? "<u/>" : "") + "\n      " + (e.color ? '<color rgb="' + l(e.color) + '" />' : '<color theme="1" />') + "\n      " + (e.fontFamily ? '\n        <name val="' + l(e.fontFamily) + '" />\n        <family val="2" />\n      ' : '\n        <name val="Calibri" />\n        <family val="2" />\n        <scheme val="minor" />\n      ') + "\n    </font>"
            }) + '\n  </fonts>\n  <fills count="' + (o.length + 2) + '">\n      <fill><patternFill patternType="none"/></fill>\n      <fill><patternFill patternType="gray125"/></fill>\n    ' + m(o, function(e) {
                return "\n      " + (e.background ? '\n        <fill>\n          <patternFill patternType="solid">\n              <fgColor rgb="' + l(e.background) + '"/>\n          </patternFill>\n        </fill>\n      ' : "")
            }) + '\n  </fills>\n  <borders count="' + (r.length + 1) + '">\n    <border><left/><right/><top/><bottom/><diagonal/></border>\n    ' + m(r, k) + '\n  </borders>\n  <cellStyleXfs count="1">\n    <xf borderId="0" fillId="0" fontId="0" />\n  </cellStyleXfs>\n  <cellXfs count="' + (i.length + 1) + '">\n    <xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0" />\n    ' + m(i, function(e) {
                return '\n      <xf xfId="0"\n          ' + (e.fontId ? 'fontId="' + e.fontId + '" applyFont="1"' : "") + "\n          " + (e.fillId ? 'fillId="' + e.fillId + '" applyFill="1"' : "") + "\n          " + (e.numFmtId ? 'numFmtId="' + e.numFmtId + '" applyNumberFormat="1"' : "") + "\n          " + (e.textAlign || e.verticalAlign || e.wrap ? 'applyAlignment="1"' : "") + "\n          " + (e.borderId ? 'borderId="' + e.borderId + '" applyBorder="1"' : "") + ">\n        " + (e.textAlign || e.verticalAlign || e.wrap ? "\n        <alignment\n          " + (e.textAlign ? 'horizontal="' + l(e.textAlign) + '"' : "") + "\n          " + (e.verticalAlign ? 'vertical="' + l(e.verticalAlign) + '"' : "") + "\n          " + (e.indent ? 'indent="' + l(e.indent) + '"' : "") + "\n          " + (e.wrap ? 'wrapText="1"' : "") + " />\n        " : "") + "\n      </xf>\n    "
            }) + '\n  </cellXfs>\n  <cellStyles count="1">\n    <cellStyle name="Normal" xfId="0" builtinId="0"/>\n  </cellStyles>\n  <dxfs count="0" />\n  <tableStyles count="0" defaultTableStyle="TableStyleMedium2" defaultPivotStyle="PivotStyleMedium9" />\n</styleSheet>'
        }, ce = kendo.Class.extend({
            init: function(n, t, o, r) {
                this.options = n, this._strings = t, this._styles = o, this._borders = r, this._validations = {}, this._comments = [], this._drawings = n.drawings || [], this._hyperlinks = (this.options.hyperlinks || []).map(function(n, t) {
                    return e.extend({}, n, {
                        rId: "link" + t
                    })
                })
            },
            relsToXML: function() {
                var e = this._hyperlinks,
                    n = this._comments,
                    t = this._drawings;
                if (e.length || n.length || t.length) return oe({
                    hyperlinks: e,
                    comments: n,
                    sheetIndex: this.options.sheetIndex,
                    drawings: t
                })
            },
            toXML: function(e) {
                var n, t, o, r, i, s, l, a, m, c = this,
                    f = this.options.mergedCells || [],
                    u = this.options.rows || [],
                    h = I(u, f);
                this._readCells(h), n = this.options.filter, n && "number" == typeof n.from && "number" == typeof n.to ? n = {
                    from: d(p(this.options), n.from),
                    to: d(p(this.options), n.to)
                } : n && n.ref && n.columns && (t = n, n = null), o = [];
                for (r in this._validations) Object.prototype.hasOwnProperty.call(c._validations, r) && o.push(c._validations[r]);
                return i = null, this.options.defaultCellStyle && (i = this._lookupStyle(this.options.defaultCellStyle)), s = this.options.freezePane || {}, l = this.options.defaults || {}, a = this.options.rows ? this._getLastRow() : 1, m = this.options.rows ? this._getLastCol() : 1, ne({
                    frozenColumns: this.options.frozenColumns || s.colSplit,
                    frozenRows: this.options.frozenRows || s.rowSplit,
                    columns: this.options.columns,
                    defaults: l,
                    data: h,
                    index: e,
                    mergeCells: f,
                    autoFilter: n,
                    filter: t,
                    showGridLines: this.options.showGridLines,
                    hyperlinks: this._hyperlinks,
                    validations: o,
                    defaultCellStyleId: i,
                    rtl: void 0 !== this.options.rtl ? this.options.rtl : l.rtl,
                    legacyDrawing: this._comments.length ? "vml" + this.options.sheetIndex : null,
                    drawing: this._drawings.length ? "drw" + this.options.sheetIndex : null,
                    lastRow: a,
                    lastCol: m
                })
            },
            commentsXML: function() {
                if (this._comments.length) return re({
                    comments: this._comments
                })
            },
            drawingsXML: function(e) {
                var n, t;
                if (this._drawings.length) return n = {}, t = this._drawings.map(function(t) {
                    var o = D(t.topLeftCell),
                        r = n[t.image];
                    return r || (r = n[t.image] = {
                        rId: "img" + t.image,
                        target: e[t.image].target
                    }), {
                        col: o.col,
                        colOffset: F(t.offsetX),
                        row: o.row,
                        rowOffset: F(t.offsetY),
                        width: F(t.width),
                        height: F(t.height),
                        imageId: r.rId
                    }
                }), {
                    main: se(t),
                    rels: le(n)
                }
            },
            legacyDrawing: function() {
                if (this._comments.length) return ie({
                    comments: this._comments
                })
            },
            _lookupString: function(e) {
                var n, t = "$" + e,
                    o = this._strings.indexes[t];
                return void 0 !== o ? n = o : (n = this._strings.indexes[t] = this._strings.uniqueCount, this._strings.uniqueCount++), this._strings.count++, n
            },
            _lookupStyle: function(e) {
                var n, t = JSON.stringify(e);
                return "{}" === t ? 0 : (n = s(t, this._styles), n < 0 && (n = this._styles.push(t) - 1), n + 1)
            },
            _lookupBorder: function(e) {
                var n, t = JSON.stringify(e);
                if ("{}" !== t) return n = s(t, this._borders), n < 0 && (n = this._borders.push(t) - 1), n + 1
            },
            _readCells: function(e) {
                var n, t, o, r, i, s = this;
                for (n = 0; n < e.length; n++)
                    for (t = e[n], o = t.cells, t.data = [], r = 0; r < o.length; r++) i = s._cell(o[r], t.index, r), i && t.data.push(i)
            },
            _cell: function(e, n, t) {
                var o, i, s, l, a, m, c, f, u, p;
                return e && e !== he ? (o = e.value, i = {}, e.borderLeft && (i.left = e.borderLeft), e.borderRight && (i.right = e.borderRight), e.borderTop && (i.top = e.borderTop), e.borderBottom && (i.bottom = e.borderBottom), i = this._lookupBorder(i), s = this.options.defaultCellStyle || {}, l = {
                    borderId: i
                }, function(e) {
                    e("color"), e("background"), e("bold"), e("italic"), e("underline"), e("fontFamily") || e("fontName", "fontFamily"), e("fontSize"), e("format"), e("textAlign") || e("hAlign", "textAlign"), e("verticalAlign") || e("vAlign", "verticalAlign"), e("wrap"), e("indent")
                }(function(n, t) {
                    var o = e[n];
                    if (void 0 === o && (o = s[n]), void 0 !== o) return l[t || n] = o, !0
                }), a = this.options.columns || [], m = a[t], c = typeof o, !m || !m.autoWidth || e.colSpan && 1 !== e.colSpan || (f = o, "number" === c && (f = B.toString(o, e.format)), m.width = Math.max(m.width || 0, (f + "").length)), "string" === c ? (o = x(o), o = this._lookupString(o), c = "s") : "number" === c ? c = "n" : "boolean" === c ? (c = "b", o = +o) : o && o.getTime ? (c = null, o = r(o), l.format || (l.format = "mm-dd-yy")) : (c = null, o = null), l = this._lookupStyle(l), u = d(n, t), e.validation && this._addValidation(e.validation, u), e.comment && (p = [t + 1, 15, n, 10, t + 3, 15, n + 3, 4], this._comments.push({
                    ref: u,
                    text: e.comment,
                    row: n,
                    col: t,
                    anchor: p.join(", ")
                })), {
                    value: o,
                    formula: e.formula,
                    type: c,
                    style: l,
                    ref: u
                }) : null
            },
            _addValidation: function(e, n) {
                var t = {
                        showErrorMessage: "reject" === e.type ? 1 : 0,
                        formula1: e.from,
                        formula2: e.to,
                        type: de[e.dataType] || e.dataType,
                        operator: fe[e.comparerType] || e.comparerType,
                        allowBlank: e.allowNulls ? 1 : 0,
                        showDropDown: e.showButton ? 0 : 1,
                        error: e.messageTemplate,
                        errorTitle: e.titleTemplate
                    },
                    o = JSON.stringify(t);
                this._validations[o] || (this._validations[o] = t, t.sqref = []), this._validations[o].sqref.push(n)
            },
            _getLastRow: function() {
                return y(this.options.rows)
            },
            _getLastCol: function() {
                var e = 0;
                return this.options.rows.forEach(function(n) {
                    n.cells && (e = Math.max(e, y(n.cells)))
                }), e
            }
        }), fe = {
            greaterThanOrEqualTo: "greaterThanOrEqual",
            lessThanOrEqualTo: "lessThanOrEqual"
        }, de = {
            number: "decimal"
        }, ue = {
            General: 0,
            0: 1,
            "0.00": 2,
            "#,##0": 3,
            "#,##0.00": 4,
            "0%": 9,
            "0.00%": 10,
            "0.00E+00": 11,
            "# ?/?": 12,
            "# ??/??": 13,
            "mm-dd-yy": 14,
            "d-mmm-yy": 15,
            "d-mmm": 16,
            "mmm-yy": 17,
            "h:mm AM/PM": 18,
            "h:mm:ss AM/PM": 19,
            "h:mm": 20,
            "h:mm:ss": 21,
            "m/d/yy h:mm": 22,
            "#,##0 ;(#,##0)": 37,
            "#,##0 ;[Red](#,##0)": 38,
            "#,##0.00;(#,##0.00)": 39,
            "#,##0.00;[Red](#,##0.00)": 40,
            "mm:ss": 45,
            "[h]:mm:ss": 46,
            "mmss.0": 47,
            "##0.0E+0": 48,
            "@": 49,
            "[$-404]e/m/d": 27,
            "m/d/yy": 30,
            t0: 59,
            "t0.00": 60,
            "t#,##0": 61,
            "t#,##0.00": 62,
            "t0%": 67,
            "t0.00%": 68,
            "t# ?/?": 69,
            "t# ??/??": 70
        }, pe = kendo.Class.extend({
            init: function(e) {
                var n = this;
                this.options = e || {}, this._strings = {
                    indexes: {},
                    count: 0,
                    uniqueCount: 0
                }, this._styles = [], this._borders = [], this._images = this.options.images, this._imgId = 0, this._sheets = q(this.options.sheets || [], function(e, t) {
                    return e.defaults = n.options, e.sheetIndex = t + 1, new ce(e, n._strings, n._styles, n._borders)
                })
            },
            imageFilename: function(e) {
                var n = ++this._imgId;
                switch (e) {
                    case "image/jpg":
                    case "image/jpeg":
                        return "image" + n + ".jpg";
                    case "image/png":
                        return "image" + n + ".png";
                    case "image/gif":
                        return "image" + n + ".gif";
                    default:
                        return "image" + n + ".bin"
                }
            },
            toZIP: function() {
                var e, n, t, o, r, i, l, a, m, c, f, d, h, g, x, y, w, b, k, I, T, _, C, S, F, P, L, M, A, R = this,
                    O = z(),
                    E = O.folder("docProps");
                for (E.file("core.xml", Q({
                        creator: this.options.creator || "Kendo UI",
                        lastModifiedBy: this.options.creator || "Kendo UI",
                        created: this.options.date || (new Date).toJSON(),
                        modified: this.options.date || (new Date).toJSON()
                    })), e = this._sheets.length, E.file("app.xml", K({
                        sheets: this._sheets
                    })), n = O.folder("_rels"), n.file(".rels", G), t = O.folder("xl"), o = t.folder("_rels"), o.file("workbook.xml.rels", te({
                        count: e
                    })), this._images && (r = t.folder("media"), Object.keys(this._images).forEach(function(e) {
                        var n = R._images[e],
                            t = R.imageFilename(n.type);
                        r.file(t, n.data), n.target = "../media/" + t
                    })), i = {}, t.file("workbook.xml", ee({
                        sheets: this._sheets,
                        filterNames: q(this._sheets, function(e, n) {
                            var t, o, r, s, l = e.options,
                                a = l.name || l.title || "Sheet" + (n + 1);
                            if (i[a.toLowerCase()] = n, t = l.filter) {
                                if (t.ref) return o = t.ref.split(":"), r = D(o[0]), s = D(o[1]), {
                                    localSheetId: n,
                                    name: a,
                                    from: u(r.row, r.col),
                                    to: u(s.row, s.col)
                                };
                                if (void 0 !== t.from && void 0 !== t.to) return {
                                    localSheetId: n,
                                    name: a,
                                    from: u(p(l), t.from),
                                    to: u(p(l), t.to)
                                }
                            }
                        }),
                        userNames: q(this.options.names || [], function(e) {
                            return {
                                name: e.localName,
                                localSheetId: e.sheet ? i[e.sheet.toLowerCase()] : null,
                                value: e.value,
                                hidden: e.hidden
                            }
                        })
                    })), l = t.folder("worksheets"), a = t.folder("drawings"), m = a.folder("_rels"), c = l.folder("_rels"), f = [], d = [], h = 0; h < e; h++) g = R._sheets[h], x = "sheet" + (h + 1) + ".xml", y = g.toXML(h), w = g.relsToXML(), b = g.commentsXML(), k = g.legacyDrawing(), I = g.drawingsXML(R._images), w && c.file(x + ".rels", w), b && (T = "comments" + g.options.sheetIndex + ".xml", t.file(T, b), f.push(T)), k && a.file("vmlDrawing" + g.options.sheetIndex + ".vml", k), I && (_ = "drawing" + g.options.sheetIndex + ".xml", a.file(_, I.main), m.file(_ + ".rels", I.rels), d.push(_)), l.file(x, y);
                return C = q(this._borders, Z), S = q(this._styles, Z), F = function(e) {
                    return e.underline || e.bold || e.italic || e.color || e.fontFamily || e.fontSize
                }, P = function(e) {
                    var n, t = +e;
                    return t && (n = 3 * t / 4), n
                }, L = q(S, function(e) {
                    if (e.fontSize && (e.fontSize = P(e.fontSize)), e.color && (e.color = v(e.color)), F(e)) return e
                }), M = q(S, function(e) {
                    if (e.format && void 0 === ue[e.format]) return e
                }), A = q(S, function(e) {
                    if (e.background) return e.background = v(e.background), e
                }), t.file("styles.xml", me({
                    fonts: L,
                    fills: A,
                    formats: M,
                    borders: C,
                    styles: q(S, function(e) {
                        var n = {};
                        return F(e) && (n.fontId = s(e, L) + 1), e.background && (n.fillId = s(e, A) + 2), n.textAlign = e.textAlign, n.indent = e.indent, n.verticalAlign = e.verticalAlign, n.wrap = e.wrap, n.borderId = e.borderId, e.format && (n.numFmtId = void 0 !== ue[e.format] ? ue[e.format] : 165 + s(e, M)), n
                    })
                })), t.file("sharedStrings.xml", ae(this._strings)), O.file("[Content_Types].xml", Y({
                    sheetCount: e,
                    commentFiles: f,
                    drawingFiles: d
                })), O
            },
            toDataURL: function() {
                var e = this.toZIP();
                return e.generateAsync ? e.generateAsync(X).then(i) : i(e.generate(X))
            },
            toBlob: function() {
                var e = this.toZIP();
                return e.generateAsync ? e.generateAsync(H) : new Blob([e.generate(J)], {
                    type: W
                })
            }
        }), he = {}, ge = function(e) {
            var n = e.ref,
                t = e.columns,
                o = e.generators;
            return '\n<autoFilter ref="' + n + '">\n  ' + m(t, function(e) {
                return '\n    <filterColumn colId="' + e.index + '">\n      ' + o[e.filter](e) + "\n    </filterColumn>\n  "
            }) + "\n</autoFilter>"
        }, xe = function(e) {
            var n = e.logic,
                t = e.criteria;
            return "\n<customFilters " + ("and" === n ? 'and="1"' : "") + ">\n" + m(t, function(e) {
                var n = O.customOperator(e),
                    t = O.customValue(e);
                return "<customFilter " + (n ? 'operator="' + n + '"' : "") + ' val="' + t + '"/>'
            }) + "\n</customFilters>"
        }, ye = function(e) {
            var n = e.type;
            return '<dynamicFilter type="' + O.dynamicFilterType(n) + '" />'
        }, ve = function(e) {
            var n = e.type,
                t = e.value;
            return '<top10 percent="' + (/percent$/i.test(n) ? 1 : 0) + '"\n       top="' + (/^top/i.test(n) ? 1 : 0) + '"\n       val="' + t + '" />'
        }, we = function(e) {
            var n = e.blanks,
                t = e.values;
            return "<filters " + (n ? 'blank="1"' : "") + ">\n    " + m(t, function(e) {
                return '\n      <filter val="' + e + '" />'
            }) + "\n  </filters>"
        }, O.customOperator = function(e) {
            return {
                eq: "equal",
                gt: "greaterThan",
                gte: "greaterThanOrEqual",
                lt: "lessThan",
                lte: "lessThanOrEqual",
                ne: "notEqual",
                doesnotstartwith: "notEqual",
                doesnotendwith: "notEqual",
                doesnotcontain: "notEqual",
                doesnotmatch: "notEqual"
            }[e.operator.toLowerCase()]
        }, O.customValue = function(e) {
            function n(e) {
                return e.replace(/([*?])/g, "~$1")
            }
            switch (e.operator.toLowerCase()) {
                case "startswith":
                case "doesnotstartwith":
                    return n(e.value) + "*";
                case "endswith":
                case "doesnotendwith":
                    return "*" + n(e.value);
                case "contains":
                case "doesnotcontain":
                    return "*" + n(e.value) + "*";
                default:
                    return e.value
            }
        }, O.dynamicFilterType = function(e) {
            return {
                quarter1: "Q1",
                quarter2: "Q2",
                quarter3: "Q3",
                quarter4: "Q4",
                january: "M1",
                february: "M2",
                march: "M3",
                april: "M4",
                may: "M5",
                june: "M6",
                july: "M7",
                august: "M8",
                september: "M9",
                october: "M10",
                november: "M11",
                december: "M12"
            }[e.toLowerCase()] || e
        }, kendo.deepExtend(kendo.ooxml, {
            IntlService: B,
            Workbook: pe,
            Worksheet: ce
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, n, t) {
    (t || n)()
}),
function(e, define) {
    define("ooxml/main.min", ["kendo.core.min", "ooxml/kendo-ooxml.min"], e)
}(function() {
    ! function(e) {
        var n = kendo.ooxml.Workbook;
        kendo.ooxml.IntlService.register({
            toString: kendo.toString
        }), kendo.ooxml.Workbook = n.extend({
            toDataURL: function() {
                var e = n.fn.toDataURL.call(this);
                if ("string" != typeof e) throw Error("The toDataURL method can be used only with jsZip 2. Either include jsZip 2 or use the toDataURLAsync method.");
                return e
            },
            toDataURLAsync: function() {
                var t = e.Deferred(),
                    o = n.fn.toDataURL.call(this);
                return "string" == typeof o ? o = t.resolve(o) : o && o.then && o.then(function(e) {
                    t.resolve(e)
                }, function() {
                    t.reject()
                }), t.promise()
            }
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, n, t) {
    (t || n)()
}),
function(e, define) {
    define("kendo.ooxml.min", ["ooxml/main.min"], e)
}(function() {}, "function" == typeof define && define.amd ? define : function(e, n, t) {
    (t || n)()
});;
! function(e, define) {
    define("excel/kendo-excel.min", ["kendo.core.min"], e)
}(function() {
    ! function(e) {
        function t(e) {
            return e.title + ": " + e.value
        }

        function o(e, t) {
            var o, n = [];
            for (o = 0; o < e; o++) n.push(t(o));
            return n
        }
        var n, r, i, l, a;
        window.kendo.excel = window.kendo.excel || {}, n = kendo.getter, r = e.map, i = {
            compile: function(e) {
                return e
            }
        }, l = kendo.Class.extend({}), l.register = function(e) {
            i = e
        }, l.compile = function(e) {
            return i.compile(e)
        }, a = kendo.Class.extend({
            init: function(e) {
                e.columns = this._trimColumns(e.columns || []), this.allColumns = r(this._leafColumns(e.columns || []), this._prepareColumn), this.columns = this.allColumns.filter(function(e) {
                    return !e.hidden
                }), this.options = e, this.data = e.data || [], this.aggregates = e.aggregates || {}, this.groups = [].concat(e.groups || []), this.hierarchy = e.hierarchy
            },
            workbook: function() {
                var e = {
                    sheets: [{
                        columns: this._columns(),
                        rows: this.hierarchy ? this._hierarchyRows() : this._rows(),
                        freezePane: this._freezePane(),
                        filter: this._filter()
                    }]
                };
                return e
            },
            _trimColumns: function(e) {
                var t = this;
                return e.filter(function(e) {
                    var o = !!e.field;
                    return !o && e.columns && (o = t._trimColumns(e.columns).length > 0), o
                })
            },
            _leafColumns: function(e) {
                var t, o = this,
                    n = [];
                for (t = 0; t < e.length; t++) e[t].columns ? n = n.concat(o._leafColumns(e[t].columns)) : n.push(e[t]);
                return n
            },
            _prepareColumn: function(o) {
                var r, i;
                return o.field ? (r = function(e) {
                    return n(o.field, !0)(e)
                }, i = null, o.values && (i = {}, o.values.forEach(function(e) {
                    i[e.value] = e.text
                }), r = function(e) {
                    return i[n(o.field, !0)(e)]
                }), e.extend({}, o, {
                    value: r,
                    values: i,
                    groupHeaderTemplate: o.groupHeaderTemplate ? l.compile(o.groupHeaderTemplate) : t,
                    groupFooterTemplate: o.groupFooterTemplate ? l.compile(o.groupFooterTemplate) : null,
                    footerTemplate: o.footerTemplate ? l.compile(o.footerTemplate) : null
                })) : null
            },
            _filter: function() {
                if (!this.options.filterable) return null;
                var e = this._depth();
                return {
                    from: e,
                    to: e + this.columns.length - 1
                }
            },
            _createPaddingCells: function(t) {
                var n = this;
                return o(t, function() {
                    return e.extend({
                        background: "#dfdfdf",
                        color: "#333"
                    }, n.options.paddingCellOptions)
                })
            },
            _dataRow: function(t, o, n) {
                var r, i, l, a, s, u, c, h, d = this,
                    f = this._createPaddingCells(o);
                if (n && t.items) return r = this.allColumns.filter(function(e) {
                    return e.field === t.field
                })[0], i = r && r.title ? r.title : t.field, l = r ? r.groupHeaderTemplate : null, a = e.extend({
                    title: i,
                    field: t.field,
                    value: r && r.values ? r.values[t.value] : t.value,
                    aggregates: t.aggregates,
                    items: t.items
                }, t.aggregates[t.field]), s = i + ": " + t.value, l && (s = l(a)), f.push(e.extend({
                    value: s,
                    background: "#dfdfdf",
                    color: "#333",
                    colSpan: this.columns.length + n - o
                }, (r || {}).groupHeaderCellOptions)), u = this._dataRows(t.items, o + 1), u.unshift({
                    type: "group-header",
                    cells: f,
                    level: this.options.collapsible ? o : null
                }), u.concat(this._footer(t, o));
                for (c = [], h = 0; h < this.columns.length; h++) c[h] = d._cell(t, d.columns[h]);
                return this.hierarchy && (c[0].colSpan = n - o + 1), [{
                    type: "data",
                    cells: f.concat(c),
                    level: this.options.collapsible ? o : null
                }]
            },
            _dataRows: function(e, t) {
                var o, n = this,
                    r = this._depth(),
                    i = [];
                for (o = 0; o < e.length; o++) i.push.apply(i, n._dataRow(e[o], t, r));
                return i
            },
            _hierarchyRows: function() {
                var e, t, o, n, r, i = this,
                    l = this._depth(),
                    a = this.data,
                    s = this.hierarchy.itemLevel,
                    u = this._hasFooterTemplate(),
                    c = [],
                    h = [],
                    d = 0;
                for (t = 0; t < a.length; t++) o = a[t], n = s(o), u && (n > d ? h.push({
                    id: e,
                    level: d
                }) : n < d && c.push.apply(c, i._hierarchyFooterRows(h, n, l)), d = n, e = o.id), c.push.apply(c, i._dataRow(o, n + 1, l));
                return u && (c.push.apply(c, this._hierarchyFooterRows(h, 0, l)), r = a.length ? this.aggregates[a[0].parentId] : {}, c.push(this._hierarchyFooter(r, 0, l))), this._prependHeaderRows(c), c
            },
            _hierarchyFooterRows: function(e, t, o) {
                for (var n, r = this, i = []; e.length && e[e.length - 1].level >= t;) n = e.pop(), i.push(r._hierarchyFooter(r.aggregates[n.id], n.level + 1, o));
                return i
            },
            _hasFooterTemplate: function() {
                var e, t = this.columns;
                for (e = 0; e < t.length; e++)
                    if (t[e].footerTemplate) return !0
            },
            _hierarchyFooter: function(t, o, n) {
                var r = this.columns.map(function(r, i) {
                    var l = i ? 1 : n - o + 1;
                    return r.footerTemplate ? e.extend({
                        background: "#dfdfdf",
                        color: "#333",
                        colSpan: l,
                        value: r.footerTemplate(e.extend({}, (t || {})[r.field]))
                    }, r.footerCellOptions) : e.extend({
                        background: "#dfdfdf",
                        color: "#333",
                        colSpan: l
                    }, r.footerCellOptions)
                });
                return {
                    type: "footer",
                    cells: this._createPaddingCells(o).concat(r)
                }
            },
            _footer: function(t, o) {
                var n, r, i, l = [],
                    a = this.columns.some(function(e) {
                        return e.groupFooterTemplate
                    });
                return a && (r = {
                    group: {
                        items: t.items,
                        field: t.field,
                        value: t.value
                    }
                }, n = {}, Object.keys(t.aggregates).forEach(function(o) {
                    n[o] = e.extend({}, t.aggregates[o], r)
                })), i = this.columns.map(function(o) {
                    if (o.groupFooterTemplate) {
                        var i = e.extend({}, n, t.aggregates[o.field], r);
                        return e.extend({
                            background: "#dfdfdf",
                            color: "#333",
                            value: o.groupFooterTemplate(i)
                        }, o.groupFooterCellOptions)
                    }
                    return e.extend({
                        background: "#dfdfdf",
                        color: "#333"
                    }, o.groupFooterCellOptions)
                }), a && l.push({
                    type: "group-footer",
                    cells: this._createPaddingCells(this.groups.length).concat(i),
                    level: this.options.collapsible ? o : null
                }), l
            },
            _isColumnVisible: function(e) {
                return this._visibleColumns([e]).length > 0 && (e.field || e.columns)
            },
            _visibleColumns: function(e) {
                var t = this;
                return e.filter(function(e) {
                    var o = !e.hidden;
                    return o && e.columns && (o = t._visibleColumns(e.columns).length > 0), o
                })
            },
            _headerRow: function(t, n) {
                var r = this,
                    i = t.cells.map(function(o) {
                        return e.extend(o, {
                            colSpan: o.colSpan > 1 ? o.colSpan : 1,
                            rowSpan: t.rowSpan > 1 && !o.colSpan ? t.rowSpan : 1
                        })
                    });
                return this.hierarchy && (i[0].colSpan = this._depth() + 1), {
                    type: "header",
                    cells: o(n.length, function() {
                        return e.extend({
                            background: "#7a7a7a",
                            color: "#fff"
                        }, r.options.headerPaddingCellOptions)
                    }).concat(i)
                }
            },
            _prependHeaderRows: function(e) {
                var t, o = this,
                    n = this.groups,
                    r = [{
                        rowSpan: 1,
                        cells: [],
                        index: 0
                    }];
                for (this._prepareHeaderRows(r, this.options.columns), t = r.length - 1; t >= 0; t--) e.unshift(o._headerRow(r[t], n))
            },
            _prepareHeaderRows: function(t, o, n, r) {
                var i, l, a, s = this,
                    u = r || t[t.length - 1],
                    c = t[u.index + 1],
                    h = 0;
                for (i = 0; i < o.length; i++) l = o[i], s._isColumnVisible(l) && (a = e.extend({
                    background: "#7a7a7a",
                    color: "#fff",
                    value: l.title || l.field,
                    colSpan: 0
                }, l.headerCellOptions), u.cells.push(a), l.columns && l.columns.length && (c || (c = {
                    rowSpan: 0,
                    cells: [],
                    index: t.length
                }, t.push(c)), a.colSpan = s._trimColumns(s._visibleColumns(l.columns)).length, s._prepareHeaderRows(t, l.columns, a, c), h += a.colSpan - 1, u.rowSpan = t.length - u.index));
                n && (n.colSpan += h)
            },
            _rows: function() {
                var t, o, n = this,
                    r = this._dataRows(this.data, 0);
                return this.columns.length && (this._prependHeaderRows(r), t = !1, o = this.columns.map(function(o) {
                    return o.footerTemplate ? (t = !0, e.extend({
                        background: "#dfdfdf",
                        color: "#333",
                        value: o.footerTemplate(e.extend({}, n.aggregates, n.aggregates[o.field]))
                    }, o.footerCellOptions)) : e.extend({
                        background: "#dfdfdf",
                        color: "#333"
                    }, o.footerCellOptions)
                }), t && r.push({
                    type: "footer",
                    cells: this._createPaddingCells(this.groups.length).concat(o)
                })), r
            },
            _headerDepth: function(e) {
                var t, o, n = this,
                    r = 1,
                    i = 0;
                for (t = 0; t < e.length; t++) e[t].columns && (o = n._headerDepth(e[t].columns), o > i && (i = o));
                return r + i
            },
            _freezePane: function() {
                var e = this._visibleColumns(this.options.columns || []),
                    t = this._visibleColumns(this._trimColumns(this._leafColumns(e.filter(function(e) {
                        return e.locked
                    })))).length;
                return {
                    rowSplit: this._headerDepth(e),
                    colSplit: t ? t + this.groups.length : 0
                }
            },
            _cell: function(t, o) {
                return e.extend({
                    value: o.value(t)
                }, o.cellOptions)
            },
            _depth: function() {
                var e = 0;
                return e = this.hierarchy ? this.hierarchy.depth : this.groups.length
            },
            _columns: function() {
                var e = this._depth(),
                    t = o(e, function() {
                        return {
                            width: 20
                        }
                    });
                return t.concat(this.columns.map(function(e) {
                    return {
                        width: parseInt(e.width, 10),
                        autoWidth: !e.width
                    }
                }))
            }
        }), kendo.deepExtend(kendo.excel, {
            ExcelExporter: a,
            TemplateService: l
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, o) {
    (o || t)()
}),
function(e, define) {
    define("excel/main.min", ["kendo.core.min", "kendo.data.min", "excel/kendo-excel.min"], e)
}(function() {
    return function(e, t) {
        var o = t.excel.ExcelExporter,
            n = e.extend;
        t.excel.TemplateService.register({
            compile: t.template
        }), t.ExcelExporter = t.Class.extend({
            init: function(e) {
                var o, r, i, l;
                if (this.options = e, o = e.dataSource, o instanceof t.data.DataSource) {
                    if (o.filter() || (o.options.filter = void 0), this.dataSource = new o.constructor(n({}, o.options, {
                            page: e.allPages ? 0 : o.page(),
                            filter: o.filter(),
                            pageSize: e.allPages ? o.total() : o.pageSize() || o.total(),
                            sort: o.sort(),
                            group: o.group(),
                            aggregate: o.aggregate()
                        })), r = o.data(), r.length > 0) {
                        if (e.hierarchy)
                            for (i = 0; i < r.length; i++) r[i].expanded !== !1 && void 0 !== r[i].expanded || (r[i].expanded = !0);
                        this.dataSource._data = r, l = this.dataSource.transport, o._isServerGrouped() && l.options && l.options.data && (l.options.data = null)
                    }
                } else this.dataSource = t.data.DataSource.create(o)
            },
            _hierarchy: function() {
                var e, t, o, n, r = this.options.hierarchy,
                    i = this.dataSource;
                if (r && i.level) {
                    for (r = {
                            itemLevel: function(e) {
                                return i.level(e)
                            }
                        }, e = i.view(), t = 0, n = 0; n < e.length; n++) o = i.level(e[n]), o > t && (t = o);
                    r.depth = t + 1
                } else r = !1;
                return {
                    hierarchy: r
                }
            },
            workbook: function() {
                return e.Deferred(e.proxy(function(t) {
                    this.dataSource.fetch().then(e.proxy(function() {
                        var e = new o(n({}, this.options, this._hierarchy(), {
                            data: this.dataSource.view(),
                            groups: this.dataSource.group(),
                            aggregates: this.dataSource.aggregates()
                        })).workbook();
                        t.resolve(e, this.dataSource.view())
                    }, this))
                }, this)).promise()
            }
        })
    }(kendo.jQuery, kendo), kendo
}, "function" == typeof define && define.amd ? define : function(e, t, o) {
    (o || t)()
}),
function(e, define) {
    define("excel/mixins.min", ["excel/main.min", "kendo.ooxml.min"], e)
}(function() {
    return function(e, t) {
        t.ExcelMixin = {
            extend: function(t) {
                t.events.push("excelExport"), t.options.excel = e.extend(t.options.excel, this.options), t.saveAsExcel = this.saveAsExcel
            },
            options: {
                proxyURL: "",
                allPages: !1,
                filterable: !1,
                fileName: "Export.xlsx",
                collapsible: !1
            },
            saveAsExcel: function() {
                var o = this.options.excel || {},
                    n = new t.ExcelExporter({
                        columns: this.columns,
                        dataSource: this.dataSource,
                        allPages: o.allPages,
                        filterable: o.filterable,
                        hierarchy: o.hierarchy,
                        collapsible: o.collapsible
                    });
                n.workbook().then(e.proxy(function(e, n) {
                    if (!this.trigger("excelExport", {
                            workbook: e,
                            data: n
                        })) {
                        var r = new t.ooxml.Workbook(e);
                        r.toDataURLAsync().then(function(n) {
                            t.saveAs({
                                dataURI: n,
                                fileName: e.fileName || o.fileName,
                                proxyURL: o.proxyURL,
                                forceProxy: o.forceProxy
                            })
                        })
                    }
                }, this))
            }
        }
    }(kendo.jQuery, kendo), kendo
}, "function" == typeof define && define.amd ? define : function(e, t, o) {
    (o || t)()
}),
function(e, define) {
    define("kendo.excel.min", ["excel/main.min", "excel/mixins.min"], e)
}(function() {}, "function" == typeof define && define.amd ? define : function(e, t, o) {
    (o || t)()
});;
! function(e, define) {
    define("kendo.columnsorter.min", ["kendo.core.min"], e)
}(function() {
    return function(e, t) {
        function n(n) {
            var r = n.find("tr:not(.k-filter-row)"),
                o = i.attr("index"),
                a = r.find("th[" + o + "]:visible");
            return a.sort(function(n, r) {
                var i, a;
                return n = e(n), r = e(r), i = n.attr(o), a = r.attr(o), i === t && (i = e(n).index()), a === t && (a = e(r).index()), i = parseInt(i, 10), a = parseInt(a, 10), i > a ? 1 : i < a ? -1 : 0
            }), a
        }

        function r(e) {
            var t = null;
            return e.is("th") && (t = e.closest("table"), t.parent().hasClass("k-grid-header-wrap") ? t = t.closest(".k-grid").find(".k-grid-content > table") : t.parent().hasClass("k-grid-header-locked") && (t = t.closest(".k-grid").find(".k-grid-content-locked > table"))), t
        }
        var i = window.kendo,
            o = i.ui,
            a = o.Widget,
            s = "dir",
            d = "asc",
            l = "single",
            c = "field",
            f = "desc",
            u = ".kendoColumnSorter",
            p = ".k-link",
            h = "aria-sort",
            k = e.proxy,
            g = a.extend({
                init: function(e, t) {
                    var n, r = this;
                    a.fn.init.call(r, e, t), r._refreshHandler = k(r.refresh, r), r.dataSource = r.options.dataSource.bind("change", r._refreshHandler), r.directions = r.options.initialDirection === d ? [d, f] : [f, d], n = r.element.find(p), n[0] || (n = r.element.wrapInner('<a class="k-link" href="#"/>').find(p)), r.link = n, r.element.on("click" + u, k(r._click, r))
                },
                options: {
                    name: "ColumnSorter",
                    mode: l,
                    allowUnsort: !0,
                    compare: null,
                    filter: "",
                    initialDirection: d,
                    showIndexes: !1
                },
                events: ["change"],
                destroy: function() {
                    var e = this;
                    a.fn.destroy.call(e), e.element.off(u), e.dataSource.unbind("change", e._refreshHandler), e._refreshHandler = e.element = e.link = e.dataSource = null
                },
                refresh: function(o) {
                    if (!o || "itemchange" !== o.action && "sync" !== o.action) {
                        var a, l, u, p, k, g = this,
                            m = g.dataSource.sort() || [],
                            S = g.element,
                            v = S.attr(i.attr(c)),
                            w = (g.dataSource._sortFields || {})[v];
                        S.removeAttr(i.attr(s)), S.removeAttr(h), w && (a = w.dir, S.attr(i.attr(s), a), k = w.index), S.is("th") && w && (l = r(S), l && (S.attr(i.attr("index")) ? (u = n(S.closest("table")), p = u.index(S)) : p = S.parent().children(":visible").index(S), l.find("col:not(.k-group-col):not(.k-hierarchy-col)").eq(p).toggleClass("k-sorted", a !== t))), S.toggleClass("k-sorted", a !== t), S.find(".k-i-sort-asc-sm,.k-i-sort-desc-sm,.k-sort-order").remove(), a === d ? (e('<span class="k-icon k-i-sort-asc-sm" />').appendTo(g.link), S.attr(h, "ascending")) : a === f && (e('<span class="k-icon k-i-sort-desc-sm" />').appendTo(g.link), S.attr(h, "descending")), g.options.showIndexes && m.length > 1 && k && e('<span class="k-sort-order" />').html(k).appendTo(g.link)
                    }
                },
                _toggleSortDirection: function(e) {
                    var n = this.directions;
                    return e === n[n.length - 1] && this.options.allowUnsort ? t : n[0] === e ? n[1] : n[0]
                },
                _click: function(e) {
                    var n, r, o = this,
                        a = o.element,
                        d = a.attr(i.attr(c)),
                        f = a.attr(i.attr(s)),
                        u = o.options,
                        p = null === o.options.compare ? t : o.options.compare,
                        h = o.dataSource.sort() || [];
                    if (e.preventDefault(), (!u.filter || a.is(u.filter)) && (f = this._toggleSortDirection(f), !this.trigger("change", {
                            sort: {
                                field: d,
                                dir: f,
                                compare: p
                            }
                        }))) {
                        if (u.mode === l) h = [{
                            field: d,
                            dir: f,
                            compare: p
                        }];
                        else if ("multiple" === u.mode) {
                            for (n = 0, r = h.length; n < r; n++)
                                if (h[n].field === d) {
                                    h.splice(n, 1);
                                    break
                                }
                            h.push({
                                field: d,
                                dir: f,
                                compare: p
                            })
                        }
                        this.dataSource.options.endless && (this.dataSource.options.endless = null, a.closest(".k-grid").getKendoGrid()._endlessPageSize = o.dataSource.options.pageSize, this.dataSource.pageSize(o.dataSource.options.pageSize)), this.dataSource.sort(h)
                    }
                }
            });
        o.plugin(g)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(e, define) {
    define("util/text-metrics.min", ["kendo.core.min"], e)
}(function() {
    ! function(e) {
        function t(e) {
            return (e + "").replace(i, s)
        }

        function r(e) {
            var t, r = [];
            for (t in e) r.push(t + e[t]);
            return r.sort().join("")
        }

        function l(e) {
            var t, r = 2166136261;
            for (t = 0; t < e.length; ++t) r += (r << 1) + (r << 4) + (r << 7) + (r << 8) + (r << 24), r ^= e.charCodeAt(t);
            return r >>> 0
        }

        function o() {
            return {
                width: 0,
                height: 0,
                baseline: 0
            }
        }

        function a(e, t, r) {
            return u.current.measure(e, t, r)
        }
        var n, i, s, d, c, u;
        window.kendo.util = window.kendo.util || {}, n = kendo.Class.extend({
            init: function(e) {
                this._size = e, this._length = 0, this._map = {}
            },
            put: function(e, t) {
                var r = this._map,
                    l = {
                        key: e,
                        value: t
                    };
                r[e] = l, this._head ? (this._tail.newer = l, l.older = this._tail, this._tail = l) : this._head = this._tail = l, this._length >= this._size ? (r[this._head.key] = null, this._head = this._head.newer, this._head.older = null) : this._length++
            },
            get: function(e) {
                var t = this._map[e];
                if (t) return t === this._head && t !== this._tail && (this._head = t.newer, this._head.older = null), t !== this._tail && (t.older && (t.older.newer = t.newer, t.newer.older = t.older), t.older = this._tail, t.newer = null, this._tail.newer = t, this._tail = t), t.value
            }
        }), i = /\r?\n|\r|\t/g, s = " ", d = {
            baselineMarkerSize: 1
        }, "undefined" != typeof document && (c = document.createElement("div"), c.style.cssText = "position: absolute !important; top: -4000px !important; width: auto !important; height: auto !important;padding: 0 !important; margin: 0 !important; border: 0 !important;line-height: normal !important; visibility: hidden !important; white-space: pre!important;"), u = kendo.Class.extend({
            init: function(t) {
                this._cache = new n(1e3), this.options = e.extend({}, d, t)
            },
            measure: function(e, a, n) {
                var i, s, d, u, p, h, f, g, m;
                if (void 0 === n && (n = {}), !e) return o();
                if (i = r(a), s = l(e + i), d = this._cache.get(s)) return d;
                u = o(), p = n.box || c, h = this._baselineMarker().cloneNode(!1);
                for (f in a) g = a[f], void 0 !== g && (p.style[f] = g);
                return m = n.normalizeText !== !1 ? t(e) : e + "", p.textContent = m, p.appendChild(h), document.body.appendChild(p), m.length && (u.width = p.offsetWidth - this.options.baselineMarkerSize, u.height = p.offsetHeight, u.baseline = h.offsetTop + this.options.baselineMarkerSize), u.width > 0 && u.height > 0 && this._cache.put(s, u), p.parentNode.removeChild(p), u
            },
            _baselineMarker: function() {
                var e = document.createElement("div");
                return e.style.cssText = "display: inline-block; vertical-align: baseline;width: " + this.options.baselineMarkerSize + "px; height: " + this.options.baselineMarkerSize + "px;overflow: hidden;", e
            }
        }), u.current = new u, kendo.deepExtend(kendo.util, {
            LRUCache: n,
            TextMetrics: u,
            measureText: a,
            objectKey: r,
            hashKey: l,
            normalizeText: t
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, r) {
    (r || t)()
}),
function(e, define) {
    define("kendo.grid.min", ["kendo.data.min", "kendo.columnsorter.min", "kendo.editable.min", "kendo.window.min", "kendo.filtermenu.min", "kendo.columnmenu.min", "kendo.groupable.min", "kendo.pager.min", "kendo.selectable.min", "kendo.sortable.min", "kendo.reorderable.min", "kendo.resizable.min", "kendo.ooxml.min", "kendo.excel.min", "kendo.pane.min", "kendo.progressbar.min", "kendo.pdf.min", "kendo.dialog.min", "kendo.pane.min", "kendo.switch.min"], e)
}(function() {
    return function(e, t) {
        function r(e, t) {
            return "[" + Ee.attr(e) + "=" + t + "]"
        }

        function l(e) {
            return Array(e + 1).join('<td class="k-group-cell">&nbsp;</td>')
        }

        function o(e) {
            var t, r = " ";
            if (e) {
                if (typeof e === ar) return e;
                for (t in e) "" !== e[t] && (r += t + '="' + e[t] + '"')
            }
            return r
        }

        function a(t, r) {
            e("th, th .k-grid-filter, th .k-link", t).add(document.body).css("cursor", r)
        }

        function n(t, r, l, o, a) {
            var n, i = r;
            for (r = e(), a = a || 1, n = 0; n < a; n++) r = r.add(t.eq(i + n));
            "number" == typeof l ? r[o ? "insertBefore" : "insertAfter"](t.eq(l)) : r.appendTo(l)
        }

        function i(t, r, l) {
            return e(t).add(r).find(l)
        }

        function s(e, t, r) {
            var l, o, a, n;
            for (r = Ke(r) ? r : [r], l = 0, o = r.length; l < o; l++) a = r[l], Be(a) && a.click && (n = a.name || a.text, t.on(er + pt, "a.k-grid-" + (n || "").replace(/\s/g, ""), {
                commandName: n
            }, $e(a.click, e)))
        }

        function d(e, t, r, l) {
            return Ne(e, function(e) {
                var o, a;
                return e = typeof e === ar ? {
                    field: e
                } : e, e.parentIds = l, _(e) && !r || (e.attributes = te(e.attributes), e.footerAttributes = te(e.footerAttributes), e.headerAttributes = te(e.headerAttributes), o = !0), a = Ee.guid(), e.headerAttributes = Oe({
                    headers: l
                }, e.headerAttributes), e.headerAttributes.id ? a = e.headerAttributes.id : e.headerAttributes = Oe({
                    id: a
                }, e.headerAttributes), e.columns && (e.columns = d(e.columns, t, o, l ? l + " " + a : a)), Oe({
                    encoded: t,
                    hidden: o
                }, e)
            })
        }

        function c(e, t) {
            var r = [];
            return u(e, t, r), r[r.length - 1]
        }

        function u(e, t, r) {
            var l, o;
            for (r = r || [], l = 0; l < t.length; l++) {
                if (e === t[l]) return !0;
                if (t[l].columns) {
                    if (o = r.length, r.push(t[l]), u(e, t[l].columns, r)) return !0;
                    r.splice(o, r.length - o)
                }
            }
            return !1
        }

        function p(e, t) {
            h(e, t, t)
        }

        function h(e, t, r) {
            var l = r ? re : te;
            e.hidden = !t, e.attributes = l(e.attributes), e.footerAttributes = l(e.footerAttributes), e.headerAttributes = l(e.headerAttributes)
        }

        function f(e, t) {
            g(e);
            var r = e._hideByMedia;
            h(e, t, r ? e.matchesMedia : t)
        }

        function g(e) {
            e.matchesMedia = m(e)
        }

        function m(e) {
            return e && (C(e.media) || !C(e.media) && Ee.matchesMedia(e.media))
        }

        function k() {
            return "none" !== this.style.display
        }

        function b(t) {
            return "none" !== e(t)[0].style.display
        }

        function _(e) {
            return v([e]).length > 0
        }

        function v(e) {
            return Ge(e, function(e) {
                var t = !e.hidden && e.matchesMedia !== !1;
                return t && e.columns && (t = v(e.columns).length > 0), t
            })
        }

        function w(e) {
            var t, r, l = [];
            for (r = 0; r < e.length; r++) {
                if (t = e[r], !C(t.media)) {
                    if (!C(t.minScreenWidth)) throw Error("Using 'media' and 'minScreenWidth' options at the same time is not supported.");
                    l.push(t)
                }
                t.columns && (l = l.concat(w(t.columns)))
            }
            return l
        }

        function C(e) {
            return t === e
        }

        function y(t) {
            return e(t).map(function() {
                return this.toArray()
            })
        }

        function S(e, t, r) {
            var l = H(N(t)),
                o = H(G(t)),
                a = e.rowSpan;
            e.rowSpan = r ? l > o ? a - (l - o) || 1 : a + (o - l) : l > o ? a + (l - o) : a - (o - l) || 1
        }

        function T(t, r, l, o, a, n, i, s) {
            var d, c, u = H(t),
                p = H([r]);
            u > p && (d = Array(i + 1).join('<th class="k-group-cell k-header" scope="col">&nbsp;</th>'), c = n.children(":not(.k-filter-row)"), e(Array(u - p + 1).join("<tr>" + d + "</tr>")).insertAfter(c.last())), P(n, u - p), R(l, o, a, n, s)
        }

        function x(t, r, l) {
            var o, a, n, i, s, d, c, u;
            for (l = l || 0, n = r, r = Q(r), i = {}, s = t.find(">tr:not(.k-filter-row)"), d = function() {
                    var t = e(this);
                    return !t.hasClass("k-group-cell") && !t.hasClass("k-hierarchy-cell")
                }, c = 0, u = r.length; c < u; c++) o = I(r[c], n), i[o.row] || (i[o.row] = s.eq(o.row).find(".k-header").filter(d)), a = i[o.row].eq(o.cell), a.attr(Ee.attr("index"), l + c);
            return r.length
        }

        function H(e) {
            var t, r, l = 1,
                o = 0;
            for (t = 0; t < e.length; t++) e[t].columns && (r = H(e[t].columns), r > o && (o = r));
            return l + o
        }

        function R(t, r, l, o, a) {
            var n, i, s = L(t[0], r),
                d = l.find(">tr:not(.k-filter-row):eq(" + s.row + ")>th.k-header"),
                c = e(),
                u = s.cell;
            for (n = 0; n < t.length; n++) c = c.add(d.eq(u + n));
            for (o.find(">tr:not(.k-filter-row)").eq(s.row)[a](c), i = [], n = 0; n < t.length; n++) t[n].columns && (i = i.concat(t[n].columns));
            i.length && R(i, r, l, o, a)
        }

        function I(e, t, r, l) {
            var o, a;
            for (r = r || 0, l = l || {}, l[r] = l[r] || 0, a = 0; a < t.length; a++) {
                if (t[a] == e) {
                    o = {
                        cell: l[r],
                        row: r
                    };
                    break
                }
                if (t[a].columns && (o = I(e, t[a].columns, r + 1, l))) break;
                l[r]++
            }
            return o
        }

        function z(e, t, r, l) {
            var o, a, n = !!r.locked;
            do o = e[t], t += l ? 1 : -1, a = !!o.locked; while (o && t > -1 && t < e.length && o != r && !o.columns && a === n);
            return o
        }

        function E(e, t, r, l, o) {
            var a, n, i, s, d;
            return t.columns ? (t = t.columns, t[l ? 0 : t.length - 1]) : (a = c(t, e), n = a ? a.columns : e, i = je(t, n), 0 === i && l ? i++ : i == n.length - 1 && !l || !r.locked && !t.columns && !l ? i-- : (i > 0 || 0 === i && !l) && i++, s = je(r, n), t = z(n, i, r, s > i), d = je(t, o), (!t.columns || d && d !== n.length - 1) && t && t != r && t.columns ? E(e, t, r, l, o) : null)
        }

        function L(e, t, r, l) {
            var o, a;
            for (r = r || 0, l = l || {}, l[r] = l[r] || 0, a = 0; a < t.length; a++) {
                if (t[a] == e) {
                    o = {
                        cell: l[r],
                        row: r
                    };
                    break
                }
                if (t[a].columns && (o = L(e, t[a].columns, r + 1, l))) break;
                t[a].hidden || l[r]++
            }
            return o
        }

        function M(e) {
            var t = F(N(e));
            return t.concat(F(G(e)))
        }

        function D(e, t, r, l) {
            var o = e[r],
                a = e[l],
                n = c(o, t);
            return t = n ? n.columns : t, je(a, t)
        }

        function F(e) {
            var t, r = [],
                l = [];
            for (t = 0; t < e.length; t++) r.push(e[t]), e[t].columns && (l = l.concat(e[t].columns));
            return l.length && (r = r.concat(F(l))), r
        }

        function A(e) {
            var t, r, l = 0;
            for (r = 0; r < e.length; r++) t = e[r], t.columns ? l += A(t.columns) : t.hidden && l++;
            return l
        }

        function W(e) {
            var t, r, l = 0;
            for (t = 0, r = e.length; t < r; t++) e[t].hidden || (l += parseInt(e[t].width, 10));
            return l
        }

        function q(e) {
            var t, r, l, o = 0;
            for (r = 0, l = e.length; r < l; r++) t = e[r].style.width, t && t.indexOf("%") == -1 && (o += parseInt(t, 10));
            return o
        }

        function V(e, t) {
            var r, l, o = e.find("tr:not(.k-filter-row) th:not(.k-group-cell,.k-hierarchy-cell)");
            for (l = 0; l < o.length; l++) r = o[l].rowSpan, r > 1 && (o[l].rowSpan = r - t || 1)
        }

        function P(e, t) {
            var r, l = e.find("tr:not(.k-filter-row) th:not(.k-group-cell,.k-hierarchy-cell)");
            for (r = 0; r < l.length; r++) l[r].rowSpan += t
        }

        function B(t) {
            var r, l = t.find("tr:not(.k-filter-row)"),
                o = l.filter(function() {
                    return !e(this).children().length
                }).remove().length,
                a = l.find("th:not(.k-group-cell,.k-hierarchy-cell)");
            for (r = 0; r < a.length; r++) a[r].rowSpan > 1 && (a[r].rowSpan -= o);
            return l.length - o
        }

        function O(e, t, r, l, o) {
            var a, n, i, s = [];
            for (a = 0, i = e.length; a < i; a++) n = r[l] || [], n.push(t.eq(o + a)), r[l] = n, e[a].columns && (s = s.concat(e[a].columns));
            s.length && O(s, t, r, l + 1, o + e.length)
        }

        function N(e) {
            return Ge(e, function(e) {
                return e.locked
            })
        }

        function G(e) {
            return Ge(e, function(e) {
                return !e.locked
            })
        }

        function K(e) {
            return Ge(e, function(e) {
                return !e.locked && _(e)
            })
        }

        function j(e) {
            return Ge(e, function(e) {
                return e.locked && _(e)
            })
        }

        function U(e) {
            var t, r = [];
            for (t = 0; t < e.length; t++) e[t].hidden || (e[t].columns ? r = r.concat(U(e[t].columns)) : r.push(e[t]));
            return r
        }

        function $(e) {
            var t, r = [];
            for (t = 0; t < e.length; t++) e[t].columns && (r = r.concat(e[t].columns));
            return r
        }

        function Q(e) {
            var t, r = [];
            for (t = 0; t < e.length; t++) e[t].columns ? r = r.concat(Q(e[t].columns)) : r.push(e[t]);
            return r
        }

        function J(e) {
            var t, r = [];
            for (e = Q(e), t = 0; t < e.length; t++) "string" == typeof e[t] ? r.push(e[t]) : e[t].field && r.push(e[t].field);
            return r
        }

        function Y(r) {
            var l, o = r.find(">tr:not(.k-filter-row)"),
                a = function() {
                    var t = e(this);
                    return !t.hasClass("k-group-cell") && !t.hasClass("k-hierarchy-cell")
                },
                n = e();
            return o.length > 1 && (n = o.find("th").filter(a).filter(function() {
                return this.rowSpan > 1
            })), n = n.add(o.last().find("th").filter(a)), l = Ee.attr("index"), n.sort(function(r, o) {
                var a, n;
                return r = e(r), o = e(o), a = r.attr(l), n = o.attr(l), a === t && (a = e(r).index()), n === t && (n = e(o).index()), a = parseInt(a, 10), n = parseInt(n, 10), a > n ? 1 : a < n ? -1 : 0
            }), n
        }

        function X(t) {
            var r, l, o, a, n, i, s, d = t.closest("table"),
                c = e().add(t),
                u = t.closest("tr"),
                p = d.find("tr:not(.k-filter-row)"),
                h = p.index(u);
            if (h > 0) {
                for (r = p.eq(h - 1), l = r.find("th:not(.k-group-cell,.k-hierarchy-cell)").filter(function() {
                        return !e(this).attr("rowspan")
                    }), o = 0, a = u.find("th:not(.k-group-cell,.k-hierarchy-cell)").index(t), n = t.prevAll(":not(.k-group-cell,.k-hierarchy-cell)").filter(function() {
                        return this.colSpan > 1
                    }), i = 0; i < n.length; i++) o += n[i].colSpan || 1;
                for (a += Math.max(o - 1, 0), o = 0, i = 0; i < l.length; i++)
                    if (s = l.eq(i), o += s.attr("data-colspan") ? s[0].getAttribute("data-colspan") : 1, a >= i && a < o) {
                        c = X(s).add(c);
                        break
                    }
            }
            return c
        }

        function Z(t) {
            var r, l, o, a, n, i, s, d = t.closest("thead"),
                c = e().add(t),
                u = t.closest("tr"),
                p = d.find("tr:not(.k-filter-row)"),
                h = p.index(u) + t[0].rowSpan,
                f = Ee.attr("colspan");
            if (h <= p.length - 1) {
                for (r = u.next(), l = t.prevAll(":not(.k-group-cell,.k-hierarchy-cell)"), l = l.filter(function() {
                        return !this.rowSpan || 1 === this.rowSpan
                    }), a = 0, o = 0; o < l.length; o++) a += parseInt(l.eq(o).attr(f), 10) || 1;
                for (n = r.find("th:not(.k-group-cell,.k-hierarchy-cell)"), i = parseInt(t.attr(f), 10) || 1, o = 0; o < i;) r = n.eq(o + a), c = c.add(Z(r)), s = parseInt(r.attr(f), 10), s > 1 && (i -= s - 1), o++
            }
            return c
        }

        function ee(t, r, l, o) {
            var a, n = t;
            return o && t.empty(), Fe ? t[0].innerHTML = l : (a = document.createElement("div"), a.innerHTML = "<table><tbody>" + l + "</tbody></table>", t = a.firstChild.firstChild, r[0].replaceChild(t, n[0]), t = e(t)), t
        }

        function te(e) {
            e = e || {};
            var t = e.style;
            return t ? (t = t.replace(/display:[^;]*/i, "display:none"), t.match(/display:/i) || (t = t.replace(/(.*)?/i, "display:none;$1"))) : t = "display:none", Oe({}, e, {
                style: t
            })
        }

        function re(e) {
            e = e || {};
            var t = e.style;
            return t && (e.style = t.replace(/(display\s*:\s*none\s*;?)*/gi, "")), e
        }

        function le(t, r, l, o) {
            var a, n = t.find(">colgroup"),
                i = Ne(r, function(e) {
                    return a = e.width, a && 0 !== parseInt(a, 10) ? Ee.format('<col style="width:{0}"/>', typeof a === ar ? a : a + "px") : "<col />"
                });
            (l || n.find(".k-hierarchy-col").length) && i.splice(0, 0, '<col class="k-hierarchy-col" />'), n.length && n.remove(), n = e(Array(o + 1).join('<col class="k-group-col">') + i.join("")), n.is("colgroup") || (n = e("<colgroup/>").append(n)), t.prepend(n), Fr.msie && 8 == Fr.version && (t.css("display", "inline-table"), window.setTimeout(function() {
                t.css("display", "")
            }, 1))
        }

        function oe(e, t) {
            var r, l, o = 0,
                a = e.find("th:not(.k-group-cell)");
            for (r = 0, l = t.length; r < l; r++) t[r].locked && (a.eq(r).insertBefore(a.eq(o)), a = e.find("th:not(.k-group-cell)"), o++)
        }

        function ae(e) {
            var t, r, l, o = {};
            for (r = 0, l = e.length; r < l; r++) t = e[r], o[t.value] = t.text;
            return o
        }

        function ne(e, t, r, l) {
            var o = r && r.length && Be(r[0]) && "value" in r[0],
                a = o ? ae(r)[e] : e;
            return a = null != a ? a : "", t ? Ee.format(t, a) : l === !1 ? a : Ee.htmlEncode(a)
        }

        function ie(e, t, r) {
            for (var l, o = 0, a = e[o]; a;) {
                if (l = !!r || "none" !== a.style.display, l && !Ir.test(a.className) && --t < 0) {
                    a.style.display = r ? "" : "none";
                    break
                }
                a = e[++o]
            }
        }

        function se(t, r) {
            for (var l, o, a = 0, n = t.length; a < n; a += 1) o = t.eq(a), o.is(".k-grouping-row,.k-detail-row") ? (l = o.children(":not(.k-group-cell):first,.k-detail-cell").last(), l.attr("colspan", parseInt(l.attr("colspan"), 10) - 1)) : (o.hasClass("k-grid-edit-row") && (l = o.children(".k-edit-container")[0]) && (l = e(l), l.attr("colspan", parseInt(l.attr("colspan"), 10) - 1), l.find("col").eq(r).remove(), o = l.find("tr:first")), ie(o[0].cells, r, !1))
        }

        function de(e) {
            var t, r, l = [];
            for (r = 0; r < e.length && (t = e[r], "field" in t && "value" in t && "items" in t); r++) l.push(t), t.hasSubgroups && (l = l.concat(de(t.items)));
            return l
        }

        function ce(e) {
            var t, r, l = [];
            for (r = 0; r < e.length && (t = e[r], "field" in t && "value" in t && "items" in t); r++) t.hasSubgroups && (l = l.concat(ce(t.items))), l.push(t.aggregates);
            return l
        }

        function ue(t, r) {
            for (var l, o, a, n = 0, i = t.length; n < i; n += 1) o = t.eq(n), o.is(".k-grouping-row,.k-detail-row") ? (l = o.children(":not(.k-group-cell):first,.k-detail-cell").last(), l.attr("colspan", parseInt(l.attr("colspan"), 10) + 1)) : (o.hasClass("k-grid-edit-row") && (l = o.children(".k-edit-container")[0]) && (l = e(l), l.attr("colspan", parseInt(l.attr("colspan"), 10) + 1), le(l.find(">form>table"), v(a), !1, 0), o = l.find("tr:first")), ie(o[0].cells, r, !0))
        }

        function pe(e, t, r) {
            r = r || 1;
            var l, o, a;
            for (o = 0, a = e.length; o < a; o++) l = e.eq(o).children().last(), l.attr("colspan", parseInt(l.attr("colspan"), 10) + r), l = t.eq(o).children().last(), l.attr("colspan", parseInt(l.attr("colspan"), 10) - r)
        }

        function he(e) {
            var t, r, l = 0,
                o = e.find(">colgroup>col");
            for (t = 0, r = o.length; t < r; t += 1) l += parseInt(o[t].style.width, 10);
            return l
        }

        function fe(e, t) {
            var r, l, o, a;
            e = e[0], t = t[0], e.rows.length !== t.rows.length && (r = e.offsetHeight, l = t.offsetHeight, r > l ? (o = t.rows[t.rows.length - 1], zr.test(o.className) && (o = t.rows[t.rows.length - 2]), a = r - l) : (o = e.rows[e.rows.length - 1], zr.test(o.className) && (o = e.rows[e.rows.length - 2]), a = l - r), o.style.height = o.offsetHeight + a + "px")
        }

        function ge(e, t) {
            var r, l = e.offsetHeight,
                o = t.offsetHeight;
            l > o ? r = l + "px" : l < o && (r = o + "px"), r && (e.style.height = t.style.height = r)
        }

        function me(e, t) {
            var r, l, o;
            if (typeof e === ar && e === t) return e;
            if (Be(e) && e.name === t) return e;
            if (Ke(e))
                for (r = 0, l = e.length; r < l; r++)
                    if (o = e[r], typeof o === ar && o === t || o.name === t) return o;
            return null
        }

        function ke(t, r) {
            if (r === !0) {
                t = e(t);
                var l = t.parent().scrollLeft();
                Ee.focusElement(t), t.parent().scrollLeft(l)
            } else e(t).one("focusin", function(e) {
                e.preventDefault()
            }).focus()
        }

        function be(e, r) {
            return e.options.groupable && (r.groupable || r.groupable === t)
        }

        function _e(t, r) {
            return !!e.grep(t, function(e) {
                return e.field === r
            }).length
        }

        function ve(e, t) {
            return !(!e.field || e.selectable) && (!(t.editable && !t.editable(e.field)) && !(e.editable && !e.editable(t)))
        }

        function we(t) {
            return e(t).is(":button,a,:input,a>.k-icon,textarea,span.k-select,span.k-icon,span.k-link,label.k-checkbox-label,.k-input,.k-multiselect-wrap,.k-picker-wrap,.k-picker-wrap>.k-selected-color,.k-tool-icon,.k-dropdown")
        }

        function Ce(r) {
            var l = e(r.currentTarget),
                o = l.is("th"),
                a = this.table.add(this.lockedTable),
                n = this.thead.parent().add(e(">table", this.lockedHeader)),
                i = we(r.target),
                s = e(r.target).is(".k-checkbox-label, .k-checkbox"),
                d = e(r.target),
                c = l.closest("table")[0];
            return i && l.find(Ee.roleSelector("filtercell")).length ? (this._setCurrent(l), t) : (c !== a[0] && c !== a[1] && c !== n[0] && c !== n[1] || d.is("a.k-i-expand, a.k-i-collapse") || (this.options.navigatable && this._setCurrent(l, !1, s), !o && i || setTimeout(function() {
                Wr && e(Ee._activeElement()).hasClass("k-widget") || !e(Ee._activeElement()).is(Bt) && we(Ee._activeElement()) && e.contains(c, Ee._activeElement()) || ke(c, !0)
            }), o && !Ee.support.touch && r.preventDefault()), t)
        }

        function ye(e, t) {
            if (!t) return 0;
            var r = 0;
            return Ee.support.browser.webkit && (r = e.width()), r
        }

        function Se(e) {
            var r;
            return "string" == typeof e ? (r = e.toLowerCase(), "true" === r ? {
                rows: !0
            } : {
                rows: r.indexOf("rows") > -1,
                columns: r.indexOf("columns") > -1
            }) : e === !0 ? {
                rows: !0
            } : t
        }

        function Te(t, r) {
            var l, o;
            return !!t && (r = e(r), !!(r[0] && Ye(t[0], r[0]) && (l = r.offset().top - t.offset().top, o = r.outerHeight() / 2, (l >= 0 || Xe.abs(l) <= o) && Xe.floor(l + o) <= t.height())))
        }

        function xe(e) {
            return e && (e.hasClass("k-edit-cell") || e.parent().hasClass("k-grid-edit-row"))
        }

        function He(e) {
            return '<td colspan="#=data.colspan +' + e + '#"><p class="k-reset"><a class="k-icon k-i-collapse" href="\\#" tabindex="-1" ' + Tr + '="' + yr + '"></a>#=data.text#</p></td>'
        }

        function Re(e) {
            return '<td colspan="' + e + '"><p class="k-reset">&nbsp;</p></td>'
        }

        function Ie(e, t, r) {
            return '<tr role="row" class="k-grouping-row">' + l(t) + '<td colspan="' + e + '" aria-expanded="true"><p class="k-reset"><a class="k-icon k-i-collapse" href="#" tabindex="-1" ' + Tr + '="' + yr + '"></a>' + r + "</p></td></tr>"
        }

        function ze(e) {
            return '<tr role="row" class="k-grouping-row"><td colspan="' + e + '" aria-expanded="true"><p class="k-reset">&nbsp;</p></td></tr>'
        }
        var Ee = window.kendo,
            Le = Ee.ui,
            Me = Ee.data.DataSource,
            De = Ee.data.ObservableObject,
            Fe = Ee.support.tbodyInnerHtml,
            Ae = Ee._activeElement,
            We = Le.Widget,
            qe = Ee._outerWidth,
            Ve = Ee._outerHeight,
            Pe = Ee.keys,
            Be = e.isPlainObject,
            Oe = e.extend,
            Ne = e.map,
            Ge = e.grep,
            Ke = e.isArray,
            je = e.inArray,
            Ue = Array.prototype.push,
            $e = e.proxy,
            Qe = Ee.isFunction,
            Je = e.isEmptyObject,
            Ye = e.contains,
            Xe = Math,
            Ze = ".",
            et = "progress",
            tt = "error",
            rt = "k-hierarchy-cell",
            lt = ":not(.k-group-cell):not([" + Ee.attr("virtual") + "]):not(.k-hierarchy-cell:not(:has(.k-icon.k-i-collapse,.k-icon.k-i-expand))):visible",
            ot = "tbody>tr:not(.k-grouping-row):not(.k-detail-row):not(.k-group-footer) > td:not(.k-group-cell):not(.k-hierarchy-cell)",
            at = "tr:not(.k-footer-template):visible",
            nt = ":not(.k-group-cell):not(.k-detail-cell):not(.k-hierarchy-cell):visible",
            it = "tr:not(.k-grouping-row):not(.k-detail-row):not(.k-footer-template):not(.k-group-footer):visible",
            st = it + ":first",
            dt = it + ":last",
            ct = at + ":first>" + nt + ":first",
            ut = "th.k-header:not(.k-group-cell):not(.k-hierarchy-cell)",
            pt = ".kendoGrid",
            ht = "k-grid-content-locked",
            ft = "k-group-cell",
            gt = "edit",
            mt = "beforeEdit",
            kt = "save",
            bt = "remove",
            _t = "detailInit",
            vt = "filterMenuInit",
            wt = "columnMenuInit",
            Ct = "filterMenuOpen",
            yt = "columnMenuOpen",
            St = "cellClose",
            Tt = "change",
            xt = "columnHide",
            Ht = "columnShow",
            Rt = "saveChanges",
            It = "dataBound",
            zt = "detailExpand",
            Et = "detailCollapse",
            Lt = "itemchange",
            Mt = "page",
            Dt = "paging",
            Ft = "scroll",
            At = "sync",
            Wt = "k-state-focused",
            qt = ":kendoFocusable",
            Vt = "k-state-selected",
            Pt = "k-checkbox",
            Bt = "input[data-role='checkbox']." + Pt,
            Ot = "k-grid-norecords",
            Nt = "k-link",
            Gt = "k-icon",
            Kt = "k-sort-order",
            jt = "k-header-column-menu",
            Ut = "k-grid-filter",
            $t = "resize",
            Qt = "columnResize",
            Jt = "columnReorder",
            Yt = "columnLock",
            Xt = "columnUnlock",
            Zt = "navigate",
            er = "click",
            tr = "mousedown",
            rr = "height",
            lr = "tabIndex",
            or = "function",
            ar = "string",
            nr = "bottom",
            ir = "container-for",
            sr = "field",
            dr = "input",
            cr = "incell",
            ur = "inline",
            pr = "uid",
            hr = 1,
            fr = "colSpan",
            gr = "overflow",
            mr = "hidden",
            kr = "sort",
            br = "group-sort",
            _r = "Are you sure you want to delete this record?",
            vr = "No records available.",
            wr = "Delete",
            Cr = "Cancel",
            yr = "Zwiń",
            Sr = "Rozwiń",
            Tr = "aria-label",
            xr = /(\}|\#)/gi,
            Hr = /#/gi,
            Rr = "[\\x20\\t\\r\\n\\f]",
            Ir = RegExp("(^|" + Rr + ")(k-group-cell|k-hierarchy-cell)(" + Rr + "|$)"),
            zr = RegExp("(^|" + Rr + ")(k-filter-row)(" + Rr + "|$)"),
            Er = '# if (iconClass) {#<a role="button" class="k-button k-button-icontext #=className#" #=attr# href="\\#"><span class="#=iconClass#"></span>#=text#</a># } else { #<a role="button" class="k-button k-button-icontext #=className#" #=attr# href="\\#">#=text#</a># } #',
            Lr = '# var checkboxGuid = kendo.guid(); #<input class="' + Pt + '" data-role="checkbox" id="#= checkboxGuid #" aria-label="Select row" aria-checked="false" type="checkbox"><label for="#= checkboxGuid #" class="k-checkbox-label k-no-text">&\\#8203;</label>',
            Mr = '# var checkboxGuid = kendo.guid(); #<input class="' + Pt + '" data-role="checkbox" aria-label="Select all rows" aria-checked="false" type="checkbox" id="#= checkboxGuid #"><label for="#= checkboxGuid #" class="k-checkbox-label k-no-text">##&\\#8203;##</label>',
            Dr = !1,
            Fr = Ee.support.browser,
            Ar = Fr.msie && 7 == Fr.version,
            Wr = Fr.msie && 8 == Fr.version,
            qr = Fr.msie && 11 === Fr.version,
            Vr = /Mac OS/.test(navigator.userAgent),
            Pr = {
                content: "k-content",
                widget: "k-widget",
                scrollContainer: "k-scroll-container"
            },
            Br = We.extend({
                init: function(e, t) {
                    var r = this;
                    We.fn.init.call(r, e, t), r._refreshHandler = $e(r.refresh, r), r.setDataSource(t.dataSource), r.wrap()
                },
                setDataSource: function(e) {
                    var t = this;
                    t.dataSource && t.dataSource.unbind(Tt, t._refreshHandler), t.dataSource = e, t.dataSource.bind(Tt, t._refreshHandler), t.dataSource.options.useRanges = !0
                },
                options: {
                    name: "VirtualScrollable",
                    itemHeight: e.noop,
                    prefetch: !0,
                    maxScrollHeight: 25e4
                },
                events: [Dt, Mt, Ft],
                destroy: function() {
                    var e = this;
                    We.fn.destroy.call(e), e.dataSource.unbind(Tt, e._refreshHandler), e.wrapper.add(e.verticalScrollbar).off(pt), clearTimeout(e._timeout), e._scrollingTimeout && clearTimeout(e._scrollingTimeout), e.drag && (e.drag.destroy(), e.drag = null), e.wrapper = e.element = e.verticalScrollbar = null, e._refreshHandler = null
                },
                wrap: function() {
                    var t, r = this,
                        l = Ee.support.scrollbar() + 1,
                        o = r.element;
                    o.css({
                        width: "auto",
                        overflow: "hidden"
                    }).css(Dr ? "padding-left" : "padding-right", l), r.content = o.children().first(), t = r.wrapper = r.content.wrap('<div class="k-virtual-scrollable-wrap"/>').parent().bind("DOMMouseScroll" + pt + " mousewheel" + pt, $e(r._wheelScroll, r)), r._wrapper(), (Ee.support.kineticScrollNeeded || Ee.support.touch) && (r.wrapper.css("touch-action", "none"), r.drag = new Ee.UserEvents(r.wrapper, {
                        global: !0,
                        allowSelection: !0,
                        start: function(e) {
                            e.sender.capture()
                        },
                        move: function(e) {
                            r.verticalScrollbar.scrollTop(r.verticalScrollbar.scrollTop() - e.y.delta), t.scrollLeft(t.scrollLeft() - e.x.delta), e.preventDefault()
                        }
                    })), r.verticalScrollbar = e('<div class="k-scrollbar k-scrollbar-vertical" />').css({
                        width: l
                    }).appendTo(o).bind("scroll" + pt, $e(r._scroll, r))
                },
                _wrapper: function() {
                    var e = this;
                    qr && (e.wrapper.css({
                        "overflow-y": Ft
                    }), e.element.css(Dr ? "padding-left" : "padding-right", 0))
                },
                _wheelScroll: function(e) {
                    if (!e.ctrlKey) {
                        var t = this.verticalScrollbar,
                            r = t.scrollTop(),
                            l = Ee.wheelDeltaY(e);
                        !l || l > 0 && 0 === r || l < 0 && r + t[0].clientHeight == t[0].scrollHeight || (e.preventDefault(), this.verticalScrollbar.scrollTop(r + -l))
                    }
                },
                _scroll: function(e) {
                    var r = this,
                        l = !r.options.prefetch,
                        o = e.currentTarget.scrollTop,
                        a = r.dataSource,
                        n = r.itemHeight,
                        i = a.skip() || 0,
                        s = r._rangeStart || i,
                        d = r.element.innerHeight(),
                        c = !!(r._scrollbarTop && r._scrollbarTop > o),
                        u = Xe.max(Xe.floor(o / n), 0),
                        p = c ? Xe.ceil(d / n) : Xe.floor(d / n),
                        h = Xe.max(u + p, 0);
                    return r._preventScroll ? (r._preventScroll = !1, t) : (r._scrollTop = o - s * n, r._scrollbarTop = o, r._scrolling = l, r._fetch(u, h, c) || (r.wrapper[0].scrollTop = r._scrollTop), r.trigger(Ft), l && (r._scrollingTimeout && clearTimeout(r._scrollingTimeout), r._scrollingTimeout = setTimeout(function() {
                        r._scrolling = !1, r._page(r._rangeStart, r.dataSource.take())
                    }, 100)), t)
                },
                scrollToTop: function() {
                    this._scrollTo(0)
                },
                scrollToBottom: function() {
                    var e = this.verticalScrollbar;
                    this._scrollTo(e[0].scrollHeight - e.height())
                },
                _scrollWrapperToTop: function() {
                    this.wrapper.scrollTop(0)
                },
                _scrollWrapperToBottom: function() {
                    this.wrapper.scrollTop(this.wrapper[0].scrollHeight)
                },
                _scrollWrapperOnColumnResize: function() {
                    var e = this,
                        t = this.wrapper,
                        r = t.scrollTop();
                    t[0].scrollWidth > t[0].clientWidth ? (!e._wrapperScrolled && r || e._isScrolledToBottom()) && (t.scrollTop(r + Ee.support.scrollbar()), e._scrollTop = t.scrollTop(), e._wrapperScrolled = !0) : e._wrapperScrolled && (e._isWrapperScrolledToBottom() || (t.scrollTop(r - Ee.support.scrollbar()), e._scrollTop = t.scrollTop()), e._wrapperScrolled = !1)
                },
                _scrollTo: function(e) {
                    var t = this,
                        r = t.verticalScrollbar;
                    r.scrollTop() !== e && (t._preventScroll = !0), t.wrapper.scrollTop(e), t._scrollTop = t.wrapper.scrollTop(), r.scrollTop(e), t._scrollbarTop = r.scrollTop()
                },
                _isScrolledToTop: function() {
                    return 0 === this.verticalScrollbar.scrollTop()
                },
                _isScrolledToBottom: function() {
                    var e = this.verticalScrollbar,
                        t = e.scrollTop();
                    return t > 0 && t >= parseInt(e[0].scrollHeight - e.height(), 10)
                },
                _isWrapperScrolledToBottom: function() {
                    var e = this.wrapper;
                    return e.scrollTop() >= parseInt(e[0].scrollHeight - e.height(), 10)
                },
                itemIndex: function(e) {
                    var t = this._rangeStart || this.dataSource.skip() || 0;
                    return t + e
                },
                position: function(e) {
                    var t, r = this._rangeStart || this.dataSource.skip() || 0,
                        l = this.dataSource.pageSize();
                    return t = e > r ? e - r : r - e - 1, t > l ? l : t
                },
                scrollIntoView: function(e) {
                    var t = this.wrapper[0],
                        r = t.clientHeight,
                        l = this._isScrolledToBottom() ? t.scrollTop : this._scrollTop || t.scrollTop,
                        o = e[0].offsetTop,
                        a = e[0].offsetHeight;
                    l > o ? this.verticalScrollbar[0].scrollTop -= r / 2 : o + a >= l + r && (this.verticalScrollbar[0].scrollTop += r / 2)
                },
                _fetch: function(t, r, l) {
                    var o = this,
                        a = o.dataSource,
                        n = o.itemHeight,
                        i = a.take(),
                        s = o._rangeStart || a.skip() || 0,
                        d = Xe.floor(t / i) * i,
                        c = !1,
                        u = .33,
                        p = o.verticalScrollbar,
                        h = Fr.webkit ? 1 : 0;
                    return t < s ? (c = !0, s = Xe.max(0, r - i), o._scrollTop = p.scrollTop() - s * n, o._page(s, i)) : r >= s + i && !l ? (c = !0, s = Xe.min(t, a.total() - i), o._scrollTop = p.scrollTop() >= p[0].scrollHeight - p[0].offsetHeight - h ? o.wrapper[0].scrollHeight - o.wrapper[0].offsetHeight : n, o._page(s, i)) : !o._fetching && o.options.prefetch && (t < d + i - i * u && t > i && a.prefetch(d - i, i, e.noop), r > d + i * u && a.prefetch(d + i, i, e.noop)), c
                },
                fetching: function() {
                    return this._fetching
                },
                _page: function(t, r, l) {
                    var o = this,
                        a = !o.options.prefetch,
                        n = o.dataSource;
                    l = Qe(l) ? l : e.noop, o.trigger(Dt, {
                        skip: t,
                        take: r
                    }) || (clearTimeout(o._timeout), o._fetching = !0, o._rangeStart = t, n.inRange(t, r) ? (Ee.ui.progress(e(o.wrapper).parent(), !0), n.range(t, r, function() {
                        Ee.ui.progress(e(o.wrapper).parent(), !1), l(), o.trigger(Mt)
                    })) : (a || Ee.ui.progress(o.wrapper.parent(), !0), o._timeout = setTimeout(function() {
                        o._scrolling || (a && Ee.ui.progress(o.wrapper.parent(), !0), n.range(t, r, function() {
                            Ee.ui.progress(o.wrapper.parent(), !1), l(), o.trigger(Mt)
                        }))
                    }, 100)))
                },
                repaintScrollbar: function(e) {
                    var r, l = this,
                        o = "",
                        a = l.options.maxScrollHeight,
                        n = l.dataSource,
                        i = Ee.support.kineticScrollNeeded ? 0 : Ee.support.scrollbar(),
                        s = l.wrapper[0],
                        d = l._isScrolledToBottom(),
                        c = l.itemHeight = l.options.itemHeight() || 0,
                        u = s.scrollWidth > s.offsetWidth ? i : 0,
                        p = n.total() * c + u;
                    for (r = 0; r < Xe.floor(p / a); r++) o += '<div style="width:1px;height:' + a + 'px"></div>';
                    p % a && (o += '<div style="width:1px;height:' + p % a + 'px"></div>'), l.verticalScrollbar.html(o), d && !l._isScrolledToBottom() && l.scrollToBottom(), t !== l._scrollTop && e && (s.scrollTop = l._scrollTop, l._scrollWrapperOnColumnResize())
                },
                refresh: function(e) {
                    var r = this,
                        l = r.dataSource,
                        o = r._rangeStart,
                        a = (e || {}).action,
                        n = r._isScrolledToBottom() || !a || a !== Lt && a !== bt && a !== At;
                    Ee.ui.progress(r.wrapper.parent(), !1), clearTimeout(r._timeout), r.repaintScrollbar(n), r.drag && r.drag.cancel(), t === o || r._fetching || ((!a || a !== At && a !== Lt) && (r._rangeStart = l.skip()), 1 !== l.page() || a && (a === At || a === Lt) || (r.verticalScrollbar[0].scrollTop = 0)), r._fetching = !1
                }
            }),
            Or = {
                create: {
                    text: "Add new record",
                    className: "k-grid-add",
                    iconClass: "k-icon k-i-plus"
                },
                cancel: {
                    text: "Cancel changes",
                    className: "k-grid-cancel-changes",
                    iconClass: "k-icon k-i-cancel"
                },
                save: {
                    text: "Save changes",
                    className: "k-grid-save-changes",
                    iconClass: "k-icon k-i-check"
                },
                destroy: {
                    text: "Delete",
                    className: "k-grid-delete",
                    iconClass: "k-icon k-i-close"
                },
                edit: {
                    text: "Edit",
                    className: "k-grid-edit",
                    iconClass: "k-icon k-i-edit"
                },
                update: {
                    text: "Update",
                    className: "k-primary k-grid-update",
                    iconClass: "k-icon k-i-check"
                },
                canceledit: {
                    text: "Cancel",
                    className: "k-grid-cancel",
                    iconClass: "k-icon k-i-cancel"
                },
                excel: {
                    text: "Export to Excel",
                    className: "k-grid-excel",
                    iconClass: "k-icon k-i-file-excel"
                },
                pdf: {
                    text: "Export to PDF",
                    className: "k-grid-pdf",
                    iconClass: "k-icon k-i-file-pdf"
                }
            },
            Nr = Ee.ui.DataBoundWidget.extend({
                init: function(t, r, l) {
                    var o = this;
                    r = Ke(r) ? {
                        dataSource: r
                    } : r, We.fn.init.call(o, t, r), l && (o._events = l), Dr = Ee.support.isRtl(t), o._element(), o._aria(), o._columns(e.extend(!0, [], o.options.columns)), o._dataSource(), o._tbody(), o._pageable(), o._thead(), o._groupable(), o._toolbar(), o._setContentHeight(), o._templates(), o._navigatable(), o._selectable(), o._clipboard(), o._details(), o._editable(), o._attachCustomCommandsEvent(), o._adaptiveColumns(), o._minScreenSupport(), o.options.autoBind ? o.dataSource.fetch() : (o._group = o._groups() > 0, o._footer()), o.lockedContent && (o.wrapper.addClass("k-grid-lockedcolumns"), o._resizeHandler = function() {
                        o.resize()
                    }, e(window).on("resize" + pt, o._resizeHandler)), Ee.notify(o)
                },
                events: [Tt, "dataBinding", "cancel", It, zt, Et, _t, vt, Ct, wt, yt, gt, mt, kt, bt, Rt, St, Qt, Jt, Ht, xt, Yt, Xt, Zt, "page", "sort", "filter", "group", "groupExpand", "groupCollapse"],
                setDataSource: function(e) {
                    var t, r = this,
                        l = r.options.scrollable;
                    r.options.dataSource = e, r._dataSource(), r._pageable(), r._thead(), l && (l.virtual ? (t = r.content.find(">.k-virtual-scrollable-wrap"), t.scrollLeft(ye(t, Dr))) : (t = r.tbody, r.content.scrollLeft(ye(t, Dr)))), r.options.groupable && r._groupable(), r.virtualScrollable && r.virtualScrollable.setDataSource(r.options.dataSource), r.options.navigatable && r._navigatable(), r.options.selectable && r._selectable(), r.options.autoBind && r.dataSource.fetch()
                },
                options: {
                    name: "Grid",
                    columns: [],
                    toolbar: null,
                    autoBind: !0,
                    filterable: !1,
                    scrollable: !0,
                    sortable: !1,
                    selectable: !1,
                    allowCopy: !1,
                    navigatable: !1,
                    pageable: !1,
                    persistSelection: !1,
                    editable: !1,
                    groupable: !1,
                    rowTemplate: "",
                    altRowTemplate: "",
                    search: !1,
                    noRecords: !1,
                    dataSource: {},
                    height: null,
                    resizable: !1,
                    reorderable: !1,
                    columnMenu: !1,
                    detailTemplate: null,
                    columnResizeHandleWidth: 3,
                    mobile: "",
                    messages: {
                        editable: {
                            cancelDelete: Cr,
                            confirmation: _r,
                            confirmDelete: wr
                        },
                        commands: {
                            create: Or.create.text,
                            cancel: Or.cancel.text,
                            save: Or.save.text,
                            destroy: Or.destroy.text,
                            edit: Or.edit.text,
                            update: Or.update.text,
                            canceledit: Or.canceledit.text,
                            excel: Or.excel.text,
                            pdf: Or.pdf.text
                        },
                        search: "Search...",
                        noRecords: vr,
                        expandCollapseColumnHeader: "",
                        groupHeader: "Press ctrl + space to group",
                        ungroupHeader: "Press ctrl + space to ungroup"
                    }
                },
                destroy: function() {
                    var t, r = this;
                    r._angularItems("cleanup"), r._destroyColumnAttachments(), We.fn.destroy.call(r), this._navigatableTables && (this._navigatableTables.off(pt), this._navigatableTables = null), r._resizeHandler && e(window).off("resize" + pt, r._resizeHandler), r.pager && r.pager.element && r.pager.destroy(), r.timer && clearTimeout(r.timer), r._progressTimeOut && clearTimeout(r._progressTimeOut), r._collapseGroupsTimeOut && clearTimeout(r._collapseGroupsTimeOut), r._endlessFetchTimeOut && clearTimeout(r._endlessFetchTimeOut), r.pager = null, r._destroyGroupable(), r.options.reorderable && r.wrapper.data("kendoReorderable").destroy(), r.selectable && r.selectable.element && (r.selectable.destroy(), r.clearArea(), r._selectedIds = null, r.copyHandler && (r.wrapper.off("keydown", r.copyHandler), r.unbind(r.copyHandler)), r.updateClipBoardState && (r.unbind(r.updateClipBoardState), r.updateClipBoardState = null), r.clearAreaHandler && r.wrapper.off("keyup", r.clearAreaHandler)), r.selectable = null, r.resizable && (r.resizable.destroy(), r._resizeUserEvents && (r._resizeHandleDocumentClickHandler && e(document).off("click", r._resizeHandleDocumentClickHandler), r._resizeUserEvents.destroy(), r._resizeUserEvents = null), r.resizable = null), r._destroyVirtualScrollable(), r._destroyEditable(), r.dataSource && (r.dataSource.unbind(Tt, r._refreshHandler).unbind(et, r._progressHandler).unbind(tt, r._errorHandler).unbind(kr, r._clearSortClasses), r._refreshHandler = r._progressHandler = r._errorHandler = r._clearSortClasses = null), t = r.element.add(r.wrapper).add(r.table).add(r.thead).add(r.wrapper.find(">.k-grid-toolbar")), r.content && (t = t.add(r.content).add(r.content.find(">.k-virtual-scrollable-wrap"))), r.lockedHeader && r._removeLockedContainers(), r.pane && r.pane.destroy(), r._isMobile && (r.wrapper.off("transitionend" + pt), r.wrapper.off("contextmenu" + pt)), r.minScreenResizeHandler && e(window).off("resize", r.minScreenResizeHandler), r._detachColumnMediaResizeHandler(), r._draggableInstance && r._draggableInstance.element && r._draggableInstance.destroy(), r._draggableInstance = null, t.off(pt), Ee.destroy(r.wrapper), r.rowTemplate = r.altRowTemplate = r.lockedRowTemplate = r.lockedAltRowTemplate = r.detailTemplate = r.footerTemplate = r.groupFooterTemplate = r.lockedGroupFooterTemplate = r.noRecordsTemplate = null,
                        r.scrollables = r.thead = r.tbody = r.element = r.table = r.content = r.footer = r.wrapper = r.lockedTable = r.lockedContent = r.lockedHeader = r.lockedFooter = r._groupableClickHandler = r._groupRows = r._setContentWidthHandler = null
                },
                getOptions: function() {
                    var r, l, o, a = this.options;
                    return a.dataSource = null, r = Oe(!0, {}, this.options), r.columns = Ee.deepExtend([], this.columns), l = this.dataSource, o = l.options.data && l._data, l.options.data = null, r.dataSource = e.extend(!0, {}, l.options), l.options.data = o, r.dataSource.data = o, r.dataSource.page = l.page(), r.dataSource.filter = e.extend(!0, {}, l.filter()), r.dataSource.pageSize = l.pageSize(), r.dataSource.sort = l.sort(), r.dataSource.group = l.group(), r.dataSource.aggregate = l.aggregate(), r.dataSource.transport && (r.dataSource.transport.dataSource = null), r.pageable && r.pageable.pageSize && (r.pageable.pageSize = l.pageSize()), r.$angular = t, r
                },
                setOptions: function(e) {
                    var t, r, l, o, a = this.getOptions();
                    Ee.deepExtend(a, e), e.dataSource || (a.dataSource = this.dataSource), t = this.wrapper, r = this._events, l = this.element, this.destroy(), this.options = null, this._isMobile && (o = t.closest(Ee.roleSelector("pane")).parent(), o.after(t), o.remove(), t.removeClass("k-grid-mobile")), t[0] !== l[0] && (t.before(l), t.remove()), l.empty(), this.init(l, a, r), this._setEvents(a)
                },
                items: function() {
                    return this.lockedContent ? this._items(this.tbody).add(this._items(this.lockedTable.children("tbody"))) : this._items(this.tbody)
                },
                _items: function(t) {
                    return t.children().filter(function() {
                        var t = e(this);
                        return !t.hasClass("k-grouping-row") && !t.hasClass("k-detail-row") && !t.hasClass("k-group-footer")
                    })
                },
                dataItems: function() {
                    var e, t, r, l = Ee.ui.DataBoundWidget.fn.dataItems.call(this);
                    if (this.lockedContent) {
                        for (e = l.length, t = Array(2 * e), r = e; --r >= 0;) t[r] = t[r + e] = l[r];
                        l = t
                    }
                    return l
                },
                _destroyColumnAttachments: function() {
                    var t = this;
                    t.resizeHandle = null, t.thead && (this.angular("cleanup", function() {
                        return {
                            elements: t.thead.get()
                        }
                    }), t.thead.add(t.lockedHeader).find("th").each(function() {
                        var t = e(this),
                            r = t.data("kendoFilterMenu"),
                            l = t.data("kendoColumnSorter"),
                            o = t.data("kendoColumnMenu");
                        r && r.destroy(), l && l.destroy(), o && o.destroy()
                    }))
                },
                _attachCustomCommandsEvent: function() {
                    var e, t, r, l = this,
                        o = Q(l.columns || []);
                    for (t = 0, r = o.length; t < r; t++) e = o[t].command, e && s(l, l.wrapper, e)
                },
                _aria: function() {
                    var e = this.element.attr("id") || "aria";
                    e && (this._cellId = e + "_active_cell")
                },
                _element: function() {
                    var t = this,
                        r = t.element;
                    r.is("table") || (r = t.options.scrollable ? t.element.find("> .k-grid-content > table") : t.element.children("table"), r.length || (r = e("<table />").appendTo(t.element))), Ar && r.attr("cellspacing", 0), t.table = r.attr("role", t._hasDetails() ? "treegrid" : "grid"), t._wrapper()
                },
                _createResizeHandle: function(t, r) {
                    var l, o, a, n, i, s, d = this,
                        c = d.options.columnResizeHandleWidth,
                        u = d.options.scrollable,
                        p = d.resizeHandle;
                    p && d.lockedContent && p.data("th")[0] !== r[0] && (p.off(pt).remove(), p = null), p || (p = d.resizeHandle = e('<div class="k-resize-handle"><div class="k-resize-handle-inner"></div></div>'), t.append(p)), l = r.offset().left + t.scrollLeft() - parseFloat(r.css("marginLeft")) - (t.offset().left + parseFloat(t.css("borderLeftWidth"))), Dr ? u && (a = r.closest(".k-grid-header-wrap, .k-grid-header-locked"), n = Fr.msie ? a.scrollLeft() : 0, i = Fr.webkit ? a[0].scrollWidth - a[0].offsetWidth - a.scrollLeft() : 0, s = Fr.mozilla ? a[0].scrollWidth - a[0].offsetWidth - (a[0].scrollWidth - a[0].offsetWidth - a.scrollLeft()) : 0, l -= i - s + n) : l += r[0].offsetWidth, o = r.offset().top - parseFloat(r.css("marginTop")) - (t.offset().top + parseFloat(t.css("borderTopWidth"))), p.css({
                        top: o,
                        left: l - 3 * c / 2,
                        height: Ve(r),
                        width: 3 * c
                    }).data("th", r).show(), p.off("dblclick" + pt).on("dblclick" + pt, function() {
                        d._autoFitLeafColumn(parseInt(r.attr(Ee.attr("index")), 10))
                    })
                },
                _positionColumnResizeHandle: function() {
                    var r = this,
                        l = r.lockedHeader ? r.lockedHeader.find("thead:first") : e();
                    r.thead.add(l).on("mousemove" + pt, "tr:not(.k-filter-row) > th", function(l) {
                        var o = t !== l.buttons ? l.buttons : l.which || l.button,
                            a = e(this);
                        a.hasClass("k-group-cell") || a.hasClass("k-hierarchy-cell") || t !== o && 0 !== o || a[0].hasAttribute(Ee.attr(fr)) || r._createResizeHandle(a.closest("div"), a)
                    })
                },
                _resizeHandleDocumentClick: function(t) {
                    e(t.target).closest(".k-column-active").length || (e(document).off(t), this._resetResizeHandleHeader(), this._hideResizeHandle())
                },
                _resetResizeHandleHeader: function() {
                    var t;
                    this.resizeHandle && (t = e(this.resizeHandle).data("th"), t && (t.find(Ze + Nt).find(Ze + Gt).show(), t.find(Ze + Kt).show(), t.find(Ze + jt).show(), t.find(Ze + Ut).show()))
                },
                _hideResizeHandle: function() {
                    this.resizeHandle && (this.resizeHandle.data("th").removeClass("k-column-active"), this.lockedContent && !this._isMobile ? (this.resizeHandle.off(pt).remove(), this.resizeHandle = null) : this.resizeHandle.hide())
                },
                _positionColumnResizeHandleTouch: function() {
                    var t = this,
                        r = t.lockedHeader ? t.lockedHeader.find("thead:first") : e();
                    t._resizeUserEvents = new Ee.UserEvents(r.add(t.thead), {
                        filter: "th:not(.k-group-cell):not(.k-hierarchy-cell)",
                        threshold: 10,
                        minHold: 500,
                        hold: function(r) {
                            var l = e(r.target);
                            r.preventDefault(), t.resizeHandle && (t.resizeHandle.data("th").removeClass("k-column-active"), t._resetResizeHandleHeader()), l.addClass("k-column-active"), l.find(Ze + Nt).find(Ze + Gt).hide(), l.find(Ze + Kt).hide(), l.find(Ze + jt).hide(), l.find(Ze + Ut).hide(), t._createResizeHandle(l.closest("div"), l), t._resizeHandleDocumentClickHandler || (t._resizeHandleDocumentClickHandler = $e(t._resizeHandleDocumentClick, t)), e(document).on("click", t._resizeHandleDocumentClickHandler)
                        }
                    })
                },
                resizeColumn: function(r, l) {
                    var o, a, n, i, s = this,
                        d = !!r.locked,
                        c = !!r.hidden,
                        u = this.options,
                        p = Ee.support.mobileOS ? 0 : Ee.support.scrollbar(),
                        h = d ? je(r, j(s.columns)) : je(r, K(s.columns)),
                        f = d ? s.lockedTable : s.table,
                        g = s.footer || e(),
                        m = d ? s.lockedHeader.find("table") : s.thead.closest("table"),
                        k = r.minResizableWidth || 10,
                        b = qe(d ? f.find("tbody") : s.tbody);
                    return c ? (r.width = l > k ? l : k, t) : (s.footer && s.lockedContent && (g = s.footer.children(d ? ".k-grid-footer-locked" : ".k-grid-footer-wrap")), o = u.scrollable ? m.find("col:not(.k-group-col,.k-hierarchy-col):eq(" + h + ")").add(f.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + h + ")")).add(g.find("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + h + ")")) : f.find("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + h + ")"), u.scrollable ? (a = !1, n = s.wrapper.width() - p, i = l = l > k ? l : k, d && b - l + i > n && (i = l + (n - b - 2 * p), i < 0 && (i = l), a = !0), i > 10 && i >= k && (o.css("width", i), b && (i = a ? n - 2 * p : b + (l - r.width), f.add(m).add(g).css("width", i), d || (s._footerWidth = i))), s._scrollVirtualWrapperOnColumnResize()) : l > 10 && l >= k && o.css("width", l), r.width = l, s._applyLockedContainersWidth(), s._syncLockedContentHeight(), s._syncLockedHeaderHeight(), t)
                },
                _resizable: function() {
                    var t, r, l, o, n, i, s, d, c = this,
                        u = c.options,
                        p = this._isMobile,
                        h = Ee.support.mobileOS ? 0 : Ee.support.scrollbar();
                    u.resizable && (t = u.scrollable ? c.wrapper.find(".k-grid-header-wrap:first") : c.wrapper, p ? c._positionColumnResizeHandleTouch(t) : c._positionColumnResizeHandle(t), c.resizable && c.resizable.destroy(), c.resizable = new Le.Resizable(t.add(c.lockedHeader), {
                        handle: (u.scrollable ? "" : ">") + ".k-resize-handle",
                        hint: function(t) {
                            return e('<div class="k-grid-resize-indicator" />').css({
                                height: Ve(t.data("th")) + c.tbody.attr("clientHeight")
                            })
                        },
                        start: function(t) {
                            var h, f, g, m, k;
                            d = e(t.currentTarget).data("th"), p && c._hideResizeHandle(), h = d.closest("table"), f = e.inArray(d[0], Y(d.closest("thead")).filter(":visible")), i = h.parent().hasClass("k-grid-header-locked"), g = i ? c.lockedTable : c.table, m = c.footer || e(), c.footer && c.lockedContent && (m = c.footer.children(i ? ".k-grid-footer-locked" : ".k-grid-footer-wrap")), a(c.wrapper, "col-resize"), s = u.scrollable ? h.find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + f + ")").add(g.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + f + ")")).add(m.find("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + f + ")")) : g.children("colgroup").find("col:not(.k-group-col):not(.k-hierarchy-col):eq(" + f + ")"), k = e.map(c.columns, function(e) {
                                return !e.hidden && (i && e.locked || !i && !e.locked) ? e : null
                            }), r = t.x.location, l = qe(d), o = Q(k)[f].minResizableWidth || 10, n = qe(i ? g.children("tbody") : c.tbody), Fr.webkit && c.wrapper.addClass("k-grid-column-resizing")
                        },
                        resize: function(t) {
                            var a, p, f, g, m, k, b = Dr ? -1 : 1,
                                _ = l + t.x.location * b - r * b;
                            u.scrollable ? (i && c.lockedFooter ? a = c.lockedFooter.children("table") : c.footer && (a = c.footer.find(">.k-grid-footer-wrap>table")), a && a[0] || (a = e()), p = d.closest("table"), f = i ? c.lockedTable : c.table, g = !1, m = c.wrapper.width() - h, k = _, i && n - l + k > m && (k = l + (m - n - 2 * h), k < 0 && (k = _), g = !0), k > 10 && k >= o && (s.css("width", k), n && (k = g ? m - 2 * h : n + t.x.location * b - r * b, f.add(p).add(a).css("width", k), i || (c._footerWidth = k))), c._scrollVirtualWrapperOnColumnResize()) : _ > 10 && _ >= o && s.css("width", _)
                        },
                        resizeend: function() {
                            var e, t, r, o = qe(d);
                            a(c.wrapper, ""), Fr.webkit && c.wrapper.removeClass("k-grid-column-resizing"), l != o && (t = c.lockedHeader ? c.lockedHeader.find("thead:first tr:first").add(c.thead.find("tr:first")) : d.parent(), r = d.attr(Ee.attr("index")), r || (r = t.find("th:not(.k-group-cell):not(.k-hierarchy-cell)").index(d)), e = Q(c.columns)[r], e.width = o, c.trigger(Qt, {
                                column: e,
                                oldWidth: l,
                                newWidth: o
                            }), c._applyLockedContainersWidth(), c._syncLockedContentHeight(), c._syncLockedHeaderHeight()), c._resetResizeHandleHeader(), c._hideResizeHandle(), d = null
                        }
                    }))
                },
                _draggable: function() {
                    var t, r = this;
                    r.options.reorderable && (r._draggableInstance && r._draggableInstance.destroy(), t = r.wrapper.children(".k-grid-header"), r._draggableInstance = r.wrapper.kendoDraggable({
                        group: Ee.guid(),
                        autoScroll: !0,
                        filter: r.content ? ".k-grid-header:first " + ut : "table:first>.k-grid-header " + ut,
                        dragstart: function() {
                            t.children(".k-grid-header-wrap").unbind("scroll" + pt + "scrolling").bind("scroll" + pt + "scrolling", function(e) {
                                r.virtualScrollable ? r.content.find(">.k-virtual-scrollable-wrap").scrollLeft(this.scrollLeft) : r.scrollables.not(e.currentTarget).scrollLeft(this.scrollLeft)
                            })
                        },
                        dragend: function() {
                            r._resetResizeHandleHeader(), t.children(".k-grid-header-wrap").unbind("scroll" + pt + "scrolling")
                        },
                        drag: function() {
                            r._hideResizeHandle()
                        },
                        hint: function(t) {
                            var r = t.attr(Ee.attr("title"));
                            return r && (r = Ee.htmlEncode(r)), e('<div class="k-header k-reorder-clue k-drag-clue" />').html(r || t.attr(Ee.attr("field")) || t.text()).prepend('<span class="k-icon k-drag-status k-i-cancel" />')
                        }
                    }).data("kendoDraggable"))
                },
                _reorderable: function() {
                    var t = this;
                    t.options.reorderable && (t.wrapper.data("kendoReorderable") && t.wrapper.data("kendoReorderable").destroy(), t.wrapper.kendoReorderable({
                        draggable: t._draggableInstance,
                        dragOverContainers: function(e, r) {
                            var l = M(t.columns);
                            return l[e].lockable !== !1 && D(l, t.columns, e, r) > -1
                        },
                        inSameContainer: function(r) {
                            return e(r.source).parent()[0] === e(r.target).parent()[0] && D(M(t.columns), t.columns, r.sourceIndex, r.targetIndex) > -1
                        },
                        change: function(e) {
                            var r = M(t.columns),
                                l = r[e.oldIndex],
                                o = D(r, t.columns, e.oldIndex, e.newIndex);
                            t.trigger(Jt, {
                                newIndex: o,
                                oldIndex: je(l, r),
                                column: l
                            }), t.reorderColumn(o, l, "before" === e.position)
                        }
                    }))
                },
                _reorderHeader: function(e, t, r, l) {
                    var o, a, s, d, c, u = this,
                        p = I(e[0], u.columns),
                        h = I(t, u.columns),
                        f = [];
                    for (s = 0; s < e.length; s++) e[s].columns && (f = f.concat(e[s].columns));
                    a = l ? i(l, l, "tr:eq(" + p.row + ")>th.k-header:not(.k-group-cell,.k-hierarchy-cell)") : i(u.lockedHeader, u.thead, "tr:eq(" + p.row + ")>th.k-header:not(.k-group-cell,.k-hierarchy-cell)"), d = N(e).length, c = N([t]).length, f.length ? (d > 0 && 0 === c ? (o = "prepend", T(e, t, f, u.columns, u.lockedHeader.find("thead"), u.thead, this._groups(), o)) : 0 === d && c > 0 && (o = 0 !== h.cell || !e[0].columns || t.columns || u._group ? "append" : "prepend", T(e, t, f, G(u.columns), u.thead, u.lockedHeader.find("thead"), this._groups(), o)), (t.columns || p.cell - h.cell > 1 || h.cell - p.cell > 1) && (t = E(u.columns, t, e[0], r, u.columns), t && (d > 0 && 0 === c ? u._reorderHeader(f, t, r, u.thead) : 0 === d && c > 0 ? u._reorderHeader(f, t, r, u.lockedHead) : u._reorderHeader(f, t, r)))) : d !== c && S(a[p.cell], u.columns, d), n(a, p.cell, h.cell, r, e.length)
                },
                _reorderContent: function(t, r, l) {
                    var o, a, s, d, c, u, p = this,
                        h = e(),
                        f = t[0],
                        g = v(t),
                        m = je(f, Q(p.columns)),
                        k = je(r, Q(p.columns)),
                        b = je(g[0], U(p.columns)),
                        _ = je(r, U(p.columns)),
                        w = N(p.columns).length,
                        C = !!r.locked,
                        y = p.footer || p.wrapper.find(".k-grid-footer"),
                        S = o = _;
                    for (r.hidden && (s = C ? N(p.columns) : G(p.columns), v(s).length > 0 ? (S = o = _ = this._findClosestVisibleColumnIndex(s, k), a = v(s.slice(k)).length > 0) : C ? (_ = p.lockedTable.find("colgroup"), S = p.lockedHeader.find("colgroup"), o = e(p.lockedFooter).find(">table>colgroup")) : (_ = p.tbody.prev(), S = p.thead.prev(), o = y.find(".k-grid-footer-wrap").find(">table>colgroup"))), p._hasFilterRow() && n(p.wrapper.find(".k-filter-row th:not(.k-group-cell,.k-hierarchy-cell)"), m, k, l, t.length), b >= 0 && n(i(p.lockedHeader, p.thead.prev(), "col:not(.k-group-col,.k-hierarchy-col)"), b, S, a ? a : l, g.length), p.options.scrollable && b >= 0 && !p._hasVirtualColumns() && n(i(p.lockedTable, p.tbody.prev(), "col:not(.k-group-col,.k-hierarchy-col)"), b, _, a ? a : l, g.length), y && y.length && (b >= 0 && n(i(p.lockedFooter, y.find(".k-grid-footer-wrap"), ">table>colgroup>col:not(.k-group-col,.k-hierarchy-col)"), b, o, a ? a : l, g.length), n(y.find(".k-footer-template>td:not(.k-group-cell,.k-hierarchy-cell)"), m, k, l, t.length)), d = p.tbody.children(":not(.k-grouping-row,.k-detail-row)"), p.lockedTable && (w > k ? w <= m && pe(p.lockedTable.find(">tbody>tr.k-grouping-row"), p.table.find(">tbody>tr.k-grouping-row"), t.length) : w > m && pe(p.table.find(">tbody>tr.k-grouping-row"), p.lockedTable.find(">tbody>tr.k-grouping-row"), t.length), h = p.lockedTable.find(">tbody>tr:not(.k-grouping-row,.k-detail-row)")), c = 0, u = d.length; c < u; c += 1) n(i(h[c], d[c], ">td:not(.k-group-cell,.k-hierarchy-cell)"), m, k, l, t.length)
                },
                _findClosestVisibleColumnIndex: function(e, t) {
                    var r = v(e.slice(t)).length > 0 ? e.slice(t) : e.slice(0, t + 1).reverse(),
                        l = v(r)[0];
                    return je(l, v(this.columns))
                },
                _autoFitLeafColumn: function(e) {
                    this.autoFitColumn(Q(this.columns)[e])
                },
                autoFitColumn: function(t) {
                    var r, l, o, a, n, i, s, d, c, u, p, h, f, g, m, b, v, w, C, y, S = this,
                        T = S.options,
                        x = S.columns,
                        H = S.lockedHeader ? Y(S.lockedHeader.find(">table>thead")).filter(k).length : 0,
                        R = "col:not(.k-group-col):not(.k-hierarchy-col)",
                        I = "td:visible:not(.k-group-cell):not(.k-hierarchy-cell)";
                    if (t = "number" == typeof t ? x[t] : Be(t) ? Ge(F(x), function(e) {
                            return e === t
                        })[0] : Ge(F(x), function(e) {
                            return e.field === t
                        })[0], t && _(t)) {
                        for (i = t.minResizableWidth, r = je(t, Q(x)), a = t.locked, o = a ? S.lockedHeader.children("table") : S.thead.parent(), l = o.find("[data-index='" + r + "']"), c = a ? S.lockedTable : S.table, u = S.footer || e(), S.footer && S.lockedContent && (u = S.footer.children(a ? ".k-grid-footer-locked" : ".k-grid-footer-wrap")), p = u.find("table").first(), S.lockedHeader && !a && (r -= H), h = 0; h < x.length && x[h] !== t; h++) x[h].hidden && r--;
                        if (T.scrollable ? (n = o.find(R).eq(r).add(c.children("colgroup").find(R).eq(r)).add(p.find("colgroup").find(R).eq(r)), a || (s = c.parent(), d = s.scrollLeft())) : n = c.children("colgroup").find(R).eq(r), f = o.add(c).add(p), Fr.safari && l.css("white-space", "initial"), g = qe(l), n.width(""), f.css("table-layout", "fixed"), n.width("auto"), f.addClass("k-autofitting"), f.css("table-layout", ""), m = Math.ceil(Math.max(qe(l), qe(c.find("tr:not(.k-grouping-row)").eq(0).children(I).eq(r)), qe(p.find("tr").eq(0).children(I).eq(r)))) + 1, i && i > m && (m = i), n.width(m), t.width = m, Fr.safari && l.css("white-space", ""), T.scrollable) {
                            for (b = o.find("col"), w = 0, C = 0, y = b.length; C < y; C += 1)
                                if (v = b[C].style.width, v && v.indexOf("%") == -1) w += parseInt(v, 10);
                                else {
                                    if (!b.eq(C).hasClass("k-group-col")) {
                                        w = 0;
                                        break
                                    }
                                    w += parseInt(b.eq(C).width(), 10)
                                }
                            w && f.each(function() {
                                this.style.width = w + "px"
                            })
                        }
                        Fr.msie && 8 == Fr.version && (f.css("display", "inline-table"), setTimeout(function() {
                            f.css("display", "table")
                        }, 1)), f.removeClass("k-autofitting"), d && s.scrollLeft(d), S.trigger(Qt, {
                            column: t,
                            oldWidth: g,
                            newWidth: m
                        }), S._applyLockedContainersWidth(), S._syncLockedContentHeight(), S._syncLockedHeaderHeight()
                    }
                },
                reorderColumn: function(e, r, l) {
                    var o, a, n = this,
                        i = c(r, n.columns),
                        s = i ? i.columns : n.columns,
                        d = je(r, s),
                        u = s[e],
                        p = n.virtualScroll || {},
                        h = !!u.locked,
                        f = N(n.columns).length,
                        g = Ge(Q(n.columns), function(e) {
                            return e.groupHeaderColumnTemplate
                        });
                    d !== e && (!r.locked && h && 1 == G(n.columns).length || r.locked && !h && 1 == f || (n._hideResizeHandle(), l === t && (l = e < d), a = [r], n._reorderHeader(a, u, l), n.lockedHeader && (B(n.thead), B(n.lockedHeader)), u.columns && (u = Q(u.columns), u = u[l ? 0 : u.length - 1]), r.columns && (a = Q(r.columns)), n._reorderContent(a, u, l), o = !!r.locked, o = o != h, r.locked = h, s.splice(l ? e : e + 1, 0, r), s.splice(d < e ? d : d + 1, 1), n._updateLockedCols(), n._updateCols(), n._templates(), n._updateColumnCellIndex(), n._updateColumnSorters(), g.length > 0 && n._renderGroupRows(), n._updateTablesWidth(), n._applyLockedContainersWidth(), n._syncLockedHeaderHeight(), n._syncLockedContentHeight(), n._updateFirstColumnClass(), p.columns && n.refresh(), o && (h ? n.trigger(Yt, {
                        column: r
                    }) : n.trigger(Xt, {
                        column: r
                    }))))
                },
                _updateColumnCellIndex: function() {
                    var e, t = 0;
                    this.lockedHeader && (e = this.lockedHeader.find("thead"), t = x(e, N(this.columns))), x(this.thead, G(this.columns), t)
                },
                lockColumn: function(e) {
                    var t, r = this.columns;
                    e = "number" == typeof e ? r[e] : Ge(r, function(t) {
                        return t.field === e
                    })[0], !e || e.locked || e.hidden || (t = N(r).length - 1, this.reorderColumn(t, e, !1))
                },
                unlockColumn: function(e) {
                    var t, r = this.columns;
                    e = "number" == typeof e ? r[e] : Ge(r, function(t) {
                        return t.field === e
                    })[0], e && e.locked && !e.hidden && (t = N(r).length, this.reorderColumn(t, e, !0))
                },
                cellIndex: function(t) {
                    var r = 0;
                    return this.lockedTable && !e.contains(this.lockedTable[0], t[0]) && (r = Q(N(this.columns)).length), e(t).parent().children("td:not(.k-group-cell,.k-hierarchy-cell)").index(t) + r
                },
                _modelForContainer: function(t) {
                    t = e(t), t.is("tr") || "popup" === this._editMode() || (t = t.closest("tr"));
                    var r = t.attr(Ee.attr("uid"));
                    return this.dataSource.getByUid(r)
                },
                _editable: function() {
                    var t, r = this,
                        l = r.selectable && r.selectable.options.multiple,
                        o = r.options.editable,
                        a = function() {
                            var t = Ae(),
                                l = r._editContainer;
                            l && l[0] && !e.contains(l[0], t) && l[0] !== t && !e(t).closest(".k-animation-container").length && (r.editable.end() ? r.closeCell() : r._scrollVirtualWrapper())
                        };
                    o && (this.wrapper.addClass("k-editable"), t = r._editMode(), "incell" === t ? (r.table.add(r.lockedTable).on("mousedown" + pt, at + ">" + nt, function(t) {
                        var l = e(t.target);
                        "incell" === r._editMode() && l.hasClass("k-checkbox-label") && l.prev().attr(Ee.attr("bind")) && t.preventDefault()
                    }), o.update !== !1 && (Vr && r.wrapper.on(er + pt, ".k-edit-cell > input[type='checkbox']", function(t) {
                        e(t.target).focus()
                    }).on(er + pt, ".k-edit-cell", function(t) {
                        e(t.target).is("input") || e(t.currentTarget).find("input[type='checkbox']").focus()
                    }).on(tr + pt, "tr:not(.k-grouping-row) > td", function(t) {
                        var l = r._editContainer;
                        r._mousedownOnEditCell = !(!l || !l[0] || !e.contains(l[0], t.target) && l[0] !== t.target)
                    }), r.wrapper.on(Ee.support.touch ? "touchstart" + pt : er + pt, "tr:not(.k-grouping-row) > td", function(t) {
                        var o = e(this),
                            a = r.lockedTable && o.closest("table")[0] === r.lockedTable[0];
                        r._mousedownOnEditCell = !1, o.hasClass("k-hierarchy-cell") || o.hasClass("k-detail-cell") || o.hasClass("k-group-cell") || o.hasClass("k-edit-cell") || o.has("a.k-grid-delete").length || o.has("button.k-grid-delete").length || o.closest("tbody")[0] !== r.tbody[0] && !a || e(t.target).is(":input") || (r.editable ? r.editable.end() ? ((l || Ee.support.mobileOS) && e(Ae()).blur(), r.closeCell(), r.editCell(o)) : r._scrollVirtualWrapper() : r.editCell(o))
                    }).on("focusin" + pt, function() {
                        e.contains(this, Ae()) || (clearTimeout(r.timer), r.timer = null)
                    }).on("focusout" + pt, function(e) {
                        var t = !0;
                        (Vr && r._mousedownOnEditCell || r._virtualColScroll) && (t = !1), r._mousedownOnEditCell = !1, t && (r.timer = setTimeout(function() {
                            a(e)
                        }, 1))
                    }))) : o.update !== !1 && (r.wrapper.on(er + pt, "tbody>tr:not(.k-detail-row,.k-grouping-row):visible a.k-grid-edit", function(t) {
                        t.preventDefault(), r.editRow(e(this).closest("tr"))
                    }), r._isVirtualInlineEditable() && r.wrapper.on("focusout" + pt, "tr:not(.k-grouping-row) > td", function() {
                        r.editable && !r.editable.end() && r._scrollVirtualWrapper()
                    })), o.destroy !== !1 ? r.wrapper.on(er + pt, "tbody>tr:not(.k-detail-row,.k-grouping-row):visible .k-grid-delete", function(t) {
                        t.preventDefault(), t.stopPropagation(), r.removeRow(e(this).closest("tr"))
                    }) : r.wrapper.on(er + pt, "tbody>tr:not(.k-detail-row,.k-grouping-row):visible button.k-grid-delete", function(e) {
                        e.stopPropagation(), r._confirmation() || e.preventDefault()
                    }))
                },
                editCell: function(t) {
                    var r, l, o, a;
                    if (t = e(t), r = this, l = (r.virtualScroll || {}).columns ? r.virtualCols[r.cellIndex(t)] : Q(r.columns)[r.cellIndex(t)], o = r._modelForContainer(t), r.closeCell(), o && ve(l, o) && !l.command) {
                        if (r.trigger(mt, {
                                model: o
                            })) return;
                        r._attachModelChange(o), r._editContainer = t, r._shouldClearEditableState && r._clearEditableState(), r.editable = t.addClass("k-edit-cell").kendoEditable({
                            fields: {
                                field: l.field,
                                format: l.format,
                                editor: l.editor,
                                values: l.values
                            },
                            model: o,
                            target: r,
                            change: function(e) {
                                r.trigger(kt, {
                                    values: e.values,
                                    container: t,
                                    model: o
                                }) && e.preventDefault()
                            },
                            skipFocus: !(!r._isVirtualIncellEditable() && !r._hasVirtualColumns() || !r._editableState)
                        }).data("kendoEditable"), a = t.parent().addClass("k-grid-edit-row"), r.lockedContent && (ge(a[0], r._relatedRow(a).addClass("k-grid-edit-row")[0]), r._syncLockedScroll()), r.trigger(gt, {
                            container: t,
                            model: o
                        })
                    }
                },
                _adjustLockedHorizontalScrollBar: function() {
                    var e = this.table,
                        t = e.parent(),
                        r = e[0].offsetWidth > t[0].clientWidth ? Ee.support.scrollbar() : 0;
                    this.lockedContent.height(t[0].offsetHeight - r)
                },
                _syncLockedScroll: function() {
                    this.lockedContent[0].scrollTop = this.content[0].scrollTop, this.virtualScrollable && (this.lockedContent[0].scrollTop = this.wrapper.find(".k-virtual-scrollable-wrap")[0].scrollTop)
                },
                _syncLockedContentHeight: function() {
                    this.lockedTable && (this.touchScroller || this._adjustLockedHorizontalScrollBar(), this._adjustRowsHeight(this.table, this.lockedTable))
                },
                _syncLockedHeaderHeight: function() {
                    var e, t;
                    this.lockedHeader && (e = this.lockedHeader.children("table"), t = this.thead.parent(), this._adjustRowsHeight(e, t), fe(e, t))
                },
                _syncLockedFooterHeight: function() {
                    this.lockedFooter && this.footer && this.footer.length && this._adjustRowsHeight(this.lockedFooter.children("table"), this.footer.find(".k-grid-footer-wrap > table"))
                },
                _destroyEditable: function() {
                    var e = this,
                        t = function() {
                            if (e.editable) {
                                var t = e.editView ? e.editView.element : e._editContainer;
                                t && (t.off(er + pt, "a.k-grid-cancel", e._editCancelClickHandler), t.off(er + pt, "a.k-grid-update", e._editUpdateClickHandler)), e._detachModelChange(), e.editable.destroy(), e.editable = null, e._editContainer = null, e._destroyEditView(), e._editableIsClosing = null
                            }
                        };
                    e.editable && ("popup" !== e._editMode() || e._isMobile ? t() : e._editableIsClosing ? e._editContainer.data("kendoWindow").bind("deactivate", t) : (e._editableIsClosing = !0, e._editContainer.data("kendoWindow").bind("deactivate", t).close())), e._confirmDialog && (e._confirmDialog.close(), e._confirmDialog.destroy(), e._confirmDialog = null)
                },
                _destroyEditView: function() {
                    this.editView && (this.editView.purge(), this.editView = null, this.pane.navigate(""))
                },
                _attachModelChange: function(e) {
                    var t = this;
                    t._modelChangeHandler = function(e) {
                        t._modelChange({
                            field: e.field,
                            model: this
                        })
                    }, e.bind("change", t._modelChangeHandler)
                },
                _detachModelChange: function() {
                    var e = this,
                        t = e._editContainer,
                        r = e._modelForContainer(t);
                    r && r.unbind(Tt, e._modelChangeHandler)
                },
                closeCell: function(e) {
                    var t, r, l, o = this,
                        a = o._editContainer;
                    a && (l = o._modelForContainer(a), e && o.trigger("cancel", {
                        container: a,
                        model: l
                    }) || (o.trigger(St, {
                        type: e ? "cancel" : "save",
                        model: l,
                        container: a
                    }), a.removeClass("k-edit-cell"), t = (o.virtualScroll || {}).columns ? o.virtualCols[o.cellIndex(a)] : Q(o.columns)[o.cellIndex(a)], r = a.parent().removeClass("k-grid-edit-row"), o.lockedContent && o._relatedRow(r).removeClass("k-grid-edit-row"), o._destroyEditable(), o._displayCell(a, t, l), o._shouldClearEditableState && o._clearEditableState(), o.trigger("itemChange", {
                        item: r,
                        data: l,
                        ns: Le
                    }), o.lockedContent && ge(r.css("height", "")[0], o._relatedRow(r).css("height", "")[0])))
                },
                _displayCell: function(e, t, r) {
                    var l = this,
                        o = {
                            storage: {},
                            count: 0
                        },
                        a = Oe({}, Ee.Template, l.options.templateSettings),
                        n = Ee.template(l._cellTmpl(t, o), a);
                    o.count > 0 && (n = $e(n, o.storage)), e.empty().html(n(r)), l.angular("compile", function() {
                        return {
                            elements: e,
                            data: [{
                                dataItem: r
                            }]
                        }
                    })
                },
                removeRow: function(e) {
                    this._confirmation(e) && this._removeRow(e)
                },
                _removeRow: function(t) {
                    var r, l, o, a, n = this,
                        i = n._editMode();
                    "incell" !== i && n.cancelRow(), t = e(t), n.lockedContent && (t = t.add(n._relatedRow(t))), t = t.hide(), r = n._modelForContainer(t), r && !n.trigger(bt, {
                        row: t,
                        model: r
                    }) ? (a = n.dataSource.options.schema, n._selectedIds && a && a.model && (l = Qe(n.dataSource.options.schema.model) ? n.dataSource.options.schema.model.fn.idField : n.dataSource.options.schema.model.id, o = r[l], delete n._selectedIds[o]), n.dataSource.remove(r), "inline" !== i && "popup" !== i || n.dataSource.sync()) : "incell" === i && n._destroyEditable()
                },
                _editMode: function() {
                    var e = "incell",
                        t = this.options.editable;
                    return t !== !0 && (e = "string" == typeof t ? t : t.mode || e), e
                },
                editRow: function(t) {
                    var r, l, o, a = this;
                    t instanceof De ? r = t : (t = e(t), r = a._modelForContainer(t)), l = a._editMode(), a.cancelRow(), r && (t = a.tbody.children("[" + Ee.attr("uid") + "=" + r.uid + "]"), a._attachModelChange(r), "popup" === l ? a._createPopupEditor(r) : "inline" === l ? a._createInlineEditor(t, r) : "incell" === l && e(t).children(lt).each(function() {
                        var t = e(this),
                            l = Q(a.columns)[a.cellIndex(t)];
                        if (r = a._modelForContainer(t), r && (!r.editable || r.editable(l.field)) && l.field && !l.selectable) return a.editCell(t), !1
                    }), o = a.editView ? a.editView.element : a._editContainer, o && (this._editCancelClickHandler || (this._editCancelClickHandler = $e(this._editCancelClick, this)), o.on(er + pt, "a.k-grid-cancel", this._editCancelClickHandler), this._editUpdateClickHandler || (this._editUpdateClickHandler = $e(this._editUpdateClick, this)), o.on(er + pt, "a.k-grid-update", this._editUpdateClickHandler)))
                },
                _editUpdateClick: function(e) {
                    e.preventDefault(), e.stopPropagation(), this.saveRow()
                },
                _editCancelClick: function(t) {
                    var r, l = this,
                        o = l.options.navigatable,
                        a = l.editable.options.model,
                        n = l.editView ? l.editView.element : l._editContainer;
                    t.preventDefault(), t.stopPropagation(), l.trigger("cancel", {
                        container: n,
                        model: a
                    }) || (r = l.items().index(e(l.current()).parent()), l.cancelRow(), o && (l._setCurrent(l.items().eq(r).children().filter(nt).first()), ke(l.table, !0)))
                },
                _createPopupEditor: function(r) {
                    var l, o, a, n, i, s, d, c, u, p, h, f, g, m = this,
                        k = "<div " + Ee.attr("uid") + '="' + r.uid + '" class="k-popup-edit-form"><' + (m._isMobile ? 'ul class="k-edit-form-container k-listgroup k-listgroup-flush">' : 'div class="k-edit-form-container">'),
                        b = [],
                        _ = Q(m.columns),
                        v = Ee.guid(),
                        w = m.options.editable,
                        C = w.template,
                        y = Be(w) ? w.window : {},
                        S = Oe({}, Ee.Template, m.options.templateSettings);
                    if (!m.trigger(mt, {
                            model: r
                        })) {
                        if (y = y || {}, C)
                            for (typeof C === ar && (C = Ee.unescape(C)), k += Ee.template(C, S)(r), a = 0, n = _.length; a < n; a++) l = _[a], l.command && (p = me(l.command, "edit"), p && (o = p));
                        else
                            for (a = 0, n = _.length; a < n; a++) l = _[a], l.selectable || (l.command ? l.command && (p = me(l.command, "edit"), p && (o = p)) : m._isMobile ? (k += '<li class="k-item k-listgroup-item">', ve(l, r) ? (b.push({
                                field: l.field,
                                title: l.title,
                                format: l.format,
                                editor: l.editor,
                                values: l.values
                            }), k += '<label class="k-label k-listgroup-form-row">', k += '<span class="k-item-title k-listgroup-form-field-label">' + (l.title || l.field || "") + "</span>", k += '<div class="k-listgroup-form-field-wrapper" id="' + l.field + "_" + v + '" ' + Ee.attr("container-for") + '="' + l.field + '"></div>', k += "</label>") : (f = {
                                storage: {},
                                count: 0
                            }, i = Ee.template(m._cellTmpl(l, f), S), f.count > 0 && (i = $e(i, f.storage)), k += '<label class="k-label k-listgroup-form-row k-no-click">', k += '<span class="k-item-title k-listgroup-form-field-label">' + (l.title || l.field || "") + "</span>", k += '<span class="k-no-editor k-listgroup-form-field-wrapper">' + i(r) + "</span>", k += "</label>"), k += "</li>") : (k += '<div class="k-edit-label"><label for="' + l.field + '">' + (l.title || l.field || "") + "</label></div>", ve(l, r) ? (b.push({
                                field: l.field,
                                title: l.title,
                                format: l.format,
                                editor: l.editor,
                                values: l.values
                            }), k += "<div " + Ee.attr("container-for") + '="' + l.field + '" class="k-edit-field"></div>') : (f = {
                                storage: {},
                                count: 0
                            }, i = Ee.template(m._cellTmpl(l, f), S), f.count > 0 && (i = $e(i, f.storage)), k += '<div class="k-edit-field k-no-editor">' + i(r) + "</div>")));
                        o && Be(o) && (Be(o.text) && (s = o.text.update, d = o.text.cancel), Be(o.iconClass) && (c = o.iconClass.update, u = o.iconClass.cancel), o.attr && (h = o.attr)), m._isMobile ? (k += "</ul></div>", m.editView = m.pane.append("<div data-" + Ee.ns + 'role="view" class="k-grid-edit-form"><div data-' + Ee.ns + 'role="header" class="k-header"><a href="\\#" class="k-header-cancel k-link k-grid-cancel" title="#=messages.cancel#" aria-label="#=messages.cancel#"><span class="k-icon k-i-arrow-chevron-left"></span></a>' + (m.options.messages.commands.edit || "Edit") + '<a href="\\#" class="k-header-done k-link k-grid-update" title="#=messages.done#" aria-label="#=messages.done#"><span class="k-icon k-i-check"></span></a></div><div data-' + Ee.ns + 'role="content" class="' + Pr.content + '">' + k + "</div></div>"), g = m._editContainer = m.editView.element.find(".k-popup-edit-form")) : (k += '<div class="k-edit-buttons k-state-default">', k += m._createButton({
                            name: "update",
                            text: s,
                            attr: h,
                            iconClass: c
                        }) + m._createButton({
                            name: "canceledit",
                            text: d,
                            attr: h,
                            iconClass: u
                        }), k += "</div></div></div>", g = m._editContainer = e(k).appendTo(m.wrapper).eq(0).kendoWindow(Oe({
                            modal: !0,
                            resizable: !1,
                            draggable: !0,
                            title: m.options.messages.commands.edit || "Edit",
                            visible: !1,
                            close: function(l) {
                                if (l.userTriggered) {
                                    if (l.sender.element.focus(), m.trigger("cancel", {
                                            container: g,
                                            model: r
                                        })) return l.preventDefault(), t;
                                    var o = m.items().index(e(m.current()).parent());
                                    m._editableIsClosing = !0, m.cancelRow(), m.options.navigatable && (m._setCurrent(m.items().eq(o).children().filter(nt).first()), ke(m.table, !0))
                                }
                            }
                        }, y))), m.editable = m._editContainer.kendoEditable({
                            fields: b,
                            model: r,
                            clearContainer: !1,
                            target: m
                        }).data("kendoEditable"), m._openPopUpEditor(), m.trigger(gt, {
                            container: g,
                            model: r
                        })
                    }
                },
                _openPopUpEditor: function() {
                    var e = this,
                        t = e._editContainer ? e._editContainer.data("kendoWindow") : null,
                        r = (e.options.editable || {}).window || {};
                    this._isMobile ? this.pane.navigate(this.editView, this._editAnimation) : t && (r.position || t.center(), t.open())
                },
                _createInlineEditor: function(t, r) {
                    var l, o, a, n = this,
                        i = [];
                    n.trigger(mt, {
                        model: r
                    }) || (n.lockedContent && (t = t.add(n._relatedRow(t))), t.children(":not(.k-group-cell,.k-hierarchy-cell)").each(function() {
                        if (o = e(this), l = n._hasVirtualColumns() ? n.virtualCols[n.cellIndex(o)] : Q(n.columns)[n.cellIndex(o)], !l.command && ve(l, r)) i.push({
                            field: l.field,
                            title: l.title,
                            format: l.format,
                            editor: l.editor,
                            values: l.values
                        }), o.attr(Ee.attr("container-for"), l.field), o.empty();
                        else if (l.command && (a = me(l.command, "edit"))) {
                            o.empty();
                            var t, s, d, c, u;
                            Be(a) && (Be(a.text) && (t = a.text.update, s = a.text.cancel), Be(a.iconClass) && (d = a.iconClass.update, c = a.iconClass.cancel), a.attr && (u = a.attr)), e(n._createButton({
                                name: "update",
                                text: t,
                                attr: u,
                                iconClass: d
                            }) + n._createButton({
                                name: "canceledit",
                                text: s,
                                attr: u,
                                iconClass: c
                            })).appendTo(o)
                        }
                    }), n._editContainer = t, n._editContainer.addClass("k-grid-edit-row"), n._shouldClearEditableState && n._clearEditableState(), n.editable = new Ee.ui.Editable(n._editContainer, {
                        target: n,
                        fields: i,
                        model: r,
                        skipFocus: n._isVirtualInlineEditable() && n._editableState && !!n._editableState.field || n._hasVirtualColumns(),
                        clearContainer: !1
                    }), t.length > 1 && (ge(t[0], t[1]), n._applyLockedContainersWidth()), n.trigger(gt, {
                        container: t,
                        model: r
                    }))
                },
                cancelRow: function(e) {
                    var t, r = this,
                        l = r._editContainer;
                    if (l) {
                        if (t = r._modelForContainer(l), !t || e && r.trigger("cancel", {
                                container: l,
                                model: t
                            })) return;
                        r._destroyEditable(), r.dataSource.cancelChanges(t), r._clearEditableState(), r._displayRow("popup" !== r._editMode() ? l : r.tbody.find("[" + Ee.attr("uid") + "=" + t.uid + "]"))
                    }
                },
                saveRow: function() {
                    var t, r = this,
                        l = this._editContainer,
                        o = this._modelForContainer(l),
                        a = e.Deferred();
                    return l && this.editable ? (t = r.editable && r.editable.end(), !t || this.trigger(kt, {
                        container: l,
                        model: o
                    }) ? (t || r._scrollVirtualWrapper(), a.reject().promise()) : (r._clearEditableState(), this.dataSource.sync())) : a.resolve().promise()
                },
                _displayRow: function(t) {
                    var r, l, o, a, n, i = this,
                        s = i._modelForContainer(t),
                        d = t.hasClass("k-state-selected"),
                        c = t.hasClass("k-alt");
                    s && (i.lockedContent && (r = e((c ? i.lockedAltRowTemplate : i.lockedRowTemplate)(s)), i._relatedRow(t.last()).replaceWith(r)), i.angular("cleanup", function() {
                        return {
                            elements: t.get()
                        }
                    }), l = e((c ? i.altRowTemplate : i.rowTemplate)(s)), t.is(":visible") || l.hide(), t.replaceWith(l), i.trigger("itemChange", {
                        item: l,
                        data: s,
                        ns: Le
                    }), r && r.length && i.trigger("itemChange", {
                        item: r,
                        data: s,
                        ns: Le
                    }), a = l, n = [{
                        dataItem: s
                    }], r && r.length && (a = l.add(r), n.push({
                        dataItem: s
                    })), i.angular("compile", function() {
                        return {
                            elements: a.get(),
                            data: n
                        }
                    }), d && (i.options.selectable || i._checkBoxSelection) && i.select(l.add(r)), r && ge(l[0], r[0]), o = l.next(), o.hasClass("k-detail-row") && o.is(":visible") && l.find(".k-hierarchy-cell .k-icon").removeClass("k-i-expand").addClass("k-i-collapse"));
                },
                _showMessage: function(t, r) {
                    var l, o = this;
                    return o._isMobile ? (l = o._confirmDialog = new Ee.ui.Confirm(e("<div />").appendTo(document.body), {
                        modal: {
                            preventScroll: !0
                        },
                        closable: !1,
                        title: !1,
                        content: t.title,
                        messages: {
                            okText: t.confirmDelete,
                            cancel: t.cancelDelete
                        },
                        open: function() {
                            o.content.data(gr, o.content.css(gr)), o.content.css(gr, mr)
                        },
                        close: function() {
                            o.content.css(gr, o.content.data(gr))
                        }
                    }), l.result.done(function() {
                        o._removeRow(r)
                    }).fail(function() {
                        var e = o._confirmDialog;
                        e && (e.close(), e.destroy())
                    }), !1) : window.confirm(t.title)
                },
                _confirmation: function(e) {
                    var t = this,
                        r = t.options.editable,
                        l = r === !0 || typeof r === ar ? t.options.messages.editable.confirmation : r.confirmation;
                    return Be(r) && typeof r.mode === ar && typeof l !== or && typeof l !== ar && l !== !1 && (l = t.options.messages.editable.confirmation), l === !1 || null == l || (typeof l === or && (l = l(t._modelForContainer(e))), t._showMessage({
                        confirmDelete: r.confirmDelete || t.options.messages.editable.confirmDelete,
                        cancelDelete: r.cancelDelete || t.options.messages.editable.cancelDelete,
                        title: l === !0 ? t.options.messages.editable.confirmation : l
                    }, e))
                },
                cancelChanges: function() {
                    var e = this;
                    e.dataSource.cancelChanges(), e._isVirtualEditable() && e._virtualPageToTop(function() {
                        e.virtualScrollable.scrollToTop()
                    })
                },
                saveChanges: function() {
                    var e = this,
                        t = e.editable && e.editable.end();
                    !t && e.editable || e.trigger(Rt) ? t || e._scrollVirtualWrapper() : e.dataSource.sync()
                },
                addRow: function() {
                    var e, t, r = this,
                        l = r.dataSource,
                        o = r._editMode(),
                        a = r.options.editable.createAt || "",
                        n = l.pageSize(),
                        i = l.view() || [],
                        s = a.toLowerCase() === nr,
                        d = r._isVirtualEditable();
                    r.editable && r.editable.end() || !r.editable ? ("incell" != o && r.cancelRow(), e = l.indexOf(i[0]), s && (e += i.length, n && !l.options.serverPaging && n <= i.length && (e -= 1)), e < 0 && (e = l.page() > l.totalPages() ? (l.page() - 1) * n : 0), r.options.navigatable && "incell" == o && r._removeCurrent(), d ? r._virtualAddRow() : (t = l.insert(e, {}), r._editModel(t))) : r._scrollVirtualWrapper()
                },
                _editModel: function(e) {
                    var t, r, l, o, a = this,
                        n = a.options.editable.createAt || "",
                        i = a._editMode();
                    e && (t = e.uid, r = a.lockedContent ? a.lockedTable : a.table, l = r.find("tr[" + Ee.attr("uid") + "=" + t + "]"), o = l.children("td:not(.k-group-cell,.k-hierarchy-cell)").eq(a._firstEditableColumnIndex(l)), "inline" === i && l.length ? a.editRow(l) : "popup" === i ? a.editRow(e) : o.length && a.editCell(o), "bottom" == n.toLowerCase() && a.lockedContent && (a.lockedContent[0].scrollTop = a.content[0].scrollTop = a.table[0].offsetHeight))
                },
                _virtualAddRow: function() {
                    var e = this,
                        t = (e.options.editable.createAt || "").toLowerCase() === nr;
                    e._clearEditableState(), t ? e._virtualAddRowAtBottom() : e._virtualAddRowAtTop()
                },
                _virtualAddRowAtTop: function() {
                    var e, t = this,
                        r = t.dataSource,
                        l = t.virtualScrollable;
                    1 === r.page() ? (e = r.insert(0, {}), t._editModel(e), l.scrollToTop()) : t._virtualPageToTop(function() {
                        e = r.insert(0, {}), t._editModel(e), l.scrollToTop()
                    })
                },
                _virtualAddRowAtBottom: function() {
                    var e, t = this,
                        r = t.dataSource,
                        l = t.virtualScrollable,
                        o = r.total();
                    r.at(o - 1) instanceof De ? (e = r.insert(o, {}), t._virtualPageToBottom(function() {
                        t._editModel(e), l.scrollToBottom()
                    })) : t._virtualPageToBottom(function() {
                        e = r.insert(o, {}), t._editModel(e), l.scrollToBottom()
                    })
                },
                _virtualPageToTop: function(e) {
                    var t = this;
                    t._virtualPage(0, t.dataSource.take(), function() {
                        e()
                    })
                },
                _virtualPageToBottom: function(e) {
                    var t = this,
                        r = t.dataSource,
                        l = r.take(),
                        o = r.total(),
                        a = o > l ? o - l : 0;
                    t._virtualPage(a, l, function() {
                        e()
                    })
                },
                _virtualPage: function(e, t, r) {
                    var l = this;
                    l._isVirtualEditable() && (l.virtualScrollable._preventScroll = !0, l.virtualScrollable._page(e, t, r))
                },
                _firstEditableColumnIndex: function(e) {
                    var t, r, l, o = this,
                        a = Q(o.columns),
                        n = o._modelForContainer(e);
                    for (r = 0, l = a.length; r < l; r++)
                        if (t = a[r], n && (!n.editable || n.editable(t.field)) && !t.command && t.field && t.hidden !== !0) return r;
                    return -1
                },
                _toolbar: function() {
                    var t, r = this,
                        l = r.wrapper,
                        o = r.options.toolbar,
                        a = r.options.editable;
                    o && (t = r.wrapper.find(".k-grid-toolbar"), t.length || (Qe(o) || (o = typeof o === ar ? o : r._toolbarTmpl(o).replace(Hr, "\\#"), o = $e(Ee.template(o), r)), t = e('<div class="k-header k-grid-toolbar" />').html(o({})).prependTo(l), r.angular("compile", function() {
                        return {
                            elements: t.get()
                        }
                    })), a && a.create !== !1 && t.on(er + pt, ".k-grid-add", function(e) {
                        e.preventDefault(), r.addRow()
                    }).on(er + pt, ".k-grid-cancel-changes", function(e) {
                        e.preventDefault(), r.cancelChanges()
                    }).on(er + pt, ".k-grid-save-changes", function(e) {
                        e.preventDefault(), r.saveChanges()
                    }), t.on(er + pt, ".k-grid-excel", function(e) {
                        e.preventDefault(), r.saveAsExcel()
                    }), t.on(er + pt, ".k-grid-pdf", function(e) {
                        e.preventDefault(), r.saveAsPDF()
                    }), t.on(dr + pt, ".k-grid-search input", function(e) {
                        var t = e.currentTarget;
                        clearTimeout(r._searchTimeOut), r._searchTimeOut = setTimeout(function() {
                            var e, l, o, a, n;
                            if (r._searchTimeOut = null, e = r.options, l = e.search ? e.search.fields : null, o = {
                                    filters: [],
                                    logic: "or"
                                }, a = t.value, l || (l = J(e.columns)), r.dataSource.options.endless && (r.dataSource.options.endless = null, r._endlessPageSize = r.dataSource.options.pageSize), a)
                                for (n = 0; n < l.length; n++) o.filters.push({
                                    field: l[n],
                                    operator: "contains",
                                    value: a
                                });
                            else o = {};
                            r.dataSource.filter(o)
                        }, 300)
                    }))
                },
                _toolbarTmpl: function(e) {
                    var t, r, l, o = this,
                        a = "";
                    if (Ke(e))
                        for (t = 0, r = e.length; t < r; t++) l = "string" == typeof e[t] ? e[t].toLowerCase() : (e[t].name || "").toLowerCase(), "search" === l ? (a += "<span class='k-textbox k-grid-search k-display-flex'>", a += "<input autocomplete='off' placeholder='" + o.options.messages.search + "' title='" + o.options.messages.search + "' class='k-input' />", a += "<span class='k-input-icon'><span class='k-icon k-i-search'></span></span>", a += "</span>") : a += o._createButton(e[t]);
                    return a
                },
                _createButton: function(e) {
                    var r, l = e.template || Er,
                        a = typeof e === ar ? e : e.name || e.text,
                        n = Or[a] ? Or[a].className : "k-grid-" + (a || "").replace(/\s/g, ""),
                        i = {
                            className: n,
                            text: a,
                            attr: "",
                            iconClass: ""
                        },
                        s = this.options.messages.commands;
                    if (!(a || Be(e) && e.template)) throw Error("Custom commands should have name specified");
                    return Be(e) ? (e = Oe(!0, {}, e), e.className && je(i.className, e.className.split(" ")) < 0 ? e.className += " " + i.className : e.className === t && (e.className = i.className), "edit" === a && (e = Oe(!0, {}, e), e.text = Be(e.text) ? e.text.edit : e.text, e.iconClass = Be(e.iconClass) ? e.iconClass.edit : e.iconClass), e.attr && (Be(e.attr) && (e.attr = o(e.attr)), typeof e.attr === ar && (r = e.attr.match(/class="(.+?)"/), r && je(r[1], e.className.split(" ")) < 0 && (e.className += " " + r[1]))), i = Oe(!0, i, Or[a], {
                        text: s[a]
                    }, e)) : i = Oe(!0, i, Or[a], {
                        text: s[a]
                    }), Ee.template(l)(i)
                },
                _hasFooters: function() {
                    return !!this.footerTemplate || !!this.groupFooterTemplate || this.footer && this.footer.length > 0 || this.wrapper.find(".k-grid-footer").length > 0
                },
                _groupable: function() {
                    var t = this;
                    t._groupableClickHandler ? t.table.add(t.lockedTable).off(er + pt, t._groupableClickHandler) : t._groupableClickHandler = function(r) {
                        var l = e(this),
                            o = l.closest("tr"),
                            a = t._groupRows ? t._groupRows[t.wrapper.find(".k-grouping-row").index(o)] : {};
                        l.hasClass("k-i-collapse") ? t.trigger("groupCollapse", {
                            group: a,
                            element: o
                        }) || t.collapseGroup(o) : t.trigger("groupExpand", {
                            group: a,
                            element: o
                        }) || t.expandGroup(o), r.preventDefault(), r.stopPropagation()
                    }, t._isLocked() ? t.lockedTable.on(er + pt, ".k-grouping-row .k-i-expand, .k-grouping-row .k-i-collapse", t._groupableClickHandler) : t.table.on(er + pt, ".k-grouping-row .k-i-expand, .k-grouping-row .k-i-collapse", t._groupableClickHandler), t._attachGroupable()
                },
                _attachGroupable: function() {
                    var t = this,
                        r = t.wrapper,
                        l = t.options.groupable,
                        o = ut + "[" + Ee.attr("field") + "]",
                        a = t.content ? ".k-grid-header:first " + o : "table:first>.k-grid-header " + o;
                    l && l.enabled !== !1 && (r.has("div.k-grouping-header")[0] || e("<div>&nbsp;</div>").addClass("k-grouping-header").prependTo(r), t.groupable && t._destroyGroupable(), Fr.chrome && (r.find("div.k-grouping-header").css("touch-action", "none"), r.find(a).css("touch-action", "none")), t.groupable = new Le.Groupable(r, Oe({}, l, {
                        draggable: t._draggableInstance,
                        groupContainer: ">div.k-grouping-header",
                        dataSource: t.dataSource,
                        draggableElements: a,
                        filter: a,
                        allowDrag: t.options.reorderable,
                        change: function(e) {
                            t.trigger("group", {
                                groups: e.groups
                            }) ? e.preventDefault() : (t._clearEditableState(), t.dataSource.options.endless && (t.dataSource.options.endless = null, t._endlessPageSize = t.dataSource.options.pageSize, t.dataSource._skip = 0, t.dataSource._pageSize = t.dataSource._take = t._endlessPageSize, t.dataSource._page = 1))
                        }
                    })), t._addGroupableOptionsToHeader())
                },
                _addGroupableOptionsToHeader: function() {
                    var e, t, r, l = this,
                        o = F(l.columns),
                        a = {},
                        n = "",
                        i = l._headerCells(),
                        s = "";
                    for (r = 0; r < o.length; r++) n = o[r].field, a[o[r].field] = o[r];
                    for (r = 0; r < i.length; r++) e = i.eq(r), s = e.attr(Ee.attr(sr)), t = a[s], t && t.groupable && t.groupable.sort && e.data(br, t.groupable.sort)
                },
                _destroyGroupable: function() {
                    var e = this;
                    e.groupable && e.groupable.element && e.groupable.element.kendoGroupable("destroy"), e.groupable = null, e._removeGroupableOptionsFromHeader()
                },
                _removeGroupableOptionsFromHeader: function() {
                    var e, t = this,
                        r = t._headerCells();
                    for (e = 0; e < r.length; e++) r.eq(e).removeData(br)
                },
                _continuousItems: function(t, r) {
                    var l, o, a, n, i, s, d, c;
                    if (this.lockedContent) {
                        for (l = this, o = l.table.add(l.lockedTable), a = e(t, o[0]), n = e(t, o[1]), i = r ? N(l.columns).length : 1, s = r ? l.columns.length - i : 1, d = [], c = 0; c < a.length; c += i) Ue.apply(d, a.slice(c, c + i)), Ue.apply(d, n.splice(0, s));
                        return d
                    }
                },
                _selectable: function() {
                    var r, l, o, a, n = this,
                        i = [],
                        s = n._isLocked(),
                        d = n.options.selectable;
                    d && (n.selectable && n.selectable.destroy(), n._selectedIds = {}, d = Ee.ui.Selectable.parseOptions(d), r = d.multiple, l = d.cell, n._hasDetails() && (i[i.length] = ".k-detail-row"), (n.options.groupable || n._hasFooters() || n._groups()) && (i[i.length] = ".k-grouping-row,.k-group-footer"), i = i.join(","), "" !== i && (i = ":not(" + i + ")"), o = n.table, s && (o = o.add(n.lockedTable)), a = ">" + (l ? ot : "tbody>tr" + i), n.selectable = new Ee.ui.Selectable(o, {
                        filter: a,
                        aria: !0,
                        multiple: r,
                        change: function() {
                            var e;
                            l || n._persistSelectedRows(), n._checkBoxSelection && (e = n.selectable.value(), n._uncheckCheckBoxes(), n._checkRows(e), n._toggleHeaderCheckState(e.length && e.length === n.items().length ? !0 : !1)), n.trigger(Tt)
                        },
                        useAllItems: s && r && l,
                        relatedTarget: function(t) {
                            var r, o, a, i;
                            if (!l && s) {
                                for (o = e(), a = 0, i = t.length; a < i; a++) r = n._relatedRow(t[a]), je(r[0], t) < 0 && (o = o.add(r));
                                return o
                            }
                        },
                        continuousItems: function() {
                            return n._continuousItems(a, l)
                        }
                    }), n.options.navigatable && o.on("keydown" + pt, function(a) {
                        var i = n.current(),
                            d = a.target;
                        if (a.keyCode === Pe.SPACEBAR && !a.shiftKey && e.inArray(d, o) > -1 && !i.is(".k-edit-cell,.k-header") && i.parent().is(":not(.k-grouping-row,.k-detail-row,.k-group-footer)")) {
                            if (a.preventDefault(), a.stopPropagation(), i = l ? i : i.parent(), s && !l && (i = i.add(n._relatedRow(i))), r)
                                if (a.ctrlKey) {
                                    if (i.hasClass(Vt)) return n._deselectCheckRows(i), t
                                } else n.selectable.clear();
                            else n.selectable.clear();
                            l || (n.selectable._lastActive = i), n.selectable.value(i)
                        } else !l && (e(d).is("td") || e(d).is("table") && je(d, this._navigatableTables)) && (a.shiftKey && a.keyCode == Pe.LEFT || a.shiftKey && a.keyCode == Pe.RIGHT || a.shiftKey && a.keyCode == Pe.UP || a.shiftKey && a.keyCode == Pe.DOWN || a.keyCode === Pe.SPACEBAR && a.shiftKey) && (a.preventDefault(), a.stopPropagation(), i = i.parent(), s && (i = i.add(n._relatedRow(i))), r ? (n.selectable._lastActive || (n.selectable._lastActive = i), n.selectable.selectRange(n.selectable._firstSelectee(), i)) : (n.selectable.clear(), n.selectable.value(i)))
                    }))
                },
                _clipboard: function() {
                    var e, t = this.options,
                        r = t.selectable;
                    r && t.allowCopy && (e = this, t.navigatable || e.table.add(e.lockedTable).attr("tabindex", 0).on("mousedown" + pt + " keydown" + pt, ".k-detail-cell", function(e) {
                        e.target !== e.currentTarget && e.stopImmediatePropagation()
                    }).on("mousedown" + pt, at + ">" + nt, $e(Ce, e)), e.copyHandler = $e(e.copySelection, e), e.updateClipBoardState = function() {
                        e.areaClipBoard && e.areaClipBoard.val(e.getTSV()).focus().select()
                    }, e.bind("change", e.updateClipBoardState), e.wrapper.on("keydown", e.copyHandler), e.clearAreaHandler = $e(e.clearArea, e), e.wrapper.on("keyup", e.clearAreaHandler))
                },
                copySelection: function(t) {
                    t instanceof jQuery.Event && !t.ctrlKey && !t.metaKey || e(t.target).is("input:visible,textarea:visible") || window.getSelection && "" + window.getSelection() || document.selection && document.selection.createRange().text || (this.areaClipBoard || (this.areaClipBoard = e("<textarea />").css({
                        position: "fixed",
                        top: "50%",
                        left: "50%",
                        opacity: 0,
                        width: 0,
                        height: 0
                    }).appendTo(this.wrapper)), this.areaClipBoard.val(this.getTSV()).focus().select())
                },
                getTSV: function() {
                    var t, r, l, o, a, n, i = this,
                        s = i.select(),
                        d = "\t",
                        c = i.options.allowCopy,
                        u = !0;
                    return e.isPlainObject(c) && c.delimeter && (d = c.delimeter), t = "", s.length && (s.eq(0).is("tr") && (s = s.find("td:not(.k-group-cell)")), u && s.filter(":visible"), r = [], l = this.columns.length, o = i._isLocked() && N(i.columns).length, a = !0, e.each(s, function(t, n) {
                        var s, d, c, p;
                        n = e(n), s = n.closest("tr"), d = s.index(), c = n.index(), u && (c -= n.prevAll(":hidden").length), o && a && (a = e.contains(i.lockedTable[0], n[0])), i._groups() && a && (c -= i._groups()), c = a ? c : c + o, l > c && (l = c), p = n.text(), r[d] || (r[d] = []), r[d][c] = p
                    }), n = r.length, r = e.each(r, function(e, t) {
                        t && (r[e] = t.slice(l), n > e && (n = e))
                    }), e.each(r.slice(n), function(e, r) {
                        t += r ? r.join(d) + "\r\n" : "\r\n"
                    })), t
                },
                clearArea: function(t) {
                    var r;
                    this.areaClipBoard && t && t.target === this.areaClipBoard[0] && (r = this.options.navigatable ? e(this.current()).closest("table") : this.table, ke(r, !0)), this.areaClipBoard && (this.areaClipBoard.remove(), this.areaClipBoard = null)
                },
                _adaptiveColumns: function() {
                    var e = this;
                    e._anyColumnHasMediaQuery() && (e._setColumnsMediaVisibility(e.columns), e._attachColumnMediaResizeHandler())
                },
                _anyColumnHasMediaQuery: function() {
                    return this._columnsWithMediaQuery().length
                },
                _columnsWithMediaQuery: function() {
                    return w(this.columns)
                },
                _attachColumnMediaResizeHandler: function() {
                    var t = this;
                    t._detachColumnMediaResizeHandler(), t._columnMediaResizeHandler = $e(t._onColumnMediaResize, t), e(window).on($t + pt, t._columnMediaResizeHandler)
                },
                _detachColumnMediaResizeHandler: function() {
                    var t = this;
                    t._columnMediaResizeHandler && e(window).off($t + pt, t._columnMediaResizeHandler)
                },
                _onColumnMediaResize: function() {
                    var e = this;
                    e._setColumnsMediaVisibility(e.columns), e._setContentMediaWidth()
                },
                _setColumnsMediaVisibility: function(e) {
                    var t, r = e || [];
                    for (t = 0; t < r.length; t++) this._setColumnMediaVisibility(r[t])
                },
                _setColumnMediaVisibility: function(e) {
                    var t = this;
                    C(e.media) ? t._setColumnsMediaVisibility(e.columns) : m(e) ? (t._showColumnByMedia(e), e.hidden || t._setColumnsMediaVisibility(e.columns)) : t._hideColumnByMedia(e)
                },
                _showColumnByMedia: function(e) {
                    e.hidden || this.showColumn(e), g(e)
                },
                _hideColumnByMedia: function(e) {
                    var t = e.hidden;
                    t || (e._hideByMedia = !0, this.hideColumn(e), e._hideByMedia = !1, e.hidden = t), g(e)
                },
                _setContentMediaWidth: function() {
                    var t, r, l, o, a, n, i, s, d, c, u, p, h, f, g, m = this,
                        _ = m.options,
                        v = m._isLocked();
                    if (_.scrollable && _.resizable && (v && m.lockedFooter ? t = m.lockedFooter.children("table") : m.footer && (t = m.footer.find(">.k-grid-footer-wrap>table")), t && t[0] || (t = e()), r = v ? m.wrapper.find(".k-grid-header-locked").find("table") : m.wrapper.find(".k-grid-header").find("table"), l = v ? m.lockedTable : m.table, o = r.find("th"), a = r.find("colgroup"), n = o.length, i = o.filter(k).length, s = o.length - i, d = 0, "" !== r[0].style.width && parseFloat(r[0].style.width) !== d)) {
                        for (c = r.css("width"), u = 0; u < n; u++) b(o[u]) && (h = Math.max(u, u - s), f = a.children()[h], g = f ? f.style.width : "", "" !== g ? p = parseFloat(g) : (r.css("width", "auto"), p = qe(o.eq(u)), r.css("width", c)), d += p);
                        l.css("width", d - 1), r.css("width", d), t.css("width", d)
                    }
                },
                _minScreenSupport: function() {
                    var t = this.hideMinScreenCols();
                    t && (this.minScreenResizeHandler = $e(this.hideMinScreenCols, this), e(window).on("resize", this.minScreenResizeHandler))
                },
                hideMinScreenCols: function() {
                    var e = this.columns,
                        t = window.innerWidth > 0 ? window.innerWidth : screen.width;
                    return this._iterateMinScreenCols(e, t)
                },
                _iterateMinScreenCols: function(e, r) {
                    var l, o, a, n = !1;
                    for (l = 0; l < e.length; l++) o = e[l], a = o.minScreenWidth, a !== t && null !== a && (n = !0, a > r ? this.hideColumn(o) : this.showColumn(o)), !o.hidden && o.columns && (n = this._iterateMinScreenCols(o.columns, r) || n);
                    return n
                },
                _relatedRow: function(t) {
                    var r, l, o = this.lockedTable;
                    return t = e(t), o ? (r = t.closest(this.table.add(this.lockedTable)), l = r.find(">tbody>tr").index(t), r = r[0] === this.table[0] ? o : this.table, r.find(">tbody>tr").eq(l)) : t
                },
                _relatedCell: function(t) {
                    var r, l, o = this.lockedTable;
                    return t = e(t), o ? (r = t.closest(this.table.add(this.lockedTable)), l = r.find(">tbody>tr>td").index(t), r = r[0] === this.table[0] ? o : this.table, r.find(">tbody>tr>td").index(l)) : t
                },
                clearSelection: function() {
                    var e = this;
                    return e.selectable && !e._checkBoxSelection && e.selectable.clear(), e._checkBoxSelection ? (e._deselectCheckRows(e.select()), t) : (e.options.persistSelection ? e._persistSelectedRows() : e._selectedIds = {}, e.trigger(Tt), t)
                },
                select: function(e) {
                    var r = this,
                        l = r.selectable,
                        o = Ee.ui.Selectable.parseOptions(this.options.selectable),
                        a = o.cell;
                    return e = r.table.add(r.lockedTable).find(e), e.length ? (l && !l.options.multiple && (l.clear(), e = e.first()), r._isLocked() && (e = e.add(e.map(function() {
                        return a ? r._relatedCell(this) : r._relatedRow(this)
                    }))), l && !r._checkBoxSelection ? l.value(e) : (r._checkRows(e), r.select().length === r.items().length && r._toggleHeaderCheckState(!0), a || r._persistSelectedRows(), r.trigger(Tt)), t) : l ? l.value() : r.items().filter("." + Vt)
                },
                _toggleHeaderCheckState: function(e) {
                    var t = this;
                    e ? t.thead.add(t.lockedHeader).find("tr " + Bt).prop("checked", !0).attr("aria-checked", !0).attr("aria-label", "Deselect all rows") : t.thead.add(t.lockedHeader).find("tr " + Bt).prop("checked", !1).attr("aria-checked", !1).attr("aria-label", "Select all rows")
                },
                _uncheckCheckBoxes: function() {
                    var e = this,
                        t = e.table.add(e.lockedTable);
                    t.find("tbody " + Bt).attr("aria-checked", !1).prop("checked", !1).attr("aria-label", "Select row")
                },
                _deselectCheckRows: function(t) {
                    var r = this;
                    t = r.table.add(r.lockedTable).find(t), r._isLocked() && (t = t.add(t.map(function() {
                        return r._relatedRow(this)
                    }))), t.each(function() {
                        e(this).removeClass(Vt).find(Bt).attr("aria-checked", !1).prop("checked", !1).attr("aria-label", "Select row")
                    }), r._toggleHeaderCheckState(!1), r._persistSelectedRows(), r.trigger(Tt)
                },
                _checkRows: function(t) {
                    t.each(function() {
                        e(this).addClass(Vt).find(Bt).prop("checked", !0).attr("aria-label", "Deselect row").attr("aria-checked", !0)
                    })
                },
                _persistSelectedRows: function() {
                    var e, t, r, l, o = this,
                        a = o.items(),
                        n = o.dataSource.options,
                        i = n.schema,
                        s = {};
                    if (i && i.model && o._data && (r = Qe(i.model) ? i.model.fn.idField : i.model.id))
                        for (o.select().each(function() {
                                t = o.dataItem(this), s[t[r]] = !0
                            }), l = 0; l < a.length; l++) t = o.dataItem(a[l]), e = t[r], s[e] ? o._selectedIds[e] = !0 : delete o._selectedIds[e]
                },
                selectedKeyNames: function() {
                    var e, t = this,
                        r = [];
                    for (e in t._selectedIds) r.push(e);
                    return r.sort(), r
                },
                _updateCurrentAttr: function(t, r) {
                    var l = e(t).data("headerId");
                    e(t).removeClass(Wt).closest("table").removeAttr("aria-activedescendant"), l ? (l = l.replace(this._cellId, ""), e(t).attr("id", l)) : e(t).removeAttr("id"), r.data("headerId", r.attr("id")).attr("id", this._cellId).addClass(Wt).closest("table").attr("aria-activedescendant", this._cellId), this._current = r
                },
                _scrollCurrent: function() {
                    var t, r, l, o, a, n, i = this._current,
                        s = this.options.scrollable;
                    i && s && (t = i.parent(), r = t.closest("table").parent(), l = r.is(".k-grid-content-locked,.k-grid-header-locked"), o = r.is(".k-grid-content-locked,.k-grid-content,.k-virtual-scrollable-wrap"), a = e(this.content).find(">.k-virtual-scrollable-wrap").addBack().last()[0], o && (this.virtualScroll ? (n = Math.max(je(t[0], this._items(t.parent())), 0), this.virtualScroll.rows ? (this._rowVirtualIndex = this.virtualScrollable.itemIndex(n), this.virtualScrollable.scrollIntoView(t)) : (this._rowVirtualIndex = n, this._scrollTo(this._relatedRow(t)[0], a))) : this._scrollTo(this._relatedRow(t)[0], a)), this.lockedContent && (this.lockedContent[0].scrollTop = a.scrollTop), l || this._scrollTo(i[0], a))
                },
                current: function(e) {
                    return this._setCurrent(e, !0)
                },
                _setCurrent: function(t, r, l) {
                    var o, a, n, i = this._current;
                    return t = e(t), t.length && (i && i[0] === t[0] || (o = t.parent(), a = o.children(lt), n = parseInt(o.children().first().attr("colspan"), 10), this._hasVirtualColumns() && (this._virtualCellIndex = (n > 1 ? n : 0) + a.index(t)), this._updateCurrentAttr(i, t), l || this._scrollCurrent(), r || this.trigger(Zt, {
                        element: t
                    }))), t && t.length && (this._lastCellIndex = t.parent().children(lt).index(t)), this._current
                },
                _removeCurrent: function() {
                    this._current && (this._current.removeClass(Wt), this._current = null)
                },
                _scrollTo: function(t, r) {
                    var l = t.tagName.toLowerCase(),
                        o = "td" === l || "th" === l,
                        a = e(t).closest("table")[0],
                        n = t[o ? "offsetWidth" : "offsetHeight"],
                        i = r[o ? "scrollLeft" : "scrollTop"],
                        s = r[o ? "clientWidth" : "clientHeight"],
                        d = "relative" === e(t).css("position") && Dr && o ? Math.abs(a.offsetLeft - t.offsetLeft) : t[o ? "offsetLeft" : "offsetTop"],
                        c = d + n,
                        u = 0,
                        p = 0,
                        h = 0;
                    Dr && o && (Fr.msie || Fr.edge ? p = a.offsetLeft : Fr.mozilla && (h = a.offsetLeft - Ee.support.scrollbar())), i = Math.abs(i + p - h), u = i > d ? d : c > i + s ? n <= s ? c - s : d : i, u = Math.abs(u + p) + h, r[o ? "scrollLeft" : "scrollTop"] = u
                },
                _navigatable: function() {
                    var t, r, l, o = this;
                    o.options.navigatable && (t = o.table.add(o.lockedTable), r = o.thead.parent().add(e(">table", o.lockedHeader)), l = t, o.options.scrollable && (l = l.add(r), r.attr(lr, -1)), this._navigatableTables = l, l.off("mousedown" + pt + " focus" + pt + " focusout" + pt + " keydown" + pt), r.on("keydown" + pt, $e(o._openHeaderMenu, o)).find("a.k-link").attr("tabIndex", -1), t.attr(lr, Xe.max(t.attr(lr) || 0, 0)).on("keydown" + pt, ".k-detail-cell", function(e) {
                        e.target !== e.currentTarget && e.stopImmediatePropagation()
                    }), l.on(Ee.support.touch ? "touchstart" + pt : "mousedown" + pt, at + ">" + nt, $e(Ce, o)).on("focus" + pt, $e(o._tableFocus, o)).on("focusout" + pt, $e(o._tableBlur, o)).on("keydown" + pt, $e(o._tableKeyDown, o)))
                },
                _openHeaderMenu: function(e) {
                    e.altKey && e.keyCode == Pe.DOWN && (this.current().find(".k-grid-filter, .k-header-column-menu").click(), e.stopImmediatePropagation())
                },
                _setTabIndex: function(e) {
                    this._navigatableTables.attr(lr, -1), e.attr(lr, 0)
                },
                _tableFocus: function(t) {
                    var r = this.current(),
                        l = e(t.currentTarget);
                    r && r.is(":visible") ? r.addClass(Wt) : this._virtualColScroll ? this._setCurrent(l.find(ct), !0, !0) : this._setCurrent(l.find(ct)), this._setTabIndex(l)
                },
                _tableBlur: function() {
                    var e = this.current();
                    e && e.removeClass(Wt)
                },
                _findCellIndex: function(e, t, r) {
                    var l, o;
                    if (r)
                        for (o = t; o >= 0 && (l = o, e[o].hidden); o--);
                    else
                        for (o = t; o < e.length && (l = o, e[o].hidden); o++);
                    return l
                },
                _scrollToColumn: function(e, r) {
                    var l, o, a, n, i;
                    if (this._virtualCellIndex === t) return !1;
                    for (l = this, o = l._virtualCellIndex, a = Q(G(l.columns)), n = 0, e == (Dr ? Pe.LEFT : Pe.RIGHT) && o !== a.length - 1 ? o = l._findCellIndex(a, o + 1) : e == (Dr ? Pe.RIGHT : Pe.LEFT) && o ? o = l._findCellIndex(a, o - 1, !0) : e == Pe.HOME ? o = l._findCellIndex(a, 0) : e == Pe.END && (o = l._findCellIndex(a, a.length - 1, !0)), i = 0; i < o; i++) n += a[i].width;
                    return l._virtualCellIndex = o, r && (r.preventDefault(), r.stopPropagation()), l.content.scrollLeft(n), !0
                },
                _tableKeyDown: function(r) {
                    var l, o = this.current(),
                        a = this.virtualScroll || {},
                        n = this.virtualScrollable && this.virtualScrollable.fetching(),
                        i = e(r.target),
                        s = !r.isDefaultPrevented() && !i.is(":button,a,:input,a>.k-icon");
                    return n ? (r.preventDefault(), t) : ((!a.columns || o && document.body.contains(o[0]) || !this._scrollToColumn(r.keyCode, r)) && (o || (o = e(this.lockedTable).add(this.options.scrollable ? this.table : this.tbody).find(ct)), o.length && (l = !1, s && r.keyCode == Pe.UP && (l = this._moveUp(o, r.shiftKey)), s && r.keyCode == Pe.DOWN && (l = this._moveDown(o, r.shiftKey)), s && r.keyCode == (Dr ? Pe.LEFT : Pe.RIGHT) && (l = this._moveRight(o, r.altKey, r.shiftKey, r.ctrlKey, r.currentTarget)), s && r.keyCode == (Dr ? Pe.RIGHT : Pe.LEFT) && (l = this._moveLeft(o, r.altKey, r.shiftKey, r.ctrlKey, r.currentTarget)), s && r.keyCode == Pe.PAGEDOWN && (l = this._handlePageDown()), s && r.keyCode == Pe.PAGEUP && (l = this._handlePageUp()), s && r.keyCode == Pe.HOME && (l = this._handleHome(o, r.ctrlKey)), s && r.keyCode == Pe.END && (l = this._handleEnd(o, r.ctrlKey)), s && r.keyCode == Pe.SPACEBAR && (l = this._handleSpaceKey(o, r.ctrlKey)), r.keyCode != Pe.ENTER && r.keyCode != Pe.F2 || (l = this._handleEnterKey(o, r.currentTarget, i)), r.keyCode == Pe.ESC && (l = this._handleEscKey(o, r.currentTarget)), r.keyCode == Pe.TAB && (l = this._handleTabKey(o, r.currentTarget, r.shiftKey)), l && (r.preventDefault(), r.stopPropagation()))), t)
                },
                _moveLeft: function(t, r, l, o, a) {
                    var n, i, s = t.parent(),
                        d = s.parent();
                    return r ? this.collapseRow(s) : o && t.is(".k-header") && this.options.reorderable ? this._moveColumn(t, !0) : (i = d.find(at).index(s), n = this._prevHorizontalCell(d, t, i), n[0] || (l ? this.lockedTable ? (n = this._relatedRow(s), e.contains(this.lockedTable[0], s[0]) && (n = n.prevAll(it + ":first")), n = n.children(lt + ":last")) : n = this._tabNext(t, a, !0) : (d = this._horizontalContainer(d), n = this._prevHorizontalCell(d, t, i), n[0] !== t[0] && ke(d.parent(), !0))), this._setCurrent(n)), !0
                },
                _moveRight: function(t, r, l, o, a) {
                    var n, i, s = t.parent(),
                        d = s.parent();
                    return r ? this.expandRow(s) : o && t.is(".k-header") && this.options.reorderable ? this._moveColumn(t, !1) : (i = d.find(at).index(s), n = this._nextHorizontalCell(d, t, i), n[0] || (l ? this.lockedTable ? (n = this._relatedRow(s), e.contains(this.table[0], s[0]) && (n = n.nextAll(it + ":first")), n = n.children(lt + ":first")) : n = this._tabNext(t, a, !1) : (d = this._horizontalContainer(d, !0), n = this._nextHorizontalCell(d, t, i), n[0] !== t[0] && ke(d.parent(), !0))), this._setCurrent(n)), !0
                },
                _moveUp: function(e, t) {
                    var r, l, o = e.parent().parent();
                    return t ? (r = e.parent(), r = r.prevAll(it + ":first"), r = e.parent().is(it) ? r.children().eq(e.index()) : r.children(lt + ":last")) : (r = this._prevVerticalCell(o, e), r[0] || (this._lastCellIndex = 0, o = this._verticalContainer(o, !0), r = this._prevVerticalCell(o, e), r[0] && ke(o.parent(), !0))), l = this._lastCellIndex || 0, this._setCurrent(r), this._lastCellIndex = l, !0
                },
                _moveDown: function(e, t) {
                    var r, l, o = e.parent().parent();
                    return t ? (r = e.parent(), r = r.nextAll(it + ":first"), r = e.parent().is(it) ? r.children().eq(e.index()) : r.children(lt + ":first")) : (r = this._nextVerticalCell(o, e), r[0] || (this._lastCellIndex = 0, o = this._verticalContainer(o), r = this._nextVerticalCell(o, e), r[0] && ke(o.parent(), !0))), l = this._lastCellIndex || 0, this._setCurrent(r), this._lastCellIndex = l, !0
                },
                _moveColumn: function(t, r) {
                    var l = this.wrapper.data().kendoReorderable.element.find(this._draggableInstance.options.filter + ":visible"),
                        o = v(M(this.columns)),
                        a = l.index(e(t)),
                        n = r ? -1 : 1,
                        i = o[a],
                        s = D(o, this.columns, a, a + n);
                    s >= 0 && (this.reorderColumn(s, i, r), this.trigger(Jt, {
                        newIndex: s,
                        oldIndex: a,
                        column: i
                    }))
                },
                _handleHome: function(e, r) {
                    var l, o = e.parent(),
                        a = o.parent(),
                        n = this.lockedTable && this.lockedTable.children("tbody")[0] === a[0],
                        i = a[0] === this.tbody[0];
                    return this._hasVirtualColumns() ? (this._scrollToColumn(Ee.keys.HOME), !0) : (r ? l = this.lockedTable ? this.lockedTable.find(st + ">" + nt + ":first") : this.table.find(st + ">" + nt + ":first") : (i || n) && (i && this.lockedTable && (o = this._relatedRow(o)), l = o.children(lt + ":first")), l && l.length ? (this._setCurrent(l), !0) : t)
                },
                _handleEnd: function(e, r) {
                    var l, o = e.parent(),
                        a = o.parent(),
                        n = this.lockedTable && this.lockedTable.children("tbody")[0] === a[0],
                        i = a[0] === this.tbody[0];
                    return this._hasVirtualColumns() ? (this._scrollToColumn(Ee.keys.END), !0) : (r ? l = this.table.find(dt + ">" + nt + ":last") : (i || n) && (!i && this.lockedTable && (o = this._relatedRow(o)), l = o.children(lt + ":last")), l && l.length ? (this._setCurrent(l), !0) : t)
                },
                _handlePageDown: function() {
                    return !!this.options.pageable && (this.dataSource.page(this.dataSource.page() + 1), !0)
                },
                _handlePageUp: function() {
                    return !!this.options.pageable && (this.dataSource.page(this.dataSource.page() - 1), !0)
                },
                _handleTabKey: function(t, r, l) {
                    var o, a = this.options.editable && "incell" == this._editMode();
                    return !(!a || t.is("th")) && (o = e(Ae()).closest(".k-edit-cell"), o[0] && o[0] !== t[0] && (t = o), o = this._tabNext(t, r, l), o[0] !== t[0] && (!!o.length && (this._handleEditing(t, o, o.closest("table")), !0)))
                },
                _handleEscKey: function(t, r) {
                    var l, o = Ae(),
                        a = "incell" == this._editMode();
                    return xe(t) ? (a ? this.closeCell(!0) : (l = e(t).parent().index(), o && o.blur(), this.cancelRow(!0), l >= 0 && this._setCurrent(this.items().eq(l).children(nt).first())), Fr.msie && Fr.version < 9 && document.body.focus(), ke(r, !0), !0) : !!t.has(o).length && (ke(r, !0), !0)
                },
                _toggleCurrent: function(e, t) {
                    var r = e.parent();
                    return r.is(".k-grouping-row") ? (r.find(".k-icon:first").click(), !0) : !(t || !r.is(".k-master-row")) && (r.find(".k-icon:first").click(), !0)
                },
                _handleSpaceKey: function(t, r) {
                    var l, o, a, n, i = this;
                    if (r && i.groupable && t.hasClass("k-header")) return l = i.groupable.descriptors(), o = t.attr(Ee.attr("field")), a = i.groupable.aggregates(), n = t.attr(Ee.attr("title")) || o, i.groupable._canDrag(t) ? (l.push({
                        field: o,
                        dir: "asc",
                        aggregates: a || []
                    }), n += " " + i.options.messages.ungroupHeader) : (l = e.grep(l, function(e) {
                        return e.field !== o
                    }), n += " " + i.options.messages.groupHeader), t.attr("aria-label", n), i.dataSource.group(l), !0
                },
                _handleEnterKey: function(t, r, l) {
                    var o, a, n = this.options.editable && this.options.editable.update !== !1,
                        i = l.closest("[role=gridcell]");
                    return l.is("table") || e.contains(t[0], l[0]) || (t = i), t.is("th") ? (o = t.find(".k-link"), o.length ? o.click() : t.find(Bt).focus(), !0) : !!this._toggleCurrent(t, n) || (a = t.find(":kendoFocusable:first"), a[0] && !t.hasClass("k-edit-cell") && t.hasClass("k-state-focused") ? (a.focus(), !0) : !(!n || l.is(":button,.k-button,textarea")) && (i[0] || (i = t), this._handleEditing(i, !1, r), !0))
                },
                _nextHorizontalCell: function(e, t, r) {
                    var l, o, a, n = t.nextAll(lt);
                    return n.length || (l = e.find(at), o = l.index(t.parent()), o != -1) ? n.first() : t.hasClass("k-header") ? (a = [], O([N(this.columns)[0]], Z(l.eq(0).children(":visible").first()), a, 0, 0), a[r] ? a[r][0] : t) : t.parent().hasClass("k-filter-row") ? l.last().children(lt).first() : l.eq(r).children(lt).first()
                },
                _prevHorizontalCell: function(e, t, r) {
                    var l, o, a, n, i = t.prevAll(lt);
                    return i.length || (l = e.find(at), o = l.index(t.parent()), o != -1) ? i.first() : t.hasClass("k-header") ? (a = [], n = N(this.columns), O([n[n.length - 1]], Z(l.eq(0).children().last()), a, 0, 0), a[r] ? a[r][0] : t) : t.parent().hasClass("k-filter-row") ? l.last().children(lt).last() : l.eq(r).children(lt).last()
                },
                _currentDataIndex: function(e, r) {
                    var l, o = r.attr("data-index");
                    return o ? (l = N(this.columns).length, l && !e.closest("div").hasClass("k-grid-content-locked")[0] ? o - l : o) : t
                },
                _prevVerticalCell: function(t, r) {
                    var l, o = r.parent(),
                        a = t.children(at),
                        n = a.index(o),
                        i = this._currentDataIndex(t, r);
                    if (i || r.hasClass("k-header")) return l = X(r), l.eq(l.length - 2);
                    if (i = Math.max(o.children(lt).index(r), this._lastCellIndex || 0), o.hasClass("k-filter-row")) return Y(t).filter(k).eq(i);
                    if (n == -1) {
                        if (this._hasVirtualColumns() && (i = this._virtualCellIndex), o = t.find("tr.k-filter-row:visible"), !o[0]) return (this._hasDetails() || r.parent().find(".k-hierarchy-cell").length) && i && i--, Y(t).filter(k).eq(i)
                    } else o = 0 === n ? e() : a.eq(n - 1);
                    return l = o.children(lt), l.eq(l.length > i ? i : 0)
                },
                _nextVerticalCell: function(e, r) {
                    var l, o, a, n, i, s, d, c = r.parent(),
                        u = e.children(at),
                        p = u.index(c),
                        h = this._currentDataIndex(e, r),
                        f = this.virtualScroll || {};
                    if (p != -1 && h === t && r.hasClass("k-header")) return Z(r).eq(1);
                    if (h = h ? parseInt(h, 10) : c.children(lt).index(r), h = Math.max(h, this._lastCellIndex || 0), p == -1 ? (c = u.eq(0), f.columns && (o = parseInt(c.children().first().attr("colspan"), 10), h = this._virtualCellIndex - (o > 1 ? o : 0)), (this._hasDetails() || c.find(".k-hierarchy-cell").length) && h++) : c = u.eq(p + r[0].rowSpan), a = h, this._currentDataIndex(e, r) !== t)
                        for (n = c.children(":not(.k-group-cell):not(.k-hierarchy-cell)"), i = n.filter(":hidden"), s = 0, d = i.length; s < d; s++) n.index(i[s]) < h && a--;
                    return h = a, l = c.children(lt), l.eq(l.length > h ? h : 0)
                },
                _verticalContainer: function(e, t) {
                    var r = e.parent(),
                        l = this._navigatableTables.length,
                        o = Math.floor(l / 2),
                        a = je(r[0], this._navigatableTables);
                    return t && (o *= -1), a += o, (a >= 0 || a < l) && (r = this._navigatableTables.eq(a)), r.find(t ? ">thead" : ">tbody")
                },
                _horizontalContainer: function(e, t) {
                    var r, l, o = this._navigatableTables.length;
                    return o <= 2 ? e : (r = e.parent(), l = je(r[0], this._navigatableTables), l += t ? 1 : -1, !t || 2 != l && l != o ? !t && (1 == l || l < 0) ? e : this._navigatableTables.eq(l).find("thead, tbody") : e)
                },
                _tabNext: function(e, t, r) {
                    var l = !0,
                        o = r ? e.prevAll(lt + ":first") : e.nextAll(":visible:first");
                    if (!o.length) {
                        if (o = e.parent(), this.lockedTable && (l = r && t == this.lockedTable[0] || !r && t == this.table[0], o = this._relatedRow(o)), l) {
                            if (this._hasVirtualColumns()) return e;
                            o = o[r ? "prevAll" : "nextAll"]("tr:not(.k-grouping-row):not(.k-detail-row):visible:first")
                        }
                        o = o.children(lt + (r ? ":last" : ":first"))
                    }
                    return o
                },
                _handleEditing: function(r, l, o) {
                    var a, n, i = this,
                        s = e(Ae()),
                        d = i._editMode(),
                        c = Fr.msie,
                        u = c && Fr.version < 9,
                        p = i._editContainer,
                        h = i.options.editable && i.options.editable.update !== !1;
                    if (o = e(o), n = "incell" == d ? r.hasClass("k-edit-cell") : r.parent().hasClass("k-grid-edit-row"), i.editable) {
                        if (e.contains(p[0], s[0]) && (Fr.opera || u ? s.blur().change().triggerHandler("blur") : (s.blur(), c && s.blur())), !i.editable) return ke(o), t;
                        if (!i.editable.end()) return i._setCurrent("incell" == d ? p : p.children().filter(lt).first()), a = p.find(":kendoFocusable:first")[0], a && a.focus(), t;
                        "incell" == d ? i.closeCell() : (i.saveRow(), n = !0)
                    }
                    l && i._setCurrent(l), u && document.body.focus(), ke(o, !0), h && (!n && !l || l) && (d === cr ? e(i.current()).hasClass(rt) || i.editCell(i.current()) : i.editRow(i.current().parent()))
                },
                _wrapper: function() {
                    var e = this,
                        t = e.table,
                        r = e.options.height,
                        l = e.options.width,
                        o = e.element;
                    o.is("div") || (o = o.wrap("<div/>").parent()), e.wrapper = o.addClass("k-grid k-widget k-grid-display-block"), r && (e.wrapper.css(rr, r), t.css(rr, "auto")), l && e.wrapper.css("width", l), e._initMobile()
                },
                _initMobile: function() {
                    var e, t = this.options,
                        r = this;
                    this._isMobile = t.mobile === !0 && Ee.support.mobileOS || "phone" === t.mobile || "tablet" === t.mobile, this._isMobile && (e = this.wrapper.addClass("k-grid-mobile").wrap("<div data-" + Ee.ns + 'stretch="true" data-' + Ee.ns + 'role="view" data-' + Ee.ns + 'init-widgets="false"></div>').parent(), this.pane = this._createPane(e), this.view = this.pane.view(), t.height ? this.pane.element.parent().css(rr, t.height) : this.pane.element.parent().css(rr, this.wrapper[0].style.height), this._editAnimation = "slide", r.wrapper.on("transitionend" + pt, function(e) {
                        e.stopPropagation()
                    }), r.wrapper.on("contextmenu" + pt, "th a", function(e) {
                        return e.preventDefault(), !1
                    }), this.view.bind("showStart", function() {
                        r._isLocked() && (r._updateTablesWidth(), r._applyLockedContainersWidth(), r._syncLockedContentHeight(), r._syncLockedHeaderHeight(), r._syncLockedFooterHeight())
                    }))
                },
                _createPane: function(e) {
                    var t = Ee.Pane.wrap(e, {
                        viewEngine: {
                            viewOptions: {
                                renderOnInit: !0,
                                wrap: !1,
                                wrapInSections: !0,
                                detachOnHide: !1,
                                detachOnDestroy: !1
                            }
                        }
                    });
                    return t
                },
                _tbody: function() {
                    var t, r = this,
                        l = r.table;
                    t = l.find(">tbody"), t.length || (t = e("<tbody/>").appendTo(l)), r.tbody = t.attr("role", "rowgroup")
                },
                _scrollable: function() {
                    var t, r, l, o, a, n, i, s = this,
                        d = s.options,
                        c = d.scrollable,
                        u = c !== !0 && c.virtual && !s.virtualScrollable,
                        p = u ? Se(c.virtual) : {},
                        h = !Ee.support.kineticScrollNeeded || p.rows ? Ee.support.scrollbar() : 0;
                    c && (t = s.wrapper.children(".k-grid-header"), t[0] || (t = e('<div class="k-grid-header" />').insertBefore(s.table)), t.css(Dr ? "padding-left" : "padding-right", c.virtual ? h + 1 : h), r = e('<table role="grid" />'), Ar && r.attr("cellspacing", 0), r.width(s.table[0].style.width), r.append(s.thead), t.empty().append(e('<div class="k-grid-header-wrap k-auto-scrollable" />').append(r)), s.content = s.table.parent(), s.virtualScroll = p, s.content.is(".k-virtual-scrollable-wrap, " + Ze + Pr.scrollContainer) && (s.content = s.content.parent()), s.content.is(".k-grid-content, .k-virtual-scrollable-wrap") || (s.content = s.table.wrap('<div class="k-grid-content k-auto-scrollable" />').parent()), p.rows && s._createVirtualScrollable(), p.columns && s.table.css({
                        width: W(U(K(s.columns)))
                    }), l = t.children(".k-grid-header-wrap"), s.scrollables = l.add(s.content), o = s.wrapper.find(".k-grid-footer"), o.length && (s.scrollables = s.scrollables.add(o.children(".k-grid-footer-wrap"))), l.unbind("scroll" + pt).bind("scroll" + pt, function(e) {
                        s._scrollLeft !== this.scrollLeft && s.scrollables.not(e.currentTarget).scrollLeft(this.scrollLeft)
                    }), p.rows ? s.content.find(">.k-virtual-scrollable-wrap").unbind("scroll" + pt).bind("scroll" + pt, function() {
                        var e = this.scrollLeft != s._scrollLeft;
                        s._scrollLeft = this.scrollLeft, s.scrollables.scrollLeft(this.scrollLeft), s.lockedContent && (s.lockedContent[0].scrollTop = this.scrollTop), p.columns && e && s.refresh()
                    }) : (a = c.endless, n = s.dataSource.options.pageSize, a && (s._endlessPageSize = n), s.content.unbind("scroll" + pt).bind("scroll" + pt, function(e) {
                        var t = this.scrollLeft != s._scrollLeft;
                        s._scrollLeft = this.scrollLeft, s.scrollables.not(e.currentTarget).scrollLeft(s._scrollLeft), s.lockedContent && e.currentTarget == s.content[0] && (s.lockedContent[0].scrollTop = this.scrollTop), a && this.scrollTop + this.clientHeight - this.scrollHeight >= -10 && !s._endlessFetchInProgress && s._endlessPageSize < s.dataSource.total() && (s._skipRerenderItemsCount = s._endlessPageSize, s._endlessPageSize = s._endlessPageSize + n, s.dataSource.options.endless = !0, s._endlessFetchInProgress = !0, s.dataSource.pageSize(s._endlessPageSize)), p.columns && t && (s._virtualColScroll = !0, s._cacheEditableState(), s.refresh(), s._restoreEditableState(), s._virtualColScroll = !1)
                    }), i = s.content.data("kendoTouchScroller"), i && i.destroy(), i = Ee.touchScroller(s.content), i && i.movable && (s.touchScroller = i, i.movable.bind("change", function(e) {
                        s.scrollables.scrollLeft(-e.sender.x), s.lockedContent && s.lockedContent.scrollTop(-e.sender.y)
                    }), s.one(It, function(e) {
                        e.sender.wrapper.addClass("k-grid-backface")
                    }))))
                },
                _createVirtualScrollable: function() {
                    var e = this;
                    e.virtualScrollable && e.virtualScrollable.destroy(), e.virtualScrollable = new Br(e.content, {
                        dataSource: e.dataSource,
                        itemHeight: function() {
                            return e._averageRowHeight()
                        },
                        page: function() {
                            e._restoreEditableState()
                        },
                        scroll: function() {
                            e._focusEditable()
                        }
                    }), e.virtualScrollable.bind(Dt, $e(e._onVirtualPaging, e))
                },
                _onVirtualPaging: function() {
                    var e = this;
                    e._cacheEditableState(), e._isVirtualIncellEditable() && (e._shouldClearEditableState = !1, e.closeCell(), e._shouldClearEditableState = !0)
                },
                _isVirtualEditable: function() {
                    return this._isVirtualIncellEditable() || this._isVirtualInlineEditable() || this._isVirtualPopupEditable()
                },
                _isVirtualInlineEditable: function() {
                    return this.virtualScrollable && this._editMode() === ur
                },
                _isVirtualIncellEditable: function() {
                    return this.virtualScrollable && this._editMode() === cr
                },
                _isVirtualPopupEditable: function() {
                    return this.virtualScrollable && "popup" === this._editMode()
                },
                _hasVirtualColumns: function() {
                    return !!(this.virtualScroll || {}).columns
                },
                _scrollVirtualWrapper: function() {
                    var e = this,
                        t = e.virtualScrollable;
                    (e._isVirtualInlineEditable() || e._isVirtualIncellEditable()) && (t._isScrolledToBottom() ? t._scrollWrapperToBottom() : t._isScrolledToTop() && t._scrollWrapperToTop())
                },
                _scrollVirtualWrapperOnColumnResize: function() {
                    var e = this.virtualScrollable;
                    e && e._scrollWrapperOnColumnResize()
                },
                _restoreEditableState: function() {
                    var t, l, o = this,
                        a = o._editableState || {},
                        n = a.model,
                        i = o.dataSource,
                        s = o._isVirtualInlineEditable(),
                        d = o._isVirtualIncellEditable(),
                        c = o._hasVirtualColumns();
                    (s || d || c) && n && i._getByUid(n.uid, i.view()) && (o._editMode() === ur ? (o._shouldClearEditableState = !1, o.editRow(n), c || o._focusEditable()) : o._editMode() === cr && (t = o.tbody.children(r(pr, n.uid)), l = e(t).children(r(sr, a.field)), l[0] && (o._shouldClearEditableState = !1, o.editCell(l), c || o._focusEditable()))), o._shouldClearEditableState = !0
                },
                _focusEditable: function() {
                    var e = this,
                        t = (e._editableState || {}).field,
                        l = e._editContainer;
                    l && l.length && !Ye(l[0], Ae()) && e._canFocusEditable() && (e._isVirtualInlineEditable() || e._hasVirtualColumns() ? l.find(r(ir, t)).find(qt).eq(0).focus() : (e._isVirtualIncellEditable() || e._hasVirtualColumns()) && l.find(qt).eq(0).focus())
                },
                _canFocusEditable: function() {
                    var e = this,
                        t = (e._isVirtualIncellEditable() || e._isVirtualInlineEditable() || e._hasVirtualColumns()) && (Te((e.virtualScrollable || {}).wrapper, e._editContainer) || Te(e.content, e._editContainer));
                    return t
                },
                _cacheEditableState: function() {
                    var t, r, l = this,
                        o = l._editContainer,
                        a = o ? l._modelForContainer(o) : null,
                        n = l._isVirtualInlineEditable(),
                        i = l._isVirtualIncellEditable(),
                        s = l._hasVirtualColumns();
                    (n || i || s) && a && (l._clearEditableState(), t = e(Ae()), o && t[0] && Ye(o[0], t[0]) && (t.change(), r = Ee.widgetInstance(t, Ee.ui), r && Qe(r.value) && t.is(dr) && (r.value(t.val()), r.trigger(Tt))), l._editMode() === ur ? l._editableState = {
                        model: a,
                        field: t.closest("[" + Ee.attr(ir) + "]").attr(Ee.attr(ir))
                    } : l._editMode() === cr && (l._editableState = {
                        model: a,
                        field: o.attr(Ee.attr(sr))
                    }))
                },
                _clearSortClasses: function() {
                    var e = this;
                    e.content && e.content.find("col:not(.k-group-col):not(.k-hierarchy-col)").removeClass("k-sorted"), e.lockedContent && e.lockedContent.find("col:not(.k-group-col):not(.k-hierarchy-col)").removeClass("k-sorted")
                },
                _clearEditableState: function() {
                    var e = this;
                    (e.virtualScrollable || e.virtualScroll && e._hasVirtualColumns()) && (e._editableState = null)
                },
                _destroyVirtualScrollable: function() {
                    var e = this;
                    e._clearEditableState(), e.virtualScrollable && e.virtualScrollable.element && e.virtualScrollable.destroy(), e.virtualScrollable = null
                },
                _renderNoRecordsContent: function() {
                    var t, r = this;
                    r.options.noRecords && (t = r.table.parent().children("." + Ot), t.length && (r.angular("cleanup", function() {
                        return {
                            elements: t.get()
                        }
                    }), t.remove()), r.dataSource && r.dataSource.view().length || (t = e(r.noRecordsTemplate({})).insertAfter(r.table), r.angular("compile", function() {
                        return {
                            elements: t.get(),
                            data: [{}]
                        }
                    })))
                },
                _setContentWidth: function(t) {
                    var r, l = this,
                        o = "k-grid-content-expander",
                        a = '<div class="' + o + '"></div>',
                        n = l.resizable;
                    l.options.scrollable && l.wrapper.is(":visible") && (r = l.table.parent().children("." + o), l._setContentWidthHandler = $e(l._setContentWidth, l), l.dataSource && l.dataSource.view().length ? r[0] && (r.remove(), n && n.unbind("resize", l._setContentWidthHandler)) : (r[0] || (r = e(a).appendTo(l.table.parent()), n && n.bind("resize", l._setContentWidthHandler)), l.thead && (r.width(l.thead.width()), isNaN(parseFloat(t, 10)) || l.content.scrollLeft(t))), l._applyLockedContainersWidth(), l._syncLockedContentHeight(), l.lockedHeader && 0 === l.table[0].clientWidth && (l.table[0].style.width = "1px"))
                },
                _applyLockedContainersWidth: function() {
                    if (this.options.scrollable && this.lockedHeader) {
                        var e, t = this.thead.parent(),
                            r = t.parent(),
                            l = this.wrapper[0].clientWidth,
                            o = this._groups(),
                            a = Ee.support.scrollbar(),
                            n = this.lockedHeader.find(">table>colgroup>col:not(.k-group-col, .k-hierarchy-col)"),
                            i = t.find(">colgroup>col:not(.k-group-col, .k-hierarchy-col)"),
                            s = q(n),
                            d = q(i);
                        o > 0 && (s += qe(this.lockedHeader.find(".k-group-cell:first")) * o), s >= l && (s = l - 3 * a), this.lockedHeader.add(this.lockedContent).width(s), r[0].style.width = r.parent().width() - s - 2 + "px", t.add(this.table).width(d), this.virtualScrollable && !qr && (l -= a), this.content[0].style.width = l - s - 1 + "px", this.lockedFooter && this.lockedFooter.length && (this.lockedFooter.width(s), e = this.footer.find(".k-grid-footer-wrap"), e[0].style.width = r[0].clientWidth + "px", e.children().first().width(d))
                    }
                },
                _setContentHeight: function() {
                    var e, t, r = this,
                        l = r.options,
                        o = r.wrapper.children(".k-grid-header"),
                        a = Ee.support.scrollbar(),
                        n = (l.scrollable || {}).height;
                    l.scrollable && r.wrapper.is(":visible") && (n && "" === r.content[0].style.height && (r.content[0].style.height = n), e = r.wrapper.innerHeight(), e -= Ve(o), r.pager && r.pager.element.is(":visible") && (e -= Ve(r.pager.element)), l.groupable && (e -= Ve(r.wrapper.children(".k-grouping-header"))), l.toolbar && (e -= Ve(r.wrapper.children(".k-grid-toolbar"))), r.footerTemplate && (e -= Ve(r.wrapper.children(".k-grid-footer"))), t = function(e) {
                        var t, r;
                        return !!e[0].style.height || (t = e.height(), e.height("auto"), r = e.height(), t != r ? (e.height(""), !0) : (e.height(""), !1))
                    }, t(r.wrapper) && (e > 2 * a ? (r.lockedContent && (a = r.table[0].offsetWidth > r.table.parent()[0].clientWidth ? a : 0, r.lockedContent.height(e - a)), r.content.height(e)) : r.content.height(2 * a + 1)))
                },
                _averageRowHeight: function() {
                    var e, t = this,
                        r = t._items(t.tbody).length,
                        l = t._rowHeight;
                    return 0 === r ? l : (t._rowHeight || (t._rowHeight = l = Ve(t.table) / r, t._sum = l, t._measures = 1), e = Ve(t.table) / r, l !== e && (t._measures++, t._sum += e, t._rowHeight = t._sum / t._measures), l)
                },
                _dataSource: function() {
                    var e, r = this,
                        l = r.options,
                        o = l.dataSource;
                    o = Ke(o) ? {
                        data: o
                    } : o, Be(o) && (Oe(o, {
                        table: r.table,
                        fields: r.columns
                    }), e = l.pageable, Be(e) && e.pageSize !== t && (o.pageSize = e.pageSize)), r.dataSource && r._refreshHandler ? r.dataSource.unbind(Tt, r._refreshHandler).unbind(et, r._progressHandler).unbind(tt, r._errorHandler).unbind(kr, r._sortHandler) : (r._refreshHandler = $e(r.refresh, r), r._progressHandler = $e(r._requestStart, r), r._errorHandler = $e(r._error, r), r._sortHandler = $e(r._clearSortClasses, r)), r.dataSource = Me.create(o).bind(Tt, r._refreshHandler).bind(et, r._progressHandler).bind(tt, r._errorHandler).bind(kr, r._sortHandler)
                },
                _error: function() {
                    this._progress(!1)
                },
                _requestStart: function() {
                    this._progress(!0)
                },
                _modelChange: function(t) {
                    var r, l, o, a, n, i, s, d, c, u, p = this,
                        h = p.tbody,
                        f = t.model,
                        g = p.tbody.find("tr[" + Ee.attr("uid") + "=" + f.uid + "]"),
                        m = g.hasClass("k-alt"),
                        k = p._items(h).index(g),
                        b = p.lockedContent;
                    if (b && (r = p._relatedRow(g)), g.add(r).children(".k-edit-cell").length && !p.options.rowTemplate) g.add(r).children(":not(.k-group-cell,.k-hierarchy-cell)").each(function() {
                        l = e(this), o = p._hasVirtualColumns() ? p.virtualCols[p.cellIndex(l)] : Q(p.columns)[p.cellIndex(l)], o.field === t.field && (l.hasClass("k-edit-cell") ? l.addClass("k-dirty-cell") : p._displayCell(l, o, f))
                    });
                    else if (!g.hasClass("k-grid-edit-row")) {
                        for (i = e().add(g), b && (a = (m ? p.lockedAltRowTemplate : p.lockedRowTemplate)(f), i = i.add(r), r.replaceWith(a)), p.angular("cleanup", function() {
                                return {
                                    elements: i.get()
                                }
                            }), a = (m ? p.altRowTemplate : p.rowTemplate)(f), g.replaceWith(a), a = p._items(h).eq(k), u = [{
                                dataItem: f
                            }], b && (g = g.add(r), r = p._relatedRow(a)[0], ge(a[0], r), a = a.add(r), u.push({
                                dataItem: f
                            })), p.angular("compile", function() {
                                return {
                                    elements: a.get(),
                                    data: u
                                }
                            }), n = p.options.selectable, (n || p._checkBoxSelection) && g.hasClass("k-state-selected") && p.select(a), d = i.children(":not(.k-group-cell,.k-hierarchy-cell)"), s = a.children(":not(.k-group-cell,.k-hierarchy-cell)"), k = 0, c = p.columns.length; k < c; k++) o = p.columns[k], l = s.eq(k), n && d.eq(k).hasClass("k-state-selected") && l.addClass("k-state-selected");
                        p.trigger("itemChange", {
                            item: a,
                            data: f,
                            ns: Le
                        })
                    }
                },
                _pageable: function() {
                    var t, r = this,
                        l = r.options.pageable;
                    l && (t = r.wrapper.children("div.k-grid-pager"), t.length || (t = e('<div class="k-pager-wrap k-grid-pager"/>').appendTo(r.wrapper)), r.pager && r.pager.destroy(), r.pager = "object" == typeof l && l instanceof Ee.ui.Pager ? l : new Ee.ui.Pager(t, Oe({}, l, {
                        dataSource: r.dataSource
                    })), r.pager.bind("pageChange", function(e) {
                        r.trigger("page", {
                            page: e.index
                        }) && e.preventDefault()
                    }), r._togglePagerVisibility())
                },
                _footer: function() {
                    var t, r, l, o = this,
                        a = o.dataSource.aggregates(),
                        n = "",
                        i = o.footerTemplate,
                        s = o.options,
                        d = o.footer || o.wrapper.find(".k-grid-footer");
                    i ? (n = e(o._wrapFooter(i(a))), d.length ? (r = n, o.angular("cleanup", function() {
                        return {
                            elements: d.get()
                        }
                    }), d.replaceWith(r), d = o.footer = r) : d = o.footer = s.scrollable ? s.pageable ? n.insertBefore(o.wrapper.children("div.k-grid-pager")) : n.appendTo(o.wrapper) : n.insertBefore(o.tbody), o.angular("compile", function() {
                        return {
                            elements: d.find("td:not(.k-group-cell, .k-hierarchy-cell)").get(),
                            data: Ne(o.columns, function(e) {
                                return {
                                    column: e,
                                    aggregate: a[e.field]
                                }
                            })
                        }
                    })) : d && !o.footer && (o.footer = d), d.length && (s.scrollable && (t = d.attr("tabindex", -1).children(".k-grid-footer-wrap"), o.scrollables = e(o.scrollables.filter(function() {
                        return !e(this).is(".k-grid-footer-wrap")
                    }).toArray()).add(t)), o._footerWidth && d.find("table").css("width", o._footerWidth), t && (l = o.content.scrollLeft(), s.scrollable !== !0 && o.virtualScroll.rows && (l = o.wrapper.find(".k-virtual-scrollable-wrap").scrollLeft()), t.scrollLeft(l))), o.lockedContent && (o._appendLockedColumnFooter(), o._applyLockedContainersWidth(), o._syncLockedFooterHeight())
                },
                _wrapFooter: function(t) {
                    var r = this,
                        l = "",
                        o = Ee.support.mobileOS ? 0 : Ee.support.scrollbar();
                    return r.options.scrollable ? (l = e('<div class="k-grid-footer"><div class="k-grid-footer-wrap"><table' + (Ar ? ' cellspacing="0"' : "") + "><tbody>" + t + "</tbody></table></div></div>"), r._appendCols(l.find("table")), l.css(Dr ? "padding-left" : "padding-right", o), l) : '<tfoot class="k-grid-footer">' + t + "</tfoot>"
                },
                _columnMenu: function() {
                    var e, r, l, o, a, n, i, s, d, c = this,
                        u = Q(c.columns),
                        p = c.options,
                        h = p.columnMenu,
                        f = Ge(c.columns, function(e) {
                            return e.columns !== t
                        }).length > 0,
                        g = this._isMobile,
                        m = function(e) {
                            c.trigger(wt, {
                                field: e.field,
                                container: e.container
                            })
                        },
                        k = function(e) {
                            c.trigger(yt, {
                                field: e.field,
                                container: e.container
                            })
                        },
                        b = function(e) {
                            ke(e.closest("table"), !0)
                        },
                        _ = function(e) {
                            c.trigger("sort", {
                                sort: e.sort
                            }) ? e.preventDefault() : (c._clearEditableState(), c.dataSource.options.endless && (c.dataSource.options.endless = null, c._endlessPageSize = c.dataSource.options.pageSize, c.dataSource.pageSize(c.dataSource.options.pageSize)))
                        },
                        v = function(e) {
                            c.trigger("filter", {
                                filter: e.filter,
                                field: e.field
                            }) ? e.preventDefault() : (c._clearEditableState(), c.dataSource.options.endless && (c.dataSource.options.endless = null, c._endlessPageSize = c.dataSource.options.pageSize, c.dataSource.pageSize(c.dataSource.options.pageSize)))
                        },
                        w = p.$angular;
                    if (h)
                        for ("boolean" == typeof h && (h = {}), c._setColumnsMediaVisibility(u), n = Y(c.thead), i = 0, s = n.length; i < s; i++) r = u[i], d = n.eq(i), r.command || !r.field && !d.attr("data-" + Ee.ns + "field") || (e = d.data("kendoColumnMenu"), e && e.destroy(), o = r.sortable !== !1 && h.sortable !== !1 && p.sortable !== !1 && Oe({}, p.sortable, {
                            compare: (r.sortable || {}).compare
                        }), a = !(!p.filterable || r.filterable === !1 || h.filterable === !1) && Oe({
                            pane: c.pane
                        }, p.filterable, r.filterable), r.filterable && r.filterable.dataSource && (a.forceUnique = !1, a.checkSource = r.filterable.dataSource), a && (a.format = r.format), l = {
                            dataSource: c.dataSource,
                            values: r.values,
                            columns: h.columns,
                            sortable: o,
                            filterable: a,
                            messages: h.messages,
                            owner: c,
                            closeCallback: b,
                            init: m,
                            open: k,
                            pane: c.pane,
                            sort: _,
                            filtering: v,
                            filter: g ? ":not(.k-column-active)" : "",
                            lockedColumns: !f && r.lockable !== !1 && N(u).length > 0
                        }, w && (l.$angular = w), d.kendoColumnMenu(l))
                },
                _headerCells: function() {
                    return e(this.thead).find("th").filter(function() {
                        var t = e(this);
                        return !t.hasClass("k-group-cell") && !t.hasClass("k-hierarchy-cell")
                    })
                },
                _filterable: function() {
                    var e, t, r, l, o, a, n, i = this,
                        s = Q(i.columns),
                        d = function(e) {
                            i.trigger(vt, {
                                field: e.field,
                                container: e.container
                            })
                        },
                        c = function(e) {
                            ke(e.closest("table"), !0)
                        },
                        u = function(e) {
                            i.trigger("filter", {
                                filter: e.filter,
                                field: e.field
                            }) ? e.preventDefault() : (i._clearEditableState(), i.dataSource.options.endless && (i.dataSource.options.endless = null, i._endlessPageSize = i.dataSource.options.pageSize, i.dataSource.pageSize(i.dataSource.options.pageSize)))
                        },
                        p = function(e) {
                            i.trigger(Ct, {
                                field: e.field,
                                container: e.container
                            })
                        },
                        h = i.options.filterable;
                    if (h && typeof h.mode == ar && h.mode.indexOf("menu") == -1 && (h = !1), h && !i.options.columnMenu)
                        for (t = Y(i.thead), l = 0, o = t.length; l < o; l++) r = t.eq(l), s[l].filterable === !1 || s[l].command || !s[l].field && !r.attr("data-" + Ee.ns + "field") || (e = r.data("kendoFilterMenu"), e && e.destroy(), e = r.data("kendoFilterMultiCheck"), e && e.destroy(), a = s[l].filterable, n = Oe({}, h, a, {
                            dataSource: i.dataSource,
                            values: s[l].values,
                            format: s[l].format,
                            closeCallback: c,
                            title: s[l].title || s[l].field,
                            init: d,
                            open: p,
                            pane: i.pane,
                            change: u
                        }), a && a.messages && (n.messages = Oe(!0, {}, h.messages, a.messages)), a && a.dataSource && (n.forceUnique = !1, n.checkSource = a.dataSource), a && a.multi ? r.kendoFilterMultiCheck(n) : r.kendoFilterMenu(n))
                },
                _filterRow: function() {
                    var t, r, l, o, a, n, i, s, d, c, u, p, h, f, g, m = this;
                    if (m._hasFilterRow())
                        for (r = m.options.$angular, l = Q(m.columns), o = m.options.filterable, a = m.thead.find(".k-filter-row"), n = function(e) {
                                m.trigger("filter", {
                                    filter: e.filter,
                                    field: e.field
                                }) ? e.preventDefault() : (m._clearEditableState(), m.dataSource.options.endless && (m.dataSource.options.endless = null, m._endlessPageSize = m.dataSource.options.pageSize, m.dataSource.pageSize(m.dataSource.options.pageSize)))
                            }, this._updateHeader(this.dataSource.group().length), i = 0; i < l.length; i++)
                            if (d = l[i], c = m.options.filterable.operators, u = !1, p = e("<th/>"), h = d.field, d.hidden && p.hide(), a.append(p), h && d.filterable !== !1) {
                                if (f = d.filterable && d.filterable.cell || {}, s = m.options.dataSource, s instanceof Me && (s = m.options.dataSource.options), g = Oe(!0, {}, o.messages), d.filterable && Oe(!0, g, d.filterable.messages), f.enabled === !1) {
                                    p.html("&nbsp;");
                                    continue
                                }
                                f.dataSource && (s = f.dataSource, u = !0), d.filterable && d.filterable.operators && (c = d.filterable.operators), t = {
                                    column: d,
                                    dataSource: m.dataSource,
                                    suggestDataSource: s,
                                    customDataSource: u,
                                    field: h,
                                    messages: g,
                                    values: d.values,
                                    template: f.template,
                                    delay: f.delay,
                                    inputWidth: f.inputWidth,
                                    suggestionOperator: f.suggestionOperator,
                                    minLength: f.minLength,
                                    dataTextField: f.dataTextField,
                                    operator: f.operator,
                                    operators: c,
                                    showOperators: f.showOperators,
                                    change: n
                                }, r && (t.$angular = r), e("<span/>").attr(Ee.attr("field"), h).appendTo(p).kendoFilterCell(t)
                            } else p.html("&nbsp;")
                },
                _sortable: function() {
                    var e, t, r, l, o, a, n = this,
                        i = Q(n.columns),
                        s = n.options.sortable,
                        d = function(e) {
                            n.trigger("sort", {
                                sort: e.sort
                            }) ? e.preventDefault() : n._clearEditableState()
                        };
                    if (s) {
                        for (l = Y(n.thead), o = 0, a = l.length; o < a; o++) e = i[o], e.sortable !== !1 && !e.command && e.field && (r = l.eq(o), t = r.data("kendoColumnSorter"), t && t.destroy(), r.attr("data-" + Ee.ns + "field", e.field).kendoColumnSorter(Oe({}, s, e.sortable, {
                            dataSource: n.dataSource,
                            aria: !0,
                            filter: ":not(.k-column-active)",
                            change: d
                        })));
                        l = null
                    }
                },
                _columns: function(t) {
                    var r, l, o, a = this,
                        n = a.table,
                        i = n.find("col"),
                        s = a.element.find("thead tr"),
                        c = a.options.dataSource;
                    if (t = t.length ? t : Ne(n.find("th"), function(t, r) {
                            t = e(t);
                            var l = t.attr(Ee.attr("sortable")),
                                o = t.attr(Ee.attr("filterable")),
                                a = t.attr(Ee.attr("type")),
                                n = t.attr(Ee.attr("groupable")),
                                s = t.attr(Ee.attr("field")),
                                d = t.attr(Ee.attr("title")),
                                c = t.attr(Ee.attr("menu"));
                            return s || (s = t.text().replace(/\s|[^A-z0-9]/g, "")), {
                                field: s,
                                type: a,
                                title: d,
                                sortable: "false" !== l,
                                filterable: "false" !== o,
                                groupable: "false" !== n,
                                menu: c,
                                template: t.attr(Ee.attr("template")),
                                width: i.eq(r).css("width")
                            }
                        }), r = !(a.table.find("tbody tr").length > 0 && (!c || !c.transport)), a.options.scrollable) {
                        if (o = t, l = N(t), t = G(t), l.length > 0 && 0 === t.length) throw Error("There should be at least one non locked column");
                        oe(a.element.find("tr:has(th):first"), o), t = l.concat(t)
                    }
                    s.length && t.length && a._updateColumnIDs(t, s.first()), a.columns = d(t, r), e.grep(Q(a.columns), function(e) {
                        return e.selectable
                    }).length && (a._selectedIds = {}, a._checkBoxSelection = !0, a.wrapper.on(er + pt, "tbody > tr " + Bt, $e(a._checkboxClick, a)), a.wrapper.on(er + pt, "thead > tr " + Bt, $e(a._headerCheckboxClick, a)))
                },
                _updateColumnIDs: function(e, t) {
                    var r, l, o;
                    if (e.length) {
                        for (r = t.find("th"), o = 0; o < e.length; o++) l = r.eq(o).attr("id"), l && (e[o].headerAttributes = Oe(e[o].headerAttributes, {
                            id: l
                        }));
                        this._updateColumnIDs($(e), t.next())
                    }
                },
                _headerCheckboxClick: function(t) {
                    var r = this,
                        l = e(t.target),
                        o = l.prop("checked"),
                        a = l.closest(".k-grid.k-widget").getKendoGrid();
                    r === a && (o ? r.select(a.items()) : r.clearSelection())
                },
                _checkboxClick: function(t) {
                    var r = this,
                        l = e(t.target).closest("tr"),
                        o = !l.hasClass(Vt);
                    r === l.closest(".k-grid.k-widget").getKendoGrid() && (o ? r.select(l) : r._deselectCheckRows(l))
                },
                _groups: function() {
                    var e = this.dataSource.group();
                    return e ? e.length : 0
                },
                _tmpl: function(e, r, a, n) {
                    var i, s, d, c, u, p = this,
                        h = Oe({}, Ee.Template, p.options.templateSettings),
                        f = h.paramName,
                        g = r.length,
                        m = {
                            storage: {},
                            count: 0
                        },
                        k = p._hasDetails(),
                        b = [],
                        _ = p._groups(),
                        v = p.options.navigatable,
                        w = Ee.attr("field"),
                        C = "";
                    if (!e) {
                        for (e = "<tr", a && b.push("k-alt"), k && b.push("k-master-row"), b.length && (e += ' class="' + b.join(" ") + '"'), g && (e += " " + Ee.attr("uid") + '="#=' + Ee.expr("uid", h.paramName) + '#"'), e += " role='row'>", _ > 0 && !n && (e += l(_)), k && (e += '<td class="k-hierarchy-cell" aria-expanded="false"><a class="k-icon k-i-expand" href="\\#" ' + Tr + '="' + Sr + '" tabindex="-1"></a></td>'), i = 0; i < g; i++) d = r[i], s = d.template, c = typeof s, u = d.field, p._editMode() === cr && u && (d.attributes = d.attributes || {}, p.virtualScroll && (d.attributes[w] = u), C = p._dirtyCellTemplate(u, f), d.attributes["class"] = d.attributes["class"] || "", d.attributes["class"].indexOf(C) < 0 && (d.attributes["class"] += C)), d.colSpan && d.colSpan > 1 && d.attributes && d.attributes.style && (d.attributes.style = d.attributes.style.replace("display:none", ""), d.colSpan--), d.command && (d.attributes = d.attributes || {}, t !== d.attributes["class"] ? d.attributes["class"] += " k-command-cell" : d.attributes["class"] = "k-command-cell"), e += "<td" + o(d.attributes), v && (e += " aria-describedby='" + d.headerAttributes.id + "'"), d.colSpan && (d.colSpan > 1 && (e += " " + Ee.attr("virtual")), e += " colSpan='" + d.colSpan + "'"), e += " role='gridcell'>", e += p._cellTmpl(d, m), e += "</td>";
                        e += "</tr>"
                    }
                    return e = Ee.template(e, h), m.count > 0 ? $e(e, m.storage) : e
                },
                _dirtyCellTemplate: function(e, t) {
                    var r;
                    return e && t ? (r = "[" === e.charAt(0) ? Ee.expr(e, t + ".dirtyFields") : t + ".dirtyFields['" + e + "']", "#= " + t + " && " + t + ".dirty && " + t + ".dirtyFields && " + r + " ? ' k-dirty-cell' : '' #") : ""
                },
                _headerCellText: function(e) {
                    var t = this,
                        r = Oe({}, Ee.Template, t.options.templateSettings),
                        l = e.headerTemplate,
                        o = typeof l,
                        a = e.title || e.field || "";
                    return o === or ? a = Ee.template(l, r)({}) : o === ar && (a = l), a
                },
                _cellTmpl: function(e, t) {
                    var r, l, o = this,
                        a = Oe({}, Ee.Template, o.options.templateSettings),
                        n = e.template,
                        i = a.paramName,
                        s = e.field,
                        d = "",
                        c = e.format,
                        u = typeof n,
                        p = e.values;
                    if (e.command) {
                        if (Ke(e.command)) {
                            for (r = 0, l = e.command.length; r < l; r++) d += e.command[r].visible ? Ee.format("#= {0}(data)? '{1}':'' #", e.command[r].visible, o._createButton(e.command[r]).replace(Hr, "\\#").replace(/'/gi, "\\'")) : o._createButton(e.command[r]).replace(Hr, "\\#");
                            return d
                        }
                        return o._createButton(e.command).replace(Hr, "\\#")
                    }
                    return e.selectable ? Lr : (d += o._dirtyIndicatorTemplate(s, i), u === or ? (t.storage["tmpl" + t.count] = n, d += "#=this.tmpl" + t.count + "(" + i + ")#", t.count++) : u === ar ? d += n : p && p.length && Be(p[0]) && "value" in p[0] && s ? (d += "#var v =" + Ee.stringify(ae(p)).replace(Hr, "\\#") + "#", d += "#var f = v[", a.useWithBlock || (d += i + "."), d += s + "]#", d += "${f != null ? f : ''}") : (d += e.encoded ? "#:" : "#=", c && (d += 'kendo.format("' + c.replace(xr, "\\$1") + '",'), s ? (s = Ee.expr(s, i), d += s + "==null?'':" + s) : d += "''", c && (d += ")"), d += "#"), d)
                },
                _dirtyIndicatorTemplate: function(e, t) {
                    var r;
                    return e && t ? (r = "[" === e.charAt(0) ? Ee.expr(e, t + ".dirtyFields") : t + ".dirtyFields['" + e + "']", "#= " + t + " && " + t + ".dirty && " + t + ".dirtyFields && " + r + " ? '<span class=\"k-dirty\"></span>' : '' #") : ""
                },
                _virtualCols: function(t) {
                    var r, l, o, a = this,
                        n = e.map(t, function(e) {
                            return e.hidden ? 0 : parseInt(e.width, 10)
                        }),
                        i = a.virtualScrollable ? a.content.find(">.k-virtual-scrollable-wrap").scrollLeft() : a.content.scrollLeft(),
                        s = parseInt(a.options.width || a.wrapper.width(), 10),
                        d = W(t),
                        c = [],
                        u = 0,
                        p = 0,
                        h = 0,
                        f = 0,
                        g = 0;
                    for (f = 0; f < t.length; f++) {
                        if (r = f < n.length - 1 ? n[f + 1] : 0, !(g + n[f] + 2 * r < i)) {
                            u = 1 + h;
                            break
                        }
                        n[f] && h++, g += n[f]
                    }
                    for (h = 0, g = 0, l = t.length - 1; l >= 0; l--) {
                        if (!(g + 3 * n[l] < d - s - i)) {
                            for (p = 1 + h, o = f; o <= l; o++) t[o].locked || (c.push(t[o]), t[o].colSpan && delete t[o].colSpan);
                            c[0].colSpan = u, c[c.length - 1].colSpan = p;
                            break
                        }
                        n[l] && h++, g += n[l]
                    }
                    return a.virtualCols = c, c
                },
                _templates: function() {
                    var t = this,
                        r = t.options,
                        l = t.dataSource,
                        o = l.group(),
                        a = t.footer || t.wrapper.find(".k-grid-footer"),
                        n = l.aggregate(),
                        i = Q(t.columns),
                        s = Q(N(t.columns)),
                        d = r.scrollable ? Q(G(t.columns)) : i,
                        c = (t.virtualScroll || {}).columns ? t._virtualCols(d) : d,
                        u = Ge(v(s), function(e, t) {
                            return e.groupHeaderColumnTemplate && 0 !== t
                        }),
                        p = Ge(v(c), function(e) {
                            return e.groupHeaderColumnTemplate
                        });
                    if (r.scrollable && s.length) {
                        if (r.rowTemplate || r.altRowTemplate) throw Error("Having both row template and locked columns is not supported");
                        t.rowTemplate = t._tmpl(r.rowTemplate, c, !1, !0), t.altRowTemplate = t._tmpl(r.altRowTemplate || r.rowTemplate, c, !0, !0), t.lockedRowTemplate = t._tmpl(r.rowTemplate, s), t.lockedAltRowTemplate = t._tmpl(r.altRowTemplate || r.rowTemplate, s, !0)
                    } else t.rowTemplate = t._tmpl(r.rowTemplate, c), t.altRowTemplate = t._tmpl(r.altRowTemplate || r.rowTemplate, c, !0);
                    t._hasDetails() && (t.detailTemplate = t._detailTmpl(r.detailTemplate || "")), (t._group && !Je(n) || !Je(n) && !a.length || Ge(i, function(e) {
                        return e.footerTemplate
                    }).length) && (t.footerTemplate = t._footerTmpl(i, n, "footerTemplate", "k-footer-template")), o && Ge(i, function(e) {
                        return e.groupFooterTemplate
                    }).length && (n = e.map(o, function(e) {
                        return e.aggregates
                    }), t.groupFooterTemplate = t._footerTmpl(c, n, "groupFooterTemplate", "k-group-footer", s.length), r.scrollable && s.length && (t.lockedGroupFooterTemplate = t._footerTmpl(s, n, "groupFooterTemplate", "k-group-footer"))), o && (u.length || p.length) ? (n = e.map(o, function(e) {
                        return e.aggregates
                    }), t.groupHeaderColumnTemplate = t._groupHeaderTmpl(v(c), n, "groupHeaderColumnTemplate", "k-grouping-row", s.length, p), r.scrollable && s.length && (t.lockedGroupHeaderColumnTemplate = t._groupHeaderTmpl(v(s), n, "groupHeaderColumnTemplate", "k-grouping-row", 0, u))) : (t.groupHeaderColumnTemplate = null, t.lockedGroupHeaderColumnTemplate = null), t.options.noRecords && (t.noRecordsTemplate = t._noRecordsTmpl())
                },
                _noRecordsTmpl: function() {
                    var t, r, l, o = '<div class="{0}">{1}</div>',
                        a = '<div class="k-grid-norecords-template"{1}>{0}</div>',
                        n = this.options.scrollable && !this.wrapper[0].style.height ? ' style="margin:0 auto;position:static;"' : "",
                        i = {
                            storage: {},
                            count: 0
                        },
                        s = e.extend({}, Ee.Template, this.options.templateSettings),
                        d = s.paramName,
                        c = "";
                    return t = this.options.noRecords.template ? this.options.noRecords.template : Ee.format(a, this.options.messages.noRecords, n), r = typeof t, "function" === r ? (i.storage["tmpl" + i.count] = t, c += "#=this.tmpl" + i.count + "(" + d + ")#", i.count++) : "string" === r && (c += t), l = Ee.template(Ee.format(o, Ot, c), s), i.count > 0 && (l = e.proxy(l, i.storage)), l
                },
                _footerTmpl: function(e, t, r, a, n) {
                    var i, s, d, c, u, p = this,
                        h = Oe({}, Ee.Template, p.options.templateSettings),
                        f = h.paramName,
                        g = "",
                        m = {},
                        k = 0,
                        b = {},
                        _ = p._groups(),
                        v = p.dataSource._emptyAggregates(t);
                    for (g += '<tr class="' + a + '">', _ > 0 && !n && (g += l(_)), p._hasDetails() && (g += '<td class="k-hierarchy-cell">&nbsp;</td>'), i = 0, s = e.length; i < s; i++) u = e[i], d = u[r], c = typeof d, g += "<td" + o(u.footerAttributes) + ">", d ? (c !== or && (b = v[u.field] ? Oe({}, h, {
                        paramName: f + "['" + u.field + "']"
                    }) : {}, d = Ee.template(d, b)), m["tmpl" + k] = d, g += "#=this.tmpl" + k + "(" + f + ")#", k++) : g += "&nbsp;", g += "</td>";
                    return g += "</tr>", g = Ee.template(g, h), k > 0 ? $e(g, m) : g
                },
                _groupHeaderTmpl: function(e, r, l, o, a, n) {
                    var i, s, d, c, u, p = this,
                        h = Oe({}, Ee.Template, p.options.templateSettings),
                        f = h.paramName,
                        g = "",
                        m = {},
                        k = 0,
                        b = {},
                        _ = p.dataSource._emptyAggregates(r),
                        v = n.length ? je(n[0], e) : -1;
                    if (g += '<tr role="row" class="' + o + '">', a || (g += '# for (var i = 0; i < data.groupCells; i++) { #<td class="k-group-cell">&nbsp;</td># } #'), p._hasDetails() && (g += '<td class="k-hierarchy-cell">&nbsp;</td>'), v < 0) return g += a ? "" : He(e.length), t;
                    if (v < hr && n.length <= 1 && !a) return g += a ? "" : He(e.length), Ee.template(g, h);
                    for (v < hr ? (v = a ? 0 : 1, g += a ? "" : He(v)) : g += a ? Re(v) : He(v), i = v, s = e.length; i < s; i++) u = e[i], d = u[l], c = typeof d, g += "<td>", d ? (c !== or && (b = _[u.field] ? Oe({}, h, {
                        paramName: f + "['" + u.field + "']"
                    }) : {}, d = Ee.template(d, b)), m["tmpl" + k] = d, g += "#=this.tmpl" + k + "(" + f + ")#", k++) : g += "&nbsp;", g += "</td>";
                    return g += "</tr>", g = Ee.template(g, h), k > 0 ? $e(g, m) : g
                },
                _detailTmpl: function(e) {
                    var t = this,
                        r = "",
                        o = Oe({}, Ee.Template, t.options.templateSettings),
                        a = o.paramName,
                        n = {},
                        i = 0,
                        s = t._groups(),
                        d = v(Q(t.columns)).length,
                        c = typeof e;
                    return r += '<tr class="k-detail-row">', s > 0 && (r += l(s)), r += '<td class="k-hierarchy-cell"></td><td class="k-detail-cell"' + (d ? ' colspan="' + d + '"' : "") + ">", c === or ? (n["tmpl" + i] = e, r += "#=this.tmpl" + i + "(" + a + ")#", i++) : r += e, r += "</td></tr>", r = Ee.template(r, o), i > 0 ? $e(r, n) : r
                },
                _hasDetails: function() {
                    var e = this;
                    return null !== e.options.detailTemplate || (e._events[_t] || []).length
                },
                _hasFilterRow: function() {
                    var t = this.options.filterable,
                        r = t && typeof t.mode == ar && t.mode.indexOf("row") != -1,
                        l = this.columns,
                        o = e.grep(l, function(e) {
                            return e.filterable === !1
                        });
                    return l.length && o.length == l.length && (r = !1), r
                },
                _details: function() {
                    var t = this;
                    if (t.options.scrollable && t._hasDetails() && N(t.columns).length) throw Error("Having both detail template and locked columns is not supported");
                    t.table.on(er + pt, ".k-hierarchy-cell .k-i-expand, .k-hierarchy-cell .k-i-collapse", function(r) {
                        var l, o, a = e(this),
                            n = a.closest("td.k-hierarchy-cell"),
                            i = a.hasClass("k-i-expand"),
                            s = a.closest("tr.k-master-row"),
                            d = t.detailTemplate,
                            c = t._hasDetails(),
                            u = i ? yr : Sr,
                            p = !!i;
                        return a.toggleClass("k-i-expand", !i).toggleClass("k-i-collapse", i).attr(Tr, u), n.attr("aria-expanded", p), l = s.next(), c && !l.hasClass("k-detail-row") && (o = t.dataItem(s), l = e(d(o)).addClass(s.hasClass("k-alt") ? "k-alt" : "").insertAfter(s), t.angular("compile", function() {
                            return {
                                elements: l.get(),
                                data: [{
                                    dataItem: o
                                }]
                            }
                        }), t.trigger(_t, {
                            masterRow: s,
                            detailRow: l,
                            data: o,
                            detailCell: l.find(".k-detail-cell")
                        })), t.trigger(i ? zt : Et, {
                            masterRow: s,
                            detailRow: l
                        }), l.toggle(i), r.preventDefault(), !1
                    })
                },
                dataItem: function(t) {
                    if (t = e(t)[0], !t) return null;
                    var r, l, o = this.tbody.children(),
                        a = /k-grouping-row|k-detail-row|k-group-footer/,
                        n = t.sectionRowIndex;
                    for (l = n, r = 0; r < n; r++) a.test(o[r].className) && l--;
                    return this._data[l]
                },
                expandRow: function(t) {
                    e(t).find("> td .k-i-expand").click()
                },
                collapseRow: function(t) {
                    e(t).find("> td .k-i-collapse").click()
                },
                _createHeaderCells: function(e, r) {
                    var l, a, n, i, s, d, c, u = this,
                        p = "",
                        h = u.options.messages,
                        f = Q(u.columns),
                        g = u.dataSource.group();
                    for (l = 0, i = e.length; l < i; l++) a = e[l].column || e[l], n = u._headerCellText(a), d = "", c = je(a, f), a.selectable ? (p += "<th scope='col'" + o(a.headerAttributes), r && !e[l].colSpan && (p += " rowspan='" + r + "'"), c > -1 && (p += Ee.attr("index") + "='" + c + "'"), n = a.headerTemplate ? n : Ee.template(Mr)({}), p += ">" + n + "</th>") : a.command ? (p += "<th scope='col'" + o(a.headerAttributes), r && !e[l].colSpan && (p += " rowspan='" + r + "'"), c > -1 && (p += Ee.attr("index") + "='" + c + "'"), p += ">" + n + "</th>") : (a.field && (d = Ee.attr("field") + "='" + a.field + "' "), p += "<th scope='col' role='columnheader' " + d, p += " aria-haspopup='true'", r && !e[l].colSpan && (p += " rowspan='" + r + "'"), e[l].colSpan > 1 ? (p += 'colspan="' + (e[l].colSpan - A(a.columns)) + '" ', p += Ee.attr("colspan") + "='" + e[l].colSpan + "'") : 1 === e[l].colSpan && (p += Ee.attr("colspan") + "='" + e[l].colSpan + "'"), a.title && (s = a.title.replace('"', "&quot;").replace(/'/g, "'"), p += Ee.attr("title") + '="' + s + '" '), a.groupable !== t && (p += Ee.attr("groupable") + "='" + a.groupable + "' "), be(u, a) && (p += "aria-label='" + (s || a.field) + " ", p += _e(g, a.field) ? h.ungroupHeader : h.groupHeader, p += "' "), a.aggregates && a.aggregates.length && (p += Ee.attr("aggregates") + "='" + a.aggregates + "'"),
                        c > -1 && (p += Ee.attr("index") + "='" + c + "'"), p += o(a.headerAttributes), p += ">" + n + "</th>");
                    return p
                },
                _appendLockedColumnContent: function() {
                    var t, r, l, o, a, n = this.columns,
                        i = this.table.find("colgroup"),
                        s = i.find("col:not(.k-group-col,.k-hierarchy-col)"),
                        d = e(),
                        c = 0,
                        u = 0;
                    for (t = 0, r = n.length; t < r; t++)
                        if (n[t].locked)
                            if (_(n[t])) {
                                for (o = 1, n[t].columns && (o = Q(n[t].columns).length - A(n[t].columns)), o = o || 1, a = 0; a < o; a++) d = d.add(s.eq(t + u + a - c));
                                u += o - 1
                            } else c++;
                    l = e('<div class="k-grid-content-locked"><table' + (Ar ? ' cellspacing="0"' : "") + "><colgroup/><tbody></tbody></table></div>"), i.detach(), l.find("colgroup").append(d), i.insertBefore(this.table.find("tbody")), this.lockedContent = l.insertBefore(this.content), this.lockedTable = l.children("table")
                },
                _appendLockedColumnFooter: function() {
                    var t, r, l = this,
                        o = l.footer,
                        a = o.find(".k-footer-template>td"),
                        n = o.find(".k-grid-footer-wrap>table>colgroup>col"),
                        i = e('<div class="k-grid-footer-locked"><table><colgroup /><tbody><tr class="k-footer-template"></tr></tbody></table></div>'),
                        s = l._groups(),
                        d = e(),
                        c = e();
                    for (d = d.add(a.filter(".k-group-cell")), t = 0, r = Q(N(l.columns)).length; t < r; t++) d = d.add(a.eq(t + s));
                    for (c = c.add(n.filter(".k-group-col")), t = 0, r = v(Q(j(l.columns))).length; t < r; t++) c = c.add(n.eq(t + s));
                    d.appendTo(i.find("tr")), c.appendTo(i.find("colgroup")), l.lockedFooter = i.prependTo(o)
                },
                _appendLockedColumnHeader: function(t) {
                    var r, l, o, a, n, i, s, d, c, u, p, h = this,
                        f = this.columns,
                        g = [],
                        m = 0,
                        k = e(),
                        b = h._hasFilterRow(),
                        v = 0,
                        w = e(),
                        C = 0,
                        S = e(),
                        T = h.thead.prev().find("col:not(.k-group-col,.k-hierarchy-col)"),
                        x = h.thead.find("tr:first .k-header:not(.k-group-cell,.k-hierarchy-cell)"),
                        H = h.thead.find(".k-filter-row").find("th:not(.k-group-cell,.k-hierarchy-cell)"),
                        R = 0;
                    for (r = 0, o = f.length; r < o; r++) {
                        if (f[r].locked) {
                            if (s = x.eq(r), C = Q(f[r].columns || []).length, _(f[r])) {
                                for (d = null, f[r].columns && (d = C - A(f[r].columns)), d = d || 1, c = 0; c < d; c++) k = k.add(T.eq(r + R + c - m));
                                R += d - 1
                            }
                            for (O([f[r]], Z(s), g, 0, 0), C = C || 1, u = 0; u < C; u++) w = w.add(H.eq(v + u));
                            v += C
                        }
                        f[r].columns && (m += A(f[r].columns)), _(f[r]) || m++
                    }
                    if (g.length) {
                        for (l = '<div class="k-grid-header-locked" style="width:1px"><table' + (Ar ? ' cellspacing="0"' : "") + "><colgroup/><thead>", l += Array(g.length + 1).join("<tr></tr>"), l += (b ? '<tr class="k-filter-row" />' : "") + "</thead></table></div>", i = e(l), T = i.find("colgroup"), T.append(h.thead.prev().find("col.k-group-col").add(k)), a = i.find("thead tr:not(.k-filter-row)"), r = 0, o = g.length; r < o; r++) S = y(g[r]), a.eq(r).append(h.thead.find("tr:eq(" + r + ") .k-group-cell").add(S));
                        return p = B(this.thead), g.length < p && V(i, p - g.length), n = i.find(".k-filter-row"), n.append(h.thead.find(".k-filter-row .k-group-cell").add(w)), this.lockedHeader = i.prependTo(t), this.thead.find(".k-group-cell").remove(), !0
                    }
                    return !1
                },
                _removeLockedContainers: function() {
                    var e = this.lockedHeader.add(this.lockedContent).add(this.lockedFooter);
                    Ee.destroy(e), e.off(pt).remove(), this.lockedHeader = this.lockedContent = this.lockedFooter = null, this.selectable = null
                },
                _thead: function() {
                    var t, r, l, o, a, n, i, s, d, c = this,
                        u = c.columns,
                        p = c._hasDetails() && u.length,
                        h = c._hasFilterRow(),
                        f = "",
                        g = c.table.find(">thead"),
                        m = c.element.find("thead:first").length > 0,
                        k = c.options.messages.expandCollapseColumnHeader;
                    if (g.length || (g = e("<thead/>").insertBefore(c.tbody)), c.lockedHeader && c.thead ? (r = c.thead.find("tr:has(th):not(.k-filter-row)").html(""), r.remove(), r = e(), c._removeLockedContainers()) : r = c.element.find(m ? "thead:first tr:has(th):not(.k-filter-row)" : "tr:has(th):first"), r.length) {
                        for (t = 0; t < u.length; t++) o = je(u[t], Q(u)), a = Y(r.parent()).filter("th:not(.k-group-cell):not(.k-hierarchy-cell)").eq(o), u[t].hidden && o >= 0 && (a[0].style.display = "none");
                        c._updateHeadersAttr($(u))
                    } else if (r = g.children().first(), !r.length) {
                        for (l = [{
                                rowSpan: 1,
                                cells: [],
                                index: 0
                            }], c._prepareColumns(l, u), t = 0; t < l.length; t++) f += "<tr>", p && (f += '<th class="k-hierarchy-cell" scope="col">' + k + "</th>"), f += c._createHeaderCells(l[t].cells, l[t].rowSpan), f += "</tr>";
                        r = e(f)
                    }
                    h && (n = e("<tr/>"), n.addClass("k-filter-row"), (p || r.find(".k-hierarchy-cell").length) && n.prepend('<th class="k-hierarchy-cell" scope="col">&nbsp;</th>'), i = (c.thead || g).find(".k-filter-row"), i.length && (Ee.destroy(i), i.remove()), g.append(n)), r.children().length ? p && !r.find(".k-hierarchy-cell")[0] && r.prepend('<th class="k-hierarchy-cell" scope="col">' + (k ? k : "&nbsp;") + "</th>") : (f = "", p && (f += '<th class="k-hierarchy-cell" scope="col">&nbsp;</th>'), f += c._createHeaderCells(u), r.html(f)), r.attr("role", "row").find("th").addClass("k-header"), c.options.scrollable || g.addClass("k-grid-header"), r.find("script").remove().end().prependTo(g), c.thead && c._destroyColumnAttachments(), this.angular("cleanup", function() {
                        return {
                            elements: g.find("th" + nt).get()
                        }
                    }), this.angular("compile", function() {
                        return {
                            elements: g.find(ut).get(),
                            data: Ne(u, function(e) {
                                return {
                                    column: e
                                }
                            })
                        }
                    }), c.thead = g.attr("role", "rowgroup"), c._sortable(), c._filterable(), c._filterRow(), c._scrollable(), c._columnMenu(), d = this.options.scrollable && N(this.columns).length, d && (s = c._appendLockedColumnHeader(c.thead.closest(".k-grid-header")), c._appendLockedColumnContent(), c.lockedContent.bind("DOMMouseScroll" + pt + " mousewheel" + pt, $e(c._wheelScroll, c)), c._updateLockedCols()), c._updateCols(), c._updateColumnCellIndex(), c._updateFirstColumnClass(), c._resizable(), c._draggable(), c._reorderable(), c._updateHeader(c._groups()), d && (s && c._syncLockedHeaderHeight(), c._applyLockedContainersWidth()), c.groupable && c._attachGroupable()
                },
                _retrieveFirstColumn: function(t, r) {
                    var l, o = e();
                    if (r.length && t[0]) {
                        for (l = t[0]; l.columns && l.columns.length;) l = l.columns[0], r = r.filter(":not(:first())");
                        o = o.add(r)
                    }
                    return o
                },
                _updateFirstColumnClass: function() {
                    var t, r, l = this,
                        o = l.columns || [],
                        a = l._hasDetails() && o.length;
                    a || l._groups() || (t = l.thead.find(">tr:not(.k-filter-row):not(:first)"), o = G(o), r = l._retrieveFirstColumn(o, t), l._isLocked() && (t = l.lockedHeader.find("thead>tr:not(.k-filter-row):not(:first)"), o = N(l.columns), r = r.add(l._retrieveFirstColumn(o, t))), r.each(function() {
                        var t = e(this).find("th");
                        t.removeClass("k-first"), t.eq(0).addClass("k-first")
                    }))
                },
                _prepareColumns: function(e, t, r, l) {
                    var o, a, n = l || e[e.length - 1],
                        i = e[n.index + 1],
                        s = 0;
                    for (o = 0; o < t.length; o++) a = {
                        column: t[o],
                        colSpan: 0
                    }, n.cells.push(a), t[o].columns && t[o].columns.length && (i || (i = {
                        rowSpan: 0,
                        cells: [],
                        index: e.length
                    }, e.push(i)), a.colSpan = t[o].columns.length, this._prepareColumns(e, t[o].columns, a, i), s += a.colSpan - 1, n.rowSpan = e.length - n.index);
                    r && (r.colSpan += s)
                },
                _wheelScroll: function(e) {
                    var t, r, l;
                    e.ctrlKey || (t = this.content, this.virtualScroll.rows && (t = this.virtualScrollable.verticalScrollbar), r = t.scrollTop(), l = Ee.wheelDeltaY(e), l && (t[0].scrollHeight > t[0].clientHeight && (t[0].scrollTop < t[0].scrollHeight - t[0].clientHeight && l < 0 || t[0].scrollTop > 0 && l > 0) && e.preventDefault(), t.scrollTop(r + -l)))
                },
                _isLocked: function() {
                    return null != this.lockedHeader
                },
                _updateHeaderCols: function() {
                    var e = this.thead.parent().add(this.table);
                    this._isLocked() ? le(e, U(K(this.columns)), this._hasDetails(), 0) : le(e, U(v(this.columns)), this._hasDetails(), 0)
                },
                _updateColumnSorters: function() {
                    var e, t, r, l, o, a = this,
                        n = Y(a.thead),
                        i = Q(a.columns);
                    if (a.options.sortable)
                        for (l = 0, o = n.length; l < o; l++) e = i[l], e.sortable !== !1 && !e.command && e.field && (t = n.eq(l), r = t.data("kendoColumnSorter"), r && r.refresh())
                },
                _updateHeadersAttr: function(e) {
                    var t, r, l;
                    if (e.length) {
                        for (t = this, r = 0; r < e.length; r++) e[r].headerAttributes && (l = t.element.find("[id='" + e[r].headerAttributes.id + "']"), l.attr("headers", e[r].headerAttributes.headers));
                        t._updateHeadersAttr($(e))
                    }
                },
                _updateCols: function(e) {
                    e = e || this.thead.parent().add(this.table), this._appendCols(e, this._isLocked())
                },
                _updateLockedCols: function(e) {
                    this._isLocked() && (e = e || this.lockedHeader.find("table").add(this.lockedTable), le(e, U(j(this.columns)), this._hasDetails(), this._groups()))
                },
                _appendCols: function(e, t) {
                    t ? le(e, U(K(this.columns)), this._hasDetails(), 0) : le(e, U(v(this.columns)), this._hasDetails(), this._groups())
                },
                _autoColumns: function(e) {
                    if (e && e.toJSON) {
                        var t, r, l = this;
                        e = e.toJSON(), r = !(l.table.find("tbody tr").length > 0 && (!l.dataSource || !l.dataSource.transport));
                        for (t in e) l.columns.push({
                            field: t,
                            encoded: r,
                            headerAttributes: {
                                id: Ee.guid()
                            }
                        });
                        l._thead(), l._templates()
                    }
                },
                _rowsHtml: function(e, t) {
                    var r, l, o = this,
                        a = "",
                        n = t.rowTemplate,
                        i = t.altRowTemplate;
                    for (r = 0, l = e.length; r < l; r++) o._skipRerenderItemsCount > 0 ? o._skipRerenderItemsCount-- : a += r % 2 ? i(e[r]) : n(e[r]), o._data.push(e[r]);
                    return a
                },
                _groupData: function(e, t, r) {
                    var l, o = this,
                        a = o._groupAggregatesDefaultObject || {},
                        n = e.items,
                        i = Oe({}, a, e.aggregates),
                        s = Oe({}, {
                            field: e.field,
                            value: e.value,
                            items: n,
                            aggregates: i
                        }, e.aggregates[r ? r.field : e.field]),
                        d = {};
                    if (!t)
                        for (l in i) d[l] = Oe({}, i[l], {
                            group: {
                                field: e.field,
                                value: e.value,
                                items: n
                            }
                        });
                    return Oe({}, d, s)
                },
                _groupRowHtml: function(e, t, r, l, o, a, n) {
                    var i, s, d, c = this,
                        u = "",
                        p = e.field,
                        h = Ge(Q(c.columns), function(e) {
                            return e.field == p
                        })[0] || {},
                        f = v(c.columns)[0],
                        g = f ? f.groupHeaderColumnTemplate : null,
                        m = h.groupHeaderTemplate ? h.groupHeaderTemplate : g,
                        k = (h.title || p) + ": " + ne(e.value, h.format, h.values, h.encoded),
                        b = e.items,
                        _ = c._groups(),
                        w = o.groupFooterTemplate,
                        C = o.groupHeaderColumnTemplate;
                    if ((o.groupFooterTemplate || o.groupHeaderColumnTemplate || h.groupHeaderTemplate) && (d = c._groupData(e, !1, !(h.groupHeaderTemplate || !v(c.columns)[0].groupHeaderColumnTemplate) && v(c.columns)[0])), m && !a && (k = typeof m === or ? m(d) : Ee.template(m)(d)), c._skipRerenderItemsCount ? l(t, r, k) : u += C ? C(Oe({}, d, {
                            groupCells: r,
                            colspan: _ - r,
                            text: k
                        })) : l(t, r, k), e.hasSubgroups)
                        for (i = 0, s = b.length; i < s; i++) u += c._groupRowHtml(b[i], a ? t : t - 1, r + 1, l, o, a, n && i === b.length - 1);
                    else u += c._rowsHtml(b, o);
                    return w && (n ? je(e.value, c._skippedGroups) || c._skippedGroups.push(e.value) : (c._skippedGroups.length && c._skippedGroups[0] === e.value && c._skippedGroups.shift(), c._skipRerenderItemsCount || (u += w(d)))), u
                },
                collapseGroup: function(t) {
                    var r, l, o, a, n, i, s = this,
                        d = t,
                        c = this.options.groupable,
                        u = c.showFooter,
                        p = u ? 0 : 1,
                        h = e();
                    for (t = e(t), this._isLocked() && (t.closest("div").hasClass("k-grid-content-locked") ? h = this.tbody.children("tr:eq(" + t.index() + ")").nextAll("tr") : (h = t.nextAll("tr"), t = this.lockedTable.find(">tbody>tr:eq(" + t.index() + ")"))), r = t.find(".k-group-cell").length, t.find(".k-i-collapse").addClass("k-i-expand").removeClass("k-i-collapse"), t.find("td[aria-expanded='true']:first").attr("aria-expanded", !1).find("a").attr(Tr, Sr), t = t.nextAll("tr"), i = [], o = 0, a = t.length; o < a && (n = t.eq(o), l = n.find(".k-group-cell").length, n.hasClass("k-grouping-row") ? p++ : n.hasClass("k-group-footer") && p--, !(l <= r || n.hasClass("k-group-footer") && p < 0)); o++) h.length && i.push(h[o]), i.push(n[0]);
                    e(i).hide(), this.options.scrollable.endless && this.content && (clearTimeout(s._collapseGroupsTimeOut), s._collapseGroupsTimeOut = setTimeout(function() {
                        s.content.scroll(), s._groupToCollapse = d
                    }))
                },
                expandGroup: function(t) {
                    var r, l, o, a, n, i, s, d, c, u, p;
                    for (t = e(t), r = this, l = r.options.groupable.showFooter, i = e(), c = [], u = 1, this._isLocked() && (t.closest("div").hasClass("k-grid-content-locked") ? i = this.tbody.children("tr:eq(" + t.index() + ")").nextAll("tr") : (i = t.nextAll("tr"), t = this.lockedTable.find(">tbody>tr:eq(" + t.index() + ")"))), o = t.find(".k-group-cell").length, t.find(".k-i-expand").addClass("k-i-collapse").removeClass("k-i-expand"), t.find("td[aria-expanded='false']:first").attr("aria-expanded", !0).find("a").attr(Tr, yr), t = t.nextAll("tr"), s = 0, d = t.length; s < d && (a = t.eq(s), n = a.find(".k-group-cell").length, !(n <= o)); s++) n != o + 1 || a.hasClass("k-detail-row") || (a.show(), i.eq(s).show(), a.hasClass("k-grouping-row") && a.find(".k-icon").hasClass("k-i-collapse") && r.expandGroup(a), a.hasClass("k-master-row") && a.find(".k-icon").hasClass("k-i-collapse") && (a.next().show(), i.eq(s + 1).show())), a.hasClass("k-grouping-row") && (l && c.push(a.is(":visible")), u++), a.hasClass("k-group-footer") && (l && (p = c.pop(), a.toggle(p), i.eq(s).toggle(p)), 1 == u ? (a.show(), i.eq(s).show()) : u--);
                    0 === o && r.options.scrollable.endless && this._isLocked() && r._syncLockedContentHeight()
                },
                _updateHeader: function(t) {
                    var r = this,
                        l = r._isLocked() ? r.lockedHeader.find("thead") : r.thead,
                        o = l.find("tr.k-filter-row").find("th.k-group-cell").length,
                        a = l.find("tr:first").find("th.k-group-cell").length,
                        n = l.children("tr:not(:first)").filter(function() {
                            return !e(this).children(":visible").length
                        });
                    t > a ? (e(Array(t - a + 1).join('<th class="k-group-cell k-header" scope="col">' + r.options.messages.expandCollapseColumnHeader + "</th>")).prependTo(l.children("tr:not(.k-filter-row)")), r.element.is(":visible") && n.find("th.k-group-cell").hide()) : t < a && l.find("tr").each(function() {
                        e(this).find("th.k-group-cell").filter(":eq(" + t + "),:gt(" + t + ")").remove()
                    }), t > o && e(Array(t - o + 1).join('<th class="k-group-cell k-header" scope="col">&nbsp;</th>')).prependTo(l.find(".k-filter-row"))
                },
                _firstDataItem: function(e, t) {
                    return e && t && (e = e.hasSubgroups ? this._firstDataItem(e.items[0], t) : e.items[0]), e
                },
                _updateTablesWidth: function() {
                    var t, r = this;
                    r._isLocked() && (t = e(">.k-grid-footer>.k-grid-footer-wrap>table", r.wrapper).add(r.thead.parent()).add(r.table), r._footerWidth = he(t.eq(0)), t.width(r._footerWidth), t = e(">.k-grid-footer>.k-grid-footer-locked>table", r.wrapper).add(r.lockedHeader.find(">table")).add(r.lockedTable), t.width(he(t.eq(0))))
                },
                hideColumn: function(r) {
                    var l, o, a, n, s, d, c, u, p, h, f, g = this,
                        m = 0,
                        b = g.footer || g.wrapper.find(".k-grid-footer"),
                        w = g.virtualScroll || {},
                        C = g.columns,
                        y = g.lockedHeader ? Y(g.lockedHeader.find(">table>thead")).filter(k).length : 0,
                        S = Ge(Q(g.columns), function(e) {
                            return e.groupHeaderColumnTemplate
                        });
                    if (r = "number" == typeof r ? C[r] : Be(r) ? Ge(F(C), function(e) {
                            return e === r
                        })[0] : Ge(F(C), function(e) {
                            return e.field === r
                        })[0], r && _(r)) {
                        if (h = g._columnVisibilitySetter(r), r.columns && r.columns.length) {
                            for (d = L(r, C), h(r, !1), ie(i(e(">table>thead", g.lockedHeader), g.thead, ">tr:eq(" + d.row + ")>th"), d.cell, !1), a = 0; a < r.columns.length; a++) this.hideColumn(r.columns[a]);
                            return g.trigger(xt, {
                                column: r
                            }), t
                        }
                        if (p = je(r, v(Q(C))), h(r, !1), g._setParentsVisibility(r, !1), g._templates(), g._updateCols(), g._updateLockedCols(), f = g.thead, c = p, g.lockedHeader && y > p ? f = g.lockedHeader.find(">table>thead") : c -= y, l = Y(f).filter(k).eq(c), l[0].style.display = "none", ie(i(e(">table>thead", g.lockedHeader), g.thead, ">tr.k-filter-row>th"), p, !1), b[0] && (g._updateCols(b.find(">.k-grid-footer-wrap>table")), g._updateLockedCols(b.find(">.k-grid-footer-locked>table")), ie(b.find(".k-footer-template>td"), p, !1)), w.columns && !r.locked) return g._updateContentWidth(), g.trigger(xt, {
                            column: r
                        }), t;
                        if (g.lockedTable && y > p ? se(g.lockedTable.find(">tbody>tr"), p) : se(g.tbody.children(), p - y), g.lockedTable) g._updateTablesWidth(), g._applyLockedContainersWidth(), g._syncLockedContentHeight(), g._syncLockedHeaderHeight(), g._syncLockedFooterHeight();
                        else {
                            for (n = g.thead.prev().find("col"), a = 0, u = n.length; a < u; a += 1)
                                if (s = n[a].style.width, n[a].className.indexOf("k-hierarchy-col") > -1) m += qe(n[a]);
                                else if (n[a].className.indexOf("k-group-col") > -1) m += qe(n[a]);
                            else {
                                if (!s || s.indexOf("%") != -1) {
                                    m = 0;
                                    break
                                }
                                m += parseInt(s, 10)
                            }
                            o = e(">.k-grid-header table:first,>.k-grid-footer table:first", g.wrapper).add(g.table), g._footerWidth = null, m && (o.each(function() {
                                this.style.width = m + "px"
                            }), g._footerWidth = m, g._setContentWidth()), Fr.msie && 8 == Fr.version && (o.css("display", "inline-table"), setTimeout(function() {
                                o.css("display", "table")
                            }, 1))
                        }
                        g._updateFirstColumnClass(), S.length > 0 && g._renderGroupRows(), g.trigger(xt, {
                            column: r
                        })
                    }
                },
                _setParentsVisibility: function(t, r) {
                    var l, o, a, n, s, d = this,
                        c = d.columns,
                        p = [],
                        h = d._columnVisibilitySetter(t),
                        f = r ? function(e) {
                            return v(e.columns).length && e.hidden
                        } : function(e) {
                            return !v(e.columns).length && !e.hidden
                        };
                    if (u(t, c, p) && p.length)
                        for (l = p.length - 1; l >= 0; l--) o = p[l], a = I(o, c), n = i(e(">table>thead", this.lockedHeader), this.thead, ">tr:eq(" + a.row + ")>th:not(.k-group-cell):not(.k-hierarchy-cell)").eq(a.cell), f(o) && (h(o, r), n[0].style.display = r ? "" : "none"), n.filter("[" + Ee.attr("colspan") + "]").length && (s = parseInt(n.attr(Ee.attr("colspan")), 10), n[0].colSpan = s - A(o.columns) || 1)
                },
                _updateContentWidth: function() {
                    var e = this,
                        t = e.table.add(e.thead.parent());
                    t.css({
                        width: W(U(K(e.columns)))
                    }), e.refresh()
                },
                showColumn: function(r) {
                    var l, o, a, n, s, d, c, u, p, h, f, g, m, k, b = this,
                        v = b.columns,
                        w = b.virtualScroll || {},
                        C = b.footer || b.wrapper.find(".k-grid-footer"),
                        y = b.lockedHeader ? Y(b.lockedHeader.find(">table>thead")).length : 0,
                        S = Ge(Q(b.columns), function(e) {
                            return e.groupHeaderColumnTemplate
                        });
                    if ("number" == typeof r ? (h = r, r = v[r]) : Be(r) ? e.each(F(v), function(e, t) {
                            if (t === r) return r = t, h = e, !1
                        }) : e.each(F(v), function(e, t) {
                            if (t.field === r) return r = t, h = e, !1
                        }), r && !_(r)) {
                        if (m = b._columnVisibilitySetter(r), r.columns && r.columns.length) {
                            for (c = I(r, v), f = F(b.options.columns)[h], m(r, !0), ie(i(e(">table>thead", b.lockedHeader), b.thead, ">tr:eq(" + c.row + ")>th"), c.cell, !0), l = 0; l < r.columns.length; l++) f.columns[l].hidden || this.showColumn(r.columns[l]);
                            return b.trigger(Ht, {
                                column: r
                            }), t
                        }
                        if (g = je(r, Q(v)), m(r, !0), b._setParentsVisibility(r, !0), b._templates(), b._updateCols(), b._updateLockedCols(), k = b.thead, d = g, b.lockedHeader && y > g ? k = b.lockedHeader.find(">table>thead") : d -= y, a = Y(k).eq(d), a[0].style.display = "", ie(i(e(">table>thead", b.lockedHeader), b.thead, ">tr.k-filter-row>th"), g, !0), C[0] && (b._updateCols(C.find(">.k-grid-footer-wrap>table")), b._updateLockedCols(C.find(">.k-grid-footer-locked>table")), ie(C.find(".k-footer-template>td"), g, !0)), w.columns && !r.locked) return b._updateContentWidth(), b.trigger(Ht, {
                            column: r
                        }), t;
                        if (b.lockedTable && y > g ? ue(b.lockedTable.find(">tbody>tr"), g) : ue(b.tbody.children(), g - y), b.lockedTable) b._updateTablesWidth(), b._applyLockedContainersWidth(), b._syncLockedContentHeight(), b._syncLockedHeaderHeight();
                        else if (n = e(">.k-grid-header table:first,>.k-grid-footer table:first", b.wrapper).add(b.table), r.width) {
                            for (s = 0, p = b.thead.prev().find("col"), l = 0, o = p.length; l < o; l += 1)
                                if (u = p[l].style.width, p[l].className.indexOf("k-hierarchy-col") > -1) s += qe(p[l]);
                                else if (p[l].className.indexOf("k-group-col") > -1) s += qe(p[l]);
                            else {
                                if (u.indexOf("%") > -1) {
                                    s = 0;
                                    break
                                }
                                s += parseInt(u, 10)
                            }
                            b._footerWidth = null, s && (n.each(function() {
                                this.style.width = s + "px"
                            }), b._footerWidth = s, b._setContentWidth())
                        } else n.width("");
                        b._updateFirstColumnClass(), S.length > 0 && b._renderGroupRows(), b.trigger(Ht, {
                            column: r
                        })
                    }
                },
                _columnVisibilitySetter: function(e) {
                    var t = e || {};
                    return C(t.media) ? p : f
                },
                _progress: function(e) {
                    var t = this.element,
                        r = this.options.scrollable && this.options.scrollable.endless;
                    this._editContainer && "popup" === this._editMode() ? t = this._editContainer : this.lockedContent || r ? t = this.wrapper : this.element.is("table") ? t = this.element.parent() : this.content && this.content.length && (t = this.content), r && e ? Ee.ui.progress(t, e, {
                        height: this.content.height(),
                        top: this.content[0].offsetTop,
                        opacity: !0
                    }) : Ee.ui.progress(t, e)
                },
                _resize: function(e, t) {
                    this._syncLockedContentHeight(), this._syncLockedHeaderHeight(), this.content && (this._setContentWidth(), this._setContentHeight()), this.lockedTable && this._syncLockedScroll(), this.virtualScrollable && (t || this._rowHeight) && (t && (this._rowHeight = null), this.virtualScrollable.repaintScrollbar()), this.pager && this.pager.element && this.pager.resize(t)
                },
                _isActiveInTable: function() {
                    var t = Ae();
                    return !!t && (this.table[0] === t || e.contains(this.table[0], t) || this._isLocked() && (this.lockedTable[0] === t || e.contains(this.lockedTable[0], t)))
                },
                refresh: function(t) {
                    var r, l, o, a = this,
                        n = a.dataSource.view(),
                        i = a.options.navigatable,
                        s = a.virtualScroll || {},
                        d = e(a.current()),
                        c = !1,
                        u = (a.dataSource.group() || []).length,
                        p = u + U(v(a.columns)).length;
                    t && "itemchange" === t.action && (a.editable || a.options.scrollable.endless) && ("popup" != this._editMode() || "popup" === this._editMode() && !a._editableIsClosing) || (s.columns && a._templates(), t && "remove" === t.action && a.editable && a.editable.options.model && je(a.editable.options.model, t.items) > -1 && a.editable.options.model.unbind(Tt, a._modelChangeHandler), t = t || {}, a.trigger("dataBinding", {
                        action: t.action || "rebind",
                        index: t.index,
                        items: t.items
                    }) || (t.action === At && a._isVirtualEditable() && (a._destroyEditable(), a._clearEditableState()), a._angularItems("cleanup"), a._endlessFetchInProgress || (i && (a._isActiveInTable() || a._editContainer && a._editContainer.data("kendoWindow")) && (c = d.is("th"), r = c ? d.parent().children(":not(.k-group-cell)").index(d[0]) : Math.max(a.cellIndex(d), 0)), a._destroyEditable()), a.options.scrollable && a.options.scrollable.endless ? (clearTimeout(a._progressTimeOut), a._progressTimeOut = setTimeout(function() {
                        a._endlessFetchInProgress || a._progress(!1)
                    }, 100)) : a._progress(!1), a._hideResizeHandle(), a._data = [], a.columns.length || (a._autoColumns(a._firstDataItem(n[0], u)), p = u + a.columns.length), a._group = u > 0 || a._group, a._group && (a._templates(), a._updateCols(), a._updateLockedCols(), a._virtualColScroll || a._updateHeader(u), a._group = u > 0, a._groupRows = de(n)), a.content && (l = a.content.scrollLeft()), o = a._skipRerenderItemsCount, a._renderContent(n, p, u), a.options.scrollable && a.options.scrollable.endless && this.lockedContent && (a._skipRerenderItemsCount = o), a._renderLockedContent(n, p, u), a._virtualColScroll || (a._footer(), a._renderNoRecordsContent(), a._togglePagerVisibility(), a._setContentHeight(), a._setContentWidth(a.content && l)), a.lockedTable && (s.rows ? a.content.find(">.k-virtual-scrollable-wrap").trigger("scroll") : a.touchScroller ? a.touchScroller.movable.trigger("change") : (a.wrapper.one("scroll", function(e) {
                        e.stopPropagation()
                    }), a.content.trigger("scroll"))), a._endlessFetchInProgress || a._restoreCurrent(r, c), a.touchScroller && a.touchScroller.contentResized(), a.selectable && a.selectable.resetTouchEvents(), a._muteAngularRebind(function() {
                        a._angularItems("compile")
                    }), a._checkBoxSelection && a._toggleHeaderCheckState(!1), a.options.persistSelection && (a.selectable && !Ee.ui.Selectable.parseOptions(a.options.selectable).cell || a._checkBoxSelection) && a.items().length ? a._restoreSelection() : a._selectedIds = {}, a.trigger(It)))
                },
                _restoreCurrent: function(r, l) {
                    var o, a, n, i, s;
                    if (!(r === t || r < 0)) {
                        if (this._removeCurrent(), l) this._setCurrent(this.thead.find("th:not(.k-group-cell)").eq(r));
                        else {
                            if (o = 0, a = this.virtualScroll || {}, this._rowVirtualIndex ? o = a.rows ? this.virtualScrollable.position(this._rowVirtualIndex) : this._rowVirtualIndex : r = 0, n = e(), this.lockedTable && (n = this.lockedTable.find(">tbody>tr").eq(o)), n = n.add(this.tbody.children().eq(o)), this._hasVirtualColumns() && (i = parseInt(n.find("td:first").attr("colspan"), 10), r = this._virtualCellIndex - (i > 1 ? i - 1 : 0)), s = n.find(">td:not(.k-group-cell):not(.k-hierarchy-cell)").eq(r), !s.length || r < 0) return;
                            this._hasVirtualColumns() ? this._setCurrent(s, !0, !0) : this._setCurrent(s)
                        }
                        this._current && ke(this._current.closest("table")[0], !0)
                    }
                },
                _restoreSelection: function() {
                    var e, t = this,
                        r = t.items(),
                        l = Qe(t.dataSource.options.schema.model) ? t.dataSource.options.schema.model.fn.idField : t.dataSource.options.schema.model.id;
                    e = Ge(r, function(e) {
                        var r = t.dataItem(e)[l];
                        if (t._selectedIds[r]) return e
                    }), t.select(e)
                },
                _angularItems: function(e) {
                    Ee.ui.DataBoundWidget.fn._angularItems.call(this, e), "cleanup" !== e || this.dataSource && this.dataSource.options.endless || this._cleanupDetailItems(), this._angularGroupItems(e), this._angularGroupFooterItems(e)
                },
                _cleanupDetailItems: function() {
                    var e = this;
                    e._hasDetails() && (e.angular("cleanup", function() {
                        return {
                            elements: e.tbody.children(".k-detail-row")
                        }
                    }), e.tbody.find(".k-detail-cell").empty())
                },
                _angularGroupItems: function(t) {
                    var r = this,
                        l = r.tbody;
                    r.lockedContent && (l = r.lockedTable.find("tbody")), r._group && r.angular(t, function() {
                        return {
                            elements: l.children(".k-grouping-row"),
                            data: e.map(de(r.dataSource.view()), function(e) {
                                return {
                                    dataItem: e
                                }
                            })
                        }
                    })
                },
                _angularGroupFooterItems: function(t) {
                    var r = this,
                        l = r.tbody;
                    r.lockedContent && (l = r.element), r._group && r.groupFooterTemplate && r.angular(t, function() {
                        return {
                            elements: l.find(".k-group-footer"),
                            data: e.map(ce(r.dataSource.view()), function(e) {
                                return {
                                    dataItem: e
                                }
                            })
                        }
                    })
                },
                _renderContent: function(e, t, r) {
                    var l, o, a, n, i = this,
                        s = "",
                        d = null != i.lockedContent,
                        c = null,
                        u = i.options.scrollable,
                        p = {
                            rowTemplate: i.rowTemplate,
                            altRowTemplate: i.altRowTemplate,
                            groupFooterTemplate: i.groupFooterTemplate,
                            groupHeaderColumnTemplate: i.groupHeaderColumnTemplate
                        };
                    if (u && u.endless && !i.dataSource.options.endless && (i._skipRerenderItemsCount = 0, i.content && (i.content[0].scrollTop = 0)), c = i._skipRerenderItemsCount > 0, t = d ? t - U(j(i.columns)).length : t, r > 0)
                        for (t = d ? t - r : t, i.detailTemplate && t++, i.groupFooterTemplate && (i._groupAggregatesDefaultObject = i.dataSource.aggregates()), i.options.scrollable.endless && (n = i.dataSource.flatView().length), l = 0, o = e.length; l < o; l++) i._skippedGroups || (i._skippedGroups = []), a = n && l === e.length - 1 && n !== i.dataSource.total(), s += i._groupRowHtml(e[l], t, 0, d ? ze : Ie, p, d, a);
                    else s += i._rowsHtml(e, p);
                    c ? (i.tbody.append(s), clearTimeout(i._endlessFetchTimeOut), i._endlessFetchTimeOut = setTimeout(function() {
                        i._groupToCollapse && (i.collapseGroup(i._groupToCollapse), i._groupToCollapse = null)
                    }), i._endlessFetchInProgress = null) : i.tbody = ee(i.tbody, i.table, s, this.options.$angular)
                },
                _renderGroupRows: function() {
                    var t, r, l, o, a, n, i, s, d, c, u, p, h, f, g, m, k, b = this,
                        _ = b._groupRows,
                        w = b.wrapper.find(".k-grouping-row"),
                        C = b._groups(),
                        y = null != b.lockedContent;
                    w.each(function(w, S) {
                        f = e(S), c = f.closest("table").parent(), u = c.is("." + ht), r = U(u ? v(N(b.columns)) : v(G(b.columns))), g = f.find("." + ft).length, y ? (t = u ? Ie : ze, l = u ? r.length + C - g : r.length) : (t = Ie, l = r.length + C - g), o = w >= _.length ? _[w - _.length] : _[w], a = o.field, n = Ge(Q(b.columns), function(e) {
                            return e.field == a
                        })[0] || {}, k = !(n.groupHeaderTemplate || !v(b.columns)[0].groupHeaderColumnTemplate) && v(b.columns)[0], i = n.groupHeaderTemplate ? n.groupHeaderTemplate : v(b.columns)[0].groupHeaderColumnTemplate, s = (n.title || a) + ": " + ne(o.value, n.format, n.values, n.encoded), C = C, d = b._groupData(o, !1, k), m = u ? b.lockedGroupHeaderColumnTemplate : b.groupHeaderColumnTemplate, i && (s = typeof i === or ? i(d) : Ee.template(i)(d)), p = f.prev().length ? f.prev() : f.parent(), h = e(m ? m(Oe({}, d, {
                            groupCells: g,
                            colspan: C - g,
                            text: s
                        })) : t(l, g, s)), p.is("tbody") ? p.prepend(h) : p.after(h), f.remove()
                    })
                },
                _renderLockedContent: function(e, t, r) {
                    var l, o, a, n = "",
                        i = null,
                        s = {
                            rowTemplate: this.lockedRowTemplate,
                            altRowTemplate: this.lockedAltRowTemplate,
                            groupFooterTemplate: this.lockedGroupFooterTemplate,
                            groupHeaderColumnTemplate: this.lockedGroupHeaderColumnTemplate
                        };
                    if (this.lockedContent) {
                        if (a = this.lockedTable, i = this._skipRerenderItemsCount > 0, r > 0)
                            for (t -= v(Q(G(this.columns))).length, l = 0, o = e.length; l < o; l++) n += this._groupRowHtml(e[l], t, 0, Ie, s, !1, this.options.scrollable.endless && l === e.length - 1);
                        else n = this._rowsHtml(e, s);
                        i ? a.children("tbody").append(n) : ee(a.children("tbody"), a, n, this.options.$angular), this._syncLockedContentHeight()
                    }
                },
                _togglePagerVisibility: function() {
                    this.options.pageable.alwaysVisible === !1 && this.wrapper.find(".k-grid-pager").toggle(this.dataSource.total() >= this.dataSource.pageSize())
                },
                _adjustRowsHeight: function(e, t) {
                    var r, l, o, a, n = e[0].rows,
                        i = n.length,
                        s = t[0].rows,
                        d = e.add(t),
                        c = d.length,
                        u = [];
                    for (r = 0; r < i && s[r]; r++) n[r].style.height && (n[r].style.height = s[r].style.height = "");
                    for (r = 0; r < i && s[r]; r++) l = n[r].offsetHeight, o = s[r].offsetHeight, a = 0, l > o ? a = l : l < o && (a = o), u.push(a);
                    for (r = 0; r < c; r++) d[r].style.display = "none";
                    for (r = 0; r < i; r++) u[r] && (n[r].style.height = s[r].style.height = u[r] + 1 + "px");
                    for (r = 0; r < c; r++) d[r].style.display = ""
                }
            });
        Ee.ExcelMixin && Ee.ExcelMixin.extend(Nr.prototype), Ee.PDFMixin && (Ee.PDFMixin.extend(Nr.prototype), Nr.prototype._drawPDF_autoPageBreak = function(r) {
            function l() {
                u && i !== t ? (c.one("change", o), c.page(i)) : (s.refresh(), o())
            }

            function o() {
                h.appendTo(document.body);
                var t = e.extend({}, s.options.pdf, {
                    _destructive: !0,
                    progress: function(e) {
                        r.notify({
                            page: e.page,
                            pageNumber: e.pageNum,
                            progress: .5 + e.pageNum / e.totalPages / 2,
                            totalPages: e.totalPages
                        })
                    }
                });
                Ee.drawing.drawDOM(f, t).always(function() {
                    h.remove()
                }).then(function(e) {
                    d.resolve(e)
                }).fail(function(e) {
                    d.reject(e)
                })
            }

            function a() {
                var e = c.page(),
                    t = u ? c.totalPages() : 1;
                n.append(p.find("tr")), e < t ? c.page(e + 1) : (c.unbind("change", a), l())
            }
            var n, i, s = this,
                d = new e.Deferred,
                c = s.dataSource,
                u = s.options.pdf.allPages,
                p = s.wrapper.find('table[role$="grid"] > tbody'),
                h = e("<div>").css({
                    position: "absolute",
                    left: -1e4,
                    top: -1e4
                }),
                f = s.wrapper.clone().css({
                    height: "auto",
                    width: "auto"
                }).appendTo(h);
            return f.find(".k-grid-content").css({
                height: "auto",
                width: "auto",
                overflow: "visible"
            }), f.find('table[role$="grid"], .k-grid-footer table').css({
                height: "auto",
                width: "100%",
                overflow: "visible"
            }), f.find(".k-grid-pager, .k-grid-toolbar, .k-grouping-header").remove(), f.find(".k-grid-header, .k-grid-footer, .k-auto-scrollable").css({
                paddingRight: 0
            }), this._initPDFProgress(r), n = f.find('table[role$="grid"] > tbody').empty(), i = c.page(), u ? (c.bind("change", a), c.page(1)) : a(), d.promise()
        }, Nr.prototype._drawPDF = function(r) {
            function l() {
                i && d !== t ? (n.unbind("change", o), n.one("change", function() {
                    a.resolve(s)
                }), n.page(d)) : a.resolve(s)
            }

            function o() {
                c._drawPDFShadow({
                    width: c.wrapper.width()
                }, {
                    avoidLinks: c.options.pdf.avoidLinks
                }).done(function(e) {
                    var t = n.page(),
                        o = i ? n.totalPages() : 1,
                        a = {
                            page: e,
                            pageNumber: t,
                            progress: t / o,
                            totalPages: o
                        };
                    r.notify(a), s.append(a.page), t < o ? n.page(t + 1) : l()
                }).fail(function(e) {
                    a.reject(e)
                })
            }
            var a, n, i, s, d, c = this;
            return c.options.pdf.paperSize && "auto" != c.options.pdf.paperSize ? c._drawPDF_autoPageBreak(r) : (a = new e.Deferred, n = c.dataSource, i = c.options.pdf.allPages, this._initPDFProgress(r), s = new Ee.drawing.Group, d = n.page(), i ? (n.bind("change", o), n.page(1)) : o(), a.promise())
        }, Nr.prototype._initPDFProgress = function(t) {
            var r, l = e("<div class='k-loading-pdf-mask'><div class='k-loading-color'/></div>");
            l.prepend(this.wrapper.clone().css({
                position: "absolute",
                top: 0,
                left: 0
            })), this.wrapper.append(l), r = e("<div class='k-loading-pdf-progress'>").appendTo(l).kendoProgressBar({
                type: "chunk",
                chunkCount: 10,
                min: 0,
                max: 1,
                value: 0
            }).data("kendoProgressBar"), t.progress(function(e) {
                r.value(e.progress)
            }).always(function() {
                Ee.destroy(l), l.remove()
            })
        }), Le.plugin(Nr), Le.plugin(Br)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, r) {
    (r || t)()
});;
! function(t, define) {
    define("kendo.maskedtextbox.min", ["kendo.core.min"], t)
}(function() {
    return function(t, e) {
        function n(t) {
            return t + p
        }

        function a(t, e) {
            for (var n = 0; n < e.length && t[n] === e[n];) n++;
            return n
        }

        function i(t) {
            return t.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")
        }
        var s = window,
            r = s.Math.min,
            o = s.kendo,
            l = o.caret,
            u = o.keys,
            _ = o.ui,
            d = _.Widget,
            p = ".kendoMaskedTextBox",
            m = t.proxy,
            h = window.setTimeout,
            c = "k-state-disabled",
            f = "k-state-invalid",
            v = "disabled",
            g = "readonly",
            k = "change",
            b = "mouseup",
            y = "drop",
            w = "keydown",
            C = "paste",
            x = "input",
            I = n(o.support.propertyChangeEvent ? "propertychange" : x),
            E = d.extend({
                init: function(e, n) {
                    var a, i, s = this;
                    d.fn.init.call(s, e, n), s._rules = t.extend({}, s.rules, s.options.rules), e = s.element, a = e[0], s._wrapper(), s._tokenize(), s._form(), s.element.addClass("k-textbox").attr("autocomplete", "off").on("focus" + p, function() {
                        var t = a.value;
                        t ? s._togglePrompt(!0) : a.value = s._old = s._emptyMask, s._oldValue = t, s._timeoutId = h(function() {
                            l(e, 0, t ? s._maskLength : 0)
                        })
                    }).on("focusout" + p, function() {
                        var t = e.val();
                        clearTimeout(s._timeoutId), a.value = s._old = "", t !== s._emptyMask && (a.value = s._old = t), s._change(), s._togglePrompt()
                    }), i = e.is("[disabled]") || t(s.element).parents("fieldset").is(":disabled"), i ? s.enable(!1) : s.readonly(e.is("[readonly]")), s.value(s.options.value || e.val()), s._validationIcon = t("<span class='k-icon k-i-warning'></span>").insertAfter(e), o.notify(s)
                },
                options: {
                    name: "MaskedTextBox",
                    clearPromptChar: !1,
                    unmaskOnPost: !1,
                    promptChar: "_",
                    culture: "",
                    rules: {},
                    value: "",
                    mask: ""
                },
                events: [k],
                rules: {
                    0: /\d/,
                    9: /\d|\s/,
                    "#": /\d|\s|\+|\-/,
                    L: /[a-zA-Z]/,
                    "?": /[a-zA-Z]|\s/,
                    "&": /\S/,
                    C: /./,
                    A: /[a-zA-Z0-9]/,
                    a: /[a-zA-Z0-9]|\s/
                },
                setOptions: function(e) {
                    var n = this;
                    d.fn.setOptions.call(n, e), n._rules = t.extend({}, n.rules, n.options.rules), n._tokenize(), this._unbindInput(), this._bindInput(), n.value(n.element.val())
                },
                destroy: function() {
                    var t = this;
                    t.element.off(p), t._formElement && (t._formElement.off("reset", t._resetHandler), t._formElement.off("submit", t._submitHandler)), d.fn.destroy.call(t)
                },
                raw: function() {
                    var t = this._unmask(this.element.val(), 0);
                    return t.replace(RegExp(i(this.options.promptChar), "g"), "")
                },
                value: function(t) {
                    var n = this.element,
                        a = this._emptyMask;
                    return t === e ? this.element.val() : (null === t && (t = ""), a ? (t = this._unmask(t + ""), n.val(t ? a : ""), this._mask(0, this._maskLength, t), this._unmaskedValue = null, t = n.val(), this._oldValue = t, o._activeElement() !== n && (t === a ? n.val("") : this._togglePrompt()), e) : (this._oldValue = t, n.val(t), e))
                },
                _togglePrompt: function(t) {
                    var e = this.element[0],
                        n = e.value;
                    this.options.clearPromptChar && (n = t ? this._oldValue : n.replace(RegExp(i(this.options.promptChar), "g"), " "), e.value = this._old = n)
                },
                readonly: function(t) {
                    this._editable({
                        readonly: t === e || t,
                        disable: !1
                    })
                },
                enable: function(t) {
                    this._editable({
                        readonly: !1,
                        disable: !(t = t === e || t)
                    })
                },
                _bindInput: function() {
                    var t, e, a = this;
                    a._maskLength && (a.options.$angular && a.element.off(x), a.element.on(n(w), m(a._keydown, a)).on(n(y), m(a._drop, a)).on(n(k), m(a._trackChange, a)).on(I, m(a._inputHandler, a)), o.support.browser.msie && (t = o.support.browser.version, t > 8 && t < 11 && (e = [n(b), n(y), n(w), n(C)].join(" "), a.element.on(e, m(a._legacyIEInputHandler, a)))))
                },
                _unbindInput: function() {
                    var t = [I, n(w), n(b), n(y), n(C)].join(" ");
                    this.element.off(t)
                },
                _editable: function(t) {
                    var e = this,
                        n = e.element,
                        a = e.wrapper,
                        i = t.disable,
                        s = t.readonly;
                    e._unbindInput(), s || i ? (n.attr(v, i).attr(g, s), a.toggleClass(c, i)) : (n.removeAttr(v).removeAttr(g), a.removeClass(c), e._bindInput())
                },
                _change: function() {
                    var t = this,
                        e = t.value();
                    e !== t._oldValue ? (t._oldValue = e, t.trigger(k), t.element.trigger(k)) : "" === e && t.__changing && t.element.trigger(k)
                },
                inputChange: function(t) {
                    var e, n, i, s, u, _ = this,
                        d = _._old,
                        p = _.element[0],
                        m = p.value,
                        h = l(p),
                        c = h[1],
                        f = m.length - d.length,
                        v = o.support.mobileOS;
                    _.__dropping && f < 0 || (f === -1 && v.android && "chrome" === v.browser && (t = !0), e = r(c, a(m, d)), n = m.substring(e, c), p.value = m.substring(0, e) + _._emptyMask.substring(e), i = _._mask(e, c, n), s = _._trimStartPromptChars(m.substring(c), r(f, i - e)), u = _._unmask(s, d.length - s.length), _._mask(i, i, u), t && (i = _._findCaretPosBackwards(e)), l(p, i), _.__dropping = !1)
                },
                _trimStartPromptChars: function(t, e) {
                    for (var n = this.options.promptChar; e-- > 0 && 0 === t.indexOf(n);) t = t.substring(1);
                    return t
                },
                _findCaretPosBackwards: function(t) {
                    var e = this._find(t, !0);
                    return e < t && (e += 1), e
                },
                _inputHandler: function() {
                    o._activeElement() === this.element[0] && this.inputChange(this.__backward)
                },
                _legacyIEInputHandler: function(t) {
                    var e = this,
                        n = e.element[0],
                        a = n.value,
                        i = t.type;
                    e.__pasting = "paste" === i, h(function() {
                        "mouseup" === i && e.__pasting || n.value && n.value !== a && e.inputChange(e.__backward)
                    })
                },
                _trackChange: function() {
                    var t = this;
                    t.__changing = !0, h(function() {
                        t.__changing = !1
                    })
                },
                _form: function() {
                    var e = this,
                        n = e.element,
                        a = n.attr("form"),
                        i = a ? t("#" + a) : n.closest("form");
                    i[0] && (e._resetHandler = function() {
                        h(function() {
                            e.value(n[0].value)
                        })
                    }, e._submitHandler = function() {
                        e.element[0].value = e._old = e.raw()
                    }, e.options.unmaskOnPost && i.on("submit", e._submitHandler), e._formElement = i.on("reset", e._resetHandler))
                },
                _keydown: function(t) {
                    var e = t.keyCode;
                    this.__backward = e === u.BACKSPACE, e === u.ENTER && this._change()
                },
                _drop: function() {
                    this.__dropping = !0
                },
                _find: function(t, e) {
                    var n = this.element.val() || this._emptyMask,
                        a = 1;
                    for (e === !0 && (a = -1); t > -1 || t <= this._maskLength;) {
                        if (n.charAt(t) !== this.tokens[t]) return t;
                        t += a
                    }
                    return -1
                },
                _mask: function(t, n, a, i) {
                    var s, r, u, _, d = this.element[0],
                        p = d.value || this._emptyMask,
                        m = this.options.promptChar,
                        h = 0;
                    for (t = this._find(t, i), t > n && (n = t), r = this._unmask(p.substring(n), n), a = this._unmask(a, t), s = a.length, a && (r = r.replace(RegExp("^_{0," + s + "}"), "")), a += r, p = p.split(""), u = a.charAt(h); t < this._maskLength;) p[t] = u || m, u = a.charAt(++h), _ === e && h > s && (_ = t), t = this._find(t + 1);
                    return d.value = this._old = p.join(""), o._activeElement() === d && (_ === e && (_ = this._maskLength), l(d, _)), _
                },
                _unmask: function(e, n) {
                    var a, i, s, r, o, l, u, _;
                    if (!e) return "";
                    if (this._unmaskedValue === e) return this._unmaskedValue;
                    for (e = (e + "").split(""), s = 0, r = n || 0, o = this.options.promptChar, l = e.length, u = this.tokens.length, _ = ""; r < u && (a = e[s], i = this.tokens[r], a === i || a === o ? (_ += a === o ? o : "", s += 1, r += 1) : "string" != typeof i ? (i && i.test && i.test(a) || t.isFunction(i) && i(a) ? (_ += a, r += 1) : 1 === l && this._blinkInvalidState(), s += 1) : r += 1, !(s >= l)););
                    return this._unmaskedValue = _, _
                },
                _wrapper: function() {
                    var t = this,
                        e = t.element,
                        n = e[0],
                        a = e.wrap("<span class='k-widget k-maskedtextbox'></span>").parent();
                    a[0].style.cssText = n.style.cssText, n.style.width = "100%", t.wrapper = a.addClass(n.className)
                },
                _blinkInvalidState: function() {
                    var t = this;
                    t.wrapper.addClass(f), clearTimeout(t._invalidStateTimeout), t._invalidStateTimeout = h(m(t._removeInvalidState, t), 100)
                },
                _removeInvalidState: function() {
                    var t = this;
                    t.wrapper.removeClass(f), t._invalidStateTimeout = null
                },
                _tokenize: function() {
                    for (var t, e, n, a, i = [], s = 0, r = this.options.mask || "", l = r.split(""), u = l.length, _ = 0, d = "", p = this.options.promptChar, m = o.getCulture(this.options.culture).numberFormat, h = this._rules; _ < u; _++)
                        if (t = l[_], e = h[t]) i[s] = e, d += p, s += 1;
                        else
                            for ("." === t || "," === t ? t = m[t] : "$" === t ? t = m.currency.symbol : "\\" === t && (_ += 1, t = l[_]), t = t.split(""), n = 0, a = t.length; n < a; n++) i[s] = t[n], d += t[n], s += 1;
                    this.tokens = i, this._emptyMask = d, this._maskLength = d.length
                }
            });
        _.plugin(E)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, n) {
    (n || e)()
});;
! function(t, define) {
    define("kendo.multicolumncombobox.min", ["kendo.combobox.min"], t)
}(function() {
    return function(t, o) {
        var i = window.kendo,
            n = i.ui,
            s = n.ComboBox,
            d = /^\d+(\.\d+)?%$/i,
            l = "k-dropdowngrid",
            e = "k-dropdowngrid-popup k-popup-flush",
            r = s.extend({
                init: function(t, o) {
                    s.fn.init.call(this, t, o), this.list.addClass(e), this._allColumnsWidthsAreSet(this.options) ? this.list.width(this._calculateDropDownWidth(this.options)) : this.options.dropDownWidth && this.list.width(this.options.dropDownWidth)
                },
                options: {
                    name: "MultiColumnComboBox",
                    ns: ".kendoMultiColumnComboBox",
                    columns: [],
                    dropDownWidth: null,
                    filterFields: []
                },
                setOptions: function(t) {
                    s.fn.setOptions.call(this, t), this._allColumnsWidthsAreSet(t) ? this.list.width(this._calculateDropDownWidth(t)) : this.options.dropDownWidth && this.list.width(this.options.dropDownWidth)
                },
                _allColumnsWidthsAreSet: function(t) {
                    var o, i, n = t.columns;
                    if (!n || !n.length) return !1;
                    for (o = 0; o < n.length; o++)
                        if (i = n[o].width, !i || isNaN(parseInt(i, 10)) || d.test(i)) return !1;
                    return !0
                },
                _calculateDropDownWidth: function(t) {
                    var o, n, s = t.columns,
                        d = i.support.scrollbar();
                    for (o = 0; o < s.length; o++) n = s[o].width, d += parseInt(n, 10);
                    return d
                },
                _wrapper: function() {
                    s.fn._wrapper.call(this), this.wrapper.addClass(l)
                }
            });
        n.plugin(r)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, o, i) {
    (i || o)()
});;
! function(e, define) {
    define("kendo.multiselect.min", ["kendo.list.min", "kendo.mobile.scroller.min", "kendo.virtuallist.min"], e)
}(function() {
    return function(e, t) {
        function i(e, t) {
            var i;
            if (null === e && null !== t || null !== e && null === t) return !1;
            if (i = e.length, i !== t.length) return !1;
            for (; i--;)
                if (e[i] !== t[i]) return !1;
            return !0
        }
        var a = window.kendo,
            s = a.ui,
            n = s.List,
            l = e.extend({
                A: 65
            }, a.keys),
            o = a._activeElement,
            r = a.data.ObservableArray,
            u = e.proxy,
            c = "id",
            d = "li",
            p = "accept",
            h = "filter",
            _ = "rebind",
            f = "open",
            g = "close",
            m = "change",
            v = "progress",
            T = "select",
            w = "deselect",
            I = "aria-disabled",
            b = "k-state-focused",
            y = "k-state-selected",
            S = "k-hidden",
            V = "k-state-hover",
            k = "k-state-disabled",
            x = "k-no-click",
            L = "disabled",
            C = "readonly",
            D = "off",
            O = ".kendoMultiSelect",
            E = "click" + O,
            A = "keydown" + O,
            B = "mouseenter" + O,
            F = "mouseleave" + O,
            M = B + " " + F,
            H = /"/g,
            P = e.isArray,
            K = ["font-family", "font-size", "font-stretch", "font-style", "font-weight", "letter-spacing", "text-transform", "line-height"],
            R = n.extend({
                init: function(t, i) {
                    var s, l, o = this;
                    o.ns = O, n.fn.init.call(o, t, i), o._optionsMap = {}, o._customOptions = {}, o._wrapper(), o._tagList(), o._input(), o._textContainer(), o._loader(), o._clearButton(), o._tabindex(o.input), t = o.element.attr("multiple", "multiple").hide(), i = o.options, i.placeholder || (i.placeholder = t.data("placeholder")), s = t.attr(c), s && (o._tagID = s + "_tag_active", s += "_taglist", o.tagList.attr(c, s), o.input.attr("aria-describedby", s)), o._initialOpen = !0, o._ariaLabel(), o._ariaSetLive(), o._dataSource(), o._ignoreCase(), o._popup(), o._tagTemplate(), o.requireValueMapper(o.options), o._initList(), o._reset(), o._enable(), o._placeholder(), i.autoBind ? o.dataSource.fetch() : i.value && o._preselect(i.value), l = e(o.element).parents("fieldset").is(":disabled"), l && o.enable(!1), o._ariaSetSize(o.value().length), a.notify(o), o._toggleCloseVisibility()
                },
                options: {
                    name: "MultiSelect",
                    tagMode: "multiple",
                    enabled: !0,
                    autoBind: !0,
                    autoClose: !0,
                    highlightFirst: !0,
                    dataTextField: "",
                    dataValueField: "",
                    filter: "startswith",
                    ignoreCase: !0,
                    minLength: 1,
                    messages: {
                        singleTag: "item(s) selected",
                        clear: "clear",
                        deleteTag: "delete",
                        noData: "No data found."
                    },
                    enforceMinLength: !1,
                    delay: 100,
                    value: null,
                    maxSelectedItems: null,
                    placeholder: "",
                    height: 200,
                    animation: {},
                    virtual: !1,
                    itemTemplate: "",
                    tagTemplate: "",
                    groupTemplate: "#:data#",
                    fixedGroupTemplate: "#:data#",
                    clearButton: !0,
                    autoWidth: !1,
                    popup: null
                },
                events: [f, g, m, T, w, "filtering", "dataBinding", "dataBound"],
                setDataSource: function(e) {
                    this.options.dataSource = e, this._state = "", this._dataSource(), this.persistTagList = !1, this.listView.setDataSource(this.dataSource), this.options.autoBind && this.dataSource.fetch()
                },
                setOptions: function(e) {
                    var t = this._listOptions(e);
                    n.fn.setOptions.call(this, e), this.listView.setOptions(t), this._accessors(), this._aria(this.tagList.attr(c)), this._tagTemplate(), this._placeholder(), this._clearButton()
                },
                currentTag: function(e) {
                    var i = this;
                    return e === t ? i._currentTag : (i._currentTag && (i._currentTag.removeClass(b).removeAttr(c), i._currentTag.find(".k-select").attr("aria-hidden", !0), i.input.removeAttr("aria-activedescendant")), e && (e.addClass(b).attr(c, i._tagID), e.find(".k-select").removeAttr("aria-hidden"), i.input.attr("aria-activedescendant", i._tagID)), i._currentTag = e, t)
                },
                dataItems: function() {
                    return this.listView.selectedDataItems()
                },
                destroy: function() {
                    var e = this,
                        t = e.ns;
                    clearTimeout(e._busy), clearTimeout(e._typingTimeout), e.wrapper.off(t), e.tagList.off(t), e.input.off(t), e._clear.off(t), n.fn.destroy.call(e)
                },
                _activateItem: function() {
                    this.popup.visible() && n.fn._activateItem.call(this), this.currentTag(null)
                },
                _listOptions: function(t) {
                    var i = this,
                        s = n.fn._listOptions.call(i, e.extend(t, {
                            selectedItemChange: u(i._selectedItemChange, i),
                            selectable: "multiple"
                        })),
                        l = this.options.itemTemplate || this.options.template,
                        o = s.itemTemplate || l || s.template;
                    return o || (o = "#:" + a.expr(s.dataTextField, "data") + "#"), s.template = o, s
                },
                _setListValue: function() {
                    n.fn._setListValue.call(this, this._initialValues.slice(0))
                },
                _listChange: function(e) {
                    var i, a = this.dataSource.flatView(),
                        s = this._optionsMap,
                        n = this._value;
                    for (this._state === _ && (this._state = ""), i = 0; i < e.added.length; i++)
                        if (s[n(e.added[i].dataItem)] === t) {
                            this._render(a);
                            break
                        }
                    this._selectValue(e.added, e.removed)
                },
                _selectedItemChange: function(e) {
                    var t, i, a = e.items;
                    for (i = 0; i < a.length; i++) t = a[i], this.tagList.children().eq(t.index).children("span:first").html(this.tagTextTemplate(t.item))
                },
                _wrapperMousedown: function(t) {
                    var i = this,
                        s = "input" !== t.target.nodeName.toLowerCase(),
                        n = e(t.target),
                        l = n.hasClass("k-select") || n.hasClass("k-icon");
                    l && (l = !n.closest(".k-select").children(".k-i-arrow-60-down").length), !s || l && a.support.mobileOS || !t.cancelable || t.preventDefault(), l || (i.input[0] !== o() && s && i.input.focus(), 1 === i.options.minLength && i.open())
                },
                _inputFocus: function() {
                    this._placeholder(!1), this.wrapper.addClass(b)
                },
                _inputFocusout: function() {
                    var e = this;
                    clearTimeout(e._typingTimeout), e.wrapper.removeClass(b), e._placeholder(!e.listView.selectedDataItems()[0], !0), e.close(), e._state === h && (e._state = p, e.listView.skipUpdate(!0)), e.listView.bound() && e.listView.isFiltered() && (e.persistTagList = !0, e._clearFilter()), e.element.blur()
                },
                _removeTag: function(e, i) {
                    var a, s, n, l = this,
                        o = l._state,
                        r = e.index(),
                        u = l.listView,
                        c = u.value()[r],
                        d = l.listView.selectedDataItems()[r],
                        _ = l._customOptions[c],
                        f = u.element[0].children;
                    return l.trigger(w, {
                        dataItem: d,
                        item: e
                    }) ? (l._close(), t) : (_ !== t || o !== p && o !== h || (_ = l._optionsMap[c]), n = function() {
                        l.currentTag(null), i && l._change(), l._close()
                    }, _ === t && u.select().length ? (l.persistTagList = !1, u.select(u.select()[r]).done(n)) : (a = l.element[0].children[_], a && (a.selected = !1), u.removeAt(r), s = f[_], s && f[_].classList.remove("k-state-selected"), "single" !== l.options.tagMode ? e.remove() : l._updateTagListHTML(), n()), t)
                },
                _tagListClick: function(t) {
                    t.preventDefault(), t.stopPropagation();
                    var i = e(t.currentTarget);
                    i.children(".k-i-arrow-60-down").length || this._removeTag(i.closest(d), !0)
                },
                _clearValue: function() {
                    var t = this;
                    "single" === t.options.tagMode ? t._clearSingleTagValue() : t.tagList.children().each(function(i, a) {
                        t._removeTag(e(a), !1)
                    }), t.input.val(""), t._search(), t._change(), t.focus(), t._hideClear(), t._state === h && (t._state = p)
                },
                _clearSingleTagValue: function() {
                    var e = this,
                        t = e.persistTagList;
                    t && (e.persistTagList = !1), e.listView.value([]), e.persistTagList = t
                },
                _focusHandler: function() {
                    this.input.focus()
                },
                _editable: function(t) {
                    var i = this,
                        a = t.disable,
                        s = t.readonly,
                        n = i.wrapper.off(O),
                        l = i.tagList.off(O),
                        o = i.element.add(i.input.off(O));
                    s || a ? (n.toggleClass(k, a).toggleClass(x, s), o.attr(L, a).attr(C, s).attr(I, a)) : (n.removeClass(k).removeClass(x).on(M, i._toggleHover).on("mousedown" + O + " touchend" + O, u(i._wrapperMousedown, i)).on(E, u(i._focusHandler, i)), i.input.on(A, u(i._keydown, i)).on("paste" + O, u(i._search, i)).on("input" + O, u(i._search, i)).on("focus" + O, u(i._inputFocus, i)).on("focusout" + O, u(i._inputFocusout, i)), i._clear.on(E + " touchend" + O, u(i._clearValue, i)), o.removeAttr(L).removeAttr(C).attr(I, !1), l.on(B, d, function() {
                        e(this).addClass(V)
                    }).on(F, d, function() {
                        e(this).removeClass(V)
                    }).on(E + " touchend" + O, "li.k-button .k-select", u(i._tagListClick, i)))
                },
                _close: function() {
                    var e = this;
                    e.options.autoClose ? e.close() : e.popup.position()
                },
                _filterSource: function(e, t) {
                    t || (t = this._retrieveData), this._retrieveData = !1, n.fn._filterSource.call(this, e, t)
                },
                close: function() {
                    this._activeItem = null, this.input.removeAttr("aria-activedescendant"), this.popup.close()
                },
                open: function() {
                    var t = this;
                    t._request && (t._retrieveData = !1), t._retrieveData || !t.listView.bound() || t._state === p ? (t._open = !0, t._state = _, t.listView.skipUpdate(!0), t.persistTagList = !(t._initialOpen && !t.listView.bound()), t._filterSource(), t._focusItem()) : t._allowOpening() && (!t._initialOpen || t.options.autoBind || t.options.virtual || !t.options.value || e.isPlainObject(t.options.value[0]) || t.value(t.value() || t._initialValues), t.popup._hovered = !0, t._initialOpen = !1, t.popup.open(), t._focusItem())
                },
                toggle: function(e) {
                    e = e !== t ? e : !this.popup.visible(), this[e ? f : g]()
                },
                refresh: function() {
                    this.listView.refresh()
                },
                _listBound: function() {
                    var e = this,
                        i = e.dataSource.flatView(),
                        a = e.listView.skip();
                    e._render(i), e._renderFooter(), e._renderNoData(), e._toggleNoData(!i.length), e._resizePopup(), e._open && (e._open = !1, e.toggle(e._allowOpening())), e.popup.position(), !e.options.highlightFirst || a !== t && 0 !== a || e.listView.focusFirst(), e._touchScroller && e._touchScroller.reset(), e._hideBusy(), e._makeUnselectable(), e.trigger("dataBound")
                },
                _inputValue: function() {
                    var e = this,
                        t = e.input.val();
                    return e.options.placeholder === t && (t = ""), t
                },
                value: function(e) {
                    var i = this,
                        a = i.listView,
                        s = a.value().slice(),
                        n = i.options.maxSelectedItems,
                        l = a.bound() && a.isFiltered();
                    return e === t ? s : (i.persistTagList = !1, i.requireValueMapper(i.options, e), e = i._normalizeValues(e), null !== n && e.length > n && (e = e.slice(0, n)), l && i._clearFilter(), a.value(e), i._old = i._valueBeforeCascade = e.slice(), l || i._fetchData(), i._ariaSetSize(i.value().length), i._toggleCloseVisibility(), t)
                },
                _preselect: function(t, i) {
                    var s = this;
                    P(t) || t instanceof a.data.ObservableArray || (t = [t]), (e.isPlainObject(t[0]) || t[0] instanceof a.data.ObservableObject || !s.options.dataValueField) && (s.dataSource.data(t), s.value(i || s._initialValues), s._retrieveData = !0)
                },
                _setOption: function(e, t) {
                    var i = this.element[0].children[this._optionsMap[e]];
                    i && (i.selected = t)
                },
                _fetchData: function() {
                    var e = this,
                        t = !!e.dataSource.view().length,
                        i = 0 === e.listView.value().length;
                    i || e._request || (e._retrieveData || !e._fetch && !t) && (e._fetch = !0, e._retrieveData = !1, e.dataSource.read().done(function() {
                        e._fetch = !1
                    }))
                },
                _isBound: function() {
                    return this.listView.bound() && !this._retrieveData
                },
                _dataSource: function() {
                    var e = this,
                        t = e.element,
                        i = e.options,
                        s = i.dataSource || {};
                    s = P(s) ? {
                        data: s
                    } : s, s.select = t, s.fields = [{
                        field: i.dataTextField
                    }, {
                        field: i.dataValueField
                    }], e.dataSource && e._refreshHandler ? e._unbindDataSource() : (e._progressHandler = u(e._showBusy, e), e._errorHandler = u(e._hideBusy, e)), e.dataSource = a.data.DataSource.create(s).bind(v, e._progressHandler).bind("error", e._errorHandler)
                },
                _reset: function() {
                    var t = this,
                        i = t.element,
                        a = i.attr("form"),
                        s = a ? e("#" + a) : i.closest("form");
                    s[0] && (t._resetHandler = function() {
                        setTimeout(function() {
                            t.value(t._initialValues), t._placeholder()
                        })
                    }, t._form = s.on("reset", t._resetHandler))
                },
                _initValue: function() {
                    var e = this.options.value || this.element.val();
                    this._old = this._initialValues = this._normalizeValues(e)
                },
                _normalizeValues: function(t) {
                    var i = this;
                    return null === t ? t = [] : t && e.isPlainObject(t) ? t = [i._value(t)] : t && e.isPlainObject(t[0]) ? t = e.map(t, function(e) {
                        return i._value(e)
                    }) : P(t) || t instanceof r ? P(t) && (t = t.slice()) : t = [t], t
                },
                _change: function() {
                    var e = this,
                        t = e.value();
                    i(t, e._old) || (e._old = t.slice(), e.trigger(m), e.element.trigger(m)), e.popup.position(), e._ariaSetSize(t.length), e._toggleCloseVisibility()
                },
                _click: function(e) {
                    var t = this,
                        i = e.item;
                    e.preventDefault(), t._select(i).done(function() {
                        t._activeItem = i, t._change(), t._close()
                    })
                },
                _getActiveItem: function() {
                    return this._activeItem || e(this.listView.items()[this._getSelectedIndices().length - 1]) || this.listView.focus()
                },
                _getSelectedIndices: function() {
                    return this.listView._selectedIndices || this.listView._selectedIndexes
                },
                _keydown: function(i) {
                    var s, n, o, r, u = this,
                        c = i.keyCode,
                        d = u._currentTag,
                        h = u.listView,
                        _ = u.input.val(),
                        f = a.support.isRtl(u.wrapper),
                        g = u.popup.visible(),
                        m = 0;
                    if (c !== l.ENTER && (this._multipleSelection = !1), c === l.DOWN) {
                        if (i.preventDefault(), !g) return u.open(), h.focus() || h.focusFirst(), t;
                        h.focus() ? (!u._activeItem && i.shiftKey && (u._activeItem = h.focus(), m = -1), s = h.getElementIndex(u._getActiveItem().first()), h.focusNext(), h.focus() ? i.shiftKey && (this._multipleSelection = !0, u._selectRange(s, h.getElementIndex(h.focus().first()) + m)) : h.focusLast()) : h.focusFirst()
                    } else if (c === l.UP) g && (!u._activeItem && i.shiftKey && (u._activeItem = h.focus(), m = 1), s = h.getElementIndex(u._getActiveItem().first()), h.focusPrev(), h.focus() ? i.shiftKey && (this._multipleSelection = !0, u._selectRange(s, h.getElementIndex(h.focus().first()) + m)) : u.close()), i.preventDefault();
                    else if (c === l.LEFT && !f || c === l.RIGHT && f) _ || (d = d ? d.prev() : e(u.tagList[0].lastChild), d[0] && u.currentTag(d));
                    else if (c === l.RIGHT && !f || c === l.LEFT && f) !_ && d && (d = d.next(), u.currentTag(d[0] ? d : null));
                    else if (i.ctrlKey && !i.altKey && c === l.A && g && !u.options.virtual) this._multipleSelection = !0, this._getSelectedIndices().length === h.items().length && (u._activeItem = null), h.items().length && u._selectRange(0, h.items().length - 1);
                    else if (c === l.ENTER && g) {
                        if (!h.focus()) return;
                        if (i.preventDefault(), this._multipleSelection && (this._multipleSelection = !1, h.focus().hasClass(y))) return u._close(), t;
                        u._select(h.focus()).done(function() {
                            u._change(), u._close()
                        })
                    } else if (c === l.SPACEBAR && i.ctrlKey && g) u._activeItem && h.focus() && h.focus()[0] === u._activeItem[0] && (u._activeItem = null), e(h.focus()).hasClass(y) || (u._activeItem = h.focus()), u._select(h.focus()).done(function() {
                        u._change()
                    }), i.preventDefault();
                    else if (c === l.SPACEBAR && i.shiftKey && g) n = h.getElementIndex(u._getActiveItem()), o = h.getElementIndex(h.focus()), n !== t && o !== t && u._selectRange(n, o), i.preventDefault();
                    else if (c === l.ESC) g ? i.preventDefault() : (u.tagList.children().each(function(t, i) {
                        u._removeTag(e(i), !1)
                    }), u._change()), u.close();
                    else if (c === l.HOME) g ? h.focus() ? (i.ctrlKey && i.shiftKey && !u.options.virtual && u._selectRange(h.getElementIndex(h.focus()[0]), 0), h.focusFirst()) : u.close() : _ || (d = u.tagList[0].firstChild, d && u.currentTag(e(d)));
                    else if (c === l.END) g ? h.focus() ? (i.ctrlKey && i.shiftKey && !u.options.virtual && u._selectRange(h.getElementIndex(h.focus()[0]), h.element.children().length - 1), h.focusLast()) : u.close() : _ || (d = u.tagList[0].lastChild, d && u.currentTag(e(d)));
                    else if (c !== l.DELETE && c !== l.BACKSPACE || _) !u.popup.visible() || c !== l.PAGEDOWN && c !== l.PAGEUP ? (clearTimeout(u._typingTimeout), setTimeout(function() {
                        u._scale()
                    }), u._search()) : (i.preventDefault(), r = c === l.PAGEDOWN ? 1 : -1, h.scrollWith(r * h.screenHeight()));
                    else {
                        if (u._state = p, "single" === u.options.tagMode) return u._clearSingleTagValue(), u._change(), u._close(), t;
                        c !== l.BACKSPACE || d || (d = e(u.tagList[0].lastChild)), d && d[0] && u._removeTag(d, !0)
                    }
                },
                _hideBusy: function() {
                    var e = this;
                    clearTimeout(e._busy), e.input.attr("aria-busy", !1), e._loading.addClass(S), e._request = !1, e._busy = null, e._toggleCloseVisibility()
                },
                _showBusyHandler: function() {
                    this.input.attr("aria-busy", !0), this._loading.removeClass(S), this._hideClear()
                },
                _showBusy: function() {
                    var e = this;
                    e._request = !0, e._busy || (e._busy = setTimeout(u(e._showBusyHandler, e), 100))
                },
                _placeholder: function(e, i) {
                    var s = this,
                        n = s.input,
                        l = o(),
                        r = s.options.placeholder,
                        u = n.val(),
                        c = n[0] === l,
                        d = u.length;
                    c && !s.options.autoClose && u !== r || (d = 0, u = ""), e === t && (e = !1, n[0] !== l && (e = !s.listView.selectedDataItems()[0])), s._prev = u, n.toggleClass("k-readonly", e).val(e ? r : u), c && !i && a.caret(n[0], d, d), s._scale()
                },
                _scale: function() {
                    var e, t = this,
                        i = t.wrapper.find(".k-multiselect-wrap"),
                        a = i.width(),
                        s = t._span.text(t.input.val());
                    i.is(":visible") ? e = s.width() + 25 : (s.appendTo(document.documentElement), a = e = s.width() + 25, s.appendTo(i)), t.input.width(e > a ? a : e)
                },
                _option: function(e, i, s) {
                    var n = "<option";
                    return e !== t && (e += "", e.indexOf('"') !== -1 && (e = e.replace(H, "&quot;")), n += ' value="' + e + '"'), s && (n += " selected"), n += ">", i !== t && (n += a.htmlEncode(i)), n += "</option>"
                },
                _render: function(e) {
                    var t, i, a, s, n, l, o = this.listView.selectedDataItems(),
                        r = this.listView.value(),
                        u = e.length,
                        c = "";
                    for (r.length !== o.length && (o = this._buildSelectedItems(r)), n = {}, l = {}, s = 0; s < u; s++) i = e[s], a = this._value(i), t = this._selectedItemIndex(a, o), t !== -1 && o.splice(t, 1), l[a] = s, c += this._option(a, this._text(i), t !== -1);
                    if (o.length)
                        for (s = 0; s < o.length; s++) i = o[s], a = this._value(i), n[a] = u, l[a] = u, u += 1, c += this._option(a, this._text(i), !0);
                    this._customOptions = n, this._optionsMap = l, this.element.html(c)
                },
                _buildSelectedItems: function(e) {
                    var t, i, a = this.options.dataValueField,
                        s = this.options.dataTextField,
                        n = [];
                    for (i = 0; i < e.length; i++) t = {}, t[a] = e[i], t[s] = e[i], n.push(t);
                    return n
                },
                _selectedItemIndex: function(e, t) {
                    for (var i = this._value, a = 0; a < t.length; a++)
                        if (e === i(t[a])) return a;
                    return -1
                },
                _search: function() {
                    var e = this;
                    clearTimeout(e._typingTimeout), e._typingTimeout = setTimeout(function() {
                        var t = e._inputValue();
                        e._prev !== t && (e._prev = t, e.search(t), e._toggleCloseVisibility())
                    }, e.options.delay)
                },
                _toggleCloseVisibility: function() {
                    this.value().length || this.input.val() && this.input.val() !== this.options.placeholder ? this._showClear() : this._hideClear()
                },
                _allowOpening: function() {
                    return this._allowSelection() && n.fn._allowOpening.call(this)
                },
                _allowSelection: function() {
                    var e = this.options.maxSelectedItems;
                    return null === e || e > this.listView.value().length
                },
                _angularTagItems: function(t) {
                    var i = this;
                    i.angular(t, function() {
                        return {
                            elements: i.tagList[0].children,
                            data: e.map(i.dataItems(), function(e) {
                                return {
                                    dataItem: e
                                }
                            })
                        }
                    })
                },
                updatePersistTagList: function(e, t) {
                    this.persistTagList.added && this.persistTagList.added.length === t.length && this.persistTagList.removed && this.persistTagList.removed.length === e.length ? this.persistTagList = !1 : (this.listView._removedAddedIndexes = this._old.slice(), this.persistTagList = {
                        added: e,
                        removed: t
                    })
                },
                _selectValue: function(e, i) {
                    var a, s, n, l = this,
                        o = l.dataSource.total(),
                        r = l.tagList,
                        u = l._value;
                    if (this.persistTagList) return this.updatePersistTagList(e, i), t;
                    if (l._angularTagItems("cleanup"), "multiple" === l.options.tagMode) {
                        for (n = i.length - 1; n > -1; n--) a = i[n], r.children().length && (r[0].removeChild(r[0].children[a.position]), l._setOption(u(a.dataItem), !1));
                        for (n = 0; n < e.length; n++) s = e[n], r.append(l.tagTemplate(s.dataItem)), l._setOption(u(s.dataItem), !0)
                    } else {
                        for ((!l._maxTotal || l._maxTotal < o) && (l._maxTotal = o), this._updateTagListHTML(), n = i.length - 1; n > -1; n--) l._setOption(u(i[n].dataItem), !1);
                        for (n = 0; n < e.length; n++) l._setOption(u(e[n].dataItem), !0)
                    }
                    l._angularTagItems("compile"), l._placeholder()
                },
                _updateTagListHTML: function() {
                    var e = this,
                        t = e.value(),
                        i = e.dataSource.total(),
                        a = e.tagList;
                    a.html(""), t.length && a.append(e.tagTemplate({
                        values: t,
                        dataItems: e.dataItems(),
                        maxTotal: e._maxTotal,
                        currentTotal: i
                    }))
                },
                _select: function(t) {
                    var i, a, s, n, l = e.Deferred().resolve();
                    return t ? (i = this, a = i.listView, s = a.dataItemByIndex(a.getElementIndex(t)), n = t.hasClass("k-state-selected"), i._state === _ && (i._state = ""), i._allowSelection() || n ? i.trigger(n ? w : T, {
                        dataItem: s,
                        item: t
                    }) ? (i._close(), l) : (i.persistTagList = !1, a.select(t).done(function() {
                        i._placeholder(), i._state === h && (i._state = p, a.skipUpdate(!0))
                    })) : l) : l
                },
                _selectRange: function(i, a) {
                    var s, n, l = this,
                        o = this.listView,
                        r = this.options.maxSelectedItems,
                        u = this._getSelectedIndices().slice(),
                        c = [],
                        d = function(t) {
                            o.select(t).done(function() {
                                t.forEach(function(t) {
                                    var i = o.dataItemByIndex(t),
                                        a = o.element.children()[t],
                                        s = e(a).hasClass("k-state-selected");
                                    l.trigger(s ? T : w, {
                                        dataItem: i,
                                        item: e(a)
                                    })
                                }), l._change()
                            })
                        };
                    if (u.length - 1 === a - i) return d(u);
                    if (i < a)
                        for (s = i; s <= a; s++) c.push(s);
                    else
                        for (s = i; s >= a; s--) c.push(s);
                    for (null !== r && c.length > r && (c = c.slice(0, r)), s = 0; s < c.length; s++) n = c[s], this._getSelectedIndices().indexOf(n) == -1 ? u.push(n) : u.splice(u.indexOf(n), 1);
                    return u.length ? (l.persistTagList = !1, d(u)) : t
                },
                _input: function() {
                    var t = this,
                        i = t.element,
                        a = i[0].accessKey,
                        s = t._innerWrapper.children("input.k-input");
                    s[0] || (s = e('<input class="k-input" style="width: 25px" />').appendTo(t._innerWrapper)), i.removeAttr("accesskey"), t._focused = t.input = s.attr({
                        accesskey: a,
                        autocomplete: D,
                        role: "listbox",
                        title: i[0].title,
                        "aria-expanded": !1,
                        "aria-haspopup": "listbox",
                        "aria-autocomplete": "list"
                    })
                },
                _tagList: function() {
                    var t = this,
                        i = t._innerWrapper.children("ul");
                    i[0] || (i = e('<ul unselectable="on" class="k-reset"/>').appendTo(t._innerWrapper)), t.tagList = i
                },
                _tagTemplate: function() {
                    var e, t = this,
                        i = t.options,
                        s = i.tagTemplate,
                        n = i.dataSource,
                        l = "multiple" === i.tagMode,
                        o = i.messages.singleTag;
                    t.element[0].length && !n && (i.dataTextField = i.dataTextField || "text", i.dataValueField = i.dataValueField || "value"), e = l ? a.template("#:" + a.expr(i.dataTextField, "data") + "#", {
                        useWithBlock: !1
                    }) : a.template("#:values.length# " + o), t.tagTextTemplate = s = s ? a.template(s) : e, t.tagTemplate = function(e) {
                        return '<li role="option" aria-selected="true" class="k-button" unselectable="on"><span unselectable="on">' + s(e) + '</span><span aria-hidden="true" unselectable="on" aria-label="' + (l ? 'delete" title="' + t.options.messages.deleteTag + '" aria-label="' + t.options.messages.deleteTag : "open") + '" class="k-select"><span class="k-icon ' + (l ? "k-i-close" : "k-i-arrow-60-down") + '"></span></span></li>'
                    }
                },
                _loader: function() {
                    this._loading = e('<span class="k-icon k-i-loading ' + S + '"></span>').insertAfter(this.input)
                },
                _clearButton: function() {
                    n.fn._clearButton.call(this), this.options.clearButton && (this._clear.insertAfter(this.input), this.wrapper.addClass("k-multiselect-clearable"))
                },
                _textContainer: function() {
                    var t = a.getComputedStyles(this.input[0], K);
                    t.position = "absolute", t.visibility = "hidden", t.top = -3333, t.left = -3333, this._span = e("<span/>").css(t).appendTo(this.wrapper)
                },
                _wrapper: function() {
                    var t = this,
                        i = t.element,
                        a = i.parent("span.k-multiselect");
                    a[0] || (a = i.wrap('<div class="k-widget k-multiselect" unselectable="on" />').parent(), a[0].style.cssText = i[0].style.cssText, a[0].title = i[0].title, e('<div class="k-multiselect-wrap k-floatwrap" role="listbox" unselectable="on" />').insertBefore(i)), t.wrapper = a.addClass(i[0].className).css("display", ""), t._innerWrapper = e(a[0].firstChild)
                },
                _ariaSetSize: function(e) {
                    var t = this,
                        i = t.tagList.children();
                    e && i.length && i.attr("aria-setsize", e)
                },
                _ariaSetLive: function() {
                    var e = this;
                    e.ul.attr("aria-live", e._isFilterEnabled() ? "polite" : "off")
                }
            });
        s.plugin(R)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, i) {
    (i || t)()
});;
! function(t, define) {
    define("kendo.scheduler.view.min", ["kendo.core.min"], t)
}(function() {
    return kendo.ui.scheduler = {},
        function(t) {
            function e(t, e) {
                function n(t, i) {
                    var s, r;
                    if (i = i[e])
                        for (s = o[t] = o[t] || [], r = 0; r < i.length; r++) s.push(i[r]), n(t + 1, i[r])
                }
                var o = [];
                return n(0, t), o
            }

            function n() {
                return b.support.cssBorderSpacing ? "" : 'cellspacing="0"'
            }

            function o(e, o) {
                return e.length ? '<table role="presentation"' + n() + ' class="' + t.trim("k-scheduler-table " + (o || "")) + '"><tr>' + e.join("</tr><tr>") + "</tr></table>" : ""
            }

            function i(t, e) {
                return t.length ? "<div style='position:relative'>" + o(t, e) + "</div>" : ""
            }

            function s(e, n, i) {
                var s, r = [];
                if (i > 0)
                    for (s = 0; s < e; s++) r.push("<th>&#8203;</th>");
                return n && r.push('<th class="k-scheduler-times-all-day">' + n.text + "</th>"), i < 1 ? t() : t('<div class="k-scheduler-times">' + o(r) + "</div>")
            }

            function r(e, n, s) {
                var r, l, a, u, c, h, d, f, g, p, _ = [];
                for (l = 0; l < e.length; l++) {
                    for (a = e[l], u = [], c = n / a.length, r = 0; r < a.length; r++) h = a[r], u.push('<th colspan="' + (h.colspan || c) + '" class="' + (h.className || "") + '">' + h.text + "</th>");
                    _.push(u.join(""))
                }
                if (d = [], s) {
                    for (f = e[e.length - 1], g = [], p = s.cellContent, r = 0; r < f.length; r++) g.push('<td class="' + (f[r].className || "") + '">' + (p ? p(r) : "&nbsp;") + "</td>");
                    d.push(g.join(""))
                }
                return t('<div class="k-scheduler-header k-state-default"><div class="k-scheduler-header-wrap">' + o(_) + i(d, "k-scheduler-header-all-day") + "</div></div>")
            }

            function l(e, n, i) {
                var s, r, l, a, u, c, h = Array(n).join().split(","),
                    d = [];
                for (r = 0; r < e.length; r++)
                    for (l = e[r], a = n / l.length, s = 0; s < l.length; s++) u = l[s].className || "", c = l[s].text, l[s].allDay && (u = "k-scheduler-times-all-day"), i && u.indexOf("k-scheduler-group-cell") !== -1 && (c = '<span class="k-scheduler-group-text">' + c + "</span>"), h[a * s] += '<th class="' + u + '" rowspan="' + a + '">' + c + "</th>";
                for (s = 0; s < n; s++) d.push(h[s]);
                return n < 1 ? t() : t('<div class="k-scheduler-times">' + o(d) + "</div>")
            }

            function a() {
                return t('<div class="k-scheduler-content"><table role="presentation"' + n() + ' class="k-scheduler-table"/></div>')
            }

            function u() {
                return y = y ? y : b.support.scrollbar()
            }

            function c(t, e, n) {
                var o, i, s, r, l;
                for (o = t.length - 1; o >= 0; o--) i = h(t[o]), s = i.start, l = i.end, r = s <= e && l >= e, (r || s >= e && l <= n || e <= s && n >= s) && (s < e && (e = s), l > n && (n = l));
                return d(t, e, n)
            }

            function h(t) {
                return {
                    start: t.start,
                    end: t.end
                }
            }

            function d(t, e, n) {
                var o, i, s = [];
                for (o = 0; o < t.length; o++) i = h(t[o]), (i.start < e && i.end > e || i.start >= e && i.end <= n) && s.push(t[o]);
                return s
            }

            function f(t) {
                return p(t)
            }

            function g(t) {
                return p(t)
            }

            function p(t) {
                var e, n, o, i, s, r, l, a = [];
                for (e = 0; e < t.length; e++) {
                    for (n = t[e], o = h(n), i = null, s = 0, r = a.length; s < r; s++)
                        if (l = o.start > a[s].end, o.start < a[s].start || l) {
                            i = a[s], i.end < o.end && (i.end = o.end);
                            break
                        }
                    i || (i = {
                        start: o.start,
                        end: o.end,
                        events: []
                    }, a.push(i)), i.events.push(n)
                }
                return a
            }

            function _(e, n, o, i) {
                var s = [];
                return t.each(n, function(t, n) {
                    var r = n.className ? "k-slot-cell " + n.className : "k-slot-cell",
                        l = {
                            text: n.text,
                            className: r
                        };
                    l[e] = i && !n.minorTicks ? _(e, n.columns, o, i) : o, s.push(l)
                }), s
            }

            function v(e, n, o, i, s, r) {
                var l, a, u, c = n[0],
                    h = [];
                if (c) {
                    if (s && o) t.each(s, function(t, o) {
                        o[e] = r && !o.minorTicks ? v(e, n, o.columns, i, o.columns, r) : v(e, n, null, i)
                    }), h = s;
                    else
                        for (l = c.dataSource.view(), a = 0; a < l.length; a++) u = {
                            text: i({
                                text: b.htmlEncode(b.getter(c.dataTextField)(l[a])),
                                color: b.getter(c.dataColorField)(l[a]),
                                field: c.field,
                                title: c.title,
                                name: c.name,
                                value: b.getter(c.dataValueField)(l[a])
                            }),
                            className: "k-slot-cell k-scheduler-group-cell"
                        }, u[e] = v(e, n.slice(1), o, i), h.push(u);
                    return h
                }
                return o
            }

            function m(e) {
                return function(n) {
                    if (t.isArray(n) || n instanceof b.data.ObservableArray) {
                        for (var o = 0; o < n.length; o++)
                            if (n[o] == e) return !0;
                        return !1
                    }
                    return n == e
                }
            }

            function S(t) {
                t.className = t.className.replace(D, "") + " k-state-selected"
            }
            var y, C, D, b = window.kendo,
                x = b.ui,
                k = b.date.getDate,
                w = x.Widget,
                I = b._outerHeight,
                H = b.keys,
                T = ".kendoSchedulerView",
                R = "k-event-inverse",
                L = 1024,
                z = Math,
                E = '<div class="k-marquee k-scheduler-marquee"><div class="k-marquee-color"></div><div class="k-marquee-text"><div class="k-label-top"></div><div class="k-label-bottom"></div></div></div>',
                G = b.Class.extend({
                    init: function(t, e) {
                        this._index = t, this._timeSlotCollections = [], this._daySlotCollections = [], this._isRtl = e
                    },
                    addTimeSlotCollection: function(t, e) {
                        return this._addCollection(t, e, this._timeSlotCollections)
                    },
                    addDaySlotCollection: function(t, e) {
                        return this._addCollection(t, e, this._daySlotCollections)
                    },
                    _addCollection: function(t, e, n) {
                        var o = new A(t, e, this._index, n.length);
                        return n.push(o), o
                    },
                    timeSlotCollectionCount: function() {
                        return this._timeSlotCollections.length
                    },
                    daySlotCollectionCount: function() {
                        return this._daySlotCollections.length
                    },
                    daySlotByPosition: function(t, e, n) {
                        return this._slotByPosition(t, e, this._daySlotCollections, n)
                    },
                    timeSlotByPosition: function(t, e, n) {
                        return this._slotByPosition(t, e, this._timeSlotCollections, n)
                    },
                    _slotByPosition: function(t, e, n, o) {
                        var i, s, r, l, a, u, c, h, d;
                        for (i = 0; i < n.length; i++)
                            for (s = n[i], r = 0; r < s.count(); r++)
                                if (l = s.at(r), a = l.offsetWidth, u = l.offsetHeight, h = l.offsetLeft + a, d = l.offsetTop + u, o || (c = s.at(r + 1)), c && (c.offsetLeft != l.offsetLeft ? h = this._isRtl ? l.offsetLeft + (l.offsetLeft - c.offsetLeft) : c.offsetLeft : d = c.offsetTop), t >= l.offsetLeft && t < h && e >= l.offsetTop && e < d) return l
                    },
                    refresh: function() {
                        var t;
                        for (t = 0; t < this._daySlotCollections.length; t++) this._daySlotCollections[t].refresh();
                        for (t = 0; t < this._timeSlotCollections.length; t++) this._timeSlotCollections[t].refresh()
                    },
                    timeSlotRanges: function(t, e) {
                        var n, o = this._timeSlotCollections,
                            i = this._startSlot(t, o);
                        if (i.slot && !i.inRange && t >= i.slot.end && (i = null), n = i, t < e && (n = this._endSlot(e, o)), n && n.slot && !n.inRange && e <= n.slot.start && (n = null), null === i && null === n) return [];
                        if (null === i && n.slot) {
                            if (n.slot.end <= t) return [];
                            i = {
                                inRange: !0,
                                slot: o[n.slot.collectionIndex].first()
                            }
                        }
                        if (null === n && i.slot) {
                            if (i.slot.start >= e) return [];
                            n = {
                                inRange: !0,
                                slot: o[i.slot.collectionIndex].last()
                            }
                        }
                        if (!i.slot || !n.slot) return [];
                        return this._continuousRange(W, o, i, n)
                    },
                    daySlotRanges: function(t, e, n) {
                        var o, i = this._daySlotCollections,
                            s = this._startSlot(t, i, n);
                        if (s.slot && !s.inRange && t >= s.slot.end && (s = null), o = s, t < e && (o = this._endSlot(e, i, n)), o && o.slot && !o.inRange && e <= o.slot.start && (o = null), null === s && null === o) return [];
                        if (null === s && o.slot) {
                            if (o.slot.end <= t) return [];
                            do t += b.date.MS_PER_DAY, s = this._startSlot(t, i, n); while (!s.inRange && t >= s.slot.end)
                        }
                        if (null === o && s.slot) {
                            if (s.slot.start >= e) return [];
                            do e -= b.date.MS_PER_DAY, o = this._endSlot(e, i, n); while (!o.inRange && e <= o.slot.start)
                        }
                        if (!s.slot || !o.slot) return [];
                        return this._continuousRange(M, i, s, o)
                    },
                    _continuousRange: function(t, e, n, o) {
                        var i, s, r, l, a, u, c = n.slot,
                            h = o.slot,
                            d = c.collectionIndex,
                            f = h.collectionIndex,
                            g = [];
                        for (i = d; i <= f; i++) s = e[i], r = s.first(), l = s.last(), a = !1, u = !1, i == d && (u = !n.inRange), i == f && (a = !o.inRange), r.start < c.start && (r = c), l.start > h.start && (l = h), d < f && (i == d ? a = !0 : i == f ? u = !0 : a = u = !0), g.push(new t({
                            start: r,
                            end: l,
                            collection: s,
                            head: a,
                            tail: u
                        }));
                        return g
                    },
                    slotRanges: function(t, e) {
                        var n = t._startTime || b.date.toUtcTime(t.start),
                            o = t._endTime || b.date.toUtcTime(t.end);
                        return void 0 === e && (e = t.isMultiDay()), e ? this.daySlotRanges(n, o, t.isAllDay) : this.timeSlotRanges(n, o)
                    },
                    ranges: function(t, e, n, o) {
                        return "number" != typeof t && (t = b.date.toUtcTime(t)), "number" != typeof e && (e = b.date.toUtcTime(e)), n ? this.daySlotRanges(t, e, o) : this.timeSlotRanges(t, e)
                    },
                    _startCollection: function(t, e) {
                        var n, o;
                        for (n = 0; n < e.length; n++)
                            if (o = e[n], o.startInRange(t)) return o;
                        return null
                    },
                    _endCollection: function(t, e, n) {
                        var o, i;
                        for (o = 0; o < e.length; o++)
                            if (i = e[o], i.endInRange(t, n)) return i;
                        return null
                    },
                    _getCollections: function(t) {
                        return t ? this._daySlotCollections : this._timeSlotCollections
                    },
                    continuousSlot: function(t, e) {
                        var n = e ? -1 : 1,
                            o = this._getCollections(t.isDaySlot),
                            i = o[t.collectionIndex + n];
                        return i ? i[e ? "last" : "first"]() : void 0
                    },
                    firstSlot: function() {
                        var t = this._getCollections(this.daySlotCollectionCount());
                        return t[0].first()
                    },
                    lastSlot: function() {
                        var t = this._getCollections(this.daySlotCollectionCount());
                        return t[t.length - 1].last()
                    },
                    upSlot: function(t, e, n) {
                        var o = this,
                            i = function(t, n, i) {
                                var s = 0 === i;
                                if (!e && !t && s && o.daySlotCollectionCount()) return o._daySlotCollections[0].at(n)
                            };
                        return this.timeSlotCollectionCount() || (e = !0), this._verticalSlot(t, -1, i, n)
                    },
                    downSlot: function(t, e, n) {
                        var o = this,
                            i = function(t, n, i) {
                                if (!e && t && o.timeSlotCollectionCount()) return o._timeSlotCollections[i].at(0)
                            };
                        return this.timeSlotCollectionCount() || (e = !0), this._verticalSlot(t, 1, i, n)
                    },
                    leftSlot: function(t, e) {
                        return this._horizontalSlot(t, -1, e)
                    },
                    rightSlot: function(t, e) {
                        return this._horizontalSlot(t, 1, e)
                    },
                    _horizontalSlot: function(t, e, n) {
                        var o, i = t.index,
                            s = t.isDaySlot,
                            r = t.collectionIndex,
                            l = this._getCollections(s);
                        return s = !n && s, s ? i += e : r += e, o = l[r], o ? o.at(i) : void 0
                    },
                    _verticalSlot: function(t, e, n, o) {
                        var i, s = t.index,
                            r = t.isDaySlot,
                            l = t.collectionIndex,
                            a = this._getCollections(r);
                        return (t = n(r, l, s)) ? t : (r = !o && r, r ? l += e : s += e, i = a[l], i ? i.at(s) : void 0)
                    },
                    _collection: function(t, e) {
                        var n = e ? this._daySlotCollections : this._timeSlotCollections;
                        return n[t]
                    },
                    _startSlot: function(t, e, n) {
                        var o, i = this._startCollection(t, e),
                            s = !0;
                        return i || (i = e[0], s = !1), o = i.slotByStartDate(t, n), o || (o = i.first(), s = !1), {
                            slot: o,
                            inRange: s
                        }
                    },
                    _endSlot: function(t, e, n) {
                        var o, i = this._endCollection(t, e, n),
                            s = !0;
                        return i || (i = e[e.length - 1], s = !1), o = i.slotByEndDate(t, n), o || (o = i.last(), s = !1), {
                            slot: o,
                            inRange: s
                        }
                    },
                    getSlotCollection: function(t, e) {
                        return this[e ? "getDaySlotCollection" : "getTimeSlotCollection"](t)
                    },
                    getTimeSlotCollection: function(t) {
                        return this._timeSlotCollections[t]
                    },
                    getDaySlotCollection: function(t) {
                        return this._daySlotCollections[t]
                    }
                }),
                B = b.Class.extend({
                    init: function(e) {
                        t.extend(this, e)
                    },
                    innerHeight: function() {
                        var t, e = this.collection,
                            n = this.start.index,
                            o = this.end.index,
                            i = 0;
                        for (t = n; t <= o; t++) i += e.at(t).offsetHeight;
                        return i
                    },
                    events: function() {
                        return this.collection.events()
                    },
                    addEvent: function(t) {
                        this.events().push(t)
                    },
                    startSlot: function() {
                        return this.start.offsetLeft > this.end.offsetLeft ? this.end : this.start
                    },
                    endSlot: function() {
                        return this.start.offsetLeft > this.end.offsetLeft ? this.start : this.end
                    }
                }),
                W = B.extend({
                    innerHeight: function() {
                        var t, e = this.collection,
                            n = this.start.index,
                            o = this.end.index,
                            i = 0;
                        for (t = n; t <= o; t++) i += e.at(t).offsetHeight;
                        return i
                    },
                    outerRect: function(t, e, n) {
                        return this._rect("offset", t, e, n)
                    },
                    _rect: function(t, e, n, o) {
                        var i, s, r, l, a, u, c, h, d = this.start,
                            f = this.end,
                            g = b.support.isRtl(d.element);
                        return "number" != typeof e && (e = b.date.toUtcTime(e)), "number" != typeof n && (n = b.date.toUtcTime(n)), o ? (i = d.offsetTop, s = f.offsetTop + f[t + "Height"], g ? (r = f.offsetLeft, l = d.offsetLeft + d[t + "Width"]) : (r = d.offsetLeft, l = f.offsetLeft + f[t + "Width"])) : (a = e - d.start, a < 0 && (a = 0), u = d.end - d.start, i = d.offsetTop + d[t + "Height"] * a / u, c = f.end - n, c < 0 && (c = 0), h = f.end - f.start, s = f.offsetTop + f[t + "Height"] - f[t + "Height"] * c / h, g ? (r = Math.round(f.offsetLeft + f[t + "Width"] * c / h), l = Math.round(d.offsetLeft + d[t + "Width"] - d[t + "Width"] * a / u)) : (r = Math.round(d.offsetLeft + d[t + "Width"] * a / u), l = Math.round(f.offsetLeft + f[t + "Width"] - f[t + "Width"] * c / h))), {
                            top: i,
                            bottom: s,
                            left: 0 === r ? r : r + 1,
                            right: l
                        }
                    },
                    innerRect: function(t, e, n) {
                        return this._rect("client", t, e, n)
                    }
                }),
                M = B.extend({
                    innerWidth: function() {
                        var t, e = this.collection,
                            n = this.start.index,
                            o = this.end.index,
                            i = 0,
                            s = n !== o ? "offsetWidth" : "clientWidth";
                        for (t = n; t <= o; t++) i += e.at(t)[s];
                        return i
                    }
                }),
                A = b.Class.extend({
                    init: function(t, e, n, o) {
                        this._slots = [], this._events = [], this._start = b.date.toUtcTime(t), this._end = b.date.toUtcTime(e), this._groupIndex = n, this._collectionIndex = o
                    },
                    refresh: function() {
                        for (var t = 0; t < this._slots.length; t++) this._slots[t].refresh()
                    },
                    startInRange: function(t) {
                        return this._start <= t && t < this._end
                    },
                    endInRange: function(t, e) {
                        var n = e ? t < this._end : t <= this._end;
                        return this._start <= t && n
                    },
                    slotByStartDate: function(t) {
                        var e, n, o = t;
                        for ("number" != typeof o && (o = b.date.toUtcTime(t)), e = 0; e < this._slots.length; e++)
                            if (n = this._slots[e], n.startInRange(o)) return n;
                        return null
                    },
                    slotByEndDate: function(t, e) {
                        var n, o, i = t;
                        if ("number" != typeof i && (i = b.date.toUtcTime(t)), e) return this.slotByStartDate(t, !1);
                        for (n = 0; n < this._slots.length; n++)
                            if (o = this._slots[n], o.endInRange(i)) return o;
                        return null
                    },
                    count: function() {
                        return this._slots.length
                    },
                    events: function() {
                        return this._events
                    },
                    addTimeSlot: function(t, e, n, o) {
                        var i = new F(t, e, n, this._groupIndex, this._collectionIndex, this._slots.length, o);
                        this._slots.push(i)
                    },
                    addDaySlot: function(t, e, n, o) {
                        var i = new N(t, e, n, this._groupIndex, this._collectionIndex, this._slots.length, o);
                        this._slots.push(i)
                    },
                    first: function() {
                        return this._slots[0]
                    },
                    last: function() {
                        return this._slots[this._slots.length - 1]
                    },
                    at: function(t) {
                        return this._slots[t]
                    }
                }),
                V = b.Class.extend({
                    init: function(t, e, n, o, i, s) {
                        this.element = t, this.clientWidth = t.clientWidth, this.clientHeight = t.clientHeight, this.offsetWidth = t.offsetWidth, this.offsetHeight = t.offsetHeight, this.offsetTop = t.offsetTop, this.offsetLeft = t.offsetLeft, this.start = e, this.end = n, this.element = t, this.groupIndex = o, this.collectionIndex = i, this.index = s, this.isDaySlot = !1
                    },
                    refresh: function() {
                        var t = this.element;
                        this.clientWidth = t.clientWidth, this.clientHeight = t.clientHeight, this.offsetWidth = t.offsetWidth, this.offsetHeight = t.offsetHeight, this.offsetTop = t.offsetTop, this.offsetLeft = t.offsetLeft
                    },
                    startDate: function() {
                        return b.timezone.toLocalDate(this.start)
                    },
                    endDate: function() {
                        return b.timezone.toLocalDate(this.end)
                    },
                    startInRange: function(t) {
                        return this.start <= t && t < this.end
                    },
                    endInRange: function(t) {
                        return this.start < t && t <= this.end
                    },
                    startOffset: function() {
                        return this.start
                    },
                    endOffset: function() {
                        return this.end
                    }
                }),
                F = V.extend({
                    init: function(t, e, n, o, i, s, r) {
                        V.fn.init.apply(this, arguments), this.isHorizontal = !!r
                    },
                    offsetX: function(t, e) {
                        return t ? this.offsetLeft + e : this.offsetLeft + e
                    },
                    startInRange: function(t) {
                        return this.start <= t && t < this.end
                    },
                    endInRange: function(t) {
                        return this.start < t && t <= this.end
                    },
                    startOffset: function(e, n, o) {
                        var i, s, r, l, a;
                        if (o) return this.start;
                        if (i = t(this.element).offset(), s = this.end - this.start, this.isHorizontal) {
                            if (a = b.support.isRtl(this.element), r = e - i.left, l = Math.floor(s * (r / this.offsetWidth)), a) return this.start + s - l
                        } else r = n - i.top, l = Math.floor(s * (r / this.offsetHeight));
                        return this.start + l
                    },
                    endOffset: function(e, n, o) {
                        var i, s, r, l, a;
                        if (o) return this.end;
                        if (i = t(this.element).offset(), s = this.end - this.start, this.isHorizontal) {
                            if (a = b.support.isRtl(this.element), r = e - i.left, l = Math.floor(s * (r / this.offsetWidth)), a) return this.start + s - l
                        } else r = n - i.top, l = Math.floor(s * (r / this.offsetHeight));
                        return this.start + l
                    }
                }),
                N = V.extend({
                    init: function(t, e, n, o, i, s, r) {
                        if (V.fn.init.apply(this, arguments), this.eventCount = r, this.isDaySlot = !0, this.element.children.length) {
                            var l = this.element.children[0];
                            this.firstChildHeight = l.offsetHeight, this.firstChildTop = l.offsetTop
                        } else this.firstChildHeight = 3, this.firstChildTop = 0
                    },
                    startDate: function() {
                        var t = new Date(this.start);
                        return b.timezone.apply(t, "Etc/UTC")
                    },
                    endDate: function() {
                        var t = new Date(this.end);
                        return b.timezone.apply(t, "Etc/UTC")
                    },
                    startInRange: function(t) {
                        return this.start <= t && t < this.end
                    },
                    endInRange: function(t) {
                        return this.start < t && t <= this.end
                    }
                });
            b.ui.SchedulerView = w.extend({
                init: function(e, n) {
                    w.fn.init.call(this, e, n), this._normalizeOptions(), this._scrollbar = u(), this._isRtl = b.support.isRtl(e), this._resizeHint = t(), this._moveHint = t(), this._cellId = b.guid(), this._resourcesForGroups(), this._selectedSlots = []
                },
                visibleEndDate: function() {
                    return this.endDate()
                },
                _normalizeOptions: function() {
                    var t = this.options;
                    t.startTime && t.startTime.setMilliseconds(0), t.endTime && t.endTime.setMilliseconds(0), t.workDayStart && t.workDayStart.setMilliseconds(0), t.workDayEnd && t.workDayEnd.setMilliseconds(0)
                },
                _isMobile: function() {
                    var t = this.options;
                    return t.mobile === !0 && b.support.mobileOS || "phone" === t.mobile || "tablet" === t.mobile
                },
                _addResourceView: function() {
                    var t = new G(this.groups.length, this._isRtl);
                    return this.groups.push(t), t
                },
                dateForTitle: function() {
                    return b.format(this.options.selectedDateFormat, this.startDate(), this.endDate())
                },
                shortDateForTitle: function() {
                    return b.format(this.options.selectedShortDateFormat, this.startDate(), this.endDate())
                },
                mobileDateForTitle: function() {
                    return b.format(this.options.selectedMobileDateFormat || this.options.selectedShortDateFormat, this.startDate(), this.endDate())
                },
                _changeGroup: function(t, e) {
                    var n = e ? "prevGroupSlot" : "nextGroupSlot",
                        o = this[n](t.start, t.groupIndex, t.isAllDay);
                    return o && (t.groupIndex += e ? -1 : 1), this._isGroupedByDate() && !o && (t.groupIndex = e ? this.groups.length - 1 : 0), o
                },
                _changeDate: function(t, e, n) {
                    var o, i, s, r = this.groups[t.groupIndex];
                    if (n) {
                        if (o = r._getCollections(!1), i = r.daySlotCollectionCount() ? e.index - 1 : e.collectionIndex - 1, i >= 0) return o[i]._slots[o[i]._slots.length - 1]
                    } else if (o = r._getCollections(r.daySlotCollectionCount()), i = r.daySlotCollectionCount() ? 0 : e.collectionIndex + 1, s = r.daySlotCollectionCount() ? e.collectionIndex + 1 : 0, o[i] && o[i]._slots[s]) return o[i]._slots[s]
                },
                _changeGroupContinuously: function() {
                    return null
                },
                _changeViewPeriod: function() {
                    return !1
                },
                _isInRange: function(t, e) {
                    return !!(t && e && this.options.min && this.options.max) && (k(t) <= k(this.options.min) || k(e) >= k(this.options.max))
                },
                _horizontalSlots: function(t, e, n, o) {
                    var i, s, r, l = o ? "leftSlot" : "rightSlot",
                        a = {
                            startSlot: e[0].start,
                            endSlot: e[e.length - 1].end
                        },
                        u = this.groups[t.groupIndex],
                        c = this._isVerticallyGrouped();
                    return n || (i = this._normalizeHorizontalSelection(t, e, o), i && (a.startSlot = a.endSlot = i)), this._isGroupedByDate() && !n ? (s = this._changeGroup(t, o), s ? a.startSlot = a.endSlot = s : a = this._getNextHorizontalRange(u, l, a)) : (a.startSlot = u[l](a.startSlot), a.endSlot = u[l](a.endSlot), n || c || a.startSlot && a.endSlot || (a.startSlot = a.endSlot = this._changeGroup(t, o))), a.startSlot && a.endSlot || this._isGroupedByDate() || (r = this._continuousSlot(t, e, o), r = this._changeGroupContinuously(t, r, n, o), r && (a.startSlot = a.endSlot = r)), a
                },
                _getNextHorizontalRange: function(t, e, n) {
                    return this._isVerticallyGrouped() || (n.startSlot = t[e](n.startSlot), n.endSlot = t[e](n.endSlot)), n
                },
                _verticalSlots: function(t, e, n, o) {
                    var i, s, r = this.groups[t.groupIndex],
                        l = {
                            startSlot: e[0].start,
                            endSlot: e[e.length - 1].end
                        };
                    return n || (i = this._normalizeVerticalSelection(t, e, o), i && (l.startSlot = l.endSlot = i)), s = o ? "upSlot" : "downSlot", l = this._getNextVerticalRange(r, s, l, n), n || !this._isVerticallyGrouped() || l.startSlot && l.endSlot || (l.startSlot = l.endSlot = this._isGroupedByDate() ? this._changeDate(t, i, o) : this._changeGroup(t, o)), l
                },
                _getNextVerticalRange: function(t, e, n, o) {
                    return n.startSlot = t[e](n.startSlot, o), n.endSlot = t[e](n.endSlot, o), n
                },
                _normalizeHorizontalSelection: function() {
                    return null
                },
                _normalizeVerticalSelection: function(t, e, n) {
                    var o;
                    return o = n ? e[0].start : e[e.length - 1].end
                },
                _continuousSlot: function() {
                    return null
                },
                _footer: function() {
                    var e, n = this,
                        o = n.options;
                    n._isMobile() && (e = '<div class="k-header k-scheduler-footer">', e += '<span class="k-state-default k-scheduler-today"><a href="#" class="k-link">', e += o.messages.today + "</a></span>", e += "</div>", n.footer = t(e).appendTo(n.element)), n.footer && n.footer.on("click" + T, ".k-scheduler-today", function(t) {
                        var e, i, s, r, l;
                        t.preventDefault(), e = n.options.timezone, i = "today", s = new Date, e ? (l = b.timezone.offset(s, e), r = b.timezone.convert(s, s.getTimezoneOffset(), l)) : r = s, n.trigger("navigate", {
                            view: n.name || o.name,
                            action: i,
                            date: r
                        })
                    })
                },
                constrainSelection: function(t) {
                    var e, n = this.groups[0];
                    this.inRange(t) ? n.daySlotCollectionCount() ? n.timeSlotCollectionCount() || (t.isAllDay = !0) : t.isAllDay = !1 : (e = n.firstSlot(), t.isAllDay = e.isDaySlot, t.start = e.startDate(), t.end = e.endDate()), this.groups[t.groupIndex] || (t.groupIndex = 0)
                },
                move: function(t, e, n) {
                    var o, i, s, r, l, a, u = !1,
                        c = this.groups[t.groupIndex],
                        h = this._isGroupedByDate() && this._isVerticallyGrouped();
                    if (c.timeSlotCollectionCount() || (t.isAllDay = !0), o = c.ranges(t.start, t.end, t.isAllDay, !1), e === H.DOWN || e === H.UP) {
                        if (u = !0, r = e === H.UP, this._updateDirection(t, o, n, r, !0), l = this._verticalSlots(t, o, n, r), !l.startSlot && !n && this._changeViewPeriod(t, r, !h)) return u
                    } else if (o.length && (e === H.LEFT || e === H.RIGHT) && (u = !0, r = e === H.LEFT, this._updateDirection(t, o, n, r, !1), l = this._horizontalSlots(t, o, n, r), !l.startSlot && !n && this._changeViewPeriod(t, r, h))) return u;
                    return u && (i = l.startSlot, s = l.endSlot, n ? (a = t.backward, a && i ? t.start = i.startDate() : !a && s && (t.end = s.endDate())) : i && s && (t.isAllDay = i.isDaySlot, t.start = i.startDate(), t.end = s.endDate()), t.events = []), u
                },
                moveToEventInGroup: function(e, n, o, i) {
                    var s, r, l, a, u = e._continuousEvents || [],
                        c = i ? -1 : 1,
                        h = u.length,
                        d = i ? h - 1 : 0;
                    if (o.length)
                        for (l = o[o.length - 1], a = 0; a < u.length; a++) u[a].uid === l && (d = a + c);
                    for (; d < h && d > -1;) {
                        if (r = u[d], (!i && r.start.startDate() >= n.startDate() || i && r.start.startDate() <= n.startDate()) && r && t.inArray(r.uid, o) === -1) {
                            s = !!r;
                            break
                        }
                        d += c
                    }
                    return r
                },
                moveToEvent: function(t, e) {
                    var n, o, i, s, r, l, a = t.groupIndex,
                        u = this.groups[a],
                        c = u.ranges(t.start, t.end, t.isAllDay, !1)[0].start,
                        h = this.groups.length,
                        d = e ? -1 : 1,
                        f = t.events;
                    if (this._isGroupedByDate())
                        if (o = this._getAllEvents(), i = this._getUniqueEvents(o), s = this._getSortedEvents(i), 0 === f.length) r = this._getNextEventIndexBySlot(c, s, a), e && r--, n = s[r];
                        else
                            for (l = this._getStartIdx(f, s); l < s.length && l > -1 && (f.length > 0 && (c = this._getSelectedSlot(c, s, n, l, d, e)), c);) {
                                if ((!e && s[l].start.startDate() >= c.startDate() || e && s[l].start.startDate() <= c.startDate()) && f[0] != s[l].uid) {
                                    n = s[l];
                                    break
                                }
                                l += d
                            } else
                                for (; a < h && a > -1 && (n = this.moveToEventInGroup(u, c, f, e), a += d, u = this.groups[a], u && !n);) f = [], c = e ? u.lastSlot() : u.firstSlot(!0);
                    return n && (t.events = [n.uid], t.start = n.start.startDate(), t.end = n.end.endDate(), t.isAllDay = n.start.isDaySlot, t.groupIndex = n.start.groupIndex), !!n
                },
                current: function(t) {
                    return void 0 === t ? this._current : (this._current = t, void(this.content.has(t) && this._scrollTo(t, this.content[0])))
                },
                select: function(t) {
                    this.clearSelection(), this._selectEvents(t) || this._selectSlots(t)
                },
                _getNextEventIndexBySlot: function(t, e, n) {
                    var o, i, s = 0,
                        r = b.date.getDate(t.startDate());
                    for (o = 0; o < e.length; o++)
                        if (i = b.date.getDate(e[o].start.startDate()), r > i) s++;
                        else if (r.getTime() === i.getTime() && n > e[o].start.groupIndex) s++;
                    else {
                        if (!(r.getTime() === i.getTime() && n >= e[o].start.groupIndex && t.startDate() > e[o].start.startDate())) break;
                        s++
                    }
                    return s
                },
                _getSelectedSlot: function(t, e, n, o, i, s) {
                    var r, l;
                    return e[o + i] && e[o].start.groupIndex !== e[o + i].start.groupIndex && (r = e[o + i].start.groupIndex, l = this.groups[r], l && !n || (t = null), t = s ? l.lastSlot() : l.firstSlot(!0)), t
                },
                _getStartIdx: function(e, n) {
                    var o = 0;
                    return t.each(n, function() {
                        return this.uid !== e[0] && void o++
                    }), o
                },
                _getAllEvents: function() {
                    var t, e = [],
                        n = this.groups;
                    for (t = 0; t < n.length; t++) n[t]._continuousEvents && (e = e.concat(n[t]._continuousEvents));
                    return e
                },
                _getUniqueEvents: function(t) {
                    var e, n, o, i = [];
                    for (e = 0; e < t.length; e++) {
                        for (n = !1, o = 0; o < i.length; o++)
                            if (t[e].uid === i[o].uid) {
                                n = !0;
                                break
                            }
                        n || i.push(t[e])
                    }
                    return i
                },
                _getSortedEvents: function(e) {
                    return e.sort(function(e, n) {
                        var o = e.start.startDate(),
                            i = n.start.startDate(),
                            s = b.date.getDate(o) - b.date.getDate(i);
                        return 0 === s && (s = e.start.groupIndex - n.start.groupIndex), 0 === s && (s = o.getTime() - i.getTime()), 0 === s && (e.start.isDaySlot && !n.start.isDaySlot && (s = -1), !e.start.isDaySlot && n.start.isDaySlot && (s = 1)), 0 === s && (s = t(e.element).index() - t(n.element).index()), s
                    })
                },
                _selectSlots: function(t) {
                    var e, n, o, i, s, r, l, a = t.isAllDay,
                        u = this.groups[t.groupIndex];
                    for (u.timeSlotCollectionCount() || (a = !0), this._selectedSlots = [], e = u.ranges(t.start, t.end, a, !1), i = 0; i < e.length; i++)
                        for (s = e[i], r = s.collection, l = s.start.index; l <= s.end.index; l++) o = r.at(l), n = o.element, n.setAttribute("aria-selected", !0), S(n), this._selectedSlots.push({
                            start: o.startDate(),
                            end: o.endDate(),
                            element: n
                        });
                    t.backward && (n = e[0].start.element), this.current(n)
                },
                _selectEvents: function(e) {
                    var n, o, i, s = !1,
                        r = e.events,
                        l = this._getAllEvents(),
                        a = l.length;
                    if (!r[0] || !l[0]) return s;
                    for (i = t(), e.events = [], n = 0; n < a; n++) t.inArray(l[n].uid, r) > -1 && (o = l[n], i = i.add(o.element), e.events.indexOf(o.uid) === -1 && e.events.push(o.uid));
                    return i[0] && (i.addClass("k-state-selected").attr("aria-selected", !0), this.current(i.last()[0]), this._selectedSlots = [], s = !0), s
                },
                inRange: function(t) {
                    var e = this.startDate(),
                        n = b.date.addDays(this.endDate(), 1),
                        o = t.start,
                        i = t.end;
                    return e <= o && o < n && e < i && i <= n
                },
                _resourceValue: function(t, e) {
                    return t.valuePrimitive && (e = b.getter(t.dataValueField)(e)), e
                },
                _resourceBySlot: function(t) {
                    var e, n, o, i, s, r = this.groupedResources,
                        l = {};
                    if (r.length)
                        for (e = t.groupIndex, n = r.length - 1; n >= 0; n--) o = r[n], i = this._resourceValue(o, o.dataSource.view()[e % o.dataSource.total()]), o.multiple && (i = [i]), s = b.setter(o.field), s(l, i), e = Math.floor(e / o.dataSource.total());
                    return l
                },
                _createResizeHint: function(e, n, o, i) {
                    return t(E).css({
                        left: e,
                        top: n,
                        width: o,
                        height: i
                    })
                },
                _removeResizeHint: function() {
                    this._resizeHint.remove(), this._resizeHint = t()
                },
                _removeMoveHint: function(e) {
                    e ? (this._moveHint.filter("[data-uid='" + e + "']").remove(), this._moveHint = this._moveHint.filter("[data-uid!='" + e + "']")) : (this._moveHint.remove(), this._moveHint = t())
                },
                _scrollTo: function(t, e) {
                    var n = t.offsetTop,
                        o = t.offsetHeight,
                        i = e.scrollTop,
                        s = e.clientHeight,
                        r = n + o,
                        l = 0;
                    l = i > n ? n : r > i + s ? o <= s ? r - s : n : i, e.scrollTop = l
                },
                _inverseEventColor: function(t) {
                    var e = t.css("color"),
                        n = new C(e).isDark(),
                        o = t.css("background-color"),
                        i = new C(o).isDark();
                    n == i && t.addClass(R)
                },
                _eventTmpl: function(e, n) {
                    var o, i = this.options,
                        s = t.extend({}, b.Template, i.templateSettings),
                        r = s.paramName,
                        l = "",
                        a = typeof e,
                        u = {
                            storage: {},
                            count: 0
                        };
                    return "function" === a ? (u.storage["tmpl" + u.count] = e, l += "#=this.tmpl" + u.count + "(" + r + ")#", u.count++) : "string" === a && (l += e), o = b.template(b.format(n, l), s), u.count > 0 && (o = t.proxy(o, u.storage)), o
                },
                eventResources: function(t) {
                    var e, n, o, i, s, r, l, a, u, c, h = [],
                        d = this.options;
                    if (!d.resources) return h;
                    for (e = 0; e < d.resources.length; e++)
                        if (n = d.resources[e], o = n.field, i = b.getter(o)(t), null != i)
                            for (n.multiple || (i = [i]), s = n.dataSource.view(), r = 0; r < i.length; r++) {
                                for (l = null, a = i[r], n.valuePrimitive || (a = b.getter(n.dataValueField)(a)), u = 0; u < s.length; u++)
                                    if (s[u].get(n.dataValueField) == a) {
                                        l = s[u];
                                        break
                                    }
                                null !== l && (c = b.getter(n.dataColorField)(l), h.push({
                                    field: n.field,
                                    title: n.title,
                                    name: n.name,
                                    text: b.getter(n.dataTextField)(l),
                                    value: a,
                                    color: c
                                }))
                            }
                        return h
                },
                createLayout: function(o) {
                    var i, s, r, l, a, u = -1;
                    for (o.rows || (o.rows = []), i = 0; i < o.rows.length; i++)
                        if (o.rows[i].allDay) {
                            u = i;
                            break
                        }
                    s = o.rows[u], u >= 0 && o.rows.splice(u, 1), r = this.columnLevels = e(o, "columns"), l = this.rowLevels = e(o, "rows"), this.table = t('<table role="presentation"' + n() + ' class="k-scheduler-layout k-scheduler-' + this.name + 'view"><tbody></tbody></table>'), a = l[l.length - 1].length, this.table.find("tbody:first").append(this._topSection(r, s, a)), this.table.find("tbody:first").append(this._bottomSection(r, l, a)), this.element.append(this.table), this._isMobile() && r.length > 1 && "horizontal" === this._groupOrientation() && b._outerWidth(t(window)) < L && (this.table.find(".k-scheduler-content .k-scheduler-table").width(100 * r[r.length - 2].length + "%"), this.table.find(".k-scheduler-header .k-scheduler-table").width(100 * r[r.length - 2].length + "%")), this._scroller()
                },
                refreshLayout: function() {
                    var e, n, o, i, s, r, l = this,
                        a = l.element.find(">.k-scheduler-toolbar"),
                        u = l.element.innerHeight(),
                        c = this._scrollbar,
                        h = 0,
                        d = this._isRtl ? "left" : "right";
                    for (e = 0; e < a.length; e++) u -= I(a.eq(e));
                    l.datesHeader && (h = I(l.datesHeader)), l.timesHeader && I(l.timesHeader) > h && (h = I(l.timesHeader)), l.datesHeader && l.timesHeader && (n = l.datesHeader.find("table:first tr"), l.timesHeader.find("tr").height(function(e) {
                        t(this).height(n.eq(e).height())
                    })), h && (u -= h), l.footer && (u -= I(l.footer)), o = function(t) {
                        var e, n;
                        return !!t[0].style.height || (e = t.height(), t.height("auto"), n = t.height(), e != n ? (t.height(""), !0) : (t.height(""), !1))
                    }, i = l.content[0], s = b.support.kineticScrollNeeded ? 0 : c, o(l.element) && (l.content.height(u > 2 * c ? u : 2 * c + 1), l.times.height(i.clientHeight), r = l.times.find("table"), r.length && r.height(l.content.find("table")[0].clientHeight)), i.offsetWidth - i.clientWidth > 0 ? (l.table.addClass("k-scrollbar-v"), l.datesHeader.css("padding-" + d, s - parseInt(l.datesHeader.children().css("border-" + d + "-width"), 10))) : l.datesHeader.css("padding-" + d, ""), i.offsetHeight - i.clientHeight > 0 || i.clientHeight > l.content.children(".k-scheduler-table").height() ? l.table.addClass("k-scrollbar-h") : l.table.removeClass("k-scrollbar-h")
                },
                _topSection: function(e, n, o) {
                    var i, l = t("<tr>"),
                        a = e[e.length - 1].length;
                    return this.timesHeader = s(e.length, n, o), this.datesHeader = r(e, a, n), i = this.datesHeader.find(".k-nav-day"), i.length && i.closest("tr").addClass("k-scheduler-date-group"), this._isMobile() && (l.addClass("k-mobile-header"), l.addClass("k-mobile-" + this._groupOrientation() + "-header")), t(l).append(this.timesHeader.add(this.datesHeader).wrap("<td>").parent())
                },
                _bottomSection: function(e, n, o) {
                    return this.times = l(n, o, this._isMobile()), this.content = a(e[e.length - 1], n[n.length - 1]), t("<tr>").append(this.times.add(this.content).wrap("<td>").parent())
                },
                _scroller: function() {
                    var e, n = this;
                    this.content.bind("scroll" + T, function() {
                        n.datesHeader.find(">.k-scheduler-header-wrap").scrollLeft(this.scrollLeft), n.times.scrollTop(this.scrollTop)
                    }), e = b.touchScroller(this.content, {
                        avoidScrolling: function(e) {
                            return t(e.event.target).closest(".k-event.k-event-active").length > 0
                        }
                    }), e && e.movable && (this._touchScroller = e, this.content = e.scrollElement, e.movable.bind("change", function(t) {
                        n.datesHeader.find(">.k-scheduler-header-wrap").scrollLeft(-t.sender.x), n.times.scrollTop(-t.sender.y)
                    }))
                },
                _resourcesForGroups: function() {
                    var t, e, n, o, i = [],
                        s = this.options.group,
                        r = this.options.resources;
                    if (s = s && s.resources ? s.resources : [], r && s.length)
                        for (t = 0, e = r.length; t < e; t++)
                            for (n = 0, o = s.length; n < o; n++) r[t].name === s[n] && i.push(r[t]);
                    this.groupedResources = i
                },
                _createDateLayout: function(t, e, n) {
                    return _("rows", t, e, n)
                },
                _createColumnsLayout: function(t, e, n, o, i) {
                    return v("columns", t, e, n, o, i)
                },
                _groupOrientation: function() {
                    var t = this.options.group;
                    return t && t.resources ? t.orientation : "horizontal"
                },
                _isGroupedByDate: function() {
                    return this.options.group && this.options.group.date
                },
                _isVerticallyGrouped: function() {
                    return this.groupedResources.length && "vertical" === this._groupOrientation()
                },
                _createRowsLayout: function(t, e, n, o) {
                    return v("rows", t, e, n, o)
                },
                selectionByElement: function() {
                    return null
                },
                clearSelection: function() {
                    this.content.find(".k-state-selected").removeAttr("id").attr("aria-selected", !1).removeClass("k-state-selected")
                },
                destroy: function() {
                    var t = this;
                    w.fn.destroy.call(this), t.table && (b.destroy(t.table), t.table.remove()), t.footer && (b.destroy(t.footer), t.footer.remove()), t.groups = null, t.table = null, t.content = null, t.times = null, t.datesHeader = null, t.timesHeader = null, t.footer = null, t._resizeHint = null, t._moveHint = null
                },
                calendarInfo: function() {
                    return b.getCulture().calendars.standard
                },
                prevGroupSlot: function(t, e, n) {
                    var o, i = this.groups[e],
                        s = i.ranges(t, t, n, !1)[0].start;
                    if (!(e <= 0)) return this._isGroupedByDate() ? s : this._isVerticallyGrouped() ? i.timeSlotCollectionCount() ? (o = i._collection(n ? s.index : s.collectionIndex, !1), o.last()) : (o = i._collection(i.daySlotCollectionCount() - 1, !0), o.at(s.index)) : i.timeSlotCollectionCount() ? (o = i._collection(n ? 0 : i.timeSlotCollectionCount() - 1, n), n ? o.last() : o.at(s.index)) : (o = i._collection(s.collectionIndex, !0), o.last())
                },
                nextGroupSlot: function(t, e, n) {
                    var o, i, s = this.groups[e],
                        r = s.ranges(t, t, n, !1)[0].start;
                    if (!(e >= this.groups.length - 1)) return this._isGroupedByDate() ? r : this._isVerticallyGrouped() ? s.timeSlotCollectionCount() ? (i = s.daySlotCollectionCount(), o = s._collection(i ? 0 : r.collectionIndex, i), n ? o.first() : o.at(r.collectionIndex)) : (o = s._collection(0, !0), o.at(r.index)) : s.timeSlotCollectionCount() ? (o = s._collection(0, n), n ? o.first() : o.at(r.index)) : (o = s._collection(r.collectionIndex, !0), o.first())
                },
                _eventOptionsForMove: function() {
                    return {}
                },
                _updateEventForResize: function() {},
                _updateEventForSelection: function(t) {
                    return t
                }
            }), C = function(t) {
                var e, n, o, i, s, r = this,
                    l = C.formats;
                if (1 === arguments.length)
                    for (t = r.resolveColor(t), i = 0; i < l.length; i++) e = l[i].re, n = l[i].process, o = e.exec(t), o && (s = n(o), r.r = s[0], r.g = s[1], r.b = s[2]);
                else r.r = arguments[0], r.g = arguments[1], r.b = arguments[2];
                r.r = r.normalizeByte(r.r), r.g = r.normalizeByte(r.g), r.b = r.normalizeByte(r.b)
            }, C.prototype = {
                resolveColor: function(t) {
                    return t = t || "#000", "#" == t.charAt(0) && (t = t.substr(1, 6)), t = t.replace(/ /g, ""), t = t.toLowerCase(), t = C.namedColors[t] || t
                },
                normalizeByte: function(t) {
                    return t < 0 || isNaN(t) ? 0 : t > 255 ? 255 : t
                },
                percBrightness: function() {
                    var t = this;
                    return z.sqrt(.241 * t.r * t.r + .691 * t.g * t.g + .068 * t.b * t.b)
                },
                isDark: function() {
                    var t = this,
                        e = t.percBrightness();
                    return e < 180
                }
            }, C.formats = [{
                re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
                process: function(t) {
                    return [parseInt(t[1], 10), parseInt(t[2], 10), parseInt(t[3], 10)]
                }
            }, {
                re: /^(\w{2})(\w{2})(\w{2})$/,
                process: function(t) {
                    return [parseInt(t[1], 16), parseInt(t[2], 16), parseInt(t[3], 16)]
                }
            }, {
                re: /^(\w{1})(\w{1})(\w{1})$/,
                process: function(t) {
                    return [parseInt(t[1] + t[1], 16), parseInt(t[2] + t[2], 16), parseInt(t[3] + t[3], 16)]
                }
            }], C.namedColors = {
                aqua: "00ffff",
                azure: "f0ffff",
                beige: "f5f5dc",
                black: "000000",
                blue: "0000ff",
                brown: "a52a2a",
                coral: "ff7f50",
                cyan: "00ffff",
                darkblue: "00008b",
                darkcyan: "008b8b",
                darkgray: "a9a9a9",
                darkgreen: "006400",
                darkorange: "ff8c00",
                darkred: "8b0000",
                dimgray: "696969",
                fuchsia: "ff00ff",
                gold: "ffd700",
                goldenrod: "daa520",
                gray: "808080",
                green: "008000",
                greenyellow: "adff2f",
                indigo: "4b0082",
                ivory: "fffff0",
                khaki: "f0e68c",
                lightblue: "add8e6",
                lightgrey: "d3d3d3",
                lightgreen: "90ee90",
                lightpink: "ffb6c1",
                lightyellow: "ffffe0",
                lime: "00ff00",
                limegreen: "32cd32",
                linen: "faf0e6",
                magenta: "ff00ff",
                maroon: "800000",
                mediumblue: "0000cd",
                navy: "000080",
                olive: "808000",
                orange: "ffa500",
                orangered: "ff4500",
                orchid: "da70d6",
                pink: "ffc0cb",
                plum: "dda0dd",
                purple: "800080",
                red: "ff0000",
                royalblue: "4169e1",
                salmon: "fa8072",
                silver: "c0c0c0",
                skyblue: "87ceeb",
                slateblue: "6a5acd",
                slategray: "708090",
                snow: "fffafa",
                steelblue: "4682b4",
                tan: "d2b48c",
                teal: "008080",
                tomato: "ff6347",
                turquoise: "40e0d0",
                violet: "ee82ee",
                wheat: "f5deb3",
                white: "ffffff",
                whitesmoke: "f5f5f5",
                yellow: "ffff00",
                yellowgreen: "9acd32"
            }, D = /\s*k-state-selected/, t.extend(x.SchedulerView, {
                createColumns: f,
                createRows: g,
                rangeIndex: h,
                collidingEvents: c,
                groupEqFilter: m
            })
        }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, n) {
    (n || e)()
});;
! function(e, define) {
    define("kendo.scheduler.dayview.min", ["kendo.scheduler.view.min"], e)
}(function() {
    return function(e, t) {
        function a(e) {
            var t = new Date(1980, 1, 1, 0, 0, 0);
            return h(t, w(e)), t
        }

        function s(e, t, a) {
            return e >= t && e <= a
        }

        function i(e, t, a, s) {
            return s = s ? e <= a : e < a, e > t && s
        }

        function n(e, t, a, s) {
            var i, n = e._continuousEvents,
                o = n[n.length - 1],
                l = g(t.start.startDate()).getTime();
            if (s && o && g(o.start.startDate()).getTime() == l) {
                for (i = n.length - 1; i > -1 && !(n[i].isAllDay || g(n[i].start.startDate()).getTime() < l); i--);
                n.splice(i + 1, 0, {
                    element: a,
                    isAllDay: !0,
                    uid: a.attr(r.attr("uid")),
                    start: t.start,
                    end: t.end
                })
            } else n.push({
                element: a,
                isAllDay: s,
                uid: a.attr(r.attr("uid")),
                start: t.start,
                end: t.end
            })
        }

        function o(e) {
            var t = [],
                a = e.workWeekStart % 7,
                s = Math.abs(e.workWeekEnd % 7);
            for (t.push(a); s != a;) a > 6 ? a -= 7 : a++, t.push(a);
            return t
        }
        var r = window.kendo,
            l = r.ui,
            d = r.support.browser,
            h = r.date.setTime,
            u = l.SchedulerView,
            c = r._outerWidth,
            p = r._outerHeight,
            f = e.extend,
            m = e.proxy,
            g = r.date.getDate,
            _ = r.date.MS_PER_MINUTE,
            v = r.date.MS_PER_DAY,
            y = "k-current-time",
            D = "k-current-time-arrow",
            k = "k-event-inverse",
            T = .8666,
            w = r.date.getMilliseconds,
            S = ".kendoMultiDayView",
            C = r.template('<div title="(#=kendo.format("{0:t} - {1:t}", start, end)#): #=title.replace(/"/g,"&\\#34;")#"><div class="k-event-template k-event-time">#:kendo.format("{0:t} - {1:t}", start, end)#</div><div class="k-event-template">${title}</div></div>'),
            b = r.template('<div title="(#=kendo.format("{0:t}", start)#): #=title.replace(/"/g,"&\\#34;")#"><div class="k-event-template">${title}</div></div>'),
            x = r.template("#var dateString = isMobile ? kendo.toString(date,'ddd')[0] : kendo.toString(date,'ddd M/dd'); #<span class='k-link k-nav-day'>#=dateString#</span>"),
            E = '<div role="gridcell" aria-selected="false" data-#=ns#uid="#=uid#"#if (resources[0]) { #style="background-color:#=resources[0].color#; border-color: #=resources[0].color#"class="k-event"#} else {#class="k-event"#}#><span class="k-event-actions"># if(data.tail || data.middle) {#<span class="k-icon k-i-arrow-60-left"></span>#}## if(data.isException()) {#<span class="k-icon k-i-non-recurrence"></span># } else if(data.isRecurring()) {#<span class="k-icon k-i-reload"></span># } #</span>{0}<span class="k-event-actions">#if (showDelete) {#<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>#}## if(data.head || data.middle) {#<span class="k-icon k-i-arrow-60-right"></span>#}#</span>#if(resizable && !singleDay && !data.tail && !data.middle){#<span class="k-resize-handle k-resize-w"></span>#}##if(resizable && !singleDay && !data.head && !data.middle){#<span class="k-resize-handle k-resize-e"></span>#}#</div>',
            H = '<div role="gridcell" aria-selected="false" data-#=ns#uid="#=uid#" #if (resources[0]) { #style="background-color:#=resources[0].color #; border-color: #=resources[0].color#"class="k-event"#} else {#class="k-event"#}#><span class="k-event-actions"># if(data.isException()) {#<span class="k-icon k-i-non-recurrence"></span># } else if(data.isRecurring()) {#<span class="k-icon k-i-reload"></span># } #</span>{0}<span class="k-event-actions">#if (showDelete) {#<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>#}#</span><span class="k-event-top-actions"># if(data.tail || data.middle) {#<span class="k-icon k-i-arrow-60-up"></span># } #</span><span class="k-event-bottom-actions"># if(data.head || data.middle) {#<span class="k-icon k-i-arrow-60-down"></span># } #</span># if(resizable && !data.tail && !data.middle) {#<span class="k-resize-handle k-resize-n"></span># } ## if(resizable && !data.head && !data.middle) {#<span class="k-resize-handle k-resize-s"></span># } #</div>',
            M = u.extend({
                init: function(e, t) {
                    var a = this;
                    u.fn.init.call(a, e, t), a.title = a.options.title || a.options.name, a._workDays = o(a.options), a._templates(), a._editable(), a.calculateDateRange(), a._groups(), a._currentTime(!0)
                },
                _currentTimeMarkerUpdater: function() {
                    this._updateCurrentTimeMarker(new Date)
                },
                _updateCurrentTimeMarker: function(t) {
                    var a, s, i, n, o, l, h, u, f, m, g, _, v, k, w, S, C, b, x, E, H = this.options,
                        M = "<div class='" + y + "'></div>";
                    for (H.currentTimeMarker.useLocalTimezone === !1 && (o = H.dataSource.options.schema.timezone, H.dataSource && o && (l = r.timezone.offset(t, o), t = r.timezone.convert(t, t.getTimezoneOffset(), l))), a = this.times.find("." + y), s = this.content.find("." + y), h = H.group && "horizontal" != H.group.orientation ? this.groups.length : 1, u = this.times.find("tr:first th:first"), f = this.times.find("tr:first th:last"), m = this.content[0].scrollWidth, (d.msie || d.edge) && (m -= 1), n = this._isRtl ? (u && u.position() ? u.position().left + p(u) - p(f) : undefined) : (f && f.position() ? f.position().left : undefined), g = 0; g < h; g++) {
                        if (_ = this.groups[g], !_) return;
                        if (v = r.date.toUtcTime(t), k = _.timeSlotRanges(v, v + 1), 0 === k.length) return;
                        w = k[0].collection, S = w.slotByStartDate(t), S && (C = a[g] ? a.eq(g) : e(M).prependTo(this.times), b = Math.round(k[0].innerRect(t, new Date(t.getTime() + 1), !1).top), x = {}, this._isRtl ? (x.right = n, C.addClass(D + "-left")) : (x.left = n, C.addClass(D + "-right")), i || (i = c(C) * T / 2), x.top = b - i, C.css(x), E = s[g] ? s.eq(g) : e(M).prependTo(this.content), E.css({
                            top: b,
                            height: "1px",
                            right: 0,
                            width: m,
                            left: 0
                        }))
                    }
                },
                _currentTime: function(e) {
                    var a = this,
                        s = a.options.currentTimeMarker;
                    s !== !1 && s.updateInterval !== t && (a._currentTimeMarkerUpdater(), e && (a._currentTimeUpdateTimer = setInterval(m(this._currentTimeMarkerUpdater, a), s.updateInterval)))
                },
                _updateResizeHint: function(e, t, a, s) {
                    var i, n, o, l, d, h, c, p, f, m, g, _, v = e.isMultiDay(),
                        y = this.groups[t],
                        D = y.ranges(a, s, v, e.isAllDay);
                    for (this._removeResizeHint(), d = 0; d < D.length; d++)
                        if (h = D[d], c = h.startSlot(), this._isGroupedByDate() && v)
                            for (p = c.index; p <= h.end.index; p++) f = h.collection._slots[p], i = f.offsetWidth, n = f.clientHeight, o = f.offsetTop, l = u.fn._createResizeHint.call(this, f.offsetLeft, o, i, n), this._resizeHint = this._resizeHint.add(l);
                        else i = c.offsetWidth, n = c.clientHeight, o = c.offsetTop, v ? i = h.innerWidth() : (m = h.outerRect(a, s, this.options.snap), o = m.top, n = m.bottom - m.top), l = u.fn._createResizeHint.call(this, c.offsetLeft, o, i, n), this._resizeHint = this._resizeHint.add(l);
                    g = "t", _ = this.content, v && (g = "M/dd", _ = this.element.find(".k-scheduler-header-wrap:has(.k-scheduler-header-all-day) > div"), _.length || (_ = this.content)), this._resizeHint.appendTo(_), this._resizeHint.find(".k-label-top,.k-label-bottom").text(""), this._resizeHint.first().addClass("k-first").find(".k-label-top").text(r.toString(r.timezone.toLocalDate(a), g)), this._resizeHint.last().addClass("k-last").find(".k-label-bottom").text(r.toString(r.timezone.toLocalDate(s), g))
                },
                _updateMoveHint: function(t, a, s) {
                    var i, n, o, l, d, h, u, c, p, f, m = t.isMultiDay(),
                        g = this.groups[a],
                        _ = r.date.toUtcTime(t.start) + s,
                        v = _ + t.duration(),
                        y = g.ranges(_, v, m, t.isAllDay);
                    for (_ = r.timezone.toLocalDate(_), v = r.timezone.toLocalDate(v), this._removeMoveHint(t.uid), !m && (0 === w(v) || w(v) < w(this.startTime())) && y.length > 1 && y.pop(), i = e(), n = 0; n < y.length; n++)
                        if (o = y[n], l = o.start, h = {
                                left: l.offsetLeft + 2,
                                top: l.offsetTop
                            }, this._isGroupedByDate() && m)
                            for (u = l.index; u <= o.end.index; u++) c = o.collection._slots[u], h.left = this._isRtl ? .1 * c.clientWidth + c.offsetLeft + 2 : c.offsetLeft + 2, h.height = c.offsetHeight, h.width = .9 * c.clientWidth - 2, d = this._createEventElement(t.clone({
                                start: _,
                                end: v
                            }), !m), t.inverseColor && d.addClass(k), this._appendMoveHint(d, h), i = i.add(d);
                        else this._isRtl && (h.left = .1 * l.clientWidth + l.offsetLeft + 2), m ? h.width = o.innerWidth() - 2 : (p = o.outerRect(_, v, this.options.snap), h.top = p.top, h.height = p.bottom - p.top, h.width = .9 * l.clientWidth - 2), d = this._createEventElement(t.clone({
                            start: _,
                            end: v
                        }), !m), t.inverseColor && d.addClass(k), this._appendMoveHint(d, h), i = i.add(d);
                    f = this.content, m && (f = this.element.find(".k-scheduler-header-wrap:has(.k-scheduler-header-all-day) > div"), f.length || (f = this.content)), i.appendTo(f)
                },
                _appendMoveHint: function(e, t) {
                    e.addClass("k-event-drag-hint"), e.css(t), this._moveHint = this._moveHint.add(e)
                },
                _slotByPosition: function(e, t) {
                    var a, s, i, n;
                    for (this._isVerticallyGrouped() ? (s = this.content.offset(), t += this.content[0].scrollTop, e += this.content[0].scrollLeft) : s = this.element.find(".k-scheduler-header-wrap:has(.k-scheduler-header-all-day)").find(">div").offset(), s && (e -= s.left, t -= s.top), e = Math.ceil(e), t = Math.ceil(t), n = 0; n < this.groups.length; n++)
                        if (i = this.groups[n], a = i.daySlotByPosition(e, t, this._isGroupedByDate())) return a;
                    for (s && (e += s.left, t += s.top), s = this.content.offset(), e -= s.left, t -= s.top, this._isVerticallyGrouped() || (t += this.content[0].scrollTop, e += this.content[0].scrollLeft), e = Math.ceil(e), t = Math.ceil(t), n = 0; n < this.groups.length; n++)
                        if (i = this.groups[n], a = i.timeSlotByPosition(e, t)) return a;
                    return null
                },
                _groupCount: function() {
                    var e = this.groupedResources,
                        t = this._isGroupedByDate();
                    return e.length ? "vertical" === this._groupOrientation() ? t ? this._columnCountForLevel(e.length - 1) : this._rowCountForLevel(e.length - 1) : t ? this._columnCountForLevel(e.length) / this._columnCountForLevel(0) : this._columnCountForLevel(e.length) / this._columnOffsetForResource(e.length) : 1
                },
                _columnCountInResourceView: function() {
                    var e = this.groupedResources,
                        t = this._isGroupedByDate();
                    return !e.length || this._isVerticallyGrouped() ? t ? this._rowCountForLevel(0) : this._columnCountForLevel(0) : t ? this._columnCountForLevel(0) : this._columnOffsetForResource(e.length)
                },
                _timeSlotGroups: function(e, t) {
                    var a, s, i, n, o, r, l, d, h, u, c = this._timeSlotInterval(),
                        p = e,
                        f = this._isGroupedByDate(),
                        m = this.content.find("tr:not(.k-scheduler-header-all-day)");
                    for (m.attr("role", "row"), o = m.length, this._isVerticallyGrouped() && (f && (p = t), o = Math.floor(o / p)), r = 0; r < p; r++)
                        for (l = 0, d = 0, this._isVerticallyGrouped() ? l = r : d = r, i = l * o; i < (l + 1) * o;) {
                            if (h = m[i].children, i % o === 0 && (s = w(new Date((+this.startTime())))), u = 0, f)
                                if (this._isVerticallyGrouped())
                                    for (n = 0; n < e; n++) a = this.groups[n], this._addTimeSlotGroup(a, h, n, s, c, r);
                                else
                                    for (a = this.groups[r], n = d; n < e * t; n += e) this._addTimeSlotGroup(a, h, n, s, c, u), u++;
                            else
                                for (a = this.groups[r], n = d * t; n < (d + 1) * t; n++) this._addTimeSlotGroup(a, h, n, s, c, u), u++;
                            s += c, i++
                        }
                },
                _addTimeSlotGroup: function(e, t, a, s, i, n) {
                    var o, r, l, d = t[a],
                        h = e.getTimeSlotCollection(n),
                        u = this._dates[n];
                    u && d && (o = Date.UTC(u.getFullYear(), u.getMonth(), u.getDate()), r = o + s, l = r + i, d.setAttribute("role", "gridcell"), d.setAttribute("aria-selected", !1), h.addTimeSlot(d, r, l))
                },
                _addDaySlotGroup: function(e, t, a, s, i) {
                    var n, o = t[a],
                        l = this._dates[i];
                    l && (n = Date.UTC(l.getFullYear(), l.getMonth(), l.getDate()), o.setAttribute("role", "gridcell"), o.setAttribute("aria-selected", !1), e.addDaySlot(o, n, n + r.date.MS_PER_DAY))
                },
                _daySlotGroups: function(e, t) {
                    var a, s, i, n, o, r, l, d = window.kendo.support.browser, h, u = e,
                        c = this._isGroupedByDate();
                    for (this._isVerticallyGrouped() ? (c && (u = t), a = d.msie ? $(".k-scheduler-header-all-day") : this.element.find(".k-scheduler-header-all-day")) : a = d.msie ? $(".k-scheduler-header-all-day tr") : this.element.find(".k-scheduler-header-all-day tr"), a.attr("role", "row"), i = 0; i < u; i++)
                        if (n = 0, this._isVerticallyGrouped() && (n = i), l = a[n].children, d = 0, this._isVerticallyGrouped() || (d = i), h = 0, c)
                            if (this._isVerticallyGrouped())
                                for (s = 0; s < e; s++) o = this.groups[s], r = o.getDaySlotCollection(0), this._addDaySlotGroup(r, l, s, t, i);
                            else
                                for (o = this.groups[i], r = o.getDaySlotCollection(0), s = d; s < e * t; s += e) this._addDaySlotGroup(r, l, s, t, h), h++;
                    else
                        for (o = this.groups[i], r = o.getDaySlotCollection(0), s = d * t; s < (d + 1) * t; s++) this._addDaySlotGroup(r, l, s, t, h), h++
                },
                _groups: function() {
                    var e, t, a, s = this._groupCount(),
                        i = this._columnCountInResourceView();
                    for (this.groups = [], e = 0; e < s; e++) {
                        for (t = this._addResourceView(e), a = 0; a < i; a++) this._dates[a] && t.addTimeSlotCollection(this._dates[a], r.date.addDays(this._dates[a], 1));
                        this.options.allDaySlot && t.addDaySlotCollection(this._dates[0], r.date.addDays(this._dates[this._dates.length - 1], 1))
                    }
                    this._timeSlotGroups(s, i), this.options.allDaySlot && this._daySlotGroups(s, i)
                },
                options: {
                    name: "MultiDayView",
                    selectedDateFormat: "{0:D}",
                    selectedShortDateFormat: "{0:d}",
                    selectedMobileDateFormat: "{0:MMM} {0:dd} - {1:dd}",
                    allDaySlot: !0,
                    showWorkHours: !1,
                    title: "",
                    startTime: r.date.today(),
                    endTime: r.date.today(),
                    minorTickCount: 2,
                    majorTick: 60,
                    majorTimeHeaderTemplate: "<span class='k-time-text'>#=kendo.toString(date, 'h:mm')#</span> <span class='k-time-period'>#=kendo.toString(date, 'tt')#</span>",
                    minorTimeHeaderTemplate: "&\\#8203;",
                    groupHeaderTemplate: "#=text#",
                    slotTemplate: "&nbsp;",
                    allDaySlotTemplate: "&nbsp;",
                    eventTemplate: C,
                    allDayEventTemplate: b,
                    dateHeaderTemplate: x,
                    editable: !0,
                    workDayStart: new Date(1980, 1, 1, 8, 0, 0),
                    workDayEnd: new Date(1980, 1, 1, 17, 0, 0),
                    workWeekStart: 1,
                    workWeekEnd: 5,
                    footer: {
                        command: "workDay"
                    },
                    messages: {
                        allDay: "all day",
                        showFullDay: "Show full day",
                        showWorkDay: "Show business hours"
                    },
                    currentTimeMarker: {
                        updateInterval: 1e4,
                        useLocalTimezone: !0
                    }
                },
                events: ["remove", "add", "edit"],
                _templates: function() {
                    var e = this.options,
                        t = f({}, r.Template, e.templateSettings);
                    this.eventTemplate = this._eventTmpl(e.eventTemplate, H), this.allDayEventTemplate = this._eventTmpl(e.allDayEventTemplate, E), this.majorTimeHeaderTemplate = r.template(e.majorTimeHeaderTemplate, t), this.minorTimeHeaderTemplate = r.template(e.minorTimeHeaderTemplate, t), this.dateHeaderTemplate = r.template(e.dateHeaderTemplate, t), this.slotTemplate = r.template(e.slotTemplate, t), this.allDaySlotTemplate = r.template(e.allDaySlotTemplate, t), this.groupHeaderTemplate = r.template(e.groupHeaderTemplate, t)
                },
                _editable: function() {
                    this.options.editable && (this._isMobile() ? this._touchEditable() : this._mouseEditable())
                },
                _mouseEditable: function() {
                    var t = this;
                    t.element.on("click" + S, ".k-event a:has(.k-i-close)", function(a) {
                        t.trigger("remove", {
                            uid: e(this).closest(".k-event").attr(r.attr("uid"))
                        }), a.preventDefault()
                    }), t.options.editable.create !== !1 && t.element.on("dblclick" + S, ".k-scheduler-content > table td", function(a) {
                        var s, i;
                        e(this).parent().hasClass("k-scheduler-header-all-day") || (s = t._slotByPosition(a.pageX, a.pageY), s && (i = t._resourceBySlot(s), t.trigger("add", {
                            eventInfo: f({
                                start: s.startDate(),
                                end: s.endDate()
                            }, i)
                        })), a.preventDefault())
                    }).on("dblclick" + S, ".k-scheduler-header-all-day td", function(e) {
                        var a, s = t._slotByPosition(e.pageX, e.pageY);
                        s && (a = t._resourceBySlot(s), t.trigger("add", {
                            eventInfo: f({}, {
                                isAllDay: !0,
                                start: r.date.getDate(s.startDate()),
                                end: r.date.getDate(s.startDate())
                            }, a)
                        })), e.preventDefault()
                    }), t.options.editable.update !== !1 && t.element.on("dblclick" + S, ".k-event", function(a) {
                        t.trigger("edit", {
                            uid: e(this).closest(".k-event").attr(r.attr("uid"))
                        }), a.preventDefault()
                    })
                },
                _touchEditable: function() {
                    var a = this,
                        s = 0;
                    r.support.mobileOS.android && (s = 5), a.options.editable.create !== !1 && (a._addUserEvents = new r.UserEvents(a.element, {
                        threshold: s,
                        filter: ".k-scheduler-content td",
                        useClickAsTap: !r.support.browser.edge,
                        tap: function(s) {
                            var i, n, o, r;
                            a._scrolling || e(s.target).parent().hasClass("k-scheduler-header-all-day") || (i = s.x.location !== t ? s.x.location : s.x, n = s.y.location !== t ? s.y.location : s.y, o = a._slotByPosition(i, n), o && (r = a._resourceBySlot(o), a.trigger("add", {
                                eventInfo: f({
                                    start: o.startDate(),
                                    end: o.endDate()
                                }, r)
                            })), s.preventDefault())
                        }
                    }), a._allDayUserEvents = new r.UserEvents(a.element, {
                        threshold: s,
                        useClickAsTap: !r.support.browser.edge,
                        filter: ".k-scheduler-header-all-day td",
                        tap: function(e) {
                            var s, i, n, o;
                            a._scrolling || (s = e.x.location !== t ? e.x.location : e.x, i = e.y.location !== t ? e.y.location : e.y, n = a._slotByPosition(s, i), n && (o = a._resourceBySlot(n), a.trigger("add", {
                                eventInfo: f({}, {
                                    isAllDay: !0,
                                    start: r.date.getDate(n.startDate()),
                                    end: r.date.getDate(n.startDate())
                                }, o)
                            })), e.preventDefault())
                        }
                    })), a.options.editable.update !== !1 && (a._editUserEvents = new r.UserEvents(a.element, {
                        threshold: s,
                        useClickAsTap: !r.support.browser.edge,
                        filter: ".k-event",
                        tap: function(t) {
                            var s, i;
                            a._scrolling || (s = e(t.target).closest(".k-event"), i = e(t.touch.initialTouch), i.hasClass("k-i-close") ? a.trigger("remove", {
                                uid: s.attr(r.attr("uid"))
                            }) : s.hasClass("k-event-active") || a.trigger("edit", {
                                uid: s.attr(r.attr("uid"))
                            }), t.preventDefault())
                        }
                    }))
                },
                _layout: function(e) {
                    var t, a, s, i = [],
                        n = [],
                        o = this.options,
                        l = this,
                        d = l._isGroupedByDate();
                    for (t = 0; t < e.length; t++) a = {}, a.text = l.dateHeaderTemplate({
                        date: e[t],
                        isMobile: l._isMobile()
                    }), r.date.isToday(e[t]) && (a.className = "k-today"), i.push(a);
                    return s = this.groupedResources, o.allDaySlot && n.push({
                        text: o.messages.allDay,
                        allDay: !0,
                        cellContent: function(t) {
                            var a = t;
                            return t = s.length && "vertical" !== l._groupOrientation() ? t % e.length : t, l.allDaySlotTemplate({
                                date: e[t],
                                resources: function() {
                                    return l._resourceBySlot({
                                        groupIndex: a
                                    })
                                }
                            })
                        }
                    }), this._forTimeRange(this.startTime(), this.endTime(), function(e, t, a, s) {
                        var i = t ? l.majorTimeHeaderTemplate : l.minorTimeHeaderTemplate,
                            o = {
                                text: i({
                                    date: e
                                }),
                                className: s ? "k-slot-cell" : ""
                            };
                        n.push(o)
                    }), s.length && ("vertical" === this._groupOrientation() ? d ? (n = this._createDateLayout(i, n), i = this._createColumnsLayout(s, null, this.groupHeaderTemplate)) : n = this._createRowsLayout(s, n, this.groupHeaderTemplate) : i = d ? this._createColumnsLayout(s, i, this.groupHeaderTemplate, i) : this._createColumnsLayout(s, i, this.groupHeaderTemplate)), {
                        columns: i,
                        rows: n
                    }
                },
                _footer: function() {
                    var t, a, s, i = this.options;
                    i.footer !== !1 && (t = '<div class="k-header k-scheduler-footer">', a = i.footer.command, this._isMobile() && (t += '<span class="k-state-default k-scheduler-today"><a href="#" class="k-link">', t += i.messages.today + "</a></span>"), a && "workDay" === a ? this._isMobile() ? (t += '<span class="k-state-default k-scheduler-fullday"><a href="#" class="k-link">', t += (i.showWorkHours ? i.messages.showFullDay : i.messages.showWorkDay) + "</a></span>") : (t += '<ul class="k-reset k-header">', t += '<li class="k-state-default k-scheduler-fullday"><a href="#" class="k-link"><span class="k-icon k-i-clock"></span>', t += (i.showWorkHours ? i.messages.showFullDay : i.messages.showWorkDay) + "</a></li>", t += "</ul>") : t += "&nbsp;", t += "</div>", this.footer = e(t).appendTo(this.element), s = this, this.footer.on("click" + S, ".k-scheduler-fullday", function(e) {
                        e.preventDefault(), s.trigger("navigate", {
                            view: s.name || i.name,
                            date: i.date,
                            isWorkDay: !i.showWorkHours
                        })
                    }), this.footer.on("click" + S, ".k-scheduler-today", function(e) {
                        var t, a, n, o, l;
                        e.preventDefault(), t = s.options.timezone, a = "today", n = new Date, t ? (l = r.timezone.offset(n, t), o = r.timezone.convert(n, n.getTimezoneOffset(), l)) : o = n, s.trigger("navigate", {
                            view: s.name || i.name,
                            action: a,
                            date: o
                        })
                    }))
                },
                _forTimeRange: function(e, t, s, i) {
                    var n, o, r, l, d, u, c, p, f, m, g, y, D, k, T, S;
                    for (e = a(e), t = a(t), n = this, o = w(e), r = w(t), l = n.options.minorTickCount, d = n.options.majorTick * _, u = d / l || 1, c = new Date((+e)), p = c.getDate(), m = 0, y = "", g = v / u, o != r && (o > r && (r += v), g = (r - o) / u), g = Math.round(g); m < g; m++) D = m % (d / u), k = 0 === D, T = D < l - 1, S = D === l - 1, y += s(c, k, T, S), h(c, u, !1);
                    return r && (f = w(c), p < c.getDate() && (f += v), f > r && (c = new Date((+t)))), i && (y += i(c)), y
                },
                _content: function(e) {
                    var t, a, s, i = this,
                        n = i.options,
                        o = i.startTime(),
                        r = this.endTime(),
                        l = 1,
                        d = 1,
                        h = e.length,
                        u = "",
                        c = this.groupedResources,
                        p = this.allDaySlotTemplate,
                        f = !1,
                        m = i._isGroupedByDate(),
                        g = 0;
                    for (c.length && (f = "vertical" === i._groupOrientation(), f ? (d = this._rowCountForLevel(this.rowLevels.length - 2), m && (l = this._columnCountForLevel(this.columnLevels.length - 1)), n.allDaySlot && (t = function(t) {
                            var a, s = '<tr class="k-scheduler-header-all-day">',
                                n = m ? 0 : t,
                                o = function() {
                                    return i._resourceBySlot({
                                        groupIndex: n
                                    })
                                };
                            if (m)
                                for (; n < l; n++) s += "<td>" + p({
                                    date: e[g],
                                    resources: o
                                }) + "</td>";
                            else
                                for (a = 0; a < e.length; a++) s += "<td>" + p({
                                    date: e[a],
                                    resources: o
                                }) + "</td>";
                            return s + "</tr>"
                        })) : l = m ? this._columnCountForLevel(this.columnLevels.length - 1) / this._columnCountForLevel(0) : this._columnCountForLevel(this.columnLevels.length - 2)), u += "<tbody>", a = function(t, a, n) {
                            var o, r, d, u = "",
                                c = 0;
                            if (u = "<tr" + (n ? ' class="k-middle-row"' : "") + ">", m)
                                for (o = 0, r = h; o < r; o++) {
                                    for (c = 0; c < l; c++) d = o, f && (d = g), u = i._addCellsToContent(u, e, t, d, c, s);
                                    if (f) break
                                } else
                                    for (; c < l; c++)
                                        for (o = 0, r = h; o < r; o++) u = i._addCellsToContent(u, e, t, o, c, s);
                            return u += "</tr>"
                        }, s = 0; s < d; s++) u += t ? t(s) : "", u += this._forTimeRange(o, r, a), f && g++;
                    u += "</tbody>", this.content.find("table").append(u)
                },
                _addCellsToContent: function(e, t, a, s, i, n) {
                    var o, l = this,
                        d = "",
                        h = this.slotTemplate,
                        u = "vertical" === this._groupOrientation(),
                        c = function(e) {
                            return function() {
                                return l._resourceBySlot({
                                    groupIndex: e
                                })
                            }
                        };
                    return r.date.isToday(t[s]) && (d += "k-today"), (r.date.getMilliseconds(a) < r.date.getMilliseconds(this.options.workDayStart) || r.date.getMilliseconds(a) >= r.date.getMilliseconds(this.options.workDayEnd) || !this._isWorkDay(t[s])) && (d += " k-nonwork-hour"), e += "<td" + ("" !== d ? ' class="' + d + '"' : "") + ">", o = r.date.getDate(t[s]), r.date.setTime(o, r.date.getMilliseconds(a)), e += h({
                        date: o,
                        resources: c(u && !l._isGroupedByDate() ? n : i)
                    }), e += "</td>"
                },
                _isWorkDay: function(e) {
                    var t, a = e.getDay(),
                        s = this._workDays;
                    for (t = 0; t < s.length; t++)
                        if (s[t] === a) return !0;
                    return !1
                },
                _render: function(t) {
                    var a, s = this;
                    t = t || [], this._dates = t, this._startDate = t[0], this._endDate = t[t.length - 1 || 0], this.createLayout(this._layout(t)), this._content(t), this._footer(), this.refreshLayout(), a = this.element.find(".k-scheduler-header-all-day td"), a.length && (this._allDayHeaderHeight = a.first()[0].clientHeight), s.element.on("click" + S, ".k-nav-day", function(t) {
                        var a, i = e(t.currentTarget).closest("th"),
                            n = i.offset(),
                            o = 0,
                            r = p(i);
                        s._isGroupedByDate() && (s._isVerticallyGrouped() ? (o = c(s.times), r = 0) : r = p(s.datesHeader)), a = s._slotByPosition(n.left + o, n.top + r), s.trigger("navigate", {
                            view: "day",
                            date: a.startDate()
                        })
                    })
                },
                startTime: function() {
                    var e = this.options;
                    return e.showWorkHours ? e.workDayStart : e.startTime
                },
                endTime: function() {
                    var e = this.options;
                    return e.showWorkHours ? e.workDayEnd : e.endTime
                },
                startDate: function() {
                    return this._startDate
                },
                endDate: function() {
                    return this._endDate
                },
                _end: function(e) {
                    var t = w(this.endTime()) || v;
                    return e && (t = 0), new Date(this._endDate.getTime() + t)
                },
                nextDate: function() {
                    return r.date.nextDay(this.endDate())
                },
                previousDate: function() {
                    return r.date.previousDay(this.startDate())
                },
                calculateDateRange: function() {
                    this._render([this.options.date])
                },
                destroy: function() {
                    var e = this;
                    e._currentTimeUpdateTimer && clearInterval(e._currentTimeUpdateTimer), e.datesHeader && e.datesHeader.off(S), e.element && e.element.off(S), e.footer && e.footer.remove(), u.fn.destroy.call(this), this._isMobile() && e.options.editable && (e.options.editable.create !== !1 && (e._addUserEvents.destroy(), e._allDayUserEvents.destroy()), e.options.editable.update !== !1 && e._editUserEvents.destroy())
                },
                inRange: function(e) {
                    var t, a, s, i, n = u.fn.inRange.call(this, e);
                    return e.isAllDay ? n : (t = w(this.startTime()), a = w(this.endTime()) || r.date.MS_PER_DAY, s = w(e.start), i = w(e.end) || r.date.MS_PER_DAY, n && t <= s && i <= a)
                },
                selectionByElement: function(e) {
                    var t = e.offset(),
                        a = Math.round(e.innerHeight()) - 5;
                    return this._slotByPosition(t.left, t.top + a)
                },
                _timeSlotInterval: function() {
                    var e = this.options;
                    return e.majorTick / e.minorTickCount * _
                },
                _timeSlotIndex: function(e) {
                    var t = this.options,
                        a = w(e),
                        s = w(this.startTime()),
                        i = t.majorTick / t.minorTickCount * _;
                    return (a - s) / i
                },
                _slotIndex: function(e, t) {
                    return t ? this._dateSlotIndex(e) : this._timeSlotIndex(e)
                },
                _dateSlotIndex: function(e, t) {
                    var a, i, n, o, l = this._dates || [],
                        d = 1;
                    for (a = 0, i = l.length; a < i; a++)
                        if (n = r.date.getDate(l[a]), o = new Date(r.date.getDate(l[a]).getTime() + v - (t ? 0 : 1)), s(e, n, o)) return a * d;
                    return -1
                },
                _positionAllDayEvent: function(t, a) {
                    var s, i, n, o, r, l, d, h = a.innerWidth(),
                        c = a.start.index,
                        p = a.end.index,
                        f = u.collidingEvents(a.events(), c, p),
                        m = this._headerColumnCount || 0,
                        g = 2,
                        _ = c !== p ? 3 : 2,
                        v = this._allDayHeaderHeight,
                        y = a.startSlot();
                    for (t.css({
                            left: y.offsetLeft + g,
                            width: h - _
                        }), a.addEvent({
                            slotIndex: c,
                            start: c,
                            end: p,
                            element: t
                        }), f.push({
                            slotIndex: c,
                            start: c,
                            end: p,
                            element: t
                        }), s = u.createRows(f), s.length && s.length > m && (this._headerColumnCount = s.length), i = a.start.offsetTop, n = 0, o = s.length; n < o; n++)
                        for (r = s[n].events, l = 0, d = r.length; l < d; l++) e(r[l].element).css({
                            top: i + n * v
                        })
                },
                _arrangeColumns: function(e, t, a, s) {
                    var i, n, o, r, l, d, h, c, p, f, m, g, _ = s.start;
                    for (e = {
                            element: e,
                            slotIndex: _.index,
                            start: t,
                            end: t + a
                        }, n = _.clientWidth, o = .1 * n, l = s.events(), d = u.collidingEvents(l, e.start, e.end), s.addEvent(e), d.push(e), i = u.createColumns(d), h = (n - o) / i.length, c = 0, p = i.length; c < p; c++)
                        for (r = i[c].events, f = 0, m = r.length; f < m; f++) g = h - 2, r[f].element[0].style.width = (g > 0 ? g : h) + "px", r[f].element[0].style.left = (this._isRtl ? o : 0) + _.offsetLeft + c * h + 2 + "px"
                },
                _positionEvent: function(e, t, a) {
                    var s = e._startTime || e.start,
                        i = e._endTime || e.end,
                        n = a.innerRect(s, i, !1),
                        o = n.bottom - n.top;
                    o < 0 && (o = 0), t.css({
                        top: n.top,
                        height: o
                    }), this._arrangeColumns(t, n.top, t[0].clientHeight, a)
                },
                _createEventElement: function(t, a, i, n) {
                    var o, l, d, h, u, c, p = a ? this.eventTemplate : this.allDayEventTemplate,
                        m = this.options,
                        _ = m.editable,
                        y = this._isMobile(),
                        D = _ && _.destroy !== !1 && !y,
                        k = _ && _.resize !== !1,
                        T = g(this.startDate()),
                        S = g(this.endDate()),
                        C = w(this.startTime()),
                        b = w(this.endTime()),
                        x = t._time("start"),
                        E = t._time("end");
                    return C >= b && (b = w(new Date(this.endTime().getTime() + v - 1))), a || t.isAllDay || (S = new Date(S.getTime() + v)), l = t.start, d = t.end, t.isAllDay && (d = g(t.end)), !s(g(l), T, S) && !s(d, T, S) || a && x < C && E > b ? o = !0 : g(l) < T || a && x < C ? n = !0 : (d > S && !a || a && E > b) && (i = !0), h = this.eventResources(t), t._startTime && x !== r.date.getMilliseconds(t.start) && (l = new Date(x), l = r.timezone.apply(l, "Etc/UTC")), t._endTime && E !== r.date.getMilliseconds(t.end) && (d = new Date(E), d = r.timezone.apply(d, "Etc/UTC")), u = f({}, {
                        ns: r.ns,
                        resizable: k,
                        showDelete: D,
                        middle: o,
                        head: i,
                        tail: n,
                        singleDay: 1 == this._dates.length,
                        resources: h,
                        inverseColor: !1,
                        messages: m.messages
                    }, t, {
                        start: l,
                        end: d
                    }), c = e(p(u)), this.angular("compile", function() {
                        return {
                            elements: c,
                            data: [{
                                dataItem: u
                            }]
                        }
                    }), c
                },
                _isInTimeSlot: function(e) {
                    var t, a = this.startTime(),
                        s = this.endTime(),
                        n = e._startTime || e.start,
                        o = e._endTime || e.end;
                    return w(s) === w(r.date.getDate(s)) && (s = r.date.getDate(s), h(s, v - 1)), e._date("end") > e._date("start") && (o = +e._date("end") + (v - 1)), o = e._endTime ? o - e._date("end") : w(new Date(o)), n = e._startTime ? n - e._date("start") : w(new Date(n)), s = w(s), a = w(a), a === n && n === o || (t = n !== s, i(n, a, s, t) || i(o, a, s, t) || i(a, n, o) || i(s, n, o))
                },
                _isInDateSlot: function(e) {
                    var t = this.groups[0],
                        a = t.firstSlot().start,
                        i = t.lastSlot().end - 1,
                        n = r.date.toUtcTime(e.start),
                        o = r.date.toUtcTime(e.end);
                    return (s(n, a, i) || s(o, a, i) || s(a, n, o) || s(i, n, o)) && (!s(o, a, a) || s(o, n, n) || e.isAllDay)
                },
                _updateAllDayHeaderHeight: function(e) {
                    var t, a;
                    if (this._height !== e && (this._height = e, t = this.element.find(".k-scheduler-header-all-day td"), t.length))
                        for (t.parent().add(this.element.find(".k-scheduler-times-all-day").parent()).height(e), a = 0; a < this.groups.length; a++) this.groups[a].refresh()
                },
                _renderEvents: function(e, t) {
                    var a, s, i, o, r, l, d, h, u, c, p, f, m, g, _, y, D, k, T, w, S, C = this.datesHeader.find(".k-scheduler-header-wrap > div"),
                        b = this._isGroupedByDate();
                    for (s = 0, i = e.length; s < i; s++)
                        if (a = e[s], this._isInDateSlot(a))
                            if (o = a.isAllDay || a.duration() >= v, r = o && !this._isVerticallyGrouped() ? C : this.content, o) {
                                if (this.options.allDaySlot && (p = this.groups[t], p._continuousEvents || (p._continuousEvents = []), d = p.slotRanges(a), d.length))
                                    if (h = d[0], y = h.start.index, D = h.end.index, b && y !== D)
                                        for (u = h.start.start, c = h.end.end, k = new Date(u), T = new Date(u), w = h.start.index; w <= h.end.index; w++) l = this._createEventElement(a, !o, w !== D, w !== y), S = p.daySlotRanges(k, T, !0)[0], T.setDate(T.getDate() + 1), k.setDate(k.getDate() + 1), this._positionAllDayEvent(l, S), n(p, S, l, !0), l.appendTo(r), this._inverseEventColor(l);
                                    else l = this._createEventElement(a, !o), this._positionAllDayEvent(l, d[0]), n(p, d[0], l, !0), l.appendTo(r), this._inverseEventColor(l)
                            } else if (this._isInTimeSlot(a))
                        for (p = this.groups[t], p._continuousEvents || (p._continuousEvents = []), d = p.slotRanges(a), f = d.length, m = 0; m < f; m++) h = d[m], u = a.start, c = a.end, f > 1 && (0 === m ? c = h.end.endDate() : m == f - 1 ? u = h.start.startDate() : (u = h.start.startDate(), c = h.end.endDate())), g = a.clone({
                            start: u,
                            end: c,
                            _startTime: a._startTime,
                            _endTime: a.endTime
                        }), this._isInTimeSlot(g) && (_ = h.head, l = this._createEventElement(a, !o, _, h.tail), l.appendTo(r), this._inverseEventColor(l), this._positionEvent(g, l, h), n(p, h, l, !1))
                },
                render: function(t) {
                    var a, i, n, o;
                    for (this._headerColumnCount = 0, this._groups(), this.element.find(".k-event").remove(), t = new r.data.Query(t).sort([{
                            field: "start",
                            dir: "asc"
                        }, {
                            field: "end",
                            dir: "desc"
                        }]).toArray(), a = [], this._eventsByResource(t, this.groupedResources, a), i = e.map(this._dates, function(t) {
                            return Math.max.apply(null, e.map(a, function(a) {
                                return e.grep(a, function(e) {
                                    return e.isMultiDay() && s(t, g(e.start), g(e.end))
                                }).length
                            }))
                        }), n = Math.max.apply(null, i), this._updateAllDayHeaderHeight((n + 1) * this._allDayHeaderHeight), o = 0; o < a.length; o++) this._renderEvents(a[o], o);
                    this.refreshLayout(), this._currentTime(!1), this.trigger("activate")
                },
                _eventsByResource: function(e, t, a) {
                    var s, i, n, o, l = t[0];
                    if (l)
                        for (s = l.dataSource.view(), i = 0; i < s.length; i++) n = this._resourceValue(l, s[i]), o = new r.data.Query(e).filter({
                            field: l.field,
                            operator: u.groupEqFilter(n)
                        }).toArray(), t.length > 1 ? this._eventsByResource(o, t.slice(1), a) : a.push(o);
                    else a.push(e)
                },
                _columnOffsetForResource: function(e) {
                    return this._columnCountForLevel(e) / this._columnCountForLevel(e - 1)
                },
                _columnCountForLevel: function(e) {
                    var t = this.columnLevels[e];
                    return t ? t.length : 0
                },
                _rowCountForLevel: function(e) {
                    var t = this.rowLevels[e];
                    return t ? t.length : 0
                },
                clearSelection: function() {
                    this.content.add(this.datesHeader).find(".k-state-selected").removeAttr("id").attr("aria-selected", !1).removeClass("k-state-selected")
                },
                _updateDirection: function(e, t, a, s, i) {
                    var n = e.isAllDay,
                        o = t[0].start,
                        r = t[t.length - 1].end;
                    a && (i ? n || o.index !== r.index || o.collectionIndex !== r.collectionIndex || (e.backward = s) : (n && o.index === r.index || !n && o.collectionIndex === r.collectionIndex) && (e.backward = s))
                },
                _changeViewPeriod: function(e, t, a) {
                    var s, i, n, o, r, l, d, u, c, p, f, m, g;
                    if (!a) return s = t ? this.previousDate() : this.nextDate(), i = e.start, n = e.end, o = this._isGroupedByDate() && this._isVerticallyGrouped(), r = this.groups[e.groupIndex], l = t ? r._timeSlotCollections : r._getCollections(r.daySlotCollectionCount()), d = l[l.length - 1]._slots, u = t || r.daySlotCollectionCount() ? d.length - 1 : 0, p = new Date(s), f = new Date(s), !this._isInRange(p, f) && (e.start = p, e.end = f, o ? (m = new Date(d[u].startDate()), g = new Date(d[u].endDate()), c = w(g) ? w(g) : v, h(e.start, w(m)), h(e.end, c), r.daySlotCollectionCount() && (e.isAllDay = !e.isAllDay)) : (c = e.isAllDay || !w(n) ? v : w(n), h(e.start, w(i)), h(e.end, c)), this._isVerticallyGrouped() || (e.groupIndex = t ? this.groups.length - 1 : 0), e.events = [], !0)
                }
            });
        f(!0, l, {
            MultiDayView: M,
            DayView: M.extend({
                options: {
                    name: "DayView",
                    title: "Day",
                    selectedMobileDateFormat: "{0:MMM d}"
                },
                name: "day"
            }),
            WeekView: M.extend({
                options: {
                    name: "WeekView",
                    title: "Week",
                    selectedDateFormat: "{0:D} - {1:D}",
                    selectedShortDateFormat: "{0:d} - {1:d}"
                },
                name: "week",
                calculateDateRange: function() {
                    var e, t, a = this.options.date,
                        s = r.date.dayOfWeek(a, this.calendarInfo().firstDay, -1),
                        i = [];
                    for (e = 0, t = 7; e < t; e++) i.push(s), s = r.date.nextDay(s);
                    this._render(i)
                }
            }),
            WorkWeekView: M.extend({
                options: {
                    name: "WorkWeekView",
                    title: "Work Week",
                    selectedDateFormat: "{0:D} - {1:D}",
                    selectedShortDateFormat: "{0:d} - {1:d}"
                },
                name: "workWeek",
                nextDate: function() {
                    var e = r.date.dayOfWeek(r.date.nextDay(this.startDate()), this.calendarInfo().firstDay, 1);
                    return r.date.addDays(e, this._workDays[0])
                },
                previousDate: function() {
                    var e = r.date.dayOfWeek(this.startDate(), this.calendarInfo().firstDay, -1),
                        t = this._workDays;
                    return r.date.addDays(e, t[t.length - 1] - 7)
                },
                calculateDateRange: function() {
                    for (var e = this.options.date, t = r.date.dayOfWeek, a = t(e, this.calendarInfo().firstDay, -1), s = t(a, this.options.workWeekStart, 1), i = t(s, this.options.workWeekEnd, 1), n = []; s <= i;) n.push(s), s = r.date.nextDay(s);
                    this._render(n)
                }
            })
        })
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, a) {
    (a || t)()
});;
! function(e, define) {
    define("kendo.scheduler.agendaview.min", ["kendo.scheduler.view.min"], e)
}(function() {
    return function(e) {
        function t(e) {
            var t, s, a = 0;
            for (t = 0, s = e.length; t < s; t++) a += e[t].items.length;
            return a
        }

        function s(e, t) {
            return e.valuePrimitive && (t = r.getter(e.dataValueField)(t)), t
        }

        function a(e) {
            for (var t, s = 0, a = e.length, r = []; s < a; s++) t = e[s], t.groups ? (t = n(t.groups), r = r.concat(t)) : r = r.concat(n(t.items));
            return r
        }

        function n(e) {
            for (var t = [].concat(e), s = t.shift(), a = [], n = [].push; s;) s.groups ? n.apply(t, s.groups) : s.items ? n.apply(t, s.items) : n.call(a, s), s = t.shift();
            return a
        }
        var r = window.kendo,
            i = r.ui,
            o = ".kendoAgendaView",
            l = '<div class="k-task" title="#:(data.title || "").replace(/"/g,"\'")#" data-#=kendo.ns#uid="#=uid#"># if (resources[0]) {#<span class="k-scheduler-mark" style="background-color:#=resources[0].color#"></span># } ## if (data.isException()) { #<span class="k-icon k-i-non-recurrence"></span># } else if (data.isRecurring()) {#<span class="k-icon k-i-reload"></span># } #<span class="k-scheduler-task-text">{0}</span>#if (showDelete) {#<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>#}#</div>',
            d = '# if (!isMobile) { #<strong class="k-scheduler-agendaday">#=kendo.toString(date, "dd")#</strong><em class="k-scheduler-agendaweek">#=kendo.toString(date,"dddd")#</em><span class="k-scheduler-agendadate">#=kendo.toString(date, "y")#</span># } else { #<div class="k-scheduler-datecolumn-wrap"><span class="k-mobile-scheduler-agendadate"><span class="k-mobile-scheduler-agendaday">#=kendo.toString(date, "dd")#</span>&nbsp<span class="k-mobile-scheduler-agendamonth">#=kendo.toString(date, "MMMM")#</span></span><span class="k-mobile-scheduler-agendaweekday">#=kendo.toString(date, "dddd")#</span></div># } #',
            u = '# if (!isMobile) { #<strong class="k-scheduler-adgendagroup">#=value#</strong># } else { #<span class="k-scheduler-group-text">#=value#</span># } #',
            c = r.Class.extend({
                init: function(e) {
                    this._view = e
                },
                _getColumns: function(e, t) {
                    return e.concat(t)
                },
                _getGroupsInDay: function() {
                    return []
                },
                _getSumOfItemsForDate: function() {
                    return 0
                },
                _renderTaskGroupsCells: function(e, t, s, a) {
                    var n = this._view;
                    0 === s && 0 === a && t.length && n._renderTaskGroupsCells(e, t)
                },
                _renderDateCell: function(e, t, s, a, n, i) {
                    var o = this._view,
                        l = o._isMobile();
                    e.push(r.format('<td class="k-scheduler-datecolumn{3}{2}" rowspan="{0}">{1}</td>', s.length, o._dateTemplate({
                        date: a,
                        isMobile: l
                    }), n != i.length - 1 || t.length ? "" : " k-last", t.length ? "" : " k-first"))
                },
                _renderDates: function() {},
                _getParents: function(e) {
                    return e.splice(0)
                },
                _getGroupsByDate: function() {},
                _renderTaskGroups: function(e, t, s) {
                    var a = this._view;
                    e.append(a._renderTaskGroups(t, s))
                }
            }),
            h = r.Class.extend({
                init: function(e) {
                    this._view = e
                },
                _getColumns: function(e, t) {
                    var s, a, n = this._view;
                    return n._isMobile() ? e.concat(t) : (s = t.slice(0, 1), a = t.slice(1), s.concat(e).concat(a))
                },
                _compareDateGroups: function(e, t, s) {
                    return e[s].text == t[s].text && (0 === s || this._compareDateGroups(e, t, s - 1))
                },
                _getGroupsInDay: function(e, t) {
                    var s, a, n, r, i, o = [],
                        l = null;
                    for (s = 0; s < e.length; s++)
                        for (a = 0; a < e[s].items.length; a++) {
                            if (n = 0, 0 === o.length)
                                for (n; n < t[s].length; n++) o.push([1]);
                            else
                                for (n; n < t[s].length; n++)
                                    if (this._compareDateGroups(t[s], l, n)) o[n][o[n].length - 1]++;
                                    else {
                                        for (r = o[n][o[n].length - 1] - 1, i = 0; i < r; i++) o[n].push(0);
                                        o[n].push(1)
                                    }
                            l = t[s]
                        }
                    return o
                },
                _getSumOfItemsForDate: function(e) {
                    var t, s = 0;
                    for (t = 0; t < e.length; t++) s += e[t].items.length;
                    return s
                },
                _renderTaskGroupsCells: function(e, t, s, a, n, i, o, l) {
                    var d, u = this._view,
                        c = u._isMobile();
                    if (c) 0 === s && 0 === a && t.length && u._renderTaskGroupsCells(e, t);
                    else
                        for (0 === s && 0 === a && e.push(r.format('<td class="k-scheduler-datecolumn k-first" rowspan="{0}">{1}</td>', i, u._dateTemplate({
                                date: o,
                                isMobile: c
                            }))), d = 0; d < t[s].length; d++) n[d][l] && e.push(r.format('<td class="k-scheduler-groupcolumn" rowspan="{0}">{1}</td>', n[d][l], u._groupTemplate({
                            value: t[s][d].text,
                            isMobile: c
                        }), t[s][d].className))
                },
                _renderDateCell: function() {},
                _renderDates: function(e) {
                    var t, s = this._view,
                        a = s._groupsByDate.sort(function(e, t) {
                            return e.array[0].value.getTime() - t.array[0].value.getTime()
                        });
                    for (t = 0; t < a.length; t++) e.append(s._renderTaskGroups(a[t].array, a[t].groups))
                },
                _getParents: function(e) {
                    return e.slice(0)
                },
                _getGroupsByDate: function(e, t, s) {
                    var a, n, r, i, o = this._view;
                    if (e[t].items)
                        for (a = 0; a < e[t].items.length; a++) {
                            for (n = e[t].items[a].value, r = !1, i = 0; i < o._groupsByDate.length; i++) o._groupsByDate[i].array[0].value.getTime() === n.getTime() && (r = !0, o._groupsByDate[i].array.push(e[t].items[a]), o._groupsByDate[i].groups.push(s));
                            r || o._groupsByDate.push({
                                array: [e[t].items[a]],
                                groups: [s]
                            })
                        }
                },
                _renderTaskGroups: function() {}
            });
        r.ui.scheduler.AgendaGroupedView = c, r.ui.scheduler.AgendaGroupedByDateView = h, i.AgendaView = i.SchedulerView.extend({
            init: function(t, s) {
                i.SchedulerView.fn.init.call(this, t, s), this._groupedView = this._getGroupedView(), s = this.options, s.editable && (s.editable = e.extend({
                    "delete": !0
                }, s.editable, {
                    create: !1,
                    update: !1
                }, {
                    messages: s.messages
                })), this.title = s.title, this._eventTemplate = this._eventTmpl(s.eventTemplate, l), this._dateTemplate = r.template(s.eventDateTemplate), this._groupTemplate = r.template(s.eventGroupTemplate), this._timeTemplate = r.template(s.eventTimeTemplate), this.element.on("mouseenter" + o, ".k-scheduler-agenda .k-scheduler-content tr", "_mouseenter").on("mouseleave" + o, ".k-scheduler-agenda .k-scheduler-content tr", "_mouseleave").on("click" + o, ".k-scheduler-agenda .k-scheduler-content .k-link:has(.k-i-close)", "_remove"), this._renderLayout(s.date)
            },
            name: "agenda",
            _getGroupedView: function() {
                return this._isGroupedByDate() ? new r.ui.scheduler.AgendaGroupedByDateView(this) : new r.ui.scheduler.AgendaGroupedView(this)
            },
            _mouseenter: function(t) {
                e(t.currentTarget).addClass("k-state-hover")
            },
            _mouseleave: function(t) {
                e(t.currentTarget).removeClass("k-state-hover")
            },
            _remove: function(t) {
                t.preventDefault(), this.trigger("remove", {
                    uid: e(t.currentTarget).closest(".k-task").attr(r.attr("uid"))
                })
            },
            nextDate: function() {
                return r.date.nextDay(this.startDate())
            },
            startDate: function() {
                return this._startDate
            },
            endDate: function() {
                return this._endDate
            },
            previousDate: function() {
                return r.date.previousDay(this.startDate())
            },
            _renderLayout: function(e) {
                this._startDate = e, this._endDate = r.date.addDays(e, 7), this.createLayout(this._layout()), this._footer(), this.table.addClass("k-scheduler-agenda")
            },
            _layout: function() {
                var e, t, s, a = [{
                    text: this.options.messages.time,
                    className: "k-scheduler-timecolumn"
                }, {
                    text: this.options.messages.event
                }];
                if (this._isMobile() || a.splice(0, 0, {
                        text: this.options.messages.date,
                        className: "k-scheduler-datecolumn"
                    }), e = this.groupedResources, e.length) {
                    for (t = [], s = 0; s < e.length; s++) t.push({
                        text: "",
                        className: "k-scheduler-groupcolumn"
                    });
                    a = this._groupedView._getColumns(t, a)
                }
                return {
                    columns: a
                }
            },
            _tasks: function(e) {
                var t, s, a, n, i, o, l, d = [];
                for (t = 0; t < e.length; t++)
                    if (s = e[t], a = s.start, n = s.isAllDay ? r.date.getDate(s.end) : s.end, i = Math.ceil((n - r.date.getDate(a)) / r.date.MS_PER_DAY), s.isAllDay && (i += 1), o = s.clone(), o.startDate = r.date.getDate(a), o.startDate >= this.startDate() && d.push(o), i > 1)
                        for (o.end = r.date.nextDay(a), o.head = !0, l = 1; l < i; l++) a = o.end, o = s.clone(), o.start = o.startDate = r.date.getDate(a), o.end = r.date.nextDay(a), l == i - 1 ? (o.end = new Date(o.start.getFullYear(), o.start.getMonth(), o.start.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds()), o.tail = !0) : (o.isAllDay = !0, o.middle = !0), (r.date.getDate(o.end) <= this.endDate() && o.start >= this.startDate() || r.date.getDate(o.start).getTime() == this.endDate().getTime()) && d.push(o);
                return new r.data.Query(d).sort([{
                    field: "start",
                    dir: "asc"
                }, {
                    field: "end",
                    dir: "asc"
                }]).groupBy({
                    field: "startDate"
                }).toArray()
            },
            _renderTaskGroups: function(e, t) {
                var s, a, n, i, o, l, d, u, c = [],
                    h = this.options.editable,
                    p = h && h.destroy !== !1 && !this._isMobile(),
                    g = this._isMobile(),
                    m = this._groupedView._getSumOfItemsForDate(e),
                    f = this._groupedView._getGroupsInDay(e, t),
                    _ = 0;
                for (s = 0; s < e.length; s++)
                    for (a = e[s].value, n = e[s].items, i = r.date.isToday(a), o = 0; o < n.length; o++) l = n[o], d = [], u = g ? [] : d, this._groupedView._renderTaskGroupsCells(u, t, s, o, f, m, a, _), _++, 0 === o && (g ? (u.push(r.format('<td class="k-scheduler-datecolumn {1}" colspan="2">{0}</td>', this._dateTemplate({
                        date: a,
                        isMobile: g
                    }), this.groupedResources.length ? "" : "k-first")), c.push('<tr role="row" aria-selected="false"' + (i ? ' class="k-today">' : ">") + u.join("") + "</tr>")) : this._groupedView._renderDateCell(d, t, n, a, s, e)), l.format = l.head ? "{0:t}" : l.tail ? "{1:t}" : "{0:t}-{1:t}", l.resources = this.eventResources(l), d.push(r.format('<td class="k-scheduler-timecolumn {4}"><div>{0}{1}{2}</div></td><td>{3}</td>', l.tail || l.middle ? '<span class="k-icon k-i-arrow-60-left"></span>' : "", this._timeTemplate(l.clone({
                        start: l._startTime || l.start,
                        end: l.endTime || l.end
                    })), l.head || l.middle ? '<span class="k-icon k-i-arrow-60-right"></span>' : "", this._eventTemplate(l.clone({
                        showDelete: p,
                        messages: this.options.messages
                    })), !this.groupedResources.length && g ? "k-first" : "")), c.push('<tr role="row" aria-selected="false"' + (i ? ' class="k-today">' : ">") + d.join("") + "</tr>");
                return c.join("")
            },
            _renderTaskGroupsCells: function(e, t) {
                var s, a = this._isMobile();
                for (s = 0; s < t.length; s++) e.push(r.format('<td class="k-scheduler-groupcolumn{2}" rowspan="{0}">{1}</td>', t[s].rowSpan, this._groupTemplate({
                    value: t[s].text,
                    isMobile: a
                }), t[s].className))
            },
            render: function(e) {
                var t, s, n = this.content.find("table").empty(),
                    r = [];
                e.length > 0 && (t = this.groupedResources, t.length ? (r = this._createGroupConfiguration(e, t, null), this._groupsByDate = [], this._renderGroups(r, n, []), this._groupedView._renderDates(n)) : (r = this._tasks(e), n.append(this._renderTaskGroups(r, [])))), s = this._eventsList = a(r), this._angularItems(n, s), this.refreshLayout(), this.trigger("activate")
            },
            _angularItems: function(e, t) {
                this.angular("compile", function() {
                    var s = [],
                        a = t.map(function(t) {
                            return s.push({
                                dataItem: t
                            }), e.find(".k-task[" + r.attr("uid") + "=" + t.uid + "]")
                        });
                    return {
                        elements: a,
                        data: s
                    }
                })
            },
            _renderGroups: function(e, t, s) {
                var a, n, r;
                for (a = 0, n = e.length; a < n; a++) r = this._groupedView._getParents(s), r.push(e[a]), this._groupedView._getGroupsByDate(e, a, r), e[a].groups ? this._renderGroups(e[a].groups, t, r) : this._groupedView._renderTaskGroups(t, e[a].items, r)
            },
            _createGroupConfiguration: function(e, a, n) {
                var o, l, d, u, c, h, p, g = a[0],
                    m = [],
                    f = g.dataSource.view(),
                    _ = this._isMobile();
                for (o = 0; o < f.length; o++) l = s(g, f[o]), d = new r.data.Query(e).filter({
                    field: g.field,
                    operator: i.SchedulerView.groupEqFilter(l)
                }).toArray(), d.length && (u = this._tasks(d), c = n ? "" : " k-first", o === f.length - 1 && (!n || n.className.indexOf("k-last") > -1) && (c += " k-last"), h = {
                    text: r.getter(g.dataTextField)(f[o]),
                    value: l,
                    rowSpan: 0,
                    className: c
                }, a.length > 1 ? (h.groups = this._createGroupConfiguration(d, a.slice(1), h), n && (n.rowSpan += h.rowSpan)) : (h.items = u, p = t(h.items), _ && (p += h.items.length), h.rowSpan = p, n && (n.rowSpan += p)), m.push(h));
                return m
            },
            selectionByElement: function(t) {
                var s, a, n;
                if (t = e(t), !t.hasClass("k-scheduler-datecolumn") && this._eventsList.length) return t.is(".k-task") && (t = t.closest("td")), this._isMobile() ? (n = t.parent(), s = n.parent().children().filter(function() {
                    return e(this).children(":not(.k-scheduler-datecolumn)").length
                }).index(n)) : s = t.parent().index(), a = this._eventsList[s], {
                    index: s,
                    start: a.start,
                    end: a.end,
                    isAllDay: a.isAllDay,
                    uid: a.uid
                }
            },
            select: function(e) {
                this.clearSelection();
                var t = this.table.find(".k-task").eq(e.index).closest("tr").addClass("k-state-selected").attr("aria-selected", !0)[0];
                this.current(t)
            },
            move: function(e, t) {
                var s, a = !1,
                    n = e.index;
                return t == r.keys.UP ? (n--, a = !0) : t == r.keys.DOWN && (n++, a = !0), a && (s = this._eventsList[n], s && (e.start = s.start, e.end = s.end, e.isAllDay = s.isAllDay, e.events = [s.uid], e.index = n)), a
            },
            moveToEvent: function() {
                return !1
            },
            constrainSelection: function(e) {
                var t = this._eventsList[0];
                t && (e.start = t.start, e.end = t.end, e.isAllDay = t.isAllDay, e.events = [t.uid], e.index = 0)
            },
            isInRange: function() {
                return !0
            },
            destroy: function() {
                this.element && this.element.off(o), i.SchedulerView.fn.destroy.call(this)
            },
            options: {
                title: "Agenda",
                name: "agenda",
                editable: !0,
                selectedDateFormat: "{0:D}-{1:D}",
                selectedShortDateFormat: "{0:d} - {1:d}",
                selectedMobileDateFormat: "{0: MMM} {0:dd} - {1:dd}",
                eventTemplate: "#:title#",
                eventTimeTemplate: "#if(data.isAllDay) {##=this.options.messages.allDay##} else { ##=kendo.format(format, start, end)## } #",
                eventDateTemplate: d,
                eventGroupTemplate: u,
                messages: {
                    event: "Event",
                    date: "Date",
                    time: "Time",
                    allDay: "all day"
                }
            }
        })
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, s) {
    (s || t)()
});;
! function(t, define) {
    define("kendo.scheduler.monthview.min", ["kendo.scheduler.view.min"], t)
}(function() {
    return function(t) {
        function e(t, e) {
            return t.slice(e).concat(t.slice(0, e))
        }

        function n(t, e) {
            for (var n = e.firstDay, o = new Date(t.getFullYear(), t.getMonth(), 0, t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()); o.getDay() != n;) i.date.setTime(o, -1 * u);
            return o
        }

        function o(t, e, n) {
            var o, i = e,
                a = n;
            return o = t, o >= i && o <= a
        }
        var i = window.kendo,
            a = i.ui,
            r = a.SchedulerView,
            s = ".kendoMonthView",
            l = t.extend,
            d = i.date.getDate,
            u = i.date.MS_PER_DAY,
            h = 6,
            c = 7,
            f = "k-event-inverse",
            p = i.template('<span class="k-link k-nav-day">#:kendo.toString(date, "dd")#</span>'),
            v = '<div role="gridcell" aria-selected="false" data-#=ns#uid="#=uid#"#if (resources[0]) { #style="background-color:#=resources[0].color #; border-color: #=resources[0].color#"class="k-event"#} else {#class="k-event"#}#><span class="k-event-actions"># if (data.tail || data.middle) {#<span class="k-icon k-i-arrow-60-left"></span>#}## if (data.isException()) {#<span class="k-icon k-i-non-recurrence"></span># } else if (data.isRecurring()) {#<span class="k-icon k-i-reload"></span>#}#</span>{0}<span class="k-event-actions">#if (showDelete) {#<a href="\\#" class="k-link k-event-delete" title="${data.messages.destroy}" aria-label="${data.messages.destroy}"><span class="k-icon k-i-close"></span></a>#}## if (data.head || data.middle) {#<span class="k-icon k-i-arrow-60-right"></span>#}#</span># if (resizable && !data.tail && !data.middle) {#<span class="k-resize-handle k-resize-w"></span>#}## if (resizable && !data.head && !data.middle) {#<span class="k-resize-handle k-resize-e"></span>#}#</div>',
            _ = i.template('<div title="#=title.replace(/"/g,"&\\#34;")#"><div class="k-event-template">#:title#</div></div>'),
            g = 2,
            m = i.template('<div style="width:#=width#px;left:#=left#px;top:#=top#px" class="k-more-events k-button"><span class="k-icon k-i-more-horizontal"></span></div>'),
            y = i.Class.extend({
                init: function(t) {
                    this._view = t
                },
                _verticalRowCountForLevel: function(t) {
                    var e = this._view;
                    return e._rowCountForLevel(t)
                },
                _horizontalGroupCountForLevel: function(t) {
                    var e = this._view;
                    return e._columnCountForLevel(t)
                },
                _getCalendarRowsLength: function(t, e) {
                    return e / t
                },
                _createRows: function(t, e, n, o) {
                    var i, a = this._view,
                        r = c,
                        s = a._isVerticallyGrouped(),
                        l = "";
                    for (i = 0; i < n; i++) l += a._createRow(t, e, r, s ? o : i);
                    return l
                },
                _adjustStartDate: function(t) {
                    return i.date.addDays(t, c)
                },
                _getContent: function(t, e, n) {
                    return t({
                        date: e,
                        resources: n
                    })
                },
                _getTimeSlotByPosition: function(t, e, n) {
                    var o = this._view.groups[n];
                    return o.daySlotByPosition(t, e)
                },
                _nextSlotStartDate: function(t) {
                    return i.date.nextDay(t)
                },
                _createRowsLayout: function(t, e, n) {
                    var o = this._view;
                    return o._createRowsLayout(t, e, n)
                },
                _createVerticalColumnsLayout: function(t, e, n, o) {
                    return o
                },
                _createColumnsLayout: function(t, e, n) {
                    var o = this._view;
                    return o._createColumnsLayout(t, e, n)
                },
                _verticalGroupCount: function(t) {
                    var e = this._view;
                    return e._rowCountForLevel(t)
                },
                _horizontalGroupCount: function(t) {
                    var e = this._view;
                    return e._columnCountForLevel(t) / e._columnOffsetForResource(t)
                },
                _positionMobileEvent: function(t, e, n, o, i, a, r) {
                    var s, l = this._view;
                    o > 1 && (0 === r ? a = n.end.endDate() : r == o - 1 ? i = n.start.startDate() : (i = n.start.startDate(), a = n.end.endDate())), s = t.clone({
                        start: i,
                        end: a,
                        head: n.head,
                        tail: n.tail
                    }), l._positionMobileEvent(n, l._createEventElement(s), e)
                },
                _positionEvent: function(t, e, n, o, i, a, r) {
                    var s, l = this._view;
                    o > 1 && (0 === r ? a = n.end.endDate() : r == o - 1 ? i = n.start.startDate() : (i = n.start.startDate(), a = n.end.endDate())), s = t.clone({
                        start: i,
                        end: a,
                        head: n.head,
                        tail: n.tail
                    }), l._positionEvent(n, l._createEventElement(s), e)
                },
                _addDaySlotCollections: function(t, e, n) {
                    var o, a, r, s, l, d, u, f, p, v, _, g = this._view,
                        m = c,
                        y = h;
                    for (o = 0; o < t; o++)
                        for (a = 0, r = 0, g._isVerticallyGrouped() && (r = o), s = r * y; s < (r + 1) * y; s++)
                            for (l = g.groups[o], d = l.addDaySlotCollection(i.date.addDays(n, a), i.date.addDays(n, a + m)), u = e[s], f = u.children, p = 0, u.setAttribute("role", "row"), g._isVerticallyGrouped() || (p = o), v = p * m; v < (p + 1) * m; v++) _ = f[v], g.addDaySlot(d, _, n, a), a++
                },
                _changePeriodGroupIndex: function(t) {
                    var e = this._view;
                    return t ? e.groups.length - 1 : 0
                },
                _createResizeHint: function(t) {
                    var e = this._view,
                        n = t.startSlot().offsetLeft,
                        o = t.start.offsetTop,
                        i = t.innerWidth(),
                        a = t.start.clientHeight - 2,
                        s = r.fn._createResizeHint.call(e, n, o, i, a);
                    e._appendResizeHint(s)
                },
                _createMoveHint: function(t, e) {
                    var n = this._view,
                        o = t.startSlot(),
                        i = t.endSlot(),
                        a = n._createEventElement(e.clone({
                            head: t.head,
                            tail: t.tail
                        }));
                    a.css({
                        left: o.offsetLeft + 2,
                        top: o.offsetTop + o.firstChildHeight,
                        height: "auto" === n.options.eventHeight ? 25 : n.options.eventHeight,
                        width: t.innerWidth() - (o.index !== i.index ? 3 : 2)
                    }), a.addClass("k-event-drag-hint"), e.inverseColor && a.addClass(f), n._appendMoveHint(a)
                }
            }),
            D = i.Class.extend({
                init: function(t) {
                    this._view = t
                },
                _verticalRowCountForLevel: function() {
                    return 1
                },
                _horizontalGroupCountForLevel: function(t) {
                    var e = this._view;
                    return e._columnCountForLevel(t + 1) / c
                },
                _createRows: function(t, e, n) {
                    var o, a, r = this._view,
                        s = c,
                        l = r._isVerticallyGrouped(),
                        d = "",
                        u = 0;
                    if (l) {
                        for (o = new Date(t), a = r._groupCount(), u; u < h; u++) d += r._createRow(o, e, a, u), o = i.date.addDays(o, s);
                        t = i.date.nextDay(t)
                    } else {
                        for (u; u < s; u++) d += r._createRow(t, e, n, u), t = i.date.nextDay(t);
                        t = i.date.addDays(t, s)
                    }
                    return d
                },
                _adjustStartDate: function(t, e) {
                    var n = this._view,
                        o = n._isVerticallyGrouped();
                    return o ? e ? i.date.addDays(t, c * (h - 1) + 1) : i.date.nextDay(t) : i.date.addDays(t, c)
                },
                _getContent: function(t, e, n, o) {
                    return 0 === o ? t({
                        date: e,
                        resources: n
                    }) : ""
                },
                _getTimeSlotByPosition: function(t, e, n) {
                    var o = this._view.groups[n];
                    return o.daySlotByPosition(t, e, !0)
                },
                _nextSlotStartDate: function(t) {
                    return t
                },
                _getCalendarRowsLength: function() {
                    var t = this._view,
                        e = t._isVerticallyGrouped();
                    return e ? c : h
                },
                _createRowsLayout: function(t, e, n, o) {
                    var i = this._view;
                    return i._createDateLayout(o, null, !1)
                },
                _createVerticalColumnsLayout: function(t, e, n) {
                    var o, a, r = this._view,
                        s = t[0],
                        l = [],
                        d = s.dataSource.view();
                    for (o = 0; o < d.length * h; o++) a = {
                        text: n({
                            text: i.htmlEncode(i.getter(s.dataTextField)(d[o % d.length])),
                            color: i.getter(s.dataColorField)(d[o % d.length]),
                            field: s.field,
                            title: s.title,
                            name: s.name,
                            value: i.getter(s.dataValueField)(d[o % d.length])
                        }),
                        className: "k-slot-cell"
                    }, a.columns = r._createColumnsLayout(t.slice(1), null, n), l.push(a);
                    return l
                },
                _createColumnsLayout: function(t, e, n, o) {
                    var i = this._view;
                    return i._createColumnsLayout(t, e, n, o, !0)
                },
                _verticalGroupCount: function(t) {
                    var e = this._view;
                    return e._columnCountForLevel(t) / h
                },
                _horizontalGroupCount: function(t) {
                    var e = this._view;
                    return e._columnCountForLevel(t) / c
                },
                _positionMobileEvent: function(t, e, n, o, i, a) {
                    var r, s, l, d, u = this._view,
                        h = n.start.index,
                        c = n.end.index;
                    for (r = n.start.index; r <= n.end.index; r++) s = n.collection._slots[r], l = e.daySlotRanges(s.start, s.start, !0)[0], d = t.clone({
                        start: r === h ? i : s.startDate(),
                        end: r === c ? a : s.endDate(),
                        head: r !== c || n.head,
                        tail: r !== h || n.tail
                    }), u._positionMobileEvent(l, u._createEventElement(d), e)
                },
                _positionEvent: function(t, e, n, o, i, a) {
                    var r, s, l, d, u = this._view,
                        h = n.start.index,
                        c = n.end.index;
                    for (r = n.start.index; r <= n.end.index; r++) s = n.collection._slots[r], l = e.daySlotRanges(s.start, s.start, !0)[0], d = t.clone({
                        start: r === h ? i : s.startDate(),
                        end: r === c ? a : s.endDate(),
                        head: r !== c || n.head,
                        tail: r !== h || n.tail
                    }), u._positionEvent(l, u._createEventElement(d), e)
                },
                _addDaySlotCollections: function(t, e, n) {
                    var o, a, r, s, l, d, u, f, p, v, _, g, m, y, D = this._view,
                        w = c,
                        S = h,
                        C = D._isVerticallyGrouped();
                    for (o = 0; o < w; o++)
                        for (a = 0; a < S; a++)
                            for (r = 0, s = C ? o : a, l = e[s], d = l.children, u = 0, l.setAttribute("role", "row"), D._isVerticallyGrouped() || (u = o), f = u * t; f < (u + 1) * t; f++) p = a * w + o, v = C ? f + a * t : f, _ = d[v], g = C ? f : r, m = D.groups[g], y = 0 === o ? m.addDaySlotCollection(i.date.addDays(n, p), i.date.addDays(n, p + w)) : m._daySlotCollections[a], D.addDaySlot(y, _, n, p), r++
                },
                _changePeriodGroupIndex: function(t, e, n) {
                    var o = this._view;
                    return e && o._isVerticallyGrouped() ? t ? o.groups.length - 1 : 0 : n
                },
                _createResizeHint: function(t) {
                    var e, n, o, i, a, s, l, d = this._view;
                    if (d._isVerticallyGrouped()) e = t.startSlot().offsetLeft, n = t.start.offsetTop, o = t.startSlot().offsetWidth, i = t.endSlot().offsetTop + t.startSlot().offsetHeight - t.startSlot().offsetTop - 2, a = r.fn._createResizeHint.call(d, e, n, o, i), d._appendResizeHint(a);
                    else
                        for (s = t.startSlot().index; s <= t.endSlot().index; s++) l = t.collection._slots[s], e = l.offsetLeft, n = l.offsetTop, o = l.offsetWidth, i = l.offsetHeight - 2, a = r.fn._createResizeHint.call(d, e, n, o, i), d._appendResizeHint(a)
                },
                _createMoveHint: function(t, e) {
                    var n, o, i, a = this._view,
                        r = t.startSlot(),
                        s = t.endSlot();
                    for (n = r.index; n <= s.index; n++) o = t.collection._slots[n], i = a._createEventElement(e.clone({
                        head: t.head,
                        tail: t.tail
                    })), i.css({
                        left: o.offsetLeft,
                        top: o.offsetTop + o.firstChildHeight,
                        height: "auto" === a.options.eventHeight ? 25 : a.options.eventHeight,
                        width: o.offsetWidth - 2
                    }), i.addClass("k-event-drag-hint"), e.inverseColor && i.addClass(f), a._appendMoveHint(i)
                }
            });
        i.ui.scheduler.MonthGroupedView = y, i.ui.scheduler.MonthGroupedByDateView = D, a.MonthView = r.extend({
            init: function(t, e) {
                var n, o, i, a = this;
                if (0 === e.eventsPerDay && (e.eventsPerDay = 1), 0 === e.eventHeight && (e.eventHeight = 1), 0 === e.moreButtonHeight && (e.moreButtonHeight = 1), "string" == typeof e.eventHeight && "auto" !== e.eventHeight && (e.eventHeight = 25), "auto" === e.eventHeight && (e.adaptiveSlotHeight = !0), r.fn.init.call(a, t, e), a._groupedView = a._getGroupedView(), n = this._isGroupedByDate(), o = this.options.adaptiveSlotHeight, i = this.options.eventHeight, n === !0 && o === !0) throw Error("Incompatible options: adaptive slot height and date grouping!");
                if (n === !0 && "auto" === i) throw Error("Incompatible options: auto event height and date grouping!");
                a.title = a.options.title, a._templates(), a._editable(), a._renderLayout(a.options.date), a._groups()
            },
            name: "month",
            _getGroupedView: function() {
                return this._isGroupedByDate() ? new i.ui.scheduler.MonthGroupedByDateView(this) : new i.ui.scheduler.MonthGroupedView(this)
            },
            _updateDirection: function(t, e, n, o, i) {
                var a, r, s, l, d;
                n && (a = e[0].start, r = e[e.length - 1].end, s = a.index === r.index, l = a.collectionIndex === r.collectionIndex, d = i ? s && l || l : s && l, d && (t.backward = o))
            },
            _changeDate: function(t, e, n) {
                var o, i, a, r = this.groups[t.groupIndex];
                if (n) {
                    if (o = r._getCollections(r.daySlotCollectionCount()), i = e.collectionIndex - 1, i >= 0) return o[i]._slots[o[i]._slots.length - 1]
                } else if (o = r._getCollections(r.daySlotCollectionCount()), i = e.collectionIndex + 1, a = 0, o[i] && o[i]._slots[a]) return o[i]._slots[a]
            },
            _getNextHorizontalRange: function(t, e, n) {
                var o = this._isVerticallyGrouped();
                return n.startSlot = t[e](n.startSlot, o), n.endSlot = t[e](n.endSlot, o), n
            },
            _getNextVerticalRange: function(t, e, n, o) {
                var i = this._isVerticallyGrouped() && this._isGroupedByDate();
                return n.startSlot = t[e](n.startSlot, o, i), n.endSlot = t[e](n.endSlot, o, i), n
            },
            _changeViewPeriod: function(t, e, n) {
                var o, a, r = n ? 7 : 1;
                return e && (r *= -1), o = i.date.addDays(t.start, r), a = i.date.addDays(t.end, r), !this._isInRange(o, a) && (t.start = o, t.end = a, (!n || n && this._isVerticallyGrouped()) && (t.groupIndex = this._groupedView._changePeriodGroupIndex(e, n, t.groupIndex)), t.events = [], !0)
            },
            _continuousSlot: function(t, e, n) {
                var o = t.backward ? 0 : e.length - 1,
                    i = this.groups[t.groupIndex];
                return i.continuousSlot(e[o].start, n)
            },
            _changeGroupContinuously: function(t, e, n, o) {
                var i, a, r, s;
                return n || (i = t.groupIndex, a = this.groups.length - 1, r = this._isVerticallyGrouped(), s = this.groups[i], !e && r ? (e = s[o ? "lastSlot" : "firstSlot"](), i += o ? -1 : 1) : e && !r && (i = o ? a : 0), (i < 0 || i > a) && (i = o ? a : 0, e = null), t.groupIndex = i), e
            },
            _normalizeHorizontalSelection: function(t, e, n) {
                var o;
                return o = n ? e[0].start : e[e.length - 1].end
            },
            _normalizeVerticalSelection: function(t, e) {
                var n;
                return n = t.backward ? e[0].start : e[e.length - 1].end
            },
            _templates: function() {
                var t = this.options,
                    e = l({}, i.Template, t.templateSettings);
                this.eventTemplate = this._eventTmpl(t.eventTemplate, v), this.dayTemplate = i.template(t.dayTemplate, e), this.groupHeaderTemplate = i.template(t.groupHeaderTemplate, e)
            },
            dateForTitle: function() {
                return i.format(this.options.selectedDateFormat, this._firstDayOfMonth, this._lastDayOfMonth)
            },
            shortDateForTitle: function() {
                return i.format(this.options.selectedShortDateFormat, this._firstDayOfMonth, this._lastDayOfMonth)
            },
            mobileDateForTitle: function() {
                return i.format(this.options.selectedMobileDateFormat, this._firstDayOfMonth, this._lastDayOfMonth)
            },
            nextDate: function() {
                return i.date.nextDay(this._lastDayOfMonth)
            },
            previousDate: function() {
                return i.date.previousDay(this._firstDayOfMonth)
            },
            startDate: function() {
                return this._startDate
            },
            endDate: function() {
                return this._endDate
            },
            _renderLayout: function(e) {
                var o = this;
                this._firstDayOfMonth = i.date.firstDayOfMonth(e), this._lastDayOfMonth = i.date.lastDayOfMonth(e), this._startDate = n(e, this.calendarInfo()), this.createLayout(this._layout()), this._content(), this._initSlotHeight(), this.refreshLayout(), this.content.on("click" + s, ".k-nav-day,.k-more-events", function(e) {
                    var n = t(e.currentTarget).offset(),
                        i = o._slotByPosition(n.left, n.top);
                    e.preventDefault(), o.trigger("navigate", {
                        view: "day",
                        date: i.startDate()
                    })
                }), this._footer()
            },
            _editable: function() {
                this.options.editable && (this._isMobile() ? this._touchEditable() : this._mouseEditable())
            },
            _mouseEditable: function() {
                var e = this;
                e.element.on("click" + s, ".k-scheduler-monthview .k-event a:has(.k-i-close)", function(n) {
                    e.trigger("remove", {
                        uid: t(this).closest(".k-event").attr(i.attr("uid"))
                    }), n.preventDefault()
                }), e.options.editable.create !== !1 && e.element.on("dblclick" + s, ".k-scheduler-monthview .k-scheduler-content td", function(n) {
                    var o, i = t(n.currentTarget).offset(),
                        a = e._slotByPosition(i.left, i.top);
                    a && (o = e._resourceBySlot(a), e.trigger("add", {
                        eventInfo: l({
                            isAllDay: !0,
                            start: a.startDate(),
                            end: a.startDate()
                        }, o)
                    })), n.preventDefault()
                }), e.options.editable.update !== !1 && e.element.on("dblclick" + s, ".k-scheduler-monthview .k-event", function(n) {
                    e.trigger("edit", {
                        uid: t(this).closest(".k-event").attr(i.attr("uid"))
                    }), n.preventDefault()
                })
            },
            _touchEditable: function() {
                var e = this,
                    n = 0;
                i.support.mobileOS.android && (n = 5), e.options.editable.create !== !1 && (e._addUserEvents = new i.UserEvents(e.element, {
                    threshold: n,
                    useClickAsTap: !i.support.browser.edge,
                    filter: ".k-scheduler-monthview .k-scheduler-content td",
                    tap: function(n) {
                        var o, i, a;
                        e._scrolling || (o = t(n.target).offset(), i = e._slotByPosition(o.left, o.top), i && (a = e._resourceBySlot(i), e.trigger("add", {
                            eventInfo: l({
                                isAllDay: !0,
                                start: i.startDate(),
                                end: i.startDate()
                            }, a)
                        })), n.preventDefault())
                    }
                }))
            },
            selectionByElement: function(e) {
                var n = t(e).offset();
                return this._slotByPosition(n.left, n.top)
            },
            _columnCountForLevel: function(t) {
                var e = this.columnLevels[t];
                return e ? e.length : 0
            },
            _rowCountForLevel: function(t) {
                var e = this.rowLevels[t];
                return e ? e.length : 0
            },
            _content: function() {
                var t, e = "<tbody>",
                    n = 1,
                    o = this._groupedView,
                    i = this.groupedResources;
                for (i.length && this._isVerticallyGrouped() && (n = o._verticalRowCountForLevel(i.length - 1)), t = 0; t < n; t++) e += this._createCalendar(t);
                e += "</tbody>", this.content.find("table").html(e)
            },
            _calcSlotHeight: function(t) {
                var e = this.options,
                    n = e.eventHeight,
                    o = e.eventSpacing,
                    i = e.moreButtonHeight,
                    a = this.content.find("table tr td")[0],
                    r = a.firstChild;
                if ("auto" !== n) return Math.round(a.offsetHeight - a.clientHeight + r.offsetTop + r.offsetHeight + g + t * n + (t - 1) * o + (g + i) + g)
            },
            _initSlotHeight: function() {
                var t, e = this.options,
                    n = e.eventsPerDay,
                    o = e.eventHeight,
                    i = this._isMobile(),
                    a = this.content.find("table");
                i || "number" == typeof o && (a.addClass("k-scheduler-table-auto"), t = this._calcSlotHeight(n), a.find("tr").height(t))
            },
            _adjustSlotHeight: function(t) {
                var e, n = this.options,
                    o = n.eventHeight,
                    i = n.eventSpacing,
                    a = n.moreButtonHeight;
                this._canAdjustSlotHeight === !0 && (e = t._daySlotCollections, this.content.find("table").addClass("k-scheduler-table-auto"), e.forEach(function(t) {
                    var e = t._events,
                        n = 0,
                        r = t._slots,
                        s = r[0],
                        l = s.element.offsetTop,
                        d = 0;
                    r.forEach(function(t) {
                        t.eventMeta ? t.actualEventCount = t.eventMeta.length : (t.eventMeta = [], t.actualEventCount = 0)
                    }), r.forEach(function(t, e) {
                        t.eventMeta.forEach(function(n, o) {
                            n.startIndex === e && n.startIndex !== n.endIndex && r.slice(e, n.endIndex + 1).forEach(function(e) {
                                var i = e.eventMeta;
                                i.indexOf(n) > -1 || (i[i.length] = t.eventMeta[o], e.actualEventCount = i.length, e.dirty = !0)
                            })
                        }), t.dirty === !0 && (t.eventMeta.sort(function(t, e) {
                            return t.order - e.order
                        }), delete t.dirty)
                    }), "auto" === o && r.forEach(function(t, e) {
                        var n = t.firstChildTop + t.firstChildHeight + g;
                        t.eventMeta.forEach(function(t, e) {
                            t.top = Math.max(t.top, l + n), n = t.top - l + i + t.height
                        })
                    }), r.forEach(function(t, r) {
                        var s = t.firstChildTop + t.firstChildHeight + g;
                        t.eventMeta.forEach(function(t) {
                            t.top = Math.max(t.top, l + s), s = t.top - l + i + t.height, t.startIndex === r && (e[n].element[0].style.top = t.top + "px", n++)
                        }), t.eventMeta.length > 0 ? (s -= i, s += g) : s += "auto" === o ? 25 : o, t.more && (t.more[0].style.top = l + s + "px", s += g + a), d = Math.max(d, s + 1)
                    }), s.element.parentNode.style.height = d + "px", r.forEach(function(t) {
                        t.offsetTop = l, t.offsetHeight = d, t.clientHeight = d - 1
                    })
                }.bind(this)))
            },
            _createCalendar: function(t) {
                var e, n, o, a = this.startDate(),
                    r = c * h,
                    s = c,
                    l = [a],
                    d = "",
                    u = 1,
                    f = this._isVerticallyGrouped(),
                    p = this._groupedView,
                    v = this.groupedResources;
                for (v.length && (f || (u = p._horizontalGroupCountForLevel(v.length - 1))), this._slotIndices = {}, e = p._getCalendarRowsLength(s, r), n = 0; n < e; n++) d += "<tr>", l.push(a), o = n * s, d += p._createRows(a, o, u, t), a = p._adjustStartDate(a, n === e - 1), d += "</tr>";
                return this._weekStartDates = l, this._endDate = i.date.previousDay(a), d
            },
            _createRow: function(t, e, n, o) {
                var a, r = this,
                    s = r._firstDayOfMonth,
                    l = r._lastDayOfMonth,
                    u = r.dayTemplate,
                    h = "",
                    c = "",
                    f = this._groupedView,
                    p = function() {
                        return r._resourceBySlot({
                            groupIndex: o
                        })
                    };
                for (a = 0; a < n; a++) h = "", i.date.isToday(t) && (h += "k-today"), i.date.isInDateRange(t, s, l) || (h += " k-other-month"), c += "<td ", "" !== h && (c += 'class="' + h + '"'), c += ">", c += f._getContent(u, t, p, a), c += "</td>", r._slotIndices[d(t).getTime()] = e + a, t = f._nextSlotStartDate(t);
                return c
            },
            _layout: function() {
                var n, o, i, a = this.calendarInfo(),
                    r = this._isMobile() ? a.days.namesShort.map(function(t) {
                        return t[0]
                    }) : a.days.names,
                    s = e(r, a.firstDay),
                    l = t.map(s, function(t) {
                        return {
                            text: t
                        }
                    }),
                    d = this.groupedResources,
                    u = this._groupedView;
                if (d.length)
                    if (this._isVerticallyGrouped()) {
                        for (o = [], i = 0; i < 6; i++) o.push({
                            text: "<div>&nbsp;</div>",
                            className: "k-hidden k-slot-cell"
                        });
                        n = u._createRowsLayout(d, o, this.groupHeaderTemplate, l), l = u._createVerticalColumnsLayout(d, o, this.groupHeaderTemplate, l)
                    } else l = u._createColumnsLayout(d, l, this.groupHeaderTemplate, l);
                return {
                    columns: l,
                    rows: n
                }
            },
            _createEventElement: function(e) {
                var n, o = this.options,
                    a = o.editable,
                    r = this._isMobile();
                return e.showDelete = a && a.destroy !== !1 && !r, e.resizable = a && a.resize !== !1 && !r, e.ns = i.ns, e.resources = this.eventResources(e), e.inverseColor = !1, e.messages = o.messages || {
                    destroy: "Delete"
                }, n = t(this.eventTemplate(e)), this.angular("compile", function() {
                    return {
                        elements: n,
                        data: [{
                            dataItem: e
                        }]
                    }
                }), n
            },
            _isInDateSlot: function(t) {
                var e = this.groups[0],
                    n = e.firstSlot().start,
                    a = e.lastSlot().end - 1,
                    r = i.date.toUtcTime(t.start),
                    s = i.date.toUtcTime(t.end);
                return (o(r, n, a) || o(s, n, a) || o(n, r, s) || o(a, r, s)) && (!o(s, n, n) || o(s, r, r) || t.isAllDay)
            },
            _slotIndex: function(t) {
                return this._slotIndices[d(t).getTime()]
            },
            _positionMobileEvent: function(e, n, o) {
                var a, s, l, d, u, h, c, f = e.start;
                e.start.offsetLeft > e.end.offsetLeft && (f = e.end), a = e.start.index, s = a, l = 3, d = r.collidingEvents(e.events(), a, s), d.push({
                    element: n,
                    start: a,
                    end: s
                }), u = r.createRows(d), h = e.collection.at(a), c = h.container, c || (c = t(i.format('<div class="k-events-container" style="top:{0};left:{1};width:{2}"/>', f.offsetTop + f.firstChildTop + f.firstChildHeight + "px", f.offsetLeft + "px", f.offsetWidth + "px")), h.container = c, this.content[0].appendChild(c[0])), u.length <= l && (e.addEvent({
                    element: n,
                    start: a,
                    end: s,
                    groupIndex: f.groupIndex
                }), o._continuousEvents.push({
                    element: n,
                    uid: n.attr(i.attr("uid")),
                    start: e.start,
                    end: e.end
                }), c[0].appendChild(n[0]))
            },
            _positionEvent: function(e, n, o) {
                var a, s, l, d, u, h, c, f, p, v, _, y, D, w, S, C, H, x, k = this.options.eventHeight,
                    M = this.options.eventSpacing,
                    b = e.start;
                for (e.start.offsetLeft > e.end.offsetLeft && (b = e.end), a = e.start.index, s = e.end.index, l = b.eventCount, d = r.collidingEvents(e.events(), a, s), u = a !== s ? 3 : 2, d.push({
                        element: n,
                        start: a,
                        end: s
                    }), h = r.createRows(d), c = 0, f = Math.min(h.length, l); c < f; c++)
                    for (p = h[c].events, v = "auto" === k ? "" : b.offsetTop + b.firstChildTop + b.firstChildHeight + g + c * (k + M) + "px", _ = 0, y = p.length; _ < y; _++) p[_].element[0].style.top = v, p[_].element.attr(i.attr("order"), c);
                if (h.length > l)
                    for (D = a; D <= s; D++) w = e.collection, S = w.at(D), S.more || (S.more = t(m({
                        ns: i.ns,
                        start: D,
                        end: D,
                        width: S.clientWidth - 2,
                        left: S.offsetLeft + 2,
                        top: "auto" === k ? "" : S.offsetTop + S.firstChildTop + S.firstChildHeight + g + l * k + (l - 1) * M + g
                    })), this.content[0].appendChild(S.more[0]));
                else e.addEvent({
                    element: n,
                    start: a,
                    end: s,
                    groupIndex: b.groupIndex
                }), n[0].style.width = e.innerWidth() - u + "px", n[0].style.left = b.offsetLeft + 2 + "px", n[0].style.height = "auto" === k ? "" : k + "px", o._continuousEvents.push({
                    element: n,
                    uid: n.attr(i.attr("uid")),
                    start: e.start,
                    end: e.end,
                    order: parseInt(n.attr(i.attr("order")), 10)
                }), n.appendTo(this.content), this._inverseEventColor(n), C = e.start.collectionIndex, H = e.start.index, x = o._daySlotCollections[C]._slots[H], x.eventMeta || (x.eventMeta = []), x.eventMeta.push({
                    height: "auto" === k ? n.outerHeight() : k,
                    top: 0,
                    startIndex: H,
                    endIndex: e.end.index,
                    uid: n.attr(i.attr("uid")),
                    order: parseInt(n.attr(i.attr("order")), 10)
                })
            },
            _slotByPosition: function(t, e) {
                var n, o, i = this.content.offset();
                for (t -= i.left, e -= i.top, e += this.content[0].scrollTop, t += this.content[0].scrollLeft, t = Math.ceil(t), e = Math.ceil(e), n = 0; n < this.groups.length; n++)
                    if (o = this._groupedView._getTimeSlotByPosition(t, e, n)) return o;
                return null
            },
            _appendResizeHint: function(t) {
                t.appendTo(this.content), this._resizeHint = this._resizeHint.add(t)
            },
            _updateResizeHint: function(t, e, n, o) {
                var a, r, s;
                for (this._removeResizeHint(), a = this.groups[e], r = a.ranges(n, o, !0, t.isAllDay), s = 0; s < r.length; s++) this._groupedView._createResizeHint(r[s]);
                this._resizeHint.find(".k-label-top,.k-label-bottom").text(""), this._resizeHint.first().addClass("k-first").find(".k-label-top").text(i.toString(i.timezone.toLocalDate(n), "M/dd")), this._resizeHint.last().addClass("k-last").find(".k-label-bottom").text(i.toString(i.timezone.toLocalDate(o), "M/dd"))
            },
            _updateMoveHint: function(t, e, n) {
                var o, a = i.date.toUtcTime(t.start) + n,
                    r = a + t.duration(),
                    s = this.groups[e],
                    l = s.ranges(a, r, !0, t.isAllDay);
                for (this._removeMoveHint(t.uid), o = 0; o < l.length; o++) this._groupedView._createMoveHint(l[o], t)
            },
            _appendMoveHint: function(t) {
                t.appendTo(this.content), this._moveHint = this._moveHint.add(t)
            },
            _groups: function() {
                var t, e = this._groupCount(),
                    n = this.content[0].getElementsByTagName("tr"),
                    o = this.startDate();
                for (this.groups = [], t = 0; t < e; t++) this._addResourceView(t);
                this._groupedView._addDaySlotCollections(e, n, o)
            },
            addDaySlot: function(t, e, n, o) {
                var a = i.date.addDays(n, o),
                    r = i.date.MS_PER_DAY,
                    s = this.options.eventsPerDay;
                n.getHours() !== a.getHours() && (r += (n.getHours() - a.getHours()) * i.date.MS_PER_HOUR), a = i.date.toUtcTime(a), r += a, e.setAttribute("role", "gridcell"), e.setAttribute("aria-selected", !1), t.addDaySlot(e, a, r, s)
            },
            render: function(t) {
                var e, n, o, a;
                this.content.children(".k-event,.k-more-events,.k-events-container").remove(), this._groups(), t = new i.data.Query(t).sort([{
                    field: "start",
                    dir: "asc"
                }, {
                    field: "end",
                    dir: "desc"
                }]).toArray().filter(function(t) {
                    return this._isInDateSlot(t)
                }.bind(this)), e = this.groupedResources, n = this._isMobile(), o = this._isGroupedByDate(), a = this.options.adaptiveSlotHeight, this._canAdjustSlotHeight = n !== !0 && o !== !0 && 0 === e.length && a === !0, e.length ? this._renderGroups(t, e, 0, 1) : this._renderEvents(t, 0), this.refreshLayout(), this.trigger("activate")
            },
            _renderEvents: function(t, e) {
                var n = this.groups[e],
                    o = this._groupedView._view,
                    a = o._isMobile();
                n._continuousEvents || (n._continuousEvents = []), a ? t.forEach(function(t) {
                    for (var e, o = n.slotRanges(t, !0), a = o[0], r = a.start.start, s = a.end.end, l = new Date(a.start.start), d = o[o.length - 1].end.end, u = new Date(l), h = new Date(s); l.getTime() <= d && t.end >= i.timezone.toLocalDate(l) && t.start <= i.timezone.toLocalDate(d);) e = n.daySlotRanges(u.getTime(), h.getTime(), !0)[0], h.setDate(h.getDate() + 1), u.setDate(u.getDate() + 1), e && (e.head = null, e.middle = null, e.tail = null, this._groupedView._positionMobileEvent(t, n, e, 1, r, s, 0)), l = i.date.addDays(l, 1)
                }.bind(this)) : (t.forEach(function(t) {
                    var e, o, i = t.start,
                        a = t.end,
                        r = n.slotRanges(t, !0),
                        s = r.length;
                    for (o = 0; o < s; o++) e = r[o], this._groupedView._positionEvent(t, n, e, s, i, a, o)
                }.bind(this)), this._canAdjustSlotHeight === !0 && this._adjustSlotHeight(n))
            },
            _renderGroups: function(t, e, n, o) {
                var a, s, l, d, u = e[0];
                if (u)
                    for (a = u.dataSource.view(), s = 0; s < a.length; s++) l = this._resourceValue(u, a[s]), d = new i.data.Query(t).filter({
                        field: u.field,
                        operator: r.groupEqFilter(l)
                    }).toArray(), e.length > 1 ? n = this._renderGroups(d, e.slice(1), n++, o + 1) : this._renderEvents(d, n++);
                return n
            },
            _groupCount: function() {
                var t = this.groupedResources,
                    e = this._groupedView;
                return t.length ? this._isVerticallyGrouped() ? e._verticalGroupCount(t.length - 1) : e._horizontalGroupCount(t.length) : 1
            },
            _columnOffsetForResource: function(t) {
                return this._columnCountForLevel(t) / this._columnCountForLevel(t - 1)
            },
            destroy: function() {
                this.table && this.table.removeClass("k-scheduler-monthview"), this.content && this.content.off(s), this.element && this.element.off(s), r.fn.destroy.call(this), this._isMobile() && this.options.editable && this.options.editable.create !== !1 && this._addUserEvents.destroy()
            },
            events: ["remove", "add", "edit", "navigate"],
            options: {
                title: "Month",
                name: "month",
                eventHeight: 25,
                moreButtonHeight: 13,
                editable: !0,
                selectedDateFormat: "{0:y}",
                selectedShortDateFormat: "{0:y}",
                selectedMobileDateFormat: "{0:MMMM}",
                groupHeaderTemplate: "#=text#",
                dayTemplate: p,
                eventTemplate: _,
                eventsPerDay: 2,
                adaptiveSlotHeight: !1,
                eventSpacing: 3
            }
        })
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, n) {
    (n || e)()
});;
! function(e, define) {
    define("kendo.scheduler.recurrence.min", ["kendo.dropdownlist.min", "kendo.datepicker.min", "kendo.numerictextbox.min"], e)
}(function() {
    return function(e, t) {
        function a(e, t) {
            var a;
            return 0 !== e && e < t ? a = t - e : (a = e % t, a && (a = t - a)), a
        }

        function n(e) {
            var t = e.getMonth(),
                a = k(e) ? se[t] : re[t];
            return a + e.getDate()
        }

        function s(e, a) {
            var n, s;
            return e = new Date(e.getFullYear(), e.getMonth(), e.getDate()), te(e, 0), n = e.getFullYear(), a !== t ? (ee(e, a, -1), e.setDate(e.getDate() + 4)) : e.setDate(e.getDate() + (4 - (e.getDay() || 7))), te(e, 0), s = Math.floor((e.getTime() - new Date(n, 0, 1, (-6))) / 864e5), 1 + Math.floor(s / 7)
        }

        function r(e, t) {
            var a = ae(e).getDay(),
                n = 7 - (a + 7 - (t || 7)) || 7;
            return n < 0 && (n += 7), Math.ceil((e.getDate() - n) / 7) + 1
        }

        function i(e, t) {
            return e + (e < t ? 7 : 0)
        }

        function l(e, t, a) {
            var n, s, l, o, u, c = t.offset;
            return c ? (n = new Date(e.getFullYear(), e.getMonth() + 1, 0), s = r(n, a), l = i(t.day, a), o = l < i(new Date(e.getFullYear(), e.getMonth(), 1).getDay(), a), u = l > i(n.getDay(), a), c < 0 ? c = s + (c + 1 - (u ? 1 : 0)) : o && (c += 1), s -= u ? 1 : 0, c < (o ? 1 : 0) || c > s ? null : c) : r(e, a)
        }

        function o(e, t) {
            return r(new Date(e.getFullYear(), e.getMonth() + 1, 0), t)
        }

        function u(e, t, a) {
            return r(e, a) === l(e, t, a)
        }

        function c(e, t, a) {
            for (var n, s, o, u, c = i(t.getDay(), a), d = e.length, f = [], y = 0; y < d; y++)
                if (s = e[y], u = r(t, a), n = l(t, s, a), null !== n)
                    if (u < n) f.push(s);
                    else if (u === n)
                if (o = i(s.day, a), c < o) f.push(s);
                else if (c === o) return null;
            return f
        }

        function d(e, t, a) {
            for (var n, s = 0, r = e.length, i = []; s < r; s++) {
                if (n = e[s], a && (n = a(n)), t === n) return null;
                t < n && i.push(n)
            }
            return i
        }

        function f(e, t) {
            for (var a, n = 0, s = e.length; n < s; n++) {
                if (a = parseInt(e[n], 10), isNaN(a) || a < t.start || a > t.end || 0 === a && t.start < 0) return null;
                e[n] = a
            }
            return e.sort(v)
        }

        function y(e) {
            for (var a, n, s, r = 0, i = e.length; r < i; r++) {
                if (a = e[r], n = a.length, s = a.substring(n - 2).toUpperCase(), s = oe[s], s === t) return null;
                e[r] = {
                    offset: parseInt(a.substring(0, n - 2), 10) || 0,
                    day: s
                }
            }
            return e
        }

        function p(e) {
            for (var t, a, n = 0, s = e.length, r = []; n < s; n++) t = e[n], "string" == typeof t ? a = t : (a = "" + le[t.day], t.offset && (a = t.offset + a)), r.push(a);
            return "" + r
        }

        function m(e) {
            var t = e.getMonth();
            return 1 === t ? 1 === new Date(e.getFullYear(), 1, 29).getMonth() ? 29 : 28 : ie[t]
        }

        function k(e) {
            return e = e.getFullYear(), e % 4 === 0 && e % 100 !== 0 || e % 400 === 0
        }

        function v(e, t) {
            return e - t
        }

        function h(e, t) {
            var a, n, s = 0,
                r = [];
            if (e)
                for (e = e.split(e.indexOf(";") !== -1 ? ";" : ","), a = e.length; s < a; s++) n = H(e[s], t), n && r.push(n);
            return r
        }

        function g(t, a, n) {
            for (var s = e.isArray(t) ? t : h(t, n), r = a.getTime() - a.getMilliseconds(), i = 0, l = s.length; i < l; i++)
                if (s[i].getTime() === r) return !0;
            return !1
        }

        function _(e, t) {
            var a, n, s = 0,
                r = [].concat(e);
            for (a = r.length; s < a; s++) n = r[s], n = Z.timezone.convert(n, t || n.getTimezoneOffset(), "Etc/UTC"), r[s] = Z.toString(n, fe);
            return r.join(",")
        }

        function w(e, t) {
            var a = new Date(e);
            switch (t.freq) {
                case "yearly":
                    a.setFullYear(a.getFullYear(), 0, 1);
                    break;
                case "monthly":
                    a.setFullYear(a.getFullYear(), a.getMonth(), 1);
                    break;
                case "weekly":
                    ee(a, t.weekStart, -1)
            }
            return t.hours && a.setHours(0), t.minutes && a.setMinutes(0), t.seconds && a.setSeconds(0), a
        }

        function D(e, t) {
            var a = new Date(e);
            switch (t.freq) {
                case "yearly":
                    a.setFullYear(a.getFullYear(), 11, 31);
                    break;
                case "monthly":
                    a.setFullYear(a.getFullYear(), a.getMonth() + 1, 0);
                    break;
                case "weekly":
                    ee(a, t.weekStart, -1), a.setDate(a.getDate() + 6)
            }
            return t.hours && a.setHours(23), t.minutes && a.setMinutes(59), t.seconds && a.setSeconds(59), a
        }

        function b(e, t, a) {
            var n, s, r, i, l = e.length,
                o = [];
            for (r = 0, i = a.length; r < i; r++) n = a[r], n < 0 ? n = l + n : n -= 1, s = e[n], s && s.start >= t && o.push(s);
            return o
        }

        function T(e, t, a) {
            var n, s, r = [];
            for (s = 0; s < e.length; s++) n = e[s], g(t, n.start, a) || r.push(n);
            return r
        }

        function M(e, a, n, s) {
            var r, i, l, o, u, c, d, f, y, p, m, k, v, M, H, O, S, F, R, q, B, z, N, V, W, P, U, C, I, A, L, Z, j, K, Q, X, G = Y(e.recurrenceRule, s),
                ee = [];
            if (!G) return [e];
            for (q = G.positions, B = q ? 0 : 1, p = G.start, m = G.end, (p || m) && (e = e.clone({
                    start: p ? new Date(p.value[0]) : t,
                    end: m ? new Date(m.value[0]) : t
                })), S = e.start, O = S.getTime(), H = ne(S), M = h(e.recurrenceException, s), !M[0] && G.exdates && (M = G.exdates.value, e.set("recurrenceException", _(M, s))), f = a = new Date(a), n = new Date(n), v = G.freq, R = _e[v], F = G.count, G.until && G.until < n && (n = new Date(G.until)), k = "yearly" === v || "monthly" === v || "weekly" === v, a < O || F || G.interval > 1 || k || ("daily" === v || "hourly" === v) && !G.seconds ? a = new Date(O) : (o = a.getHours(), u = a.getMinutes(), c = a.getSeconds(), G.hours || (o = S.getHours()), G.minutes || (u = S.getMinutes()), G.seconds || (c = S.getSeconds()), a.setHours(o, u, c, S.getMilliseconds())), G._startPeriod = new Date(a), q && (a = w(a, G), n = D(n, G), U = ne(n) - ne(a), U < 0 && (o = a.getHours(), n.setHours(o, a.getMinutes(), a.getSeconds(), a.getMilliseconds()), J.adjustDST(n, o)), G._startPeriod = new Date(a), G._endPeriod = D(a, G)), d = e.duration(), G._startTime = r = J.toInvariantTime(a), R.setup && R.setup(G, S, a), R.limit(a, n, G); a <= n;)
                if (l = new Date(a), $(l, d), y = a >= f || l > f, (y && !g(M, a, s) || q) && (r = J.toUtcTime(J.getDate(a)) + ne(G._startTime), i = r + d, O !== a.getTime() || H !== ne(G._startTime) ? (e.isAllDay || (C = e.startTimezone || e.endTimezone, I = e.endTimezone || e.startTimezone, (s && C || !s && !C) && (A = E(a, s) - E(e.start, s), L = E(l, s) - E(e.end, s), Z = E(a, C) - E(e.start, C), j = E(l, I) - E(e.end, I), A !== Z && (K = 6e4 * (A - Z), N = new Date(a.getTime() - K), W = r - K), L !== j && (Q = 6e4 * (L - j), V = new Date(l.getTime() - Q), P = i - Q))), ee.push(e.toOccurrence({
                        start: N || new Date(a),
                        end: V || l,
                        _startTime: W || r,
                        _endTime: P || i
                    })), N = V = W = P = null) : (e._startTime = r, e._endTime = i, ee.push(e))), q) {
                    if (R.next(a, G), R.limit(a, n, G), a > G._endPeriod && (z = b(ee.slice(B), S, q), z = T(z, M, s), ee = ee.slice(0, B).concat(z), G._endPeriod = D(a, G), B = ee.length), F && F === B) break
                } else {
                    if (F && F === B) break;
                    B += 1, X = x(a), R.next(a, G), X && "hourly" !== G.freq && J.toInvariantTime(e.start).getTime() !== J.toInvariantTime(a).getTime() && (G._startTime = r = new Date(a.getTime() - 36e5)), R.limit(a, n, G)
                }
            return ee
        }

        function x(e) {
            var t = e.getTimezoneOffset(),
                a = new Date(e.getTime() - 36e5),
                n = a.getTimezoneOffset();
            return t < n
        }

        function E(e, t) {
            return t ? Z.timezone.offset(e, t) : e.getTimezoneOffset()
        }

        function H(e, t) {
            return e = Z.parseDate(e, ue), e && t && (e = j.apply(e, t)), e
        }

        function O(e, t) {
            var a, n, s, r, i, l, o, u, c = e.split(";");
            for (o = 0, u = c.length; o < u; o++)
                if (a = c[o].split(":"), n = a[0], s = a[1], n.indexOf("TZID") !== -1 && (r = n.substring(n.indexOf("TZID")).split("=")[1]), s)
                    for (s = s.split(","), i = 0, l = s.length; i < l; i++) s[i] = H(s[i], r || t);
            if (s) return {
                value: s,
                tzid: r
            }
        }

        function Y(a, n) {
            var s, r, i, l, o, u, c, d, p, m = {},
                k = 0,
                v = !1,
                h = function(e, t) {
                    var a = e.day,
                        n = t.day;
                    return a < d && (a += 7), n < d && (n += 7), a - n
                };
            if (!a) return null;
            for (u = a.split("\n"), u[1] || a.indexOf("DTSTART") === -1 && a.indexOf("DTEND") === -1 && a.indexOf("EXDATE") === -1 || (u = a.split(" ")), k = 0, i = u.length; k < i; k++) o = e.trim(u[k]), o.indexOf("DTSTART") !== -1 ? m.start = O(o, n) : o.indexOf("DTEND") !== -1 ? m.end = O(o, n) : o.indexOf("EXDATE") !== -1 ? m.exdates = O(o, n) : o.indexOf("RRULE") !== -1 ? l = o.substring(6) : e.trim(o) && (l = o);
            for (l = l.split(";"), k = 0, i = l.length; k < i; k++) switch (c = l[k], s = c.split("="), r = e.trim(s[1]).split(","), e.trim(s[0]).toUpperCase()) {
                case "FREQ":
                    m.freq = r[0].toLowerCase();
                    break;
                case "UNTIL":
                    m.until = H(r[0], n);
                    break;
                case "COUNT":
                    m.count = parseInt(r[0], 10);
                    break;
                case "INTERVAL":
                    m.interval = parseInt(r[0], 10);
                    break;
                case "BYSECOND":
                    m.seconds = f(r, {
                        start: 0,
                        end: 60
                    }), v = !0;
                    break;
                case "BYMINUTE":
                    m.minutes = f(r, {
                        start: 0,
                        end: 59
                    }), v = !0;
                    break;
                case "BYHOUR":
                    m.hours = f(r, {
                        start: 0,
                        end: 23
                    }), v = !0;
                    break;
                case "BYMONTHDAY":
                    m.monthDays = f(r, {
                        start: -31,
                        end: 31
                    }), v = !0;
                    break;
                case "BYYEARDAY":
                    m.yearDays = f(r, {
                        start: -366,
                        end: 366
                    }), v = !0;
                    break;
                case "BYMONTH":
                    m.months = f(r, {
                        start: 1,
                        end: 12
                    }), v = !0;
                    break;
                case "BYDAY":
                    m.weekDays = p = y(r), v = !0;
                    break;
                case "BYWEEKNO":
                    m.weeks = f(r, {
                        start: -53,
                        end: 53
                    }), v = !0;
                    break;
                case "BYSETPOS":
                    m.positions = f(r, {
                        start: -366,
                        end: 366
                    });
                    break;
                case "WKST":
                    m.weekStart = d = oe[r[0]]
            }
            return m.freq === t || m.count !== t && m.until ? null : (m.interval || (m.interval = 1), d === t && (m.weekStart = d = Z.culture().calendar.firstDay), p && (m.weekDays = p.sort(h)), m.positions && !v && (m.positions = null), m._hasRuleValue = v, m)
        }

        function S(e, t) {
            for (var a, n = e.value, s = e.tzid || "", r = n.length, i = 0; i < r; i++) a = n[i], a = j.convert(a, s || t || a.getTimezoneOffset(), "Etc/UTC"), n[i] = Z.toString(a, "yyyyMMddTHHmmssZ");
            return s && (s = ";TZID=" + s), s + ":" + n.join(",") + " "
        }

        function F(e, a) {
            var n = e.weekStart,
                s = "FREQ=" + e.freq.toUpperCase(),
                r = e.exdates || "",
                i = e.start || "",
                l = e.end || "",
                o = e.until;
            return e.interval > 1 && (s += ";INTERVAL=" + e.interval), e.count && (s += ";COUNT=" + e.count), o && (o = j.convert(o, a || o.getTimezoneOffset(), "Etc/UTC"), s += ";UNTIL=" + Z.toString(o, "yyyyMMddTHHmmssZ")), e.months && (s += ";BYMONTH=" + e.months), e.weeks && (s += ";BYWEEKNO=" + e.weeks), e.yearDays && (s += ";BYYEARDAY=" + e.yearDays), e.monthDays && (s += ";BYMONTHDAY=" + e.monthDays), e.weekDays && (s += ";BYDAY=" + p(e.weekDays)), e.hours && (s += ";BYHOUR=" + e.hours), e.minutes && (s += ";BYMINUTE=" + e.minutes), e.seconds && (s += ";BYSECOND=" + e.seconds), e.positions && (s += ";BYSETPOS=" + e.positions), n !== t && (s += ";WKST=" + le[n]), i && (i = "DTSTART" + S(i, a)), l && (l = "DTEND" + S(l, a)), r && (r = "EXDATE" + S(r, a)), (i || l || r) && (s = i + l + r + "RRULE:" + s), s
        }
        var R, q, B, z, N, V, W, P, U, C, I, A, L, Z = window.kendo,
            j = Z.timezone,
            K = Z.Class,
            Q = Z.ui,
            X = Q.Widget,
            G = Q.DropDownList,
            J = Z.date,
            $ = J.setTime,
            ee = J.setDayOfWeek,
            te = J.adjustDST,
            ae = J.firstDayOfMonth,
            ne = J.getMilliseconds,
            se = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335, 366],
            re = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334, 365],
            ie = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
            le = {
                0: "SU",
                1: "MO",
                2: "TU",
                3: "WE",
                4: "TH",
                5: "FR",
                6: "SA"
            },
            oe = {
                SU: 0,
                MO: 1,
                TU: 2,
                WE: 3,
                TH: 4,
                FR: 5,
                SA: 6
            },
            ue = ["yyyy-MM-ddTHH:mm:ss.fffzzz", "yyyy-MM-ddTHH:mm:sszzz", "yyyy-MM-ddTHH:mm:ss", "yyyy-MM-ddTHH:mm", "yyyy-MM-ddTHH", "yyyy-MM-dd", "yyyyMMddTHHmmssfffzzz", "yyyyMMddTHHmmsszzz", "yyyyMMddTHHmmss", "yyyyMMddTHHmm", "yyyyMMddTHH", "yyyyMMdd"],
            ce = ["months", "weeks", "yearDays", "monthDays", "weekDays", "hours", "minutes", "seconds"],
            de = ce.length,
            fe = "yyyyMMddTHHmmssZ",
            ye = {
                months: function(e, t, a) {
                    var n = a.months,
                        s = d(n, e.getMonth() + 1),
                        r = !1;
                    return null !== s && (s.length ? e.setMonth(s[0] - 1, 1) : e.setFullYear(e.getFullYear() + 1, n[0] - 1, 1), r = !0), r
                },
                monthDays: function(e, t, a) {
                    for (var n, s, r, i = !1, l = e.getHours(), o = function(e) {
                            return e < 0 && (e = n + e + 1), e
                        }; e <= t;) {
                        if (s = e.getMonth(), n = m(e), r = d(a.monthDays, e.getDate(), o), null === r) return i;
                        if (i = !0, r.length) {
                            if (e.setMonth(s, r.sort(v)[0]), te(e, l), s === e.getMonth()) break
                        } else e.setMonth(s + 1, 1)
                    }
                    return i
                },
                yearDays: function(e, t, a) {
                    for (var s, r, i = !1, l = e.getHours(), o = function(e) {
                            return e < 0 && (e = s + e), e
                        }; e < t;) {
                        if (s = k(e) ? 366 : 365, r = d(a.yearDays, n(e), o), null === r) return i;
                        if (i = !0, s = e.getFullYear(), r.length) {
                            e.setFullYear(s, 0, r.sort(v)[0]), te(e, l);
                            break
                        }
                        e.setFullYear(s + 1, 0, 1)
                    }
                    return i
                },
                weeks: function(e, t, a) {
                    for (var n, r, i, l = a.weekStart, o = !1, u = e.getHours(), c = function(e) {
                            return e < 0 && (e = 53 + e), e
                        }; e < t;) {
                        if (r = d(a.weeks, s(e, l), c), null === r) return o;
                        if (o = !0, n = e.getFullYear(), r.length) {
                            i = 7 * r.sort(v)[0] - 1, e.setFullYear(n, 0, i), ee(e, l, -1), te(e, u);
                            break
                        }
                        e.setFullYear(n + 1, 0, 1)
                    }
                    return o
                },
                weekDays: function(e, t, a) {
                    var n, s, i = a.weekDays,
                        l = a.weekStart,
                        d = c(i, e, l),
                        f = e.getHours();
                    if (null === d) return !1;
                    if (n = d[0], n || (n = i[0], ee(e, l)), s = n.day, n.offset)
                        for (; e <= t && !u(e, n, l);) r(e, l) === o(e, l) ? (e.setMonth(e.getMonth() + 1, 1), te(e, f)) : (e.setDate(e.getDate() + 7), te(e, f), ee(e, l, -1));
                    return e.getDay() !== s && ee(e, s), !0
                },
                hours: function(e, t, a) {
                    var n = a.hours,
                        s = a._startTime,
                        r = s.getHours(),
                        i = d(n, r),
                        l = !1;
                    return null !== i && (l = !0, e.setHours(r), te(e, r), i.length ? (i = i[0], e.setHours(i)) : (i = e.getHours(), e.setDate(e.getDate() + 1), te(e, i), i = n[0], e.setHours(i), te(e, i)), a.minutes && e.setMinutes(0), s.setHours(i, e.getMinutes())), l
                },
                minutes: function(e, t, a) {
                    var n = a.minutes,
                        s = e.getMinutes(),
                        r = d(n, s),
                        i = a._startTime.getHours(),
                        l = !1;
                    return null !== r && (l = !0, r.length ? r = r[0] : (i += 1, r = n[0]), a.seconds && e.setSeconds(0), e.setHours(i, r), i %= 24, te(e, i), a._startTime.setHours(i, r, e.getSeconds())), l
                },
                seconds: function(e, t, a) {
                    var n = a.seconds,
                        s = a._startTime.getHours(),
                        r = d(n, e.getSeconds()),
                        i = e.getMinutes(),
                        l = !1;
                    return null !== r && (l = !0, r.length ? e.setSeconds(r[0]) : (i += 1, e.setMinutes(i, n[0]), i > 59 && (i %= 60, s = (s + 1) % 24)), a._startTime.setHours(s, i, e.getSeconds())), l
                }
            },
            pe = K.extend({
                next: function(e, t) {
                    var a, n, s = t._startTime,
                        r = s.getDate();
                    if (t.seconds) n = e.getSeconds() + 1, e.setSeconds(n), s.setSeconds(n), s.setDate(r);
                    else {
                        if (!t.minutes) return !1;
                        a = e.getMinutes() + 1, e.setMinutes(a), s.setMinutes(a), s.setDate(r)
                    }
                    return !0
                },
                normalize: function(e) {
                    var t = e.rule;
                    4 === e.idx && t.hours && (t._startTime.setHours(0), this._hour(e.date, t))
                },
                limit: function(e, a, n) {
                    for (var s, r, i, l, o, u = n.interval; e <= a;) {
                        for (i = r = t, o = e.getDate(), l = 0; l < de; l++) {
                            if (s = ce[l], n[s]) {
                                if (i = ye[s](e, a, n), r !== t && i) break;
                                r = i
                            }
                            i && this.normalize({
                                date: e,
                                rule: n,
                                day: o,
                                idx: l
                            })
                        }
                        if ((1 === u || !this.interval(n, e)) && l === de) break
                    }
                },
                interval: function(e, t) {
                    var n, s, r, l, o = new Date(e._startPeriod),
                        u = new Date(t),
                        c = t.getHours(),
                        d = e.weekStart,
                        f = e.interval,
                        y = e.freq,
                        p = !1,
                        m = 0,
                        k = 0,
                        v = 1;
                    return "hourly" === y ? (n = u.getTimezoneOffset() - o.getTimezoneOffset(), s = e._startTime.getHours(), u = u.getTime(), c !== s && (u += (s - c) * J.MS_PER_HOUR), u -= o, n && (u -= n * J.MS_PER_MINUTE), n = Math.floor(u / J.MS_PER_HOUR), m = a(n, f), 0 !== m && (this._hour(t, e, m), p = !0)) : "daily" === y ? (J.setTime(u, -o, !0), n = Math.round(u / J.MS_PER_DAY), m = a(n, f), 0 !== m && (this._date(t, e, m), p = !0)) : "weekly" === y ? (m = this._getNumberOfWeeksBetweenDates(o, t), r = i(t.getDay(), d), l = i(o.getDay(), d), r < l && (m += 1), m = a(m, f), 0 !== m && (J.setDayOfWeek(t, e.weekStart, -1), t.setDate(t.getDate() + 7 * m), te(t, c), p = !0)) : "monthly" === y ? (n = t.getFullYear() - o.getFullYear(), n = t.getMonth() - o.getMonth() + 12 * n, m = a(n, f), 0 !== m && (v = e._hasRuleValue ? 1 : t.getDate(), t.setFullYear(t.getFullYear(), t.getMonth() + m, v), te(t, c), p = !0)) : "yearly" === y && (n = t.getFullYear() - o.getFullYear(), m = a(n, f), e.months || (k = t.getMonth()), e.yearDays || e.monthDays || e.weekDays || (v = t.getDate()), 0 !== m && (t.setFullYear(t.getFullYear() + m, k, v), te(t, c), p = !0)), p
                },
                _getNumberOfWeeksBetweenDates: function(e, t) {
                    var a = (t - e) / 6048e5,
                        n = Math.floor(a);
                    return a - n > .99 && (n = Math.round(a)), n
                },
                _hour: function(e, t, a) {
                    var n = t._startTime,
                        s = n.getHours();
                    a && (s += a), e.setHours(s), s %= 24, n.setHours(s), te(e, s)
                },
                _date: function(e, t, a) {
                    var n = e.getHours();
                    e.setDate(e.getDate() + a), te(e, n) || this._hour(e, t)
                }
            }),
            me = pe.extend({
                next: function(e, t) {
                    pe.fn.next(e, t) || this._hour(e, t, 1)
                },
                normalize: function(e) {
                    var t = e.rule;
                    4 === e.idx && (t._startTime.setHours(0), this._hour(e.date, t))
                }
            }),
            ke = pe.extend({
                next: function(e, t) {
                    pe.fn.next(e, t) || this[t.hours ? "_hour" : "_date"](e, t, 1)
                }
            }),
            ve = ke.extend({
                setup: function(e, t) {
                    e.weekDays || (e.weekDays = [{
                        day: t.getDay(),
                        offset: 0
                    }])
                }
            }),
            he = pe.extend({
                next: function(e, t) {
                    var a, n;
                    if (!pe.fn.next(e, t))
                        if (t.hours) this._hour(e, t, 1);
                        else if (t.monthDays || t.weekDays || t.yearDays || t.weeks) this._date(e, t, 1);
                    else {
                        for (a = e.getDate(), n = e.getHours(), e.setMonth(e.getMonth() + 1), te(e, n); e.getDate() !== a;) e.setDate(a), te(e, n);
                        this._hour(e, t)
                    }
                },
                normalize: function(e) {
                    var t = e.rule,
                        a = e.date,
                        n = a.getHours();
                    0 !== e.idx || t.monthDays || t.weekDays ? pe.fn.normalize(e) : (a.setDate(e.day), te(a, n))
                },
                setup: function(e, t, a) {
                    e.monthDays || e.weekDays || a.setDate(t.getDate())
                }
            }),
            ge = he.extend({
                next: function(e, t) {
                    var a, n = e.getHours();
                    if (!pe.fn.next(e, t))
                        if (t.hours) this._hour(e, t, 1);
                        else if (t.monthDays || t.weekDays || t.yearDays || t.weeks) this._date(e, t, 1);
                    else if (t.months) {
                        for (a = e.getDate(), e.setMonth(e.getMonth() + 1), te(e, n); e.getDate() !== a;) e.setDate(a), te(e, n);
                        this._hour(e, t)
                    } else e.setFullYear(e.getFullYear() + 1), te(e, n), this._hour(e, t)
                },
                setup: function() {}
            }),
            _e = {
                hourly: new me,
                daily: new ke,
                weekly: new ve,
                monthly: new he,
                yearly: new ge
            },
            we = "click",
            De = "change";
        Z.recurrence = {
            rule: {
                parse: Y,
                serialize: F
            },
            expand: M,
            dayInYear: n,
            weekInYear: s,
            weekInMonth: r,
            numberOfWeeks: o,
            isException: g,
            toExceptionString: _
        }, R = function(e) {
            for (var t = Z.culture().calendar.days.namesShort, a = t.length, n = "", s = 0, r = []; s < a; s++) r.push(s);
            for (t = t.slice(e).concat(t.slice(0, e)), r = r.slice(e).concat(r.slice(0, e)), s = 0; s < a; s++) n += '<label class="k-check"><input class="k-recur-weekday-checkbox" type="checkbox" value="' + r[s] + '" /> ' + t[s] + "</label>";
            return n
        }, q = function(e) {
            for (var t = Z.culture().calendar.days.names, a = t.length, n = "", s = 0, r = []; s < a; s++) r.push(s);
            for (t = t.slice(e).concat(t.slice(0, e)), r = r.slice(e).concat(r.slice(0, e)), s = 0; s < a; s++) n += '<li class="k-item k-listgroup-item">', n += '<label class="k-label k-listgroup-form-row">', n += '<span class="k-item-title k-listgroup-form-field-label">' + t[s] + "</span>", n += '<span class="k-listgroup-form-field-wrapper">', n += '<input class="k-recur-weekday-checkbox k-check" type="checkbox" value="' + r[s] + '" />', n += "</span>", n += "</label>", n += "</li>";
            return n
        }, B = Z.template('# if (frequency !== "never") { #<div class="k-edit-label"><label>#:messages.repeatEvery#</label></div><div class="k-edit-field"><input class="k-recur-interval" title="#:messages.interval#"/>#:messages.interval#</div># } ## if (frequency === "weekly") { #<div class="k-edit-label"><label>#:messages.repeatOn#</label></div><div class="k-edit-field">#=weekDayCheckBoxes(firstWeekDay)#</div># } else if (frequency === "monthly") { #<div class="k-edit-label"><label>#:messages.repeatOn#</label></div><div class="k-edit-field"><ul class="k-reset"><li><label><input class="k-recur-month-radio" type="radio" name="month" value="monthday" title="#:messages.day#" />#:messages.day#</label><input class="k-recur-monthday" title="#:messages.day#" /></li><li><input class="k-recur-month-radio" type="radio" name="month" value="weekday" title="#:messages.repeatOn#" /><input class="k-recur-weekday-offset" title="#:messages.repeatOn#" /><input class="k-recur-weekday" title="#:messages.day#" /></li></ul></div># } else if (frequency === "yearly") { #<div class="k-edit-label"><label>#:messages.repeatOn#</label></div><div class="k-edit-field"><ul class="k-reset"><li><input class="k-recur-year-radio" type="radio" name="year" value="monthday" title="#:messages.repeatOn#" /><input class="k-recur-month" title="#:messages.repeatOn#" /><input class="k-recur-monthday" title="#:messages.day#" /></li><li><input class="k-recur-year-radio" type="radio" name="year" value="weekday" title="#:messages.repeatOn#" /><input class="k-recur-weekday-offset" title="#:messages.repeatOn#" /><input class="k-recur-weekday" title="#:messages.day#"  />#:messages.of#<input class="k-recur-month" title="#:messages.of#"/></li></ul></div># } ## if (frequency !== "never") { #<div class="k-edit-label"><label>#:end.label#</label></div><div class="k-edit-field"><ul class="k-reset"><li><label><input class="k-recur-end-never" type="radio" name="end" value="never" />#:end.never#</label></li><li><label><input class="k-recur-end-count" type="radio" name="end" value="count" />#:end.after#</label><input class="k-recur-count" title="#:end.occurrence#" />#:end.occurrence#</li><li><label><input class="k-recur-end-until" type="radio" name="end" value="until" />#:end.on#</label><input class="k-recur-until" title="#:end.on#" /></li></ul></div># } #'), z = [{
            day: 0,
            offset: 0
        }, {
            day: 1,
            offset: 0
        }, {
            day: 2,
            offset: 0
        }, {
            day: 3,
            offset: 0
        }, {
            day: 4,
            offset: 0
        }, {
            day: 5,
            offset: 0
        }, {
            day: 6,
            offset: 0
        }], N = [{
            day: 1,
            offset: 0
        }, {
            day: 2,
            offset: 0
        }, {
            day: 3,
            offset: 0
        }, {
            day: 4,
            offset: 0
        }, {
            day: 5,
            offset: 0
        }], V = [{
            day: 0,
            offset: 0
        }, {
            day: 6,
            offset: 0
        }], W = X.extend({
            init: function(e, t) {
                var a, n = this,
                    s = t && t.frequencies;
                X.fn.init.call(n, e, t), n.wrapper = n.element, t = n.options, t.start = a = t.start || J.today(), s && (t.frequencies = s), "string" == typeof a && (t.start = Z.parseDate(a, "yyyyMMddTHHmmss")), null === t.firstWeekDay && (t.firstWeekDay = Z.culture().calendar.firstDay), n._namespace = "." + t.name
            },
            options: {
                value: "",
                start: "",
                timezone: "",
                spinners: !0,
                firstWeekDay: null,
                frequencies: ["never", "daily", "weekly", "monthly", "yearly"],
                mobile: !1,
                messages: {
                    recurrenceEditorTitle: "Recurrence editor",
                    frequencies: {
                        never: "Never",
                        hourly: "Hourly",
                        daily: "Daily",
                        weekly: "Weekly",
                        monthly: "Monthly",
                        yearly: "Yearly"
                    },
                    hourly: {
                        repeatEvery: "Repeat every: ",
                        interval: " hour(s)"
                    },
                    daily: {
                        repeatEvery: "Repeat every: ",
                        interval: " day(s)"
                    },
                    weekly: {
                        interval: " week(s)",
                        repeatEvery: "Repeat every: ",
                        repeatOn: "Repeat on: "
                    },
                    monthly: {
                        repeatEvery: "Repeat every: ",
                        repeatOn: "Repeat on: ",
                        interval: " month(s)",
                        day: "Day "
                    },
                    yearly: {
                        repeatEvery: "Repeat every: ",
                        repeatOn: "Repeat on: ",
                        interval: " year(s)",
                        of: " of "
                    },
                    end: {
                        label: "End:",
                        mobileLabel: "Ends",
                        never: "Never",
                        after: "After ",
                        occurrence: " occurrence(s)",
                        on: "On "
                    },
                    offsetPositions: {
                        first: "first",
                        second: "second",
                        third: "third",
                        fourth: "fourth",
                        last: "last"
                    },
                    weekdays: {
                        day: "day",
                        weekday: "weekday",
                        weekend: "weekend day"
                    }
                }
            },
            events: ["change"],
            _initInterval: function() {
                var e = this,
                    t = e._value;
                e._container.find(".k-recur-interval").kendoNumericTextBox({
                    spinners: e.options.spinners,
                    value: t.interval || 1,
                    decimals: 0,
                    format: "#",
                    min: 1,
                    change: function() {
                        t.interval = this.value(), e._trigger()
                    }
                })
            },
            _weekDayRule: function(e) {
                var t = this,
                    a = (t._weekDay.element || t._weekDay).val(),
                    n = +(t._weekDayOffset.element || t._weekDayOffset).val(),
                    s = null,
                    r = null;
                e || ("day" === a ? (s = z, r = n) : "weekday" === a ? (s = N, r = n) : "weekend" === a ? (s = V, r = n) : s = [{
                    offset: n,
                    day: +a
                }]), t._value.weekDays = s, t._value.positions = r
            },
            _weekDayView: function() {
                var e, t, a, n, s = this,
                    r = s._value.weekDays,
                    i = s._value.positions,
                    l = s._weekDayOffset;
                r && (a = r.length, i && (7 === a ? (t = "day", e = i) : 5 === a ? (t = "weekday", e = i) : 2 === a && (t = "weekend", e = i)), t || (r = r[0], t = r.day, e = r.offset || ""), n = l.value ? "value" : "val", l[n](e), s._weekDay[n](t))
            },
            _initWeekDay: function() {
                var t, a = this,
                    n = a.options.messages.weekdays,
                    s = a.options.messages.offsetPositions,
                    r = a._container.find(".k-recur-weekday"),
                    i = function() {
                        a._weekDayRule(), a._trigger()
                    };
                r[0] && (a._weekDayOffset = new G(a._container.find(".k-recur-weekday-offset"), {
                    change: i,
                    dataTextField: "text",
                    dataValueField: "value",
                    dataSource: [{
                        text: s.first,
                        value: "1"
                    }, {
                        text: s.second,
                        value: "2"
                    }, {
                        text: s.third,
                        value: "3"
                    }, {
                        text: s.fourth,
                        value: "4"
                    }, {
                        text: s.last,
                        value: "-1"
                    }]
                }), t = [{
                    text: n.day,
                    value: "day"
                }, {
                    text: n.weekday,
                    value: "weekday"
                }, {
                    text: n.weekend,
                    value: "weekend"
                }], a._weekDay = new G(r, {
                    value: a.options.start.getDay(),
                    change: i,
                    dataTextField: "text",
                    dataValueField: "value",
                    dataSource: t.concat(e.map(Z.culture().calendar.days.names, function(e, t) {
                        return {
                            text: e,
                            value: t
                        }
                    }))
                }), a._weekDayView())
            },
            _initWeekDays: function() {
                var t, a, n, s, r, i = this,
                    l = i._value,
                    o = i._container.find(".k-recur-weekday-checkbox");
                if (o[0] && (o.on(we + i._namespace, function() {
                        l.weekDays = e.map(o.filter(":checked"), function(e) {
                            return {
                                day: +e.value,
                                offset: 0
                            }
                        }), i.options.mobile || i._trigger()
                    }), l.weekDays))
                    for (n = 0, s = o.length, r = l.weekDays.length; n < s; n++)
                        for (a = o[n], t = 0; t < r; t++) a.value == l.weekDays[t].day && (a.checked = !0)
            },
            _initMonthDay: function() {
                var e = this,
                    t = e._value,
                    a = e._container.find(".k-recur-monthday");
                a[0] && (e._monthDay = new Z.ui.NumericTextBox(a, {
                    spinners: e.options.spinners,
                    min: 1,
                    max: 31,
                    decimals: 0,
                    format: "#",
                    value: t.monthDays ? t.monthDays[0] : e.options.start.getDate(),
                    change: function() {
                        var a = this.value();
                        t.monthDays = a ? [a] : a, e._trigger()
                    }
                }))
            },
            _initCount: function() {
                var e = this,
                    t = e._container.find(".k-recur-count"),
                    a = e._value;
                e._count = t.kendoNumericTextBox({
                    spinners: e.options.spinners,
                    value: a.count || 1,
                    decimals: 0,
                    format: "#",
                    min: 1,
                    change: function() {
                        a.count = this.value(), e._trigger()
                    }
                }).data("kendoNumericTextBox")
            },
            _initUntil: function() {
                var e = this,
                    t = e._container.find(".k-recur-until"),
                    a = e.options.start,
                    n = e._value,
                    s = n.until;
                e._until = t.kendoDatePicker({
                    min: s && s < a ? s : a,
                    value: s || new Date(a.getFullYear(), a.getMonth(), a.getDate(), 23, 59, 59),
                    change: function() {
                        var t = this.value();
                        n.until = new Date(t.getFullYear(), t.getMonth(), t.getDate(), 23, 59, 59), e._trigger()
                    }
                }).data("kendoDatePicker")
            },
            _trigger: function() {
                this.options.mobile || this.trigger("change")
            }
        }), P = W.extend({
            init: function(e, t) {
                var a = this;
                W.fn.init.call(a, e, t), a._initFrequency(), a._initContainer(), a.value(a.options.value)
            },
            options: {
                name: "RecurrenceEditor"
            },
            events: ["change"],
            destroy: function() {
                var e = this;
                e._frequency.destroy(), e._container.find("input[type=radio],input[type=checkbox]").off(we + e._namespace), Z.destroy(e._container), W.fn.destroy.call(e)
            },
            value: function(e) {
                var a, n = this,
                    s = n.options.timezone;
                return e === t ? n._value.freq ? F(n._value, s) : "" : (n._value = Y(e, s) || {}, a = n._value.freq, a ? n._frequency.value(a) : n._frequency.select(0), n._initView(n._frequency.value()), t)
            },
            _initContainer: function() {
                var t = this.element,
                    a = e('<div class="k-recur-view" />'),
                    n = t.parent(".k-edit-field");
                n[0] ? a.insertAfter(n) : t.append(a), this._container = a
            },
            _initFrequency: function() {
                var t, a = this,
                    n = a.options,
                    s = n.frequencies,
                    r = n.messages.frequencies,
                    i = e("<input />").attr({
                        title: n.messages.recurrenceEditorTitle
                    });
                s = e.map(s, function(e) {
                    return {
                        text: r[e],
                        value: e
                    }
                }), t = s[0], t && "never" === t.value && (t.value = ""), a.element.append(i), a._frequency = new G(i, {
                    dataTextField: "text",
                    dataValueField: "value",
                    dataSource: s,
                    change: function() {
                        a._value = {}, a._initView(a._frequency.value()), a.trigger("change")
                    }
                })
            },
            _initView: function(e) {
                var a = this,
                    n = a._value,
                    s = a.options,
                    r = {
                        frequency: e || "never",
                        weekDayCheckBoxes: R,
                        firstWeekDay: s.firstWeekDay,
                        messages: s.messages[e],
                        end: s.messages.end
                    };
                return Z.destroy(a._container), a._container.html(B(r)), e ? (n.freq = e, "weekly" !== e || n.weekDays || (n.weekDays = [{
                    day: s.start.getDay(),
                    offset: 0
                }]), a._initInterval(), a._initWeekDays(), a._initMonthDay(), a._initWeekDay(), a._initMonth(), a._initCount(), a._initUntil(), a._period(), a._end(), t) : (a._value = {}, t)
            },
            _initMonth: function() {
                var t, a = this,
                    n = a._value,
                    s = n.months || [a.options.start.getMonth() + 1],
                    r = a._container.find(".k-recur-month");
                r[0] && (t = {
                    change: function() {
                        n.months = [+this.value()], a.trigger("change")
                    },
                    dataTextField: "text",
                    dataValueField: "value",
                    dataSource: e.map(Z.culture().calendar.months.names, function(e, t) {
                        return {
                            text: e,
                            value: t + 1
                        }
                    })
                }, a._month1 = new G(r[0], t), a._month2 = new G(r[1], t), s && (s = s[0], a._month1.value(s), a._month2.value(s)))
            },
            _end: function() {
                var e, t = this,
                    a = t._value,
                    n = t._container,
                    s = t._namespace,
                    r = function(e) {
                        t._toggleEnd(e.currentTarget.value), t.trigger("change")
                    };
                t._buttonNever = n.find(".k-recur-end-never").on(we + s, r), t._buttonCount = n.find(".k-recur-end-count").on(we + s, r), t._buttonUntil = n.find(".k-recur-end-until").on(we + s, r), a.count ? e = "count" : a.until && (e = "until"), t._toggleEnd(e)
            },
            _period: function() {
                var e = this,
                    t = e._value,
                    a = "monthly" === t.freq,
                    n = a ? e._toggleMonthDay : e._toggleYear,
                    s = ".k-recur-" + (a ? "month" : "year") + "-radio",
                    r = e._container.find(s);
                (a || "yearly" === t.freq) && (r.on(we + e._namespace, function(t) {
                    n.call(e, t.currentTarget.value), e.trigger("change")
                }), e._buttonMonthDay = r.eq(0), e._buttonWeekDay = r.eq(1), n.call(e, t.weekDays ? "weekday" : "monthday"))
            },
            _toggleEnd: function(e) {
                var t, a, n, s, r = this;
                "count" === e ? (r._buttonCount.prop("checked", !0), n = !0, s = !1, t = r._count.value(), a = null) : "until" === e ? (r._buttonUntil.prop("checked", !0), n = !1, s = !0, t = null, a = r._until.value()) : (r._buttonNever.prop("checked", !0), n = s = !1, t = a = null), r._count && r._count.enable(n), r._until && r._until.enable(s), r._value.count = t, r._value.until = a
            },
            _toggleMonthDay: function(e) {
                var t, a = this,
                    n = !1,
                    s = !0,
                    r = !1;
                "monthday" === e ? (a._buttonMonthDay.prop("checked", !0), t = [a._monthDay.value()], n = !0, s = !1, r = !0) : (a._buttonWeekDay.prop("checked", !0), t = null), a._weekDay.enable(s), a._weekDayOffset.enable(s), a._monthDay.enable(n), a._value.monthDays = t, a._weekDayRule(r)
            },
            _toggleYear: function(e) {
                var t, a = this,
                    n = !1,
                    s = !0;
                "monthday" === e ? (n = !0, s = !1, t = a._month1.value()) : t = a._month2.value(), a._month1.enable(n), a._month2.enable(s), a._value.months = [t], a._toggleMonthDay(e)
            }
        }), Q.plugin(P), U = Z.template('<div data-role="content"><ul class="k-listgroup k-listgroup-flush"><li class="k-item k-listgroup-item"><label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">#:headerTitle#</span><div class="k-recur-pattern k-listgroup-form-field-wrapper"></div></label></li><li class="k-item k-listgroup-item k-recur-view"></li></ul></div>'), C = Z.template('# if (frequency !== "never") { #<label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">#:messages.repeatEvery#</span><div class="k-recur-editor-wrap k-listgroup-form-field-wrapper"><input class="k-recur-interval" type="number" pattern="\\\\d*"/># if (messages.interval.length) { #<span class="k-recur-editor-text">#:messages.interval#</span># } #</div></label># } ## if (frequency === "weekly") { #<ul class="k-recur-items-wrap k-listgroup k-listgroup-flush"><li class="k-item k-listgroup-item k-no-click"><label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">#:messages.repeatOn#</span></label></li>#=weekDayCheckBoxes(firstWeekDay)#</ul># } else if (frequency === "monthly") { #<ul class="k-recur-items-wrap k-listgroup k-listgroup-flush"><li class="k-item k-listgroup-item"><label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">#:messages.repeatBy#</span><div class="k-repeat-rule k-listgroup-form-field-wrapper"></div></label></li><li class="k-monthday-view k-item k-listgroup-item" style="display:none"><label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">#:messages.day#</span><div class="k-listgroup-form-field-wrapper"><input class="k-recur-monthday" type="number" title="#:messages.day#" pattern="\\\\d*"/></div></label></li><li class="k-weekday-view k-item k-listgroup-item" style="display:none"><label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">#:messages.every#</span><div class="k-listgroup-form-field-wrapper"><select class="k-recur-weekday-offset" title="#:messages.every#"></select></div></label></li><li class="k-weekday-view k-item k-listgroup-item" style="display:none"><label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">#:messages.day#</span><div class="k-listgroup-form-field-wrapper"><select class="k-recur-weekday" title="#:messages.day#"></select></div></label></li></ul># } else if (frequency === "yearly") { #<ul class="k-recur-items-wrap k-listgroup k-listgroup-flush"><li class="k-item k-listgroup-item"><label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">#:messages.repeatBy#</span><div class="k-repeat-rule k-listgroup-form-field-wrapper"></div></label></li><li class="k-monthday-view k-item k-listgroup-item" style="display:none"><label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">#:messages.day#</span><div class="k-listgroup-form-field-wrapper"><input class="k-recur-monthday" type="number" title="#:messages.day#" pattern="\\\\d*"/></div></label></li><li class="k-weekday-view k-item k-listgroup-item" style="display:none"><label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">#:messages.every#</span><div class="k-listgroup-form-field-wrapper"><select class="k-recur-weekday-offset" title="#:messages.every#"></select></div></label></li><li class="k-weekday-view k-item k-listgroup-item" style="display:none"><label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">#:messages.day#</span><div class="k-listgroup-form-field-wrapper"><select class="k-recur-weekday" title="#:messages.day#"></select></div></label></li><li class="k-item k-item k-listgroup-item"><label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">#:messages.month#</span><div class="k-listgroup-form-field-wrapper"><select class="k-recur-month" title="#:messages.month#"></select></div></label></li></ul># } #'), I = Z.template('# if (endPattern === "count") { #<label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">#:messages.after#</span><div class="k-listgroup-form-field-wrapper"><input class="k-recur-count" type="number" pattern="\\\\d*" /></div></label># } else if (endPattern === "until") { #<label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">#:messages.on#</span><div class="k-listgroup-form-field-wrapper"><input type="date" class="k-recur-until" /></div></label># } #'), A = Z.template('<select class="k-scheduler-select">#for (var i = 0, length = dataSource.length; i < length; i++) {#<option value="#=dataSource[i].value#" #= value === dataSource[i].value  ? "selected" : "" #>#:dataSource[i].text#</option>#}#</select>'), L = W.extend({
            init: function(e, t) {
                var a = this;
                W.fn.init.call(a, e, t), t = a.options, a._optionTemplate = Z.template('<option value="#:value#">#:text#</option>'), a.value(t.value), a._pane = t.pane || a.wrapper.closest("[data-role=pane]").data("kendoPane"), a._initRepeatButton(), a._initParentRepeatEnd(), a._defaultValue = a._value
            },
            options: {
                name: "MobileRecurrenceEditor",
                animations: {
                    left: "slide",
                    right: "slide:right"
                },
                mobile: !0,
                messages: {
                    cancel: "Cancel",
                    update: "Save",
                    endTitle: "Repeat ends",
                    repeatTitle: "Repeat pattern",
                    headerTitle: "Repeat event",
                    end: {
                        patterns: {
                            never: "Never",
                            after: "After...",
                            on: "On..."
                        },
                        never: "Never",
                        after: "End repeat after",
                        on: "End repeat on"
                    },
                    daily: {
                        interval: ""
                    },
                    hourly: {
                        interval: ""
                    },
                    weekly: {
                        interval: ""
                    },
                    monthly: {
                        interval: "",
                        repeatBy: "Repeat by: ",
                        dayOfMonth: "Day of the month",
                        dayOfWeek: "Day of the week",
                        repeatEvery: "Repeat every",
                        every: "Every",
                        day: "Day "
                    },
                    yearly: {
                        interval: "",
                        repeatBy: "Repeat by: ",
                        dayOfMonth: "Day of the month",
                        dayOfWeek: "Day of the week",
                        repeatEvery: "Repeat every: ",
                        every: "Every",
                        month: "Month",
                        day: "Day"
                    }
                }
            },
            events: ["change"],
            value: function(e) {
                var a = this,
                    n = a.options.timezone;
                return e === t ? a._value.freq ? F(a._value, n) : "" : (a._value = Y(e, n) || {}, t)
            },
            destroy: function() {
                this._destroyView(), Z.destroy(this._endFields), this.element.off(we + this._namespace), W.fn.destroy.call(this)
            },
            _initInterval: function() {
                var e = this,
                    t = e._value;
                e._container.find(".k-recur-interval").val(e._value.interval || 1).on(De + e._namespace, function(a) {
                    t.interval = a.target.value, e._trigger()
                })
            },
            _initRepeatButton: function() {
                var t = this,
                    a = t.options.messages.frequencies[this._value.freq || "never"];
                t._chevronButton = e('<span class="k-icon k-i-arrow-chevron-right"></span>'), t._repeatValue = e('<span class="">' + a + "</span>"), t.element.append(t._repeatValue).append(t._chevronButton), t.element.parents("li.k-item").on(we + t._namespace, function(e) {
                    e.preventDefault(), t._createView("repeat"), t._pane.navigate(t._view, t.options.animations.left)
                })
            },
            _endLiItem: function() {
                var e = this;
                return '<li class="k-item k-listgroup-item"><label class="k-label k-listgroup-form-row"><span class="k-item-title k-listgroup-form-field-label">' + e.options.messages.end.mobileLabel + "</span></label></li>"
            },
            _initParentRepeatEnd: function() {
                var t = this,
                    a = e(t._endLiItem()).insertAfter(t.element.parents("li.k-item")),
                    n = e('<div class="k-scheduler-recur-end-wrap k-listgroup-form-field-wrapper"><span class="k-scheduler-recur-end"></span></div>').appendTo(a.find(".k-label"));
                a.on(we + t._namespace, function(e) {
                    e.preventDefault(), t._navigateToView("repeat")
                }), t._endParentLabelField = a.toggle(!!t._value.freq), t._endParentEndButton = n.find(".k-scheduler-recur-end").text(t._endText())
            },
            _initRepeatEnd: function() {
                var t = this,
                    a = e(t._endLiItem()).insertAfter(t._container),
                    n = e('<div class="k-scheduler-recur-end-wrap k-listgroup-form-field-wrapper"><span class="k-scheduler-recur-end"></span><span class="k-icon k-i-arrow-chevron-right"></span></div>').appendTo(a.find(".k-label"));
                a.on(we + t._namespace, function(e) {
                    e.preventDefault(), t._navigateToView("end")
                }), t._endLabelField = a.toggleClass("k-state-disabled", !t._value.freq), t._endButton = n.find(".k-scheduler-recur-end").text(t._endText())
            },
            _navigateToView: function(e) {
                var t = this;
                t._createView(e), t._pane.navigate(t._view, t.options.animations.left)
            },
            _endText: function() {
                var e = this._value,
                    t = this.options.messages.end,
                    a = t.never;
                return e.count ? a = Z.format("{0} {1}", t.after, e.count) : e.until && (a = Z.format("{0} {1:d}", t.on, e.until)), a
            },
            _initFrequency: function() {
                var t = this,
                    a = t.options.messages.frequencies,
                    n = A({
                        dataSource: e.map(this.options.frequencies, function(e) {
                            return {
                                text: a[e],
                                value: "never" !== e ? e : ""
                            }
                        }),
                        value: t._value.freq || "",
                        ns: Z.ns
                    });
                t._view.element.find(".k-recur-pattern").append(n), t._view.element.find(".k-scheduler-select").on(De + t._namespace, function(e) {
                    var a = e.target.value;
                    t._value = {
                        freq: a
                    }, t._initRepeatView(!0)
                })
            },
            _initEndNavigation: function() {
                var e, t = this,
                    a = t.options.messages.end.patterns,
                    n = t._value,
                    s = "";
                n.count ? s = "count" : n.until && (s = "until"), e = A({
                    dataSource: [{
                        text: a.never,
                        value: ""
                    }, {
                        text: a.after,
                        value: "count"
                    }, {
                        text: a.on,
                        value: "until"
                    }],
                    value: s,
                    ns: Z.ns
                }), t._view.element.find(".k-recur-pattern").append(e), t._view.element.find(".k-scheduler-select").on(De + t._namespace, function(e) {
                    var a = e.target.value,
                        s = null,
                        r = null;
                    t._initEndView(a), t._count.length ? (s = t._count.val(), r = null) : t._until.length && (s = null, r = t._until.val ? Z.parseDate(t._until.val(), "yyyy-MM-dd") : t._until.value()), n.count = s, n.until = r
                })
            },
            _createView: function(t) {
                var a = this,
                    n = a.options,
                    s = n.messages,
                    r = s["repeat" === t ? "repeatTitle" : "endTitle"],
                    i = '<div data-role="view" class="k-popup-edit-form k-scheduler-edit-form" id="recurrence"><div data-role="header" class="k-header"><a href="#" class="k-header-cancel k-scheduler-cancel k-link" title="' + s.cancel + '"aria-label="' + s.cancel + '"><span class="k-icon k-i-arrow-chevron-left"></span></a>' + s.headerTitle + '<a href="#" class="k-header-done k-scheduler-update k-link" title="' + s.update + '" aria-label="' + s.update + '"><span class="k-icon k-i-check"></span></a></div>',
                    l = a._pane.view().id;
                a._view = a._pane.append(i + U({
                    headerTitle: r
                })), a._view.element.on(we + a._namespace, "a.k-scheduler-cancel, a.k-scheduler-update", function(t) {
                    t.preventDefault(), t.stopPropagation(), e(this).hasClass("k-scheduler-update") ? (a.trigger("change"), a._defaultValue = e.extend({}, a._value)) : a._value = a._defaultValue;
                    var n = a._value.freq;
                    a._endParentEndButton.text(a._endText()), a._endParentLabelField.toggle(!!n && "never" !== n), a._endButton.text(a._endText()), a._repeatValue.text(s.frequencies[n || "never"]), a._pane.one("viewShow", function() {
                        a._destroyView()
                    }), a._pane.navigate(l, a.options.animations.right)
                }), a._container = a._view.element.find(".k-recur-view"), "repeat" === t ? (a._initFrequency(), a._initRepeatView(!0), a._initRepeatEnd()) : (a._initEndNavigation(), a._initEndView())
            },
            _destroyView: function() {
                this._view && (this._view.destroy(), this._view.element.remove(), this._container = null), this._view = null
            },
            _initRepeatView: function(e) {
                var a = this,
                    n = a._value.freq || "never",
                    s = {
                        frequency: n,
                        weekDayCheckBoxes: e ? q : R,
                        firstWeekDay: a.options.firstWeekDay,
                        messages: a.options.messages[n]
                    },
                    r = C(s),
                    i = a._container = a._container || this._pane.view().content.find("li.k-recur-view"),
                    l = a._value;
                return a._endLabelField && a._endLabelField.toggleClass("k-state-disabled", "never" === n), Z.destroy(i), i.html(r), r ? (i.show(), "weekly" !== n || l.weekDays || (l.weekDays = [{
                    day: a.options.start.getDay(),
                    offset: 0
                }]), a._initInterval(), a._initMonthDay(), a._initWeekDays(), a._initWeekDay(), a._initMonth(), a._period(), t) : (a._value = {}, i.hide(), t)
            },
            _initMonthDay: function() {
                var e = this,
                    t = e._value,
                    a = e._monthDay = e._container.find(".k-recur-monthday");
                a.attr({
                    min: 1,
                    max: 31
                }).val(t.monthDays ? t.monthDays[0] : e.options.start.getDate()).on(De + e._namespace, function(a) {
                    t.count = a.target.value, e._trigger()
                })
            },
            _initCount: function() {
                var e = this,
                    t = e._count = e._container.find(".k-recur-count"),
                    a = e._value;
                t.val(a.count || 1).on(De + e._namespace, function(t) {
                    a.count = t.target.value, e._trigger()
                })
            },
            _initEndView: function(e) {
                var a, n = this,
                    s = n._value;
                e === t && (s.count ? e = "count" : s.until && (e = "until")), a = {
                    endPattern: e,
                    messages: n.options.messages.end
                }, Z.destroy(n._container), n._container.html(I(a)), n._initCount(), n._initUntil()
            },
            _initWeekDay: function() {
                var t, a = this,
                    n = a.options.messages.weekdays,
                    s = a.options.messages.offsetPositions,
                    r = a._container.find(".k-recur-weekday"),
                    i = function() {
                        a._weekDayRule(), a.trigger("change")
                    };
                r[0] && (a._weekDayOffset = a._container.find(".k-recur-weekday-offset").html(a._options([{
                    text: s.first,
                    value: "1"
                }, {
                    text: s.second,
                    value: "2"
                }, {
                    text: s.third,
                    value: "3"
                }, {
                    text: s.fourth,
                    value: "4"
                }, {
                    text: s.last,
                    value: "-1"
                }])).change(i), t = [{
                    text: n.day,
                    value: "day"
                }, {
                    text: n.weekday,
                    value: "weekday"
                }, {
                    text: n.weekend,
                    value: "weekend"
                }], t = t.concat(e.map(Z.culture().calendar.days.names, function(e, t) {
                    return {
                        text: e,
                        value: t
                    }
                })), a._weekDay = r.html(a._options(t)).change(i).val(a.options.start.getDay()), a._weekDayView())
            },
            _initMonth: function() {
                var t, a = this,
                    n = a._value,
                    s = a.options.start,
                    r = n.months || [s.getMonth() + 1],
                    i = a._container.find(".k-recur-month"),
                    l = Z.culture().calendar.months.names;
                i[0] && (t = e.map(l, function(e, t) {
                    return {
                        text: e,
                        value: t + 1
                    }
                }), i.html(a._options(t)).change(function() {
                    n.months = [+this.value]
                }), a._monthSelect = i, r && i.val(r[0]))
            },
            _period: function() {
                var e, t, a, n = this,
                    s = n._value,
                    r = n._container,
                    i = n.options.messages[s.freq],
                    l = r.find(".k-repeat-rule"),
                    o = r.find(".k-weekday-view"),
                    u = r.find(".k-monthday-view");
                l[0] && (e = s.weekDays ? "weekday" : "monthday", t = A({
                    value: e,
                    dataSource: [{
                        text: i.dayOfMonth,
                        value: "monthday"
                    }, {
                        text: i.dayOfWeek,
                        value: "weekday"
                    }],
                    ns: Z.ns
                }), a = function(e) {
                    var t = n._weekDay.val(),
                        a = n._weekDayOffset.val(),
                        r = n._monthDay.val(),
                        i = n._monthSelect ? n._monthSelect.val() : null;
                    "monthday" === e ? (s.weekDays = null, s.monthDays = r ? [r] : r, s.months = i ? [+i] : i, o.hide(), u.show()) : (s.monthDays = null, s.months = i ? [+i] : i, s.weekDays = [{
                        offset: +a,
                        day: +t
                    }], o.show(), u.hide())
                }, l.append(t), l.find(".k-scheduler-select").on(De + n._namespace, function(e) {
                    a(e.target.value)
                }), a(e))
            },
            _initUntil: function() {
                var e = this,
                    t = e._container.find(".k-recur-until"),
                    a = e.options.start,
                    n = e._value,
                    s = n.until,
                    r = s && s < a ? s : a;
                e._until = Z.support.input.date ? t.attr("min", Z.toString(r, "yyyy-MM-dd")).val(Z.toString(s || a, "yyyy-MM-dd")).on("change", function() {
                    n.until = Z.parseDate(this.value, "yyyy-MM-dd")
                }) : t.kendoDatePicker({
                    min: r,
                    value: s || a,
                    change: function() {
                        n.until = this.value()
                    }
                }).data("kendoDatePicker")
            },
            _options: function(e, t) {
                var a = 0,
                    n = "",
                    s = e.length,
                    r = this._optionTemplate;
                for (t && (n += r({
                        value: "",
                        text: t
                    })); a < s; a++) n += r(e[a]);
                return n
            }
        }), Q.plugin(L)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, a) {
    (a || t)()
});;
! function(e, define) {
    define("util/text-metrics.min", ["kendo.core.min"], e)
}(function() {
    ! function(e) {
        function t(e) {
            return (e + "").replace(s, l)
        }

        function i(e) {
            var t, i = [];
            for (t in e) i.push(t + e[t]);
            return i.sort().join("")
        }

        function n(e) {
            var t, i = 2166136261;
            for (t = 0; t < e.length; ++t) i += (i << 1) + (i << 4) + (i << 7) + (i << 8) + (i << 24), i ^= e.charCodeAt(t);
            return i >>> 0
        }

        function a() {
            return {
                width: 0,
                height: 0,
                baseline: 0
            }
        }

        function r(e, t, i) {
            return u.current.measure(e, t, i)
        }
        var o, s, l, d, c, u;
        window.kendo.util = window.kendo.util || {}, o = kendo.Class.extend({
            init: function(e) {
                this._size = e, this._length = 0, this._map = {}
            },
            put: function(e, t) {
                var i = this._map,
                    n = {
                        key: e,
                        value: t
                    };
                i[e] = n, this._head ? (this._tail.newer = n, n.older = this._tail, this._tail = n) : this._head = this._tail = n, this._length >= this._size ? (i[this._head.key] = null, this._head = this._head.newer, this._head.older = null) : this._length++
            },
            get: function(e) {
                var t = this._map[e];
                if (t) return t === this._head && t !== this._tail && (this._head = t.newer, this._head.older = null), t !== this._tail && (t.older && (t.older.newer = t.newer, t.newer.older = t.older), t.older = this._tail, t.newer = null, this._tail.newer = t, this._tail = t), t.value
            }
        }), s = /\r?\n|\r|\t/g, l = " ", d = {
            baselineMarkerSize: 1
        }, "undefined" != typeof document && (c = document.createElement("div"), c.style.cssText = "position: absolute !important; top: -4000px !important; width: auto !important; height: auto !important;padding: 0 !important; margin: 0 !important; border: 0 !important;line-height: normal !important; visibility: hidden !important; white-space: pre!important;"), u = kendo.Class.extend({
            init: function(t) {
                this._cache = new o(1e3), this.options = e.extend({}, d, t)
            },
            measure: function(e, r, o) {
                var s, l, d, u, h, p, f, v, m;
                if (void 0 === o && (o = {}), !e) return a();
                if (s = i(r), l = n(e + s), d = this._cache.get(l)) return d;
                u = a(), h = o.box || c, p = this._baselineMarker().cloneNode(!1);
                for (f in r) v = r[f], void 0 !== v && (h.style[f] = v);
                return m = o.normalizeText !== !1 ? t(e) : e + "", h.textContent = m, h.appendChild(p), document.body.appendChild(h), m.length && (u.width = h.offsetWidth - this.options.baselineMarkerSize, u.height = h.offsetHeight, u.baseline = p.offsetTop + this.options.baselineMarkerSize), u.width > 0 && u.height > 0 && this._cache.put(l, u), h.parentNode.removeChild(h), u
            },
            _baselineMarker: function() {
                var e = document.createElement("div");
                return e.style.cssText = "display: inline-block; vertical-align: baseline;width: " + this.options.baselineMarkerSize + "px; height: " + this.options.baselineMarkerSize + "px;overflow: hidden;", e
            }
        }), u.current = new u, kendo.deepExtend(kendo.util, {
            LRUCache: o,
            TextMetrics: u,
            measureText: r,
            objectKey: i,
            hashKey: n,
            normalizeText: t
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, i) {
    (i || t)()
}),
function(e, define) {
    define("kendo.scheduler.min", ["kendo.dropdownlist.min", "kendo.editable.min", "kendo.multiselect.min", "kendo.window.min", "kendo.datetimepicker.min", "kendo.scheduler.recurrence.min", "kendo.scheduler.view.min", "kendo.scheduler.dayview.min", "kendo.scheduler.agendaview.min", "kendo.scheduler.monthview.min", "kendo.scheduler.timelineview.min", "kendo.dialog.min", "kendo.pane.min", "kendo.pdf.min", "kendo.switch.min"], e)
}(function() {
    return function(e, t) {
        function i(e, t) {
            return t = t || "", e.startTimezone && (t = e.startTimezone, e.endTimezone && (t += " | " + e.endTimezone)), t
        }

        function n(e, t) {
            var i = t.timezone;
            i && (e[I.attr("timezone")] = i)
        }

        function a(e, t) {
            var i, n = t.model.fields[t.field].validation;
            n && (i = n.validDateValidator, i && Q(i) && i.message && (e[I.attr("validDate-msg")] = i.message))
        }

        function r(e, t) {
            var i, n = t.model.fields[t.field].validation;
            n && (i = n.dateCompare, i && Q(i) && i.message && (e[I.attr("dateCompare-msg")] = i.message))
        }

        function o(e, t) {
            return function(i) {
                return i = e(i), l(i, "apply", t), i || []
            }
        }

        function s(e, t) {
            return function(i) {
                return i && ("[object Array]" === J.call(i) || i instanceof I.data.ObservableArray || (i = [i])), l(i, "remove", t, !0), i = e(i), i || []
            }
        }

        function l(e, t, i, n) {
            var a, r, o;
            for (e = e || [], r = 0, o = e.length; r < o; r++) a = e[r], n ? a.startTimezone || a.endTimezone ? i ? (a.start = I.timezone.convert(a.start, a.startTimezone || a.endTimezone, i), a.end = I.timezone.convert(a.end, a.endTimezone || a.startTimezone, i), a.start = I.timezone[t](a.start, i), a.end = I.timezone[t](a.end, i)) : (a.start = I.timezone[t](a.start, a.startTimezone || a.endTimezone), a.end = I.timezone[t](a.end, a.endTimezone || a.startTimezone)) : i && (a.start = I.timezone[t](a.start, i), a.end = I.timezone[t](a.end, i)) : a.startTimezone || a.endTimezone ? (a.start = I.timezone[t](a.start, a.startTimezone || a.endTimezone), a.end = I.timezone[t](a.end, a.endTimezone || a.startTimezone), i && (a.start = I.timezone.convert(a.start, a.startTimezone || a.endTimezone, i), a.end = I.timezone.convert(a.end, a.endTimezone || a.startTimezone, i))) : i && (a.start = I.timezone[t](a.start, i), a.end = I.timezone[t](a.end, i)), n && delete a.uid;
            return e
        }

        function d(e, t) {
            for (var i, n = e.length, a = 0; a < n; a++)
                if (i = e[a], i.uid === t) return i
        }

        function c(e, t, i) {
            return e = i ? I.timezone.convert(e, t, i) : I.timezone.remove(e, t)
        }

        function u(e) {
            var t, i;
            return !(e.filter("[name=start]").length && e.filter("[title=Start]").length || e.filter("[name=end]").length && e.filter("[title=End]").length) || (i = I.widgetInstance(e, I.ui), i ? (t = I.parseDate(e.val(), i.options.format), !!t && i.value()) : (t = I.parseDate(e.val()), !!t))
        }

        function h(e) {
            var t, i, n, a, r, o, s, l, d, u, h, p;
            return !(e.filter("[name=end]").length && (t = e.closest(".k-scheduler-edit-form"), i = t.find("[name=start]:visible"), n = t.find("[name=end]:visible"), n[0] && i[0] && (o = I.widgetInstance(i, I.ui), s = I.widgetInstance(n, I.ui), l = t.data("kendoEditable"), d = l ? l.options.model : null, o && s ? (a = o.value(), r = s.value()) : (a = I.parseDate(i.val()), r = I.parseDate(n.val())), a && r))) || (d && (u = i.attr(I.attr("timezone")), h = d.startTimezone, p = d.endTimezone, h = h || p, p = p || h, h && (a = c(a, h, u), r = c(r, p, u))), a <= r)
        }

        function p(e, t, i, n) {
            for (var a = e.length, r = [], o = 0; o < a; o++) r = r.concat(e[o].expand(t, i, n));
            return r
        }

        function f(e) {
            return delete e.name, delete e.prefix, delete e.remove, delete e.edit, delete e.add, delete e.navigate, e
        }

        function v(t, i) {
            var n, a, r = (t.fields || t)[i],
                o = ["url", "email", "number", "date", "boolean"],
                s = r ? r.validation : {},
                l = I.attr("type"),
                d = e.inArray,
                c = {};
            for (n in s) a = s[n], d(n, o) >= 0 ? c[l] = n : I.isFunction(a) || (c[n] = Q(a) ? a.value || n : a), c[I.attr(n + "-msg")] = a.message;
            return c
        }

        function m(t, i) {
            var n = v(i, t.field);
            return function(a) {
                e(I.format('<select data-{0}bind="value:{1}" title="' + i.title + '">', I.ns, t.field)).appendTo(a).attr(n).kendoDropDownList({
                    dataTextField: t.dataTextField,
                    dataValueField: t.dataValueField,
                    dataSource: t.dataSource,
                    valuePrimitive: t.valuePrimitive,
                    optionLabel: "None",
                    template: I.format('<span class="k-scheduler-mark" style="background-color:#= data.{0}?{0}:"none" #"></span>#={1}#', t.dataColorField, t.dataTextField)
                })
            }
        }

        function g(t, i) {
            var n = v(i, t.field);
            return function(i) {
                var a, r, o = "",
                    s = t.dataSource.view();
                for (a = 0, r = s.length; a < r; a++) o += I.format('<option value="{0}">{1}</option>', I.getter(t.dataValueField)(s[a]), I.getter(t.dataTextField)(s[a]));
                e(I.format('<select data-{0}bind="value:{1}">{2}</select>', I.ns, t.field, o, t.valuePrimitive)).appendTo(i).attr(n)
            }
        }

        function _(t) {
            var i = v(t.model, t.field);
            return function(t, n) {
                e('<textarea name="description" class="k-textbox" title="' + n.title + '"/>').attr(i).appendTo(t)
            }
        }

        function k(t, i) {
            var n = v(i, t.field);
            return function(i) {
                e(I.format('<select data-{0}bind="value:{1}">', I.ns, t.field)).appendTo(i).attr(n).kendoMultiSelect({
                    dataTextField: t.dataTextField,
                    dataValueField: t.dataValueField,
                    dataSource: t.dataSource,
                    valuePrimitive: t.valuePrimitive,
                    itemTemplate: I.format('<span class="k-scheduler-mark" style="background-color:#= data.{0}?{0}:"none" #"></span>#={1}#', t.dataColorField, t.dataTextField),
                    tagTemplate: I.format('<span class="k-scheduler-mark" style="background-color:#= data.{0}?{0}:"none" #"></span>#={1}#', t.dataColorField, t.dataTextField)
                })
            }
        }

        function w(t, i) {
            var n = v(i, t.field);
            return function(i) {
                var a, r, o = "",
                    s = t.dataSource.view();
                for (a = 0, r = s.length; a < r; a++) o += I.format('<option value="{0}">{1}</option>', I.getter(t.dataValueField)(s[a]), I.getter(t.dataTextField)(s[a]));
                e(I.format('<select data-{0}bind="value:{1}" multiple="multiple" data-{0}value-primitive="{3}">{2}</select>', I.ns, t.field, o, t.valuePrimitive)).appendTo(i).attr(n)
            }
        }

        function b(e, t) {
            var i, n = e.end.getTime() - e.start.getTime(),
                a = new Date(e.start.getTime());
            return I.date.setTime(a, t), i = new Date(a.getTime()), I.date.setTime(i, n, !0), {
                start: a,
                end: i
            }
        }
        var y, z, T, D, S, x, E, C, R, P, M, V, I = window.kendo,
            A = I.date,
            B = A.MS_PER_DAY,
            H = A.getDate,
            W = I.date.getMilliseconds,
            O = I.recurrence,
            F = e.extend({
                F10: 121
            }, I.keys),
            N = I.ui,
            L = N.Widget,
            U = N.DataBoundWidget,
            K = "string",
            q = N.Popup,
            Y = N.Calendar,
            j = I.data.DataSource,
            Q = e.isPlainObject,
            $ = e.extend,
            X = e.proxy,
            J = Object.prototype.toString,
            Z = e.isArray,
            G = ".kendoScheduler",
            ee = "click",
            te = "mousedown",
            ie = I.support.pointers ? "pointerdown" : "touchstart",
            ne = I.support.pointers ? "pointermove" : "touchmove",
            ae = I.support.pointers ? "pointerup" : "touchend",
            re = I.support.mousemove,
            oe = "change",
            se = "progress",
            le = "error",
            de = "cancel",
            ce = "remove",
            ue = "resetSeries",
            he = "save",
            pe = "add",
            fe = "edit",
            ve = "k-state-focused",
            me = "k-state-expanded",
            ge = ".k-scheduler-views",
            _e = "k-event-inverse",
            ke = /(?:value:start|value:end)(?:,|$)/,
            we = H(new Date),
            be = ",",
            ye = /\;/g,
            ze = "recurrenceException",
            Te = "Are you sure you want to delete this event?",
            De = "Do you want to delete only this event occurrence or the whole series?",
            Se = "Do you want to edit only this event occurrence or the whole series?",
            xe = "Are you sure you want to delete this event occurrence?",
            Ee = "Are you sure you want to reset the whole series?",
            Ce = "Are you sure you want to delete the whole series?",
            Re = '<a class="k-button #=className#" #=attr# href="\\#">#=text#</a>',
            Pe = I.template('<li class="k-current-view" data-#=ns#name="#=view#"><a role="button" href="\\#" class="k-link">${views[view].title}</a></li>'),
            Me = I.template('<div class="k-floatwrap k-header k-scheduler-toolbar"># if (pdf) { #<ul class="k-reset k-scheduler-tools"><li><a role="button" href="\\#" class="k-button k-pdf"><span class="k-icon k-i-file-pdf"></span>${messages.pdf}</a></li></ul># } #<ul class="k-reset k-scheduler-navigation"><li class="k-state-default k-header k-nav-today"><a role="button" href="\\#" class="k-link" title="${messages.today}">${messages.today}</a></li><li class="k-state-default k-header k-nav-prev"><a role="button" href="\\#" class="k-link" title="${messages.previous}" aria-label="${messages.previous}"><span class="k-icon k-i-arrow-60-left" style="pointer-events: none"></span></a></li><li class="k-state-default k-header k-nav-next"><a role="button" href="\\#" class="k-link" title="${messages.next}" aria-label="${messages.next}"><span class="k-icon k-i-arrow-60-right" style="pointer-events: none"></span></a></li><li class="k-state-default k-nav-current"><a role="button" href="\\#" class="k-link"><span class="k-icon k-i-calendar"></span><span class="k-sm-date-format" data-#=ns#bind="text: formattedShortDate"></span><span class="k-lg-date-format" data-#=ns#bind="text: formattedDate"></span></a></li></ul>#if(viewsCount === 1){#<a role="button" data-#=ns#name="#=view#" href="\\#" class="k-link k-scheduler-refresh"><span class="k-icon k-i-reload"></span></a>#}else{#<ul class="k-reset k-header k-scheduler-views">#for(var view in views){#<li class="k-state-default k-view-#= view.toLowerCase() #" data-#=ns#name="#=view#"><a role="button" href="\\#" class="k-link">${views[view].title}</a></li>#}#</ul>#}#</div>'),
            Ve = I.template('<div class="k-header k-scheduler-toolbar"><ul class="k-reset k-scheduler-tools"># if (pdf) { #<li><a role="button" href="\\#" class="k-button k-pdf"><span class="k-icon k-i-file-pdf"></span></a></li># } #<li><a role="button" href="\\#" class="k-button k-nav-calendar"><span class="k-icon k-i-calendar"></span></a></li># if (editable) { #<li><a role="button" href="\\#" class="k-button k-create-event"><span class="k-icon k-i-plus"></span></a></li># } #</ul>#if(viewsCount === 1){#<a role="button" data-#=ns#name="#=view#" href="\\#" class="k-link k-scheduler-refresh"><span class="k-icon k-i-reload"></span></a>#}else{#<select class="k-scheduler-mobile-views">#for(var view in views){#<option class="k-state-default k-view-#= view.toLowerCase() #" value="#=view#">${views[view].title}</option>#}#</select>#}#</div><div class="k-header k-scheduler-toolbar"><ul class="k-reset k-header k-scheduler-navigation"><li class="k-state-default k-nav-prev"><a role="button" href="\\#" class="k-link"><span class="k-icon k-i-arrow-chevron-left"></span></a></li><li class="k-state-default k-nav-current"><span class="k-m-date-format" data-#=ns#bind="text: formattedMobileDate"></span><span class="k-y-date-format" data-#=ns#bind="text: formattedYear"></span></li><li class="k-state-default k-nav-next"><a role="button" href="\\#" class="k-link"><span class="k-icon k-i-arrow-chevron-right"></span></a></li></ul></div>'),
            Ie = function(t, i) {
                var o = {
                        name: i.field,
                        title: i.title
                    },
                    s = i.model.isAllDay,
                    l = I.attr("validate") + "='" + !s + "'",
                    d = I.attr("validate") + "='" + s + "'";
                n(o, i), a(o, i), r(o, i), e('<input type="datetime-local" required ' + I.attr("type") + '="datetime-local" ' + I.attr("bind") + '="value:' + i.field + ', invisible:isAllDay" ' + l + "/>").attr(o).appendTo(t), e('<input type="date" required ' + I.attr("type") + '="date" ' + I.attr("bind") + '="value:' + i.field + ',visible:isAllDay" ' + d + "/>").attr(o).appendTo(t), e("<span " + I.attr("for") + '="' + i.field + '" class="k-invalid-msg"/>').hide().appendTo(t)
            },
            Ae = function(t, i) {
                var o = {
                        name: i.field,
                        title: i.title
                    },
                    s = i.model.isAllDay,
                    l = I.attr("validate") + "='" + !s + "' ",
                    d = I.attr("validate") + "='" + s + "' ";
                n(o, i), a(o, i), r(o, i), e('<input type="text" required ' + I.attr("type") + '="date" ' + I.attr("role") + '="datetimepicker" ' + I.attr("bind") + '="value:' + i.field + ',invisible:isAllDay" ' + l + "/>").attr(o).appendTo(t), e('<input type="text" required ' + I.attr("type") + '="date" ' + I.attr("role") + '="datepicker" ' + I.attr("bind") + '="value:' + i.field + ',visible:isAllDay" ' + d + "/>").attr(o).appendTo(t), e("<span " + I.attr("bind") + '="text: ' + i.field + 'Timezone"></span>').appendTo(t), "end" === i.field && e("<span " + I.attr("bind") + '="text: startTimezone, invisible: endTimezone"></span>').appendTo(t), e("<span " + I.attr("for") + '="' + i.field + '" class="k-invalid-msg"/>').hide().appendTo(t)
            },
            Be = function(t, i) {
                e("<div " + I.attr("bind") + '="value:' + i.field + '" />').attr({
                    name: i.field
                }).appendTo(t).kendoRecurrenceEditor({
                    start: i.model.start,
                    timezone: i.timezone,
                    messages: i.messages
                })
            },
            He = function(t, i) {
                e("<div " + I.attr("bind") + '="value:' + i.field + '" />').attr({
                    name: i.field
                }).appendTo(t).kendoMobileRecurrenceEditor({
                    start: i.model.start,
                    timezone: i.timezone,
                    messages: i.messages,
                    pane: i.pane,
                    value: i.model[i.field]
                })
            },
            We = function(t, i) {
                e('<input type="checkbox" data-role="switch"' + I.attr("bind") + '="value:' + i.field + '" />').appendTo(t)
            },
            Oe = function(t, n) {
                var a = i(n.model, n.messages.noTimezone);
                e('<span class="k-timezone-label"></span>').text(a).appendTo(t), e('<span class="k-icon k-i-arrow-chevron-right"></span>').appendTo(t), t.closest("li.k-item label").click(n.click)
            },
            Fe = function(t, i) {
                e('<a href="#" class="k-button" data-bind="invisible:isAllDay">' + i.messages.timezoneEditorButton + "</a>").click(i.click).appendTo(t)
            },
            Ne = function(t, i) {
                e('<div class="k-mobiletimezoneeditor" ' + I.attr("bind") + '="value:' + i.field + '" />').attr({
                    name: i.field
                }).appendTo(t).kendoMobileTimezoneEditor({
                    optionLabel: i.noTimezone
                })
            },
            Le = function(i, n) {
                var a = n.visible || n.visible === t;
                e("<div " + I.attr("bind") + '="value:' + n.field + '" />').attr({
                    name: n.field
                }).toggle(a).appendTo(i).kendoTimezoneEditor({
                    optionLabel: n.noTimezone,
                    title: n.title
                })
            },
            Ue = I.Class.extend({
                init: function(t, i) {
                    var n = t.timezone;
                    this.reader = i, i.model && (this.model = i.model), this.timezone = n, this.data = o(e.proxy(this.data, this), n), this.serialize = s(e.proxy(this.serialize, this), n)
                },
                errors: function(e) {
                    return this.reader.errors(e)
                },
                parse: function(e) {
                    return this.reader.parse(e)
                },
                data: function(e) {
                    return this.reader.data(e)
                },
                total: function(e) {
                    return this.reader.total(e)
                },
                groups: function(e) {
                    return this.reader.groups(e)
                },
                aggregates: function(e) {
                    return this.reader.aggregates(e)
                },
                serialize: function(e) {
                    return this.reader.serialize(e)
                }
            }),
            Ke = I.data.Model.define({
                init: function(e) {
                    var t = this;
                    I.data.Model.fn.init.call(t, e), t._defaultId = t.defaults[t.idField]
                },
                _time: function(e) {
                    var t = this[e],
                        i = "_" + e + "Time";
                    return this[i] ? this[i] - I.date.toUtcTime(I.date.getDate(t)) : W(t)
                },
                _date: function(e) {
                    var t = "_" + e + "Time";
                    return this[t] ? this[t] - this._time(e) : I.date.getDate(this[e])
                },
                clone: function(t, i) {
                    var n = this.uid,
                        a = new this.constructor(e.extend({}, this.toJSON(), t));
                    return i || (a.uid = n), a
                },
                duration: function() {
                    var e = this.end,
                        t = this.start,
                        i = (e.getTimezoneOffset() - t.getTimezoneOffset()) * I.date.MS_PER_MINUTE;
                    return e - t - i
                },
                expand: function(e, t, i) {
                    return O ? O.expand(this, e, t, i) : [this]
                },
                update: function(e) {
                    for (var t in e) this.set(t, e[t]);
                    this._startTime && this.set("_startTime", I.date.toUtcTime(this.start)), this._endTime && this.set("_endTime", I.date.toUtcTime(this.end))
                },
                isMultiDay: function() {
                    return this.isAllDay || this.duration() >= I.date.MS_PER_DAY
                },
                isException: function() {
                    return !this.isNew() && this.recurrenceId
                },
                isOccurrence: function() {
                    return this.isNew() && this.recurrenceId
                },
                isRecurring: function() {
                    return !(!this.recurrenceRule && !this.recurrenceId)
                },
                isRecurrenceHead: function() {
                    return !(!this.id || !this.recurrenceRule)
                },
                toOccurrence: function(t) {
                    return t = e.extend(t, {
                        recurrenceException: null,
                        recurrenceRule: null,
                        recurrenceId: this.id || this.recurrenceId
                    }), t[this.idField] = this.defaults[this.idField], this.clone(t, !0)
                },
                toJSON: function() {
                    var e = I.data.Model.fn.toJSON.call(this);
                    return e.uid = this.uid, delete e._startTime, delete e._endTime, e
                },
                shouldSerialize: function(e) {
                    return I.data.Model.fn.shouldSerialize.call(this, e) && "_defaultId" !== e
                },
                set: function(e, t) {
                    var i, n, a, r = this.isAllDay || !1;
                    I.data.Model.fn.set.call(this, e, t), "isAllDay" == e && t != r && (i = I.date.getDate(this.start), n = new Date(this.end), a = I.date.getMilliseconds(n), 0 === a && t && (a = B), this.set("start", i), t === !0 ? (I.date.setTime(n, -a), n < i && (n = i)) : I.date.setTime(n, B - a), this.set("end", n))
                },
                id: "id",
                fields: {
                    id: {
                        type: "number"
                    },
                    title: {
                        defaultValue: "",
                        type: "string"
                    },
                    start: {
                        type: "date",
                        validation: {
                            required: !0,
                            validDate: {
                                value: u
                            }
                        }
                    },
                    startTimezone: {
                        type: "string"
                    },
                    end: {
                        type: "date",
                        validation: {
                            required: !0,
                            validDate: {
                                value: u
                            },
                            dateCompare: {
                                value: h
                            }
                        }
                    },
                    endTimezone: {
                        type: "string"
                    },
                    recurrenceRule: {
                        defaultValue: "",
                        type: "string"
                    },
                    recurrenceException: {
                        defaultValue: "",
                        type: "string"
                    },
                    isAllDay: {
                        type: "boolean",
                        defaultValue: !1
                    },
                    description: {
                        type: "string"
                    }
                }
            }),
            qe = j.extend({
                init: function(e) {
                    j.fn.init.call(this, $(!0, {}, {
                        schema: {
                            modelBase: Ke,
                            model: Ke
                        }
                    }, e)), this.reader = new Ue(this.options.schema, this.reader)
                },
                expand: function(e, t) {
                    var i, n = this.view(),
                        a = {};
                    return e && t && (i = t.getTimezoneOffset(), t = new Date(t.getTime() + B - 1), t.getTimezoneOffset() !== i && (t = I.timezone.apply(t, i)), a = {
                        logic: "or",
                        filters: [{
                            logic: "and",
                            filters: [{
                                field: "start",
                                operator: "gte",
                                value: e
                            }, {
                                field: "end",
                                operator: "gte",
                                value: e
                            }, {
                                field: "start",
                                operator: "lte",
                                value: t
                            }]
                        }, {
                            logic: "and",
                            filters: [{
                                field: "start",
                                operator: "lte",
                                value: new Date(e.getTime() + B - 1)
                            }, {
                                field: "end",
                                operator: "gte",
                                value: e
                            }]
                        }]
                    }, n = new I.data.Query(p(n, e, t, this.reader.timezone)).filter(a).toArray()), n
                },
                cancelChanges: function(e) {
                    e && e.isOccurrence() && this._removeExceptionDate(e), j.fn.cancelChanges.call(this, e)
                },
                insert: function(e, t) {
                    if (t) {
                        if (!(t instanceof Ke)) {
                            var i = t;
                            t = this._createNewModel(), t.accept(i)
                        }
                        return (!this._pushCreated && t.isRecurrenceHead() || t.recurrenceId) && (t = t.recurrenceId ? t : t.toOccurrence(), this._addExceptionDate(t)), j.fn.insert.call(this, e, t)
                    }
                },
                pushCreate: function(e) {
                    this._pushCreated = !0, j.fn.pushCreate.call(this, e), this._pushCreated = !1
                },
                remove: function(e) {
                    return e.isRecurrenceHead() ? this._removeExceptions(e) : e.isRecurring() && this._addExceptionDate(e), j.fn.remove.call(this, e)
                },
                _removeExceptions: function(e) {
                    for (var t = this.data().slice(0), i = t.shift(), n = e.id; i;) i.recurrenceId === n && j.fn.remove.call(this, i), i = t.shift();
                    e.set(ze, "")
                },
                _removeExceptionDate: function(e) {
                    var t, i, n, a;
                    e.recurrenceId && (t = this.get(e.recurrenceId), t && (i = e.defaults.start, n = RegExp("(\\" + be + "?)" + O.toExceptionString(i, this.reader.timezone)), a = (t.recurrenceException || "").replace(ye, be).replace(/\,$/, ""), n.test(a) ? t.set(ze, a.replace(n, "")) : (i = e.start, n = RegExp("(\\" + be + "?)" + O.toExceptionString(i, this.reader.timezone)), t.set(ze, a.replace(n, "")))))
                },
                _addExceptionDate: function(e) {
                    var t, i = e.start,
                        n = this.reader.timezone,
                        a = this.get(e.recurrenceId),
                        r = (a.recurrenceException || "").replace(ye, be).replace(/\,$/, "");
                    O.isException(r, i, n) || (t = O.toExceptionString(i, n), e.defaults.start = i, a.set(ze, r + (r && t ? be : "") + t))
                }
            });
        qe.create = function(e) {
            (Z(e) || e instanceof I.data.ObservableArray) && (e = {
                data: e
            });
            var t = e || {},
                i = t.data;
            if (t.data = i, !(t instanceof qe) && t instanceof I.data.DataSource) throw Error("Incorrect DataSource type. Only SchedulerDataSource instances are supported");
            return t instanceof qe ? t : new qe(t)
        }, $(!0, I.data, {
            SchedulerDataSource: qe,
            SchedulerDataReader: Ue,
            SchedulerEvent: Ke
        }), y = {
            update: {
                text: "Save",
                className: "k-primary k-scheduler-update"
            },
            canceledit: {
                text: "Cancel",
                className: "k-scheduler-cancel"
            },
            destroy: {
                text: "Delete",
                imageClass: "k-i-close",
                className: "k-primary k-scheduler-delete",
                iconClass: "k-icon"
            }
        }, z = {
            mobile: {
                dateRange: Ie,
                timezonePopUp: Oe,
                timezone: Ne,
                recurrence: He,
                description: _,
                multipleResources: w,
                resources: g,
                isAllDay: We
            },
            desktop: {
                dateRange: Ae,
                timezonePopUp: Fe,
                timezone: Le,
                recurrence: Be,
                description: _,
                multipleResources: k,
                resources: m
            }
        }, T = I.Observable.extend({
            init: function(e, t) {
                I.Observable.fn.init.call(this), this.element = e, this.options = $(!0, {}, this.options, t), this.createButton = this.options.createButton, this.toggleDateValidationHandler = X(this._toggleDateValidation, this)
            },
            _toggleDateValidation: function(t) {
                if ("isAllDay" == t.field) {
                    var i, n, a, r = this.container,
                        o = this.editable.options.model.isAllDay,
                        s = I.attr("bind");
                    r.find("[" + s + "*=end],[" + s + "*=start]").each(function() {
                        i = e(this), ke.test(i.attr(s)) && (n = i.is("[" + I.attr("role") + "=datetimepicker],[type*=datetime]"), a = o !== n, i.attr(I.attr("validate"), a))
                    })
                }
            },
            fields: function(e, t) {
                var i, n, a = this,
                    r = a.options.messages,
                    o = a.options.timezone,
                    s = function(e) {
                        e.preventDefault(), a._initTimezoneEditor(t, this)
                    },
                    l = [{
                        field: "title",
                        title: r.editor.title
                    }, {
                        field: "start",
                        title: r.editor.start,
                        editor: e.dateRange,
                        timezone: o
                    }, {
                        field: "end",
                        title: r.editor.end,
                        editor: e.dateRange,
                        timezone: o
                    }, {
                        field: "isAllDay",
                        title: r.editor.allDayEvent,
                        editor: e.isAllDay
                    }];
                I.timezone.windows_zones && (l.push({
                    field: "timezone",
                    title: r.editor.timezone,
                    editor: e.timezonePopUp,
                    click: s,
                    messages: r.editor,
                    model: t
                }), l.push({
                    field: "startTimezone",
                    title: r.editor.startTimezone,
                    editor: e.timezone,
                    noTimezone: r.editor.noTimezone
                }), l.push({
                    field: "endTimezone",
                    title: r.editor.endTimezone,
                    editor: e.timezone,
                    noTimezone: r.editor.noTimezone
                })), t.recurrenceId || l.push({
                    field: "recurrenceRule",
                    title: r.editor.repeat,
                    editor: e.recurrence,
                    timezone: o,
                    messages: r.recurrenceEditor,
                    pane: this.pane
                }), "description" in t && l.push({
                    field: "description",
                    title: r.editor.description,
                    editor: e.description({
                        model: t,
                        field: "description"
                    })
                });
                for (i = 0; i < this.options.resources.length; i++) n = this.options.resources[i], l.push({
                    field: n.field,
                    title: n.title,
                    editor: n.multiple ? e.multipleResources(n, t) : e.resources(n, t)
                });
                return l
            },
            end: function() {
                return this.editable.end()
            },
            _buildDesktopEditTemplate: function(e, t, i) {
                var n, a, r, o, s = this.options.messages,
                    l = $({}, I.Template, this.options.templateSettings),
                    d = l.paramName,
                    c = "";
                for (n = 0, a = t.length; n < a; n++) r = t[n], "startTimezone" === r.field && (c += '<div class="k-popup-edit-form k-scheduler-edit-form k-scheduler-timezones" style="display:none">', c += '<div class="k-edit-form-container">', c += '<div class="k-edit-label"></div>', c += '<div class="k-edit-field"><label class="k-check"><input class="k-timezone-toggle" type="checkbox" />' + s.editor.separateTimezones + "</label></div>"), c += '<div class="k-edit-label"><label for="' + r.field + '">' + (r.title || r.field || "") + "</label></div>", !e.editable || e.editable(r.field) ? (i.push(r), c += "<div " + I.attr("container-for") + '="' + r.field + '" class="k-edit-field"></div>') : (o = "#:", r.field ? (r = I.expr(r.field, d), o += r + "==null?'':" + r) : o += "''", o += "#", o = I.template(o, l), c += '<div class="k-edit-field">' + o(e) + "</div>"), "endTimezone" === r.field && (c += this._createEndTimezoneButton());
                return c
            },
            _buildMobileEditTemplate: function(e, t, i) {
                var n, a, r, o, s = this.options.messages,
                    l = $({}, I.Template, this.options.templateSettings),
                    d = l.paramName,
                    c = "";
                for (c += '<ul class="k-listgroup k-listgroup-flush">', n = 0, a = t.length; n < a; n++) r = t[n], "timezone" !== r.field && "recurrenceRule" !== r.field || (c += '</ul><ul class="k-listgroup k-listgroup-flush">'), "startTimezone" === r.field && (c += '<div class="k-popup-edit-form k-scheduler-edit-form k-scheduler-timezones" style="display:none">', c += '<ul class="k-listgroup k-listgroup-flush">', c += '<li class="k-item k-listgroup-item">', c += '<label class="k-label k-listgroup-form-row">', c += '<span class="k-item-title k-listgroup-form-row">' + s.editor.separateTimezones + "</span>", c += '<span class="k-listgroup-form-field-wrapper">', c += '<input class="k-timezone-toggle" data-role="switch" type="checkbox" />', c += "</span>", c += "</label>", c += "</li>"), !e.editable || e.editable(r.field) ? (c += '<li class="k-item k-listgroup-item">', c += "timezone" === r.field ? '<label class="k-label k-listgroup-form-row" data-bind="css: { k-state-disabled: isAllDay }">' : '<label class="k-label k-listgroup-form-row">', c += '<span class="k-item-title k-listgroup-form-field-label">' + (r.title || r.field || "") + "</span>", i.push(r), c += '<div class="k-listgroup-form-field-wrapper" ' + I.attr("container-for") + '="' + r.field + '"></div>', c += "</label></li>") : (o = "#:", c += '<li class="k-item k-listgroup-item">', c += '<label class="k-label k-no-click k-listgroup-form-row">', c += '<span class="k-item-title k-listgroup-form-field-label">' + (r.title || r.field || "") + "</span>", r.field ? (r = I.expr(r.field, d), o += r + "==null?'':" + r) : o += "''", o += "#", o = I.template(o, l), c += '<span class="k-no-editor k-listgroup-form-field-wrapper">' + o(e) + "</span>", c += "</label></li>"), "recurrenceRule" === r.field && (c += '</ul><ul class="k-listgroup k-listgroup-flush">'), "endTimezone" === r.field && (c += "</ul></div>");
                return c += "</ul>"
            },
            _buildEditTemplate: function(e, t, i, n) {
                var a = $({}, I.Template, this.options.templateSettings),
                    r = this.options.editable.template,
                    o = "";
                return r ? (typeof r === K && (r = I.unescape(r)), o += I.template(r, a)(e)) : o += n ? '<div data-role="content">' + this._buildMobileEditTemplate(e, t, i) + "</div>" : this._buildDesktopEditTemplate(e, t, i), o
            },
            _createEndTimezoneButton: function() {
                return "</ul></div>"
            },
            _revertTimezones: function(e) {
                e.set("startTimezone", this._startTimezone), e.set("endTimezone", this._endTimezone), delete this._startTimezone, delete this._endTimezone
            }
        }), D = T.extend({
            init: function() {
                T.fn.init.apply(this, arguments), this.pane = I.Pane.wrap(this.element, {
                    viewEngine: {
                        viewOptions: {
                            renderOnInit: !0,
                            wrap: !1,
                            wrapInSections: !0,
                            detachOnHide: !1,
                            detachOnDestroy: !1
                        }
                    }
                }), this.pane.element.parent().css("height", this.options.height), this.view = this.pane.view()
            },
            options: {
                animations: {
                    left: "slide",
                    right: "slide:right"
                }
            },
            destroy: function() {
                this.close(), this.unbind(), this.pane.destroy()
            },
            _initTimezoneEditor: function(t) {
                var n, a = this,
                    r = a.pane,
                    o = a.options.messages,
                    s = a.timezoneView,
                    l = s ? s.content.find(".k-scheduler-timezones") : a.container.find(".k-scheduler-timezones"),
                    d = l.find("input.k-timezone-toggle").data("kendoSwitch"),
                    c = l.find("li.k-item:not(.k-zonepicker):last"),
                    u = function(e) {
                        if ("startTimezone" === e.field) {
                            var i = t.startTimezone;
                            d.enable(i), i || (c.hide(), t.set("endTimezone", ""), d.value(!1))
                        }
                    };
                a._startTimezone = t.startTimezone || "", a._endTimezone = t.endTimezone || "", s || (n = '<div data-role="view" class="k-popup-edit-form k-scheduler-edit-form"><div data-role="header" class="k-header"><a href="\\#" class="k-header-cancel k-scheduler-cancel k-link" title="' + o.cancel + '"aria-label="' + o.cancel + '"><span class="k-icon k-i-arrow-chevron-left"></span></a>' + o.editor.timezoneTitle + '<a href="\\#" class="k-header-done k-scheduler-update k-link" title="' + o.save + '" aria-label="' + o.save + '"><span class="k-icon k-i-check"></span></a></div><div data-role="content"></div>', this.timezoneView = s = r.append(n), s.contentElement.append(l.show()), s.element.on(ee + G, ".k-scheduler-cancel, .k-scheduler-update", function(n) {
                    var s, l;
                    n.preventDefault(), n.stopPropagation(), e(this).hasClass("k-scheduler-cancel") && a._revertTimezones(t), t.unbind("change", u), s = a._editPane, l = i(t, o.editor.noTimezone), s.content.find(".k-timezone-label").text(l), r.navigate(s, a.options.animations.right)
                }), d.bind("change", function(e) {
                    c.toggle(e.checked), t.set("endTimezone", "")
                }), t.bind("change", u)), d.value(!!t.endTimezone), d.enable(!!t.startTimezone), t.endTimezone ? c.show() : c.hide(), r.navigate(s, a.options.animations.left)
            },
            showDialog: function(t) {
                var i = t.buttons.map(function(e) {
                    return {
                        text: e.text,
                        action: e.click
                    }
                });
                i.push({
                    text: this.options.messages.cancel,
                    primary: !0
                }), e("<div />").appendTo(document.body).kendoDialog({
                    close: function() {
                        this.destroy()
                    },
                    modal: {
                        preventScroll: !0
                    },
                    closable: !1,
                    title: !1,
                    content: t.text,
                    actions: i
                })
            },
            editEvent: function(t) {
                var i, n, a, r, o, s, l, d = this.pane,
                    c = "",
                    u = this.options.messages,
                    h = u.save,
                    p = u.destroy,
                    f = u.cancel,
                    v = u.editor.editorTitle,
                    m = u.resetSeries;
                return c += '<div data-role="view" class="k-popup-edit-form k-scheduler-edit-form"' + I.attr("uid") + '="' + t.uid + '"><div data-role="header" class="k-header"><a href="\\#" class="k-header-cancel k-scheduler-cancel k-link" title="' + f + '"aria-label="' + f + '"><span class="k-icon k-i-arrow-chevron-left"></span></a>' + v + '<a href="\\#" class="k-header-done k-scheduler-update k-link" title="' + h + '" aria-label="' + h + '"><span class="k-icon k-i-check"></span></a></div>', i = this.fields(z.mobile, t), n = this, a = [], c += this._buildEditTemplate(t, i, a, !0), c += "</div>", r = d.append(c), !t.isNew() && this.options.editable && this.options.editable.destroy !== !1 && t.isRecurrenceHead() && t.recurrenceException && (o = '<ul class="k-edit-buttons k-listgroup k-listgroup-flush"><li class="k-item k-listgroup-item"><span class="k-scheduler-resetSeries k-link k-label" aria-label="' + m + '">' + m + "</span></li></ul>", r.contentElement.append(o)), !t.isNew() && this.options.editable && this.options.editable.destroy !== !1 && (s = '<ul class="k-edit-buttons k-listgroup k-listgroup-flush"><li class="k-item k-listgroup-item"><span class="k-scheduler-delete k-link k-label" aria-label="' + p + '">' + p + "</span></li></ul>", r.contentElement.append(s)), this._editPane = r, l = this.container = r.element, this.editable = l.kendoEditable({
                    fields: a,
                    model: t,
                    clearContainer: !1,
                    target: n.options.target,
                    validateOnBlur: !0
                }).data("kendoEditable"), this.trigger("edit", {
                    container: l,
                    model: t
                }) ? this.trigger("cancel", {
                    container: l,
                    model: t
                }) : (l.on(ee + G, "a.k-scheduler-edit, a.k-scheduler-cancel, a.k-scheduler-update, span.k-scheduler-delete, span.k-scheduler-resetSeries", function(i) {
                    var a, r;
                    i.preventDefault(), i.stopPropagation(), a = e(this), a.hasClass("k-scheduler-edit") ? d.navigate(this._editPane, n.options.animations.right) : (r = "cancel", a.hasClass("k-scheduler-update") ? r = "save" : a.hasClass("k-scheduler-delete") ? r = "remove" : a.hasClass("k-scheduler-resetSeries") && (r = ue), n.trigger(r, {
                        container: l,
                        model: t
                    }))
                }), d.navigate(r, n.options.animations.left), t.bind("change", n.toggleDateValidationHandler)), this.editable
            },
            _views: function() {
                return this.pane.element.find(I.roleSelector("view")).not(this.view.element)
            },
            close: function() {
                var e, t, i, n;
                if (this.container) {
                    for (this.pane.navigate("", this.options.animations.right), e = this._views(), i = 0, n = e.length; i < n; i++) t = e.eq(i).data("kendoView"), t && t.purge();
                    e.remove(), this.container = null, this.editable && (this.editable.options.model.unbind("change", this.toggleDateValidationHandler), this.editable.destroy(), this.editable = null), this.timezoneView = null
                }
            }
        }), S = T.extend({
            destroy: function() {
                this.close(), this.unbind()
            },
            editEvent: function(t) {
                var i, n, a, r = this,
                    o = r.options.editable,
                    s = "<div " + I.attr("uid") + '="' + t.uid + '" class="k-popup-edit-form k-scheduler-edit-form"><div class="k-edit-form-container">',
                    l = r.options.messages,
                    d = l.save,
                    c = l.cancel,
                    u = l.destroy,
                    h = l.resetSeries,
                    p = this.fields(z.desktop, t),
                    f = [];
                return s += this._buildEditTemplate(t, p, f, !1), n = Q(o) ? o.window : {}, s += '<div class="k-edit-buttons k-state-default">', s += this.createButton({
                    name: "update",
                    text: d,
                    attr: i
                }) + this.createButton({
                    name: "canceledit",
                    text: c,
                    attr: i
                }), !t.isNew() && o.destroy !== !1 && t.isRecurrenceHead() && t.recurrenceException && (s += this.createButton({
                    name: "resetSeries",
                    text: h,
                    attr: i
                })), t.isNew() || o.destroy === !1 || (s += this.createButton({
                    name: "delete",
                    text: u,
                    attr: i
                })), s += "</div></div></div>", a = this.container = e(s).appendTo(r.element).eq(0).kendoWindow($({
                    modal: !0,
                    resizable: !1,
                    draggable: !0,
                    title: l.editor.editorTitle,
                    visible: !1,
                    close: function(e) {
                        e.userTriggered && r.trigger(de, {
                            container: a,
                            model: t
                        }) && e.preventDefault()
                    }
                }, n)), r.editable = a.kendoEditable({
                    fields: f,
                    model: t,
                    clearContainer: !1,
                    validateOnBlur: !0,
                    target: r.options.target
                }).data("kendoEditable"), r.trigger(fe, {
                    container: a,
                    model: t
                }) ? r.trigger(de, {
                    container: a,
                    model: t
                }) : (a.data("kendoWindow").center().open(), a.on(ee + G, "a.k-scheduler-cancel", function(e) {
                    e.preventDefault(), e.stopPropagation(), r.trigger(de, {
                        container: a,
                        model: t
                    })
                }), a.on(ee + G, "a.k-scheduler-update", function(e) {
                    e.preventDefault(), e.stopPropagation(), r.trigger("save", {
                        container: a,
                        model: t
                    })
                }), a.on(ee + G, "a.k-scheduler-delete", function(e) {
                    e.preventDefault(), e.stopPropagation(), r.trigger(ce, {
                        container: a,
                        model: t
                    })
                }), a.on(ee + G, "a.k-scheduler-resetSeries", function(e) {
                    e.preventDefault(), e.stopPropagation(), r.trigger(ue, {
                        container: a,
                        model: t
                    })
                }), I.cycleForm(a), t.bind("change", r.toggleDateValidationHandler)), r.editable
            },
            close: function() {
                var e = this,
                    t = function() {
                        e.editable && (e.editable.options.model.unbind("change", e.toggleDateValidationHandler), e.editable.destroy(), e.editable = null, e.container = null), e.popup && (e.popup.destroy(), e.popup = null)
                    };
                e.editable ? (e._timezonePopup && e._timezonePopup.data("kendoWindow") && (e._timezonePopup.data("kendoWindow").destroy(), e._timezonePopup = null), e.container.is(":visible") ? e.container.data("kendoWindow").bind("deactivate", t).close() : t()) : t()
            },
            _createEndTimezoneButton: function() {
                var e = this.options.messages,
                    t = "";
                return t += '<div class="k-edit-buttons k-state-default">', t += this.createButton({
                    name: "savetimezone",
                    text: e.save
                }) + this.createButton({
                    name: "canceltimezone",
                    text: e.cancel
                }), t += "</div></div></div>"
            },
            showDialog: function(t) {
                var i, n, a, r = I.format("<div class='k-popup-edit-form'><div class='k-edit-form-container'><p class='k-popup-message'>{0}</p>", t.text);
                for (r += '<div class="k-edit-buttons k-state-default">', i = 0; i < t.buttons.length; i++) r += this.createButton(t.buttons[i]);
                r += "</div></div></div>", n = this.element, this.popup && this.popup.destroy(), a = this.popup = e(r).appendTo(n).eq(0).on(ee, ".k-button", function(i) {
                    i.preventDefault(), a.close();
                    var n = e(i.currentTarget).index();
                    t.buttons[n].click()
                }).kendoWindow({
                    modal: !0,
                    resizable: !1,
                    draggable: !1,
                    title: t.title,
                    visible: !1,
                    close: function() {
                        this.destroy(), n.focus()
                    }
                }).getKendoWindow(), a.center().open()
            },
            _initTimezoneEditor: function(e, t) {
                var i, n = this,
                    a = n.container.find(".k-scheduler-timezones"),
                    r = a.find("input.k-timezone-toggle"),
                    o = a.find(".k-edit-label:last").add(a.find(".k-edit-field:last")),
                    s = a.find(".k-scheduler-savetimezone"),
                    l = a.find(".k-scheduler-canceltimezone"),
                    d = n._timezonePopup,
                    c = function(t) {
                        if ("startTimezone" === t.field) {
                            var i = e.startTimezone;
                            r.prop("disabled", !i), i || (o.hide(), e.set("endTimezone", ""), r.prop("checked", !1))
                        }
                    };
                n._startTimezone = e.startTimezone, n._endTimezone = e.endTimezone, d || (n._timezonePopup = d = a.kendoWindow({
                    modal: !0,
                    resizable: !1,
                    draggable: !0,
                    title: n.options.messages.editor.timezoneEditorTitle,
                    visible: !1,
                    close: function(i) {
                        e.unbind("change", c), i.userTriggered && n._revertTimezones(e), t && t.focus()
                    }
                }), r.click(function() {
                    o.toggle(r.prop("checked")), e.set("endTimezone", "")
                }), s.click(function(e) {
                    e.preventDefault(), i.close()
                }), l.click(function(t) {
                    t.preventDefault(), n._revertTimezones(e), i.close()
                }), e.bind("change", c)), r.prop("checked", e.endTimezone).prop("disabled", !e.startTimezone), e.endTimezone ? o.show() : o.hide(), i = d.data("kendoWindow"), i.center().open()
            }
        }), x = U.extend({
            init: function(t, i) {
                var n = this;
                L.fn.init.call(n, t, i), n.options.views && n.options.views.length || (n.options.views = ["day", "week"]), n.resources = [], n._initModel(), n._wrapper(), n._views(), n._toolbar(), n._dataSource(), n._resources(), n._resizeHandler = function() {
                    n.resize()
                }, n.wrapper.on(te + G + " selectstart" + G, function(t) {
                    e(t.target).is(":kendoFocusable") || t.preventDefault()
                }), n.options.editable && n.options.editable.resize !== !1 && n._resizable(), n._movable(), n._bindResize(), n.options.messages && n.options.messages.recurrence && (O.options = n.options.messages.recurrence), n._selectable(), n._touchHandlers(), n._ariaId = I.guid(), n._createEditor()
            },
            _bindResize: function() {
                e(window).on("resize" + G, this._resizeHandler)
            },
            _unbindResize: function() {
                e(window).off("resize" + G, this._resizeHandler)
            },
            dataItems: function() {
                var i, n, a, r, o, s = this,
                    l = s.items(),
                    d = s._data,
                    c = e.map(l, function(t) {
                        return e(t).attr("data-uid")
                    }),
                    u = {},
                    h = c.length;
                for (i = 0; i < h; i++) u[c[i]] = null;
                for (a = d.length, i = 0; i < a; i++) r = d[i], u[r.uid] !== t && (u[r.uid] = r);
                o = [];
                for (n in u) o.push(u[n]);
                return o
            },
            _isMobile: function() {
                var e = this.options;
                return e.mobile === !0 && I.support.mobileOS || "phone" === e.mobile || "tablet" === e.mobile
            },
            _isTouch: function(e) {
                return /touch/.test(e.type) || e.originalEvent && /touch/.test(e.originalEvent.pointerType)
            },
            _isInverseColor: function(e) {
                return e.hasClass(_e)
            },
            _groupsByResource: function(e, t, i, n, a) {
                var r, o, s, l, d, c, u;
                if (i || (i = []), r = e[0]) {
                    for (s = r.dataSource.view(), l = 0, d = 0; d < s.length; d++) c = I.getter(r.dataValueField)(s[d]), u = t + l + d, o = this._groupsByResource(e.slice(1), u, i, c, r.field), o[r.field] = c, l = o.groupIndex, a && n && (o[a] = n), 1 === e.length && (o.groupIndex = t + d, i.push(o));
                    return o
                }
                return {}
            },
            data: function() {
                return this._data
            },
            select: function(i) {
                var n, a, r, o, s, l, d, c, u, h, p = this,
                    f = p.view(),
                    v = p._selection,
                    m = f.groups;
                if (i === t) return r = f._selectedSlots, v ? (v && v.events && (a = p._selectedEvents()), {
                    start: v.start,
                    end: v.end,
                    events: a,
                    slots: r,
                    resources: f._resourceBySlot(v)
                }) : [];
                if (!i) return p._selection = null, p._old = null, f.clearSelection(), t;
                if (e.isArray(i) && (i = {
                        events: i.splice(0)
                    }), i.resources) {
                    s = [], l = [], f.groupedResources && p._groupsByResource(f.groupedResources, 0, l);
                    for (o in i.resources) s.push({
                        field: o,
                        operator: "eq",
                        value: i.resources[o]
                    });
                    n = new I.data.Query(l).filter(s).toArray()
                }
                return i.events && i.events.length ? (p._selectEvents(i.events, n), p._select(), t) : (m && i.start && i.end && (d = H(f._startDate), c = I.date.addDays(H(f._endDate), 1), i.start < c && d <= i.end && (u = n && n.length ? m[n[0].groupIndex] : m[0], u.timeSlotCollectionCount() || (i.isAllDay = !0), h = u.ranges(i.start, i.end, i.isAllDay, !1), h.length && (p._selection = {
                    start: I.timezone.toLocalDate(h[0].start.start),
                    end: I.timezone.toLocalDate(h[h.length - 1].end.end),
                    groupIndex: h[0].start.groupIndex,
                    index: h[0].start.index,
                    isAllDay: h[0].start.isDaySlot,
                    events: []
                }, p._select()))), t)
            },
            _selectEvents: function(e, t) {
                var i, n, a, r, o, s, l, d, c = this,
                    u = c.view(),
                    h = u.groups,
                    p = e.length,
                    f = t && t.length;
                for (i = 0; i < p; i++)
                    if (h && f) {
                        for (n = h[t[0].groupIndex], a = [], r = n.timeSlotCollectionCount(), o = n.daySlotCollectionCount(), s = 0; s < r; s++) a = a.concat(n.getTimeSlotCollection(s).events());
                        for (l = 0; l < o; l++) a = a.concat(n.getDaySlotCollection(l).events());
                        a = new I.data.Query(a).filter({
                            field: "element[0].getAttribute('data-uid')",
                            operator: "eq",
                            value: e[i]
                        }).toArray(), a[0] && c._createSelection(a[0].element)
                    } else d = u.element.find(I.format(".k-event[data-uid={0}], .k-task[data-uid={0}]", e[i])), d.length && c._createSelection(d[0])
            },
            _touchHandlers: function() {
                var t, i, n, a, r, o = this,
                    s = o.wrapper,
                    l = e.proxy(o._touchMove, o);
                s.on(ie + G, ".k-scheduler-header-all-day td, .k-scheduler-content td, .k-event", function(e) {
                    var n = o.wrapper.find(".k-scheduler-content");
                    o._isTouch(e) && (n.stop(!0, !1), o._touchPosX = t = o._tapPosition(e, "X"), o._touchPosY = i = o._tapPosition(e, "Y"), o._userTouched = !0, o.view()._scrolling = !1, r = Date.now(), s.on(ne + G, ".k-scheduler-header-all-day td, .k-scheduler-content td, .k-event", l))
                }), s.on(ae + G, ".k-scheduler-header-all-day td, .k-scheduler-content td, .k-event", function(e) {
                    var d, c, u;
                    o._isTouch(e) && (d = Date.now() - r, c = o.wrapper.find(".k-scheduler-content"), u = -o._amplitude * (3e3 / d), n = o._tapPosition(e, "X"), a = o._tapPosition(e, "Y"), o._dragging || (o.options.selectable && (Math.abs(n - t) <= 10 || Math.abs(a - i) <= 10) && o._mouseDownSelection(e), !I.support.kineticScrollNeeded && d < 200 && Math.abs(n - t) > 10 && c.animate({
                        scrollTop: c[0].scrollTop + u
                    }), s.off(ne + G, ".k-scheduler-header-all-day td, .k-scheduler-content td", l)))
                })
            },
            _selectable: function() {
                var t, i = this,
                    n = i.wrapper;
                i.options.selectable && (i._tabindex(), n.on(te + G, ".k-scheduler-header-all-day td, .k-scheduler-content td, .k-event", function(e) {
                    i._isTouch(e) || i._mouseDownSelection(e)
                }), t = e.proxy(i._mouseMove, i), n.on(te + G, ".k-scheduler-header-all-day td, .k-scheduler-content td", function(e) {
                    var a = e.which,
                        r = e.button,
                        o = a && 3 === a || r && 2 == r;
                    i._isTouch(e) || o || n.on(re + G, ".k-scheduler-header-all-day td, .k-scheduler-content td", t)
                }), n.on("mouseup" + G + " mousecancel" + G, function() {
                    n.off(re + G, ".k-scheduler-header-all-day td, .k-scheduler-content td", t)
                }), n.on("focus" + G, function() {
                    i._selection || i._userTouched || i._selectFirstSlot(), i._select()
                }), n.on("focusout" + G, function(t) {
                    i._ctrlKey = i._shiftKey = !1, i.toolbar.find("ul > li").removeClass(ve), e(t.relatedTarget).closest(ge).length || i.toolbar.find(ge).removeClass(me)
                }), n.on("keydown" + G, X(i._keydown, i)), n.on("keyup" + G, function(e) {
                    i._ctrlKey = e.ctrlKey, i._shiftKey = e.shiftKey
                }))
            },
            _mouseDownSelection: function(e) {
                var t = e.which,
                    i = e.button,
                    n = t && 3 === t || i && 2 == i;
                n || (e.ctrlKey && (this._ctrlKey = e.ctrlKey), e.shiftKey && (this._shiftKey = e.shiftKey), this._createSelection(e.currentTarget)), I._activeElement() !== this.wrapper.get(0) ? I.focusElement(this.wrapper) : this._select(), this.toolbar && this.toolbar.find("ul > li").removeClass(ve)
            },
            _selectFirstSlot: function() {
                this._createSelection(this.wrapper.find(".k-scheduler-content").find("td:first"))
            },
            _select: function() {
                var t, i, n, a, r, o = this,
                    s = o.view(),
                    l = o.wrapper,
                    d = s.current(),
                    c = o._selection,
                    u = o._old ? o._old.selection : null,
                    h = o._old ? o._old.eventsLength : null;
                if (c && (d && (d.removeAttribute("id"), d.removeAttribute("aria-label"), l.removeAttr("aria-activedescendant")), s.select(c), d = s.current(), d && (u !== d || c.events && h !== c.events.length))) {
                    if (t = e(d).data("uid"), o._old && t && t === e(o._old.selection).data("uid") && c.events && o._old.eventsLength === c.events.length) return;
                    n = c, a = o._selectedEvents(), r = s._selectedSlots, a[0] ? (n = a[0] || c, i = I.format(o.options.messages.ariaEventLabel, n.title, n.start, n.start)) : i = I.format(o.options.messages.ariaSlotLabel, n.start, n.end), d.setAttribute("id", o._ariaId), d.setAttribute("aria-label", i), l.attr("aria-activedescendant", o._ariaId), o._old = {
                        selection: d,
                        eventsLength: a.length
                    }, o.trigger("change", {
                        start: c.start,
                        end: c.end,
                        events: a,
                        slots: r,
                        resources: s._resourceBySlot(c)
                    })
                }
            },
            _selectedEvents: function() {
                for (var e, t = this._selection.events, i = t.length, n = 0, a = []; n < i; n++) e = this.occurrenceByUid(t[n]), e && a.push(e);
                return a
            },
            _tapPosition: function(e, t) {
                return /touch/.test(e.type) ? (e.originalEvent || e).changedTouches[0]["page" + t] : e["page" + t]
            },
            _touchMove: function(e) {
                var t = this,
                    i = t.wrapper.find(".k-scheduler-content"),
                    n = i[0].scrollHeight > i[0].clientHeight,
                    a = i[0].scrollWidth > i[0].clientWidth,
                    r = t._tapPosition(e, "Y"),
                    o = t._tapPosition(e, "X"),
                    s = i[0].scrollTop - Math.round(r - t._touchPosY),
                    l = i[0].scrollLeft - Math.round(o - t._touchPosX),
                    d = n && Math.abs(r - t._touchPosY) > 10,
                    c = a && Math.abs(r - t._touchPosY) > 10;
                t._dragging || I.support.kineticScrollNeeded || !t._isTouch(e) || (d || c) && (t._amplitude = Math.round(r - t._touchPosY), t._touchPosY = r, t._touchPosX = o, i.animate({
                    scrollTop: s,
                    scrollLeft: l
                }, 0), t.view()._scrolling = !0)
            },
            _mouseMove: function(t) {
                var i = this;
                clearTimeout(i._moveTimer), i._isTouch(t) || (i._moveTimer = setTimeout(function() {
                    var n, a, r, o = i.view(),
                        s = i._selection;
                    s && (n = o.selectionByElement(e(t.currentTarget)), n && s.groupIndex === n.groupIndex && (a = n.startDate(), r = n.endDate(), a >= s.end ? s.backward = !1 : r <= s.start && (s.backward = !0), s.backward ? s.start = a : s.end = r, i._select()))
                }, 5))
            },
            _viewByIndex: function(e) {
                var t, i = this.views;
                for (t in i) {
                    if (!e) return t;
                    e--
                }
            },
            _keydown: function(i) {
                var n, a, r, o, s, l, d = this,
                    c = i.keyCode,
                    u = d.view(),
                    h = u.options.editable,
                    p = d._selection,
                    f = e.extend(p),
                    v = 16 === c || 18 === c || 17 === c || 91 === c || 92 === c,
                    m = ".k-scheduler-tools > li,.k-scheduler-navigation > li,.k-scheduler-views > li.k-state-selected:visible, .k-scheduler-views > li.k-current-view:visible",
                    g = d.toolbar.find(m),
                    _ = d.toolbar.find(ge),
                    k = e(i.target).closest(ge).length || d.toolbar.find(".k-scheduler-views .k-state-focused").length,
                    w = _.children().index(d.toolbar.find("." + ve)),
                    b = I.support.isRtl(d.element),
                    y = b ? -1 : 1;
                if (w == -1 && (w = _.children().index(d.toolbar.find(".k-state-selected"))), d._ctrlKey = i.ctrlKey, d._shiftKey = i.shiftKey, c === F.F10) return d.toolbar.find("ul > li:first").focus().addClass(ve), i.preventDefault(), t;
                if (c === F.TAB) {
                    if (d.toolbar.find("." + ve).length) return a = g.index(d.toolbar.find("." + ve)), a === -1 && d._focusedView && (a = g.index(d.toolbar.find(".k-scheduler-views > .k-state-selected"))), r = i.shiftKey ? g[a - 1] : g[a + 1], d.toolbar.find("." + ve).removeClass(ve), r ? (e(r).addClass(ve).focus(), d._focusedView = null, i.preventDefault(), t) : (d.element.focus(), i.preventDefault(), t)
                } else if (c === F.ENTER || c === F.SPACEBAR) {
                    if (k && d._focusedView && !d._focusedView.hasClass("k-state-selected")) return o = d._focusedView.data().name, d.trigger("navigate", {
                        view: o,
                        action: "changeView",
                        date: d.date()
                    }) || (d.view(o), _.removeClass(me), d.toolbar.find(".k-current-view:visible").length && (e(document.activeElement).blur(), d.toolbar.find(".k-current-view:visible").addClass(ve).find(".k-link").focus())), i.preventDefault(), t;
                    if (d.toolbar.find("." + ve + ":visible").length) return d.toolbar.find("." + ve + ":visible").click(), i.preventDefault(), t
                } else if (i.altKey && c === F.DOWN) {
                    if (d.toolbar.find("." + ve + ":visible").length) return d.toolbar.find("." + ve + ":visible").click(), i.preventDefault(), t
                } else {
                    if (c === F.RIGHT && k) return e(d.toolbar.find("." + ve)).removeClass(ve), d._focusedView = e(b ? w - 1 === 0 ? _.children(":not(.k-current-view):last") : _.children()[w + 1 * y] : w + 1 === _.children().length ? _.children(":not(.k-current-view):first") : _.children()[w + 1 * y]), d._focusedView.focus().addClass(ve), i.preventDefault(), t;
                    if (c === F.LEFT && k) return e(d.toolbar.find("." + ve)).removeClass(ve), d._focusedView = e(b ? w + 1 === _.children().length ? _.children(":not(.k-current-view):first") : _.children()[w - 1 * y] : w - 1 === 0 ? _.children(":not(.k-current-view):last") : _.children()[w - 1 * y]), d._focusedView.focus().addClass(ve), i.preventDefault(), t;
                    if (c === F.DOWN && d.toolbar.find(ge).hasClass(me)) return d.toolbar.find("." + ve).removeClass(ve), n = d._focusedView ? _.find(d._focusedView).index() : _.children(".k-scheduler-views > .k-state-selected").index(), d._focusedView = e(n + 1 === _.children().length ? _.children(":not(.k-current-view):first") : _.children()[n + 1 * y]), d._focusedView.focus().addClass(ve), i.preventDefault(), t;
                    if (c === F.UP && d.toolbar.find(ge).hasClass(me)) return d.toolbar.find("." + ve).removeClass(ve), n = d._focusedView ? _.find(d._focusedView).index() : _.children(".k-scheduler-views > .k-state-selected").index(), d._focusedView = e(n - 1 === 0 ? _.children(":not(.k-current-view):last") : _.children()[n - 1 * y]), d._focusedView.focus().addClass(ve), i.preventDefault(), t;
                    if (i.altKey && c === F.DOWN && d.toolbar.find(".k-nav-current").hasClass(ve)) return d._showCalendar(), i.preventDefault(), t;
                    if (c === F.ESC && d.popup && d.popup.visible()) return d.popup.close(), i.preventDefault(), t;
                    if (c === F.ESC && d.toolbar.find(ge).hasClass(me)) return d.toolbar.find(ge).removeClass(me), d.toolbar.find(ge).children().removeClass(ve), d._focusedView = null, d.toolbar.find(".k-current-view").focus().addClass(ve), i.preventDefault(), t
                }
                if (!v) {
                    if (!p) return d._selectFirstSlot(), d._select(), d.element.focus(), t;
                    c === F.TAB ? u.moveToEvent(p, i.shiftKey) && (d._select(), document.activeElement.getAttribute("id") !== d.element.attr("id") && d.element.focus(), i.preventDefault()) : c === F.ENTER || c === F.SPACEBAR ? p.events.length && h ? h.update !== !1 && d.editEvent(p.events[0]) : h && h.create !== !1 && (p.isAllDay && (p = e.extend({}, p, {
                        end: I.date.addDays(p.end, -1)
                    })), i.preventDefault(), d.addEvent($({}, p, u._resourceBySlot(p)))) : c === F.DELETE && h !== !1 && h.destroy !== !1 ? d.removeEvent(p.events[0]) : c >= 49 && c <= 57 ? (s = d._viewByIndex(c - 49), s && !d.trigger("navigate", {
                        view: s,
                        action: "changeView",
                        date: d.date()
                    }) && d.view(s)) : u.move(p, c, i.shiftKey) && (u.inRange(p) ? d._select() : (l = d.date().getTime() > p.start.getTime() ? "previous" : "next", d.trigger("navigate", {
                        view: d._selectedViewName,
                        action: l,
                        date: p.start
                    }) ? (p.start = f.start, p.end = f.end) : d.date(p.start)), d.toolbar.find("ul > li").removeClass(ve), i.preventDefault()), d._adjustSelectedDate()
                }
            },
            _createSelection: function(t) {
                var i, n, a = this._selection;
                t = e(t), t.is(".k-event") && (i = t.attr(I.attr("uid")), a && a.events.indexOf(i) !== -1 && !this._ctrlKey) || (a && (this._ctrlKey || this._shiftKey) || (a = this._selection = {
                    events: [],
                    groupIndex: 0
                }), n = this.view().selectionByElement(t), n && (a.groupIndex = n.groupIndex || 0), i && (n = d(this._data, i)), n && n.uid && (i = [n.uid]), this._updateSelection(n, i), this._adjustSelectedDate())
            },
            _updateSelection: function(e, i, n) {
                var a, r, o, s = this._selection;
                e && s && (a = this.view(), e.uid && (e = a._updateEventForSelection(e)), this._shiftKey && s.start && s.end ? (r = e.end < s.end, s.end = e.endDate ? e.endDate() : e.end, r && a._timeSlotInterval && I.date.setTime(s.end, -a._timeSlotInterval())) : (s.start = e.startDate ? e.startDate() : e.start, s.end = e.endDate ? e.endDate() : e.end), s.isAllDay = "isDaySlot" in e ? e.isDaySlot : e.isAllDay, null !== n && n !== t && (s.groupIndex = n), s.index = e.index, this._ctrlKey ? (o = i && i.length ? s.events.indexOf(i[0]) : -1, o > -1 ? s.events.splice(o, 1) : s.events = s.events.concat(i || [])) : s.events = i || [])
            },
            options: {
                name: "Scheduler",
                date: we,
                editable: !0,
                autoBind: !0,
                snap: !0,
                mobile: !1,
                timezone: "",
                allDaySlot: !0,
                min: new Date(1900, 0, 1),
                max: new Date(2099, 11, 31),
                toolbar: null,
                workWeekStart: 1,
                workWeekEnd: 5,
                showWorkHours: !1,
                startTime: we,
                endTime: we,
                currentTimeMarker: {
                    updateInterval: 1e4,
                    useLocalTimezone: !0
                },
                footer: {},
                messages: {
                    today: "Today",
                    pdf: "Export to PDF",
                    save: "Save",
                    cancel: "Cancel",
                    destroy: "Delete",
                    resetSeries: "Reset Series",
                    deleteWindowTitle: "Delete event",
                    next: "Next",
                    previous: "Previous",
                    ariaSlotLabel: "Selected from {0:t} to {1:t}",
                    ariaEventLabel: "{0} on {1:D} at {2:t}",
                    views: {
                        day: "Day",
                        week: "Week",
                        workWeek: "Work Week",
                        agenda: "Agenda",
                        month: "Month",
                        timeline: "Timeline",
                        timelineWeek: "Timeline Week",
                        timelineWorkWeek: "Timeline Work Week",
                        timelineMonth: "Timeline Month"
                    },
                    recurrenceMessages: {
                        deleteWindowTitle: "Delete Recurring Item",
                        resetSeriesWindowTitle: "Reset Series",
                        deleteWindowOccurrence: "Delete current occurrence",
                        deleteWindowSeries: "Delete the series",
                        editWindowTitle: "Edit Recurring Item",
                        editWindowOccurrence: "Edit current occurrence",
                        editWindowSeries: "Edit the series"
                    },
                    editable: {
                        confirmation: Te
                    },
                    editor: {
                        title: "Title",
                        start: "Start",
                        end: "End",
                        allDayEvent: "All day event",
                        description: "Description",
                        repeat: "Repeat",
                        timezone: "Timezone",
                        startTimezone: "Start timezone",
                        endTimezone: "End timezone",
                        separateTimezones: "Use separate start and end time zones",
                        timezoneEditorTitle: "Timezones",
                        timezoneEditorButton: "Time zone",
                        timezoneTitle: "Time zones",
                        noTimezone: "No timezone",
                        editorTitle: "Event"
                    }
                },
                height: null,
                width: null,
                resources: [],
                group: {
                    resources: [],
                    orientation: "horizontal"
                },
                views: [],
                selectable: !1
            },
            events: [ce, fe, de, he, "add", "dataBinding", "dataBound", "moveStart", "move", "moveEnd", "resizeStart", "resize", "resizeEnd", "navigate", "change"],
            destroy: function() {
                var t, i, n, a = this;
                if (L.fn.destroy.call(a), a.dataSource && (a.dataSource.unbind(oe, a._refreshHandler), a.dataSource.unbind(se, a._progressHandler), a.dataSource.unbind(le, a._errorHandler)), a._resourceRefreshHandler)
                    for (i = 0; i < a.resources.length; i++) n = a.resources[i].dataSource, n.unbind(oe, a._resourceRefreshHandler), n.unbind(se, a._resourceProgressHandler), n.unbind(le, a._resourceErrorHandler);
                a.calendar && (a.calendar.destroy(), a.popup.destroy()), a.view() && a.view().destroy(), a._editor && a._editor.destroy(), this._moveDraggable && this._moveDraggable.destroy(), this._resizeDraggable && this._resizeDraggable.destroy(), t = a.element.add(a.wrapper).add(a.toolbar).add(a.popup), t.off(G), clearTimeout(a._moveTimer), a._model = null, a.toolbar = null, a.element = null, e(window).off("resize" + G, a._resizeHandler), I.destroy(a.wrapper)
            },
            setDataSource: function(e) {
                this.options.dataSource = e, this._dataSource(), this.options.autoBind && e.fetch ? e.fetch() : Z(e) && this.view(this._selectedView)
            },
            items: function() {
                var e = this.wrapper.find(".k-scheduler-content"),
                    t = this.view();
                return t && "agenda" === t.options.name ? e.find(".k-task") : e.find(".k-event").add(this.wrapper.find(".k-scheduler-header-wrap").find(".k-scheduler-header-all-day").siblings())
            },
            _movable: function() {
                var i, n, a, r, o, s, l, d, c, u, h = this,
                    p = 0,
                    f = [],
                    v = [],
                    m = h._isMobile(),
                    g = h.options.editable && h.options.editable.move !== !1,
                    _ = h.options.editable && h.options.editable.resize !== !1;
                (g || _ && m) && (h._dragging = !1, m && I.support.mobileOS.android && (p = 5), h._moveDraggable = new I.ui.Draggable(h.element, {
                    distance: p,
                    filter: ".k-event",
                    ignore: ".k-resize-handle",
                    holdToDrag: m,
                    autoScroll: !0
                }), g && h._moveDraggable.bind("dragstart", function(e) {
                    var o, p, v, m, g = h.view(),
                        _ = e.currentTarget,
                        k = h._isTouch(e);
                    if (h._dragging = !0, !g.options.editable || g.options.editable.move === !1) return h._dragging = !1, e.preventDefault(), t;
                    if (k && !_.hasClass("k-event-active")) return h._dragging = !1, h.element.find(".k-event-active").removeClass("k-event-active"), e.preventDefault(), t;
                    if (s = h.occurrenceByUid(_.attr(I.attr("uid"))), l = s.clone(), u = s.clone(), l.update(g._eventOptionsForMove(l)), l.inverseColor = h._isInverseColor(_), f = [], h._selection)
                        for (o = h._selection.events, p = 0; p < o.length; p++) v = h.occurrenceByUid(o[p]).clone(), m = this.element.find('div.k-event[data-uid="' + v.uid + '"]').eq(0), v.update(g._eventOptionsForMove(v)), m.length && (v.inverseColor = h._isInverseColor(m)), f.push(v);
                    else f.push(l);
                    i = g._slotByPosition(e.x.startLocation, e.y.startLocation), a = g._resourceBySlot(i), c = r = i.startOffset(e.x.startLocation, e.y.startLocation, h.options.snap), n = i, d = i, i && !h.trigger("moveStart", {
                        event: s
                    }) || e.preventDefault()
                }).bind("drag", function(t) {
                    var a, u, p, m, g, _ = h.view(),
                        k = _._slotByPosition(t.x.location, t.y.location);
                    if (k) {
                        if (o = k.startOffset(t.x.location, t.y.location, h.options.snap), k.isDaySlot !== i.isDaySlot)
                            if (k.isDaySlot !== d.isDaySlot)
                                for (m = e(i.element).index(), g = e(k.element).parent().children().eq(m), i = _._slotByPosition(g.offset().left, g.offset().top), r = i.startOffset(t.x.location, t.y.location, !0), v = f.map(function(e) {
                                        return e.clone()
                                    }), p = 0; p < f.length; p++) f[p].isAllDay != k.isDaySlot && (f[p].isAllDay = k.isDaySlot, f[p].end = I.date.getDate(f[p].start), f[p].start = I.date.getDate(f[p].start), k.isDaySlot || (I.date.setTime(f[p].start, I.date.getMilliseconds(_.startTime())), I.date.setTime(f[p].end, I.date.getMilliseconds(_.startTime()) + _._timeSlotInterval())));
                            else i = e.extend(!0, {}, d), r = c, f = v;
                        for (a = o - r, p = 0; p < f.length; p++) _._updateMoveHint(f[p], k.groupIndex, a);
                        if (u = b(l, a), h.trigger("move", {
                                event: s,
                                slot: {
                                    element: k.element,
                                    start: k.startDate(),
                                    end: k.endDate(),
                                    isDaySlot: k.isDaySlot
                                },
                                resources: _._resourceBySlot(k),
                                start: u.start,
                                end: u.end
                            }))
                            for (p = 0; p < f.length; p++) _._updateMoveHint(f[p], k.groupIndex, a);
                        else n = k
                    }
                }).bind("dragend", function(t) {
                    var i, c, u, p, m, g, _, k, w, y;
                    if (h.view()._removeMoveHint(), i = o - r, c = b(l, i), u = c.start, p = c.end, h._dragging = !1, m = h.view()._resourceBySlot(n), g = h.trigger("moveEnd", {
                            event: s,
                            slot: {
                                element: n.element,
                                start: n.startDate(),
                                end: n.endDate()
                            },
                            start: u,
                            end: p,
                            resources: m
                        }), !g && (s.start.getTime() !== u.getTime() || s.end.getTime() !== p.getTime() || d.isDaySlot !== n.isDaySlot || I.stringify(m) !== I.stringify(a))) {
                        for (h._isMultiDrag = f.length > 1, _ = 0; _ < f.length; _++) k = f[_], c = b(k, i), w = h.view()._eventOptionsForMove(k), y = e.extend({
                            isAllDay: k.isAllDay,
                            start: c.start,
                            end: c.end
                        }, w, m), h._updateEvent(null, k, y);
                        h._isMultiDrag && (h.dataSource.sync(), h._isMultiDrag = !1)
                    }
                    t.currentTarget.removeClass("k-event-active"), this.cancelHold(), f = [], v = []
                }).bind("dragcancel", function() {
                    h.view()._removeMoveHint(), this.cancelHold(), f = [], v = []
                }), h._moveDraggable.bind("hold", function(e) {
                    h._isTouch(e) && (h.element.find(".k-event-active").removeClass("k-event-active"), h.options.selectable && h._createSelection(e.currentTarget), e.currentTarget.addClass("k-event-active"))
                }))
            },
            _resizable: function() {
                function t(e) {
                    var t, i = {
                        "k-resize-e": "east",
                        "k-resize-w": "west",
                        "k-resize-n": "north",
                        "k-resize-s": "south"
                    };
                    for (t in i)
                        if (e.hasClass(t)) return i[t]
                }
                var i, n, a, r, o, s = this,
                    l = 0;
                s._isMobile() && I.support.mobileOS.android && (l = 5), s._resizeDraggable = new I.ui.Draggable(s.element, {
                    distance: l,
                    filter: ".k-resize-handle",
                    autoScroll: !0,
                    dragstart: function(t) {
                        var l = e(t.currentTarget),
                            d = l.closest(".k-event"),
                            c = d.attr(I.attr("uid")),
                            u = s.view();
                        s._dragging = !0, a = s.occurrenceByUid(c), r = a.clone(), u._updateEventForResize(r), o = u._slotByPosition(t.x.startLocation, t.y.startLocation), s.trigger("resizeStart", {
                            event: a
                        }) && t.preventDefault(), i = I.date.toUtcTime(r.start), n = I.date.toUtcTime(r.end)
                    },
                    drag: function(l) {
                        var d, c, u, h, p, f;
                        o && (d = e(l.currentTarget), c = t(d), u = s.view(), h = u._slotByPosition(l.x.location, l.y.location), h && o.groupIndex == h.groupIndex && (o = h, p = i, f = n, "south" == c ? !o.isDaySlot && o.end - I.date.toUtcTime(r.start) >= u._timeSlotInterval() && (n = r.isAllDay ? o.startOffset(l.x.location, l.y.location, s.options.snap) : o.endOffset(l.x.location, l.y.location, s.options.snap)) : "north" == c ? !o.isDaySlot && I.date.toUtcTime(r.end) - o.start >= u._timeSlotInterval() && (i = o.startOffset(l.x.location, l.y.location, s.options.snap)) : "east" == c ? o.isDaySlot && I.date.toUtcTime(I.date.getDate(o.endDate())) >= I.date.toUtcTime(I.date.getDate(r.start)) ? n = r.isAllDay ? o.startOffset(l.x.location, l.y.location, s.options.snap) : o.endOffset(l.x.location, l.y.location, s.options.snap) : !o.isDaySlot && o.end - I.date.toUtcTime(r.start) >= u._timeSlotInterval() && (n = o.endOffset(l.x.location, l.y.location, s.options.snap)) : "west" == c && (o.isDaySlot && I.date.toUtcTime(I.date.getDate(r.end)) >= I.date.toUtcTime(I.date.getDate(o.startDate())) ? i = o.startOffset(l.x.location, l.y.location, s.options.snap) : !o.isDaySlot && I.date.toUtcTime(r.end) - o.start >= u._timeSlotInterval() && (i = o.startOffset(l.x.location, l.y.location, s.options.snap))), s.trigger("resize", {
                            event: a,
                            slot: {
                                element: o.element,
                                start: o.startDate(),
                                end: o.endDate()
                            },
                            start: I.timezone.toLocalDate(i),
                            end: I.timezone.toLocalDate(n),
                            resources: u._resourceBySlot(o)
                        }) ? (i = p, n = f) : u._updateResizeHint(r, o.groupIndex, i, n)))
                    },
                    dragend: function(l) {
                        var d, c = e(l.currentTarget),
                            u = new Date(r.start.getTime()),
                            h = new Date(r.end.getTime()),
                            p = t(c);
                        s._dragging = !1, s.view()._removeResizeHint(), "south" == p ? h = I.timezone.toLocalDate(n) : "north" == p ? u = I.timezone.toLocalDate(i) : "east" == p ? h = o.isDaySlot ? I.date.getDate(I.timezone.toLocalDate(n)) : I.timezone.toLocalDate(n) : "west" == p && (o.isDaySlot ? (u = new Date(I.timezone.toLocalDate(i)), u.setHours(0), u.setMinutes(0)) : u = I.timezone.toLocalDate(i)), d = s.trigger("resizeEnd", {
                            event: a,
                            slot: {
                                element: o.element,
                                start: o.startDate(),
                                end: o.endDate()
                            },
                            start: u,
                            end: h,
                            resources: s.view()._resourceBySlot(o)
                        }), !d && h.getTime() >= u.getTime() && (r.start.getTime() == u.getTime() && r.end.getTime() == h.getTime() || (s.view()._updateEventForResize(a), s._updateEvent(p, a, {
                            start: u,
                            end: h
                        }))), o = null, a = null
                    },
                    dragcancel: function() {
                        s._dragging = !1, s.view()._removeResizeHint(), o = null, a = null
                    }
                })
            },
            _updateEvent: function(e, t, i) {
                var n, a = this,
                    r = function(e, t) {
                        try {
                            a._preventRefresh = !0, e.update(i), a._convertDates(e)
                        } finally {
                            a._preventRefresh = !1
                        }
                        a.trigger(he, {
                            event: e
                        }) || (t && t(), a._isMultiDrag || a.dataSource.sync())
                    },
                    o = function(e) {
                        return e.recurrenceRule ? a.dataSource.getByUid(e.uid) : a.dataSource.get(e.recurrenceId)
                    },
                    s = function() {
                        var n, s, l = o(t);
                        "south" != e && "north" != e || (i.start && (n = I.date.getDate(l.start), I.date.setTime(n, W(i.start)), i.start = n), i.end && (s = I.date.getDate(l.end), I.date.setTime(s, W(i.end)), i.end = s)), a.dataSource._removeExceptions(l), r(l)
                    },
                    l = function() {
                        var e = o(t),
                            i = function() {
                                a._convertDates(e), a._selection && a._selection.events.push(s)
                            },
                            n = e.toOccurrence({
                                start: t.start,
                                end: t.end
                            }),
                            s = n.uid;
                        r(a.dataSource.add(n), i)
                    };
                t.recurrenceRule || t.isOccurrence() ? (n = a.options.messages.recurrenceMessages, a._showRecurringDialog(t, l, s, {
                    title: n.editWindowTitle,
                    text: n.editRecurring ? n.editRecurring : Se,
                    occurrenceText: n.editWindowOccurrence,
                    seriesText: n.editWindowSeries
                })) : r(a.dataSource.getByUid(t.uid))
            },
            _modelForContainer: function(t) {
                return t = e(t).closest("[" + I.attr("uid") + "]"), this.dataSource.getByUid(t.attr(I.attr("uid")))
            },
            showDialog: function(e) {
                this._editor.showDialog(e)
            },
            focus: function() {
                this.wrapper.focus()
            },
            _confirmation: function(e, t, i) {
                var n, a, r, o, s, l = this.options.editable;
                l === !0 || l.confirmation !== !1 ? (n = this.options.messages, a = n.deleteWindowTitle, r = typeof l.confirmation === K ? l.confirmation : n.editable.confirmation, this._isEditorOpened() && t.isRecurring() && (o = this.options.messages.recurrenceMessages, a = o.deleteWindowTitle, r = t.isException() ? o.deleteRecurringConfirmation ? o.deleteRecurringConfirmation : xe : o.deleteSeriesConfirmation ? o.deleteSeriesConfirmation : Ce, i && (a = o.resetSeriesWindowTitle, r = o.resetSeriesConfirmation ? o.resetSeriesConfirmation : Ee)), s = [{
                    name: "destroy",
                    text: i ? n.resetSeries : n.destroy,
                    click: function() {
                        e()
                    }
                }], this._isMobile() && I.Pane || s.push({
                    name: "canceledit",
                    text: n.cancel,
                    click: function() {
                        e(!0)
                    }
                }), this._unbindResize(), this.showDialog({
                    model: t,
                    text: r,
                    title: a,
                    buttons: s
                }), this._bindResize()) : e()
            },
            addEvent: function(e) {
                var t, i, n = this._editor.editable,
                    a = this.dataSource;
                e = e || {}, i = this.trigger("add", {
                    event: e
                }), !i && (n && n.end() || !n) && (this.cancelEvent(), e && e.toJSON && (e = e.toJSON()), t = a.add(e), t && (this.cancelEvent(), this._editEvent(t)))
            },
            saveEvent: function() {
                var e, t, i, n = this._editor;
                n && (e = n.editable, t = n.container, i = this._modelForContainer(t), t && e && e.end() && !this.trigger(he, {
                    container: t,
                    event: i
                }) && (i.dirty || i.isOccurrence() || this._convertDates(i, "remove"), this.dataSource.sync()))
            },
            cancelEvent: function() {
                var e, t = this._editor,
                    i = t.container;
                i && (e = this._modelForContainer(i), e && e.isOccurrence() && (this._convertDates(e, "remove"), this._convertDates(this.dataSource.get(e.recurrenceId), "remove")), this.dataSource.cancelChanges(e), t.close())
            },
            editEvent: function(e) {
                var t = "string" == typeof e ? this.occurrenceByUid(e) : e;
                t && (this.cancelEvent(), t.isRecurring() ? this._editRecurringDialog(t) : this._editEvent(t))
            },
            _editEvent: function(e) {
                this._preventRefresh = !0, this._unbindResize(), this._createPopupEditor(e), this._bindResize()
            },
            _editRecurringDialog: function(e) {
                var t = this,
                    i = function() {
                        e.isException() ? t._editEvent(e) : t.addEvent(e)
                    },
                    n = function() {
                        e.recurrenceId && (e = t.dataSource.get(e.recurrenceId)), t._editEvent(e)
                    },
                    a = t.options.messages.recurrenceMessages;
                t._showRecurringDialog(e, i, n, {
                    title: a.editWindowTitle,
                    text: a.editRecurring ? a.editRecurring : Se,
                    occurrenceText: a.editWindowOccurrence,
                    seriesText: a.editWindowSeries
                })
            },
            _showRecurringDialog: function(e, t, i, n) {
                var a = this.options.editable,
                    r = Q(a) ? a.editRecurringMode : "dialog";
                "occurrence" === r || this._isMultiDrag ? t() : "series" === r ? i() : (this._unbindResize(), this.showDialog({
                    model: e,
                    title: n.title,
                    text: n.text,
                    buttons: [{
                        text: n.occurrenceText,
                        click: t
                    }, {
                        text: n.seriesText,
                        click: i
                    }]
                }), this._bindResize())
            },
            _createButton: function(e) {
                var t = e.template || Re,
                    i = typeof e === K ? e : e.name || e.text,
                    n = {
                        className: "k-scheduler-" + (i || "").replace(/\s/g, ""),
                        text: i,
                        attr: ""
                    };
                if (!(i || Q(e) && e.template)) throw Error("Custom commands should have name specified");
                return Q(e) ? (e.className && (e.className += " " + n.className), "edit" === i && Q(e.text) && (e = $(!0, {}, e), e.text = e.text.edit), n = $(!0, n, y[i], e)) : n = $(!0, n, y[i]), I.template(t)(n)
            },
            _convertDates: function(e, t) {
                var i = this.dataSource.reader.timezone,
                    n = e.startTimezone,
                    a = e.endTimezone,
                    r = e.start,
                    o = e.start;
                t = t || "apply", n = n || a, a = a || n, n && (i ? "apply" === t ? (r = I.timezone.convert(e.start, i, n), o = I.timezone.convert(e.end, i, a)) : (r = I.timezone.convert(e.start, n, i), o = I.timezone.convert(e.end, a, i)) : (r = I.timezone[t](e.start, n), o = I.timezone[t](e.end, a)), e._set("start", r), e._set("end", o))
            },
            _createEditor: function() {
                var e, i = this;
                e = i._editor = this._isMobile() && I.Pane ? new D(this.wrapper, $({}, this.options, {
                    target: this,
                    timezone: i.dataSource.reader.timezone,
                    resources: i.resources,
                    createButton: X(this._createButton, this)
                })) : new S(this.wrapper, $({}, this.options, {
                    target: this,
                    createButton: X(this._createButton, this),
                    timezone: i.dataSource.reader.timezone,
                    resources: i.resources
                })), e.bind("cancel", function(e) {
                    return i.trigger("cancel", {
                        container: e.container,
                        event: e.model
                    }) ? (e.preventDefault(), t) : (i._preventRefresh = !1, i.cancelEvent(), i._attemptRefresh && i.refresh(), i.focus(), t)
                }), e.bind("edit", function(e) {
                    i.trigger(fe, {
                        container: e.container,
                        event: e.model
                    }) && e.preventDefault()
                }), e.bind("save", function() {
                    i._preventRefresh = !1, i.saveEvent()
                }), e.bind("remove", function(e) {
                    i._preventRefresh = !1, i.removeEvent(e.model)
                }), e.bind("resetSeries", function(e) {
                    i._confirmation(function(t) {
                        i._preventRefresh = !1, t || (i.dataSource._removeExceptions(e.model), i.saveEvent())
                    }, e.model, !0)
                })
            },
            _createPopupEditor: function(e) {
                var t = this._editor;
                e.isNew() && !e.isOccurrence() || (e.isOccurrence() && this._convertDates(e.recurrenceId ? this.dataSource.get(e.recurrenceId) : e), this._convertDates(e)), this.editable = t.editEvent(e)
            },
            removeEvent: function(e) {
                var t = this,
                    i = "string" == typeof e ? t.occurrenceByUid(e) : e;
                i && (i.isRecurring() ? t._deleteRecurringDialog(i) : t._confirmation(function(e) {
                    e || t._removeEvent(i)
                }, i))
            },
            occurrenceByUid: function(e) {
                var t = this.dataSource.getByUid(e);
                return t || (t = d(this._data, e)), t
            },
            occurrencesInRange: function(e, t) {
                return new I.data.Query(this._data).filter({
                    logic: "or",
                    filters: [{
                        logic: "and",
                        filters: [{
                            field: "start",
                            operator: "gte",
                            value: e
                        }, {
                            field: "end",
                            operator: "gte",
                            value: e
                        }, {
                            field: "start",
                            operator: "lt",
                            value: t
                        }]
                    }, {
                        logic: "and",
                        filters: [{
                            field: "start",
                            operator: "lte",
                            value: e
                        }, {
                            field: "end",
                            operator: "gt",
                            value: e
                        }]
                    }]
                }).toArray()
            },
            _removeEvent: function(e) {
                this.trigger(ce, {
                    event: e
                }) || this.dataSource.remove(e) && this.dataSource.sync()
            },
            _deleteRecurringDialog: function(e) {
                var t, i, n, a, r, o = this,
                    s = e,
                    l = o.options.editable,
                    d = Q(l) ? l.editRecurringMode : "dialog",
                    c = function() {
                        var e = s.recurrenceId ? s : s.toOccurrence(),
                            t = o.dataSource.get(e.recurrenceId);
                        o._convertDates(t), o._removeEvent(e)
                    },
                    u = function() {
                        s.recurrenceId && (s = o.dataSource.get(s.recurrenceId)), o._removeEvent(s)
                    };
                ("dialog" != d || o._isEditorOpened()) && (t = function() {
                    o._confirmation(function(e) {
                        e || c()
                    }, s)
                }, i = function() {
                    o._confirmation(function(e) {
                        e || u()
                    }, s)
                }), n = i || u, a = t || c, o._isEditorOpened() ? e.isException() ? a() : n() : (r = o.options.messages.recurrenceMessages, o._showRecurringDialog(e, a, n, {
                    title: r.deleteWindowTitle,
                    text: r.deleteRecurring ? r.deleteRecurring : De,
                    occurrenceText: r.deleteWindowOccurrence,
                    seriesText: r.deleteWindowSeries
                }))
            },
            _isEditorOpened: function() {
                return !!this._editor.container
            },
            _unbindView: function(e) {
                var t = this;
                t.angular("cleanup", function() {
                    return {
                        elements: t.items()
                    }
                }), e.destroy()
            },
            _bindView: function(e) {
                var t = this;
                t.options.editable && (t._viewRemoveHandler && e.unbind(ce, t._viewRemoveHandler), t._viewRemoveHandler = function(e) {
                    t.removeEvent(e.uid)
                }, e.bind(ce, t._viewRemoveHandler), t._viewAddHandler && e.unbind(pe, t._viewAddHandler), t._viewAddHandler = function(e) {
                    t.addEvent(e.eventInfo)
                }, e.bind(pe, this._viewAddHandler), t._viewEditHandler && e.unbind(fe, t._viewEditHandler), t._viewEditHandler = function(e) {
                    t.editEvent(e.uid)
                }, e.bind(fe, this._viewEditHandler)), t._viewNavigateHandler && e.unbind("navigate", t._viewNavigateHandler), t._viewNavigateHandler = function(e) {
                    var i, n;
                    e.view && (i = "isWorkDay" in e, n = i ? "changeWorkDay" : "changeView", t.trigger("navigate", {
                        view: e.view,
                        isWorkDay: e.isWorkDay,
                        action: n,
                        date: e.date
                    }) || (i && (t._workDayMode = e.isWorkDay), t._selectView(e.view), t.date(e.date)))
                }, e.bind("navigate", t._viewNavigateHandler), t._viewActivateHandler && e.unbind("activate", t._viewActivateHandler), t._viewActivateHandler = function() {
                    var e = this;
                    t._selection && (e.constrainSelection(t._selection), t._select(), t._adjustSelectedDate())
                }, e.bind("activate", t._viewActivateHandler)
            },
            _selectView: function(e) {
                var t, i, n, a, r = this;
                e && r.views[e] && (r._selectedView && r._unbindView(r._selectedView), r._selectedView = r._renderView(e), r._selectedViewName = e, r._viewsCount > 1 && !r._isMobile() ? (t = Pe({
                    views: r.views,
                    view: e,
                    ns: I.ns
                }), i = r.toolbar.find(".k-scheduler-views li:first-child"), i.is(".k-current-view") ? i.replaceWith(t) : r.toolbar.find(".k-scheduler-views").prepend(t), n = r.toolbar.find(".k-scheduler-views li").removeClass("k-state-selected"), n.end().find(".k-view-" + e.replace(/\./g, "\\.").toLowerCase()).addClass("k-state-selected")) : (a = r.toolbar.find(".k-scheduler-mobile-views"), a.find("[value=" + e.replace(/\./g, "\\.") + "]").prop("selected", "selected")))
            },
            view: function(e) {
                var i = this;
                return e ? (i._selectView(e), i.rebind(), t) : i._selectedView
            },
            viewName: function() {
                return this.view().name
            },
            _renderView: function(e) {
                var t = this._initializeView(e);
                return this._bindView(t), (I.support.mouseAndTouchPresent || I.support.pointers) && (t.content.css("-ms-touch-action", "pinch-zoom"), t.content.css("touch-action", "pinch-zoom")), this._model.set("formattedDate", t.dateForTitle()), this._model.set("formattedShortDate", t.shortDateForTitle()), this._model.set("formattedMobileDate", t.mobileDateForTitle ? t.mobileDateForTitle() : t.shortDateForTitle()), this._model.set("formattedYear", I.format("{0:yyyy}", t.startDate())), t
            },
            resize: function(e) {
                var t = this.getSize(),
                    i = this._size,
                    n = this.view();
                n && n.groups && (!e && i && t.width === i.width && t.height === i.height || (this.refresh({
                    action: "resize"
                }), this._size = t))
            },
            _adjustSelectedDate: function() {
                var e = this._model.selectedDate,
                    t = this._selection,
                    i = t.start;
                i && !I.date.isInDateRange(e, H(i), H(t.end)) && e.setFullYear(i.getFullYear(), i.getMonth(), i.getDate())
            },
            _initializeView: function(e) {
                var t, i, n = this.views[e];
                if (n) {
                    if (t = Q(n), i = n.type, typeof i === K && (i = I.getter(n.type)(window)), !i) throw Error("There is no such view");
                    n = new i(this.wrapper, f($(!0, {}, this.options, t ? n : {}, {
                        resources: this.resources,
                        date: this.date(),
                        startTime: I.parseDate(n.startTime) || I.parseDate(this.options.startTime),
                        endTime: I.parseDate(n.endTime) || I.parseDate(this.options.endTime),
                        showWorkHours: this._workDayMode
                    })))
                }
                return n
            },
            _views: function() {
                var e, t, i, n, a, r, o, s, l, d = this.options.views;
                for (this.views = {}, this._viewsCount = 0, o = 0, s = d.length; o < s; o++) l = !1, e = d[o], n = Q(e), n ? (r = a = e.type ? e.type : e, typeof r !== K && (a = e.name || e.title, l = !0)) : r = a = e, t = E[a], t && !l && (e.type = t.type, t.title = this.options.messages.views[a], "day" === t.type ? t.messages = {
                    allDay: this.options.messages.allDay
                } : "agenda" === t.type && (t.messages = {
                    event: this.options.messages.event,
                    date: this.options.messages.date,
                    time: this.options.messages.time
                })), e = $({
                    title: a
                }, t, n ? e : {}), a && (this.views[a] = e, this._viewsCount++, i && !e.selected || (i = a));
                i && (this._selectedViewName = i)
            },
            rebind: function() {
                this.dataSource.fetch()
            },
            _dataSource: function() {
                var e = this,
                    t = e.options,
                    i = t.dataSource;
                i = Z(i) ? {
                    data: i
                } : i, !t.timezone || i instanceof qe ? i instanceof qe && (t.timezone = i.options.schema ? i.options.schema.timezone : "") : i = $(!0, i, {
                    schema: {
                        timezone: t.timezone
                    }
                }), e.dataSource && e._refreshHandler ? e.dataSource.unbind(oe, e._refreshHandler).unbind(se, e._progressHandler).unbind(le, e._errorHandler) : (e._refreshHandler = X(e.refresh, e), e._progressHandler = X(e._requestStart, e), e._errorHandler = X(e._error, e)), e.dataSource = I.data.SchedulerDataSource.create(i).bind(oe, e._refreshHandler).bind(se, e._progressHandler).bind(le, e._errorHandler), e.options.dataSource = e.dataSource
            },
            _error: function() {
                this._progress(!1)
            },
            _requestStart: function() {
                this._progress(!0)
            },
            _progress: function(e) {
                var t = this.element.find(".k-scheduler-content");
                I.ui.progress(t, e)
            },
            _resources: function() {
                var t, i, n, a, r, o = this,
                    s = o.options.resources,
                    l = [];
                for (t = 0; t < s.length; t++) {
                    if (i = s[t], n = i.field, a = i.name || n, r = i.dataSource, !n || !r) throw Error('The "field" and "dataSource" options of the scheduler resource are mandatory.');
                    o.resources.push({
                        field: n,
                        name: a,
                        title: i.title || n,
                        dataTextField: i.dataTextField || "text",
                        dataValueField: i.dataValueField || "value",
                        dataColorField: i.dataColorField || "color",
                        valuePrimitive: null == i.valuePrimitive || i.valuePrimitive,
                        multiple: i.multiple || !1,
                        dataSource: o._resourceDataSource(r, a, l)
                    })
                }
                o.options.autoBind ? e.when.apply(null, l).then(function() {
                    o.view(o._selectedViewName)
                }) : o._selectView(o._selectedViewName)
            },
            _resourceDataSource: function(e, t, i) {
                var n = this,
                    a = Z(e) ? {
                        data: e
                    } : e,
                    r = I.data.DataSource.create(a);
                return n.options.autoBind ? i.push(r.fetch(function() {
                    n._bindResourceEvents(this, t)
                })) : n._bindResourceEvents(r, t), r
            },
            _bindResourceEvents: function(e, t) {
                var i = this,
                    n = i.options.group && i.options.group.resources.length,
                    a = n && i.options.group.resources.indexOf(t) > -1;
                !i._resourceRefreshHandler && a && (i._resourceRefreshHandler = X(i._refreshResource, i), i._resourceErrorHandler = X(i._error, i)), a && e.bind(oe, i._resourceRefreshHandler).bind(le, i._resourceErrorHandler)
            },
            _refreshResource: function() {
                var e = this,
                    t = e._editor.editable || e._preventRefresh;
                t || e.view(e._selectedViewName)
            },
            _initModel: function() {
                var e = this;
                e._model = I.observable({
                    selectedDate: new Date(this.options.date),
                    formattedDate: "",
                    formattedShortDate: ""
                }), e._model.bind("change", function(t) {
                    "selectedDate" === t.field && e.view(e._selectedViewName)
                })
            },
            _wrapper: function() {
                var e = this,
                    t = e.options,
                    i = t.height,
                    n = t.width;
                e.wrapper = e.element.addClass("k-widget k-scheduler k-floatwrap").attr("role", "grid").attr("aria-multiselectable", !0), e._isMobile() && e.wrapper.addClass("k-scheduler-mobile"), i && e.wrapper.height(i), n && e.wrapper.width(n)
            },
            date: function(e) {
                return null != e && H(e) >= H(this.options.min) && H(e) <= H(this.options.max) && this._model.set("selectedDate", e), H(this._model.get("selectedDate"))
            },
            _toolbar: function() {
                var i, n, a = this,
                    r = a.options,
                    o = [];
                r.toolbar && (o = e.isArray(r.toolbar) ? r.toolbar : [r.toolbar]), i = this._isMobile() ? Ve : Me, n = e(i({
                    messages: r.messages,
                    pdf: e.grep(o, function(e) {
                        return "pdf" == e || "pdf" == e.name
                    }).length > 0,
                    ns: I.ns,
                    view: a._selectedViewName,
                    views: a.views,
                    viewsCount: a._viewsCount,
                    editable: a.options.editable
                })), a.wrapper.append(n), a.toolbar = n, I.bind(a.toolbar, a._model), n.on(ee + G, ".k-pdf", function(e) {
                    e.preventDefault(), a.saveAsPDF()
                }), n.on(ee + G, ".k-create-event", function(e) {
                    e.preventDefault(), a.addEvent()
                }), n.on(ee + G, ".k-nav-calendar", function(e) {
                    e.preventDefault(), a._showCalendar(e.target)
                }), n.on(ee + G, ".k-scheduler-navigation li", function(i) {
                    var n, r = e(this),
                        o = new Date(a.date()),
                        s = "",
                        l = new Date,
                        d = a.options.timezone;
                    if (i.preventDefault(), r.hasClass("k-nav-today")) s = "today", d ? (n = I.timezone.offset(l, d), o = I.timezone.convert(l, l.getTimezoneOffset(), n)) : o = l;
                    else if (r.hasClass("k-nav-next")) s = "next", o = a.view().nextDate();
                    else if (r.hasClass("k-nav-prev")) s = "previous", o = a.view().previousDate();
                    else if (r.hasClass("k-nav-current") && !a._isMobile()) return a._showCalendar(), t;
                    a.trigger("navigate", {
                        view: a._selectedViewName,
                        action: s,
                        date: o
                    }) || a.date(o)
                }), n.on(ee + G, ".k-scheduler-views li:not(.k-current-view), .k-scheduler-refresh", function(t) {
                    t.preventDefault();
                    var i = e(this).attr(I.attr("name"));
                    a.trigger("navigate", {
                        view: i,
                        action: "changeView",
                        date: a.date()
                    }) || (a.view(i), a.element.find("." + me).removeClass(me))
                }), n.on(ee + G, ".k-scheduler-views li.k-current-view", function(t) {
                    t.preventDefault(), a.element.find(".k-scheduler-views").toggleClass(me), e(document).on(te + G, function(t) {
                        0 === e(t.target).closest(".k-scheduler-views").length && (a.element.find("." + me).removeClass(me), e(document).off(ee + G))
                    })
                }), n.find(".k-scheduler-mobile-views").on("change", function(e) {
                    a.view(e.target.value)
                }), n.find("li").hover(function() {
                    e(this).addClass("k-state-hover")
                }, function() {
                    e(this).removeClass("k-state-hover")
                })
            },
            _showCalendar: function(t) {
                var i = this,
                    n = t || i.toolbar.find(".k-nav-current"),
                    a = e('<div class="k-calendar-container"><div class="k-scheduler-calendar"/></div>');
                i.popup || (i.popup = new q(a, {
                    anchor: n,
                    activate: function() {
                        i.popup && i.calendar && (i.popup._toggleResize(!1), i.calendar.element.find("table").focus(), i.popup._toggleResize(!0))
                    },
                    open: function() {
                        i.calendar || (i.calendar = new Y(this.element.find(".k-scheduler-calendar"), {
                            change: function() {
                                var e = this.value();
                                i.trigger("navigate", {
                                    view: i._selectedViewName,
                                    action: "changeDate",
                                    date: e
                                }) || (i.date(e), i.popup.close()), i._isMobile || (i._selectedView.element.focus(), i.toolbar.find(".k-nav-current").focus().addClass(ve))
                            },
                            min: i.options.min,
                            max: i.options.max
                        })), i.calendar.element.on("keydown" + G, function(e) {
                            e.keyCode !== F.ESC && e.keyCode !== F.TAB || (i.popup.close(), i._selectedView.element.focus(), i.toolbar.find(".k-nav-current").focus().addClass(ve))
                        }), i.calendar.value(i.date())
                    },
                    copyAnchorStyles: !1
                })), i.popup.open()
            },
            refresh: function(e) {
                var i = this,
                    n = this.view(),
                    a = e && "itemchange" === e.action && (this._editor.editable || this._preventRefresh) || "signalr" === this.dataSource.options.type && this._preventRefresh;
                if (this._progress(!1), this.angular("cleanup", function() {
                        return {
                            elements: i.items()
                        }
                    }), e = e || {}, n) return a ? (this._attemptRefresh = "signalr" === this.dataSource.options.type, t) : (this.trigger("dataBinding", {
                    action: e.action || "rebind",
                    index: e.index,
                    items: e.items
                }) || (e && "resize" === e.action || !this._editor || this._editor.close(), this._data = this.dataSource.expand(n.startDate(), n.visibleEndDate()), n.refreshLayout(), n.render(this._data), this.trigger("dataBound"), this._attemptRefresh = !1), t)
            },
            slotByPosition: function(e, t) {
                var i, n = this.view();
                return n._slotByPosition ? (i = n._slotByPosition(e, t), i ? {
                    startDate: i.startDate(),
                    endDate: i.endDate(),
                    groupIndex: i.groupIndex,
                    element: i.element,
                    isDaySlot: i.isDaySlot
                } : null) : null
            },
            slotByElement: function(t) {
                var i = e(t).offset();
                return this.slotByPosition(i.left, i.top)
            },
            resourcesBySlot: function(e) {
                return this.view()._resourceBySlot(e)
            }
        }), E = {
            day: {
                type: "kendo.ui.DayView"
            },
            week: {
                type: "kendo.ui.WeekView"
            },
            workWeek: {
                type: "kendo.ui.WorkWeekView"
            },
            agenda: {
                type: "kendo.ui.AgendaView"
            },
            month: {
                type: "kendo.ui.MonthView"
            },
            timeline: {
                type: "kendo.ui.TimelineView"
            },
            timelineWeek: {
                type: "kendo.ui.TimelineWeekView"
            },
            timelineWorkWeek: {
                type: "kendo.ui.TimelineWorkWeekView"
            },
            timelineMonth: {
                type: "kendo.ui.TimelineMonthView"
            }
        }, N.plugin(x), I.PDFMixin && (I.PDFMixin.extend(x.prototype), C = "k-scheduler-pdf-export", x.fn._drawPDF = function(t) {
            var i, n, a, r = this.wrapper,
                o = r[0].style.cssText;
            return r.css({
                width: r.width(),
                height: r.height()
            }), r.addClass(C), i = this, n = new e.Deferred, a = r.find(".k-scheduler-content").find("table").css("table-layout", "auto"), setTimeout(function() {
                a.css("table-layout", "fixed"), i.resize(!0), i._drawPDFShadow({}, {
                    avoidLinks: i.options.pdf.avoidLinks
                }).done(function(e) {
                    var i = {
                        page: e,
                        pageNumber: 1,
                        progress: 1,
                        totalPages: 1
                    };
                    t.notify(i), n.resolve(i.page)
                }).fail(function(e) {
                    n.reject(e)
                }).always(function() {
                    r[0].style.cssText = o, r.removeClass(C), i.resize(!0), i.resize(!0)
                })
            }), n
        }), R = L.extend({
            init: function(e, t) {
                var i = this,
                    n = I.timezone.windows_zones;
                if (!n || !I.timezone.zones_titles) throw Error("kendo.timezones.min.js is not included.");
                L.fn.init.call(i, e, t), i.wrapper = i.element, i._zonesQuery = new I.data.Query(n), i._zoneTitleId = I.guid(), i._zoneTitlePicker(), i._zonePicker(), i._zoneTitle.bind("cascade", function() {
                    this.value() || i._zone.wrapper.hide()
                }), i._zone.bind("cascade", function() {
                    i._value = this.value(), i.trigger("change")
                }), i.value(i.options.value)
            },
            options: {
                name: "TimezoneEditor",
                value: "",
                optionLabel: "No timezone"
            },
            events: ["change"],
            _zoneTitlePicker: function() {
                var t = this,
                    i = e('<input id="' + t._zoneTitleId + '" aria-label="' + t.options.title + '"/>').appendTo(t.wrapper);
                t._zoneTitle = new I.ui.DropDownList(i, {
                    dataSource: I.timezone.zones_titles,
                    dataValueField: "other_zone",
                    dataTextField: "name",
                    optionLabel: t.options.optionLabel
                })
            },
            _zonePicker: function() {
                var t = this,
                    i = e('<input aria-label="' + t.options.title + '"/>').appendTo(this.wrapper);
                t._zone = new I.ui.DropDownList(i, {
                    dataValueField: "zone",
                    dataTextField: "territory",
                    dataSource: t._zonesQuery.data,
                    cascadeFrom: t._zoneTitleId,
                    dataBound: function() {
                        t._value = this.value(), this.wrapper.toggle(this.dataSource.view().length > 1)
                    }
                }), t._zone.wrapper.hide()
            },
            destroy: function() {
                L.fn.destroy.call(this), I.destroy(this.wrapper)
            },
            value: function(e) {
                var i, n = this;
                return e === t ? n._value : (i = n._zonesQuery.filter({
                    field: "zone",
                    operator: "eq",
                    value: e
                }).data[0], i ? (n._zoneTitle.value(i.other_zone), n._zone.value(i.zone)) : n._zoneTitle.select(0), t)
            }
        }), N.plugin(R), P = I.template('<option value="#=other_zone#">#=name#</option>'), M = I.template('<option value="#=zone#">#=territory#</option>'), V = L.extend({
            init: function(e, t) {
                var i = this,
                    n = I.timezone.windows_zones;
                if (!n || !I.timezone.zones_titles) throw Error("kendo.timezones.min.js is not included.");
                L.fn.init.call(i, e, t), i.wrapper = i.element, i._zonesQuery = new I.data.Query(n), i._zoneTitlePicker(), i._zonePicker(), i.value(i.options.value)
            },
            options: {
                name: "MobileTimezoneEditor",
                optionLabel: "No timezone",
                value: ""
            },
            events: ["change"],
            _bindZones: function(e) {
                var t = e ? this._filter(e) : [];
                this._zone.html(this._options(t, M))
            },
            _filter: function(e) {
                return this._zonesQuery.filter({
                    field: "other_zone",
                    operator: "eq",
                    value: e
                }).data
            },
            _options: function(e, t, i) {
                var n = 0,
                    a = "",
                    r = e.length;
                for (i && (a += t({
                        other_zone: "",
                        name: i
                    })); n < r; n++) a += t(e[n]);
                return a
            },
            _zoneTitlePicker: function() {
                var t = this,
                    i = t._options(I.timezone.zones_titles, P, t.options.optionLabel);
                t._zoneTitle = e("<select>" + i + "</select>").appendTo(t.wrapper).change(function() {
                    var e = this.value,
                        i = t._zonePickerLabel,
                        n = i.find("select");
                    t._bindZones(e), e && n.children().length > 1 ? i.show() : i.hide(), t._value = t._zone[0].value, t.trigger("change")
                })
            },
            _zonePicker: function() {
                var t = this;
                t._zonePickerLabel = e("<li class='k-item k-listgroup-item k-zonepicker' style='display:none'><label class='k-label k-listgroup-form-row'><span class='k-item-title k-listgroup-form-field-label'></span><div class='k-listgroup-form-field-wrapper'></div></label></li>"), t._zone = e("<select></select>").appendTo(t._zonePickerLabel.find("div")).change(function() {
                    t._value = this.value, t.trigger("change")
                }), this.wrapper.closest(".k-item").after(t._zonePickerLabel), t._bindZones(t._zoneTitle.val()), t._value = t._zone[0].value
            },
            destroy: function() {
                L.fn.destroy.call(this), I.destroy(this.wrapper)
            },
            value: function(e) {
                var i, n = this,
                    a = n._zone,
                    r = "",
                    o = "";
                return e === t ? n._value : (i = n._zonesQuery.filter({
                    field: "zone",
                    operator: "eq",
                    value: e
                }).data[0], i && (o = i.zone, r = i.other_zone), n._zoneTitle.val(r), n._bindZones(r), a.val(o), o = a[0].value, o && a.children.length > 1 ? n._zonePickerLabel.show() : n._zonePickerLabel.hide(), n._value = o, t)
            }
        }), N.plugin(V)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, i) {
    (i || t)()
});;
! function(t, define) {
    define("kendo.tooltip.min", ["kendo.core.min", "kendo.popup.min", "kendo.fx.min"], t)
}(function() {
    return function(t, o) {
        function e(t) {
            for (; t.length && !n(t);) t = t.parent()
        }

        function n(t) {
            var o = t.data(r.ns + "title");
            if (o) return t.attr("title", o), t.removeData(r.ns + "title"), !0
        }

        function i(t) {
            var o = t.attr("title");
            if (o) return t.data(r.ns + "title", o), t.attr("title", ""), !0
        }

        function s(t) {
            for (; t.length && !t.is("body") && !i(t);) t = t.parent()
        }
        var r = window.kendo,
            u = r.ui.Widget,
            p = r.ui.Popup,
            c = r.isFunction,
            l = t.isPlainObject,
            a = t.extend,
            h = t.proxy,
            f = t(document),
            d = r.isLocalUrl,
            m = "_tt_active",
            w = "aria-describedby",
            _ = "show",
            g = "hide",
            v = "error",
            k = "contentLoad",
            y = "requestStart",
            O = "k-content-frame",
            b = '<div role="tooltip" class="k-widget k-tooltip#if (!autoHide) {# k-tooltip-closable#}#">#if (!autoHide) {# <div class="k-tooltip-button"><a href="\\#" class="k-icon k-i-close" title="Close"></a></div> #}#<div class="k-tooltip-content"></div>#if (callout){ #<div class="k-callout k-callout-#=dir#"></div>#}#</div>',
            C = r.template("<iframe frameborder='0' class='" + O + "' src='#= content.url #'>This page requires frames in order to show content</iframe>"),
            S = ".kendoTooltip",
            T = {
                bottom: {
                    origin: "bottom center",
                    position: "top center"
                },
                top: {
                    origin: "top center",
                    position: "bottom center"
                },
                left: {
                    origin: "center left",
                    position: "center right",
                    collision: "fit flip"
                },
                right: {
                    origin: "center right",
                    position: "center left",
                    collision: "fit flip"
                },
                center: {
                    position: "center center",
                    origin: "center center"
                }
            },
            H = {
                top: "bottom",
                bottom: "top",
                left: "right",
                right: "left",
                center: "center"
            },
            x = {
                bottom: "n",
                top: "s",
                left: "e",
                right: "w",
                center: "n"
            },
            A = {
                horizontal: {
                    offset: "top",
                    size: "outerHeight"
                },
                vertical: {
                    offset: "left",
                    size: "outerWidth"
                }
            },
            D = function(t) {
                return t.target.data(r.ns + "title")
            },
            E = u.extend({
                init: function(t, o) {
                    var e, n = this;
                    u.fn.init.call(n, t, o), e = n.options.position.match(/left|right/) ? "horizontal" : "vertical", n.dimensions = A[e], n._documentKeyDownHandler = h(n._documentKeyDown, n), n.element.on(n.options.showOn + S, n.options.filter, h(n._showOn, n)), (this._isShownOnMouseEnter() || this._isShownOnClick()) && n.element.on("mouseenter" + S, n.options.filter, h(n._mouseenter, n)), this.options.autoHide && this._isShownOnMouseEnter() && n.element.on("mouseleave" + S, n.options.filter, h(n._mouseleave, n)), this.options.autoHide && this._isShownOnFocus() && n.element.on("blur" + S, n.options.filter, h(n._blur, n))
                },
                options: {
                    name: "Tooltip",
                    filter: "",
                    content: D,
                    showAfter: 100,
                    hideAfter: 100,
                    callout: !0,
                    offset: 0,
                    position: "bottom",
                    showOn: "mouseenter",
                    autoHide: !0,
                    width: null,
                    height: null,
                    animation: {
                        open: {
                            effects: "fade:in",
                            duration: 0
                        },
                        close: {
                            duration: 40,
                            hide: !0
                        }
                    }
                },
                events: [_, g, k, v, y],
                _isShownOnFocus: function() {
                    return this.options.showOn && this.options.showOn.match(/focus/)
                },
                _isShownOnMouseEnter: function() {
                    return this.options.showOn && this.options.showOn.match(/mouseenter/)
                },
                _isShownOnClick: function() {
                    return this.options.showOn && this.options.showOn.match(/click/)
                },
                _mouseenter: function(o) {
                    s(t(o.currentTarget))
                },
                _showOn: function(o) {
                    var e = this,
                        n = t(o.currentTarget);
                    e._isShownOnClick() && !e._isShownOnMouseEnter() ? e._show(n) : e._isShownOnFocus() ? (s(n), e._show(n)) : (clearTimeout(e.timeout), e.timeout = setTimeout(function() {
                        e._show(n)
                    }, e.options.showAfter))
                },
                _appendContent: function(t) {
                    var o, e = this,
                        n = e.options.content,
                        i = e.content,
                        s = e.options.iframe;
                    l(n) && n.url ? ("iframe" in e.options || (s = !d(n.url)), e.trigger(y, {
                        options: n,
                        target: t
                    }), s ? (i.hide(), o = i.find("." + O)[0], o ? o.src = n.url || o.src : i.html(C({
                        content: n
                    })), i.find("." + O).off("load" + S).on("load" + S, function() {
                        e.trigger(k), i.show()
                    })) : (i.empty(), r.ui.progress(i, !0), e._ajaxRequest(n))) : n && c(n) ? (n = n({
                        sender: this,
                        target: t
                    }), i.html(n || "")) : i.html(n), e.angular("compile", function() {
                        return {
                            elements: i
                        }
                    })
                },
                _ajaxRequest: function(t) {
                    var o = this;
                    jQuery.ajax(a({
                        type: "GET",
                        dataType: "html",
                        cache: !1,
                        error: function(t, e) {
                            r.ui.progress(o.content, !1), o.trigger(v, {
                                status: e,
                                xhr: t
                            })
                        },
                        success: h(function(t) {
                            r.ui.progress(o.content, !1), o.content.html(t), o.trigger(k)
                        }, o)
                    }, t))
                },
                _documentKeyDown: function(t) {
                    t.keyCode === r.keys.ESC && this.hide()
                },
                refresh: function() {
                    var t = this,
                        o = t.popup;
                    o && o.options.anchor && t._appendContent(o.options.anchor)
                },
                hide: function() {
                    this.popup && this.popup.close()
                },
                show: function(t) {
                    t = t || this.element, s(t), this._show(t)
                },
                _show: function(t) {
                    var o = this,
                        n = o.target();
                    o.popup || o._initPopup(), n && n[0] != t[0] && (o.popup.close(), o.popup.element.kendoStop(!0, !0)), n && n[0] == t[0] || (o._appendContent(t), o.popup.options.anchor = t), o.popup.one("deactivate", function() {
                        e(t), t.removeAttr(w), this.element.removeAttr("id").attr("aria-hidden", !0), f.off("keydown" + S, o._documentKeyDownHandler)
                    }), o.popup._hovered = !0, o.popup.open()
                },
                _initPopup: function() {
                    var e = this,
                        n = e.options,
                        i = t(r.template(b)({
                            callout: n.callout && "center" !== n.position,
                            dir: x[n.position],
                            autoHide: n.autoHide
                        }));
                    e.popup = new p(i, a({
                        autosize: !0,
                        activate: function() {
                            var t = this.options.anchor,
                                i = t[0].id || e.element[0].id;
                            i && (t.attr(w, i + m), this.element.attr("id", i + m)), n.callout ? e._positionCallout() : e._offset(e.options.position, e.options.offset), this.element.removeAttr("aria-hidden"), f.on("keydown" + S, e._documentKeyDownHandler), e.trigger(_), e.popup._hovered = o
                        },
                        close: function() {
                            e.trigger(g)
                        },
                        copyAnchorStyles: !1,
                        animation: n.animation
                    }, T[n.position])), i.css({
                        width: n.width,
                        height: n.height
                    }), e.content = i.find(".k-tooltip-content"), e.arrow = i.find(".k-callout"), n.autoHide && this._isShownOnMouseEnter() ? i.on("mouseleave" + S, h(e._mouseleave, e)) : i.on("click" + S, ".k-tooltip-button", h(e._closeButtonClick, e))
                },
                _closeButtonClick: function(t) {
                    t.preventDefault(), this.hide()
                },
                _mouseleave: function(t) {
                    var o = this;
                    clearTimeout(o.timeout), o.timeout = setTimeout(function() {
                        o._closePopup(t.currentTarget)
                    }, o.options.hideAfter)
                },
                _blur: function(t) {
                    this._closePopup(t.currentTarget)
                },
                _closePopup: function(o) {
                    this.popup && !this.popup._hovered ? this.popup.close() : e(t(o))
                },
                target: function() {
                    return this.popup ? this.popup.options.anchor : null
                },
                _positionCallout: function() {
                    var o = this,
                        e = o.options.position,
                        n = o.dimensions,
                        i = n.offset,
                        s = o.popup,
                        r = s.options.anchor,
                        u = t(r).offset(),
                        p = t(s.element).offset(),
                        c = x[s.flipped ? H[e] : e],
                        l = u[i] - p[i] + t(r)[n.size]() / 2;
                    o._offset(e, o.options.offset), o.arrow.removeClass("k-callout-n k-callout-s k-callout-w k-callout-e").addClass("k-callout-" + c).css(i, l)
                },
                destroy: function() {
                    var t = this.popup;
                    t && (t.element.off(S), t.destroy()), clearTimeout(this.timeout), this.element.off(S), f.off("keydown" + S, this._documentKeyDownHandler), u.fn.destroy.call(this)
                },
                _offset: function(t, o) {
                    var e = this,
                        n = "top" == t || "left" == t,
                        i = e.popup.flipped,
                        s = n && i || !n && !i ? 1 : -1,
                        u = n ? "margin-" + t : "margin-" + H[t],
                        p = r._outerWidth(e.arrow) / 2 + o;
                    e.popup.wrapper.css(u, p * s + "px")
                }
            });
        r.ui.plugin(E)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, o, e) {
    (e || o)()
});;
! function(t, define) {
    define("kendo.treeview.draganddrop.min", ["kendo.data.min", "kendo.draganddrop.min"], t)
}(function() {
    return function(t, i) {
        var e = window.kendo,
            o = e.ui,
            s = t.proxy,
            n = t.extend,
            r = "visibility",
            a = "k-state-hover",
            d = "input,a:not(.k-in),textarea,.k-multiselect-wrap,select,button,a.k-button>.k-icon,button.k-button>.k-icon,span.k-icon.k-i-arrow-60-right,span.k-icon.k-i-arrow-45-down-right";
        o.HierarchicalDragAndDrop = e.Class.extend({
            init: function(i, r) {
                this.element = i, this.hovered = i, this.options = n({
                    dragstart: t.noop,
                    drag: t.noop,
                    drop: t.noop,
                    dragend: t.noop
                }, r), this._draggable = new o.Draggable(i, {
                    ignore: d,
                    filter: r.filter,
                    autoScroll: r.autoScroll,
                    cursorOffset: {
                        left: 10,
                        top: e.support.mobileOS ? -40 / e.support.zoomLevel() : 10
                    },
                    hint: s(this._hint, this),
                    dragstart: s(this.dragstart, this),
                    dragcancel: s(this.dragcancel, this),
                    drag: s(this.drag, this),
                    dragend: s(this.dragend, this),
                    $angular: r.$angular
                })
            },
            _hint: function(t) {
                return "<div class='k-header k-drag-clue'><span class='k-icon k-drag-status' />" + this.options.hintText(t) + "</div>"
            },
            _removeTouchHover: function() {
                e.support.touch && this.hovered && (this.hovered.find("." + a).removeClass(a), this.hovered = !1)
            },
            _hintStatus: function(e) {
                var o = this._draggable.hint.find(".k-drag-status")[0];
                return e ? (o.className = "k-icon k-drag-status " + e, i) : t.trim(o.className.replace(/(p|k)-(icon|drag-status)/g, ""))
            },
            dragstart: function(i) {
                this.source = i.currentTarget.closest(this.options.itemSelector), this.options.dragstart(this.source) && i.preventDefault(), this.dropHint = this.options.reorderable ? t("<div class='k-icon k-i-drag-and-drop' />").css(r, "hidden").appendTo(this.element) : t()
            },
            drag: function(i) {
                var o, s, n, d, h, l, c, p, g, u, v, k = this.options,
                    f = this.source,
                    m = this.dropTarget = t(e.eventTarget(i)),
                    _ = m.closest(k.allowedContainers);
                _.length ? f[0] == m[0] || k.contains(f[0], m[0]) ? v = "k-i-cancel" : (v = "k-i-insert-middle", g = k.itemFromTarget(m), o = g.item, o.length ? (this._removeTouchHover(), s = e._outerHeight(o), d = g.content, k.reorderable ? (h = s / (d.length > 0 ? 4 : 2), n = e.getOffset(o).top, l = i.y.location < n + h, c = n + s - h < i.y.location, p = d.length && !l && !c) : (p = !0, l = !1, c = !1), this.hovered = !!p && _, this.dropHint.css(r, p ? "hidden" : "visible"), this._lastHover && this._lastHover[0] != d[0] && this._lastHover.removeClass(a), this._lastHover = d.toggleClass(a, p), p ? v = "k-i-plus" : (u = o.position(), u.top += l ? 0 : s, this.dropHint.css(u)[l ? "prependTo" : "appendTo"](k.dropHintContainer(o)), l && g.first && (v = "k-i-insert-up"), c && g.last && (v = "k-i-insert-down"))) : m[0] != this.dropHint[0] && (this._lastHover && this._lastHover.removeClass(a), v = t.contains(this.element[0], _[0]) ? "k-i-cancel" : "k-i-plus")) : (v = "k-i-cancel", this._removeTouchHover()), this.options.drag({
                    originalEvent: i.originalEvent,
                    source: f,
                    target: m,
                    pageY: i.y.location,
                    pageX: i.x.location,
                    status: v.substring(2),
                    setStatus: function(t) {
                        v = t
                    }
                }), 0 !== v.indexOf("k-i-insert") && this.dropHint.css(r, "hidden"), this._hintStatus(v)
            },
            dragcancel: function() {
                this.dropHint.remove()
            },
            dragend: function(t) {
                var e, o, s, n = "over",
                    d = this.source,
                    h = this.dropHint,
                    l = this.dropTarget;
                return "visible" == h.css(r) ? (n = this.options.dropPositionFrom(h), e = h.closest(this.options.itemSelector)) : l && (e = l.closest(this.options.itemSelector), e.length || (e = l.closest(this.options.allowedContainers))), o = {
                    originalEvent: t.originalEvent,
                    source: d[0],
                    destination: e[0],
                    valid: "k-i-cancel" != this._hintStatus(),
                    setValid: function(t) {
                        this.valid = t
                    },
                    dropTarget: l[0],
                    position: n
                }, s = this.options.drop(o), h.remove(), this._removeTouchHover(), this._lastHover && this._lastHover.removeClass(a), !o.valid || s ? (this._draggable.dropped = o.valid, i) : (this._draggable.dropped = !0, this.options.dragend({
                    originalEvent: t.originalEvent,
                    source: d,
                    destination: e,
                    position: n
                }), i)
            },
            destroy: function() {
                this._lastHover = this.hovered = null, this._draggable.destroy()
            }
        })
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, i, e) {
    (e || i)()
});;
! function(e, define) {
    define("kendo.treeview.min", ["kendo.data.min", "kendo.treeview.draganddrop.min"], e)
}(function() {
    return function(e, t) {
        function n(e) {
            return function(t) {
                var n = t.children(".k-animation-container");
                return n.length || (n = t), n.children(e)
            }
        }

        function i(e) {
            return p.template(e, {
                useWithBlock: !1
            })
        }

        function a(e) {
            return e.find(".k-checkbox-wrapper:first input[type=checkbox]")
        }

        function r(e) {
            return function(t, n) {
                n = n.closest(G);
                var i, a = n.parent();
                return a.parent().is("li") && (i = a.parent()), this._dataSourceMove(t, a, i, function(t, i) {
                    var a = this.dataItem(n),
                        r = a ? a.parent().indexOf(a) : n.index();
                    return this._insert(t.data(), i, r + e)
                })
            }
        }

        function s(t, n) {
            for (var i; t && "ul" != t.nodeName.toLowerCase();) i = t, t = t.nextSibling, 3 == i.nodeType && (i.nodeValue = e.trim(i.nodeValue)), u.test(i.className) ? n.insertBefore(i, n.firstChild) : n.appendChild(i)
        }

        function o(t) {
            var n = t.children("div"),
                i = t.children("ul"),
                a = n.children(".k-icon"),
                r = t.children("input[type=checkbox]"),
                o = n.children(".k-in");
            t.hasClass("k-treeview") || (n.length || (n = e("<div />").prependTo(t)), !a.length && i.length ? a = e("<span class='k-icon' />").prependTo(n) : i.length && i.children().length || (a.remove(), i.remove()), r.length && e("<span class='k-checkbox-wrapper' />").appendTo(n).append(r), o.length || (o = t.children("a").eq(0).addClass("k-in k-link"), o.length || (o = e("<span class='k-in' />")), o.appendTo(n), n.length && s(n[0].nextSibling, o[0])))
        }
        var d, l, c, h, u, p = window.kendo,
            f = p.ui,
            g = p.data,
            m = e.extend,
            k = p.template,
            v = e.isArray,
            _ = f.Widget,
            x = g.HierarchicalDataSource,
            b = e.proxy,
            C = p.keys,
            w = ".kendoTreeView",
            y = ".kendoTreeViewTemp",
            S = "select",
            N = "check",
            T = "navigate",
            I = "expand",
            D = "change",
            B = "error",
            A = "checked",
            O = "indeterminate",
            U = "collapse",
            E = "dragstart",
            L = "drag",
            H = "drop",
            V = "dragend",
            q = "dataBound",
            F = "click",
            j = "undefined",
            R = "k-state-hover",
            P = "k-treeview",
            M = ":visible",
            G = ".k-item",
            Q = "string",
            W = "aria-checked",
            J = "aria-selected",
            X = "aria-disabled",
            Y = "k-state-disabled",
            $ = {
                text: "dataTextField",
                url: "dataUrlField",
                spriteCssClass: "dataSpriteCssClassField",
                imageUrl: "dataImageUrlField"
            },
            z = function(e) {
                return e instanceof p.jQuery || window.jQuery && e instanceof window.jQuery
            },
            K = function(e) {
                return "object" == typeof HTMLElement ? e instanceof HTMLElement : e && "object" == typeof e && 1 === e.nodeType && typeof e.nodeName === Q
            };
        l = n(".k-group"), c = n(".k-group,.k-content"), h = function(e) {
            return e.children("div").children(".k-icon")
        }, u = /k-sprite/, d = p.ui.DataBoundWidget.extend({
            init: function(e, t) {
                var n, i = this,
                    a = !1,
                    r = t && !!t.dataSource;
                v(t) && (t = {
                    dataSource: t
                }), t && typeof t.loadOnDemand == j && v(t.dataSource) && (t.loadOnDemand = !1), _.prototype.init.call(i, e, t), e = i.element, t = i.options, i._dataSourceUids = {}, n = e.is("ul") && e || e.hasClass(P) && e.children("ul"), a = !r && n.length, a && (t.dataSource.list = n), i._animation(), i._accessors(), i._templates(), e.hasClass(P) ? (i.wrapper = e, i.root = e.children("ul").eq(0)) : (i._wrapper(), n && (i.root = e, i._group(i.wrapper))), i._tabindex(), i.wrapper.attr("role", "tree"), i._dataSource(a), i._attachEvents(), i._dragging(), a ? i._syncHtmlAndDataSource() : t.autoBind && (i._progress(!0), i.dataSource.fetch()), t.checkboxes && t.checkboxes.checkChildren && i.updateIndeterminate(), i.element[0].id && (i._ariaId = p.format("{0}_tv_active", i.element[0].id)), p.notify(i)
            },
            _attachEvents: function() {
                var t = this,
                    n = ".k-in:not(.k-state-selected,.k-state-disabled)",
                    i = "mouseenter";
                t.wrapper.on(i + w, ".k-in.k-state-selected", function(e) {
                    e.preventDefault()
                }).on(i + w, n, function() {
                    e(this).addClass(R)
                }).on("mouseleave" + w, n, function() {
                    e(this).removeClass(R)
                }).on(F + w, n, b(t._click, t)).on("dblclick" + w, ".k-in:not(.k-state-disabled)", b(t._toggleButtonClick, t)).on(F + w, ".k-i-expand,.k-i-collapse", b(t._toggleButtonClick, t)).on("keydown" + w, b(t._keydown, t)).on("keypress" + w, b(t._keypress, t)).on("focus" + w, b(t._focus, t)).on("blur" + w, b(t._blur, t)).on("mousedown" + w, ".k-in,.k-checkbox-wrapper :checkbox,.k-i-expand,.k-i-collapse", b(t._mousedown, t)).on("change" + w, ".k-checkbox-wrapper :checkbox", b(t._checkboxChange, t)).on("click" + w, ".checkbox-span", b(t._checkboxLabelClick, t)).on("click" + w, ".k-request-retry", b(t._retryRequest, t)).on("click" + w, ".k-link.k-state-disabled", function(e) {
                    e.preventDefault()
                }).on("click" + w, function(n) {
                    var i = e(n.target);
                    i.is(":kendoFocusable") || i.find("input,select,textarea,button,object").is(":kendoFocusable") || t.focus()
                })
            },
            _checkboxLabelClick: function(t) {
                var n = e(t.target.previousSibling);
                n.is("[disabled]") || (n.prop("checked", !n.prop("checked")), n.trigger("change"))
            },
            _syncHtmlAndDataSource: function(e, t) {
                e = e || this.root, t = t || this.dataSource;
                var n, i, r, s, o, d = t.view(),
                    l = p.attr("uid"),
                    c = p.attr("expanded"),
                    h = this.options.checkboxes,
                    u = e.children("li");
                for (n = 0; n < u.length; n++) r = d[n], s = r.uid, i = u.eq(n), i.attr("role", "treeitem").attr(l, s).attr(J, i.hasClass("k-state-selected")), r.expanded = "true" === i.attr(c), h && (o = a(i), r.checked = o.prop(A), o.attr("id", "_" + s), o.next(".k-checkbox-label").attr("for", "_" + s)), this._syncHtmlAndDataSource(i.children("ul"), r.children)
            },
            _animation: function() {
                var e = this.options,
                    t = e.animation,
                    n = t.collapse && "effects" in t.collapse,
                    i = m({}, t.expand, t.collapse);
                n || (i = m(i, {
                    reverse: !0
                })), t === !1 && (t = {
                    expand: {
                        effects: {}
                    },
                    collapse: {
                        hide: !0,
                        effects: {}
                    }
                }), t.collapse = m(i, {
                    hide: !0
                }), e.animation = t
            },
            _dragging: function() {
                var t, n = this.options.dragAndDrop,
                    i = this.dragging;
                n && !i ? (t = this, this.dragging = new f.HierarchicalDragAndDrop(this.element, {
                    reorderable: !0,
                    $angular: this.options.$angular,
                    autoScroll: this.options.autoScroll,
                    filter: "div:not(.k-state-disabled) .k-in",
                    allowedContainers: ".k-treeview",
                    itemSelector: ".k-treeview .k-item",
                    hintText: b(this._hintText, this),
                    contains: function(t, n) {
                        return e.contains(t, n)
                    },
                    dropHintContainer: function(e) {
                        return e
                    },
                    itemFromTarget: function(e) {
                        var t = e.closest(".k-top,.k-mid,.k-bot");
                        return {
                            item: t,
                            content: e.closest(".k-in"),
                            first: t.hasClass("k-top"),
                            last: t.hasClass("k-bot")
                        }
                    },
                    dropPositionFrom: function(e) {
                        return e.prevAll(".k-in").length > 0 ? "after" : "before"
                    },
                    dragstart: function(e) {
                        return t.trigger(E, {
                            sourceNode: e[0]
                        })
                    },
                    drag: function(e) {
                        t.trigger(L, {
                            originalEvent: e.originalEvent,
                            sourceNode: e.source[0],
                            dropTarget: e.target[0],
                            pageY: e.pageY,
                            pageX: e.pageX,
                            statusClass: e.status,
                            setStatusClass: e.setStatus
                        })
                    },
                    drop: function(n) {
                        var i = e(n.dropTarget),
                            a = i.closest("a");
                        return a && a.attr("href") && t._tempPreventNavigation(a), t.trigger(H, {
                            originalEvent: n.originalEvent,
                            sourceNode: n.source,
                            destinationNode: n.destination,
                            valid: n.valid,
                            setValid: function(e) {
                                this.valid = e, n.setValid(e)
                            },
                            dropTarget: n.dropTarget,
                            dropPosition: n.position
                        })
                    },
                    dragend: function(e) {
                        function n(n) {
                            t.options.checkboxes && t.options.checkboxes.checkChildren && t.updateIndeterminate(), t.trigger(V, {
                                originalEvent: e.originalEvent,
                                sourceNode: n && n[0],
                                destinationNode: a[0],
                                dropPosition: r
                            })
                        }
                        var i = e.source,
                            a = e.destination,
                            r = e.position;
                        "over" == r ? t.append(i, a, n) : ("before" == r ? i = t.insertBefore(i, a) : "after" == r && (i = t.insertAfter(i, a)), n(i))
                    }
                })) : !n && i && (i.destroy(), this.dragging = null)
            },
            _tempPreventNavigation: function(e) {
                e.on(F + w + y, function(t) {
                    t.preventDefault(), e.off(F + w + y)
                })
            },
            _hintText: function(e) {
                return this.templates.dragClue({
                    item: this.dataItem(e),
                    treeview: this.options
                })
            },
            _templates: function() {
                var e = this,
                    t = e.options,
                    n = b(e._fieldAccessor, e);
                t.template && typeof t.template == Q ? t.template = k(t.template) : t.template || (t.template = i("# var text = " + n("text") + "(data.item); ## if (typeof data.item.encoded != 'undefined' && data.item.encoded === false) {##= text ## } else { ##: text ## } #")), e._checkboxes(), e.templates = {
                    setAttributes: function(e) {
                        var t, n = "",
                            i = e.attr || {};
                        for (t in i) i.hasOwnProperty(t) && "class" !== t && (n += t + '="' + i[t] + '" ');
                        return n
                    },
                    wrapperCssClass: function(e, t) {
                        var n = "k-item",
                            i = t.index;
                        return e.firstLevel && 0 === i && (n += " k-first"), i == e.length - 1 && (n += " k-last"), n
                    },
                    cssClass: function(e, t) {
                        var n = "",
                            i = t.index,
                            a = e.length - 1;
                        return e.firstLevel && 0 === i && (n += "k-top "), n += 0 === i && i != a ? "k-top" : i == a ? "k-bot" : "k-mid"
                    },
                    textClass: function(e, t) {
                        var n = "k-in";
                        return t && (n += " k-link"), e.enabled === !1 && (n += " k-state-disabled"), e.selected === !0 && (n += " k-state-selected"), n
                    },
                    toggleButtonClass: function(e) {
                        var t = "k-icon";
                        return t += e.expanded !== !0 ? " k-i-expand" : " k-i-collapse"
                    },
                    groupAttributes: function(e) {
                        var t = "";
                        return e.firstLevel || (t = "role='group'"), t + (e.expanded !== !0 ? " style='display:none'" : "")
                    },
                    groupCssClass: function(e) {
                        var t = "k-group";
                        return e.firstLevel && (t += " k-treeview-lines"), t
                    },
                    dragClue: i("#= data.treeview.template(data) #"),
                    group: i("<ul class='#= data.r.groupCssClass(data.group) #'#= data.r.groupAttributes(data.group) #>#= data.renderItems(data) #</ul>"),
                    itemContent: i("# var imageUrl = " + n("imageUrl") + "(data.item); ## var spriteCssClass = " + n("spriteCssClass") + "(data.item); ## if (imageUrl) { #<img class='k-image' alt='' src='#= imageUrl #'># } ## if (spriteCssClass) { #<span class='k-sprite #= spriteCssClass #' /># } ##= data.treeview.template(data) #"),
                    itemElement: i("# var item = data.item, r = data.r; ## var url = " + n("url") + "(item); #<div class='#= r.cssClass(data.group, item) #'># if (item.hasChildren) { #<span class='#= r.toggleButtonClass(item) #'/># } ## if (data.treeview.checkboxes) { #<span class='k-checkbox-wrapper' role='presentation'>#= data.treeview.checkboxes.template(data) #</span># } ## var tag = url ? 'a' : 'span'; ## var textAttr = url ? ' href=\\'' + url + '\\'' : ''; #<#=tag# class='#= r.textClass(item, !!url) #'#= textAttr #>#= r.itemContent(data) #</#=tag#></div>"),
                    item: i("# var item = data.item, r = data.r; #<li role='treeitem' class='#= r.wrapperCssClass(data.group, item) #'" + p.attr("uid") + '=\'#= item.uid #\' #= r.setAttributes(item.toJSON ? item.toJSON() : item) # # if (data.treeview.checkboxes) { #aria-checked=\'#= item.checked ? "true" : "false" #\' # } #aria-selected=\'#= item.selected ? "true" : "false" #\' #=item.enabled === false ? "aria-disabled=\'true\'" : \'\'#aria-expanded=\'#= item.expanded ? "true" : "false" #\' data-expanded=\'#= item.expanded ? "true" : "false" #\' >#= r.itemElement(data) #</li>'),
                    loading: i("<div class='k-icon k-i-loading' /> #: data.messages.loading #"),
                    retry: i("#: data.messages.requestFailed # <button class='k-button k-request-retry'>#: data.messages.retry #</button>")
                }
            },
            items: function() {
                return this.element.find(".k-item > div:first-child")
            },
            setDataSource: function(t) {
                var n = this.options;
                n.dataSource = t, this._dataSourceUids = {}, this._dataSource(), n.checkboxes && n.checkboxes.checkChildren && this.dataSource.one("change", e.proxy(this.updateIndeterminate, this, null)), this.options.autoBind && this.dataSource.fetch()
            },
            _bindDataSource: function() {
                this._refreshHandler = b(this.refresh, this), this._errorHandler = b(this._error, this), this.dataSource.bind(D, this._refreshHandler), this.dataSource.bind(B, this._errorHandler)
            },
            _unbindDataSource: function() {
                var e = this.dataSource;
                e && (e.unbind(D, this._refreshHandler), e.unbind(B, this._errorHandler))
            },
            _dataSource: function(e) {
                function t(e) {
                    for (var n = 0; n < e.length; n++) e[n]._initChildren(), e[n].children.fetch(), t(e[n].children.view())
                }
                var n = this,
                    i = n.options,
                    a = i.dataSource;
                a = v(a) ? {
                    data: a
                } : a, n._unbindDataSource(), a.fields || (a.fields = [{
                    field: "text"
                }, {
                    field: "url"
                }, {
                    field: "spriteCssClass"
                }, {
                    field: "imageUrl"
                }]), n.dataSource = a = x.create(a), e && (a.fetch(), t(a.view())), n._bindDataSource()
            },
            events: [E, L, H, V, q, I, U, S, D, T, N],
            options: {
                name: "TreeView",
                dataSource: {},
                animation: {
                    expand: {
                        effects: "expand:vertical",
                        duration: 200
                    },
                    collapse: {
                        duration: 100
                    }
                },
                messages: {
                    loading: "Loading...",
                    requestFailed: "Request failed.",
                    retry: "Retry"
                },
                dragAndDrop: !1,
                checkboxes: !1,
                autoBind: !0,
                autoScroll: !1,
                loadOnDemand: !0,
                template: "",
                dataTextField: null
            },
            _accessors: function() {
                var e, t, n, i = this,
                    a = i.options,
                    r = i.element;
                for (e in $) t = a[$[e]], n = r.attr(p.attr(e + "-field")), !t && n && (t = n), t || (t = e), v(t) || (t = [t]), a[$[e]] = t
            },
            _fieldAccessor: function(t) {
                var n = this.options[$[t]],
                    i = n.length,
                    a = "(function(item) {";
                return 0 === i ? a += "return item['" + t + "'];" : (a += "var levels = [" + e.map(n, function(e) {
                    return "function(d){ return " + p.expr(e) + "}"
                }).join(",") + "];", a += "return levels[Math.min(item.level(), " + i + "-1)](item)"), a += "})"
            },
            setOptions: function(e) {
                _.fn.setOptions.call(this, e), this._animation(), this._dragging(), this._templates()
            },
            _trigger: function(e, t) {
                return this.trigger(e, {
                    node: t.closest(G)[0]
                })
            },
            _setChecked: function(t, n) {
                if (t && e.isFunction(t.view))
                    for (var i = 0, a = t.view(); i < a.length; i++) a[i].enabled !== !1 && this._setCheckedValue(a[i], n), a[i].children && this._setChecked(a[i].children, n)
            },
            _setCheckedValue: function(e, t) {
                e[A] = t
            },
            _setIndeterminate: function(e) {
                var t, n, i, r = l(e),
                    s = !0;
                if (r.length && (t = a(r.children()), n = t.length)) {
                    if (n > 1) {
                        for (i = 1; i < n; i++)
                            if (t[i].checked != t[i - 1].checked || t[i].indeterminate || t[i - 1].indeterminate) {
                                s = !1;
                                break
                            }
                    } else s = !t[0].indeterminate;
                    return e.attr(W, s ? t[0].checked : "mixed"), a(e).data(O, !s).prop(O, !s).prop(A, s && t[0].checked)
                }
            },
            updateIndeterminate: function(e) {
                var t, n, i, a;
                if (e = e || this.wrapper, t = l(e).children(), t.length) {
                    for (n = 0; n < t.length; n++) this.updateIndeterminate(t.eq(n));
                    if (e.is(".k-treeview")) return;
                    i = this._setIndeterminate(e), a = this.dataItem(e), i && i.prop(A) ? a.checked = !0 : a && delete a.checked
                }
            },
            _bubbleIndeterminate: function(e, t) {
                if (e.length) {
                    t || this.updateIndeterminate(e);
                    var n, i = this.parent(e);
                    i.length && (this._setIndeterminate(i), n = i.children("div").find(".k-checkbox-wrapper input[type=checkbox]"), this._skip = !0, n.prop(O) === !1 ? this.dataItem(i).set(A, n.prop(A)) : this.dataItem(i).set(A, !1), this._skip = !1, this._bubbleIndeterminate(i, !0))
                }
            },
            _checkboxChange: function(t) {
                var n = this,
                    i = e(t.target),
                    a = i.prop(A),
                    r = i.closest(G),
                    s = this.dataItem(r);
                this._preventChange || (s.checked != a && (s.set(A, a), r.attr(W, a), this._trigger(N, r)), i.is(":focus") && (n._trigger(T, r), n.focus()))
            },
            _toggleButtonClick: function(t) {
                var n = e(t.currentTarget).closest(G);
                n.is("[aria-disabled='true']") || this.toggle(n)
            },
            _mousedown: function(t) {
                var n = this,
                    i = e(t.currentTarget),
                    a = e(t.currentTarget).closest(G),
                    r = p.support.browser;
                a.is("[aria-disabled='true']") || ((r.msie || r.edge) && i.is(":checkbox") && (i.prop(O) ? (n._preventChange = !1, i.prop(A, !i.prop(A)), i.trigger(D), i.on(F + w, function(e) {
                    e.preventDefault()
                }), n._preventChange = !0) : (i.off(F + w), n._preventChange = !1)), n._clickTarget = a, n.current(a))
            },
            _focusable: function(e) {
                return e && e.length && e.is(":visible") && !e.find(".k-in:first").hasClass(Y)
            },
            _focus: function() {
                var t = this.select(),
                    n = this._clickTarget;
                p.support.touch || (n && n.length && (t = n), this._focusable(t) || (t = this.current()), this._focusable(t) || (t = this._nextVisible(e())), this.current(t))
            },
            focus: function() {
                var e, t = this.wrapper,
                    n = t[0],
                    i = [],
                    a = [],
                    r = document.documentElement;
                do n = n.parentNode, n.scrollHeight > n.clientHeight && (i.push(n), a.push(n.scrollTop)); while (n != r);
                for (p.focusElement(t), e = 0; e < i.length; e++) i[e].scrollTop = a[e]
            },
            _blur: function() {
                this.current().find(".k-in:first").removeClass("k-state-focused")
            },
            _enabled: function(e) {
                return !e.children("div").children(".k-in").hasClass(Y)
            },
            parent: function(t) {
                var n, i, a = /\bk-treeview\b/,
                    r = /\bk-item\b/;
                typeof t == Q && (t = this.element.find(t)), K(t) || (t = t[0]), i = r.test(t.className);
                do t = t.parentNode, r.test(t.className) && (i ? n = t : i = !0); while (!a.test(t.className) && !n);
                return e(n)
            },
            _nextVisible: function(e) {
                function t(e) {
                    for (; e.length && !e.next().length;) e = i.parent(e);
                    return e.next().length ? e.next() : e
                }
                var n, i = this,
                    a = i._expanded(e);
                return e.length && e.is(":visible") ? a ? (n = l(e).children().first(), n.length || (n = t(e))) : n = t(e) : n = i.root.children().eq(0), n
            },
            _previousVisible: function(e) {
                var t, n, i = this;
                if (!e.length || e.prev().length)
                    for (n = e.length ? e.prev() : i.root.children().last(); i._expanded(n) && (t = l(n).children().last(), t.length);) n = t;
                else n = i.parent(e) || e;
                return n
            },
            _keydown: function(n) {
                var i, a = this,
                    r = n.keyCode,
                    s = a.current(),
                    o = a._expanded(s),
                    d = s.find(".k-checkbox-wrapper:first :checkbox"),
                    l = p.support.isRtl(a.element);
                n.target == n.currentTarget && (!l && r == C.RIGHT || l && r == C.LEFT ? o ? i = a._nextVisible(s) : s.find(".k-in:first").hasClass(Y) || a.expand(s) : !l && r == C.LEFT || l && r == C.RIGHT ? o && !s.find(".k-in:first").hasClass(Y) ? a.collapse(s) : (i = a.parent(s), a._enabled(i) || (i = t)) : r == C.DOWN ? i = a._nextVisible(s) : r == C.UP ? i = a._previousVisible(s) : r == C.HOME ? i = a._nextVisible(e()) : r == C.END ? i = a._previousVisible(e()) : r != C.ENTER || s.find(".k-in:first").hasClass(Y) ? r == C.SPACEBAR && d.length && (s.find(".k-in:first").hasClass(Y) || (d.prop(A, !d.prop(A)).data(O, !1).prop(O, !1), a._checkboxChange({
                    target: d
                })), i = s) : s.find(".k-in:first").hasClass("k-state-selected") || a._trigger(S, s) || a.select(s), i && (n.preventDefault(), s[0] != i[0] && (a._trigger(T, i), a.current(i))))
            },
            _keypress: function(e) {
                var t, n = this,
                    i = 300,
                    a = n.current().get(0),
                    r = e.key,
                    s = 1 === r.length;
                s && (n._match || (n._match = ""), n._match += r, clearTimeout(n._matchTimer), n._matchTimer = setTimeout(function() {
                    n._match = ""
                }, i), t = a && n._matchNextByText(Array.prototype.indexOf.call(n.element.find(".k-item"), a), n._match), t.length || (t = n._matchNextByText(-1, n._match)), t.get(0) && t.get(0) !== a && (n._trigger(T, t), n.current(t)))
            },
            _matchNextByText: function(t, n) {
                var i = this.element,
                    a = i.find(".k-in").filter(function(i, a) {
                        return i > t && e(a).is(":visible") && 0 === e(a).text().toLowerCase().indexOf(n)
                    });
                return a.eq(0).closest(G)
            },
            _click: function(t) {
                var n, i = this,
                    a = e(t.currentTarget),
                    r = c(a.closest(G)),
                    s = a.attr("href");
                n = s ? "#" == s || s.indexOf("#" + this.element.id + "-") >= 0 : r.length && !r.children().length, n && t.preventDefault(), a.hasClass(".k-state-selected") || i._trigger(S, a) || i.select(a)
            },
            _wrapper: function() {
                var e, t, n = this,
                    i = n.element,
                    a = "k-widget k-treeview";
                i.is("ul") ? (e = i.wrap("<div />").parent(), t = i) : (e = i, t = e.children("ul").eq(0)), n.wrapper = e.addClass(a), n.root = t
            },
            _getSelectedNode: function() {
                return this.element.find(".k-state-selected").closest(G)
            },
            _group: function(e) {
                var t = this,
                    n = e.hasClass(P),
                    i = {
                        firstLevel: n,
                        expanded: n || t._expanded(e)
                    },
                    a = e.children("ul");
                a.addClass(t.templates.groupCssClass(i)).css("display", i.expanded ? "" : "none"), t._nodes(a, i)
            },
            _nodes: function(t, n) {
                var i, a = this,
                    r = t.children("li");
                n = m({
                    length: r.length
                }, n), r.each(function(t, r) {
                    r = e(r), i = {
                        index: t,
                        expanded: a._expanded(r)
                    }, o(r), a._updateNodeClasses(r, n, i), a._group(r)
                })
            },
            _checkboxes: function() {
                var e, t = this.options,
                    n = t.checkboxes;
                n && (e = "<input type='checkbox' tabindex='-1' #= (item.enabled === false) ? 'disabled' : '' # #= item.checked ? 'checked' : '' #", n.name && (e += " name='" + n.name + "'"), e += " id='_#= item.uid #' class='k-checkbox' /><span class='k-checkbox-label checkbox-span'></span>", n = m({
                    template: e
                }, t.checkboxes), typeof n.template == Q && (n.template = k(n.template)), t.checkboxes = n)
            },
            _updateNodeClasses: function(e, t, n) {
                var i, a, r = e.children("div"),
                    s = e.children("ul"),
                    o = this.templates;
                e.hasClass("k-treeview") || (n = n || {}, n.expanded = typeof n.expanded != j ? n.expanded : this._expanded(e), n.index = typeof n.index != j ? n.index : e.index(), n.enabled = typeof n.enabled != j ? n.enabled : !r.children(".k-in").hasClass("k-state-disabled"), t = t || {}, t.firstLevel = typeof t.firstLevel != j ? t.firstLevel : e.parent().parent().hasClass(P), t.length = typeof t.length != j ? t.length : e.parent().children().length, e.removeClass("k-first k-last").addClass(o.wrapperCssClass(t, n)), r.removeClass("k-top k-mid k-bot").addClass(o.cssClass(t, n)), i = r.children(".k-in"), a = i[0] && "a" == i[0].nodeName.toLowerCase(), i.removeClass("k-in k-link k-state-default k-state-disabled").addClass(o.textClass(n, a)), (s.length || "true" == e.attr("data-hasChildren")) && (r.children(".k-icon").removeClass("k-i-expand k-i-collapse").addClass(o.toggleButtonClass(n)), s.addClass("k-group")))
            },
            _processNodes: function(t, n) {
                var i, a = this,
                    r = a.element.find(t);
                for (i = 0; i < r.length; i++) n.call(a, i, e(r[i]).closest(G))
            },
            dataItem: function(t) {
                var n = e(t).closest(G).attr(p.attr("uid")),
                    i = this.dataSource;
                return i && i.getByUid(n)
            },
            _dataItem: function(t) {
                var n = e(t).closest(G).attr(p.attr("uid")),
                    i = this.dataSource;
                return i && this._dataSourceUids[n]
            },
            _insertNode: function(t, n, i, a, r) {
                var s, d, c, h, u, f, g = this,
                    m = l(i),
                    k = m.children().length + 1,
                    v = {
                        firstLevel: i.hasClass(P),
                        expanded: !r,
                        length: k
                    },
                    _ = "",
                    x = function(e, t) {
                        e.appendTo(t)
                    };
                for (c = 0; c < t.length; c++) h = t[c], h.index = n + c, _ += g._renderItem({
                    group: v,
                    item: h
                });
                if (d = e(_), d.length) {
                    for (g.angular("compile", function() {
                            return {
                                elements: d.get(),
                                data: t.map(function(e) {
                                    return {
                                        dataItem: e
                                    }
                                })
                            }
                        }), m.length || (m = e(g._renderGroup({
                            group: v
                        })).appendTo(i)), a(d, m), i.hasClass("k-item") && (o(i), g._updateNodeClasses(i, v, {
                            expanded: !r
                        })), u = d.prev().first(), f = d.next().last(), g._updateNodeClasses(u, {}, {
                            expanded: "true" == u.attr(p.attr("expanded"))
                        }), g._updateNodeClasses(f, {}, {
                            expanded: "true" == f.attr(p.attr("expanded"))
                        }), c = 0; c < t.length; c++) h = t[c], h.hasChildren && (s = h.children.data(), s.length && g._insertNode(s, h.index, d.eq(c), x, !h.expanded));
                    return d
                }
            },
            _updateNodes: function(t, n) {
                function i(e, t) {
                    e.is(".k-group") && e.find(".k-item:not([aria-disabled])").attr(W, t), e.find(".k-checkbox-wrapper input[type=checkbox]:not([disabled])").prop(A, t).data(O, !1).prop(O, !1)
                }
                var a, r, s, o, d, l, h, u = this,
                    p = {
                        treeview: u.options,
                        item: o
                    },
                    g = "expanded" != n && "checked" != n;
                if ("selected" == n) o = t[0], r = u.findByUid(o.uid).find(".k-in:first").removeClass("k-state-hover").toggleClass("k-state-selected", o[n]).end(), o[n] && u.current(r), r.attr(J, !!o[n]);
                else {
                    for (h = e.map(t, function(e) {
                            return u.findByUid(e.uid).children("div")
                        }), g && u.angular("cleanup", function() {
                            return {
                                elements: h
                            }
                        }), a = 0; a < t.length; a++) p.item = o = t[a], s = h[a], r = s.parent(), g && s.children(".k-in").html(u.templates.itemContent(p)), n == A ? (d = o[n], i(s, d), r.attr(W, d), u.options.checkboxes.checkChildren && (i(r.children(".k-group"), d), u._setChecked(o.children, d), u._bubbleIndeterminate(r))) : "expanded" == n ? u._toggle(r, o, o[n]) : "enabled" == n && (r.find(".k-checkbox-wrapper input[type=checkbox]").prop("disabled", !o[n]), l = !c(r).is(M), r.removeAttr(X), o[n] || (o.selected && o.set("selected", !1), o.expanded && o.set("expanded", !1), l = !0, r.attr(J, !1).attr(X, !0)), u._updateNodeClasses(r, {}, {
                        enabled: o[n],
                        expanded: !l
                    })), s.length && (o._events && o._events.change && o._events.change.splice(1), this.trigger("itemChange", {
                        item: s,
                        data: o,
                        ns: f
                    }));
                    g && u.angular("compile", function() {
                        return {
                            elements: h,
                            data: e.map(t, function(e) {
                                return [{
                                    dataItem: e
                                }]
                            })
                        }
                    })
                }
            },
            _appendItems: function(e, t, n) {
                var i, a, r, s = l(n),
                    o = s.children(),
                    d = !this._expanded(n);
                this.element === n ? (i = this.dataSource.data(), a = this.dataSource.view(), r = a.length < i.length ? a : i, e = r.indexOf(t[0])) : t.length && (e = t[0].parent().indexOf(t[0])), typeof e == j && (e = o.length), this._insertNode(t, e, n, function(t, n) {
                    e >= o.length ? t.appendTo(n) : t.insertBefore(o.eq(e))
                }, d), d || (this._updateNodeClasses(n, {}, {
                    expanded: !d
                }), l(n).css("display", "block"))
            },
            _refreshChildren: function(e, t, n) {
                var i, a, r, s = this.options,
                    d = s.loadOnDemand,
                    c = s.checkboxes && s.checkboxes.checkChildren;
                if (l(e).empty(), t.length)
                    for (this._appendItems(n, t, e), a = l(e).children(), d && c && this._bubbleIndeterminate(a.last()), i = 0; i < a.length; i++) r = a.eq(i), this.trigger("itemChange", {
                        item: r.children("div"),
                        data: t[i],
                        ns: f
                    });
                else o(e)
            },
            _refreshRoot: function(t) {
                var n, i, a, r = this._renderGroup({
                    items: t,
                    group: {
                        firstLevel: !0,
                        expanded: !0
                    }
                });
                for (this.root.length ? (this._angularItems("cleanup"), n = e(r), this.root.attr("class", n.attr("class")).html(n.html())) : this.root = this.wrapper.html(r).children("ul"), i = this.root.children(".k-item"), a = 0; a < t.length; a++) this.trigger("itemChange", {
                    item: i.eq(a),
                    data: t[a],
                    ns: f
                });
                this._angularItems("compile")
            },
            refresh: function(e) {
                var n, i, a = e.node,
                    r = e.action,
                    s = e.items,
                    o = this.wrapper,
                    d = this.options,
                    l = d.loadOnDemand,
                    c = d.checkboxes && d.checkboxes.checkChildren;
                if (!this._skip) {
                    for (n = 0; n < s.length; n++) this._dataSourceUids[s[n].uid] = s[n];
                    if (e.field) {
                        if (!s[0] || !s[0].level) return;
                        return this._updateNodes(s, e.field)
                    }
                    if (a && (o = this.findByUid(a.uid), this._progress(o, !1)), c && "remove" != r) {
                        for (i = !1, n = 0; n < s.length; n++)
                            if ("checked" in s[n]) {
                                i = !0;
                                break
                            }
                        if (!i && a && a.checked)
                            for (n = 0; n < s.length; n++) s[n].checked = !0
                    }
                    if ("add" == r ? this._appendItems(e.index, s, o) : "remove" == r ? this._remove(this.findByUid(s[0].uid), !1) : "itemchange" == r ? this._updateNodes(s) : "itemloaded" == r ? this._refreshChildren(o, s, e.index) : this._refreshRoot(s), "remove" != r)
                        for (n = 0; n < s.length; n++)(!l || s[n].expanded || s[n]._loaded) && s[n].load();
                    this.trigger(q, {
                        node: a ? o : t
                    }), this.dataSource.filter() && this.options.checkboxes.checkChildren && this.updateIndeterminate(o)
                }
            },
            _error: function(e) {
                var t = e.node && this.findByUid(e.node.uid),
                    n = this.templates.retry({
                        messages: this.options.messages
                    });
                t ? (this._progress(t, !1), this._expanded(t, !1), h(t).addClass("k-i-reload"), e.node.loaded(!1)) : (this._progress(!1), this.element.html(n))
            },
            _retryRequest: function(e) {
                e.preventDefault(), this.dataSource.fetch()
            },
            expand: function(e) {
                this._processNodes(e, function(e, t) {
                    this.toggle(t, !0)
                })
            },
            collapse: function(e) {
                this._processNodes(e, function(e, t) {
                    this.toggle(t, !1)
                })
            },
            enable: function(e, t) {
                "boolean" == typeof e ? (t = e, e = this.items()) : t = 2 != arguments.length || !!t, this._processNodes(e, function(e, n) {
                    this.dataItem(n).set("enabled", t)
                })
            },
            current: function(n) {
                var i = this,
                    a = i._current,
                    r = i.element,
                    s = i._ariaId;
                return arguments.length > 0 && n && n.length ? (a && (a[0].id === s && a.removeAttr("id"), a.find(".k-in:first").removeClass("k-state-focused")), a = i._current = e(n, r).closest(G), a.find(".k-in:first").addClass("k-state-focused"), s = a[0].id || s, s && (i.wrapper.removeAttr("aria-activedescendant"), a.attr("id", s), i.wrapper.attr("aria-activedescendant", s)), t) : (a || (a = i._nextVisible(e())), a)
            },
            select: function(n) {
                var i = this,
                    a = i.element;
                return arguments.length ? (n = e(n, a).closest(G), a.find(".k-state-selected").each(function() {
                    var t = i.dataItem(this);
                    t ? (t.set("selected", !1), delete t.selected) : e(this).removeClass("k-state-selected")
                }), n.length && (i.dataItem(n).set("selected", !0), i._clickTarget = n), i.trigger(D), t) : a.find(".k-state-selected").closest(G)
            },
            _toggle: function(e, t, n) {
                var i, a = this.options,
                    r = c(e),
                    s = n ? "expand" : "collapse";
                r.data("animating") || (i = t && t.loaded(), n && !i ? (a.loadOnDemand && this._progress(e, !0), r.remove(), t.load()) : (this._updateNodeClasses(e, {}, {
                    expanded: n
                }), n || r.css("height", r.height()).css("height"), r.kendoStop(!0, !0).kendoAnimate(m({
                    reset: !0
                }, a.animation[s], {
                    complete: function() {
                        n && r.css("height", "")
                    }
                }))))
            },
            toggle: function(t, n) {
                t = e(t), h(t).is(".k-i-expand, .k-i-collapse") && (1 == arguments.length && (n = !this._expanded(t)), this._expanded(t, n))
            },
            destroy: function() {
                var e = this;
                _.fn.destroy.call(e), e.wrapper.off(w), e.wrapper.find(".k-checkbox-wrapper :checkbox").off(w), e._unbindDataSource(), e.dragging && e.dragging.destroy(), e._dataSourceUids = {}, p.destroy(e.element), e.root = e.wrapper = e.element = null
            },
            _expanded: function(e, n, i) {
                var a, r = p.attr("expanded"),
                    s = n,
                    o = s ? "expand" : "collapse";
                return 1 == arguments.length ? (a = this._dataItem(e), "true" === e.attr(r) || a && a.expanded) : (a = this.dataItem(e), c(e).data("animating") || !i && this._trigger(o, e) || (s ? (e.attr(r, "true"), e.attr("aria-expanded", "true")) : (e.removeAttr(r), e.attr("aria-expanded", "false")), a && (a.set("expanded", s), s = a.expanded)), t)
            },
            _progress: function(e, t) {
                var n = this.element,
                    i = this.templates.loading({
                        messages: this.options.messages
                    });
                1 == arguments.length ? (t = e, t ? n.html(i) : n.empty()) : h(e).toggleClass("k-i-loading", t).removeClass("k-i-reload")
            },
            text: function(e, n) {
                var i = this.dataItem(e),
                    a = this.options[$.text],
                    r = i.level(),
                    s = a.length,
                    o = a[Math.min(r, s - 1)];
                return n ? (i.set(o, n), t) : i[o]
            },
            _objectOrSelf: function(t) {
                return e(t).closest("[data-role=treeview]").data("kendoTreeView") || this
            },
            _dataSourceMove: function(t, n, i, a) {
                var r, s = this._objectOrSelf(i || n),
                    o = s.dataSource,
                    d = e.Deferred().resolve().promise();
                return i && i[0] != s.element[0] && (r = s.dataItem(i), r.loaded() || (s._progress(i, !0), d = r.load()), i != this.root && (o = r.children, o && o instanceof x || (r._initChildren(), r.loaded(!0), o = r.children))), t = this._toObservableData(t), a.call(s, o, t, d)
            },
            _toObservableData: function(t) {
                var n, i, a = t;
                return (z(t) || K(t)) && (n = this._objectOrSelf(t).dataSource, i = e(t).attr(p.attr("uid")), a = n.getByUid(i), a && (a = n.remove(a))), a
            },
            _insert: function(e, t, n) {
                t instanceof p.data.ObservableArray ? t = t.toJSON() : v(t) || (t = [t]);
                var i = e.parent();
                return i && i._initChildren && (i.hasChildren = !0, i._initChildren()), e.splice.apply(e, [n, 0].concat(t)), this.findByUid(e[n].uid)
            },
            insertAfter: r(1),
            insertBefore: r(0),
            append: function(t, n, i) {
                var a = this.root;
                if (!(n && t instanceof jQuery && n[0] === t[0])) return n = n && n.length ? n : null, n && (a = l(n)), this._dataSourceMove(t, a, n, function(t, a, r) {
                    function s() {
                        n && d._expanded(n, !0, !0);
                        var e = t.data(),
                            i = Math.max(e.length, 0);
                        return d._insert(e, a, i)
                    }
                    var o, d = this;
                    return r.done(function() {
                        o = s(), (i = i || e.noop)(o)
                    }), o || null
                })
            },
            _remove: function(t, n) {
                var i, a, r, s = this;
                return t = e(t, s.element), this.angular("cleanup", function() {
                    return {
                        elements: t.get()
                    }
                }), i = t.parent().parent(), a = t.prev(), r = t.next(), t[n ? "detach" : "remove"](), i.hasClass("k-item") && (o(i), s._updateNodeClasses(i)), s._updateNodeClasses(a), s._updateNodeClasses(r), t
            },
            remove: function(e) {
                var t = this.dataItem(e);
                t && this.dataSource.remove(t)
            },
            detach: function(e) {
                return this._remove(e, !0)
            },
            findByText: function(t) {
                return e(this.element).find(".k-in").filter(function(n, i) {
                    return e(i).text() == t
                }).closest(G)
            },
            findByUid: function(t) {
                var n, i, a = this.element.find(".k-item"),
                    r = p.attr("uid");
                for (i = 0; i < a.length; i++)
                    if (a[i].getAttribute(r) == t) {
                        n = a[i];
                        break
                    }
                return e(n)
            },
            expandPath: function(t, n) {
                function i() {
                    s.shift(), s.length ? a(s[0]).then(i) : o.call(r)
                }

                function a(t) {
                    var n = e.Deferred(),
                        i = r.dataSource.get(t);
                    return i ? i.loaded() ? (i.set("expanded", !0), n.resolve()) : (r._progress(r.findByUid(i.uid), !0), i.load().then(function() {
                        i.set("expanded", !0), n.resolve()
                    })) : n.resolve(), n.promise()
                }
                var r = this,
                    s = t.slice(0),
                    o = n || e.noop;
                a(s[0]).then(i)
            },
            _parentIds: function(e) {
                for (var t = e && e.parentNode(), n = []; t && t.parentNode;) n.unshift(t.id), t = t.parentNode();
                return n
            },
            expandTo: function(e) {
                e instanceof p.data.Node || (e = this.dataSource.get(e));
                var t = this._parentIds(e);
                this.expandPath(t)
            },
            _renderItem: function(e) {
                return e.group || (e.group = {}), e.treeview = this.options, e.r = this.templates, this.templates.item(e)
            },
            _renderGroup: function(e) {
                var t = this;
                return e.renderItems = function(e) {
                    var n = "",
                        i = 0,
                        a = e.items,
                        r = a ? a.length : 0,
                        s = e.group;
                    for (s.length = r; i < r; i++) e.group = s, e.item = a[i], e.item.index = i, n += t._renderItem(e);
                    return n
                }, e.r = t.templates, t.templates.group(e)
            }
        }), f.plugin(d)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(t, define) {
    define("util/text-metrics.min", ["kendo.core.min"], t)
}(function() {
    ! function(t) {
        function i(t) {
            return (t + "").replace(a, l)
        }

        function n(t) {
            var i, n = [];
            for (i in t) n.push(i + t[i]);
            return n.sort().join("")
        }

        function e(t) {
            var i, n = 2166136261;
            for (i = 0; i < t.length; ++i) n += (n << 1) + (n << 4) + (n << 7) + (n << 8) + (n << 24), n ^= t.charCodeAt(i);
            return n >>> 0
        }

        function o() {
            return {
                width: 0,
                height: 0,
                baseline: 0
            }
        }

        function s(t, i, n) {
            return c.current.measure(t, i, n)
        }
        var r, a, l, h, u, c;
        window.kendo.util = window.kendo.util || {}, r = kendo.Class.extend({
            init: function(t) {
                this._size = t, this._length = 0, this._map = {}
            },
            put: function(t, i) {
                var n = this._map,
                    e = {
                        key: t,
                        value: i
                    };
                n[t] = e, this._head ? (this._tail.newer = e, e.older = this._tail, this._tail = e) : this._head = this._tail = e, this._length >= this._size ? (n[this._head.key] = null, this._head = this._head.newer, this._head.older = null) : this._length++
            },
            get: function(t) {
                var i = this._map[t];
                if (i) return i === this._head && i !== this._tail && (this._head = i.newer, this._head.older = null), i !== this._tail && (i.older && (i.older.newer = i.newer, i.newer.older = i.older), i.older = this._tail, i.newer = null, this._tail.newer = i, this._tail = i), i.value
            }
        }), a = /\r?\n|\r|\t/g, l = " ", h = {
            baselineMarkerSize: 1
        }, "undefined" != typeof document && (u = document.createElement("div"), u.style.cssText = "position: absolute !important; top: -4000px !important; width: auto !important; height: auto !important;padding: 0 !important; margin: 0 !important; border: 0 !important;line-height: normal !important; visibility: hidden !important; white-space: pre!important;"), c = kendo.Class.extend({
            init: function(i) {
                this._cache = new r(1e3), this.options = t.extend({}, h, i)
            },
            measure: function(t, s, r) {
                var a, l, h, c, f, d, p, m, g;
                if (void 0 === r && (r = {}), !t) return o();
                if (a = n(s), l = e(t + a), h = this._cache.get(l)) return h;
                c = o(), f = r.box || u, d = this._baselineMarker().cloneNode(!1);
                for (p in s) m = s[p], void 0 !== m && (f.style[p] = m);
                return g = r.normalizeText !== !1 ? i(t) : t + "", f.textContent = g, f.appendChild(d), document.body.appendChild(f), g.length && (c.width = f.offsetWidth - this.options.baselineMarkerSize, c.height = f.offsetHeight, c.baseline = d.offsetTop + this.options.baselineMarkerSize), c.width > 0 && c.height > 0 && this._cache.put(l, c), f.parentNode.removeChild(f), c
            },
            _baselineMarker: function() {
                var t = document.createElement("div");
                return t.style.cssText = "display: inline-block; vertical-align: baseline;width: " + this.options.baselineMarkerSize + "px; height: " + this.options.baselineMarkerSize + "px;overflow: hidden;", t
            }
        }), c.current = new c, kendo.deepExtend(kendo.util, {
            LRUCache: r,
            TextMetrics: c,
            measureText: s,
            objectKey: n,
            hashKey: e,
            normalizeText: i
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(t, i, n) {
    (n || i)()
}),
function(t, define) {
    define("dataviz/core/kendo-core.min", ["kendo.core.min", "kendo.drawing.min"], t)
}(function() {
    ! function(t) {
        function i(t) {
            return Array.isArray(t)
        }

        function n(t, n) {
            var e, o, s = i(n) ? n : [n];
            for (e = 0; e < s.length; e++) o = s[e], t.className.indexOf(o) === -1 && (t.className += " " + o)
        }

        function e(t, i) {
            t && t.className && (t.className = t.className.replace(i, "").replace(vi, " "))
        }

        function o(t) {
            var i, n = .5;
            for (t.options.stroke && kendo.drawing.util.defined(t.options.stroke.width) && t.options.stroke.width % 2 === 0 && (n = 0), i = 0; i < t.segments.length; i++) t.segments[i].anchor().round(0).translate(n, n);
            return t
        }

        function s(t, i) {
            return -t.x * i.y + t.y * i.x < 0
        }

        function r(t) {
            return "number" == typeof t && !isNaN(t)
        }

        function a(t) {
            return typeof t === hi
        }

        function l(t) {
            return r(t) || a(t) && isFinite(t)
        }

        function h(t) {
            return "object" == typeof t
        }

        function u(t) {
            return r(t) ? t + "px" : t
        }

        function c(t) {
            return bi.test(t)
        }

        function f(t, n) {
            var e, o, s, r, l, f = a(n) ? [n] : n;
            if (i(f)) {
                for (e = {}, o = window.getComputedStyle(t), s = 0; s < f.length; s++) r = f[s], e[r] = c(r) ? parseFloat(o[r]) : o[r];
                return e
            }
            if (h(n))
                for (l in n) t.style[l] = u(n[l])
        }

        function d(t, i) {
            void 0 === i && (i = 0);
            var n = {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            };
            return "number" == typeof t ? n[ui] = n[ai] = n[Vt] = n[Zt] = t : (n[ui] = t[ui] || i, n[ai] = t[ai] || i, n[Vt] = t[Vt] || i, n[Zt] = t[Zt] || i), n
        }

        function p(t) {
            void 0 === t && (t = {});
            var i;
            return t.template ? t.template = i = ji.compile(t.template) : Bt(t.content) && (i = t.content), i
        }

        function m(t, i) {
            var n, e = t.length,
                o = [];
            for (n = 0; n < e; n++) i(t[n]) && o.push(t[n]);
            return o
        }

        function g(t, i) {
            var n, e;
            if (t.className)
                for (n = i.split(" "), e = 0; e < n.length; e++)
                    if (t.className.indexOf(n[e]) !== -1) return !0
        }

        function x(t, i) {
            if (i) return i.indexOf(t) !== -1
        }

        function v(t, i, n) {
            return kendo.drawing.util.round(t + (i - t) * n, Dt)
        }

        function b(t, i) {
            var n, e, o = t.length,
                s = [];
            for (n = 0; n < o; n++) e = i(t[n]), kendo.drawing.util.defined(e) && s.push(e);
            return s
        }

        function y(t) {
            var i = 0;
            return t.wheelDelta && (i = -t.wheelDelta / 120, i = i > 0 ? Math.ceil(i) : Math.floor(i)), t.detail && (i = kendo.drawing.util.round(t.detail / 3)), i
        }

        function w(t, i) {
            var n = t.prototype;
            n.options = n.options ? It({}, n.options, i) : i
        }

        function M(t) {
            var i, n, e, o = $t,
                s = ti;
            for (i = 0, n = t.length; i < n; i++) e = t[i], null !== e && isFinite(e) && (o = Math.min(o, e), s = Math.max(s, e));
            return {
                min: o === $t ? void 0 : o,
                max: s === ti ? void 0 : s
            }
        }

        function k(t, i) {
            var n, e, o, s = qi(i - t, Yt - 1);
            if (0 === s) {
                if (0 === i) return .1;
                s = Math.abs(i)
            }
            return n = Math.pow(10, Math.floor(Math.log(s) / Math.log(10))), e = qi(s / n, Yt), o = 1, o = e < 1.904762 ? .2 : e < 4.761904 ? .5 : e < 9.523809 ? 1 : 2, qi(n * o, Yt)
        }

        function T(t, i, n, e, o) {
            var s = Xi(o);
            return new Ji(n + (t - n) * Math.cos(s) + (i - e) * Math.sin(s), e - (t - n) * Math.sin(s) + (i - e) * Math.cos(s))
        }

        function S(t, i) {
            return t - i
        }

        function R(t, i) {
            var n, e, o, s, r, a, l, h, u;
            return t.x1 === i.x1 && t.y1 === i.y1 && t.x2 === i.x2 && t.y2 === i.y2 ? i : (n = Math.min(t.x1, i.x1), e = Math.max(t.x1, i.x1), o = Math.min(t.x2, i.x2), s = Math.max(t.x2, i.x2), r = Math.min(t.y1, i.y1), a = Math.max(t.y1, i.y1), l = Math.min(t.y2, i.y2), h = Math.max(t.y2, i.y2), u = [], u[0] = new Zi(e, r, o, a), u[1] = new Zi(n, a, e, l), u[2] = new Zi(o, a, s, l), u[3] = new Zi(e, l, o, h), t.x1 === n && t.y1 === r || i.x1 === n && i.y1 === r ? (u[4] = new Zi(n, r, e, a), u[5] = new Zi(o, l, s, h)) : (u[4] = new Zi(o, r, s, a), u[5] = new Zi(n, l, e, h)), m(u, function(t) {
                return t.height() > 0 && t.width() > 0
            })[0])
        }

        function U(i) {
            var n, e, o = i.stops,
                s = i.innerRadius / i.radius * 100,
                r = o.length,
                a = [];
            for (n = 0; n < r; n++) e = t.extend({}, o[n]), e.offset = (e.offset * (100 - s) + s) / 100, a.push(e);
            return a
        }

        function L(t) {
            var i = t.origin,
                n = t.bottomRight();
            return new Zi(i.x, i.y, n.x, n.y)
        }

        function j(t, i) {
            var n = t.tickX,
                e = t.tickY,
                s = t.position,
                r = new Mt({
                    stroke: {
                        width: i.width,
                        color: i.color
                    }
                });
            return t.vertical ? r.moveTo(n, s).lineTo(n + i.size, s) : r.moveTo(s, e).lineTo(s, e + i.size), o(r), r
        }

        function A(t, i) {
            var n = t.lineStart,
                e = t.lineEnd,
                s = t.position,
                r = new Mt({
                    stroke: {
                        width: i.width,
                        color: i.color,
                        dashType: i.dashType
                    }
                });
            return t.vertical ? r.moveTo(n, s).lineTo(e, s) : r.moveTo(s, n).lineTo(s, e), o(r), r
        }

        function I(t, i) {
            var n = t.getTime() - i,
                e = t.getTimezoneOffset() - i.getTimezoneOffset();
            return n - e * Bn
        }

        function B(t, i) {
            return new Date(t.getTime() + i)
        }

        function C(t) {
            var i;
            return t instanceof Date ? i = t : t && (i = new Date(t)), i
        }

        function P(t, i) {
            var n, e;
            if (void 0 === i && (i = 0), n = 0, e = t.getDay(), !isNaN(e))
                for (; e !== i;) 0 === e ? e = 6 : e--, n++;
            return B(t, -n * Pn)
        }

        function _(t, i) {
            return 0 === i && 23 === t.getHours() && (t.setHours(t.getHours() + 2), !0)
        }

        function z(t, i) {
            var n, e = new Date(t);
            return e.setMinutes(0, 0, 0), n = (t.getTimezoneOffset() - e.getTimezoneOffset()) * Bn, B(e, n + i * Cn)
        }

        function V(t, i, n, e) {
            var o, s, r = t;
            return t && (o = C(t), s = o.getHours(), n === jn ? (r = new Date(o.getFullYear() + i, 0, 1), _(r, 0)) : n === Ln ? (r = new Date(o.getFullYear(), o.getMonth() + i, 1), _(r, s)) : n === Un ? (r = V(P(o, e), 7 * i, Rn), _(r, s)) : n === Rn ? (r = new Date(o.getFullYear(), o.getMonth(), o.getDate() + i), _(r, s)) : n === Sn ? r = z(o, i) : n === Tn ? (r = B(o, i * Bn), r.getSeconds() > 0 && r.setSeconds(0)) : n === kn ? r = B(o, i * In) : n === Mn && (r = B(o, i)), n !== Mn && r.getMilliseconds() > 0 && r.setMilliseconds(0)), r
        }

        function E(t, i, n) {
            return V(C(t), 0, i, n)
        }

        function O(t, i, n) {
            var e = C(t);
            return e && E(e, i, n).getTime() === e.getTime() ? e : V(e, 1, i, n)
        }

        function D(t, i) {
            return t && i ? t.getTime() - i.getTime() : -1
        }

        function G(t, i) {
            return t.getTime() - i
        }

        function F(t) {
            var n, e;
            if (i(t)) {
                for (n = [], e = 0; e < t.length; e++) n.push(F(t[e]));
                return n
            }
            if (t) return C(t).getTime()
        }

        function N(t, i) {
            return t && i ? F(t) === F(i) : t === i
        }

        function H(t, i, n) {
            return I(t, i) / En[n]
        }

        function Y(t, i, n, e) {
            var o, s = C(t),
                r = C(i);
            return o = n === Ln ? s.getMonth() - r.getMonth() + 12 * (s.getFullYear() - r.getFullYear()) + H(s, new Date(s.getFullYear(), s.getMonth()), Rn) / new Date(s.getFullYear(), s.getMonth() + 1, 0).getDate() : n === jn ? s.getFullYear() - r.getFullYear() + Y(s, new Date(s.getFullYear(), 0), Ln, 1) / 12 : n === Rn || n === Un ? H(s, r, n) : G(s, i) / En[n], o / e
        }

        function X(t, i, n) {
            var e;
            return e = n === jn ? i.getFullYear() - t.getFullYear() : n === Ln ? 12 * X(t, i, jn) + i.getMonth() - t.getMonth() : n === Rn ? Math.floor(G(i, t) / Pn) : Math.floor(G(i, t) / En[n])
        }

        function q(t, i) {
            for (var n, e, o = 0, s = i.length - 1; o <= s;)
                if (n = Math.floor((o + s) / 2), e = i[n], e < t) o = n + 1;
                else {
                    if (!(e > t)) {
                        for (; N(i[n - 1], t);) n--;
                        return n
                    }
                    s = n - 1
                }
            return i[n] <= t ? n : n - 1
        }

        function K(t, i) {
            var n;
            return n = a(i) ? t.parseDate(i) || C(i) : C(i)
        }

        function W(t, n) {
            var e, o;
            if (i(n)) {
                for (e = [], o = 0; o < n.length; o++) e.push(K(t, n[o]));
                return e
            }
            return K(t, n)
        }

        function Q(t, i) {
            var n, e;
            if (t instanceof Date) {
                for (n = i.length, e = 0; e < n; e++)
                    if (N(i[e], t)) return e;
                return -1
            }
            return i.indexOf(t)
        }

        function J(t) {
            var i = t._range;
            return i || (i = t._range = M(t), i.min = C(i.min), i.max = C(i.max)), i
        }

        function Z(t, i, n) {
            for (var e, o, s, r = J(t.categories), a = (t.max || r.max) - (t.min || r.min), l = t.autoBaseUnitSteps, h = t.maxDateGroups, u = t.baseUnit === Xn, c = i ? Yn.indexOf(i) : 0, f = u ? Yn[c++] : t.baseUnit, d = a / En[f], p = d; !o || d >= h;) {
                e = e || l[f].slice(0);
                do s = e.shift(); while (s && i === f && s < n);
                if (s) o = s, d = p / o;
                else {
                    if (f === Ni(Yn)) {
                        o = Math.ceil(p / h);
                        break
                    }
                    if (!u) {
                        d > h && (o = Math.ceil(p / h));
                        break
                    }
                    f = Yn[c++] || Ni(Yn), p = a / En[f], e = null
                }
            }
            t.baseUnitStep = o, t.baseUnit = f
        }

        function $(t) {
            var i, n, e, o, s, r = t.categories,
                a = Vi(r) ? r.length : 0,
                l = $t;
            for (e = 0; e < a; e++) o = r[e], o && i && (s = I(o, i), s > 0 && (l = Math.min(l, s), n = l >= Vn ? jn : l >= zn - 3 * Pn ? Ln : l >= _n ? Un : l >= Pn ? Rn : l >= Cn ? Sn : l >= Bn ? Tn : kn)), i = o;
            t.baseUnit = n || Rn
        }

        function tt(t) {
            var i = (t.baseUnit || "").toLowerCase(),
                n = i !== Xn && !x(i, Yn);
            return n && $(t), i !== Xn && t.baseUnitStep !== Hn || Z(t), t
        }

        function it(t, i, n) {
            var e, o, s;
            if (!t && !i) return 0;
            if (t >= 0 && i >= 0) {
                if (o = t === i ? 0 : t, s = (i - o) / i, n === !1 || !n && s > Nn) return 0;
                e = Math.max(0, o - (i - o) / 2)
            } else e = t;
            return e
        }

        function nt(t, i, n) {
            var e, o, s;
            if (!t && !i) return 1;
            if (t <= 0 && i <= 0) {
                if (o = t === i ? 0 : i, s = Math.abs((o - t) / o), n === !1 || !n && s > Nn) return 0;
                e = Math.min(0, o - (t - o) / 2)
            } else e = i;
            return e
        }

        function et(t, i) {
            return qi(Math.floor(t / i) * i, Yt)
        }

        function ot(t, i) {
            return qi(Math.ceil(t / i) * i, Yt)
        }

        function st(t) {
            return Math.max(Math.min(t, Gn), -Gn)
        }

        function rt(t, i, n) {
            var e = n.narrowRange,
                o = it(t, i, e),
                s = nt(t, i, e),
                r = k(o, s),
                a = {
                    majorUnit: r
                };
            return n.roundToMajorUnit !== !1 && (o < 0 && ut(o, r, 1 / 3) && (o -= r), s > 0 && ut(s, r, 1 / 3) && (s += r)), a.min = et(o, r), a.max = ot(s, r), a
        }

        function at(t, i) {
            return {
                min: Vi(i.min) ? Math.min(t.min, i.min) : t.min,
                max: Vi(i.max) ? Math.max(t.max, i.max) : t.max,
                majorUnit: t.majorUnit
            }
        }

        function lt(t, i) {
            var n, e;
            for (n = 0; n < i.length; n++) e = i[n], null === t[e] && (t[e] = void 0)
        }

        function ht(t, i) {
            var n, e, o, s, r = i;
            return i && (lt(i, ["min", "max"]), n = Vi(i.min), e = Vi(i.max), o = n || e, o && i.min === i.max && (i.min > 0 ? i.min = 0 : i.max = 1), i.majorUnit ? (t.min = et(t.min, i.majorUnit), t.max = ot(t.max, i.majorUnit)) : o && (r = It(t, i), t.majorUnit = k(r.min, r.max))), t.minorUnit = (r.majorUnit || t.majorUnit) / 5, s = It(t, r), s.min >= s.max && (n && !e ? s.max = s.min + s.majorUnit : !n && e && (s.min = s.max - s.majorUnit)), s
        }

        function ut(t, i, n) {
            var e = qi(Math.abs(t % i), Yt),
                o = i * (1 - n);
            return 0 === e || e > o
        }

        function ct(t) {
            var i = Sn;
            return t >= Vn ? i = jn : t >= zn ? i = Ln : t >= _n ? i = Un : t >= Pn && (i = Rn), i
        }

        function ft(t, i, n) {
            var e = n.min || t,
                o = n.max || i,
                s = n.baseUnit || (o && e ? ct(I(o, e)) : Sn),
                r = En[s],
                a = E(F(e) - 1, s) || C(o),
                l = O(F(o) + 1, s),
                h = n.majorUnit ? n.majorUnit : void 0,
                u = h || ot(k(a.getTime(), l.getTime()), r) / r,
                c = X(a, l, s),
                f = ot(c, u),
                d = f - c,
                p = Math.floor(d / 2),
                m = d - p;
            return n.baseUnit || delete n.baseUnit, n.baseUnit = n.baseUnit || s, n.min = n.min || V(a, -p, s), n.max = n.max || V(l, m, s), n.minorUnit = n.minorUnit || u / 5, n.majorUnit = u, n
        }

        function dt(t, i, n, e) {
            var o = n.min,
                s = n.max;
            return Vi(n.axisCrossingValue) && n.axisCrossingValue <= 0 && gt(), Vi(e.max) ? e.max <= 0 && gt() : s = i, Vi(e.min) ? e.min <= 0 && gt() : o = t, {
                min: o,
                max: s
            }
        }

        function pt(t, i, n) {
            var e = n.majorUnit,
                o = t;
            return t <= 0 ? o = i <= 1 ? Math.pow(e, -2) : 1 : n.narrowRange || (o = Math.pow(e, Math.floor(xt(t, e)))), o
        }

        function mt(t, i) {
            var n, e = qi(xt(t, i), Yt) % 1;
            return n = t <= 0 ? i : 0 !== e && (e < .3 || e > .9) ? Math.pow(i, xt(t, i) + .2) : Math.pow(i, Math.ceil(xt(t, i)))
        }

        function gt() {
            throw Error("Non positive values cannot be used for a logarithmic axis")
        }

        function xt(t, i) {
            return Math.log(t) / Math.log(i)
        }

        function vt(t, i) {
            return 180 - Math.abs(Math.abs(t - i) - 180)
        }

        function bt(t) {
            return t <= 0 ? -1 : 1
        }
        var yt, wt, Mt, kt, Tt, St, Rt, Ut, Lt, jt, At, It, Bt, Ct, Pt, _t, zt, Vt, Et, Ot, Dt, Gt, Ft, Nt, Ht, Yt, Xt, qt, Kt, Wt, Qt, Jt, Zt, $t, ti, ii, ni, ei, oi, si, ri, ai, li, hi, ui, ci, fi, di, pi, mi, gi, xi, vi, bi, yi, wi, Mi, ki, Ti, Si, Ri, Ui, Li, ji, Ai, Ii, Bi, Ci, Pi, _i, zi, Vi, Ei, Oi, Di, Gi, Fi, Ni, Hi, Yi, Xi, qi, Ki, Wi, Qi, Ji, Zi, $i, tn, nn, en, on, sn, rn, an, ln, hn, un, cn, fn, dn, pn, mn, gn, xn, vn, bn, yn, wn, Mn, kn, Tn, Sn, Rn, Un, Ln, jn, An, In, Bn, Cn, Pn, _n, zn, Vn, En, On, Dn, Gn, Fn, Nn, Hn, Yn, Xn, qn, Kn, Wn, Qn, Jn, Zn, $n, te, ie, ne, ee, oe, se, re, ae, le, he;
        window.kendo.dataviz = window.kendo.dataviz || {}, yt = kendo.drawing, wt = yt.util, Mt = yt.Path, kt = yt.Group, Tt = kendo.Class, St = kendo.geometry, Rt = St.Rect, Ut = St.Circle, Lt = St.transform, jt = St.Segment, At = kendo.dataviz, It = kendo.deepExtend, Bt = kendo.isFunction, Ct = kendo.getter, Pt = "arc", _t = "axisLabelClick", zt = "#000", Vt = "bottom", Et = "center", Ot = "circle", Dt = 3, Gt = "cross", Ft = "date", Nt = "12px sans-serif", Ht = 400, Yt = 10, Xt = 600, qt = "end", Kt = /\{\d+:?/, Wt = "height", Qt = 100, Jt = "inside", Zt = "left", $t = Number.MAX_VALUE, ti = -Number.MAX_VALUE, ii = "none", ni = "noteClick", ei = "noteHover", oi = "noteLeave", si = "object", ri = "outside", ai = "right", li = "start", hi = "string", ui = "top", ci = "triangle", fi = "value", di = "#fff", pi = "width", mi = "x", gi = "y", xi = {
            ARC: Pt,
            AXIS_LABEL_CLICK: _t,
            BLACK: zt,
            BOTTOM: Vt,
            CENTER: Et,
            CIRCLE: Ot,
            COORD_PRECISION: Dt,
            CROSS: Gt,
            DATE: Ft,
            DEFAULT_FONT: Nt,
            DEFAULT_HEIGHT: Ht,
            DEFAULT_PRECISION: Yt,
            DEFAULT_WIDTH: Xt,
            END: qt,
            FORMAT_REGEX: Kt,
            HEIGHT: Wt,
            HIGHLIGHT_ZINDEX: Qt,
            INSIDE: Jt,
            LEFT: Zt,
            MAX_VALUE: $t,
            MIN_VALUE: ti,
            NONE: ii,
            NOTE_CLICK: ni,
            NOTE_HOVER: ei,
            NOTE_LEAVE: oi,
            OBJECT: si,
            OUTSIDE: ri,
            RIGHT: ai,
            START: li,
            STRING: hi,
            TOP: ui,
            TRIANGLE: ci,
            VALUE: fi,
            WHITE: di,
            WIDTH: pi,
            X: mi,
            Y: gi
        }, vi = /\s+/g, bi = /width|height|top|left|bottom|right/i, yi = {
            format: function(t, i) {
                return i
            },
            toString: function(t) {
                return t
            },
            parseDate: function(t) {
                return new Date(t)
            }
        }, wi = yi, Mi = Tt.extend({}), Mi.register = function(t) {
            wi = t
        }, Object.defineProperties && Object.defineProperties(Mi, {
            implementation: {
                get: function() {
                    return wi
                }
            }
        }), ki = /\{(\d+)(:[^\}]+)?\}/g, Ti = Tt.extend({
            init: function(t) {
                this._intlService = t
            },
            auto: function(t) {
                for (var i, n = [], e = arguments.length - 1; e-- > 0;) n[e] = arguments[e + 1];
                return i = this.intl, a(t) && t.match(Kt) ? i.format.apply(i, [t].concat(n)) : i.toString(n[0], t)
            },
            localeAuto: function(t, i, n) {
                var e, o = this.intl;
                return e = a(t) && t.match(Kt) ? t.replace(ki, function(t, e, s) {
                    var r = i[parseInt(e, 10)];
                    return o.toString(r, s ? s.substring(1) : "", n)
                }) : o.toString(i[0], t, n)
            }
        }), Object.defineProperties && Object.defineProperties(Ti.fn, {
            intl: {
                get: function() {
                    return this._intlService || Mi.implementation
                },
                set: function(t) {
                    this._intlService = t
                }
            }
        }), Si = Tt.extend({
            init: function(t, i) {
                void 0 === i && (i = {}), this._intlService = i.intlService, this.sender = i.sender || t, this.format = new Ti(i.intlService), this.chart = t, this.rtl = !!i.rtl
            },
            notify: function(t, i) {
                this.chart && this.chart.trigger(t, i)
            },
            isPannable: function(t) {
                var i = ((this.chart || {}).options || {}).pannable;
                return i && i.lock !== t
            }
        }), Object.defineProperties && Object.defineProperties(Si.fn, {
            intl: {
                get: function() {
                    return this._intlService || Mi.implementation
                },
                set: function(t) {
                    this._intlService = t, this.format.intl = t
                }
            }
        }), Ui = Tt.extend({}), Ui.register = function(t) {
            Ri = t
        }, Ui.create = function(t, i) {
            if (Ri) return Ri.create(t, i)
        }, Li = {
            compile: function(t) {
                return t
            }
        }, ji = Tt.extend({}), ji.register = function(t) {
            Li = t
        }, ji.compile = function(t) {
            return Li.compile(t)
        }, Ai = {
            ChartService: Si,
            DomEventsBuilder: Ui,
            FormatService: Ti,
            IntlService: Mi,
            TemplateService: ji
        }, Ii = function() {
            this._map = {}
        }, Ii.prototype.get = function(t) {
            return this._map[this._key(t)]
        }, Ii.prototype.set = function(t, i) {
            this._map[this._key(t)] = i
        }, Ii.prototype._key = function(t) {
            return t instanceof Date ? t.getTime() : t
        }, Bi = "trigger", Ci = Tt.extend({
            init: function(t, i) {
                this.observer = t, this.handlerMap = It({}, this.handlerMap, i)
            },
            trigger: function(t, i) {
                var n, e = this,
                    o = e.observer,
                    s = e.handlerMap;
                return s[t] ? n = this.callObserver(s[t], i) : o[Bi] && (n = this.callObserver(Bi, t, i)), n
            },
            callObserver: function(t) {
                for (var i = [], n = arguments.length - 1; n-- > 0;) i[n] = arguments[n + 1];
                return this.observer[t].apply(this.observer, i)
            },
            requiresHandlers: function(t) {
                var i, n = this;
                if (this.observer.requiresHandlers) return this.observer.requiresHandlers(t);
                for (i = 0; i < t.length; i++)
                    if (n.handlerMap[t[i]]) return !0
            }
        }), Pi = kendo.drawing.util, _i = Pi.append, zi = Pi.bindEvents, Vi = Pi.defined, Ei = Pi.deg, Oi = Pi.elementOffset, Di = Pi.elementSize, Gi = Pi.eventElement, Fi = Pi.eventCoordinates, Ni = Pi.last, Hi = Pi.limitValue, Yi = Pi.objectKey, Xi = Pi.rad, qi = Pi.round, Ki = Pi.unbindEvents, Wi = Pi.valueOrDefault, Qi = Tt.extend({}), Qi.fetchFonts = function(t, i, n) {
            void 0 === n && (n = {
                depth: 0
            });
            var e = 5;
            !t || n.depth > e || !document.fonts || Object.keys(t).forEach(function(e) {
                var o = t[e];
                "dataSource" !== e && "$" !== e[0] && o && ("font" === e ? i.push(o) : "object" == typeof o && (n.depth++, Qi.fetchFonts(o, i, n), n.depth--))
            })
        }, Qi.loadFonts = function(t, i) {
            var n = [];
            if (t.length > 0 && document.fonts) {
                try {
                    n = t.map(function(t) {
                        return document.fonts.load(t)
                    })
                } catch (e) {
                    kendo.logToConsole(e)
                }
                Promise.all(n).then(i, i)
            } else i()
        }, Qi.preloadFonts = function(t, i) {
            var n = [];
            Qi.fetchFonts(t, n), Qi.loadFonts(n, i)
        }, Ji = Tt.extend({
            init: function(t, i) {
                this.x = t || 0, this.y = i || 0
            },
            clone: function() {
                return new Ji(this.x, this.y)
            },
            equals: function(t) {
                return t && this.x === t.x && this.y === t.y
            },
            rotate: function(t, i) {
                var n = Xi(i),
                    e = Math.cos(n),
                    o = Math.sin(n),
                    s = t.x,
                    r = t.y,
                    a = this,
                    l = a.x,
                    h = a.y;
                return this.x = qi(s + (l - s) * e + (h - r) * o, Dt), this.y = qi(r + (h - r) * e - (l - s) * o, Dt), this
            },
            multiply: function(t) {
                return this.x *= t, this.y *= t, this
            },
            distanceTo: function(t) {
                var i = this.x - t.x,
                    n = this.y - t.y;
                return Math.sqrt(i * i + n * n)
            }
        }), Ji.onCircle = function(t, i, n) {
            var e = Xi(i);
            return new Ji(t.x - n * Math.cos(e), t.y - n * Math.sin(e))
        }, Zi = Tt.extend({
            init: function(t, i, n, e) {
                this.x1 = t || 0, this.y1 = i || 0, this.x2 = n || 0, this.y2 = e || 0
            },
            equals: function(t) {
                return this.x1 === t.x1 && this.x2 === t.x2 && this.y1 === t.y1 && this.y2 === t.y2
            },
            width: function() {
                return this.x2 - this.x1
            },
            height: function() {
                return this.y2 - this.y1
            },
            translate: function(t, i) {
                return this.x1 += t, this.x2 += t, this.y1 += i, this.y2 += i, this
            },
            move: function(t, i) {
                var n = this.height(),
                    e = this.width();
                return Vi(t) && (this.x1 = t, this.x2 = this.x1 + e), Vi(i) && (this.y1 = i, this.y2 = this.y1 + n), this
            },
            wrap: function(t) {
                return this.x1 = Math.min(this.x1, t.x1), this.y1 = Math.min(this.y1, t.y1), this.x2 = Math.max(this.x2, t.x2), this.y2 = Math.max(this.y2, t.y2), this
            },
            wrapPoint: function(t) {
                var n = i(t),
                    e = n ? t[0] : t.x,
                    o = n ? t[1] : t.y;
                return this.wrap(new Zi(e, o, e, o)), this
            },
            snapTo: function(t, i) {
                return i !== mi && i || (this.x1 = t.x1, this.x2 = t.x2), i !== gi && i || (this.y1 = t.y1, this.y2 = t.y2), this
            },
            alignTo: function(t, i) {
                var n, e, o = this.height(),
                    s = this.width(),
                    r = i === ui || i === Vt ? gi : mi,
                    a = r === gi ? o : s;
                return i === Et ? (n = t.center(), e = this.center(), this.x1 += n.x - e.x, this.y1 += n.y - e.y) : this[r + 1] = i === ui || i === Zt ? t[r + 1] - a : t[r + 2], this.x2 = this.x1 + s, this.y2 = this.y1 + o, this
            },
            shrink: function(t, i) {
                return this.x2 -= t, this.y2 -= i, this
            },
            expand: function(t, i) {
                return this.shrink(-t, -i), this
            },
            pad: function(t) {
                var i = d(t);
                return this.x1 -= i.left, this.x2 += i.right, this.y1 -= i.top, this.y2 += i.bottom, this
            },
            unpad: function(t) {
                var i = d(t);
                return i.left = -i.left, i.top = -i.top, i.right = -i.right, i.bottom = -i.bottom, this.pad(i)
            },
            clone: function() {
                return new Zi(this.x1, this.y1, this.x2, this.y2)
            },
            center: function() {
                return new Ji(this.x1 + this.width() / 2, this.y1 + this.height() / 2)
            },
            containsPoint: function(t) {
                return t.x >= this.x1 && t.x <= this.x2 && t.y >= this.y1 && t.y <= this.y2
            },
            points: function() {
                return [new Ji(this.x1, this.y1), new Ji(this.x2, this.y1), new Ji(this.x2, this.y2), new Ji(this.x1, this.y2)]
            },
            getHash: function() {
                return [this.x1, this.y1, this.x2, this.y2].join(",")
            },
            overlaps: function(t) {
                return !(t.y2 < this.y1 || this.y2 < t.y1 || t.x2 < this.x1 || this.x2 < t.x1)
            },
            rotate: function(t) {
                var i = this.width(),
                    n = this.height(),
                    e = this.center(),
                    o = e.x,
                    s = e.y,
                    r = T(0, 0, o, s, t),
                    a = T(i, 0, o, s, t),
                    l = T(i, n, o, s, t),
                    h = T(0, n, o, s, t);
                return i = Math.max(r.x, a.x, l.x, h.x) - Math.min(r.x, a.x, l.x, h.x), n = Math.max(r.y, a.y, l.y, h.y) - Math.min(r.y, a.y, l.y, h.y), this.x2 = this.x1 + i, this.y2 = this.y1 + n, this
            },
            toRect: function() {
                return new Rt([this.x1, this.y1], [this.width(), this.height()])
            },
            hasSize: function() {
                return 0 !== this.width() && 0 !== this.height()
            },
            align: function(t, i, n) {
                var e = i + 1,
                    o = i + 2,
                    s = i === mi ? pi : Wt,
                    r = this[s]();
                x(n, [Zt, ui]) ? (this[e] = t[e], this[o] = this[e] + r) : x(n, [ai, Vt]) ? (this[o] = t[o], this[e] = this[o] - r) : n === Et && (this[e] = t[e] + (t[s]() - r) / 2, this[o] = this[e] + r)
            }
        }), $i = Tt.extend({
            init: function(t, i, n, e, o) {
                this.center = t, this.innerRadius = i, this.radius = n, this.startAngle = e, this.angle = o
            },
            clone: function() {
                return new $i(this.center, this.innerRadius, this.radius, this.startAngle, this.angle)
            },
            middle: function() {
                return this.startAngle + this.angle / 2
            },
            setRadius: function(t, i) {
                return i ? this.innerRadius = t : this.radius = t, this
            },
            point: function(t, i) {
                var n = Xi(t),
                    e = Math.cos(n),
                    o = Math.sin(n),
                    s = i ? this.innerRadius : this.radius,
                    r = qi(this.center.x - e * s, Dt),
                    a = qi(this.center.y - o * s, Dt);
                return new Ji(r, a)
            },
            adjacentBox: function(t, i, n) {
                var e = this.clone().expand(t),
                    o = e.middle(),
                    s = e.point(o),
                    r = i / 2,
                    a = n / 2,
                    l = Math.sin(Xi(o)),
                    h = Math.cos(Xi(o)),
                    u = s.x - r,
                    c = s.y - a;
                return Math.abs(l) < .9 && (u += r * -h / Math.abs(h)), Math.abs(h) < .9 && (c += a * -l / Math.abs(l)), new Zi(u, c, u + i, c + n)
            },
            containsPoint: function(t) {
                var i = this.center,
                    n = this.innerRadius,
                    e = this.radius,
                    o = this.startAngle,
                    r = this.startAngle + this.angle,
                    a = t.x - i.x,
                    l = t.y - i.y,
                    h = new Ji(a, l),
                    u = this.point(o),
                    c = new Ji(u.x - i.x, u.y - i.y),
                    f = this.point(r),
                    d = new Ji(f.x - i.x, f.y - i.y),
                    p = qi(a * a + l * l, Dt);
                return (c.equals(h) || s(c, h)) && !s(d, h) && p >= n * n && p <= e * e
            },
            getBBox: function() {
                var t, i, n, e = this,
                    o = new Zi($t, $t, ti, ti),
                    s = qi(this.startAngle % 360),
                    r = qi((s + this.angle) % 360),
                    a = this.innerRadius,
                    l = [0, 90, 180, 270, s, r].sort(S),
                    h = l.indexOf(s),
                    u = l.indexOf(r);
                for (t = s === r ? l : h < u ? l.slice(h, u + 1) : [].concat(l.slice(0, u + 1), l.slice(h, l.length)), i = 0; i < t.length; i++) n = e.point(t[i]), o.wrapPoint(n), o.wrapPoint(n, a);
                return a || o.wrapPoint(this.center), o
            },
            expand: function(t) {
                return this.radius += t, this
            }
        }), tn = $i.extend({
            init: function(t, i, n, e) {
                $i.fn.init.call(this, t, 0, i, n, e)
            },
            expand: function(t) {
                return $i.fn.expand.call(this, t)
            },
            clone: function() {
                return new tn(this.center, this.radius, this.startAngle, this.angle)
            },
            setRadius: function(t) {
                return this.radius = t, this
            }
        }), nn = .001, en = Tt.extend({
            createRing: function(t, i) {
                var n, e, o, s, r, a, l = t.startAngle + 180,
                    h = t.angle + l;
                return t.angle > 0 && l === h && (h += nn), n = new St.Point(t.center.x, t.center.y), e = Math.max(t.radius, 0), o = Math.max(t.innerRadius, 0), s = new St.Arc(n, {
                    startAngle: l,
                    endAngle: h,
                    radiusX: e,
                    radiusY: e
                }), r = Mt.fromArc(s, i).close(), o ? (s.radiusX = s.radiusY = o, a = s.pointAt(h), r.lineTo(a.x, a.y), r.arc(h, l, o, o, !0)) : r.lineTo(n.x, n.y), r
            }
        }), en.current = new en, on = Tt.extend({
            init: function(t) {
                this.children = [], this.options = It({}, this.options, this.initUserOptions(t))
            },
            initUserOptions: function(t) {
                return t
            },
            reflow: function(t) {
                var i, n, e, o = this.children;
                for (n = 0; n < o.length; n++) e = o[n], e.reflow(t), i = i ? i.wrap(e.box) : e.box.clone();
                this.box = i || t
            },
            destroy: function() {
                var t, i = this.children;
                for (this.animation && this.animation.destroy(), t = 0; t < i.length; t++) i[t].destroy()
            },
            getRoot: function() {
                var t = this.parent;
                return t ? t.getRoot() : null
            },
            getSender: function() {
                var t = this.getService();
                if (t) return t.sender
            },
            getService: function() {
                for (var t = this; t;) {
                    if (t.chartService) return t.chartService;
                    t = t.parent
                }
            },
            translateChildren: function(t, i) {
                var n, e = this.children,
                    o = e.length;
                for (n = 0; n < o; n++) e[n].box.translate(t, i)
            },
            append: function() {
                var t, i, n = arguments,
                    e = this;
                for (t = 0; t < arguments.length; t++) i = n[t], e.children.push(i), i.parent = e
            },
            renderVisual: function() {
                this.options.visible !== !1 && (this.createVisual(), this.addVisual(), this.renderChildren(), this.createAnimation(), this.renderComplete())
            },
            addVisual: function() {
                this.visual && (this.visual.chartElement = this, this.parent && this.parent.appendVisual(this.visual))
            },
            renderChildren: function() {
                var t, i = this.children,
                    n = i.length;
                for (t = 0; t < n; t++) i[t].renderVisual()
            },
            createVisual: function() {
                this.visual = new kt({
                    zIndex: this.options.zIndex,
                    visible: Wi(this.options.visible, !0)
                })
            },
            createAnimation: function() {
                this.visual && this.options.animation && (this.animation = yt.Animation.create(this.visual, this.options.animation))
            },
            appendVisual: function(t) {
                t.chartElement || (t.chartElement = this), t.options.noclip ? this.clipRoot().visual.append(t) : Vi(t.options.zIndex) ? this.stackRoot().stackVisual(t) : this.isStackRoot ? this.stackVisual(t) : this.visual ? this.visual.append(t) : this.parent.appendVisual(t)
            },
            clipRoot: function() {
                return this.parent ? this.parent.clipRoot() : this
            },
            stackRoot: function() {
                return this.parent ? this.parent.stackRoot() : this
            },
            stackVisual: function(t) {
                var i, n, e, o = t.options.zIndex || 0,
                    s = this.visual.children,
                    r = s.length;
                for (i = 0; i < r && (n = s[i], e = Wi(n.options.zIndex, 0), !(e > o)); i++);
                this.visual.insert(i, t)
            },
            traverse: function(t) {
                var i, n, e = this.children,
                    o = e.length;
                for (i = 0; i < o; i++) n = e[i], t(n), n.traverse && n.traverse(t)
            },
            closest: function(t) {
                for (var i = this, n = !1; i && !n;) n = t(i), n || (i = i.parent);
                if (n) return i
            },
            renderComplete: function() {},
            hasHighlight: function() {
                var t = (this.options || {}).highlight;
                return !(!this.createHighlight || t && t.visible === !1)
            },
            toggleHighlight: function(i) {
                var n, e = this,
                    o = (this.options || {}).highlight || {},
                    s = o.visual,
                    r = this._highlight;
                if (!r) {
                    if (n = {
                            fill: {
                                color: di,
                                opacity: .2
                            },
                            stroke: {
                                color: di,
                                width: 1,
                                opacity: .2
                            }
                        }, s) {
                        if (r = this._highlight = s(t.extend(this.highlightVisualArgs(), {
                                createVisual: function() {
                                    return e.createHighlight(n)
                                },
                                sender: this.getSender(),
                                series: this.series,
                                dataItem: this.dataItem,
                                category: this.category,
                                value: this.value,
                                percentage: this.percentage,
                                runningTotal: this.runningTotal,
                                total: this.total
                            })), !r) return
                    } else r = this._highlight = this.createHighlight(n);
                    Vi(r.options.zIndex) || (r.options.zIndex = Wi(o.zIndex, this.options.zIndex)), this.appendVisual(r)
                }
                r.visible(i)
            },
            createGradientOverlay: function(i, n, e) {
                var o = new Mt(t.extend({
                    stroke: {
                        color: "none"
                    },
                    fill: this.createGradient(e),
                    closed: i.options.closed
                }, n));
                return o.segments.elements(i.segments.elements()), o
            },
            createGradient: function(t) {
                if (this.parent) return this.parent.createGradient(t)
            }
        }), on.prototype.options = {}, sn = on.extend({
            init: function(t) {
                on.fn.init.call(this, t), this.options.margin = d(this.options.margin), this.options.padding = d(this.options.padding)
            },
            reflow: function(t) {
                var i, n, e, o, s = this,
                    r = this.options,
                    a = r.width,
                    l = r.height,
                    h = r.shrinkToFit,
                    u = a && l,
                    c = r.margin,
                    f = r.padding,
                    d = r.border.width,
                    p = function() {
                        s.align(t, mi, r.align), s.align(t, gi, r.vAlign), s.paddingBox = i.clone().unpad(c).unpad(d)
                    },
                    m = t.clone();
                for (u && (m.x2 = m.x1 + a, m.y2 = m.y1 + l), h && m.unpad(c).unpad(d).unpad(f), on.fn.reflow.call(this, m), i = u ? this.box = new Zi(0, 0, a, l) : this.box, h && u ? (p(), m = this.contentBox = this.paddingBox.clone().unpad(f)) : (m = this.contentBox = i.clone(), i.pad(f).pad(d).pad(c), p()), this.translateChildren(i.x1 - m.x1 + c.left + d + f.left, i.y1 - m.y1 + c.top + d + f.top), n = this.children, e = 0; e < n.length; e++) o = n[e], o.reflow(o.box)
            },
            align: function(t, i, n) {
                this.box.align(t, i, n)
            },
            hasBox: function() {
                var t = this.options;
                return t.border.width || t.background
            },
            createVisual: function() {
                on.fn.createVisual.call(this);
                var t = this.options;
                t.visible && this.hasBox() && this.visual.append(Mt.fromRect(this.paddingBox.toRect(), this.visualStyle()))
            },
            visualStyle: function() {
                var t = this.options,
                    i = t.border || {};
                return {
                    stroke: {
                        width: i.width,
                        color: i.color,
                        opacity: Wi(i.opacity, t.opacity),
                        dashType: i.dashType
                    },
                    fill: {
                        color: t.background,
                        opacity: t.opacity
                    },
                    cursor: t.cursor
                }
            }
        }), w(sn, {
            align: Zt,
            vAlign: ui,
            margin: {},
            padding: {},
            border: {
                color: zt,
                width: 0
            },
            background: "",
            shrinkToFit: !1,
            width: 0,
            height: 0,
            visible: !0
        }), rn = sn.extend({
            init: function(t, i) {
                sn.fn.init.call(this, t), this.pointData = i
            },
            getElement: function() {
                var t, i, n = this,
                    e = n.options,
                    o = n.paddingBox,
                    s = e.type,
                    r = e.rotation,
                    a = o.center(),
                    l = o.width() / 2;
                return e.visible && this.hasBox() ? (t = this.visualStyle(), s === Ot ? i = new yt.Circle(new Ut([qi(o.x1 + l, Dt), qi(o.y1 + o.height() / 2, Dt)], l), t) : s === ci ? i = Mt.fromPoints([
                    [o.x1 + l, o.y1],
                    [o.x1, o.y2],
                    [o.x2, o.y2]
                ], t).close() : s === Gt ? (i = new yt.MultiPath(t), i.moveTo(o.x1, o.y1).lineTo(o.x2, o.y2), i.moveTo(o.x1, o.y2).lineTo(o.x2, o.y1)) : i = Mt.fromRect(o.toRect(), t), r && i.transform(Lt().rotate(-r, [a.x, a.y])), i.options.zIndex = e.zIndex, i) : null
            },
            createElement: function() {
                var t, i = this,
                    n = this.options.visual,
                    e = this.pointData || {};
                return t = n ? n({
                    value: e.value,
                    dataItem: e.dataItem,
                    sender: this.getSender(),
                    series: e.series,
                    category: e.category,
                    rect: this.paddingBox.toRect(),
                    options: this.visualOptions(),
                    createVisual: function() {
                        return i.getElement()
                    }
                }) : this.getElement()
            },
            visualOptions: function() {
                var t = this.options;
                return {
                    background: t.background,
                    border: t.border,
                    margin: t.margin,
                    padding: t.padding,
                    type: t.type,
                    size: t.width,
                    visible: t.visible
                }
            },
            createVisual: function() {
                this.visual = this.createElement()
            }
        }), w(rn, {
            type: Ot,
            align: Et,
            vAlign: Et
        }), an = "linear", ln = "radial", hn = {
            glass: {
                type: an,
                rotation: 0,
                stops: [{
                    offset: 0,
                    color: di,
                    opacity: 0
                }, {
                    offset: .25,
                    color: di,
                    opacity: .3
                }, {
                    offset: 1,
                    color: di,
                    opacity: 0
                }]
            },
            sharpBevel: {
                type: ln,
                stops: [{
                    offset: 0,
                    color: di,
                    opacity: .55
                }, {
                    offset: .65,
                    color: di,
                    opacity: 0
                }, {
                    offset: .95,
                    color: di,
                    opacity: .25
                }]
            },
            roundedBevel: {
                type: ln,
                stops: [{
                    offset: .33,
                    color: di,
                    opacity: .06
                }, {
                    offset: .83,
                    color: di,
                    opacity: .2
                }, {
                    offset: .95,
                    color: di,
                    opacity: 0
                }]
            },
            roundedGlass: {
                type: ln,
                supportVML: !1,
                stops: [{
                    offset: 0,
                    color: di,
                    opacity: 0
                }, {
                    offset: .5,
                    color: di,
                    opacity: .3
                }, {
                    offset: .99,
                    color: di,
                    opacity: 0
                }]
            },
            sharpGlass: {
                type: ln,
                supportVML: !1,
                stops: [{
                    offset: 0,
                    color: di,
                    opacity: .2
                }, {
                    offset: .15,
                    color: di,
                    opacity: .15
                }, {
                    offset: .17,
                    color: di,
                    opacity: .35
                }, {
                    offset: .85,
                    color: di,
                    opacity: .05
                }, {
                    offset: .87,
                    color: di,
                    opacity: .15
                }, {
                    offset: .99,
                    color: di,
                    opacity: 0
                }]
            },
            bubbleShadow: {
                type: ln,
                center: [.5, .5],
                radius: .5
            }
        }, un = on.extend({
            init: function(t) {
                on.fn.init.call(this, t);
                var i = this.options;
                i.width = parseInt(i.width, 10), i.height = parseInt(i.height, 10), this.gradients = {}
            },
            reflow: function() {
                var t, i = this,
                    n = i.options,
                    e = i.children,
                    o = new Zi(0, 0, n.width, n.height);
                for (this.box = o.unpad(n.margin), t = 0; t < e.length; t++) e[t].reflow(o), o = R(o, e[t].box) || new Zi
            },
            createVisual: function() {
                this.visual = new kt, this.createBackground()
            },
            createBackground: function() {
                var t = this.options,
                    i = t.border || {},
                    n = this.box.clone().pad(t.margin).unpad(i.width),
                    e = Mt.fromRect(n.toRect(), {
                        stroke: {
                            color: i.width ? i.color : "",
                            width: i.width,
                            dashType: i.dashType
                        },
                        fill: {
                            color: t.background,
                            opacity: t.opacity
                        },
                        zIndex: -10
                    });
                this.visual.append(e)
            },
            getRoot: function() {
                return this
            },
            createGradient: function(i) {
                var n, e, o = this.gradients,
                    s = Yi(i),
                    r = hn[i.gradient];
                return o[s] ? n = o[s] : (e = t.extend({}, r, i), "linear" === r.type ? n = new yt.LinearGradient(e) : (i.innerRadius && (e.stops = U(e)), n = new yt.RadialGradient(e), n.supportVML = r.supportVML !== !1), o[s] = n), n
            },
            cleanGradients: function() {
                var t, i = this.gradients;
                for (t in i) i[t]._observers = []
            },
            size: function() {
                var t = this.options;
                return new Zi(0, 0, t.width, t.height)
            }
        }), w(un, {
            width: Xt,
            height: Ht,
            background: di,
            border: {
                color: zt,
                width: 0
            },
            margin: d(5),
            zIndex: -2
        }), cn = on.extend({
            init: function(t) {
                on.fn.init.call(this, t), this._initDirection()
            },
            _initDirection: function() {
                var t = this.options;
                t.vertical ? (this.groupAxis = mi, this.elementAxis = gi, this.groupSizeField = pi, this.elementSizeField = Wt, this.groupSpacing = t.spacing, this.elementSpacing = t.vSpacing) : (this.groupAxis = gi, this.elementAxis = mi, this.groupSizeField = Wt, this.elementSizeField = pi, this.groupSpacing = t.vSpacing, this.elementSpacing = t.spacing)
            },
            reflow: function(t) {
                this.box = t.clone(), this.reflowChildren()
            },
            reflowChildren: function() {
                var t, i, n, e, o, s, r, a, l, h, u, c = this,
                    f = this,
                    d = f.box,
                    p = f.elementAxis,
                    m = f.groupAxis,
                    g = f.elementSizeField,
                    x = f.groupSizeField,
                    v = this.groupOptions(),
                    b = v.groups,
                    y = v.groupsSize,
                    w = v.maxGroupElementsSize,
                    M = b.length,
                    k = d[m + 1] + this.alignStart(y, d[x]());
                if (M) {
                    for (t = k, i = 0; i < M; i++) {
                        for (n = b[i], e = n.groupElements, o = d[p + 1], s = e.length, r = 0; r < s; r++) a = e[r], l = c.elementSize(a), h = t + c.alignStart(l[x], n.groupSize), u = new Zi, u[m + 1] = h, u[m + 2] = h + l[x], u[p + 1] = o, u[p + 2] = o + l[g], a.reflow(u), o += l[g] + c.elementSpacing;
                        t += n.groupSize + c.groupSpacing
                    }
                    d[m + 1] = k, d[m + 2] = k + y, d[p + 2] = d[p + 1] + w
                }
            },
            alignStart: function(t, i) {
                var n = 0,
                    e = this.options.align;
                return e === ai || e === Vt ? n = i - t : e === Et && (n = (i - t) / 2), n
            },
            groupOptions: function() {
                var t, i, n, e = this,
                    o = this,
                    s = o.box,
                    r = o.children,
                    a = o.elementSizeField,
                    l = o.groupSizeField,
                    h = o.elementSpacing,
                    u = o.groupSpacing,
                    c = qi(s[a]()),
                    f = r.length,
                    d = [],
                    p = 0,
                    m = 0,
                    g = 0,
                    x = 0,
                    v = [];
                for (t = 0; t < f; t++) i = r[t], i.box || i.reflow(s), n = e.elementSize(i), e.options.wrap && qi(m + h + n[a]) > c && (d.push({
                    groupElements: v,
                    groupSize: p,
                    groupElementsSize: m
                }), x = Math.max(x, m), g += u + p, p = 0, m = 0, v = []), p = Math.max(p, n[l]), m > 0 && (m += h), m += n[a], v.push(i);
                return d.push({
                    groupElements: v,
                    groupSize: p,
                    groupElementsSize: m
                }), x = Math.max(x, m), g += p, {
                    groups: d,
                    groupsSize: g,
                    maxGroupElementsSize: x
                }
            },
            elementSize: function(t) {
                return {
                    width: t.box.width(),
                    height: t.box.height()
                }
            },
            createVisual: function() {}
        }), w(cn, {
            vertical: !0,
            wrap: !0,
            vSpacing: 0,
            spacing: 0
        }), fn = yt.Text, dn = on.extend({
            init: function(t, i) {
                on.fn.init.call(this, i), this.content = t, this.reflow(new Zi)
            },
            reflow: function(t) {
                var i = this.options,
                    n = i.size = wt.measureText(this.content, {
                        font: i.font
                    });
                this.baseline = n.baseline, this.box = new Zi(t.x1, t.y1, t.x1 + n.width, t.y1 + n.height)
            },
            createVisual: function() {
                var t = this.options,
                    i = t.font,
                    n = t.color,
                    e = t.opacity,
                    o = t.cursor;
                this.visual = new fn(this.content, this.box.toRect().topLeft(), {
                    font: i,
                    fill: {
                        color: n,
                        opacity: e
                    },
                    cursor: o
                })
            }
        }), w(dn, {
            font: Nt,
            color: zt
        }), pn = /\n/m, mn = sn.extend({
            init: function(t, i, n) {
                sn.fn.init.call(this, i), this.content = t, this.data = n, this._initContainer(), this.options._autoReflow !== !1 && this.reflow(new Zi)
            },
            _initContainer: function() {
                var t, i, n = this.options,
                    e = (this.content + "").split(pn),
                    o = new cn({
                        vertical: !0,
                        align: n.align,
                        wrap: !1
                    }),
                    s = It({}, n, {
                        opacity: 1,
                        animation: null
                    });
                for (this.container = o, this.append(o), t = 0; t < e.length; t++) i = new dn(e[t].trim(), s), o.append(i)
            },
            reflow: function(t) {
                var i, n, e, o, s = this.options,
                    r = s.visual;
                this.container.options.align = s.align, r && !this._boxReflow ? (i = t, i.hasSize() || (this._boxReflow = !0, this.reflow(i), this._boxReflow = !1, i = this.box), n = this.visual = r(this.visualContext(i)), n && (i = L(n.clippedBBox() || new Rt), n.options.zIndex = s.zIndex), this.box = this.contentBox = this.paddingBox = i) : (sn.fn.reflow.call(this, t), s.rotation && (e = d(s.margin), o = this.box.unpad(e), this.targetBox = t, this.normalBox = o.clone(), o = this.rotate(), o.translate(e.left - e.right, e.top - e.bottom), this.rotatedBox = o.clone(), o.pad(e)))
            },
            createVisual: function() {
                var t, i = this.options;
                this.visual = new kt({
                    transform: this.rotationTransform(),
                    zIndex: i.zIndex,
                    noclip: i.noclip
                }), this.hasBox() && (t = Mt.fromRect(this.paddingBox.toRect(), this.visualStyle()), this.visual.append(t))
            },
            renderVisual: function() {
                if (this.options.visible)
                    if (this.options.visual) {
                        var t = this.visual;
                        t && !Vi(t.options.noclip) && (t.options.noclip = this.options.noclip), this.addVisual(), this.createAnimation()
                    } else sn.fn.renderVisual.call(this)
            },
            visualContext: function(i) {
                var n = this,
                    e = {
                        text: this.content,
                        rect: i.toRect(),
                        sender: this.getSender(),
                        options: this.options,
                        createVisual: function() {
                            return n._boxReflow = !0, n.reflow(i), n._boxReflow = !1, n.getDefaultVisual()
                        }
                    };
                return this.data && t.extend(e, this.data), e
            },
            getDefaultVisual: function() {
                this.createVisual(), this.renderChildren();
                var t = this.visual;
                return delete this.visual, t
            },
            rotate: function() {
                var t = this.options;
                return this.box.rotate(t.rotation), this.align(this.targetBox, mi, t.align), this.align(this.targetBox, gi, t.vAlign), this.box
            },
            rotationTransform: function() {
                var t, i, n, e, o = this.options.rotation;
                return o ? (t = this.normalBox.center(), i = t.x, n = t.y, e = this.rotatedBox.center(), Lt().translate(e.x - i, e.y - n).rotate(o, [i, n])) : null
            }
        }), gn = on.extend({
            init: function(i) {
                on.fn.init.call(this, i), this.append(new mn(this.options.text, t.extend({}, this.options, {
                    vAlign: this.options.position
                })))
            },
            reflow: function(t) {
                on.fn.reflow.call(this, t), this.box.snapTo(t, mi)
            }
        }), gn.buildTitle = function(i, n, e) {
            var o, s = i;
            return "string" == typeof i && (s = {
                text: i
            }), s = t.extend({
                visible: !0
            }, e, s), s && s.visible && s.text && (o = new gn(s), n.append(o)), o
        }, w(gn, {
            color: zt,
            position: ui,
            align: Et,
            margin: d(5),
            padding: d(5)
        }), xn = mn.extend({
            init: function(t, i, n, e, o) {
                mn.fn.init.call(this, i, o), this.text = i, this.value = t, this.index = n, this.dataItem = e, this.reflow(new Zi)
            },
            visualContext: function(t) {
                var i = mn.fn.visualContext.call(this, t);
                return i.value = this.value, i.dataItem = this.dataItem, i.format = this.options.format, i.culture = this.options.culture, i
            },
            click: function(t, i) {
                t.trigger(_t, {
                    element: Gi(i),
                    value: this.value,
                    text: this.text,
                    index: this.index,
                    dataItem: this.dataItem,
                    axis: this.parent.options
                })
            },
            rotate: function() {
                var t, i;
                return this.options.alignRotation !== Et ? (t = this.normalBox.toRect(), i = this.rotationTransform(), this.box = L(t.bbox(i.matrix()))) : mn.fn.rotate.call(this), this.box
            },
            rotationTransform: function() {
                var t, i, n, e, o, s, r, a, l, h, u, c, f, d, p, m, g, x, v = this.options,
                    b = v.rotation;
                return b ? v.alignRotation === Et ? mn.fn.rotationTransform.call(this) : (t = Lt().rotate(b).matrix(), i = this.normalBox.toRect(), n = this.targetBox.toRect(), e = v.rotationOrigin || ui, o = e === ui || e === Vt ? mi : gi, s = e === ui || e === Vt ? gi : mi, r = e === ui || e === Zt ? n.origin : n.bottomRight(), a = i.topLeft().transformCopy(t), l = i.topRight().transformCopy(t), h = i.bottomRight().transformCopy(t), u = i.bottomLeft().transformCopy(t), c = Rt.fromPoints(a, l, h, u), f = {}, f[s] = n.origin[s] - c.origin[s], d = Math.abs(a[s] + f[s] - r[s]), p = Math.abs(l[s] + f[s] - r[s]), qi(d, Yt) === qi(p, Yt) ? (m = a, g = l) : p < d ? (m = l, g = h) : (m = a, g = u), x = m[o] + (g[o] - m[o]) / 2, f[o] = n.center()[o] - x, Lt().translate(f.x, f.y).rotate(b)) : null
            }
        }), w(xn, {
            _autoReflow: !1
        }), vn = 7, bn = "#fff", yn = sn.extend({
            init: function(t, i, n) {
                sn.fn.init.call(this, i), this.fields = t, this.chartService = n, this.render()
            },
            hide: function() {
                this.options.visible = !1
            },
            show: function() {
                this.options.visible = !0
            },
            render: function() {
                var t, i, n, e, o, s, r, a, l, h, u = this,
                    c = this.options;
                c.visible && (t = c.label, i = c.icon, n = new Zi, e = function() {
                    return u
                }, o = i.size, s = this.fields.text, Vi(t) && t.visible && (l = p(t), l ? s = l(this.fields) : t.format && (s = this.chartService.format.auto(t.format, s)), t.color || (t.color = t.position === Jt ? bn : i.background), this.label = new mn(s, It({}, t)), this.label.aliasFor = e, t.position !== Jt || Vi(o) || (i.type === Ot ? o = Math.max(this.label.box.width(), this.label.box.height()) : (r = this.label.box.width(), a = this.label.box.height()), n.wrap(this.label.box))), i.width = r || o || vn, i.height = a || o || vn, h = new rn(It({}, i)), h.aliasFor = e, this.marker = h, this.append(h), this.label && this.append(this.label), h.reflow(new Zi), this.wrapperBox = n.wrap(h.box))
            },
            reflow: function(t) {
                var i, n, e, o = this,
                    s = o.options,
                    r = o.label,
                    a = o.marker,
                    l = o.wrapperBox,
                    h = t.center(),
                    u = s.line.length,
                    c = s.position;
                s.visible && (x(c, [Zt, ai]) ? c === Zt ? (e = l.alignTo(t, c).translate(-u, t.center().y - l.center().y), s.line.visible && (i = [t.x1, h.y], this.linePoints = [i, [e.x2, h.y]], n = e.clone().wrapPoint(i))) : (e = l.alignTo(t, c).translate(u, t.center().y - l.center().y), s.line.visible && (i = [t.x2, h.y], this.linePoints = [i, [e.x1, h.y]], n = e.clone().wrapPoint(i))) : c === Vt ? (e = l.alignTo(t, c).translate(t.center().x - l.center().x, u), s.line.visible && (i = [h.x, t.y2], this.linePoints = [i, [h.x, e.y1]], n = e.clone().wrapPoint(i))) : (e = l.alignTo(t, c).translate(t.center().x - l.center().x, -u), s.line.visible && (i = [h.x, t.y1], this.linePoints = [i, [h.x, e.y2]], n = e.clone().wrapPoint(i))), a && a.reflow(e), r && (r.reflow(e), a && (s.label.position === ri && r.box.alignTo(a.box, c), r.reflow(r.box))), this.contentBox = e, this.targetBox = t, this.box = n || e)
            },
            createVisual: function() {
                sn.fn.createVisual.call(this), this.visual.options.noclip = this.options.noclip, this.options.visible && this.createLine()
            },
            renderVisual: function() {
                var i = this,
                    n = this.options,
                    e = n.visual;
                n.visible && e ? (this.visual = e(t.extend(this.fields, {
                    sender: this.getSender(),
                    rect: this.targetBox.toRect(),
                    options: {
                        background: n.background,
                        border: n.background,
                        icon: n.icon,
                        label: n.label,
                        line: n.line,
                        position: n.position,
                        visible: n.visible
                    },
                    createVisual: function() {
                        i.createVisual(), i.renderChildren();
                        var t = i.visual;
                        return delete i.visual, t
                    }
                })), this.addVisual()) : sn.fn.renderVisual.call(this)
            },
            createLine: function() {
                var t, i = this.options.line;
                this.linePoints && (t = Mt.fromPoints(this.linePoints, {
                    stroke: {
                        color: i.color,
                        width: i.width,
                        dashType: i.dashType
                    }
                }), o(t), this.visual.append(t))
            },
            click: function(t, i) {
                var n = this.eventArgs(i);
                t.trigger(ni, n) || i.preventDefault()
            },
            over: function(t, i) {
                var n = this.eventArgs(i);
                t.trigger(ei, n) || i.preventDefault()
            },
            out: function(t, i) {
                var n = this.eventArgs(i);
                t.trigger(oi, n)
            },
            eventArgs: function(i) {
                var n = this.options;
                return t.extend(this.fields, {
                    element: Gi(i),
                    text: Vi(n.label) ? n.label.text : "",
                    visual: this.visual
                })
            }
        }), w(yn, {
            icon: {
                visible: !0,
                type: Ot
            },
            label: {
                position: Jt,
                visible: !0,
                align: Et,
                vAlign: Et
            },
            line: {
                visible: !0
            },
            visible: !0,
            position: ui,
            zIndex: 2
        }), wn = on.extend({
            init: function(t, i) {
                void 0 === i && (i = new Si), on.fn.init.call(this, t), this.chartService = i, this.options.visible || (this.options = It({}, this.options, {
                    labels: {
                        visible: !1
                    },
                    line: {
                        visible: !1
                    },
                    margin: 0,
                    majorTickSize: 0,
                    minorTickSize: 0
                })), this.options.minorTicks = It({}, {
                    color: this.options.line.color,
                    width: this.options.line.width,
                    visible: this.options.minorTickType !== ii
                }, this.options.minorTicks, {
                    size: this.options.minorTickSize,
                    align: this.options.minorTickType
                }), this.options.majorTicks = It({}, {
                    color: this.options.line.color,
                    width: this.options.line.width,
                    visible: this.options.majorTickType !== ii
                }, this.options.majorTicks, {
                    size: this.options.majorTickSize,
                    align: this.options.majorTickType
                }), this.initFields(), this.options._deferLabels || this.createLabels(), this.createTitle(), this.createNotes()
            },
            initFields: function() {},
            labelsRange: function() {
                return {
                    min: this.options.labels.skip,
                    max: this.labelsCount()
                }
            },
            createLabels: function() {
                var t, i, n, e, o = this,
                    s = this.options,
                    r = s.vertical ? ai : Et,
                    a = It({}, s.labels, {
                        align: r,
                        zIndex: s.zIndex
                    }),
                    l = Math.max(1, a.step);
                if (this.clearLabels(), a.visible)
                    for (t = this.labelsRange(), i = a.rotation, h(i) && (a.alignRotation = i.align, a.rotation = i.angle), "auto" === a.rotation && (a.rotation = 0, s.autoRotateLabels = !0), n = t.min; n < t.max; n += l) e = o.createAxisLabel(n, a), e && (o.append(e), o.labels.push(e))
            },
            clearLabels: function() {
                this.children = m(this.children, function(t) {
                    return !(t instanceof xn)
                }), this.labels = []
            },
            clearTitle: function() {
                var t = this;
                this.title && (this.children = m(this.children, function(i) {
                    return i !== t.title
                }), this.title = void 0)
            },
            clear: function() {
                this.clearLabels(), this.clearTitle()
            },
            lineBox: function() {
                var t = this,
                    i = t.options,
                    n = t.box,
                    e = i.vertical,
                    o = i.labels.mirror,
                    s = o ? n.x1 : n.x2,
                    r = o ? n.y2 : n.y1,
                    a = i.line.width || 0;
                return e ? new Zi(s, n.y1, s, n.y2 - a) : new Zi(n.x1, r, n.x2 - a, r)
            },
            createTitle: function() {
                var t, i = this.options,
                    n = It({
                        rotation: i.vertical ? -90 : 0,
                        text: "",
                        zIndex: 1,
                        visualSize: !0
                    }, i.title);
                n.visible && n.text && (t = new mn(n.text, n), this.append(t), this.title = t)
            },
            createNotes: function() {
                var t, i, n, e = this,
                    o = this.options,
                    s = o.notes,
                    r = s.data || [];
                for (this.notes = [], t = 0; t < r.length; t++) i = It({}, s, r[t]), i.value = e.parseNoteValue(i.value), n = new yn({
                    value: i.value,
                    text: i.label.text,
                    dataItem: i
                }, i, e.chartService), n.options.visible && (Vi(n.options.position) ? o.vertical && !x(n.options.position, [Zt, ai]) ? n.options.position = o.reverse ? Zt : ai : o.vertical || x(n.options.position, [ui, Vt]) || (n.options.position = o.reverse ? Vt : ui) : n.options.position = o.vertical ? o.reverse ? Zt : ai : o.reverse ? Vt : ui, e.append(n), e.notes.push(n))
            },
            parseNoteValue: function(t) {
                return t
            },
            renderVisual: function() {
                on.fn.renderVisual.call(this), this.createPlotBands()
            },
            createVisual: function() {
                on.fn.createVisual.call(this), this.createBackground(), this.createLine()
            },
            gridLinesVisual: function() {
                var t = this._gridLines;
                return t || (t = this._gridLines = new kt({
                    zIndex: -2
                }), this.appendVisual(this._gridLines)), t
            },
            createTicks: function(t) {
                function i(i, n, s) {
                    var a, l = i.length,
                        h = Math.max(1, n.step);
                    if (n.visible)
                        for (a = n.skip; a < l; a += h) Vi(s) && a % s === 0 || (r.tickX = o ? e.x2 : e.x2 - n.size, r.tickY = o ? e.y1 - n.size : e.y1, r.position = i[a], t.append(j(r, n)))
                }
                var n = this.options,
                    e = this.lineBox(),
                    o = n.labels.mirror,
                    s = n.majorTicks.visible ? n.majorUnit : 0,
                    r = {
                        vertical: n.vertical
                    };
                i(this.getMajorTickPositions(), n.majorTicks), i(this.getMinorTickPositions(), n.minorTicks, s / n.minorUnit)
            },
            createLine: function() {
                var t, i, n = this.options,
                    e = n.line,
                    s = this.lineBox();
                e.width > 0 && e.visible && (t = new Mt({
                    stroke: {
                        width: e.width,
                        color: e.color,
                        dashType: e.dashType
                    }
                }), t.moveTo(s.x1, s.y1).lineTo(s.x2, s.y2), n._alignLines && o(t), i = this._lineGroup = new kt, i.append(t), this.visual.append(i), this.createTicks(i))
            },
            getActualTickSize: function() {
                var t = this.options,
                    i = 0;
                return t.majorTicks.visible && t.minorTicks.visible ? i = Math.max(t.majorTicks.size, t.minorTicks.size) : t.majorTicks.visible ? i = t.majorTicks.size : t.minorTicks.visible && (i = t.minorTicks.size), i
            },
            createBackground: function() {
                var t = this,
                    i = t.options,
                    n = t.box,
                    e = i.background;
                e && (this._backgroundPath = Mt.fromRect(n.toRect(), {
                    fill: {
                        color: e
                    },
                    stroke: null
                }), this.visual.append(this._backgroundPath))
            },
            createPlotBands: function() {
                var t, i, n, e, o, s, r, a, l = this,
                    h = this.options,
                    u = h.plotBands || [],
                    c = h.vertical,
                    f = this.plotArea;
                if (0 !== u.length) {
                    for (t = this._plotbandGroup = new kt({
                            zIndex: -1
                        }), i = m(this.pane.axes, function(t) {
                            return t.options.vertical !== l.options.vertical
                        })[0], n = 0; n < u.length; n++) e = u[n], o = void 0, s = void 0, c ? (o = (i || f.axisX).lineBox(), s = l.getSlot(e.from, e.to, !0)) : (o = l.getSlot(e.from, e.to, !0), s = (i || f.axisY).lineBox()), 0 !== o.width() && 0 !== s.height() && (r = new Rt([o.x1, s.y1], [o.width(), s.height()]), a = Mt.fromRect(r, {
                        fill: {
                            color: e.color,
                            opacity: e.opacity
                        },
                        stroke: null
                    }), t.append(a));
                    this.appendVisual(t)
                }
            },
            createGridLines: function(t) {
                function i(t, i, n) {
                    var e, o, s = t.length,
                        r = Math.max(1, i.step);
                    if (i.visible)
                        for (e = i.skip; e < s; e += r) o = qi(t[e]), x(o, f) || e % n === 0 || a && u === o || (c.position = o, d.append(A(c, i)), f.push(o))
                }
                var n = this.options,
                    e = n.minorGridLines,
                    o = n.majorGridLines,
                    s = n.minorUnit,
                    r = n.vertical,
                    a = t.options.line.visible,
                    l = o.visible ? n.majorUnit : 0,
                    h = t.lineBox(),
                    u = h[r ? "y1" : "x1"],
                    c = {
                        lineStart: h[r ? "x1" : "y1"],
                        lineEnd: h[r ? "x2" : "y2"],
                        vertical: r
                    },
                    f = [],
                    d = this.gridLinesVisual();
                return i(this.getMajorTickPositions(), o), i(this.getMinorTickPositions(), e, l / s), d.children
            },
            reflow: function(t) {
                var i, n, e = this,
                    o = e.options,
                    s = e.labels,
                    r = e.title,
                    a = o.vertical,
                    l = s.length,
                    h = a ? pi : Wt,
                    u = r ? r.box[h]() : 0,
                    c = this.getActualTickSize() + o.margin + u,
                    f = (this.getRoot() || {}).box || t,
                    d = f[h](),
                    p = 0;
                for (i = 0; i < l; i++) n = s[i].box[h](), n + c <= d && (p = Math.max(p, n));
                this.box = a ? new Zi(t.x1, t.y1, t.x1 + p + c, t.y2) : new Zi(t.x1, t.y1, t.x2, t.y1 + p + c), this.arrangeTitle(), this.arrangeLabels(), this.arrangeNotes()
            },
            getLabelsTickPositions: function() {
                return this.getMajorTickPositions()
            },
            labelTickIndex: function(t) {
                return t.index
            },
            arrangeLabels: function() {
                var t, i, n, e, o, s, r, a, l, h, u, c = this,
                    f = this,
                    d = f.options,
                    p = f.labels,
                    m = this.labelsBetweenTicks(),
                    g = d.vertical,
                    x = this.lineBox(),
                    v = d.labels.mirror,
                    b = this.getLabelsTickPositions(),
                    y = this.getActualTickSize() + d.margin;
                for (t = 0; t < p.length; t++) i = p[t], n = c.labelTickIndex(i), e = g ? i.box.height() : i.box.width(), o = b[n] - e / 2, s = void 0, r = void 0, a = void 0, g ? (m && (r = b[n], a = b[n + 1], l = r + (a - r) / 2, o = l - e / 2), h = x.x2, v ? (h += y, i.options.rotationOrigin = Zt) : (h -= y + i.box.width(), i.options.rotationOrigin = ai), s = i.box.move(h, o)) : (m ? (r = b[n], a = b[n + 1]) : (r = o, a = o + e), u = x.y1, v ? (u -= y + i.box.height(), i.options.rotationOrigin = Vt) : (u += y, i.options.rotationOrigin = ui), s = new Zi(r, u, a, u + i.box.height())), i.reflow(s)
            },
            autoRotateLabels: function() {
                var t, i, n, e, o, s, r;
                if (this.options.autoRotateLabels && !this.options.vertical) {
                    for (t = this.getMajorTickPositions(), i = this.labels, e = 0; e < i.length; e++)
                        if (o = Math.abs(t[e + 1] - t[e]), s = i[e].box, s.width() > o) {
                            if (s.height() > o) {
                                n = -90;
                                break
                            }
                            n = -45
                        }
                    if (n) {
                        for (r = 0; r < i.length; r++) i[r].options.rotation = n, i[r].reflow(new Zi);
                        return !0
                    }
                }
            },
            arrangeTitle: function() {
                var t = this,
                    i = t.options,
                    n = t.title,
                    e = i.labels.mirror,
                    o = i.vertical;
                n && (o ? (n.options.align = e ? ai : Zt, n.options.vAlign = n.options.position) : (n.options.align = n.options.position, n.options.vAlign = e ? ui : Vt), n.reflow(this.box))
            },
            arrangeNotes: function() {
                var t, i, n, e, o = this;
                for (t = 0; t < this.notes.length; t++) i = o.notes[t], n = i.options.value, e = void 0, Vi(n) ? (o.shouldRenderNote(n) ? i.show() : i.hide(), e = o.noteSlot(n)) : i.hide(), i.reflow(e || o.lineBox())
            },
            noteSlot: function(t) {
                return this.getSlot(t)
            },
            alignTo: function(t) {
                var i = t.lineBox(),
                    n = this.options.vertical,
                    e = n ? gi : mi;
                this.box.snapTo(i, e), n ? this.box.shrink(0, this.lineBox().height() - i.height()) : this.box.shrink(this.lineBox().width() - i.width(), 0), this.box[e + 1] -= this.lineBox()[e + 1] - i[e + 1], this.box[e + 2] -= this.lineBox()[e + 2] - i[e + 2]
            },
            axisLabelText: function(t, i, n) {
                var e = p(n),
                    o = t;
                return e ? o = e({
                    value: t,
                    dataItem: i,
                    format: n.format,
                    culture: n.culture
                }) : n.format && (o = this.chartService.format.localeAuto(n.format, [t], n.culture)), o
            },
            slot: function(t, i, n) {
                var e = this.getSlot(t, i, n);
                if (e) return e.toRect()
            },
            contentBox: function() {
                var t, i, n, e = this.box.clone(),
                    o = this.labels;
                return o.length && (t = this.options.vertical ? gi : mi, this.chartService.isPannable(t) ? (i = this.maxLabelOffset(), e[t + 1] -= i.start, e[t + 2] += i.end) : (o[0].options.visible && e.wrap(o[0].box), n = o[o.length - 1], n.options.visible && e.wrap(n.box))), e
            },
            maxLabelOffset: function() {
                var t, i, n, e, o, s = this,
                    r = this.options,
                    a = r.vertical,
                    l = r.reverse,
                    h = this.labelsBetweenTicks(),
                    u = this.getLabelsTickPositions(),
                    c = a ? gi : mi,
                    f = this.labels,
                    d = l ? 1 : 0,
                    p = l ? 0 : 1,
                    m = 0,
                    g = 0;
                for (t = 0; t < f.length; t++) i = f[t], n = s.labelTickIndex(i), e = void 0, o = void 0, h ? (e = u[n + d], o = u[n + p]) : e = o = u[n], m = Math.max(m, e - i.box[c + 1]), g = Math.max(g, i.box[c + 2] - o);
                return {
                    start: m,
                    end: g
                }
            },
            limitRange: function(t, i, n, e, o) {
                var s, r, a, l = this.options;
                return t < n && o < 0 && (!Vi(l.min) || l.min <= n) || e < i && o > 0 && (!Vi(l.max) || e <= l.max) ? null : i < n && o > 0 || e < t && o < 0 ? {
                    min: t,
                    max: i
                } : (s = i - t, r = t, a = i, t < n && o < 0 ? (r = Hi(t, n, e), a = Hi(t + s, n + s, e)) : i > e && o > 0 && (a = Hi(i, n, e), r = Hi(i - s, n, e - s)), {
                    min: r,
                    max: a
                })
            },
            valueRange: function() {
                return {
                    min: this.seriesMin,
                    max: this.seriesMax
                }
            },
            labelsBetweenTicks: function() {
                return !this.options.justified
            },
            prepareUserOptions: function() {}
        }), w(wn, {
            labels: {
                visible: !0,
                rotation: 0,
                mirror: !1,
                step: 1,
                skip: 0
            },
            line: {
                width: 1,
                color: zt,
                visible: !0
            },
            title: {
                visible: !0,
                position: Et
            },
            majorTicks: {
                align: ri,
                size: 4,
                skip: 0,
                step: 1
            },
            minorTicks: {
                align: ri,
                size: 3,
                skip: 0,
                step: 1
            },
            axisCrossingValue: 0,
            majorTickType: ri,
            minorTickType: ii,
            majorGridLines: {
                skip: 0,
                step: 1
            },
            minorGridLines: {
                visible: !1,
                width: 1,
                color: zt,
                skip: 0,
                step: 1
            },
            margin: 5,
            visible: !0,
            reverse: !1,
            justified: !0,
            notes: {
                label: {
                    text: ""
                }
            },
            _alignLines: !0,
            _deferLabels: !1
        }), Mn = "milliseconds", kn = "seconds", Tn = "minutes", Sn = "hours", Rn = "days", Un = "weeks", Ln = "months", jn = "years", An = 1, In = 1e3, Bn = 60 * In, Cn = 60 * Bn, Pn = 24 * Cn, _n = 7 * Pn, zn = 31 * Pn, Vn = 365 * Pn, En = {
            years: Vn,
            months: zn,
            weeks: _n,
            days: Pn,
            hours: Cn,
            minutes: Bn,
            seconds: In,
            milliseconds: An
        }, On = .01, Dn = wn.extend({
            initFields: function() {
                this._ticks = {}
            },
            categoriesHash: function() {
                return ""
            },
            clone: function() {
                var i = new Dn(t.extend({}, this.options), this.chartService);
                return i.createLabels(), i
            },
            initUserOptions: function(t) {
                var i, n, e = t.categories || [],
                    o = Vi(t.min),
                    s = Vi(t.max);
                return t.srcCategories = t.categories = e, (o || s) && e.length && (i = o ? Math.floor(t.min) : 0, n = s ? t.justified ? Math.floor(t.max) + 1 : Math.ceil(t.max) : e.length, t.categories = t.categories.slice(i, n)), t
            },
            rangeIndices: function() {
                var t, i = this.options,
                    n = i.categories.length || 1,
                    e = r(i.min) ? i.min % 1 : 0;
                return t = r(i.max) && i.max % 1 !== 0 && i.max < this.totalRange().max ? n - (1 - i.max % 1) : n - (i.justified ? 1 : 0), {
                    min: e,
                    max: t
                }
            },
            totalRangeIndices: function(t) {
                var i, n, e = this.options,
                    o = r(e.min) ? e.min : 0;
                return i = r(e.max) ? e.max : r(e.min) ? o + e.categories.length : this.totalRange().max || 1, t && (n = this.totalRange(), o = Hi(o, 0, n.max), i = Hi(i, 0, n.max)), {
                    min: o,
                    max: i
                }
            },
            range: function() {
                var t = this.options,
                    i = r(t.min) ? t.min : 0,
                    n = r(t.max) ? t.max : this.totalRange().max;
                return {
                    min: i,
                    max: n
                }
            },
            roundedRange: function() {
                return this.range()
            },
            totalRange: function() {
                var t = this.options;
                return {
                    min: 0,
                    max: Math.max(this._seriesMax || 0, t.srcCategories.length) - (t.justified ? 1 : 0)
                }
            },
            scaleOptions: function() {
                var t = this.rangeIndices(),
                    i = t.min,
                    n = t.max,
                    e = this.lineBox(),
                    o = this.options.vertical ? e.height() : e.width(),
                    s = o / (n - i || 1);
                return {
                    scale: s * (this.options.reverse ? -1 : 1),
                    box: e,
                    min: i,
                    max: n
                }
            },
            arrangeLabels: function() {
                wn.fn.arrangeLabels.call(this), this.hideOutOfRangeLabels()
            },
            hideOutOfRangeLabels: function() {
                var t, i, n, e, o, s = this,
                    r = s.box,
                    a = s.labels;
                a.length && (t = this.options.vertical ? gi : mi, i = r[t + 1], n = r[t + 2], e = a[0], o = Ni(a), (e.box[t + 1] > n || e.box[t + 2] < i) && (e.options.visible = !1), (o.box[t + 1] > n || o.box[t + 2] < i) && (o.options.visible = !1))
            },
            getMajorTickPositions: function() {
                return this.getTicks().majorTicks
            },
            getMinorTickPositions: function() {
                return this.getTicks().minorTicks
            },
            getLabelsTickPositions: function() {
                return this.getTicks().labelTicks
            },
            tickIndices: function(t) {
                for (var i = this.rangeIndices(), n = i.min, e = i.max, o = Math.ceil(e), s = Math.floor(n), r = []; s <= o;) r.push(s), s += t;
                return r
            },
            getTickPositions: function(t) {
                var i, n = this.options,
                    e = n.vertical,
                    o = n.reverse,
                    s = this.scaleOptions(),
                    r = s.scale,
                    a = s.box,
                    l = s.min,
                    h = a[(e ? gi : mi) + (o ? 2 : 1)],
                    u = this.tickIndices(t),
                    c = [];
                for (i = 0; i < u.length; i++) c.push(h + qi(r * (u[i] - l), Dt));
                return c
            },
            getTicks: function() {
                var t, i = this.options,
                    n = this._ticks,
                    e = this.rangeIndices(),
                    o = this.lineBox(),
                    s = o.getHash() + e.min + "," + e.max + i.reverse + i.justified;
                return n._hash !== s && (t = i.minorTicks.visible || i.minorGridLines.visible, n._hash = s, n.labelTicks = this.getTickPositions(1), n.majorTicks = this.filterOutOfRangePositions(n.labelTicks, o), n.minorTicks = t ? this.filterOutOfRangePositions(this.getTickPositions(.5), o) : []), n
            },
            filterOutOfRangePositions: function(t, i) {
                var n, e, o, s, r;
                if (!t.length) return t;
                for (n = this.options.vertical ? gi : mi, e = function(t) {
                        return i[n + 1] <= t && t <= i[n + 2]
                    }, o = t.length - 1, s = 0; !e(t[s]) && s <= o;) s++;
                for (r = o; !e(t[r]) && r >= 0;) r--;
                return t.slice(s, r + 1)
            },
            getSlot: function(t, i, n) {
                var e, o, s = this.options,
                    r = s.reverse,
                    a = s.justified,
                    l = s.vertical,
                    h = this.scaleOptions(),
                    u = h.scale,
                    c = h.box,
                    f = h.min,
                    d = l ? gi : mi,
                    p = c[d + (r ? 2 : 1)],
                    m = c.clone(),
                    g = !Vi(i),
                    x = Wi(t, 0),
                    v = Wi(i, x);
                return v = Math.max(v - 1, x), v = Math.max(x, v), e = p + (x - f) * u, o = p + (v + 1 - f) * u, g && a && (o = e), n && (e = Hi(e, c[d + 1], c[d + 2]), o = Hi(o, c[d + 1], c[d + 2])), m[d + 1] = r ? o : e, m[d + 2] = r ? e : o, m
            },
            limitSlot: function(t) {
                var i = this.options.vertical,
                    n = i ? gi : mi,
                    e = this.lineBox(),
                    o = t.clone();
                return o[n + 1] = Hi(t[n + 1], e[n + 1], e[n + 2]), o[n + 2] = Hi(t[n + 2], e[n + 1], e[n + 2]), o
            },
            slot: function(t, i, n) {
                var e = Math.floor(this.options.min || 0),
                    o = t,
                    s = i;
                return "string" == typeof o ? o = this.categoryIndex(o) : r(o) && (o -= e), "string" == typeof s ? s = this.categoryIndex(s) : r(s) && (s -= e), wn.fn.slot.call(this, o, s, n)
            },
            pointCategoryIndex: function(t) {
                var i, n, e = this.options,
                    o = e.reverse,
                    s = e.justified,
                    r = e.vertical,
                    a = r ? gi : mi,
                    l = this.scaleOptions(),
                    h = l.scale,
                    u = l.box,
                    c = l.min,
                    f = l.max,
                    d = o ? f : c,
                    p = u[a + 1],
                    m = u[a + 2],
                    g = t[a];
                return g < p || g > m ? null : (i = d + (g - p) / h, n = i % 1, s ? i = Math.round(i) : 0 === n && i > 0 && i--, Math.floor(i))
            },
            getCategory: function(t) {
                var i = this.pointCategoryIndex(t);
                return null === i ? null : this.options.categories[i]
            },
            categoryIndex: function(t) {
                return this.totalIndex(t) - Math.floor(this.options.min || 0)
            },
            categoryAt: function(t, i) {
                var n = this.options;
                return (i ? n.srcCategories : n.categories)[t]
            },
            categoriesCount: function() {
                return (this.options.categories || []).length
            },
            translateRange: function(t) {
                var i = this.options,
                    n = this.lineBox(),
                    e = i.vertical ? n.height() : n.width(),
                    o = i.categories.length,
                    s = e / o,
                    r = qi(t / s, Yt);
                return {
                    min: r,
                    max: o + r
                }
            },
            zoomRange: function(t) {
                var i = this.totalRangeIndices(),
                    n = this.totalRange(),
                    e = n.min,
                    o = n.max,
                    s = Hi(i.min + t, e, o),
                    r = Hi(i.max - t, e, o);
                if (r - s > 0) return {
                    min: s,
                    max: r
                }
            },
            scaleRange: function(t) {
                var i = this.options.categories.length,
                    n = t * i;
                return {
                    min: -n,
                    max: i + n
                }
            },
            labelsCount: function() {
                var t = this.labelsRange();
                return t.max - t.min
            },
            labelsRange: function() {
                var t, i = this.options,
                    n = i.justified,
                    e = i.labels,
                    o = this.totalRangeIndices(!0),
                    s = o.min,
                    r = o.max,
                    a = Math.floor(s);
                return n ? (s = Math.ceil(s), r = Math.floor(r)) : (s = Math.floor(s), r = Math.ceil(r)), t = s > e.skip ? e.skip + e.step * Math.ceil((s - e.skip) / e.step) : e.skip, {
                    min: t - a,
                    max: (i.categories.length ? r + (n ? 1 : 0) : 0) - a
                }
            },
            createAxisLabel: function(t, i) {
                var n = this.options,
                    e = n.dataItems ? n.dataItems[t] : null,
                    o = Wi(n.categories[t], ""),
                    s = this.axisLabelText(o, e, i);
                return new xn(o, s, t, e, i)
            },
            shouldRenderNote: function(t) {
                var i = this.totalRangeIndices();
                return Math.floor(i.min) <= t && t <= Math.ceil(i.max)
            },
            noteSlot: function(t) {
                var i = this.options,
                    n = t - Math.floor(i.min || 0);
                return this.getSlot(n)
            },
            arrangeNotes: function() {
                wn.fn.arrangeNotes.call(this), this.hideOutOfRangeNotes()
            },
            hideOutOfRangeNotes: function() {
                var t, i, n, e, o, s = this,
                    r = s.notes,
                    a = s.box;
                if (r && r.length)
                    for (t = this.options.vertical ? gi : mi, i = a[t + 1], n = a[t + 2], e = 0; e < r.length; e++) o = r[e], o.box && (n < o.box[t + 1] || o.box[t + 2] < i) && o.hide()
            },
            pan: function(t) {
                var i = this.totalRangeIndices(!0),
                    n = this.scaleOptions(),
                    e = n.scale,
                    o = qi(t / e, Yt),
                    s = this.totalRange(),
                    r = i.min + o,
                    a = i.max + o;
                return this.limitRange(r, a, 0, s.max, o)
            },
            pointsRange: function(t, i) {
                var n = this.options,
                    e = n.reverse,
                    o = n.vertical,
                    s = o ? gi : mi,
                    r = this.totalRangeIndices(!0),
                    a = this.scaleOptions(),
                    l = a.scale,
                    h = a.box,
                    u = h[s + (e ? 2 : 1)],
                    c = t[s] - u,
                    f = i[s] - u,
                    d = r.min + c / l,
                    p = r.min + f / l,
                    m = Math.min(d, p),
                    g = Math.max(d, p);
                if (g - m >= On) return {
                    min: m,
                    max: g
                }
            },
            valueRange: function() {
                return this.range()
            },
            totalIndex: function(t) {
                var i = this.options,
                    n = this._categoriesMap ? this._categoriesMap.get(t) : Q(t, i.srcCategories);
                return n
            },
            currentRangeIndices: function() {
                var t, i = this.options,
                    n = 0;
                return r(i.min) && (n = Math.floor(i.min)), t = r(i.max) ? i.justified ? Math.floor(i.max) : Math.ceil(i.max) - 1 : this.totalCount() - 1, {
                    min: n,
                    max: t
                }
            },
            mapCategories: function() {
                var t, i, n;
                if (!this._categoriesMap)
                    for (t = this._categoriesMap = new Ii, i = this.options.srcCategories, n = 0; n < i.length; n++) t.set(i[n], n)
            },
            totalCount: function() {
                return Math.max(this.options.srcCategories.length, this._seriesMax || 0)
            }
        }), w(Dn, {
            type: "category",
            vertical: !1,
            majorGridLines: {
                visible: !1,
                width: 1,
                color: zt
            },
            labels: {
                zIndex: 1
            },
            justified: !1,
            _deferLabels: !0
        }), Gn = 3e5, Fn = {
            milliseconds: "HH:mm:ss.fff",
            seconds: "HH:mm:ss",
            minutes: "HH:mm",
            hours: "HH:mm",
            days: "M/d",
            weeks: "M/d",
            months: "MMM 'yy",
            years: "yyyy"
        }, Nn = .2, Hn = "auto", Yn = [Mn, kn, Tn, Sn, Rn, Un, Ln, jn], Xn = "fit", qn = Tt.extend({
            init: function(t) {
                this.options = t
            },
            displayIndices: function() {
                return {
                    min: 0,
                    max: 1
                }
            },
            displayRange: function() {
                return {}
            },
            total: function() {
                return {}
            },
            valueRange: function() {
                return {}
            },
            valueIndex: function() {
                return -1
            },
            values: function() {
                return []
            },
            totalIndex: function() {
                return -1
            },
            valuesCount: function() {
                return 0
            },
            totalCount: function() {
                return 0
            },
            dateAt: function() {
                return null
            }
        }), Kn = Tt.extend({
            init: function(t, i, n) {
                var e, o, s, r, a, l;
                this.options = n, n.baseUnitStep = n.baseUnitStep || 1, e = n.roundToBaseUnit, o = n.justified, this.start = V(t, 0, n.baseUnit, n.weekStartDay), s = this.roundToTotalStep(i), r = !o && N(i, s) && !n.justifyEnd, this.end = this.roundToTotalStep(i, !o, r ? 1 : 0), a = n.min || t, this.valueStart = this.roundToTotalStep(a), this.displayStart = e ? this.valueStart : a, l = n.max, l ? (this.valueEnd = this.roundToTotalStep(l, !1, !o && N(l, this.roundToTotalStep(l)) ? -1 : 0), this.displayEnd = e ? this.roundToTotalStep(l, !o) : n.max) : (this.valueEnd = s, this.displayEnd = e || r ? this.end : i), this.valueEnd < this.valueStart && (this.valueEnd = this.valueStart), this.displayEnd <= this.displayStart && (this.displayEnd = this.roundToTotalStep(this.displayStart, !1, 1))
            },
            displayRange: function() {
                return {
                    min: this.displayStart,
                    max: this.displayEnd
                }
            },
            displayIndices: function() {
                var t, i, n, e, o;
                return this._indices || (t = this.options, i = t.baseUnit, n = t.baseUnitStep, e = Y(this.displayStart, this.valueStart, i, n), o = Y(this.displayEnd, this.valueStart, i, n), this._indices = {
                    min: e,
                    max: o
                }), this._indices
            },
            total: function() {
                return {
                    min: this.start,
                    max: this.end
                }
            },
            totalCount: function() {
                var t = this.totalIndex(this.end);
                return t + (this.options.justified ? 1 : 0)
            },
            valueRange: function() {
                return {
                    min: this.valueStart,
                    max: this.valueEnd
                }
            },
            valueIndex: function(t) {
                var i = this.options;
                return Math.floor(Y(t, this.valueStart, i.baseUnit, i.baseUnitStep))
            },
            totalIndex: function(t) {
                var i = this.options;
                return Math.floor(Y(t, this.start, i.baseUnit, i.baseUnitStep))
            },
            dateIndex: function(t) {
                var i = this.options;
                return Y(t, this.valueStart, i.baseUnit, i.baseUnitStep)
            },
            valuesCount: function() {
                var t = this.valueIndex(this.valueEnd);
                return t + 1
            },
            values: function() {
                var t, i, n, e = this._values;
                if (!e)
                    for (t = this.options, i = this.valueRange(), this._values = e = [], n = i.min; n <= i.max;) e.push(n), n = V(n, t.baseUnitStep, t.baseUnit, t.weekStartDay);
                return e
            },
            dateAt: function(t, i) {
                var n = this.options;
                return V(i ? this.start : this.valueStart, n.baseUnitStep * t, n.baseUnit, n.weekStartDay)
            },
            roundToTotalStep: function(t, i, n) {
                var e = this.options,
                    o = e.baseUnit,
                    s = e.baseUnitStep,
                    r = e.weekStartDay,
                    a = this.start,
                    l = Y(t, a, o, s),
                    h = i ? Math.ceil(l) : Math.floor(l);
                return n && (h += n), V(a, h * s, o, r)
            }
        }), Wn = Dn.extend({
            clone: function() {
                var i = new Wn(t.extend({}, this.options), this.chartService);
                return i.createLabels(), i
            },
            categoriesHash: function() {
                var t = this.dataRange.total().min;
                return this.options.baseUnit + this.options.baseUnitStep + t
            },
            initUserOptions: function(t) {
                return t
            },
            initFields: function() {
                var i, n, e, o, s, r, a, l, h;
                Dn.fn.initFields.call(this), i = this.chartService, n = i.intl, e = this.options, o = e.categories || [], o._parsed || (o = W(n, o), o._parsed = !0), e = It({
                    roundToBaseUnit: !0
                }, e, {
                    categories: o,
                    min: K(n, e.min),
                    max: K(n, e.max)
                }), i.panning && i.isPannable(e.vertical ? gi : mi) && (e.roundToBaseUnit = !1), e.userSetBaseUnit = e.userSetBaseUnit || e.baseUnit, e.userSetBaseUnitStep = e.userSetBaseUnitStep || e.baseUnitStep, this.options = e, e.srcCategories = o, o.length > 0 ? (s = J(o), r = e.maxDivisions, this.dataRange = new Kn(s.min, s.max, tt(e)), r ? (a = this.dataRange.displayRange(), l = t.extend({}, e, {
                    justified: !0,
                    roundToBaseUnit: !1,
                    baseUnit: "fit",
                    min: a.min,
                    max: a.max,
                    maxDateGroups: r
                }), h = this.dataRange.options, Z(l, h.baseUnit, h.baseUnitStep), this.divisionRange = new Kn(s.min, s.max, l)) : this.divisionRange = this.dataRange) : (e.baseUnit = e.baseUnit || Rn, this.dataRange = this.divisionRange = new qn(e))
            },
            tickIndices: function(t) {
                var i, n, e, o, s, r = this,
                    a = r.dataRange,
                    l = r.divisionRange,
                    h = l.valuesCount();
                if (!this.options.maxDivisions || !h) return Dn.fn.tickIndices.call(this, t);
                for (i = [], n = l.values(), e = 0, this.options.justified || (n = n.concat(l.dateAt(h)), e = .5), o = 0; o < n.length; o++) i.push(a.dateIndex(n[o]) + e), 1 !== t && o >= 1 && (s = i.length - 1, i.splice(o, 0, i[s - 1] + (i[s] - i[s - 1]) * t));
                return i
            },
            shouldRenderNote: function(t) {
                var i = this.range(),
                    n = this.options.categories || [];
                return D(t, i.min) >= 0 && D(t, i.max) <= 0 && n.length
            },
            parseNoteValue: function(t) {
                return K(this.chartService.intl, t)
            },
            noteSlot: function(t) {
                return this.getSlot(t)
            },
            translateRange: function(t) {
                var i, n, e = this.options,
                    o = e.baseUnit,
                    s = e.weekStartDay,
                    r = e.vertical,
                    a = this.lineBox(),
                    l = r ? a.height() : a.width(),
                    h = this.range(),
                    u = l / (h.max - h.min),
                    c = qi(t / u, Yt);
                return h.min && h.max && (i = B(e.min || h.min, c), n = B(e.max || h.max, c), h = {
                    min: V(i, 0, o, s),
                    max: V(n, 0, o, s)
                }), h
            },
            scaleRange: function(t) {
                var i, n, e = Math.abs(t),
                    o = this.range(),
                    s = o.min,
                    r = o.max;
                if (s && r) {
                    for (; e--;) i = G(s, r), n = Math.round(.1 * i), t < 0 ? (s = B(s, n), r = B(r, -n)) : (s = B(s, -n), r = B(r, n));
                    o = {
                        min: s,
                        max: r
                    }
                }
                return o
            },
            labelsRange: function() {
                return {
                    min: this.options.labels.skip,
                    max: this.divisionRange.valuesCount()
                }
            },
            pan: function(t) {
                var i, n, e, o, s, r, a, l, h, u, c, f;
                return this.isEmpty() ? null : (i = this.options, n = this.lineBox(), e = i.vertical ? n.height() : n.width(), o = this.dataRange.displayRange(), s = o.min, r = o.max, a = this.dataRange.total(), l = e / (r - s), h = qi(t / l, Yt) * (i.reverse ? -1 : 1), u = B(s, h), c = B(r, h), f = this.limitRange(F(u), F(c), F(a.min), F(a.max), h), f ? (f.min = C(f.min), f.max = C(f.max), f.baseUnit = i.baseUnit, f.baseUnitStep = i.baseUnitStep || 1, f.userSetBaseUnit = i.userSetBaseUnit, f.userSetBaseUnitStep = i.userSetBaseUnitStep, f) : void 0)
            },
            pointsRange: function(t, i) {
                var n, e, o, s, r, a, l;
                return this.isEmpty() ? null : (n = Dn.fn.pointsRange.call(this, t, i), e = this.dataRange.displayRange(), o = this.dataRange.displayIndices(), s = G(e.max, e.min) / (o.max - o.min), r = this.options, a = B(e.min, n.min * s), l = B(e.min, n.max * s), {
                    min: a,
                    max: l,
                    baseUnit: r.userSetBaseUnit || r.baseUnit,
                    baseUnitStep: r.userSetBaseUnitStep || r.baseUnitStep
                })
            },
            zoomRange: function(t) {
                var i, n, e, o, s, r, a, l, h, u, c, f, d, p, m, g, x, v, b, y, w;
                if (this.isEmpty()) return null;
                if (i = this.options, n = i.userSetBaseUnit === Xn, e = this.dataRange.total(), o = this.dataRange.displayRange(), s = o.min, r = o.max, a = this.dataRange.options, l = a.weekStartDay, h = a.baseUnit, u = a.baseUnitStep, c = V(s, t * u, h, l), f = V(r, -t * u, h, l), n)
                    if (d = i.autoBaseUnitSteps, p = i.maxDateGroups, m = Ni(d[h]) * p * En[h], g = G(r, s), x = G(f, c), v = Yn.indexOf(h), x < En[h] && h !== Mn) h = Yn[v - 1], b = Ni(d[h]), y = (g - (p - 1) * b * En[h]) / 2, c = B(s, y), f = B(r, -y);
                    else if (x > m && h !== jn) {
                    w = 0;
                    do {
                        v++, h = Yn[v], w = 0, y = 2 * En[h];
                        do b = d[h][w], w++; while (w < d[h].length && y * b < g)
                    } while (h !== jn && y * b < g);
                    y = (y * b - g) / 2, y > 0 && (c = B(s, -y), f = B(r, y), c = B(c, Hi(f, e.min, e.max) - f), f = B(f, Hi(c, e.min, e.max) - c))
                }
                return c < e.min && (c = e.min), f > e.max && (f = e.max), c && f && G(f, c) > 0 ? {
                    min: c,
                    max: f,
                    baseUnit: i.userSetBaseUnit || i.baseUnit,
                    baseUnitStep: i.userSetBaseUnitStep || i.baseUnitStep
                } : void 0
            },
            range: function() {
                return this.dataRange.displayRange()
            },
            createAxisLabel: function(t, i) {
                var n, e = this.options,
                    o = e.dataItems && !e.maxDivisions ? e.dataItems[t] : null,
                    s = this.divisionRange.dateAt(t),
                    r = i.dateFormats[this.divisionRange.options.baseUnit];
                if (i.format = i.format || r, n = this.axisLabelText(s, o, i)) return new xn(s, n, t, o, i)
            },
            categoryIndex: function(t) {
                return this.dataRange.valueIndex(t)
            },
            slot: function(t, i, n) {
                var e, o = this.dataRange,
                    s = t,
                    r = i;
                if (s instanceof Date && (s = o.dateIndex(s)), r instanceof Date && (r = o.dateIndex(r)), e = this.getSlot(s, r, n)) return e.toRect()
            },
            getSlot: function(t, i, n) {
                var e = t,
                    o = i;
                return typeof e === si && (e = this.categoryIndex(e)), typeof o === si && (o = this.categoryIndex(o)), Dn.fn.getSlot.call(this, e, o, n)
            },
            valueRange: function() {
                var t = this.options,
                    i = J(t.srcCategories);
                return {
                    min: C(i.min),
                    max: C(i.max)
                }
            },
            categoryAt: function(t, i) {
                return this.dataRange.dateAt(t, i)
            },
            categoriesCount: function() {
                return this.dataRange.valuesCount()
            },
            rangeIndices: function() {
                return this.dataRange.displayIndices();
            },
            labelsBetweenTicks: function() {
                return !this.divisionRange.options.justified
            },
            prepareUserOptions: function() {
                this.isEmpty() || (this.options.categories = this.dataRange.values())
            },
            getCategory: function(t) {
                var i = this.pointCategoryIndex(t);
                return null === i ? null : this.dataRange.dateAt(i)
            },
            totalIndex: function(t) {
                return this.dataRange.totalIndex(t)
            },
            currentRangeIndices: function() {
                var t = this.dataRange.valueRange();
                return {
                    min: this.dataRange.totalIndex(t.min),
                    max: this.dataRange.totalIndex(t.max)
                }
            },
            totalRange: function() {
                return this.dataRange.total()
            },
            totalCount: function() {
                return this.dataRange.totalCount()
            },
            isEmpty: function() {
                return !this.options.srcCategories.length
            },
            roundedRange: function() {
                var i, n, e;
                return this.options.roundToBaseUnit !== !1 || this.isEmpty() ? this.range() : (i = this.options, n = J(i.srcCategories), e = new Kn(n.min, n.max, t.extend({}, i, {
                    justified: !1,
                    roundToBaseUnit: !0,
                    justifyEnd: i.justified
                })), e.displayRange())
            }
        }), w(Wn, {
            type: Ft,
            labels: {
                dateFormats: Fn
            },
            autoBaseUnitSteps: {
                milliseconds: [1, 10, 100],
                seconds: [1, 2, 5, 15, 30],
                minutes: [1, 2, 5, 15, 30],
                hours: [1, 2, 3],
                days: [1, 2, 3],
                weeks: [1, 2],
                months: [1, 2, 3, 6],
                years: [1, 2, 3, 5, 10, 25, 50]
            },
            maxDateGroups: 10
        }), Qn = Math.pow(10, -Yt + 1), Jn = wn.extend({
            init: function(i, n, e, o) {
                wn.fn.init.call(this, t.extend({}, e, {
                    seriesMin: i,
                    seriesMax: n
                }), o)
            },
            initUserOptions: function(t) {
                var i = rt(t.seriesMin, t.seriesMax, t);
                return this.totalOptions = at(i, t), ht(i, t)
            },
            initFields: function() {
                this.totalMin = this.totalOptions.min, this.totalMax = this.totalOptions.max, this.totalMajorUnit = this.totalOptions.majorUnit, this.seriesMin = this.options.seriesMin, this.seriesMax = this.options.seriesMax
            },
            clone: function() {
                return new Jn(this.seriesMin, this.seriesMax, t.extend({}, this.options), this.chartService)
            },
            startValue: function() {
                return 0
            },
            range: function() {
                var t = this.options;
                return {
                    min: t.min,
                    max: t.max
                }
            },
            getDivisions: function(t) {
                var i, n;
                return 0 === t ? 1 : (i = this.options, n = i.max - i.min, Math.floor(qi(n / t, Dt)) + 1)
            },
            getTickPositions: function(t, i) {
                var n, e = this.options,
                    o = e.vertical,
                    s = e.reverse,
                    r = this.lineBox(),
                    a = o ? r.height() : r.width(),
                    l = e.max - e.min,
                    h = a / l,
                    u = t * h,
                    c = this.getDivisions(t),
                    f = (o ? -1 : 1) * (s ? -1 : 1),
                    d = 1 === f ? 1 : 2,
                    p = [],
                    m = r[(o ? gi : mi) + d],
                    g = 0;
                for (i && (g = i / t), n = 0; n < c; n++) n % g !== 0 && p.push(qi(m, Dt)), m += u * f;
                return p
            },
            getMajorTickPositions: function() {
                return this.getTickPositions(this.options.majorUnit)
            },
            getMinorTickPositions: function() {
                return this.getTickPositions(this.options.minorUnit)
            },
            getSlot: function(t, i, n) {
                var e, o, s, r, a, l, h, u, c, f, d, p, m, g;
                return void 0 === n && (n = !1), e = this.options, o = e.vertical, s = e.reverse, r = o ? gi : mi, a = this.lineBox(), l = a[r + (s ? 2 : 1)], h = o ? a.height() : a.width(), u = s ? -1 : 1, c = u * (h / (e.max - e.min)), f = new Zi(a.x1, a.y1, a.x1, a.y1), d = t, p = i, Vi(d) || (d = p || 0), Vi(p) || (p = d || 0), n && (d = Math.max(Math.min(d, e.max), e.min), p = Math.max(Math.min(p, e.max), e.min)), o ? (m = e.max - Math.max(d, p), g = e.max - Math.min(d, p)) : (m = Math.min(d, p) - e.min, g = Math.max(d, p) - e.min), f[r + 1] = st(l + c * (s ? g : m)), f[r + 2] = st(l + c * (s ? m : g)), f
            },
            getValue: function(t) {
                var i, n = this.options,
                    e = n.vertical,
                    o = n.reverse,
                    s = +n.max,
                    r = +n.min,
                    a = e ? gi : mi,
                    l = this.lineBox(),
                    h = l[a + (o ? 2 : 1)],
                    u = e ? l.height() : l.width(),
                    c = o ? -1 : 1,
                    f = c * (t[a] - h),
                    d = (s - r) / u,
                    p = f * d;
                return f < 0 || f > u ? null : (i = e ? s - p : r + p, qi(i, Yt))
            },
            translateRange: function(t) {
                var i = this.options,
                    n = i.vertical,
                    e = i.reverse,
                    o = i.max,
                    s = i.min,
                    r = this.lineBox(),
                    a = n ? r.height() : r.width(),
                    l = o - s,
                    h = a / l,
                    u = qi(t / h, Yt);
                return !n && !e || n && e || (u = -u), {
                    min: s + u,
                    max: o + u,
                    offset: u
                }
            },
            scaleRange: function(t) {
                var i = this.options,
                    n = -t * i.majorUnit;
                return {
                    min: i.min - n,
                    max: i.max + n
                }
            },
            labelsCount: function() {
                return this.getDivisions(this.options.majorUnit)
            },
            createAxisLabel: function(t, i) {
                var n = this.options,
                    e = qi(n.min + t * n.majorUnit, Yt),
                    o = this.axisLabelText(e, null, i);
                return new xn(e, o, t, null, i)
            },
            shouldRenderNote: function(t) {
                var i = this.range();
                return i.min <= t && t <= i.max
            },
            pan: function(t) {
                var i = this.translateRange(t);
                return this.limitRange(i.min, i.max, this.totalMin, this.totalMax, i.offset)
            },
            pointsRange: function(t, i) {
                var n = this.getValue(t),
                    e = this.getValue(i),
                    o = Math.min(n, e),
                    s = Math.max(n, e);
                if (this.isValidRange(o, s)) return {
                    min: o,
                    max: s
                }
            },
            zoomRange: function(t) {
                var i = this,
                    n = i.totalMin,
                    e = i.totalMax,
                    o = this.scaleRange(t),
                    s = Hi(o.min, n, e),
                    r = Hi(o.max, n, e);
                if (this.isValidRange(s, r)) return {
                    min: s,
                    max: r
                }
            },
            isValidRange: function(t, i) {
                return i - t > Qn
            }
        }), w(Jn, {
            type: "numeric",
            min: 0,
            max: 1,
            vertical: !0,
            majorGridLines: {
                visible: !0,
                width: 1,
                color: zt
            },
            labels: {
                format: "#.####################"
            },
            zIndex: 1
        }), Zn = wn.extend({
            init: function(t, i, n, e) {
                var o = C(t),
                    s = C(i),
                    r = e.intl,
                    a = n || {};
                a = It(a || {}, {
                    min: K(r, a.min),
                    max: K(r, a.max),
                    axisCrossingValue: W(r, a.axisCrossingValues || a.axisCrossingValue)
                }), a = ft(o, s, a), wn.fn.init.call(this, a, e), this.intlService = r, this.seriesMin = o, this.seriesMax = s, this.totalMin = F(E(F(o) - 1, a.baseUnit)), this.totalMax = F(O(F(s) + 1, a.baseUnit))
            },
            clone: function() {
                return new Zn(this.seriesMin, this.seriesMax, t.extend({}, this.options), this.chartService)
            },
            range: function() {
                var t = this.options;
                return {
                    min: t.min,
                    max: t.max
                }
            },
            getDivisions: function(t) {
                var i = this.options;
                return Math.floor(X(i.min, i.max, i.baseUnit) / t + 1)
            },
            getTickPositions: function(t) {
                var i, n, e, o = this.options,
                    s = o.vertical,
                    r = this.lineBox(),
                    a = (s ? -1 : 1) * (o.reverse ? -1 : 1),
                    l = 1 === a ? 1 : 2,
                    h = r[(s ? gi : mi) + l],
                    u = this.getDivisions(t),
                    c = G(o.max, o.min),
                    f = s ? r.height() : r.width(),
                    d = f / c,
                    p = [h];
                for (i = 1; i < u; i++) n = V(o.min, i * t, o.baseUnit), e = h + G(n, o.min) * d * a, p.push(qi(e, Dt));
                return p
            },
            getMajorTickPositions: function() {
                return this.getTickPositions(this.options.majorUnit)
            },
            getMinorTickPositions: function() {
                return this.getTickPositions(this.options.minorUnit)
            },
            getSlot: function(t, i, n) {
                return Jn.prototype.getSlot.call(this, K(this.intlService, t), K(this.intlService, i), n)
            },
            getValue: function(t) {
                var i = Jn.prototype.getValue.call(this, t);
                return null !== i ? C(i) : null
            },
            labelsCount: function() {
                return this.getDivisions(this.options.majorUnit)
            },
            createAxisLabel: function(t, i) {
                var n, e, o = this.options,
                    s = t * o.majorUnit,
                    r = o.min;
                return s > 0 && (r = V(r, s, o.baseUnit)), n = i.dateFormats[o.baseUnit], i.format = i.format || n, e = this.axisLabelText(r, null, i), new xn(r, e, t, null, i)
            },
            translateRange: function(t, i) {
                var n = this.options,
                    e = n.baseUnit,
                    o = n.weekStartDay,
                    s = this.lineBox(),
                    r = n.vertical ? s.height() : s.width(),
                    a = this.range(),
                    l = r / G(a.max, a.min),
                    h = qi(t / l, Yt) * (n.reverse ? -1 : 1),
                    u = B(n.min, h),
                    c = B(n.max, h);
                return i || (u = V(u, 0, e, o), c = V(c, 0, e, o)), {
                    min: u,
                    max: c,
                    offset: h
                }
            },
            scaleRange: function(t) {
                for (var i, n, e = this.options, o = e.min, s = e.max, r = Math.abs(t); r--;) i = G(o, s), n = Math.round(.1 * i), t < 0 ? (o = B(o, n), s = B(s, -n)) : (o = B(o, -n), s = B(s, n));
                return {
                    min: o,
                    max: s
                }
            },
            shouldRenderNote: function(t) {
                var i = this.range();
                return D(t, i.min) >= 0 && D(t, i.max) <= 0
            },
            pan: function(t) {
                var i = this.translateRange(t, !0),
                    n = this.limitRange(F(i.min), F(i.max), this.totalMin, this.totalMax, i.offset);
                if (n) return {
                    min: C(n.min),
                    max: C(n.max)
                }
            },
            pointsRange: function(t, i) {
                var n = this.getValue(t),
                    e = this.getValue(i),
                    o = Math.min(n, e),
                    s = Math.max(n, e);
                return {
                    min: C(o),
                    max: C(s)
                }
            },
            zoomRange: function(t) {
                var i = this.scaleRange(t),
                    n = C(Hi(F(i.min), this.totalMin, this.totalMax)),
                    e = C(Hi(F(i.max), this.totalMin, this.totalMax));
                return {
                    min: n,
                    max: e
                }
            }
        }), w(Zn, {
            type: Ft,
            majorGridLines: {
                visible: !0,
                width: 1,
                color: zt
            },
            labels: {
                dateFormats: Fn
            }
        }), $n = 10, te = wn.extend({
            init: function(t, i, n, e) {
                var o = It({
                        majorUnit: $n,
                        min: t,
                        max: i
                    }, n),
                    s = o.majorUnit,
                    r = mt(i, s),
                    a = pt(t, i, o),
                    l = dt(a, r, o, n);
                o.max = l.max, o.min = l.min, o.minorUnit = n.minorUnit || qi(s - 1, Yt), wn.fn.init.call(this, o, e), this.totalMin = Vi(n.min) ? Math.min(a, n.min) : a, this.totalMax = Vi(n.max) ? Math.max(r, n.max) : r, this.logMin = qi(xt(l.min, s), Yt), this.logMax = qi(xt(l.max, s), Yt), this.seriesMin = t, this.seriesMax = i, this.createLabels()
            },
            clone: function() {
                return new te(this.seriesMin, this.seriesMax, t.extend({}, this.options), this.chartService)
            },
            startValue: function() {
                return this.options.min
            },
            getSlot: function(t, i, n) {
                var e, o, s = this,
                    r = s.options,
                    a = s.logMin,
                    l = s.logMax,
                    h = r.reverse,
                    u = r.vertical,
                    c = r.majorUnit,
                    f = u ? gi : mi,
                    d = this.lineBox(),
                    p = d[f + (h ? 2 : 1)],
                    m = u ? d.height() : d.width(),
                    g = h ? -1 : 1,
                    x = g * (m / (l - a)),
                    v = new Zi(d.x1, d.y1, d.x1, d.y1),
                    b = t,
                    y = i;
                return Vi(b) || (b = y || 1), Vi(y) || (y = b || 1), b <= 0 || y <= 0 ? null : (n && (b = Math.max(Math.min(b, r.max), r.min), y = Math.max(Math.min(y, r.max), r.min)), b = xt(b, c), y = xt(y, c), u ? (e = l - Math.max(b, y), o = l - Math.min(b, y)) : (e = Math.min(b, y) - a, o = Math.max(b, y) - a), v[f + 1] = st(p + x * (h ? o : e)), v[f + 2] = st(p + x * (h ? e : o)), v)
            },
            getValue: function(t) {
                var i, n = this,
                    e = n.options,
                    o = n.logMin,
                    s = n.logMax,
                    r = e.reverse,
                    a = e.vertical,
                    l = e.majorUnit,
                    h = this.lineBox(),
                    u = a === r ? 1 : -1,
                    c = 1 === u ? 1 : 2,
                    f = a ? h.height() : h.width(),
                    d = (s - o) / f,
                    p = a ? gi : mi,
                    m = h[p + c],
                    g = u * (t[p] - m),
                    x = g * d;
                return g < 0 || g > f ? null : (i = o + x, qi(Math.pow(l, i), Yt))
            },
            range: function() {
                var t = this.options;
                return {
                    min: t.min,
                    max: t.max
                }
            },
            scaleRange: function(t) {
                var i = this.options.majorUnit,
                    n = -t;
                return {
                    min: Math.pow(i, this.logMin - n),
                    max: Math.pow(i, this.logMax + n)
                }
            },
            translateRange: function(t) {
                var i = this,
                    n = i.options,
                    e = i.logMin,
                    o = i.logMax,
                    s = n.reverse,
                    r = n.vertical,
                    a = n.majorUnit,
                    l = this.lineBox(),
                    h = r ? l.height() : l.width(),
                    u = h / (o - e),
                    c = qi(t / u, Yt);
                return !r && !s || r && s || (c = -c), {
                    min: Math.pow(a, e + c),
                    max: Math.pow(a, o + c),
                    offset: c
                }
            },
            labelsCount: function() {
                var t = Math.floor(this.logMax),
                    i = Math.floor(t - this.logMin) + 1;
                return i
            },
            getMajorTickPositions: function() {
                var t = [];
                return this.traverseMajorTicksPositions(function(i) {
                    t.push(i)
                }, {
                    step: 1,
                    skip: 0
                }), t
            },
            createTicks: function(t) {
                function i(i, n) {
                    h.tickX = r ? a.x2 : a.x2 - n.size, h.tickY = r ? a.y1 - n.size : a.y1, h.position = i, t.append(j(h, n))
                }
                var n = this.options,
                    e = n.majorTicks,
                    o = n.minorTicks,
                    s = n.vertical,
                    r = n.labels.mirror,
                    a = this.lineBox(),
                    l = [],
                    h = {
                        vertical: s
                    };
                return e.visible && this.traverseMajorTicksPositions(i, e), o.visible && this.traverseMinorTicksPositions(i, o), l
            },
            createGridLines: function(t) {
                function i(t, i) {
                    x(t, l) || (a.position = t, h.append(A(a, i)), l.push(t))
                }
                var n = this.options,
                    e = n.minorGridLines,
                    o = n.majorGridLines,
                    s = n.vertical,
                    r = t.lineBox(),
                    a = {
                        lineStart: r[s ? "x1" : "y1"],
                        lineEnd: r[s ? "x2" : "y2"],
                        vertical: s
                    },
                    l = [],
                    h = this.gridLinesVisual();
                return o.visible && this.traverseMajorTicksPositions(i, o), e.visible && this.traverseMinorTicksPositions(i, e), h.children
            },
            traverseMajorTicksPositions: function(t, i) {
                var n, e, o = this._lineOptions(),
                    s = o.lineStart,
                    r = o.step,
                    a = this,
                    l = a.logMin,
                    h = a.logMax;
                for (n = Math.ceil(l) + i.skip; n <= h; n += i.step) e = qi(s + r * (n - l), Yt), t(e, i)
            },
            traverseMinorTicksPositions: function(t, i) {
                var n, e, o, s, r, a = this,
                    l = this.options,
                    h = l.min,
                    u = l.max,
                    c = l.minorUnit,
                    f = l.majorUnit,
                    d = this._lineOptions(),
                    p = d.lineStart,
                    m = d.step,
                    g = this,
                    x = g.logMin,
                    v = g.logMax,
                    b = Math.floor(x);
                for (n = b; n < v; n++)
                    for (e = a._minorIntervalOptions(n), o = i.skip; o < c && (s = e.value + o * e.minorStep, !(s > u)); o += i.step) s >= h && (r = qi(p + m * (xt(s, f) - x), Yt), t(r, i))
            },
            createAxisLabel: function(t, i) {
                var n = Math.ceil(this.logMin + t),
                    e = Math.pow(this.options.majorUnit, n),
                    o = this.axisLabelText(e, null, i);
                return new xn(e, o, t, null, i)
            },
            shouldRenderNote: function(t) {
                var i = this.range();
                return i.min <= t && t <= i.max
            },
            pan: function(t) {
                var i = this.translateRange(t);
                return this.limitRange(i.min, i.max, this.totalMin, this.totalMax, i.offset)
            },
            pointsRange: function(t, i) {
                var n = this.getValue(t),
                    e = this.getValue(i),
                    o = Math.min(n, e),
                    s = Math.max(n, e);
                return {
                    min: o,
                    max: s
                }
            },
            zoomRange: function(t) {
                var i = this,
                    n = i.options,
                    e = i.totalMin,
                    o = i.totalMax,
                    s = this.scaleRange(t),
                    r = Hi(s.min, e, o),
                    a = Hi(s.max, e, o),
                    l = n.majorUnit,
                    h = a > r && n.min && n.max && qi(xt(n.max, l) - xt(n.min, l), Yt) < 1,
                    u = !(n.min === e && n.max === o) && qi(xt(a, l) - xt(r, l), Yt) >= 1;
                if (h || u) return {
                    min: r,
                    max: a
                }
            },
            _minorIntervalOptions: function(t) {
                var i = this.options,
                    n = i.minorUnit,
                    e = i.majorUnit,
                    o = Math.pow(e, t),
                    s = Math.pow(e, t + 1),
                    r = s - o,
                    a = r / n;
                return {
                    value: o,
                    minorStep: a
                }
            },
            _lineOptions: function() {
                var t = this.options,
                    i = t.reverse,
                    n = t.vertical,
                    e = n ? gi : mi,
                    o = this.lineBox(),
                    s = n === i ? 1 : -1,
                    r = 1 === s ? 1 : 2,
                    a = n ? o.height() : o.width(),
                    l = s * (a / (this.logMax - this.logMin)),
                    h = o[e + r];
                return {
                    step: l,
                    lineStart: h,
                    lineBox: o
                }
            }
        }), w(te, {
            type: "log",
            majorUnit: $n,
            minorUnit: 1,
            axisCrossingValue: 1,
            vertical: !0,
            majorGridLines: {
                visible: !0,
                width: 1,
                color: zt
            },
            zIndex: 1,
            _deferLabels: !0
        }), ie = {
            createGridLines: function(t) {
                var i, n, e = this.options,
                    o = Math.abs(this.box.center().y - t.lineBox().y1),
                    s = [],
                    r = !1;
                return e.majorGridLines.visible && (i = this.majorGridLineAngles(t), r = !0, s = this.renderMajorGridLines(i, o, e.majorGridLines)), e.minorGridLines.visible && (n = this.minorGridLineAngles(t, r), _i(s, this.renderMinorGridLines(n, o, e.minorGridLines, t, r))), s
            },
            renderMajorGridLines: function(t, i, n) {
                return this.renderGridLines(t, i, n)
            },
            renderMinorGridLines: function(t, i, n, e, o) {
                var s = this.radiusCallback && this.radiusCallback(i, e, o);
                return this.renderGridLines(t, i, n, s)
            },
            renderGridLines: function(t, i, n, e) {
                var o, s, r = {
                        stroke: {
                            width: n.width,
                            color: n.color,
                            dashType: n.dashType
                        }
                    },
                    a = this.box.center(),
                    l = new Ut([a.x, a.y], i),
                    h = this.gridLinesVisual();
                for (o = 0; o < t.length; o++) s = new Mt(r), e && (l.radius = e(t[o])), s.moveTo(l.center).lineTo(l.pointAt(t[o] + 180)), h.append(s);
                return h.children
            },
            gridLineAngles: function(t, i, n, e, o) {
                var s = this,
                    r = this.intervals(i, n, e, o),
                    a = t.options,
                    l = a.visible && (a.line || {}).visible !== !1;
                return b(r, function(t) {
                    var i = s.intervalAngle(t);
                    if (!l || 90 !== i) return i
                })
            }
        }, ne = Dn.extend({
            range: function() {
                return {
                    min: 0,
                    max: this.options.categories.length
                }
            },
            reflow: function(t) {
                this.box = t, this.reflowLabels()
            },
            lineBox: function() {
                return this.box
            },
            reflowLabels: function() {
                var t, i, n = this,
                    e = this,
                    o = e.labels,
                    s = e.options.labels,
                    r = s.skip || 0,
                    a = s.step || 1,
                    l = new Zi;
                for (t = 0; t < o.length; t++) o[t].reflow(l), i = o[t].box, o[t].reflow(n.getSlot(r + t * a).adjacentBox(0, i.width(), i.height()))
            },
            intervals: function(t, i, n, e) {
                var o, s, r, a, l, h, u, c, f;
                for (void 0 === e && (e = !1), o = this.options, s = o.categories.length, r = s / t || 1, a = 360 / r, l = i || 0, h = n || 1, u = [], c = 0, f = l; f < r; f += h) c = o.reverse ? 360 - f * a : f * a, c = qi(c, Dt) % 360, e && x(c, e) || u.push(c);
                return u
            },
            majorIntervals: function() {
                return this.intervals(1)
            },
            minorIntervals: function() {
                return this.intervals(.5)
            },
            intervalAngle: function(t) {
                return (360 + t + this.options.startAngle) % 360
            },
            majorAngles: function() {
                var t = this;
                return b(this.majorIntervals(), function(i) {
                    return t.intervalAngle(i)
                })
            },
            createLine: function() {
                return []
            },
            majorGridLineAngles: function(t) {
                var i = this.options.majorGridLines;
                return this.gridLineAngles(t, 1, i.skip, i.step)
            },
            minorGridLineAngles: function(t, i) {
                var n = this.options,
                    e = n.minorGridLines,
                    o = n.majorGridLines,
                    s = i ? this.intervals(1, o.skip, o.step) : null;
                return this.gridLineAngles(t, .5, e.skip, e.step, s)
            },
            radiusCallback: function(t, i, n) {
                var e, o, s, r;
                if (i.options.type !== Pt) return e = Xi(360 / (2 * this.options.categories.length)), o = Math.cos(e) * t, s = this.majorAngles(), r = function(i) {
                    return !n && x(i, s) ? t : o
                }
            },
            createPlotBands: function() {
                var t, i, n, e, o, s, r, a = this,
                    l = this.options.plotBands || [],
                    h = this._plotbandGroup = new kt({
                        zIndex: -1
                    });
                for (t = 0; t < l.length; t++) i = l[t], n = a.plotBandSlot(i), e = a.getSlot(i.from), o = i.from - Math.floor(i.from), n.startAngle += o * e.angle, s = Math.ceil(i.to) - i.to, n.angle -= (s + o) * e.angle, r = en.current.createRing(n, {
                    fill: {
                        color: i.color,
                        opacity: i.opacity
                    },
                    stroke: {
                        opacity: i.opacity
                    }
                }), h.append(r);
                this.appendVisual(h)
            },
            plotBandSlot: function(t) {
                return this.getSlot(t.from, t.to - 1)
            },
            getSlot: function(t, i) {
                var n, e, o, s, r = this.options,
                    a = r.justified,
                    l = this.box,
                    h = this.majorAngles(),
                    u = h.length,
                    c = 360 / u,
                    f = t;
                return r.reverse && !a && (f = (f + 1) % u), f = Hi(Math.floor(f), 0, u - 1), n = h[f], a && (n -= c / 2, n < 0 && (n += 360)), e = Hi(Math.ceil(i || f), f, u - 1), o = e - f + 1, s = c * o, new $i(l.center(), 0, l.height() / 2, n, s)
            },
            slot: function(t, i) {
                var n = this.getSlot(t, i),
                    e = n.startAngle + 180,
                    o = e + n.angle;
                return new St.Arc([n.center.x, n.center.y], {
                    startAngle: e,
                    endAngle: o,
                    radiusX: n.radius,
                    radiusY: n.radius
                })
            },
            pointCategoryIndex: function(t) {
                var i, n, e = this,
                    o = this.options.categories.length,
                    s = null;
                for (i = 0; i < o; i++)
                    if (n = e.getSlot(i), n.containsPoint(t)) {
                        s = i;
                        break
                    }
                return s
            }
        }), w(ne, {
            startAngle: 90,
            labels: {
                margin: d(10)
            },
            majorGridLines: {
                visible: !0
            },
            justified: !0
        }), It(ne.prototype, ie), ee = wn.extend({
            init: function(t, i) {
                wn.fn.init.call(this, t, i);
                var n = this.options;
                n.minorUnit = n.minorUnit || n.majorUnit / 2
            },
            getDivisions: function(t) {
                return Jn.prototype.getDivisions.call(this, t) - 1
            },
            reflow: function(t) {
                this.box = t, this.reflowLabels()
            },
            reflowLabels: function() {
                var t, i, n = this,
                    e = this,
                    o = e.options,
                    s = e.labels,
                    r = e.options.labels,
                    a = r.skip || 0,
                    l = r.step || 1,
                    h = new Zi,
                    u = this.intervals(o.majorUnit, a, l);
                for (t = 0; t < s.length; t++) s[t].reflow(h), i = s[t].box, s[t].reflow(n.getSlot(u[t]).adjacentBox(0, i.width(), i.height()))
            },
            lineBox: function() {
                return this.box
            },
            intervals: function(t, i, n, e) {
                var o, s, r, a, l, h, u;
                for (void 0 === e && (e = !1), o = this.options.min, s = this.getDivisions(t), r = [], a = i || 0, l = n || 1, h = a; h < s; h += l) u = (360 + o + h * t) % 360, e && x(u, e) || r.push(u);
                return r
            },
            majorIntervals: function() {
                return this.intervals(this.options.majorUnit)
            },
            minorIntervals: function() {
                return this.intervals(this.options.minorUnit)
            },
            intervalAngle: function(t) {
                return (540 - t - this.options.startAngle) % 360
            },
            createLine: function() {
                return []
            },
            majorGridLineAngles: function(t) {
                var i = this.options.majorGridLines;
                return this.gridLineAngles(t, this.options.majorUnit, i.skip, i.step)
            },
            minorGridLineAngles: function(t, i) {
                var n = this.options,
                    e = n.minorGridLines,
                    o = n.majorGridLines,
                    s = i ? this.intervals(n.majorUnit, o.skip, o.step) : null;
                return this.gridLineAngles(t, n.minorUnit, e.skip, e.step, s)
            },
            plotBandSlot: function(t) {
                return this.getSlot(t.from, t.to)
            },
            getSlot: function(t, i) {
                var n, e = this,
                    o = e.options,
                    s = e.box,
                    r = o.startAngle,
                    a = Hi(t, o.min, o.max),
                    l = Hi(i || a, a, o.max);
                return o.reverse && (a *= -1, l *= -1), a = (540 - a - r) % 360, l = (540 - l - r) % 360, l < a && (n = a, a = l, l = n), new $i(s.center(), 0, s.height() / 2, a, l - a)
            },
            slot: function(t, i) {
                var n, e, o, s, r, a, l;
                return void 0 === i && (i = t), n = this.options, e = 360 - n.startAngle, o = this.getSlot(t, i), s = Math.min(t, i), r = Math.max(t, i), n.reverse ? (a = s, l = r) : (a = 360 - r, l = 360 - s), a = (a + e) % 360, l = (l + e) % 360, new St.Arc([o.center.x, o.center.y], {
                    startAngle: a,
                    endAngle: l,
                    radiusX: o.radius,
                    radiusY: o.radius
                })
            },
            getValue: function(t) {
                var i = this.options,
                    n = this.box.center(),
                    e = t.x - n.x,
                    o = t.y - n.y,
                    s = Math.round(Ei(Math.atan2(o, e))),
                    r = i.startAngle;
                return i.reverse || (s *= -1, r *= -1), (s + r + 360) % 360
            },
            valueRange: function() {
                return {
                    min: 0,
                    max: 2 * Math.PI
                }
            }
        }), w(ee, {
            type: "polar",
            startAngle: 0,
            reverse: !1,
            majorUnit: 60,
            min: 0,
            max: 360,
            labels: {
                margin: d(10)
            },
            majorGridLines: {
                color: zt,
                visible: !0,
                width: 1
            },
            minorGridLines: {
                color: "#aaa"
            }
        }), It(ee.prototype, ie, {
            createPlotBands: ne.prototype.createPlotBands,
            majorAngles: ne.prototype.majorAngles,
            range: Jn.prototype.range,
            labelsCount: Jn.prototype.labelsCount,
            createAxisLabel: Jn.prototype.createAxisLabel
        }), oe = {
            options: {
                majorGridLines: {
                    visible: !0
                }
            },
            createPlotBands: function() {
                var t, i, n, e, o, s, r, a, l, h, u = this,
                    c = this.options,
                    f = c.majorGridLines.type,
                    d = c.plotBands;
                for (void 0 === d && (d = []), t = this.plotArea.polarAxis, i = t.majorAngles(), n = t.box.center(), e = this._plotbandGroup = new kt({
                        zIndex: -1
                    }), o = 0; o < d.length; o++) s = d[o], r = {
                    fill: {
                        color: s.color,
                        opacity: s.opacity
                    },
                    stroke: {
                        opacity: s.opacity
                    }
                }, a = u.getSlot(s.from, s.to, !0), l = new $i(n, n.y - a.y2, n.y - a.y1, 0, 360), h = void 0, h = f === Pt ? en.current.createRing(l, r) : Mt.fromPoints(u.plotBandPoints(l, i), r).close(), e.append(h);
                this.appendVisual(e)
            },
            plotBandPoints: function(t, i) {
                var n, e = [],
                    o = [],
                    s = [t.center.x, t.center.y],
                    r = new Ut(s, t.innerRadius),
                    a = new Ut(s, t.radius);
                for (n = 0; n < i.length; n++) e.push(r.pointAt(i[n] + 180)), o.push(a.pointAt(i[n] + 180));
                return e.reverse(), e.push(e[0]), o.push(o[0]), o.concat(e)
            },
            createGridLines: function(t) {
                var i, n = this.options,
                    e = this.radarMajorGridLinePositions(),
                    o = t.majorAngles(),
                    s = t.box.center(),
                    r = [];
                return n.majorGridLines.visible && (r = this.renderGridLines(s, e, o, n.majorGridLines)), n.minorGridLines.visible && (i = this.radarMinorGridLinePositions(), _i(r, this.renderGridLines(s, i, o, n.minorGridLines))), r
            },
            renderGridLines: function(t, i, n, e) {
                var o, s, r, a, l, h, u, c = {
                        stroke: {
                            width: e.width,
                            color: e.color,
                            dashType: e.dashType
                        }
                    },
                    f = e.skip;
                for (void 0 === f && (f = 0), o = e.step, void 0 === o && (o = 0), s = this.gridLinesVisual(), r = f; r < i.length; r += o)
                    if (a = t.y - i[r], a > 0)
                        if (l = new Ut([t.x, t.y], a), e.type === Pt) s.append(new yt.Circle(l, c));
                        else {
                            for (h = new Mt(c), u = 0; u < n.length; u++) h.lineTo(l.pointAt(n[u] + 180));
                            h.close(), s.append(h)
                        }
                return s.children
            },
            getValue: function(t) {
                var i, n, e, o, s, r, a, l = this.lineBox(),
                    h = this.plotArea.polarAxis,
                    u = h.majorAngles(),
                    c = h.box.center(),
                    f = t.distanceTo(c),
                    d = f;
                return this.options.majorGridLines.type !== Pt && u.length > 1 && (i = t.x - c.x, n = t.y - c.y, e = (Ei(Math.atan2(n, i)) + 540) % 360, u.sort(function(t, i) {
                    return vt(t, e) - vt(i, e)
                }), o = vt(u[0], u[1]) / 2, s = vt(e, u[0]), r = 90 - o, a = 180 - s - r, d = f * (Math.sin(Xi(a)) / Math.sin(Xi(r)))), this.axisType().prototype.getValue.call(this, new Ji(l.x1, l.y2 - d))
            }
        }, se = Jn.extend({
            radarMajorGridLinePositions: function() {
                return this.getTickPositions(this.options.majorUnit)
            },
            radarMinorGridLinePositions: function() {
                var t = this.options,
                    i = 0;
                return t.majorGridLines.visible && (i = t.majorUnit), this.getTickPositions(t.minorUnit, i)
            },
            axisType: function() {
                return Jn
            }
        }), It(se.prototype, oe), re = te.extend({
            radarMajorGridLinePositions: function() {
                var t = [];
                return this.traverseMajorTicksPositions(function(i) {
                    t.push(i)
                }, this.options.majorGridLines), t
            },
            radarMinorGridLinePositions: function() {
                var t = [];
                return this.traverseMinorTicksPositions(function(i) {
                    t.push(i)
                }, this.options.minorGridLines), t
            },
            axisType: function() {
                return te
            }
        }), It(re.prototype, oe), ae = .333, le = .01, he = Tt.extend({
            init: function(t) {
                this.closed = t
            },
            process: function(t) {
                var i, n, e, o, s, r, a, l, h, u, c, f, d, p, m = this,
                    g = t.slice(0),
                    x = [],
                    v = this.closed,
                    b = g.length;
                if (b > 2 && (this.removeDuplicates(0, g), b = g.length), b < 2 || 2 === b && g[0].equals(g[1])) return x;
                for (i = g[0], n = g[1], e = g[2], x.push(new jt(i)); i.equals(g[b - 1]);) v = !0, g.pop(), b--;
                if (2 === b) return o = this.tangent(i, n, mi, gi), Ni(x).controlOut(this.firstControlPoint(o, i, n, mi, gi)), x.push(new jt(n, this.secondControlPoint(o, i, n, mi, gi))), x;
                for (v ? (i = g[b - 1], n = g[0], e = g[1], a = this.controlPoints(i, n, e), s = a[1], r = a[0]) : (l = this.tangent(i, n, mi, gi), s = this.firstControlPoint(l, i, n, mi, gi)), h = s, u = 0; u <= b - 3; u++) m.removeDuplicates(u, g), b = g.length, u + 3 <= b && (i = g[u], n = g[u + 1], e = g[u + 2], c = m.controlPoints(i, n, e), Ni(x).controlOut(h), h = c[1], f = c[0], x.push(new jt(n, f)));
                return v ? (i = g[b - 2], n = g[b - 1], e = g[0], d = this.controlPoints(i, n, e), Ni(x).controlOut(h), x.push(new jt(n, d[0])), Ni(x).controlOut(d[1]), x.push(new jt(e, r))) : (p = this.tangent(n, e, mi, gi), Ni(x).controlOut(h), x.push(new jt(e, this.secondControlPoint(p, n, e, mi, gi)))), x
            },
            removeDuplicates: function(t, i) {
                for (; i[t + 1] && (i[t].equals(i[t + 1]) || i[t + 1].equals(i[t + 2]));) i.splice(t + 1, 1)
            },
            invertAxis: function(t, i, n) {
                var e, o, s = !1;
                return t.x === i.x ? s = !0 : i.x === n.x ? (i.y < n.y && t.y <= i.y || n.y < i.y && i.y <= t.y) && (s = !0) : (e = this.lineFunction(t, i), o = this.calculateFunction(e, n.x), t.y <= i.y && n.y <= o || i.y <= t.y && n.y >= o || (s = !0)), s
            },
            isLine: function(t, i, n) {
                var e = this.lineFunction(t, i),
                    o = this.calculateFunction(e, n.x);
                return t.x === i.x && i.x === n.x || qi(o, 1) === qi(n.y, 1)
            },
            lineFunction: function(t, i) {
                var n = (i.y - t.y) / (i.x - t.x),
                    e = t.y - n * t.x;
                return [e, n]
            },
            controlPoints: function(t, i, n) {
                var e, o, s, r, a, l, h = mi,
                    u = gi,
                    c = !1,
                    f = !1;
                return this.isLine(t, i, n) ? e = this.tangent(t, i, mi, gi) : (o = {
                    x: this.isMonotonicByField(t, i, n, mi),
                    y: this.isMonotonicByField(t, i, n, gi)
                }, o.x && o.y ? (e = this.tangent(t, n, mi, gi), c = !0) : (this.invertAxis(t, i, n) && (h = gi, u = mi), o[h] ? e = 0 : (s = n[u] < t[u] && t[u] <= i[u] || t[u] < n[u] && i[u] <= t[u] ? bt((n[u] - t[u]) * (i[h] - t[h])) : -bt((n[h] - t[h]) * (i[u] - t[u])), e = le * s, f = !0))), r = this.secondControlPoint(e, t, i, h, u), f && (a = h, h = u, u = a), l = this.firstControlPoint(e, i, n, h, u), c && (this.restrictControlPoint(t, i, r, e), this.restrictControlPoint(i, n, l, e)), [r, l]
            },
            restrictControlPoint: function(t, i, n, e) {
                t.y < i.y ? i.y < n.y ? (n.x = t.x + (i.y - t.y) / e, n.y = i.y) : n.y < t.y && (n.x = i.x - (i.y - t.y) / e, n.y = t.y) : n.y < i.y ? (n.x = t.x - (t.y - i.y) / e, n.y = i.y) : t.y < n.y && (n.x = i.x + (t.y - i.y) / e, n.y = t.y)
            },
            tangent: function(t, i, n, e) {
                var o, s = i[n] - t[n],
                    r = i[e] - t[e];
                return o = 0 === s ? 0 : r / s
            },
            isMonotonicByField: function(t, i, n, e) {
                return n[e] > i[e] && i[e] > t[e] || n[e] < i[e] && i[e] < t[e]
            },
            firstControlPoint: function(t, i, n, e, o) {
                var s = i[e],
                    r = n[e],
                    a = (r - s) * ae;
                return this.point(s + a, i[o] + a * t, e, o)
            },
            secondControlPoint: function(t, i, n, e, o) {
                var s = i[e],
                    r = n[e],
                    a = (r - s) * ae;
                return this.point(r - a, n[o] - a * t, e, o)
            },
            point: function(t, i, n, e) {
                var o = new St.Point;
                return o[n] = t, o[e] = i, o
            },
            calculateFunction: function(t, i) {
                var n, e = t.length,
                    o = 0;
                for (n = 0; n < e; n++) o += Math.pow(i, n) * t[n];
                return o
            }
        }), At.Gradients = hn, kendo.deepExtend(kendo.dataviz, {
            constants: xi,
            services: Ai,
            autoMajorUnit: k,
            Point: Ji,
            Box: Zi,
            Ring: $i,
            Sector: tn,
            ShapeBuilder: en,
            ShapeElement: rn,
            ChartElement: on,
            BoxElement: sn,
            RootElement: un,
            FloatElement: cn,
            Text: dn,
            TextBox: mn,
            Title: gn,
            AxisLabel: xn,
            Axis: wn,
            Note: yn,
            CategoryAxis: Dn,
            DateCategoryAxis: Wn,
            DateValueAxis: Zn,
            NumericAxis: Jn,
            LogarithmicAxis: te,
            PolarAxis: ee,
            RadarCategoryAxis: ne,
            RadarNumericAxis: se,
            RadarLogarithmicAxis: re,
            CurveProcessor: he,
            rectToBox: L,
            addClass: n,
            removeClass: e,
            alignPathToPixel: o,
            clockwise: s,
            convertableToNumber: l,
            deepExtend: It,
            elementStyles: f,
            getSpacing: d,
            getTemplate: p,
            getter: Ct,
            grep: m,
            hasClasses: g,
            HashMap: Ii,
            inArray: x,
            interpolateValue: v,
            InstanceObserver: Ci,
            isArray: i,
            isFunction: Bt,
            isNumber: r,
            isObject: h,
            isString: a,
            map: b,
            mousewheelDelta: y,
            FontLoader: Qi,
            setDefaultOptions: w,
            sparseArrayLimits: M,
            styleValue: u,
            append: _i,
            bindEvents: zi,
            Class: Tt,
            defined: Vi,
            deg: Ei,
            elementOffset: Oi,
            elementSize: Di,
            eventElement: Gi,
            eventCoordinates: Fi,
            last: Ni,
            limitValue: Hi,
            logToConsole: kendo.logToConsole,
            objectKey: Yi,
            rad: Xi,
            round: qi,
            unbindEvents: Ki,
            valueOrDefault: Wi,
            absoluteDateDiff: I,
            addDuration: V,
            addTicks: B,
            ceilDate: O,
            dateComparer: D,
            dateDiff: G,
            dateEquals: N,
            dateIndex: Y,
            duration: X,
            floorDate: E,
            lteDateIndex: q,
            startOfWeek: P,
            toDate: C,
            parseDate: K,
            parseDates: W,
            toTime: F
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(t, i, n) {
    (n || i)()
}),
function(t, define) {
    define("dataviz/core/core.min", ["dataviz/core/kendo-core.min"], t)
}(function() {
    ! function(t) {
        var i = kendo.dataviz,
            n = i.services,
            e = kendo.drawing;
        i.SASS_THEMES = ["sass", "default-v2", "bootstrap-v4", "material-v2"], i.ExportMixin = {
            extend: function(t, i) {
                if (!t.exportVisual) throw Error("Mixin target has no exportVisual method defined.");
                t.exportSVG = this.exportSVG, t.exportImage = this.exportImage, t.exportPDF = this.exportPDF, i || (t.svg = this.svg, t.imageDataURL = this.imageDataURL)
            },
            exportSVG: function(t) {
                return e.exportSVG(this.exportVisual(), t)
            },
            exportImage: function(t) {
                return e.exportImage(this.exportVisual(t), t)
            },
            exportPDF: function(t) {
                return e.exportPDF(this.exportVisual(), t)
            },
            svg: function() {
                if (e.svg.Surface) return e.svg.exportGroup(this.exportVisual());
                throw Error("SVG Export failed. Unable to export instantiate kendo.drawing.svg.Surface")
            },
            imageDataURL: function() {
                var i, n, o;
                if (!kendo.support.canvas) return null;
                if (e.canvas.Surface) return i = t("<div />").css({
                    display: "none",
                    width: this.element.width(),
                    height: this.element.height()
                }).appendTo(document.body), n = new e.canvas.Surface(i[0]), n.draw(this.exportVisual()), o = n._rootElement.toDataURL(), n.destroy(), i.remove(), o;
                throw Error("Image Export failed. Unable to export instantiate kendo.drawing.canvas.Surface")
            }
        }, n.IntlService.register({
            format: function(t) {
                return kendo.format.apply(null, [t].concat(Array.prototype.slice.call(arguments, 1)))
            },
            toString: kendo.toString,
            parseDate: kendo.parseDate
        }), n.TemplateService.register({
            compile: kendo.template
        }), i.Point2D = i.Point, i.Box2D = i.Box, i.mwDelta = function(t) {
            return i.mousewheelDelta(t.originalEvent)
        }
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(t, i, n) {
    (n || i)()
}),
function(t, define) {
    define("kendo.dataviz.core.min", ["dataviz/core/kendo-core.min", "dataviz/core/core.min"], t)
}(function() {}, "function" == typeof define && define.amd ? define : function(t, i, n) {
    (n || i)()
});;
! function(o, define) {
    define("util/text-metrics.min", ["kendo.core.min"], o)
}(function() {
    ! function(o) {
        function e(o) {
            return (o + "").replace(i, n)
        }

        function r(o) {
            var e, r = [];
            for (e in o) r.push(e + o[e]);
            return r.sort().join("")
        }

        function l(o) {
            var e, r = 2166136261;
            for (e = 0; e < o.length; ++e) r += (r << 1) + (r << 4) + (r << 7) + (r << 8) + (r << 24), r ^= o.charCodeAt(e);
            return r >>> 0
        }

        function c() {
            return {
                width: 0,
                height: 0,
                baseline: 0
            }
        }

        function a(o, e, r) {
            return d.current.measure(o, e, r)
        }
        var t, i, n, s, f, d;
        window.kendo.util = window.kendo.util || {}, t = kendo.Class.extend({
            init: function(o) {
                this._size = o, this._length = 0, this._map = {}
            },
            put: function(o, e) {
                var r = this._map,
                    l = {
                        key: o,
                        value: e
                    };
                r[o] = l, this._head ? (this._tail.newer = l, l.older = this._tail, this._tail = l) : this._head = this._tail = l, this._length >= this._size ? (r[this._head.key] = null, this._head = this._head.newer, this._head.older = null) : this._length++
            },
            get: function(o) {
                var e = this._map[o];
                if (e) return e === this._head && e !== this._tail && (this._head = e.newer, this._head.older = null), e !== this._tail && (e.older && (e.older.newer = e.newer, e.newer.older = e.older), e.older = this._tail, e.newer = null, this._tail.newer = e, this._tail = e), e.value
            }
        }), i = /\r?\n|\r|\t/g, n = " ", s = {
            baselineMarkerSize: 1
        }, "undefined" != typeof document && (f = document.createElement("div"), f.style.cssText = "position: absolute !important; top: -4000px !important; width: auto !important; height: auto !important;padding: 0 !important; margin: 0 !important; border: 0 !important;line-height: normal !important; visibility: hidden !important; white-space: pre!important;"), d = kendo.Class.extend({
            init: function(e) {
                this._cache = new t(1e3), this.options = o.extend({}, s, e)
            },
            measure: function(o, a, t) {
                var i, n, s, d, b, h, u, k, g;
                if (void 0 === t && (t = {}), !o) return c();
                if (i = r(a), n = l(o + i), s = this._cache.get(n)) return s;
                d = c(), b = t.box || f, h = this._baselineMarker().cloneNode(!1);
                for (u in a) k = a[u], void 0 !== k && (b.style[u] = k);
                return g = t.normalizeText !== !1 ? e(o) : o + "", b.textContent = g, b.appendChild(h), document.body.appendChild(b), g.length && (d.width = b.offsetWidth - this.options.baselineMarkerSize, d.height = b.offsetHeight, d.baseline = h.offsetTop + this.options.baselineMarkerSize), d.width > 0 && d.height > 0 && this._cache.put(n, d), b.parentNode.removeChild(b), d
            },
            _baselineMarker: function() {
                var o = document.createElement("div");
                return o.style.cssText = "display: inline-block; vertical-align: baseline;width: " + this.options.baselineMarkerSize + "px; height: " + this.options.baselineMarkerSize + "px;overflow: hidden;", o
            }
        }), d.current = new d, kendo.deepExtend(kendo.util, {
            LRUCache: t,
            TextMetrics: d,
            measureText: a,
            objectKey: r,
            hashKey: l,
            normalizeText: e
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(o, e, r) {
    (r || e)()
}),
function(o, define) {
    define("dataviz/themes/chart-base-theme.min", ["kendo.dataviz.core.min"], o)
}(function() {
    ! function() {
        var o, e, r, l, c, a, t, i, n, s, f, d, b, h, u, k, g, m, v, p, D, w, C, x, y, B, z, T, j, L, _, A, G, P;
        window.kendo.dataviz = window.kendo.dataviz || {}, o = 1.5, e = .4, r = "#000", l = "Arial, Helvetica, sans-serif", c = "11px " + l, a = "12px " + l, t = "16px " + l, i = "transparent", n = "#fff", s = function() {
            return {
                icon: {
                    border: {
                        width: 1
                    }
                },
                label: {
                    font: a,
                    padding: 3
                },
                line: {
                    length: 10,
                    width: 2
                },
                visible: !0
            }
        }, f = function() {
            return {
                labels: {
                    font: a
                },
                notes: s(),
                title: {
                    font: t,
                    margin: 5
                }
            }
        }, d = function() {
            return {
                highlight: {
                    markers: {
                        border: {}
                    }
                },
                line: {
                    opacity: 1,
                    width: 0
                },
                markers: {
                    size: 6,
                    visible: !1
                },
                opacity: .4
            }
        }, b = function() {
            return {
                highlight: {
                    markers: {
                        border: {}
                    }
                },
                line: {
                    opacity: 1,
                    width: 0
                },
                markers: {
                    size: 6,
                    visible: !1
                },
                opacity: .4
            }
        }, h = function() {
            return {
                gap: o,
                spacing: e
            }
        }, u = function() {
            return {
                outliersField: "",
                meanField: "",
                border: {
                    _brightness: .8,
                    width: 1
                },
                downColor: n,
                gap: 1,
                highlight: {
                    border: {
                        opacity: 1,
                        width: 2
                    },
                    whiskers: {
                        width: 3
                    },
                    mean: {
                        width: 2
                    },
                    median: {
                        width: 2
                    }
                },
                mean: {
                    width: 2
                },
                median: {
                    width: 2
                },
                spacing: .3,
                whiskers: {
                    width: 2
                }
            }
        }, k = function() {
            return {
                border: {
                    width: 0
                },
                labels: {
                    background: i
                },
                opacity: .6
            }
        }, g = function() {
            return {
                gap: o,
                spacing: e,
                target: {
                    color: "#ff0000"
                }
            }
        }, m = function() {
            return {
                border: {
                    _brightness: .8,
                    width: 1
                },
                downColor: n,
                gap: 1,
                highlight: {
                    border: {
                        opacity: 1,
                        width: 2
                    },
                    line: {
                        width: 2
                    }
                },
                line: {
                    color: r,
                    width: 1
                },
                spacing: .3
            }
        }, v = function() {
            return {
                gap: o,
                spacing: e
            }
        }, p = function() {
            return {
                margin: 1
            }
        }, D = function() {
            return {
                width: 2
            }
        }, w = function() {
            return {
                gap: 1,
                highlight: {
                    line: {
                        opacity: 1,
                        width: 3
                    }
                },
                line: {
                    width: 1
                },
                spacing: .3
            }
        }, C = function() {
            return {
                line: {
                    opacity: 1,
                    width: 0
                },
                markers: {
                    size: 6,
                    visible: !1
                },
                opacity: .5
            }
        }, x = function() {
            return {
                markers: {
                    visible: !1
                },
                width: 2
            }
        }, y = function() {
            return {
                gap: o,
                spacing: e
            }
        }, B = function() {
            return {
                gap: o,
                spacing: e
            }
        }, z = function() {
            return {
                width: 1
            }
        }, T = function() {
            return {
                gap: .5,
                line: {
                    color: r,
                    width: 1
                },
                spacing: e
            }
        }, j = function() {
            return {
                labels: {
                    background: "",
                    color: "",
                    padding: {
                        top: 5,
                        bottom: 5,
                        left: 7,
                        right: 7
                    }
                }
            }
        }, L = function() {
            return {
                labels: {
                    background: "",
                    color: "",
                    padding: {
                        top: 5,
                        bottom: 5,
                        left: 7,
                        right: 7
                    }
                }
            }
        }, _ = function(o) {
            return {
                visible: !0,
                labels: {
                    font: c
                },
                overlay: o.gradients ? {} : {
                    gradient: "none"
                },
                area: d(),
                rangeArea: b(),
                verticalRangeArea: b(),
                bar: h(),
                boxPlot: u(),
                bubble: k(),
                bullet: g(),
                candlestick: m(),
                column: v(),
                pie: j(),
                donut: p(),
                funnel: L(),
                horizontalWaterfall: T(),
                line: D(),
                notes: s(),
                ohlc: w(),
                radarArea: C(),
                radarLine: x(),
                polarArea: C(),
                polarLine: x(),
                rangeBar: y(),
                rangeColumn: B(),
                scatterLine: z(),
                verticalArea: d(),
                verticalBoxPlot: u(),
                verticalBullet: g(),
                verticalLine: D(),
                waterfall: T()
            }
        }, A = function() {
            return {
                font: t
            }
        }, G = function() {
            return {
                labels: {
                    font: a
                }
            }
        }, P = function(o) {
            return void 0 === o && (o = {}), {
                axisDefaults: f(),
                categoryAxis: {
                    majorGridLines: {
                        visible: !0
                    }
                },
                navigator: {
                    pane: {
                        height: 90,
                        margin: {
                            top: 10
                        }
                    }
                },
                seriesDefaults: _(o),
                title: A(),
                legend: G()
            }
        }, kendo.deepExtend(kendo.dataviz, {
            chartBaseTheme: P
        })
    }()
}, "function" == typeof define && define.amd ? define : function(o, e, r) {
    (r || e)()
}),
function(o, define) {
    define("dataviz/themes/auto-theme.min", ["kendo.dataviz.core.min"], o)
}(function() {
    ! function(o) {
        function e(e) {
            function l(o, e) {
                a(o, c(e, "backgroundColor"))
            }

            function c(o, e) {
                return i.find(".k-var--" + o).css(e)
            }

            function a(o, e) {
                for (var r = t, l = o.split("."), c = l.shift(); l.length > 0;) r = r[c] = r[c] || {}, c = l.shift();
                r[c] = e
            }
            var t, i;
            return !e && r ? r : (t = {
                chart: kendo.dataviz.chartBaseTheme()
            }, i = o('<div style="display: none">  <div class="k-var--accent"></div>  <div class="k-var--accent-contrast"></div>  <div class="k-var--base"></div>  <div class="k-var--background"></div>  <div class="k-var--normal-background"></div>  <div class="k-var--normal-text-color"></div>  <div class="k-var--hover-background"></div>  <div class="k-var--hover-text-color"></div>  <div class="k-var--selected-background"></div>  <div class="k-var--selected-text-color"></div>  <div class="k-var--chart-error-bars-background"></div>  <div class="k-var--chart-notes-background"></div>  <div class="k-var--chart-notes-border"></div>  <div class="k-var--chart-notes-lines"></div>  <div class="k-var--chart-crosshair-background"></div>  <div class="k-var--chart-inactive"></div>  <div class="k-var--chart-major-lines"></div>  <div class="k-var--chart-minor-lines"></div>  <div class="k-var--chart-area-opacity"></div>  <div class="k-widget">      <div class="k-var--chart-font"></div>      <div class="k-var--chart-title-font"></div>      <div class="k-var--chart-label-font"></div>  </div>  <div class="k-var--series">    <div class="k-var--series-a"></div>    <div class="k-var--series-b"></div>    <div class="k-var--series-c"></div>    <div class="k-var--series-d"></div>    <div class="k-var--series-e"></div>    <div class="k-var--series-f"></div>  </div>  <div class="k-var--gauge-pointer"></div>  <div class="k-var--gauge-track"></div></div>').appendTo(document.body), function() {
                l("chart.axisDefaults.crosshair.color", "chart-crosshair-background"), l("chart.axisDefaults.labels.color", "normal-text-color"), l("chart.axisDefaults.line.color", "chart-major-lines"), l("chart.axisDefaults.majorGridLines.color", "chart-major-lines"), l("chart.axisDefaults.minorGridLines.color", "chart-minor-lines"), l("chart.axisDefaults.notes.icon.background", "chart-notes-background"), l("chart.axisDefaults.notes.icon.border.color", "chart-notes-border"), l("chart.axisDefaults.notes.line.color", "chart-notes-lines"), l("chart.axisDefaults.title.color", "normal-text-color"), l("chart.chartArea.background", "background"), l("chart.legend.inactiveItems.labels.color", "chart-inactive"), l("chart.legend.inactiveItems.markers.color", "chart-inactive"), l("chart.legend.labels.color", "normal-text-color"), l("chart.seriesDefaults.boxPlot.downColor", "chart-major-lines"), l("chart.seriesDefaults.boxPlot.mean.color", "base"), l("chart.seriesDefaults.boxPlot.median.color", "base"), l("chart.seriesDefaults.boxPlot.whiskers.color", "accent"), l("chart.seriesDefaults.bullet.target.color", "accent"), l("chart.seriesDefaults.candlestick.downColor", "normal-text-color"), l("chart.seriesDefaults.candlestick.line.color", "normal-text-color"), l("chart.seriesDefaults.errorBars.color", "chart-error-bars-background"), l("chart.seriesDefaults.horizontalWaterfall.line.color", "chart-major-lines"), l("chart.seriesDefaults.icon.border.color", "chart-major-lines"), l("chart.seriesDefaults.labels.background", "background"), l("chart.seriesDefaults.labels.color", "normal-text-color"), l("chart.seriesDefaults.notes.icon.background", "chart-notes-background"), l("chart.seriesDefaults.notes.icon.border.color", "chart-notes-border"), l("chart.seriesDefaults.notes.line.color", "chart-notes-lines"), l("chart.seriesDefaults.verticalBoxPlot.downColor", "chart-major-lines"), l("chart.seriesDefaults.verticalBoxPlot.mean.color", "base"), l("chart.seriesDefaults.verticalBoxPlot.median.color", "base"), l("chart.seriesDefaults.verticalBoxPlot.whiskers.color", "accent"), l("chart.seriesDefaults.verticalBullet.target.color", "accent"), l("chart.seriesDefaults.waterfall.line.color", "chart-major-lines"), l("chart.title.color", "normal-text-color"), a("chart.seriesDefaults.labels.opacity", c("chart-area-opacity", "opacity")), l("diagram.shapeDefaults.fill.color", "accent"), l("diagram.shapeDefaults.content.color", "accent-contrast"), l("diagram.shapeDefaults.connectorDefaults.fill.color", "normal-text-color"), l("diagram.shapeDefaults.connectorDefaults.stroke.color", "accent-contrast"), l("diagram.shapeDefaults.connectorDefaults.hover.fill.color", "accent-contrast"), l("diagram.shapeDefaults.connectorDefaults.hover.stroke.color", "normal-text-color"), l("diagram.editable.resize.handles.stroke.color", "normal-text-color"), l("diagram.editable.resize.handles.fill.color", "normal-background"), l("diagram.editable.resize.handles.hover.stroke.color", "normal-text-color"), l("diagram.editable.resize.handles.hover.fill.color", "normal-text-color"), l("diagram.selectable.stroke.color", "normal-text-color"), l("diagram.connectionDefaults.stroke.color", "normal-text-color"), l("diagram.connectionDefaults.content.color", "normal-text-color"), l("diagram.connectionDefaults.selection.handles.fill.color", "accent-contrast"), l("diagram.connectionDefaults.selection.handles.stroke.color", "normal-text-color"), l("diagram.connectionDefaults.selection.stroke.color", "normal-text-color"), l("gauge.pointer.color", "gauge-pointer"), l("gauge.scale.labels.color", "normal-text-color"), l("gauge.scale.minorTicks.color", "normal-text-color"), l("gauge.scale.majorTicks.color", "normal-text-color"), l("gauge.scale.line.color", "normal-text-color"), l("gauge.scale.rangePlaceholderColor", "gauge-track")
            }(), function() {
                function o(o) {
                    return c(o, "fontSize") + " " + c(o, "fontFamily")
                }
                var e = o("chart-font"),
                    r = o("chart-title-font"),
                    l = o("chart-label-font");
                a("chart.axisDefaults.labels.font", l), a("chart.axisDefaults.notes.label.font", e), a("chart.axisDefaults.title.font", e), a("chart.legend.labels.font", e), a("chart.seriesDefaults.labels.font", l), a("chart.seriesDefaults.notes.label.font", e), a("chart.title.font", r)
            }(), function() {
                function e(o) {
                    return o.toLowerCase().charCodeAt(0) - "a".charCodeAt(0)
                }

                function r(o) {
                    return e(o.match(/series-([a-z])$/)[1])
                }
                var l = o(".k-var--series div").toArray(),
                    c = l.reduce(function(e, l) {
                        var c = r(l.className);
                        return e[c] = o(l).css("backgroundColor"), e
                    }, []);
                a("chart.seriesColors", c)
            }(), i.remove(), r = t, t)
        }
        var r;
        kendo.dataviz.autoTheme = e
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(o, e, r) {
    (r || e)()
}),
function(o, define) {
    define("dataviz/themes/themes.min", ["dataviz/themes/chart-base-theme.min"], o)
}(function() {
    return function(o) {
        function e(e, r) {
            return o.map(e, function(o, e) {
                return [
                    [o, r[e]]
                ]
            })
        }
        var r = window.kendo,
            l = r.dataviz.ui,
            c = r.deepExtend,
            a = "#000",
            t = "Arial,Helvetica,sans-serif",
            i = "12px " + t,
            n = "#fff",
            s = r.dataviz.chartBaseTheme({
                gradients: !0
            }),
            f = {
                scale: {
                    labels: {
                        font: i
                    }
                }
            },
            d = {
                shapeDefaults: {
                    hover: {
                        opacity: .2
                    },
                    stroke: {
                        width: 0
                    }
                },
                editable: {
                    resize: {
                        handles: {
                            width: 7,
                            height: 7
                        }
                    }
                },
                selectable: {
                    stroke: {
                        width: 1,
                        dashType: "dot"
                    }
                },
                connectionDefaults: {
                    stroke: {
                        width: 2
                    },
                    selection: {
                        handles: {
                            width: 8,
                            height: 8
                        }
                    },
                    editable: {
                        tools: ["edit", "delete"]
                    }
                }
            },
            b = l.themes,
            h = l.registerTheme = function(o, e) {
                var r, l = {};
                l.chart = c({}, s, e.chart), l.gauge = c({}, f, e.gauge), l.diagram = c({}, d, e.diagram), l.treeMap = c({}, e.treeMap), r = l.chart.seriesDefaults, r.verticalLine = c({}, r.line), r.verticalArea = c({}, r.area), r.rangeArea = c({}, r.area), r.verticalRangeArea = c({}, r.rangeArea), r.verticalBoxPlot = c({}, r.boxPlot), r.polarArea = c({}, r.radarArea), r.polarLine = c({}, r.radarLine), b[o] = l
            };
        h("black", {
                chart: {
                    title: {
                        color: n
                    },
                    legend: {
                        labels: {
                            color: n
                        },
                        inactiveItems: {
                            labels: {
                                color: "#919191"
                            },
                            markers: {
                                color: "#919191"
                            }
                        }
                    },
                    seriesDefaults: {
                        labels: {
                            color: n
                        },
                        errorBars: {
                            color: n
                        },
                        notes: {
                            icon: {
                                background: "#3b3b3b",
                                border: {
                                    color: "#8e8e8e"
                                }
                            },
                            label: {
                                color: n
                            },
                            line: {
                                color: "#8e8e8e"
                            }
                        },
                        pie: {
                            overlay: {
                                gradient: "sharpBevel"
                            }
                        },
                        donut: {
                            overlay: {
                                gradient: "sharpGlass"
                            }
                        },
                        line: {
                            markers: {
                                background: "#3d3d3d"
                            }
                        },
                        scatter: {
                            markers: {
                                background: "#3d3d3d"
                            }
                        },
                        scatterLine: {
                            markers: {
                                background: "#3d3d3d"
                            }
                        },
                        waterfall: {
                            line: {
                                color: "#8e8e8e"
                            }
                        },
                        horizontalWaterfall: {
                            line: {
                                color: "#8e8e8e"
                            }
                        },
                        candlestick: {
                            downColor: "#555",
                            line: {
                                color: n
                            },
                            border: {
                                _brightness: 1.5,
                                opacity: 1
                            },
                            highlight: {
                                border: {
                                    color: n,
                                    opacity: .2
                                }
                            }
                        },
                        ohlc: {
                            line: {
                                color: n
                            }
                        }
                    },
                    chartArea: {
                        background: "#3d3d3d"
                    },
                    seriesColors: ["#0081da", "#3aafff", "#99c900", "#ffeb3d", "#b20753", "#ff4195"],
                    axisDefaults: {
                        line: {
                            color: "#8e8e8e"
                        },
                        labels: {
                            color: n
                        },
                        majorGridLines: {
                            color: "#545454"
                        },
                        minorGridLines: {
                            color: "#454545"
                        },
                        title: {
                            color: n
                        },
                        crosshair: {
                            color: "#8e8e8e"
                        },
                        notes: {
                            icon: {
                                background: "#3b3b3b",
                                border: {
                                    color: "#8e8e8e"
                                }
                            },
                            label: {
                                color: n
                            },
                            line: {
                                color: "#8e8e8e"
                            }
                        }
                    }
                },
                gauge: {
                    pointer: {
                        color: "#0070e4"
                    },
                    scale: {
                        rangePlaceholderColor: "#1d1d1d",
                        labels: {
                            color: n
                        },
                        minorTicks: {
                            color: n
                        },
                        majorTicks: {
                            color: n
                        },
                        line: {
                            color: n
                        }
                    }
                },
                diagram: {
                    shapeDefaults: {
                        fill: {
                            color: "#0066cc"
                        },
                        connectorDefaults: {
                            fill: {
                                color: n
                            },
                            stroke: {
                                color: "#384049"
                            },
                            hover: {
                                fill: {
                                    color: "#3d3d3d"
                                },
                                stroke: {
                                    color: "#efefef"
                                }
                            }
                        },
                        content: {
                            color: n
                        }
                    },
                    editable: {
                        resize: {
                            handles: {
                                fill: {
                                    color: "#3d3d3d"
                                },
                                stroke: {
                                    color: n
                                },
                                hover: {
                                    fill: {
                                        color: n
                                    },
                                    stroke: {
                                        color: n
                                    }
                                }
                            }
                        },
                        rotate: {
                            thumb: {
                                stroke: {
                                    color: n
                                },
                                fill: {
                                    color: n
                                }
                            }
                        }
                    },
                    selectable: {
                        stroke: {
                            color: n
                        }
                    },
                    connectionDefaults: {
                        stroke: {
                            color: n
                        },
                        content: {
                            color: n
                        },
                        selection: {
                            handles: {
                                fill: {
                                    color: "#3d3d3d"
                                },
                                stroke: {
                                    color: "#efefef"
                                }
                            }
                        }
                    }
                },
                treeMap: {
                    colors: [
                        ["#0081da", "#314b5c"],
                        ["#3aafff", "#3c5464"],
                        ["#99c900", "#4f5931"],
                        ["#ffeb3d", "#64603d"],
                        ["#b20753", "#543241"],
                        ["#ff4195", "#643e4f"]
                    ]
                }
            }), h("blueopal", {
                chart: {
                    title: {
                        color: "#293135"
                    },
                    legend: {
                        labels: {
                            color: "#293135"
                        },
                        inactiveItems: {
                            labels: {
                                color: "#27A5BA"
                            },
                            markers: {
                                color: "#27A5BA"
                            }
                        }
                    },
                    seriesDefaults: {
                        labels: {
                            color: a,
                            background: n,
                            opacity: .5
                        },
                        errorBars: {
                            color: "#293135"
                        },
                        candlestick: {
                            downColor: "#c4d0d5",
                            line: {
                                color: "#9aabb2"
                            }
                        },
                        waterfall: {
                            line: {
                                color: "#9aabb2"
                            }
                        },
                        horizontalWaterfall: {
                            line: {
                                color: "#9aabb2"
                            }
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#9aabb2"
                                }
                            },
                            label: {
                                color: "#293135"
                            },
                            line: {
                                color: "#9aabb2"
                            }
                        }
                    },
                    seriesColors: ["#0069a5", "#0098ee", "#7bd2f6", "#ffb800", "#ff8517", "#e34a00"],
                    axisDefaults: {
                        line: {
                            color: "#9aabb2"
                        },
                        labels: {
                            color: "#293135"
                        },
                        majorGridLines: {
                            color: "#c4d0d5"
                        },
                        minorGridLines: {
                            color: "#edf1f2"
                        },
                        title: {
                            color: "#293135"
                        },
                        crosshair: {
                            color: "#9aabb2"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#9aabb2"
                                }
                            },
                            label: {
                                color: "#293135"
                            },
                            line: {
                                color: "#9aabb2"
                            }
                        }
                    }
                },
                gauge: {
                    pointer: {
                        color: "#005c83"
                    },
                    scale: {
                        rangePlaceholderColor: "#daecf4",
                        labels: {
                            color: "#293135"
                        },
                        minorTicks: {
                            color: "#293135"
                        },
                        majorTicks: {
                            color: "#293135"
                        },
                        line: {
                            color: "#293135"
                        }
                    }
                },
                diagram: {
                    shapeDefaults: {
                        fill: {
                            color: "#7ec6e3"
                        },
                        connectorDefaults: {
                            fill: {
                                color: "#003f59"
                            },
                            stroke: {
                                color: n
                            },
                            hover: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#003f59"
                                }
                            }
                        },
                        content: {
                            color: "#293135"
                        }
                    },
                    editable: {
                        resize: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#003f59"
                                },
                                hover: {
                                    fill: {
                                        color: "#003f59"
                                    },
                                    stroke: {
                                        color: "#003f59"
                                    }
                                }
                            }
                        },
                        rotate: {
                            thumb: {
                                stroke: {
                                    color: "#003f59"
                                },
                                fill: {
                                    color: "#003f59"
                                }
                            }
                        }
                    },
                    selectable: {
                        stroke: {
                            color: "#003f59"
                        }
                    },
                    connectionDefaults: {
                        stroke: {
                            color: "#003f59"
                        },
                        content: {
                            color: "#293135"
                        },
                        selection: {
                            handles: {
                                fill: {
                                    color: "#3d3d3d"
                                },
                                stroke: {
                                    color: "#efefef"
                                }
                            }
                        }
                    }
                },
                treeMap: {
                    colors: [
                        ["#0069a5", "#bad7e7"],
                        ["#0098ee", "#b9e0f5"],
                        ["#7bd2f6", "#ceeaf6"],
                        ["#ffb800", "#e6e3c4"],
                        ["#ff8517", "#e4d8c8"],
                        ["#e34a00", "#ddccc2"]
                    ]
                }
            }), h("highcontrast", {
                chart: {
                    title: {
                        color: "#ffffff"
                    },
                    legend: {
                        labels: {
                            color: "#ffffff"
                        },
                        inactiveItems: {
                            labels: {
                                color: "#66465B"
                            },
                            markers: {
                                color: "#66465B"
                            }
                        }
                    },
                    seriesDefaults: {
                        labels: {
                            color: "#ffffff"
                        },
                        errorBars: {
                            color: "#ffffff"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#ffffff"
                                }
                            },
                            label: {
                                color: "#ffffff"
                            },
                            line: {
                                color: "#ffffff"
                            }
                        },
                        pie: {
                            overlay: {
                                gradient: "sharpGlass"
                            }
                        },
                        donut: {
                            overlay: {
                                gradient: "sharpGlass"
                            }
                        },
                        line: {
                            markers: {
                                background: "#2c232b"
                            }
                        },
                        scatter: {
                            markers: {
                                background: "#2c232b"
                            }
                        },
                        scatterLine: {
                            markers: {
                                background: "#2c232b"
                            }
                        },
                        area: {
                            opacity: .5
                        },
                        waterfall: {
                            line: {
                                color: "#ffffff"
                            }
                        },
                        horizontalWaterfall: {
                            line: {
                                color: "#ffffff"
                            }
                        },
                        candlestick: {
                            downColor: "#664e62",
                            line: {
                                color: "#ffffff"
                            },
                            border: {
                                _brightness: 1.5,
                                opacity: 1
                            },
                            highlight: {
                                border: {
                                    color: "#ffffff",
                                    opacity: 1
                                }
                            }
                        },
                        ohlc: {
                            line: {
                                color: "#ffffff"
                            }
                        }
                    },
                    chartArea: {
                        background: "#2c232b"
                    },
                    seriesColors: ["#a7008f", "#ffb800", "#3aafff", "#99c900", "#b20753", "#ff4195"],
                    axisDefaults: {
                        line: {
                            color: "#ffffff"
                        },
                        labels: {
                            color: "#ffffff"
                        },
                        majorGridLines: {
                            color: "#664e62"
                        },
                        minorGridLines: {
                            color: "#4f394b"
                        },
                        title: {
                            color: "#ffffff"
                        },
                        crosshair: {
                            color: "#ffffff"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#ffffff"
                                }
                            },
                            label: {
                                color: "#ffffff"
                            },
                            line: {
                                color: "#ffffff"
                            }
                        }
                    }
                },
                gauge: {
                    pointer: {
                        color: "#a7008f"
                    },
                    scale: {
                        rangePlaceholderColor: "#2c232b",
                        labels: {
                            color: "#ffffff"
                        },
                        minorTicks: {
                            color: "#2c232b"
                        },
                        majorTicks: {
                            color: "#664e62"
                        },
                        line: {
                            color: "#ffffff"
                        }
                    }
                },
                diagram: {
                    shapeDefaults: {
                        fill: {
                            color: "#a7018f"
                        },
                        connectorDefaults: {
                            fill: {
                                color: n
                            },
                            stroke: {
                                color: "#2c232b"
                            },
                            hover: {
                                fill: {
                                    color: "#2c232b"
                                },
                                stroke: {
                                    color: n
                                }
                            }
                        },
                        content: {
                            color: n
                        }
                    },
                    editable: {
                        resize: {
                            handles: {
                                fill: {
                                    color: "#2c232b"
                                },
                                stroke: {
                                    color: n
                                },
                                hover: {
                                    fill: {
                                        color: n
                                    },
                                    stroke: {
                                        color: n
                                    }
                                }
                            }
                        },
                        rotate: {
                            thumb: {
                                stroke: {
                                    color: n
                                },
                                fill: {
                                    color: n
                                }
                            }
                        }
                    },
                    selectable: {
                        stroke: {
                            color: n
                        }
                    },
                    connectionDefaults: {
                        stroke: {
                            color: n
                        },
                        content: {
                            color: n
                        },
                        selection: {
                            handles: {
                                fill: {
                                    color: "#2c232b"
                                },
                                stroke: {
                                    color: n
                                }
                            }
                        }
                    }
                },
                treeMap: {
                    colors: [
                        ["#a7008f", "#451c3f"],
                        ["#ffb800", "#564122"],
                        ["#3aafff", "#2f3f55"],
                        ["#99c900", "#424422"],
                        ["#b20753", "#471d33"],
                        ["#ff4195", "#562940"]
                    ]
                }
            }), h("default", {
                chart: {
                    title: {
                        color: "#8e8e8e"
                    },
                    legend: {
                        labels: {
                            color: "#232323"
                        },
                        inactiveItems: {
                            labels: {
                                color: "#919191"
                            },
                            markers: {
                                color: "#919191"
                            }
                        }
                    },
                    seriesDefaults: {
                        labels: {
                            color: a,
                            background: n,
                            opacity: .5
                        },
                        errorBars: {
                            color: "#232323"
                        },
                        candlestick: {
                            downColor: "#dedede",
                            line: {
                                color: "#8d8d8d"
                            }
                        },
                        waterfall: {
                            line: {
                                color: "#8e8e8e"
                            }
                        },
                        horizontalWaterfall: {
                            line: {
                                color: "#8e8e8e"
                            }
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#8e8e8e"
                                }
                            },
                            label: {
                                color: "#232323"
                            },
                            line: {
                                color: "#8e8e8e"
                            }
                        }
                    },
                    seriesColors: ["#ff6800", "#a0a700", "#ff8d00", "#678900", "#ffb53c", "#396000"],
                    axisDefaults: {
                        line: {
                            color: "#8e8e8e"
                        },
                        labels: {
                            color: "#232323"
                        },
                        minorGridLines: {
                            color: "#f0f0f0"
                        },
                        majorGridLines: {
                            color: "#dfdfdf"
                        },
                        title: {
                            color: "#232323"
                        },
                        crosshair: {
                            color: "#8e8e8e"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#8e8e8e"
                                }
                            },
                            label: {
                                color: "#232323"
                            },
                            line: {
                                color: "#8e8e8e"
                            }
                        }
                    }
                },
                gauge: {
                    pointer: {
                        color: "#ea7001"
                    },
                    scale: {
                        rangePlaceholderColor: "#dedede",
                        labels: {
                            color: "#2e2e2e"
                        },
                        minorTicks: {
                            color: "#2e2e2e"
                        },
                        majorTicks: {
                            color: "#2e2e2e"
                        },
                        line: {
                            color: "#2e2e2e"
                        }
                    }
                },
                diagram: {
                    shapeDefaults: {
                        fill: {
                            color: "#e15613"
                        },
                        connectorDefaults: {
                            fill: {
                                color: "#282828"
                            },
                            stroke: {
                                color: n
                            },
                            hover: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#282828"
                                }
                            }
                        },
                        content: {
                            color: "#2e2e2e"
                        }
                    },
                    editable: {
                        resize: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#282828"
                                },
                                hover: {
                                    fill: {
                                        color: "#282828"
                                    },
                                    stroke: {
                                        color: "#282828"
                                    }
                                }
                            }
                        },
                        rotate: {
                            thumb: {
                                stroke: {
                                    color: "#282828"
                                },
                                fill: {
                                    color: "#282828"
                                }
                            }
                        }
                    },
                    selectable: {
                        stroke: {
                            color: "#a7018f"
                        }
                    },
                    connectionDefaults: {
                        stroke: {
                            color: "#282828"
                        },
                        content: {
                            color: "#2e2e2e"
                        },
                        selection: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#282828"
                                }
                            }
                        }
                    }
                },
                treeMap: {
                    colors: [
                        ["#ff6800", "#edcfba"],
                        ["#a0a700", "#dadcba"],
                        ["#ff8d00", "#edd7ba"],
                        ["#678900", "#cfd6ba"],
                        ["#ffb53c", "#eddfc6"],
                        ["#396000", "#c6ceba"]
                    ]
                }
            }), h("silver", {
                chart: {
                    title: {
                        color: "#4e5968"
                    },
                    legend: {
                        labels: {
                            color: "#4e5968"
                        },
                        inactiveItems: {
                            labels: {
                                color: "#B1BCC8"
                            },
                            markers: {
                                color: "#B1BCC8"
                            }
                        }
                    },
                    seriesDefaults: {
                        labels: {
                            color: "#293135",
                            background: "#eaeaec",
                            opacity: .5
                        },
                        errorBars: {
                            color: "#4e5968"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#4e5968"
                                }
                            },
                            label: {
                                color: "#4e5968"
                            },
                            line: {
                                color: "#4e5968"
                            }
                        },
                        line: {
                            markers: {
                                background: "#eaeaec"
                            }
                        },
                        scatter: {
                            markers: {
                                background: "#eaeaec"
                            }
                        },
                        scatterLine: {
                            markers: {
                                background: "#eaeaec"
                            }
                        },
                        pie: {
                            connectors: {
                                color: "#A6B1C0"
                            }
                        },
                        donut: {
                            connectors: {
                                color: "#A6B1C0"
                            }
                        },
                        waterfall: {
                            line: {
                                color: "#a6b1c0"
                            }
                        },
                        horizontalWaterfall: {
                            line: {
                                color: "#a6b1c0"
                            }
                        },
                        candlestick: {
                            downColor: "#a6afbe"
                        }
                    },
                    chartArea: {
                        background: "#eaeaec"
                    },
                    seriesColors: ["#007bc3", "#76b800", "#ffae00", "#ef4c00", "#a419b7", "#430B62"],
                    axisDefaults: {
                        line: {
                            color: "#a6b1c0"
                        },
                        labels: {
                            color: "#4e5968"
                        },
                        majorGridLines: {
                            color: "#dcdcdf"
                        },
                        minorGridLines: {
                            color: "#eeeeef"
                        },
                        title: {
                            color: "#4e5968"
                        },
                        crosshair: {
                            color: "#a6b1c0"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#4e5968"
                                }
                            },
                            label: {
                                color: "#4e5968"
                            },
                            line: {
                                color: "#4e5968"
                            }
                        }
                    }
                },
                gauge: {
                    pointer: {
                        color: "#0879c0"
                    },
                    scale: {
                        rangePlaceholderColor: "#f3f3f4",
                        labels: {
                            color: "#515967"
                        },
                        minorTicks: {
                            color: "#515967"
                        },
                        majorTicks: {
                            color: "#515967"
                        },
                        line: {
                            color: "#515967"
                        }
                    }
                },
                diagram: {
                    shapeDefaults: {
                        fill: {
                            color: "#1c82c2"
                        },
                        connectorDefaults: {
                            fill: {
                                color: "#515967"
                            },
                            stroke: {
                                color: n
                            },
                            hover: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#282828"
                                }
                            }
                        },
                        content: {
                            color: "#515967"
                        }
                    },
                    editable: {
                        resize: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#515967"
                                },
                                hover: {
                                    fill: {
                                        color: "#515967"
                                    },
                                    stroke: {
                                        color: "#515967"
                                    }
                                }
                            }
                        },
                        rotate: {
                            thumb: {
                                stroke: {
                                    color: "#515967"
                                },
                                fill: {
                                    color: "#515967"
                                }
                            }
                        }
                    },
                    selectable: {
                        stroke: {
                            color: "#515967"
                        }
                    },
                    connectionDefaults: {
                        stroke: {
                            color: "#515967"
                        },
                        content: {
                            color: "#515967"
                        },
                        selection: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#515967"
                                }
                            }
                        }
                    }
                },
                treeMap: {
                    colors: [
                        ["#007bc3", "#c2dbea"],
                        ["#76b800", "#dae7c3"],
                        ["#ffae00", "#f5e5c3"],
                        ["#ef4c00", "#f2d2c3"],
                        ["#a419b7", "#e3c7e8"],
                        ["#430b62", "#d0c5d7"]
                    ]
                }
            }), h("metro", {
                chart: {
                    title: {
                        color: "#777777"
                    },
                    legend: {
                        labels: {
                            color: "#777777"
                        },
                        inactiveItems: {
                            labels: {
                                color: "#CBCBCB"
                            },
                            markers: {
                                color: "#CBCBCB"
                            }
                        }
                    },
                    seriesDefaults: {
                        labels: {
                            color: a
                        },
                        errorBars: {
                            color: "#777777"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#777777"
                                }
                            },
                            label: {
                                color: "#777777"
                            },
                            line: {
                                color: "#777777"
                            }
                        },
                        candlestick: {
                            downColor: "#c7c7c7",
                            line: {
                                color: "#787878"
                            }
                        },
                        waterfall: {
                            line: {
                                color: "#c7c7c7"
                            }
                        },
                        horizontalWaterfall: {
                            line: {
                                color: "#c7c7c7"
                            }
                        },
                        overlay: {
                            gradient: "none"
                        },
                        border: {
                            _brightness: 1
                        }
                    },
                    seriesColors: ["#8ebc00", "#309b46", "#25a0da", "#ff6900", "#e61e26", "#d8e404", "#16aba9", "#7e51a1", "#313131", "#ed1691"],
                    axisDefaults: {
                        line: {
                            color: "#c7c7c7"
                        },
                        labels: {
                            color: "#777777"
                        },
                        minorGridLines: {
                            color: "#c7c7c7"
                        },
                        majorGridLines: {
                            color: "#c7c7c7"
                        },
                        title: {
                            color: "#777777"
                        },
                        crosshair: {
                            color: "#c7c7c7"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#777777"
                                }
                            },
                            label: {
                                color: "#777777"
                            },
                            line: {
                                color: "#777777"
                            }
                        }
                    }
                },
                gauge: {
                    pointer: {
                        color: "#8ebc00"
                    },
                    scale: {
                        rangePlaceholderColor: "#e6e6e6",
                        labels: {
                            color: "#777"
                        },
                        minorTicks: {
                            color: "#777"
                        },
                        majorTicks: {
                            color: "#777"
                        },
                        line: {
                            color: "#777"
                        }
                    }
                },
                diagram: {
                    shapeDefaults: {
                        fill: {
                            color: "#8ebc00"
                        },
                        connectorDefaults: {
                            fill: {
                                color: a
                            },
                            stroke: {
                                color: n
                            },
                            hover: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: a
                                }
                            }
                        },
                        content: {
                            color: "#777"
                        }
                    },
                    editable: {
                        resize: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#787878"
                                },
                                hover: {
                                    fill: {
                                        color: "#787878"
                                    },
                                    stroke: {
                                        color: "#787878"
                                    }
                                }
                            }
                        },
                        rotate: {
                            thumb: {
                                stroke: {
                                    color: "#787878"
                                },
                                fill: {
                                    color: "#787878"
                                }
                            }
                        }
                    },
                    selectable: {
                        stroke: {
                            color: "#515967"
                        }
                    },
                    connectionDefaults: {
                        stroke: {
                            color: "#787878"
                        },
                        content: {
                            color: "#777"
                        },
                        selection: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#787878"
                                }
                            }
                        }
                    }
                },
                treeMap: {
                    colors: [
                        ["#8ebc00", "#e8f2cc"],
                        ["#309b46", "#d6ebda"],
                        ["#25a0da", "#d3ecf8"],
                        ["#ff6900", "#ffe1cc"],
                        ["#e61e26", "#fad2d4"],
                        ["#d8e404", "#f7facd"],
                        ["#16aba9", "#d0eeee"],
                        ["#7e51a1", "#e5dcec"],
                        ["#313131", "#d6d6d6"],
                        ["#ed1691", "#fbd0e9"]
                    ]
                }
            }), h("metroblack", {
                chart: {
                    title: {
                        color: "#ffffff"
                    },
                    legend: {
                        labels: {
                            color: "#ffffff"
                        },
                        inactiveItems: {
                            labels: {
                                color: "#797979"
                            },
                            markers: {
                                color: "#797979"
                            }
                        }
                    },
                    seriesDefaults: {
                        border: {
                            _brightness: 1
                        },
                        labels: {
                            color: "#ffffff"
                        },
                        errorBars: {
                            color: "#ffffff"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#cecece"
                                }
                            },
                            label: {
                                color: "#ffffff"
                            },
                            line: {
                                color: "#cecece"
                            }
                        },
                        line: {
                            markers: {
                                background: "#0e0e0e"
                            }
                        },
                        bubble: {
                            opacity: .6
                        },
                        scatter: {
                            markers: {
                                background: "#0e0e0e"
                            }
                        },
                        scatterLine: {
                            markers: {
                                background: "#0e0e0e"
                            }
                        },
                        candlestick: {
                            downColor: "#828282",
                            line: {
                                color: "#ffffff"
                            }
                        },
                        waterfall: {
                            line: {
                                color: "#cecece"
                            }
                        },
                        horizontalWaterfall: {
                            line: {
                                color: "#cecece"
                            }
                        },
                        overlay: {
                            gradient: "none"
                        }
                    },
                    chartArea: {
                        background: "#0e0e0e"
                    },
                    seriesColors: ["#00aba9", "#309b46", "#8ebc00", "#ff6900", "#e61e26", "#d8e404", "#25a0da", "#7e51a1", "#313131", "#ed1691"],
                    axisDefaults: {
                        line: {
                            color: "#cecece"
                        },
                        labels: {
                            color: "#ffffff"
                        },
                        minorGridLines: {
                            color: "#2d2d2d"
                        },
                        majorGridLines: {
                            color: "#333333"
                        },
                        title: {
                            color: "#ffffff"
                        },
                        crosshair: {
                            color: "#cecece"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#cecece"
                                }
                            },
                            label: {
                                color: "#ffffff"
                            },
                            line: {
                                color: "#cecece"
                            }
                        }
                    }
                },
                gauge: {
                    pointer: {
                        color: "#00aba9"
                    },
                    scale: {
                        rangePlaceholderColor: "#2d2d2d",
                        labels: {
                            color: "#ffffff"
                        },
                        minorTicks: {
                            color: "#333333"
                        },
                        majorTicks: {
                            color: "#cecece"
                        },
                        line: {
                            color: "#cecece"
                        }
                    }
                },
                diagram: {
                    shapeDefaults: {
                        fill: {
                            color: "#00aba9"
                        },
                        connectorDefaults: {
                            fill: {
                                color: n
                            },
                            stroke: {
                                color: "#0e0e0e"
                            },
                            hover: {
                                fill: {
                                    color: "#0e0e0e"
                                },
                                stroke: {
                                    color: n
                                }
                            }
                        },
                        content: {
                            color: n
                        }
                    },
                    editable: {
                        resize: {
                            handles: {
                                fill: {
                                    color: "#0e0e0e"
                                },
                                stroke: {
                                    color: "#787878"
                                },
                                hover: {
                                    fill: {
                                        color: "#787878"
                                    },
                                    stroke: {
                                        color: "#787878"
                                    }
                                }
                            }
                        },
                        rotate: {
                            thumb: {
                                stroke: {
                                    color: n
                                },
                                fill: {
                                    color: n
                                }
                            }
                        }
                    },
                    selectable: {
                        stroke: {
                            color: "#787878"
                        }
                    },
                    connectionDefaults: {
                        stroke: {
                            color: n
                        },
                        content: {
                            color: n
                        },
                        selection: {
                            handles: {
                                fill: {
                                    color: "#0e0e0e"
                                },
                                stroke: {
                                    color: n
                                }
                            }
                        }
                    }
                },
                treeMap: {
                    colors: [
                        ["#00aba9", "#0b2d2d"],
                        ["#309b46", "#152a19"],
                        ["#8ebc00", "#28310b"],
                        ["#ff6900", "#3e200b"],
                        ["#e61e26", "#391113"],
                        ["#d8e404", "#36390c"],
                        ["#25a0da", "#132b37"],
                        ["#7e51a1", "#241b2b"],
                        ["#313131", "#151515"],
                        ["#ed1691", "#3b1028"]
                    ]
                }
            }), h("moonlight", {
                chart: {
                    title: {
                        color: "#ffffff"
                    },
                    legend: {
                        labels: {
                            color: "#ffffff"
                        },
                        inactiveItems: {
                            labels: {
                                color: "#A1A7AB"
                            },
                            markers: {
                                color: "#A1A7AB"
                            }
                        }
                    },
                    seriesDefaults: {
                        labels: {
                            color: "#ffffff"
                        },
                        errorBars: {
                            color: "#ffffff"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#8c909e"
                                }
                            },
                            label: {
                                color: "#ffffff"
                            },
                            line: {
                                color: "#8c909e"
                            }
                        },
                        pie: {
                            overlay: {
                                gradient: "sharpBevel"
                            }
                        },
                        donut: {
                            overlay: {
                                gradient: "sharpGlass"
                            }
                        },
                        line: {
                            markers: {
                                background: "#212a33"
                            }
                        },
                        bubble: {
                            opacity: .6
                        },
                        scatter: {
                            markers: {
                                background: "#212a33"
                            }
                        },
                        scatterLine: {
                            markers: {
                                background: "#212a33"
                            }
                        },
                        area: {
                            opacity: .3
                        },
                        candlestick: {
                            downColor: "#757d87",
                            line: {
                                color: "#ea9d06"
                            },
                            border: {
                                _brightness: 1.5,
                                opacity: 1
                            },
                            highlight: {
                                border: {
                                    color: n,
                                    opacity: .2
                                }
                            }
                        },
                        waterfall: {
                            line: {
                                color: "#8c909e"
                            }
                        },
                        horizontalWaterfall: {
                            line: {
                                color: "#8c909e"
                            }
                        },
                        ohlc: {
                            line: {
                                color: "#ea9d06"
                            }
                        }
                    },
                    chartArea: {
                        background: "#212a33"
                    },
                    seriesColors: ["#ffca08", "#ff710f", "#ed2e24", "#ff9f03", "#e13c02", "#a00201"],
                    axisDefaults: {
                        line: {
                            color: "#8c909e"
                        },
                        minorTicks: {
                            color: "#8c909e"
                        },
                        majorTicks: {
                            color: "#8c909e"
                        },
                        labels: {
                            color: "#ffffff"
                        },
                        majorGridLines: {
                            color: "#3e424d"
                        },
                        minorGridLines: {
                            color: "#2f3640"
                        },
                        title: {
                            color: "#ffffff"
                        },
                        crosshair: {
                            color: "#8c909e"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#8c909e"
                                }
                            },
                            label: {
                                color: "#ffffff"
                            },
                            line: {
                                color: "#8c909e"
                            }
                        }
                    }
                },
                gauge: {
                    pointer: {
                        color: "#f4af03"
                    },
                    scale: {
                        rangePlaceholderColor: "#2f3640",
                        labels: {
                            color: n
                        },
                        minorTicks: {
                            color: "#8c909e"
                        },
                        majorTicks: {
                            color: "#8c909e"
                        },
                        line: {
                            color: "#8c909e"
                        }
                    }
                },
                diagram: {
                    shapeDefaults: {
                        fill: {
                            color: "#f3ae03"
                        },
                        connectorDefaults: {
                            fill: {
                                color: n
                            },
                            stroke: {
                                color: "#414550"
                            },
                            hover: {
                                fill: {
                                    color: "#414550"
                                },
                                stroke: {
                                    color: n
                                }
                            }
                        },
                        content: {
                            color: n
                        }
                    },
                    editable: {
                        resize: {
                            handles: {
                                fill: {
                                    color: "#414550"
                                },
                                stroke: {
                                    color: n
                                },
                                hover: {
                                    fill: {
                                        color: n
                                    },
                                    stroke: {
                                        color: n
                                    }
                                }
                            }
                        },
                        rotate: {
                            thumb: {
                                stroke: {
                                    color: n
                                },
                                fill: {
                                    color: n
                                }
                            }
                        }
                    },
                    selectable: {
                        stroke: {
                            color: n
                        }
                    },
                    connectionDefaults: {
                        stroke: {
                            color: n
                        },
                        content: {
                            color: n
                        },
                        selection: {
                            handles: {
                                fill: {
                                    color: "#414550"
                                },
                                stroke: {
                                    color: n
                                }
                            }
                        }
                    }
                },
                treeMap: {
                    colors: [
                        ["#ffca08", "#4e4b2b"],
                        ["#ff710f", "#4e392d"],
                        ["#ed2e24", "#4b2c31"],
                        ["#ff9f03", "#4e422a"],
                        ["#e13c02", "#482e2a"],
                        ["#a00201", "#3b232a"]
                    ]
                }
            }), h("uniform", {
                chart: {
                    title: {
                        color: "#686868"
                    },
                    legend: {
                        labels: {
                            color: "#686868"
                        },
                        inactiveItems: {
                            labels: {
                                color: "#B6B6B6"
                            },
                            markers: {
                                color: "#B6B6B6"
                            }
                        }
                    },
                    seriesDefaults: {
                        labels: {
                            color: "#686868"
                        },
                        errorBars: {
                            color: "#686868"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#9e9e9e"
                                }
                            },
                            label: {
                                color: "#686868"
                            },
                            line: {
                                color: "#9e9e9e"
                            }
                        },
                        pie: {
                            overlay: {
                                gradient: "sharpBevel"
                            }
                        },
                        donut: {
                            overlay: {
                                gradient: "sharpGlass"
                            }
                        },
                        line: {
                            markers: {
                                background: "#ffffff"
                            }
                        },
                        bubble: {
                            opacity: .6
                        },
                        scatter: {
                            markers: {
                                background: "#ffffff"
                            }
                        },
                        scatterLine: {
                            markers: {
                                background: "#ffffff"
                            }
                        },
                        area: {
                            opacity: .3
                        },
                        candlestick: {
                            downColor: "#cccccc",
                            line: {
                                color: "#cccccc"
                            },
                            border: {
                                _brightness: 1.5,
                                opacity: 1
                            },
                            highlight: {
                                border: {
                                    color: "#cccccc",
                                    opacity: .2
                                }
                            }
                        },
                        waterfall: {
                            line: {
                                color: "#9e9e9e"
                            }
                        },
                        horizontalWaterfall: {
                            line: {
                                color: "#9e9e9e"
                            }
                        },
                        ohlc: {
                            line: {
                                color: "#cccccc"
                            }
                        }
                    },
                    chartArea: {
                        background: "#ffffff"
                    },
                    seriesColors: ["#527aa3", "#6f91b3", "#8ca7c2", "#a8bdd1", "#c5d3e0", "#e2e9f0"],
                    axisDefaults: {
                        line: {
                            color: "#9e9e9e"
                        },
                        minorTicks: {
                            color: "#aaaaaa"
                        },
                        majorTicks: {
                            color: "#888888"
                        },
                        labels: {
                            color: "#686868"
                        },
                        majorGridLines: {
                            color: "#dadada"
                        },
                        minorGridLines: {
                            color: "#e7e7e7"
                        },
                        title: {
                            color: "#686868"
                        },
                        crosshair: {
                            color: "#9e9e9e"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#9e9e9e"
                                }
                            },
                            label: {
                                color: "#686868"
                            },
                            line: {
                                color: "#9e9e9e"
                            }
                        }
                    }
                },
                gauge: {
                    pointer: {
                        color: "#527aa3"
                    },
                    scale: {
                        rangePlaceholderColor: "#e7e7e7",
                        labels: {
                            color: "#686868"
                        },
                        minorTicks: {
                            color: "#aaaaaa"
                        },
                        majorTicks: {
                            color: "#888888"
                        },
                        line: {
                            color: "#9e9e9e"
                        }
                    }
                },
                diagram: {
                    shapeDefaults: {
                        fill: {
                            color: "#d1d1d1"
                        },
                        connectorDefaults: {
                            fill: {
                                color: "#686868"
                            },
                            stroke: {
                                color: n
                            },
                            hover: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#686868"
                                }
                            }
                        },
                        content: {
                            color: "#686868"
                        }
                    },
                    editable: {
                        resize: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#686868"
                                },
                                hover: {
                                    fill: {
                                        color: "#686868"
                                    },
                                    stroke: {
                                        color: "#686868"
                                    }
                                }
                            }
                        },
                        rotate: {
                            thumb: {
                                stroke: {
                                    color: "#686868"
                                },
                                fill: {
                                    color: "#686868"
                                }
                            }
                        }
                    },
                    selectable: {
                        stroke: {
                            color: "#686868"
                        }
                    },
                    connectionDefaults: {
                        stroke: {
                            color: "#686868"
                        },
                        content: {
                            color: "#686868"
                        },
                        selection: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#686868"
                                }
                            }
                        }
                    }
                },
                treeMap: {
                    colors: [
                        ["#527aa3", "#d0d8e1"],
                        ["#6f91b3", "#d6dde4"],
                        ["#8ca7c2", "#dce1e7"],
                        ["#a8bdd1", "#e2e6ea"],
                        ["#c5d3e0", "#e7eaed"],
                        ["#e2e9f0", "#edeff0"]
                    ]
                }
            }), h("bootstrap", {
                chart: {
                    title: {
                        color: "#333333"
                    },
                    legend: {
                        labels: {
                            color: "#333333"
                        },
                        inactiveItems: {
                            labels: {
                                color: "#999999"
                            },
                            markers: {
                                color: "#9A9A9A"
                            }
                        }
                    },
                    seriesDefaults: {
                        labels: {
                            color: "#333333"
                        },
                        overlay: {
                            gradient: "none"
                        },
                        errorBars: {
                            color: "#343434"
                        },
                        notes: {
                            icon: {
                                background: "#000000",
                                border: {
                                    color: "#000000"
                                }
                            },
                            label: {
                                color: "#333333"
                            },
                            line: {
                                color: "#000000"
                            }
                        },
                        pie: {
                            overlay: {
                                gradient: "none"
                            }
                        },
                        donut: {
                            overlay: {
                                gradient: "none"
                            }
                        },
                        line: {
                            markers: {
                                background: "#ffffff"
                            }
                        },
                        bubble: {
                            opacity: .6
                        },
                        scatter: {
                            markers: {
                                background: "#ffffff"
                            }
                        },
                        scatterLine: {
                            markers: {
                                background: "#ffffff"
                            }
                        },
                        area: {
                            opacity: .8
                        },
                        candlestick: {
                            downColor: "#d0d0d0",
                            line: {
                                color: "#333333"
                            },
                            border: {
                                _brightness: 1.5,
                                opacity: 1
                            },
                            highlight: {
                                border: {
                                    color: "#b8b8b8",
                                    opacity: .2
                                }
                            }
                        },
                        waterfall: {
                            line: {
                                color: "#cccccc"
                            }
                        },
                        horizontalWaterfall: {
                            line: {
                                color: "#cccccc"
                            }
                        },
                        ohlc: {
                            line: {
                                color: "#333333"
                            }
                        }
                    },
                    chartArea: {
                        background: "#ffffff"
                    },
                    seriesColors: ["#428bca", "#5bc0de", "#5cb85c", "#f2b661", "#e67d4a", "#da3b36"],
                    axisDefaults: {
                        line: {
                            color: "#cccccc"
                        },
                        minorTicks: {
                            color: "#ebebeb"
                        },
                        majorTicks: {
                            color: "#cccccc"
                        },
                        labels: {
                            color: "#333333"
                        },
                        majorGridLines: {
                            color: "#cccccc"
                        },
                        minorGridLines: {
                            color: "#ebebeb"
                        },
                        title: {
                            color: "#333333"
                        },
                        crosshair: {
                            color: "#000000"
                        },
                        notes: {
                            icon: {
                                background: "#000000",
                                border: {
                                    color: "#000000"
                                }
                            },
                            label: {
                                color: "#ffffff"
                            },
                            line: {
                                color: "#000000"
                            }
                        }
                    }
                },
                gauge: {
                    pointer: {
                        color: "#428bca"
                    },
                    scale: {
                        rangePlaceholderColor: "#cccccc",
                        labels: {
                            color: "#333333"
                        },
                        minorTicks: {
                            color: "#ebebeb"
                        },
                        majorTicks: {
                            color: "#cccccc"
                        },
                        line: {
                            color: "#cccccc"
                        }
                    }
                },
                diagram: {
                    shapeDefaults: {
                        fill: {
                            color: "#428bca"
                        },
                        connectorDefaults: {
                            fill: {
                                color: "#333333"
                            },
                            stroke: {
                                color: n
                            },
                            hover: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#333333"
                                }
                            }
                        },
                        content: {
                            color: "#333333"
                        }
                    },
                    editable: {
                        resize: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#333333"
                                },
                                hover: {
                                    fill: {
                                        color: "#333333"
                                    },
                                    stroke: {
                                        color: "#333333"
                                    }
                                }
                            }
                        },
                        rotate: {
                            thumb: {
                                stroke: {
                                    color: "#333333"
                                },
                                fill: {
                                    color: "#333333"
                                }
                            }
                        }
                    },
                    selectable: {
                        stroke: {
                            color: "#333333"
                        }
                    },
                    connectionDefaults: {
                        stroke: {
                            color: "#c4c4c4"
                        },
                        content: {
                            color: "#333333"
                        },
                        selection: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#333333"
                                }
                            },
                            stroke: {
                                color: "#333333"
                            }
                        }
                    }
                },
                treeMap: {
                    colors: [
                        ["#428bca", "#d1e0ec"],
                        ["#5bc0de", "#d6eaf0"],
                        ["#5cb85c", "#d6e9d6"],
                        ["#5cb85c", "#f4e8d7"],
                        ["#e67d4a", "#f2ddd3"],
                        ["#da3b36", "#f0d0cf"]
                    ]
                }
            }), h("flat", {
                chart: {
                    title: {
                        color: "#4c5356"
                    },
                    legend: {
                        labels: {
                            color: "#4c5356"
                        },
                        inactiveItems: {
                            labels: {
                                color: "#CBCBCB"
                            },
                            markers: {
                                color: "#CBCBCB"
                            }
                        }
                    },
                    seriesDefaults: {
                        labels: {
                            color: "#4c5356"
                        },
                        errorBars: {
                            color: "#4c5356"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#cdcdcd"
                                }
                            },
                            label: {
                                color: "#4c5356"
                            },
                            line: {
                                color: "#cdcdcd"
                            }
                        },
                        candlestick: {
                            downColor: "#c7c7c7",
                            line: {
                                color: "#787878"
                            }
                        },
                        area: {
                            opacity: .9
                        },
                        waterfall: {
                            line: {
                                color: "#cdcdcd"
                            }
                        },
                        horizontalWaterfall: {
                            line: {
                                color: "#cdcdcd"
                            }
                        },
                        overlay: {
                            gradient: "none"
                        },
                        border: {
                            _brightness: 1
                        }
                    },
                    seriesColors: ["#10c4b2", "#ff7663", "#ffb74f", "#a2df53", "#1c9ec4", "#ff63a5", "#1cc47b"],
                    axisDefaults: {
                        line: {
                            color: "#cdcdcd"
                        },
                        labels: {
                            color: "#4c5356"
                        },
                        minorGridLines: {
                            color: "#cdcdcd"
                        },
                        majorGridLines: {
                            color: "#cdcdcd"
                        },
                        title: {
                            color: "#4c5356"
                        },
                        crosshair: {
                            color: "#cdcdcd"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#cdcdcd"
                                }
                            },
                            label: {
                                color: "#4c5356"
                            },
                            line: {
                                color: "#cdcdcd"
                            }
                        }
                    }
                },
                gauge: {
                    pointer: {
                        color: "#10c4b2"
                    },
                    scale: {
                        rangePlaceholderColor: "#cdcdcd",
                        labels: {
                            color: "#4c5356"
                        },
                        minorTicks: {
                            color: "#4c5356"
                        },
                        majorTicks: {
                            color: "#4c5356"
                        },
                        line: {
                            color: "#4c5356"
                        }
                    }
                },
                diagram: {
                    shapeDefaults: {
                        fill: {
                            color: "#10c4b2"
                        },
                        connectorDefaults: {
                            fill: {
                                color: "#363940"
                            },
                            stroke: {
                                color: n
                            },
                            hover: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#363940"
                                }
                            }
                        },
                        content: {
                            color: "#4c5356"
                        }
                    },
                    editable: {
                        resize: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#363940"
                                },
                                hover: {
                                    fill: {
                                        color: "#363940"
                                    },
                                    stroke: {
                                        color: "#363940"
                                    }
                                }
                            }
                        },
                        rotate: {
                            thumb: {
                                stroke: {
                                    color: "#363940"
                                },
                                fill: {
                                    color: "#363940"
                                }
                            }
                        }
                    },
                    selectable: {
                        stroke: {
                            color: "#363940"
                        }
                    },
                    connectionDefaults: {
                        stroke: {
                            color: "#cdcdcd"
                        },
                        content: {
                            color: "#4c5356"
                        },
                        selection: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#363940"
                                }
                            },
                            stroke: {
                                color: "#363940"
                            }
                        }
                    }
                },
                treeMap: {
                    colors: [
                        ["#10c4b2", "#cff3f0"],
                        ["#ff7663", "#ffe4e0"],
                        ["#ffb74f", "#fff1dc"],
                        ["#a2df53", "#ecf9dd"],
                        ["#1c9ec4", "#d2ecf3"],
                        ["#ff63a5", "#ffe0ed"],
                        ["#1cc47b", "#d2f3e5"]
                    ]
                }
            }), h("material", {
                chart: {
                    title: {
                        color: "#444444"
                    },
                    legend: {
                        labels: {
                            color: "#444444"
                        },
                        inactiveItems: {
                            labels: {
                                color: "#CBCBCB"
                            },
                            markers: {
                                color: "#CBCBCB"
                            }
                        }
                    },
                    seriesDefaults: {
                        labels: {
                            color: "#444444"
                        },
                        errorBars: {
                            color: "#444444"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#e5e5e5"
                                }
                            },
                            label: {
                                color: "#444444"
                            },
                            line: {
                                color: "#e5e5e5"
                            }
                        },
                        candlestick: {
                            downColor: "#c7c7c7",
                            line: {
                                color: "#787878"
                            }
                        },
                        area: {
                            opacity: .9
                        },
                        waterfall: {
                            line: {
                                color: "#e5e5e5"
                            }
                        },
                        horizontalWaterfall: {
                            line: {
                                color: "#e5e5e5"
                            }
                        },
                        overlay: {
                            gradient: "none"
                        },
                        border: {
                            _brightness: 1
                        }
                    },
                    seriesColors: ["#3f51b5", "#03a9f4", "#4caf50", "#f9ce1d", "#ff9800", "#ff5722"],
                    axisDefaults: {
                        line: {
                            color: "#e5e5e5"
                        },
                        labels: {
                            color: "#444444"
                        },
                        minorGridLines: {
                            color: "#e5e5e5"
                        },
                        majorGridLines: {
                            color: "#e5e5e5"
                        },
                        title: {
                            color: "#444444"
                        },
                        crosshair: {
                            color: "#7f7f7f"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#e5e5e5"
                                }
                            },
                            label: {
                                color: "#444444"
                            },
                            line: {
                                color: "#e5e5e5"
                            }
                        }
                    }
                },
                gauge: {
                    pointer: {
                        color: "#3f51b5"
                    },
                    scale: {
                        rangePlaceholderColor: "#e5e5e5",
                        labels: {
                            color: "#444444"
                        },
                        minorTicks: {
                            color: "#444444"
                        },
                        majorTicks: {
                            color: "#444444"
                        },
                        line: {
                            color: "#444444"
                        }
                    }
                },
                diagram: {
                    shapeDefaults: {
                        fill: {
                            color: "#3f51b5"
                        },
                        connectorDefaults: {
                            fill: {
                                color: "#7f7f7f"
                            },
                            stroke: {
                                color: n
                            },
                            hover: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#7f7f7f"
                                }
                            }
                        },
                        content: {
                            color: "#444444"
                        }
                    },
                    editable: {
                        resize: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#444444"
                                },
                                hover: {
                                    fill: {
                                        color: "#444444"
                                    },
                                    stroke: {
                                        color: "#444444"
                                    }
                                }
                            }
                        },
                        rotate: {
                            thumb: {
                                stroke: {
                                    color: "#444444"
                                },
                                fill: {
                                    color: "#444444"
                                }
                            }
                        }
                    },
                    selectable: {
                        stroke: {
                            color: "#444444"
                        }
                    },
                    connectionDefaults: {
                        stroke: {
                            color: "#7f7f7f"
                        },
                        content: {
                            color: "#444444"
                        },
                        selection: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#444444"
                                }
                            },
                            stroke: {
                                color: "#444444"
                            }
                        }
                    }
                },
                treeMap: {
                    colors: [
                        ["#3f51b5", "#cff3f0"],
                        ["#03a9f4", "#e5f6fe"],
                        ["#4caf50", "#edf7ed"],
                        ["#f9ce1d", "#fefae8"],
                        ["#ff9800", "#fff4e5"],
                        ["#ff5722", "#ffeee8"]
                    ]
                }
            }), h("materialblack", {
                chart: {
                    title: {
                        color: "#fff"
                    },
                    legend: {
                        labels: {
                            color: "#fff"
                        },
                        inactiveItems: {
                            labels: {
                                color: "#CBCBCB"
                            },
                            markers: {
                                color: "#CBCBCB"
                            }
                        }
                    },
                    seriesDefaults: {
                        labels: {
                            color: "#fff"
                        },
                        errorBars: {
                            color: "#fff"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#e5e5e5"
                                }
                            },
                            label: {
                                color: "#fff"
                            },
                            line: {
                                color: "#e5e5e5"
                            }
                        },
                        candlestick: {
                            downColor: "#c7c7c7",
                            line: {
                                color: "#787878"
                            }
                        },
                        area: {
                            opacity: .9
                        },
                        waterfall: {
                            line: {
                                color: "#4d4d4d"
                            }
                        },
                        horizontalWaterfall: {
                            line: {
                                color: "#4d4d4d"
                            }
                        },
                        overlay: {
                            gradient: "none"
                        },
                        border: {
                            _brightness: 1
                        }
                    },
                    chartArea: {
                        background: "#1c1c1c"
                    },
                    seriesColors: ["#3f51b5", "#03a9f4", "#4caf50", "#f9ce1d", "#ff9800", "#ff5722"],
                    axisDefaults: {
                        line: {
                            color: "#4d4d4d"
                        },
                        labels: {
                            color: "#fff"
                        },
                        minorGridLines: {
                            color: "#4d4d4d"
                        },
                        majorGridLines: {
                            color: "#4d4d4d"
                        },
                        title: {
                            color: "#fff"
                        },
                        crosshair: {
                            color: "#7f7f7f"
                        },
                        notes: {
                            icon: {
                                background: "transparent",
                                border: {
                                    color: "#4d4d4d"
                                }
                            },
                            label: {
                                color: "#fff"
                            },
                            line: {
                                color: "#4d4d4d"
                            }
                        }
                    }
                },
                gauge: {
                    pointer: {
                        color: "#3f51b5"
                    },
                    scale: {
                        rangePlaceholderColor: "#4d4d4d",
                        labels: {
                            color: "#fff"
                        },
                        minorTicks: {
                            color: "#fff"
                        },
                        majorTicks: {
                            color: "#fff"
                        },
                        line: {
                            color: "#fff"
                        }
                    }
                },
                diagram: {
                    shapeDefaults: {
                        fill: {
                            color: "#3f51b5"
                        },
                        connectorDefaults: {
                            fill: {
                                color: "#7f7f7f"
                            },
                            stroke: {
                                color: n
                            },
                            hover: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#7f7f7f"
                                }
                            }
                        },
                        content: {
                            color: "#fff"
                        }
                    },
                    editable: {
                        resize: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#fff"
                                },
                                hover: {
                                    fill: {
                                        color: "#fff"
                                    },
                                    stroke: {
                                        color: "#fff"
                                    }
                                }
                            }
                        },
                        rotate: {
                            thumb: {
                                stroke: {
                                    color: "#fff"
                                },
                                fill: {
                                    color: "#fff"
                                }
                            }
                        }
                    },
                    selectable: {
                        stroke: {
                            color: "#fff"
                        }
                    },
                    connectionDefaults: {
                        stroke: {
                            color: "#7f7f7f"
                        },
                        content: {
                            color: "#fff"
                        },
                        selection: {
                            handles: {
                                fill: {
                                    color: n
                                },
                                stroke: {
                                    color: "#fff"
                                }
                            },
                            stroke: {
                                color: "#fff"
                            }
                        }
                    }
                },
                treeMap: {
                    colors: [
                        ["#3f51b5", "#cff3f0"],
                        ["#03a9f4", "#e5f6fe"],
                        ["#4caf50", "#edf7ed"],
                        ["#f9ce1d", "#fefae8"],
                        ["#ff9800", "#fff4e5"],
                        ["#ff5722", "#ffeee8"]
                    ]
                }
            }),
            function() {
                function o() {
                    return {
                        icon: {
                            background: "#007cc0",
                            border: {
                                color: "#007cc0"
                            }
                        },
                        label: {
                            color: "#ffffff"
                        },
                        line: {
                            color: a
                        }
                    }
                }
                var r = "#333333",
                    l = "#7f7f7f",
                    c = "#bdbdbd",
                    a = "#c8c8c8",
                    t = "#dddddd",
                    i = ["#008fd3", "#99d101", "#f39b02", "#f05662", "#c03c53", "#acacac"],
                    s = ["#cbe8f5", "#eaf5cb", "#fceacc", "#fbdcdf", "#f2d7dc", "#eeeeee"],
                    f = i[0],
                    d = n;
                h("fiori", {
                    chart: {
                        title: {
                            color: r
                        },
                        legend: {
                            labels: {
                                color: r
                            },
                            inactiveItems: {
                                labels: {
                                    color: l
                                },
                                markers: {
                                    color: l
                                }
                            }
                        },
                        seriesDefaults: {
                            labels: {
                                color: r
                            },
                            errorBars: {
                                color: r
                            },
                            notes: o(),
                            candlestick: {
                                downColor: a,
                                line: {
                                    color: c
                                }
                            },
                            area: {
                                opacity: .8
                            },
                            waterfall: {
                                line: {
                                    color: a
                                }
                            },
                            horizontalWaterfall: {
                                line: {
                                    color: a
                                }
                            },
                            overlay: {
                                gradient: "none"
                            },
                            border: {
                                _brightness: 1
                            }
                        },
                        seriesColors: i,
                        axisDefaults: {
                            line: {
                                color: a
                            },
                            labels: {
                                color: r
                            },
                            minorGridLines: {
                                color: t
                            },
                            majorGridLines: {
                                color: a
                            },
                            title: {
                                color: r
                            },
                            crosshair: {
                                color: l
                            },
                            notes: o()
                        }
                    },
                    gauge: {
                        pointer: {
                            color: f
                        },
                        scale: {
                            rangePlaceholderColor: a,
                            labels: {
                                color: r
                            },
                            minorTicks: {
                                color: r
                            },
                            majorTicks: {
                                color: r
                            },
                            line: {
                                color: r
                            }
                        }
                    },
                    diagram: {
                        shapeDefaults: {
                            fill: {
                                color: f
                            },
                            connectorDefaults: {
                                fill: {
                                    color: r
                                },
                                stroke: {
                                    color: d
                                },
                                hover: {
                                    fill: {
                                        color: d
                                    },
                                    stroke: {
                                        color: r
                                    }
                                }
                            },
                            content: {
                                color: r
                            }
                        },
                        editable: {
                            resize: {
                                handles: {
                                    fill: {
                                        color: d
                                    },
                                    stroke: {
                                        color: c
                                    },
                                    hover: {
                                        fill: {
                                            color: c
                                        },
                                        stroke: {
                                            color: c
                                        }
                                    }
                                }
                            },
                            rotate: {
                                thumb: {
                                    stroke: {
                                        color: c
                                    },
                                    fill: {
                                        color: c
                                    }
                                }
                            }
                        },
                        selectable: {
                            stroke: {
                                color: c
                            }
                        },
                        connectionDefaults: {
                            stroke: {
                                color: c
                            },
                            content: {
                                color: c
                            },
                            selection: {
                                handles: {
                                    fill: {
                                        color: d
                                    },
                                    stroke: {
                                        color: c
                                    }
                                },
                                stroke: {
                                    color: c
                                }
                            }
                        }
                    },
                    treeMap: {
                        colors: e(i, s)
                    }
                })
            }(),
            function() {
                function o() {
                    return {
                        icon: {
                            background: "#00b0ff",
                            border: {
                                color: "#00b0ff"
                            }
                        },
                        label: {
                            color: "#ffffff"
                        },
                        line: {
                            color: a
                        }
                    }
                }
                var r = "#4e4e4e",
                    l = "#7f7f7f",
                    c = "#bdbdbd",
                    a = "#c8c8c8",
                    t = "#e5e5e5",
                    i = ["#0072c6", "#5db2ff", "#008a17", "#82ba00", "#ff8f32", "#ac193d"],
                    s = ["#cbe2f3", "#deeffe", "#cbe7d0", "#e5f0cb", "#fee8d5", "#eed0d7"],
                    f = i[0],
                    d = n;
                h("office365", {
                    chart: {
                        title: {
                            color: r
                        },
                        legend: {
                            labels: {
                                color: r
                            },
                            inactiveItems: {
                                labels: {
                                    color: l
                                },
                                markers: {
                                    color: l
                                }
                            }
                        },
                        seriesDefaults: {
                            labels: {
                                color: r
                            },
                            errorBars: {
                                color: r
                            },
                            notes: o(),
                            candlestick: {
                                downColor: a,
                                line: {
                                    color: c
                                }
                            },
                            area: {
                                opacity: .8
                            },
                            waterfall: {
                                line: {
                                    color: a
                                }
                            },
                            horizontalWaterfall: {
                                line: {
                                    color: a
                                }
                            },
                            overlay: {
                                gradient: "none"
                            },
                            border: {
                                _brightness: 1
                            }
                        },
                        seriesColors: i,
                        axisDefaults: {
                            line: {
                                color: a
                            },
                            labels: {
                                color: r
                            },
                            minorGridLines: {
                                color: t
                            },
                            majorGridLines: {
                                color: a
                            },
                            title: {
                                color: r
                            },
                            crosshair: {
                                color: l
                            },
                            notes: o()
                        }
                    },
                    gauge: {
                        pointer: {
                            color: f
                        },
                        scale: {
                            rangePlaceholderColor: a,
                            labels: {
                                color: r
                            },
                            minorTicks: {
                                color: r
                            },
                            majorTicks: {
                                color: r
                            },
                            line: {
                                color: r
                            }
                        }
                    },
                    diagram: {
                        shapeDefaults: {
                            fill: {
                                color: f
                            },
                            connectorDefaults: {
                                fill: {
                                    color: r
                                },
                                stroke: {
                                    color: d
                                },
                                hover: {
                                    fill: {
                                        color: d
                                    },
                                    stroke: {
                                        color: r
                                    }
                                }
                            },
                            content: {
                                color: r
                            }
                        },
                        editable: {
                            resize: {
                                handles: {
                                    fill: {
                                        color: d
                                    },
                                    stroke: {
                                        color: c
                                    },
                                    hover: {
                                        fill: {
                                            color: c
                                        },
                                        stroke: {
                                            color: c
                                        }
                                    }
                                }
                            },
                            rotate: {
                                thumb: {
                                    stroke: {
                                        color: c
                                    },
                                    fill: {
                                        color: c
                                    }
                                }
                            }
                        },
                        selectable: {
                            stroke: {
                                color: c
                            }
                        },
                        connectionDefaults: {
                            stroke: {
                                color: c
                            },
                            content: {
                                color: c
                            },
                            selection: {
                                handles: {
                                    fill: {
                                        color: d
                                    },
                                    stroke: {
                                        color: c
                                    }
                                },
                                stroke: {
                                    color: c
                                }
                            }
                        }
                    },
                    treeMap: {
                        colors: e(i, s)
                    }
                })
            }(),
            function() {
                function o() {
                    return {
                        icon: {
                            background: "#007cc0",
                            border: {
                                color: "#007cc0"
                            }
                        },
                        label: {
                            color: "#ffffff"
                        },
                        line: {
                            color: a
                        }
                    }
                }
                var r = "#32364c",
                    l = "#7f7f7f",
                    c = "#bdbdbd",
                    a = "#dfe0e1",
                    t = "#dfe0e1",
                    i = ["#ff4350", "#ff9ea5", "#00acc1", "#80deea", "#ffbf46", "#ffd78c"],
                    s = ["#ffd9dc", "#ffeced", "#cceef3", "#e6f8fb", "#fff2da", "#fff7e8"],
                    f = i[0],
                    d = n;
                h("nova", {
                    chart: {
                        title: {
                            color: r
                        },
                        legend: {
                            labels: {
                                color: r
                            },
                            inactiveItems: {
                                labels: {
                                    color: l
                                },
                                markers: {
                                    color: l
                                }
                            }
                        },
                        seriesDefaults: {
                            labels: {
                                color: r
                            },
                            errorBars: {
                                color: r
                            },
                            notes: o(),
                            candlestick: {
                                downColor: a,
                                line: {
                                    color: c
                                }
                            },
                            area: {
                                opacity: .8
                            },
                            waterfall: {
                                line: {
                                    color: a
                                }
                            },
                            horizontalWaterfall: {
                                line: {
                                    color: a
                                }
                            },
                            overlay: {
                                gradient: "none"
                            },
                            border: {
                                _brightness: 1
                            }
                        },
                        seriesColors: i,
                        axisDefaults: {
                            line: {
                                color: a
                            },
                            labels: {
                                color: r
                            },
                            minorGridLines: {
                                color: t
                            },
                            majorGridLines: {
                                color: a
                            },
                            title: {
                                color: r
                            },
                            crosshair: {
                                color: r
                            },
                            notes: o()
                        }
                    },
                    gauge: {
                        pointer: {
                            color: f
                        },
                        scale: {
                            rangePlaceholderColor: a,
                            labels: {
                                color: r
                            },
                            minorTicks: {
                                color: r
                            },
                            majorTicks: {
                                color: r
                            },
                            line: {
                                color: r
                            }
                        }
                    },
                    diagram: {
                        shapeDefaults: {
                            fill: {
                                color: f
                            },
                            connectorDefaults: {
                                fill: {
                                    color: r
                                },
                                stroke: {
                                    color: d
                                },
                                hover: {
                                    fill: {
                                        color: d
                                    },
                                    stroke: {
                                        color: r
                                    }
                                }
                            },
                            content: {
                                color: r
                            }
                        },
                        editable: {
                            resize: {
                                handles: {
                                    fill: {
                                        color: d
                                    },
                                    stroke: {
                                        color: c
                                    },
                                    hover: {
                                        fill: {
                                            color: c
                                        },
                                        stroke: {
                                            color: c
                                        }
                                    }
                                }
                            },
                            rotate: {
                                thumb: {
                                    stroke: {
                                        color: c
                                    },
                                    fill: {
                                        color: c
                                    }
                                }
                            }
                        },
                        selectable: {
                            stroke: {
                                color: c
                            }
                        },
                        connectionDefaults: {
                            stroke: {
                                color: c
                            },
                            content: {
                                color: c
                            },
                            selection: {
                                handles: {
                                    fill: {
                                        color: d
                                    },
                                    stroke: {
                                        color: c
                                    }
                                },
                                stroke: {
                                    color: c
                                }
                            }
                        }
                    },
                    treeMap: {
                        colors: e(i, s)
                    }
                })
            }(),
            function() {
                var o = ["#ff6358", "#ffd246", "#78d237", "#28b4c8", "#2d73f5", "#aa46be"],
                    r = ["#ffd9dc", "#ffeced", "#cceef3", "#e6f8fb", "#fff2da", "#fff7e8"];
                h("default-v2", {
                    chart: {},
                    gauge: {},
                    diagram: {},
                    treeMap: {
                        colors: e(o, r)
                    }
                }), b.sass = b["default-v2"]
            }(),
            function() {
                var o = "#292b2c",
                    r = "rgba(0, 0, 0, .04)",
                    l = ["#0275d8", "#5bc0de", "#5cb85c", "#f0ad4e", "#e67d4a", "#d9534f"],
                    c = ["#ffd9dc", "#ffeced", "#cceef3", "#e6f8fb", "#fff2da", "#fff7e8"],
                    a = l[0];
                h("bootstrap-v4", {
                    chart: {},
                    gauge: {
                        pointer: {
                            color: a
                        },
                        scale: {
                            rangePlaceholderColor: r,
                            labels: {
                                color: o
                            },
                            minorTicks: {
                                color: o
                            },
                            majorTicks: {
                                color: o
                            },
                            line: {
                                color: o
                            }
                        }
                    },
                    diagram: {},
                    treeMap: {
                        colors: e(l, c)
                    }
                })
            }()
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(o, e, r) {
    (r || e)()
}),
function(o, define) {
    define("kendo.dataviz.themes.min", ["kendo.dataviz.core.min", "dataviz/themes/chart-base-theme.min", "dataviz/themes/auto-theme.min", "dataviz/themes/themes.min"], o)
}(function() {}, "function" == typeof define && define.amd ? define : function(o, e, r) {
    (r || e)()
});;
! function(t, define) {
    define("util/text-metrics.min", ["kendo.core.min"], t)
}(function() {
    ! function(t) {
        function e(t) {
            return (t + "").replace(a, h)
        }

        function i(t) {
            var e, i = [];
            for (e in t) i.push(e + t[e]);
            return i.sort().join("")
        }

        function n(t) {
            var e, i = 2166136261;
            for (e = 0; e < t.length; ++e) i += (i << 1) + (i << 4) + (i << 7) + (i << 8) + (i << 24), i ^= t.charCodeAt(e);
            return i >>> 0
        }

        function s() {
            return {
                width: 0,
                height: 0,
                baseline: 0
            }
        }

        function o(t, e, i) {
            return u.current.measure(t, e, i)
        }
        var r, a, h, l, c, u;
        window.kendo.util = window.kendo.util || {}, r = kendo.Class.extend({
            init: function(t) {
                this._size = t, this._length = 0, this._map = {}
            },
            put: function(t, e) {
                var i = this._map,
                    n = {
                        key: t,
                        value: e
                    };
                i[t] = n, this._head ? (this._tail.newer = n, n.older = this._tail, this._tail = n) : this._head = this._tail = n, this._length >= this._size ? (i[this._head.key] = null, this._head = this._head.newer, this._head.older = null) : this._length++
            },
            get: function(t) {
                var e = this._map[t];
                if (e) return e === this._head && e !== this._tail && (this._head = e.newer, this._head.older = null), e !== this._tail && (e.older && (e.older.newer = e.newer, e.newer.older = e.older), e.older = this._tail, e.newer = null, this._tail.newer = e, this._tail = e), e.value
            }
        }), a = /\r?\n|\r|\t/g, h = " ", l = {
            baselineMarkerSize: 1
        }, "undefined" != typeof document && (c = document.createElement("div"), c.style.cssText = "position: absolute !important; top: -4000px !important; width: auto !important; height: auto !important;padding: 0 !important; margin: 0 !important; border: 0 !important;line-height: normal !important; visibility: hidden !important; white-space: pre!important;"), u = kendo.Class.extend({
            init: function(e) {
                this._cache = new r(1e3), this.options = t.extend({}, l, e)
            },
            measure: function(t, o, r) {
                var a, h, l, u, p, d, g, f, v;
                if (void 0 === r && (r = {}), !t) return s();
                if (a = i(o), h = n(t + a), l = this._cache.get(h)) return l;
                u = s(), p = r.box || c, d = this._baselineMarker().cloneNode(!1);
                for (g in o) f = o[g], void 0 !== f && (p.style[g] = f);
                return v = r.normalizeText !== !1 ? e(t) : t + "", p.textContent = v, p.appendChild(d), document.body.appendChild(p), v.length && (u.width = p.offsetWidth - this.options.baselineMarkerSize, u.height = p.offsetHeight, u.baseline = d.offsetTop + this.options.baselineMarkerSize), u.width > 0 && u.height > 0 && this._cache.put(h, u), p.parentNode.removeChild(p), u
            },
            _baselineMarker: function() {
                var t = document.createElement("div");
                return t.style.cssText = "display: inline-block; vertical-align: baseline;width: " + this.options.baselineMarkerSize + "px; height: " + this.options.baselineMarkerSize + "px;overflow: hidden;", t
            }
        }), u.current = new u, kendo.deepExtend(kendo.util, {
            LRUCache: r,
            TextMetrics: u,
            measureText: o,
            objectKey: i,
            hashKey: n,
            normalizeText: e
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(t, e, i) {
    (i || e)()
}),
function(t, define) {
    define("dataviz/chart/kendo-chart.min", ["kendo.core.min", "kendo.color.min", "kendo.drawing.min", "kendo.dataviz.core.min"], t)
}(function() {
    ! function(t) {
        function e(t, e) {
            for (var i = 0; i < e.length; i++)
                if (e[i].options.name === t) return e[i].prepareUserOptions(), new le(e[i])
        }

        function i(t) {
            var e, i, n = t.length,
                s = 0;
            for (e = 0; e < n; e++) i = t[e], et(i) && s++;
            return s
        }

        function n(t, e) {
            if (null === e) return e;
            var i = _t(t, !0);
            return i(e)
        }

        function s(t, e, i, n) {
            var o, r, a, h, l;
            if (void 0 === i && (i = {}), void 0 === n && (n = !1), o = i.defaults = i.defaults || {}, r = i.depth = i.depth || 0, a = !1, i.excluded = i.excluded || [], r > Qi) return null;
            for (h in t) !Pt(h, i.excluded) && t.hasOwnProperty(h) && (l = t[h], Tt(l) ? (a = !0, n || (t[h] = Et(l(e), o[h]))) : Rt(l) && (n || (i.defaults = o[h]), i.depth++, a = s(l, e, i, n) || a, i.depth--));
            return a
        }

        function o(t) {
            var e, i = t.length,
                n = 0;
            for (e = 0; e < i; e++) n = Math.max(n, t[e].data.length);
            return n
        }

        function r(t, e, i, n, s) {
            var o = t.box,
                r = new ae;
            return r[e] = o[e + i], r[n] = o[n + s], r
        }

        function a(t) {
            for (var e = 0; e < t.length; e++)
                if (yt(t[e].zIndex)) return !0
        }

        function h(t) {
            var e = t.overlay;
            return e && e.gradient && "none" !== e.gradient
        }

        function l(t, e) {
            t.forEach(e)
        }

        function c(t, e) {
            var i, n = t.length;
            for (i = n - 1; i >= 0; i--) e(t[i], i - n - 1)
        }

        function u(t) {
            return i(t) === t.length
        }

        function p(t) {
            return yt(t) && null !== t
        }

        function d(t) {
            var e, i, n, s = t.series;
            for (e = 0; e < s.length; e++) i = s[e], n = i.data, !n || wt(n[0]) || Rt(n[0]) || (i.data = [n])
        }

        function g() {
            return "pane" + Hn++
        }

        function f(t, e) {
            null !== e && t.push(e)
        }

        function v(t, e, i) {
            var n, s = e.visible;
            return yt(s) ? s : (n = t.pointVisibility, n ? n[i] : void 0)
        }

        function m(t) {
            var e, i, n, s = t.data,
                o = [],
                r = 0,
                a = 0;
            for (e = 0; e < s.length; e++) i = de.current.bindPoint(t, e), n = i.valueFields.value, Ft(n) && (n = parseFloat(n)), et(n) ? (i.visible = v(t, i.fields, e) !== !1, i.value = Math.abs(n), o.push(i), i.visible && (r += i.value), 0 !== n && a++) : o.push(null);
            return {
                total: r,
                points: o,
                count: a
            }
        }

        function x(t, e) {
            return t && e ? t.toLowerCase() === e.toLowerCase() : t === e
        }

        function y(t, e) {
            var i, n, s = [],
                o = [].concat(e);
            for (i = 0; i < t.length; i++) n = t[i], Pt(n.type, o) && s.push(n);
            return s
        }

        function _(t, e, i) {
            var n, s;
            return null === e ? e : (n = "_date_" + t, s = e[n], s || (s = Nt(i, _t(t, !0)(e)), e[n] = s), s)
        }

        function w(t, e) {
            var i = t.type,
                n = e instanceof Date;
            return !i && n || x(i, vt)
        }

        function b(t) {
            return 1 === t.length ? t[0] : t
        }

        function A(t) {
            return t.missingValues ? t.missingValues : Fn.test(t.type) || t.stack ? Le : Me
        }

        function S(t, e) {
            var i, n = de.current.bindPoint(t, null, e),
                s = n.valueFields;
            for (i in s)
                if (J.convertableToNumber(s[i])) return !0
        }

        function C(t) {
            var e, i, n = t.start,
                s = t.dir,
                o = t.min,
                r = t.max,
                a = t.getter,
                h = t.hasItem,
                l = t.series,
                c = n;
            do c += s, h(c) && (i = a(c), e = S(l, i.item)); while (o <= c && c <= r && !e);
            if (e) return i
        }

        function k(t, e, i, n, s) {
            var o, r, a, h, l, c = e.min,
                u = e.max,
                p = c > 0 && c < i,
                d = u + 1 < i;
            (p || d) && (o = A(t), o !== Me ? (p && (r = n(c - 1)), d && (a = n(u + 1))) : (p && (h = n(c - 1), l = S(t, h.item), r = l ? h : C({
                start: c,
                dir: -1,
                min: 0,
                max: i - 1,
                getter: n,
                hasItem: s,
                series: t
            })), d && (h = n(u + 1), l = S(t, h.item), a = l ? h : C({
                start: u,
                dir: 1,
                min: 0,
                max: i - 1,
                getter: n,
                hasItem: s,
                series: t
            }))), r && (t._outOfRangeMinPoint = r), a && (t._outOfRangeMaxPoint = a))
        }

        function P(t) {
            var e, i, n, s = t.length;
            if (s > 0)
                for (i = 0; i < s; i++) n = t[i].contentBox(), e ? e.wrap(n) : e = n.clone();
            return e || new St
        }

        function T(t, e) {
            var i, n;
            for (i = 0; i < t.length; i++)
                if (n = t[i], n && n.pane === e) return n
        }

        function E(t) {
            return "" === t || null === t || "none" === t || "transparent" === t || !yt(t)
        }

        function R(t, e, i) {
            var n, s = e,
                o = t;
            if (t.indexOf(".") > -1) {
                for (n = t.split("."); n.length > 1;) o = n.shift(), yt(s[o]) || (s[o] = {}), s = s[o];
                o = n.shift()
            }
            s[o] = i
        }

        function I(t, e, i) {
            var n = [].concat(e instanceof qt ? t.categoryAxis : t.valueAxis);
            It(n[e.axisIndex], i)
        }

        function V(t, e, i) {
            return Ut(t, function(t) {
                return 0 === i && !t.categoryAxis || t.categoryAxis === e
            })
        }

        function L() {
            this._defaultPrevented = !0
        }

        function M(t, e) {
            var i = (e || "").toLowerCase(),
                n = t.event,
                s = "none" === i && !(n.ctrlKey || n.shiftKey || n.altKey) || n[i + "Key"];
            return s
        }

        function O(t) {
            var e, i, n = {};
            for (e = 0; e < t.length; e++) i = t[e], i.axis.options.name && (n[i.axis.options.name] = {
                min: i.range.min,
                max: i.range.max
            });
            return n
        }

        function B(t) {
            var e = document.createElement("div");
            return t && (e.className = t), e
        }

        function z(t) {
            for (var e = t; e && !jt(e, "k-handle");) e = e.parentNode;
            return e
        }

        function D(t, e, i, n) {
            var s = [].concat(i ? t.yAxis : t.xAxis)[e];
            It(s, n)
        }

        function H(t) {
            var e, i, n = J.rad(t),
                s = Xt(Math.sin(n), mt),
                o = Xt(Math.cos(n), mt);
            return e = Math.abs(s) > Ms ? rt : o < 0 ? gt : lt, i = Math.abs(s) < Ls ? rt : s < 0 ? ht : at, {
                horizontal: e,
                vertical: i
            }
        }

        function F(t, e, i, n) {
            var s, o, r = (n.x - i.x) * (t.y - i.y) - (n.y - i.y) * (t.x - i.x),
                a = (n.y - i.y) * (e.x - t.x) - (n.x - i.x) * (e.y - t.y);
            return 0 !== a && (o = r / a, s = new At(t.x + o * (e.x - t.x), t.y + o * (e.y - t.y))), s
        }

        function N(t, e) {
            return t.value.x - e.value.x
        }

        function G(t) {
            var e, i, n = xo;
            for (e = 0; e < n.length; e++) i = n[e] + "Axes", t[i] && (t[n[e] + "Axis"] = t[i], delete t[i])
        }

        function q(t, e) {
            if (t)
                for (var i = 0; i < t.length; i++)
                    if (t[i].category === e) return [t[i]]
        }

        function W(t, e) {
            function i(t) {
                var e = (t || {}).color || s.color,
                    i = It({}, a, a[n], s, s[n], {
                        line: {
                            color: e
                        },
                        labels: {
                            color: e
                        },
                        title: {
                            color: e
                        }
                    }, t);
                return delete i[n], i
            }
            var n, s, o, r, a = (e || {}).axisDefaults || {};
            for (r = 0; r < xo.length; r++) n = xo[r] + "Axis", s = t.axisDefaults || {}, o = [].concat(t[n]), o = o.map(i), t[n] = o.length > 1 ? o : o[0]
        }

        function X(t, e) {
            var i, n, s, o = t.series,
                r = o.length,
                a = t.seriesDefaults,
                h = It({}, t.seriesDefaults),
                l = e ? It({}, e.seriesDefaults) : {},
                c = It({}, l);
            for (Z(h), Z(c), i = 0; i < r; i++) n = o[i].type || t.seriesDefaults.type, s = It({
                data: []
            }, c, l[n], {
                tooltip: t.tooltip
            }, h, a[n]), o[i]._defaults = s, o[i] = It({}, s, o[i]), o[i].data = o[i].data || []
        }

        function Z(t) {
            delete t.bar, delete t.column, delete t.rangeColumn, delete t.line, delete t.verticalLine, delete t.pie, delete t.donut, delete t.area, delete t.verticalArea, delete t.scatter, delete t.scatterLine, delete t.bubble, delete t.candlestick, delete t.ohlc, delete t.boxPlot, delete t.bullet, delete t.verticalBullet, delete t.polarArea, delete t.polarLine, delete t.radarArea, delete t.radarLine, delete t.waterfall
        }

        function U(t) {
            var e, i, n, s = {};
            for (e = 0; e < t.length; e++) i = t[e], n = i.options.name, n && (s[n] = i.range());
            return s
        }

        function Y(t, e) {
            void 0 === e && (e = J.dateComparer);
            for (var i = 1, n = t.length; i < n; i++)
                if (e(t[i], t[i - 1]) < 0) {
                    t.sort(e);
                    break
                }
            return t
        }

        function j(t, e) {
            var i, n, s, o;
            for (void 0 === e && (e = J.dateComparer), i = Y(t, e), n = i.length, s = n > 0 ? [i[0]] : [], o = 1; o < n; o++) 0 !== e(i[o], Vt(s)) && s.push(i[o]);
            return s
        }

        function K(t) {
            var e, i, n, s, o = t.length,
                r = [];
            for (e = 0; e < o; e++)
                for (i = t[e], n = i.length, s = 0; s < n; s++) r[s] = r[s] || [], r[s].push(i[s]);
            return r
        }

        function Q(t, e) {
            var i, n, s, o;
            for (i in e) !Pt(i, So) && e.hasOwnProperty(i) && (n = e[i], s = t[i], yt(s) && (o = null === n, o || !yt(n) ? (delete t[i], o && delete e[i]) : s && Rt(n) && Rt(s) && Q(s, n)))
        }

        function $(t) {
            for (var e = 0; e < t.length; e++) t[e].notifyRender()
        }
        var J, tt, et, it, nt, st, ot, rt, at, ht, lt, ct, ut, pt, dt, gt, ft, vt, mt, xt, yt, _t, wt, bt, At, St, Ct, kt, Pt, Tt, Et, Rt, It, Vt, Lt, Mt, Ot, Bt, zt, Dt, Ht, Ft, Nt, Gt, qt, Wt, Xt, Zt, Ut, Yt, jt, Kt, Qt, $t, Jt, te, ee, ie, ne, se, oe, re, ae, he, le, ce, ue, pe, de, ge, fe, ve, me, xe, ye, _e, we, be, Ae, Se, Ce, ke, Pe, Te, Ee, Re, Ie, Ve, Le, Me, Oe, Be, ze, De, He, Fe, Ne, Ge, qe, We, Xe, Ze, Ue, Ye, je, Ke, Qe, $e, Je, ti, ei, ii, ni, si, oi, ri, ai, hi, li, ci, ui, pi, di, gi, fi, vi, mi, xi, yi, _i, wi, bi, Ai, Si, Ci, ki, Pi, Ti, Ei, Ri, Ii, Vi, Li, Mi, Oi, Bi, zi, Di, Hi, Fi, Ni, Gi, qi, Wi, Xi, Zi, Ui, Yi, ji, Ki, Qi, $i, Ji, tn, en, nn, sn, on, rn, an, hn, ln, cn, un, pn, dn, gn, fn, vn, mn, xn, yn, _n, wn, bn, An, Sn, Cn, kn, Pn, Tn, En, Rn, In, Vn, Ln, Mn, On, Bn, zn, Dn, Hn, Fn, Nn, Gn, qn, Wn, Xn, Zn, Un, Yn, jn, Kn, Qn, $n, Jn, ts, es, is, ns, ss, os, rs, as, hs, ls, cs, us, ps, ds, gs, fs, vs, ms, xs, ys, _s, ws, bs, As, Ss, Cs, ks, Ps, Ts, Es, Rs, Is, Vs, Ls, Ms, Os, Bs, zs, Ds, Hs, Fs, Ns, Gs, qs, Ws, Xs, Zs, Us, Ys, js, Ks, Qs, $s, Js, to, eo, io, no, so, oo, ro, ao, ho, lo, co, uo, po, go, fo, vo, mo, xo, yo, _o, wo, bo, Ao, So;
        window.kendo.dataviz = window.kendo.dataviz || {}, J = kendo.dataviz, tt = J.Class, et = J.isNumber, it = J.constants, nt = it.MAX_VALUE, st = it.MIN_VALUE, ot = it.VALUE, rt = it.CENTER, at = it.TOP, ht = it.BOTTOM, lt = it.LEFT, ct = it.WHITE, ut = it.CIRCLE, pt = it.X, dt = it.Y, gt = it.RIGHT, ft = it.BLACK, vt = it.DATE, mt = it.DEFAULT_PRECISION, xt = it.ARC, yt = J.defined, _t = J.getter, wt = J.isArray, bt = J.ChartElement, At = J.Point, St = J.Box, Ct = J.alignPathToPixel, kt = J.setDefaultOptions, Pt = J.inArray, Tt = J.isFunction, Et = J.valueOrDefault, Rt = J.isObject, It = J.deepExtend, Vt = J.last, Lt = J.eventElement, Mt = J.getTemplate, Ot = J.TextBox, Bt = J.ShapeElement, zt = J.getSpacing, Dt = J.CurveProcessor, Ht = J.append, Ft = J.isString, Nt = J.parseDate, Gt = J.styleValue, qt = J.CategoryAxis, Wt = J.BoxElement, Xt = J.round, Zt = J.limitValue, Ut = J.grep, Yt = J.elementStyles, jt = J.hasClasses, Kt = J.bindEvents, Qt = J.services, $t = J.unbindEvents, Jt = kendo.support, te = kendo.drawing, ee = te.Path, ie = te.Animation, ne = te.AnimationFactory, se = te.Group, oe = kendo.Color, re = kendo.geometry, ae = re.Point, he = re.transform, le = tt.extend({
            init: function(t) {
                this._axis = t, this.options = t.options
            },
            value: function(t) {
                var e = this._axis,
                    i = e.getCategory ? e.getCategory(t) : e.getValue(t);
                return i
            },
            slot: function(t, e, i) {
                return void 0 === i && (i = !0), this._axis.slot(t, e, i)
            },
            range: function() {
                return this._axis.range()
            },
            valueRange: function() {
                return this._axis.valueRange()
            }
        }), ce = kendo.Class.extend({
            init: function(t) {
                this.visual = t.visual, this.chartsVisual = t.chartContainer.visual, this._pane = t
            },
            findAxisByName: function(t) {
                return e(t, this._pane.axes)
            }
        }), ue = tt.extend({
            init: function(t) {
                this._plotArea = t, this.visual = t.visual, this.backgroundVisual = t._bgVisual
            }
        }), pe = {
            min: function(t) {
                var e, i, n = t.length,
                    s = nt;
                for (e = 0; e < n; e++) i = t[e], et(i) && (s = Math.min(s, i));
                return s === nt ? t[0] : s
            },
            max: function(t) {
                var e, i, n = t.length,
                    s = st;
                for (e = 0; e < n; e++) i = t[e], et(i) && (s = Math.max(s, i));
                return s === st ? t[0] : s
            },
            sum: function(t) {
                var e, i, n = t.length,
                    s = 0;
                for (e = 0; e < n; e++) i = t[e], et(i) && (s += i);
                return s
            },
            sumOrNull: function(t) {
                var e = null;
                return i(t) && (e = pe.sum(t)), e
            },
            count: function(t) {
                var e, i, n = t.length,
                    s = 0;
                for (e = 0; e < n; e++) i = t[e], null !== i && yt(i) && s++;
                return s
            },
            avg: function(t) {
                var e = i(t),
                    n = t[0];
                return e > 0 && (n = pe.sum(t) / e), n
            },
            first: function(t) {
                var e, i, n = t.length;
                for (e = 0; e < n; e++)
                    if (i = t[e], null !== i && yt(i)) return i;
                return t[0]
            }
        }, de = tt.extend({
            init: function() {
                this._valueFields = {}, this._otherFields = {}, this._nullValue = {}, this._undefinedValue = {}
            },
            register: function(t, e, i) {
                var n, s, o = this;
                for (void 0 === e && (e = [ot]), void 0 === i && (i = {}), n = 0; n < t.length; n++) s = t[n], o._valueFields[s] = e, o._otherFields[s] = i, o._nullValue[s] = o._makeValue(e, null), o._undefinedValue[s] = o._makeValue(e, void 0)
            },
            canonicalFields: function(t) {
                return this.valueFields(t).concat(this.otherFields(t))
            },
            valueFields: function(t) {
                return this._valueFields[t.type] || [ot]
            },
            otherFields: function(t) {
                return this._otherFields[t.type] || [ot]
            },
            bindPoint: function(t, e, i) {
                var n, s, o, r, a, h = t.data,
                    l = yt(i) ? i : h[e],
                    c = {
                        valueFields: {
                            value: l
                        }
                    },
                    u = this.valueFields(t),
                    p = this._otherFields[t.type];
                return null === l ? s = this._nullValue[t.type] : yt(l) ? Array.isArray(l) ? (o = l.slice(u.length), s = this._bindFromArray(l, u), n = this._bindFromArray(o, p)) : "object" == typeof l && (r = this.sourceFields(t, u), a = this.sourceFields(t, p), s = this._bindFromObject(l, u, r), n = this._bindFromObject(l, p, a)) : s = this._undefinedValue[t.type], yt(s) && (1 === u.length ? c.valueFields.value = s[u[0]] : c.valueFields = s), c.fields = n || {}, c
            },
            _makeValue: function(t, e) {
                var i, n, s = {},
                    o = t.length;
                for (i = 0; i < o; i++) n = t[i], s[n] = e;
                return s
            },
            _bindFromArray: function(t, e) {
                var i, n, s = {};
                if (e)
                    for (i = Math.min(e.length, t.length), n = 0; n < i; n++) s[e[n]] = t[n];
                return s
            },
            _bindFromObject: function(t, e, i) {
                var s, o, r, a, h;
                if (void 0 === i && (i = e), s = {}, e)
                    for (o = e.length, r = 0; r < o; r++) a = e[r], h = i[r], null !== h && (s[a] = n(h, t));
                return s
            },
            sourceFields: function(t, e) {
                var i, n, s, o, r = [];
                if (e)
                    for (i = e.length, n = 0; n < i; n++) s = e[n], o = s === ot ? "field" : s + "Field", r.push(null !== t[o] ? t[o] || s : null);
                return r
            }
        }), de.current = new de, ge = "stderr", fe = "stddev", ve = /percent(?:\w*)\((\d+)\)/, me = RegExp("^" + fe + "(?:\\((\\d+(?:\\.\\d+)?)\\))?$"), xe = tt.extend({
            init: function(t, e, i) {
                this.initGlobalRanges(t, e, i)
            },
            initGlobalRanges: function(t, e, i) {
                var n, s, o, r, a, h = e.data,
                    l = me.exec(t);
                l ? (this.valueGetter = this.createValueGetter(e, i), n = this.getAverage(h), s = this.getStandardDeviation(h, n, !1), o = l[1] ? parseFloat(l[1]) : 1, r = {
                    low: n.value - s * o,
                    high: n.value + s * o
                }, this.globalRange = function() {
                    return r
                }) : t.indexOf && t.indexOf(ge) >= 0 && (this.valueGetter = this.createValueGetter(e, i), a = this.getStandardError(h, this.getAverage(h)), this.globalRange = function(t) {
                    return {
                        low: t - a,
                        high: t + a
                    }
                })
            },
            createValueGetter: function(t, e) {
                var i, n, s, o = t.data,
                    r = de.current,
                    a = r.valueFields(t),
                    h = yt(o[0]) ? o[0] : {};
                return wt(h) ? (n = e ? a.indexOf(e) : 0, i = _t("[" + n + "]")) : et(h) ? i = _t() : typeof h === it.OBJECT && (s = r.sourceFields(t, a), i = _t(s[a.indexOf(e)])), i
            },
            getErrorRange: function(t, e) {
                var i, n, s, o;
                if (!yt(e)) return null;
                if (this.globalRange) return this.globalRange(t);
                if (wt(e)) i = t - e[0], n = t + e[1];
                else if (et(s = parseFloat(e))) i = t - s, n = t + s;
                else {
                    if (!(s = ve.exec(e))) throw Error("Invalid ErrorBar value: " + e);
                    o = t * (parseFloat(s[1]) / 100), i = t - Math.abs(o), n = t + Math.abs(o)
                }
                return {
                    low: i,
                    high: n
                }
            },
            getStandardError: function(t, e) {
                return this.getStandardDeviation(t, e, !0) / Math.sqrt(e.count)
            },
            getStandardDeviation: function(t, e, i) {
                var n, s, o = this,
                    r = t.length,
                    a = i ? e.count - 1 : e.count,
                    h = 0;
                for (n = 0; n < r; n++) s = o.valueGetter(t[n]), et(s) && (h += Math.pow(s - e.value, 2));
                return Math.sqrt(h / a)
            },
            getAverage: function(t) {
                var e, i, n = this,
                    s = t.length,
                    o = 0,
                    r = 0;
                for (e = 0; e < s; e++) i = n.valueGetter(t[e]), et(i) && (o += i, r++);
                return {
                    value: o / r,
                    count: r
                }
            }
        }), ye = Jt.browser || {}, _e = 600, we = "fadeIn", be = "glass", Ae = .8, Se = 5, Ce = ye.msie ? .001 : 0, ke = "errorLow", Pe = "errorHigh", Te = "xErrorLow", Ee = "xErrorHigh", Re = "yErrorLow", Ie = "yErrorHigh", Ve = 8, Le = "zero", Me = "interpolate", Oe = "gap", Be = "above", ze = "below", De = "smooth", He = "step", Fe = "area", Ne = "bar", Ge = "boxPlot", qe = "bubble", We = "bullet", Xe = "candlestick", Ze = "column", Ue = "donut", Ye = "funnel", je = "horizontalWaterfall", Ke = "line", Qe = "ohlc", $e = "pie", Je = "polarArea", ti = "polarLine", ei = "polarScatter", ii = "radarArea", ni = "radarColumn", si = "radarLine", oi = "rangeArea", ri = "rangeBar", ai = "rangeColumn", hi = "scatter", li = "scatterLine", ci = "verticalArea", ui = "verticalBoxPlot", pi = "verticalBullet", di = "verticalLine", gi = "verticalRangeArea", fi = "waterfall", vi = [Ne, Ze, Qe, Xe, Ge, ui, We, ai, ri, fi, je], mi = "legendItemClick", xi = "legendItemHover", yi = "legendItemLeave", _i = "seriesClick", wi = "seriesHover", bi = "seriesOver", Ai = "seriesLeave", Si = "plotAreaClick", Ci = "plotAreaHover", ki = "plotAreaLeave", Pi = "drag", Ti = "dragEnd", Ei = "dragStart", Ri = "zoomStart", Ii = "zoom", Vi = "zoomEnd", Li = "selectStart", Mi = "select", Oi = "selectEnd", Bi = "render", zi = "showTooltip", Di = "hideTooltip", Hi = "paneRender", Fi = "log", Ni = "category", Gi = "insideEnd", qi = "insideBase", Wi = "outsideEnd", Xi = "DOMMouseScroll mousewheel", Zi = 150, Ui = {
            INITIAL_ANIMATION_DURATION: _e,
            FADEIN: we,
            LEGEND_ITEM_CLICK: mi,
            LEGEND_ITEM_HOVER: xi,
            LEGEND_ITEM_LEAVE: yi,
            SERIES_CLICK: _i,
            SERIES_HOVER: wi,
            SERIES_OVER: bi,
            SERIES_LEAVE: Ai,
            GLASS: be,
            BORDER_BRIGHTNESS: Ae,
            TOOLTIP_OFFSET: Se,
            START_SCALE: Ce,
            ERROR_LOW_FIELD: ke,
            ERROR_HIGH_FIELD: Pe,
            X_ERROR_LOW_FIELD: Te,
            X_ERROR_HIGH_FIELD: Ee,
            Y_ERROR_LOW_FIELD: Re,
            Y_ERROR_HIGH_FIELD: Ie,
            LINE_MARKER_SIZE: Ve,
            INTERPOLATE: Me,
            ZERO: Le,
            SMOOTH: De,
            STEP: He,
            CATEGORY: Ni,
            FUNNEL: Ye,
            BAR: Ne,
            CANDLESTICK: Xe,
            PIE: $e,
            COLUMN: Ze,
            AREA: Fe,
            VERTICAL_BULLET: pi,
            BOX_PLOT: Ge,
            OHLC: Qe,
            WATERFALL: fi,
            LINE: Ke,
            BULLET: We,
            VERTICAL_LINE: di,
            VERTICAL_AREA: ci,
            RANGE_AREA: oi,
            VERTICAL_RANGE_AREA: gi,
            RANGE_COLUMN: ai,
            VERTICAL_BOX_PLOT: ui,
            RANGE_BAR: ri,
            HORIZONTAL_WATERFALL: je,
            SCATTER: hi,
            SCATTER_LINE: li,
            BUBBLE: qe,
            RADAR_AREA: ii,
            RADAR_LINE: si,
            RADAR_COLUMN: ni,
            POLAR_LINE: ti,
            POLAR_AREA: Je,
            POLAR_SCATTER: ei,
            RENDER: Bi,
            PLOT_AREA_CLICK: Si,
            PLOT_AREA_HOVER: Ci,
            PLOT_AREA_LEAVE: ki,
            LOGARITHMIC: Fi,
            DRAG: Pi,
            DRAG_START: Ei,
            DRAG_END: Ti,
            ZOOM_START: Ri,
            ZOOM: Ii,
            ZOOM_END: Vi,
            SELECT_START: Li,
            SELECT: Mi,
            SELECT_END: Oi,
            PANE_RENDER: Hi,
            GAP: Oe,
            DONUT: Ue,
            INSIDE_END: Gi,
            INSIDE_BASE: qi,
            OUTSIDE_END: Wi,
            MOUSEWHEEL: Xi,
            MOUSEWHEEL_DELAY: Zi,
            SHOW_TOOLTIP: zi,
            HIDE_TOOLTIP: Di,
            EQUALLY_SPACED_SERIES: vi,
            ABOVE: Be,
            BELOW: ze
        }, Yi = 4, ji = bt.extend({
            init: function(t, e, i, n, s, o) {
                bt.fn.init.call(this, o), this.low = t, this.high = e, this.isVertical = i, this.chart = n, this.series = s
            },
            reflow: function(t) {
                var e, i = this.options.endCaps,
                    n = this.isVertical,
                    s = this.getAxis(),
                    o = s.getSlot(this.low, this.high),
                    r = t.center(),
                    a = this.getCapsWidth(t, n),
                    h = n ? r.x : r.y,
                    l = h - a,
                    c = h + a;
                n ? (e = [new At(r.x, o.y1), new At(r.x, o.y2)], i && e.push(new At(l, o.y1), new At(c, o.y1), new At(l, o.y2), new At(c, o.y2)), this.box = new St(l, o.y1, c, o.y2)) : (e = [new At(o.x1, r.y), new At(o.x2, r.y)], i && e.push(new At(o.x1, l), new At(o.x1, c), new At(o.x2, l), new At(o.x2, c)), this.box = new St(o.x1, l, o.x2, c)), this.linePoints = e
            },
            getCapsWidth: function(t, e) {
                var i = e ? t.width() : t.height(),
                    n = Math.min(Math.floor(i / 2), Yi) || Yi;
                return n
            },
            createVisual: function() {
                var t = this,
                    e = this.options,
                    i = e.visual;
                i ? this.visual = i({
                    low: this.low,
                    high: this.high,
                    rect: this.box.toRect(),
                    sender: this.getSender(),
                    options: {
                        endCaps: e.endCaps,
                        color: e.color,
                        line: e.line
                    },
                    createVisual: function() {
                        t.createDefaultVisual();
                        var e = t.visual;
                        return delete t.visual, e
                    }
                }) : this.createDefaultVisual()
            },
            createDefaultVisual: function() {
                var t, e, i = this,
                    n = this,
                    s = n.options,
                    o = n.linePoints,
                    r = {
                        stroke: {
                            color: s.color,
                            width: s.line.width,
                            dashType: s.line.dashType
                        }
                    };
                for (bt.fn.createVisual.call(this), t = 0; t < o.length; t += 2) e = new ee(r).moveTo(o[t].x, o[t].y).lineTo(o[t + 1].x, o[t + 1].y), Ct(e), i.visual.append(e)
            }
        }), kt(ji, {
            animation: {
                type: we,
                delay: _e
            },
            endCaps: !0,
            line: {
                width: 2
            },
            zIndex: 1
        }), Ki = ji.extend({
            getAxis: function() {
                var t = this.chart.seriesValueAxis(this.series);
                return t
            }
        }), Qi = 5, $i = bt.extend({
            init: function(t, e) {
                bt.fn.init.call(this, e), this.plotArea = t, this.chartService = t.chartService, this.categoryAxis = t.seriesCategoryAxis(e.series[0]), this.valueAxisRanges = {}, this.points = [], this.categoryPoints = [], this.seriesPoints = [], this.seriesOptions = [], this._evalSeries = [], this.render()
            },
            render: function() {
                this.traverseDataPoints(this.addValue.bind(this))
            },
            pointOptions: function(t, e) {
                var i, n = this.seriesOptions[e];
                return n || (i = this.pointType().prototype.defaults, this.seriesOptions[e] = n = It({}, i, {
                    vertical: !this.options.invertAxes
                }, t)), n
            },
            plotValue: function(t) {
                var e, i, n, s, o, r, a, h;
                if (!t) return 0;
                if (this.options.isStacked100 && et(t.value)) {
                    for (e = t.categoryIx, i = this.categoryPoints[e], n = [], s = 0, o = 0; o < i.length; o++)
                        if (r = i[o]) {
                            if (a = t.series.stack, h = r.series.stack, a && h && a.group !== h.group) continue;
                            et(r.value) && (s += Math.abs(r.value), n.push(Math.abs(r.value)))
                        }
                    if (s > 0) return t.value / s
                }
                return t.value
            },
            plotRange: function(t, e) {
                var i, n, s, o, r, a, h, l, c, u, p, d, g, f = this;
                if (void 0 === e && (e = 0), i = this.categoryPoints[t.categoryIx], this.options.isStacked) {
                    for (n = this.plotValue(t), s = n >= 0, o = e, r = !1, a = 0; a < i.length && (h = i[a], t !== h); a++) {
                        if (l = t.series.stack, c = h.series.stack, l && c) {
                            if (typeof l === it.STRING && l !== c) continue;
                            if (l.group && l.group !== c.group) continue
                        }
                        u = f.plotValue(h), (u >= 0 && s || u < 0 && !s) && (o += u, n += u, r = !0, f.options.isStacked100 && (n = Math.min(n, 1)))
                    }
                    return r && (o -= e), [o, n]
                }
                return p = t.series, d = this.seriesValueAxis(p), g = this.categoryAxisCrossingValue(d), [g, J.convertableToNumber(t.value) ? t.value : g]
            },
            stackLimits: function(t, e) {
                var i, n, s, o, r, a = this,
                    h = nt,
                    l = st;
                for (i = 0; i < this.categoryPoints.length; i++)
                    if (n = a.categoryPoints[i])
                        for (s = 0; s < n.length; s++) o = n[s], o && (o.series.stack !== e && o.series.axis !== t || (r = a.plotRange(o, 0)[1], yt(r) && isFinite(r) && (l = Math.max(l, r), h = Math.min(h, r))));
                return {
                    min: h,
                    max: l
                }
            },
            updateStackRange: function() {
                var t, e, i, n, s, o, r = this,
                    a = this.options,
                    h = a.isStacked,
                    l = a.series,
                    c = {};
                if (h)
                    for (t = 0; t < l.length; t++) e = l[t], i = e.axis, n = i + e.stack, s = c[n], s || (s = r.stackLimits(i, e.stack), o = r.errorTotals, o && (o.negative.length && (s.min = Math.min(s.min, J.sparseArrayLimits(o.negative).min)), o.positive.length && (s.max = Math.max(s.max, J.sparseArrayLimits(o.positive).max))), s.min !== nt || s.max !== st ? c[n] = s : s = null), s && (r.valueAxisRanges[i] = s)
            },
            addErrorBar: function(t, e, i) {
                var n, s = t.value,
                    o = t.series,
                    r = t.seriesIx,
                    a = t.options.errorBars,
                    h = e.fields[ke],
                    l = e.fields[Pe];
                et(h) && et(l) ? n = {
                    low: h,
                    high: l
                } : a && yt(a.value) && (this.seriesErrorRanges = this.seriesErrorRanges || [], this.seriesErrorRanges[r] = this.seriesErrorRanges[r] || new xe(a.value, o, ot), n = this.seriesErrorRanges[r].getErrorRange(s, a.value)), n && (t.low = n.low, t.high = n.high, this.addPointErrorBar(t, i))
            },
            addPointErrorBar: function(t, e) {
                var i, n, s, o = !this.options.invertAxes,
                    r = t.options.errorBars,
                    a = t.series,
                    h = t.low,
                    l = t.high;
                this.options.isStacked ? (i = this.stackedErrorRange(t, e), h = i.low, l = i.high) : (n = {
                    categoryIx: e,
                    series: a
                }, this.updateRange({
                    value: h
                }, n), this.updateRange({
                    value: l
                }, n)), s = new Ki(h, l, o, this, a, r), t.errorBars = [s], t.append(s)
            },
            stackedErrorRange: function(t, e) {
                var i = this.plotRange(t, 0)[1] - t.value,
                    n = t.low + i,
                    s = t.high + i;
                return this.errorTotals = this.errorTotals || {
                    positive: [],
                    negative: []
                }, n < 0 && (this.errorTotals.negative[e] = Math.min(this.errorTotals.negative[e] || 0, n)), s > 0 && (this.errorTotals.positive[e] = Math.max(this.errorTotals.positive[e] || 0, s)), {
                    low: n,
                    high: s
                }
            },
            addValue: function(e, i) {
                var n, s, o = i.categoryIx,
                    r = i.series,
                    a = i.seriesIx,
                    h = this.categoryPoints[o];
                h || (this.categoryPoints[o] = h = []), n = this.seriesPoints[a], n || (this.seriesPoints[a] = n = []), s = this.createPoint(e, i), s && (t.extend(s, i), s.owner = this, s.noteText = e.fields.noteText, yt(s.dataItem) || (s.dataItem = r.data[o]), this.addErrorBar(s, e, o)), this.points.push(s), n.push(s), h.push(s), this.updateRange(e.valueFields, i)
            },
            evalPointOptions: function(t, e, i, n, o, r) {
                var a, h = {
                        defaults: o._defaults,
                        excluded: ["data", "aggregate", "_events", "tooltip", "content", "template", "visual", "toggle", "_outOfRangeMinPoint", "_outOfRangeMaxPoint"]
                    },
                    l = this._evalSeries[r];
                return yt(l) || (this._evalSeries[r] = l = s(t, {}, h, !0)), a = t, l && (a = It({}, a), s(a, {
                    value: e,
                    category: i,
                    index: n,
                    series: o,
                    dataItem: o.data[n]
                }, h)), a
            },
            updateRange: function(t, e) {
                var i = e.series.axis,
                    n = t.value,
                    s = this.valueAxisRanges[i];
                isFinite(n) && null !== n && (s = this.valueAxisRanges[i] = s || {
                    min: nt,
                    max: st
                }, s.min = Math.min(s.min, n), s.max = Math.max(s.max, n))
            },
            seriesValueAxis: function(t) {
                var e = this.plotArea,
                    i = t.axis,
                    n = i ? e.namedValueAxes[i] : e.valueAxis;
                if (!n) throw Error("Unable to locate value axis with name " + i);
                return n
            },
            reflow: function(t) {
                var e = this,
                    i = this.categorySlots = [],
                    n = this.points,
                    s = this.categoryAxis,
                    o = 0;
                this.traverseDataPoints(function(t, r) {
                    var a, h, l, c = r.categoryIx,
                        u = r.series,
                        p = e.seriesValueAxis(u),
                        d = n[o++],
                        g = i[c];
                    g || (i[c] = g = e.categorySlot(s, c, p)), d && (a = e.plotRange(d, p.startValue()), h = e.valueSlot(p, a), h ? (l = e.pointSlot(g, h), d.aboveAxis = e.aboveAxis(d, p), d.stackValue = a[1], e.options.isStacked100 && (d.percentage = e.plotValue(d)), e.reflowPoint(d, l)) : d.visible = !1)
                }), this.reflowCategories(i), !this.options.clip && this.options.limitPoints && this.points.length && this.limitPoints(), this.box = t
            },
            valueSlot: function(t, e) {
                return t.getSlot(e[0], e[1], !this.options.clip)
            },
            limitPoints: function() {
                var t, e = this,
                    i = this.categoryPoints,
                    n = i[0].concat(Vt(i));
                for (t = 0; t < n.length; t++) n[t] && e.limitPoint(n[t])
            },
            limitPoint: function(t) {
                var e = this.categoryAxis.limitSlot(t.box);
                e.equals(t.box) || t.reflow(e)
            },
            aboveAxis: function(t, e) {
                var i = this.categoryAxisCrossingValue(e),
                    n = t.value;
                return e.options.reverse ? n < i : n >= i
            },
            categoryAxisCrossingValue: function(t) {
                var e = this.categoryAxis,
                    i = t.options,
                    n = [].concat(i.axisCrossingValues || i.axisCrossingValue);
                return n[e.axisIndex || 0] || 0
            },
            reflowPoint: function(t, e) {
                t.reflow(e)
            },
            reflowCategories: function() {},
            pointSlot: function(t, e) {
                var i = this.options,
                    n = i.invertAxes,
                    s = n ? e : t,
                    o = n ? t : e;
                return new St(s.x1, o.y1, s.x2, o.y2)
            },
            categorySlot: function(t, e) {
                return t.getSlot(e)
            },
            traverseDataPoints: function(t) {
                var e, i, n, s, r, a, h, l = this,
                    c = this.options.series,
                    u = o(c),
                    p = c.length;
                for (e = 0; e < p; e++) l._outOfRangeCallback(c[e], "_outOfRangeMinPoint", e, t);
                for (i = 0; i < u; i++)
                    for (n = 0; n < p; n++) s = c[n], r = l.categoryAxis.categoryAt(i), a = l._bindPoint(s, n, i), t(a, {
                        category: r,
                        categoryIx: i,
                        series: s,
                        seriesIx: n
                    });
                for (h = 0; h < p; h++) l._outOfRangeCallback(c[h], "_outOfRangeMaxPoint", h, t)
            },
            _outOfRangeCallback: function(t, e, i, n) {
                var s, o, r = t[e];
                r && (s = r.categoryIx, o = this._bindPoint(t, i, s, r.item), n(o, {
                    category: r.category,
                    categoryIx: s,
                    series: t,
                    seriesIx: i,
                    dataItem: r.item
                }))
            },
            _bindPoint: function(t, e, i, n) {
                var s, o;
                return this._bindCache || (this._bindCache = []), s = this._bindCache[e], s || (s = this._bindCache[e] = []), o = s[i], o || (o = s[i] = de.current.bindPoint(t, i, n)), o
            },
            formatPointValue: function(t, e) {
                return null === t.value ? "" : this.chartService.format.auto(e, t.value)
            },
            pointValue: function(t) {
                return t.valueFields.value
            }
        }), kt($i, {
            series: [],
            invertAxes: !1,
            isStacked: !1,
            clip: !0,
            limitPoints: !0
        }), Ji = {
            click: function(t, e) {
                return t.trigger(_i, this.eventArgs(e))
            },
            hover: function(t, e) {
                return t.trigger(wi, this.eventArgs(e))
            },
            over: function(t, e) {
                return t.trigger(bi, this.eventArgs(e))
            },
            out: function(t, e) {
                return t.trigger(Ai, this.eventArgs(e))
            },
            eventArgs: function(t) {
                return {
                    value: this.value,
                    percentage: this.percentage,
                    stackValue: this.stackValue,
                    category: this.category,
                    series: this.series,
                    dataItem: this.dataItem,
                    runningTotal: this.runningTotal,
                    total: this.total,
                    element: Lt(t),
                    originalEvent: t,
                    point: this
                }
            }
        }, tn = {
            createNote: function() {
                var t = this.options.notes,
                    e = this.noteText || t.label.text;
                t.visible !== !1 && yt(e) && null !== e && (this.note = new J.Note({
                    value: this.value,
                    text: e,
                    dataItem: this.dataItem,
                    category: this.category,
                    series: this.series
                }, this.options.notes, this.owner.chartService), this.append(this.note))
            }
        }, en = bt.extend({
            init: function(t, e) {
                bt.fn.init.call(this), this.value = t, this.options = e, this.aboveAxis = Et(this.options.aboveAxis, !0), this.tooltipTracking = !0
            },
            render: function() {
                var t, e, i, n = this.options,
                    s = n.markers,
                    o = n.labels;
                this._rendered || (this._rendered = !0, s.visible && s.size && (this.marker = this.createMarker(), this.append(this.marker)), o.visible && (t = Mt(o), e = this.pointData(), i = this.value, t ? i = t(e) : o.format && (i = this.formatValue(o.format)), this.label = new Ot(i, It({
                    align: rt,
                    vAlign: rt,
                    margin: {
                        left: 5,
                        right: 5
                    },
                    zIndex: Et(o.zIndex, this.series.zIndex)
                }, o), e), this.append(this.label)), this.createNote(), this.errorBar && this.append(this.errorBar))
            },
            markerBorder: function() {
                var t = this.options.markers,
                    e = t.background,
                    i = It({
                        color: this.color
                    }, t.border);
                return yt(i.color) || (i.color = new oe(e).brightness(Ae).toHex()), i
            },
            createVisual: function() {},
            createMarker: function() {
                var t = this.options.markers,
                    e = new Bt({
                        type: t.type,
                        width: t.size,
                        height: t.size,
                        rotation: t.rotation,
                        background: t.background,
                        border: this.markerBorder(),
                        opacity: t.opacity,
                        zIndex: Et(t.zIndex, this.series.zIndex),
                        animation: t.animation,
                        visual: t.visual
                    }, {
                        dataItem: this.dataItem,
                        value: this.value,
                        series: this.series,
                        category: this.category
                    });
                return e
            },
            markerBox: function() {
                return this.marker || (this.marker = this.createMarker(), this.marker.reflow(this._childBox)), this.marker.box
            },
            reflow: function(t) {
                var e, i, n, s, o = this,
                    r = this,
                    a = r.options,
                    h = r.aboveAxis,
                    l = a.vertical;
                if (this.render(), this.box = t, e = t.clone(), l ? h ? e.y1 -= e.height() : e.y2 += e.height() : h ? e.x1 += e.width() : e.x2 -= e.width(), this._childBox = e, this.marker && this.marker.reflow(e), this.reflowLabel(e), this.errorBars)
                    for (i = 0; i < this.errorBars.length; i++) o.errorBars[i].reflow(e);
                this.note && (n = this.markerBox(), a.markers.visible && a.markers.size || (s = n.center(), n = new St(s.x, s.y, s.x, s.y)), this.note.reflow(n))
            },
            reflowLabel: function(t) {
                var e = this,
                    i = e.options,
                    n = e.label,
                    s = i.labels.position;
                n && (s = s === Be ? at : s, s = s === ze ? ht : s, n.reflow(t), n.box.alignTo(this.markerBox(), s), n.reflow(n.box))
            },
            createHighlight: function() {
                var t = this.options.highlight.markers,
                    e = this.markerBorder().color,
                    i = this.options.markers,
                    n = i.size + (i.border.width || 0) + (t.border.width || 0),
                    s = new Bt({
                        type: i.type,
                        width: n,
                        height: n,
                        rotation: i.rotation,
                        background: t.color || e,
                        border: {
                            color: t.border.color,
                            width: t.border.width,
                            opacity: Et(t.border.opacity, 1)
                        },
                        opacity: Et(t.opacity, 1)
                    });
                return s.reflow(this._childBox), s.getElement()
            },
            highlightVisual: function() {
                return (this.marker || {}).visual
            },
            highlightVisualArgs: function() {
                var t, e, i, n, s, o = this.marker;
                return o ? (e = o.paddingBox.toRect(), t = o.visual) : (i = this.options.markers.size, n = i / 2, s = this.box.center(), e = new re.Rect([s.x - n, s.y - n], [i, i])), {
                    options: this.options,
                    rect: e,
                    visual: t
                }
            },
            tooltipAnchor: function() {
                var t, e, i, n, s = this.markerBox(),
                    o = this.owner.pane.clipBox(),
                    r = !o || o.overlaps(s);
                if (r) return t = s.x2 + Se, e = lt, this.aboveAxis ? (i = s.y1, n = ht) : (i = s.y2, n = at), {
                    point: new At(t, i),
                    align: {
                        horizontal: e,
                        vertical: n
                    }
                }
            },
            formatValue: function(t) {
                return this.owner.formatPointValue(this, t)
            },
            overlapsBox: function(t) {
                var e = this.markerBox();
                return e.overlaps(t)
            },
            unclipElements: function() {
                this.label && (this.label.options.noclip = !0), this.note && (this.note.options.noclip = !0)
            },
            pointData: function() {
                return {
                    dataItem: this.dataItem,
                    category: this.category,
                    value: this.value,
                    percentage: this.percentage,
                    stackValue: this.stackValue,
                    series: this.series
                }
            }
        }), en.prototype.defaults = {
            vertical: !0,
            markers: {
                visible: !0,
                background: ct,
                size: Ve,
                type: ut,
                border: {
                    width: 2
                },
                opacity: 1
            },
            labels: {
                visible: !1,
                position: Be,
                margin: zt(3),
                padding: zt(4),
                animation: {
                    type: we,
                    delay: _e
                }
            },
            notes: {
                label: {}
            },
            highlight: {
                markers: {
                    border: {
                        color: "#fff",
                        width: 2
                    }
                },
                zIndex: it.HIGHLIGHT_ZINDEX
            },
            errorBars: {
                line: {
                    width: 1
                }
            }
        }, It(en.prototype, Ji), It(en.prototype, tn), nn = bt.extend({
            init: function(t, e, i) {
                bt.fn.init.call(this), this.linePoints = t, this.series = e, this.seriesIx = i
            },
            points: function() {
                return this.toGeometryPoints(this.linePoints)
            },
            toGeometryPoints: function(t) {
                var e, i, n = [];
                for (e = 0, i = t.length; e < i; e++) t[e] && t[e].visible !== !1 && n.push(t[e]._childBox.toRect().center());
                return n
            },
            createVisual: function() {
                var t = this,
                    e = this.series.visual;
                e ? (this.visual = e({
                    points: this.toGeometryPoints(this.linePoints),
                    series: this.series,
                    sender: this.getSender(),
                    createVisual: function() {
                        return t.segmentVisual(), t.visual
                    }
                }), this.visual && !yt(this.visual.options.zIndex) && (this.visual.options.zIndex = this.series.zIndex)) : this.segmentVisual()
            },
            segmentVisual: function() {
                var t, e = this,
                    i = e.options,
                    n = e.series,
                    s = n.color,
                    o = n._defaults;
                Tt(s) && o && (s = o.color), t = ee.fromPoints(this.points(), {
                    stroke: {
                        color: s,
                        width: n.width,
                        opacity: n.opacity,
                        dashType: n.dashType
                    },
                    zIndex: n.zIndex
                }), i.closed && t.close(), this.visual = t
            },
            aliasFor: function(t, e) {
                return this.parent.getNearestPoint(e.x, e.y, this.seriesIx)
            }
        }), kt(nn, {
            closed: !1
        }), sn = {
            calculateStepPoints: function(t) {
                var e, i, n, s = this.parent.plotArea.seriesCategoryAxis(this.series),
                    o = s.options,
                    a = o.justified,
                    h = o.vertical,
                    l = o.reverse,
                    c = h ? pt : dt,
                    u = h ? dt : pt,
                    p = l ? 2 : 1,
                    d = p,
                    g = r(t[0], c, p, u, d),
                    f = [g];
                for (e = 1; e < t.length; e++) i = r(t[e], c, p, u, d), g[c] !== i[c] && (n = new ae, n[c] = g[c], n[u] = i[u], f.push(n, i)), g = i;
                return a ? g !== Vt(f) && f.push(g) : f.push(r(Vt(t), c, p, u, l ? 1 : 2)), f
            }
        }, on = nn.extend({
            points: function() {
                return this.calculateStepPoints(this.linePoints)
            }
        }), It(on.prototype, sn), rn = nn.extend({
            segmentVisual: function() {
                var t, e, i, n = this.series,
                    s = n._defaults,
                    o = n.color;
                Tt(o) && s && (o = s.color), t = new Dt(this.options.closed), e = t.process(this.points()), i = new ee({
                    stroke: {
                        color: o,
                        width: n.width,
                        opacity: n.opacity,
                        dashType: n.dashType
                    },
                    zIndex: n.zIndex
                }), i.segments.push.apply(i.segments, e), this.visual = i
            }
        }), an = {
            renderSegments: function() {
                var t, e, i, n, s, o, r, a, h = this,
                    l = this,
                    c = l.options,
                    u = l.seriesPoints,
                    p = c.series,
                    d = u.length;
                for (this._segments = [], e = 0; e < d; e++) {
                    for (i = p[e], n = h.sortPoints(u[e]), s = n.length, o = [], r = 0; r < s; r++) a = n[r], a ? o.push(a) : h.seriesMissingValues(i) !== Me && (o.length > 1 && (t = h.createSegment(o, i, e, t), h._addSegment(t)), o = []);
                    o.length > 1 && (t = h.createSegment(o, i, e, t), h._addSegment(t))
                }
                this.children.unshift.apply(this.children, this._segments)
            },
            _addSegment: function(t) {
                this._segments.push(t), t.parent = this
            },
            sortPoints: function(t) {
                return t
            },
            seriesMissingValues: function(t) {
                var e = t.missingValues,
                    i = !e && this.options.isStacked;
                return i ? Le : e || Me
            },
            getNearestPoint: function(t, e, i) {
                var n, s, o, r, a, h = new At(t, e),
                    l = this.seriesPoints[i],
                    c = nt;
                for (s = 0; s < l.length; s++) o = l[s], o && yt(o.value) && null !== o.value && o.visible !== !1 && (r = o.box, a = r.center().distanceTo(h), a < c && (n = o, c = a));
                return n
            }
        }, hn = ie.extend({
            setup: function() {
                this._setEnd(this.options.box.x1)
            },
            step: function(t) {
                var e = this.options.box;
                this._setEnd(J.interpolateValue(e.x1, e.x2, t))
            },
            _setEnd: function(t) {
                var e = this.element,
                    i = e.segments,
                    n = i[1].anchor(),
                    s = i[2].anchor();
                e.suspend(), n.setX(t), e.resume(), s.setX(t)
            }
        }), kt(hn, {
            duration: _e
        }), ne.current.register("clip", hn), ln = {
            createAnimation: function() {
                var t, e, i = this.getRoot();
                i && (i.options || {}).transitions !== !1 && (t = i.size(), e = ee.fromRect(t.toRect()), this.visual.clip(e), this.animation = new hn(e, {
                    box: t
                }), a(this.options.series) && this._setChildrenAnimation(e))
            },
            _setChildrenAnimation: function(t) {
                var e, i, n = this.animationPoints();
                for (e = 0; e < n.length; e++) i = n[e], i && i.visual && yt(i.visual.options.zIndex) && i.visual.clip(t)
            }
        }, cn = $i.extend({
            render: function() {
                $i.fn.render.call(this), this.updateStackRange(), this.renderSegments()
            },
            pointType: function() {
                return en
            },
            createPoint: function(t, e) {
                var i, n, s, o = e.categoryIx,
                    r = e.category,
                    a = e.series,
                    h = e.seriesIx,
                    l = this.seriesMissingValues(a),
                    c = t.valueFields.value;
                if (!yt(c) || null === c) {
                    if (l !== Le) return null;
                    c = 0
                }
                return i = this.pointOptions(a, h), i = this.evalPointOptions(i, c, r, o, a, h), n = t.fields.color || a.color, Tt(a.color) && (n = i.color), s = new en(c, i), s.color = n, this.append(s), s
            },
            plotRange: function(t) {
                var e, i, n, s, o = this,
                    r = this.plotValue(t);
                if (this.options.isStacked)
                    for (e = t.categoryIx, i = this.categoryPoints[e], n = 0; n < i.length && (s = i[n], t !== s); n++) r += o.plotValue(s), o.options.isStacked100 && (r = Math.min(r, 1));
                return [r, r]
            },
            createSegment: function(t, e, i) {
                var n, s = e.style;
                return new(n = s === He ? on : s === De ? rn : nn)(t, e, i)
            },
            animationPoints: function() {
                var t, e = this.points,
                    i = [];
                for (t = 0; t < e.length; t++) i.push((e[t] || {}).marker);
                return i.concat(this._segments)
            }
        }), It(cn.prototype, an, ln), un = nn.extend({
            init: function(t, e, i, n, s) {
                nn.fn.init.call(this, t, e, i), this.prevSegment = n, this.stackPoints = s
            },
            createVisual: function() {
                var t = this.series,
                    e = t._defaults,
                    i = t.line || {},
                    n = t.color;
                Tt(n) && e && (n = e.color), this.visual = new se({
                    zIndex: t.zIndex
                }), this.createFill({
                    fill: {
                        color: n,
                        opacity: t.opacity
                    },
                    stroke: null
                }), i.width > 0 && i.visible !== !1 && this.createStroke({
                    stroke: It({
                        color: n,
                        opacity: t.opacity,
                        lineCap: "butt"
                    }, i)
                })
            },
            strokeSegments: function() {
                var t = this._strokeSegments;
                return t || (t = this._strokeSegments = this.createStrokeSegments()), t
            },
            createStrokeSegments: function() {
                return this.segmentsFromPoints(this.points())
            },
            stackSegments: function() {
                return this.prevSegment ? this.prevSegment.createStackSegments(this.stackPoints) : this.createStackSegments(this.stackPoints)
            },
            createStackSegments: function(t) {
                return this.segmentsFromPoints(this.toGeometryPoints(t)).reverse()
            },
            segmentsFromPoints: function(t) {
                return t.map(function(t) {
                    return new re.Segment(t)
                })
            },
            createStroke: function(t) {
                var e = new ee(t);
                e.segments.push.apply(e.segments, this.strokeSegments()), this.visual.append(e)
            },
            hasStackSegment: function() {
                return this.prevSegment || this.stackPoints && this.stackPoints.length
            },
            createFill: function(t) {
                var e, i, n = this.strokeSegments(),
                    s = n.slice(0),
                    o = this.hasStackSegment();
                o && (e = this.stackSegments(), Ht(s, e)), i = new ee(t), i.segments.push.apply(i.segments, s), !o && n.length > 1 && this.fillToAxes(i), this.visual.append(i)
            },
            fillToAxes: function(t) {
                var e = this.parent,
                    i = e.options.invertAxes,
                    n = e.seriesValueAxis(this.series),
                    s = e.categoryAxisCrossingValue(n),
                    o = n.getSlot(s, s, !0),
                    r = this.strokeSegments(),
                    a = r[0].anchor(),
                    h = Vt(r).anchor(),
                    l = i ? o.x1 : o.y1;
                i ? t.lineTo(l, h.y).lineTo(l, a.y) : t.lineTo(h.x, l).lineTo(a.x, l)
            }
        }), pn = un.extend({
            createStrokeSegments: function() {
                return this.segmentsFromPoints(this.calculateStepPoints(this.linePoints))
            },
            createStackSegments: function(t) {
                return this.segmentsFromPoints(this.calculateStepPoints(t)).reverse()
            }
        }), It(pn.prototype, sn), dn = un.extend({
            createStrokeSegments: function() {
                var t = new Dt(this.options.closed),
                    e = this.points();
                return t.process(e)
            },
            createStackSegments: function() {
                var t, e, i = this.strokeSegments(),
                    n = [];
                for (t = i.length - 1; t >= 0; t--) e = i[t], n.push(new re.Segment(e.anchor(), e.controlOut(), e.controlIn()));
                return n
            }
        }), gn = cn.extend({
            createSegment: function(t, e, i, n) {
                var s, o, r, a, h = this.options.isStacked,
                    l = (e.line || {}).style;
                return h && i > 0 && n && (r = this.seriesMissingValues(e), "gap" !== r ? (o = n.linePoints, s = n) : o = this._gapStackPoints(t, i, l)), new(a = l === He ? pn : l === De ? dn : un)(t, e, i, s, o)
            },
            reflow: function(t) {
                var e, i, n, s, o = this;
                if (cn.fn.reflow.call(this, t), e = this._stackPoints)
                    for (i = 0; i < e.length; i++) n = e[i], s = o.categoryAxis.getSlot(n.categoryIx), n.reflow(s)
            },
            _gapStackPoints: function(t, e, i) {
                var n, s, o, r, a, h, l, c, u = this,
                    p = this.seriesPoints,
                    d = t[0].categoryIx,
                    g = t.length;
                for (d < 0 && (d = 0, g--), n = d + g, s = this.seriesOptions[0]._outOfRangeMinPoint ? 1 : 0, o = [], this._stackPoints = this._stackPoints || [], r = d; r < n; r++) {
                    a = r + s, h = e, l = void 0;
                    do h--, l = p[h][a]; while (h > 0 && !l);
                    l ? (i !== He && r > d && !p[h][a - 1] && o.push(u._previousSegmentPoint(r, a, a - 1, h)), o.push(l), i !== He && r + 1 < n && !p[h][a + 1] && o.push(u._previousSegmentPoint(r, a, a + 1, h))) : (c = u._createGapStackPoint(r), u._stackPoints.push(c), o.push(c))
                }
                return o
            },
            _previousSegmentPoint: function(t, e, i, n) {
                for (var s, o = this.seriesPoints, r = n; r > 0 && !s;) r--, s = o[r][i];
                return s ? s = o[r][e] : (s = this._createGapStackPoint(t), this._stackPoints.push(s)), s
            },
            _createGapStackPoint: function(t) {
                var e = this.pointOptions({}, 0),
                    i = new en(0, e);
                return i.categoryIx = t, i.series = {}, i
            },
            seriesMissingValues: function(t) {
                return t.missingValues || Le
            }
        }), fn = tt.extend({
            init: function() {
                this.axisRanges = {}
            },
            update: function(t) {
                var e, i, n, s = this.axisRanges;
                for (e in t) i = t[e], n = s[e], s[e] = n = n || {
                    min: nt,
                    max: st
                }, n.min = Math.min(n.min, i.min), n.max = Math.max(n.max, i.max)
            },
            reset: function(t) {
                this.axisRanges[t] = void 0
            },
            query: function(t) {
                return this.axisRanges[t]
            }
        }), vn = bt.extend({
            init: function(t, e, i) {
                bt.fn.init.call(this, e), this.textBox = new Ot(t, this.options, i), this.append(this.textBox)
            },
            createVisual: function() {
                this.textBox.options.noclip = this.options.noclip
            },
            reflow: function(t) {
                var e = this.options,
                    i = e.vertical,
                    n = e.aboveAxis,
                    s = this.children[0],
                    o = s.options,
                    r = s.box,
                    a = s.options.padding,
                    h = t;
                o.align = i ? rt : lt, o.vAlign = i ? at : rt, e.position === Gi ? i ? (o.vAlign = at, !n && r.height() < t.height() && (o.vAlign = ht)) : o.align = n ? gt : lt : e.position === rt ? (o.vAlign = rt, o.align = rt) : e.position === qi ? i ? o.vAlign = n ? ht : at : o.align = n ? lt : gt : e.position === Wi && (i ? h = n ? new St(t.x1, t.y1 - r.height(), t.x2, t.y1) : new St(t.x1, t.y2, t.x2, t.y2 + r.height()) : (o.align = rt, h = n ? new St(t.x2, t.y1, t.x2 + r.width(), t.y2) : new St(t.x1 - r.width(), t.y1, t.x1, t.y2))), e.rotation || (i ? a.left = a.right = (h.width() - s.contentBox.width()) / 2 : a.top = a.bottom = (h.height() - s.contentBox.height()) / 2), s.reflow(h)
            },
            alignToClipBox: function(t) {
                var e, i = this.options.vertical,
                    n = i ? dt : pt,
                    s = n + "1",
                    o = n + "2",
                    r = this.children[0],
                    a = this.parent.box;
                (a[s] < t[s] || t[o] < a[o]) && (e = r.paddingBox.clone(), e[s] = Math.max(a[s], t[s]), e[o] = Math.min(a[o], t[o]), this.reflow(e))
            }
        }), kt(vn, {
            position: Wi,
            margin: zt(3),
            padding: zt(4),
            color: ft,
            background: "",
            border: {
                width: 1,
                color: ""
            },
            aboveAxis: !0,
            vertical: !1,
            animation: {
                type: we,
                delay: _e
            },
            zIndex: 2
        }), mn = 6, xn = bt.extend({
            init: function(t, e) {
                bt.fn.init.call(this), this.options = e, this.color = e.color || ct, this.aboveAxis = Et(this.options.aboveAxis, !0), this.value = t
            },
            render: function() {
                this._rendered || (this._rendered = !0, this.createLabel(), this.createNote(), this.errorBar && this.append(this.errorBar))
            },
            createLabel: function() {
                var t, e, i, n = this.options,
                    s = n.labels;
                s.visible && (t = this.pointData(), e = Mt(s), i = e ? e(t) : this.formatValue(s.format), this.label = new vn(i, It({
                    vertical: n.vertical
                }, s), t), this.append(this.label))
            },
            formatValue: function(t) {
                return this.owner.formatPointValue(this, t)
            },
            reflow: function(t) {
                var e, i, n = this;
                if (this.render(), e = this.label, this.box = t, e && (e.options.aboveAxis = this.aboveAxis, e.reflow(t)), this.note && this.note.reflow(t), this.errorBars)
                    for (i = 0; i < this.errorBars.length; i++) n.errorBars[i].reflow(t)
            },
            createVisual: function() {
                var t, e = this,
                    i = this,
                    n = i.box,
                    s = i.options,
                    o = s.visual;
                this.visible !== !1 && (bt.fn.createVisual.call(this), o ? (t = this.rectVisual = o({
                    category: this.category,
                    dataItem: this.dataItem,
                    value: this.value,
                    sender: this.getSender(),
                    series: this.series,
                    percentage: this.percentage,
                    stackValue: this.stackValue,
                    runningTotal: this.runningTotal,
                    total: this.total,
                    rect: n.toRect(),
                    createVisual: function() {
                        var t = new se;
                        return e.createRect(t), t
                    },
                    options: s
                }), t && this.visual.append(t)) : n.width() > 0 && n.height() > 0 && this.createRect(this.visual))
            },
            createRect: function(t) {
                var e, i, n, s, o, r = this.options,
                    a = r.border,
                    l = yt(a.opacity) ? a.opacity : r.opacity,
                    c = this.box.toRect();
                c.size.width = Math.round(c.size.width), e = this.rectVisual = ee.fromRect(c, {
                    fill: {
                        color: this.color,
                        opacity: r.opacity
                    },
                    stroke: {
                        color: this.getBorderColor(),
                        width: a.width,
                        opacity: l,
                        dashType: a.dashType
                    }
                }), i = this.box.width(), n = this.box.height(), s = r.vertical ? i : n, s > mn && (Ct(e), (i < 1 || n < 1) && (e.options.stroke.lineJoin = "round")), t.append(e), h(r) && (o = this.createGradientOverlay(e, {
                    baseColor: this.color
                }, It({
                    end: r.vertical ? void 0 : [0, 1]
                }, r.overlay)), t.append(o))
            },
            createHighlight: function(t) {
                var e = ee.fromRect(this.box.toRect(), t);
                return Ct(e)
            },
            highlightVisual: function() {
                return this.rectVisual
            },
            highlightVisualArgs: function() {
                return {
                    options: this.options,
                    rect: this.box.toRect(),
                    visual: this.rectVisual
                }
            },
            getBorderColor: function() {
                var t = this.color,
                    e = this.options.border,
                    i = e._brightness || Ae,
                    n = e.color;
                return yt(n) || (n = new oe(t).brightness(i).toHex()), n
            },
            tooltipAnchor: function() {
                var t, e, i, n, s = this,
                    o = s.options,
                    r = s.box,
                    a = s.aboveAxis,
                    h = this.owner.pane.clipBox() || r,
                    l = lt,
                    c = at;
                return o.vertical ? (t = Math.min(r.x2, h.x2) + Se, a ? e = Math.max(r.y1, h.y1) : (e = Math.min(r.y2, h.y2), c = ht)) : (i = Math.max(r.x1, h.x1), n = Math.min(r.x2, h.x2), o.isStacked ? (c = ht, a ? (l = gt, t = n) : t = i, e = Math.max(r.y1, h.y1) - Se) : (a ? t = n + Se : (t = i - Se, l = gt), e = Math.max(r.y1, h.y1))), {
                    point: new At(t, e),
                    align: {
                        horizontal: l,
                        vertical: c
                    }
                }
            },
            overlapsBox: function(t) {
                return this.box.overlaps(t)
            },
            pointData: function() {
                return {
                    dataItem: this.dataItem,
                    category: this.category,
                    value: this.value,
                    percentage: this.percentage,
                    stackValue: this.stackValue,
                    runningTotal: this.runningTotal,
                    total: this.total,
                    series: this.series
                }
            }
        }), It(xn.prototype, Ji), It(xn.prototype, tn), xn.prototype.defaults = {
            border: {
                width: 1
            },
            vertical: !0,
            overlay: {
                gradient: "glass"
            },
            labels: {
                visible: !1,
                format: "{0}"
            },
            opacity: 1,
            notes: {
                label: {}
            }
        }, yn = bt.extend({
            init: function(t) {
                bt.fn.init.call(this, t), this.forEach = t.rtl ? c : l
            },
            reflow: function(t) {
                var e = this.options,
                    i = e.vertical,
                    n = e.gap,
                    s = e.spacing,
                    o = this.children,
                    r = o.length,
                    a = i ? dt : pt,
                    h = r + n + s * (r - 1),
                    l = (i ? t.height() : t.width()) / h,
                    c = t[a + 1] + l * (n / 2);
                this.forEach(o, function(e, i) {
                    var n = (e.box || t).clone();
                    n[a + 1] = c, n[a + 2] = c + l, e.reflow(n), i < r - 1 && (c += l * s), c += l
                })
            }
        }), kt(yn, {
            vertical: !1,
            gap: 0,
            spacing: 0
        }), _n = bt.extend({
            reflow: function(t) {
                var e, i, n, s = this,
                    o = this.options.vertical ? pt : dt,
                    r = this.children,
                    a = r.length,
                    h = this.box = new St;
                for (e = 0; e < a; e++) i = r[e], i.visible !== !1 && (n = i.box.clone(), n.snapTo(t, o), 0 === e && (h = s.box = n.clone()), i.reflow(n), h.wrap(n))
            }
        }), kt(_n, {
            vertical: !0
        }), wn = $i.extend({
            render: function() {
                $i.fn.render.call(this), this.updateStackRange()
            },
            pointType: function() {
                return xn
            },
            clusterType: function() {
                return yn
            },
            stackType: function() {
                return _n
            },
            stackLimits: function(t, e) {
                var i = $i.fn.stackLimits.call(this, t, e);
                return i
            },
            createPoint: function(t, e) {
                var i, n, s, o, r, a, h = e.categoryIx,
                    l = e.category,
                    c = e.series,
                    u = e.seriesIx,
                    p = this,
                    d = p.options,
                    g = p.children,
                    f = d.isStacked,
                    v = this.pointValue(t),
                    m = this.pointOptions(c, u),
                    x = m.labels;
                return f && x.position === Wi && (x.position = Gi), m.isStacked = f, i = t.fields.color || c.color, v < 0 && m.negativeColor && (i = m.negativeColor), m = this.evalPointOptions(m, v, l, h, c, u), Tt(c.color) && (i = m.color), n = this.pointType(), s = new n(v, m), s.color = i, o = g[h], o || (r = this.clusterType(), o = new r({
                    vertical: d.invertAxes,
                    gap: d.gap,
                    spacing: d.spacing,
                    rtl: !d.invertAxes && (this.chartService || {}).rtl
                }), this.append(o)), f ? (a = this.getStackWrap(c, o), a.append(s)) : o.append(s), s
            },
            getStackWrap: function(t, e) {
                var i, n, s, o = t.stack,
                    r = o ? o.group || o : o,
                    a = e.children;
                if (typeof r === it.STRING) {
                    for (n = 0; n < a.length; n++)
                        if (a[n]._stackGroup === r) {
                            i = a[n];
                            break
                        }
                } else i = a[0];
                return i || (s = this.stackType(), i = new s({
                    vertical: !this.options.invertAxes
                }), i._stackGroup = r, e.append(i)), i
            },
            categorySlot: function(t, e, i) {
                var n, s, o = this.options,
                    r = t.getSlot(e),
                    a = i.startValue();
                return o.isStacked && (n = i.getSlot(a, a, !0), s = o.invertAxes ? pt : dt, r[s + 1] = r[s + 2] = n[s + 1]), r
            },
            reflowCategories: function(t) {
                var e, i = this.children,
                    n = i.length;
                for (e = 0; e < n; e++) i[e].reflow(t[e])
            },
            createAnimation: function() {
                this._setAnimationOptions(), $i.fn.createAnimation.call(this), a(this.options.series) && this._setChildrenAnimation()
            },
            _setChildrenAnimation: function() {
                var t, e, i, n = this,
                    s = this.points;
                for (t = 0; t < s.length; t++) e = s[t], i = e.visual, i && yt(i.options.zIndex) && (e.options.animation = n.options.animation, e.createAnimation())
            },
            _setAnimationOptions: function() {
                var t, e, i = this.options,
                    n = i.animation || {};
                i.isStacked ? (e = this.seriesValueAxis(i.series[0]), t = e.getSlot(e.startValue())) : t = this.categoryAxis.getSlot(0), n.origin = new ae(t.x1, t.y1), n.vertical = !i.invertAxes
            }
        }), kt(wn, {
            animation: {
                type: Ne
            }
        }), bn = bt.extend({
            init: function(t, e) {
                bt.fn.init.call(this, e), this.value = t
            },
            reflow: function(t) {
                var e, i, n = this,
                    s = n.options,
                    o = n.value,
                    r = n.owner,
                    a = r.seriesValueAxis(s),
                    h = a.getSlot(o.open, o.close),
                    l = a.getSlot(o.low, o.high);
                h.x1 = l.x1 = t.x1, h.x2 = l.x2 = t.x2, this.realBody = h, e = l.center().x, i = [], i.push([
                    [e, l.y1],
                    [e, h.y1]
                ]), i.push([
                    [e, h.y2],
                    [e, l.y2]
                ]), this.lines = i, this.box = l.clone().wrap(h), this._rendered || (this._rendered = !0, this.createNote()), this.reflowNote()
            },
            reflowNote: function() {
                this.note && this.note.reflow(this.box)
            },
            createVisual: function() {
                bt.fn.createVisual.call(this), this._mainVisual = this.mainVisual(this.options), this.visual.append(this._mainVisual), this.createOverlay()
            },
            mainVisual: function(t) {
                var e = new se;
                return this.createBody(e, t), this.createLines(e, t), e
            },
            createBody: function(t, e) {
                var i = ee.fromRect(this.realBody.toRect(), {
                    fill: {
                        color: this.color,
                        opacity: e.opacity
                    },
                    stroke: null
                });
                e.border.width > 0 && i.options.set("stroke", {
                    color: this.getBorderColor(),
                    width: e.border.width,
                    dashType: e.border.dashType,
                    opacity: Et(e.border.opacity, e.opacity)
                }), Ct(i), t.append(i), h(e) && t.append(this.createGradientOverlay(i, {
                    baseColor: this.color
                }, It({
                    end: e.vertical ? void 0 : [0, 1]
                }, e.overlay)))
            },
            createLines: function(t, e) {
                this.drawLines(t, e, this.lines, e.line)
            },
            drawLines: function(t, e, i, n) {
                var s, o, r;
                if (i)
                    for (s = {
                            stroke: {
                                color: n.color || this.color,
                                opacity: Et(n.opacity, e.opacity),
                                width: n.width,
                                dashType: n.dashType,
                                lineCap: "butt"
                            }
                        }, o = 0; o < i.length; o++) r = ee.fromPoints(i[o], s), Ct(r), t.append(r)
            },
            getBorderColor: function() {
                var t = this.options.border,
                    e = t.color;
                return yt(e) || (e = new oe(this.color).brightness(t._brightness).toHex()), e
            },
            createOverlay: function() {
                var t = ee.fromRect(this.box.toRect(), {
                    fill: {
                        color: ct,
                        opacity: 0
                    },
                    stroke: null
                });
                this.visual.append(t)
            },
            createHighlight: function() {
                var t, e = this.options.highlight,
                    i = this.color;
                return this.color = e.color || this.color, t = this.mainVisual(It({}, this.options, {
                    line: {
                        color: this.getBorderColor()
                    }
                }, e)), this.color = i, t
            },
            highlightVisual: function() {
                return this._mainVisual
            },
            highlightVisualArgs: function() {
                return {
                    options: this.options,
                    rect: this.box.toRect(),
                    visual: this._mainVisual
                }
            },
            tooltipAnchor: function() {
                var t = this.box,
                    e = this.owner.pane.clipBox() || t;
                return {
                    point: new At(t.x2 + Se, Math.max(t.y1, e.y1) + Se),
                    align: {
                        horizontal: lt,
                        vertical: at
                    }
                }
            },
            formatValue: function(t) {
                return this.owner.formatPointValue(this, t)
            },
            overlapsBox: function(t) {
                return this.box.overlaps(t)
            }
        }), kt(bn, {
            vertical: !0,
            border: {
                _brightness: .8
            },
            line: {
                width: 2
            },
            overlay: {
                gradient: "glass"
            },
            tooltip: {
                format: "<table><tr><th colspan='2'>{4:d}</th></tr><tr><td>Open:</td><td>{0:C}</td></tr><tr><td>High:</td><td>{1:C}</td></tr><tr><td>Low:</td><td>{2:C}</td></tr><tr><td>Close:</td><td>{3:C}</td></tr></table>"
            },
            highlight: {
                opacity: 1,
                border: {
                    width: 1,
                    opacity: 1
                },
                line: {
                    width: 1,
                    opacity: 1
                }
            },
            notes: {
                visible: !0,
                label: {}
            }
        }), It(bn.prototype, Ji), It(bn.prototype, tn), An = $i.extend({
            reflowCategories: function(t) {
                var e, i = this.children,
                    n = i.length;
                for (e = 0; e < n; e++) i[e].reflow(t[e])
            },
            addValue: function(t, e) {
                var i, n, s = e.categoryIx,
                    o = e.category,
                    r = e.series,
                    a = e.seriesIx,
                    h = this,
                    l = h.children,
                    c = h.options,
                    p = t.valueFields,
                    d = this.splitValue(p),
                    g = u(d),
                    f = r.data[s],
                    v = this.categoryPoints[s];
                v || (this.categoryPoints[s] = v = []), g && (i = this.createPoint(t, e)), n = l[s], n || (n = new yn({
                    vertical: c.invertAxes,
                    gap: c.gap,
                    spacing: c.spacing,
                    rtl: !c.invertAxes && (this.chartService || {}).rtl
                }), this.append(n)), i && (this.updateRange(p, e), n.append(i), i.categoryIx = s, i.category = o, i.series = r, i.seriesIx = a, i.owner = this, i.dataItem = f, i.noteText = t.fields.noteText), this.points.push(i), v.push(i)
            },
            pointType: function() {
                return bn
            },
            createPoint: function(t, e) {
                var i, n = e.categoryIx,
                    s = e.category,
                    o = e.series,
                    r = e.seriesIx,
                    a = this.pointType(),
                    h = t.valueFields,
                    l = It({}, o),
                    c = t.fields.color || o.color;
                return l = this.evalPointOptions(l, h, s, n, o, r), o.type === Xe && h.open > h.close && (c = t.fields.downColor || o.downColor || o.color), Tt(o.color) && (c = l.color), l.vertical = !this.options.invertAxes, i = new a(h, l), i.color = c, i
            },
            splitValue: function(t) {
                return [t.low, t.open, t.close, t.high]
            },
            updateRange: function(t, e) {
                var i = e.series.axis,
                    n = this.splitValue(t),
                    s = this.valueAxisRanges[i];
                s = this.valueAxisRanges[i] = s || {
                    min: nt,
                    max: st
                }, s = this.valueAxisRanges[i] = {
                    min: Math.min.apply(Math, n.concat([s.min])),
                    max: Math.max.apply(Math, n.concat([s.max]))
                }
            },
            formatPointValue: function(t, e) {
                var i = t.value;
                return this.chartService.format.auto(e, i.open, i.high, i.low, i.close, t.category)
            },
            animationPoints: function() {
                return this.points
            }
        }), It(An.prototype, ln), Sn = bn.extend({
            init: function(t, e) {
                bn.fn.init.call(this, t, e), this.createNote()
            },
            reflow: function(t) {
                var e, i, n, s, o = this,
                    r = o.options,
                    a = o.value,
                    h = o.owner,
                    l = h.seriesValueAxis(r);
                this.boxSlot = i = l.getSlot(a.q1, a.q3), this.realBody = i, this.reflowBoxSlot(t), this.whiskerSlot = e = l.getSlot(a.lower, a.upper), this.reflowWhiskerSlot(t), n = l.getSlot(a.median), a.mean && (s = l.getSlot(a.mean), this.meanPoints = this.calcMeanPoints(t, s)), this.whiskerPoints = this.calcWhiskerPoints(i, e), this.medianPoints = this.calcMedianPoints(t, n), this.box = e.clone().wrap(i), this.reflowNote()
            },
            reflowBoxSlot: function(t) {
                this.boxSlot.x1 = t.x1, this.boxSlot.x2 = t.x2
            },
            reflowWhiskerSlot: function(t) {
                this.whiskerSlot.x1 = t.x1, this.whiskerSlot.x2 = t.x2
            },
            calcMeanPoints: function(t, e) {
                return [
                    [
                        [t.x1, e.y1],
                        [t.x2, e.y1]
                    ]
                ]
            },
            calcWhiskerPoints: function(t, e) {
                var i = e.center().x;
                return [
                    [
                        [i - 5, e.y1],
                        [i + 5, e.y1],
                        [i, e.y1],
                        [i, t.y1]
                    ],
                    [
                        [i - 5, e.y2],
                        [i + 5, e.y2],
                        [i, e.y2],
                        [i, t.y2]
                    ]
                ]
            },
            calcMedianPoints: function(t, e) {
                return [
                    [
                        [t.x1, e.y1],
                        [t.x2, e.y1]
                    ]
                ]
            },
            renderOutliers: function(t) {
                var e, i, n, s, o = this,
                    r = this.value,
                    a = r.outliers || [],
                    h = 3 * Math.abs(r.q3 - r.q1),
                    l = [],
                    c = t.markers || {};
                for (e = 0; e < a.length; e++) i = a[e], c = i < r.q3 + h && i > r.q1 - h ? t.outliers : t.extremes, n = It({}, c.border), yt(n.color) || (n.color = yt(o.color) ? o.color : new oe(c.background).brightness(Ae).toHex()), s = new Bt({
                    type: c.type,
                    width: c.size,
                    height: c.size,
                    rotation: c.rotation,
                    background: c.background,
                    border: n,
                    opacity: c.opacity
                }), s.value = i, l.push(s);
                return this.reflowOutliers(l), l
            },
            reflowOutliers: function(t) {
                var e, i, n, s = this,
                    o = this.owner.seriesValueAxis(this.options),
                    r = this.box.center();
                for (e = 0; e < t.length; e++) i = t[e].value, n = o.getSlot(i), s.options.vertical ? n.move(r.x) : n.move(void 0, r.y), s.box = s.box.wrap(n), t[e].reflow(n)
            },
            mainVisual: function(t) {
                var e, i, n = bn.fn.mainVisual.call(this, t),
                    s = this.renderOutliers(t);
                for (e = 0; e < s.length; e++) i = s[e].getElement(), i && n.append(i);
                return n
            },
            createLines: function(t, e) {
                this.drawLines(t, e, this.whiskerPoints, e.whiskers), this.drawLines(t, e, this.medianPoints, e.median), this.drawLines(t, e, this.meanPoints, e.mean)
            },
            getBorderColor: function() {
                return (this.options.border || {}).color ? this.options.border.color : this.color ? this.color : bn.fn.getBorderColor.call(this)
            }
        }), kt(Sn, {
            border: {
                _brightness: .8
            },
            line: {
                width: 2
            },
            median: {
                color: "#f6f6f6"
            },
            mean: {
                width: 2,
                dashType: "dash",
                color: "#f6f6f6"
            },
            overlay: {
                gradient: "glass"
            },
            tooltip: {
                format: "<table><tr><th colspan='2'>{6:d}</th></tr><tr><td>Lower:</td><td>{0:C}</td></tr><tr><td>Q1:</td><td>{1:C}</td></tr><tr><td>Median:</td><td>{2:C}</td></tr><tr><td>Mean:</td><td>{5:C}</td></tr><tr><td>Q3:</td><td>{3:C}</td></tr><tr><td>Upper:</td><td>{4:C}</td></tr></table>"
            },
            highlight: {
                opacity: 1,
                border: {
                    width: 1,
                    opacity: 1
                },
                line: {
                    width: 1,
                    opacity: 1
                }
            },
            notes: {
                visible: !0,
                label: {}
            },
            outliers: {
                visible: !0,
                size: Ve,
                type: it.CROSS,
                background: ct,
                border: {
                    width: 2,
                    opacity: 1
                },
                opacity: 0
            },
            extremes: {
                visible: !0,
                size: Ve,
                type: ut,
                background: ct,
                border: {
                    width: 2,
                    opacity: 1
                },
                opacity: 0
            }
        }), It(Sn.prototype, Ji), Cn = Sn.extend({
            reflowBoxSlot: function(t) {
                this.boxSlot.y1 = t.y1, this.boxSlot.y2 = t.y2
            },
            reflowWhiskerSlot: function(t) {
                this.whiskerSlot.y1 = t.y1, this.whiskerSlot.y2 = t.y2
            },
            calcMeanPoints: function(t, e) {
                return [
                    [
                        [e.x1, t.y1],
                        [e.x1, t.y2]
                    ]
                ]
            },
            calcWhiskerPoints: function(t, e) {
                var i = e.center().y;
                return [
                    [
                        [e.x1, i - 5],
                        [e.x1, i + 5],
                        [e.x1, i],
                        [t.x1, i]
                    ],
                    [
                        [e.x2, i - 5],
                        [e.x2, i + 5],
                        [e.x2, i],
                        [t.x2, i]
                    ]
                ]
            },
            calcMedianPoints: function(t, e) {
                return [
                    [
                        [e.x1, t.y1],
                        [e.x1, t.y2]
                    ]
                ]
            }
        }), kn = An.extend({
            addValue: function(t, e) {
                var i, n, s = e.categoryIx,
                    o = e.category,
                    r = e.series,
                    a = e.seriesIx,
                    h = this,
                    l = h.children,
                    c = h.options,
                    p = t.valueFields,
                    d = this.splitValue(p),
                    g = u(d),
                    f = r.data[s],
                    v = this.categoryPoints[s];
                v || (this.categoryPoints[s] = v = []), g && (i = this.createPoint(t, e)), n = l[s], n || (n = new yn({
                    vertical: c.invertAxes,
                    gap: c.gap,
                    spacing: c.spacing,
                    rtl: !c.invertAxes && (this.chartService || {}).rtl
                }), this.append(n)), i && (this.updateRange(p, e), n.append(i), i.categoryIx = s, i.category = o, i.series = r, i.seriesIx = a, i.owner = this, i.dataItem = f), this.points.push(i), v.push(i)
            },
            pointType: function() {
                return this.options.invertAxes ? Cn : Sn
            },
            splitValue: function(t) {
                return [t.lower, t.q1, t.median, t.q3, t.upper]
            },
            updateRange: function(t, e) {
                var i = e.series.axis,
                    n = this.valueAxisRanges[i],
                    s = this.splitValue(t).concat(this.filterOutliers(t.outliers));
                yt(t.mean) && (s = s.concat(t.mean)), n = this.valueAxisRanges[i] = n || {
                    min: nt,
                    max: st
                }, n = this.valueAxisRanges[i] = {
                    min: Math.min.apply(Math, s.concat([n.min])),
                    max: Math.max.apply(Math, s.concat([n.max]))
                }
            },
            formatPointValue: function(t, e) {
                var i = t.value;
                return this.chartService.format.auto(e, i.lower, i.q1, i.median, i.q3, i.upper, i.mean, t.category)
            },
            filterOutliers: function(t) {
                var e, i, n = (t || []).length,
                    s = [];
                for (e = 0; e < n; e++) i = t[e], yt(i) && null !== i && s.push(i);
                return s
            }
        }), Pn = ji.extend({
            getAxis: function() {
                var t = this.chart.seriesAxes(this.series),
                    e = this.isVertical ? t.y : t.x;
                return e
            }
        }), Tn = bt.extend({
            init: function(t, e) {
                bt.fn.init.call(this, e), this.plotArea = t, this.chartService = t.chartService, this._initFields(), this.render()
            },
            _initFields: function() {
                this.xAxisRanges = {}, this.yAxisRanges = {}, this.points = [], this.seriesPoints = [], this.seriesOptions = [], this._evalSeries = []
            },
            render: function() {
                this.traverseDataPoints(this.addValue.bind(this))
            },
            addErrorBar: function(t, e, i) {
                var n, s = t.value[e],
                    o = e + "Value",
                    r = e + "ErrorLow",
                    a = e + "ErrorHigh",
                    h = i.seriesIx,
                    l = i.series,
                    c = t.options.errorBars,
                    u = i[r],
                    p = i[a];
                et(s) && (et(u) && et(p) && (n = {
                    low: u,
                    high: p
                }), c && yt(c[o]) && (this.seriesErrorRanges = this.seriesErrorRanges || {
                    x: [],
                    y: []
                }, this.seriesErrorRanges[e][h] = this.seriesErrorRanges[e][h] || new xe(c[o], l, e), n = this.seriesErrorRanges[e][h].getErrorRange(s, c[o])), n && this.addPointErrorBar(n, t, e))
            },
            addPointErrorBar: function(t, e, i) {
                var n, s = t.low,
                    o = t.high,
                    r = e.series,
                    a = e.options.errorBars,
                    h = i === dt,
                    l = {};
                e[i + "Low"] = s, e[i + "High"] = o, e.errorBars = e.errorBars || [], n = new Pn(s, o, h, this, r, a), e.errorBars.push(n), e.append(n), l[i] = s, this.updateRange(l, r), l[i] = o, this.updateRange(l, r)
            },
            addValue: function(e, i) {
                var n, s = e.x,
                    o = e.y,
                    r = i.seriesIx,
                    a = this.options.series[r],
                    h = this.seriesMissingValues(a),
                    l = this.seriesPoints[r],
                    c = e;
                p(s) && p(o) || (c = this.createMissingValue(c, h)), c && (n = this.createPoint(c, i), n && (t.extend(n, i), this.addErrorBar(n, pt, i), this.addErrorBar(n, dt, i)), this.updateRange(c, i.series)), this.points.push(n), l.push(n)
            },
            seriesMissingValues: function(t) {
                return t.missingValues
            },
            createMissingValue: function() {},
            updateRange: function(t, e) {
                var i = this.chartService.intl,
                    n = e.xAxis,
                    s = e.yAxis,
                    o = t.x,
                    r = t.y,
                    a = this.xAxisRanges[n],
                    h = this.yAxisRanges[s];
                p(o) && (a = this.xAxisRanges[n] = a || {
                    min: nt,
                    max: st
                }, Ft(o) && (o = Nt(i, o)), a.min = Math.min(a.min, o), a.max = Math.max(a.max, o)), p(r) && (h = this.yAxisRanges[s] = h || {
                    min: nt,
                    max: st
                }, Ft(r) && (r = Nt(i, r)), h.min = Math.min(h.min, r), h.max = Math.max(h.max, r))
            },
            evalPointOptions: function(t, e, i) {
                var n, o = i.series,
                    r = i.seriesIx,
                    a = {
                        defaults: o._defaults,
                        excluded: ["data", "tooltip", "content", "template", "visual", "toggle", "_outOfRangeMinPoint", "_outOfRangeMaxPoint"]
                    },
                    h = this._evalSeries[r];
                return yt(h) || (this._evalSeries[r] = h = s(t, {}, a, !0)), n = t, h && (n = It({}, t), s(n, {
                    value: e,
                    series: o,
                    dataItem: i.dataItem
                }, a)), n
            },
            pointType: function() {
                return en
            },
            pointOptions: function(t, e) {
                var i, n = this.seriesOptions[e];
                return n || (i = this.pointType().prototype.defaults, this.seriesOptions[e] = n = It({}, i, {
                    markers: {
                        opacity: t.opacity
                    },
                    tooltip: {
                        format: this.options.tooltip.format
                    },
                    labels: {
                        format: this.options.labels.format
                    }
                }, t)), n
            },
            createPoint: function(t, e) {
                var i, n = e.series,
                    s = this.pointOptions(n, e.seriesIx),
                    o = e.color || n.color;
                return s = this.evalPointOptions(s, t, e), Tt(n.color) && (o = s.color), i = new en(t, s), i.color = o, this.append(i), i
            },
            seriesAxes: function(t) {
                var e = t.xAxis,
                    i = t.yAxis,
                    n = this.plotArea,
                    s = e ? n.namedXAxes[e] : n.axisX,
                    o = i ? n.namedYAxes[i] : n.axisY;
                if (!s) throw Error("Unable to locate X axis with name " + e);
                if (!o) throw Error("Unable to locate Y axis with name " + i);
                return {
                    x: s,
                    y: o
                }
            },
            reflow: function(t) {
                var e = this,
                    i = this.points,
                    n = !this.options.clip,
                    s = 0;
                this.traverseDataPoints(function(t, o) {
                    var r, a = i[s++],
                        h = e.seriesAxes(o.series),
                        l = h.x.getSlot(t.x, t.x, n),
                        c = h.y.getSlot(t.y, t.y, n);
                    a && (l && c ? (r = e.pointSlot(l, c), a.reflow(r)) : a.visible = !1)
                }), this.box = t
            },
            pointSlot: function(t, e) {
                return new St(t.x1, e.y1, t.x2, e.y2)
            },
            traverseDataPoints: function(t) {
                var e, i, n, s, o, r, a, h = this,
                    l = this,
                    c = l.options.series,
                    u = l.seriesPoints;
                for (e = 0; e < c.length; e++)
                    for (i = c[e], n = u[e], n || (u[e] = []), s = 0; s < i.data.length; s++) o = h._bindPoint(i, e, s), r = o.valueFields, a = o.fields, t(r, It({
                        pointIx: s,
                        series: i,
                        seriesIx: e,
                        dataItem: i.data[s],
                        owner: h
                    }, a))
            },
            formatPointValue: function(t, e) {
                var i = t.value;
                return this.chartService.format.auto(e, i.x, i.y)
            },
            animationPoints: function() {
                var t, e = this.points,
                    i = [];
                for (t = 0; t < e.length; t++) i.push((e[t] || {}).marker);
                return i
            }
        }), kt(Tn, {
            series: [],
            tooltip: {
                format: "{0}, {1}"
            },
            labels: {
                format: "{0}, {1}"
            },
            clip: !0
        }), It(Tn.prototype, ln, {
            _bindPoint: $i.prototype._bindPoint
        }), En = en.extend({
            init: function(t, e) {
                en.fn.init.call(this, t, e), this.category = t.category
            },
            createHighlight: function() {
                var t = this.options.highlight,
                    e = t.border,
                    i = this.options.markers,
                    n = this.box.center(),
                    s = (i.size + i.border.width + e.width) / 2,
                    o = new se,
                    r = new te.Circle(new re.Circle([n.x, n.y + s / 5 + e.width / 2], s + e.width / 2), {
                        stroke: {
                            color: "none"
                        },
                        fill: this.createGradient({
                            gradient: "bubbleShadow",
                            color: i.background,
                            stops: [{
                                offset: 0,
                                color: i.background,
                                opacity: .3
                            }, {
                                offset: 1,
                                color: i.background,
                                opacity: 0
                            }]
                        })
                    }),
                    a = new te.Circle(new re.Circle([n.x, n.y], s), {
                        stroke: {
                            color: e.color || new oe(i.background).brightness(Ae).toHex(),
                            width: e.width,
                            opacity: e.opacity
                        },
                        fill: {
                            color: i.background,
                            opacity: t.opacity
                        }
                    });
                return o.append(r, a), o
            }
        }), En.prototype.defaults = It({}, En.prototype.defaults, {
            labels: {
                position: rt
            },
            highlight: {
                opacity: 1,
                border: {
                    color: "#fff",
                    width: 2,
                    opacity: 1
                }
            }
        }), En.prototype.defaults.highlight.zIndex = void 0, Rn = Tn.extend({
            _initFields: function() {
                this._maxSize = st, Tn.fn._initFields.call(this)
            },
            addValue: function(t, e) {
                null !== t.size && (t.size > 0 || t.size < 0 && e.series.negativeValues.visible) ? (this._maxSize = Math.max(this._maxSize, Math.abs(t.size)), Tn.fn.addValue.call(this, t, e)) : (this.points.push(null), this.seriesPoints[e.seriesIx].push(null))
            },
            reflow: function(t) {
                this.updateBubblesSize(t), Tn.fn.reflow.call(this, t)
            },
            pointType: function() {
                return En
            },
            createPoint: function(t, e) {
                var i, n, s = e.series,
                    o = s.data.length,
                    r = e.pointIx * (_e / o),
                    a = {
                        delay: r,
                        duration: _e - r,
                        type: qe
                    },
                    h = e.color || s.color;
                return t.size < 0 && s.negativeValues.visible && (h = Et(s.negativeValues.color, h)), i = It({
                    labels: {
                        animation: {
                            delay: r,
                            duration: _e - r
                        }
                    }
                }, this.pointOptions(s, e.seriesIx), {
                    markers: {
                        type: ut,
                        border: s.border,
                        opacity: s.opacity,
                        animation: a
                    }
                }), i = this.evalPointOptions(i, t, e), Tt(s.color) && (h = i.color), i.markers.background = h, n = new En(t, i), n.color = h, this.append(n), n
            },
            updateBubblesSize: function(t) {
                var e, i, n, s, o, r, a, h, l, c, u, p, d, g, f, v, m, x = this,
                    y = this,
                    _ = y.options.series,
                    w = Math.min(t.width(), t.height());
                for (e = 0; e < _.length; e++)
                    for (i = _[e], n = x.seriesPoints[e], s = i.minSize || Math.max(.02 * w, 10), o = i.maxSize || .2 * w, r = s / 2, a = o / 2, h = Math.PI * r * r, l = Math.PI * a * a, c = l - h, u = c / x._maxSize, p = 0; p < n.length; p++) d = n[p], d && (g = Math.abs(d.value.size) * u, f = Math.sqrt((h + g) / Math.PI), v = Et(d.options.zIndex, 0), m = v + (1 - f / a), It(d.options, {
                        zIndex: m,
                        markers: {
                            size: 2 * f,
                            zIndex: m
                        },
                        labels: {
                            zIndex: m + 1
                        }
                    }))
            },
            formatPointValue: function(t, e) {
                var i = t.value;
                return this.chartService.format.auto(e, i.x, i.y, i.size, t.category)
            },
            createAnimation: function() {},
            createVisual: function() {}
        }), kt(Rn, {
            tooltip: {
                format: "{3}"
            },
            labels: {
                format: "{3}"
            }
        }), In = Bt.extend({}), It(In.prototype, Ji), Vn = bt.extend({
            init: function(t, e) {
                bt.fn.init.call(this, e), this.aboveAxis = this.options.aboveAxis, this.color = e.color || ct, this.value = t
            },
            render: function() {
                var t = this.options;
                this._rendered || (this._rendered = !0, yt(this.value.target) && (this.target = new In({
                    type: t.target.shape,
                    background: t.target.color || this.color,
                    opacity: t.opacity,
                    zIndex: t.zIndex,
                    border: t.target.border,
                    vAlign: at,
                    align: gt
                }), this.target.value = this.value, this.target.dataItem = this.dataItem, this.target.series = this.series, this.append(this.target)), this.createNote())
            },
            reflow: function(t) {
                var e, i, n, s, o, r, a, h, l, c, u;
                this.render(), e = this, i = e.options, n = e.target, s = e.owner, o = i.invertAxes, r = s.seriesValueAxis(this.options), a = s.categorySlot(s.categoryAxis, i.categoryIx, r), h = r.getSlot(this.value.target), l = o ? h : a, c = o ? a : h, n && (u = new St(l.x1, c.y1, l.x2, c.y2), n.options.height = o ? u.height() : i.target.line.width, n.options.width = o ? i.target.line.width : u.width(), n.reflow(u)), this.note && this.note.reflow(t), this.box = t
            },
            createVisual: function() {
                var t, e;
                bt.fn.createVisual.call(this), t = this.options, e = ee.fromRect(this.box.toRect(), {
                    fill: {
                        color: this.color,
                        opacity: t.opacity
                    },
                    stroke: null
                }), t.border.width > 0 && e.options.set("stroke", {
                    color: t.border.color || this.color,
                    width: t.border.width,
                    dashType: t.border.dashType,
                    opacity: Et(t.border.opacity, t.opacity)
                }), this.bodyVisual = e, Ct(e), this.visual.append(e)
            },
            createAnimation: function() {
                this.bodyVisual && (this.animation = ie.create(this.bodyVisual, this.options.animation))
            },
            createHighlight: function(t) {
                return ee.fromRect(this.box.toRect(), t)
            },
            highlightVisual: function() {
                return this.bodyVisual
            },
            highlightVisualArgs: function() {
                return {
                    rect: this.box.toRect(),
                    visual: this.bodyVisual,
                    options: this.options
                }
            },
            formatValue: function(t) {
                return this.owner.formatPointValue(this, t)
            }
        }), Vn.prototype.tooltipAnchor = xn.prototype.tooltipAnchor, kt(Vn, {
            border: {
                width: 1
            },
            vertical: !1,
            opacity: 1,
            target: {
                shape: "",
                border: {
                    width: 0,
                    color: "green"
                },
                line: {
                    width: 2
                }
            },
            tooltip: {
                format: "Current: {0}<br />Target: {1}"
            }
        }), It(Vn.prototype, Ji), It(Vn.prototype, tn), Ln = $i.extend({
            init: function(t, e) {
                d(e), $i.fn.init.call(this, t, e)
            },
            reflowCategories: function(t) {
                var e, i = this.children,
                    n = i.length;
                for (e = 0; e < n; e++) i[e].reflow(t[e])
            },
            plotRange: function(t) {
                var e = t.series,
                    i = this.seriesValueAxis(e),
                    n = this.categoryAxisCrossingValue(i);
                return [n, t.value.current || n]
            },
            createPoint: function(t, e) {
                var i, n, s = e.categoryIx,
                    o = e.category,
                    r = e.series,
                    a = e.seriesIx,
                    h = this,
                    l = h.options,
                    c = h.children,
                    u = t.valueFields,
                    p = It({
                        vertical: !l.invertAxes,
                        overlay: r.overlay,
                        categoryIx: s,
                        invertAxes: l.invertAxes
                    }, r),
                    d = t.fields.color || r.color;
                return p = this.evalPointOptions(p, u, o, s, r, a), Tt(r.color) && (d = p.color), i = new Vn(u, p),
                    i.color = d, n = c[s], n || (n = new yn({
                        vertical: l.invertAxes,
                        gap: l.gap,
                        spacing: l.spacing,
                        rtl: !l.invertAxes && (this.chartService || {}).rtl
                    }), this.append(n)), n.append(i), i
            },
            updateRange: function(t, e) {
                var i = t.current,
                    n = t.target,
                    s = e.series.axis,
                    o = this.valueAxisRanges[s];
                yt(i) && !isNaN(i) && yt(n && !isNaN(n)) && (o = this.valueAxisRanges[s] = o || {
                    min: nt,
                    max: st
                }, o.min = Math.min(o.min, i, n), o.max = Math.max(o.max, i, n))
            },
            formatPointValue: function(t, e) {
                return this.chartService.format.auto(e, t.value.current, t.value.target)
            },
            pointValue: function(t) {
                return t.valueFields.current
            },
            aboveAxis: function(t) {
                var e = t.value.current;
                return e > 0
            },
            createAnimation: function() {
                var t, e, i = this,
                    n = this.points;
                for (this._setAnimationOptions(), t = 0; t < n.length; t++) e = n[t], e.options.animation = i.options.animation, e.createAnimation()
            }
        }), Ln.prototype._setAnimationOptions = wn.prototype._setAnimationOptions, kt(Ln, {
            animation: {
                type: Ne
            }
        }), Mn = tt.extend({
            init: function(t, e) {
                this.chartService = t, this.options = It({}, this.options, e)
            },
            getStyle: function(t, e) {
                var i, n, s = t.background,
                    o = t.border.color;
                return e && (i = e.color || e.options.color, s = Et(s, i), o = Et(o, i)), n = zt(t.padding || {}, "auto"), {
                    backgroundColor: s,
                    borderColor: o,
                    font: t.font,
                    color: t.color,
                    opacity: t.opacity,
                    borderWidth: Gt(t.border.width),
                    paddingTop: Gt(n.top),
                    paddingBottom: Gt(n.bottom),
                    paddingLeft: Gt(n.left),
                    paddingRight: Gt(n.right)
                }
            },
            show: function(t, e, i) {
                t.format = e.format;
                var n = this.getStyle(e, i);
                t.style = n, !yt(e.color) && new oe(n.backgroundColor).percBrightness() > 180 && (t.className = "k-chart-tooltip-inverse"), this.chartService.notify(zi, t), this.visible = !0
            },
            hide: function() {
                this.chartService && this.chartService.notify(Di), this.visible = !1
            },
            destroy: function() {
                delete this.chartService
            }
        }), kt(Mn, {
            border: {
                width: 1
            },
            opacity: 1
        }), On = Mn.extend({
            init: function(t, e, i) {
                Mn.fn.init.call(this, t, i), this.crosshair = e, this.formatService = t.format, this.initAxisName()
            },
            initAxisName: function() {
                var t, e = this.crosshair.axis,
                    i = e.plotArea;
                t = i.categoryAxis ? e.getCategory ? "categoryAxis" : "valueAxis" : e.options.vertical ? "yAxis" : "xAxis", this.axisName = t
            },
            showAt: function(t) {
                var e = this,
                    i = e.crosshair.axis,
                    n = e.options,
                    s = i[n.stickyMode ? "getCategory" : "getValue"](t),
                    o = s;
                n.format ? o = this.formatService.auto(n.format, s) : i.options.type === vt && (o = this.formatService.auto(i.options.labels.dateFormats[i.options.baseUnit], s)), this.show({
                    point: t,
                    anchor: this.getAnchor(),
                    crosshair: this.crosshair,
                    value: o,
                    axisName: this.axisName,
                    axisIndex: this.crosshair.axis.axisIndex
                }, this.options)
            },
            hide: function() {
                this.chartService.notify(Di, {
                    crosshair: this.crosshair,
                    axisName: this.axisName,
                    axisIndex: this.crosshair.axis.axisIndex
                })
            },
            getAnchor: function() {
                var t, e, i, n = this,
                    s = n.crosshair,
                    o = n.options,
                    r = o.position,
                    a = o.padding,
                    h = !s.axis.options.vertical,
                    l = s.line.bbox();
                return h ? (t = rt, r === ht ? (e = at, i = l.bottomLeft().translate(0, a)) : (e = ht, i = l.topLeft().translate(0, -a))) : (e = rt, r === lt ? (t = gt, i = l.topLeft().translate(-a, 0)) : (t = lt, i = l.topRight().translate(a, 0))), {
                    point: i,
                    align: {
                        horizontal: t,
                        vertical: e
                    }
                }
            }
        }), kt(On, {
            padding: 10
        }), Bn = bt.extend({
            init: function(t, e, i) {
                bt.fn.init.call(this, i), this.axis = e, this.stickyMode = e instanceof qt;
                var n = this.options.tooltip;
                n.visible && (this.tooltip = new On(t, this, It({}, n, {
                    stickyMode: this.stickyMode
                })))
            },
            showAt: function(t) {
                this.point = t, this.moveLine(), this.line.visible(!0), this.tooltip && this.tooltip.showAt(t)
            },
            hide: function() {
                this.line.visible(!1), this.tooltip && this.tooltip.hide()
            },
            moveLine: function() {
                var t, e, i = this,
                    n = i.axis,
                    s = i.point,
                    o = n.options.vertical,
                    r = this.getBox(),
                    a = o ? dt : pt,
                    h = new ae(r.x1, r.y1);
                t = o ? new ae(r.x2, r.y1) : new ae(r.x1, r.y2), s && (this.stickyMode ? (e = n.getSlot(n.pointCategoryIndex(s)), h[a] = t[a] = e.center()[a]) : h[a] = t[a] = s[a]), this.box = r, this.line.moveTo(h).lineTo(t)
            },
            getBox: function() {
                var t, e, i, n = this.axis,
                    s = n.pane.axes,
                    o = s.length,
                    r = n.options.vertical,
                    a = n.lineBox().clone(),
                    h = r ? pt : dt;
                for (e = 0; e < o; e++) i = s[e], i.options.vertical !== r && (t ? t.wrap(i.lineBox()) : t = i.lineBox().clone());
                return a[h + 1] = t[h + 1], a[h + 2] = t[h + 2], a
            },
            createVisual: function() {
                bt.fn.createVisual.call(this);
                var t = this.options;
                this.line = new ee({
                    stroke: {
                        color: t.color,
                        width: t.width,
                        opacity: t.opacity,
                        dashType: t.dashType
                    },
                    visible: !1
                }), this.moveLine(), this.visual.append(this.line)
            },
            destroy: function() {
                this.tooltip && this.tooltip.destroy(), bt.fn.destroy.call(this)
            }
        }), kt(Bn, {
            color: ft,
            width: 2,
            zIndex: -1,
            tooltip: {
                visible: !1
            }
        }), zn = bt.extend({
            init: function(t, e) {
                bt.fn.init.call(this, t), this.pane = e
            },
            shouldClip: function() {
                var t, e = this.children,
                    i = e.length;
                for (t = 0; t < i; t++)
                    if (e[t].options.clip === !0) return !0;
                return !1
            },
            _clipBox: function() {
                return this.pane.chartsBox()
            },
            createVisual: function() {
                var t, e, i;
                this.visual = new se({
                    zIndex: 0
                }), this.shouldClip() && (t = this.clipBox = this._clipBox(), e = t.toRect(), i = ee.fromRect(e), Ct(i), this.visual.clip(i), this.unclipLabels())
            },
            stackRoot: function() {
                return this
            },
            unclipLabels: function() {
                var t, e, i, n, s, o, r, a = this,
                    h = a.children,
                    l = a.clipBox;
                for (t = 0; t < h.length; t++)
                    for (e = h[t].points || {}, i = e.length, n = 0; n < i; n++) s = e[n], s && s.visible !== !1 && s.overlapsBox && s.overlapsBox(l) && (s.unclipElements ? s.unclipElements() : (o = s.label, r = s.note, o && o.options.visible && (o.alignToClipBox && o.alignToClipBox(l), o.options.noclip = !0), r && r.options.visible && (r.options.noclip = !0)))
            },
            destroy: function() {
                bt.fn.destroy.call(this), delete this.parent
            }
        }), zn.prototype.isStackRoot = !0, Dn = Wt.extend({
            init: function(t) {
                Wt.fn.init.call(this, t), this.id = g(), this.createTitle(), this.content = new bt, this.chartContainer = new zn({}, this), this.append(this.content), this.axes = [], this.charts = []
            },
            createTitle: function() {
                var t = this.options.title;
                Rt(t) && (t = It({}, t, {
                    align: t.position,
                    position: at
                })), this.title = J.Title.buildTitle(t, this, Dn.prototype.options.title)
            },
            appendAxis: function(t) {
                this.content.append(t), this.axes.push(t), t.pane = this
            },
            appendAxisAt: function(t, e) {
                this.content.append(t), this.axes.splice(e, 0, t), t.pane = this
            },
            appendChart: function(t) {
                this.chartContainer.parent !== this.content && this.content.append(this.chartContainer), this.charts.push(t), this.chartContainer.append(t), t.pane = this
            },
            empty: function() {
                var t, e, i = this,
                    n = this.parent;
                if (n) {
                    for (t = 0; t < this.axes.length; t++) n.removeAxis(i.axes[t]);
                    for (e = 0; e < this.charts.length; e++) n.removeChart(i.charts[e])
                }
                this.axes = [], this.charts = [], this.content.destroy(), this.content.children = [], this.chartContainer.children = []
            },
            reflow: function(t) {
                var e;
                Vt(this.children) === this.content && (e = this.children.pop()), Wt.fn.reflow.call(this, t), e && this.children.push(e), this.title && (this.contentBox.y1 += this.title.box.height())
            },
            visualStyle: function() {
                var t = Wt.fn.visualStyle.call(this);
                return t.zIndex = -10, t
            },
            renderComplete: function() {
                this.options.visible && this.createGridLines()
            },
            stackRoot: function() {
                return this
            },
            clipRoot: function() {
                return this
            },
            createGridLines: function() {
                var t, e, i, n, s, o, r = this.axes,
                    a = r.concat(this.parent.axes),
                    h = [],
                    l = [];
                for (t = 0; t < r.length; t++)
                    for (e = r[t], i = e.options.vertical, n = i ? h : l, s = 0; s < a.length; s++) 0 === n.length && (o = a[s], i !== o.options.vertical && Ht(n, e.createGridLines(o)))
            },
            refresh: function() {
                this.visual.clear(), this.content.parent = null, this.content.createGradient = this.createGradient.bind(this), this.content.renderVisual(), this.content.parent = this, this.title && this.visual.append(this.title.visual), this.visual.append(this.content.visual), this.renderComplete(), this.notifyRender()
            },
            chartsBox: function() {
                var t, e, i, n, s, o, r, a, h, l = this.axes,
                    c = l.length,
                    u = new St;
                for (t = 0; t < c; t++) e = l[t], i = e.options.vertical ? dt : pt, n = e.lineBox(), u[i + 1] = n[i + 1], u[i + 2] = n[i + 2];
                if (0 === u.x2)
                    for (s = this.parent.axes, o = s.length, r = 0; r < o; r++) a = s[r], a.options.vertical || (h = a.lineBox(), u.x1 = h.x1, u.x2 = h.x2);
                return u
            },
            clipBox: function() {
                return this.chartContainer.clipBox
            },
            notifyRender: function() {
                var t = this.getService();
                t && t.notify(Hi, {
                    pane: new ce(this),
                    index: this.paneIndex,
                    name: this.options.name
                })
            }
        }), Hn = 1, Dn.prototype.isStackRoot = !0, kt(Dn, {
            zIndex: -1,
            shrinkToFit: !0,
            title: {
                align: lt
            },
            visible: !0
        }), Fn = /area/i, Nn = bt.extend({
            init: function(t, e, i) {
                bt.fn.init.call(this, e), this.initFields(t, e), this.series = t, this.initSeries(), this.charts = [], this.options.legend.items = [], this.axes = [], this.crosshairs = [], this.chartService = i, this.originalOptions = e, this.createPanes(), this.render(), this.createCrosshairs()
            },
            initFields: function() {},
            initSeries: function() {
                var t, e = this.series;
                for (t = 0; t < e.length; t++) e[t].index = t
            },
            createPanes: function() {
                function t(t, e) {
                    Ft(t.title) && (t.title = {
                        text: t.title
                    }), t.title = It({}, e.title, t.title)
                }
                var e, i, n, s = this,
                    o = {
                        title: {
                            color: (this.options.title || {}).color
                        }
                    },
                    r = [],
                    a = this.options.panes || [],
                    h = Math.max(a.length, 1);
                for (e = 0; e < h; e++) i = a[e] || {}, t(i, o), n = new Dn(i), n.paneIndex = e, r.push(n), s.append(n);
                this.panes = r
            },
            createCrosshairs: function(t) {
                var e, i, n, s, o, r = this;
                for (void 0 === t && (t = this.panes), e = 0; e < t.length; e++)
                    for (i = t[e], n = 0; n < i.axes.length; n++) s = i.axes[n], s.options.crosshair && s.options.crosshair.visible && (o = new Bn(r.chartService, s, s.options.crosshair), r.crosshairs.push(o), i.content.append(o))
            },
            removeCrosshairs: function(t) {
                var e, i, n = this.crosshairs,
                    s = t.axes;
                for (e = n.length - 1; e >= 0; e--)
                    for (i = 0; i < s.length; i++)
                        if (n[e].axis === s[i]) {
                            n.splice(e, 1);
                            break
                        }
            },
            hideCrosshairs: function() {
                var t, e = this.crosshairs;
                for (t = 0; t < e.length; t++) e[t].hide()
            },
            findPane: function(t) {
                var e, i, n = this.panes;
                for (i = 0; i < n.length; i++)
                    if (n[i].options.name === t) {
                        e = n[i];
                        break
                    }
                return e || n[0]
            },
            findPointPane: function(t) {
                var e, i, n = this.panes;
                for (i = 0; i < n.length; i++)
                    if (n[i].box.containsPoint(t)) {
                        e = n[i];
                        break
                    }
                return e
            },
            appendAxis: function(t) {
                var e = this.findPane(t.options.pane);
                e.appendAxis(t), this.axes.push(t), t.plotArea = this
            },
            removeAxis: function(t) {
                var e, i, n = this,
                    s = [];
                for (e = 0; e < this.axes.length; e++) i = n.axes[e], t !== i ? s.push(i) : i.destroy();
                this.axes = s
            },
            appendChart: function(t, e) {
                this.charts.push(t), e ? e.appendChart(t) : this.append(t)
            },
            removeChart: function(t) {
                var e, i, n = this,
                    s = [];
                for (e = 0; e < this.charts.length; e++) i = n.charts[e], i !== t ? s.push(i) : i.destroy();
                this.charts = s
            },
            addToLegend: function(t) {
                var e, i, n, s, o, r, a, h, l, c = t.length,
                    u = this.options.legend,
                    d = u.labels || {},
                    g = u.inactiveItems || {},
                    f = g.labels || {},
                    v = [];
                for (e = 0; e < c; e++) i = t[e], n = i.visible !== !1, i.visibleInLegend !== !1 && (s = i.name, o = n ? Mt(d) : Mt(f) || Mt(d), o && (s = o({
                    text: p(s) ? s : "",
                    series: i
                })), r = i._defaults, a = i.color, Tt(a) && r && (a = r.color), h = void 0, l = void 0, n ? (h = {}, l = a) : (h = {
                    color: f.color,
                    font: f.font
                }, l = g.markers.color), p(s) && "" !== s && v.push({
                    text: s,
                    labels: h,
                    markerColor: l,
                    series: i,
                    active: n
                }));
                Ht(u.items, v)
            },
            groupAxes: function(t) {
                var e, i, n, s, o = [],
                    r = [];
                for (e = 0; e < t.length; e++)
                    for (i = t[e].axes, n = 0; n < i.length; n++) s = i[n], s.options.vertical ? r.push(s) : o.push(s);
                return {
                    x: o,
                    y: r,
                    any: o.concat(r)
                }
            },
            groupSeriesByPane: function() {
                var t, e, i, n = this,
                    s = this.series,
                    o = {};
                for (t = 0; t < s.length; t++) e = s[t], i = n.seriesPaneName(e), o[i] ? o[i].push(e) : o[i] = [e];
                return o
            },
            filterVisibleSeries: function(t) {
                var e, i, n = [];
                for (e = 0; e < t.length; e++) i = t[e], i.visible !== !1 && n.push(i);
                return n
            },
            reflow: function(t) {
                var e = this.options.plotArea,
                    i = this.panes,
                    n = zt(e.margin);
                this.box = t.clone().unpad(n), this.reflowPanes(), this.detachLabels(), this.reflowAxes(i), this.reflowCharts(i)
            },
            redraw: function(t) {
                var e, i, n, s = this,
                    o = [].concat(t);
                for (this.initSeries(), e = this.getRoot(), e && e.cleanGradients(), i = 0; i < o.length; i++) s.removeCrosshairs(o[i]), o[i].empty();
                for (this.render(o), this.detachLabels(), this.reflowAxes(this.panes), this.reflowCharts(o), this.createCrosshairs(o), n = 0; n < o.length; n++) o[n].refresh()
            },
            axisCrossingValues: function(t, e) {
                var i, n = t.options,
                    s = [].concat(n.axisCrossingValues || n.axisCrossingValue),
                    o = e.length - s.length,
                    r = s[0] || 0;
                for (i = 0; i < o; i++) s.push(r);
                return s
            },
            alignAxisTo: function(t, e, i, n) {
                var s = t.getSlot(i, i, !0),
                    o = t.options.reverse ? 2 : 1,
                    r = e.getSlot(n, n, !0),
                    a = e.options.reverse ? 2 : 1,
                    h = t.box.translate(r[pt + a] - s[pt + o], r[dt + a] - s[dt + o]);
                t.pane !== e.pane && h.translate(0, t.pane.box.y1 - e.pane.box.y1), t.reflow(h)
            },
            alignAxes: function(t, e) {
                var i, n, s, o, r, a, h, l, c, u, p, d, g, f, v = this,
                    m = t[0],
                    x = e[0],
                    y = this.axisCrossingValues(m, e),
                    _ = this.axisCrossingValues(x, t),
                    w = {},
                    b = {},
                    A = {},
                    S = {};
                for (i = 0; i < e.length; i++) n = e[i], s = n.pane, o = s.id, r = n.options.visible !== !1, a = T(t, s) || m, h = y, a !== m && (h = v.axisCrossingValues(a, e)), v.alignAxisTo(n, a, _[i], h[i]), n.options._overlap || (Xt(n.lineBox().x1) === Xt(a.lineBox().x1) && (w[o] && n.reflow(n.box.alignTo(w[o].box, lt).translate(-n.options.margin, 0)), r && (w[o] = n)), Xt(n.lineBox().x2) === Xt(a.lineBox().x2) && (n._mirrored || (n.options.labels.mirror = !n.options.labels.mirror, n._mirrored = !0), v.alignAxisTo(n, a, _[i], h[i]), b[o] && n.reflow(n.box.alignTo(b[o].box, gt).translate(n.options.margin, 0)), r && (b[o] = n)), 0 !== i && x.pane === n.pane && (n.alignTo(x), n.reflow(n.box)));
                for (l = 0; l < t.length; l++) c = t[l], u = c.pane, p = u.id, d = c.options.visible !== !1, g = T(e, u) || x, f = _, g !== x && (f = v.axisCrossingValues(g, t)), v.alignAxisTo(c, g, y[l], f[l]), c.options._overlap || (Xt(c.lineBox().y1) === Xt(g.lineBox().y1) && (c._mirrored || (c.options.labels.mirror = !c.options.labels.mirror, c._mirrored = !0), v.alignAxisTo(c, g, y[l], f[l]), A[p] && c.reflow(c.box.alignTo(A[p].box, at).translate(0, -c.options.margin)), d && (A[p] = c)), Xt(c.lineBox().y2, it.COORD_PRECISION) === Xt(g.lineBox().y2, it.COORD_PRECISION) && (S[p] && c.reflow(c.box.alignTo(S[p].box, ht).translate(0, c.options.margin)), d && (S[p] = c)), 0 !== l && (c.alignTo(m), c.reflow(c.box)))
            },
            shrinkAxisWidth: function(t) {
                var e, i, n, s, o = this.groupAxes(t).any,
                    r = P(o),
                    a = 0;
                for (e = 0; e < t.length; e++) i = t[e], i.axes.length > 0 && (a = Math.max(a, r.width() - i.contentBox.width()));
                if (0 !== a)
                    for (n = 0; n < o.length; n++) s = o[n], s.options.vertical || s.reflow(s.box.shrink(a, 0))
            },
            shrinkAxisHeight: function(t) {
                var e, i, n, s, o, r, a;
                for (i = 0; i < t.length; i++)
                    if (n = t[i], s = n.axes, o = Math.max(0, P(s).height() - n.contentBox.height()), 0 !== o) {
                        for (r = 0; r < s.length; r++) a = s[r], a.options.vertical && a.reflow(a.box.shrink(0, o));
                        e = !0
                    }
                return e
            },
            fitAxes: function(t) {
                var e, i, n, s, o, r, a, h, l, c, u = this.groupAxes(t).any,
                    p = 0;
                for (e = 0; e < t.length; e++)
                    if (i = t[e], n = i.axes, s = i.contentBox, n.length > 0)
                        for (o = P(n), r = Math.max(s.y1 - o.y1, s.y2 - o.y2), p = Math.max(p, s.x1 - o.x1), a = 0; a < n.length; a++) h = n[a], h.reflow(h.box.translate(0, r));
                for (l = 0; l < u.length; l++) c = u[l], c.reflow(c.box.translate(p, 0))
            },
            reflowAxes: function(t) {
                var e, i = this,
                    n = this.groupAxes(t);
                for (e = 0; e < t.length; e++) i.reflowPaneAxes(t[e]);
                n.x.length > 0 && n.y.length > 0 && (this.alignAxes(n.x, n.y), this.shrinkAxisWidth(t), this.autoRotateAxisLabels(n), this.alignAxes(n.x, n.y), this.shrinkAxisWidth(t) && this.alignAxes(n.x, n.y), this.shrinkAxisHeight(t), this.alignAxes(n.x, n.y), this.shrinkAxisHeight(t) && this.alignAxes(n.x, n.y), this.fitAxes(t))
            },
            autoRotateAxisLabels: function(t) {
                var e, i, n, s, o = this,
                    r = this,
                    a = r.panes,
                    h = Gn(a);
                for (i = 0; i < h.length; i++) n = h[i], n.autoRotateLabels() && (e = !0);
                if (e) {
                    for (s = 0; s < a.length; s++) o.reflowPaneAxes(a[s]);
                    t.x.length > 0 && t.y.length > 0 && (this.alignAxes(t.x, t.y), this.shrinkAxisWidth(a))
                }
            },
            reflowPaneAxes: function(t) {
                var e, i = t.axes,
                    n = i.length;
                if (n > 0)
                    for (e = 0; e < n; e++) i[e].reflow(t.contentBox)
            },
            reflowCharts: function(t) {
                var e, i, n = this.charts,
                    s = n.length,
                    o = this.box;
                for (e = 0; e < s; e++) i = n[e].pane, i && !Pt(i, t) || n[e].reflow(o)
            },
            reflowPanes: function() {
                var t, e, i, n, s, o, r, a, h, l = this,
                    c = l.box,
                    u = l.panes,
                    p = u.length,
                    d = c.height(),
                    g = p,
                    f = 0,
                    v = c.y1;
                for (t = 0; t < p; t++) e = u[t], i = e.options.height, e.options.width = c.width(), e.options.height ? (i.indexOf && i.indexOf("%") && (n = parseInt(i, 10) / 100, e.options.height = n * c.height()), e.reflow(c.clone()), d -= e.options.height) : f++;
                for (s = 0; s < p; s++) o = u[s], o.options.height || (o.options.height = d / f);
                for (r = 0; r < p; r++) a = u[r], h = c.clone().move(c.x1, v), a.reflow(h), g--, v += a.options.height
            },
            backgroundBox: function() {
                var t, e, i, n, s, o, r = this.axes,
                    a = r.length;
                for (e = 0; e < a; e++)
                    for (i = r[e], n = 0; n < a; n++) s = r[n], i.options.vertical !== s.options.vertical && (o = i.lineBox().clone().wrap(s.lineBox()), t = t ? t.wrap(o) : o);
                return t || this.box
            },
            chartsBoxes: function() {
                var t, e = this.panes,
                    i = [];
                for (t = 0; t < e.length; t++) i.push(e[t].chartsBox());
                return i
            },
            addBackgroundPaths: function(t) {
                var e, i = this.chartsBoxes();
                for (e = 0; e < i.length; e++) t.paths.push(ee.fromRect(i[e].toRect()))
            },
            backgroundContainsPoint: function(t) {
                var e, i = this.chartsBoxes();
                for (e = 0; e < i.length; e++)
                    if (i[e].containsPoint(t)) return !0
            },
            createVisual: function() {
                var t, e, i, n, s;
                bt.fn.createVisual.call(this), t = this.options.plotArea, e = t.opacity, i = t.background, n = t.border, void 0 === n && (n = {}), E(i) && (i = ct, e = 0), s = this._bgVisual = new te.MultiPath({
                    fill: {
                        color: i,
                        opacity: e
                    },
                    stroke: {
                        color: n.width ? n.color : "",
                        width: n.width,
                        dashType: n.dashType
                    },
                    zIndex: -1
                }), this.addBackgroundPaths(s), this.appendVisual(s)
            },
            pointsByCategoryIndex: function(t) {
                var e, i, n, s, o, r = this.charts,
                    a = [];
                if (null !== t)
                    for (e = 0; e < r.length; e++)
                        if (i = r[e], "_navigator" !== i.pane.options.name && (n = r[e].categoryPoints[t], n && n.length))
                            for (s = 0; s < n.length; s++) o = n[s], o && yt(o.value) && null !== o.value && a.push(o);
                return a
            },
            pointsBySeriesIndex: function(t) {
                return this.filterPoints(function(e) {
                    return e.series.index === t
                })
            },
            pointsBySeriesName: function(t) {
                return this.filterPoints(function(e) {
                    return e.series.name === t
                })
            },
            filterPoints: function(t) {
                var e, i, n, s, o, r = this.charts,
                    a = [];
                for (e = 0; e < r.length; e++)
                    for (i = r[e], n = i.points, s = 0; s < n.length; s++) o = n[s], o && o.visible !== !1 && t(o) && a.push(o);
                return a
            },
            findPoint: function(t) {
                var e, i, n, s, o, r = this.charts;
                for (e = 0; e < r.length; e++)
                    for (i = r[e], n = i.points, s = 0; s < n.length; s++)
                        if (o = n[s], o && o.visible !== !1 && t(o)) return o
            },
            paneByPoint: function(t) {
                var e, i, n = this.panes;
                for (e = 0; e < n.length; e++)
                    if (i = n[e], i.box.containsPoint(t)) return i
            },
            detachLabels: function() {
                var t = this.groupAxes(this.panes),
                    e = t.x,
                    i = t.y;
                this.detachAxisGroupLabels(i, e), this.detachAxisGroupLabels(e, i)
            },
            detachAxisGroupLabels: function(t, e) {
                var i, n, s, o, r, a, h, l = this,
                    c = 0;
                for (i = 0; i < t.length; i++) n = t[i], s = n.pane, o = T(e, s) || e[0], r = i + c, a = l.createLabelAxis(n, r, o), a && (c++, h = s.axes.indexOf(n) + c, s.appendAxisAt(a, h))
            },
            createLabelAxis: function(t, e, i) {
                var n, s, o, r, a, h, l, c, u = t.options.labels,
                    p = u.position,
                    d = p !== it.END && p !== it.START,
                    g = u.visible;
                return d || g === !1 ? null : (n = this.groupAxes(this.panes), s = i.options.vertical ? n.x : n.y, o = this.axisCrossingValues(i, s), r = p === it.END, a = i.range(), h = r ? a.max : a.min, l = Zt(o[e], a.min, a.max), l - h === 0 ? null : (o.splice(e + 1, 0, h), i.options.axisCrossingValues = o, c = t.clone(), t.clear(), c.options.name = void 0, c.options.line.visible = !1, c.options.crosshair = void 0, c.options.notes = void 0, c.options.plotBands = void 0, c))
            }
        }), Gn = function(t) {
            return t.reduce(function(t, e) {
                return t.concat(e.axes)
            }, [])
        }, kt(Nn, {
            series: [],
            plotArea: {
                margin: {}
            },
            background: "",
            border: {
                color: ft,
                width: 0
            },
            legend: {
                inactiveItems: {
                    labels: {
                        color: "#919191"
                    },
                    markers: {
                        color: "#919191"
                    }
                }
            }
        }), qn = {
            hover: function(t, e) {
                this._dispatchEvent(t, e, Ci)
            },
            click: function(t, e) {
                this._dispatchEvent(t, e, Si)
            }
        }, Wn = tt.extend({
            init: function(t, e, i) {
                var n, s, o, r = e.canonicalFields(t),
                    a = e.valueFields(t),
                    h = e.sourceFields(t, r),
                    l = this._seriesFields = [],
                    c = i.query(t.type),
                    u = t.aggregate || c;
                for (this._series = t, this._binder = e, n = 0; n < r.length; n++) {
                    if (s = r[n], o = void 0, Rt(u)) o = u[s];
                    else {
                        if (0 !== n && !Pt(s, a)) break;
                        o = u
                    }
                    o && l.push({
                        canonicalName: s,
                        name: h[n],
                        transform: Tt(o) ? o : pe[o]
                    })
                }
            },
            aggregatePoints: function(t, e) {
                var i, n, s, o, r, a = this,
                    h = this,
                    l = h._series,
                    c = h._seriesFields,
                    u = this._bindPoints(t || []),
                    p = u.dataItems[0],
                    d = {};
                for (!p || et(p) || wt(p) || (i = function() {}, i.prototype = p, d = new i), n = 0; n < c.length; n++) {
                    if (s = c[n], o = a._bindField(u.values, s.canonicalName), r = s.transform(o, l, u.dataItems, e), !(null === r || !Rt(r) || yt(r.length) || r instanceof Date)) {
                        d = r;
                        break
                    }
                    yt(r) && R(s.name, d, r)
                }
                return d
            },
            _bindPoints: function(t) {
                var e, i, n = this,
                    s = n._binder,
                    o = n._series,
                    r = [],
                    a = [];
                for (e = 0; e < t.length; e++) i = t[e], r.push(s.bindPoint(o, i)), a.push(o.data[i]);
                return {
                    values: r,
                    dataItems: a
                }
            },
            _bindField: function(t, e) {
                var i, n, s, o, r = [],
                    a = t.length;
                for (i = 0; i < a; i++) n = t[i], s = n.valueFields, o = void 0, o = yt(s[e]) ? s[e] : n.fields[e], r.push(o);
                return r
            }
        }), Xn = tt.extend({
            init: function() {
                this._defaults = {}
            },
            register: function(t, e) {
                var i, n = this;
                for (i = 0; i < t.length; i++) n._defaults[t[i]] = e
            },
            query: function(t) {
                return this._defaults[t]
            }
        }), Xn.current = new Xn, Zn = xn.extend({
            createLabel: function() {
                var t = this.options.labels,
                    e = It({}, t, t.from),
                    i = It({}, t, t.to);
                e.visible && (this.labelFrom = this._createLabel(e), this.append(this.labelFrom)), i.visible && (this.labelTo = this._createLabel(i), this.append(this.labelTo))
            },
            _createLabel: function(t) {
                var e, i = Mt(t),
                    n = this.pointData();
                return e = i ? i(n) : this.formatValue(t.format), new vn(e, It({
                    vertical: this.options.vertical
                }, t), n)
            },
            reflow: function(t) {
                var e, i, n, s;
                this.render(), e = this, i = e.labelFrom, n = e.labelTo, s = e.value, this.box = t, i && (i.options.aboveAxis = s.from > s.to, i.reflow(t)), n && (n.options.aboveAxis = s.to > s.from, n.reflow(t)), this.note && this.note.reflow(t)
            }
        }), Zn.prototype.defaults = It({}, Zn.prototype.defaults, {
            labels: {
                format: "{0} - {1}"
            },
            tooltip: {
                format: "{1}"
            }
        }), Un = wn.extend({
            pointType: function() {
                return Zn
            },
            pointValue: function(t) {
                return t.valueFields
            },
            formatPointValue: function(t, e) {
                return null === t.value.from && null === t.value.to ? "" : this.chartService.format.auto(e, t.value.from, t.value.to)
            },
            plotRange: function(t) {
                return t ? [t.value.from, t.value.to] : 0
            },
            updateRange: function(t, e) {
                var i = e.series.axis,
                    n = t.from,
                    s = t.to,
                    o = this.valueAxisRanges[i];
                null !== t && et(n) && et(s) && (o = this.valueAxisRanges[i] = o || {
                    min: nt,
                    max: st
                }, o.min = Math.min(o.min, n), o.max = Math.max(o.max, n), o.min = Math.min(o.min, s), o.max = Math.max(o.max, s))
            },
            aboveAxis: function(t) {
                var e = t.value;
                return e.from < e.to
            }
        }), Un.prototype.plotLimits = $i.prototype.plotLimits, Yn = en.extend({
            aliasFor: function() {
                return this.parent
            }
        }), jn = "auto", Kn = "{0}", Qn = "{1}", $n = bt.extend({
            init: function(t, e) {
                bt.fn.init.call(this), this.value = t, this.options = e, this.aboveAxis = Et(this.options.aboveAxis, !0), this.tooltipTracking = !0, this.initLabelsFormat()
            },
            render: function() {
                var t, e, i, n, s, o;
                this._rendered || (this._rendered = !0, t = this.options, e = t.markers, i = t.labels, n = this.value, s = this.fromPoint = new Yn(n, It({}, this.options, {
                    labels: i.from,
                    markers: e.from
                })), o = this.toPoint = new Yn(n, It({}, this.options, {
                    labels: i.to,
                    markers: e.to
                })), this.copyFields(s), this.copyFields(o), this.append(s), this.append(o))
            },
            reflow: function(t) {
                var e, i;
                this.render(), e = t.from, i = t.to, this.positionLabels(e, i), this.fromPoint.reflow(e), this.toPoint.reflow(i), this.box = this.fromPoint.markerBox().clone().wrap(this.toPoint.markerBox())
            },
            createHighlight: function() {
                var t = new se;
                return t.append(this.fromPoint.createHighlight()), t.append(this.toPoint.createHighlight()), t
            },
            highlightVisual: function() {
                return this.visual
            },
            highlightVisualArgs: function() {
                return {
                    options: this.options,
                    from: this.fromPoint.highlightVisualArgs(),
                    to: this.toPoint.highlightVisualArgs()
                }
            },
            tooltipAnchor: function() {
                var t, e, i, n, s, o, r = this.owner.pane.clipBox(),
                    a = !r || r.overlaps(this.box);
                if (a) return t = this.box, e = t.center(), i = lt, this.options.vertical ? (n = e.x, s = t.y1 - Se, o = ht) : (n = t.x2 + Se, s = e.y, o = rt), {
                    point: new At(n, s),
                    align: {
                        horizontal: i,
                        vertical: o
                    }
                }
            },
            formatValue: function(t) {
                return this.owner.formatPointValue(this, t)
            },
            overlapsBox: function(t) {
                return this.box.overlaps(t)
            },
            unclipElements: function() {
                this.fromPoint.unclipElements(), this.toPoint.unclipElements()
            },
            initLabelsFormat: function() {
                var e = this.options.labels;
                e.format || (e.from && e.from.format || (e.from = t.extend({}, e.from, {
                    format: Kn
                })), e.to && e.to.format || (e.to = t.extend({}, e.to, {
                    format: Qn
                })))
            },
            positionLabels: function(t, e) {
                var i, n, s = this.options,
                    o = s.labels,
                    r = s.vertical;
                o.position === jn && (r ? e.y1 <= t.y1 ? (n = Be, i = ze) : (n = ze, i = Be) : e.x1 <= t.x1 ? (n = lt, i = gt) : (n = gt, i = lt), o.from && o.from.position || (this.fromPoint.options.labels.position = i), o.to && o.to.position || (this.toPoint.options.labels.position = n))
            },
            copyFields: function(t) {
                t.dataItem = this.dataItem, t.category = this.category, t.series = this.series, t.color = this.color, t.owner = this.owner
            }
        }), It($n.prototype, Ji), It($n.prototype, tn), $n.prototype.defaults = {
            markers: {
                visible: !1,
                background: ct,
                size: Ve,
                type: ut,
                border: {
                    width: 2
                },
                opacity: 1
            },
            labels: {
                visible: !1,
                margin: zt(3),
                padding: zt(4),
                animation: {
                    type: we,
                    delay: _e
                },
                position: jn
            },
            notes: {
                label: {}
            },
            highlight: {
                markers: {
                    border: {
                        color: ct,
                        width: 2
                    }
                },
                zIndex: it.HIGHLIGHT_ZINDEX
            },
            tooltip: {
                format: "{0} - {1}"
            }
        }, Jn = un.extend({
            createStrokeSegments: function() {
                return this.segmentsFromPoints(this.toGeometryPoints(this.toPoints()))
            },
            stackSegments: function() {
                var t = this.fromSegments;
                return this.fromSegments || (t = this.fromSegments = this.segmentsFromPoints(this.toGeometryPoints(this.fromPoints().reverse()))), t
            },
            createStroke: function(t) {
                var e = new ee(t),
                    i = new ee(t);
                e.segments.push.apply(e.segments, this.strokeSegments()), i.segments.push.apply(i.segments, this.stackSegments()), this.visual.append(e), this.visual.append(i)
            },
            hasStackSegment: function() {
                return !0
            },
            fromPoints: function() {
                return this.linePoints.map(function(t) {
                    return t.fromPoint
                })
            },
            toPoints: function() {
                return this.linePoints.map(function(t) {
                    return t.toPoint
                })
            }
        }), ts = Jn.extend({
            createStrokeSegments: function() {
                return this.createCurveSegments(this.toPoints())
            },
            stackSegments: function() {
                var t = this.fromSegments;
                return this.fromSegments || (t = this.fromSegments = this.createCurveSegments(this.fromPoints().reverse())), t
            },
            createCurveSegments: function(t) {
                var e = new Dt;
                return e.process(this.toGeometryPoints(t))
            }
        }), es = Jn.extend({
            createStrokeSegments: function() {
                return this.segmentsFromPoints(this.calculateStepPoints(this.toPoints()))
            },
            stackSegments: function() {
                var t = this.fromSegments;
                return this.fromSegments || (t = this.fromSegments = this.segmentsFromPoints(this.calculateStepPoints(this.fromPoints())), t.reverse()), t
            }
        }), It(es.prototype, sn), is = $i.extend({
            render: function() {
                $i.fn.render.call(this), this.renderSegments()
            },
            pointType: function() {
                return $n
            },
            createPoint: function(t, e) {
                var i, n, s, o = e.categoryIx,
                    r = e.category,
                    a = e.series,
                    h = e.seriesIx,
                    l = t.valueFields;
                if (!p(l.from) && !p(l.to)) {
                    if (this.seriesMissingValues(a) !== Le) return null;
                    l = {
                        from: 0,
                        to: 0
                    }
                }
                return i = this.pointOptions(a, h), i = this.evalPointOptions(i, l, r, o, a, h), n = t.fields.color || a.color, Tt(a.color) && (n = i.color), s = new $n(l, i), s.color = n, this.append(s), s
            },
            createSegment: function(t, e, i) {
                var n, s = (e.line || {}).style;
                return new(n = "smooth" === s ? ts : "step" === s ? es : Jn)(t, e, i)
            },
            plotRange: function(t, e) {
                return t ? [t.value.from, t.value.to] : [e, e]
            },
            valueSlot: function(t, e) {
                var i = t.getSlot(e[0], e[0], !this.options.clip),
                    n = t.getSlot(e[1], e[1], !this.options.clip);
                if (i && n) return {
                    from: i,
                    to: n
                }
            },
            pointSlot: function(t, e) {
                var i, n, s = e.from,
                    o = e.to;
                return this.options.invertAxes ? (i = new St(s.x1, t.y1, s.x2, t.y2), n = new St(o.x1, t.y1, o.x2, t.y2)) : (i = new St(t.x1, s.y1, t.x2, s.y2), n = new St(t.x1, o.y1, t.x2, o.y2)), {
                    from: i,
                    to: n
                }
            },
            addValue: function(t, e) {
                var i = t.valueFields;
                et(i.from) || (i.from = i.to), et(i.to) || (i.to = i.from), $i.fn.addValue.call(this, t, e)
            },
            updateRange: function(t, e) {
                var i, n, s, o;
                null !== t && et(t.from) && et(t.to) && (i = e.series.axis, n = this.valueAxisRanges[i] = this.valueAxisRanges[i] || {
                    min: nt,
                    max: st
                }, s = t.from, o = t.to, n.min = Math.min(n.min, s, o), n.max = Math.max(n.max, s, o))
            },
            formatPointValue: function(t, e) {
                var i = t.value;
                return this.chartService.format.auto(e, i.from, i.to)
            },
            animationPoints: function() {
                var t, e, i = this.points,
                    n = [];
                for (t = 0; t < i.length; t++) e = i[t], e && (n.push((e.fromPoint || {}).marker), n.push((e.toPoint || {}).marker));
                return n.concat(this._segments)
            }
        }), It(is.prototype, an, ln), ns = bn.extend({
            reflow: function(t) {
                var e, i = this,
                    n = i.options,
                    s = i.value,
                    o = i.owner,
                    r = o.seriesValueAxis(n),
                    a = [],
                    h = [],
                    l = [],
                    c = r.getSlot(s.low, s.high),
                    u = r.getSlot(s.open, s.open),
                    p = r.getSlot(s.close, s.close);
                u.x1 = p.x1 = c.x1 = t.x1, u.x2 = p.x2 = c.x2 = t.x2, e = c.center().x, a.push([u.x1, u.y1]), a.push([e, u.y1]), h.push([e, p.y1]), h.push([p.x2, p.y1]), l.push([e, c.y1]), l.push([e, c.y2]), this.lines = [a, h, l], this.box = c.clone().wrap(u.clone().wrap(p)), this.reflowNote()
            },
            createBody: function() {}
        }), ss = An.extend({
            pointType: function() {
                return ns
            }
        }), os = bt.extend({
            init: function(t, e, i) {
                bt.fn.init.call(this), this.from = t, this.to = e, this.series = i
            },
            linePoints: function() {
                var t, e, i = this.from,
                    n = this,
                    s = n.from.box,
                    o = n.to.box,
                    r = [];
                return i.isVertical ? (t = i.aboveAxis ? s.y1 : s.y2, r.push([s.x1, t], [o.x2, t])) : (e = i.aboveAxis ? s.x2 : s.x1, r.push([e, s.y1], [e, o.y2])), r
            },
            createVisual: function() {
                var t, e;
                bt.fn.createVisual.call(this), t = this.series.line || {}, e = ee.fromPoints(this.linePoints(), {
                    stroke: {
                        color: t.color,
                        width: t.width,
                        opacity: t.opacity,
                        dashType: t.dashType
                    }
                }), Ct(e), this.visual.append(e)
            }
        }), kt(os, {
            animation: {
                type: we,
                delay: _e
            }
        }), rs = wn.extend({
            render: function() {
                wn.fn.render.call(this), this.createSegments()
            },
            traverseDataPoints: function(t) {
                var e, i, n, s, r, a, h, l, c, u, p = this,
                    d = this.options.series,
                    g = o(d),
                    f = !this.options.invertAxes;
                for (e = 0; e < d.length; e++)
                    for (i = d[e], n = 0, s = 0, r = 0; r < g; r++) a = de.current.bindPoint(i, r), h = a.valueFields.value, l = a.fields.summary, c = n, u = void 0, l ? "total" === l.toLowerCase() ? (a.valueFields.value = n, c = 0, u = n) : (a.valueFields.value = s, u = c - s, s = 0) : et(h) && (s += h, n += h, u = n), t(a, {
                        category: p.categoryAxis.categoryAt(r),
                        categoryIx: r,
                        series: i,
                        seriesIx: e,
                        total: n,
                        runningTotal: s,
                        from: c,
                        to: u,
                        isVertical: f
                    })
            },
            updateRange: function(t, e) {
                wn.fn.updateRange.call(this, {
                    value: e.to
                }, e)
            },
            aboveAxis: function(t) {
                return t.value >= 0
            },
            plotRange: function(t) {
                return [t.from, t.to]
            },
            createSegments: function() {
                var t, e, i, n, s, o, r, a = this,
                    h = this.options.series,
                    l = this.seriesPoints,
                    c = this.segments = [];
                for (t = 0; t < h.length; t++)
                    if (e = h[t], i = l[t])
                        for (n = void 0, s = 0; s < i.length; s++) o = i[s], o && n && (r = new os(n, o, e), c.push(r), a.append(r)), n = o
            }
        }), as = [Fe, ci, oi, gi], hs = [Ke, di].concat(as), ls = Nn.extend({
            initFields: function(t) {
                var e, i, n = this;
                if (this.namedCategoryAxes = {}, this.namedValueAxes = {}, this.valueAxisRangeTracker = new fn, t.length > 0)
                    for (this.invertAxes = Pt(t[0].type, [Ne, We, di, ci, gi, ri, je, ui]), e = 0; e < t.length; e++)
                        if (i = t[e].stack, i && "100%" === i.type) {
                            n.stack100 = !0;
                            break
                        }
            },
            render: function(t) {
                void 0 === t && (t = this.panes), this.createCategoryAxes(t), this.aggregateCategories(t), this.createCategoryAxesLabels(t), this.createCharts(t), this.createValueAxes(t)
            },
            removeAxis: function(t) {
                var e = t.options.name;
                Nn.fn.removeAxis.call(this, t), t instanceof qt ? delete this.namedCategoryAxes[e] : (this.valueAxisRangeTracker.reset(e), delete this.namedValueAxes[e]), t === this.categoryAxis && delete this.categoryAxis, t === this.valueAxis && delete this.valueAxis
            },
            createCharts: function(t) {
                var e, i, n, s, o, r, a = this,
                    h = this.groupSeriesByPane();
                for (e = 0; e < t.length; e++)
                    if (i = t[e], n = h[i.options.name || "default"] || [], a.addToLegend(n), s = a.filterVisibleSeries(n))
                        for (o = a.groupSeriesByCategoryAxis(s), r = 0; r < o.length; r++) a.createChartGroup(o[r], i)
            },
            createChartGroup: function(t, e) {
                this.createAreaChart(y(t, [Fe, ci]), e), this.createRangeAreaChart(y(t, [oi, gi]), e), this.createBarChart(y(t, [Ze, Ne]), e), this.createRangeBarChart(y(t, [ai, ri]), e), this.createBulletChart(y(t, [We, pi]), e), this.createCandlestickChart(y(t, Xe), e), this.createBoxPlotChart(y(t, [Ge, ui]), e), this.createOHLCChart(y(t, Qe), e), this.createWaterfallChart(y(t, [fi, je]), e), this.createLineChart(y(t, [Ke, di]), e)
            },
            aggregateCategories: function(t) {
                var e, i, n, s, o, r = this,
                    a = this.srcSeries || this.series,
                    h = [];
                for (this._currentPointsCache = {}, this._seriesPointsCache = this._seriesPointsCache || {}, e = 0; e < a.length; e++) i = a[e], n = r.seriesCategoryAxis(i), s = r.findPane(n.options.pane), o = x(n.options.type, vt), i = (o || i.categoryField) && Pt(s, t) ? r.aggregateSeries(i, n) : r.filterSeries(i, n), h.push(i);
                this._seriesPointsCache = this._currentPointsCache, this._currentPointsCache = null, this.srcSeries = a, this.series = h
            },
            filterSeries: function(t, e) {
                var i, n, s, o = (t.data || {}).length;
                return e._seriesMax = Math.max(e._seriesMax || 0, o), et(e.options.min) || et(e.options.max) ? (i = e.currentRangeIndices(), n = Pt(t.type, hs), s = It({}, t), s.data = (s.data || []).slice(i.min, i.max + 1), n && k(s, i, o, function(n) {
                    return {
                        item: t.data[n],
                        category: e.categoryAt(n, !0),
                        categoryIx: n - i.min
                    }
                }, function(e) {
                    return yt(t.data[e])
                }), s) : t
            },
            clearSeriesPointsCache: function() {
                this._seriesPointsCache = {}
            },
            seriesSourcePoints: function(t, e) {
                var i, s, o, r, a, h, l, c, u, p = this,
                    d = t.index + ";" + e.categoriesHash();
                if (this._seriesPointsCache[d]) return this._currentPointsCache[d] = this._seriesPointsCache[d], this._seriesPointsCache[d];
                for (i = e.options, s = i.srcCategories, o = x(i.type, vt), r = t.data, a = o ? _ : n, h = [], o || e.mapCategories(), l = 0; l < r.length; l++) c = void 0, c = t.categoryField ? a(t.categoryField, r[l], p.chartService.intl) : s[l], yt(c) && null !== c && (u = e.totalIndex(c), h[u] = h[u] || {
                    items: [],
                    category: c
                }, h[u].items.push(l));
                return this._currentPointsCache[d] = h, h
            },
            aggregateSeries: function(t, e) {
                var i, n, s, o, r, a, h, l, c, u = t.data;
                if (!u.length) return t;
                for (i = this.seriesSourcePoints(t, e), n = It({}, t), s = new Wn(It({}, t), de.current, Xn.current), o = n.data = [], r = e.options.dataItems || [], a = e.currentRangeIndices(), h = function(t) {
                        var n, o = t - a.min,
                            r = i[t];
                        return r || (r = i[t] = {}), r.categoryIx = o, r.item || (n = e.categoryAt(t, !0), r.category = n, r.item = s.aggregatePoints(r.items, n)), r
                    }, l = a.min; l <= a.max; l++) c = h(l), o[c.categoryIx] = c.item, c.items && c.items.length && (r[c.categoryIx] = c.item);
                return Pt(n.type, hs) && k(n, a, e.totalCount(), h, function(t) {
                    return i[t]
                }), e.options.dataItems = r, n
            },
            appendChart: function(t, e) {
                var i = t.options.series,
                    n = this.seriesCategoryAxis(i[0]),
                    s = n.options.categories,
                    r = Math.max(0, o(i) - s.length);
                if (r > 0)
                    for (s = n.options.categories = n.options.categories.slice(0); r--;) s.push("");
                this.valueAxisRangeTracker.update(t.valueAxisRanges), Nn.fn.appendChart.call(this, t, e)
            },
            seriesPaneName: function(t) {
                var e = this.options,
                    i = t.axis,
                    n = [].concat(e.valueAxis),
                    s = Ut(n, function(t) {
                        return t.name === i
                    })[0],
                    o = e.panes || [{}],
                    r = (o[0] || {}).name || "default",
                    a = (s || {}).pane || r;
                return a
            },
            seriesCategoryAxis: function(t) {
                var e = t.categoryAxis,
                    i = e ? this.namedCategoryAxes[e] : this.categoryAxis;
                if (!i) throw Error("Unable to locate category axis with name " + e);
                return i
            },
            stackableChartOptions: function(t, e) {
                var i = t.stack,
                    n = i && "100%" === i.type,
                    s = e.options.clip;
                return {
                    isStacked: i,
                    isStacked100: n,
                    clip: s
                }
            },
            groupSeriesByCategoryAxis: function(t) {
                var e, i, n, s, o, r, a = [],
                    h = {};
                for (e = 0; e < t.length; e++) i = t[e].categoryAxis || "$$default$$", h.hasOwnProperty(i) || (h[i] = !0, a.push(i));
                for (n = [], s = 0; s < a.length; s++) o = a[s], r = V(t, o, s), 0 !== r.length && n.push(r);
                return n
            },
            createBarChart: function(e, i) {
                var n, s;
                0 !== e.length && (n = e[0], s = new wn(this, t.extend({
                    series: e,
                    invertAxes: this.invertAxes,
                    gap: n.gap,
                    spacing: n.spacing
                }, this.stackableChartOptions(n, i))), this.appendChart(s, i))
            },
            createRangeBarChart: function(t, e) {
                var i, n;
                0 !== t.length && (i = t[0], n = new Un(this, {
                    series: t,
                    invertAxes: this.invertAxes,
                    gap: i.gap,
                    spacing: i.spacing
                }), this.appendChart(n, e))
            },
            createBulletChart: function(t, e) {
                var i, n;
                0 !== t.length && (i = t[0], n = new Ln(this, {
                    series: t,
                    invertAxes: this.invertAxes,
                    gap: i.gap,
                    spacing: i.spacing,
                    clip: e.options.clip
                }), this.appendChart(n, e))
            },
            createLineChart: function(e, i) {
                var n, s;
                0 !== e.length && (n = e[0], s = new cn(this, t.extend({
                    invertAxes: this.invertAxes,
                    series: e
                }, this.stackableChartOptions(n, i))), this.appendChart(s, i))
            },
            createAreaChart: function(e, i) {
                var n, s;
                0 !== e.length && (n = e[0], s = new gn(this, t.extend({
                    invertAxes: this.invertAxes,
                    series: e
                }, this.stackableChartOptions(n, i))), this.appendChart(s, i))
            },
            createRangeAreaChart: function(t, e) {
                if (0 !== t.length) {
                    var i = new is(this, {
                        invertAxes: this.invertAxes,
                        series: t,
                        clip: e.options.clip
                    });
                    this.appendChart(i, e)
                }
            },
            createOHLCChart: function(t, e) {
                var i, n;
                0 !== t.length && (i = t[0], n = new ss(this, {
                    invertAxes: this.invertAxes,
                    gap: i.gap,
                    series: t,
                    spacing: i.spacing,
                    clip: e.options.clip
                }), this.appendChart(n, e))
            },
            createCandlestickChart: function(t, e) {
                var i, n;
                0 !== t.length && (i = t[0], n = new An(this, {
                    invertAxes: this.invertAxes,
                    gap: i.gap,
                    series: t,
                    spacing: i.spacing,
                    clip: e.options.clip
                }), this.appendChart(n, e))
            },
            createBoxPlotChart: function(t, e) {
                var i, n;
                0 !== t.length && (i = t[0], n = new kn(this, {
                    invertAxes: this.invertAxes,
                    gap: i.gap,
                    series: t,
                    spacing: i.spacing,
                    clip: e.options.clip
                }), this.appendChart(n, e))
            },
            createWaterfallChart: function(t, e) {
                var i, n;
                0 !== t.length && (i = t[0], n = new rs(this, {
                    series: t,
                    invertAxes: this.invertAxes,
                    gap: i.gap,
                    spacing: i.spacing
                }), this.appendChart(n, e))
            },
            axisRequiresRounding: function(t, e) {
                var i, n, s, o, r, a = this,
                    h = y(this.series, vi);
                for (i = 0; i < this.series.length; i++) n = a.series[i], Pt(n.type, as) && (s = n.line, s && s.style === He && h.push(n));
                for (o = 0; o < h.length; o++)
                    if (r = h[o].categoryAxis || "", r === t || !r && 0 === e) return !0
            },
            aggregatedAxis: function(t, e) {
                var i, n, s = this.series;
                for (i = 0; i < s.length; i++)
                    if (n = s[i].categoryAxis || "", (n === t || !n && 0 === e) && s[i].categoryField) return !0
            },
            createCategoryAxesLabels: function() {
                var t, e = this.axes;
                for (t = 0; t < e.length; t++) e[t] instanceof qt && e[t].createLabels()
            },
            createCategoryAxes: function(t) {
                var e, i, n, s, o, r, a, h = this,
                    l = this.invertAxes,
                    c = [].concat(this.options.categoryAxis),
                    u = [];
                for (e = 0; e < c.length; e++)
                    if (i = c[e], n = h.findPane(i.pane), Pt(n, t)) {
                        if (s = i.name, o = i.categories, void 0 === o && (o = []), i = It({
                                vertical: l,
                                reverse: !l && h.chartService.rtl,
                                axisCrossingValue: l ? nt : 0
                            }, i), yt(i.justified) || (i.justified = h.isJustified()), h.axisRequiresRounding(s, e) && (i.justified = !1), r = void 0, r = w(i, o[0]) ? new J.DateCategoryAxis(i, h.chartService) : new qt(i, h.chartService), c[e].categories = r.options.srcCategories, s) {
                            if (h.namedCategoryAxes[s]) throw Error("Category axis with name " + s + " is already defined");
                            h.namedCategoryAxes[s] = r
                        }
                        r.axisIndex = e, u.push(r), h.appendAxis(r)
                    }
                a = this.categoryAxis || u[0], this.categoryAxis = a, l ? this.axisY = a : this.axisX = a
            },
            isJustified: function() {
                var t, e, i = this.series;
                for (t = 0; t < i.length; t++)
                    if (e = i[t], !Pt(e.type, as)) return !1;
                return !0
            },
            createValueAxes: function(t) {
                var e, i, n, s, o, r, a, h, l, c = this,
                    u = this.valueAxisRangeTracker,
                    p = u.query(),
                    d = [].concat(this.options.valueAxis),
                    g = this.invertAxes,
                    f = {
                        vertical: !g,
                        reverse: g && this.chartService.rtl
                    },
                    v = [];
                for (this.stack100 && (f.roundToMajorUnit = !1, f.labels = {
                        format: "P0"
                    }), e = 0; e < d.length; e++)
                    if (i = d[e], n = c.findPane(i.pane), Pt(n, t)) {
                        if (s = i.name, o = x(i.type, Fi) ? {
                                min: .1,
                                max: 1
                            } : {
                                min: 0,
                                max: 1
                            }, r = u.query(s) || p || o, 0 === e && r && p && (r.min = Math.min(r.min, p.min), r.max = Math.max(r.max, p.max)), a = void 0, a = x(i.type, Fi) ? J.LogarithmicAxis : J.NumericAxis, h = new a(r.min, r.max, It({}, f, i), c.chartService), s) {
                            if (c.namedValueAxes[s]) throw Error("Value axis with name " + s + " is already defined");
                            c.namedValueAxes[s] = h
                        }
                        h.axisIndex = e, v.push(h), c.appendAxis(h)
                    }
                l = this.valueAxis || v[0], this.valueAxis = l, g ? this.axisX = l : this.axisY = l
            },
            _dispatchEvent: function(t, e, i) {
                var n, s, o, r = t._eventCoordinates(e),
                    a = new At(r.x, r.y),
                    h = this.pointPane(a),
                    l = [],
                    c = [];
                if (h) {
                    for (n = h.axes, s = 0; s < n.length; s++) o = n[s], o.getValue ? f(c, o.getValue(a)) : f(l, o.getCategory(a));
                    0 === l.length && f(l, this.categoryAxis.getCategory(a)), l.length > 0 && c.length > 0 && t.trigger(i, {
                        element: Lt(e),
                        originalEvent: e,
                        category: b(l),
                        value: b(c)
                    })
                }
            },
            pointPane: function(t) {
                var e, i, n = this.panes;
                for (e = 0; e < n.length; e++)
                    if (i = n[e], i.contentBox.containsPoint(t)) return i
            },
            updateAxisOptions: function(t, e) {
                I(this.options, t, e), I(this.originalOptions, t, e)
            }
        }), kt(ls, {
            categoryAxis: {},
            valueAxis: {}
        }), It(ls.prototype, qn), cs = tt.extend({
            init: function() {
                this._points = []
            },
            destroy: function() {
                this._points = []
            },
            show: function(t) {
                var e, i, n = this,
                    s = [].concat(t);
                for (this.hide(), e = 0; e < s.length; e++) i = s[e], i && i.toggleHighlight && i.hasHighlight() && (n.togglePointHighlight(i, !0), n._points.push(i))
            },
            togglePointHighlight: function(t, e) {
                var i, n = (t.options.highlight || {}).toggle;
                n ? (i = {
                    category: t.category,
                    series: t.series,
                    dataItem: t.dataItem,
                    value: t.value,
                    stackValue: t.stackValue,
                    preventDefault: L,
                    visual: t.highlightVisual(),
                    show: e
                }, n(i), i._defaultPrevented || t.toggleHighlight(e)) : t.toggleHighlight(e)
            },
            hide: function() {
                for (var t = this, e = this._points; e.length;) t.togglePointHighlight(e.pop(), !1)
            },
            isHighlighted: function(t) {
                var e, i, n = this._points;
                for (e = 0; e < n.length; e++)
                    if (i = n[e], t === i) return !0;
                return !1
            }
        }), us = tt.extend({
            init: function(t, e) {
                this.plotArea = t, this.options = It({}, this.options, e)
            },
            start: function(t) {
                return this._active = M(t, this.options.key)
            },
            move: function(t) {
                if (this._active) {
                    var e = this.axisRanges = this._panAxes(t, pt).concat(this._panAxes(t, dt));
                    if (e.length) return this.axisRanges = e, O(e)
                }
            },
            end: function() {
                var t = this._active;
                return this._active = !1, t
            },
            pan: function() {
                var t, e, i = this,
                    n = i.plotArea,
                    s = i.axisRanges;
                if (s.length) {
                    for (t = 0; t < s.length; t++) e = s[t], n.updateAxisOptions(e.axis, e.range);
                    n.redraw(n.panes)
                }
            },
            destroy: function() {
                delete this.plotArea
            },
            _panAxes: function(t, e) {
                var i, n, s, o, r = this.plotArea,
                    a = -t[e].delta,
                    h = (this.options.lock || "").toLowerCase(),
                    l = [];
                if (0 !== a && (h || "").toLowerCase() !== e)
                    for (i = r.axes, n = 0; n < i.length; n++) s = i[n], (e === pt && !s.options.vertical || e === dt && s.options.vertical) && (o = s.pan(a), o && (o.limitRange = !0, l.push({
                        axis: s,
                        range: o
                    })));
                return l
            }
        }), us.prototype.options = {
            key: "none",
            lock: "none"
        }, ps = tt.extend({
            init: function(t, e) {
                this.chart = t, this.options = It({}, this.options, e), this.createElement()
            },
            createElement: function() {
                var t, e = this._marquee = document.createElement("div");
                e.className = "k-marquee", t = document.createElement("div"), t.className = "k-marquee-color", e.appendChild(t)
            },
            removeElement: function() {
                this._marquee.parentNode && this._marquee.parentNode.removeChild(this._marquee)
            },
            setStyles: function(t) {
                Yt(this._marquee, t)
            },
            start: function(t) {
                var e, i, n, s, o;
                return !!(M(t, this.options.key) && (e = this.chart, i = e._eventCoordinates(t), n = this._zoomPane = e._plotArea.paneByPoint(i), s = n ? n.chartsBox().clone() : null, n && s)) && (o = this._elementOffset(), s.translate(o.left, o.top), this._zoomPaneClipBox = s, document.body.appendChild(this._marquee), this.setStyles({
                    left: t.pageX + 1,
                    top: t.pageY + 1,
                    width: 0,
                    height: 0
                }), !0)
            },
            _elementOffset: function() {
                var t = this.chart.element,
                    e = Yt(t, ["paddingLeft", "paddingTop"]),
                    i = e.paddingLeft,
                    n = e.paddingTop,
                    s = J.elementOffset(t);
                return {
                    left: i + s.left,
                    top: n + s.top
                }
            },
            move: function(t) {
                var e = this._zoomPane;
                e && this.setStyles(this._selectionPosition(t))
            },
            end: function(t) {
                var e, i, n, s, o = this._zoomPane;
                if (o) return e = this._elementOffset(), i = this._selectionPosition(t), i.left -= e.left, i.top -= e.top, n = {
                    x: i.left,
                    y: i.top
                }, s = {
                    x: i.left + i.width,
                    y: i.top + i.height
                }, this._updateAxisRanges(n, s), this.removeElement(), delete this._zoomPane, O(this.axisRanges)
            },
            zoom: function() {
                var t, e, i, n = this.axisRanges;
                if (n && n.length) {
                    for (t = this.chart._plotArea, e = 0; e < n.length; e++) i = n[e], t.updateAxisOptions(i.axis, i.range);
                    t.redraw(t.panes)
                }
            },
            destroy: function() {
                this.removeElement(), delete this._marquee, delete this.chart
            },
            _updateAxisRanges: function(t, e) {
                var i, n, s, o, r = (this.options.lock || "").toLowerCase(),
                    a = [],
                    h = this._zoomPane.axes;
                for (i = 0; i < h.length; i++) n = h[i], s = n.options.vertical, r === pt && !s || r === dt && s || (o = n.pointsRange(t, e), o && a.push({
                    axis: n,
                    range: o
                }));
                this.axisRanges = a
            },
            _selectionPosition: function(t) {
                var e = this._zoomPaneClipBox,
                    i = {
                        x: t.x.startLocation,
                        y: t.y.startLocation
                    },
                    n = t.x.location,
                    s = t.y.location,
                    o = (this.options.lock || "").toLowerCase(),
                    r = Math.min(i.x, n),
                    a = Math.min(i.y, s),
                    h = Math.abs(i.x - n),
                    l = Math.abs(i.y - s);
                return o === pt && (r = e.x1, h = e.width()), o === dt && (a = e.y1, l = e.height()), n > e.x2 && (h = e.x2 - i.x), n < e.x1 && (h = i.x - e.x1), s > e.y2 && (l = e.y2 - i.y), s < e.y1 && (l = i.y - e.y1), {
                    left: Math.max(r, e.x1),
                    top: Math.max(a, e.y1),
                    width: h,
                    height: l
                }
            }
        }), ps.prototype.options = {
            key: "shift",
            lock: "none"
        }, ds = tt.extend({
            init: function(t, e) {
                this.chart = t, this.options = It({}, this.options, e)
            },
            updateRanges: function(t) {
                var e, i, n, s, o = (this.options.lock || "").toLowerCase(),
                    r = [],
                    a = this.chart._plotArea.axes;
                for (e = 0; e < a.length; e++) i = a[e], n = i.options.vertical, o === pt && !n || o === dt && n || (s = i.zoomRange(-t), s && r.push({
                    axis: i,
                    range: s
                }));
                return this.axisRanges = r, O(r)
            },
            zoom: function() {
                var t, e, i, n = this.axisRanges;
                if (n && n.length) {
                    for (t = this.chart._plotArea, e = 0; e < n.length; e++) i = n[e], t.updateAxisOptions(i.axis, i.range);
                    t.redraw(t.panes)
                }
            },
            destroy: function() {
                delete this.chart
            }
        }), gs = bt.extend({
            init: function(t, e) {
                bt.fn.init.call(this, t), this.chartService = e
            },
            render: function() {
                var t, e, i = this,
                    n = i.children,
                    s = i.options,
                    o = s.vertical;
                for (this.visual = new te.Layout(null, {
                        spacing: o ? 0 : s.spacing,
                        lineSpacing: o ? s.spacing : 0,
                        orientation: o ? "vertical" : "horizontal",
                        reverse: s.rtl,
                        alignItems: o ? "start" : "center"
                    }), t = 0; t < n.length; t++) e = n[t], e.reflow(new St), e.renderVisual()
            },
            reflow: function(t) {
                this.visual.rect(t.toRect()), this.visual.reflow();
                var e = this.visual.clippedBBox();
                this.box = e ? J.rectToBox(e) : new St
            },
            renderVisual: function() {
                this.addVisual()
            },
            createVisual: function() {}
        }), fs = Wt.extend({
            init: function(t) {
                Wt.fn.init.call(this, t), this.createContainer(), t.rtl ? (this.createLabel(), this.createMarker()) : (this.createMarker(), this.createLabel())
            },
            createContainer: function() {
                this.container = new J.FloatElement({
                    vertical: !1,
                    wrap: !1,
                    align: rt,
                    spacing: this.options.spacing
                }), this.append(this.container)
            },
            createMarker: function() {
                this.container.append(new Bt(this.markerOptions()))
            },
            markerOptions: function() {
                var t = this.options,
                    e = t.markerColor;
                return It({}, t.markers, {
                    background: e,
                    border: {
                        color: e
                    }
                })
            },
            createLabel: function() {
                var t = this.options,
                    e = It({}, t.labels);
                this.container.append(new Ot(t.text, e))
            },
            renderComplete: function() {
                var t, e;
                Wt.fn.renderComplete.call(this), t = this.options.cursor || {}, e = this._itemOverlay = ee.fromRect(this.container.box.toRect(), {
                    fill: {
                        color: ct,
                        opacity: 0
                    },
                    stroke: null,
                    cursor: t.style || t
                }), this.appendVisual(e)
            },
            click: function(t, e) {
                var i = this.eventArgs(e);
                !t.trigger(mi, i) && e && "contextmenu" === e.type && e.preventDefault()
            },
            over: function(t, e) {
                var i = this.eventArgs(e);
                return t.trigger(xi, i) || t._legendItemHover(i.seriesIndex, i.pointIndex), !0
            },
            out: function(t, e) {
                t._unsetActivePoint(), t.trigger(yi, this.eventArgs(e))
            },
            eventArgs: function(t) {
                var e = this.options;
                return {
                    element: Lt(t),
                    text: e.text,
                    series: e.series,
                    seriesIndex: e.series.index,
                    pointIndex: e.pointIndex
                }
            },
            renderVisual: function() {
                var t = this,
                    e = this.options,
                    i = e.visual;
                i ? (this.visual = i({
                    active: e.active,
                    series: e.series,
                    sender: this.getSender(),
                    pointIndex: e.pointIndex,
                    options: {
                        markers: this.markerOptions(),
                        labels: e.labels
                    },
                    createVisual: function() {
                        t.createVisual(), t.renderChildren(), t.renderComplete();
                        var e = t.visual;
                        return delete t.visual, e
                    }
                }), this.addVisual()) : Wt.fn.renderVisual.call(this)
            }
        }), vs = "horizontal", ms = "pointer", xs = "custom", ys = bt.extend({
            init: function(t, e) {
                void 0 === e && (e = {}), bt.fn.init.call(this, t), this.chartService = e, Pt(this.options.position, [at, gt, ht, lt, xs]) || (this.options.position = gt), this.createContainer(), this.createItems()
            },
            createContainer: function() {
                var t = this.options,
                    e = t.position,
                    i = t.align,
                    n = e,
                    s = rt;
                e === xs ? n = lt : Pt(e, [at, ht]) ? (n = "start" === i ? lt : "end" === i ? gt : rt, s = e) : i && ("start" === i ? s = at : "end" === i && (s = ht)), this.container = new Wt({
                    margin: t.margin,
                    padding: t.padding,
                    background: t.background,
                    border: t.border,
                    vAlign: s,
                    align: n,
                    zIndex: t.zIndex,
                    shrinkToFit: !0
                }), this.append(this.container)
            },
            createItems: function() {
                var t, e, i, n = this.getService(),
                    s = this.options,
                    o = this.isVertical(),
                    r = new gs({
                        vertical: o,
                        spacing: s.spacing,
                        rtl: n.rtl
                    }, n),
                    a = s.items;
                for (s.reverse && (a = a.slice(0).reverse()), t = a.length, e = 0; e < t; e++) i = a[e], r.append(new fs(It({}, {
                    markers: s.markers,
                    labels: s.labels,
                    rtl: n.rtl
                }, s.item, i)));
                r.render(), this.container.append(r)
            },
            isVertical: function() {
                var t = this.options,
                    e = t.orientation,
                    i = t.position,
                    n = i === xs && e !== vs || (yt(e) ? e !== vs : Pt(i, [lt, gt]));
                return n
            },
            hasItems: function() {
                return this.container.children[0].children.length > 0
            },
            reflow: function(t) {
                var e = this.options,
                    i = t.clone();
                return this.hasItems() ? void(e.position === xs ? (this.containerCustomReflow(i), this.box = i) : this.containerReflow(i)) : void(this.box = i)
            },
            containerReflow: function(t) {
                var e, i = this,
                    n = i.options,
                    s = i.container,
                    o = n.position,
                    r = n.width,
                    a = n.height,
                    h = o === at || o === ht ? pt : dt,
                    l = this.isVertical(),
                    c = t.clone(),
                    u = t.clone();
                o !== lt && o !== gt || (u.y1 = c.y1 = 0), l && a ? (u.y2 = u.y1 + a, u.align(c, dt, s.options.vAlign)) : !l && r && (u.x2 = u.x1 + r, u.align(c, pt, s.options.align)), s.reflow(u), u = s.box, e = u.clone(), (n.offsetX || n.offsetY) && (u.translate(n.offsetX, n.offsetY), this.container.reflow(u)), e[h + 1] = t[h + 1], e[h + 2] = t[h + 2], this.box = e
            },
            containerCustomReflow: function(t) {
                var e = this,
                    i = e.options,
                    n = e.container,
                    s = i.offsetX,
                    o = i.offsetY,
                    r = i.width,
                    a = i.height,
                    h = this.isVertical(),
                    l = t.clone();
                h && a ? l.y2 = l.y1 + a : !h && r && (l.x2 = l.x1 + r), n.reflow(l), l = n.box, n.reflow(new St(s, o, s + l.width(), o + l.height()))
            },
            renderVisual: function() {
                this.hasItems() && bt.fn.renderVisual.call(this)
            }
        }), kt(ys, {
            position: gt,
            items: [],
            offsetX: 0,
            offsetY: 0,
            margin: zt(5),
            padding: zt(5),
            border: {
                color: ft,
                width: 0
            },
            item: {
                cursor: ms,
                spacing: 6
            },
            spacing: 6,
            background: "",
            zIndex: 1,
            markers: {
                border: {
                    width: 0
                },
                width: 15,
                height: 3,
                type: "rect",
                align: lt,
                vAlign: rt
            }
        }), _s = tt.extend({
            init: function() {
                this._registry = []
            },
            register: function(t, e) {
                this._registry.push({
                    type: t,
                    seriesTypes: e
                })
            },
            create: function(t, e, i) {
                var n, s, o, r = this._registry,
                    a = r[0];
                for (s = 0; s < r.length; s++)
                    if (o = r[s], n = y(t, o.seriesTypes), n.length > 0) {
                        a = o;
                        break
                    }
                return new a.type(n, e, i)
            }
        }), _s.current = new _s, ws = 3, bs = .1, As = tt.extend({
            init: function(t, e, i, n) {
                var s = t.element;
                this.options = It({}, this.options, i), this.chart = t, this.observer = n, this.chartElement = s, this.categoryAxis = e, this._dateAxis = this.categoryAxis instanceof J.DateCategoryAxis, this.initOptions(), this.options.visible && (this.createElements(), this.set(this._index(this.options.from), this._index(this.options.to)), this.bindEvents())
            },
            onPane: function(t) {
                return this.categoryAxis.pane === t
            },
            createElements: function() {
                var t, e, i, n, s, o, r = this.options,
                    a = this.wrapper = B("k-selector");
                Yt(a, {
                    top: r.offset.top,
                    left: r.offset.left,
                    width: r.width,
                    height: r.height,
                    direction: "ltr"
                }), t = this.selection = B("k-selection"), this.leftMask = B("k-mask"), this.rightMask = B("k-mask"), a.appendChild(this.leftMask), a.appendChild(this.rightMask), a.appendChild(t), t.appendChild(B("k-selection-bg")), e = this.leftHandle = B("k-handle k-left-handle"), i = this.rightHandle = B("k-handle k-right-handle"), e.appendChild(B()), i.appendChild(B()), t.appendChild(e), t.appendChild(i), this.chartElement.appendChild(a), n = Yt(t, ["borderLeftWidth", "borderRightWidth", "height"]), s = Yt(e, "height").height, o = Yt(i, "height").height, r.selection = {
                    border: {
                        left: n.borderLeftWidth,
                        right: n.borderRightWidth
                    }
                }, Yt(e, {
                    top: (n.height - s) / 2
                }), Yt(i, {
                    top: (n.height - o) / 2
                }), a.style.cssText = a.style.cssText
            },
            bindEvents: function() {
                if (this.options.mousewheel !== !1) {
                    this._mousewheelHandler = this._mousewheel.bind(this);
                    var t;
                    Kt(this.wrapper, (t = {}, t[Xi] = this._mousewheelHandler, t))
                }
                this._domEvents = Qt.DomEventsBuilder.create(this.wrapper, {
                    stopPropagation: !0,
                    start: this._start.bind(this),
                    move: this._move.bind(this),
                    end: this._end.bind(this),
                    tap: this._tap.bind(this),
                    press: this._press.bind(this),
                    gesturestart: this._gesturestart.bind(this),
                    gesturechange: this._gesturechange.bind(this),
                    gestureend: this._gestureend.bind(this)
                })
            },
            initOptions: function() {
                var t, e, i, n = this,
                    s = n.options,
                    o = n.categoryAxis,
                    r = o.pane.chartsBox(),
                    a = this.chart.chartService.intl;
                this._dateAxis && It(s, {
                    min: Nt(a, s.min),
                    max: Nt(a, s.max),
                    from: Nt(a, s.from),
                    to: Nt(a, s.to)
                }), t = Yt(this.chartElement, ["paddingLeft", "paddingTop"]), e = t.paddingLeft, i = t.paddingTop, this.options = It({}, {
                    width: r.width(),
                    height: r.height() + bs,
                    padding: {
                        left: e,
                        top: i
                    },
                    offset: {
                        left: r.x1 + e,
                        top: r.y1 + i
                    },
                    from: s.min,
                    to: s.max
                }, s)
            },
            destroy: function() {
                if (this._domEvents && (this._domEvents.destroy(), delete this._domEvents), clearTimeout(this._mwTimeout), this._state = null, this.wrapper) {
                    if (this._mousewheelHandler) {
                        var t;
                        $t(this.wrapper, (t = {}, t[Xi] = this._mousewheelHandler, t)), this._mousewheelHandler = null
                    }
                    this.chartElement.removeChild(this.wrapper), this.wrapper = null
                }
            },
            _rangeEventArgs: function(t) {
                return {
                    axis: this.categoryAxis.options,
                    from: this._value(t.from),
                    to: this._value(t.to)
                }
            },
            _start: function(t) {
                var e, i = this.options,
                    n = Lt(t);
                !this._state && n && (this.chart._unsetActivePoint(), this._state = {
                    moveTarget: z(n) || n,
                    startLocation: t.x ? t.x.location : 0,
                    range: {
                        from: this._index(i.from),
                        to: this._index(i.to)
                    }
                }, e = this._rangeEventArgs({
                    from: this._index(i.from),
                    to: this._index(i.to)
                }), this.trigger(Li, e) && (this._state = null))
            },
            _press: function(t) {
                var e;
                e = this._state ? this._state.moveTarget : z(Lt(t)), e && J.addClass(e, "k-handle-active")
            },
            _move: function(t) {
                var e, i, n, s, o, r, a, h, l, c, u, p, d, g, f, v, m, x;
                this._state && (e = this, i = e._state, n = e.options, s = e.categoryAxis, o = i.range, r = i.moveTarget, a = s.options.reverse, h = this._index(n.from), l = this._index(n.to), c = this._index(n.min), u = this._index(n.max), p = i.startLocation - t.x.location, d = {
                    from: o.from,
                    to: o.to
                }, g = o.to - o.from, f = Yt(this.wrapper, "width").width / (s.categoriesCount() - 1), v = Math.round(p / f) * (a ? -1 : 1), r && (m = jt(r, "k-left-handle"), x = jt(r, "k-right-handle"), jt(r, "k-selection k-selection-bg") ? (o.from = Math.min(Math.max(c, h - v), u - g), o.to = Math.min(o.from + g, u)) : m && !a || x && a ? (o.from = Math.min(Math.max(c, h - v), u - 1), o.to = Math.max(o.from + 1, o.to)) : (m && a || x && !a) && (o.to = Math.min(Math.max(c + 1, l - v), u), o.from = Math.min(o.to - 1, o.from)), o.from === d.from && o.to === d.to || (this.move(o.from, o.to), this.trigger(Mi, this._rangeEventArgs(o)))))
            },
            _end: function() {
                var t, e;
                this._state && (t = this._state.moveTarget, t && J.removeClass(t, "k-handle-active"), e = this._state.range, this.set(e.from, e.to), this.trigger(Oi, this._rangeEventArgs(e)), delete this._state)
            },
            _tap: function(t) {
                var e = this,
                    i = e.options,
                    n = e.categoryAxis,
                    s = this.chart._eventCoordinates(t),
                    o = n.pointCategoryIndex(new At(s.x, n.box.y1)),
                    r = this._index(i.from),
                    a = this._index(i.to),
                    h = this._index(i.min),
                    l = this._index(i.max),
                    c = a - r,
                    u = r + c / 2,
                    p = {},
                    d = 3 === t.event.which,
                    g = Math.round(u - o);
                this._state || d || (this.chart._unsetActivePoint(), n.options.justified || g--, p.from = Math.min(Math.max(h, r - g), l - c), p.to = Math.min(p.from + c, l), this._start(t), this._state && (this._state.range = p, this.trigger(Mi, this._rangeEventArgs(p)), this._end()))
            },
            _mousewheel: function(t) {
                var e, i = this,
                    n = J.mousewheelDelta(t);
                this._start({
                    target: this.selection
                }), this._state && (e = this._state.range, t.preventDefault(), t.stopPropagation(), Math.abs(n) > 1 && (n *= ws), this.options.mousewheel.reverse && (n *= -1), this.expand(n) && this.trigger(Mi, {
                    axis: this.categoryAxis.options,
                    delta: n,
                    originalEvent: t,
                    from: this._value(e.from),
                    to: this._value(e.to)
                }), this._mwTimeout && clearTimeout(this._mwTimeout), this._mwTimeout = setTimeout(function() {
                    i._end()
                }, Zi))
            },
            _gesturestart: function(t) {
                var e, i = this.options;
                this._state = {
                    range: {
                        from: this._index(i.from),
                        to: this._index(i.to)
                    }
                }, e = this._rangeEventArgs(this._state.range), this.trigger(Li, e) ? this._state = null : t.preventDefault()
            },
            _gestureend: function() {
                this._state && (this.trigger(Oi, this._rangeEventArgs(this._state.range)), delete this._state)
            },
            _gesturechange: function(t) {
                var e = this,
                    i = e.chart,
                    n = e._state,
                    s = e.options,
                    o = e.categoryAxis,
                    r = n.range,
                    a = i._toModelCoordinates(t.touches[0].x.location).x,
                    h = i._toModelCoordinates(t.touches[1].x.location).x,
                    l = Math.min(a, h),
                    c = Math.max(a, h);
                t.preventDefault(), r.from = o.pointCategoryIndex(new At(l)) || s.min, r.to = o.pointCategoryIndex(new At(c)) || s.max, this.move(r.from, r.to), this.trigger(Mi, this._rangeEventArgs(r))
            },
            _index: function(t) {
                var e = t;
                return t instanceof Date && (e = this.categoryAxis.categoryIndex(t)), e
            },
            _value: function(t) {
                var e = t;
                return this._dateAxis && (e = this.categoryAxis.categoryAt(t), e > this.options.max && (e = this.options.max)), e
            },
            _slot: function(t) {
                var e = this.categoryAxis,
                    i = this._index(t);
                return e.getSlot(i, i, !0)
            },
            move: function(t, e) {
                var i, n, s = this.options,
                    o = this.categoryAxis.options.reverse,
                    r = s.offset,
                    a = s.padding,
                    h = s.selection.border,
                    l = o ? e : t,
                    c = o ? t : e,
                    u = "x" + (o ? 2 : 1),
                    p = this._slot(l),
                    d = Xt(p[u] - r.left + a.left);
                Yt(this.leftMask, {
                    width: d
                }), Yt(this.selection, {
                    left: d
                }), p = this._slot(c), i = Xt(s.width - (p[u] - r.left + a.left)), Yt(this.rightMask, {
                    width: i
                }), n = s.width - i, n !== s.width && (n += h.right), Yt(this.rightMask, {
                    left: n
                }), Yt(this.selection, {
                    width: Math.max(s.width - (d + i) - h.right, 0)
                })
            },
            set: function(t, e) {
                var i = this.options,
                    n = this._index(i.min),
                    s = this._index(i.max),
                    o = Zt(this._index(t), n, s),
                    r = Zt(this._index(e), o + 1, s);
                i.visible && this.move(o, r), i.from = this._value(o), i.to = this._value(r)
            },
            expand: function(t) {
                var e = this.options,
                    i = this._index(e.min),
                    n = this._index(e.max),
                    s = e.mousewheel.zoom,
                    o = this._index(e.from),
                    r = this._index(e.to),
                    a = {
                        from: o,
                        to: r
                    },
                    h = It({}, a);
                if (this._state && (a = this._state.range), s !== gt && (a.from = Zt(Zt(o - t, 0, r - 1), i, n)), s !== lt && (a.to = Zt(Zt(r + t, a.from + 1, n), i, n)), a.from !== h.from || a.to !== h.to) return this.set(a.from, a.to), !0
            },
            trigger: function(t, e) {
                return (this.observer || this.chart).trigger(t, e)
            }
        }), kt(As, {
            visible: !0,
            mousewheel: {
                zoom: "both"
            },
            min: st,
            max: nt
        }), Ss = Mn.extend({
            show: function(t) {
                var e, i;
                !t || !t.tooltipAnchor || this._current && this._current === t || (e = It({}, this.options, t.options.tooltip), i = t.tooltipAnchor(), i ? (this._current = t, Mn.fn.show.call(this, {
                    point: t,
                    anchor: i
                }, e, t)) : this.hide())
            },
            hide: function() {
                delete this._current, Mn.fn.hide.call(this)
            }
        }), Cs = Mn.extend({
            init: function(t, e) {
                Mn.fn.init.call(this, t.chartService, e), this.plotArea = t, this.formatService = t.chartService.format
            },
            showAt: function(t, e) {
                var i, n, s, o = Ut(t, function(t) {
                    var e = t.series.tooltip,
                        i = e && e.visible === !1;
                    return !i
                });
                o.length > 0 && (i = o[0], n = this.plotArea.categoryAxis.getSlot(i.categoryIx), s = e ? this._slotAnchor(e, n) : this._defaultAnchor(i, n), this.show({
                    anchor: s,
                    shared: !0,
                    points: t,
                    category: i.category,
                    categoryText: this.formatService.auto(this.options.categoryFormat, i.category),
                    series: this.plotArea.series
                }, this.options))
            },
            _slotAnchor: function(t, e) {
                var i = this.plotArea.categoryAxis,
                    n = {
                        horizontal: "left",
                        vertical: "center"
                    };
                return i.options.vertical || (t.x = e.center().x), {
                    point: t,
                    align: n
                }
            },
            _defaultAnchor: function(t, e) {
                var i, n = t.owner.pane.chartsBox(),
                    s = this.plotArea.categoryAxis.options.vertical,
                    o = n.center(),
                    r = e.center(),
                    a = {
                        horizontal: "center",
                        vertical: "center"
                    };
                return i = s ? new At(o.x, r.y) : new At(r.x, o.y), {
                    point: i,
                    align: a
                }
            }
        }), kt(Cs, {
            categoryFormat: "{0:d}"
        }), ks = ie.extend({
            setup: function() {
                var t, e, i = this,
                    n = i.element,
                    s = i.options,
                    o = n.bbox();
                o ? (this.origin = s.origin, t = s.vertical ? dt : pt, e = this.fromScale = new ae(1, 1), e[t] = Ce, n.transform(he().scale(e.x, e.y))) : this.abort()
            },
            step: function(t) {
                var e = J.interpolateValue(this.fromScale.x, 1, t),
                    i = J.interpolateValue(this.fromScale.y, 1, t);
                this.element.transform(he().scale(e, i, this.origin))
            },
            abort: function() {
                ie.fn.abort.call(this), this.element.transform(null)
            }
        }), kt(ks, {
            duration: _e
        }), ne.current.register(Ne, ks), Ps = ie.extend({
            setup: function() {
                var t = this.center = this.element.bbox().center();
                this.element.transform(he().scale(Ce, Ce, t))
            },
            step: function(t) {
                this.element.transform(he().scale(t, t, this.center))
            }
        }), kt(Ps, {
            easing: "easeOutElastic"
        }), ne.current.register(qe, Ps), Ts = ie.extend({
            setup: function() {
                this.fadeTo = this.element.opacity(), this.element.opacity(0)
            },
            step: function(t) {
                this.element.opacity(t * this.fadeTo)
            }
        }), kt(Ts, {
            duration: 200,
            easing: "linear"
        }), ne.current.register(we, Ts), Es = ie.extend({
            setup: function() {
                this.element.transform(he().scale(Ce, Ce, this.options.center))
            },
            step: function(t) {
                this.element.transform(he().scale(t, t, this.options.center))
            }
        }), kt(Es, {
            easing: "easeOutElastic",
            duration: _e
        }), ne.current.register($e, Es), Rs = Tn.extend({
            render: function() {
                Tn.fn.render.call(this), this.renderSegments()
            },
            createSegment: function(t, e, i) {
                var n, s = e.style;
                return new(n = s === De ? rn : nn)(t, e, i)
            },
            animationPoints: function() {
                var t = Tn.fn.animationPoints.call(this);
                return t.concat(this._segments)
            },
            createMissingValue: function(t, e) {
                if (e === Le) {
                    var i = {
                        x: t.x,
                        y: t.y
                    };
                    return p(i.x) || (i.x = 0), p(i.y) || (i.y = 0), i
                }
            }
        }), It(Rs.prototype, an), Is = Nn.extend({
            initFields: function() {
                this.namedXAxes = {}, this.namedYAxes = {}, this.xAxisRangeTracker = new fn, this.yAxisRangeTracker = new fn
            },
            render: function(t) {
                var e, i, n, s, o, r = this;
                for (void 0 === t && (t = this.panes), e = this.groupSeriesByPane(), i = 0; i < t.length; i++) n = t[i], s = e[n.options.name || "default"] || [], r.addToLegend(s), o = r.filterVisibleSeries(s), o && (r.createScatterChart(y(o, hi), n), r.createScatterLineChart(y(o, li), n), r.createBubbleChart(y(o, qe), n));
                this.createAxes(t)
            },
            appendChart: function(t, e) {
                this.xAxisRangeTracker.update(t.xAxisRanges), this.yAxisRangeTracker.update(t.yAxisRanges), Nn.fn.appendChart.call(this, t, e)
            },
            removeAxis: function(t) {
                var e = t.options.name;
                Nn.fn.removeAxis.call(this, t), t.options.vertical ? (this.yAxisRangeTracker.reset(e), delete this.namedYAxes[e]) : (this.xAxisRangeTracker.reset(e), delete this.namedXAxes[e]), t === this.axisX && delete this.axisX, t === this.axisY && delete this.axisY
            },
            seriesPaneName: function(t) {
                var e = this.options,
                    i = t.xAxis,
                    n = [].concat(e.xAxis),
                    s = Ut(n, function(t) {
                        return t.name === i
                    })[0],
                    o = t.yAxis,
                    r = [].concat(e.yAxis),
                    a = Ut(r, function(t) {
                        return t.name === o
                    })[0],
                    h = e.panes || [{}],
                    l = h[0].name || "default",
                    c = (s || {}).pane || (a || {}).pane || l;
                return c
            },
            createScatterChart: function(t, e) {
                t.length > 0 && this.appendChart(new Tn(this, {
                    series: t,
                    clip: e.options.clip
                }), e)
            },
            createScatterLineChart: function(t, e) {
                t.length > 0 && this.appendChart(new Rs(this, {
                    series: t,
                    clip: e.options.clip
                }), e)
            },
            createBubbleChart: function(t, e) {
                t.length > 0 && this.appendChart(new Rn(this, {
                    series: t,
                    clip: e.options.clip
                }), e)
            },
            createXYAxis: function(t, e, i) {
                var n, s, o, r, a, h, l, c, u = t.name,
                    p = e ? this.namedYAxes : this.namedXAxes,
                    d = e ? this.yAxisRangeTracker : this.xAxisRangeTracker,
                    g = It({
                        reverse: !e && this.chartService.rtl
                    }, t, {
                        vertical: e
                    }),
                    f = x(g.type, Fi),
                    v = d.query(),
                    m = f ? {
                        min: .1,
                        max: 1
                    } : {
                        min: 0,
                        max: 1
                    },
                    y = d.query(u) || v || m,
                    _ = [g.min, g.max],
                    w = this.series;
                for (n = 0; n < w.length; n++)
                    if (s = w[n], o = s[e ? "yAxis" : "xAxis"], o === g.name || 0 === i && !o) {
                        r = de.current.bindPoint(s, 0).valueFields, _.push(r[e ? "y" : "x"]);
                        break
                    }
                for (0 === i && v && (y.min = Math.min(y.min, v.min), y.max = Math.max(y.max, v.max)), h = 0; h < _.length; h++)
                    if (_[h] instanceof Date) {
                        a = !0;
                        break
                    }
                if (l = x(g.type, vt) || !g.type && a ? J.DateValueAxis : f ? J.LogarithmicAxis : J.NumericAxis, c = new l(y.min, y.max, g, this.chartService), c.axisIndex = i, u) {
                    if (p[u]) throw Error((e ? "Y" : "X") + " axis with name " + u + " is already defined");
                    p[u] = c
                }
                return this.appendAxis(c), c
            },
            createAxes: function(t) {
                var e, i, n, s, o = this,
                    r = this.options,
                    a = [].concat(r.xAxis),
                    h = [],
                    l = [].concat(r.yAxis),
                    c = [];
                for (e = 0; e < a.length; e++) i = o.findPane(a[e].pane), Pt(i, t) && h.push(o.createXYAxis(a[e], !1, e));
                for (n = 0; n < l.length; n++) s = o.findPane(l[n].pane), Pt(s, t) && c.push(o.createXYAxis(l[n], !0, n));
                this.axisX = this.axisX || h[0], this.axisY = this.axisY || c[0]
            },
            _dispatchEvent: function(t, e, i) {
                var n, s, o, r, a = t._eventCoordinates(e),
                    h = new At(a.x, a.y),
                    l = this.axes,
                    c = l.length,
                    u = [],
                    p = [];
                for (n = 0; n < c; n++) s = l[n], o = s.options.vertical ? p : u, r = s.getValue(h), null !== r && o.push(r);
                u.length > 0 && p.length > 0 && t.trigger(i, {
                    element: Lt(e),
                    originalEvent: e,
                    x: b(u),
                    y: b(p)
                })
            },
            updateAxisOptions: function(t, e) {
                var i = t.options.vertical,
                    n = this.groupAxes(this.panes),
                    s = (i ? n.y : n.x).indexOf(t);
                D(this.options, s, i, e), D(this.originalOptions, s, i, e)
            }
        }), kt(Is, {
            xAxis: {},
            yAxis: {}
        }), It(Is.prototype, qn), Vs = bt.extend({
            init: function(t, e, i) {
                bt.fn.init.call(this, i), this.value = t, this.sector = e
            },
            render: function() {
                var t, e, i, n, s = this.options.labels,
                    o = this.owner.chartService,
                    r = this.value;
                this._rendered || this.visible === !1 || (this._rendered = !0, t = Mt(s), e = this.pointData(), t ? r = t(e) : s.format && (r = o.format.auto(s.format, r)), s.visible && (r || 0 === r) && (s.position === rt || s.position === Gi ? (s.color || (i = new oe(this.options.color).percBrightness(), s.color = i > 180 ? ft : ct), s.background || (s.background = this.options.color)) : (n = o.theme.seriesDefaults.labels, s.color = s.color || n.color, s.background = s.background || n.background), this.label = new Ot(r, It({}, s, {
                    align: rt,
                    vAlign: "",
                    animation: {
                        type: we,
                        delay: this.animationDelay
                    }
                }), e), this.append(this.label)))
            },
            reflow: function(t) {
                this.render(), this.box = t, this.reflowLabel()
            },
            reflowLabel: function() {
                var t, e, i, n, s = this,
                    o = s.options.labels,
                    r = s.label,
                    a = this.sector.clone(),
                    h = o.distance,
                    l = a.middle();
                r && (t = r.box.height(), e = r.box.width(), o.position === rt ? (a.radius = Math.abs((a.radius - t) / 2) + t, i = a.point(l), r.reflow(new St(i.x, i.y - t / 2, i.x, i.y))) : o.position === Gi ? (a.radius = a.radius - t / 2, i = a.point(l), r.reflow(new St(i.x, i.y - t / 2, i.x, i.y))) : (i = a.clone().expand(h).point(l), i.x >= a.center.x ? (n = i.x + e, r.orientation = gt) : (n = i.x - e, r.orientation = lt), r.reflow(new St(n, i.y - t, i.x, i.y))))
            },
            createVisual: function() {
                var t, e, i = this,
                    n = this,
                    s = n.sector,
                    o = n.options;
                bt.fn.createVisual.call(this), this.value && (o.visual ? (t = (s.startAngle + 180) % 360, e = o.visual({
                    category: this.category,
                    dataItem: this.dataItem,
                    value: this.value,
                    series: this.series,
                    percentage: this.percentage,
                    center: new ae(s.center.x, s.center.y),
                    radius: s.radius,
                    innerRadius: s.innerRadius,
                    startAngle: t,
                    endAngle: t + s.angle,
                    options: o,
                    sender: this.getSender(),
                    createVisual: function() {
                        var t = new se;
                        return i.createSegmentVisual(t), t
                    }
                }), e && this.visual.append(e)) : this.createSegmentVisual(this.visual))
            },
            createSegmentVisual: function(t) {
                var e = this,
                    i = e.sector,
                    n = e.options,
                    s = n.border || {},
                    o = s.width > 0 ? {
                        stroke: {
                            color: s.color,
                            width: s.width,
                            opacity: s.opacity,
                            dashType: s.dashType
                        }
                    } : {},
                    r = n.color,
                    a = {
                        color: r,
                        opacity: n.opacity
                    },
                    l = this.createSegment(i, It({
                        fill: a,
                        stroke: {
                            opacity: n.opacity
                        },
                        zIndex: n.zIndex
                    }, o));
                t.append(l), h(n) && t.append(this.createGradientOverlay(l, {
                    baseColor: r,
                    fallbackFill: a
                }, It({
                    center: [i.center.x, i.center.y],
                    innerRadius: i.innerRadius,
                    radius: i.radius,
                    userSpace: !0
                }, n.overlay)))
            },
            createSegment: function(t, e) {
                return e.singleSegment ? new te.Circle(new re.Circle(new ae(t.center.x, t.center.y), t.radius), e) : J.ShapeBuilder.current.createRing(t, e)
            },
            createAnimation: function() {
                var t = this,
                    e = t.options,
                    i = t.sector.center;
                It(e, {
                    animation: {
                        center: [i.x, i.y],
                        delay: this.animationDelay
                    }
                }), bt.fn.createAnimation.call(this)
            },
            createHighlight: function(t) {
                var e = this.options.highlight || {},
                    i = e.border || {};
                return this.createSegment(this.sector, It({}, t, {
                    fill: {
                        color: e.color,
                        opacity: e.opacity
                    },
                    stroke: {
                        opacity: i.opacity,
                        width: i.width,
                        color: i.color
                    }
                }))
            },
            highlightVisual: function() {
                return this.visual.children[0]
            },
            highlightVisualArgs: function() {
                var t = this.sector;
                return {
                    options: this.options,
                    radius: t.radius,
                    innerRadius: t.innerRadius,
                    center: new ae(t.center.x, t.center.y),
                    startAngle: t.startAngle,
                    endAngle: t.angle + t.startAngle,
                    visual: this.visual
                }
            },
            tooltipAnchor: function() {
                var t = this.sector.clone().expand(Se),
                    e = t.middle(),
                    i = t.point(e);
                return {
                    point: i,
                    align: H(e + 180)
                }
            },
            formatValue: function(t) {
                return this.owner.formatPointValue(this, t)
            },
            pointData: function() {
                return {
                    dataItem: this.dataItem,
                    category: this.category,
                    value: this.value,
                    series: this.series,
                    percentage: this.percentage
                }
            }
        }), Ls = Xt(J.rad(30), mt), Ms = Xt(J.rad(60), mt), kt(Vs, {
            color: ct,
            overlay: {
                gradient: "roundedBevel"
            },
            border: {
                width: .5
            },
            labels: {
                visible: !1,
                distance: 35,
                font: it.DEFAULT_FONT,
                margin: zt(.5),
                align: ut,
                zIndex: 1,
                position: Wi
            },
            animation: {
                type: $e
            },
            highlight: {
                visible: !0,
                border: {
                    width: 1
                }
            },
            visible: !0
        }), It(Vs.prototype, Ji), Os = {
            createLegendItem: function(t, e, i) {
                var n, s, o, r, a, h = this.options.legend || {},
                    l = h.labels || {},
                    c = h.inactiveItems || {},
                    u = c.labels || {};
                i && i.visibleInLegend !== !1 && (n = i.visible !== !1, s = n ? Mt(l) : Mt(u) || Mt(l), o = i.category, s && (o = s({
                    text: o,
                    series: i.series,
                    dataItem: i.dataItem,
                    percentage: i.percentage,
                    value: t
                })), n ? (r = {}, a = e.color) : (r = {
                    color: u.color,
                    font: u.font
                }, a = (c.markers || {}).color), p(o) && "" !== o && this.legendItems.push({
                    active: n,
                    pointIndex: i.index,
                    text: o,
                    series: i.series,
                    markerColor: a,
                    labels: r
                }))
            }
        }, Bs = 70, zs = bt.extend({
            init: function(t, e) {
                bt.fn.init.call(this, e), this.plotArea = t, this.chartService = t.chartService, this.points = [], this.legendItems = [], this.render()
            },
            render: function() {
                this.traverseDataPoints(this.addValue.bind(this))
            },
            traverseDataPoints: function(t) {
                var e, i, n, s, o, r, a, h, l, c, u, p, d, g, f, v, x, y, _, w, b = this,
                    A = this,
                    S = A.options,
                    C = A.plotArea.options.seriesColors;
                for (void 0 === C && (C = []), e = C.length, i = S.series, n = i.length, s = 0; s < n; s++)
                    for (o = i[s], r = o.data, a = m(o), h = a.total, l = a.points, c = a.count, u = 360 / h, p = void 0, isFinite(u) || (p = 360 / c), d = void 0, d = yt(o.startAngle) ? o.startAngle : S.startAngle, s !== n - 1 && o.labels.position === Wi && (o.labels.position = rt), g = 0; g < l.length; g++) f = l[g], f && (v = f.fields, x = f.value, y = f.visible, _ = 0 !== x ? p || x * u : 0, w = 1 !== r.length && !!v.explode, Tt(o.color) || (o.color = v.color || C[g % e]), t(f.valueFields.value, new J.Ring(null, 0, 0, d, _), {
                        owner: b,
                        category: yt(v.category) ? v.category : "",
                        index: g,
                        series: o,
                        seriesIx: s,
                        dataItem: r[g],
                        percentage: 0 !== h ? x / h : 0,
                        explode: w,
                        visibleInLegend: v.visibleInLegend,
                        visible: y,
                        zIndex: n - s,
                        animationDelay: b.animationDelay(g, s, n)
                    }), y !== !1 && (d += _))
            },
            evalSegmentOptions: function(t, e, i) {
                var n = i.series;
                s(t, {
                    value: e,
                    series: n,
                    dataItem: i.dataItem,
                    category: i.category,
                    percentage: i.percentage
                }, {
                    defaults: n._defaults,
                    excluded: ["data", "content", "template", "visual", "toggle"]
                })
            },
            addValue: function(e, i, n) {
                var s, o = It({}, n.series, {
                    index: n.index
                });
                this.evalSegmentOptions(o, e, n), this.createLegendItem(e, o, n), n.visible !== !1 && (s = new Vs(e, i, o), t.extend(s, n), this.append(s), this.points.push(s))
            },
            reflow: function(t) {
                var e, i, n, s, o, r, a, h, l, c, u, p, d, g, f, v, m, x, y, _, w, b = this,
                    A = b.options,
                    S = b.points,
                    C = b.seriesConfigs;
                for (void 0 === C && (C = []), e = S.length, i = t.clone(), n = 5, s = Math.min(i.width(), i.height()), o = s / 2, r = s - .85 * s, a = new St(i.x1, i.y1, i.x1 + s, i.y1 + s), h = a.center(), l = i.center(), c = A.series.length, u = [], p = [], d = Et(A.padding, r), d = d > o - n ? o - n : d, a.translate(l.x - h.x, l.y - h.y), g = o - d, f = new At(g + a.x1 + d, g + a.y1 + d), v = 0; v < e; v++) m = S[v], x = m.sector, y = m.seriesIx, x.radius = g, x.center = f, C.length && (_ = C[y], x.innerRadius = _.innerRadius, x.radius = _.radius), y === c - 1 && m.explode && (x.center = x.clone().setRadius(.15 * x.radius).point(x.middle())), m.reflow(a), w = m.label, w && w.options.position === Wi && y === c - 1 && (w.orientation === gt ? p.push(w) : u.push(w));
                u.length > 0 && (u.sort(this.labelComparator(!0)), this.leftLabelsReflow(u)), p.length > 0 && (p.sort(this.labelComparator(!1)), this.rightLabelsReflow(p)), this.box = a
            },
            leftLabelsReflow: function(t) {
                var e = this.distanceBetweenLabels(t);
                this.distributeLabels(e, t)
            },
            rightLabelsReflow: function(t) {
                var e = this.distanceBetweenLabels(t);
                this.distributeLabels(e, t)
            },
            distanceBetweenLabels: function(t) {
                var e, i, n = Vt(this.points),
                    s = n.sector,
                    o = t.length - 1,
                    r = s.radius + n.options.labels.distance,
                    a = [],
                    h = t[0].box,
                    l = Xt(h.y1 - (s.center.y - r - h.height() - h.height() / 2));
                for (a.push(l), e = 0; e < o; e++) i = t[e + 1].box, h = t[e].box, l = Xt(i.y1 - h.y2), a.push(l);
                return l = Xt(s.center.y + r - t[o].box.y2 - t[o].box.height() / 2), a.push(l), a
            },
            distributeLabels: function(t, e) {
                var i, n, s, o, r = this,
                    a = t.length;
                for (o = 0; o < a; o++)
                    for (s = -t[o], i = n = o; s > 0 && (i >= 0 || n < a);) s = r._takeDistance(t, o, --i, s), s = r._takeDistance(t, o, ++n, s);
                this.reflowLabels(t, e)
            },
            _takeDistance: function(t, e, i, n) {
                var s, o = n;
                return t[i] > 0 && (s = Math.min(t[i], o), o -= s, t[i] -= s, t[e] += s), o
            },
            reflowLabels: function(t, e) {
                var i, n, s, o, r = this,
                    a = Vt(this.points),
                    h = a.sector,
                    l = a.options.labels,
                    c = e.length,
                    u = l.distance,
                    p = h.center.y - (h.radius + u) - e[0].box.height();
                for (t[0] += 2, n = 0; n < c; n++) s = e[n], o = s.box, p += t[n], i = r.hAlignLabel(o.x2, h.clone().expand(u), p, p + o.height(), s.orientation === gt), s.orientation === gt ? (l.align !== ut && (i = h.radius + h.center.x + u), s.reflow(new St(i + o.width(), p, i, p))) : (l.align !== ut && (i = h.center.x - h.radius - u), s.reflow(new St(i - o.width(), p, i, p))), p += o.height()
            },
            createVisual: function() {
                var t, e, i, n, s, o, r, a, h, l, c, u, p, d, g = this,
                    f = this,
                    v = f.options.connectors,
                    m = f.points,
                    x = m.length,
                    y = 4;
                for (bt.fn.createVisual.call(this), this._connectorLines = [], t = 0; t < x; t++) e = m[t], i = e.sector, n = e.label, s = i.middle(), o = (e.options.connectors || {}).color || v.color, n && (r = new ee({
                    stroke: {
                        color: o,
                        width: v.width
                    },
                    animation: {
                        type: we,
                        delay: e.animationDelay
                    }
                }), n.options.position === Wi && (a = n.box, h = i.center, l = i.point(s), c = new At(a.x1, a.center().y), u = void 0, p = void 0, d = void 0, l = i.clone().expand(v.padding).point(s), r.moveTo(l.x, l.y), n.orientation === gt ? (p = new At(a.x1 - v.padding, a.center().y), d = F(h, l, c, p), c = new At(p.x - y, p.y), d = d || c, d.x = Math.min(d.x, c.x), g.pointInCircle(d, i.center, i.radius + y) || d.x < i.center.x ? (u = i.center.x + i.radius + y, e.options.labels.align !== Ze ? u < c.x ? r.lineTo(u, l.y) : r.lineTo(l.x + 2 * y, l.y) : r.lineTo(u, l.y), r.lineTo(c.x, p.y)) : (d.y = p.y, r.lineTo(d.x, d.y))) : (p = new At(a.x2 + v.padding, a.center().y), d = F(h, l, c, p), c = new At(p.x + y, p.y), d = d || c, d.x = Math.max(d.x, c.x), g.pointInCircle(d, i.center, i.radius + y) || d.x > i.center.x ? (u = i.center.x - i.radius - y, e.options.labels.align !== Ze ? u > c.x ? r.lineTo(u, l.y) : r.lineTo(l.x - 2 * y, l.y) : r.lineTo(u, l.y), r.lineTo(c.x, p.y)) : (d.y = p.y, r.lineTo(d.x, d.y))), r.lineTo(p.x, p.y), g._connectorLines.push(r), g.visual.append(r)))
            },
            labelComparator: function(t) {
                var e = t ? -1 : 1;
                return function(t, i) {
                    var n = (t.parent.sector.middle() + 270) % 360,
                        s = (i.parent.sector.middle() + 270) % 360;
                    return (n - s) * e
                }
            },
            hAlignLabel: function(t, e, i, n, s) {
                var o = e.radius,
                    r = e.center,
                    a = r.x,
                    h = r.y,
                    l = Math.min(Math.abs(h - i), Math.abs(h - n));
                return l > o ? t : a + Math.sqrt(o * o - l * l) * (s ? 1 : -1)
            },
            pointInCircle: function(t, e, i) {
                return Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2) < Math.pow(i, 2)
            },
            formatPointValue: function(t, e) {
                return this.chartService.format.auto(e, t.value)
            },
            animationDelay: function(t) {
                return t * Bs
            }
        }), kt(zs, {
            startAngle: 90,
            connectors: {
                width: 2,
                color: "#939393",
                padding: 8
            },
            inactiveItems: {
                markers: {},
                labels: {}
            }
        }), It(zs.prototype, Os), Ds = Nn.extend({
            render: function() {
                this.createPieChart(this.series)
            },
            createPieChart: function(t) {
                var e = t[0],
                    i = new zs(this, {
                        series: t,
                        padding: e.padding,
                        startAngle: e.startAngle,
                        connectors: e.connectors,
                        legend: this.options.legend
                    });
                this.appendChart(i)
            },
            appendChart: function(t, e) {
                Nn.fn.appendChart.call(this, t, e), Ht(this.options.legend.items, t.legendItems)
            }
        }), Hs = Vs.extend({
            reflowLabel: function() {
                var t, e, i = this,
                    n = i.options.labels,
                    s = i.label,
                    o = this.sector.clone(),
                    r = o.middle();
                s && (t = s.box.height(), n.position === rt ? (o.radius -= (o.radius - o.innerRadius) / 2, e = o.point(r), s.reflow(new St(e.x, e.y - t / 2, e.x, e.y))) : Vs.fn.reflowLabel.call(this))
            },
            createSegment: function(t, e) {
                return J.ShapeBuilder.current.createRing(t, e)
            }
        }), kt(Hs, {
            overlay: {
                gradient: "roundedGlass"
            },
            labels: {
                position: rt
            },
            animation: {
                type: $e
            }
        }), It(Hs.prototype, Ji), Fs = 50, Ns = zs.extend({
            addValue: function(e, i, n) {
                var s, o = It({}, n.series, {
                    index: n.index
                });
                this.evalSegmentOptions(o, e, n), this.createLegendItem(e, o, n), e && n.visible !== !1 && (s = new Hs(e, i, o), t.extend(s, n), this.append(s), this.points.push(s))
            },
            reflow: function(t) {
                var e, i, n, s, o, r, a, h, l, c, u, p, d = this,
                    g = this.options,
                    f = t.clone(),
                    v = 5,
                    m = Math.min(f.width(), f.height()),
                    x = m / 2,
                    y = m - .85 * m,
                    _ = g.series,
                    w = _.length,
                    b = Et(g.padding, y);
                for (b = b > x - v ? x - v : b, e = x - b, i = 0, s = 0; s < w; s++) o = _[s], 0 === s && yt(o.holeSize) && (n = o.holeSize, e -= o.holeSize), yt(o.size) ? e -= o.size : i++, yt(o.margin) && s !== w - 1 && (e -= o.margin);
                for (yt(n) || (r = (x - b) / (w + .75), n = .75 * r, e -= n), a = n, h = 0, this.seriesConfigs = [], u = 0; u < w; u++) p = _[u], l = Et(p.size, e / i), a += h, c = a + l, d.seriesConfigs.push({
                    innerRadius: a,
                    radius: c
                }), h = p.margin || 0, a = c;
                zs.fn.reflow.call(this, t)
            },
            animationDelay: function(t, e, i) {
                return t * Fs + _e * (e + 1) / (i + 1)
            }
        }), kt(Ns, {
            startAngle: 90,
            connectors: {
                width: 2,
                color: "#939393",
                padding: 8
            }
        }), Gs = Ds.extend({
            render: function() {
                this.createDonutChart(this.series)
            },
            createDonutChart: function(t) {
                var e = t[0],
                    i = new Ns(this, {
                        series: t,
                        padding: e.padding,
                        connectors: e.connectors,
                        legend: this.options.legend
                    });
                this.appendChart(i)
            }
        }), qs = .15, Ws = Nn.extend({
            initFields: function() {
                this.valueAxisRangeTracker = new fn
            },
            render: function() {
                this.addToLegend(this.series), this.createPolarAxis(), this.createCharts(), this.createValueAxis()
            },
            alignAxes: function() {
                var t = this.valueAxis,
                    e = t.range(),
                    i = t.options.reverse ? e.max : e.min,
                    n = t.getSlot(i),
                    s = this.polarAxis.getSlot(0).center,
                    o = t.box.translate(s.x - n.x1, s.y - n.y1);
                t.reflow(o)
            },
            createValueAxis: function() {
                var t, e, i, n, s = this.valueAxisRangeTracker,
                    o = s.query(),
                    r = this.valueAxisOptions({
                        roundToMajorUnit: !1,
                        zIndex: -1
                    });
                r.type === Fi ? (t = J.RadarLogarithmicAxis, e = {
                    min: .1,
                    max: 1
                }) : (t = J.RadarNumericAxis, e = {
                    min: 0,
                    max: 1
                }), i = s.query(name) || o || e, i && o && (i.min = Math.min(i.min, o.min), i.max = Math.max(i.max, o.max)), n = new t(i.min, i.max, r, this.chartService), this.valueAxis = n, this.appendAxis(n)
            },
            reflowAxes: function() {
                var t, e, i = this,
                    n = i.options.plotArea,
                    s = i.valueAxis,
                    o = i.polarAxis,
                    r = i.box,
                    a = Math.min(r.width(), r.height()) * qs,
                    h = zt(n.padding || {}, a),
                    l = r.clone().unpad(h),
                    c = l.clone();
                c.y2 = c.y1 + Math.min(c.width(), c.height()), c.align(l, dt, rt), t = c.clone().shrink(0, c.height() / 2), o.reflow(c), s.reflow(t), e = s.lineBox().height() - s.box.height(), s.reflow(s.box.unpad({
                    top: e
                })), this.axisBox = c, this.alignAxes(c)
            },
            backgroundBox: function() {
                return this.box
            },
            detachLabels: function() {}
        }), Xs = Tn.extend({
            pointSlot: function(t, e) {
                var i = t.center.y - e.y1,
                    n = At.onCircle(t.center, t.startAngle, i);
                return new St(n.x, n.y, n.x, n.y)
            }
        }), kt(Xs, {
            clip: !1
        }), Zs = Rs.extend({}), Zs.prototype.pointSlot = Xs.prototype.pointSlot, kt(Zs, {
            clip: !1
        }), Us = dn.extend({
            fillToAxes: function(t) {
                var e = this._polarAxisCenter();
                t.lineTo(e.x, e.y)
            },
            _polarAxisCenter: function() {
                var t = this.parent.plotArea.polarAxis,
                    e = t.box.center();
                return e
            },
            strokeSegments: function() {
                var t, e, i, n = this._strokeSegments;
                return n || (t = this._polarAxisCenter(), e = new Dt((!1)), i = this.points(), i.push(t), n = this._strokeSegments = e.process(i), n.pop()), n
            }
        }), Ys = un.extend({
            fillToAxes: function(t) {
                var e = this.parent.plotArea.polarAxis,
                    i = e.box.center(),
                    n = new re.Segment([i.x, i.y]);
                t.segments.unshift(n), t.segments.push(n)
            }
        }), js = Zs.extend({
            createSegment: function(t, e, i) {
                var n, s = (e.line || {}).style;
                return n = s === De ? new Us(t, e, i) : new Ys(t, e, i)
            },
            createMissingValue: function(t, e) {
                var i;
                return p(t.x) && e !== Me && (i = {
                    x: t.x,
                    y: t.y
                }, e === Le && (i.y = 0)), i
            },
            seriesMissingValues: function(t) {
                return t.missingValues || Le
            },
            _hasMissingValuesGap: function() {
                var t, e = this,
                    i = this.options.series;
                for (t = 0; t < i.length; t++)
                    if (e.seriesMissingValues(i[t]) === Oe) return !0
            },
            sortPoints: function(t) {
                var e, i, n, s = this;
                if (t.sort(N), this._hasMissingValuesGap())
                    for (e = 0; e < t.length; e++) i = t[e], i && (n = i.value, p(n.y) || s.seriesMissingValues(i.series) !== Oe || delete t[e]);
                return t
            }
        }), Ks = Ws.extend({
            createPolarAxis: function() {
                var t = new J.PolarAxis(this.options.xAxis, this.chartService);
                this.polarAxis = t, this.axisX = t, this.appendAxis(t)
            },
            valueAxisOptions: function(t) {
                return It(t, {
                    majorGridLines: {
                        type: xt
                    },
                    minorGridLines: {
                        type: xt
                    }
                }, this.options.yAxis)
            },
            createValueAxis: function() {
                Ws.fn.createValueAxis.call(this), this.axisY = this.valueAxis
            },
            appendChart: function(t, e) {
                this.valueAxisRangeTracker.update(t.yAxisRanges), Nn.prototype.appendChart.call(this, t, e)
            },
            createCharts: function() {
                var t = this.filterVisibleSeries(this.series),
                    e = this.panes[0];
                this.createLineChart(y(t, [ti]), e), this.createScatterChart(y(t, [ei]), e), this.createAreaChart(y(t, [Je]), e)
            },
            createLineChart: function(t, e) {
                if (0 !== t.length) {
                    var i = new Zs(this, {
                        series: t
                    });
                    this.appendChart(i, e)
                }
            },
            createScatterChart: function(t, e) {
                if (0 !== t.length) {
                    var i = new Xs(this, {
                        series: t
                    });
                    this.appendChart(i, e)
                }
            },
            createAreaChart: function(t, e) {
                if (0 !== t.length) {
                    var i = new js(this, {
                        series: t
                    });
                    this.appendChart(i, e)
                }
            },
            _dispatchEvent: function(t, e, i) {
                var n = t._eventCoordinates(e),
                    s = new At(n.x, n.y),
                    o = this.axisX.getValue(s),
                    r = this.axisY.getValue(s);
                null !== o && null !== r && t.trigger(i, {
                    element: Lt(e),
                    x: o,
                    y: r
                })
            },
            createCrosshairs: function() {}
        }), kt(Ks, {
            xAxis: {},
            yAxis: {}
        }), It(Ks.prototype, qn), Qs = cn.extend({
            pointSlot: function(t, e) {
                var i = t.center.y - e.y1,
                    n = At.onCircle(t.center, t.middle(), i);
                return new St(n.x, n.y, n.x, n.y)
            },
            createSegment: function(t, e, i) {
                var n, s, o = e.style;
                return n = o === De ? rn : nn, s = new n(t, e, i), t.length === e.data.length && (s.options.closed = !0), s
            }
        }), kt(Qs, {
            clip: !1,
            limitPoints: !1
        }), $s = dn.extend({
            fillToAxes: function() {}
        }), Js = un.extend({
            fillToAxes: function() {}
        }), to = Qs.extend({
            createSegment: function(t, e, i, n) {
                var s, o, r, a = this.options.isStacked,
                    h = (e.line || {}).style;
                return a && i > 0 && n && (o = n.linePoints.slice(0), s = n), h === De ? (r = new $s(t, e, i, s, o), r.options.closed = !0) : (t.push(t[0]), r = new Js(t, e, i, s, o)), r
            },
            seriesMissingValues: function(t) {
                return t.missingValues || Le
            }
        }), eo = Hs.extend({
            init: function(t, e) {
                Hs.fn.init.call(this, t, null, e)
            }
        }), kt(eo, {
            overlay: {
                gradient: "none"
            },
            labels: {
                distance: 10
            }
        }), io = bt.extend({
            init: function(t) {
                bt.fn.init.call(this, t), this.forEach = t.rtl ? c : l
            },
            reflow: function(t) {
                var e = this,
                    i = e.options,
                    n = e.children,
                    s = i.gap,
                    o = i.spacing,
                    r = n.length,
                    a = r + s + o * (r - 1),
                    h = t.angle / a,
                    l = t.startAngle + h * (s / 2);
                this.forEach(n, function(e) {
                    var i = t.clone();
                    i.startAngle = l, i.angle = h, e.sector && (i.radius = e.sector.radius), e.reflow(i), e.sector = i, l += h + h * o
                })
            }
        }), kt(io, {
            gap: 1,
            spacing: 0
        }), no = bt.extend({
            reflow: function(t) {
                var e, i, n = this,
                    s = n.options.reverse,
                    o = n.children,
                    r = o.length,
                    a = s ? r - 1 : 0,
                    h = s ? -1 : 1;
                for (this.box = new St, e = a; e >= 0 && e < r; e += h) i = o[e].sector, i.startAngle = t.startAngle, i.angle = t.angle
            }
        }), so = wn.extend({
            pointType: function() {
                return eo
            },
            clusterType: function() {
                return io
            },
            stackType: function() {
                return no
            },
            categorySlot: function(t, e) {
                return t.getSlot(e)
            },
            pointSlot: function(t, e) {
                var i = t.clone(),
                    n = t.center.y;
                return i.radius = n - e.y1, i.innerRadius = n - e.y2, i
            },
            reflowPoint: function(t, e) {
                t.sector = e, t.reflow()
            },
            createAnimation: function() {
                this.options.animation.center = this.box.toRect().center(), wn.fn.createAnimation.call(this)
            }
        }), so.prototype.reflow = $i.prototype.reflow, kt(so, {
            clip: !1,
            limitPoints: !1,
            animation: {
                type: "pie"
            }
        }), oo = Ws.extend({
            createPolarAxis: function() {
                var t = new J.RadarCategoryAxis(this.options.categoryAxis, this.chartService);
                this.polarAxis = t, this.categoryAxis = t, this.appendAxis(t), this.aggregateCategories(), this.createCategoryAxesLabels()
            },
            valueAxisOptions: function(t) {
                return this._hasBarCharts && It(t, {
                    majorGridLines: {
                        type: xt
                    },
                    minorGridLines: {
                        type: xt
                    }
                }), this._isStacked100 && It(t, {
                    roundToMajorUnit: !1,
                    labels: {
                        format: "P0"
                    }
                }), It(t, this.options.valueAxis)
            },
            aggregateCategories: function() {
                ls.prototype.aggregateCategories.call(this, this.panes)
            },
            createCategoryAxesLabels: function() {
                ls.prototype.createCategoryAxesLabels.call(this, this.panes)
            },
            filterSeries: function(t) {
                return t
            },
            createCharts: function() {
                var t = this.filterVisibleSeries(this.series),
                    e = this.panes[0];
                this.createAreaChart(y(t, [ii]), e), this.createLineChart(y(t, [si]), e), this.createBarChart(y(t, [ni]), e)
            },
            chartOptions: function(t) {
                var e, i, n = {
                        series: t
                    },
                    s = t[0];
                return s && (e = this.filterVisibleSeries(t), i = s.stack, n.isStacked = i && e.length > 1, n.isStacked100 = i && "100%" === i.type && e.length > 1, n.isStacked100 && (this._isStacked100 = !0)), n
            },
            createAreaChart: function(t, e) {
                if (0 !== t.length) {
                    var i = new to(this, this.chartOptions(t));
                    this.appendChart(i, e)
                }
            },
            createLineChart: function(t, e) {
                if (0 !== t.length) {
                    var i = new Qs(this, this.chartOptions(t));
                    this.appendChart(i, e)
                }
            },
            createBarChart: function(t, e) {
                var i, n, s;
                0 !== t.length && (i = t[0], n = this.chartOptions(t), n.gap = i.gap, n.spacing = i.spacing, s = new so(this, n), this.appendChart(s, e), this._hasBarCharts = !0)
            },
            seriesCategoryAxis: function() {
                return this.categoryAxis
            },
            _dispatchEvent: function(t, e, i) {
                var n = t._eventCoordinates(e),
                    s = new At(n.x, n.y),
                    o = this.categoryAxis.getCategory(s),
                    r = this.valueAxis.getValue(s);
                null !== o && null !== r && t.trigger(i, {
                    element: Lt(e),
                    category: o,
                    value: r
                })
            },
            createCrosshairs: function() {}
        }), It(oo.prototype, qn, {
            appendChart: ls.prototype.appendChart,
            aggregateSeries: ls.prototype.aggregateSeries,
            seriesSourcePoints: ls.prototype.seriesSourcePoints
        }), kt(oo, {
            categoryAxis: {
                categories: []
            },
            valueAxis: {}
        }), ro = bt.extend({
            init: function(t, e, i) {
                bt.fn.init.call(this, e), this.value = t, this.options.index = i.index
            },
            reflow: function(t) {
                var e = this.points,
                    i = this.children[0];
                this.box = new St(e[0].x, e[0].y, e[1].x, e[2].y), i && i.reflow(new St(t.x1, e[0].y, t.x2, e[2].y))
            },
            createVisual: function() {
                var t, e = this,
                    i = this.options;
                bt.fn.createVisual.call(this), t = i.visual ? i.visual({
                    category: this.category,
                    dataItem: this.dataItem,
                    value: this.value,
                    series: this.series,
                    percentage: this.percentage,
                    points: this.points,
                    options: i,
                    sender: this.getSender(),
                    createVisual: function() {
                        return e.createPath()
                    }
                }) : this.createPath(), t && this.visual.append(t)
            },
            createPath: function() {
                var t = this.options,
                    e = t.border,
                    i = ee.fromPoints(this.points, {
                        fill: {
                            color: t.color,
                            opacity: t.opacity
                        },
                        stroke: {
                            color: e.color,
                            opacity: e.opacity,
                            width: e.width
                        }
                    }).close();
                return i
            },
            createHighlight: function(t) {
                return ee.fromPoints(this.points, t)
            },
            highlightVisual: function() {
                return this.visual.children[0]
            },
            highlightVisualArgs: function() {
                var t = ee.fromPoints(this.points).close();
                return {
                    options: this.options,
                    path: t
                }
            },
            tooltipAnchor: function() {
                var t = this.box;
                return {
                    point: new At(t.center().x, t.y1),
                    align: {
                        horizontal: "center",
                        vertical: "top"
                    }
                }
            },
            formatValue: function(t) {
                var e = this;
                return e.owner.formatPointValue(e, t)
            }
        }), kt(ro, {
            color: ct,
            border: {
                width: 1
            }
        }), It(ro.prototype, Ji), ao = bt.extend({
            init: function(t, e) {
                bt.fn.init.call(this, e), this.plotArea = t, this.points = [], this.labels = [], this.legendItems = [], this.render()
            },
            formatPointValue: function(t, e) {
                return this.chartService.format.auto(e, t.value)
            },
            render: function() {
                var t, e, i, n, s, o, r, a, h, l, c, u = this,
                    p = this,
                    d = p.options,
                    g = p.plotArea.options.seriesColors;
                if (void 0 === g && (g = []), t = d.series[0], e = t.data)
                    for (i = m(t), n = i.total, s = i.points, o = 0; o < s.length; o++) r = s[o], r && (a = r.fields, Tt(t.color) || (t.color = a.color || g[o % g.length]), a = It({
                        index: o,
                        owner: u,
                        series: t,
                        dataItem: e[o],
                        percentage: r.value / n
                    }, a, {
                        visible: r.visible
                    }), h = r.valueFields.value, l = u.createSegment(h, a), c = u.createLabel(h, a), l && c && l.append(c))
            },
            evalSegmentOptions: function(t, e, i) {
                var n = i.series;
                s(t, {
                    value: e,
                    series: n,
                    dataItem: i.dataItem,
                    index: i.index
                }, {
                    defaults: n._defaults,
                    excluded: ["data", "content", "template", "toggle", "visual"]
                })
            },
            createSegment: function(e, i) {
                var n, s = It({}, i.series);
                if (this.evalSegmentOptions(s, e, i), this.createLegendItem(e, s, i), i.visible !== !1) return n = new ro(e, s, i), t.extend(n, i), this.append(n), this.points.push(n), n
            },
            createLabel: function(t, e) {
                var i, n, s, o, r = e.series,
                    a = e.dataItem,
                    h = It({}, this.options.labels, r.labels),
                    l = t;
                if (h.visible) return i = Mt(h), n = {
                    dataItem: a,
                    value: t,
                    percentage: e.percentage,
                    category: e.category,
                    series: r
                }, i ? l = i(n) : h.format && (l = this.plotArea.chartService.format.auto(h.format, l)), h.color || (s = new oe(r.color).percBrightness(), h.color = s > 180 ? ft : ct, h.background || (h.background = r.color)), this.evalSegmentOptions(h, t, e), o = new Ot(l, It({
                    vAlign: h.position
                }, h), n), this.labels.push(o), o
            },
            labelPadding: function() {
                var t, e, i, n, s = this.labels,
                    o = {
                        left: 0,
                        right: 0
                    };
                for (t = 0; t < s.length; t++) e = s[t], i = e.options.align, i !== rt && (n = s[t].box.width(), i === lt ? o.left = Math.max(o.left, n) : o.right = Math.max(o.right, n));
                return o
            },
            dynamicSlopeReflow: function(t, e, i) {
                var n, s, o, r, a, h, l, c, u, p, d, g = this,
                    f = g.options,
                    v = g.points,
                    m = v.length,
                    x = v[0],
                    y = x;
                for (n = 0; n < v.length; n++) v[n].percentage > y.percentage && (y = v[n]);
                for (s = x.percentage / y.percentage * e, o = (e - s) / 2, r = 0, a = 0; a < m; a++) h = v[a].percentage, l = v[a + 1], c = l ? l.percentage : h, u = v[a].points = [], p = f.dynamicHeight ? i * h : i / m, d = void 0, d = h ? (e - s * (c / h)) / 2 : c ? 0 : e / 2, d = Zt(d, 0, e), u.push(new ae(t.x1 + o, t.y1 + r)), u.push(new ae(t.x1 + e - o, t.y1 + r)), u.push(new ae(t.x1 + e - d, t.y1 + p + r)), u.push(new ae(t.x1 + d, t.y1 + p + r)), o = d, r += p + f.segmentSpacing, s = Zt(e - 2 * d, 0, e)
            },
            constantSlopeReflow: function(t, e, i) {
                var n, s, o, r, a, h = this,
                    l = h.options,
                    c = h.points,
                    u = c.length,
                    p = l.neckRatio <= 1,
                    d = p ? l.neckRatio * e : e,
                    g = p ? 0 : (e - e / l.neckRatio) / 2,
                    f = p ? e : e - 2 * g,
                    v = (f - d) / 2,
                    m = 0;
                for (n = 0; n < u; n++) s = c[n].points = [], o = c[n].percentage, r = l.dynamicHeight ? v * o : v / u, a = l.dynamicHeight ? i * o : i / u, s.push(new ae(t.x1 + g, t.y1 + m)), s.push(new ae(t.x1 + e - g, t.y1 + m)), s.push(new ae(t.x1 + e - g - r, t.y1 + a + m)), s.push(new ae(t.x1 + g + r, t.y1 + a + m)), g += r, m += a + l.segmentSpacing
            },
            reflow: function(t) {
                var e, i, n, s, o, r = this.points,
                    a = r.length;
                if (a)
                    for (e = this.options, i = t.clone().unpad(this.labelPadding()), n = i.height() - e.segmentSpacing * (a - 1), s = i.width(), e.dynamicSlope ? this.dynamicSlopeReflow(i, s, n) : this.constantSlopeReflow(i, s, n), o = 0; o < a; o++) r[o].reflow(t)
            }
        }), kt(ao, {
            neckRatio: .3,
            width: 300,
            dynamicSlope: !1,
            dynamicHeight: !0,
            segmentSpacing: 0,
            labels: {
                visible: !1,
                align: rt,
                position: rt,
                zIndex: 1
            }
        }), It(ao.prototype, Os), ho = Nn.extend({
            render: function() {
                this.createFunnelChart(this.series)
            },
            createFunnelChart: function(t) {
                var e = t[0],
                    i = new ao(this, {
                        series: t,
                        legend: this.options.legend,
                        neckRatio: e.neckRatio,
                        dynamicHeight: e.dynamicHeight,
                        dynamicSlope: e.dynamicSlope,
                        segmentSpacing: e.segmentSpacing,
                        highlight: e.highlight
                    });
                this.appendChart(i)
            },
            appendChart: function(t, e) {
                Nn.fn.appendChart.call(this, t, e), Ht(this.options.legend.items, t.legendItems)
            }
        }), lo = "color", co = "first", uo = "from", po = "max", go = "min", fo = "noteText", vo = "summary", mo = "to", _s.current.register(ls, [Ne, Ze, Ke, di, Fe, ci, Xe, Qe, We, pi, Ge, ui, ai, ri, fi, je, oi, gi]), _s.current.register(Is, [hi, li, qe]), _s.current.register(Ds, [$e]), _s.current.register(Gs, [Ue]), _s.current.register(ho, [Ye]), _s.current.register(Ks, [Je, ti, ei]), _s.current.register(oo, [ii, ni, si]), de.current.register([Ne, Ze, Ke, di, Fe, ci], [ot], [Ni, lo, fo, ke, Pe]), de.current.register([ai, ri, oi, gi], [uo, mo], [Ni, lo, fo]), de.current.register([fi, je], [ot], [Ni, lo, fo, vo]), de.current.register([Je, ti, ei], [pt, dt], [lo]), de.current.register([ii, ni, si], [ot], [lo]), de.current.register([Ye], [ot], [Ni, lo, "visibleInLegend", "visible"]), Xn.current.register([Ne, Ze, Ke, di, Fe, ci, fi, je], {
            value: po,
            color: co,
            noteText: co,
            errorLow: go,
            errorHigh: po
        }), Xn.current.register([ai, ri, oi, gi], {
            from: go,
            to: po,
            color: co,
            noteText: co
        }), Xn.current.register([ii, ni, si], {
            value: po,
            color: co
        }), de.current.register([hi, li, qe], [pt, dt], [lo, fo, Te, Ee, Re, Ie]), de.current.register([qe], [pt, dt, "size"], [lo, Ni, fo]), de.current.register([Xe, Qe], ["open", "high", "low", "close"], [Ni, lo, "downColor", fo]), Xn.current.register([Xe, Qe], {
            open: po,
            high: po,
            low: go,
            close: po,
            color: co,
            downColor: co,
            noteText: co
        }), de.current.register([Ge, ui], ["lower", "q1", "median", "q3", "upper", "mean", "outliers"], [Ni, lo, fo]), Xn.current.register([Ge, ui], {
            lower: po,
            q1: po,
            median: po,
            q3: po,
            upper: po,
            mean: po,
            outliers: co,
            color: co,
            noteText: co
        }), de.current.register([We, pi], ["current", "target"], [Ni, lo, "visibleInLegend", fo]), Xn.current.register([We, pi], {
            current: po,
            target: po,
            color: co,
            noteText: co
        }), de.current.register([$e, Ue], [ot], [Ni, lo, "explode", "visibleInLegend", "visible"]), xo = [Ni, ot, pt, dt], yo = "mousemove", _o = "contextmenu", wo = "mouseleave", bo = 20, Ao = tt.extend({
            init: function(t, e, i, n) {
                var s, o = this;
                void 0 === n && (n = {}), this.observers = [], this.addObserver(n.observer), this.chartService = new Qt.ChartService(this, n), this.chartService.theme = i, this._initElement(t), s = It({}, this.options, e), this._originalOptions = It({}, s), this._theme = i, this._initTheme(s, i), this._initHandlers(), this._initSurface(), this.bindCategories(), J.FontLoader.preloadFonts(e, function() {
                    o.fontLoaded = !0, o._destroyed || (o.trigger("init"), o._redraw(), o._attachEvents())
                })
            },
            _initElement: function(t) {
                for (this._setElementClass(t), t.style.position = "relative"; t.firstChild;) t.removeChild(t.firstChild);
                this.element = t
            },
            _setElementClass: function(t) {
                J.addClass(t, "k-chart")
            },
            _initTheme: function(e, i) {
                var n, s = [],
                    o = e.series || [];
                for (n = 0; n < o.length; n++) s.push(t.extend({}, o[n]));
                e.series = s, G(e), this.applyDefaults(e, i), null === e.seriesColors && delete e.seriesColors, this.options = It({}, i, e), this.applySeriesColors()
            },
            getSize: function() {
                var t = this.options.chartArea || {},
                    e = t.width ? parseInt(t.width, 10) : Math.floor(this.element.offsetWidth),
                    i = t.height ? parseInt(t.height, 10) : Math.floor(this.element.offsetHeight);
                return {
                    width: e,
                    height: i
                }
            },
            resize: function(t) {
                var e = this.getSize(),
                    i = this._size;
                (t || (e.width > 0 || e.height > 0) && (!i || e.width !== i.width || e.height !== i.height)) && (this._size = e, this._resize(e, t), this.trigger("resize", e))
            },
            _resize: function() {
                this._noTransitionsRedraw()
            },
            redraw: function(t) {
                var e, i;
                this.applyDefaults(this.options), this.applySeriesColors(), t ? (e = this._model._plotArea, i = e.findPane(t), e.redraw(i)) : this._redraw()
            },
            getAxis: function(t) {
                return e(t, this._plotArea.axes)
            },
            findAxisByName: function(t) {
                return this.getAxis(t)
            },
            findPaneByName: function(t) {
                var e, i = this._plotArea.panes;
                for (e = 0; e < i.length; e++)
                    if (i[e].options.name === t) return new ce(i[e])
            },
            findPaneByIndex: function(t) {
                var e = this._plotArea.panes;
                if (e[t]) return new ce(e[t])
            },
            plotArea: function() {
                return new ue(this._plotArea)
            },
            toggleHighlight: function(t, e) {
                var i, n, s, o = this._plotArea,
                    r = (o.srcSeries || o.series || [])[0];
                Tt(e) ? i = o.filterPoints(e) : (Rt(e) ? (n = e.series, s = e.category) : n = s = e, i = r.type === Ue ? q(o.pointsBySeriesName(n), s) : r.type === $e || r.type === Ye ? q((o.charts[0] || {}).points, s) : o.pointsBySeriesName(n)), i && this.togglePointsHighlight(t, i)
            },
            togglePointsHighlight: function(t, e) {
                var i, n = this._highlight;
                for (i = 0; i < e.length; i++) n.togglePointHighlight(e[i], t)
            },
            showTooltip: function(t) {
                var e, i, n, s = this._sharedTooltip(),
                    o = this,
                    r = o._tooltip,
                    a = o._plotArea;
                Tt(t) ? (e = a.findPoint(t), e && s && (i = e.categoryIx)) : s && yt(t) && (i = a.categoryAxis.categoryIndex(t)), s ? i >= 0 && (n = this._plotArea.pointsByCategoryIndex(i), r.showAt(n)) : e && r.show(e)
            },
            hideTooltip: function() {
                this._tooltip.hide()
            },
            _initSurface: function() {
                var t = this.surface,
                    e = this._surfaceWrap(),
                    i = this.options.chartArea;
                i.width && J.elementSize(e, {
                    width: i.width
                }), i.height && J.elementSize(e, {
                    height: i.height
                }), t && t.options.type === this.options.renderAs ? (this.surface.clear(), this.surface.resize()) : (this._destroySurface(), this.surface = te.Surface.create(e, {
                    type: this.options.renderAs
                }), this.surface.bind("mouseenter", this._surfaceMouseenterHandler), this.surface.bind("mouseleave", this._surfaceMouseleaveHandler))
            },
            _surfaceWrap: function() {
                return this.element
            },
            _redraw: function() {
                var t = this._getModel();
                this._size = {
                    width: t.options.width,
                    height: t.options.height
                }, this._destroyView(), this._model = t, this._plotArea = t._plotArea, t.renderVisual(), this.options.transitions !== !1 && t.traverse(function(t) {
                    t.animation && t.animation.setup()
                }), this._initSurface(), this.surface.draw(t.visual), this.options.transitions !== !1 && t.traverse(function(t) {
                    t.animation && t.animation.play()
                }), this._tooltip = this._createTooltip(), this._highlight = new cs, this._setupSelection(), this._createPannable(), this._createZoomSelection(), this._createMousewheelZoom(), this.trigger(Bi), $(this._plotArea.panes), this._navState || this._cancelDomEvents()
            },
            exportVisual: function(t) {
                var e, i, n, s;
                return t && (t.width || t.height || t.options) ? (i = this.options, n = It({}, t.options, {
                    chartArea: {
                        width: t.width,
                        height: t.height
                    }
                }), Q(this._originalOptions, n), this.options = It({}, this._originalOptions, n), this._initTheme(this.options, this._theme), this.bindCategories(), s = this._getModel(), s.renderVisual(), $(s._plotArea.panes), e = s.visual, this.options = i) : e = this.surface.exportVisual(), e
            },
            _sharedTooltip: function() {
                return this._plotArea instanceof ls && this.options.tooltip.shared
            },
            _createPannable: function() {
                var t = this.options;
                t.pannable !== !1 && (this._pannable = new us(this._plotArea, t.pannable))
            },
            _createZoomSelection: function() {
                var t = this.options.zoomable,
                    e = (t || {}).selection;
                t !== !1 && e !== !1 && (this._zoomSelection = new ps(this, e))
            },
            _createMousewheelZoom: function() {
                var t = this.options.zoomable,
                    e = (t || {}).mousewheel;
                t !== !1 && e !== !1 && (this._mousewheelZoom = new ds(this, e))
            },
            _toggleDragZoomEvents: function() {
                var t = this.options.pannable,
                    e = this.options.zoomable,
                    i = (e || {}).selection,
                    n = (e || {}).mousewheel,
                    s = !(t || e !== !1 && i !== !1 || this.requiresHandlers([Ei, Pi, Ti])),
                    o = (e === !1 || n === !1) && !this.requiresHandlers([Ri, Ii, Vi]),
                    r = this.element;
                this._dragZoomEnabled && s && o ? (r.style.touchAction = this._touchAction || "", this._dragZoomEnabled = !1) : this._dragZoomEnabled || s && o || (r.style.touchAction = "none", this._dragZoomEnabled = !0), this._toggleDomEvents(!s, !o)
            },
            _toggleDomEvents: function(t, e) {
                var i = this.domEvents;
                i && (i.toggleDrag && i.toggleDrag(t), i.toggleZoom && i.toggleZoom(e))
            },
            _createTooltip: function() {
                var t, e = this,
                    i = e.options.tooltip;
                return t = this._sharedTooltip() ? this._createSharedTooltip(i) : new Ss(this.chartService, i)
            },
            _createSharedTooltip: function(t) {
                return new Cs(this._plotArea, t)
            },
            applyDefaults: function(t, e) {
                W(t, e), X(t, e)
            },
            applySeriesColors: function() {
                var t, e, i, n, s = this.options,
                    o = s.series,
                    r = s.seriesColors || [];
                for (t = 0; t < o.length; t++) e = o[t], i = r[t % r.length], n = e._defaults, e.color = e.color || i, n && (n.color = n.color || i)
            },
            _getModel: function() {
                var t = this.options,
                    e = this._createPlotArea(),
                    i = new J.RootElement(this._modelOptions());
                return i.chart = this, i._plotArea = e, J.Title.buildTitle(t.title, i), t.legend.visible && i.append(new ys(e.options.legend, this.chartService)), i.append(e), i.reflow(), i
            },
            _modelOptions: function() {
                var t = this.options,
                    e = this.getSize();
                return It({
                    transitions: t.transitions,
                    width: e.width || it.DEFAULT_WIDTH,
                    height: e.height || it.DEFAULT_HEIGHT
                }, t.chartArea)
            },
            _createPlotArea: function(t) {
                var e = this.options,
                    i = _s.current.create(t ? [] : e.series, e, this.chartService);
                return i
            },
            _setupSelection: function() {
                var t, e, i, n, s, o = this,
                    r = this,
                    a = r._plotArea.axes,
                    h = this._selections = [];
                for (t = 0; t < a.length; t++) e = a[t], i = e.options, e instanceof qt && i.select && !i.vertical && (n = e.range(), s = new As(o, e, It({
                    min: n.min,
                    max: n.max
                }, i.select)), h.push(s))
            },
            _selectStart: function(t) {
                return this.trigger(Li, t)
            },
            _select: function(t) {
                return this.trigger(Mi, t)
            },
            _selectEnd: function(t) {
                return this.trigger(Oi, t)
            },
            _initHandlers: function() {
                this._clickHandler = this._click.bind(this), this._mousewheelHandler = this._mousewheel.bind(this), this._mouseleaveHandler = this._mouseleave.bind(this), this._surfaceMouseenterHandler = this._mouseover.bind(this), this._surfaceMouseleaveHandler = this._mouseout.bind(this), this._mousemove = kendo.throttle(this._mousemove.bind(this), bo)
            },
            addObserver: function(t) {
                t && this.observers.push(t)
            },
            removeObserver: function(t) {
                var e = this.observers.indexOf(t);
                e >= 0 && this.observers.splice(e, 1)
            },
            requiresHandlers: function(t) {
                var e, i = this.observers;
                for (e = 0; e < i.length; e++)
                    if (i[e].requiresHandlers(t)) return !0
            },
            trigger: function(t, e) {
                var i, n, s;
                for (void 0 === e && (e = {}), t === zi && (e.anchor.point = this._toDocumentCoordinates(e.anchor.point)), e.sender = this, i = this.observers, n = !1, s = 0; s < i.length; s++) i[s].trigger(t, e) && (n = !0);
                return n
            },
            _attachEvents: function() {
                var t, e, i = this.element;
                this._touchAction = i.style.touchAction, Kt(i, (t = {}, t[_o] = this._clickHandler, t[Xi] = this._mousewheelHandler, t[wo] = this._mouseleaveHandler, t)), this._shouldAttachMouseMove() && Kt(i, (e = {}, e[yo] = this._mousemove, e)), this.domEvents = Qt.DomEventsBuilder.create(this.element, {
                    start: this._start.bind(this),
                    move: this._move.bind(this),
                    end: this._end.bind(this),
                    tap: this._tap.bind(this),
                    gesturestart: this._gesturestart.bind(this),
                    gesturechange: this._gesturechange.bind(this),
                    gestureend: this._gestureend.bind(this)
                }), this._toggleDragZoomEvents()
            },
            _mouseleave: function(t) {
                this._hoveredPoint && (this._hoveredPoint.out(this, t), this._hoveredPoint = null), this._plotArea.hovered && (this.trigger(ki), this._plotArea.hovered = !1)
            },
            _cancelDomEvents: function() {
                this.domEvents && this.domEvents.cancel && this.domEvents.cancel()
            },
            _gesturestart: function(t) {
                this._mousewheelZoom && !this._stopChartHandlers(t) && (this._gestureDistance = t.distance, this._unsetActivePoint(), this.surface.suspendTracking())
            },
            _gestureend: function(t) {
                this._zooming && !this._stopChartHandlers(t) && (this.surface && this.surface.resumeTracking(), this._zooming = !1, this.trigger(Vi, {}))
            },
            _gesturechange: function(t) {
                var e, i, n, s, o = this._mousewheelZoom;
                o && !this._stopChartHandlers(t) && (t.preventDefault(), e = this._gestureDistance, i = -t.distance / e + 1, Math.abs(i) >= .1 && (i = Math.round(10 * i), this._gestureDistance = t.distance, n = {
                    delta: i,
                    axisRanges: U(this._plotArea.axes),
                    originalEvent: t
                }, !this._zooming && this.trigger(Ri, n) || (this._zooming || (this._zooming = !0), s = n.axisRanges = o.updateRanges(i), s && !this.trigger(Ii, n) && o.zoom())))
            },
            _mouseout: function(t) {
                if (t.element) {
                    var e = this._drawingChartElement(t.element, t);
                    e && e.leave && e.leave(this, t.originalEvent)
                }
            },
            _start: function(t) {
                var e = this._eventCoordinates(t);
                !this._stopChartHandlers(t) && this._plotArea.backgroundContainsPoint(e) && (this.requiresHandlers([Ei, Pi, Ti]) && this._startNavigation(t, e, Ei), this._pannable && this._pannable.start(t) && (this.surface.suspendTracking(), this._unsetActivePoint(), this._suppressHover = !0, this.chartService.panning = !0), this._zoomSelection && this._zoomSelection.start(t) && this.trigger(Ri, {
                    axisRanges: U(this._plotArea.axes),
                    originalEvent: t
                }))
            },
            _move: function(t) {
                var e, i, n, s, o, r, a, h, l = this,
                    c = l._navState,
                    u = l._pannable;
                if (!this._stopChartHandlers(t)) {
                    if (u) e = u.move(t), e && !this.trigger(Pi, {
                        axisRanges: e,
                        originalEvent: t
                    }) && u.pan();
                    else if (c) {
                        for (i = {}, n = c.axes, s = 0; s < n.length; s++) o = n[s], r = o.options.name, r && (a = o.options.vertical ? t.y : t.x, h = a.startLocation - a.location, 0 !== h && (i[o.options.name] = o.translateRange(h)));
                        c.axisRanges = i, this.trigger(Pi, {
                            axisRanges: i,
                            originalEvent: t
                        })
                    }
                    this._zoomSelection && this._zoomSelection.move(t)
                }
            },
            _end: function(t) {
                var e, i;
                this._stopChartHandlers(t) || (e = this._pannable, e && e.end(t) ? (this.surface.resumeTracking(), this.trigger(Ti, {
                    axisRanges: U(this._plotArea.axes),
                    originalEvent: t
                }), this._suppressHover = !1, this.chartService.panning = !1) : this._endNavigation(t, Ti), this._zoomSelection && (i = this._zoomSelection.end(t), i && !this.trigger(Ii, {
                    axisRanges: i,
                    originalEvent: t
                }) && (this._zoomSelection.zoom(), this.trigger(Vi, {
                    axisRanges: i,
                    originalEvent: t
                }))))
            },
            _stopChartHandlers: function(t) {
                var e, i, n, s = this._selections || [];
                if (!s.length) return !1;
                if (e = this._eventCoordinates(t), i = this._plotArea.paneByPoint(e))
                    for (n = 0; n < s.length; n++)
                        if (s[n].onPane(i)) return !0
            },
            _mousewheel: function(t) {
                var e, i, n, s, o, r, a, h, l, c = this,
                    u = J.mousewheelDelta(t),
                    p = this._mousewheelZoom,
                    d = this._eventCoordinates(t);
                if (!this._stopChartHandlers(t) && this._plotArea.backgroundContainsPoint(d))
                    if (p) e = {
                        delta: u,
                        axisRanges: U(this._plotArea.axes),
                        originalEvent: t
                    }, !this._zooming && this.trigger(Ri, e) || (t.preventDefault(), this._zooming || (this._unsetActivePoint(), this.surface.suspendTracking(), this._zooming = !0), this._mwTimeout && clearTimeout(this._mwTimeout), e.axisRanges = p.updateRanges(u), e.axisRanges && !this.trigger(Ii, e) && p.zoom(), this._mwTimeout = setTimeout(function() {
                        c.trigger(Vi, e), c._zooming = !1, c.surface && c.surface.resumeTracking()
                    }, Zi));
                    else if (i = this._navState, i || (n = this._startNavigation(t, d, Ri), n || (i = this._navState)), i) {
                    for (s = i.totalDelta || u, i.totalDelta = s + u, o = this._navState.axes, r = {}, a = 0; a < o.length; a++) h = o[a], l = h.options.name, l && (r[l] = h.scaleRange(-s));
                    this.trigger(Ii, {
                        delta: u,
                        axisRanges: r,
                        originalEvent: t
                    }), this._mwTimeout && clearTimeout(this._mwTimeout), this._mwTimeout = setTimeout(function() {
                        c._endNavigation(t, Vi)
                    }, Zi)
                }
            },
            _startNavigation: function(t, e, i) {
                var n, s, o = this._model._plotArea,
                    r = o.findPointPane(e),
                    a = o.axes.slice(0);
                r && (n = U(a), s = this.trigger(i, {
                    axisRanges: n,
                    originalEvent: t
                }), s ? this._cancelDomEvents() : (this._suppressHover = !0, this._unsetActivePoint(), this._navState = {
                    axisRanges: n,
                    pane: r,
                    axes: a
                }))
            },
            _endNavigation: function(t, e) {
                this._navState && (this.trigger(e, {
                    axisRanges: this._navState.axisRanges,
                    originalEvent: t
                }), this._suppressHover = !1, this._navState = null)
            },
            _getChartElement: function(t, e) {
                var i = this.surface.eventTarget(t);
                if (i) return this._drawingChartElement(i, t, e)
            },
            _drawingChartElement: function(t, e, i) {
                for (var n, s = t; s && !n;) n = s.chartElement, s = s.parent;
                if (n) return n.aliasFor && (n = n.aliasFor(e, this._eventCoordinates(e))), i && (n = n.closest(i), n && n.aliasFor && (n = n.aliasFor())), n
            },
            _eventCoordinates: function(t) {
                var e = J.eventCoordinates(t);
                return this._toModelCoordinates(e.x, e.y)
            },
            _elementPadding: function() {
                var t, e, i;
                return this._padding || (t = Yt(this.element, ["paddingLeft", "paddingTop"]), e = t.paddingLeft, i = t.paddingTop, this._padding = {
                    top: i,
                    left: e
                }), this._padding
            },
            _toDocumentCoordinates: function(t) {
                var e = this._elementPadding(),
                    i = J.elementOffset(this.element);
                return {
                    left: Xt(t.x + e.left + i.left),
                    top: Xt(t.y + e.top + i.top)
                }
            },
            _toModelCoordinates: function(t, e) {
                var i = this.element,
                    n = J.elementOffset(i),
                    s = this._elementPadding();
                return new At(t - n.left - s.left, e - n.top - s.top)
            },
            _tap: function(t) {
                var e = this,
                    i = this.surface.eventTarget(t),
                    n = this._drawingChartElement(i, t),
                    s = this._sharedTooltip();
                this._startHover(i, t) || s || this._unsetActivePoint(), s && this._trackSharedTooltip(this._eventCoordinates(t), t, !0), this._propagateClick(n, t), this.handlingTap = !0, setTimeout(function() {
                    e.handlingTap = !1
                }, 0)
            },
            _click: function(t) {
                var e = this._getChartElement(t);
                this._propagateClick(e, t)
            },
            _propagateClick: function(t, e) {
                for (var i = this, n = t; n;) n.click && n.click(i, e), n = n.parent
            },
            _startHover: function(t, e) {
                var i, n, s, o;
                return !this._suppressHover && (i = this._drawingChartElement(t, e, function(t) {
                    return (t.hover || t.over) && !(t instanceof Nn)
                }), n = this._activePoint, s = this._hoveredPoint, s && s !== i && (s.out(this, e), this._hoveredPoint = null), i && s !== i && i.over && (this._hoveredPoint = i, i.over(this, e)), i && n !== i && i.hover && (this._activePoint = i, this._sharedTooltip() || i.hover(this, e) || (o = It({}, this.options.tooltip, i.options.tooltip), o.visible && this._tooltip.show(i), this._highlight.show(i))), i)
            },
            _mouseover: function(t) {
                var e, i = this._startHover(t.element, t.originalEvent);
                i && i.tooltipTracking && !this._mouseMoveTrackHandler && !this._sharedTooltip() && (this._mouseMoveTrackHandler = this._mouseMoveTracking.bind(this), Kt(document, (e = {}, e[yo] = this._mouseMoveTrackHandler, e)))
            },
            _mouseMoveTracking: function(t) {
                var e, i, n, s = this,
                    o = s.options,
                    r = s._tooltip,
                    a = s._highlight,
                    h = s._activePoint,
                    l = this._eventCoordinates(t);
                this._plotArea.box.containsPoint(l) ? h && h.tooltipTracking && h.series && h.parent.getNearestPoint && (e = h.parent.getNearestPoint(l.x, l.y, h.seriesIx), e && e !== h && (this._activePoint = e, e.hover(this, t) || (i = It({}, o.tooltip, e.options.tooltip), i.visible && r.show(e), a.show(e)))) : ($t(document, (n = {}, n[yo] = this._mouseMoveTrackHandler, n)), this._unsetActivePoint(), this._mouseMoveTrackHandler = null)
            },
            _mousemove: function(t) {
                var e, i = this._eventCoordinates(t),
                    n = this._plotArea;
                this._trackCrosshairs(i), n.hover && (e = n.backgroundContainsPoint(i), e ? (n.hovered = !0, this._plotArea.hover(this, t)) : n.hovered && !e && (this.trigger(ki), n.hovered = !1)), this._sharedTooltip() && this._trackSharedTooltip(i, t)
            },
            _trackCrosshairs: function(t) {
                var e, i, n = this._plotArea.crosshairs;
                for (e = 0; e < n.length; e++) i = n[e], i.box.containsPoint(t) ? i.showAt(t) : i.hide()
            },
            _trackSharedTooltip: function(t, e, i) {
                var n, s, o, r, a, h, l, c, u, p;
                this._suppressHover || (n = this, s = n.options.tooltip, o = n._plotArea, r = n._plotArea.categoryAxis, a = n._tooltip, h = n._highlight, o.backgroundContainsPoint(t) ? (l = r.pointCategoryIndex(t), l !== this._tooltipCategoryIx || !this._sharedHighlight && i ? (c = o.pointsByCategoryIndex(l), u = c.map(function(t) {
                    return t.eventArgs(e)
                }), p = u[0] || {}, p.categoryPoints = u, c.length > 0 && !this.trigger(wi, p) ? (s.visible && a.showAt(c, t), h.show(c), this._sharedHighlight = !0) : a.hide(), this._tooltipCategoryIx = l) : i && this._sharedHighlight && (h.hide(), a.hide(), this._sharedHighlight = !1)) : this._sharedHighlight && (h.hide(), a.hide(), this._tooltipCategoryIx = null, this._sharedHighlight = !1))
            },
            hideElements: function() {
                var t = this._plotArea;
                this._mousemove.cancel(), t.hideCrosshairs(), this._unsetActivePoint()
            },
            _unsetActivePoint: function() {
                var t = this,
                    e = t._tooltip,
                    i = t._highlight;
                this._activePoint = null, this._hoveredPoint = null, e && e.hide(), this._tooltipCategoryIx = null, this._sharedHighlight = !1, i && i.hide()
            },
            _deferRedraw: function() {
                this._redraw()
            },
            _clearRedrawTimeout: function() {
                this._redrawTimeout && (clearInterval(this._redrawTimeout), this._redrawTimeout = null)
            },
            bindCategories: function() {
                var t, e, i = this,
                    n = this.options,
                    s = [].concat(n.categoryAxis);
                for (t = 0; t < s.length; t++) e = s[t], e.autoBind !== !1 && i.bindCategoryAxisFromSeries(e, t)
            },
            bindCategoryAxisFromSeries: function(t, e) {
                var i, s, o, r, a, h, l, c, u, p, d, g, f = this,
                    v = this.options.series,
                    m = v.length,
                    x = new J.HashMap,
                    y = [],
                    b = !1;
                for (s = 0; s < m; s++)
                    if (o = v[s], r = o.categoryAxis === t.name || !o.categoryAxis && 0 === e, a = o.data, h = a.length, l = o.categoryField && r, b = l || b, l && h > 0)
                        for (i = w(t, n(o.categoryField, a[0])), c = i ? _ : n, u = 0; u < h; u++) p = a[u], d = c(o.categoryField, p, f.chartService.intl), !i && x.get(d) || (y.push([d, p]), i || x.set(d, !0));
                y.length > 0 ? (i && (y = j(y, function(t, e) {
                    return J.dateComparer(t[0], e[0])
                })), g = K(y), t.categories = g[0]) : b && (t.categories = [])
            },
            _isBindable: function(t) {
                var e, i, n = de.current.valueFields(t),
                    s = !0;
                for (e = 0; e < n.length; e++)
                    if (i = n[e], i === ot ? i = "field" : i += "Field", !yt(t[i])) {
                        s = !1;
                        break
                    }
                return s
            },
            _noTransitionsRedraw: function() {
                var t, e = this.options;
                e.transitions && (e.transitions = !1, t = !0), this._redraw(), t && (e.transitions = !0)
            },
            _legendItemHover: function(t, e) {
                var i, n = this,
                    s = n._plotArea,
                    o = n._highlight,
                    r = (s.srcSeries || s.series)[t];
                i = Pt(r.type, [$e, Ue, Ye]) ? s.findPoint(function(i) {
                    return i.series.index === t && i.index === e
                }) : s.pointsBySeriesIndex(t), o.show(i)
            },
            _shouldAttachMouseMove: function() {
                return this._plotArea.crosshairs.length || this._tooltip && this._sharedTooltip() || this.requiresHandlers([Ci, ki])
            },
            updateMouseMoveHandler: function() {
                var t, e;
                $t(this.element, (t = {}, t[yo] = this._mousemove, t)), this._shouldAttachMouseMove() && Kt(this.element, (e = {}, e[yo] = this._mousemove, e))
            },
            applyOptions: function(t, e) {
                Q(this._originalOptions, t), this._originalOptions = It(this._originalOptions, t), this.options = It({}, this._originalOptions), e && (this._theme = e, this.chartService.theme = e), this._initTheme(this.options, this._theme), this._toggleDragZoomEvents()
            },
            setOptions: function(t, e) {
                this.applyOptions(t, e), this.bindCategories(), this.redraw(), this.updateMouseMoveHandler()
            },
            setDirection: function(t) {
                this.chartService.rtl = !!t, this.surface && "svg" === this.surface.type && this._destroySurface()
            },
            setIntlService: function(t) {
                this.chartService.intl = t
            },
            noTransitionsRedraw: function() {
                this._noTransitionsRedraw()
            },
            destroy: function() {
                var t, e;
                this._destroyed = !0, $t(this.element, (t = {}, t[_o] = this._clickHandler, t[Xi] = this._mousewheelHandler, t[yo] = this._mousemove, t[wo] = this._mouseleaveHandler, t)), this.domEvents && (this.domEvents.destroy(), delete this.domEvents), this._mouseMoveTrackHandler && $t(document, (e = {}, e[yo] = this._mouseMoveTrackHandler, e)), this._destroyView(), this._destroySurface(), this._clearRedrawTimeout()
            },
            _destroySurface: function() {
                var t = this.surface;
                t && (t.unbind("mouseenter", this._surfaceMouseenterHandler), t.unbind("mouseleave", this._surfaceMouseleaveHandler), t.destroy(), this.surface = null)
            },
            _destroyView: function() {
                var t = this,
                    e = t._model,
                    i = t._selections;
                if (e && (e.destroy(), this._model = null), i)
                    for (; i.length > 0;) i.shift().destroy();
                this._unsetActivePoint(), this._tooltip && this._tooltip.destroy(), this._highlight && this._highlight.destroy(), this._zoomSelection && (this._zoomSelection.destroy(), delete this._zoomSelection), this._pannable && (this._pannable.destroy(), delete this._pannable), this._mousewheelZoom && (this._mousewheelZoom.destroy(), delete this._mousewheelZoom)
            }
        }), So = ["data", "categories"], kt(Ao, {
            renderAs: "",
            chartArea: {},
            legend: {
                visible: !0,
                labels: {}
            },
            categoryAxis: {},
            seriesDefaults: {
                type: Ze,
                data: [],
                highlight: {
                    visible: !0
                },
                labels: {},
                negativeValues: {
                    visible: !1
                }
            },
            series: [],
            seriesColors: null,
            tooltip: {
                visible: !1
            },
            transitions: !0,
            valueAxis: {},
            plotArea: {},
            title: {},
            xAxis: {},
            yAxis: {},
            panes: [{}],
            pannable: !1,
            zoomable: !1
        }), kendo.deepExtend(kendo.dataviz, {
            constants: Ui,
            Aggregates: pe,
            AreaChart: gn,
            AreaSegment: un,
            AxisGroupRangeTracker: fn,
            Bar: xn,
            BarChart: wn,
            BarLabel: vn,
            BoxPlotChart: kn,
            BoxPlot: Sn,
            BubbleChart: Rn,
            Bullet: Vn,
            BulletChart: Ln,
            CandlestickChart: An,
            Candlestick: bn,
            CategoricalChart: $i,
            CategoricalErrorBar: Ki,
            CategoricalPlotArea: ls,
            Chart: Ao,
            ChartContainer: zn,
            ClipAnimation: hn,
            ClusterLayout: yn,
            Crosshair: Bn,
            CrosshairTooltip: On,
            DefaultAggregates: Xn,
            DonutChart: Ns,
            DonutPlotArea: Gs,
            DonutSegment: Hs,
            ErrorBarBase: ji,
            ErrorRangeCalculator: xe,
            Highlight: cs,
            SharedTooltip: Cs,
            Legend: ys,
            LegendItem: fs,
            LegendLayout: gs,
            LineChart: cn,
            LinePoint: en,
            LineSegment: nn,
            Pane: Dn,
            PieAnimation: Es,
            PieChart: zs,
            PieChartMixin: Os,
            PiePlotArea: Ds,
            PieSegment: Vs,
            PlotAreaBase: Nn,
            PlotAreaEventsMixin: qn,
            PlotAreaFactory: _s,
            PointEventsMixin: Ji,
            RangeBar: Zn,
            RangeBarChart: Un,
            RangeAreaPoint: $n,
            RangeAreaChart: is,
            ScatterChart: Tn,
            ScatterErrorBar: Pn,
            ScatterLineChart: Rs,
            Selection: As,
            SeriesAggregator: Wn,
            SeriesBinder: de,
            SplineSegment: rn,
            SplineAreaSegment: dn,
            StackWrap: _n,
            Tooltip: Ss,
            OHLCChart: ss,
            OHLCPoint: ns,
            WaterfallChart: rs,
            WaterfallSegment: os,
            XYPlotArea: Is,
            MousewheelZoom: ds,
            ZoomSelection: ps,
            Pannable: us,
            ChartAxis: le,
            ChartPane: ce,
            ChartPlotArea: ue,
            findAxisByName: e,
            anyHasZIndex: a,
            appendIfNotNull: f,
            areNumbers: u,
            bindSegments: m,
            categoriesCount: o,
            countNumbers: i,
            equalsIgnoreCase: x,
            evalOptions: s,
            filterSeriesByType: y,
            getDateField: _,
            getField: n,
            hasGradientOverlay: h,
            hasValue: p,
            isDateAxis: w,
            segmentVisible: v,
            singleItemOrArray: b,
            createOutOfRangePoints: k
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(t, e, i) {
    (i || e)()
}),
function(t, define) {
    define("dataviz/chart/chart.min", ["dataviz/chart/kendo-chart.min", "kendo.data.min", "kendo.dataviz.core.min", "kendo.dataviz.themes.min", "kendo.drawing.min", "kendo.userevents.min"], t)
}(function() {
    return function(t, e) {
        function i(t) {
            a.fn[t] = function() {
                var e = this._instance;
                if (e) return e[t].apply(e, arguments)
            }
        }

        function n(t, i) {
            var n, s, o, r = [],
                a = t.groupNameTemplate,
                h = i.length;
            if (0 === h) return o = P({}, t), o.visibleInLegend = !1, [o];
            for (T(a) ? (m.logToConsole("'groupNameTemplate' is obsolete and will be removed in future versions. Specify the group name template as 'series.name'"), a && (n = B(a))) : (n = B(t.name || ""), 0 === n._slotCount && (n = B(T(t.name) ? "#= group.value #: #= series.name #" : "#= group.value #"))), s = 0; s < h; s++) o = P({}, t), m.isFunction(o.color) || (o.color = e), o._groupIx = s, o._groupValue = i[s].value, r.push(o), n && (o.name = n({
                series: o,
                group: i[s]
            }));
            return r
        }

        function s(t) {
            for (var i in t) t[i] === e && (t[i] = "");
            return t
        }

        function o(t) {
            for (var e = 0; e < t.length; e++) t[e].notifyRender()
        }
        var r, a, h, l, c, u, p, d, g, f, v = ".kendoChart",
            m = window.kendo,
            x = m.Class,
            y = m._outerWidth,
            _ = m._outerHeight,
            w = m.dataviz,
            b = w.constants,
            A = w.Chart,
            S = w.SeriesBinder,
            C = m.ui.Widget,
            k = m.data.DataSource,
            P = m.deepExtend,
            T = w.defined,
            E = w.getField,
            R = w.InstanceObserver,
            I = w.inArray,
            V = w.services,
            L = t.proxy,
            M = t.isArray,
            O = t.extend,
            B = m.template,
            z = "mouseleave" + v,
            D = b.AXIS_LABEL_CLICK,
            H = b.LEGEND_ITEM_CLICK,
            F = b.LEGEND_ITEM_HOVER,
            N = b.LEGEND_ITEM_LEAVE,
            G = b.SERIES_CLICK,
            q = b.SERIES_HOVER,
            W = b.SERIES_OVER,
            X = b.SERIES_LEAVE,
            Z = b.PANE_RENDER,
            U = b.PLOT_AREA_CLICK,
            Y = b.PLOT_AREA_HOVER,
            j = b.PLOT_AREA_LEAVE,
            K = b.DRAG,
            Q = b.DRAG_END,
            $ = b.DRAG_START,
            J = b.ZOOM_START,
            tt = b.ZOOM,
            et = b.ZOOM_END,
            it = b.SELECT_START,
            nt = b.SELECT,
            st = b.SELECT_END,
            ot = b.RENDER,
            rt = b.NOTE_CLICK,
            at = b.NOTE_HOVER,
            ht = b.NOTE_LEAVE,
            lt = "change",
            ct = "dataBound",
            ut = "leave",
            pt = b.VALUE,
            dt = b.PIE,
            gt = b.DONUT,
            ft = b.FUNNEL,
            vt = m.Observable,
            mt = 150,
            xt = 100,
            yt = "k-chart-tooltip-inverse",
            _t = "k-chart-shared-tooltip",
            wt = "rtl";
        for (V.DomEventsBuilder.register({
                create: function(t, e) {
                    return new m.UserEvents(t, P({
                        global: !0,
                        multiTouch: !0,
                        fastTap: !0
                    }, e))
                }
            }), r = R.extend({
                handlerMap: {
                    showTooltip: "_showTooltip",
                    hideTooltip: "_hideTooltip",
                    legendItemClick: "_onLegendItemClick",
                    render: "_onRender",
                    init: "_onInit"
                }
            }), a = C.extend({
                init: function(t, e) {
                    var i;
                    m.destroy(t), C.fn.init.call(this, t), e && (i = e.dataSource, delete e.dataSource), this.options = P({}, this.options, e), this.wrapper = this.element, this._attachEvents(), e && (e.dataSource = i), this._seriesVisibility = new c, this.bind(this.events, this.options), this._initDataSource(e), m.notify(this, w.ui)
                },
                events: [ct, G, q, W, X, D, H, F, N, Z, U, Y, j, $, K, Q, J, tt, et, it, nt, st, rt, at, ht, ot],
                options: {
                    name: "Chart",
                    renderAs: "",
                    theme: "default",
                    axisDefaults: {},
                    chartArea: {},
                    legend: {},
                    categoryAxis: {},
                    autoBind: !0,
                    seriesDefaults: {},
                    series: [],
                    seriesColors: null,
                    tooltip: {},
                    transitions: !0,
                    valueAxis: {},
                    plotArea: {},
                    title: {},
                    xAxis: {},
                    yAxis: {},
                    panes: [{}],
                    pannable: !1,
                    zoomable: !1
                },
                items: function() {
                    return t()
                },
                refresh: function() {
                    var t = this,
                        e = t._instance;
                    e.applyDefaults(t.options), e.applySeriesColors(), t._bindSeries(), t._bindCategories(), t.trigger(ct), t._redraw()
                },
                getSize: function() {
                    return m.dimensions(this.element)
                },
                redraw: function(t) {
                    this._size = null, this._instance.redraw(t)
                },
                setOptions: function(t) {
                    var e = this,
                        i = t.dataSource;
                    delete t.dataSource, C.fn._setEvents.call(e, t), this._instance.applyOptions(t, this._getThemeOptions(t)), this.options = this._instance.options, this._tooltip.setOptions(this.options.tooltip), this._seriesVisibility.setOptions(this.options), this._sourceSeries = null, i && e.setDataSource(i), e._hasDataSource ? e._onDataChanged() : (e._bindCategories(), e.redraw()), e._instance.updateMouseMoveHandler()
                },
                setDataSource: function(t) {
                    var e = this;
                    e.dataSource.unbind(lt, e._dataChangeHandler), e.dataSource = t = k.create(t), e._hasDataSource = !0, e._hasData = !1, t.bind(lt, e._dataChangeHandler), e.options.autoBind && t.fetch()
                },
                destroy: function() {
                    var t = this,
                        e = t.dataSource;
                    t.element.off(v), e && e.unbind(lt, t._dataChangeHandler), t._instance && (t._instance.destroy(), delete this._instance), this._tooltip && (this._tooltip.destroy(), delete this._tooltip), this._destroyCrosshairTooltips(), C.fn.destroy.call(t)
                },
                findPaneByName: function(t) {
                    var e, i = this._plotArea.panes;
                    for (e = 0; e < i.length; e++)
                        if (i[e].options.name === t) return new g(this, i[e])
                },
                findPaneByIndex: function(t) {
                    var e = this._plotArea.panes;
                    if (e[t]) return new g(this, e[t])
                },
                findSeries: function(t) {
                    var e, i = this._plotArea,
                        n = i.srcSeries || i.series;
                    for (e = 0; e < n.length; e++)
                        if (t(n[e])) return new f(this, n[e])
                },
                findSeriesByName: function(t) {
                    return this._createSeries({
                        name: t
                    })
                },
                findSeriesByIndex: function(t) {
                    return this._createSeries({
                        index: t
                    })
                },
                exportVisual: function(t) {
                    var e, i, n, s, r = this._instance;
                    if (r) return t && (t.width || t.height) ? (i = r.options.chartArea, n = r._originalOptions.chartArea, P(i, t), s = r._getModel(), i.width = n.width, i.height = n.height, s.renderVisual(), o(s._plotArea.panes), e = s.visual) : e = r.exportVisual(), e
                },
                _createSeries: function(t) {
                    var e = this._seriesOptions(t);
                    if (e) return new f(this, e)
                },
                _seriesOptions: function(t) {
                    var e, i, n = this._plotArea,
                        s = n.srcSeries || n.series;
                    if (T(t.index)) e = s[t.index];
                    else if (T(t.name))
                        for (i = 0; i < s.length; i++)
                            if (s[i].name === t.name) {
                                e = s[i];
                                break
                            }
                    return e
                },
                _attachEvents: function() {
                    this.element.on(z, L(this._mouseleave, this))
                },
                _mouseleave: function(e) {
                    var i = this._instance,
                        n = this._tooltip,
                        s = e.relatedTarget;
                    s && t(s).closest(n.element).length || !i || i.handlingTap || i.hideElements()
                },
                _getThemeOptions: function(t) {
                    var i, n, s = (t || {}).theme;
                    return s && w.SASS_THEMES.indexOf(s.toLowerCase()) !== -1 ? w.autoTheme().chart : T(s) ? (i = w.ui.themes || {}, n = i[s] || i[s.toLowerCase()] || {}, n.chart || {}) : e
                },
                _initChart: function() {
                    this._createChart(this.options, this._getThemeOptions(this.options)), this.options = this._instance.options, this._seriesVisibility.setOptions(this.options)
                },
                _createChart: function(t, e) {
                    this._instance = new A(this.element[0], t, e, {
                        observer: new r(this),
                        sender: this,
                        rtl: this._isRtl()
                    })
                },
                _onInit: function(t) {
                    this._instance = t.sender
                },
                _initDataSource: function(t) {
                    var e = this,
                        i = (t || {}).dataSource;
                    e._dataChangeHandler = L(e._onDataChanged, e), e.dataSource = k.create(i).bind("change", e._dataChangeHandler), e._bindCategories(), i && (e._hasDataSource = !0), this._initChart(), this._initTooltip(), i && e.options.autoBind && e.dataSource.fetch()
                },
                _destroyCrosshairTooltips: function() {
                    var t, e = this._crosshairTooltips;
                    if (e)
                        for (t in e) e[t].destroy();
                    this._crosshairTooltips = {}
                },
                _getCrosshairTooltip: function(t, e) {
                    var i = this._crosshairTooltips = this._crosshairTooltips || {},
                        n = t + e,
                        s = i[n];
                    return s || (s = i[n] = new d(this.element)), s
                },
                _showTooltip: function(t) {
                    if (t.crosshair) {
                        var e = this._getCrosshairTooltip(t.axisName, t.axisIndex);
                        e.show(t)
                    } else this._tooltip && this._tooltip.show(t)
                },
                _hideTooltip: function(t) {
                    if (t.crosshair) {
                        var e = this._getCrosshairTooltip(t.axisName, t.axisIndex);
                        e.hide()
                    } else this._tooltip && this._tooltip.hide(t)
                },
                _onRender: function(t) {
                    this._destroyCrosshairTooltips(), this._copyMembers(t.sender), this._hasDataSource && !this._hasData && this.options.autoBind || this.trigger(ot)
                },
                _copyMembers: function(t) {
                    this.options = t.options, this._originalOptions = t._originalOptions, this.surface = t.surface, this._plotArea = t._plotArea, this._model = t._model, this._highlight = t._highlight, this._selections = t._selections, this._pannable = t._pannable, this._zoomSelection = t._zoomSelection, this._mousewheelZoom = t._mousewheelZoom
                },
                requiresHandlers: function(t) {
                    var e, i = this._events;
                    for (e = 0; e < t.length; e++)
                        if (T(i[t[e]])) return !0
                },
                _initTooltip: function() {
                    this._tooltip = this._createTooltip(), this._tooltip.bind(ut, L(this._tooltipleave, this))
                },
                _onLegendItemClick: function(t) {
                    this.trigger(H, t) || this._legendItemClick(t.seriesIndex, t.pointIndex)
                },
                _legendItemClick: function(e, i) {
                    var n, s, o, r = this._instance,
                        a = r._plotArea,
                        h = (a.srcSeries || a.series)[e];
                    t.inArray(h.type, [dt, gt, ft]) >= 0 ? (n = h.data[i], n && T(n.visible) ? n.visible = !n.visible : (s = h.pointVisibility = h.pointVisibility || {}, o = s[i], s[i] = !!T(o) && !o)) : (h.visible = !h.visible, this._seriesVisibility.save(h)), r._noTransitionsRedraw()
                },
                _createTooltip: function() {
                    return new p(this.element, O({}, this.options.tooltip, {
                        rtl: this._isRtl()
                    }))
                },
                _tooltipleave: function() {
                    this._instance && this._instance.hideElements()
                },
                _bindData: function(t) {
                    var e, i, s, o = this,
                        r = o.options,
                        a = o._sourceSeries || r.series,
                        h = a.length,
                        l = o.dataSource.view(),
                        c = (o.dataSource.group() || []).length > 0,
                        u = [],
                        p = this._seriesVisibility;
                    for (p.read(), e = 0; e < h; e++) i = a[e], o._isBindable(i) && c ? (s = n(i, l), u = u.concat(s), p.applyByGroup(s, t)) : (i = O({}, i), u.push(i), p.applyByIndex(i, t));
                    o._sourceSeries = a, r.series = u, this._instance.applySeriesColors(), o._bindSeries(), o._bindCategories(), this._hasData = !0
                },
                _onDataChanged: function(t) {
                    this._bindData(t), this.trigger(ct), this._instance && this._instance.fontLoaded && this._redraw()
                },
                _bindSeries: function() {
                    var t, e, i, n, s = this,
                        o = s.dataSource.view(),
                        r = s.options.series,
                        a = r.length;
                    for (t = 0; t < a; t++) e = r[t], s._isBindable(e) && (i = e._groupIx, n = T(i) ? (o[i] || {}).items : o, e.autoBind !== !1 && (e.data = n))
                },
                _bindCategories: function() {
                    var t, e, i = this,
                        n = i.dataSource.view() || [],
                        s = (i.dataSource.group() || []).length > 0,
                        o = n,
                        r = i.options,
                        a = [].concat(r.categoryAxis);
                    for (s && n.length && (o = n[0].items), t = 0; t < a.length; t++) e = a[t], e.autoBind !== !1 && i._bindCategoryAxis(e, o, t)
                },
                _bindCategoryAxis: function(t, e, i) {
                    var n, s, o, r = (e || []).length;
                    if (t.field)
                        for (t.categories = [], n = 0; n < r; n++) o = e[n], s = E(t.field, o), 0 === n ? (t.categories = [s], t.dataItems = [o]) : (t.categories.push(s), t.dataItems.push(o));
                    else this._instance && this._instance.bindCategoryAxisFromSeries(t, i)
                },
                _isBindable: function(t) {
                    var e, i, n = S.current.valueFields(t),
                        s = !0;
                    for (i = 0; i < n.length; i++)
                        if (e = n[i], e === pt ? e = "field" : e += "Field", !T(t[e])) {
                            s = !1;
                            break
                        }
                    return s
                },
                _isRtl: function() {
                    return m.support.isRtl(this.element) && this.element.css("direction") === wt
                }
            }), h = ["getAxis", "findAxisByName", "plotArea", "toggleHighlight", "showTooltip", "hideTooltip", "_resize", "_redraw", "_noTransitionsRedraw", "_legendItemHover", "_eventCoordinates"], l = 0; l < h.length; l++) i(h[l]);
        w.ExportMixin.extend(a.fn), m.PDFMixin && m.PDFMixin.extend(a.fn), w.ui.plugin(a), c = x.extend({
            init: function() {
                this.groups = {}, this.index = {}, this.options = {}
            },
            applyByGroup: function(t, e) {
                if (e && e.action || this.options.persistSeriesVisibility)
                    for (var i = 0; i < t.length; i++) this.groups[t[i]._groupValue] === !1 && (t[i].visible = !1);
                else this.groups = {}
            },
            applyByIndex: function(t, e) {
                e && e.action || this.options.persistSeriesVisibility ? this.index[t.index] === !1 && (t.visible = !1) : this.index = {}
            },
            save: function(t) {
                t && (this.options.persistSeriesVisibility ? this.options.series[t.index].visible = t.visible : this.saveState(t))
            },
            setOptions: function(t) {
                this.options = t, this.groups = {}, this.index = {}
            },
            read: function() {
                var t, e, i = this.options;
                if (i.persistSeriesVisibility)
                    for (t = i.series, e = 0; e < t.length; e++) this.saveState(t[e])
            },
            saveState: function(t) {
                T(t._groupValue) ? this.groups[t._groupValue] = t.visible : this.index[t.index] = t.visible
            }
        }), u = m.geometry, p = vt.extend({
            init: function(e, i) {
                var n, s = this;
                vt.fn.init.call(s), this.setOptions(i), s.chartElement = e, s.template = p.template, s.template || (s.template = p.template = m.template("<div class='k-tooltip k-chart-tooltip#= d.rtl ? \" k-rtl\" : \"\"#' style='display:none; position: absolute; font: #= d.font #;#if (d.border) {# border: #= d.border.width #px solid; #}#opacity: #= d.opacity #; filter: alpha(opacity=#= d.opacity * 100 #);'></div>", {
                    useWithBlock: !1,
                    paramName: "d"
                })), s.element = t(s.template(s.options)), s.move = L(s.move, s), s._mouseleave = L(s._mouseleave, s), n = m.format("[{0}='content'],[{0}='scroller']", m.attr("role")), s._mobileScroller = e.closest(n).data("kendoMobileScroller")
            },
            destroy: function() {
                this._clearShowTimeout(), this.element && (this.element.off(z).remove(), this.element = null)
            },
            setOptions: function(t) {
                this.options = P({}, this.options, t)
            },
            options: {
                opacity: 1,
                animation: {
                    duration: mt
                },
                sharedTemplate: "<table><th colspan='#= colspan #'>#= categoryText #</th># for(var i = 0; i < points.length; i++) { ## var point = points[i]; #<tr># if(colorMarker) { # <td><span class='k-chart-shared-tooltip-marker' style='background-color:#:point.series.color#'></span></td># } ## if(nameColumn) { # <td> #if (point.series.name) {# #: point.series.name #: #} else {# &nbsp; #}#</td># } #<td>#= content(point) #</td></tr># } #</table>",
                categoryFormat: "{0:d}"
            },
            move: function() {
                var t, e = this,
                    i = e.options,
                    n = e.element;
                e.anchor && e.element && (t = e._offset(), e.visible || n.css({
                    top: t.top,
                    left: t.left
                }), e.visible = !0, e._ensureElement(document.body), n.stop(!0, !0).show().animate({
                    left: t.left,
                    top: t.top
                }, i.animation.duration))
            },
            _clearShowTimeout: function() {
                this.showTimeout && (clearTimeout(this.showTimeout), this.showTimeout = null)
            },
            getAnchor: function(t) {
                var e = this.anchor,
                    i = e.point,
                    n = e.align,
                    s = i.left,
                    o = i.top;
                return "center" === n.horizontal ? s -= t.width / 2 : "right" === n.horizontal && (s -= t.width), "center" === n.vertical ? o -= t.height / 2 : "bottom" === n.vertical && (o -= t.height), {
                    x: s,
                    y: o
                }
            },
            _offset: function() {
                var e, i, n = this,
                    s = n._measure(),
                    o = n.getAnchor(s),
                    r = o.y,
                    a = o.x,
                    h = m.support.zoomLevel(),
                    l = t(window),
                    c = window.pageYOffset || document.documentElement.scrollTop || 0,
                    p = window.pageXOffset || document.documentElement.scrollLeft || 0,
                    d = (this._mobileScroller || {}).movable;
                return d && 1 !== d.scale ? (e = u.transform().scale(d.scale, d.scale, [d.x, d.y]), i = new u.Point(a, r).transform(e), a = i.x, r = i.y) : (r += n._fit(r - c, s.height, _(l) / h), a += n._fit(a - p, s.width, y(l) / h)), {
                    top: r,
                    left: a
                }
            },
            show: function(t) {
                this.anchor = t.anchor, this.element.css(s(t.style)), this.element.toggleClass(yt, !!t.className), this.element.toggleClass(_t, !!t.shared);
                var e = t.shared ? this._sharedContent(t) : this._pointContent(t.point);
                this.element.html(e), this._clearShowTimeout(), this.showTimeout = setTimeout(this.move, xt)
            },
            hide: function() {
                var t = this;
                clearTimeout(t.showTimeout), t._hideElement(), t.visible && (t.point = null, t.visible = !1, t.index = null)
            },
            _sharedContent: function(t) {
                var e, i, n = t.points,
                    s = w.grep(n, function(t) {
                        return T(t.series.name)
                    }).length,
                    o = t.series.length > 1,
                    r = 1;
                return s && r++, o && r++, e = m.template(this.options.sharedTemplate), i = e({
                    points: n,
                    category: t.category,
                    categoryText: t.categoryText,
                    content: this._pointContent,
                    colorMarker: o,
                    nameColumn: s,
                    colspan: r
                })
            },
            _measure: function() {
                this._ensureElement();
                var t = {
                    width: y(this.element),
                    height: _(this.element)
                };
                return t
            },
            _ensureElement: function() {
                this.element && this.element.appendTo(document.body).on(z, this._mouseleave)
            },
            _mouseleave: function(e) {
                var i = e.relatedTarget,
                    n = this.chartElement[0];
                i && i !== n && !t.contains(n, i) && this.trigger(ut)
            },
            _hideElement: function() {
                var t = this,
                    e = this.element;
                e && e.fadeOut({
                    always: function() {
                        t.visible || e.off(z).remove()
                    }
                })
            },
            _pointContent: function(t) {
                var e, i, n = this,
                    s = P({}, n.options, t.options.tooltip);
                return T(t.value) && (e = "" + t.value), s.template ? (i = B(s.template), e = i({
                    value: t.value,
                    category: t.category,
                    series: t.series,
                    dataItem: t.dataItem,
                    percentage: t.percentage,
                    runningTotal: t.runningTotal,
                    total: t.total,
                    low: t.low,
                    high: t.high,
                    xLow: t.xLow,
                    xHigh: t.xHigh,
                    yLow: t.yLow,
                    yHigh: t.yHigh
                })) : s.format && (e = t.formatValue(s.format)), e
            },
            _fit: function(t, e, i) {
                var n = 0;
                return t + e > i && (n = i - (t + e)), t < 0 && (n = -t), n
            }
        }), d = p.extend({
            init: function(t, e) {
                p.fn.init.call(this, t, e), this.element.addClass("k-chart-crosshair-tooltip")
            },
            show: function(t) {
                var e = this.element;
                e && (this.anchor = t.anchor, this.element.css(t.style), this.element.html(this.content(t)), this.move())
            },
            move: function() {
                var t = this,
                    e = t.element,
                    i = t._offset();
                t._ensureElement(), e.css({
                    top: i.top,
                    left: i.left
                }).show()
            },
            content: function(t) {
                var e = t.value,
                    i = t.crosshair.options.tooltip;
                return i.template && (e = B(i.template)({
                    value: e
                })), e
            },
            hide: function() {
                this.element.hide()
            }
        }), g = x.extend({
            init: function(t, e) {
                this._chart = t, this._pane = e, this.visual = e.visual, this.chartsVisual = e.chartContainer.visual, this.name = e.options.name
            },
            series: function() {
                var t, e = this._chart,
                    i = e._plotArea.groupSeriesByPane(),
                    n = i[this.name || "default"],
                    s = [];
                if (n)
                    for (t = 0; t < n.length; t++) s.push(new f(e, n[t]));
                return s
            }
        }), f = x.extend({
            init: function(t, e) {
                this._chart = t, this._options = e
            },
            points: function(t) {
                var e, i, n = this._points;
                return n || (e = this._seriesOptions(), i = this._chart._plotArea, this._points = n = i.pointsBySeriesIndex(e.index)), m.isFunction(t) && (n = this._filterPoints(n, t)), n
            },
            data: function(t) {
                var e, i, n, s, o = this._seriesOptions();
                return t && (e = this._chart, i = e._plotArea, o.data = t, o.categoryField && (n = i.seriesCategoryAxis(o), s = [].concat(e.options.categoryAxis), e._instance.bindCategoryAxisFromSeries(s[n.axisIndex], n.axisIndex)), e._noTransitionsRedraw(), this._clearFields()), o.data
            },
            findPoint: function(t) {
                var e, i = this.points();
                for (e = 0; e < i.length; e++)
                    if (t(i[e])) return i[e]
            },
            toggleHighlight: function(t, e) {
                e = e ? m.isFunction(e) ? this.points(e) : M(e) ? e : [e] : this.points(), this._chart._instance.togglePointsHighlight(t, e)
            },
            toggleVisibility: function(t, e) {
                var i, n, s = this._chart,
                    o = this._seriesOptions(),
                    r = m.isFunction(e);
                if (r)
                    if (I(o.type, [dt, gt, ft]))
                        for (i = this._filterData(e), n = 0; n < i.length; n++) i[n].visible = t;
                    else o.visible = function(i) {
                        return !e(i.dataItem) || t
                    };
                else o.visible = t, s._seriesVisibility.save(o);
                s._noTransitionsRedraw(), this._clearFields()
            },
            _filterData: function(t) {
                var e, i = this._seriesOptions().data,
                    n = i.length,
                    s = [];
                for (e = 0; e < n; e++) t(i[e]) && s.push(i[e]);
                return s
            },
            _filterPoints: function(t, e) {
                var i, n = [],
                    s = t.length;
                for (i = 0; i < s; i++) e(t[i]) && n.push(t[i]);
                return n
            },
            _seriesOptions: function() {
                var t = this._series;
                return t || (t = this._series = this._chart._seriesOptions(this._options)), t
            },
            _clearFields: function() {
                delete this._points, delete this._series
            }
        }), w.Tooltip = p, w.CrosshairTooltip = d, w.ChartInstanceObserver = r, w.ChartPane = g, w.ChartSeries = f
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, i) {
    (i || e)()
}),
function(t, define) {
    define("kendo.dataviz.chart.min", ["dataviz/chart/kendo-chart.min", "dataviz/chart/chart.min"], t)
}(function() {
    return window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, i) {
    (i || e)()
});;
(function (o, define) {
    define("kendo.dataviz.qrcode.min", ["kendo.dataviz.core.min", "kendo.drawing.min"], o);
})(
    function () {
        return (
            (function (o, r) {
                function e(o) {
                    return parseInt(o, 2);
                }
                function t(o, r) {
                    var e = (+o).toString(2);
                    return e.length < r && (e = Array(r - e.length + 1).join(0) + e), e;
                }
                function d(o, r) {
                    for (var e = [], t = 0; t < o.length;) e.push(o.substring(t, t + r)), (t += r);
                    return e;
                }
                function a(o, r, e, t) {
                    for (var d = 0; d < o.length; d++) o[d][e][t] = r;
                }
                function s(o, r, e, t) {
                    for (var d = 0; d < ko.length; d++) o[d][e][t] = ko[d](e, t) ? 1 ^ r : parseInt(r, 10);
                }
                function n() {
                    var o, r;
                    for (r = 1; r < 255; r++) (o = 2 * so[r - 1]), o > 255 && (o = 285 ^ o), (so[r] = o), (ao[o] = r);
                    (o = (2 * so[r - 1]) ^ 285), (so[r] = o), (so[-1] = 0);
                }
                function l() {
                    var o,
                        r,
                        e,
                        t = 68;
                    for (o = 2; o <= t; o++) (r = no[o - 1]), (e = [o, 0]), (no[o] = D(r, e));
                }
                function i(o, e) {
                    var t = [],
                        d = o.length - 1;
                    do (t[d] = so[(o[d] + e) % 255]), d--;
                    while (o[d] !== r);
                    return t;
                }
                function u(o, r) {
                    return parseInt(o.charAt(r), 10);
                }
                function c(o, r, e, t, d) {
                    (r[o][t] = ((r[o][t] << 1) ^ d) % 128), r[o][t] == fo && (e[o] += 40);
                }
                function w(o, r, e, t, d, a) {
                    e[o][a] == t ? d[o][a]++ : ((e[o][a] = t), d[o][a] >= 5 && (r[o] += 3 + d[o][a] - 5), (d[o][a] = 1));
                }
                function C(o, r) {
                    var e = Math.floor((o / r) * 100),
                        t = e % 5,
                        d = Math.abs(e - t - 50),
                        a = Math.abs(e + 5 - t - 50),
                        s = 10 * Math.min(d / 5, a / 5);
                    return s;
                }
                var g,
                    h,
                    p,
                    f,
                    k,
                    B,
                    D,
                    P,
                    v,
                    M,
                    m,
                    _,
                    L,
                    Q,
                    S,
                    x,
                    E,
                    H,
                    A,
                    I,
                    b,
                    R,
                    T,
                    y,
                    O,
                    U,
                    V,
                    z,
                    N,
                    F,
                    Z,
                    K,
                    j,
                    W,
                    G = window.kendo,
                    $ = o.extend,
                    q = G.drawing,
                    X = G.dataviz,
                    J = G.ui.Widget,
                    Y = X.Box2D,
                    oo = "0000",
                    ro = "numeric",
                    eo = "alphanumeric",
                    to = "byte",
                    ao = { 1: 0 },
                    so = { 0: 1 },
                    no = [
                        [1, 0],
                        [1, 25, 0],
                    ],
                    lo = { 15: 20, 16: 20, 18: 24, 19: 24, 22: 20, 24: 22, 26: 24, 28: 20, 30: 20, 31: 24, 32: 28, 33: 24, 36: 18, 37: 22, 39: 20, 40: 24 },
                    io = [
                        {
                            L: { groups: [[1, 19]], totalDataCodewords: 19, errorCodewordsPerBlock: 7 },
                            M: { groups: [[1, 16]], totalDataCodewords: 16, errorCodewordsPerBlock: 10 },
                            Q: { groups: [[1, 13]], totalDataCodewords: 13, errorCodewordsPerBlock: 13 },
                            H: { groups: [[1, 9]], totalDataCodewords: 9, errorCodewordsPerBlock: 17 },
                        },
                        {
                            L: { groups: [[1, 34]], totalDataCodewords: 34, errorCodewordsPerBlock: 10 },
                            M: { groups: [[1, 28]], totalDataCodewords: 28, errorCodewordsPerBlock: 16 },
                            Q: { groups: [[1, 22]], totalDataCodewords: 22, errorCodewordsPerBlock: 22 },
                            H: { groups: [[1, 16]], totalDataCodewords: 16, errorCodewordsPerBlock: 28 },
                        },
                        {
                            L: { groups: [[1, 55]], totalDataCodewords: 55, errorCodewordsPerBlock: 15 },
                            M: { groups: [[1, 44]], totalDataCodewords: 44, errorCodewordsPerBlock: 26 },
                            Q: { groups: [[2, 17]], totalDataCodewords: 34, errorCodewordsPerBlock: 18 },
                            H: { groups: [[2, 13]], totalDataCodewords: 26, errorCodewordsPerBlock: 22 },
                        },
                        {
                            L: { groups: [[1, 80]], totalDataCodewords: 80, errorCodewordsPerBlock: 20 },
                            M: { groups: [[2, 32]], totalDataCodewords: 64, errorCodewordsPerBlock: 18 },
                            Q: { groups: [[2, 24]], totalDataCodewords: 48, errorCodewordsPerBlock: 26 },
                            H: { groups: [[4, 9]], totalDataCodewords: 36, errorCodewordsPerBlock: 16 },
                        },
                        {
                            L: { groups: [[1, 108]], totalDataCodewords: 108, errorCodewordsPerBlock: 26 },
                            M: { groups: [[2, 43]], totalDataCodewords: 86, errorCodewordsPerBlock: 24 },
                            Q: {
                                groups: [
                                    [2, 15],
                                    [2, 16],
                                ],
                                totalDataCodewords: 62,
                                errorCodewordsPerBlock: 18,
                            },
                            H: {
                                groups: [
                                    [2, 11],
                                    [2, 12],
                                ],
                                totalDataCodewords: 46,
                                errorCodewordsPerBlock: 22,
                            },
                        },
                        {
                            L: { groups: [[2, 68]], totalDataCodewords: 136, errorCodewordsPerBlock: 18 },
                            M: { groups: [[4, 27]], totalDataCodewords: 108, errorCodewordsPerBlock: 16 },
                            Q: { groups: [[4, 19]], totalDataCodewords: 76, errorCodewordsPerBlock: 24 },
                            H: { groups: [[4, 15]], totalDataCodewords: 60, errorCodewordsPerBlock: 28 },
                        },
                        {
                            L: { groups: [[2, 78]], totalDataCodewords: 156, errorCodewordsPerBlock: 20 },
                            M: { groups: [[4, 31]], totalDataCodewords: 124, errorCodewordsPerBlock: 18 },
                            Q: {
                                groups: [
                                    [2, 14],
                                    [4, 15],
                                ],
                                totalDataCodewords: 88,
                                errorCodewordsPerBlock: 18,
                            },
                            H: {
                                groups: [
                                    [4, 13],
                                    [1, 14],
                                ],
                                totalDataCodewords: 66,
                                errorCodewordsPerBlock: 26,
                            },
                        },
                        {
                            L: { groups: [[2, 97]], totalDataCodewords: 194, errorCodewordsPerBlock: 24 },
                            M: {
                                groups: [
                                    [2, 38],
                                    [2, 39],
                                ],
                                totalDataCodewords: 154,
                                errorCodewordsPerBlock: 22,
                            },
                            Q: {
                                groups: [
                                    [4, 18],
                                    [2, 19],
                                ],
                                totalDataCodewords: 110,
                                errorCodewordsPerBlock: 22,
                            },
                            H: {
                                groups: [
                                    [4, 14],
                                    [2, 15],
                                ],
                                totalDataCodewords: 86,
                                errorCodewordsPerBlock: 26,
                            },
                        },
                        {
                            L: { groups: [[2, 116]], totalDataCodewords: 232, errorCodewordsPerBlock: 30 },
                            M: {
                                groups: [
                                    [3, 36],
                                    [2, 37],
                                ],
                                totalDataCodewords: 182,
                                errorCodewordsPerBlock: 22,
                            },
                            Q: {
                                groups: [
                                    [4, 16],
                                    [4, 17],
                                ],
                                totalDataCodewords: 132,
                                errorCodewordsPerBlock: 20,
                            },
                            H: {
                                groups: [
                                    [4, 12],
                                    [4, 13],
                                ],
                                totalDataCodewords: 100,
                                errorCodewordsPerBlock: 24,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [2, 68],
                                    [2, 69],
                                ],
                                totalDataCodewords: 274,
                                errorCodewordsPerBlock: 18,
                            },
                            M: {
                                groups: [
                                    [4, 43],
                                    [1, 44],
                                ],
                                totalDataCodewords: 216,
                                errorCodewordsPerBlock: 26,
                            },
                            Q: {
                                groups: [
                                    [6, 19],
                                    [2, 20],
                                ],
                                totalDataCodewords: 154,
                                errorCodewordsPerBlock: 24,
                            },
                            H: {
                                groups: [
                                    [6, 15],
                                    [2, 16],
                                ],
                                totalDataCodewords: 122,
                                errorCodewordsPerBlock: 28,
                            },
                        },
                        {
                            L: { groups: [[4, 81]], totalDataCodewords: 324, errorCodewordsPerBlock: 20 },
                            M: {
                                groups: [
                                    [1, 50],
                                    [4, 51],
                                ],
                                totalDataCodewords: 254,
                                errorCodewordsPerBlock: 30,
                            },
                            Q: {
                                groups: [
                                    [4, 22],
                                    [4, 23],
                                ],
                                totalDataCodewords: 180,
                                errorCodewordsPerBlock: 28,
                            },
                            H: {
                                groups: [
                                    [3, 12],
                                    [8, 13],
                                ],
                                totalDataCodewords: 140,
                                errorCodewordsPerBlock: 24,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [2, 92],
                                    [2, 93],
                                ],
                                totalDataCodewords: 370,
                                errorCodewordsPerBlock: 24,
                            },
                            M: {
                                groups: [
                                    [6, 36],
                                    [2, 37],
                                ],
                                totalDataCodewords: 290,
                                errorCodewordsPerBlock: 22,
                            },
                            Q: {
                                groups: [
                                    [4, 20],
                                    [6, 21],
                                ],
                                totalDataCodewords: 206,
                                errorCodewordsPerBlock: 26,
                            },
                            H: {
                                groups: [
                                    [7, 14],
                                    [4, 15],
                                ],
                                totalDataCodewords: 158,
                                errorCodewordsPerBlock: 28,
                            },
                        },
                        {
                            L: { groups: [[4, 107]], totalDataCodewords: 428, errorCodewordsPerBlock: 26 },
                            M: {
                                groups: [
                                    [8, 37],
                                    [1, 38],
                                ],
                                totalDataCodewords: 334,
                                errorCodewordsPerBlock: 22,
                            },
                            Q: {
                                groups: [
                                    [8, 20],
                                    [4, 21],
                                ],
                                totalDataCodewords: 244,
                                errorCodewordsPerBlock: 24,
                            },
                            H: {
                                groups: [
                                    [12, 11],
                                    [4, 12],
                                ],
                                totalDataCodewords: 180,
                                errorCodewordsPerBlock: 22,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [3, 115],
                                    [1, 116],
                                ],
                                totalDataCodewords: 461,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [4, 40],
                                    [5, 41],
                                ],
                                totalDataCodewords: 365,
                                errorCodewordsPerBlock: 24,
                            },
                            Q: {
                                groups: [
                                    [11, 16],
                                    [5, 17],
                                ],
                                totalDataCodewords: 261,
                                errorCodewordsPerBlock: 20,
                            },
                            H: {
                                groups: [
                                    [11, 12],
                                    [5, 13],
                                ],
                                totalDataCodewords: 197,
                                errorCodewordsPerBlock: 24,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [5, 87],
                                    [1, 88],
                                ],
                                totalDataCodewords: 523,
                                errorCodewordsPerBlock: 22,
                            },
                            M: {
                                groups: [
                                    [5, 41],
                                    [5, 42],
                                ],
                                totalDataCodewords: 415,
                                errorCodewordsPerBlock: 24,
                            },
                            Q: {
                                groups: [
                                    [5, 24],
                                    [7, 25],
                                ],
                                totalDataCodewords: 295,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [11, 12],
                                    [7, 13],
                                ],
                                totalDataCodewords: 223,
                                errorCodewordsPerBlock: 24,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [5, 98],
                                    [1, 99],
                                ],
                                totalDataCodewords: 589,
                                errorCodewordsPerBlock: 24,
                            },
                            M: {
                                groups: [
                                    [7, 45],
                                    [3, 46],
                                ],
                                totalDataCodewords: 453,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [15, 19],
                                    [2, 20],
                                ],
                                totalDataCodewords: 325,
                                errorCodewordsPerBlock: 24,
                            },
                            H: {
                                groups: [
                                    [3, 15],
                                    [13, 16],
                                ],
                                totalDataCodewords: 253,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [1, 107],
                                    [5, 108],
                                ],
                                totalDataCodewords: 647,
                                errorCodewordsPerBlock: 28,
                            },
                            M: {
                                groups: [
                                    [10, 46],
                                    [1, 47],
                                ],
                                totalDataCodewords: 507,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [1, 22],
                                    [15, 23],
                                ],
                                totalDataCodewords: 367,
                                errorCodewordsPerBlock: 28,
                            },
                            H: {
                                groups: [
                                    [2, 14],
                                    [17, 15],
                                ],
                                totalDataCodewords: 283,
                                errorCodewordsPerBlock: 28,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [5, 120],
                                    [1, 121],
                                ],
                                totalDataCodewords: 721,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [9, 43],
                                    [4, 44],
                                ],
                                totalDataCodewords: 563,
                                errorCodewordsPerBlock: 26,
                            },
                            Q: {
                                groups: [
                                    [17, 22],
                                    [1, 23],
                                ],
                                totalDataCodewords: 397,
                                errorCodewordsPerBlock: 28,
                            },
                            H: {
                                groups: [
                                    [2, 14],
                                    [19, 15],
                                ],
                                totalDataCodewords: 313,
                                errorCodewordsPerBlock: 28,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [3, 113],
                                    [4, 114],
                                ],
                                totalDataCodewords: 795,
                                errorCodewordsPerBlock: 28,
                            },
                            M: {
                                groups: [
                                    [3, 44],
                                    [11, 45],
                                ],
                                totalDataCodewords: 627,
                                errorCodewordsPerBlock: 26,
                            },
                            Q: {
                                groups: [
                                    [17, 21],
                                    [4, 22],
                                ],
                                totalDataCodewords: 445,
                                errorCodewordsPerBlock: 26,
                            },
                            H: {
                                groups: [
                                    [9, 13],
                                    [16, 14],
                                ],
                                totalDataCodewords: 341,
                                errorCodewordsPerBlock: 26,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [3, 107],
                                    [5, 108],
                                ],
                                totalDataCodewords: 861,
                                errorCodewordsPerBlock: 28,
                            },
                            M: {
                                groups: [
                                    [3, 41],
                                    [13, 42],
                                ],
                                totalDataCodewords: 669,
                                errorCodewordsPerBlock: 26,
                            },
                            Q: {
                                groups: [
                                    [15, 24],
                                    [5, 25],
                                ],
                                totalDataCodewords: 485,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [15, 15],
                                    [10, 16],
                                ],
                                totalDataCodewords: 385,
                                errorCodewordsPerBlock: 28,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [4, 116],
                                    [4, 117],
                                ],
                                totalDataCodewords: 932,
                                errorCodewordsPerBlock: 28,
                            },
                            M: { groups: [[17, 42]], totalDataCodewords: 714, errorCodewordsPerBlock: 26 },
                            Q: {
                                groups: [
                                    [17, 22],
                                    [6, 23],
                                ],
                                totalDataCodewords: 512,
                                errorCodewordsPerBlock: 28,
                            },
                            H: {
                                groups: [
                                    [19, 16],
                                    [6, 17],
                                ],
                                totalDataCodewords: 406,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [2, 111],
                                    [7, 112],
                                ],
                                totalDataCodewords: 1006,
                                errorCodewordsPerBlock: 28,
                            },
                            M: { groups: [[17, 46]], totalDataCodewords: 782, errorCodewordsPerBlock: 28 },
                            Q: {
                                groups: [
                                    [7, 24],
                                    [16, 25],
                                ],
                                totalDataCodewords: 568,
                                errorCodewordsPerBlock: 30,
                            },
                            H: { groups: [[34, 13]], totalDataCodewords: 442, errorCodewordsPerBlock: 24 },
                        },
                        {
                            L: {
                                groups: [
                                    [4, 121],
                                    [5, 122],
                                ],
                                totalDataCodewords: 1094,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [4, 47],
                                    [14, 48],
                                ],
                                totalDataCodewords: 860,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [11, 24],
                                    [14, 25],
                                ],
                                totalDataCodewords: 614,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [16, 15],
                                    [14, 16],
                                ],
                                totalDataCodewords: 464,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [6, 117],
                                    [4, 118],
                                ],
                                totalDataCodewords: 1174,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [6, 45],
                                    [14, 46],
                                ],
                                totalDataCodewords: 914,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [11, 24],
                                    [16, 25],
                                ],
                                totalDataCodewords: 664,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [30, 16],
                                    [2, 17],
                                ],
                                totalDataCodewords: 514,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [8, 106],
                                    [4, 107],
                                ],
                                totalDataCodewords: 1276,
                                errorCodewordsPerBlock: 26,
                            },
                            M: {
                                groups: [
                                    [8, 47],
                                    [13, 48],
                                ],
                                totalDataCodewords: 1e3,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [7, 24],
                                    [22, 25],
                                ],
                                totalDataCodewords: 718,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [22, 15],
                                    [13, 16],
                                ],
                                totalDataCodewords: 538,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [10, 114],
                                    [2, 115],
                                ],
                                totalDataCodewords: 1370,
                                errorCodewordsPerBlock: 28,
                            },
                            M: {
                                groups: [
                                    [19, 46],
                                    [4, 47],
                                ],
                                totalDataCodewords: 1062,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [28, 22],
                                    [6, 23],
                                ],
                                totalDataCodewords: 754,
                                errorCodewordsPerBlock: 28,
                            },
                            H: {
                                groups: [
                                    [33, 16],
                                    [4, 17],
                                ],
                                totalDataCodewords: 596,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [8, 122],
                                    [4, 123],
                                ],
                                totalDataCodewords: 1468,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [22, 45],
                                    [3, 46],
                                ],
                                totalDataCodewords: 1128,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [8, 23],
                                    [26, 24],
                                ],
                                totalDataCodewords: 808,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [12, 15],
                                    [28, 16],
                                ],
                                totalDataCodewords: 628,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [3, 117],
                                    [10, 118],
                                ],
                                totalDataCodewords: 1531,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [3, 45],
                                    [23, 46],
                                ],
                                totalDataCodewords: 1193,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [4, 24],
                                    [31, 25],
                                ],
                                totalDataCodewords: 871,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [11, 15],
                                    [31, 16],
                                ],
                                totalDataCodewords: 661,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [7, 116],
                                    [7, 117],
                                ],
                                totalDataCodewords: 1631,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [21, 45],
                                    [7, 46],
                                ],
                                totalDataCodewords: 1267,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [1, 23],
                                    [37, 24],
                                ],
                                totalDataCodewords: 911,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [19, 15],
                                    [26, 16],
                                ],
                                totalDataCodewords: 701,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [5, 115],
                                    [10, 116],
                                ],
                                totalDataCodewords: 1735,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [19, 47],
                                    [10, 48],
                                ],
                                totalDataCodewords: 1373,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [15, 24],
                                    [25, 25],
                                ],
                                totalDataCodewords: 985,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [23, 15],
                                    [25, 16],
                                ],
                                totalDataCodewords: 745,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [13, 115],
                                    [3, 116],
                                ],
                                totalDataCodewords: 1843,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [2, 46],
                                    [29, 47],
                                ],
                                totalDataCodewords: 1455,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [42, 24],
                                    [1, 25],
                                ],
                                totalDataCodewords: 1033,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [23, 15],
                                    [28, 16],
                                ],
                                totalDataCodewords: 793,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: { groups: [[17, 115]], totalDataCodewords: 1955, errorCodewordsPerBlock: 30 },
                            M: {
                                groups: [
                                    [10, 46],
                                    [23, 47],
                                ],
                                totalDataCodewords: 1541,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [10, 24],
                                    [35, 25],
                                ],
                                totalDataCodewords: 1115,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [19, 15],
                                    [35, 16],
                                ],
                                totalDataCodewords: 845,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [17, 115],
                                    [1, 116],
                                ],
                                totalDataCodewords: 2071,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [14, 46],
                                    [21, 47],
                                ],
                                totalDataCodewords: 1631,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [29, 24],
                                    [19, 25],
                                ],
                                totalDataCodewords: 1171,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [11, 15],
                                    [46, 16],
                                ],
                                totalDataCodewords: 901,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [13, 115],
                                    [6, 116],
                                ],
                                totalDataCodewords: 2191,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [14, 46],
                                    [23, 47],
                                ],
                                totalDataCodewords: 1725,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [44, 24],
                                    [7, 25],
                                ],
                                totalDataCodewords: 1231,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [59, 16],
                                    [1, 17],
                                ],
                                totalDataCodewords: 961,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [12, 121],
                                    [7, 122],
                                ],
                                totalDataCodewords: 2306,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [12, 47],
                                    [26, 48],
                                ],
                                totalDataCodewords: 1812,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [39, 24],
                                    [14, 25],
                                ],
                                totalDataCodewords: 1286,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [22, 15],
                                    [41, 16],
                                ],
                                totalDataCodewords: 986,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [6, 121],
                                    [14, 122],
                                ],
                                totalDataCodewords: 2434,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [6, 47],
                                    [34, 48],
                                ],
                                totalDataCodewords: 1914,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [46, 24],
                                    [10, 25],
                                ],
                                totalDataCodewords: 1354,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [2, 15],
                                    [64, 16],
                                ],
                                totalDataCodewords: 1054,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [17, 122],
                                    [4, 123],
                                ],
                                totalDataCodewords: 2566,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [29, 46],
                                    [14, 47],
                                ],
                                totalDataCodewords: 1992,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [49, 24],
                                    [10, 25],
                                ],
                                totalDataCodewords: 1426,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [24, 15],
                                    [46, 16],
                                ],
                                totalDataCodewords: 1096,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [4, 122],
                                    [18, 123],
                                ],
                                totalDataCodewords: 2702,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [13, 46],
                                    [32, 47],
                                ],
                                totalDataCodewords: 2102,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [48, 24],
                                    [14, 25],
                                ],
                                totalDataCodewords: 1502,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [42, 15],
                                    [32, 16],
                                ],
                                totalDataCodewords: 1142,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [20, 117],
                                    [4, 118],
                                ],
                                totalDataCodewords: 2812,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [40, 47],
                                    [7, 48],
                                ],
                                totalDataCodewords: 2216,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [43, 24],
                                    [22, 25],
                                ],
                                totalDataCodewords: 1582,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [10, 15],
                                    [67, 16],
                                ],
                                totalDataCodewords: 1222,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                        {
                            L: {
                                groups: [
                                    [19, 118],
                                    [6, 119],
                                ],
                                totalDataCodewords: 2956,
                                errorCodewordsPerBlock: 30,
                            },
                            M: {
                                groups: [
                                    [18, 47],
                                    [31, 48],
                                ],
                                totalDataCodewords: 2334,
                                errorCodewordsPerBlock: 28,
                            },
                            Q: {
                                groups: [
                                    [34, 24],
                                    [34, 25],
                                ],
                                totalDataCodewords: 1666,
                                errorCodewordsPerBlock: 30,
                            },
                            H: {
                                groups: [
                                    [20, 15],
                                    [61, 16],
                                ],
                                totalDataCodewords: 1276,
                                errorCodewordsPerBlock: 30,
                            },
                        },
                    ],
                    uo = [1, 0, 1, 1, 1],
                    co = [1, 0, 1],
                    wo = { L: "01", M: "00", Q: "11", H: "10" },
                    Co = "101010000010010",
                    go = "10100110111",
                    ho = "1111100100101",
                    po = ["11101100", "00010001"],
                    fo = 93,
                    ko = [
                        function (o, r) {
                            return (o + r) % 2 === 0;
                        },
                        function (o) {
                            return o % 2 === 0;
                        },
                        function (o, r) {
                            return r % 3 === 0;
                        },
                        function (o, r) {
                            return (o + r) % 3 === 0;
                        },
                        function (o, r) {
                            return (Math.floor(o / 2) + Math.floor(r / 3)) % 2 === 0;
                        },
                        function (o, r) {
                            return ((o * r) % 2) + ((o * r) % 3) === 0;
                        },
                        function (o, r) {
                            return (((o * r) % 2) + ((o * r) % 3)) % 2 === 0;
                        },
                        function (o, r) {
                            return (((o + r) % 2) + ((o * r) % 3)) % 2 === 0;
                        },
                    ],
                    Bo = /^\d+/,
                    Do = "A-Z0-9 $%*+./:-",
                    Po = "A-Z $%*+./:-",
                    vo = RegExp("^[" + Po + "]+"),
                    Mo = RegExp("^[" + Do + "]+"),
                    mo = RegExp("^[^" + Do + "]+"),
                    _o = 8,
                    Lo = 5,
                    Qo = 8,
                    So = 17,
                    xo = 9,
                    Eo = 16,
                    Ho = Math.round,
                    Ao = G.Class.extend({
                        getVersionIndex: function (o) {
                            return o < 10 ? 0 : o > 26 ? 2 : 1;
                        },
                        getBitsCharacterCount: function (o) {
                            var r = this;
                            return r.bitsInCharacterCount[r.getVersionIndex(o || 40)];
                        },
                        getModeCountString: function (o, r) {
                            var e = this;
                            return e.modeIndicator + t(o, e.getBitsCharacterCount(r));
                        },
                        encode: function () { },
                        getStringBitsLength: function () { },
                        getValue: function () { },
                        modeIndicator: "",
                        bitsInCharacterCount: [],
                    }),
                    Io = {};
                (Io[ro] = Ao.extend({
                    bitsInCharacterCount: [10, 12, 14],
                    modeIndicator: "0001",
                    getValue: function (o) {
                        return parseInt(o, 10);
                    },
                    encode: function (o, r) {
                        var e,
                            a = this,
                            s = d(o, 3),
                            n = a.getModeCountString(o.length, r);
                        for (e = 0; e < s.length - 1; e++) n += t(s[e], 10);
                        return n + t(s[e], 1 + 3 * s[e].length);
                    },
                    getStringBitsLength: function (o, r) {
                        var e = o % 3;
                        return 4 + this.getBitsCharacterCount(r) + 10 * Math.floor(o / 3) + 3 * e + (0 === e ? 0 : 1);
                    },
                })),
                    (Io[eo] = Ao.extend({
                        characters: {
                            0: 0,
                            1: 1,
                            2: 2,
                            3: 3,
                            4: 4,
                            5: 5,
                            6: 6,
                            7: 7,
                            8: 8,
                            9: 9,
                            A: 10,
                            B: 11,
                            C: 12,
                            D: 13,
                            E: 14,
                            F: 15,
                            G: 16,
                            H: 17,
                            I: 18,
                            J: 19,
                            K: 20,
                            L: 21,
                            M: 22,
                            N: 23,
                            O: 24,
                            P: 25,
                            Q: 26,
                            R: 27,
                            S: 28,
                            T: 29,
                            U: 30,
                            V: 31,
                            W: 32,
                            X: 33,
                            Y: 34,
                            Z: 35,
                            " ": 36,
                            $: 37,
                            "%": 38,
                            "*": 39,
                            "+": 40,
                            "-": 41,
                            ".": 42,
                            "/": 43,
                            ":": 44,
                        },
                        bitsInCharacterCount: [9, 11, 13],
                        modeIndicator: "0010",
                        getValue: function (o) {
                            return this.characters[o];
                        },
                        encode: function (o, r) {
                            var e,
                                a,
                                s = this,
                                n = d(o, 2),
                                l = s.getModeCountString(o.length, r);
                            for (a = 0; a < n.length - 1; a++) (e = 45 * s.getValue(n[a].charAt(0)) + s.getValue(n[a].charAt(1))), (l += t(e, 11));
                            return (e = 2 == n[a].length ? 45 * s.getValue(n[a].charAt(0)) + s.getValue(n[a].charAt(1)) : s.getValue(n[a].charAt(0))), l + t(e, 1 + 5 * n[a].length);
                        },
                        getStringBitsLength: function (o, r) {
                            return 4 + this.getBitsCharacterCount(r) + 11 * Math.floor(o / 2) + 6 * (o % 2);
                        },
                    })),
                    (Io[to] = Ao.extend({
                        bitsInCharacterCount: [8, 16, 16],
                        modeIndicator: "0100",
                        getValue: function (o) {
                            var r = o.charCodeAt(0);
                            if (r <= 127 || (160 <= r && r <= 255)) return r;
                            throw Error("Unsupported character: " + o);
                        },
                        encode: function (o, r) {
                            var e,
                                d = this,
                                a = d.getModeCountString(o.length, r);
                            for (e = 0; e < o.length; e++) a += t(d.getValue(o.charAt(e)), 8);
                            return a;
                        },
                        getStringBitsLength: function (o, r) {
                            return 4 + this.getBitsCharacterCount(r) + 8 * o;
                        },
                    })),
                    (g = {});
                for (h in Io) g[h] = new Io[h]();
                (p = function (o) {
                    var e = this,
                        t = o.length - 1,
                        d = o.length - 1,
                        a = d,
                        s = -1,
                        n = 0;
                    (e.move = function () {
                        (t += s * n), (n ^= 1), (d = a - n);
                    }),
                        (e.getNextCell = function () {
                            for (; o[t][d] !== r;) e.move(), (t < 0 || t >= o.length) && ((s = -s), (a -= 8 != a ? 2 : 3), (d = a), (t = s < 0 ? o.length - 1 : 0));
                            return { row: t, column: d };
                        }),
                        (e.getNextRemainderCell = function () {
                            if ((e.move(), o[t][d] === r)) return { row: t, column: d };
                        });
                }),
                    (f = function (o, r) {
                        var e,
                            t,
                            d,
                            a,
                            n,
                            l,
                            i = new p(o[0]);
                        for (a = 0; a < r.length; a++)
                            for (e = r[a], t = 0; e.length > 0;) {
                                for (n = 0; n < e.length; n++) for (l = 0; l < 8; l++) (d = i.getNextCell()), s(o, e[n][t].charAt(l), d.row, d.column);
                                for (t++; e[0] && t == e[0].length;) e.splice(0, 1);
                            }
                        for (; (d = i.getNextRemainderCell());) s(o, 0, d.row, d.column);
                    }),
                    (k = function (o, r) {
                        for (var e = 8 * r, t = 0, d = 0; o.length < e && t < oo.length;) o += oo.charAt(t++);
                        for (o.length % 8 !== 0 && (o += Array(9 - (o.length % 8)).join("0")); o.length < e;) (o += po[d]), (d ^= 1);
                        return o;
                    }),
                    (B = function (o, r) {
                        var e,
                            t = [],
                            d = o.length - 2;
                        for (e = d; e >= 0; e--) t[e] = o[e] ^ r[e];
                        return t;
                    }),
                    (D = function (o, e) {
                        var t,
                            d,
                            a = [];
                        for (t = 0; t < o.length; t++) for (d = 0; d < e.length; d++) a[t + d] = a[t + d] === r ? (o[t] + (e[d] >= 0 ? e[d] : 0)) % 255 : ao[so[a[t + d]] ^ so[(o[t] + e[d]) % 255]];
                        return a;
                    }),
                    n(),
                    l(),
                    (P = function (o, r) {
                        var e,
                            d,
                            a = no[r - 1],
                            s = Array(r).concat(o),
                            n = Array(s.length - a.length).concat(a),
                            l = o.length,
                            u = [];
                        for (d = 0; d < l; d++) (e = i(n, ao[s[s.length - 1]])), n.splice(0, 1), (s = B(e, s));
                        for (d = s.length - 1; d >= 0; d--) u[r - 1 - d] = t(s[d], 8);
                        return u;
                    }),
                    (v = function (o, r) {
                        var t,
                            d,
                            a,
                            s,
                            n,
                            l,
                            i,
                            u,
                            c = 0,
                            w = [],
                            C = [],
                            g = r.groups;
                        for (l = 0; l < g.length; l++)
                            for (a = g[l][0], i = 0; i < a; i++) {
                                for (d = g[l][1], t = [], s = [], u = 1; u <= d; u++) (n = o.substring(c, c + 8)), t.push(n), (s[d - u] = e(n)), (c += 8);
                                w.push(t), C.push(P(s, r.errorCodewordsPerBlock));
                            }
                        return [w, C];
                    }),
                    (M = function (o, r, e, t, d) {
                        var a,
                            s,
                            n = Bo.exec(o),
                            l = n ? n[0] : "",
                            i = vo.exec(o),
                            u = i ? i[0] : "",
                            c = Mo.exec(o),
                            w = c ? c[0] : "";
                        return (
                            l && (l.length >= r || o.length == l.length || (l.length >= e && !Mo.test(o.charAt(l.length))))
                                ? ((a = ro), (s = l))
                                : w && (o.length == w.length || w.length >= t || d == eo)
                                    ? ((a = eo), (s = l || u))
                                    : ((a = to), (s = w ? w + mo.exec(o.substring(w.length))[0] : mo.exec(o)[0])),
                            { mode: a, modeString: s }
                        );
                    }),
                    (m = function (o) {
                        var r,
                            e,
                            t = [],
                            d = 0;
                        for (t.push(M(o, _o, Lo, Qo, r)), r = t[0].mode, o = o.substr(t[0].modeString.length); o.length > 0;)
                            (e = M(o, So, xo, Eo, r)), e.mode != r ? ((r = e.mode), t.push(e), d++) : (t[d].modeString += e.modeString), (o = o.substr(e.modeString.length));
                        return t;
                    }),
                    (_ = function (o) {
                        var r,
                            e,
                            t = 0;
                        for (e = 0; e < o.length; e++) (r = g[o[e].mode]), (t += r.getStringBitsLength(o[e].modeString.length));
                        return Math.ceil(t / 8);
                    }),
                    (L = function (o, r) {
                        var e = 0,
                            t = io.length - 1,
                            d = Math.floor(io.length / 2);
                        do o < io[d][r].totalDataCodewords ? (t = d) : (e = d), (d = e + Math.floor((t - e) / 2));
                        while (t - e > 1);
                        return o <= io[e][r].totalDataCodewords ? d + 1 : t + 1;
                    }),
                    (Q = function (o, r) {
                        var e,
                            t,
                            d = "";
                        for (t = 0; t < o.length; t++) (e = g[o[t].mode]), (d += e.encode(o[t].modeString, r));
                        return d;
                    }),
                    (S = function (o) {
                        var r,
                            t,
                            d = e(o),
                            a = "";
                        if (0 === d) return "101010000010010";
                        for (r = x(e(o), go, 15), t = 0; t < r.length; t++) a += r.charAt(t) ^ Co.charAt(t);
                        return a;
                    }),
                    (x = function (o, r, d) {
                        var a = e(r),
                            s = r.length - 1,
                            n = o << s,
                            l = d - s,
                            i = t(o, l),
                            u = E(n, a);
                        return (u = i + t(u, s));
                    }),
                    (E = function (o, r) {
                        var e = r.toString(2).length,
                            t = o.toString(2).length;
                        do (o ^= r << (t - e)), (t = o.toString(2).length);
                        while (t >= e);
                        return o;
                    }),
                    (H = function (o) {
                        var r,
                            e,
                            t = [],
                            d = 17 + 4 * o;
                        for (r = 0; r < ko.length; r++) for (t[r] = Array(d), e = 0; e < d; e++) t[r][e] = Array(d);
                        return t;
                    }),
                    (A = function (o, r) {
                        var e,
                            t,
                            d = o[0],
                            s = 0,
                            n = r.length;
                        for (e = 0, t = 8; e <= 8; e++) 6 !== e && a(o, u(r, n - 1 - s++), e, t);
                        for (e = 8, t = 7; t >= 0; t--) 6 !== t && a(o, u(r, n - 1 - s++), e, t);
                        for (s = 0, t = d.length - 1, e = 8; t >= d.length - 8; t--) a(o, u(r, n - 1 - s++), e, t);
                        for (a(o, 1, d.length - 8, 8), e = d.length - 7, t = 8; e < d.length; e++) a(o, u(r, n - 1 - s++), e, t);
                    }),
                    (I = function (o) {
                        return x(o, ho, 18);
                    }),
                    (b = function (o, r) {
                        var e,
                            t,
                            d,
                            s,
                            n = o[0],
                            l = n.length,
                            i = 0,
                            c = l - 11,
                            w = l - 11,
                            C = 0;
                        for (s = 0; s < r.length; s++) (e = Math.floor(s / 3)), (t = s % 3), (d = u(r, r.length - s - 1)), a(o, d, i + e, c + t), a(o, d, w + t, C + e);
                    }),
                    (R = function (o, r, e, t) {
                        var d,
                            s,
                            n,
                            l = r.length + 2,
                            i = r.length + 1;
                        for (s = 0; s < r.length; s++) for (n = s; n < l - s; n++) (d = r[s]), a(o, d, e + n, t + s), a(o, d, e + s, t + n), a(o, d, e + i - n, t + i - s), a(o, d, e + i - s, t + i - n);
                    }),
                    (T = function (o, r, e, t) {
                        var d = e,
                            s = t,
                            n = o[0];
                        do a(o, 0, d, t), a(o, 0, e, s), (d += r[0]), (s += r[1]);
                        while (d >= 0 && d < n.length);
                    }),
                    (y = function (o) {
                        var r = o[0].length;
                        R(o, uo, 0, 0), T(o, [-1, -1], 7, 7), R(o, uo, r - 7, 0), T(o, [1, -1], r - 8, 7), R(o, uo, 0, r - 7), T(o, [-1, 1], 7, r - 8);
                    }),
                    (O = function (o, e) {
                        var t, d, a, s, n, l, i, u, c;
                        if (!(e < 2)) {
                            for (t = o[0], d = t.length, a = Math.floor(e / 7), s = [6], i = 0, (n = lo[e]) ? (l = (d - 13 - n) / a) : (n = l = (d - 13) / (a + 1)), s.push(s[i++] + n); s[i] + l < d;) s.push(s[i++] + l);
                            for (u = 0; u < s.length; u++) for (c = 0; c < s.length; c++) t[s[u]][s[c]] === r && R(o, co, s[u] - 2, s[c] - 2);
                        }
                    }),
                    (U = function (o) {
                        var r,
                            e = 6,
                            t = 6,
                            d = 1,
                            s = o[0].length;
                        for (r = 8; r < s - 8; r++) a(o, d, e, r), a(o, d, r, t), (d ^= 1);
                    }),
                    (V = function (o) {
                        var r,
                            e,
                            t,
                            d,
                            a,
                            s,
                            n,
                            l = [],
                            i = [],
                            u = [],
                            g = [],
                            h = [],
                            p = 0,
                            f = 1,
                            k = o[0].length;
                        for (e = 0; e < o.length; e++) (l[e] = 0), (u[e] = 0), (h[e] = [0, 0]), (g[e] = [0, 0]), (i[e] = []);
                        for (e = 0; e < k; e++)
                            for (t = 0; t < k; t++)
                                for (d = 0; d < o.length; d++)
                                    (r = o[d]),
                                        (u[d] += parseInt(r[e][t], 10)),
                                        i[d][p] === r[e][t] && e + 1 < k && t - 1 >= 0 && r[e + 1][t] == i[d][p] && r[e + 1][t - 1] == i[d][p] && (l[d] += 3),
                                        c(d, g, l, p, r[e][t]),
                                        c(d, g, l, f, r[t][e]),
                                        w(d, l, i, r[e][t], h, p),
                                        w(d, l, i, r[t][e], h, f);
                        for (a = k * k, n = Number.MAX_VALUE, e = 0; e < l.length; e++) (l[e] += C(u[e], a)), l[e] < n && ((n = l[e]), (s = e));
                        return s;
                    }),
                    (z = function (o, r) {
                        (this.dataString = o), (this.version = r);
                    }),
                    (N = function () {
                        this.getEncodingResult = function (o, r) {
                            var e = m(o),
                                t = _(e),
                                d = L(t, r),
                                a = Q(e, d);
                            return new z(a, d);
                        };
                    }),
                    (F = function () {
                        this.mode = g[this.encodingMode];
                    }),
                    (F.fn = F.prototype = {
                        encodingMode: to,
                        utfBOM: "111011111011101110111111",
                        initialModeCountStringLength: 20,
                        getEncodingResult: function (o, r) {
                            var e = this,
                                t = e.encode(o),
                                d = e.getDataCodewordsCount(t),
                                a = L(d, r),
                                s = e.mode.getModeCountString(t.length / 8, a) + t;
                            return new z(s, a);
                        },
                        getDataCodewordsCount: function (o) {
                            var r = this,
                                e = o.length,
                                t = Math.ceil((r.initialModeCountStringLength + e) / 8);
                            return t;
                        },
                        encode: function (o) {
                            var r,
                                e = this,
                                t = e.utfBOM;
                            for (r = 0; r < o.length; r++) t += e.encodeCharacter(o.charCodeAt(r));
                            return t;
                        },
                        encodeCharacter: function (o) {
                            var r,
                                e,
                                d = this.getBytesCount(o),
                                a = d - 1,
                                s = "";
                            if (1 == d) s = t(o, 8);
                            else {
                                for (r = 8 - d, e = 0; e < a; e++) s = t(((o >> (6 * e)) & 63) | 128, 8) + s;
                                s = ((o >> (6 * a)) | ((255 >> r) << r)).toString(2) + s;
                            }
                            return s;
                        },
                        getBytesCount: function (o) {
                            var r,
                                e = this.ranges;
                            for (r = 0; r < e.length; r++) if (o < e[r]) return r + 1;
                        },
                        ranges: [128, 2048, 65536, 2097152, 67108864],
                    }),
                    (Z = function (o) {
                        return o && o.toLowerCase().indexOf("utf_8") >= 0 ? new F() : new N();
                    }),
                    (K = function (o, r, e) {
                        var d,
                            a,
                            s,
                            n = new Z(e),
                            l = n.getEncodingResult(o, r),
                            i = l.version,
                            u = io[i - 1][r],
                            c = k(l.dataString, u.totalDataCodewords),
                            w = v(c, u),
                            C = H(i);
                        return y(C), O(C, i), U(C), i >= 7 && b(C, t(0, 18)), A(C, t(0, 15)), f(C, w), (d = V(C)), (a = C[d]), i >= 7 && b([a], I(i)), (s = wo[r] + t(d, 3)), A([a], S(s)), a;
                    }),
                    (j = { DEFAULT_SIZE: 200, QUIET_ZONE_LENGTH: 4, DEFAULT_ERROR_CORRECTION_LEVEL: "L", DEFAULT_BACKGROUND: "#fff", DEFAULT_DARK_MODULE_COLOR: "#000", MIN_BASE_UNIT_SIZE: 1 }),
                    (W = J.extend({
                        init: function (r, e) {
                            var t = this;
                            J.fn.init.call(t, r, e),
                                (t.element = o(r)),
                                (t.wrapper = t.element),
                                t.element.addClass("k-qrcode"),
                                (t.surfaceWrap = o("<div />").css("position", "relative").appendTo(this.element)),
                                (t.surface = q.Surface.create(t.surfaceWrap, { type: t.options.renderAs })),
                                t.setOptions(e);
                        },
                        redraw: function () {
                            var o = this._getSize();
                            this.surfaceWrap.css({ width: o, height: o }), this.surface.clear(), this.surface.resize(), this.createVisual(), this.surface.draw(this.visual);
                        },
                        getSize: function () {
                            return G.dimensions(this.element);
                        },
                        _resize: function () {
                            this.redraw();
                        },
                        createVisual: function () {
                            this.visual = this._render();
                        },
                        exportVisual: function () {
                            return this._render();
                        },
                        _render: function () {
                            var o,
                                r,
                                e,
                                t,
                                d,
                                a,
                                s,
                                n = this,
                                l = n._value,
                                i = n.options.border || {},
                                u = n.options.padding || 0,
                                c = i.width || 0;
                            return (
                                (i.width = c),
                                (s = new q.Group()),
                                l &&
                                ((e = K(l, n.options.errorCorrection, n.options.encoding)),
                                    (t = n._getSize()),
                                    (a = t - 2 * (c + u)),
                                    (o = n._calculateBaseUnit(a, e.length)),
                                    (d = e.length * o),
                                    (r = c + u + (a - d) / 2),
                                    s.append(n._renderBackground(t, i)),
                                    s.append(n._renderMatrix(e, o, r))),
                                s
                            );
                        },
                        _getSize: function () {
                            var o,
                                r,
                                e,
                                t = this;
                            return t.options.size ? (o = parseInt(t.options.size, 10)) : ((r = t.element), (e = Math.min(r.width(), r.height())), (o = e > 0 ? e : j.DEFAULT_SIZE)), o;
                        },
                        _calculateBaseUnit: function (o, r) {
                            var e = Math.floor(o / r);
                            if (e < j.MIN_BASE_UNIT_SIZE) throw Error("Insufficient size.");
                            return e * r >= o && e - 1 >= j.MIN_BASE_UNIT_SIZE && e--, e;
                        },
                        _renderMatrix: function (o, r, e) {
                            var t,
                                d,
                                a,
                                s,
                                n,
                                l,
                                i,
                                u,
                                c = new q.MultiPath({ fill: { color: this.options.color }, stroke: null });
                            for (t = 0; t < o.length; t++)
                                for (d = e + t * r, a = 0; a < o.length;) {
                                    for (; 0 === o[t][a] && a < o.length;) a++;
                                    if (a < o.length) {
                                        for (s = a; 1 == o[t][a];) a++;
                                        (n = Ho(e + s * r)), (l = Ho(d)), (i = Ho(e + a * r)), (u = Ho(d + r)), c.moveTo(n, l).lineTo(n, u).lineTo(i, u).lineTo(i, l).close();
                                    }
                                }
                            return c;
                        },
                        _renderBackground: function (o, r) {
                            var e = new Y(0, 0, o, o).unpad(r.width / 2);
                            return q.Path.fromRect(e.toRect(), { fill: { color: this.options.background }, stroke: { color: r.color, width: r.width } });
                        },
                        setOptions: function (o) {
                            var e = this;
                            (o = o || {}), (e.options = $(e.options, o)), o.value !== r && (e._value = e.options.value + ""), e.redraw();
                        },
                        value: function (o) {
                            var e = this;
                            return o === r ? e._value : ((e._value = o + ""), e.redraw(), r);
                        },
                        options: {
                            name: "QRCode",
                            renderAs: "svg",
                            encoding: "ISO_8859_1",
                            value: "",
                            errorCorrection: j.DEFAULT_ERROR_CORRECTION_LEVEL,
                            background: j.DEFAULT_BACKGROUND,
                            color: j.DEFAULT_DARK_MODULE_COLOR,
                            size: "",
                            padding: 0,
                            border: { color: "", width: 0 },
                        },
                    })),
                    X.ExportMixin.extend(W.fn),
                    X.ui.plugin(W),
                    G.deepExtend(X, {
                        QRCode: W,
                        QRCodeDefaults: j,
                        QRCodeFunctions: {
                            FreeCellVisitor: p,
                            fillData: f,
                            padDataString: k,
                            generateErrorCodewords: P,
                            xorPolynomials: B,
                            getBlocks: v,
                            multiplyPolynomials: D,
                            chooseMode: M,
                            getModes: m,
                            getDataCodewordsCount: _,
                            getVersion: L,
                            getDataString: Q,
                            encodeFormatInformation: S,
                            encodeBCH: x,
                            dividePolynomials: E,
                            initMatrices: H,
                            addFormatInformation: A,
                            encodeVersionInformation: I,
                            addVersionInformation: b,
                            addCentricPattern: R,
                            addFinderSeparator: T,
                            addFinderPatterns: y,
                            addAlignmentPatterns: O,
                            addTimingFunctions: U,
                            scoreMaskMatrixes: V,
                            encodeData: K,
                            UTF8Encoder: F,
                        },
                        QRCodeFields: { modes: g, powersOfTwo: ao, powersOfTwoResult: so, generatorPolynomials: no },
                    });
            })(window.kendo.jQuery),
            window.kendo
        );
    },
    "function" == typeof define && define.amd
        ? define
        : function (o, r, e) {
            (e || r)();
        }
);
! function(e, define) {
    define("kendo.mobile.view.min", ["kendo.core.min", "kendo.fx.min", "kendo.mobile.scroller.min", "kendo.view.min"], e)
}(function() {
    return function(e, t) {
        function i(e) {
            var t, i, o = e.find(x("popover")),
                n = s.roles;
            for (t = 0, i = o.length; t < i; t++) r.initWidget(o[t], {}, n)
        }

        function o(e) {
            r.triggeredByInput(e) || e.preventDefault()
        }

        function n(t) {
            t.each(function() {
                r.initWidget(e(this), {}, s.roles)
            })
        }
        var r = window.kendo,
            a = r.mobile,
            s = a.ui,
            l = r.attr,
            h = s.Widget,
            d = r.ViewClone,
            c = "init",
            u = '<div style="height: 100%; width: 100%; position: absolute; top: 0; left: 0; z-index: 20000; display: none" />',
            p = "beforeShow",
            f = "show",
            g = "afterShow",
            m = "beforeHide",
            v = "transitionEnd",
            w = "transitionStart",
            y = "hide",
            _ = "destroy",
            b = r.attrValue,
            x = r.roleSelector,
            S = r.directiveSelector,
            k = r.compileMobileDirective,
            V = h.extend({
                init: function(t, i) {
                    h.fn.init.call(this, t, i), this.params = {}, e.extend(this, i), this.transition = this.transition || this.defaultTransition, this._id(), this.options.$angular ? this._overlay() : (this._layout(), this._overlay(), this._scroller(), this._model())
                },
                events: [c, p, f, g, m, y, _, w, v],
                options: {
                    name: "View",
                    title: "",
                    layout: null,
                    getLayout: e.noop,
                    reload: !1,
                    transition: "",
                    defaultTransition: "",
                    useNativeScrolling: !1,
                    stretch: !1,
                    zoom: !1,
                    model: null,
                    modelScope: window,
                    scroller: {},
                    initWidgets: !0
                },
                enable: function(e) {
                    t === e && (e = !0), e ? this.overlay.hide() : this.overlay.show()
                },
                destroy: function() {
                    this.layout && this.layout.detach(this), this.trigger(_), h.fn.destroy.call(this), this.scroller && this.scroller.destroy(), this.options.$angular && this.element.scope().$destroy(), r.destroy(this.element)
                },
                purge: function() {
                    this.destroy(), this.element.remove()
                },
                triggerBeforeShow: function() {
                    return !this.trigger(p, {
                        view: this
                    })
                },
                triggerBeforeHide: function() {
                    return !this.trigger(m, {
                        view: this
                    })
                },
                showStart: function() {
                    var e = this.element;
                    e.css("display", ""), this.inited ? this._invokeNgController() : (this.inited = !0, this.trigger(c, {
                        view: this
                    })), this.layout && this.layout.attach(this), this._padIfNativeScrolling(), this.trigger(f, {
                        view: this
                    }), r.resize(e)
                },
                showEnd: function() {
                    this.trigger(g, {
                        view: this
                    }), this._padIfNativeScrolling()
                },
                hideEnd: function() {
                    var e = this;
                    e.element.hide(), e.trigger(y, {
                        view: e
                    }), e.layout && e.layout.trigger(y, {
                        view: e,
                        layout: e.layout
                    })
                },
                beforeTransition: function(e) {
                    this.trigger(w, {
                        type: e
                    })
                },
                afterTransition: function(e) {
                    this.trigger(v, {
                        type: e
                    })
                },
                _padIfNativeScrolling: function() {
                    if (a.appLevelNativeScrolling()) {
                        var e = r.support.mobileOS && r.support.mobileOS.android,
                            t = a.application.skin() || "",
                            i = a.application.os.android || t.indexOf("android") > -1,
                            o = "flat" === t || t.indexOf("material") > -1,
                            n = !e && !i || o ? "header" : "footer",
                            s = !e && !i || o ? "footer" : "header";
                        this.content.css({
                            paddingTop: this[n].height(),
                            paddingBottom: this[s].height()
                        })
                    }
                },
                contentElement: function() {
                    var e = this;
                    return e.options.stretch ? e.content : e.scrollerContent
                },
                clone: function() {
                    return new d(this)
                },
                _scroller: function() {
                    var t = this;
                    a.appLevelNativeScrolling() || (t.options.stretch ? t.content.addClass("km-stretched-view") : (t.content.kendoMobileScroller(e.extend(t.options.scroller, {
                        zoom: t.options.zoom,
                        useNative: t.options.useNativeScrolling
                    })), t.scroller = t.content.data("kendoMobileScroller"), t.scrollerContent = t.scroller.scrollElement), r.support.kineticScrollNeeded && (e(t.element).on("touchmove", ".km-header", o), t.options.useNativeScrolling || t.options.stretch || e(t.element).on("touchmove", ".km-content", o)))
                },
                _model: function() {
                    var e = this,
                        t = e.element,
                        o = e.options.model;
                    "string" == typeof o && (o = r.getter(o)(e.options.modelScope)), e.model = o, i(t), e.element.css("display", ""), e.options.initWidgets && (o ? r.bind(t, o, s, r.ui, r.dataviz.ui) : a.init(t.children())), e.element.css("display", "none")
                },
                _id: function() {
                    var e = this.element,
                        t = e.attr("id") || "";
                    this.id = b(e, "url") || "#" + t, "#" == this.id && (this.id = r.guid(), e.attr("id", this.id))
                },
                _layout: function() {
                    var e = x("content"),
                        t = this.element;
                    t.addClass("km-view"), this.header = t.children(x("header")).addClass("km-header"), this.footer = t.children(x("footer")).addClass("km-footer"), t.children(e)[0] || t.wrapInner("<div " + l("role") + '="content"></div>'), this.content = t.children(x("content")).addClass("km-content"), this.element.prepend(this.header).append(this.footer), this.layout = this.options.getLayout(this.layout), this.layout && this.layout.setup(this)
                },
                _overlay: function() {
                    this.overlay = e(u).appendTo(this.element)
                },
                _invokeNgController: function() {
                    var t, i, o;
                    this.options.$angular && (t = this.element.controller(), i = this.options.$angular[0], t && (o = e.proxy(this, "_callController", t, i), /^\$(digest|apply)$/.test(i.$$phase) ? o() : i.$apply(o)))
                },
                _callController: function(e, t) {
                    this.element.injector().invoke(e.constructor, e, {
                        $scope: t
                    })
                }
            }),
            C = h.extend({
                init: function(e, t) {
                    h.fn.init.call(this, e, t), e = this.element, this.header = e.children(this._locate("header")).addClass("km-header"), this.footer = e.children(this._locate("footer")).addClass("km-footer"), this.elements = this.header.add(this.footer), i(e), this.options.$angular || r.mobile.init(this.element.children()), this.element.detach(), this.trigger(c, {
                        layout: this
                    })
                },
                _locate: function(e) {
                    return this.options.$angular ? S(e) : x(e)
                },
                options: {
                    name: "Layout",
                    id: null,
                    platform: null
                },
                events: [c, f, y],
                setup: function(e) {
                    e.header[0] || (e.header = this.header), e.footer[0] || (e.footer = this.footer)
                },
                detach: function(e) {
                    var t = this;
                    e.header === t.header && t.header[0] && e.element.prepend(t.header.detach()[0].cloneNode(!0)), e.footer === t.footer && t.footer.length && e.element.append(t.footer.detach()[0].cloneNode(!0))
                },
                attach: function(e) {
                    var t = this,
                        i = t.currentView;
                    i && t.detach(i), e.header === t.header && (t.header.detach(), e.element.children(x("header")).remove(), e.element.prepend(t.header)), e.footer === t.footer && (t.footer.detach(), e.element.children(x("footer")).remove(), e.element.append(t.footer)), t.trigger(f, {
                        layout: t,
                        view: e
                    }), t.currentView = e
                }
            }),
            $ = r.Observable,
            L = /<body[^>]*>(([\u000a\u000d\u2028\u2029]|.)*)<\/body>/i,
            N = "loadStart",
            T = "loadComplete",
            E = "showStart",
            I = "sameViewRequested",
            O = "viewShow",
            R = "viewTypeDetermined",
            W = "after",
            z = $.extend({
                init: function(t) {
                    var i, o, a, s, l = this;
                    if ($.fn.init.call(l), e.extend(l, t), l.sandbox = e("<div />"), a = l.container, i = l._hideViews(a), l.rootView = i.first(), !l.rootView[0] && t.rootNeeded) throw o = a[0] == r.mobile.application.element[0] ? 'Your kendo mobile application element does not contain any direct child elements with data-role="view" attribute set. Make sure that you instantiate the mobile application using the correct container.' : 'Your pane element does not contain any direct child elements with data-role="view" attribute set.', Error(o);
                    l.layouts = {}, l.viewContainer = new r.ViewContainer(l.container), l.viewContainer.bind("accepted", function(e) {
                        e.view.params = l.params
                    }), l.viewContainer.bind("complete", function(e) {
                        l.trigger(O, {
                            view: e.view
                        })
                    }), l.viewContainer.bind(W, function() {
                        l.trigger(W)
                    }), this.getLayoutProxy = e.proxy(this, "_getLayout"), l._setupLayouts(a), s = a.children(l._locate("modalview drawer")), l.$angular ? (l.$angular[0].viewOptions = {
                        defaultTransition: l.transition,
                        loader: l.loader,
                        container: l.container,
                        getLayout: l.getLayoutProxy
                    }, s.each(function(i, o) {
                        k(e(o), t.$angular[0])
                    })) : n(s), this.bind(this.events, t)
                },
                events: [E, W, O, N, T, I, R],
                destroy: function() {
                    r.destroy(this.container);
                    for (var e in this.layouts) this.layouts[e].destroy()
                },
                view: function() {
                    return this.viewContainer.view
                },
                showView: function(e, t, i) {
                    if (e = e.replace(RegExp("^" + this.remoteViewURLPrefix), ""), "" === e && this.remoteViewURLPrefix && (e = "/"), e.replace(/^#/, "") === this.url) return this.trigger(I), !1;
                    this.trigger(E);
                    var o = this,
                        n = function(i) {
                            return o.viewContainer.show(i, t, e)
                        },
                        a = o._findViewElement(e),
                        s = r.widgetInstance(a);
                    return o.url = e.replace(/^#/, ""), o.params = i, s && s.reload && (s.purge(), a = []), this.trigger(R, {
                        remote: 0 === a.length,
                        url: e
                    }), a[0] ? (s || (s = o._createView(a)), n(s)) : (this.serverNavigation ? location.href = e : o._loadView(e, n), !0)
                },
                append: function(e, t) {
                    var i, o, r, a = this.sandbox,
                        s = (t || "").split("?")[0],
                        h = this.container;
                    return L.test(e) && (e = RegExp.$1), a[0].innerHTML = e, h.append(a.children("script, style")), i = this._hideViews(a), r = i.first(), r.length || (i = r = a.wrapInner("<div data-role=view />").children()), s && r.hide().attr(l("url"), s), this._setupLayouts(a), o = a.children(this._locate("modalview drawer")), h.append(a.children(this._locate("layout modalview drawer")).add(i)), n(o), this._createView(r)
                },
                _locate: function(e) {
                    return this.$angular ? S(e) : x(e)
                },
                _findViewElement: function(e) {
                    var t, i = e.split("?")[0];
                    return i ? (t = this.container.children("[" + l("url") + "='" + i + "']"), t[0] || i.indexOf("/") !== -1 || (t = this.container.children("#" === i.charAt(0) ? i : "#" + i)), t) : this.rootView
                },
                _createView: function(e) {
                    return this.$angular ? k(e, this.$angular[0]) : r.initWidget(e, {
                        defaultTransition: this.transition,
                        loader: this.loader,
                        container: this.container,
                        getLayout: this.getLayoutProxy,
                        modelScope: this.modelScope,
                        reload: b(e, "reload")
                    }, s.roles)
                },
                _getLayout: function(e) {
                    return "" === e ? null : e ? this.layouts[e] : this.layouts[this.layout]
                },
                _loadView: function(t, i) {
                    this._xhr && this._xhr.abort(), this.trigger(N), this._xhr = e.get(r.absoluteURL(t, this.remoteViewURLPrefix), "html").always(e.proxy(this, "_xhrComplete", i, t))
                },
                _xhrComplete: function(e, t, i) {
                    var o = !0;
                    if ("object" == typeof i && 0 === i.status) {
                        if (!(i.responseText && i.responseText.length > 0)) return;
                        o = !0, i = i.responseText
                    }
                    this.trigger(T), o && e(this.append(i, t))
                },
                _hideViews: function(e) {
                    return e.children(this._locate("view splitview")).hide()
                },
                _setupLayouts: function(t) {
                    var i, o = this;
                    t.children(o._locate("layout")).each(function() {
                        i = o.$angular ? k(e(this), o.$angular[0]) : r.initWidget(e(this), {}, s.roles);
                        var t = i.options.platform;
                        t && t !== a.application.os.name ? i.destroy() : o.layouts[i.options.id] = i
                    })
                }
            });
        r.mobile.ViewEngine = z, s.plugin(V), s.plugin(C)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, i) {
    (i || t)()
});;
! function(n, define) {
    define("kendo.mobile.loader.min", ["kendo.core.min"], n)
}(function() {
    return function(n, t) {
        var e = window.kendo,
            i = e.mobile.ui,
            o = i.Widget,
            a = n.map(e.eventMap, function(n) {
                return n
            }).join(" ").split(" "),
            s = o.extend({
                init: function(t, e) {
                    var i = this,
                        a = n('<div class="km-loader"><span class="km-loading km-spin"></span><span class="km-loading-left"></span><span class="km-loading-right"></span></div>');
                    o.fn.init.call(i, a, e), i.container = t, i.captureEvents = !1, i._attachCapture(), a.append(i.options.loading).hide().appendTo(t)
                },
                options: {
                    name: "Loader",
                    loading: "<h1>Loading...</h1>",
                    timeout: 100
                },
                show: function() {
                    var n = this;
                    clearTimeout(n._loading), n.options.loading !== !1 && (n.captureEvents = !0, n._loading = setTimeout(function() {
                        n.element.show()
                    }, n.options.timeout))
                },
                hide: function() {
                    this.captureEvents = !1, clearTimeout(this._loading), this.element.hide()
                },
                changeMessage: function(n) {
                    this.options.loading = n, this.element.find(">h1").html(n)
                },
                transition: function() {
                    this.captureEvents = !0, this.container.css("pointer-events", "none")
                },
                transitionDone: function() {
                    this.captureEvents = !1, this.container.css("pointer-events", "")
                },
                _attachCapture: function() {
                    function n(n) {
                        e.captureEvents && n.preventDefault()
                    }
                    var t, e = this;
                    for (e.captureEvents = !1, t = 0; t < a.length; t++) e.container[0].addEventListener(a[t], n, !0)
                }
            });
        i.plugin(s)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(n, t, e) {
    (e || t)()
});;
! function(t, define) {
    define("kendo.mobile.pane.min", ["kendo.mobile.view.min", "kendo.mobile.loader.min"], t)
}(function() {
    return function(t, e) {
        var i = window.kendo,
            n = i.mobile,
            o = i.roleSelector,
            a = n.ui,
            r = a.Widget,
            s = n.ViewEngine,
            l = a.View,
            u = n.ui.Loader,
            c = "external",
            h = "href",
            d = "#!",
            p = "navigate",
            v = "viewShow",
            f = "sameViewRequested",
            g = i.support.mobileOS,
            w = g.ios && !g.appMode && g.flatVersion >= 700,
            m = /popover|actionsheet|modalview|drawer/,
            y = "#:back",
            b = i.attrValue,
            k = r.extend({
                init: function(t, e) {
                    var n = this;
                    r.fn.init.call(n, t, e), e = n.options, t = n.element, t.addClass("km-pane"), n.options.collapsible && t.addClass("km-collapsible-pane"), this.history = [], this.historyCallback = function(t, e, i) {
                        var o = n.transition;
                        return n.transition = null, w && i && (o = "none"), n.viewEngine.showView(t, o, e)
                    }, this._historyNavigate = function(t) {
                        if (t === y) {
                            if (1 === n.history.length) return;
                            n.history.pop(), t = n.history[n.history.length - 1]
                        } else n.history.push(t);
                        n.historyCallback(t, i.parseQueryStringParams(t))
                    }, this._historyReplace = function(t) {
                        var e = i.parseQueryStringParams(t);
                        n.history[n.history.length - 1] = t, n.historyCallback(t, e)
                    }, n.loader = new u(t, {
                        loading: n.options.loading
                    }), n.viewEngine = new s({
                        container: t,
                        transition: e.transition,
                        modelScope: e.modelScope,
                        rootNeeded: !e.initial,
                        serverNavigation: e.serverNavigation,
                        remoteViewURLPrefix: e.root || "",
                        layout: e.layout,
                        $angular: e.$angular,
                        loader: n.loader,
                        showStart: function() {
                            n.loader.transition(), n.closeActiveDialogs()
                        },
                        after: function() {
                            n.loader.transitionDone()
                        },
                        viewShow: function(t) {
                            n.trigger(v, t)
                        },
                        loadStart: function() {
                            n.loader.show()
                        },
                        loadComplete: function() {
                            n.loader.hide()
                        },
                        sameViewRequested: function() {
                            n.trigger(f)
                        },
                        viewTypeDetermined: function(t) {
                            t.remote && n.options.serverNavigation || n.trigger(p, {
                                url: t.url
                            })
                        }
                    }), this._setPortraitWidth(), i.onResize(function() {
                        n._setPortraitWidth()
                    }), n._setupAppLinks()
                },
                closeActiveDialogs: function() {
                    var e = this.element.find(o("actionsheet popover modalview")).filter(":visible");
                    e.each(function() {
                        i.widgetInstance(t(this), a).close()
                    })
                },
                navigateToInitial: function() {
                    var t = this.options.initial;
                    return t && this.navigate(t), t
                },
                options: {
                    name: "Pane",
                    portraitWidth: "",
                    transition: "",
                    layout: "",
                    collapsible: !1,
                    initial: null,
                    modelScope: window,
                    loading: "<h1>Loading...</h1>"
                },
                events: [p, v, f],
                append: function(t) {
                    return this.viewEngine.append(t)
                },
                destroy: function() {
                    r.fn.destroy.call(this), this.viewEngine.destroy(), this.userEvents.destroy()
                },
                navigate: function(t, e) {
                    t instanceof l && (t = t.id), this.transition = e, this._historyNavigate(t)
                },
                replace: function(t, e) {
                    t instanceof l && (t = t.id), this.transition = e, this._historyReplace(t)
                },
                bindToRouter: function(t) {
                    var e = this,
                        n = this.history,
                        o = this.viewEngine;
                    t.bind("init", function(e) {
                        var a, r = e.url,
                            s = t.pushState ? r : "/";
                        o.rootView.attr(i.attr("url"), s), a = n.length, "/" === r && a && (t.navigate(n[a - 1], !0), e.preventDefault())
                    }), t.bind("routeMissing", function(t) {
                        e.historyCallback(t.url, t.params, t.backButtonPressed) || t.preventDefault()
                    }), t.bind("same", function() {
                        e.trigger(f)
                    }), e._historyNavigate = function(e) {
                        t.navigate(e)
                    }, e._historyReplace = function(e) {
                        t.replace(e)
                    }
                },
                hideLoading: function() {
                    this.loader.hide()
                },
                showLoading: function() {
                    this.loader.show()
                },
                changeLoadingMessage: function(t) {
                    this.loader.changeMessage(t)
                },
                view: function() {
                    return this.viewEngine.view()
                },
                _setPortraitWidth: function() {
                    var t, e = this.options.portraitWidth;
                    e && (t = i.mobile.application.element.is(".km-vertical") ? e : "auto", this.element.css("width", t))
                },
                _setupAppLinks: function() {
                    var e = this,
                        n = "tab",
                        a = "[data-" + i.ns + "navigate-on-press]",
                        r = t.map(["button", "backbutton", "detailbutton", "listview-link"], function(t) {
                            return o(t) + ":not(" + a + ")"
                        }).join(",");
                    this.element.handler(this).on("down", o(n) + "," + a, "_mouseup").on("click", o(n) + "," + r + "," + a, "_appLinkClick"), this.userEvents = new i.UserEvents(this.element, {
                        fastTap: !0,
                        filter: r,
                        tap: function(t) {
                            t.event.currentTarget = t.touch.currentTarget, e._mouseup(t.event)
                        }
                    }), this.element.css("-ms-touch-action", "")
                },
                _appLinkClick: function(e) {
                    var i = t(e.currentTarget).attr("href"),
                        n = i && "#" !== i[0] && this.options.serverNavigation;
                    n || b(t(e.currentTarget), "rel") == c || e.preventDefault()
                },
                _mouseup: function(o) {
                    if (!(o.which > 1 || o.isDefaultPrevented())) {
                        var r = this,
                            s = t(o.currentTarget),
                            l = b(s, "transition"),
                            u = b(s, "rel") || "",
                            p = b(s, "target"),
                            v = s.attr(h),
                            f = w && 0 === s[0].offsetHeight,
                            g = v && "#" !== v[0] && this.options.serverNavigation;
                        f || g || u === c || e === v || v === d || (s.attr(h, d), setTimeout(function() {
                            s.attr(h, v)
                        }), u.match(m) ? (i.widgetInstance(t(v), a).openFor(s), "actionsheet" !== u && "drawer" !== u || o.stopPropagation()) : ("_top" === p ? r = n.application.pane : p && (r = t("#" + p).data("kendoMobilePane")), r.navigate(v, l)), o.preventDefault())
                    }
                }
            });
        k.wrap = function(t) {
            t.is(o("view")) || (t = t.wrap("<div data-" + i.ns + 'role="view" data-stretch="true"></div>').parent());
            var e = t.wrap('<div class="km-pane-wrapper"><div></div></div>').parent(),
                n = new k(e);
            return n.navigate(""), n
        }, a.plugin(k)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(t, e, i) {
    (i || e)()
});;
! function(e, define) {
    define("kendo.mobile.popover.min", ["kendo.popup.min", "kendo.mobile.pane.min"], e)
}(function() {
    return function(e, o) {
        var i = window.kendo,
            t = i.mobile,
            n = t.ui,
            p = "hide",
            r = "open",
            s = "close",
            a = '<div class="km-popup-wrapper" />',
            l = '<div class="km-popup-arrow" />',
            d = '<div class="km-popup-overlay" />',
            c = "km-up km-down km-left km-right",
            h = n.Widget,
            u = {
                down: {
                    origin: "bottom center",
                    position: "top center"
                },
                up: {
                    origin: "top center",
                    position: "bottom center"
                },
                left: {
                    origin: "center left",
                    position: "center right",
                    collision: "fit flip"
                },
                right: {
                    origin: "center right",
                    position: "center left",
                    collision: "fit flip"
                }
            },
            f = {
                animation: {
                    open: {
                        effects: "fade:in",
                        duration: 0
                    },
                    close: {
                        effects: "fade:out",
                        duration: 400
                    }
                }
            },
            w = {
                horizontal: {
                    offset: "top",
                    size: "height"
                },
                vertical: {
                    offset: "left",
                    size: "width"
                }
            },
            m = {
                up: "down",
                down: "up",
                left: "right",
                right: "left"
            },
            v = h.extend({
                init: function(o, t) {
                    var n, r, s = this,
                        c = o.closest(".km-modalview-wrapper"),
                        m = o.closest(".km-root").children(".km-pane").first(),
                        v = c[0] ? c : m;
                    t.viewport ? m = t.viewport : m[0] || (m = window), t.container ? v = t.container : v[0] || (v = document.body), n = {
                        viewport: m,
                        copyAnchorStyles: !1,
                        autosize: !0,
                        open: function() {
                            s.overlay.show()
                        },
                        activate: e.proxy(s._activate, s),
                        deactivate: function() {
                            s.overlay.hide(), s._apiCall || s.trigger(p), s._apiCall = !1
                        }
                    }, h.fn.init.call(s, o, t), o = s.element, t = s.options, o.wrap(a).addClass("km-popup").show(), r = s.options.direction.match(/left|right/) ? "horizontal" : "vertical", s.dimensions = w[r], s.wrapper = o.parent().css({
                        width: t.width,
                        height: t.height
                    }).addClass("km-popup-wrapper km-" + t.direction).hide(), s.arrow = e(l).prependTo(s.wrapper).hide(), s.overlay = e(d).appendTo(v).hide(), n.appendTo = s.overlay, t.className && s.overlay.addClass(t.className), s.popup = new i.ui.Popup(s.wrapper, e.extend(!0, n, f, u[t.direction]))
                },
                options: {
                    name: "Popup",
                    width: 240,
                    height: "",
                    direction: "down",
                    container: null,
                    viewport: null
                },
                events: [p],
                show: function(o) {
                    this.popup.options.anchor = e(o), this.popup.open()
                },
                hide: function() {
                    this._apiCall = !0, this.popup.close()
                },
                destroy: function() {
                    h.fn.destroy.call(this), this.popup.destroy(), this.overlay.remove()
                },
                target: function() {
                    return this.popup.options.anchor
                },
                _activate: function() {
                    var o = this,
                        i = o.options.direction,
                        t = o.dimensions,
                        n = t.offset,
                        p = o.popup,
                        r = p.options.anchor,
                        s = e(r).offset(),
                        a = e(p.element).offset(),
                        l = p.flipped ? m[i] : i,
                        d = 2 * o.arrow[t.size](),
                        h = o.element[t.size]() - o.arrow[t.size](),
                        u = e(r)[t.size](),
                        f = s[n] - a[n] + u / 2;
                    f < d && (f = d), f > h && (f = h), o.wrapper.removeClass(c).addClass("km-" + l), o.arrow.css(n, f).show()
                }
            }),
            g = h.extend({
                init: function(o, t) {
                    var p, r = this;
                    r.initialOpen = !1, h.fn.init.call(r, o, t), p = e.extend({
                        className: "km-popover-root",
                        hide: function() {
                            r.trigger(s)
                        }
                    }, this.options.popup), r.popup = new v(r.element, p), r.popup.overlay.on("move", function(e) {
                        e.target == r.popup.overlay[0] && e.preventDefault()
                    }), r.pane = new n.Pane(r.element, e.extend(this.options.pane, {
                        $angular: this.options.$angular
                    })), i.notify(r, n)
                },
                options: {
                    name: "PopOver",
                    popup: {},
                    pane: {}
                },
                events: [r, s],
                open: function(e) {
                    this.popup.show(e), this.initialOpen ? this.pane.view()._invokeNgController() : (this.pane.navigateToInitial() || this.pane.navigate(""), this.popup.popup._position(), this.initialOpen = !0)
                },
                openFor: function(e) {
                    this.open(e), this.trigger(r, {
                        target: this.popup.target()
                    })
                },
                close: function() {
                    this.popup.hide()
                },
                destroy: function() {
                    h.fn.destroy.call(this), this.pane.destroy(), this.popup.destroy(), i.destroy(this.element)
                }
            });
        n.plugin(v), n.plugin(g)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, o, i) {
    (i || o)()
});;
! function(e, define) {
    define("kendo.mobile.shim.min", ["kendo.popup.min"], e)
}(function() {
    return function(e, n) {
        var i = window.kendo,
            o = i.mobile.ui,
            t = i.ui.Popup,
            s = '<div class="km-shim"/>',
            a = "hide",
            d = o.Widget,
            p = d.extend({
                init: function(n, o) {
                    var p = this,
                        c = i.mobile.application,
                        l = i.support.mobileOS,
                        r = c ? c.os.name : l ? l.name : "ios",
                        u = "ios" === r || "wp" === r || !!c && c.os.skin,
                        h = "blackberry" === r,
                        m = o.align || (u ? "bottom center" : h ? "center right" : "center center"),
                        f = o.position || (u ? "bottom center" : h ? "center right" : "center center"),
                        w = o.effect || (u ? "slideIn:up" : h ? "slideIn:left" : "fade:in"),
                        g = e(s).handler(p).hide();
                    d.fn.init.call(p, n, o), p.shim = g, n = p.element, o = p.options, o.className && p.shim.addClass(o.className), o.modal || p.shim.on("down", "_hide"), (c ? c.element : e(document.body)).append(g), p.popup = new t(p.element, {
                        anchor: g,
                        modal: !0,
                        appendTo: g,
                        origin: m,
                        position: f,
                        animation: {
                            open: {
                                effects: w,
                                duration: o.duration
                            },
                            close: {
                                duration: o.duration
                            }
                        },
                        close: function(e) {
                            var n = !1;
                            p._apiCall || (n = p.trigger(a)), n && e.preventDefault(), p._apiCall = !1
                        },
                        deactivate: function() {
                            g.hide()
                        },
                        open: function() {
                            g.show()
                        }
                    }), i.notify(p)
                },
                events: [a],
                options: {
                    name: "Shim",
                    modal: !1,
                    align: n,
                    position: n,
                    effect: n,
                    duration: 200
                },
                show: function() {
                    this.popup.open()
                },
                hide: function() {
                    this._apiCall = !0, this.popup.close()
                },
                destroy: function() {
                    d.fn.destroy.call(this), this.shim.kendoDestroy(), this.popup.destroy(), this.shim.remove()
                },
                _hide: function(n) {
                    n && e.contains(this.shim.children().children(".k-popup")[0], n.target) || this.popup.close()
                }
            });
        o.plugin(p)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, n, i) {
    (i || n)()
});;
! function(e, define) {
    define("kendo.mobile.actionsheet.min", ["kendo.mobile.popover.min", "kendo.mobile.shim.min"], e)
}(function() {
    return function(e, t) {
        var n = window.kendo,
            i = n.support,
            o = n.mobile.ui,
            s = o.Shim,
            a = o.Popup,
            c = o.Widget,
            r = "open",
            l = "close",
            h = "command",
            p = "li>a",
            d = "actionsheetContext",
            u = '<div class="km-actionsheet-wrapper" />',
            m = n.template('<li class="km-actionsheet-cancel"><a href="\\#">#:cancel#</a></li>'),
            f = c.extend({
                init: function(t, r) {
                    var l, h, d, f = this,
                        g = i.mobileOS;
                    c.fn.init.call(f, t, r), r = f.options, d = r.type, t = f.element, h = "auto" === d ? g && g.tablet : "tablet" === d, l = h ? a : s, r.cancelTemplate && (m = n.template(r.cancelTemplate)), t.addClass("km-actionsheet").append(m({
                        cancel: f.options.cancel
                    })).wrap(u).on("up", p, "_click").on("click", p, n.preventDefault), f.view().bind("destroy", function() {
                        f.destroy()
                    }), f.wrapper = t.parent().addClass(d ? " km-actionsheet-" + d : ""), f.shim = new l(f.wrapper, e.extend({
                        modal: g.ios && g.majorVersion < 7,
                        className: "km-actionsheet-root"
                    }, f.options.popup)), f._closeProxy = e.proxy(f, "_close"), f._shimHideProxy = e.proxy(f, "_shimHide"), f.shim.bind("hide", f._shimHideProxy), h && n.onResize(f._closeProxy), n.notify(f, o)
                },
                events: [r, l, h],
                options: {
                    name: "ActionSheet",
                    cancel: "Cancel",
                    type: "auto",
                    popup: {
                        height: "auto"
                    }
                },
                open: function(t, n) {
                    var i = this;
                    i.target = e(t), i.context = n, i.shim.show(t)
                },
                close: function() {
                    this.context = this.target = null, this.shim.hide()
                },
                openFor: function(e) {
                    var t = this,
                        n = e.data(d);
                    t.open(e, n), t.trigger(r, {
                        target: e,
                        context: n
                    })
                },
                destroy: function() {
                    c.fn.destroy.call(this), n.unbindResize(this._closeProxy), this.shim.destroy()
                },
                _click: function(t) {
                    var i, o, s, a;
                    t.isDefaultPrevented() || (i = e(t.currentTarget), o = i.data("action"), o && (s = {
                        target: this.target,
                        context: this.context
                    }, a = this.options.$angular, a ? this.element.injector().get("$parse")(o)(a[0])(s) : n.getter(o)(window)(s)), this.trigger(h, {
                        target: this.target,
                        context: this.context,
                        currentTarget: i
                    }), t.preventDefault(), this._close())
                },
                _shimHide: function(e) {
                    this.trigger(l) ? e.preventDefault() : this.context = this.target = null
                },
                _close: function(e) {
                    this.trigger(l) ? e.preventDefault() : this.close()
                }
            });
        o.plugin(f)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(e, define) {
    define("kendo.mobile.application.min", ["kendo.mobile.pane.min", "kendo.router.min"], e)
}(function() {
    return function(e, i) {
        function t(e, i) {
            var t = [];
            return u && t.push("km-on-" + u.name), t.push(e.skin ? "km-" + e.skin : "ios" == e.name && e.majorVersion > 6 ? "km-ios7" : "km-" + e.name), ("ios" == e.name && e.majorVersion < 7 || "ios" != e.name) && t.push("km-" + e.name + e.majorVersion), t.push("km-" + e.majorVersion), t.push("km-m" + (e.minorVersion ? e.minorVersion[0] : 0)), e.variant && (e.skin && e.skin === e.name || !e.skin || e.setDefaultPlatform === !1) && t.push("km-" + (e.skin ? e.skin : e.name) + "-" + e.variant), e.cordova && t.push("km-cordova"), t.push(e.appMode ? "km-app" : "km-web"), i && i.statusBarStyle && t.push("km-" + i.statusBarStyle + "-status-bar"), t.join(" ")
        }

        function n(i) {
            return "km-wp-" + (i.noVariantSet ? 0 === parseInt(e("<div style='background: Background' />").css("background-color").split(",")[1], 10) ? "dark" : "light" : i.variant + " km-wp-" + i.variant + "-force")
        }

        function o(e) {
            return u.wp ? "-kendo-landscape" == e.css("animation-name") : Math.abs(window.orientation) / 90 == 1
        }

        function a(e) {
            return o(e) ? y : g
        }

        function s(e) {
            e.parent().addBack().css("min-height", window.innerHeight)
        }

        function r() {
            e("meta[name=viewport]").remove(), D.append(x({
                height: ", width=device-width" + (o() ? ", height=" + window.innerHeight + "px" : d.mobileOS.flatVersion >= 600 && d.mobileOS.flatVersion < 700 ? ", height=" + window.innerWidth + "px" : ", height=device-height")
            }))
        }
        var l = window.kendo,
            p = l.mobile,
            d = l.support,
            c = p.ui.Widget,
            h = p.ui.Pane,
            m = "ios7",
            u = d.mobileOS,
            f = "blackberry" == u.device && u.flatVersion >= 600 && u.flatVersion < 1e3 && u.appMode,
            v = .93,
            g = "km-vertical",
            k = "chrome" === u.browser,
            w = u.ios && u.flatVersion >= 700 && u.flatVersion < 800 && (u.appMode || k),
            b = Math.abs(window.orientation) / 90 == 1,
            y = "km-horizontal",
            V = {
                ios7: {
                    ios: !0,
                    browser: "default",
                    device: "iphone",
                    flatVersion: "700",
                    majorVersion: "7",
                    minorVersion: "0.0",
                    name: "ios",
                    tablet: !1
                },
                ios: {
                    ios: !0,
                    browser: "default",
                    device: "iphone",
                    flatVersion: "612",
                    majorVersion: "6",
                    minorVersion: "1.2",
                    name: "ios",
                    tablet: !1
                },
                android: {
                    android: !0,
                    browser: "default",
                    device: "android",
                    flatVersion: "442",
                    majorVersion: "4",
                    minorVersion: "4.2",
                    name: "android",
                    tablet: !1
                },
                blackberry: {
                    blackberry: !0,
                    browser: "default",
                    device: "blackberry",
                    flatVersion: "710",
                    majorVersion: "7",
                    minorVersion: "1.0",
                    name: "blackberry",
                    tablet: !1
                },
                meego: {
                    meego: !0,
                    browser: "default",
                    device: "meego",
                    flatVersion: "850",
                    majorVersion: "8",
                    minorVersion: "5.0",
                    name: "meego",
                    tablet: !1
                },
                wp: {
                    wp: !0,
                    browser: "default",
                    device: "wp",
                    flatVersion: "800",
                    majorVersion: "8",
                    minorVersion: "0.0",
                    name: "wp",
                    tablet: !1
                }
            },
            x = l.template('<meta content="initial-scale=#: data.scale #, maximum-scale=#: data.scale #, user-scalable=no#=data.height#" name="viewport" />', {
                usedWithBlock: !1
            }),
            B = l.template('<meta name="apple-mobile-web-app-capable" content="#= data.webAppCapable === false ? \'no\' : \'yes\' #" /> <meta name="apple-mobile-web-app-status-bar-style" content="#=data.statusBarStyle#" /> <meta name="msapplication-tap-highlight" content="no" /> ', {
                usedWithBlock: !1
            }),
            C = l.template("<style>.km-view { clip: rect(0 #= data.width #px #= data.height #px 0); }</style>", {
                usedWithBlock: !1
            }),
            S = u.android && "chrome" != u.browser || u.blackberry,
            H = l.template('<link rel="apple-touch-icon' + (u.android ? "-precomposed" : "") + '" # if(data.size) { # sizes="#=data.size#" #}# href="#=data.icon#" />', {
                usedWithBlock: !1
            }),
            _ = ("iphone" == u.device || "ipod" == u.device) && u.majorVersion < 7,
            P = ("iphone" == u.device || "ipod" == u.device) && u.majorVersion >= 7,
            T = P ? "none" : null,
            z = "mobilesafari" == u.browser ? 60 : 0,
            j = 20,
            M = e(window),
            W = window.screen,
            D = e("head"),
            E = "init",
            R = e.proxy,
            N = c.extend({
                init: function(i, t) {
                    p.application = this, e(e.proxy(this, "bootstrap", i, t))
                },
                bootstrap: function(i, t) {
                    var n, o, a;
                    i = e(i), i[0] || (i = e(document.body)), c.fn.init.call(this, i, t), this.element.removeAttr("data-" + l.ns + "role"), this._setupPlatform(), this._attachMeta(), this._setupElementClass(), this._attachHideBarHandlers(), n = e.extend({}, this.options), delete n.name, o = this, a = function() {
                        o.pane = new h(o.element, n), o.pane.navigateToInitial(), o.options.updateDocumentTitle && o._setupDocumentTitle(), o._startHistory(), o.trigger(E)
                    }, this.options.$angular ? setTimeout(a) : a()
                },
                options: {
                    name: "Application",
                    hideAddressBar: !0,
                    browserHistory: !0,
                    historyTransition: T,
                    modelScope: window,
                    statusBarStyle: "black",
                    transition: "",
                    retina: !1,
                    platform: null,
                    skin: null,
                    updateDocumentTitle: !0,
                    useNativeScrolling: !1
                },
                events: [E],
                navigate: function(e, i) {
                    this.pane.navigate(e, i)
                },
                replace: function(e, i) {
                    this.pane.replace(e, i)
                },
                scroller: function() {
                    return this.view().scroller
                },
                hideLoading: function() {
                    if (!this.pane) throw Error("The mobile application instance is not fully instantiated. Please consider activating loading in the application init event handler.");
                    this.pane.hideLoading()
                },
                showLoading: function() {
                    if (!this.pane) throw Error("The mobile application instance is not fully instantiated. Please consider activating loading in the application init event handler.");
                    this.pane.showLoading()
                },
                changeLoadingMessage: function(e) {
                    if (!this.pane) throw Error("The mobile application instance is not fully instantiated. Please consider changing the message in the application init event handler.");
                    this.pane.changeLoadingMessage(e)
                },
                view: function() {
                    return this.pane.view()
                },
                skin: function(e) {
                    var i = this;
                    return arguments.length ? (i.options.skin = e || "", i.element[0].className = "km-pane", i._setupPlatform(), i._setupElementClass(), i.options.skin) : i.options.skin
                },
                destroy: function() {
                    c.fn.destroy.call(this), this.pane.destroy(), this.options.browserHistory && this.router.destroy()
                },
                _setupPlatform: function() {
                    var i = this,
                        o = i.options.platform,
                        a = i.options.skin,
                        s = [],
                        r = u || V[m];
                    o && (r.setDefaultPlatform = !0, "string" == typeof o ? (s = o.split("-"), r = e.extend({
                        variant: s[1]
                    }, r, V[s[0]])) : r = o), a && (s = a.split("-"), u || (r.setDefaultPlatform = !1), r = e.extend({}, r, {
                        skin: s[0],
                        variant: s[1]
                    })), r.variant || (r.noVariantSet = !0, r.variant = "dark"), i.os = r, i.osCssClass = t(i.os, i.options), "wp" == r.name && (i.refreshBackgroundColorProxy || (i.refreshBackgroundColorProxy = e.proxy(function() {
                        (i.os.variant && i.os.skin && i.os.skin === i.os.name || !i.os.skin) && i.element.removeClass("km-wp-dark km-wp-light km-wp-dark-force km-wp-light-force").addClass(n(i.os))
                    }, i)), e(document).off("visibilitychange", i.refreshBackgroundColorProxy), e(document).off("resume", i.refreshBackgroundColorProxy), r.skin || (i.element.parent().css("overflow", "hidden"), e(document).on("visibilitychange", i.refreshBackgroundColorProxy), e(document).on("resume", i.refreshBackgroundColorProxy), i.refreshBackgroundColorProxy()))
                },
                _startHistory: function() {
                    this.options.browserHistory ? (this.router = new l.Router({
                        pushState: this.options.pushState,
                        root: this.options.root,
                        hashBang: this.options.hashBang
                    }), this.pane.bindToRouter(this.router), this.router.start()) : this.options.initial || this.pane.navigate("")
                },
                _resizeToScreenHeight: function() {
                    var i, t = e("meta[name=apple-mobile-web-app-status-bar-style]").attr("content").match(/black-translucent|hidden/),
                        n = this.element;
                    i = k ? window.innerHeight : o(n) ? t ? b ? W.availWidth + j : W.availWidth : b ? W.availWidth : W.availWidth - j : t ? b ? W.availHeight : W.availHeight + j : b ? W.availHeight - j : W.availHeight, n.height(i)
                },
                _setupElementClass: function() {
                    var i, t = this,
                        n = t.element;
                    n.parent().addClass("km-root km-" + (t.os.tablet ? "tablet" : "phone")), n.addClass(t.osCssClass + " " + a(n)), this.options.useNativeScrolling && n.parent().addClass("km-native-scrolling"), k && n.addClass("km-ios-chrome"), d.wpDevicePixelRatio && n.parent().css("font-size", d.wpDevicePixelRatio + "em"), this.options.retina && (n.parent().addClass("km-retina"), n.parent().css("font-size", d.devicePixelRatio * v + "em")), f && r(), t.options.useNativeScrolling ? n.parent().addClass("km-native-scrolling") : S && (i = (screen.availWidth > screen.availHeight ? screen.availWidth : screen.availHeight) + 200, e(C({
                        width: i,
                        height: i
                    })).appendTo(D)), w && t._resizeToScreenHeight(), l.onResize(function() {
                        n.removeClass("km-horizontal km-vertical").addClass(a(n)), t.options.useNativeScrolling && s(n), w && t._resizeToScreenHeight(), f && r(), l.resize(n)
                    })
                },
                _clearExistingMeta: function() {
                    D.find("meta").filter("[name|='apple-mobile-web-app'],[name|='msapplication-tap'],[name='viewport']").remove()
                },
                _attachMeta: function() {
                    var e, i = this.options,
                        t = i.icon;
                    if (this._clearExistingMeta(), f || D.prepend(x({
                            height: "",
                            scale: this.options.retina ? 1 / d.devicePixelRatio : "1.0"
                        })), D.prepend(B(i)), t) {
                        "string" == typeof t && (t = {
                            "": t
                        });
                        for (e in t) D.prepend(H({
                            icon: t[e],
                            size: e
                        }))
                    }
                    i.useNativeScrolling && s(this.element)
                },
                _attachHideBarHandlers: function() {
                    var e = this,
                        i = R(e, "_hideBar");
                    !d.mobileOS.appMode && e.options.hideAddressBar && _ && !e.options.useNativeScrolling && (e._initialHeight = {}, M.on("load", i), l.onResize(function() {
                        setTimeout(window.scrollTo, 0, 0, 1)
                    }))
                },
                _setupDocumentTitle: function() {
                    var e = this,
                        t = document.title;
                    e.pane.bind("viewShow", function(e) {
                        var n = e.view.title;
                        document.title = n !== i ? n : t
                    })
                },
                _hideBar: function() {
                    var i = this,
                        t = i.element;
                    t.height(l.support.transforms.css + "calc(100% + " + z + "px)"), e(window).trigger(l.support.resize)
                }
            });
        l.mobile.Application = N, l.ui.plugin(N, l.mobile, "Mobile")
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, i, t) {
    (t || i)()
});;
! function(e, define) {
    define("kendo.touch.min", ["kendo.core.min", "kendo.userevents.min"], e)
}(function() {
    return function(e, t) {
        var n = window.kendo,
            i = n.ui.Widget,
            a = e.proxy,
            o = Math.abs,
            r = 20,
            s = i.extend({
                init: function(e, t) {
                    function o(e) {
                        return function(t) {
                            s._triggerTouch(e, t)
                        }
                    }

                    function r(e) {
                        return function(t) {
                            s.trigger(e, {
                                touches: t.touches,
                                distance: t.distance,
                                center: t.center,
                                event: t.event
                            })
                        }
                    }
                    var s = this;
                    i.fn.init.call(s, e, t), t = s.options, e = s.element, s.wrapper = e, s.events = new n.UserEvents(e, {
                        filter: t.filter,
                        surface: t.surface,
                        minHold: t.minHold,
                        multiTouch: t.multiTouch,
                        allowSelection: !0,
                        fastTap: t.fastTap,
                        press: o("touchstart"),
                        hold: o("hold"),
                        tap: a(s, "_tap"),
                        gesturestart: r("gesturestart"),
                        gesturechange: r("gesturechange"),
                        gestureend: r("gestureend")
                    }), t.enableSwipe ? (s.events.bind("start", a(s, "_swipestart")), s.events.bind("move", a(s, "_swipemove"))) : (s.events.bind("start", a(s, "_dragstart")), s.events.bind("move", o("drag")), s.events.bind("end", o("dragend"))), n.notify(s)
                },
                events: ["touchstart", "dragstart", "drag", "dragend", "tap", "doubletap", "hold", "swipe", "gesturestart", "gesturechange", "gestureend"],
                options: {
                    name: "Touch",
                    surface: null,
                    global: !1,
                    fastTap: !1,
                    filter: null,
                    multiTouch: !1,
                    enableSwipe: !1,
                    minXDelta: 30,
                    maxYDelta: 20,
                    maxDuration: 1e3,
                    minHold: 800,
                    doubleTapTimeout: 800
                },
                cancel: function() {
                    this.events.cancel()
                },
                destroy: function() {
                    i.fn.destroy.call(this), this.events.destroy()
                },
                _triggerTouch: function(e, t) {
                    this.trigger(e, {
                        touch: t.touch,
                        event: t.event
                    }) && t.preventDefault()
                },
                _tap: function(e) {
                    var t = this,
                        i = t.lastTap,
                        a = e.touch;
                    i && a.endTime - i.endTime < t.options.doubleTapTimeout && n.touchDelta(a, i).distance < r ? (t._triggerTouch("doubletap", e), t.lastTap = null) : (t._triggerTouch("tap", e), t.lastTap = a)
                },
                _dragstart: function(e) {
                    this._triggerTouch("dragstart", e)
                },
                _swipestart: function(e) {
                    2 * o(e.x.velocity) >= o(e.y.velocity) && e.sender.capture()
                },
                _swipemove: function(e) {
                    var t = this,
                        n = t.options,
                        i = e.touch,
                        a = e.event.timeStamp - i.startTime,
                        r = i.x.initialDelta > 0 ? "right" : "left";
                    o(i.x.initialDelta) >= n.minXDelta && o(i.y.initialDelta) < n.maxYDelta && a < n.maxDuration && (t.trigger("swipe", {
                        direction: r,
                        touch: e.touch
                    }), i.cancel())
                }
            });
        n.ui.plugin(s)
    }(window.kendo.jQuery), window.kendo
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;
! function(e, define) {
    define("aspnetmvc/kendo.data.aspnetmvc.min", ["kendo.data.min", "kendo.combobox.min", "kendo.multiselect.min", "kendo.validator.min"], e)
}(function() {
    ! function(e, t) {
        function n(t, n, i) {
            var r, o = {};
            return t.sort ? (o[this.options.prefix + "sort"] = e.map(t.sort, function(e) {
                return e.field + "-" + e.dir
            }).join("~"), delete t.sort) : o[this.options.prefix + "sort"] = "", t.page && (o[this.options.prefix + "page"] = t.page, delete t.page), t.pageSize && (o[this.options.prefix + "pageSize"] = t.pageSize, delete t.pageSize), t.group ? (o[this.options.prefix + "group"] = e.map(t.group, function(e) {
                return e.field + "-" + e.dir
            }).join("~"), delete t.group) : o[this.options.prefix + "group"] = "", t.aggregate && (o[this.options.prefix + "aggregate"] = e.map(t.aggregate, function(e) {
                return e.field + "-" + e.aggregate
            }).join("~"), delete t.aggregate), t.filter ? (o[this.options.prefix + "filter"] = a(t.filter, i.encode), delete t.filter) : (o[this.options.prefix + "filter"] = "", delete t.filter), delete t.take, delete t.skip, r = new g(i), r.serialize(o, t, ""), o
        }

        function a(n, r) {
            return n.filters ? e.map(n.filters, function(e) {
                var t = e.filters && e.filters.length > 1,
                    n = a(e, r);
                return n && t && (n = "(" + n + ")"), n
            }).join("~" + n.logic + "~") : n.field ? n.field + "~" + n.operator + "~" + i(n.value, r) : t
        }

        function i(e, t) {
            if ("string" == typeof e) {
                if (!(e.indexOf("Date(") > -1)) return e = e.replace(l, "''"), t && (e = encodeURIComponent(e)), "'" + e + "'";
                e = new Date(parseInt(e.replace(/^\/Date\((.*?)\)\/$/, "$1"), 10))
            }
            return e && e.getTime ? "datetime'" + c.format("{0:yyyy-MM-ddTHH-mm-ss}", e) + "'" : e
        }

        function r(e, n) {
            return t !== e ? e : n
        }

        function o(t) {
            var n = t.HasSubgroups || t.hasSubgroups || !1,
                a = t.Items || t.items;
            return {
                value: r(t.Key, r(t.key, t.value)),
                field: t.Member || t.member || t.field,
                hasSubgroups: n,
                aggregates: s(t.Aggregates || t.aggregates),
                items: n ? e.map(a, o) : a
            }
        }

        function d(e) {
            var t = {};
            return t[e.AggregateMethodName.toLowerCase()] = e.Value, t
        }

        function s(e) {
            var t, n, a, i = {};
            for (t in e) {
                i = {}, a = e[t];
                for (n in a) i[n.toLowerCase()] = a[n];
                e[t] = i
            }
            return e
        }

        function u(e) {
            var t, n, a, i = {};
            for (t = 0, n = e.length; t < n; t++) a = e[t], i[a.Member] = f(!0, i[a.Member], d(a));
            return i
        }
        var c = window.kendo,
            l = /'/gi,
            f = e.extend,
            p = e.isArray,
            m = e.isPlainObject,
            v = ".",
            g = function(e) {
                e = e || {}, this.culture = e.culture || c.culture(), this.stringifyDates = e.stringifyDates, this.decimalSeparator = this.culture.numberFormat[v]
            };
        g.prototype = g.fn = {
            serialize: function(e, t, n) {
                var a, i;
                for (i in t) a = n ? n + "." + i : i, this.serializeField(e, t[i], t, i, a)
            },
            serializeField: function(e, n, a, i, r) {
                p(n) ? this.serializeArray(e, n, r) : m(n) ? this.serialize(e, n, r) : e[r] === t && (e[r] = a[i] = this.serializeValue(n))
            },
            serializeArray: function(e, t, n) {
                var a, i, r, o, d;
                for (o = 0, d = 0; o < t.length; o++) a = t[o], i = "[" + d + "]", r = n + i, this.serializeField(e, a, t, i, r), d++
            },
            serializeValue: function(e) {
                return e instanceof Date ? e = this.stringifyDates ? c.stringify(e).replace(/"/g, "") : c.toString(e, "G", this.culture.name) : "number" == typeof e && (e = ("" + e).replace(v, this.decimalSeparator)), e
            }
        }, f(!0, c.data, {
            schemas: {
                "aspnetmvc-ajax": {
                    groups: function(t) {
                        return e.map(this._dataAccessFunction(t), o)
                    },
                    aggregates: function(t) {
                        var n, a;
                        if (t = t.d || t, n = t.AggregateResults || [], !e.isArray(n)) {
                            for (a in n) n[a] = u(n[a]);
                            return n
                        }
                        return u(n)
                    }
                }
            }
        }), f(!0, c.data, {
            transports: {
                "aspnetmvc-ajax": c.data.RemoteTransport.extend({
                    init: function(e) {
                        var t = this,
                            a = (e || {}).stringifyDates;
                        c.data.RemoteTransport.fn.init.call(this, f(!0, {}, this.options, e, {
                            parameterMap: function(e, i) {
                                return n.call(t, e, i, {
                                    encode: !1,
                                    stringifyDates: a
                                })
                            }
                        }))
                    },
                    read: function(e) {
                        var t = this.options.data,
                            n = this.options.read.url;
                        m(t) ? (n && (this.options.data = null), !t.Data.length && n ? c.data.RemoteTransport.fn.read.call(this, e) : e.success(t)) : c.data.RemoteTransport.fn.read.call(this, e)
                    },
                    options: {
                        read: {
                            type: "POST"
                        },
                        update: {
                            type: "POST"
                        },
                        create: {
                            type: "POST"
                        },
                        destroy: {
                            type: "POST"
                        },
                        parameterMap: n,
                        prefix: ""
                    }
                })
            }
        }), f(!0, c.data, {
            schemas: {
                webapi: c.data.schemas["aspnetmvc-ajax"]
            }
        }), f(!0, c.data, {
            transports: {
                webapi: c.data.RemoteTransport.extend({
                    init: function(e) {
                        var t, a, i = this,
                            r = (e || {}).stringifyDates,
                            o = c.cultures[e.culture] || c.cultures["en-US"];
                        e.update && (t = "string" == typeof e.update ? e.update : e.update.url, e.update = f(e.update, {
                            url: function(n) {
                                return c.format(t, n[e.idField])
                            }
                        })), e.destroy && (a = "string" == typeof e.destroy ? e.destroy : e.destroy.url, e.destroy = f(e.destroy, {
                            url: function(t) {
                                return c.format(a, t[e.idField])
                            }
                        })), e.create && "string" == typeof e.create && (e.create = {
                            url: e.create
                        }), c.data.RemoteTransport.fn.init.call(this, f(!0, {}, this.options, e, {
                            parameterMap: function(e, t) {
                                return n.call(i, e, t, {
                                    encode: !1,
                                    stringifyDates: r,
                                    culture: o
                                })
                            }
                        }))
                    },
                    read: function(e) {
                        var t = this.options.data,
                            n = this.options.read.url;
                        m(t) ? (n && (this.options.data = null), !t.Data.length && n ? c.data.RemoteTransport.fn.read.call(this, e) : e.success(t)) : c.data.RemoteTransport.fn.read.call(this, e)
                    },
                    options: {
                        read: {
                            type: "GET"
                        },
                        update: {
                            type: "PUT"
                        },
                        create: {
                            type: "POST"
                        },
                        destroy: {
                            type: "DELETE"
                        },
                        parameterMap: n,
                        prefix: ""
                    }
                })
            }
        }), f(!0, c.data, {
            transports: {
                "aspnetmvc-server": c.data.RemoteTransport.extend({
                    init: function(e) {
                        var t = this;
                        c.data.RemoteTransport.fn.init.call(this, f(e, {
                            parameterMap: function(e, a) {
                                return n.call(t, e, a, {
                                    encode: !0
                                })
                            }
                        }))
                    },
                    read: function(t) {
                        var n, a, i = this.options.prefix,
                            r = [i + "sort", i + "page", i + "pageSize", i + "group", i + "aggregate", i + "filter"],
                            o = RegExp("(" + r.join("|") + ")=[^&]*&?", "g");
                        a = location.search.replace(o, "").replace("?", ""), a.length && !/&$/.test(a) && (a += "&"), t = this.setup(t, "read"), n = t.url, n.indexOf("?") >= 0 ? (a = a.replace(/(.*?=.*?)&/g, function(e) {
                            return n.indexOf(e.substr(0, e.indexOf("="))) >= 0 ? "" : e
                        }), n += "&" + a) : n += "?" + a, n += e.map(t.data, function(e, t) {
                            return t + "=" + e
                        }).join("&"), location.href = n
                    }
                })
            }
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("aspnetmvc/kendo.combobox.aspnetmvc.min", ["aspnetmvc/kendo.data.aspnetmvc.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            a = n.ui;
        a && a.ComboBox && (a.ComboBox.requestData = function(t) {
            var n, a, i = e(t).data("kendoComboBox");
            if (i) return n = i.dataSource.filter(), a = i.input.val(), n && n.filters.length || (a = ""), {
                text: a
            }
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("aspnetmvc/kendo.multicolumncombobox.aspnetmvc.min", ["aspnetmvc/kendo.data.aspnetmvc.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            a = n.ui;
        a && a.MultiColumnComboBox && (a.MultiColumnComboBox.requestData = function(t) {
            var n, a, i = e(t).data("kendoMultiColumnComboBox");
            if (i) return n = i.dataSource.filter(), a = i.input.val(), n && n.filters.length || (a = ""), {
                text: a
            }
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("aspnetmvc/kendo.dropdownlist.aspnetmvc.min", ["aspnetmvc/kendo.data.aspnetmvc.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            a = n.ui;
        a && a.DropDownList && (a.DropDownList.requestData = function(t) {
            var n, a, i, r = e(t).data("kendoDropDownList");
            if (r) return n = r.dataSource.filter(), a = r.filterInput, i = a ? a.val() : "", n && n.filters.length || (i = ""), {
                text: i
            }
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("aspnetmvc/kendo.dropdowntree.aspnetmvc.min", ["aspnetmvc/kendo.data.aspnetmvc.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            a = n.ui;
        a && a.DropDownTree && (a.DropDownTree.requestData = function(t) {
            var n, a, i, r = e(t).data("kendoDropDownTree");
            if (r) return n = r.dataSource.filter(), a = r.filterInput, i = a ? a.val() : "", n && n.filters.length || (i = ""), {
                text: i
            }
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("aspnetmvc/kendo.multiselect.aspnetmvc.min", ["aspnetmvc/kendo.combobox.aspnetmvc.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            a = n.ui;
        a && a.MultiSelect && (a.MultiSelect.requestData = function(t) {
            var n, a = e(t).data("kendoMultiSelect");
            if (a) return n = a.input.val(), {
                text: n !== a.options.placeholder ? n : ""
            }
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("aspnetmvc/kendo.imagebrowser.aspnetmvc.min", ["aspnetmvc/kendo.multiselect.aspnetmvc.min"], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            a = e.extend,
            i = e.isFunction;
        a(!0, n.data, {
            schemas: {
                "imagebrowser-aspnetmvc": {
                    data: function(e) {
                        return e || []
                    },
                    model: {
                        id: "name",
                        fields: {
                            name: {
                                field: "Name"
                            },
                            size: {
                                field: "Size"
                            },
                            type: {
                                field: "EntryType",
                                parse: function(e) {
                                    return 0 == e ? "f" : "d"
                                }
                            }
                        }
                    }
                }
            }
        }), a(!0, n.data, {
            schemas: {
                "filebrowser-aspnetmvc": n.data.schemas["imagebrowser-aspnetmvc"]
            }
        }), a(!0, n.data, {
            transports: {
                "imagebrowser-aspnetmvc": n.data.RemoteTransport.extend({
                    init: function(t) {
                        n.data.RemoteTransport.fn.init.call(this, e.extend(!0, {}, this.options, t))
                    },
                    _call: function(t, a) {
                        a.data = e.extend({}, a.data, {
                            path: this.options.path()
                        }), i(this.options[t]) ? this.options[t].call(this, a) : n.data.RemoteTransport.fn[t].call(this, a)
                    },
                    read: function(e) {
                        this._call("read", e)
                    },
                    create: function(e) {
                        this._call("create", e)
                    },
                    destroy: function(e) {
                        this._call("destroy", e)
                    },
                    update: function() {},
                    options: {
                        read: {
                            type: "POST"
                        },
                        update: {
                            type: "POST"
                        },
                        create: {
                            type: "POST"
                        },
                        destroy: {
                            type: "POST"
                        },
                        parameterMap: function(e, t) {
                            return "read" != t && (e.EntryType = "f" === e.EntryType ? 0 : 1), e
                        }
                    }
                })
            }
        }), a(!0, n.data, {
            transports: {
                "filebrowser-aspnetmvc": n.data.transports["imagebrowser-aspnetmvc"]
            }
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("aspnetmvc/kendo.validator.aspnetmvc.min", ["aspnetmvc/kendo.imagebrowser.aspnetmvc.min"], e)
}(function() {
    ! function(e, t) {
        function n() {
            var e, t = {};
            for (e in m) t["mvc" + e] = d(e);
            return t
        }

        function a() {
            var e, t = {};
            for (e in m) t["mvc" + e] = s(e);
            return t
        }

        function i(e, t) {
            var n, a, i, r = {},
                o = e.data(),
                d = t.length;
            for (i in o) a = i.toLowerCase(), n = a.indexOf(t), n > -1 && (a = a.substring(n + d, i.length), a && (r[a] = o[i]));
            return r
        }

        function r(t) {
            var n, a, i = t.Fields || [],
                r = {};
            for (n = 0, a = i.length; n < a; n++) e.extend(!0, r, o(i[n]));
            return r
        }

        function o(e) {
            var t, n, a, i, r = {},
                o = {},
                d = e.FieldName,
                s = e.ValidationRules;
            for (a = 0, i = s.length; a < i; a++) t = s[a].ValidationType, n = s[a].ValidationParameters, r[d + t] = c(d, t, n), o[d + t] = u(s[a].ErrorMessage);
            return {
                rules: r,
                messages: o
            }
        }

        function d(e) {
            return function(t) {
                return t.attr("data-val-" + e)
            }
        }

        function s(e) {
            return function(t) {
                return !t.filter("[data-val-" + e + "]").length || m[e](t, i(t, e))
            }
        }

        function u(e) {
            return function() {
                return e
            }
        }

        function c(e, t, n) {
            return function(a) {
                return !a.filter("[name=" + e + "]").length || m[t](a, n)
            }
        }

        function l(e, t) {
            return "string" == typeof t && (t = RegExp("^(?:" + t + ")$")), t.test(e)
        }
        var f = /("|\%|'|\[|\]|\$|\.|\,|\:|\;|\+|\*|\&|\!|\#|\(|\)|<|>|\=|\?|\@|\^|\{|\}|\~|\/|\||`)/g,
            p = ".k-switch",
            m = {
                required: function(e) {
                    var t, n, a, i = e.val(),
                        r = e.filter("[type=checkbox]");
                    return r.length && (t = r[0].name.replace(f, "\\$1"), n = "input:hidden[name='" + t + "']", r.closest(p).length && (r = r.closest(p)), a = r.next(n), a.length || (a = r.next("label.k-checkbox-label").next(n)), i = a.length ? a.val() : e.prop("checked") === !0), !("" === i || !i || 0 === i.length)
                },
                number: function(e) {
                    return "" === e.val() || null == e.val() || null !== kendo.parseFloat(e.val())
                },
                regex: function(e, t) {
                    return "" === e.val() || l(e.val(), t.pattern)
                },
                range: function(e, t) {
                    return "" === e.val() || this.min(e, t) && this.max(e, t)
                },
                min: function(e, t) {
                    var n = parseFloat(t.min) || 0,
                        a = kendo.parseFloat(e.val());
                    return n <= a
                },
                max: function(e, t) {
                    var n = parseFloat(t.max) || 0,
                        a = kendo.parseFloat(e.val());
                    return a <= n
                },
                date: function(e) {
                    return "" === e.val() || null !== kendo.parseDate(e.val())
                },
                length: function(t, n) {
                    if ("" !== t.val()) {
                        var a = e.trim(t.val()).length;
                        return (!n.min || a >= (n.min || 0)) && (!n.max || a <= (n.max || 0))
                    }
                    return !0
                }
            };
        e.extend(!0, kendo.ui.validator, {
            rules: a(),
            messages: n(),
            messageLocators: {
                mvcLocator: {
                    locate: function(e, t) {
                        return t = t.replace(f, "\\$1"), e.find(".field-validation-valid[data-valmsg-for='" + t + "'], .field-validation-error[data-valmsg-for='" + t + "']")
                    },
                    decorate: function(e, t) {
                        e.addClass("field-validation-error").attr("data-valmsg-for", t || "")
                    }
                },
                mvcMetadataLocator: {
                    locate: function(e, t) {
                        return t = t.replace(f, "\\$1"), e.find("#" + t + "_validationMessage.field-validation-valid")
                    },
                    decorate: function(e, t) {
                        e.addClass("field-validation-error").attr("id", t + "_validationMessage")
                    }
                }
            },
            ruleResolvers: {
                mvcMetaDataResolver: {
                    resolve: function(t) {
                        var n, a = window.mvcClientValidationMetadata || [];
                        if (a.length)
                            for (t = e(t), n = 0; n < a.length; n++)
                                if (a[n].FormId == t.attr("id")) return r(a[n]);
                        return {}
                    }
                }
            }
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("aspnetmvc/kendo.filemanager.aspnetmvc.min", [], e)
}(function() {
    ! function(e, t) {
        var n = window.kendo,
            a = e.extend;
        a(!0, n.data, {
            schemas: {
                filemanager: {
                    data: function(e) {
                        return e || []
                    },
                    model: {
                        id: "path",
                        hasChildren: "hasDirectories",
                        fields: {
                            name: {
                                field: "Name",
                                editable: !0,
                                type: "String",
                                defaultValue: "New Folder"
                            },
                            size: {
                                field: "Size",
                                editable: !1,
                                type: "Number"
                            },
                            path: {
                                field: "Path",
                                editable: !1,
                                type: "String"
                            },
                            extension: {
                                field: "Extension",
                                editable: !1,
                                type: "String"
                            },
                            isDirectory: {
                                field: "IsDirectory",
                                editable: !1,
                                defaultValue: !0,
                                type: "Boolean"
                            },
                            hasDirectories: {
                                field: "HasDirectories",
                                editable: !1,
                                defaultValue: !1,
                                type: "Boolean"
                            },
                            created: {
                                field: "Created",
                                type: "Date",
                                editable: !1
                            },
                            createdUtc: {
                                field: "CreatedUtc",
                                type: "Date",
                                editable: !1
                            },
                            modified: {
                                field: "Modified",
                                type: "Date",
                                editable: !1
                            },
                            modifiedUtc: {
                                field: "ModifiedUtc",
                                type: "Date",
                                editable: !1
                            }
                        }
                    }
                }
            }
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
}),
function(e, define) {
    define("kendo.aspnetmvc.min", ["kendo.data.min", "kendo.combobox.min", "kendo.dropdownlist.min", "kendo.dropdowntree.min", "kendo.multiselect.min", "kendo.validator.min", "aspnetmvc/kendo.data.aspnetmvc.min", "aspnetmvc/kendo.combobox.aspnetmvc.min", "aspnetmvc/kendo.multicolumncombobox.aspnetmvc.min", "aspnetmvc/kendo.dropdownlist.aspnetmvc.min", "aspnetmvc/kendo.dropdowntree.aspnetmvc.min", "aspnetmvc/kendo.multiselect.aspnetmvc.min", "aspnetmvc/kendo.imagebrowser.aspnetmvc.min", "aspnetmvc/kendo.validator.aspnetmvc.min", "aspnetmvc/kendo.filemanager.aspnetmvc.min"], e)
}(function() {
    ! function(e, t) {
        function n(t) {
            kendo.__documentIsReady ? t() : e(t)
        }
        var a = e.extend;
        e(function() {
            kendo.__documentIsReady = !0
        }), a(kendo, {
            syncReady: n
        })
    }(window.kendo.jQuery)
}, "function" == typeof define && define.amd ? define : function(e, t, n) {
    (n || t)()
});;